/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 320);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setSelectedLanguage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDefaultLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sharedLabelsPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeLanguage; });
/* unused harmony export getLocalizationData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSelectedLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return loadingTranslation; });
/* unused harmony export getTranslations */
/* unused harmony export getSelectedTranslation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTranslation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTranslationsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translations__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_storageApi__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
// import {ofType} from 'redux-observable';
// import { mapTo} from 'rxjs/operators';
// import {Api} from "../../api/api";
// import {logout, onForbidden} from "../account/login";
//- Actions
var setSelectedLanguage=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SELECTED_LANGUAGE_SET',function(language){return language;});// TODO: use it when improve localization in future
// export const fetchGetTranslationsSuccess = createAction('FETCH_GET_TRANSLATIONS_SUCCESS');
// export const fetchGetTranslationsFailed = createAction('FETCH_GET_TRANSLATIONS_FAILED');
// export const fetchGetTranslations = createAction(
//     'FETCH_GET_TRANSLATIONS',
//     () => Api.getTranslations(),
//     () => ({
//         apiCall: true,
//         onSuccess: fetchGetTranslationsSuccess,
//         onFail: fetchGetTranslationsFailed,
//         onUnauthorized: logout,
//         onForbidden: onForbidden
//     })
// );
//
// export const fetchGetTranslationFailed = createAction('FETCH_GET_TRANSLATION_FAILED');
// export const fetchGetTranslationSuccess = createAction('FETCH_GET_TRANSLATION_SUCCESS');
// export const fetchGetTranslationByPath = createAction(
//     'FETCH_GET_TRANSLATION',
//     (path) => Api.getTranslationByPath(path),
//     () => ({
//         apiCall: true,
//         onSuccess: fetchGetTranslationSuccess,
//         onFail: fetchGetTranslationFailed,
//         onUnauthorized: logout,
//         onForbidden: onForbidden
//     })
// );
//
// export const loadLanguage = (topLanguage, languages) => (dispatch, getState) => {
//     let newLanguage = StorageApi.getLanguage();
//     let translations = getTranslations(getState());
//     if (_.isNil(newLanguage)) {
//         if (_.isArray(languages)) {
//             newLanguage = _.find(languages, language => _.includes(_.keys(translations), language.substring(0, 2))).substring(0,2) || DEFAULT_LANGUAGE;
//         } else if (!_.isNil(topLanguage) && _.includes(_.keys(translations), topLanguage.substring(0, 2))) {
//             newLanguage = topLanguage.substring(0, 2);
//         } else {
//             newLanguage = DEFAULT_LANGUAGE;
//         }
//     }
//     if(_.includes(_.keys(translations), newLanguage)) {
//         dispatch(setSelectedLanguage(newLanguage));
//         dispatch(fetchGetTranslationByPath(translations[newLanguage].path));
//     }
// };
var getDefaultLanguage=function getDefaultLanguage(){var newLanguage=__WEBPACK_IMPORTED_MODULE_3__utils_storageApi__["a" /* StorageApi */].getLanguage();if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(newLanguage)){var topLanguage=window.navigator.language;var languages=window.navigator.languages;if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(languages)){newLanguage=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(languages,function(language){return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(__WEBPACK_IMPORTED_MODULE_2__translations__["a" /* translations */]),language.substring(0,2));}).substring(0,2)||DEFAULT_LANGUAGE;}else if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(topLanguage)&&__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(__WEBPACK_IMPORTED_MODULE_2__translations__["a" /* translations */]),topLanguage.substring(0,2))){newLanguage=topLanguage.substring(0,2);}else{newLanguage=DEFAULT_LANGUAGE;}}return newLanguage;};var sharedLabelsPath={errors:'errors',defaultError:'errors.DEFAULT_ERROR',add_button:'shared.add_button',cancel_button:'shared.cancel_button',remove_button:'shared.remove_button',first_name_label:"shared.first_name_label",last_name_label:"shared.last_name_label",email_label:"shared.email_label",personal_email_label:"shared.personal_email_label",professional_email_label:"shared.professional_email_label",password_label:"shared.password_label",department_label:"shared.department_label",continent_input_placeholder:"shared.continent_input_placeholder",country_input_placeholder:"shared.country_input_placeholder",continent_label:"shared.continent_label",continent_filter_label:"shared.continent_filter_label",country_label:"shared.country_label",fetching_message:"shared.fetching_message",success_message:"shared.success_message",national_id_label:"shared.national_id_label",continents:"continents",countries:"countries",company_label:"shared.company_label",edu_org_label:"shared.edu_org_label",employee_count_label:"shared.employee_count_label",name_label:"shared.name_label",accreditation_group_label:"shared.accreditation_group_label",okey_button:"shared.okey_button",yes_label:"shared.yes_label",no_label:"shared.no_label",org_label:"shared.org_label",edit_button:"shared.edit_button",datepicker_placeholder:"shared.datepicker_placeholder",save_changes_button:"shared.save_changes_button",domain_label:"shared.domain_label",back_button:"shared.back_button",company_domain_label:"shared.company_domain_label",search_label:"shared.search_label",about_label:"shared.about_label",title_label:"shared.title_label",phone_number_label:"shared.phone_number_label",required_field_error_message:"shared.required_field_error_message",pages_label:"shared.pages_label",examples_label:"shared.examples_label",location_label:"shared.location_label",all_label:"shared.all_label",filter_options_label:"shared.filter_options_label"};var changeLanguage=function changeLanguage(language){return function(dispatch){dispatch(setSelectedLanguage(language));// dispatch(fetchGetTranslationByPath(getPathByLanguageCode(getState(), language)));
__WEBPACK_IMPORTED_MODULE_3__utils_storageApi__["a" /* StorageApi */].setLanguage(language);};};var DEFAULT_LANGUAGE='en';var DEFAULT_MOMENT_LOCALE='en-gb';// moment.locale(_.isNil(lastSelectedLanguage) ? DEFAULT_LANGUAGE : lastSelectedLanguage);
//- State
var initialState={fetching:false,error:null,selectedLanguage:DEFAULT_LANGUAGE,translation:null,translations:__WEBPACK_IMPORTED_MODULE_2__translations__["a" /* translations */]};//- Reducers
/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({// TODO: use it when improve localization in future
// FETCH_GET_TRANSLATION: (state) => {
//     return {...state, fetching: true, translation: null, error: null};
// },
// FETCH_GET_TRANSLATION_FAILED: (state, action) => {
//     return {...state, fetching: false, translation: null, error: action.payload};
// },
// FETCH_GET_TRANSLATION_SUCCESS: (state, action) => {
//     return {...state, fetching: false, translation: action.payload, error: null};
// },
// FETCH_GET_TRANSLATIONS: (state) => {
//     return {...state, fetching: true, translations: null, error: null};
// },
// FETCH_GET_TRANSLATIONS_FAILED: (state, action) => {
//     return {...state, translations: null, error: action.payload};
// },
// FETCH_GET_TRANSLATIONS_SUCCESS: (state, action) => {
//     return {...state, translations: action.payload, error: null};
// },
SELECTED_LANGUAGE_SET:function SELECTED_LANGUAGE_SET(state,action){var languageCode=action.payload;if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(state.translations,languageCode)){var locale=state.translations[languageCode].momentLocale;__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_4_moment___default.a.locales(),locale)?__WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale(locale):__WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale(DEFAULT_MOMENT_LOCALE);}else{languageCode=DEFAULT_LANGUAGE;__WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale(DEFAULT_MOMENT_LOCALE);}return Object.assign({},state,{selectedLanguage:languageCode});}},initialState));//- Epics
// TODO: use it when improve localization in future
// export const getTranslationsSuccessEpic = (action$) => {
//     return action$.pipe(
//         ofType('FETCH_GET_TRANSLATIONS_SUCCESS'),
//         mapTo(loadLanguage(window.navigator.language, window.navigator.languages)))
//     };
//- Selectors
var getLocalizationData=function getLocalizationData(state){return state.localization;};var getSelectedLanguage=function getSelectedLanguage(state){return getLocalizationData(state).selectedLanguage;};var loadingTranslation=function loadingTranslation(state){return getLocalizationData(state).fetching;};var getTranslations=function getTranslations(state){return getLocalizationData(state).translations;};var getSelectedTranslation=function getSelectedTranslation(state){return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(getTranslations(state))||!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(getTranslations(state),getSelectedLanguage(state))?null:getTranslations(state)[getSelectedLanguage(state)];};var getTranslation=function getTranslation(state){return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(getSelectedTranslation(state))?null:getSelectedTranslation(state).translation;};var getTranslationsList=function getTranslationsList(state){return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.chain(getTranslations(state)).map(function(translation,key){return{value:key,label:key.toUpperCase(),title:translation.label};}).value();};// TODO: use it when improve localization in future
// export const getPathByLanguageCode = (state, languageCode) => {
//     let translation = _.find(getLocalizationData(state).translations, (translation, code) => code === languageCode);
//
//     if (_.isNil(translation)) {
//         return null;
//     }
//
//     return translation.path;
// } ;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(327);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(335)();
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.11';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37), __webpack_require__(250)(module)))

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(338);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Container__ = __webpack_require__(525);
/* unused harmony reexport Container */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Row__ = __webpack_require__(527);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_1__Row__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Col__ = __webpack_require__(528);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__Col__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Navbar__ = __webpack_require__(529);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_3__Navbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavbarBrand__ = __webpack_require__(530);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_4__NavbarBrand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavbarToggler__ = __webpack_require__(531);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_5__NavbarToggler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Nav__ = __webpack_require__(532);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_6__Nav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavItem__ = __webpack_require__(533);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_7__NavItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NavDropdown__ = __webpack_require__(534);
/* unused harmony reexport NavDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavLink__ = __webpack_require__(539);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_9__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Breadcrumb__ = __webpack_require__(540);
/* unused harmony reexport Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BreadcrumbItem__ = __webpack_require__(541);
/* unused harmony reexport BreadcrumbItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Button__ = __webpack_require__(172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_12__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ButtonDropdown__ = __webpack_require__(259);
/* unused harmony reexport ButtonDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ButtonGroup__ = __webpack_require__(542);
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ButtonToolbar__ = __webpack_require__(543);
/* unused harmony reexport ButtonToolbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Dropdown__ = __webpack_require__(103);
/* unused harmony reexport Dropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DropdownItem__ = __webpack_require__(544);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_17__DropdownItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__ = __webpack_require__(545);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__ = __webpack_require__(547);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Fade__ = __webpack_require__(173);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_20__Fade__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Badge__ = __webpack_require__(554);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_21__Badge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Card__ = __webpack_require__(555);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_22__Card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__CardGroup__ = __webpack_require__(556);
/* unused harmony reexport CardGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__CardDeck__ = __webpack_require__(557);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_24__CardDeck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__CardColumns__ = __webpack_require__(558);
/* unused harmony reexport CardColumns */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__CardBody__ = __webpack_require__(263);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_26__CardBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__CardBlock__ = __webpack_require__(559);
/* unused harmony reexport CardBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__CardLink__ = __webpack_require__(560);
/* unused harmony reexport CardLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__CardFooter__ = __webpack_require__(561);
/* unused harmony reexport CardFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__CardHeader__ = __webpack_require__(562);
/* unused harmony reexport CardHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__CardImg__ = __webpack_require__(563);
/* unused harmony reexport CardImg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__CardImgOverlay__ = __webpack_require__(564);
/* unused harmony reexport CardImgOverlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Carousel__ = __webpack_require__(264);
/* unused harmony reexport Carousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__UncontrolledCarousel__ = __webpack_require__(565);
/* unused harmony reexport UncontrolledCarousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__CarouselControl__ = __webpack_require__(265);
/* unused harmony reexport CarouselControl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__CarouselItem__ = __webpack_require__(175);
/* unused harmony reexport CarouselItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__CarouselIndicators__ = __webpack_require__(266);
/* unused harmony reexport CarouselIndicators */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__CarouselCaption__ = __webpack_require__(267);
/* unused harmony reexport CarouselCaption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__CardSubtitle__ = __webpack_require__(566);
/* unused harmony reexport CardSubtitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__CardText__ = __webpack_require__(567);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_40__CardText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__CardTitle__ = __webpack_require__(568);
/* unused harmony reexport CardTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__CustomInput__ = __webpack_require__(569);
/* unused harmony reexport CustomInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__PopperContent__ = __webpack_require__(268);
/* unused harmony reexport PopperContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__PopperTargetHelper__ = __webpack_require__(570);
/* unused harmony reexport PopperTargetHelper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Popover__ = __webpack_require__(269);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_45__Popover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__UncontrolledPopover__ = __webpack_require__(571);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_46__UncontrolledPopover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__PopoverHeader__ = __webpack_require__(271);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_47__PopoverHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__PopoverTitle__ = __webpack_require__(572);
/* unused harmony reexport PopoverTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__PopoverBody__ = __webpack_require__(272);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_49__PopoverBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__PopoverContent__ = __webpack_require__(573);
/* unused harmony reexport PopoverContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Progress__ = __webpack_require__(574);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_51__Progress__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Modal__ = __webpack_require__(576);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_52__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ModalHeader__ = __webpack_require__(578);
/* unused harmony reexport ModalHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__ModalBody__ = __webpack_require__(579);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_54__ModalBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ModalFooter__ = __webpack_require__(580);
/* unused harmony reexport ModalFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Tooltip__ = __webpack_require__(273);
/* unused harmony reexport Tooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Table__ = __webpack_require__(581);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_57__Table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__ListGroup__ = __webpack_require__(582);
/* unused harmony reexport ListGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Form__ = __webpack_require__(583);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_59__Form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__FormFeedback__ = __webpack_require__(584);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_60__FormFeedback__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__FormGroup__ = __webpack_require__(585);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_61__FormGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__FormText__ = __webpack_require__(586);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_62__FormText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Input__ = __webpack_require__(587);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_63__Input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__InputGroup__ = __webpack_require__(588);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_64__InputGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__InputGroupAddon__ = __webpack_require__(274);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_65__InputGroupAddon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__InputGroupButton__ = __webpack_require__(589);
/* unused harmony reexport InputGroupButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__InputGroupButtonDropdown__ = __webpack_require__(590);
/* unused harmony reexport InputGroupButtonDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__InputGroupText__ = __webpack_require__(275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_68__InputGroupText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Label__ = __webpack_require__(591);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_69__Label__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Media__ = __webpack_require__(592);
/* unused harmony reexport Media */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Pagination__ = __webpack_require__(593);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_71__Pagination__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__PaginationItem__ = __webpack_require__(594);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_72__PaginationItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__PaginationLink__ = __webpack_require__(595);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_73__PaginationLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__TabContent__ = __webpack_require__(596);
/* unused harmony reexport TabContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__TabPane__ = __webpack_require__(597);
/* unused harmony reexport TabPane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__Jumbotron__ = __webpack_require__(598);
/* unused harmony reexport Jumbotron */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Alert__ = __webpack_require__(276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_77__Alert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Collapse__ = __webpack_require__(277);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_78__Collapse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__ListGroupItem__ = __webpack_require__(599);
/* unused harmony reexport ListGroupItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__ListGroupItemHeading__ = __webpack_require__(600);
/* unused harmony reexport ListGroupItemHeading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__ListGroupItemText__ = __webpack_require__(601);
/* unused harmony reexport ListGroupItemText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__UncontrolledAlert__ = __webpack_require__(602);
/* unused harmony reexport UncontrolledAlert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__UncontrolledButtonDropdown__ = __webpack_require__(603);
/* unused harmony reexport UncontrolledButtonDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__UncontrolledCollapse__ = __webpack_require__(604);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_84__UncontrolledCollapse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__UncontrolledDropdown__ = __webpack_require__(278);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_85__UncontrolledDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__UncontrolledNavDropdown__ = __webpack_require__(605);
/* unused harmony reexport UncontrolledNavDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__UncontrolledTooltip__ = __webpack_require__(606);
/* unused harmony reexport UncontrolledTooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__Spinner__ = __webpack_require__(607);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_88__Spinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__utils__ = __webpack_require__(9);
/* unused harmony reexport Util */





















































































































































































/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return MODAL_NEW_STAFF_MEMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return MODAL_REMOVE_STAFF_MEMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return MODAL_REMOVE_ALIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MODAL_ADD_ALIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MODAL_CREATE_ORG_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return MODAL_CHANGE_ORG_BALANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MODAL_ADD_ACCREDITATION_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return MODAL_EDIT_ACCREDITATION_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MODAL_ADD_EMPLOYEE_TO_ACCREDITATION_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return MODAL_REMOVE_EMPLOYEE_FROM_ACCREDITATION_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return MODAL_REMOVE_ACCREDITATION_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MODAL_ADD_DEPARTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return MODAL_EDIT_DEPARTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MODAL_ADD_EMPLOYEE_TO_DEPARTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return MODAL_REMOVE_EMPLOYEE_FROM_DEPARTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return MODAL_REMOVE_DEPARTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return MODAL_RESENT_ACTIVATION_STAFF_MEMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return MODAL_CHANGE_ANCHOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return MODAL_RESENT_ACTIVATION_ANCHOR; });
/* unused harmony export MODAL_REGISTER_APPLICANT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return MODAL_REMOVE_ACCREDITATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return MODAL_REMOVE_BULK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return MODAL_LICENSE_AGREEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return MODAL_VALIDATE_ACCREDITATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return MODAL_CERTIFIED_ACCREDITATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return MODAL_VALIDATE_PENDING_ACCREDITATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MODAL_DISCARD_PENDING_ACCREDITATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return MODAL_REGISTER_ORG_BY_ANCHOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return MODAL_REMOVE_ACTIVE_CONSENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MODAL_CANCEL_CONSENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return MODAL_REMOVE_PRIOR_CONSENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return MODAL_DISMISS_CONSENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return MODAL_CHANGE_2FA_ENABLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return MODAL_REMOVE_SELF_STUDY_BOOK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return MODAL_REMOVE_BULK_CONSENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MODAL_ADD_CERTIFICATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return MODAL_REMOVE_CERTIFICATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return MODAL_SIGNING_ACCREDITATIONS_PROGRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return MODAL_REMOVE_ACCREDITATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return MODAL_REMOVE_ACCREDITATION_REQUESTS_BY_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return MODAL_EDIT_ACCREDITATION_REQUESTS_BY_DOMAIN; });
/* unused harmony export MODAL_ACCREDITATION_REQUESTS_WARNING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MODAL_ACCREDITATION_REQUESTS_REJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MODAL_ACCREDITATION_REQUESTS_SET_AG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MODAL_ACCREDITATION_REQUESTS_GET_ORG_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MODAL_ACCREDITATION_REQUEST_DATA; });
/* unused harmony export MODAL_VALIDATE_ACCREDITATION_REQUESTS_BY_DOMAIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return MODAL_LAST_REQUESTORS_ACCREDITATION_REQUEST_BY_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MODAL_ADD_ORG_FIRST_CERTIFICATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return MODAL_REMOVE_ASSISTANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return MODAL_REMOVE_BUSINESS_AMBASSADOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return MODAL_REMOVE_COMMISSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MODAL_BA_WIRE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return MODAL_UNI_WIRE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return MODAL_COMPANIES_CREDITS_CONTACT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MODAL_BA_DUE_PAYMENT_CONFIRM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return MODAL_UNI_DUE_PAYMENT_CONFIRM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return MODAL_SYSTEM_DUE_PAYMENT_CONFIRM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return MODAL_VALIDATE_PENDING_ORGANIZATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return MODAL_EDIT_ASSISTANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return MODAL_PAYMENT_HISTORY_COMMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return MODAL_REMOVE_ORG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return MODAL_VALIDATE_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return MODAL_EDIT_VALIDATED_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return MODAL_REMOVE_VALIDATED_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MODAL_ADD_VALIDATED_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MODAL_APPLICANT_REQUESTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return MODAL_REMOVE_CERTIFIED_ACCREDITATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MODAL_COMPANY_CREDITS_HISTORY_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return showModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return hideModal; });
/* unused harmony export initialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return getActiveModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//- Modal types
var MODAL_NEW_STAFF_MEMBER="MODAL_NEW_STAFF_MEMBER";var MODAL_REMOVE_STAFF_MEMBER="MODAL_REMOVE_STAFF_MEMBER";var MODAL_REMOVE_ALIAS="MODAL_REMOVE_ALIAS";var MODAL_ADD_ALIAS="MODAL_ADD_ALIAS";var MODAL_CREATE_ORG_PRICE='MODAL_CREATE_ORG_PRICE';var MODAL_CHANGE_ORG_BALANCE='MODAL_CHANGE_ORG_BALANCE';var MODAL_ADD_ACCREDITATION_GROUP='MODAL_ADD_ACCREDITATION_GROUP';var MODAL_EDIT_ACCREDITATION_GROUP='MODAL_EDIT_ACCREDITATION_GROUP';var MODAL_ADD_EMPLOYEE_TO_ACCREDITATION_GROUP='MODAL_ADD_EMPLOYEE_TO_ACCREDITATION_GROUP';var MODAL_REMOVE_EMPLOYEE_FROM_ACCREDITATION_GROUP='MODAL_REMOVE_EMPLOYEE_FROM_ACCREDITATION_GROUP';var MODAL_REMOVE_ACCREDITATION_GROUP='MODAL_REMOVE_ACCREDITATION_GROUP';var MODAL_ADD_DEPARTMENT='MODAL_ADD_DEPARTMENT';var MODAL_EDIT_DEPARTMENT='MODAL_EDIT_DEPARTMENT';var MODAL_ADD_EMPLOYEE_TO_DEPARTMENT='MODAL_ADD_EMPLOYEE_TO_DEPARTMENT';var MODAL_REMOVE_EMPLOYEE_FROM_DEPARTMENT='MODAL_REMOVE_EMPLOYEE_FROM_DEPARTMENT';var MODAL_REMOVE_DEPARTMENT='MODAL_REMOVE_DEPARTMENT';var MODAL_RESENT_ACTIVATION_STAFF_MEMBER='MODAL_RESENT_ACTIVATION_STAFF_MEMBER';var MODAL_CHANGE_ANCHOR='MODAL_CHANGE_ANCHOR';var MODAL_RESENT_ACTIVATION_ANCHOR='MODAL_RESENT_ACTIVATION_ANCHOR';var MODAL_REGISTER_APPLICANT='MODAL_REGISTER_APPLICANT';var MODAL_REMOVE_ACCREDITATION='MODAL_REMOVE_ACCREDITATION';var MODAL_REMOVE_BULK='MODAL_REMOVE_BULK';var MODAL_LICENSE_AGREEMENT='MODAL_LICENSE_AGREEMENT';var MODAL_VALIDATE_ACCREDITATION='MODAL_VALIDATE_ACCREDITATION';var MODAL_CERTIFIED_ACCREDITATION='MODAL_CERTIFIED_ACCREDITATION';var MODAL_VALIDATE_PENDING_ACCREDITATION='MODAL_VALIDATE_PENDING_ACCREDITATION';var MODAL_DISCARD_PENDING_ACCREDITATION='MODAL_DISCARD_PENDING_ACCREDITATION';var MODAL_REGISTER_ORG_BY_ANCHOR='MODAL_REGISTER_ORG_BY_ANCHOR';var MODAL_REMOVE_ACTIVE_CONSENT='MODAL_REMOVE_ACTIVE_CONSENT';var MODAL_CANCEL_CONSENT_REQUEST='MODAL_CANCEL_CONSENT_REQUEST';var MODAL_REMOVE_PRIOR_CONSENT='MODAL_REMOVE_PRIOR_CONSENT';var MODAL_DISMISS_CONSENT_REQUEST='MODAL_DISMISS_CONSENT_REQUEST';var MODAL_CHANGE_2FA_ENABLING='MODAL_CHANGE_2FA_ENABLING';var MODAL_REMOVE_SELF_STUDY_BOOK='MODAL_REMOVE_PRIOR_CONSENT';var MODAL_REMOVE_BULK_CONSENT_REQUEST='MODAL_REMOVE_BULK_CONSENT_REQUEST';var MODAL_ADD_CERTIFICATE='MODAL_ADD_CERTIFICATE';var MODAL_REMOVE_CERTIFICATE='MODAL_REMOVE_CERTIFICATE';var MODAL_SIGNING_ACCREDITATIONS_PROGRESS='MODAL_SIGNING_ACCREDITATIONS_PROGRESS';var MODAL_REMOVE_ACCREDITATION_REQUEST='MODAL_SIGNING_ACCREDITATIONS_PROGRESS';var MODAL_REMOVE_ACCREDITATION_REQUESTS_BY_DOMAIN='MODAL_REMOVE_ACCREDITATION_REQUESTS_BY_DOMAIN';var MODAL_EDIT_ACCREDITATION_REQUESTS_BY_DOMAIN='MODAL_EDIT_ACCREDITATION_REQUESTS_BY_DOMAIN';var MODAL_ACCREDITATION_REQUESTS_WARNING='MODAL_ACCREDITATION_REQUESTS_WARNING';var MODAL_ACCREDITATION_REQUESTS_REJECT='MODAL_ACCREDITATION_REQUESTS_REJECT';var MODAL_ACCREDITATION_REQUESTS_SET_AG='MODAL_ACCREDITATION_REQUESTS_SET_AG';var MODAL_ACCREDITATION_REQUESTS_GET_ORG_ERROR='MODAL_ACCREDITATION_REQUESTS_GET_ORG_ERROR';var MODAL_ACCREDITATION_REQUEST_DATA='MODAL_ACCREDITATION_REQUEST_DATA';var MODAL_VALIDATE_ACCREDITATION_REQUESTS_BY_DOMAIN='MODAL_VALIDATE_ACCREDITATION_REQUESTS_BY_DOMAIN';var MODAL_LAST_REQUESTORS_ACCREDITATION_REQUEST_BY_DOMAIN='MODAL_LAST_REQUESTORS_ACCREDITATION_REQUEST_BY_DOMAIN';var MODAL_ADD_ORG_FIRST_CERTIFICATE='MODAL_ADD_ORG_FIRST_CERTIFICATE';var MODAL_REMOVE_ASSISTANT='MODAL_REMOVE_ASSISTANT';var MODAL_REMOVE_BUSINESS_AMBASSADOR='MODAL_REMOVE_BUSINESS_AMBASSADOR';var MODAL_REMOVE_COMMISSION='MODAL_REMOVE_COMMISSION';var MODAL_BA_WIRE_DATA='MODAL_BA_WIRE_DATA';var MODAL_UNI_WIRE_DATA='MODAL_UNI_WIRE_DATA';var MODAL_COMPANIES_CREDITS_CONTACT_DATA='MODAL_COMPANIES_CREDITS_CONTACT_DATA';var MODAL_BA_DUE_PAYMENT_CONFIRM='MODAL_BA_DUE_PAYMENT_CONFIRM';var MODAL_UNI_DUE_PAYMENT_CONFIRM='MODAL_UNI_DUE_PAYMENT_CONFIRM';var MODAL_SYSTEM_DUE_PAYMENT_CONFIRM='MODAL_SYSTEM_DUE_PAYMENT_CONFIRM';var MODAL_VALIDATE_PENDING_ORGANIZATION='MODAL_VALIDATE_PENDING_ORGANIZATION';var MODAL_EDIT_ASSISTANT='MODAL_EDIT_ASSISTANT';var MODAL_PAYMENT_HISTORY_COMMENT='MODAL_PAYMENT_HISTORY_COMMENT';var MODAL_REMOVE_ORG='MODAL_REMOVE_ORG';var MODAL_VALIDATE_DOMAIN='MODAL_VALIDATE_DOMAIN';var MODAL_EDIT_VALIDATED_DOMAIN='MODAL_EDIT_VALIDATED_DOMAIN';var MODAL_REMOVE_VALIDATED_DOMAIN='MODAL_REMOVE_VALIDATED_DOMAIN';var MODAL_ADD_VALIDATED_DOMAIN='MODAL_ADD_VALIDATED_DOMAIN';var MODAL_APPLICANT_REQUESTS='MODAL_APPLICANT_REQUESTS';var MODAL_REMOVE_CERTIFIED_ACCREDITATION='MODAL_REMOVE_CERTIFIED_ACCREDITATION';var MODAL_COMPANY_CREDITS_HISTORY_MODAL='MODAL_COMPANY_CREDITS_HISTORY_MODAL';//- Actions
var showModal=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('MODAL_SHOW',function(modal){return modal;});var hideModal=function hideModal(){return function(dispatch,getState){var activeModal=getActiveModal(getState());if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual(activeModal,initialState)){dispatch({type:'MODAL_HIDE'});}};};//- State
var initialState={};//- Reducers
/* harmony default export */ __webpack_exports__["_14"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({MODAL_SHOW:function MODAL_SHOW(state,action){return Object.assign({},action.payload);},MODAL_HIDE:function MODAL_HIDE(){return initialState;}},initialState));//- Selectors
var getActiveModal=function getActiveModal(state){return state.activeModal;};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchSubmitForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchSubmitFormFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchSubmitFormSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return resetSubmitFormData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetSubmitForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return resetFieldErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setFieldErrors; });
/* unused harmony export getSubmitForm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getSubmitFormSuccessStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSubmitFormError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getSubmitFormFetchingStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSubmitFormFieldsErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//- Actions
var fetchSubmitForm=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_SUBMIT_FORM');var fetchSubmitFormFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_SUBMIT_FORM_FAILED');var fetchSubmitFormSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_SUBMIT_FORM_SUCCESS');var resetSubmitFormData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RESET_SUBMIT_FORM_DATA');var resetSubmitForm=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RESET_SUBMIT_FORM');var resetFieldErrors=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RESET_FIELD_ERRORS');var setFieldErrors=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_FIELD_ERRORS');//- State
var initialState={error:null,fetching:false,success:false,fieldsErrors:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_SUBMIT_FORM:function FETCH_SUBMIT_FORM(state){return Object.assign({},state,{error:null,fetching:true,success:false});},FETCH_SUBMIT_FORM_FAILED:function FETCH_SUBMIT_FORM_FAILED(state,action){return Object.assign({},state,{error:action.payload,fetching:false,success:false});},FETCH_SUBMIT_FORM_SUCCESS:function FETCH_SUBMIT_FORM_SUCCESS(state){return Object.assign({},state,{error:null,fetching:false,success:true});},RESET_SUBMIT_FORM_DATA:function RESET_SUBMIT_FORM_DATA(){return initialState;},RESET_SUBMIT_FORM:function RESET_SUBMIT_FORM(state){return Object.assign({},initialState,{fieldsErrors:state.fieldsErrors});},RESET_FIELD_ERRORS:function RESET_FIELD_ERRORS(state,action){var fieldsErrors=state.fieldsErrors;if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(fieldsErrors)){fieldsErrors=fieldsErrors.length>1?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.without(fieldsErrors,action.payload):null;}return Object.assign({},state,{fieldsErrors:fieldsErrors});},SET_FIELD_ERRORS:function SET_FIELD_ERRORS(state,action){var fieldsErrors=!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(action.payload)&&__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isPlainObject(action.payload)?Object.keys(action.payload):null;return Object.assign({},state,{fieldsErrors:fieldsErrors});}},initialState));//- Selectors
var getSubmitForm=function getSubmitForm(state){return state.submitForm;};var getSubmitFormSuccessStatus=function getSubmitFormSuccessStatus(state){return getSubmitForm(state).success;};var getSubmitFormError=function getSubmitFormError(state){return getSubmitForm(state).error;};var getSubmitFormFetchingStatus=function getSubmitFormFetchingStatus(state){return getSubmitForm(state).fetching;};var getSubmitFormFieldsErrors=function getSubmitFormFieldsErrors(state){return getSubmitForm(state).fieldsErrors;};

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = __extends;
/* unused harmony export __assign */
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getScrollbarWidth */
/* harmony export (immutable) */ __webpack_exports__["s"] = setScrollbarWidth;
/* unused harmony export isBodyOverflowing */
/* harmony export (immutable) */ __webpack_exports__["m"] = getOriginalBodyPadding;
/* harmony export (immutable) */ __webpack_exports__["h"] = conditionallyUpdateScrollbar;
/* unused harmony export setGlobalCssModule */
/* harmony export (immutable) */ __webpack_exports__["p"] = mapToCssModules;
/* harmony export (immutable) */ __webpack_exports__["q"] = omit;
/* harmony export (immutable) */ __webpack_exports__["r"] = pick;
/* harmony export (immutable) */ __webpack_exports__["v"] = warnOnce;
/* harmony export (immutable) */ __webpack_exports__["j"] = deprecated;
/* harmony export (immutable) */ __webpack_exports__["a"] = DOMElement;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return targetPropType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return tagPropType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TransitionTimeouts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TransitionPropTypeKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TransitionStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return keyCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PopperPlacements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return canUseDOM; });
/* unused harmony export isReactRefObj */
/* harmony export (immutable) */ __webpack_exports__["k"] = findDOMElements;
/* unused harmony export isArrayOrNodeList */
/* harmony export (immutable) */ __webpack_exports__["n"] = getTarget;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return defaultToggleEvents; });
/* harmony export (immutable) */ __webpack_exports__["f"] = addMultipleEventListeners;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return focusableElements; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isfunction__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);

 // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443

function getScrollbarWidth() {
  var scrollDiv = document.createElement('div'); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113

  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}
function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? padding + "px" : null;
}
function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}
function getOriginalBodyPadding() {
  var style = window.getComputedStyle(document.body, null);
  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
}
function conditionallyUpdateScrollbar() {
  var scrollbarWidth = getScrollbarWidth(); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433

  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}
var globalCssModule;
function setGlobalCssModule(cssModule) {
  globalCssModule = cssModule;
}
function mapToCssModules(className, cssModule) {
  if (className === void 0) {
    className = '';
  }

  if (cssModule === void 0) {
    cssModule = globalCssModule;
  }

  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}
/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */

function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}
/**
 * Returns a filtered copy of an object with only the specified keys.
 */

function pick(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key;
  var result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }

  return result;
}
var warned = {};
function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }

    warned[message] = true;
  }
}
function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce("\"" + propName + "\" property of \"" + componentName + "\" has been deprecated.\n" + explanation);
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };
}
function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}
var targetPropType = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  current: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
})]);
var tagPropType = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  $$typeof: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.symbol,
  render: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  $$typeof: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.symbol,
  render: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
})]))]);
/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
// These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss

var TransitionTimeouts = {
  Fade: 150,
  // $transition-fade
  Collapse: 350,
  // $transition-collapse
  Modal: 300,
  // $modal-transition
  Carousel: 600 // $carousel-transition

}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.

var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];
var TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};
var keyCodes = {
  esc: 27,
  space: 32,
  enter: 13,
  tab: 9,
  up: 38,
  down: 40,
  home: 36,
  end: 35,
  n: 78,
  p: 80
};
var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function isReactRefObj(target) {
  if (target && typeof target === 'object') {
    return 'current' in target;
  }

  return false;
}
function findDOMElements(target) {
  if (isReactRefObj(target)) {
    return target.current;
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isfunction___default()(target)) {
    return target();
  }

  if (typeof target === 'string' && canUseDOM) {
    var selection = document.querySelectorAll(target);

    if (!selection.length) {
      selection = document.querySelectorAll("#" + target);
    }

    if (!selection.length) {
      throw new Error("The target '" + target + "' could not be identified in the dom, tip: check spelling");
    }

    return selection;
  }

  return target;
}
function isArrayOrNodeList(els) {
  if (els === null) {
    return false;
  }

  return Array.isArray(els) || canUseDOM && typeof els.length === 'number';
}
function getTarget(target) {
  var els = findDOMElements(target);

  if (isArrayOrNodeList(els)) {
    return els[0];
  }

  return els;
}
var defaultToggleEvents = ['touchstart', 'click'];
function addMultipleEventListeners(_els, handler, _events, useCapture) {
  var els = _els;

  if (!isArrayOrNodeList(els)) {
    els = [els];
  }

  var events = _events;

  if (typeof events === 'string') {
    events = events.split(/\s+/);
  }

  if (!isArrayOrNodeList(els) || typeof handler !== 'function' || !Array.isArray(events)) {
    throw new Error("\n      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.\n      The second must be a function.\n      The third is a string or an array of strings that represents DOM events\n    ");
  }

  Array.prototype.forEach.call(events, function (event) {
    Array.prototype.forEach.call(els, function (el) {
      el.addEventListener(event, handler, useCapture);
    });
  });
  return function removeEvents() {
    Array.prototype.forEach.call(events, function (event) {
      Array.prototype.forEach.call(els, function (el) {
        el.removeEventListener(event, handler, useCapture);
      });
    });
  };
}
var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'object', 'embed', '[tabindex]:not(.modal)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Utils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var BOLD_ANNOTATION="$";var ITALIC_ANNOTATION="#";var DEFAULT_BANK_DATA_COUNTRY="LT";var Utils=function(){function Utils(){_classCallCheck(this,Utils);}_createClass(Utils,null,[{key:'getParamsFromLocationSearch',value:function getParamsFromLocationSearch(data){return __WEBPACK_IMPORTED_MODULE_3_query_string___default.a.parse(data);}},{key:'convertParamsToLocationSearch',value:function convertParamsToLocationSearch(data){return __WEBPACK_IMPORTED_MODULE_3_query_string___default.a.stringify(data);}},{key:'getOptions',value:function getOptions(data){var options=[];if(!data)return options;data.forEach(function(elem){options.push({value:elem.code,label:elem.name});});return options;}},{key:'getLocationOptions',value:function getLocationOptions(codes,translations){var formattedData=[];if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(codes)){formattedData=codes.map(function(elem){return{value:elem,label:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(translations)?'':translations[elem]};});}formattedData=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sortBy(formattedData,["label"]);return formattedData;}},{key:'getAccreditationGroupOptions',value:function getAccreditationGroupOptions(data,emptyOption){if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(data)||!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(data)){return this.getOptions(null,emptyOption);}var formattedData=data.map(function(elem){return{code:elem.id,name:elem.name};});return this.getOptions(formattedData,emptyOption);}},{key:'getLevelsOptions',value:function getLevelsOptions(data,translations){if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(data)){return[];}return data.map(function(elem){return{value:elem,label:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(translations)?'':translations[elem]};});}},{key:'getCurrenciesOptions',value:function getCurrenciesOptions(data){if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(data)||!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(data)){return[];}return data.map(function(elem){return{value:elem,label:__WEBPACK_IMPORTED_MODULE_0__constants_constants__["g" /* CURRENCIES */][elem]};});}},{key:'getPresetsOptions',value:function getPresetsOptions(data){if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(data)||!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(data)){return[];}return data.map(function(elem){return{value:elem.id,label:elem.name};});}},{key:'getBAsOptions',value:function getBAsOptions(data){if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(data)||!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(data)){return[];}return data.map(function(elem){return{value:elem.id,label:elem.firstName+" "+elem.lastName};});}},{key:'isValidPassword',value:function isValidPassword(password){return password.length<=__WEBPACK_IMPORTED_MODULE_0__constants_constants__["p" /* PASSWORD_MAX_LENGTH */]&&password.length>=__WEBPACK_IMPORTED_MODULE_0__constants_constants__["q" /* PASSWORD_MIN_LENGTH */];}},{key:'objectToFormData',value:function objectToFormData(obj){return Object.keys(obj).map(function(k){return encodeURIComponent(k)+'='+encodeURIComponent(obj[k]);}).join('&');}},{key:'stringToBase64',value:function stringToBase64(str){return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,function toSolidBytes(match,p1){return String.fromCharCode('0x'+p1);}));}},{key:'isDateHistorical',value:function isDateHistorical(date){var boundaryDate=__WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(2,'months');return date<boundaryDate;}},{key:'getTagsFromStringWithStyles',value:function getTagsFromStringWithStyles(str){var array=this.parseStringToArrayWithStyles(str);return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(array,function(elem,id){if(elem.italic&&elem.bold){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b',{key:id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i',null,elem.text));}else if(elem.italic){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i',{key:id},elem.text);}else if(elem.bold){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('b',{key:id},elem.text);}else{return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{key:id},elem.text);}});}},{key:'parseStringToArrayWithStyles',value:function parseStringToArrayWithStyles(str){var result=[];var bold=false,italic=false;var text=str.split('').reduce(function(a,b){if(b===BOLD_ANNOTATION){if(bold){if(a!==''){if(italic)result.push({text:a,bold:true,italic:true});else result.push({text:a,bold:true});}bold=false;}else{if(italic)result.push({text:a,italic:true});else result.push({text:a});bold=true;}return'';}else if(b===ITALIC_ANNOTATION){if(italic){if(a!==''){if(bold)result.push({text:a,bold:true,italic:true});else result.push({text:a,italic:true});}italic=false;}else{if(bold)result.push({text:a,bold:true});else result.push({text:a});italic=true;}return'';}else{return a+b;}},'');if(text!==''){result.push({text:text});}return result;}},{key:'getBankDataByCountry',value:function getBankDataByCountry(countryCode,translations){var banksData=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(translations,'payment.bank_data_by_location');if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(translations)||!banksData){return null;}return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(banksData,countryCode)||__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(banksData,DEFAULT_BANK_DATA_COUNTRY);}}]);return Utils;}();Utils.getAccreditationFormattedData=function(accreditation){if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(accreditation)){return{};}var data={titleOrig:accreditation.accreditationData.titles.original,titleEn:accreditation.accreditationData.titles.en,titlesAdditional:{},dateIssued:__WEBPACK_IMPORTED_MODULE_2_moment___default()(accreditation.accreditationData.issuedAt),level:accreditation.accreditationData.level,personFirstName:accreditation.verifiedIdentity.firstName,personLastName:accreditation.verifiedIdentity.lastName,personNationalId:accreditation.verifiedIdentity.nationalId,personCountry:accreditation.verifiedIdentity.countryCode};__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(accreditation.accreditationData.titles,function(value,key){if(key!=='en'&&key!=='original'){data.titlesAdditional[key]=value;}});return data;};

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IconContainer_css__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IconContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__IconContainer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons_Add__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icons_CheckBox__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons_CheckBoxOutlineBlank__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icons_Clear__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icons_Create__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__icons_Info__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__icons_Person__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icons_RadioButtonChecked__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__icons_RadioButtonUnchecked__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__icons_ArrowBack__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__icons_QuestionMark__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons_KeyboardArrowRight__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__icons_KeyboardArrowDown__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__icons_Certify__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__icons_Search__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__icons_Visibility__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__icons_CheckCircleOutline__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__icons_HighlightOff__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__icons_Book__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__icons_Trash__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__icons_NotificationCircle__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__icons_Restore__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__icons_Lock__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__icons_Save__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__icons_Payment__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__icons_PlayCircleOutline__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__icons_AddYear__ = __webpack_require__(635);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ICONS_MAP={add:__WEBPACK_IMPORTED_MODULE_4__icons_Add__["a" /* default */],check_box:__WEBPACK_IMPORTED_MODULE_5__icons_CheckBox__["a" /* default */],check_box_outline_blank:__WEBPACK_IMPORTED_MODULE_6__icons_CheckBoxOutlineBlank__["a" /* default */],clear:__WEBPACK_IMPORTED_MODULE_7__icons_Clear__["a" /* default */],create:__WEBPACK_IMPORTED_MODULE_8__icons_Create__["a" /* default */],info:__WEBPACK_IMPORTED_MODULE_9__icons_Info__["a" /* default */],person:__WEBPACK_IMPORTED_MODULE_10__icons_Person__["a" /* default */],radio_button_checked:__WEBPACK_IMPORTED_MODULE_11__icons_RadioButtonChecked__["a" /* default */],radio_button_unchecked:__WEBPACK_IMPORTED_MODULE_12__icons_RadioButtonUnchecked__["a" /* default */],arrow_back:__WEBPACK_IMPORTED_MODULE_13__icons_ArrowBack__["a" /* default */],question_mark:__WEBPACK_IMPORTED_MODULE_14__icons_QuestionMark__["a" /* default */],keyboard_arrow_right:__WEBPACK_IMPORTED_MODULE_15__icons_KeyboardArrowRight__["a" /* default */],keyboard_arrow_down:__WEBPACK_IMPORTED_MODULE_16__icons_KeyboardArrowDown__["a" /* default */],certify:__WEBPACK_IMPORTED_MODULE_17__icons_Certify__["a" /* default */],search:__WEBPACK_IMPORTED_MODULE_18__icons_Search__["a" /* default */],visibility:__WEBPACK_IMPORTED_MODULE_19__icons_Visibility__["a" /* default */],check_circle_outline:__WEBPACK_IMPORTED_MODULE_20__icons_CheckCircleOutline__["a" /* default */],highlight_off:__WEBPACK_IMPORTED_MODULE_21__icons_HighlightOff__["a" /* default */],book:__WEBPACK_IMPORTED_MODULE_22__icons_Book__["a" /* default */],trash:__WEBPACK_IMPORTED_MODULE_23__icons_Trash__["a" /* default */],notification_circle:__WEBPACK_IMPORTED_MODULE_24__icons_NotificationCircle__["a" /* default */],restore:__WEBPACK_IMPORTED_MODULE_25__icons_Restore__["a" /* default */],lock:__WEBPACK_IMPORTED_MODULE_26__icons_Lock__["a" /* default */],save:__WEBPACK_IMPORTED_MODULE_27__icons_Save__["a" /* default */],payment:__WEBPACK_IMPORTED_MODULE_28__icons_Payment__["a" /* default */],play_circle_outline:__WEBPACK_IMPORTED_MODULE_29__icons_PlayCircleOutline__["a" /* default */],add_year:__WEBPACK_IMPORTED_MODULE_30__icons_AddYear__["a" /* default */]};var IconContainer=function(_Component){_inherits(IconContainer,_Component);function IconContainer(){_classCallCheck(this,IconContainer);return _possibleConstructorReturn(this,(IconContainer.__proto__||Object.getPrototypeOf(IconContainer)).apply(this,arguments));}_createClass(IconContainer,[{key:'render',value:function render(){var TagName=ICONS_MAP[this.props.icon];if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.icon)||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(ICONS_MAP[this.props.icon])){return null;}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"icon-container-component "+(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.className)?this.props.className:""),title:this.props.title,onClick:this.props.onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TagName,null));}}}]);return IconContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);IconContainer.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (IconContainer);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormWrapper__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{error:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_submitForm__["e" /* getSubmitFormError */])(state),fetching:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_submitForm__["f" /* getSubmitFormFetchingStatus */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onResetState:function onResetState(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onCloseAlert:function onCloseAlert(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_submitForm__["j" /* resetSubmitForm */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__FormWrapper__["a" /* default */]));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(250)(module)))

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return onForbidden; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return onServerError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return onRefreshForbidden; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return logout; });
/* unused harmony export fetchAuthorizeFailed */
/* unused harmony export fetchAuthorizeSuccess */
/* unused harmony export fetchAuthorize2FARequired */
/* unused harmony export onAuthorizeSuccess */
/* unused harmony export onAuthorizeFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchAuthorize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cleanLoginError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clean2FARequiredStatus; });
/* unused harmony export getLogin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getLoginAuthoriseStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getLoginFetchingStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getLoginError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getIs2FARequired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isForbidden; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isServerError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_storageApi__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_handleApiCall__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__userData__ = __webpack_require__(35);
//- Actions
var onForbidden=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_FORBIDDEN');var onServerError=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_SERVER_ERROR');var onRefreshForbidden=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REFRESH_FORBIDDEN');var logout=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('LOGOUT');var fetchAuthorizeFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_AUTHORIZE_FAILED');var fetchAuthorizeSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_AUTHORIZE_SUCCESS');var fetchAuthorize2FARequired=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_AUTHORIZE_2FA_REQUIRED');var onAuthorizeSuccess=function onAuthorizeSuccess(result){return function(dispatch){dispatch(fetchAuthorizeSuccess(result.token));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__userData__["b" /* fetchGetUserData */])());};};var onAuthorizeFailed=function onAuthorizeFailed(error){return function(dispatch){switch(error){case __WEBPACK_IMPORTED_MODULE_3__common_handleApiCall__["c" /* UNAUTHORIZED */]:dispatch(fetchAuthorizeFailed("INCORRECT_USERNAME_OR_PASSWORD"));break;case __WEBPACK_IMPORTED_MODULE_3__common_handleApiCall__["b" /* TOTP_CODE_REQUIRED */]:dispatch(fetchAuthorize2FARequired());break;default:dispatch(fetchAuthorizeFailed(error));break;}};};var fetchAuthorize=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_AUTHORIZE',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getToken(data);},function(){return{apiCall:true,onSuccess:onAuthorizeSuccess,onFail:onAuthorizeFailed};});var cleanLoginError=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAN_LOGIN_ERROR');var clean2FARequiredStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAN_2FA_REQUIRED_STATUS');//- State
var initialState={isAuthorised:!!__WEBPACK_IMPORTED_MODULE_2__utils_storageApi__["a" /* StorageApi */].getLoginToken(),error:null,fetching:false,isForbidden:false,isServerError:false,is2FARequired:false};//- Reducers
/* harmony default export */ __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_AUTHORIZE:function FETCH_AUTHORIZE(state){__WEBPACK_IMPORTED_MODULE_2__utils_storageApi__["a" /* StorageApi */].removeUserData();return Object.assign({},state,{isAuthorised:false,error:null,fetching:true});},FETCH_UPDATE_AUTHORIZATION:function FETCH_UPDATE_AUTHORIZATION(state){return Object.assign({},state,{error:null,fetching:true});},FETCH_AUTHORIZE_FAILED:function FETCH_AUTHORIZE_FAILED(state,action){__WEBPACK_IMPORTED_MODULE_2__utils_storageApi__["a" /* StorageApi */].removeLoginToken();return Object.assign({},state,{isAuthorised:false,error:action.payload,fetching:false});},FETCH_AUTHORIZE_2FA_REQUIRED:function FETCH_AUTHORIZE_2FA_REQUIRED(state){return Object.assign({},state,{isAuthorised:false,is2FARequired:true,fetching:false});},FETCH_AUTHORIZE_SUCCESS:function FETCH_AUTHORIZE_SUCCESS(state,action){__WEBPACK_IMPORTED_MODULE_2__utils_storageApi__["a" /* StorageApi */].setLoginToken(action.payload);return Object.assign({},state,{isAuthorised:true,error:null,fetching:false,is2FARequired:false});},LOGOUT:function LOGOUT(state){__WEBPACK_IMPORTED_MODULE_2__utils_storageApi__["a" /* StorageApi */].removeLoginToken();__WEBPACK_IMPORTED_MODULE_2__utils_storageApi__["a" /* StorageApi */].removeUserData();return Object.assign({},state,{isAuthorised:false,error:null});},SET_FORBIDDEN:function SET_FORBIDDEN(state){return Object.assign({},state,{isForbidden:true});},SET_SERVER_ERROR:function SET_SERVER_ERROR(state){return Object.assign({},state,{isServerError:true});},REFRESH_FORBIDDEN:function REFRESH_FORBIDDEN(state){return Object.assign({},state,{isForbidden:false});},CLEAN_LOGIN_ERROR:function CLEAN_LOGIN_ERROR(state){return Object.assign({},state,{error:null});},CLEAN_2FA_REQUIRED_STATUS:function CLEAN_2FA_REQUIRED_STATUS(state){return Object.assign({},state,{is2FARequired:false});}},initialState));//- Selectors
var getLogin=function getLogin(state){return state.login;};var getLoginAuthoriseStatus=function getLoginAuthoriseStatus(state){return getLogin(state).isAuthorised;};var getLoginFetchingStatus=function getLoginFetchingStatus(state){return getLogin(state).fetching;};var getLoginError=function getLoginError(state){return getLogin(state).error;};var getIs2FARequired=function getIs2FARequired(state){return getLogin(state).is2FARequired;};var isForbidden=function isForbidden(state){return getLogin(state).isForbidden;};var isServerError=function isServerError(state){return getLogin(state).isServerError;};

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__combineActions__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAction__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createActions__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createCurriedAction__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handleAction__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handleActions__ = __webpack_require__(482);
/* unused harmony reexport combineActions */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__createAction__["a"]; });
/* unused harmony reexport createActions */
/* unused harmony reexport createCurriedAction */
/* unused harmony reexport handleAction */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__handleActions__["a"]; });









/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_storageApi__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Api=function(){function Api(){_classCallCheck(this,Api);}_createClass(Api,null,[{key:'fetchGetRequest',value:function fetchGetRequest(path){return fetch(path);}},{key:'fetchGetRequestWithToken',value:function fetchGetRequestWithToken(path){var token=__WEBPACK_IMPORTED_MODULE_0__utils_storageApi__["a" /* StorageApi */].getLoginToken();return fetch(path,{headers:{'Authorization':'Bearer '+token}});}},{key:'fetchPostRequest',value:function fetchPostRequest(path,data){return fetch(path,{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify(data)});}},{key:'fetchPostRequestWithToken',value:function fetchPostRequestWithToken(path,data){var token=__WEBPACK_IMPORTED_MODULE_0__utils_storageApi__["a" /* StorageApi */].getLoginToken();return fetch(path,{method:"POST",headers:{'Authorization':'Bearer '+token,'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify(data)});}},{key:'fetchPostRequestWithTokenWithTextBody',value:function fetchPostRequestWithTokenWithTextBody(path,data){var token=__WEBPACK_IMPORTED_MODULE_0__utils_storageApi__["a" /* StorageApi */].getLoginToken();return fetch(path,{method:"POST",headers:{'Authorization':'Bearer '+token,'Content-Type':'text/plain'},body:data});}},{key:'fetchPutRequestWithToken',value:function fetchPutRequestWithToken(path,data){var token=__WEBPACK_IMPORTED_MODULE_0__utils_storageApi__["a" /* StorageApi */].getLoginToken();return fetch(path,{method:"PUT",headers:{'Authorization':'Bearer '+token,'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify(data)});}},{key:'fetchDeleteRequestWithToken',value:function fetchDeleteRequestWithToken(path){var token=__WEBPACK_IMPORTED_MODULE_0__utils_storageApi__["a" /* StorageApi */].getLoginToken();return fetch(path,{method:"DELETE",headers:{'Authorization':'Bearer '+token}});}},{key:'fetchDeleteRequestWithTokenAndBody',value:function fetchDeleteRequestWithTokenAndBody(path,data){var token=__WEBPACK_IMPORTED_MODULE_0__utils_storageApi__["a" /* StorageApi */].getLoginToken();return fetch(path,{method:"DELETE",headers:{'Authorization':'Bearer '+token,'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify(data)});}},{key:'getToken',value:function getToken(data){var path='/api/login';return fetch(path,{method:"POST",headers:{'Content-Type':'application/x-www-form-urlencoded'},body:__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* Utils */].objectToFormData(data)});}},{key:'getUserDataByToken',value:function getUserDataByToken(token){var path='/api/user';return fetch(path,{method:"GET",headers:{'Authorization':'Bearer '+token}});}},{key:'getUserData',value:function getUserData(){var path='/api/user';return this.fetchGetRequestWithToken(path);}},{key:'checkEmailAvailability',value:function checkEmailAvailability(email){var path='/api/user/email?email='+email;return fetch(path);}},{key:'checkOAuthRequest',value:function checkOAuthRequest(params){var path='/api/oauth/authorize'+params;return fetch(path);}},{key:'sendOAuthGiveAccess',value:function sendOAuthGiveAccess(data){var path='/api/oauth/authorize?';path+=__WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* Utils */].convertParamsToLocationSearch(data);return this.fetchPostRequestWithToken(path);}},{key:'getInserterGroups',value:function getInserterGroups(){var path='/api/organization/accreditation-groups/inserter-list';return this.fetchGetRequestWithToken(path);}},{key:'getValidatorGroups',value:function getValidatorGroups(){var path='/api/organization/accreditation-groups/validator-list';return this.fetchGetRequestWithToken(path);}},{key:'getHMGroups',value:function getHMGroups(){var path='/api/organization/departments/hm-list';return this.fetchGetRequestWithToken(path);}},{key:'getBOGroups',value:function getBOGroups(){var path='/api/organization/departments/bo-list';return this.fetchGetRequestWithToken(path);}},{key:'activateAccount',value:function activateAccount(token,data){var path='/api/user/activation';return fetch(path,{method:"PUT",headers:{'Authorization':'Bearer '+token,'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify(data)});}},{key:'registerApplicant',value:function registerApplicant(language,data){var path='/api/user?language='+language;return this.fetchPostRequest(path,data);}},{key:'sendResetPasswordEmail',value:function sendResetPasswordEmail(email){var path='/api/user/password';return this.fetchPostRequest(path,email);}},{key:'resetPassword',value:function resetPassword(token,password){var path='/api/user/password';return fetch(path,{method:"PUT",headers:{'Authorization':'Bearer '+token,'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify(password)});}},{key:'changePassword',value:function changePassword(data){var path='/api/user/change-password';return this.fetchPutRequestWithToken(path,data);}},{key:'changeEmail',value:function changeEmail(email){var path='/api/user/email';return this.fetchPostRequestWithToken(path,email);}},{key:'submitChangeEmail',value:function submitChangeEmail(token){var path='/api/user/email';return fetch(path,{method:"PUT",headers:{'Authorization':'Bearer '+token,'Accept':'application/json','Content-Type':'application/json'}});}},{key:'getTranslationByPath',value:function getTranslationByPath(path){return fetch(path);}},{key:'getTranslations',value:function getTranslations(){var path='/static/translations/translations_list.json';return fetch(path);}},{key:'getAliases',value:function getAliases(){var path='/api/user/aliases';return this.fetchGetRequestWithToken(path);}},{key:'addAlias',value:function addAlias(data){var path='/api/user/aliases';return this.fetchPostRequestWithToken(path,data);}},{key:'updateAlias',value:function updateAlias(id,data){var path='/api/user/aliases/'+id;return this.fetchPutRequestWithToken(path,data);}},{key:'removeAlias',value:function removeAlias(id){var path='/api/user/aliases/'+id;return this.fetchDeleteRequestWithToken(path);}},{key:'getDefaultAlias',value:function getDefaultAlias(){var path='/api/user/aliases/default';return this.fetchGetRequestWithToken(path);}},{key:'setDefaultAlias',value:function setDefaultAlias(data){var path='/api/user/aliases/default';return this.fetchPutRequestWithToken(path,data);}},{key:'getCountries',value:function getCountries(){var path='/api/countries';return this.fetchGetRequest(path);}},{key:'getOrgs',value:function getOrgs(validated,page,countryCode,name){var path='/api/system/organizations?size=10';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(validated)){path+='&validatedFilter='+validated;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(countryCode)){path+='&countryCodeFilter='+countryCode;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(name)){path+='&nameFilter='+name;}return this.fetchGetRequestWithToken(path);}},{key:'getOrgsWithoutCertificates',value:function getOrgsWithoutCertificates(page){var path='/api/system/organizations?validatedFilter=true&certificateSpecifiedFilter=false&hasIVsFilter=true&size=10';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}return this.fetchGetRequestWithToken(path);}},{key:'registerOrganization',value:function registerOrganization(data){var path='/api/system/organizations';return this.fetchPostRequestWithToken(path,data);}},{key:'updateOrganizationValidatedState',value:function updateOrganizationValidatedState(id,isValidated){var path='/api/system/organizations/'+id+'/validated';return this.fetchPutRequestWithToken(path,isValidated);}},{key:'updateOrganizationGeneralData',value:function updateOrganizationGeneralData(id,data){var path='/api/system/organizations/'+id+'/general';return this.fetchPutRequestWithToken(path,data);}},{key:'updateOrganizationFinancialData',value:function updateOrganizationFinancialData(id,data){var path='/api/system/organizations/'+id+'/financial-data';return this.fetchPutRequestWithToken(path,data);}},{key:'getOrganizationDataById',value:function getOrganizationDataById(id){var path='/api/system/organizations/'+id;return this.fetchGetRequestWithToken(path);}},{key:'getOrg',value:function getOrg(){var path='/api/organization';return this.fetchGetRequestWithToken(path);}},{key:'resendActivation',value:function resendActivation(email){var path='/api/user/activation';return this.fetchPostRequest(path,email);}},{key:'getStaffMembers',value:function getStaffMembers(page,size){var pageSize=10;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(size)){pageSize=size;}var path='/api/organization/staff?size='+pageSize;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}return this.fetchGetRequestWithToken(path);}},{key:'registerStaff',value:function registerStaff(data){var path='/api/organization/staff';return this.fetchPostRequestWithToken(path,data);}},{key:'removeStaffMember',value:function removeStaffMember(staffMemberId){var path='/api/organization/staff/'+staffMemberId;return this.fetchDeleteRequestWithToken(path);}},{key:'getAccreditationGroups',value:function getAccreditationGroups(page){var path='/api/organization/accreditation-groups?size=10';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}return this.fetchGetRequestWithToken(path);}},{key:'registerAccreditationGroup',value:function registerAccreditationGroup(data){var path='/api/organization/accreditation-groups';return this.fetchPostRequestWithToken(path,data);}},{key:'editAccreditationGroup',value:function editAccreditationGroup(groupId,data){var path='/api/organization/accreditation-groups/'+groupId;return this.fetchPutRequestWithToken(path,data);}},{key:'getAccreditationGroup',value:function getAccreditationGroup(id){var path='/api/organization/accreditation-groups/'+id;return this.fetchGetRequestWithToken(path);}},{key:'getEmployeesByAccreditationGroupAndRole',value:function getEmployeesByAccreditationGroupAndRole(id,role){var path='/api/organization/accreditation-groups/'+id+'/staff?role='+role;return this.fetchGetRequestWithToken(path);}},{key:'addEmployeeToAccreditationGroup',value:function addEmployeeToAccreditationGroup(groupId,employeeId,role){var path='/api/organization/accreditation-groups/'+groupId+'/staff';return this.fetchPutRequestWithToken(path,{id:employeeId,role:role});}},{key:'removeEmployeeFromAccreditationGroup',value:function removeEmployeeFromAccreditationGroup(groupId,employeeId,role){var path='/api/organization/accreditation-groups/'+groupId+'/staff';return this.fetchDeleteRequestWithTokenAndBody(path,{id:employeeId,role:role});}},{key:'removeAccreditationGroup',value:function removeAccreditationGroup(groupId){var path='/api/organization/accreditation-groups/'+groupId;return this.fetchDeleteRequestWithToken(path);}},{key:'getDepartments',value:function getDepartments(page){var path='/api/organization/departments?size=10';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}return this.fetchGetRequestWithToken(path);}},{key:'editDepartment',value:function editDepartment(departmentId,data){var path='/api/organization/departments/'+departmentId;return this.fetchPutRequestWithToken(path,data);}},{key:'registerDepartment',value:function registerDepartment(data){var path='/api/organization/departments';return this.fetchPostRequestWithToken(path,data);}},{key:'getDepartment',value:function getDepartment(departmentId){var path='/api/organization/departments/'+departmentId;return this.fetchGetRequestWithToken(path);}},{key:'getEmployeesByDepartmentAndRole',value:function getEmployeesByDepartmentAndRole(departmentId,role){var path='/api/organization/departments/'+departmentId+'/staff?role='+role;return this.fetchGetRequestWithToken(path);}},{key:'addEmployeeToDepartment',value:function addEmployeeToDepartment(departmentId,employeeId,role){var path='/api/organization/departments/'+departmentId+'/staff';return this.fetchPutRequestWithToken(path,{id:employeeId,role:role});}},{key:'removeEmployeeFromDepartment',value:function removeEmployeeFromDepartment(departmentId,employeeId,role){var path='/api/organization/departments/'+departmentId+'/staff';return this.fetchDeleteRequestWithTokenAndBody(path,{id:employeeId,role:role});}},{key:'removeDepartment',value:function removeDepartment(departmentId){var path='/api/organization/departments/'+departmentId;return this.fetchDeleteRequestWithToken(path);}},{key:'changeAnchor',value:function changeAnchor(data){var path='/api/organization/anchor';return this.fetchPostRequestWithToken(path,data);}},{key:'getTitleCodes',value:function getTitleCodes(){var path='/api/organization/accreditations/title-codes';return this.fetchGetRequestWithToken(path);}},{key:'getLevels',value:function getLevels(){var path='/api/organization/accreditations/levels';return this.fetchGetRequestWithToken(path);}},{key:'insertAccreditation',value:function insertAccreditation(data){var path='/api/organization/accreditations';return this.fetchPostRequestWithToken(path,data);}},{key:'getAccreditationsForValidation',value:function getAccreditationsForValidation(groupId,countryFilter,domainFilter,page){var path='/api/organization/accreditations/pending?accredGroupId='+groupId+'&size=10';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(countryFilter)){path+='&countryCodeFilter='+countryFilter;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(domainFilter)){path+='&domainFilter='+domainFilter;}return this.fetchGetRequestWithToken(path);}},{key:'getStaticsticsForAccreditationsForValidation',value:function getStaticsticsForAccreditationsForValidation(group,countryCode,groupBy){var path='/api/organization/accreditations/pending/statistics?accredGroupId='+group;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(countryCode)){path+='&countryCodeFilter='+countryCode;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(groupBy)){path+='&groupBy='+groupBy;}return this.fetchGetRequestWithToken(path);}},{key:'validateAccreditation',value:function validateAccreditation(accreditationId,data){var path='/api/organization/accreditations/'+accreditationId+'/validation';return this.fetchPostRequestWithToken(path,data);}},{key:'getAccreditationsForReviewByGroupId',value:function getAccreditationsForReviewByGroupId(groupId,page,isInternal,countryFilter,domainFilter){var path='/api/organization/accreditations/rejected?accredGroupId='+groupId+'&size=10';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}path+='&status=REJECTED_BY_'+(isInternal?'VALIDATOR':'APPLICANT');if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(countryFilter)){path+='&countryCodeFilter='+countryFilter;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(domainFilter)){path+='&domainFilter='+domainFilter;}return this.fetchGetRequestWithToken(path);}},{key:'getStatisticsForRejectedAccreditations',value:function getStatisticsForRejectedAccreditations(group,isInternal,countryCode,groupBy){var path='/api/organization/accreditations/rejected/statistics?accredGroupId='+group;path+='&status=REJECTED_BY_'+(isInternal?'VALIDATOR':'APPLICANT');if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(countryCode)){path+='&countryCodeFilter='+countryCode;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(groupBy)){path+='&groupBy='+groupBy;}return this.fetchGetRequestWithToken(path);}},{key:'reviewAccreditation',value:function reviewAccreditation(accreditationId,data){var path='/api/organization/accreditations/'+accreditationId;return this.fetchPostRequestWithToken(path,data);}},{key:'removeAccreditation',value:function removeAccreditation(accreditationId){var path='/api/organization/accreditations/'+accreditationId;return this.fetchDeleteRequestWithToken(path);}},{key:'getBulkJobs',value:function getBulkJobs(groupId){var path='/api/organization/accreditations/bulk?accredGroupId='+groupId;return this.fetchGetRequestWithToken(path);}},{key:'fetchUploadBulkAccreditationsAsFile',value:function fetchUploadBulkAccreditationsAsFile(data){var path='/api/organization/accreditations/bulk/file';var token=__WEBPACK_IMPORTED_MODULE_0__utils_storageApi__["a" /* StorageApi */].getLoginToken();return fetch(path,{method:"POST",headers:{'Authorization':'Bearer '+token},body:data});}},{key:'fetchUploadBulkAccreditationsAsJSON',value:function fetchUploadBulkAccreditationsAsJSON(data){var path='/api/organization/accreditations/bulk/json';return this.fetchPostRequestWithToken(path,data);}},{key:'removeBulk',value:function removeBulk(bulkId){var path='/api/organization/accreditations/bulk/'+bulkId;return this.fetchDeleteRequestWithToken(path);}},{key:'changeAnchorBySysAdmin',value:function changeAnchorBySysAdmin(orgId,anchorData){var path='/api/system/organizations/'+orgId+'/anchor';return this.fetchPostRequestWithToken(path,anchorData);}},{key:'getCertifiedAccreditations',value:function getCertifiedAccreditations(){var path='/api/user/accreditations';return this.fetchGetRequestWithToken(path);}},{key:'updateCertifiedAccreditation',value:function updateCertifiedAccreditation(id,data){var path='/api/user/accreditations/'+id;return this.fetchPutRequestWithToken(path,data);}},{key:'removeCertifiedAccreditation',value:function removeCertifiedAccreditation(id){var path='/api/user/accreditations/'+id;return this.fetchDeleteRequestWithToken(path);}},{key:'getPendingAccreditations',value:function getPendingAccreditations(){var path='/api/user/accreditations/pending';return this.fetchGetRequestWithToken(path);}},{key:'validatePendingAccreditation',value:function validatePendingAccreditation(accreditationId,data){var path='/api/user/accreditations/pending/'+accreditationId+'/review';return this.fetchPostRequestWithToken(path,data);}},{key:'discardPendingAccreditation',value:function discardPendingAccreditation(accreditationId){var path='/api/user/accreditations/pending/'+accreditationId;return this.fetchDeleteRequestWithToken(path);}},{key:'getAllVIDs',value:function getAllVIDs(){var path='/api/user/verified-identities';return this.fetchGetRequestWithToken(path);}},{key:'updateVID',value:function updateVID(id,data){var path='/api/user/verified-identities/'+id;return this.fetchPutRequestWithToken(path,data);}},{key:'activateVID',value:function activateVID(id){var path='/api/user/verified-identities/'+id+'/activate';return this.fetchPostRequestWithToken(path);}},{key:'updateOrgByAnchor',value:function updateOrgByAnchor(data){var path='/api/organization';return this.fetchPutRequestWithToken(path,data);}},{key:'getCurrencies',value:function getCurrencies(){var path='/api/system/currencies';return this.fetchGetRequestWithToken(path);}},{key:'changeOrganizationBalance',value:function changeOrganizationBalance(id,data){var path='/api/system/organizations/'+id+'/balance';return this.fetchPostRequestWithToken(path,data);}},{key:'getPriceByOrgTypeAndCountry',value:function getPriceByOrgTypeAndCountry(orgType,countryCode){var path='/api/system/organizations/default-financial-settings?organizationType='+orgType+"&countryCode="+countryCode;return this.fetchGetRequestWithToken(path);}},{key:'getPresets',value:function getPresets(){var path='/api/system/pricing-presets';return this.fetchGetRequestWithToken(path);}},{key:'convertMoney',value:function convertMoney(data){var path='/api/system/currencies/exchange?amount='+data.amount+'&currencyFrom='+data.currencyFrom+'&currencyTo='+data.currencyTo;return this.fetchGetRequestWithToken(path);}},{key:'getOrgBalance',value:function getOrgBalance(){var path='/api/organization/balance';return this.fetchGetRequestWithToken(path);}},{key:'registerOrgByAnchor',value:function registerOrgByAnchor(language,data){var path='/api/organization?language='+language;return this.fetchPostRequest(path,data);}},{key:'requestCredentialsVerification',value:function requestCredentialsVerification(data){var path='/api/organization/consent-requests';return this.fetchPostRequestWithToken(path,data);}},{key:'getRequestsByStatus',value:function getRequestsByStatus(status,page){var path='/api/user/consent-requests?statuses='+(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isArray(status)?status.join(','):status)+'&size=10';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}return this.fetchGetRequestWithToken(path);}},{key:'getConsentById',value:function getConsentById(id){var path='/api/user/consent-requests/'+id;return this.fetchGetRequestWithToken(path);}},{key:'updateConsent',value:function updateConsent(id,data){var path='/api/user/consent-requests/'+id+'/response';return this.fetchPutRequestWithToken(path,data);}},{key:'getOrganizationConsents',value:function getOrganizationConsents(departmentId,filterParams){var path='/api/organization/consent-requests?departmentId='+departmentId+'&size=10';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(filterParams.updatedBefore)){path+='&updatedBefore='+filterParams.updatedBefore;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(filterParams.status)){path+='&statuses='+filterParams.status;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(filterParams.job)){path+='&jobTitleFilter='+encodeURIComponent(filterParams.job);}return this.fetchGetRequestWithToken(path);}},{key:'getConsentRequestDetails',value:function getConsentRequestDetails(id){var path='/api/organization/consent-requests/'+id;return this.fetchGetRequestWithToken(path);}},{key:'abandonConsentRequest',value:function abandonConsentRequest(id){var path='/api/organization/consent-requests/'+id;return this.fetchDeleteRequestWithToken(path);}},{key:'getUserSettings',value:function getUserSettings(){var path='/api/user/settings';return this.fetchGetRequestWithToken(path);}},{key:'updateUserSettings',value:function updateUserSettings(data){var path='/api/user/settings';return this.fetchPutRequestWithToken(path,data);}},{key:'getSecurityState',value:function getSecurityState(){var path='/api/user/2fa/state';return this.fetchGetRequestWithToken(path);}},{key:'generate2FASecret',value:function generate2FASecret(){var path='/api/user/2fa/secret';return this.fetchPostRequestWithToken(path);}},{key:'enable2FA',value:function enable2FA(checkCode){var path='/api/user/2fa/enable';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(checkCode)){path+='?checkCode='+checkCode;}return this.fetchPostRequestWithToken(path);}},{key:'disable2FA',value:function disable2FA(){var path='/api/user/2fa/disable';return this.fetchPostRequestWithToken(path);}},{key:'getPriorConsents',value:function getPriorConsents(date){var path='/api/user/prior-consents';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(date)){path+='?enabledTillAfter='+date;}return this.fetchGetRequestWithToken(path);}},{key:'createPriorConsent',value:function createPriorConsent(data){var path='/api/user/prior-consents';return this.fetchPostRequestWithToken(path,data);}},{key:'getPriorConsentById',value:function getPriorConsentById(id){var path='/api/user/prior-consents/'+id;return this.fetchGetRequestWithToken(path);}},{key:'updatePriorConsent',value:function updatePriorConsent(id,data){var path='/api/user/prior-consents/'+id;return this.fetchPutRequestWithToken(path,data);}},{key:'removePriorConsent',value:function removePriorConsent(id){var path='/api/user/prior-consents/'+id;return this.fetchDeleteRequestWithToken(path);}},{key:'getApplicantSelfStudyBooks',value:function getApplicantSelfStudyBooks(){var path='/api/user/self-studies/books';return this.fetchGetRequestWithToken(path);}},{key:'addApplicantSelfStudyBooks',value:function addApplicantSelfStudyBooks(data){var path='/api/user/self-studies/books';return this.fetchPostRequestWithToken(path,data);}},{key:'getApplicantSelfStudyBook',value:function getApplicantSelfStudyBook(id){var path='/api/user/self-studies/books/'+id;return this.fetchGetRequestWithToken(path);}},{key:'updateSelfStudyBook',value:function updateSelfStudyBook(id,data){var path='/api/user/self-studies/books/'+id;return this.fetchPutRequestWithToken(path,data);}},{key:'removeSelfStudyBook',value:function removeSelfStudyBook(id){var path='/api/user/self-studies/books/'+id;return this.fetchDeleteRequestWithToken(path);}},{key:'requestBulkCredentialsVerification',value:function requestBulkCredentialsVerification(data){var path='/api/organization/consent-requests/bulk';return this.fetchPostRequestWithToken(path,data);}},{key:'getBulkRequestsJobs',value:function getBulkRequestsJobs(departmentId){var path='/api/organization/consent-requests/bulk?departmentId='+departmentId;return this.fetchGetRequestWithToken(path);}},{key:'removeBulkRequestJob',value:function removeBulkRequestJob(id){var path='/api/organization/consent-requests/bulk/'+id;return this.fetchDeleteRequestWithToken(path);}},{key:'resumeBulkRequestJob',value:function resumeBulkRequestJob(id){var path='/api/organization/consent-requests/bulk/'+id+'/resume';return this.fetchPutRequestWithToken(path);}},{key:'getGlobalCertificates',value:function getGlobalCertificates(){var path='/api/system/ca/certificates';return this.fetchGetRequestWithToken(path);}},{key:'addGlobalCertificate',value:function addGlobalCertificate(data){var path='/api/system/ca/certificates';return this.fetchPostRequestWithTokenWithTextBody(path,data);}},{key:'removeGlobalCertificate',value:function removeGlobalCertificate(certId){var path='/api/system/ca/certificates/'+certId;return this.fetchDeleteRequestWithToken(path);}},{key:'getOrgCertificates',value:function getOrgCertificates(orgId){var path='/api/system/organizations/'+orgId+'/certificates';return this.fetchGetRequestWithToken(path);}},{key:'addOrgCertificate',value:function addOrgCertificate(orgId,data){var path='/api/system/organizations/'+orgId+'/certificates';return this.fetchPostRequestWithTokenWithTextBody(path,data);}},{key:'removeOrgCertificate',value:function removeOrgCertificate(orgId,certId){var path='/api/system/organizations/'+orgId+'/certificates/'+certId;return this.fetchDeleteRequestWithToken(path);}},{key:'verifyJWK',value:function verifyJWK(data){var path='/api/organization/verify-key';return this.fetchPostRequestWithToken(path,data);}},{key:'getAccreditationRequests',value:function getAccreditationRequests(){var path='/api/user/aar';return this.fetchGetRequestWithToken(path);}},{key:'createAccreditationRequest',value:function createAccreditationRequest(data){var path='/api/user/aar';return this.fetchPostRequestWithToken(path,data);}},{key:'getAccreditationRequestById',value:function getAccreditationRequestById(id){var path='/api/user/aar/'+id;return this.fetchGetRequestWithToken(path);}},{key:'updateAccreditationRequest',value:function updateAccreditationRequest(id,data,fullUpdateRequired){var path='/api/user/aar/'+id+'?fullUpdateRequired='+fullUpdateRequired;return this.fetchPutRequestWithToken(path,data);}},{key:'removeAccreditationRequest',value:function removeAccreditationRequest(id){var path='/api/user/aar/'+id;return this.fetchDeleteRequestWithToken(path);}},{key:'getOrgsForRequest',value:function getOrgsForRequest(country,orgName){var path='/api/user/aar/organization';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(country)){path+='?country='+country;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(orgName)){path+=(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(country)?'?':'&')+'orgNameFilter='+orgName;}return this.fetchGetRequestWithToken(path);}},{key:'getAGsForRequest',value:function getAGsForRequest(orgId){var path='/api/public/organization/'+orgId+'/accreditation-groups';return this.fetchGetRequestWithToken(path);}},{key:'getOrgByDomain',value:function getOrgByDomain(domain){var path='/api/public/organization/'+domain;return this.fetchGetRequestWithToken(path);}},{key:'getAccreditationRequestsByDomains',value:function getAccreditationRequestsByDomains(validated,domain,page,size){//TODO: do not pass empty string
var pageSize=10;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(size)){pageSize=size;}var path='/api/system/aar/domains?domainFilter='+(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(domain)?domain:'')+'&size='+pageSize;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(validated)){path+='&domainVerifiedFilter='+validated;}return this.fetchGetRequestWithToken(path);}},{key:'updateAccreditationRequestByDomain',value:function updateAccreditationRequestByDomain(domain,data){var path='/api/system/aar/domains/'+domain;return this.fetchPutRequestWithToken(path,data);}},{key:'removeAccreditationRequestByDomain',value:function removeAccreditationRequestByDomain(domain){var path='/api/system/aar/domains/'+domain;return this.fetchDeleteRequestWithToken(path);}},{key:'getAccreditationRequestsByAGs',value:function getAccreditationRequestsByAGs(AG,page,size){//TODO: do not pass empty string
var pageSize=10;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(size)){pageSize=size;}var path='/api/organization/aar/accreditation-groups?agNameFilter='+(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(AG)?AG:'')+'&size='+pageSize;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}return this.fetchGetRequestWithToken(path);}},{key:'updateAccreditationRequestByAG',value:function updateAccreditationRequestByAG(AGId,AGs){var path='/api/organization/aar/accreditation-groups/'+AGId;return this.fetchPutRequestWithToken(path,AGs);}},{key:'removeAccreditationRequestByAG',value:function removeAccreditationRequestByAG(AGs){var path='/api/organization/aar/accreditation-groups/reject';return this.fetchPostRequestWithToken(path,AGs);}},{key:'getPendingAccreditationRequests',value:function getPendingAccreditationRequests(group,countryFilter,domainFilter,page,size){var path='/api/organization/aar?agIdFilter='+group;var pageSize=10;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(size)){pageSize=size;}path+='&size='+pageSize;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(countryFilter)){path+='&countryCodeFilter='+countryFilter;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(domainFilter)){path+='&domainFilter='+domainFilter;}return this.fetchGetRequestWithToken(path);}},{key:'getStaticsticsForPendingAccreditationRequests',value:function getStaticsticsForPendingAccreditationRequests(group,countryCode,groupBy){var path='/api/organization/aar/statistics?agIdFilter='+group;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(countryCode)){path+='&countryCodeFilter='+countryCode;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(groupBy)){path+='&groupBy='+groupBy;}return this.fetchGetRequestWithToken(path);}},{key:'confirmAccreditationRequest',value:function confirmAccreditationRequest(id,data){var path='/api/organization/accreditations?applicantAccreditationRequestId='+id;return this.fetchPostRequestWithToken(path,data);}},{key:'rejectAccreditationRequest',value:function rejectAccreditationRequest(id){var path='/api/organization/aar/'+id;return this.fetchDeleteRequestWithToken(path);}},{key:'getAccreditationRequestForProcessing',value:function getAccreditationRequestForProcessing(id){var path='/api/organization/aar/'+id;return this.fetchGetRequestWithToken(path);}},{key:'getLastRequestorsOfAccreditationRequestByDomain',value:function getLastRequestorsOfAccreditationRequestByDomain(domain){var path='/api/system/aar/domains/'+domain+'/users';return this.fetchGetRequestWithToken(path);}},{key:'getPricingPresetByAnchor',value:function getPricingPresetByAnchor(countryCode,organizationType){var path='/api/organization/pricing-preset?countryCode='+countryCode+'&organizationType='+organizationType;return this.fetchGetRequest(path);}},{key:'getAssistants',value:function getAssistants(){var path='/api/system/admins';return this.fetchGetRequestWithToken(path);}},{key:'addAssistant',value:function addAssistant(data){var path='/api/system/admins';return this.fetchPostRequestWithToken(path,data);}},{key:'removeAssistant',value:function removeAssistant(id){var path='/api/system/admins/'+id;return this.fetchDeleteRequestWithToken(path);}},{key:'editAssistant',value:function editAssistant(id,data){var path='/api/system/admins/'+id+'/subroles';return this.fetchPutRequestWithToken(path,data);}},{key:'getBusinessAmbassadors',value:function getBusinessAmbassadors(){var path='/api/system/business-ambassadors';return this.fetchGetRequestWithToken(path);}},{key:'addBusinessAmbassador',value:function addBusinessAmbassador(data){var path='/api/system/business-ambassadors';return this.fetchPostRequestWithToken(path,data);}},{key:'removeBusinessAmbassador',value:function removeBusinessAmbassador(id){var path='/api/system/business-ambassadors/'+id;return this.fetchDeleteRequestWithToken(path);}},{key:'getBusinessAmbassador',value:function getBusinessAmbassador(id){var path='/api/system/business-ambassadors/'+id;return this.fetchGetRequestWithToken(path);}},{key:'updateBusinessAmbassador',value:function updateBusinessAmbassador(id,data){var path='/api/system/business-ambassadors/'+id;return this.fetchPutRequestWithToken(path,data);}},{key:'getCommissions',value:function getCommissions(page,filters){var path='/api/system/business-ambassadors/contracts?size=10';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(filters)){path+=filters.baId?'&baIdFilter='+filters.baId:"";path+=filters.countries?'&countryCodeFilter='+(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isArray(filters.countries)?filters.countries.join(','):filters.countries):"";}return this.fetchGetRequestWithToken(path);}},{key:'addCommission',value:function addCommission(baId,data){var path='/api/system/business-ambassadors/'+baId+'/contracts/';return this.fetchPostRequestWithToken(path,data);}},{key:'removeCommission',value:function removeCommission(baId,commissionId){var path='/api/system/business-ambassadors/'+baId+'/contracts/'+commissionId;return this.fetchDeleteRequestWithToken(path);}},{key:'updateCommission',value:function updateCommission(baId,commissionId,data){var path='/api/system/business-ambassadors/'+baId+'/contracts/'+commissionId;return this.fetchPutRequestWithToken(path,data);}},{key:'getCommissionData',value:function getCommissionData(baId,commissionId){var path='/api/system/business-ambassadors/'+baId+'/contracts/'+commissionId;return this.fetchGetRequestWithToken(path);}},{key:'getDuePaymentsForBAs',value:function getDuePaymentsForBAs(countries,name){var path='/api/system/business-ambassadors/transactions-statistics?size=10';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(countries)){path+='&countryCodesFilter='+countries.join(',');}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(name)){path+='&nameFilter='+name;}path+='&transactionTypeFilter=PAYED_CONSENT_REQUEST_REMUNERATION,CONSENT_REQUEST_REMUNERATION_PAYMENT';return this.fetchGetRequestWithToken(path);}},{key:'getDuePaymentsForUniversities',value:function getDuePaymentsForUniversities(page,countries,name){var path='/api/system/organizations/transactions-statistics?size=10';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(countries)){path+='&countryCodesFilter='+countries.join(',');}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(name)){path+='&nameFilter='+name;}path+='&transactionTypeFilter=PAYED_CONSENT_REQUEST_REMUNERATION,CONSENT_REQUEST_REMUNERATION_PAYMENT';path+='&hasIVsFilter=true';return this.fetchGetRequestWithToken(path);}},{key:'getDuePaymentsForSystem',value:function getDuePaymentsForSystem(){var path='/api/system/balance/transactions-statistics';return this.fetchGetRequestWithToken(path);}},{key:'payDuePaymentForSystem',value:function payDuePaymentForSystem(data){var path='/api/system/balance/consent-request-remuneration';return this.fetchPostRequestWithToken(path,data);}},{key:'payDuePaymentsForBA',value:function payDuePaymentsForBA(id,data){var path='/api/system/business-ambassadors/'+id+'/consent-request-remuneration';return this.fetchPostRequestWithToken(path,data);}},{key:'getPaymentsHistoryForBAs',value:function getPaymentsHistoryForBAs(page,filters){var path='/api/system/business-ambassadors/transactions-history?size=10';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(filters)){path+=filters.dateFrom?'&dateFromFilter='+filters.dateFrom:"";path+=filters.dateTo?'&dateToFilter='+filters.dateTo:"";path+=filters.name?'&nameFilter='+filters.name:"";path+=filters.countries?'&countryCodesFilter='+filters.countries.join(','):"";}path+='&transactionTypeFilter=PAYED_CONSENT_REQUEST_REMUNERATION';return this.fetchGetRequestWithToken(path);}},{key:'getPaymentsHistoryForUniversities',value:function getPaymentsHistoryForUniversities(page,filters){var path='/api/system/organizations/transactions-history?size=10';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(filters)){path+=filters.dateFrom?'&dateFromFilter='+filters.dateFrom:"";path+=filters.dateTo?'&dateToFilter='+filters.dateTo:"";path+=filters.name?'&nameFilter='+filters.name:"";path+=filters.countries?'&countryCodesFilter='+filters.countries.join(','):"";}path+='&transactionTypeFilter=PAYED_CONSENT_REQUEST_REMUNERATION';return this.fetchGetRequestWithToken(path);}},{key:'getCompaniesCredits',value:function getCompaniesCredits(page,sorting,name,countries){var path='/api/system/organizations/transactions-statistics?size=10';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(sorting)){path+='&orderBy='+sorting;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(name)){path+='&nameFilter='+name;}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(countries)){path+='&countryCodesFilter='+countries.join(',');}path+='&transactionTypeFilter=ANNUAL_FEE_PAYMENT,CONSENT_REQUEST_FEE_PAYMENT';return this.fetchGetRequestWithToken(path);}},{key:'getCompanyCreditsHistory',value:function getCompanyCreditsHistory(page,id){var path='/api/system/organizations/'+id+'/transactions-history?size=10';if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(page)){path+='&page='+page;}return this.fetchGetRequestWithToken(path);}},{key:'getOperationAvailability',value:function getOperationAvailability(){var path='/api/organization/operation-availability';return this.fetchGetRequestWithToken(path);}},{key:'payDuePaymentsForUniversity',value:function payDuePaymentsForUniversity(id,data){var path='/api/system/organizations/'+id+'/consent-request-remuneration';return this.fetchPostRequestWithToken(path,data);}},{key:'removeOrg',value:function removeOrg(id){var path='/api/system/organizations/'+id;return this.fetchDeleteRequestWithToken(path);}},{key:'markOrgAsBava',value:function markOrgAsBava(id){var path='/api/system/organizations/'+id+'/bava';return this.fetchPutRequestWithToken(path);}},{key:'removeBavaFlag',value:function removeBavaFlag(){var path='/api/system/organizations/bava';return this.fetchDeleteRequestWithToken(path);}},{key:'getValidatedDomains',value:function getValidatedDomains(countryCode,name,domain,page){var path='/api/system/aar/domains?size=10&domainVerifiedFilter=true';if(domain){path+='&domainFilter='+domain;}if(countryCode){path+='&countryCodeFilter='+countryCode;}if(name){path+='&nameFilter='+name;}if(page){path+='&page='+page;}return this.fetchGetRequestWithToken(path);}},{key:'addValidatedDomain',value:function addValidatedDomain(data,bavaManaged){var path='/api/system/organizations/managed-organizations/?bavaManaged='+bavaManaged;return this.fetchPostRequestWithToken(path,data);}},{key:'editValidatedDomain',value:function editValidatedDomain(domain,data,bavaManaged){var path='/api/system/aar/domains/'+domain+'?bavaManaged='+bavaManaged;return this.fetchPutRequestWithToken(path,data);}},{key:'removeValidatedDomain',value:function removeValidatedDomain(domain){var path='/api/system/aar/domains/'+domain;return this.fetchDeleteRequestWithToken(path);}},{key:'validateDomain',value:function validateDomain(domain,data,bavaManaged){var path='/api/system/aar/domains/'+domain+'?bavaManaged='+bavaManaged;return this.fetchPostRequestWithToken(path,data);}},{key:'getManagedOrgs',value:function getManagedOrgs(countryCode){var path='/api/organization/managed-organizations';if(countryCode){path+='?countryCodeFilter='+countryCode;}return this.fetchGetRequestWithToken(path);}}]);return Api;}();

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NO_SUB_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SUB_ROLES; });
/* unused harmony export ROLES_TRANSLATIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SUB_ROLES_TRANSLATIONS; });
/* unused harmony export setRole */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return setRoleAndSubRoles; });
/* unused harmony export onSetSubRoles */
/* unused harmony export setSubRoles */
/* unused harmony export fetchGetSubRolesFailed */
/* unused harmony export fetchGetSubRolesSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchGetSubRoles; });
/* unused harmony export onGetSubRolesSuccess */
/* unused harmony export fetchGetGroupsFailed */
/* unused harmony export fetchGetGroupsSuccess */
/* unused harmony export onGetGroupsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchReGetGroups; });
/* unused harmony export fetchGetGroups */
/* unused harmony export setCurrentSubRole */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return changeCurrentSubRole; });
/* unused harmony export fetchUpdateSubRolesSuccess */
/* unused harmony export fetchUpdateSubRolesFailed */
/* unused harmony export onUpdateSubRolesSuccess */
/* unused harmony export fetchUpdateSubRoles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changeCurrentGroup; });
/* unused harmony export onChangeCurrentGroup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return setUserSubRoleMissing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return setOrgPermissionsMissing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return onChangeConsentRequestsFilterVisibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return removeSubRolesRequiringHasIVs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return isUserSubRoleMissing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return isOrgPermissionsMissing; });
/* unused harmony export getRole */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getCurrentRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getCurrentSubRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getSubRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getGroupsForSubRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCurrentGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getLoading; });
/* unused harmony export getGroupSelectionEnabling */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getConsentRequestsFilterVisibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getCurrentGroupEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getCurrentGroupName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getGroupsNumberForSubRole; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_storageApi__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__organization_organization__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__accreditation_accreditations__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__finance_finance__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__finance_currencies__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__userData__ = __webpack_require__(35);
var _ROLES_TRANSLATIONS,_SUB_ROLES_TRANSLATIO;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//- Constants
var ROLES={SYS_ADMIN:'SysAdmin',EMPLOYEE:'Employee',APPLICANT:'Applicant'};var NO_SUB_ROLES='No sub roles';var SUB_ROLES={ANCHOR:'Anchor',INSERTER:'Inserter',VALIDATOR:'Validator',HM:'HRManager',BO:'BusinessOwner',ROOT:'SysAdmin_Root',FA:'SysAdmin_FinancialManager',PA:'SysAdmin_ProcessingManager'};var ROLES_TRANSLATIONS=(_ROLES_TRANSLATIONS={},_defineProperty(_ROLES_TRANSLATIONS,ROLES.SYS_ADMIN,"admin_label"),_defineProperty(_ROLES_TRANSLATIONS,ROLES.EMPLOYEE,"employee_label"),_defineProperty(_ROLES_TRANSLATIONS,ROLES.APPLICANT,"applicant_label"),_ROLES_TRANSLATIONS);var SUB_ROLES_TRANSLATIONS=(_SUB_ROLES_TRANSLATIO={},_defineProperty(_SUB_ROLES_TRANSLATIO,SUB_ROLES.ANCHOR,"anchor_label"),_defineProperty(_SUB_ROLES_TRANSLATIO,SUB_ROLES.INSERTER,"inserter_label"),_defineProperty(_SUB_ROLES_TRANSLATIO,SUB_ROLES.VALIDATOR,"validator_label"),_defineProperty(_SUB_ROLES_TRANSLATIO,SUB_ROLES.HM,"hm_label"),_defineProperty(_SUB_ROLES_TRANSLATIO,SUB_ROLES.BO,"bo_label"),_SUB_ROLES_TRANSLATIO);var SUB_ROLES_REQUIRING_HAS_IVS=[SUB_ROLES.INSERTER,SUB_ROLES.VALIDATOR];//- Actions
var setRole=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('ROLE_SET');var setRoleAndSubRoles=function setRoleAndSubRoles(role,subRoles){return function(dispatch){dispatch(setRole(role));if(ROLES[role]===ROLES.EMPLOYEE){dispatch(setSubRoles(subRoles));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__organization_organization__["f" /* fetchGetOrgForApp */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__organization_organization__["c" /* fetchGetOperationAvailability */])());}if(ROLES[role]===ROLES.SYS_ADMIN){dispatch(onSetSubRoles(subRoles));dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__finance_currencies__["c" /* fetchGetCurrencies */])());if(subRoles.includes(SUB_ROLES.ROOT)||subRoles.includes(SUB_ROLES.FA)){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__finance_finance__["b" /* fetchGetPresets */])());}}};};var onSetSubRoles=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SUB_ROLES_SET');var setSubRoles=function setSubRoles(subRoles){return function(dispatch,getState){subRoles=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sortBy(subRoles);var orgPermissions=Object(__WEBPACK_IMPORTED_MODULE_5__organization_organization__["p" /* getOrgPermissions */])(getState());if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(orgPermissions)&&!orgPermissions.hasIVs){subRoles=subRoles.filter(function(subRole){return!SUB_ROLES_REQUIRING_HAS_IVS.includes(subRole);});}var lastUsedSubRole=__WEBPACK_IMPORTED_MODULE_1__utils_storageApi__["a" /* StorageApi */].getLastUsedSubRole();var subRole=subRoles.length>0?subRoles[0]:NO_SUB_ROLES;if(subRole!==NO_SUB_ROLES){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(lastUsedSubRole)&&subRoles.includes(lastUsedSubRole)){subRole=lastUsedSubRole;}else{__WEBPACK_IMPORTED_MODULE_1__utils_storageApi__["a" /* StorageApi */].setLastUsedSubRole(subRole);}if(subRole===SUB_ROLES.ANCHOR){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__organization_organization__["e" /* fetchGetOrgBalance */])());}else{dispatch(fetchGetGroups(subRole));}}dispatch(onSetSubRoles(subRoles));dispatch(setCurrentSubRole(subRole));};};var fetchGetSubRolesFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_SUB_ROLES_FAILED');var fetchGetSubRolesSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_SUB_ROLES_SUCCESS');var fetchGetSubRoles=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_SUB_ROLES',function(){return __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* Api */].getUserData();},function(){return{apiCall:true,onSuccess:onGetSubRolesSuccess,onFail:fetchGetSubRolesFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var onGetSubRolesSuccess=function onGetSubRolesSuccess(userData){return function(dispatch){dispatch(setSubRoles(userData.subRoles));dispatch(fetchGetSubRolesSuccess());};};var fetchGetGroupsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_GROUPS_FAILED');var fetchGetGroupsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_GROUPS_SUCCESS');var onGetGroupsSuccess=function onGetGroupsSuccess(groups){return function(dispatch){if(groups.length===0){dispatch(fetchGetGroupsFailed());dispatch(setUserSubRoleMissing(true));}else{groups=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sortBy(groups);var lastUsedGroup=__WEBPACK_IMPORTED_MODULE_1__utils_storageApi__["a" /* StorageApi */].getLastUsedGroup();var group=groups[0].id;if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(lastUsedGroup)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(groups.find(function(elem){return lastUsedGroup===elem.id;}))){group=lastUsedGroup;}dispatch(fetchGetGroupsSuccess(groups));dispatch(changeCurrentGroup(group));}};};var fetchReGetGroups=function fetchReGetGroups(){return function(dispatch,getState){var subRole=getCurrentSubRole(getState());dispatch(fetchGetGroups(subRole));};};var fetchGetGroups=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_GROUPS',function(subRole){switch(subRole){case SUB_ROLES.INSERTER:return __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* Api */].getInserterGroups();case SUB_ROLES.VALIDATOR:return __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* Api */].getValidatorGroups();case SUB_ROLES.HM:return __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* Api */].getHMGroups();case SUB_ROLES.BO:return __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* Api */].getBOGroups();default:break;}},function(){return{apiCall:true,onSuccess:onGetGroupsSuccess,onFail:fetchGetGroupsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var setCurrentSubRole=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CURRENT_SUB_ROLE_SET',function(newSubRole){return newSubRole;});var changeCurrentSubRole=function changeCurrentSubRole(newSubRole){return function(dispatch,getState){var userId=__WEBPACK_IMPORTED_MODULE_1__utils_storageApi__["a" /* StorageApi */].getUserId();var userIdFromState=Object(__WEBPACK_IMPORTED_MODULE_9__userData__["g" /* getUserId */])(getState());if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(userId)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(userIdFromState)&&userIdFromState!==userId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */])());}else{dispatch(fetchUpdateSubRoles(newSubRole));}};};var fetchUpdateSubRolesSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("FETCH_UPDATE_SUB_ROLES_SUCCESS");var fetchUpdateSubRolesFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("FETCH_UPDATE_SUB_ROLES_FAILED");var onUpdateSubRolesSuccess=function onUpdateSubRolesSuccess(newSubRole){return function(userData){return function(dispatch,getState){var subRoles=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sortBy(userData.subRoles);var orgPermissions=Object(__WEBPACK_IMPORTED_MODULE_5__organization_organization__["p" /* getOrgPermissions */])(getState());if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(orgPermissions)&&!orgPermissions.hasIVs){subRoles=subRoles.filter(function(subRole){return!SUB_ROLES_REQUIRING_HAS_IVS.includes(subRole);});}if(subRoles.includes(newSubRole)){var role=getCurrentRole(getState());if(role===ROLES.EMPLOYEE&&newSubRole!==SUB_ROLES.ANCHOR&&newSubRole!==NO_SUB_ROLES){dispatch(fetchGetGroups(newSubRole));}__WEBPACK_IMPORTED_MODULE_1__utils_storageApi__["a" /* StorageApi */].setLastUsedSubRole(newSubRole);dispatch(setCurrentSubRole(newSubRole));}else{var oldSubRole=getCurrentSubRole(getState());if(!subRoles.includes(oldSubRole)){dispatch(setCurrentSubRole(subRoles.length>0?subRoles[0]:NO_SUB_ROLES));}dispatch(setUserSubRoleMissing(true));}dispatch(fetchUpdateSubRolesSuccess(subRoles));};};};var fetchUpdateSubRoles=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_UPDATE_SUB_ROLES',function(){return __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* Api */].getUserData();},function(newSubRole){return{apiCall:true,onSuccess:onUpdateSubRolesSuccess(newSubRole),onFail:fetchUpdateSubRolesFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var changeCurrentGroup=function changeCurrentGroup(newGroupId){return function(dispatch,getState){var userId=__WEBPACK_IMPORTED_MODULE_1__utils_storageApi__["a" /* StorageApi */].getUserId();var userIdFromState=Object(__WEBPACK_IMPORTED_MODULE_9__userData__["g" /* getUserId */])(getState());if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(userId)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(userIdFromState)&&userIdFromState!==userId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */])());}else{__WEBPACK_IMPORTED_MODULE_1__utils_storageApi__["a" /* StorageApi */].setLastUsedGroup(newGroupId);dispatch(onChangeCurrentGroup(newGroupId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__accreditation_accreditations__["c" /* cleanStartAccreditation */])());}};};var onChangeCurrentGroup=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CURRENT_GROUP_CHANGE',function(newGroupId){return newGroupId;});var setUserSubRoleMissing=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_USER_SUB_ROLE_MISSING');var setOrgPermissionsMissing=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_ORG_PERMISSIONS_MISSING');var onChangeConsentRequestsFilterVisibility=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CONSENT_REQUESTS_FILTER_VISIBILITY',function(isVisible){return isVisible;});var removeSubRolesRequiringHasIVs=function removeSubRolesRequiringHasIVs(){return function(dispatch,getState){var subRoles=getSubRoles(getState());subRoles=subRoles.filter(function(subRole){return!SUB_ROLES_REQUIRING_HAS_IVS.includes(subRole);});dispatch(setSubRoles(subRoles));};};//- State
var initialState={role:null,subRoles:null,currentSubRole:null,currentGroup:null,groups:null,fetching:false,fetchingUpdateSubRoles:false,error:null,userSubRoleIsMissing:false,orgPermissionsMissing:false,isConsentRequestsFilterVisible:false};//- Reducers
/* harmony default export */ __webpack_exports__["g"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({SET_USER_SUB_ROLE_MISSING:function SET_USER_SUB_ROLE_MISSING(state,action){return Object.assign({},state,{userSubRoleIsMissing:action.payload});},SET_ORG_PERMISSIONS_MISSING:function SET_ORG_PERMISSIONS_MISSING(state,action){return Object.assign({},state,{orgPermissionsMissing:action.payload});},ROLE_SET:function ROLE_SET(state,action){return Object.assign({},state,{role:ROLES[action.payload]});},FETCH_GET_SUB_ROLES:function FETCH_GET_SUB_ROLES(state){return Object.assign({},state,{error:null,fetching:true});},FETCH_GET_SUB_ROLES_FAILED:function FETCH_GET_SUB_ROLES_FAILED(state,action){return Object.assign({},state,{subRoles:null,currentSubRole:null,error:action.payload,fetching:false});},FETCH_GET_SUB_ROLES_SUCCESS:function FETCH_GET_SUB_ROLES_SUCCESS(state){return Object.assign({},state,{error:null,fetching:false});},SUB_ROLES_SET:function SUB_ROLES_SET(state,action){return Object.assign({},state,{subRoles:action.payload});},FETCH_UPDATE_SUB_ROLES:function FETCH_UPDATE_SUB_ROLES(state){return Object.assign({},state,{fetchingUpdateSubRoles:true});},FETCH_UPDATE_SUB_ROLES_SUCCESS:function FETCH_UPDATE_SUB_ROLES_SUCCESS(state,action){return Object.assign({},state,{subRoles:action.payload,fetchingUpdateSubRoles:false});},FETCH_UPDATE_SUB_ROLES_FAILED:function FETCH_UPDATE_SUB_ROLES_FAILED(state,action){return Object.assign({},state,{error:action.payload,fetchingUpdateSubRoles:false});},FETCH_GET_GROUPS:function FETCH_GET_GROUPS(state){return Object.assign({},state,{groups:null,currentGroup:null,error:null,fetching:true});},FETCH_GET_GROUPS_FAILED:function FETCH_GET_GROUPS_FAILED(state,action){return Object.assign({},state,{error:action.payload,fetching:false});},FETCH_GET_GROUPS_SUCCESS:function FETCH_GET_GROUPS_SUCCESS(state,action){return Object.assign({},state,{groups:action.payload,error:null,fetching:false});},CURRENT_SUB_ROLE_SET:function CURRENT_SUB_ROLE_SET(state,action){return Object.assign({},state,{currentSubRole:action.payload});},CURRENT_GROUP_CHANGE:function CURRENT_GROUP_CHANGE(state,action){return Object.assign({},state,{currentGroup:action.payload});},CONSENT_REQUESTS_FILTER_VISIBILITY:function CONSENT_REQUESTS_FILTER_VISIBILITY(state,action){return Object.assign({},state,{isConsentRequestsFilterVisible:action.payload});}},initialState));var isUserSubRoleMissing=function isUserSubRoleMissing(state){return getRole(state).userSubRoleIsMissing;};var isOrgPermissionsMissing=function isOrgPermissionsMissing(state){return getRole(state).orgPermissionsMissing;};var getRole=function getRole(state){return state.role;};var getCurrentRole=function getCurrentRole(state){return getRole(state).role;};var getCurrentSubRole=function getCurrentSubRole(state){return getRole(state).currentSubRole;};var getSubRoles=function getSubRoles(state){return getRole(state).subRoles;};var getGroupsForSubRole=function getGroupsForSubRole(state){return getRole(state).groups;};var getCurrentGroup=function getCurrentGroup(state){return getRole(state).currentGroup;};var getLoading=function getLoading(state){return getRole(state).fetching||getRole(state).fetchingUpdateSubRoles;};var getGroupSelectionEnabling=function getGroupSelectionEnabling(state){return getRole(state).isGroupSelectionEnable;};var getConsentRequestsFilterVisibility=function getConsentRequestsFilterVisibility(state){return getRole(state).isConsentRequestsFilterVisible;};var getCurrentGroupEmail=function getCurrentGroupEmail(state){var currentGroupId=getCurrentGroup(state);var groups=getGroupsForSubRole(state);var currentGroup=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(groups,function(group){return group.id===currentGroupId;});return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(currentGroup)?null:currentGroup.email;};var getCurrentGroupName=function getCurrentGroupName(state){var currentGroupId=getCurrentGroup(state);var groups=getGroupsForSubRole(state);var currentGroup=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(groups,function(group){return group.id===currentGroupId;});return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(currentGroup)?null:currentGroup.name;};var getGroupsNumberForSubRole=function getGroupsNumberForSubRole(state){var groups=getRole(state).groups;return groups?groups.length:null;};

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetCountriesFailed */
/* unused harmony export fetchGetCountriesSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetCountries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setCurrentContinent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setCurrentContinentByCountry; });
/* unused harmony export getLocation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getLocationData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCurrentContinent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getContinentsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCountriesData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getContinentByCountry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_constants__ = __webpack_require__(24);
//- Actions
var fetchGetCountriesFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_COUNTRIES_FAILED');var fetchGetCountriesSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_COUNTRIES_SUCCESS');var fetchGetCountries=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_COUNTRIES',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getCountries();},function(){return{apiCall:true,onSuccess:fetchGetCountriesSuccess,onFail:fetchGetCountriesFailed};});var setCurrentContinent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_CURRENT_CONTINENT');var setCurrentContinentByCountry=function setCurrentContinentByCountry(countryCode){return function(dispatch,getState){dispatch(setCurrentContinent(getContinentByCountry(countryCode,getState())));};};//- State
var initialState={data:null,currentContinent:"",error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_COUNTRIES:function FETCH_GET_COUNTRIES(state){return Object.assign({},state,{data:null,error:null,fetching:true});},FETCH_GET_COUNTRIES_FAILED:function FETCH_GET_COUNTRIES_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_COUNTRIES_SUCCESS:function FETCH_GET_COUNTRIES_SUCCESS(state,action){var countries=action.payload;var data={};__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(__WEBPACK_IMPORTED_MODULE_3__constants_constants__["k" /* LOCATION_MAP */],function(value,key){var newValue=value.filter(function(elem){return countries.includes(elem);});data[key]=newValue;});return Object.assign({},state,{data:data,error:null,fetching:false});},SET_CURRENT_CONTINENT:function SET_CURRENT_CONTINENT(state,action){return Object.assign({},state,{currentContinent:action.payload});},SET_CURRENT_CONTINENT_BY_COUNTRY:function SET_CURRENT_CONTINENT_BY_COUNTRY(state,action){return Object.assign({},state,{currentContinent:action.payload});}},initialState));//- Selectors
var getLocation=function getLocation(state){return state.location;};var getLocationData=function getLocationData(state){return getLocation(state).data;};var getCurrentContinent=function getCurrentContinent(state){return getLocation(state).currentContinent;};var getContinentsData=function getContinentsData(state){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(getLocationData(state))){return[];}return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(getLocationData(state));};var getCountriesData=function getCountriesData(state){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(getLocationData(state))){return[];}return getLocationData(state)[getCurrentContinent(state)];};var getContinentByCountry=function getContinentByCountry(countryCode,state){var data=getLocationData(state);return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(getLocationData(state)).find(function(key){return data[key].includes(countryCode);});};

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(502);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(508);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(509);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(511);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(513);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(515);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(169);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(517);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(519);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(521);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(522);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(523);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscriber; });
/* unused harmony export SafeSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isFunction__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Observer__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscription__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_symbol_rxSubscriber__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_hostReportError__ = __webpack_require__(149);
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */







var Subscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        _this._parentSubscription = null;
        switch (arguments.length) {
            case 0:
                _this.destination = __WEBPACK_IMPORTED_MODULE_2__Observer__["a" /* empty */];
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = __WEBPACK_IMPORTED_MODULE_2__Observer__["a" /* empty */];
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[__WEBPACK_IMPORTED_MODULE_4__internal_symbol_rxSubscriber__["a" /* rxSubscriber */]]();
                        _this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        _this.destination = trustedSubscriber;
                        trustedSubscriber._addParentTeardownLogic(_this);
                    }
                    else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[__WEBPACK_IMPORTED_MODULE_4__internal_symbol_rxSubscriber__["a" /* rxSubscriber */]] = function () { return this; };
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
            this._unsubscribeParentSubscription();
        }
    };
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
            this._unsubscribeParentSubscription();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._addParentTeardownLogic = function (parentTeardownLogic) {
        if (parentTeardownLogic !== this) {
            this._parentSubscription = this.add(parentTeardownLogic);
        }
    };
    Subscriber.prototype._unsubscribeParentSubscription = function () {
        if (this._parentSubscription !== null) {
            this._parentSubscription.unsubscribe();
        }
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        this._parentSubscription = null;
        return this;
    };
    return Subscriber;
}(__WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Subscription */]));

var SafeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isFunction__["a" /* isFunction */])(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== __WEBPACK_IMPORTED_MODULE_2__Observer__["a" /* empty */]) {
                context = Object.create(observerOrNext);
                if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isFunction__["a" /* isFunction */])(context.unsubscribe)) {
                    _this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) {
                    throw err;
                }
                Object(__WEBPACK_IMPORTED_MODULE_6__util_hostReportError__["a" /* hostReportError */])(err);
            }
            else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_6__util_hostReportError__["a" /* hostReportError */])(err);
                }
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            if (__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
                throw err;
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_6__util_hostReportError__["a" /* hostReportError */])(err);
            }
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        if (!__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
            throw new Error('bad call');
        }
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            if (__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_6__util_hostReportError__["a" /* hostReportError */])(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));

function isTrustedSubscriber(obj) {
    return obj instanceof Subscriber || ('_addParentTeardownLogic' in obj && obj[__WEBPACK_IMPORTED_MODULE_4__internal_symbol_rxSubscriber__["a" /* rxSubscriber */]]);
}
//# sourceMappingURL=Subscriber.js.map


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LOCATION_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CURRENCIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PASSWORD_MIN_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PASSWORD_MAX_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EMPLOYEES_COUNT_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ORGANIZATION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ORGANIZATION_AVAILABLE_FLAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FLAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AVAILABLE_CONSENT_PERIODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return REFUSE_REASONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return REQUEST_EMAIL_SOURCE_REQUESTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return REQUEST_EMAIL_SOURCE_DEPARTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return REQUEST_EMAIL_SOURCE_NONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AVAILABLE_PRIOR_CONSENT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BOOK_DOMAINS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return OAUTH_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TITLES_LANGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NOTIFICATION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCREDITATION_REQUEST_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ASSISTANT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return EXPOSE_NID_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return TRANSACTION_TYPES; });
var LOCATION_MAP={"AF":["AO","BF","BI","BJ","BW","CD","CF","CG","CI","CM","CV","DJ","DZ","EG","EH","ER","ET","GA","GH","GM","GN","GQ","GW","KE","KM","LR","LS","LY","MA","MG","ML","MR","MU","MW","MZ","NA","NE","NG","RE","RW","SC","SD","SH","SL","SN","SO","SS","ST","SZ","TD","TG","TN","TZ","UG","YT","ZA","ZM","ZW"],"AN":["AQ","BV","GS","HM","TF"],"AS":["AE","AF","AM","AZ","BD","BH","BN","BT","CC","CN","CX","CY","GE","HK","ID","IL","IN","IO","IQ","IR","JO","JP","KG","KH","KP","KR","KW","KZ","LA","LB","LK","MM","MN","MO","MV","MY","NP","OM","PH","PK","PS","QA","SA","SG","SY","TH","TJ","TL","TM","TW","UZ","VN","YE"],"EU":["AD","AL","AT","AX","BA","BE","BG","BY","CH","CZ","DE","DK","EE","ES","FI","FO","FR","GB","GG","GI","GR","HR","HU","IE","IM","IS","IT","JE","LI","LT","LU","LV","MC","MD","ME","MK","MT","NL","NO","PL","PT","RO","RS","RU","SE","SI","SJ","SK","SM","TR","UA","VA"],"NA":["AG","AI","AW","BB","BL","BM","BQ","BS","BZ","CA","CR","CU","CW","DM","DO","GD","GL","GP","GT","HN","HT","JM","KN","KY","LC","MF","MQ","MS","MX","NI","PA","PM","PR","SV","SX","TC","TT","US","VC","VG","VI"],"OC":["AS","AU","CK","FJ","FM","GU","KI","MH","MP","NC","NF","NR","NU","NZ","PF","PG","PN","PW","SB","TK","TO","TV","UM","VU","WF","WS"],"SA":["AR","BO","BR","CL","CO","EC","FK","GF","GY","PE","PY","SR","UY","VE"]};var CURRENCIES={USD:"$",EUR:"€"};var PASSWORD_MIN_LENGTH=6;var PASSWORD_MAX_LENGTH=32;var EMPLOYEES_COUNT_VALUES=[{code:'UNKNOWN',name:'orgs.unknown_label'},{code:'ONE_TO_TEN',name:'1-10'},{code:'TEN_TO_FIFTY',name:'10-50'},{code:'FIFTY_TO_TWO_HUNDRED',name:'50-200'},{code:'TWO_HUNDRED_TO_FIVE_HUNDRED',name:'200-500'},{code:'FIVE_HUNDRED_TO_ONE_THOUSAND',name:'500-1000'},{code:'ONE_THOUSAND_TO_FIVE_THOUSAND',name:'1000-5000'},{code:'FIVE_THOUSAND_TO_TEN_THOUSAND',name:'5000-10000'},{code:'TEN_THOUSAND_PLUS',name:'10000+'}];var ORGANIZATION_TYPES=[{code:'EDU_ORG',name:'shared.edu_org_label'},{code:'COMPANY',name:'shared.company_label'}];var ORGANIZATION_AVAILABLE_FLAGS=['hasIVs','providesMoocCertificates'];var FLAGS={'hasIVs':'orgs.has_accreditation_groups_label','verifiesIdentities':'orgs.verifies_identities_label','providesMoocCertificates':'orgs.provides_mooc_certificates_label'};var AVAILABLE_CONSENT_PERIODS={WEEK:'week',MONTH:'month',YEAR:'year',FOREVER:'forever'};var AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST={WEEK:'week',MONTH:'month'};var REFUSE_REASONS=["TIMING1","TIMING2","INTEREST","MISMATCH","ANOTHER"];var REQUEST_EMAIL_SOURCE_REQUESTER='REQUESTER';var REQUEST_EMAIL_SOURCE_DEPARTMENT='DEPARTMENT';var REQUEST_EMAIL_SOURCE_NONE='NONE';var AVAILABLE_PRIOR_CONSENT_TYPES={PERSON:'PERSON',ORGANIZATION:'ORGANIZATION',ANYONE:'ANYONE'};var BOOK_DOMAINS=["ADMINISTRATION_AND_MANAGEMENT","COMMUNICATION","CULTURE_AND_SPORTS_AND_ENTERTAINMENT","GOV","IT","LAND_AND_SEA_AND_AIR","LEGAL","LIFE_AND_DEATH","MANUFACTURING_AND_WORKING_WITH_MATERIALS","SALES_AND_MARKETING","SERVICES","STEM","OTHER"];var OAUTH_ERRORS={INVALID_REQUEST:"invalid_request",UNAUTHORIZED_CLIENT:"unauthorized_client",ACCESS_DENIED:"access_denied",UNSUPPORTED_RESPONSE_TYPE:"unsupported_response_type",INVALID_SCOPE:"invalid_scope",SERVER_ERROR:"server_error",TEMPORARILY_UNAVAILABLE:"temporarily_unavailable"};var TITLES_LANGS=["de","es","nl","fr","ja","ru","original","en"];var NOTIFICATION_TYPES={PENDING_ORGANIZATIONS:'pending_organizations',REVIEW_FAILED_ACCREDITATIONS:'review_failed_accreditations',VALIDATE_ACCREDITATIONS:'validate_accreditations',PENDING_ACCREDITATIONS:'pending_accreditations',PENDING_CONSENTS:'pending_consents',PENDING_ACCREDITATION_REQUESTS:'pending_accreditation_requests',UNREFERENCED_ACCREDITATION_REQUESTS_BY_AGS:'unreferenced_accreditation_requests_by_ags',UNREFERENCED_ACCREDITATION_REQUESTS_BY_DOMAINS:'unreferenced_accreditation_requests_by_domains',REJECTED_BY_APPLICANTS_ACCREDITATIONS:'rejected_by_applicants_accreditations',REJECTED_BY_VALIDATORS_ACCREDITATIONS:'rejected_by_validators_accreditations',ANCHOR_SECURITY_GOT_IT:'anchor_security_got_it',INSERTER_SECURITY_NO_CERTIFICATE:"inserter_security_no_certificate",ADMIN_SECURITY_NOTIFICATIONS:"admin_security_notification"};var ACCREDITATION_REQUEST_STATUSES={REQUEST_IN_PROCESS:'REQUEST_IN_PROCESS',REQUEST_SUBMITTED:'REQUEST_SUBMITTED',REQUEST_REJECTED:'REQUEST_REJECTED'};var ASSISTANT_TYPES={PROCESS_ASSISTANT:'process_assistant',FINANCIAL_ASSISTANT:'financial_assistant'};var EXPOSE_NID_OPTIONS={EXPOSE_FULL:'EXPOSE_FULL',EXPOSE_SHORT:'EXPOSE_SHORT',NOT_EXPOSE:'NOT_EXPOSE'};var TRANSACTION_TYPES={PAYED_CONSENT_REQUEST_REMUNERATION:'PAYED_CONSENT_REQUEST_REMUNERATION'};

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CustomSelect__ = __webpack_require__(131);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__CustomSelect__["b" /* default */]));

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_toSubscriber__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_symbol_observable__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_pipe__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(115);
/** PURE_IMPORTS_START _util_toSubscriber,_internal_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */




var Observable = /*@__PURE__*/ (function () {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = Object(__WEBPACK_IMPORTED_MODULE_0__util_toSubscriber__["a" /* toSubscriber */])(observerOrNext, error, complete);
        if (operator) {
            operator.call(sink, this.source);
        }
        else {
            sink._addParentTeardownLogic(this.source || (__WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable) ?
                this._subscribe(sink) :
                this._trySubscribe(sink));
        }
        if (__WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) {
                    throw sink.syncErrorValue;
                }
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            if (__WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function (value) {
                try {
                    next(value);
                }
                catch (err) {
                    reject(err);
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[__WEBPACK_IMPORTED_MODULE_1__internal_symbol_observable__["a" /* observable */]] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_2__util_pipe__["b" /* pipeFromArray */])(operations)(this);
    };
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());

function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) {
        promiseCtor = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].Promise || Promise;
    }
    if (!promiseCtor) {
        throw new Error('no Promise impl found');
    }
    return promiseCtor;
}
//# sourceMappingURL=Observable.js.map


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OuterSubscriber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


var OuterSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](OuterSubscriber, _super);
    function OuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));

//# sourceMappingURL=OuterSubscriber.js.map


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subscribeToResult;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InnerSubscriber__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscribeTo__ = __webpack_require__(221);
/** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo PURE_IMPORTS_END */


function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, destination) {
    if (destination === void 0) {
        destination = new __WEBPACK_IMPORTED_MODULE_0__InnerSubscriber__["a" /* InnerSubscriber */](outerSubscriber, outerValue, outerIndex);
    }
    if (destination.closed) {
        return;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__subscribeTo__["a" /* subscribeTo */])(result)(destination);
}
//# sourceMappingURL=subscribeToResult.js.map


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export onRegisterOrgByAnchor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchRegisterOrgByAnchor; });
/* unused harmony export onRegisterOrgByAnchorSuccess */
/* unused harmony export fetchGetOrgPriceByAnchorFailed */
/* unused harmony export fetchGetOrgPriceByAnchorSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchGetOrgPriceByAnchor; });
/* unused harmony export fetchGetOrgFailed */
/* unused harmony export fetchGetOrgSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchGetOrg; });
/* unused harmony export fetchGetOrgForAppFailed */
/* unused harmony export fetchGetOrgForAppSuccess */
/* unused harmony export onFetchGetOrgForAppSuccess */
/* unused harmony export onGetOrgPriceByAnchor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchGetOrgForApp; });
/* unused harmony export fetchGetOrgBalanceFailed */
/* unused harmony export fetchGetOrgBalanceSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchGetOrgBalance; });
/* unused harmony export onEditOrgByAnchorSuccess */
/* unused harmony export onEditOrgByAnchor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchEditOrgByAnchor; });
/* unused harmony export fetchGetOperationAvailabilityFailed */
/* unused harmony export fetchGetOperationAvailabilitySuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetOperationAvailability; });
/* unused harmony export getOrg */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getOrgData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return loadingOrg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return loadingOrgForApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getEmailDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getOrgName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getOrgCountryCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getOrgBalance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getOrgPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getOrgPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return isAccreditationSigningRequired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getOrgType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getOrgSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return isOrganizationValidated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getOrgPricingData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getConsentRequestFee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getPaidTillDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getOperationAvailability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return isOrgBava; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__accreditation_certificate__ = __webpack_require__(53);
//- Actions
var onRegisterOrgByAnchor=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REGISTER_ORG_BY_ANCHOR',function(language,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].registerOrgByAnchor(language,data);},function(){return{apiCall:true,onSuccess:onRegisterOrgByAnchorSuccess,onFail:__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchRegisterOrgByAnchor=function fetchRegisterOrgByAnchor(data){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onRegisterOrgByAnchor(Object(__WEBPACK_IMPORTED_MODULE_8__common_localization__["d" /* getSelectedLanguage */])(getState()),data));};};var onRegisterOrgByAnchorSuccess=function onRegisterOrgByAnchorSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_activeModal__["_16" /* hideModal */])());};};var fetchGetOrgPriceByAnchorFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_PRICE_BY_ANCHOR_FAILED');var fetchGetOrgPriceByAnchorSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_PRICE_BY_ANCHOR_SUCCESS');var fetchGetOrgPriceByAnchor=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_PRICE_BY_ANCHOR',function(countryCode,organizationType){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getPricingPresetByAnchor(countryCode,organizationType);},function(){return{apiCall:true,onSuccess:fetchGetOrgPriceByAnchorSuccess,onFail:fetchGetOrgPriceByAnchorFailed,onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchGetOrgFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_FAILED');var fetchGetOrgSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_SUCCESS');var fetchGetOrg=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getOrg();},function(){return{apiCall:true,onSuccess:fetchGetOrgSuccess,onFail:fetchGetOrgFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchGetOrgForAppFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_FOR_APP_FAILED');var fetchGetOrgForAppSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_FOR_APP_SUCCESS');var onFetchGetOrgForAppSuccess=function onFetchGetOrgForAppSuccess(data){return function(dispatch,getState){var hasIVs=data.hasIVs;if(!hasIVs){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__account_role__["w" /* removeSubRolesRequiringHasIVs */])());}var subRoles=Object(__WEBPACK_IMPORTED_MODULE_7__account_role__["s" /* getSubRoles */])(getState());if(subRoles.includes(__WEBPACK_IMPORTED_MODULE_7__account_role__["c" /* SUB_ROLES */].INSERTER)/*&& check permissions*/){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__accreditation_certificate__["b" /* fetchGetKey */])());}dispatch(fetchGetOrgForAppSuccess(data));};};var onGetOrgPriceByAnchor=function onGetOrgPriceByAnchor(){return function(dispatch,getState){var data=getOrgData(getState());if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){dispatch(fetchGetOrgPriceByAnchor(data.address.countryCode,data.type));}};};var fetchGetOrgForApp=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_FOR_APP',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getOrg();},function(){return{apiCall:true,onSuccess:onFetchGetOrgForAppSuccess,onFail:fetchGetOrgForAppFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchGetOrgBalanceFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_BALANCE_FAILED');var fetchGetOrgBalanceSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_BALANCE_SUCCESS');var fetchGetOrgBalance=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_BALANCE',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getOrgBalance();},function(){return{apiCall:true,onSuccess:fetchGetOrgBalanceSuccess,onFail:fetchGetOrgBalanceFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onEditOrgByAnchorSuccess=function onEditOrgByAnchorSuccess(){return function(dispatch){dispatch(fetchGetOrg());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["d" /* fetchSubmitFormSuccess */])());};};var onEditOrgByAnchor=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_EDIT_ORG_BY_ANCHOR',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateOrgByAnchor(data);},function(){return{apiCall:true,onSuccess:onEditOrgByAnchorSuccess,onFail:__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchEditOrgByAnchor=function fetchEditOrgByAnchor(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onEditOrgByAnchor(data));};};var fetchGetOperationAvailabilityFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_OPERATION_AVAILABILITY_FAILED');var fetchGetOperationAvailabilitySuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_OPERATION_AVAILABILITY_SUCCESS');var fetchGetOperationAvailability=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_OPERATION_AVAILABILITY',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getOperationAvailability();},function(){return{apiCall:true,onSuccess:fetchGetOperationAvailabilitySuccess,onFail:fetchGetOperationAvailabilityFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});//- State
var initialState={error:null,fetching:false,success:false,data:null,balanceData:null,fetchingBalance:false,fetchingOrgForApp:false,pricingData:null,operationAvailability:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_ORG:function FETCH_GET_ORG(state){return Object.assign({},state,{error:null,fetching:true,success:false});},FETCH_GET_ORG_FAILED:function FETCH_GET_ORG_FAILED(state,action){return Object.assign({},state,{error:action.payload,fetching:false,success:false});},FETCH_GET_ORG_SUCCESS:function FETCH_GET_ORG_SUCCESS(state,action){return Object.assign({},state,{error:null,fetching:false,success:true,data:action.payload});},FETCH_GET_ORG_FOR_APP:function FETCH_GET_ORG_FOR_APP(state){return Object.assign({},state,{error:null,fetchingOrgForApp:true});},FETCH_GET_ORG_FOR_APP_FAILED:function FETCH_GET_ORG_FOR_APP_FAILED(state,action){return Object.assign({},state,{error:action.payload,fetchingOrgForApp:false});},FETCH_GET_ORG_FOR_APP_SUCCESS:function FETCH_GET_ORG_FOR_APP_SUCCESS(state,action){return Object.assign({},state,{error:null,fetchingOrgForApp:false,data:action.payload});},FETCH_GET_ORG_BALANCE:function FETCH_GET_ORG_BALANCE(state){return Object.assign({},state,{error:null,fetchingBalance:true});},FETCH_GET_ORG_BALANCE_FAILED:function FETCH_GET_ORG_BALANCE_FAILED(state,action){return Object.assign({},state,{balanceData:null,error:action.payload,fetchingBalance:false});},FETCH_GET_ORG_BALANCE_SUCCESS:function FETCH_GET_ORG_BALANCE_SUCCESS(state,action){return Object.assign({},state,{balanceData:action.payload,error:null,fetchingBalance:false,success:true});},FETCH_GET_ORG_PRICE_BY_ANCHOR:function FETCH_GET_ORG_PRICE_BY_ANCHOR(state){return Object.assign({},state,{pricingData:null,fetching:true,error:null,success:false});},FETCH_GET_ORG_PRICE_BY_ANCHOR_SUCCESS:function FETCH_GET_ORG_PRICE_BY_ANCHOR_SUCCESS(state,action){return Object.assign({},state,{pricingData:action.payload,fetching:false,error:null,success:true});},FETCH_GET_ORG_PRICE_BY_ANCHOR_FAILED:function FETCH_GET_ORG_PRICE_BY_ANCHOR_FAILED(state,action){return Object.assign({},state,{pricingData:null,fetching:false,error:action.payload,success:false});},FETCH_GET_OPERATION_AVAILABILITY_SUCCESS:function FETCH_GET_OPERATION_AVAILABILITY_SUCCESS(state,action){return Object.assign({},state,{operationAvailability:action.payload});},FETCH_GET_OPERATION_AVAILABILITY_FAILED:function FETCH_GET_OPERATION_AVAILABILITY_FAILED(state){return Object.assign({},state,{operationAvailability:null});}},initialState));//- Selectors
var getOrg=function getOrg(state){return state.organization;};var getOrgData=function getOrgData(state){return getOrg(state).data;};var loadingOrg=function loadingOrg(state){return getOrg(state).fetching;};var loadingOrgForApp=function loadingOrgForApp(state){return getOrg(state).fetchingOrgForApp;};var getEmailDomain=function getEmailDomain(state){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(getOrgData(state))){return null;}return getOrgData(state).domain;};var getOrgName=function getOrgName(state){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(getOrgData(state))){return null;}return getOrgData(state).name;};var getOrgCountryCode=function getOrgCountryCode(state){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(getOrgData(state))||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(getOrgData(state).address)){return null;}return getOrgData(state).address.countryCode;};var getOrgBalance=function getOrgBalance(state){return getOrg(state).balanceData;};var getOrgPrice=function getOrgPrice(state){var data=getOrgData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return Object.assign({},data.pricing);};var getOrgPermissions=function getOrgPermissions(state){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(getOrgData(state))){return null;}var data=getOrgData(state);return{hasIVs:data.hasIVs,verifiesIdentities:data.verifiesIdentities,providesMoocCertificates:data.providesMoocCertificates,validated:data.validated};};var isAccreditationSigningRequired=function isAccreditationSigningRequired(state){var data=getOrgData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return data.inserterSignatureRequired;};var getOrgType=function getOrgType(state){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(getOrgData(state))){return null;}return getOrgData(state).type;};var getOrgSettings=function getOrgSettings(state){var data=getOrgData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return{orgType:data.type,orgName:data.name,orgDomain:data.domain,orgVatNumber:data.vatNumber,companyCode:data.companyCode,orgContinent:Object(__WEBPACK_IMPORTED_MODULE_4__common_location__["c" /* getContinentByCountry */])(data.address.countryCode,state),orgCountry:data.address.countryCode,orgEmployeeCount:data.employeeCount,orgCity:data.address.city,orgPostal:data.address.postal,orgStreet:data.address.street,financialData:data.financialData};};var isOrganizationValidated=function isOrganizationValidated(state){var data=getOrgData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return data.validated;};var getOrgPricingData=function getOrgPricingData(state){return getOrg(state).pricingData;};var getConsentRequestFee=function getConsentRequestFee(state){var data=getOrgData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data.pricing)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data.pricing.consentRequestFee)){return null;}return data.pricing.consentRequestFee;};var getPaidTillDate=function getPaidTillDate(state){var data=getOrgData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return data.paidTill;};var getOperationAvailability=function getOperationAvailability(state){return getOrg(state).operationAvailability;};var isOrgBava=function isOrgBava(state){return getOrgData(state).bava;};

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return onSetNextOrg; });
/* unused harmony export incrementNumberOfValidatedOrgs */
/* unused harmony export incrementNumberOfSkippedOrgs */
/* unused harmony export setNumberOfSkippedOrgs */
/* unused harmony export onValidateOrgSuccess */
/* unused harmony export onValidateOrg */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return fetchValidateOrg; });
/* unused harmony export setCurrentOrg */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return startOrgValidation; });
/* unused harmony export cleanValidatedStatus */
/* unused harmony export fetchGetValidatedOrgsFailed */
/* unused harmony export fetchGetNotValidatedOrgsFailed */
/* unused harmony export fetchGetValidatedOrgsSuccess */
/* unused harmony export fetchGetNotValidatedOrgsSuccess */
/* unused harmony export onGetOrgsSuccess */
/* unused harmony export onUpdateValidatedOrgs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchGetValidatedOrgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchGetNotValidatedOrgs; });
/* unused harmony export onRegisterOrganization */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return fetchRegisterOrganization; });
/* unused harmony export onRegisterOrganizationSuccess */
/* unused harmony export onEditOrgSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchChangeOrgBalance; });
/* unused harmony export onFetchChangeOrgBalance */
/* unused harmony export fetchChangeOrgBalanceSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return fetchUpdateOrgPrice; });
/* unused harmony export onUpdateOrgGeneralData */
/* unused harmony export onUpdateOrgFinancialData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchEditOrg; });
/* unused harmony export onChangeAnchorBySysAdmin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchChangeAnchorBySysAdmin; });
/* unused harmony export fetchGetOrgDataByIdFailed */
/* unused harmony export fetchGetOrgDataByIdSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchGetOrgDataById; });
/* unused harmony export onGetOrgDataById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchGetOrgDataForValidateById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearOrgData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDU_ORG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LABEL_PATH_BY_ORG_TYPE; });
/* unused harmony export onUpdateNotValidatedOrgSuccess */
/* unused harmony export onUpdateNotValidatedOrgGeneralData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return fetchUpdateNotValidatedOrgGeneralData; });
/* unused harmony export onChangeAnchorBySysAdminForNotValidatedOrgSuccess */
/* unused harmony export onFetchChangeAnchorBySysAdminForNotValidatedOrg */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchChangeAnchorBySysAdminForNotValidatedOrg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return resetTotalElementsForNotValidated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return setCountryFilter; });
/* unused harmony export fetchRemoveOrgSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return onFetchRemoveOrg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return fetchMarkOrgAsBava; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return fetchRemoveOrgBavaFlag; });
/* unused harmony export onFetchMarkOrgAsBava */
/* unused harmony export onFetchRemoveBavaFlag */
/* unused harmony export getOrgs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return loadingOrgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return loadingOrg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getFetchingErrorOrg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getCurrentPageForValidatedOrgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getCurrentPageForNotValidatedOrgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getTotalPagesForValidatedOrgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getTotalPagesForNotValidatedOrgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getValidatedOrgsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getValidatedOrgsPaymentsData; });
/* unused harmony export getOrgsPaymentsData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getNotValidatedOrgsData; });
/* unused harmony export getOrgsData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getOrganizationData; });
/* unused harmony export getOrganizationDataForRequest */
/* unused harmony export getOrganizationPriceDataForRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getOrgDataToEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getOrgPermissionsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getOrgFinanceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getOrgDataToEditPayments; });
/* unused harmony export getOrgIndexById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getCurrentOrgIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getCurrentOrgId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getLeftOrgsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getNumberOfValidatedOrgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getNumberOfSkippedOrgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getTotalNumberOfNotValidatedOrgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getOrgName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getCountryFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_activeModal__ = __webpack_require__(6);
//- Actions
var onSetNextOrg=function onSetNextOrg(){return function(dispatch,getState){var list=getNotValidatedOrgsData(getState());var currentPage=getCurrentPageForNotValidatedOrgs(getState());dispatch(incrementNumberOfSkippedOrgs());if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(list)&&list.length>0){var currentIndex=getCurrentOrgIndex(getState());if(currentIndex<list.length-1){dispatch(setCurrentOrg(currentIndex+1));dispatch(fetchGetNotValidatedOrgs(currentPage));}else{var totalPages=getTotalPagesForNotValidatedOrgs(getState());if(currentPage<totalPages-1){dispatch(setCurrentOrg(0));dispatch(fetchGetNotValidatedOrgs(currentPage+1));}else{dispatch(setCurrentOrg(null));}}}};};var incrementNumberOfValidatedOrgs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('NUMBER_OF_VALIDATED_ORGS_INCREMENT');var incrementNumberOfSkippedOrgs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('NUMBER_OF_SKIPPED_ORGS_INCREMENT');var setNumberOfSkippedOrgs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('NUMBER_OF_SKIPPED_ORGS_SET');var onValidateOrgSuccess=function onValidateOrgSuccess(){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(fetchGetNotValidatedOrgs(getCurrentPageForNotValidatedOrgs(getState())));dispatch(incrementNumberOfValidatedOrgs());dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_activeModal__["_16" /* hideModal */])());};};var onValidateOrg=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_VALIDATE_ORG',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateOrganizationValidatedState(id,true);},function(){return{apiCall:true,onSuccess:onValidateOrgSuccess,onFail:__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchValidateOrg=function fetchValidateOrg(id){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onValidateOrg(id));var currentIndex=getCurrentOrgIndex(getState());dispatch(setCurrentOrg(currentIndex+1));};};var setCurrentOrg=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CURRENT_ORG_SET',function(index){return index;});var startOrgValidation=function startOrgValidation(id){return function(dispatch,getState){var index=getOrgIndexById(getState(),id);var currentPage=getCurrentPageForNotValidatedOrgs(getState());var skipped=currentPage*10+index;dispatch(setNumberOfSkippedOrgs(skipped));dispatch(setCurrentOrg(index));dispatch(cleanValidatedStatus());};};var cleanValidatedStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('VALIDATED_STATUS_CLEAN');var fetchGetValidatedOrgsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_VALIDATED_ORGS_FAILED');var fetchGetNotValidatedOrgsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOT_VALIDATED_ORGS_FAILED');var fetchGetValidatedOrgsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_VALIDATED_ORGS_SUCCESS');var fetchGetNotValidatedOrgsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOT_VALIDATED_ORGS_SUCCESS');var onGetOrgsSuccess=function onGetOrgsSuccess(validated){return function(data){return function(dispatch,getState){var isEmpty=data.empty;var currentPage=data.number;if(!isEmpty&&currentPage!==0||currentPage===0){dispatch(validated?fetchGetValidatedOrgsSuccess(data):fetchGetNotValidatedOrgsSuccess(data));}else{var countryFilter=getCountryFilter(getState());dispatch(validated?fetchGetValidatedOrgs(currentPage-1,countryFilter):fetchGetNotValidatedOrgs(currentPage-1,countryFilter));}};};};var onUpdateValidatedOrgs=function onUpdateValidatedOrgs(){return function(dispatch,getState){var currentPage=getCurrentPageForValidatedOrgs(getState());var countryFilter=getCountryFilter(getState());dispatch(fetchGetValidatedOrgs(currentPage,countryFilter));};};var fetchGetValidatedOrgs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_VALIDATED_ORGS',function(page,countryCode,name){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getOrgs(true,page,countryCode,name);},function(){return{apiCall:true,onSuccess:onGetOrgsSuccess(true),onFail:fetchGetValidatedOrgsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchGetNotValidatedOrgs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOT_VALIDATED_ORGS',function(page){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getOrgs(false,page);},function(){return{apiCall:true,onSuccess:onGetOrgsSuccess(false),onFail:fetchGetNotValidatedOrgsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onRegisterOrganization=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REGISTER_ORG',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].registerOrganization(data);},function(){return{apiCall:true,onSuccess:onRegisterOrganizationSuccess,onFail:__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchRegisterOrganization=function fetchRegisterOrganization(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onRegisterOrganization(data));};};var onRegisterOrganizationSuccess=function onRegisterOrganizationSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_activeModal__["_16" /* hideModal */])());};};var onEditOrgSuccess=function onEditOrgSuccess(){return function(dispatch,getState){var orgData=getOrganizationData(getState());if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(orgData)){dispatch(fetchGetOrgDataById(orgData.id));}dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["d" /* fetchSubmitFormSuccess */])());};};var fetchChangeOrgBalance=function fetchChangeOrgBalance(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onFetchChangeOrgBalance(id,data));};};var onFetchChangeOrgBalance=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CHANGE_ORG_BALANCE',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].changeOrganizationBalance(id,data);},function(){return{apiCall:true,onSuccess:fetchChangeOrgBalanceSuccess,onFail:__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchChangeOrgBalanceSuccess=function fetchChangeOrgBalanceSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_activeModal__["_16" /* hideModal */])());dispatch(onUpdateValidatedOrgs());};};var fetchUpdateOrgPrice=function fetchUpdateOrgPrice(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onUpdateOrgFinancialData(id,data));};};var onUpdateOrgGeneralData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_EDIT_ORG',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateOrganizationGeneralData(id,data);},function(){return{apiCall:true,onSuccess:onEditOrgSuccess,onFail:__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onUpdateOrgFinancialData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_EDIT_ORG',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateOrganizationFinancialData(id,data);},function(){return{apiCall:true,onSuccess:onEditOrgSuccess,onFail:__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchEditOrg=function fetchEditOrg(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onUpdateOrgGeneralData(id,data));};};var onChangeAnchorBySysAdmin=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_EDIT_ANCHOR',function(orgId,anchorData){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].changeAnchorBySysAdmin(orgId,anchorData);},function(){return{apiCall:true,onSuccess:onEditOrgSuccess,onFail:__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchChangeAnchorBySysAdmin=function fetchChangeAnchorBySysAdmin(orgId,anchorData){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onChangeAnchorBySysAdmin(orgId,anchorData));};};var fetchGetOrgDataByIdFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_DATA_BY_ID_FAILED');var fetchGetOrgDataByIdSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_DATA_BY_ID_SUCCESS');var fetchGetOrgDataById=function fetchGetOrgDataById(id){return function(dispatch){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(id)&&id!==''){dispatch(onGetOrgDataById(id));}else{dispatch(fetchGetOrgDataByIdFailed("ID_IS_NULL"));}};};var onGetOrgDataById=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_DATA_BY_ID',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getOrganizationDataById(id);},function(){return{apiCall:true,onSuccess:fetchGetOrgDataByIdSuccess,onFail:fetchGetOrgDataByIdFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchGetOrgDataForValidateById=function fetchGetOrgDataForValidateById(id){return function(dispatch){dispatch(clearOrgData());dispatch(fetchGetOrgDataById(id));};};var clearOrgData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_ORG_DATA');var EDU_ORG='EDU_ORG';var COMPANY='COMPANY';var LABEL_PATH_BY_ORG_TYPE={'EDU_ORG':'edu_org_label','COMPANY':'company_label'};var onUpdateNotValidatedOrgSuccess=function onUpdateNotValidatedOrgSuccess(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(fetchGetOrgDataByIdSuccess(data));};};var onUpdateNotValidatedOrgGeneralData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_UPDATE_NOT_VALIDATED_ORG',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateOrganizationGeneralData(id,data);},function(){return{apiCall:true,onSuccess:onUpdateNotValidatedOrgSuccess,onFail:__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchUpdateNotValidatedOrgGeneralData=function fetchUpdateNotValidatedOrgGeneralData(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onUpdateNotValidatedOrgGeneralData(id,data));};};var onChangeAnchorBySysAdminForNotValidatedOrgSuccess=function onChangeAnchorBySysAdminForNotValidatedOrgSuccess(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(fetchGetOrgDataByIdSuccess(data));};};var onFetchChangeAnchorBySysAdminForNotValidatedOrg=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CHANGE_ANCHOR_BY_SA_NOT_VALIDATED_ORG',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].changeAnchorBySysAdmin(id,data);},function(){return{apiCall:true,onSuccess:onChangeAnchorBySysAdminForNotValidatedOrgSuccess,onFail:__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchChangeAnchorBySysAdminForNotValidatedOrg=function fetchChangeAnchorBySysAdminForNotValidatedOrg(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onFetchChangeAnchorBySysAdminForNotValidatedOrg(id,data));};};var resetTotalElementsForNotValidated=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RESET_TOTAL_ELEMENTS_FOR_NOT_VALIDATED');var setCountryFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('COUNTRY_FILTER_SET');var fetchRemoveOrgSuccess=function fetchRemoveOrgSuccess(validated){return function(){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["d" /* fetchSubmitFormSuccess */])());if(validated){var countryFilter=getCountryFilter(getState());var currentPage=getCurrentPageForValidatedOrgs(getState());dispatch(fetchGetValidatedOrgs(currentPage,countryFilter));}else{var _currentPage=getCurrentPageForNotValidatedOrgs(getState());dispatch(fetchGetNotValidatedOrgs(_currentPage));}};};};var onFetchRemoveOrg=function onFetchRemoveOrg(validated){return Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_ORG',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeOrg(id);},function(){return{apiCall:true,onSuccess:fetchRemoveOrgSuccess(validated),onFail:__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});};var fetchMarkOrgAsBava=function fetchMarkOrgAsBava(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onFetchMarkOrgAsBava(id));};};var fetchRemoveOrgBavaFlag=function fetchRemoveOrgBavaFlag(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onFetchRemoveBavaFlag());};};var onFetchMarkOrgAsBava=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_MARK_ORG_AS_BAVA',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].markOrgAsBava(id);},function(){return{apiCall:true,onSuccess:onEditOrgSuccess,onFail:__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onFetchRemoveBavaFlag=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_BAVA_FLAG',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeBavaFlag();},function(){return{apiCall:true,onSuccess:onEditOrgSuccess,onFail:__WEBPACK_IMPORTED_MODULE_5__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});//- State
var initialState={validatedOrgs:null,notValidatedOrgs:null,error:null,organizationData:null,currentPageForValidated:null,currentPageForNotValidated:null,totalPagesForValidated:null,totalPagesForNotValidated:null,totalElementsForNotValidated:null,currentOrgIndex:null,validated:0,skipped:0,leftNumber:null,fetching:false,organizationFetching:false,countryFilter:null};//- Reducers
/* harmony default export */ __webpack_exports__["e"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_VALIDATED_ORGS:function FETCH_GET_VALIDATED_ORGS(state){return Object.assign({},state,{validatedOrgs:null,currentPageForValidated:null,totalPagesForValidated:null,totalPagesForNotValidated:null,error:null,fetching:true});},FETCH_GET_NOT_VALIDATED_ORGS:function FETCH_GET_NOT_VALIDATED_ORGS(state){return Object.assign({},state,{notValidatedOrgs:null,currentPageForNotValidated:null,totalPagesForNotValidated:null,error:null,fetching:true,leftNumber:null});},FETCH_GET_VALIDATED_ORGS_FAILED:function FETCH_GET_VALIDATED_ORGS_FAILED(state,action){return Object.assign({},state,{validatedOrgs:null,currentPageForValidated:null,totalPagesForValidated:null,error:action.payload,fetching:false});},FETCH_GET_NOT_VALIDATED_ORGS_FAILED:function FETCH_GET_NOT_VALIDATED_ORGS_FAILED(state,action){return Object.assign({},state,{notValidatedOrgs:null,currentPageForNotValidated:null,totalPagesForNotValidated:null,totalElementsForNotValidated:null,error:action.payload,fetching:false});},FETCH_GET_VALIDATED_ORGS_SUCCESS:function FETCH_GET_VALIDATED_ORGS_SUCCESS(state,action){return Object.assign({},state,{validatedOrgs:action.payload.content,currentPageForValidated:action.payload.number,totalPagesForValidated:action.payload.totalPages,error:null,fetching:false});},FETCH_GET_NOT_VALIDATED_ORGS_SUCCESS:function FETCH_GET_NOT_VALIDATED_ORGS_SUCCESS(state,action){return Object.assign({},state,{notValidatedOrgs:action.payload.content,currentPageForNotValidated:action.payload.number,totalPagesForNotValidated:action.payload.totalPages,totalElementsForNotValidated:state.totalElementsForNotValidated||action.payload.totalElements,error:null,fetching:false,leftNumber:action.payload.totalElements});},FETCH_GET_ORG_DATA_BY_ID:function FETCH_GET_ORG_DATA_BY_ID(state){return Object.assign({},state,{error:null,organizationFetching:true});},FETCH_GET_ORG_DATA_BY_ID_FAILED:function FETCH_GET_ORG_DATA_BY_ID_FAILED(state,action){return Object.assign({},state,{organizationData:null,error:action.payload,organizationFetching:false});},FETCH_GET_ORG_DATA_BY_ID_SUCCESS:function FETCH_GET_ORG_DATA_BY_ID_SUCCESS(state,action){return Object.assign({},state,{organizationData:action.payload,error:null,organizationFetching:false});},CURRENT_ORG_SET:function CURRENT_ORG_SET(state,action){return Object.assign({},state,{currentOrgIndex:action.payload});},VALIDATED_STATUS_CLEAN:function VALIDATED_STATUS_CLEAN(state){return Object.assign({},state,{validated:0});},NUMBER_OF_SKIPPED_ORGS_SET:function NUMBER_OF_SKIPPED_ORGS_SET(state,action){return Object.assign({},state,{skipped:action.payload});},NUMBER_OF_SKIPPED_ORGS_INCREMENT:function NUMBER_OF_SKIPPED_ORGS_INCREMENT(state){return Object.assign({},state,{skipped:state.skipped+1});},NUMBER_OF_VALIDATED_ORGS_INCREMENT:function NUMBER_OF_VALIDATED_ORGS_INCREMENT(state){return Object.assign({},state,{validated:state.validated+1});},CLEAR_ORG_DATA:function CLEAR_ORG_DATA(state){return Object.assign({},state,{organizationData:null});},RESET_TOTAL_ELEMENTS_FOR_NOT_VALIDATED:function RESET_TOTAL_ELEMENTS_FOR_NOT_VALIDATED(state){return Object.assign({},state,{totalElementsForNotValidated:null});},COUNTRY_FILTER_SET:function COUNTRY_FILTER_SET(state,action){return Object.assign({},state,{countryFilter:action.payload});}},initialState));//- Selectors
var getOrgs=function getOrgs(state){return state.organizations;};var loadingOrgs=function loadingOrgs(state){return getOrgs(state).fetching;};var loadingOrg=function loadingOrg(state){return getOrgs(state).organizationFetching;};var getFetchingErrorOrg=function getFetchingErrorOrg(state){return getOrgs(state).error;};var getCurrentPageForValidatedOrgs=function getCurrentPageForValidatedOrgs(state){return getOrgs(state).currentPageForValidated;};var getCurrentPageForNotValidatedOrgs=function getCurrentPageForNotValidatedOrgs(state){return getOrgs(state).currentPageForNotValidated;};var getTotalPagesForValidatedOrgs=function getTotalPagesForValidatedOrgs(state){return getOrgs(state).totalPagesForValidated;};var getTotalPagesForNotValidatedOrgs=function getTotalPagesForNotValidatedOrgs(state){return getOrgs(state).totalPagesForNotValidated;};var getValidatedOrgsData=function getValidatedOrgsData(state){return getOrgsData(state,true);};var getValidatedOrgsPaymentsData=function getValidatedOrgsPaymentsData(state){return getOrgsPaymentsData(state,true);};var getOrgsPaymentsData=function getOrgsPaymentsData(state,validated){var data=validated?getOrgs(state).validatedOrgs:getOrgs(state).notValidatedOrgs;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(data,function(org){return{id:org.id,orgType:org.type,orgName:org.name,active:org.anchor.active,balance:org.balance,paidTillDate:org.paidTill,anchorName:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(org.anchor.identityAlias)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(org.anchor.identityAlias.firstName)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(org.anchor.identityAlias.lastName)?org.anchor.email:org.anchor.identityAlias.firstName+" "+org.anchor.identityAlias.lastName,anchorEmail:org.anchor.email,location:org.address.countryCode};});};var getNotValidatedOrgsData=function getNotValidatedOrgsData(state){return getOrgsData(state,false);};var getOrgsData=function getOrgsData(state,validated){var data=validated?getOrgs(state).validatedOrgs:getOrgs(state).notValidatedOrgs;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(data,function(org){return{id:org.id,anchorName:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(org.anchor.identityAlias)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(org.anchor.identityAlias.firstName)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(org.anchor.identityAlias.lastName)?org.anchor.email:org.anchor.identityAlias.firstName+" "+org.anchor.identityAlias.lastName,anchorEmail:org.anchor.email,active:org.anchor.active,location:org.address.countryCode,orgName:org.name,generalDataValidated:org.generalDataValidated,financialDataValidated:org.financialDataValidated,orgType:org.type,isBava:org.bava};});};var getOrganizationData=function getOrganizationData(state){return getOrgs(state).organizationData;};var getOrganizationDataForRequest=function getOrganizationDataForRequest(state){var data=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(getOrganizationData(state));delete data.balance;delete data.pricing;return data;};var getOrganizationPriceDataForRequest=function getOrganizationPriceDataForRequest(state){return{pricing:getOrganizationData(state).pricing,balance:getOrganizationData(state).balance};};var getOrgDataToEdit=function getOrgDataToEdit(state){var data=getOrganizationData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return{orgId:data.id,orgType:data.type,orgName:data.name,orgDomain:data.domain,orgVatNumber:data.vatNumber,companyCode:data.companyCode,orgContinent:Object(__WEBPACK_IMPORTED_MODULE_4__common_location__["c" /* getContinentByCountry */])(data.address.countryCode,state),orgCountry:data.address.countryCode,orgEmployeeCount:data.employeeCount,orgCity:data.address.city,orgPostal:data.address.postal,orgStreet:data.address.street,anchorFirstName:data.anchor.identityAlias.firstName,anchorLastName:data.anchor.identityAlias.lastName,anchorEmail:data.anchor.email,hasIVs:data.hasIVs,verifiesIdentities:data.verifiesIdentities,providesMoocCertificates:data.providesMoocCertificates,presetId:data.pricing.pricingPreset.id,generalDataValidated:data.generalDataValidated,financialDataValidated:data.financialDataValidated,isBava:data.bava};};var getOrgPermissionsData=function getOrgPermissionsData(state){var data=getOrganizationData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return{hasIVs:data.hasIVs,verifiesIdentities:data.verifiesIdentities,providesMoocCertificates:data.providesMoocCertificates};};var getOrgFinanceData=function getOrgFinanceData(state){var data=getOrganizationData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return{balance:data.balance.amount,balanceCurrency:data.balance.currency,presetId:data.pricing.pricingPreset.id,paidTillDate:data.paidTill,annualFee:data.pricing.annualFee||data.pricing.pricingPreset.annualFee,consentRequestFee:data.pricing.consentRequestFee||data.pricing.pricingPreset.consentRequestFee,deviationDate:data.pricing.validTill,deviationDateForever:(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data.pricing.annualFee)||!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data.pricing.consentRequestFee))&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data.pricing.validTill),financialData:data.financialData||""};};var getOrgDataToEditPayments=function getOrgDataToEditPayments(state){var data=getOrganizationData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return{orgType:data.type,orgName:data.name,orgContinent:Object(__WEBPACK_IMPORTED_MODULE_4__common_location__["c" /* getContinentByCountry */])(data.address.countryCode,state),orgCountry:data.address.countryCode,anchorName:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data.anchor.identityAlias)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data.anchor.identityAlias.firstName)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data.anchor.identityAlias.lastName)?data.anchor.email:data.anchor.identityAlias.firstName+" "+data.anchor.identityAlias.lastName,anchorEmail:data.anchor.email};};var getOrgIndexById=function getOrgIndexById(state,id){var notValidatedOrgsList=getOrgs(state).notValidatedOrgs;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(notValidatedOrgsList)){return null;}var index=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(notValidatedOrgsList,function(org){return org.id===id;});if(index<0){return null;}return index;};var getCurrentOrgIndex=function getCurrentOrgIndex(state){return getOrgs(state).currentOrgIndex;};var getCurrentOrgId=function getCurrentOrgId(state){var index=getOrgs(state).currentOrgIndex;var ids=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(getNotValidatedOrgsData(state),function(org){return org.id;});if(index>=ids.length){return null;}return ids[index];};var getLeftOrgsNumber=function getLeftOrgsNumber(state){return getOrgs(state).leftNumber;};var getNumberOfValidatedOrgs=function getNumberOfValidatedOrgs(state){return getOrgs(state).validated;};var getNumberOfSkippedOrgs=function getNumberOfSkippedOrgs(state){return getOrgs(state).skipped;};var getTotalNumberOfNotValidatedOrgs=function getTotalNumberOfNotValidatedOrgs(state){return getOrgs(state).totalElementsForNotValidated;};var getOrgName=function getOrgName(state){var data=getOrganizationData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return data.name;};var getCountryFilter=function getCountryFilter(state){return getOrgs(state).countryFilter;};

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BackButtonComponent_css__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BackButtonComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BackButtonComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BackButtonComponent=function(_Component){_inherits(BackButtonComponent,_Component);function BackButtonComponent(){_classCallCheck(this,BackButtonComponent);return _possibleConstructorReturn(this,(BackButtonComponent.__proto__||Object.getPrototypeOf(BackButtonComponent)).apply(this,arguments));}_createClass(BackButtonComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'back-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["A" /* NavLink */],{tag:__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],to:this.props.path,className:'back-button-nav-link',title:this.props.label},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__iconContainer_IconContainer__["a" /* default */],{className:'back-button-icon',icon:'arrow_back'}),this.props.label));}}]);return BackButtonComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BackButtonComponent.propTypes={path:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (BackButtonComponent);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_isArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isObject__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isFunction__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_tryCatch__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_errorObject__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_UnsubscriptionError__ = __webpack_require__(210);
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_tryCatch,_util_errorObject,_util_UnsubscriptionError PURE_IMPORTS_END */






var Subscription = /*@__PURE__*/ (function () {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function () {
        var hasErrors = false;
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        while (_parent) {
            _parent.remove(this);
            _parent = ++index < len && _parents[index] || null;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_isFunction__["a" /* isFunction */])(_unsubscribe)) {
            var trial = Object(__WEBPACK_IMPORTED_MODULE_3__util_tryCatch__["a" /* tryCatch */])(_unsubscribe).call(this);
            if (trial === __WEBPACK_IMPORTED_MODULE_4__util_errorObject__["a" /* errorObject */]) {
                hasErrors = true;
                errors = errors || (__WEBPACK_IMPORTED_MODULE_4__util_errorObject__["a" /* errorObject */].e instanceof __WEBPACK_IMPORTED_MODULE_5__util_UnsubscriptionError__["a" /* UnsubscriptionError */] ?
                    flattenUnsubscriptionErrors(__WEBPACK_IMPORTED_MODULE_4__util_errorObject__["a" /* errorObject */].e.errors) : [__WEBPACK_IMPORTED_MODULE_4__util_errorObject__["a" /* errorObject */].e]);
            }
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util_isArray__["a" /* isArray */])(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isObject__["a" /* isObject */])(sub)) {
                    var trial = Object(__WEBPACK_IMPORTED_MODULE_3__util_tryCatch__["a" /* tryCatch */])(sub.unsubscribe).call(sub);
                    if (trial === __WEBPACK_IMPORTED_MODULE_4__util_errorObject__["a" /* errorObject */]) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = __WEBPACK_IMPORTED_MODULE_4__util_errorObject__["a" /* errorObject */].e;
                        if (err instanceof __WEBPACK_IMPORTED_MODULE_5__util_UnsubscriptionError__["a" /* UnsubscriptionError */]) {
                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
        }
        if (hasErrors) {
            throw new __WEBPACK_IMPORTED_MODULE_5__util_UnsubscriptionError__["a" /* UnsubscriptionError */](errors);
        }
    };
    Subscription.prototype.add = function (teardown) {
        if (!teardown || (teardown === Subscription.EMPTY)) {
            return Subscription.EMPTY;
        }
        if (teardown === this) {
            return this;
        }
        var subscription = teardown;
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (typeof subscription._addParent !== 'function') {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.prototype._addParent = function (parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) {
            this._parent = parent;
        }
        else if (!_parents) {
            this._parents = [parent];
        }
        else if (_parents.indexOf(parent) === -1) {
            _parents.push(parent);
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());

function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof __WEBPACK_IMPORTED_MODULE_5__util_UnsubscriptionError__["a" /* UnsubscriptionError */]) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetUserDataByTokenFailed */
/* unused harmony export fetchGetUserDataByTokenSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetUserDataByToken; });
/* unused harmony export fetchGetUserDataFailed */
/* unused harmony export fetchGetUserDataSuccess */
/* unused harmony export onGetUserDataSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetUserData; });
/* unused harmony export getUser */
/* unused harmony export getUserData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getLoadingDataByToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUserDataError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUserEmail; });
/* unused harmony export getUserIdentityAlias */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getUserRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getUserSecret; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getUserPersonalData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_storageApi__ = __webpack_require__(56);
//- Actions
var fetchGetUserDataByTokenFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_USER_DATA_BY_TOKEN_FAILED');var fetchGetUserDataByTokenSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_USER_DATA_BY_TOKEN_SUCCESS');var fetchGetUserDataByToken=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_USER_DATA_BY_TOKEN',function(token){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getUserDataByToken(token);},function(){return{apiCall:true,onSuccess:fetchGetUserDataByTokenSuccess,onFail:fetchGetUserDataByTokenFailed};});var fetchGetUserDataFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_USER_DATA_FAILED');var fetchGetUserDataSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_USER_DATA_SUCCESS');var onGetUserDataSuccess=function onGetUserDataSuccess(data){return function(dispatch){__WEBPACK_IMPORTED_MODULE_5__utils_storageApi__["a" /* StorageApi */].setUserId(data.id);dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__role__["y" /* setRoleAndSubRoles */])(data.role,data.subRoles));dispatch(fetchGetUserDataSuccess(data));};};var fetchGetUserData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_USER_DATA',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getUserData();},function(){return{apiCall:true,onSuccess:onGetUserDataSuccess,onFail:fetchGetUserDataFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__login__["l" /* onForbidden */]};});//- State
var initialState={data:null,error:null,fetching:false,fetchingByToken:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_USER_DATA:function FETCH_GET_USER_DATA(state){return Object.assign({},state,{data:null,error:null,fetching:true});},FETCH_GET_USER_DATA_FAILED:function FETCH_GET_USER_DATA_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_USER_DATA_SUCCESS:function FETCH_GET_USER_DATA_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});},FETCH_GET_USER_DATA_BY_TOKEN:function FETCH_GET_USER_DATA_BY_TOKEN(state){return Object.assign({},state,{data:null,error:null,fetchingByToken:true});},FETCH_GET_USER_DATA_BY_TOKEN_FAILED:function FETCH_GET_USER_DATA_BY_TOKEN_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetchingByToken:false});},FETCH_GET_USER_DATA_BY_TOKEN_SUCCESS:function FETCH_GET_USER_DATA_BY_TOKEN_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetchingByToken:false});}},initialState));//- Selectors
var getUser=function getUser(state){return state.userData;};var getUserData=function getUserData(state){return getUser(state).data;};var isLoading=function isLoading(state){return getUser(state).fetching;};var getLoadingDataByToken=function getLoadingDataByToken(state){return getUser(state).fetchingByToken;};var getUserDataError=function getUserDataError(state){return getUser(state).error;};var getUserEmail=function getUserEmail(state){var data=getUserData(state);if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(data)){return null;}return data.email;};var getUserIdentityAlias=function getUserIdentityAlias(state){var data=getUserData(state);if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(data)){return null;}return data.identityAlias;};var getUserRole=function getUserRole(state){var data=getUserData(state);if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(data)){return null;}return data.role;};var getUserId=function getUserId(state){var data=getUserData(state);if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(data)){return null;}return data.id;};var getUserSecret=function getUserSecret(state){var data=getUserData(state);if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(data)){return null;}return data.browserSecret;};var getUserPersonalData=function getUserPersonalData(state){return Object.assign({email:getUserEmail(state)},getUserIdentityAlias(state));};

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent_css__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PREVIOUS="pervious";var NEXT="next";var PaginationComponent=function(_Component){_inherits(PaginationComponent,_Component);function PaginationComponent(props){_classCallCheck(this,PaginationComponent);var _this=_possibleConstructorReturn(this,(PaginationComponent.__proto__||Object.getPrototypeOf(PaginationComponent)).call(this,props));_this.getPaginationItems=function(){var items=[];for(var i=0;i<_this.state.total;i++){var active=_this.state.current===i;items.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["F" /* PaginationItem */],{active:active,key:"pagination-item-"+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["G" /* PaginationLink */],{onClick:_this.handleClickPage(i)},i+1)));}return items;};_this.handleClickPage=function(id){return function(){id=parseInt(id,10);if(Number.isInteger(id)&&_this.state.current!==id){_this.props.getDataForPage(id);_this.setState({current:id});}};};_this.handleClickNavigation=function(id){return function(){if(id===NEXT){_this.props.getDataForPage(_this.state.current+1);_this.setState({current:_this.state.current+1});}else if(id===PREVIOUS){_this.props.getDataForPage(_this.state.current-1);_this.setState({current:_this.state.current-1});}};};_this.state={current:null,total:null};return _this;}_createClass(PaginationComponent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(nextProps.current)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(nextProps.total)&&(this.state.current!==nextProps.current||this.state.total!==nextProps.total)){this.setState({current:nextProps.current,total:nextProps.total});}}},{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.state.current)||__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.state.total)||this.state.total<=1){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["E" /* Pagination */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["F" /* PaginationItem */],{disabled:this.state.current===0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["G" /* PaginationLink */],{previous:true,onClick:this.handleClickNavigation(PREVIOUS)})),this.getPaginationItems(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["F" /* PaginationItem */],{disabled:this.state.current===this.state.total-1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["G" /* PaginationLink */],{next:true,onClick:this.handleClickNavigation(NEXT)}))));}}]);return PaginationComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PaginationComponent.propTypes={total:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,current:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,getDataForPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (PaginationComponent);

/***/ }),
/* 37 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REJECTED_BY_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REJECTED_BY_APPLICANTS; });
/* unused harmony export resetAccreditationListData */
/* unused harmony export onSetStartAccreditation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return setStartAccreditation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cleanStartAccreditation; });
/* unused harmony export onSetNextAsStartAccreditation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return setNextAsStartAccreditationForValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return setNextAsStartAccreditationForReview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cleanValidatedStatus; });
/* unused harmony export incrementNumberOfValidatedAccreditations */
/* unused harmony export fetchGetAccreditationsFailed */
/* unused harmony export fetchGetAccreditationsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getAccreditationForValidation; });
/* unused harmony export fetchGetAccreditationsForValidation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return setRejectedBy; });
/* unused harmony export getAccreditationForReview */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getRejectedByValidatorsAccreditations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getRejectedByApplicantsAccreditations; });
/* unused harmony export fetchGetAccreditationsForReview */
/* unused harmony export onInsertAccreditation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchInsertAccreditation; });
/* unused harmony export onValidateAccreditationSuccess */
/* unused harmony export onValidateAccreditation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return fetchValidateAccreditation; });
/* unused harmony export onReviewAccreditationSuccess */
/* unused harmony export onReviewAccreditation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return fetchReviewAccreditation; });
/* unused harmony export onRemoveAccreditationSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return fetchRemoveAccreditation; });
/* unused harmony export fetchGetManagedOrgsSuccess */
/* unused harmony export fetchGetManagedOrgsFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchGetManagedOrgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearManagedOrgs; });
/* unused harmony export fetchGetAccreditationsPerCountryFailed */
/* unused harmony export fetchGetAccreditationsPerCountrySuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchGetAccreditationsPerCountryForValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchGetAccreditationsPerCountryRejectedByValidators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchGetAccreditationsPerCountryRejectedByApplicants; });
/* unused harmony export setAccreditationsCountryFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearAccreditationsCountryFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return onUpdateAccreditationsCountryFilterForValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return onUpdateAccreditationsCountryFilterRejectedByValidators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return onUpdateAccreditationsCountryFilterRejectedByApplicants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return onFetchGetAccreditationsPerDomainForValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return onFetchGetAccreditationsPerDomainRejectedByValidators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return onFetchGetAccreditationsPerDomainRejectedByApplicants; });
/* unused harmony export fetchGetAccreditationsPerDomainFailed */
/* unused harmony export fetchGetAccreditationsPerDomainSuccess */
/* unused harmony export fetchGetAccreditationsPerDomainForValidation */
/* unused harmony export fetchGetAccreditationsPerDomainRejectedByValidators */
/* unused harmony export fetchGetAccreditationsPerDomainRejectedByApplicants */
/* unused harmony export setAccreditationsDomainFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearAccreditationsDomainFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return onUpdateAccreditationsDomainFilterForValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return onUpdateAccreditationsDomainFilterRejectedByValidators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return onUpdateAccreditationsDomainFilterRejectedByApplicants; });
/* unused harmony export getAccreditations */
/* unused harmony export getAccreditationsData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getCurrentPageForAccreditationsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getTotalPagesForAccreditationsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getLeftAccreditationsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return loadingAccreditationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getCurrentAccreditationIndex; });
/* unused harmony export getStartAccreditationIndex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getRejectedBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getNumberOfValidatedAccreditations; });
/* unused harmony export getAccreditationDataByIndex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getAccreditationDataFormatted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getAccreditationAnswer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getAccreditationsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getCurrentAccreditationGroupId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getCurrentAccreditationId; });
/* unused harmony export getAccreditationIndexById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return loadingManagedOrgs; });
/* unused harmony export getManagedOrgsData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getManagedOrgsOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getAccreditationsPerCountryData; });
/* unused harmony export loadingAccreditationsPerCountryData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getAccreditationsCountryFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getAccreditationsDomainFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getAccreditationsPerDomainData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getAccreditationRequestsPerContinentData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_notifications__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_location__ = __webpack_require__(21);
var REJECTED_BY_VALIDATORS="REJECTED_BY_VALIDATORS";var REJECTED_BY_APPLICANTS="REJECTED_BY_APPLICANTS";//- Actions
var resetAccreditationListData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('ACCREDITATION_GROUP_LIST_RESET');var onSetStartAccreditation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_START_ACCREDITATION');var setStartAccreditation=function setStartAccreditation(id){return function(dispatch,getState){var index=getAccreditationIndexById(getState(),id);dispatch(onSetStartAccreditation(index));dispatch(cleanValidatedStatus());};};var cleanStartAccreditation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAN_START_ACCREDITATION');var onSetNextAsStartAccreditation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_NEXT_AS_START_ACCREDITATION');var setNextAsStartAccreditationForValidation=function setNextAsStartAccreditationForValidation(){return function(dispatch,getState){var list=getAccreditationsData(getState());var currentPage=getCurrentPageForAccreditationsList(getState());var groupId=Object(__WEBPACK_IMPORTED_MODULE_6__account_role__["k" /* getCurrentGroup */])(getState());if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(list)&&list.length>0){var currentIndex=getCurrentAccreditationIndex(getState());if(currentIndex<list.length-1){dispatch(onSetNextAsStartAccreditation(currentIndex+1));dispatch(getAccreditationForValidation(groupId,currentPage));}else{var totalPages=getTotalPagesForAccreditationsList(getState());if(currentPage<totalPages-1){dispatch(onSetNextAsStartAccreditation(0));dispatch(getAccreditationForValidation(groupId,currentPage+1));}else{dispatch(cleanStartAccreditation());}}}};};var setNextAsStartAccreditationForReview=function setNextAsStartAccreditationForReview(){return function(dispatch,getState){var list=getAccreditationsData(getState());var currentPage=getCurrentPageForAccreditationsList(getState());var groupId=Object(__WEBPACK_IMPORTED_MODULE_6__account_role__["k" /* getCurrentGroup */])(getState());if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(list)&&list.length>0){var currentIndex=getCurrentAccreditationIndex(getState());if(currentIndex<list.length-1){dispatch(onSetNextAsStartAccreditation(currentIndex+1));dispatch(getAccreditationForReview(groupId,currentPage));}else{var totalPages=getTotalPagesForAccreditationsList(getState());if(currentPage<totalPages-1){dispatch(onSetNextAsStartAccreditation(0));dispatch(getAccreditationForReview(groupId,currentPage+1));}else{dispatch(cleanStartAccreditation());}}}};};var cleanValidatedStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAN_VALIDATED_STATUS');var incrementNumberOfValidatedAccreditations=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('NUMBER_OF_VALIDATED_ACCREDITATIONS_INCREMENT');var fetchGetAccreditationsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATIONS_FAILED');var fetchGetAccreditationsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATIONS_SUCCESS');var getAccreditationForValidation=function getAccreditationForValidation(group,page){return function(dispatch,getState){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(group)){var countryFilter=getAccreditationsCountryFilter(getState());var domainFilter=getAccreditationsDomainFilter(getState());dispatch(fetchGetAccreditationsForValidation(group,countryFilter,domainFilter,page));}};};var fetchGetAccreditationsForValidation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATIONS',function(groupId,countryFilter,domainFilter,page){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAccreditationsForValidation(groupId,countryFilter,domainFilter,page);},function(){return{apiCall:true,onSuccess:fetchGetAccreditationsSuccess,onFail:fetchGetAccreditationsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var setRejectedBy=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REJECTED_BY_SET');var getAccreditationForReview=function getAccreditationForReview(group,page){return function(dispatch,getState){var rejectedBy=getRejectedBy(getState());switch(rejectedBy){case REJECTED_BY_VALIDATORS:dispatch(getRejectedByValidatorsAccreditations(group,page));break;case REJECTED_BY_APPLICANTS:dispatch(getRejectedByApplicantsAccreditations(group,page));break;default:break;}};};var getRejectedByValidatorsAccreditations=function getRejectedByValidatorsAccreditations(group,page){return function(dispatch,getState){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(group)){var countryFilter=getAccreditationsCountryFilter(getState());var domainFilter=getAccreditationsDomainFilter(getState());dispatch(fetchGetAccreditationsForReview(group,page,true,countryFilter,domainFilter));}};};var getRejectedByApplicantsAccreditations=function getRejectedByApplicantsAccreditations(group,page){return function(dispatch,getState){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(group)){var countryFilter=getAccreditationsCountryFilter(getState());var domainFilter=getAccreditationsDomainFilter(getState());dispatch(fetchGetAccreditationsForReview(group,page,false,countryFilter,domainFilter));}};};var fetchGetAccreditationsForReview=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATIONS',function(groupId,page,isInternal,countryFilter,domainFilter){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAccreditationsForReviewByGroupId(groupId,page,isInternal,countryFilter,domainFilter);},function(){return{apiCall:true,onSuccess:fetchGetAccreditationsSuccess,onFail:fetchGetAccreditationsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var onInsertAccreditation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_INSERT_ACCREDITATION',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].insertAccreditation(data);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchInsertAccreditation=function fetchInsertAccreditation(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onInsertAccreditation(data));};};var onValidateAccreditationSuccess=function onValidateAccreditationSuccess(){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());var currentPage=getCurrentPageForAccreditationsList(getState());var groupId=Object(__WEBPACK_IMPORTED_MODULE_6__account_role__["k" /* getCurrentGroup */])(getState());dispatch(getAccreditationForValidation(groupId,currentPage));dispatch(incrementNumberOfValidatedAccreditations());};};var onValidateAccreditation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_VALIDATE_ACCREDITATION',function(accreditationId,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].validateAccreditation(accreditationId,data);},function(){return{apiCall:true,onSuccess:onValidateAccreditationSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchValidateAccreditation=function fetchValidateAccreditation(accreditationId,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onValidateAccreditation(accreditationId,data));};};var onReviewAccreditationSuccess=function onReviewAccreditationSuccess(){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());var currentPage=getCurrentPageForAccreditationsList(getState());var groupId=Object(__WEBPACK_IMPORTED_MODULE_6__account_role__["k" /* getCurrentGroup */])(getState());dispatch(getAccreditationForReview(groupId,currentPage));dispatch(incrementNumberOfValidatedAccreditations());};};var onReviewAccreditation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REVIEW_ACCREDITATION',function(accreditationId,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].reviewAccreditation(accreditationId,data);},function(){return{apiCall:true,onSuccess:onReviewAccreditationSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchReviewAccreditation=function fetchReviewAccreditation(accreditationId,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onReviewAccreditation(accreditationId,data));};};var onRemoveAccreditationSuccess=function onRemoveAccreditationSuccess(){return function(dispatch,getState){var currentPage=getCurrentPageForAccreditationsList(getState());var groupId=Object(__WEBPACK_IMPORTED_MODULE_6__account_role__["k" /* getCurrentGroup */])(getState());dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__common_notifications__["e" /* fetchGetRejectedAccreditationsNotifications */])(groupId));dispatch(getAccreditationForReview(groupId,currentPage));};};var fetchRemoveAccreditation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_ACCREDITATION',function(accreditationId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeAccreditation(accreditationId);},function(){return{apiCall:true,onSuccess:onRemoveAccreditationSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchGetManagedOrgsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_MANAGED_ORGS_SUCCESS');var fetchGetManagedOrgsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_MANAGED_ORGS_FAILED');var fetchGetManagedOrgs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_MANAGED_ORGS',function(countryCode){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getManagedOrgs(countryCode);},function(){return{apiCall:true,onSuccess:fetchGetManagedOrgsSuccess,onFail:fetchGetManagedOrgsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var clearManagedOrgs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_MANAGED_ORGS');var fetchGetAccreditationsPerCountryFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATIONS_PER_COUNTRY_FAILED');var fetchGetAccreditationsPerCountrySuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATIONS_PER_COUNTRY_SUCCESS');var fetchGetAccreditationsPerCountryForValidation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATIONS_PER_COUNTRY',function(groupId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getStaticsticsForAccreditationsForValidation(groupId);},function(){return{apiCall:true,onSuccess:fetchGetAccreditationsPerCountrySuccess,onFail:fetchGetAccreditationsPerCountryFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchGetAccreditationsPerCountryRejectedByValidators=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATIONS_PER_COUNTRY',function(groupId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getStatisticsForRejectedAccreditations(groupId,true);},function(){return{apiCall:true,onSuccess:fetchGetAccreditationsPerCountrySuccess,onFail:fetchGetAccreditationsPerCountryFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchGetAccreditationsPerCountryRejectedByApplicants=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATIONS_PER_COUNTRY',function(groupId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getStatisticsForRejectedAccreditations(groupId,false);},function(){return{apiCall:true,onSuccess:fetchGetAccreditationsPerCountrySuccess,onFail:fetchGetAccreditationsPerCountryFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var setAccreditationsCountryFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_ACCREDITATIONS_COUNTRY_FILTER');var clearAccreditationsCountryFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_ACCREDITATIONS_COUNTRY_FILTER');var onUpdateAccreditationsCountryFilterForValidation=function onUpdateAccreditationsCountryFilterForValidation(countryFilter){return function(dispatch,getState){dispatch(setAccreditationsCountryFilter(countryFilter));var groupId=Object(__WEBPACK_IMPORTED_MODULE_6__account_role__["k" /* getCurrentGroup */])(getState());dispatch(fetchGetAccreditationsForValidation(groupId,countryFilter));dispatch(fetchGetAccreditationsPerDomainForValidation(groupId,countryFilter));dispatch(clearAccreditationsDomainFilter());};};var onUpdateAccreditationsCountryFilterRejectedByValidators=function onUpdateAccreditationsCountryFilterRejectedByValidators(countryFilter){return function(dispatch,getState){dispatch(setAccreditationsCountryFilter(countryFilter));var groupId=Object(__WEBPACK_IMPORTED_MODULE_6__account_role__["k" /* getCurrentGroup */])(getState());dispatch(fetchGetAccreditationsForReview(groupId,null,true,countryFilter));dispatch(fetchGetAccreditationsPerDomainRejectedByValidators(groupId,countryFilter));dispatch(clearAccreditationsDomainFilter());};};var onUpdateAccreditationsCountryFilterRejectedByApplicants=function onUpdateAccreditationsCountryFilterRejectedByApplicants(countryFilter){return function(dispatch,getState){dispatch(setAccreditationsCountryFilter(countryFilter));var groupId=Object(__WEBPACK_IMPORTED_MODULE_6__account_role__["k" /* getCurrentGroup */])(getState());dispatch(fetchGetAccreditationsForReview(groupId,null,false,countryFilter));dispatch(fetchGetAccreditationsPerDomainRejectedByApplicants(groupId,countryFilter));dispatch(clearAccreditationsDomainFilter());};};var onFetchGetAccreditationsPerDomainForValidation=function onFetchGetAccreditationsPerDomainForValidation(groupId){return function(dispatch,getState){var countryFilter=getAccreditationsCountryFilter(getState());dispatch(fetchGetAccreditationsPerDomainForValidation(groupId,countryFilter));};};var onFetchGetAccreditationsPerDomainRejectedByValidators=function onFetchGetAccreditationsPerDomainRejectedByValidators(groupId){return function(dispatch,getState){var countryFilter=getAccreditationsCountryFilter(getState());dispatch(fetchGetAccreditationsPerDomainRejectedByValidators(groupId,countryFilter));};};var onFetchGetAccreditationsPerDomainRejectedByApplicants=function onFetchGetAccreditationsPerDomainRejectedByApplicants(groupId){return function(dispatch,getState){var countryFilter=getAccreditationsCountryFilter(getState());dispatch(fetchGetAccreditationsPerDomainRejectedByApplicants(groupId,countryFilter));};};var fetchGetAccreditationsPerDomainFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATIONS_PER_DOMAIN_FAILED');var fetchGetAccreditationsPerDomainSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATIONS_PER_DOMAIN_SUCCESS');var fetchGetAccreditationsPerDomainForValidation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATIONS_PER_DOMAIN',function(groupId,countryCode){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getStaticsticsForAccreditationsForValidation(groupId,countryCode,'DOMAIN');},function(){return{apiCall:true,onSuccess:fetchGetAccreditationsPerDomainSuccess,onFail:fetchGetAccreditationsPerDomainFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchGetAccreditationsPerDomainRejectedByValidators=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATIONS_PER_DOMAIN',function(groupId,countryCode){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getStatisticsForRejectedAccreditations(groupId,true,countryCode,'DOMAIN');},function(){return{apiCall:true,onSuccess:fetchGetAccreditationsPerDomainSuccess,onFail:fetchGetAccreditationsPerDomainFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchGetAccreditationsPerDomainRejectedByApplicants=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATIONS_PER_DOMAIN',function(groupId,countryCode){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getStatisticsForRejectedAccreditations(groupId,false,countryCode,'DOMAIN');},function(){return{apiCall:true,onSuccess:fetchGetAccreditationsPerDomainSuccess,onFail:fetchGetAccreditationsPerDomainFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var setAccreditationsDomainFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_ACCREDITATIONS_DOMAIN_FILTER');var clearAccreditationsDomainFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_ACCREDITATIONS_DOMAIN_FILTER');var onUpdateAccreditationsDomainFilterForValidation=function onUpdateAccreditationsDomainFilterForValidation(domain){return function(dispatch,getState){dispatch(setAccreditationsDomainFilter(domain));var groupId=Object(__WEBPACK_IMPORTED_MODULE_6__account_role__["k" /* getCurrentGroup */])(getState());var countryFilter=getAccreditationsCountryFilter(getState());dispatch(fetchGetAccreditationsForValidation(groupId,countryFilter,domain));};};var onUpdateAccreditationsDomainFilterRejectedByValidators=function onUpdateAccreditationsDomainFilterRejectedByValidators(domain){return function(dispatch,getState){dispatch(setAccreditationsDomainFilter(domain));var groupId=Object(__WEBPACK_IMPORTED_MODULE_6__account_role__["k" /* getCurrentGroup */])(getState());var countryFilter=getAccreditationsCountryFilter(getState());dispatch(fetchGetAccreditationsForReview(groupId,null,true,countryFilter,domain));};};var onUpdateAccreditationsDomainFilterRejectedByApplicants=function onUpdateAccreditationsDomainFilterRejectedByApplicants(domain){return function(dispatch,getState){dispatch(setAccreditationsDomainFilter(domain));var groupId=Object(__WEBPACK_IMPORTED_MODULE_6__account_role__["k" /* getCurrentGroup */])(getState());var countryFilter=getAccreditationsCountryFilter(getState());dispatch(fetchGetAccreditationsForReview(groupId,null,false,countryFilter,domain));};};//- State
var initialState={data:null,error:null,fetching:false,currentAccreditationIndex:null,validated:0,currentPage:null,totalPages:null,leftNumber:null,rejectedBy:REJECTED_BY_VALIDATORS,loadingManagedOrgs:false,managedOrgs:null,requestsPerCountry:null,fetchingRequestsPerCountry:false,countryFilter:null,requestsPerDomain:null,fetchingRequestsPerDomain:false,domainFilter:null};//- Reducers
/* harmony default export */ __webpack_exports__["h"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_ACCREDITATIONS:function FETCH_GET_ACCREDITATIONS(state){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,leftNumber:null,error:null,fetching:true});},FETCH_GET_ACCREDITATIONS_FAILED:function FETCH_GET_ACCREDITATIONS_FAILED(state,action){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,error:action.payload,fetching:false});},FETCH_GET_ACCREDITATIONS_SUCCESS:function FETCH_GET_ACCREDITATIONS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload.content,currentPage:action.payload.number,totalPages:action.payload.totalPages,leftNumber:action.payload.totalElements,error:null,fetching:false});},SET_START_ACCREDITATION:function SET_START_ACCREDITATION(state,action){return Object.assign({},state,{currentAccreditationIndex:action.payload});},SET_NEXT_AS_START_ACCREDITATION:function SET_NEXT_AS_START_ACCREDITATION(state,action){return Object.assign({},state,{currentAccreditationIndex:action.payload});},CLEAN_VALIDATED_STATUS:function CLEAN_VALIDATED_STATUS(state){return Object.assign({},state,{validated:0});},CLEAN_START_ACCREDITATION:function CLEAN_START_ACCREDITATION(state){return Object.assign({},state,{currentAccreditationIndex:null});},NUMBER_OF_VALIDATED_ACCREDITATIONS_INCREMENT:function NUMBER_OF_VALIDATED_ACCREDITATIONS_INCREMENT(state){return Object.assign({},state,{validated:state.validated+1});},ACCREDITATION_GROUP_LIST_RESET:function ACCREDITATION_GROUP_LIST_RESET(state){return Object.assign({},state,{data:null});},REJECTED_BY_SET:function REJECTED_BY_SET(state,action){return Object.assign({},state,{rejectedBy:action.payload});},FETCH_GET_MANAGED_ORGS:function FETCH_GET_MANAGED_ORGS(state){return Object.assign({},state,{loadingManagedOrgs:true});},FETCH_GET_MANAGED_ORGS_SUCCESS:function FETCH_GET_MANAGED_ORGS_SUCCESS(state,action){return Object.assign({},state,{managedOrgs:action.payload.content,loadingManagedOrgs:false});},FETCH_GET_MANAGED_ORGS_FAILED:function FETCH_GET_MANAGED_ORGS_FAILED(state){return Object.assign({},state,{managedOrgs:null,loadingManagedOrgs:false});},FETCH_GET_ACCREDITATIONS_PER_COUNTRY:function FETCH_GET_ACCREDITATIONS_PER_COUNTRY(state){return Object.assign({},state,{requestsPerCountry:null,error:null,fetchingRequestsPerCountry:true});},FETCH_GET_ACCREDITATIONS_PER_COUNTRY_FAILED:function FETCH_GET_ACCREDITATIONS_PER_COUNTRY_FAILED(state,action){return Object.assign({},state,{requestsPerCountry:null,error:action.payload,fetchingRequestsPerCountry:false});},FETCH_GET_ACCREDITATIONS_PER_COUNTRY_SUCCESS:function FETCH_GET_ACCREDITATIONS_PER_COUNTRY_SUCCESS(state,action){return Object.assign({},state,{requestsPerCountry:action.payload,error:null,fetchingRequestsPerCountry:false});},SET_ACCREDITATIONS_COUNTRY_FILTER:function SET_ACCREDITATIONS_COUNTRY_FILTER(state,action){return Object.assign({},state,{countryFilter:action.payload});},CLEAR_ACCREDITATIONS_COUNTRY_FILTER:function CLEAR_ACCREDITATIONS_COUNTRY_FILTER(state){return Object.assign({},state,{countryFilter:null});},FETCH_GET_ACCREDITATIONS_PER_DOMAIN:function FETCH_GET_ACCREDITATIONS_PER_DOMAIN(state){return Object.assign({},state,{requestsPerDomain:null,error:null,fetchingRequestsPerDomain:true});},FETCH_GET_ACCREDITATIONS_PER_DOMAIN_FAILED:function FETCH_GET_ACCREDITATIONS_PER_DOMAIN_FAILED(state,action){return Object.assign({},state,{requestsPerDomain:null,error:action.payload,fetchingRequestsPerDomain:false});},FETCH_GET_ACCREDITATIONS_PER_DOMAIN_SUCCESS:function FETCH_GET_ACCREDITATIONS_PER_DOMAIN_SUCCESS(state,action){return Object.assign({},state,{requestsPerDomain:action.payload,error:null,fetchingRequestsPerDomain:false});},SET_ACCREDITATIONS_DOMAIN_FILTER:function SET_ACCREDITATIONS_DOMAIN_FILTER(state,action){return Object.assign({},state,{domainFilter:action.payload});},CLEAR_ACCREDITATIONS_DOMAIN_FILTER:function CLEAR_ACCREDITATIONS_DOMAIN_FILTER(state){return Object.assign({},state,{domainFilter:null});},CLEAR_MANAGED_ORGS:function CLEAR_MANAGED_ORGS(state){return Object.assign({},state,{managedOrgs:null});}},initialState));//- Selectors
var getAccreditations=function getAccreditations(state){return state.accreditations;};var getAccreditationsData=function getAccreditationsData(state){return getAccreditations(state).data;};var getCurrentPageForAccreditationsList=function getCurrentPageForAccreditationsList(state){return getAccreditations(state).currentPage;};var getTotalPagesForAccreditationsList=function getTotalPagesForAccreditationsList(state){return getAccreditations(state).totalPages;};var getLeftAccreditationsNumber=function getLeftAccreditationsNumber(state){return getAccreditations(state).leftNumber;};var loadingAccreditationList=function loadingAccreditationList(state){return getAccreditations(state).fetching;};var getCurrentAccreditationIndex=function getCurrentAccreditationIndex(state){return getAccreditations(state).currentAccreditationIndex;};var getStartAccreditationIndex=function getStartAccreditationIndex(state){return getAccreditations(state).startIndex;};var getRejectedBy=function getRejectedBy(state){return getAccreditations(state).rejectedBy;};var getNumberOfValidatedAccreditations=function getNumberOfValidatedAccreditations(state){return getAccreditations(state).validated;};var getAccreditationDataByIndex=function getAccreditationDataByIndex(state,index){var data=getAccreditationsData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(index)||index<0||index>data.length-1){return null;}else{return data[index];}};var getAccreditationDataFormatted=function getAccreditationDataFormatted(state){var index=getCurrentAccreditationIndex(state);var data=getAccreditationDataByIndex(state,index);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)||!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(data,'accreditationData.titles')||!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(data,'verifiedIdentity')){return null;}var managedOrgs=getManagedOrgsData(state);var managingOrg=managedOrgs?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(managedOrgs,function(org){return org.domain===data.orgDomain;}):null;// TODO: fix warning with empty ("") email "A component is changing a controlled input of type email to be uncontrolled."
var accreditationData={titleOrig:data.accreditationData.titles.original,titleEn:data.accreditationData.titles.en,titlesAdditional:{},dateIssued:__WEBPACK_IMPORTED_MODULE_4_moment___default()(data.accreditationData.issuedAt),level:data.accreditationData.level,personFirstName:data.verifiedIdentity.firstName,personLastName:data.verifiedIdentity.lastName,personNationalId:data.verifiedIdentity.nationalId,email:data.email||"",personCountry:data.verifiedIdentity.countryCode,orgId:managingOrg?managingOrg.id:null,orgContinent:Object(__WEBPACK_IMPORTED_MODULE_8__common_location__["c" /* getContinentByCountry */])(data.orgCountryCode,state),orgCountry:data.orgCountryCode,orgDomain:data.orgDomain,fieldErrors:data.answer?data.answer.fieldErrors:null};var additionalTitles=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(data.accreditationData.titles,function(value,key){return key!=='en'&&key!=='original';});__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(additionalTitles,function(value,key){accreditationData.titlesAdditional[key]=value;});return accreditationData;};var getAccreditationAnswer=function getAccreditationAnswer(state){var index=getCurrentAccreditationIndex(state);var data=getAccreditationDataByIndex(state,index);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data.answer)){return null;}if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data.answer.fieldErrors)){data.answer.fieldErrors={};}else if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(data.answer.fieldErrors,'orgCountry.value')){data.answer.fieldErrors=Object.assign({},data.answer.fieldErrors,{orgContinent:{value:Object(__WEBPACK_IMPORTED_MODULE_8__common_location__["c" /* getContinentByCountry */])(data.answer.fieldErrors.orgCountry.value,state)}});}return data.answer;};var getAccreditationsList=function getAccreditationsList(state){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(getAccreditationsData(state))){return null;}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(getAccreditationsData(state),function(data){return{id:data.id,title:data.accreditationData.titles.original,date:__WEBPACK_IMPORTED_MODULE_4_moment___default()(data.accreditationData.issuedAt).format("L"),level:data.accreditationData.level,applicantName:data.verifiedIdentity.firstName+" "+data.verifiedIdentity.lastName,location:data.verifiedIdentity.countryCode};});};var getCurrentAccreditationGroupId=function getCurrentAccreditationGroupId(state){var index=getCurrentAccreditationIndex(state);var data=getAccreditationDataByIndex(state,index);if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return data.accreditationGroupId;}};var getCurrentAccreditationId=function getCurrentAccreditationId(state){var index=getCurrentAccreditationIndex(state);var data=getAccreditationDataByIndex(state,index);if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return data.id;}};var getAccreditationIndexById=function getAccreditationIndexById(state,id){var accreditationsList=getAccreditationsList(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(accreditationsList)){return null;}var index=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(accreditationsList,function(elem){return elem.id===id;});if(index<0){return null;}else{return index;}};var loadingManagedOrgs=function loadingManagedOrgs(state){return getAccreditations(state).loadingManagedOrgs;};var getManagedOrgsData=function getManagedOrgsData(state){return getAccreditations(state).managedOrgs;};var getManagedOrgsOptions=function getManagedOrgsOptions(state){var managedOrgs=getManagedOrgsData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(managedOrgs)){return[];}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(managedOrgs,function(org){return{value:org.id,label:org.name+' ('+org.domain+')',countryCode:org.address.countryCode};});};var getAccreditationsPerCountryData=function getAccreditationsPerCountryData(state){return getAccreditations(state).requestsPerCountry;};var loadingAccreditationsPerCountryData=function loadingAccreditationsPerCountryData(state){return getAccreditations(state).fetchingRequestsPerCountry;};var getAccreditationsCountryFilter=function getAccreditationsCountryFilter(state){return getAccreditations(state).countryFilter;};var getAccreditationsDomainFilter=function getAccreditationsDomainFilter(state){return getAccreditations(state).domainFilter;};var getAccreditationsPerDomainData=function getAccreditationsPerDomainData(state){return getAccreditations(state).requestsPerDomain;};var getAccreditationRequestsPerContinentData=function getAccreditationRequestsPerContinentData(state){var countryData=getAccreditationsPerCountryData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(countryData)){return null;}var locationData=Object(__WEBPACK_IMPORTED_MODULE_8__common_location__["g" /* getLocationData */])(state);var continentData=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(locationData,function(value,key){return{value:key,count:0};});__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(countryData,function(el){var continent=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findKey(locationData,function(countries){return countries.includes(el.value);});continentData[continent].count+=el.count;});return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(continentData);};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SubjectSubscriber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subject; });
/* unused harmony export AnonymousSubject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscription__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubjectSubscription__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_symbol_rxSubscriber__ = __webpack_require__(150);
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */







var SubjectSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__Subscriber__["a" /* Subscriber */]));

var Subject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[__WEBPACK_IMPORTED_MODULE_6__internal_symbol_rxSubscriber__["a" /* rxSubscriber */]] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return __WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Subscription */].EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return __WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Subscription */].EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new __WEBPACK_IMPORTED_MODULE_5__SubjectSubscription__["a" /* SubjectSubscription */](this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new __WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */]();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(__WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */]));

var AnonymousSubject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Subscription */].EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));

//# sourceMappingURL=Subject.js.map


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isArray; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EMPTY; });
/* harmony export (immutable) */ __webpack_exports__["b"] = empty;
/* unused harmony export emptyScheduled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

var EMPTY = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) { return subscriber.complete(); });
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
}
//# sourceMappingURL=empty.js.map


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return async; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncAction__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__ = __webpack_require__(91);
/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */


var async = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__["a" /* AsyncScheduler */](__WEBPACK_IMPORTED_MODULE_0__AsyncAction__["a" /* AsyncAction */]);
//# sourceMappingURL=async.js.map


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GRANTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REVOKED; });
/* unused harmony export onRequestCredentialsVerification */
/* unused harmony export onRequestBulkCredentialsVerification */
/* unused harmony export onRequestBulkCredentialsVerificationFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchRequestCredentialsVerification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchRequestBulkCredentialsVerification; });
/* unused harmony export setCurrentStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getRequestsByStatus; });
/* unused harmony export onGetConsentsSuccess */
/* unused harmony export fetchGetRequestsFailed */
/* unused harmony export fetchGetRequestsSuccess */
/* unused harmony export fetchGetRequestsByStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return onSetNextConsent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return incrementNumberOfProcessedConsents; });
/* unused harmony export incrementNumberOfSkippedConsents */
/* unused harmony export setNumberOfSkippedConsents */
/* unused harmony export setCurrentConsent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return startConsentsProcessing; });
/* unused harmony export cleanProcessingStatus */
/* unused harmony export getConsents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return loadingConsents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getConsentsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getConsentsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getCurrentStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCurrentPageForConsents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getTotalPagesForConsents; });
/* unused harmony export getCurrentConsentIndex */
/* unused harmony export getConsentIndexById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getLeftConsentsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getNumberOfSkippedConsents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getNumberOfProcessedConsents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCurrentConsentId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var PENDING='PENDING';var GRANTED='GRANTED';var REJECTED='REJECTED';var REVOKED='REVOKED';//- Actions
var onRequestCredentialsVerification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REQUEST_CREDENTIALS_VERIFICATION',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].requestCredentialsVerification(data);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var onRequestBulkCredentialsVerification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REQUEST_BULK_CREDENTIALS_VERIFICATION',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].requestBulkCredentialsVerification(data);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:onRequestBulkCredentialsVerificationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var onRequestBulkCredentialsVerificationFailed=function onRequestBulkCredentialsVerificationFailed(error){return function(dispatch){switch(error){case"REQUEST_BODY_INVALID":dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */])("INCORRECT_FILE_CONTENT"));break;default:dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */])(error));break;}};};var fetchRequestCredentialsVerification=function fetchRequestCredentialsVerification(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onRequestCredentialsVerification(data));};};var fetchRequestBulkCredentialsVerification=function fetchRequestBulkCredentialsVerification(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onRequestBulkCredentialsVerification(data));};};var setCurrentStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CURRENT_STATUS_SET');var getRequestsByStatus=function getRequestsByStatus(status,page){return function(dispatch){dispatch(setCurrentStatus(status));dispatch(fetchGetRequestsByStatus(status,page));};};var onGetConsentsSuccess=function onGetConsentsSuccess(data){return function(dispatch,getState){var isEmpty=data.empty;var currentPage=data.number;if(!isEmpty&&currentPage!==0||currentPage===0){dispatch(fetchGetRequestsSuccess(data));}else{dispatch(getRequestsByStatus(getCurrentStatus(getState()),currentPage-1));}};};var fetchGetRequestsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_REQUESTS_FAILED');var fetchGetRequestsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_REQUESTS_SUCCESS');var fetchGetRequestsByStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_REQUESTS_BY_STATUS',function(status,page){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getRequestsByStatus(status,page);},function(){return{apiCall:true,onSuccess:onGetConsentsSuccess,onFail:fetchGetRequestsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var onSetNextConsent=function onSetNextConsent(){return function(dispatch,getState){var list=getConsentsData(getState());var currentPage=getCurrentPageForConsents(getState());dispatch(incrementNumberOfSkippedConsents());if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(list)&&list.length>0){var currentIndex=getCurrentConsentIndex(getState());if(currentIndex<list.length-1){dispatch(setCurrentConsent(currentIndex+1));dispatch(getRequestsByStatus(PENDING,currentPage));}else{var totalPages=getTotalPagesForConsents(getState());if(currentPage<totalPages-1){dispatch(setCurrentConsent(0));dispatch(getRequestsByStatus(PENDING,currentPage+1));}else{dispatch(setCurrentConsent(null));}}}};};var incrementNumberOfProcessedConsents=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('NUMBER_OF_PROCESSED_CONSENTS_INCREMENT');var incrementNumberOfSkippedConsents=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('NUMBER_OF_SKIPPED_CONSENTS_INCREMENT');var setNumberOfSkippedConsents=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('NUMBER_OF_SKIPPED_CONSENTS_SET');var setCurrentConsent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CURRENT_CONSENT_SET',function(index){return index;});var startConsentsProcessing=function startConsentsProcessing(id){return function(dispatch,getState){var index=getConsentIndexById(getState(),id);var currentPage=getCurrentPageForConsents(getState());var skipped=currentPage*10+index;dispatch(setNumberOfSkippedConsents(skipped));dispatch(setCurrentConsent(index));dispatch(cleanProcessingStatus());};};var cleanProcessingStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('PROCESSING_STATUS_CLEAN');//- State
var initialState={currentStatus:null,data:null,error:null,fetching:false,currentPage:null,totalPages:null,currentConsentIndex:null,processed:0,leftNumber:null,skipped:0};//- Reducers
/* harmony default export */ __webpack_exports__["e"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_REQUESTS_BY_STATUS:function FETCH_GET_REQUESTS_BY_STATUS(state){return Object.assign({},state,{data:null,error:null,fetching:true,leftNumber:null,totalPages:null,currentPage:null});},FETCH_GET_REQUESTS_FAILED:function FETCH_GET_REQUESTS_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false,currentPage:null,totalPages:null});},FETCH_GET_REQUESTS_SUCCESS:function FETCH_GET_REQUESTS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload.content,error:null,fetching:false,leftNumber:action.payload.totalElements,currentPage:action.payload.number,totalPages:action.payload.totalPages});},CURRENT_STATUS_SET:function CURRENT_STATUS_SET(state,action){return Object.assign({},state,{currentStatus:action.payload});},CURRENT_CONSENT_SET:function CURRENT_CONSENT_SET(state,action){return Object.assign({},state,{currentConsentIndex:action.payload});},PROCESSING_STATUS_CLEAN:function PROCESSING_STATUS_CLEAN(state){return Object.assign({},state,{processed:0});},NUMBER_OF_SKIPPED_CONSENTS_SET:function NUMBER_OF_SKIPPED_CONSENTS_SET(state,action){return Object.assign({},state,{skipped:action.payload});},NUMBER_OF_SKIPPED_CONSENTS_INCREMENT:function NUMBER_OF_SKIPPED_CONSENTS_INCREMENT(state){return Object.assign({},state,{skipped:state.skipped+1});},NUMBER_OF_PROCESSED_CONSENTS_INCREMENT:function NUMBER_OF_PROCESSED_CONSENTS_INCREMENT(state){return Object.assign({},state,{processed:state.processed+1});}},initialState));//- Selectors
var getConsents=function getConsents(state){return state.consents;};var loadingConsents=function loadingConsents(state){return getConsents(state).fetching;};var getConsentsData=function getConsentsData(state){return getConsents(state).data;};var getConsentsList=function getConsentsList(state){return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(getConsentsData(state),function(consent){return{id:consent.id,firstName:consent.requester?consent.requester.identityAlias.firstName:null,lastName:consent.requester?consent.requester.identityAlias.lastName:null,companyName:consent.organization.name,countryCode:consent.organization.address.countryCode,email:consent.contactEmail,expireDate:consent.grantedTill,jobTitle:consent.jobDescription.title,requestDate:consent.createdAt};});};var getCurrentStatus=function getCurrentStatus(state){return getConsents(state).currentStatus;};var getCurrentPageForConsents=function getCurrentPageForConsents(state){return getConsents(state).currentPage;};var getTotalPagesForConsents=function getTotalPagesForConsents(state){return getConsents(state).totalPages;};var getCurrentConsentIndex=function getCurrentConsentIndex(state){return getConsents(state).currentConsentIndex;};var getConsentIndexById=function getConsentIndexById(state,id){var data=getConsentsData(state);if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(data)){return null;}var index=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(data,function(consent){return consent.id===id;});if(index<0){return null;}return index;};var getLeftConsentsNumber=function getLeftConsentsNumber(state){return getConsents(state).leftNumber;};var getNumberOfSkippedConsents=function getNumberOfSkippedConsents(state){return getConsents(state).skipped;};var getNumberOfProcessedConsents=function getNumberOfProcessedConsents(state){return getConsents(state).processed;};var getCurrentConsentId=function getCurrentConsentId(state){var index=getCurrentConsentIndex(state);var ids=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(getConsentsData(state),function(org){return org.id;});if(index>=ids.length){return null;}return ids[index];};

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CalendarContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_popper__ = __webpack_require__(779);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};









var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function generateYears(year, noOfYear, minDate, maxDate) {
  var list = [];
  for (var i = 0; i < 2 * noOfYear + 1; i++) {
    var newYear = year + noOfYear - i;
    var isInRange = true;

    if (minDate) {
      isInRange = minDate.year() <= newYear;
    }

    if (maxDate && isInRange) {
      isInRange = maxDate.year() >= newYear;
    }

    if (isInRange) {
      list.push(newYear);
    }
  }

  return list;
}

var YearDropdownOptions = function (_React$Component) {
  inherits(YearDropdownOptions, _React$Component);

  function YearDropdownOptions(props) {
    classCallCheck(this, YearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      var selectedYear = _this.props.year;
      var options = _this.state.yearsList.map(function (year) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
            key: year,
            ref: year,
            onClick: _this.onChange.bind(_this, year)
          },
          selectedYear === year ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__year-option--selected" },
            "\u2713"
          ) : "",
          year
        );
      });

      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;

      if (!maxYear || !_this.state.yearsList.find(function (year) {
        return year === maxYear;
      })) {
        options.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "upcoming",
            key: "upcoming",
            onClick: _this.incrementYears
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        ));
      }

      if (!minYear || !_this.state.yearsList.find(function (year) {
        return year === minYear;
      })) {
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "previous",
            key: "previous",
            onClick: _this.decrementYears
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        ));
      }

      return options;
    };

    _this.onChange = function (year) {
      _this.props.onChange(year);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.shiftYears = function (amount) {
      var years = _this.state.yearsList.map(function (year) {
        return year + amount;
      });

      _this.setState({
        yearsList: years
      });
    };

    _this.incrementYears = function () {
      return _this.shiftYears(1);
    };

    _this.decrementYears = function () {
      return _this.shiftYears(-1);
    };

    var yearDropdownItemNumber = props.yearDropdownItemNumber,
        scrollableYearDropdown = props.scrollableYearDropdown;

    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);

    _this.state = {
      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  YearDropdownOptions.prototype.render = function render() {
    var dropdownClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      "react-datepicker__year-dropdown": true,
      "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return YearDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

YearDropdownOptions.propTypes = {
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  year: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var dayOfWeekCodes = {
  1: "mon",
  2: "tue",
  3: "wed",
  4: "thu",
  5: "fri",
  6: "sat",
  7: "sun"
};

// These functions are not exported so
// that we avoid magic strings like 'days'
function set$1(date, unit, to) {
  return date.set(unit, to);
}

function add(date, amount, unit) {
  return date.add(amount, unit);
}

function subtract(date, amount, unit) {
  return date.subtract(amount, unit);
}

function get$1(date, unit) {
  return date.get(unit);
}

function getStartOf(date, unit) {
  return date.startOf(unit);
}

// ** Date Constructors **

function newDate(point) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()(point);
}

function newDateWithOffset(utcOffset) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()().utc().utcOffset(utcOffset);
}

function now(maybeFixedUtcOffset) {
  if (maybeFixedUtcOffset == null) {
    return newDate();
  }
  return newDateWithOffset(maybeFixedUtcOffset);
}

function cloneDate(date) {
  return date.clone();
}

function parseDate(value, _ref) {
  var dateFormat = _ref.dateFormat,
      locale = _ref.locale;

  var m = __WEBPACK_IMPORTED_MODULE_4_moment___default()(value, dateFormat, locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale(), true);
  return m.isValid() ? m : null;
}

// ** Date "Reflection" **

function isMoment(date) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.isMoment(date);
}

function isDate(date) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.isDate(date);
}

// ** Date Formatting **

function formatDate(date, format) {
  return date.format(format);
}

function safeDateFormat(date, _ref2) {
  var dateFormat = _ref2.dateFormat,
      locale = _ref2.locale;

  return date && date.clone().locale(locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || "";
}

// ** Date Setters **

function setTime(date, _ref3) {
  var hour = _ref3.hour,
      minute = _ref3.minute,
      second = _ref3.second;

  date.set({ hour: hour, minute: minute, second: second });
  return date;
}

function setMonth(date, month) {
  return set$1(date, "month", month);
}

function setYear(date, year) {
  return set$1(date, "year", year);
}



// ** Date Getters **

function getSecond(date) {
  return get$1(date, "second");
}

function getMinute(date) {
  return get$1(date, "minute");
}

function getHour(date) {
  return get$1(date, "hour");
}

// Returns day of week
function getDay(date) {
  return get$1(date, "day");
}

function getWeek(date) {
  return get$1(date, "week");
}

function getMonth(date) {
  return get$1(date, "month");
}

function getYear(date) {
  return get$1(date, "year");
}

// Returns day of month
function getDate(date) {
  return get$1(date, "date");
}



function getDayOfWeekCode(day) {
  return dayOfWeekCodes[day.isoWeekday()];
}

// *** Start of ***

function getStartOfDay(date) {
  return getStartOf(date, "day");
}

function getStartOfWeek(date) {
  return getStartOf(date, "week");
}
function getStartOfMonth(date) {
  return getStartOf(date, "month");
}

function getStartOfDate(date) {
  return getStartOf(date, "date");
}

// *** End of ***





// ** Date Math **

// *** Addition ***

function addMinutes(date, amount) {
  return add(date, amount, "minutes");
}

function addHours(date, amount) {
  return add(date, amount, "hours");
}

function addDays(date, amount) {
  return add(date, amount, "days");
}

function addWeeks(date, amount) {
  return add(date, amount, "weeks");
}

function addMonths(date, amount) {
  return add(date, amount, "months");
}

function addYears(date, amount) {
  return add(date, amount, "years");
}

// *** Subtraction ***
function subtractDays(date, amount) {
  return subtract(date, amount, "days");
}

function subtractWeeks(date, amount) {
  return subtract(date, amount, "weeks");
}

function subtractMonths(date, amount) {
  return subtract(date, amount, "months");
}

function subtractYears(date, amount) {
  return subtract(date, amount, "years");
}

// ** Date Comparison **

function isBefore(date1, date2) {
  return date1.isBefore(date2);
}

function isAfter(date1, date2) {
  return date1.isAfter(date2);
}

function equals(date1, date2) {
  return date1.isSame(date2);
}

function isSameYear(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "year");
  } else {
    return !date1 && !date2;
  }
}

function isSameMonth(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "month");
  } else {
    return !date1 && !date2;
  }
}

function isSameDay(moment1, moment2) {
  if (moment1 && moment2) {
    return moment1.isSame(moment2, "day");
  } else {
    return !moment1 && !moment2;
  }
}



function isDayInRange(day, startDate, endDate) {
  var before = startDate.clone().startOf("day").subtract(1, "seconds");
  var after = endDate.clone().startOf("day").add(1, "seconds");
  return day.clone().startOf("day").isBetween(before, after);
}

// *** Diffing ***



// ** Date Localization **

function localizeDate(date, locale) {
  return date.clone().locale(locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale());
}







function getLocaleData(date) {
  return date.localeData();
}

function getLocaleDataForLocale(locale) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.localeData(locale);
}

function getFormattedWeekdayInLocale(locale, date, formatFunc) {
  return formatFunc(locale.weekdays(date));
}

function getWeekdayMinInLocale(locale, date) {
  return locale.weekdaysMin(date);
}

function getWeekdayShortInLocale(locale, date) {
  return locale.weekdaysShort(date);
}

// TODO what is this format exactly?
function getMonthInLocale(locale, date, format) {
  return locale.months(date, format);
}

function getMonthShortInLocale(locale, date) {
  return locale.monthsShort(date);
}

// ** Utils for some components **

function isDayDisabled(day) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      minDate = _ref4.minDate,
      maxDate = _ref4.maxDate,
      excludeDates = _ref4.excludeDates,
      includeDates = _ref4.includeDates,
      filterDate = _ref4.filterDate;

  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day") || excludeDates && excludeDates.some(function (excludeDate) {
    return isSameDay(day, excludeDate);
  }) || includeDates && !includeDates.some(function (includeDate) {
    return isSameDay(day, includeDate);
  }) || filterDate && !filterDate(day.clone()) || false;
}

function isTimeDisabled(time, disabledTimes) {
  var l = disabledTimes.length;
  for (var i = 0; i < l; i++) {
    if (disabledTimes[i].get("hours") === time.get("hours") && disabledTimes[i].get("minutes") === time.get("minutes")) {
      return true;
    }
  }

  return false;
}

function isTimeInDisabledRange(time, _ref5) {
  var minTime = _ref5.minTime,
      maxTime = _ref5.maxTime;

  if (!minTime || !maxTime) {
    throw new Error("Both minTime and maxTime props required");
  }

  var base = __WEBPACK_IMPORTED_MODULE_4_moment___default()().hours(0).minutes(0).seconds(0);
  var baseTime = base.clone().hours(time.get("hours")).minutes(time.get("minutes"));
  var min = base.clone().hours(minTime.get("hours")).minutes(minTime.get("minutes"));
  var max = base.clone().hours(maxTime.get("hours")).minutes(maxTime.get("minutes"));

  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
}

function allDaysDisabledBefore(day, unit) {
  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      minDate = _ref6.minDate,
      includeDates = _ref6.includeDates;

  var dateBefore = day.clone().subtract(1, unit);
  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateBefore.isBefore(includeDate, unit);
  }) || false;
}

function allDaysDisabledAfter(day, unit) {
  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      maxDate = _ref7.maxDate,
      includeDates = _ref7.includeDates;

  var dateAfter = day.clone().add(1, unit);
  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateAfter.isAfter(includeDate, unit);
  }) || false;
}

function getEffectiveMinDate(_ref8) {
  var minDate = _ref8.minDate,
      includeDates = _ref8.includeDates;

  if (includeDates && minDate) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.min(includeDates.filter(function (includeDate) {
      return minDate.isSameOrBefore(includeDate, "day");
    }));
  } else if (includeDates) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.min(includeDates);
  } else {
    return minDate;
  }
}

function getEffectiveMaxDate(_ref9) {
  var maxDate = _ref9.maxDate,
      includeDates = _ref9.includeDates;

  if (includeDates && maxDate) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.max(includeDates.filter(function (includeDate) {
      return maxDate.isSameOrAfter(includeDate, "day");
    }));
  } else if (includeDates) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.max(includeDates);
  } else {
    return maxDate;
  }
}

function getHightLightDaysMap() {
  var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";

  var dateClasses = new Map();
  for (var i = 0, len = highlightDates.length; i < len; i++) {
    var obj = highlightDates[i];
    if (isMoment(obj)) {
      var key = obj.format("MM.DD.YYYY");
      var classNamesArr = dateClasses.get(key) || [];
      if (!classNamesArr.includes(defaultClassName)) {
        classNamesArr.push(defaultClassName);
        dateClasses.set(key, classNamesArr);
      }
    } else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") {
      var keys = Object.keys(obj);
      var className = keys[0];
      var arrOfMoments = obj[keys[0]];
      if (typeof className === "string" && arrOfMoments.constructor === Array) {
        for (var k = 0, _len = arrOfMoments.length; k < _len; k++) {
          var _key = arrOfMoments[k].format("MM.DD.YYYY");
          var _classNamesArr = dateClasses.get(_key) || [];
          if (!_classNamesArr.includes(className)) {
            _classNamesArr.push(className);
            dateClasses.set(_key, _classNamesArr);
          }
        }
      }
    }
  }

  return dateClasses;
}

function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
  var l = injectedTimes.length;
  var times = [];
  for (var i = 0; i < l; i++) {
    var injectedTime = addMinutes(addHours(cloneDate(startOfDay), getHour(injectedTimes[i])), getMinute(injectedTimes[i]));
    var nextTime = addMinutes(cloneDate(startOfDay), (currentMultiplier + 1) * intervals);

    if (injectedTime.isBetween(currentTime, nextTime)) {
      times.push(injectedTimes[i]);
    }
  }

  return times;
}

var WrappedYearDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(YearDropdownOptions);

var YearDropdown = function (_React$Component) {
  inherits(YearDropdown, _React$Component);

  function YearDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, YearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;

      var options = [];
      for (var i = minYear; i <= maxYear; i++) {
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: i, value: i },
          i
        ));
      }
      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: _this.props.year,
          className: "react-datepicker__year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__year-read-view--selected-year" },
          _this.props.year
        )
      );
    }, _this.renderDropdown = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        year: _this.props.year,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (year) {
      _this.toggleDropdown();
      if (year === _this.props.year) return;
      _this.props.onChange(year);
    }, _this.toggleDropdown = function (event) {
      _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      }, function () {
        if (_this.props.adjustDateOnChange) {
          _this.handleYearChange(_this.props.date, event);
        }
      });
    }, _this.handleYearChange = function (date, event) {
      _this.onSelect(date, event);
      _this.setOpen();
    }, _this.onSelect = function (date, event) {
      if (_this.props.onSelect) {
        _this.props.onSelect(date, event);
      }
    }, _this.setOpen = function () {
      if (_this.props.setOpen) {
        _this.props.setOpen(true);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  YearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return YearDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

YearDropdown.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  year: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var MonthDropdownOptions = function (_React$Component) {
  inherits(MonthDropdownOptions, _React$Component);

  function MonthDropdownOptions() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthDropdownOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
      return _this.props.monthNames.map(function (month, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
            key: month,
            ref: month,
            onClick: _this.onChange.bind(_this, i)
          },
          _this.props.month === i ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__month-option--selected" },
            "\u2713"
          ) : "",
          month
        );
      });
    }, _this.onChange = function (month) {
      return _this.props.onChange(month);
    }, _this.handleClickOutside = function () {
      return _this.props.onCancel();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdownOptions.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "react-datepicker__month-dropdown" },
      this.renderOptions()
    );
  };

  return MonthDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthDropdownOptions.propTypes = {
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  monthNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired).isRequired
};

var WrappedMonthDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(MonthDropdownOptions);

var MonthDropdown = function (_React$Component) {
  inherits(MonthDropdown, _React$Component);

  function MonthDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function (monthNames) {
      return monthNames.map(function (M, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: i, value: i },
          M
        );
      });
    }, _this.renderSelectMode = function (monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: _this.props.month,
          className: "react-datepicker__month-select",
          onChange: function onChange(e) {
            return _this.onChange(e.target.value);
          }
        },
        _this.renderSelectOptions(monthNames)
      );
    }, _this.renderReadView = function (visible, monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-read-view",
          onClick: _this.toggleDropdown
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__month-read-view--selected-month" },
          monthNames[_this.props.month]
        )
      );
    }, _this.renderDropdown = function (monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedMonthDropdownOptions, {
        key: "dropdown",
        ref: "options",
        month: _this.props.month,
        monthNames: monthNames,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown
      });
    }, _this.renderScrollMode = function (monthNames) {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown(monthNames));
      }
      return result;
    }, _this.onChange = function (month) {
      _this.toggleDropdown();
      if (month !== _this.props.month) {
        _this.props.onChange(month);
      }
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdown.prototype.render = function render() {
    var _this2 = this;

    var localeData = getLocaleDataForLocale(this.props.locale);
    var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
      return getMonthShortInLocale(localeData, newDate({ M: M }));
    } : function (M) {
      return getMonthInLocale(localeData, newDate({ M: M }), _this2.props.dateFormat);
    });

    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode(monthNames);
        break;
      case "select":
        renderedDropdown = this.renderSelectMode(monthNames);
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthDropdown.propTypes = {
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function generateMonthYears(minDate, maxDate) {
  var list = [];

  var currDate = getStartOfMonth(cloneDate(minDate));
  var lastDate = getStartOfMonth(cloneDate(maxDate));

  while (!isAfter(currDate, lastDate)) {
    list.push(cloneDate(currDate));

    addMonths(currDate, 1);
  }

  return list;
}

var MonthYearDropdownOptions = function (_React$Component) {
  inherits(MonthYearDropdownOptions, _React$Component);

  function MonthYearDropdownOptions(props) {
    classCallCheck(this, MonthYearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      return _this.state.monthYearsList.map(function (monthYear) {
        var monthYearPoint = monthYear.valueOf();

        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
            key: monthYearPoint,
            ref: monthYearPoint,
            onClick: _this.onChange.bind(_this, monthYearPoint)
          },
          isSameMonthYear ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__month-year-option--selected" },
            "\u2713"
          ) : "",
          formatDate(monthYear, _this.props.dateFormat)
        );
      });
    };

    _this.onChange = function (monthYear) {
      return _this.props.onChange(monthYear);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.state = {
      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  MonthYearDropdownOptions.prototype.render = function render() {
    var dropdownClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      "react-datepicker__month-year-dropdown": true,
      "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return MonthYearDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthYearDropdownOptions.propTypes = {
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var WrappedMonthYearDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(MonthYearDropdownOptions);

var MonthYearDropdown = function (_React$Component) {
  inherits(MonthYearDropdown, _React$Component);

  function MonthYearDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthYearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var currDate = getStartOfMonth(localizeDate(_this.props.minDate, _this.props.locale));
      var lastDate = getStartOfMonth(localizeDate(_this.props.maxDate, _this.props.locale));

      var options = [];

      while (!isAfter(currDate, lastDate)) {
        var timepoint = currDate.valueOf();
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: timepoint, value: timepoint },
          formatDate(currDate, _this.props.dateFormat)
        ));

        addMonths(currDate, 1);
      }

      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: getStartOfMonth(_this.props.date).valueOf(),
          className: "react-datepicker__month-year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      var yearMonth = formatDate(localizeDate(newDate(_this.props.date), _this.props.locale), _this.props.dateFormat);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__month-year-read-view--selected-month-year" },
          yearMonth
        )
      );
    }, _this.renderDropdown = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedMonthYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        date: _this.props.date,
        dateFormat: _this.props.dateFormat,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: localizeDate(_this.props.minDate, _this.props.locale),
        maxDate: localizeDate(_this.props.maxDate, _this.props.locale),
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (monthYearPoint) {
      _this.toggleDropdown();

      var changedDate = newDate(parseInt(monthYearPoint));

      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
        return;
      }

      _this.props.onChange(changedDate);
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthYearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthYearDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthYearDropdown.propTypes = {
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Day = function (_React$Component) {
  inherits(Day, _React$Component);

  function Day() {
    var _temp, _this, _ret;

    classCallCheck(this, Day);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (!_this.isDisabled() && _this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _this.handleMouseEnter = function (event) {
      if (!_this.isDisabled() && _this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.isSameDay = function (other) {
      return isSameDay(_this.props.day, other);
    }, _this.isKeyboardSelected = function () {
      return !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
    }, _this.isDisabled = function () {
      return isDayDisabled(_this.props.day, _this.props);
    }, _this.getHighLightedClass = function (defaultClassName) {
      var _this$props = _this.props,
          day = _this$props.day,
          highlightDates = _this$props.highlightDates;


      if (!highlightDates) {
        return false;
      }

      // Looking for className in the Map of {'day string, 'className'}
      var dayStr = day.format("MM.DD.YYYY");
      return highlightDates.get(dayStr);
    }, _this.isInRange = function () {
      var _this$props2 = _this.props,
          day = _this$props2.day,
          startDate = _this$props2.startDate,
          endDate = _this$props2.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isDayInRange(day, startDate, endDate);
    }, _this.isInSelectingRange = function () {
      var _this$props3 = _this.props,
          day = _this$props3.day,
          selectsStart = _this$props3.selectsStart,
          selectsEnd = _this$props3.selectsEnd,
          selectingDate = _this$props3.selectingDate,
          startDate = _this$props3.startDate,
          endDate = _this$props3.endDate;


      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
        return false;
      }

      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
        return isDayInRange(day, selectingDate, endDate);
      }

      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
        return isDayInRange(day, startDate, selectingDate);
      }

      return false;
    }, _this.isSelectingRangeStart = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props4 = _this.props,
          day = _this$props4.day,
          selectingDate = _this$props4.selectingDate,
          startDate = _this$props4.startDate,
          selectsStart = _this$props4.selectsStart;


      if (selectsStart) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, startDate);
      }
    }, _this.isSelectingRangeEnd = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props5 = _this.props,
          day = _this$props5.day,
          selectingDate = _this$props5.selectingDate,
          endDate = _this$props5.endDate,
          selectsEnd = _this$props5.selectsEnd;


      if (selectsEnd) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, endDate);
      }
    }, _this.isRangeStart = function () {
      var _this$props6 = _this.props,
          day = _this$props6.day,
          startDate = _this$props6.startDate,
          endDate = _this$props6.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(startDate, day);
    }, _this.isRangeEnd = function () {
      var _this$props7 = _this.props,
          day = _this$props7.day,
          startDate = _this$props7.startDate,
          endDate = _this$props7.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(endDate, day);
    }, _this.isWeekend = function () {
      var weekday = getDay(_this.props.day);
      return weekday === 0 || weekday === 6;
    }, _this.isOutsideMonth = function () {
      return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
    }, _this.getClassNames = function (date) {
      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
        "react-datepicker__day--disabled": _this.isDisabled(),
        "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
        "react-datepicker__day--range-start": _this.isRangeStart(),
        "react-datepicker__day--range-end": _this.isRangeEnd(),
        "react-datepicker__day--in-range": _this.isInRange(),
        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
        "react-datepicker__day--today": _this.isSameDay(now(_this.props.utcOffset)),
        "react-datepicker__day--weekend": _this.isWeekend(),
        "react-datepicker__day--outside-month": _this.isOutsideMonth()
      }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Day.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: this.getClassNames(this.props.day),
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        "aria-label": "day-" + getDate(this.props.day),
        role: "option"
      },
      getDate(this.props.day)
    );
  };

  return Day;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Day.propTypes = {
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var WeekNumber = function (_React$Component) {
  inherits(WeekNumber, _React$Component);

  function WeekNumber() {
    var _temp, _this, _ret;

    classCallCheck(this, WeekNumber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  WeekNumber.prototype.render = function render() {
    var weekNumberClasses = {
      "react-datepicker__week-number": true,
      "react-datepicker__week-number--clickable": !!this.props.onClick
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(weekNumberClasses),
        "aria-label": "week-" + this.props.weekNumber,
        onClick: this.handleClick
      },
      this.props.weekNumber
    );
  };

  return WeekNumber;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

WeekNumber.propTypes = {
  weekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var Week = function (_React$Component) {
  inherits(Week, _React$Component);

  function Week() {
    var _temp, _this, _ret;

    classCallCheck(this, Week);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleWeekClick = function (day, weekNumber, event) {
      if (typeof _this.props.onWeekSelect === "function") {
        _this.props.onWeekSelect(day, weekNumber, event);
      }
    }, _this.formatWeekNumber = function (startOfWeek) {
      if (_this.props.formatWeekNumber) {
        return _this.props.formatWeekNumber(startOfWeek);
      }
      return getWeek(startOfWeek);
    }, _this.renderDays = function () {
      var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
      var days = [];
      var weekNumber = _this.formatWeekNumber(startOfWeek);
      if (_this.props.showWeekNumber) {
        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
        days.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeekNumber, { key: "W", weekNumber: weekNumber, onClick: onClickAction }));
      }
      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Day, {
          key: offset,
          day: day,
          month: _this.props.month,
          onClick: _this.handleDayClick.bind(_this, day),
          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset
        });
      }));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Week.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "react-datepicker__week" },
      this.renderDays()
    );
  };

  return Week;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Week.propTypes = {
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onDayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDayMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;

var Month = function (_React$Component) {
  inherits(Month, _React$Component);

  function Month() {
    var _temp, _this, _ret;

    classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleMouseLeave = function () {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave();
      }
    }, _this.isWeekInMonth = function (startOfWeek) {
      var day = _this.props.day;
      var endOfWeek = addDays(cloneDate(startOfWeek), 6);
      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
    }, _this.renderWeeks = function () {
      var weeks = [];
      var isFixedHeight = _this.props.fixedHeight;
      var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
      var i = 0;
      var breakAfterNextPush = false;

      while (true) {
        weeks.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Week, {
          key: i,
          day: currentWeekStart,
          month: getMonth(_this.props.day),
          onDayClick: _this.handleDayClick,
          onDayMouseEnter: _this.handleDayMouseEnter,
          onWeekSelect: _this.props.onWeekSelect,
          formatWeekNumber: _this.props.formatWeekNumber,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          showWeekNumber: _this.props.showWeekNumbers,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset
        }));

        if (breakAfterNextPush) break;

        i++;
        currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);

        // If one of these conditions is true, we will either break on this week
        // or break on the next week
        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);

        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
          if (_this.props.peekNextMonth) {
            breakAfterNextPush = true;
          } else {
            break;
          }
        }
      }

      return weeks;
    }, _this.getClassNames = function () {
      var _this$props = _this.props,
          selectingDate = _this$props.selectingDate,
          selectsStart = _this$props.selectsStart,
          selectsEnd = _this$props.selectsEnd;

      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker__month", {
        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Month.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: this.getClassNames(),
        onMouseLeave: this.handleMouseLeave,
        role: "listbox"
      },
      this.renderWeeks()
    );
  };

  return Month;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Month.propTypes = {
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onDayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDayMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var Time = function (_React$Component) {
  inherits(Time, _React$Component);

  function Time() {
    var _temp, _this, _ret;

    classCallCheck(this, Time);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        return;
      }

      _this.props.onChange(time);
    }, _this.liClasses = function (time, currH, currM) {
      var classes = ["react-datepicker__time-list-item"];

      if (currH === getHour(time) && currM === getMinute(time)) {
        classes.push("react-datepicker__time-list-item--selected");
      }
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        classes.push("react-datepicker__time-list-item--disabled");
      }
      if (_this.props.injectTimes && (getHour(time) * 60 + getMinute(time)) % _this.props.intervals !== 0) {
        classes.push("react-datepicker__time-list-item--injected");
      }

      return classes.join(" ");
    }, _this.renderTimes = function () {
      var times = [];
      var format = _this.props.format ? _this.props.format : "hh:mm A";
      var intervals = _this.props.intervals;
      var activeTime = _this.props.selected ? _this.props.selected : newDate();
      var currH = getHour(activeTime);
      var currM = getMinute(activeTime);
      var base = getStartOfDay(newDate());
      var multiplier = 1440 / intervals;
      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
        return a - b;
      });
      for (var i = 0; i < multiplier; i++) {
        var currentTime = addMinutes(cloneDate(base), i * intervals);
        times.push(currentTime);

        if (sortedInjectTimes) {
          var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
          times = times.concat(timesToInject);
        }
      }

      return times.map(function (time, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          {
            key: i,
            onClick: _this.handleClick.bind(_this, time),
            className: _this.liClasses(time, currH, currM)
          },
          formatDate(time, format)
        );
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Time.prototype.componentDidMount = function componentDidMount() {
    // code to ensure selected time will always be in focus within time window when it first appears
    var multiplier = 60 / this.props.intervals;
    var currH = this.props.selected ? getHour(this.props.selected) : getHour(newDate());
    this.list.scrollTop = 30 * (multiplier * currH);
  };

  Time.prototype.render = function render() {
    var _this2 = this;

    var height = null;
    if (this.props.monthRef) {
      height = this.props.monthRef.clientHeight - 39;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__header react-datepicker__header--time" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker-time__header" },
          this.props.timeCaption
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__time" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__time-box" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "ul",
            {
              className: "react-datepicker__time-list",
              ref: function ref(list) {
                _this2.list = list;
              },
              style: height ? { height: height } : {}
            },
            this.renderTimes.bind(this)()
          )
        )
      )
    );
  };

  createClass(Time, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        intervals: 30,
        onTimeChange: function onTimeChange() {},
        todayButton: null,
        timeCaption: "Time"
      };
    }
  }]);
  return Time;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Time.propTypes = {
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  intervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  monthRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

function CalendarContainer(_ref) {
  var className = _ref.className,
      children = _ref.children;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "react-datepicker__triangle" }),
    children
  );
}

CalendarContainer.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];

var isDropdownSelect = function isDropdownSelect() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var classNames = (element.className || "").split(/\s+/);
  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
    return classNames.indexOf(testClassname) >= 0;
  });
};

var Calendar = function (_React$Component) {
  inherits(Calendar, _React$Component);
  createClass(Calendar, null, [{
    key: "defaultProps",
    get: function get$$1() {
      var _ref;

      return _ref = {
        onDropdownFocus: function onDropdownFocus() {},
        monthsShown: 1,
        forceShowMonthNavigation: false,
        timeCaption: "Time",
        previousMonthButtonLabel: "Previous Month"
      }, _ref["previousMonthButtonLabel"] = "Next Month", _ref;
    }
  }]);

  function Calendar(props) {
    classCallCheck(this, Calendar);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleClickOutside = function (event) {
      _this.props.onClickOutside(event);
    };

    _this.handleDropdownFocus = function (event) {
      if (isDropdownSelect(event.target)) {
        _this.props.onDropdownFocus();
      }
    };

    _this.getDateInView = function () {
      var _this$props = _this.props,
          preSelection = _this$props.preSelection,
          selected = _this$props.selected,
          openToDate = _this$props.openToDate,
          utcOffset = _this$props.utcOffset;

      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var current = now(utcOffset);
      var initialDate = openToDate || selected || preSelection;
      if (initialDate) {
        return initialDate;
      } else {
        if (minDate && isBefore(current, minDate)) {
          return minDate;
        } else if (maxDate && isAfter(current, maxDate)) {
          return maxDate;
        }
      }
      return current;
    };

    _this.localizeDate = function (date) {
      return localizeDate(date, _this.props.locale);
    };

    _this.increaseMonth = function () {
      _this.setState({
        date: addMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.decreaseMonth = function () {
      _this.setState({
        date: subtractMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.handleDayClick = function (day, event) {
      return _this.props.onSelect(day, event);
    };

    _this.handleDayMouseEnter = function (day) {
      return _this.setState({ selectingDate: day });
    };

    _this.handleMonthMouseLeave = function () {
      return _this.setState({ selectingDate: null });
    };

    _this.handleYearChange = function (date) {
      if (_this.props.onYearChange) {
        _this.props.onYearChange(date);
      }
    };

    _this.handleMonthChange = function (date) {
      if (_this.props.onMonthChange) {
        _this.props.onMonthChange(date);
      }
      if (_this.props.adjustDateOnChange) {
        if (_this.props.onSelect) {
          _this.props.onSelect(date);
        }
        if (_this.props.setOpen) {
          _this.props.setOpen(true);
        }
      }
    };

    _this.handleMonthYearChange = function (date) {
      _this.handleYearChange(date);
      _this.handleMonthChange(date);
    };

    _this.changeYear = function (year) {
      _this.setState({
        date: setYear(cloneDate(_this.state.date), year)
      }, function () {
        return _this.handleYearChange(_this.state.date);
      });
    };

    _this.changeMonth = function (month) {
      _this.setState({
        date: setMonth(cloneDate(_this.state.date), month)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.changeMonthYear = function (monthYear) {
      _this.setState({
        date: setYear(setMonth(cloneDate(_this.state.date), getMonth(monthYear)), getYear(monthYear))
      }, function () {
        return _this.handleMonthYearChange(_this.state.date);
      });
    };

    _this.header = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var startOfWeek = getStartOfWeek(cloneDate(date));
      var dayNames = [];
      if (_this.props.showWeekNumbers) {
        dayNames.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: "W", className: "react-datepicker__day-name" },
          _this.props.weekLabel || "#"
        ));
      }
      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        var localeData = getLocaleData(day);
        var weekDayName = _this.formatWeekday(localeData, day);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: offset, className: "react-datepicker__day-name" },
          weekDayName
        );
      }));
    };

    _this.formatWeekday = function (localeData, day) {
      if (_this.props.formatWeekDay) {
        return getFormattedWeekdayInLocale(localeData, day, _this.props.formatWeekDay);
      }
      return _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
    };

    _this.renderPreviousMonthButton = function () {
      var allPrevDaysDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];

      var clickHandler = _this.decreaseMonth;

      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--previous--disabled");
        clickHandler = null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        },
        _this.props.previousMonthButtonLabel
      );
    };

    _this.renderNextMonthButton = function () {
      var allNextDaysDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
      if (_this.props.showTimeSelect) {
        classes.push("react-datepicker__navigation--next--with-time");
      }
      if (_this.props.todayButton) {
        classes.push("react-datepicker__navigation--next--with-today-button");
      }

      var clickHandler = _this.increaseMonth;

      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--next--disabled");
        clickHandler = null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        },
        _this.props.nextMonthButtonLabel
      );
    };

    _this.renderCurrentMonth = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var classes = ["react-datepicker__current-month"];

      if (_this.props.showYearDropdown) {
        classes.push("react-datepicker__current-month--hasYearDropdown");
      }
      if (_this.props.showMonthDropdown) {
        classes.push("react-datepicker__current-month--hasMonthDropdown");
      }
      if (_this.props.showMonthYearDropdown) {
        classes.push("react-datepicker__current-month--hasMonthYearDropdown");
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: classes.join(" ") },
        formatDate(date, _this.props.dateFormat)
      );
    };

    _this.renderYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showYearDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(YearDropdown, {
        adjustDateOnChange: _this.props.adjustDateOnChange,
        date: _this.state.date,
        onSelect: _this.props.onSelect,
        setOpen: _this.props.setOpen,
        dropdownMode: _this.props.dropdownMode,
        onChange: _this.changeYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        year: getYear(_this.state.date),
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    };

    _this.renderMonthDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MonthDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonth,
        month: getMonth(_this.state.date),
        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
      });
    };

    _this.renderMonthYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthYearDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MonthYearDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonthYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        date: _this.state.date,
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    };

    _this.renderTodayButton = function () {
      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "react-datepicker__today-button",
          onClick: function onClick(e) {
            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
          }
        },
        _this.props.todayButton
      );
    };

    _this.renderMonths = function () {
      if (_this.props.showTimeSelectOnly) {
        return;
      }

      var monthList = [];
      for (var i = 0; i < _this.props.monthsShown; ++i) {
        var monthDate = addMonths(cloneDate(_this.state.date), i);
        var monthKey = "month-" + i;
        monthList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            key: monthKey,
            ref: function ref(div) {
              _this.monthContainer = div;
            },
            className: "react-datepicker__month-container"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "react-datepicker__header" },
            _this.renderCurrentMonth(monthDate),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
                onFocus: _this.handleDropdownFocus
              },
              _this.renderMonthDropdown(i !== 0),
              _this.renderMonthYearDropdown(i !== 0),
              _this.renderYearDropdown(i !== 0)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "react-datepicker__day-names" },
              _this.header(monthDate)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Month, {
            day: monthDate,
            dayClassName: _this.props.dayClassName,
            onDayClick: _this.handleDayClick,
            onDayMouseEnter: _this.handleDayMouseEnter,
            onMouseLeave: _this.handleMonthMouseLeave,
            onWeekSelect: _this.props.onWeekSelect,
            formatWeekNumber: _this.props.formatWeekNumber,
            minDate: _this.props.minDate,
            maxDate: _this.props.maxDate,
            excludeDates: _this.props.excludeDates,
            highlightDates: _this.props.highlightDates,
            selectingDate: _this.state.selectingDate,
            includeDates: _this.props.includeDates,
            inline: _this.props.inline,
            fixedHeight: _this.props.fixedHeight,
            filterDate: _this.props.filterDate,
            preSelection: _this.props.preSelection,
            selected: _this.props.selected,
            selectsStart: _this.props.selectsStart,
            selectsEnd: _this.props.selectsEnd,
            showWeekNumbers: _this.props.showWeekNumbers,
            startDate: _this.props.startDate,
            endDate: _this.props.endDate,
            peekNextMonth: _this.props.peekNextMonth,
            utcOffset: _this.props.utcOffset
          })
        ));
      }
      return monthList;
    };

    _this.renderTimeSection = function () {
      if (_this.props.showTimeSelect) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Time, {
          selected: _this.props.selected,
          onChange: _this.props.onTimeChange,
          format: _this.props.timeFormat,
          includeTimes: _this.props.includeTimes,
          intervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          todayButton: _this.props.todayButton,
          showMonthDropdown: _this.props.showMonthDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          monthRef: _this.state.monthContainer,
          injectTimes: _this.props.injectTimes
        });
      }
    };

    _this.state = {
      date: _this.localizeDate(_this.getDateInView()),
      selectingDate: null,
      monthContainer: _this.monthContainer
    };
    return _this;
  }

  Calendar.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    // monthContainer height is needed in time component
    // to determine the height for the ul in the time component
    // setState here so height is given after final component
    // layout is rendered
    if (this.props.showTimeSelect) {
      this.assignMonthContainer = function () {
        _this2.setState({ monthContainer: _this2.monthContainer });
      }();
    }
  };

  Calendar.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.preSelection && !isSameDay(this.props.preSelection, prevProps.preSelection)) {
      this.setState({
        date: this.localizeDate(this.props.preSelection)
      });
    } else if (this.props.openToDate && !isSameDay(this.props.openToDate, prevProps.openToDate)) {
      this.setState({
        date: this.localizeDate(this.props.openToDate)
      });
    }
  };

  Calendar.prototype.render = function render() {
    var Container = this.props.container || CalendarContainer;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Container,
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker", this.props.className, {
          "react-datepicker--time-only": this.props.showTimeSelectOnly
        })
      },
      this.renderPreviousMonthButton(),
      this.renderNextMonthButton(),
      this.renderMonths(),
      this.renderTodayButton(),
      this.renderTimeSection(),
      this.props.children
    );
  };

  return Calendar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Calendar.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]).isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]),
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  monthsShown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onMonthChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onYearChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  forceShowMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onDropdownFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showTimeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelectOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  timeFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  timeIntervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onTimeChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openToDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  useWeekdaysShort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  withPortal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  weekLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  setOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showDisabledMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previousMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  nextMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var popperPlacementPositions = ["auto", "auto-left", "auto-right", "bottom", "bottom-end", "bottom-start", "left", "left-end", "left-start", "right", "right-end", "right-start", "top", "top-end", "top-start"];

var PopperComponent = function (_React$Component) {
  inherits(PopperComponent, _React$Component);

  function PopperComponent() {
    classCallCheck(this, PopperComponent);
    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  PopperComponent.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        hidePopper = _props.hidePopper,
        popperComponent = _props.popperComponent,
        popperModifiers = _props.popperModifiers,
        popperPlacement = _props.popperPlacement,
        targetComponent = _props.targetComponent;


    var popper = void 0;

    if (!hidePopper) {
      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker-popper", className);
      popper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_popper__["b" /* Popper */],
        {
          className: classes,
          modifiers: popperModifiers,
          placement: popperPlacement
        },
        popperComponent
      );
    }

    if (this.props.popperContainer) {
      popper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.props.popperContainer, {}, popper);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_popper__["a" /* Manager */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_popper__["c" /* Target */],
        { className: "react-datepicker-wrapper" },
        targetComponent
      ),
      popper
    );
  };

  createClass(PopperComponent, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        hidePopper: true,
        popperModifiers: {
          preventOverflow: {
            enabled: true,
            escapeWithReference: true,
            boundariesElement: "viewport"
          }
        },
        popperPlacement: "bottom-start"
      };
    }
  }]);
  return PopperComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PopperComponent.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hidePopper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  popperComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  popperModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // <datepicker/> props
  popperPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(popperPlacementPositions), // <datepicker/> props
  popperContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  targetComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};

var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
var WrappedCalendar = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(Calendar);

// Compares dates year+month combinations
function hasPreSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
  }

  return date1 !== date2;
}

function hasSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return !equals(date1, date2);
  }

  return false;
}

/**
 * General datepicker component.
 */

var DatePicker = function (_React$Component) {
  inherits(DatePicker, _React$Component);
  createClass(DatePicker, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        allowSameDay: false,
        dateFormat: "L",
        dateFormatCalendar: "MMMM YYYY",
        onChange: function onChange() {},

        disabled: false,
        disabledKeyboardNavigation: false,
        dropdownMode: "scroll",
        onFocus: function onFocus() {},
        onBlur: function onBlur() {},
        onKeyDown: function onKeyDown() {},
        onSelect: function onSelect() {},
        onClickOutside: function onClickOutside$$1() {},
        onMonthChange: function onMonthChange() {},

        preventOpenOnFocus: false,
        onYearChange: function onYearChange() {},

        monthsShown: 1,
        readOnly: false,
        withPortal: false,
        shouldCloseOnSelect: true,
        showTimeSelect: false,
        timeIntervals: 30,
        timeCaption: "Time",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next month"
      };
    }
  }]);

  function DatePicker(props) {
    classCallCheck(this, DatePicker);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.getPreSelection = function () {
      return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
    };

    _this.calcInitialState = function () {
      var defaultPreSelection = _this.getPreSelection();
      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
      return {
        open: _this.props.startOpen || false,
        preventFocus: false,
        preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection,
        // transforming highlighted days (perhaps nested array)
        // to flat Map for faster access in day.jsx
        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
        focused: false
      };
    };

    _this.clearPreventFocusTimeout = function () {
      if (_this.preventFocusTimeout) {
        clearTimeout(_this.preventFocusTimeout);
      }
    };

    _this.setFocus = function () {
      if (_this.input && _this.input.focus) {
        _this.input.focus();
      }
    };

    _this.setOpen = function (open) {
      _this.setState({
        open: open,
        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
      });
    };

    _this.handleFocus = function (event) {
      if (!_this.state.preventFocus) {
        _this.props.onFocus(event);
        if (!_this.props.preventOpenOnFocus && !_this.props.readOnly) {
          _this.setOpen(true);
        }
      }
      _this.setState({ focused: true });
    };

    _this.cancelFocusInput = function () {
      clearTimeout(_this.inputFocusTimeout);
      _this.inputFocusTimeout = null;
    };

    _this.deferFocusInput = function () {
      _this.cancelFocusInput();
      _this.inputFocusTimeout = setTimeout(function () {
        return _this.setFocus();
      }, 1);
    };

    _this.handleDropdownFocus = function () {
      _this.cancelFocusInput();
    };

    _this.handleBlur = function (event) {
      if (_this.state.open && !_this.props.withPortal) {
        _this.deferFocusInput();
      } else {
        _this.props.onBlur(event);
      }
      _this.setState({ focused: false });
    };

    _this.handleCalendarClickOutside = function (event) {
      if (!_this.props.inline) {
        _this.setOpen(false);
      }
      _this.props.onClickOutside(event);
      if (_this.props.withPortal) {
        event.preventDefault();
      }
    };

    _this.handleChange = function () {
      for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
        allArgs[_key] = arguments[_key];
      }

      var event = allArgs[0];
      if (_this.props.onChangeRaw) {
        _this.props.onChangeRaw.apply(_this, allArgs);
        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
          return;
        }
      }
      _this.setState({
        inputValue: event.target.value,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_INPUT
      });
      var date = parseDate(event.target.value, _this.props);
      if (date || !event.target.value) {
        _this.setSelected(date, event, true);
      }
    };

    _this.handleSelect = function (date, event) {
      // Preventing onFocus event to fix issue
      // https://github.com/Hacker0x01/react-datepicker/issues/628
      _this.setState({ preventFocus: true }, function () {
        _this.preventFocusTimeout = setTimeout(function () {
          return _this.setState({ preventFocus: false });
        }, 50);
        return _this.preventFocusTimeout;
      });
      _this.setSelected(date, event);
      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
        _this.setPreSelection(date);
      } else if (!_this.props.inline) {
        _this.setOpen(false);
      }
    };

    _this.setSelected = function (date, event, keepInput) {
      var changedDate = date;

      if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
        return;
      }

      if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
        if (changedDate !== null) {
          if (_this.props.selected) {
            var selected = _this.props.selected;
            if (keepInput) selected = newDate(changedDate);
            changedDate = setTime(newDate(changedDate), {
              hour: getHour(selected),
              minute: getMinute(selected),
              second: getSecond(selected)
            });
          }
          if (!_this.props.inline) {
            _this.setState({
              preSelection: changedDate
            });
          }
        }
        _this.props.onChange(changedDate, event);
      }

      _this.props.onSelect(changedDate, event);

      if (!keepInput) {
        _this.setState({ inputValue: null });
      }
    };

    _this.setPreSelection = function (date) {
      var isDateRangePresent = typeof _this.props.minDate !== "undefined" && typeof _this.props.maxDate !== "undefined";
      var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
      if (isValidDateSelection) {
        _this.setState({
          preSelection: date
        });
      }
    };

    _this.handleTimeChange = function (time) {
      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
      var changedDate = setTime(cloneDate(selected), {
        hour: getHour(time),
        minute: getMinute(time)
      });

      _this.setState({
        preSelection: changedDate
      });

      _this.props.onChange(changedDate);
      _this.setOpen(false);
      _this.setState({ inputValue: null });
    };

    _this.onInputClick = function () {
      if (!_this.props.disabled && !_this.props.readOnly) {
        _this.setOpen(true);
      }
    };

    _this.onInputKeyDown = function (event) {
      _this.props.onKeyDown(event);
      var eventKey = event.key;
      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
        if (eventKey === "ArrowDown" || eventKey === "ArrowUp") {
          _this.onInputClick();
        }
        return;
      }
      var copy = newDate(_this.state.preSelection);
      if (eventKey === "Enter") {
        event.preventDefault();
        if ((isMoment(_this.state.preSelection) || isDate(_this.state.preSelection)) && _this.state.lastPreSelectChange === PRESELECT_CHANGE_VIA_NAVIGATE) {
          _this.handleSelect(copy, event);
          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
        } else {
          _this.setOpen(false);
        }
      } else if (eventKey === "Escape") {
        event.preventDefault();
        _this.setOpen(false);
      } else if (eventKey === "Tab") {
        _this.setOpen(false);
      } else if (!_this.props.disabledKeyboardNavigation) {
        var newSelection = void 0;
        switch (eventKey) {
          case "ArrowLeft":
            newSelection = subtractDays(copy, 1);
            break;
          case "ArrowRight":
            newSelection = addDays(copy, 1);
            break;
          case "ArrowUp":
            newSelection = subtractWeeks(copy, 1);
            break;
          case "ArrowDown":
            newSelection = addWeeks(copy, 1);
            break;
          case "PageUp":
            newSelection = subtractMonths(copy, 1);
            break;
          case "PageDown":
            newSelection = addMonths(copy, 1);
            break;
          case "Home":
            newSelection = subtractYears(copy, 1);
            break;
          case "End":
            newSelection = addYears(copy, 1);
            break;
        }
        if (!newSelection) return; // Let the input component handle this keydown
        event.preventDefault();
        _this.setState({ lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE });
        if (_this.props.adjustDateOnChange) {
          _this.setSelected(newSelection);
        }
        _this.setPreSelection(newSelection);
      }
    };

    _this.onClearClick = function (event) {
      if (event) {
        if (event.preventDefault) {
          event.preventDefault();
        }
      }
      _this.props.onChange(null, event);
      _this.setState({ inputValue: null });
    };

    _this.clear = function () {
      _this.onClearClick();
    };

    _this.renderCalendar = function () {
      if (!_this.props.inline && (!_this.state.open || _this.props.disabled || _this.props.readOnly)) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        WrappedCalendar,
        {
          ref: function ref(elem) {
            _this.calendar = elem;
          },
          locale: _this.props.locale,
          adjustDateOnChange: _this.props.adjustDateOnChange,
          setOpen: _this.setOpen,
          dateFormat: _this.props.dateFormatCalendar,
          useWeekdaysShort: _this.props.useWeekdaysShort,
          formatWeekDay: _this.props.formatWeekDay,
          dropdownMode: _this.props.dropdownMode,
          selected: _this.props.selected,
          preSelection: _this.state.preSelection,
          onSelect: _this.handleSelect,
          onWeekSelect: _this.props.onWeekSelect,
          openToDate: _this.props.openToDate,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          excludeDates: _this.props.excludeDates,
          filterDate: _this.props.filterDate,
          onClickOutside: _this.handleCalendarClickOutside,
          formatWeekNumber: _this.props.formatWeekNumber,
          highlightDates: _this.state.highlightDates,
          includeDates: _this.props.includeDates,
          includeTimes: _this.props.includeTimes,
          injectTimes: _this.props.injectTimes,
          inline: _this.props.inline,
          peekNextMonth: _this.props.peekNextMonth,
          showMonthDropdown: _this.props.showMonthDropdown,
          useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showWeekNumbers: _this.props.showWeekNumbers,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
          showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
          scrollableYearDropdown: _this.props.scrollableYearDropdown,
          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
          todayButton: _this.props.todayButton,
          weekLabel: _this.props.weekLabel,
          utcOffset: _this.props.utcOffset,
          outsideClickIgnoreClass: outsideClickIgnoreClass,
          fixedHeight: _this.props.fixedHeight,
          monthsShown: _this.props.monthsShown,
          onDropdownFocus: _this.handleDropdownFocus,
          onMonthChange: _this.props.onMonthChange,
          onYearChange: _this.props.onYearChange,
          dayClassName: _this.props.dayClassName,
          showTimeSelect: _this.props.showTimeSelect,
          showTimeSelectOnly: _this.props.showTimeSelectOnly,
          onTimeChange: _this.handleTimeChange,
          timeFormat: _this.props.timeFormat,
          timeIntervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          className: _this.props.calendarClassName,
          container: _this.props.calendarContainer,
          yearDropdownItemNumber: _this.props.yearDropdownItemNumber,
          previousMonthButtonLabel: _this.props.previousMonthButtonLabel,
          nextMonthButtonLabel: _this.props.nextMonthButtonLabel
        },
        _this.props.children
      );
    };

    _this.renderDateInput = function () {
      var _classnames, _React$cloneElement;

      var className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));

      var customInput = _this.props.customInput || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text" });
      var customInputRef = _this.props.customInputRef || "ref";
      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function (input) {
        _this.input = input;
      }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
    };

    _this.renderClearButton = function () {
      if (_this.props.isClearable && _this.props.selected != null) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
          type: "button",
          className: "react-datepicker__close-icon",
          onClick: _this.onClearClick,
          title: _this.props.clearButtonTitle,
          tabIndex: -1
        });
      } else {
        return null;
      }
    };

    _this.state = _this.calcInitialState();
    return _this;
  }

  DatePicker.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.inline && hasPreSelectionChanged(prevProps.selected, this.props.selected)) {
      this.setPreSelection(this.props.selected);
    }
    if (prevProps.highlightDates !== this.props.highlightDates) {
      this.setState({
        highlightDates: getHightLightDaysMap(this.props.highlightDates)
      });
    }
    if (!prevState.focused && hasSelectionChanged(prevProps.selected, this.props.selected)) {
      this.setState({ inputValue: null });
    }
  };

  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearPreventFocusTimeout();
  };

  DatePicker.prototype.render = function render() {
    var calendar = this.renderCalendar();

    if (this.props.inline && !this.props.withPortal) {
      return calendar;
    }

    if (this.props.withPortal) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        !this.props.inline ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__input-container" },
          this.renderDateInput(),
          this.renderClearButton()
        ) : null,
        this.state.open || this.props.inline ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__portal" },
          calendar
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopperComponent, {
      className: this.props.popperClassName,
      hidePopper: !this.state.open || this.props.disabled || this.props.readOnly,
      popperModifiers: this.props.popperModifiers,
      targetComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__input-container" },
        this.renderDateInput(),
        this.renderClearButton()
      ),
      popperContainer: this.props.popperContainer,
      popperComponent: calendar,
      popperPlacement: this.props.popperPlacement
    });
  };

  return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DatePicker.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowSameDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  calendarClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  calendarContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  customInputRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // eslint-disable-next-line react/no-unused-prop-types
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  dateFormatCalendar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isClearable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  monthsShown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChangeRaw: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMonthChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onYearChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  openToDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placeholderText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  popperContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  popperClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // <PopperComponent/> props
  popperModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // <PopperComponent/> props
  popperPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(popperPlacementPositions), // <PopperComponent/> props
  preventOpenOnFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  forceShowMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showDisabledMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  startOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  useWeekdaysShort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  weekLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  withPortal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  shouldCloseOnSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelectOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  timeFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  timeIntervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  clearButtonTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  previousMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  nextMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
var PRESELECT_CHANGE_VIA_INPUT = "input";
var PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";


/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return errorObject; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isScheduler;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
//# sourceMappingURL=isScheduler.js.map


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = map;
/* unused harmony export MapOperator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') {
            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        }
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());

var MapSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=map.js.map


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONSENT_REQUESTS_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONSENT_REQUESTS_CANCELED; });
/* unused harmony export fetchGetOrganizationConsentsFailed */
/* unused harmony export onGetOrganizationConsentsSuccess */
/* unused harmony export fetchGetOrganizationConsentsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchGetOrganizationConsents; });
/* unused harmony export onGetOrganizationConsents */
/* unused harmony export fetchGetOrganizationConsentsNextPageFailed */
/* unused harmony export onGetOrganizationConsentsNextPageSuccess */
/* unused harmony export fetchGetOrganizationConsentsNextPageSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchGetOrganizationConsentsNextPage; });
/* unused harmony export onGetOrganizationConsentsNextPage */
/* unused harmony export setUpdatedBefore */
/* unused harmony export setNextPageAvailable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setCurrentConsentRequestsFilterStatus; });
/* unused harmony export onSetCurrentConsentRequestsFilterStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setCurrentConsentRequestsFilterJob; });
/* unused harmony export onSetCurrentConsentRequestsFilterJob */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setCurrentConsentRequest; });
/* unused harmony export onSetCurrentConsentRequest */
/* unused harmony export fetchGetConsentRequestDetailsFailed */
/* unused harmony export fetchGetConsentRequestDetailsSuccess */
/* unused harmony export onGetConsentRequestDetailsSuccess */
/* unused harmony export fetchGetConsentRequestDetails */
/* unused harmony export updateOrganizationConsentsData */
/* unused harmony export clearCurrentConsentRequestData */
/* unused harmony export fetchAbandonConsentRequestSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchAbandonConsentRequest; });
/* unused harmony export onFetchAbandonConsentRequest */
/* unused harmony export getOrganizationConsents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return loadingOrganizationConsents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return loadingCurrentConsentRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCurrentConsentRequestId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCurrentConsentRequestData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCurrentConsentRequestsFilterStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCurrentConsentRequestsFilterJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getOrganizationConsentsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isLoadNextPageAvailable; });
/* unused harmony export getUpdatedBefore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var CONSENT_REQUESTS_PAGE_SIZE=10;var CONSENT_REQUESTS_FILTER={ALL:"ALL",PENDING:"PENDING",GRANTED:"GRANTED",REJECTED:"REJECTED",REVOKED:"REVOKED",EXPIRED:"EXPIRED"};var CONSENT_REQUESTS_CANCELED="ABANDONED";//- Actions
var fetchGetOrganizationConsentsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORGANIZATION_CONSENTS_FAILED');var onGetOrganizationConsentsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORGANIZATION_CONSENTS_SUCCESS');var fetchGetOrganizationConsentsSuccess=function fetchGetOrganizationConsentsSuccess(data){return function(dispatch){if(data.length<CONSENT_REQUESTS_PAGE_SIZE){dispatch(onGetOrganizationConsentsSuccess(data));dispatch(setNextPageAvailable(false));}else{dispatch(onGetOrganizationConsentsSuccess(data));dispatch(setUpdatedBefore(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.last(data).updatedAt));dispatch(setNextPageAvailable(true));}};};var fetchGetOrganizationConsents=function fetchGetOrganizationConsents(){return function(dispatch,getState){var status=getCurrentConsentRequestsFilterStatus(getState());var job=getCurrentConsentRequestsFilterJob(getState());var departmentId=Object(__WEBPACK_IMPORTED_MODULE_5__account_role__["k" /* getCurrentGroup */])(getState());if(departmentId){var filterParams={updatedBefore:__WEBPACK_IMPORTED_MODULE_7_moment___default()().utc().format(),status:status!==CONSENT_REQUESTS_FILTER.ALL?status:null,job:job};dispatch(onGetOrganizationConsents(departmentId,filterParams));}};};var onGetOrganizationConsents=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORGANIZATION_CONSENTS',function(departmentId,filterParams){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getOrganizationConsents(departmentId,filterParams);},function(){return{apiCall:true,onSuccess:fetchGetOrganizationConsentsSuccess,onFail:fetchGetOrganizationConsentsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchGetOrganizationConsentsNextPageFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORGANIZATION_CONSENTS_NEXT_PAGE_FAILED');var onGetOrganizationConsentsNextPageSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORGANIZATION_CONSENTS_NEXT_PAGE_SUCCESS');var fetchGetOrganizationConsentsNextPageSuccess=function fetchGetOrganizationConsentsNextPageSuccess(data){return function(dispatch){if(data.length<CONSENT_REQUESTS_PAGE_SIZE){dispatch(onGetOrganizationConsentsNextPageSuccess(data));dispatch(setNextPageAvailable(false));}else{dispatch(onGetOrganizationConsentsNextPageSuccess(data));dispatch(setUpdatedBefore(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.last(data).updatedAt));}};};var fetchGetOrganizationConsentsNextPage=function fetchGetOrganizationConsentsNextPage(){return function(dispatch,getState){var status=getCurrentConsentRequestsFilterStatus(getState());var job=getCurrentConsentRequestsFilterJob(getState());var departmentId=Object(__WEBPACK_IMPORTED_MODULE_5__account_role__["k" /* getCurrentGroup */])(getState());if(departmentId&&isLoadNextPageAvailable(getState())){var filterParams={updatedBefore:getUpdatedBefore(getState()),status:status!==CONSENT_REQUESTS_FILTER.ALL?status:null,job:job};dispatch(onGetOrganizationConsentsNextPage(departmentId,filterParams));}};};var onGetOrganizationConsentsNextPage=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORGANIZATION_CONSENTS_NEXT_PAGE',function(departmentId,filterParams){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getOrganizationConsents(departmentId,filterParams);},function(){return{apiCall:true,onSuccess:fetchGetOrganizationConsentsNextPageSuccess,onFail:fetchGetOrganizationConsentsNextPageFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var setUpdatedBefore=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_UPDATED_BEFORE');var setNextPageAvailable=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_NEXT_PAGE_AVAILABLE');var setCurrentConsentRequestsFilterStatus=function setCurrentConsentRequestsFilterStatus(newStatus){return function(dispatch){dispatch(onSetCurrentConsentRequestsFilterStatus(newStatus));dispatch(fetchGetOrganizationConsents());};};var onSetCurrentConsentRequestsFilterStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_CURRENT_CONSENT_REQUEST_FILTER_STATUS');var setCurrentConsentRequestsFilterJob=function setCurrentConsentRequestsFilterJob(newJob){return function(dispatch){dispatch(onSetCurrentConsentRequestsFilterJob(newJob));dispatch(fetchGetOrganizationConsents());};};var onSetCurrentConsentRequestsFilterJob=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_CURRENT_CONSENT_REQUEST_FILTER_JOB');var setCurrentConsentRequest=function setCurrentConsentRequest(id){return function(dispatch){dispatch(fetchGetConsentRequestDetails(id));dispatch(onSetCurrentConsentRequest(id));};};var onSetCurrentConsentRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_CURRENT_CONSENT_REQUEST');var fetchGetConsentRequestDetailsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_CONSENT_REQUEST_DETAILS_FAILED');var fetchGetConsentRequestDetailsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_CONSENT_REQUEST_DETAILS_SUCCESS');var onGetConsentRequestDetailsSuccess=function onGetConsentRequestDetailsSuccess(data){return function(dispatch,getState){var listData=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(getOrganizationConsentsData(getState()));var id=getCurrentConsentRequestId(getState());var index=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(listData,function(elem){return elem.id===id;});listData[index].status=data.status;listData[index].updatedAt=data.updatedAt;if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(data.grantedTill)){listData[index].grantedTill=data.grantedTill;}dispatch(updateOrganizationConsentsData(listData));dispatch(fetchGetConsentRequestDetailsSuccess(data));};};var fetchGetConsentRequestDetails=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_CONSENT_REQUEST_DETAILS',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getConsentRequestDetails(id);},function(){return{apiCall:true,onSuccess:onGetConsentRequestDetailsSuccess,onFail:fetchGetConsentRequestDetailsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var updateOrganizationConsentsData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_ORGANIZATION_CONSENTS_DATA');var clearCurrentConsentRequestData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_CURRENT_CONSENT_REQUEST_DATA');var fetchAbandonConsentRequestSuccess=function fetchAbandonConsentRequestSuccess(id){return function(){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */])());var listData=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(getOrganizationConsentsData(getState()));__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.remove(listData,function(elem){return elem.id===id;});dispatch(updateOrganizationConsentsData(listData));dispatch(clearCurrentConsentRequestData());dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_activeModal__["_16" /* hideModal */])());};};};var fetchAbandonConsentRequest=function fetchAbandonConsentRequest(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onFetchAbandonConsentRequest(id));};};var onFetchAbandonConsentRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CANCEL_CONSENT_REQUEST',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].abandonConsentRequest(id);},function(id){return{apiCall:true,onSuccess:fetchAbandonConsentRequestSuccess(id),onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});//- State
var initialState={data:null,updatedBefore:null,isNextPageAvailable:true,currentConsentRequestId:null,currentConsentRequestData:null,currentFilterStatus:CONSENT_REQUESTS_FILTER.ALL,currentFilterJob:"",error:null,fetching:false,fetchingCurrentConsentRequest:false};//- Reducers
/* harmony default export */ __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_ORGANIZATION_CONSENTS:function FETCH_GET_ORGANIZATION_CONSENTS(state){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,currentConsentRequestId:null,currentConsentRequestData:null,error:null,fetching:true});},FETCH_GET_ORGANIZATION_CONSENTS_FAILED:function FETCH_GET_ORGANIZATION_CONSENTS_FAILED(state,action){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,error:action.payload,fetching:false});},FETCH_GET_ORGANIZATION_CONSENTS_SUCCESS:function FETCH_GET_ORGANIZATION_CONSENTS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});},FETCH_GET_ORGANIZATION_CONSENTS_NEXT_PAGE:function FETCH_GET_ORGANIZATION_CONSENTS_NEXT_PAGE(state){return Object.assign({},state,{error:null,fetching:true});},FETCH_GET_ORGANIZATION_CONSENTS_NEXT_PAGE_FAILED:function FETCH_GET_ORGANIZATION_CONSENTS_NEXT_PAGE_FAILED(state,action){return Object.assign({},state,{error:action.payload,fetching:false});},FETCH_GET_ORGANIZATION_CONSENTS_NEXT_PAGE_SUCCESS:function FETCH_GET_ORGANIZATION_CONSENTS_NEXT_PAGE_SUCCESS(state,action){return Object.assign({},state,{data:[].concat(_toConsumableArray(state.data),_toConsumableArray(action.payload)),error:null,fetching:false});},SET_UPDATED_BEFORE:function SET_UPDATED_BEFORE(state,action){return Object.assign({},state,{updatedBefore:action.payload});},SET_NEXT_PAGE_AVAILABLE:function SET_NEXT_PAGE_AVAILABLE(state,action){return Object.assign({},state,{isNextPageAvailable:action.payload});},UPDATE_ORGANIZATION_CONSENTS_DATA:function UPDATE_ORGANIZATION_CONSENTS_DATA(state,action){return Object.assign({},state,{data:action.payload});},FETCH_GET_CONSENT_REQUEST_DETAILS:function FETCH_GET_CONSENT_REQUEST_DETAILS(state){return Object.assign({},state,{currentConsentRequestData:null,error:null,fetchingCurrentConsentRequest:true});},FETCH_GET_CONSENT_REQUEST_DETAILS_FAILED:function FETCH_GET_CONSENT_REQUEST_DETAILS_FAILED(state,action){return Object.assign({},state,{currentConsentRequestData:null,error:action.payload,fetchingCurrentConsentRequest:false});},FETCH_GET_CONSENT_REQUEST_DETAILS_SUCCESS:function FETCH_GET_CONSENT_REQUEST_DETAILS_SUCCESS(state,action){return Object.assign({},state,{currentConsentRequestData:action.payload,error:null,fetchingCurrentConsentRequest:false});},CLEAR_CURRENT_CONSENT_REQUEST_DATA:function CLEAR_CURRENT_CONSENT_REQUEST_DATA(state){return Object.assign({},state,{currentConsentRequestData:null,currentConsentRequestId:null});},SET_CURRENT_CONSENT_REQUEST_FILTER_STATUS:function SET_CURRENT_CONSENT_REQUEST_FILTER_STATUS(state,action){return Object.assign({},state,{currentFilterStatus:action.payload});},SET_CURRENT_CONSENT_REQUEST_FILTER_JOB:function SET_CURRENT_CONSENT_REQUEST_FILTER_JOB(state,action){return Object.assign({},state,{currentFilterJob:action.payload});},SET_CURRENT_CONSENT_REQUEST:function SET_CURRENT_CONSENT_REQUEST(state,action){return Object.assign({},state,{currentConsentRequestId:action.payload});}},initialState));//- Selectors
var getOrganizationConsents=function getOrganizationConsents(state){return state.organizationConsents;};var loadingOrganizationConsents=function loadingOrganizationConsents(state){return getOrganizationConsents(state).fetching;};var loadingCurrentConsentRequest=function loadingCurrentConsentRequest(state){return getOrganizationConsents(state).fetchingCurrentConsentRequest;};var getCurrentConsentRequestId=function getCurrentConsentRequestId(state){return getOrganizationConsents(state).currentConsentRequestId;};var getCurrentConsentRequestData=function getCurrentConsentRequestData(state){return getOrganizationConsents(state).currentConsentRequestData;};var getCurrentConsentRequestsFilterStatus=function getCurrentConsentRequestsFilterStatus(state){return getOrganizationConsents(state).currentFilterStatus;};var getCurrentConsentRequestsFilterJob=function getCurrentConsentRequestsFilterJob(state){return getOrganizationConsents(state).currentFilterJob;};var getOrganizationConsentsData=function getOrganizationConsentsData(state){return getOrganizationConsents(state).data;};var isLoadNextPageAvailable=function isLoadNextPageAvailable(state){return getOrganizationConsents(state).isNextPageAvailable;};var getUpdatedBefore=function getUpdatedBefore(state){return getOrganizationConsents(state).updatedBefore;};

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty__ = __webpack_require__(546);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty__["a" /* default */])(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(328);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tryCatch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errorObject__ = __webpack_require__(46);
/** PURE_IMPORTS_START _errorObject PURE_IMPORTS_END */

var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        __WEBPACK_IMPORTED_MODULE_0__errorObject__["a" /* errorObject */].e = e;
        return __WEBPACK_IMPORTED_MODULE_0__errorObject__["a" /* errorObject */];
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
//# sourceMappingURL=tryCatch.js.map


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetKeyFailed */
/* unused harmony export fetchGetKeySuccess */
/* unused harmony export onFetchGetKeySuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetKey; });
/* unused harmony export onGetKey */
/* unused harmony export fetchSubmitFormFailedIncorrectJWK */
/* unused harmony export fetchSetJWK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchPutKey; });
/* unused harmony export fetchSignToken */
/* unused harmony export fetchVerifyJWK */
/* unused harmony export onVerifyJWKSuccess */
/* unused harmony export onPutKey */
/* unused harmony export onPutKeySuccess */
/* unused harmony export fetchSetKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleCryptoEpic; });
/* unused harmony export getCertificate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getKey; });
/* unused harmony export getJWK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getKeyLoading; });
/* unused harmony export getKeyError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_cryptoUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_userData__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_storageApi__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_notifications__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_constants__ = __webpack_require__(24);
//- Actions
var fetchGetKeyFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_KEY_FAILED');var fetchGetKeySuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_KEY_SUCCESS');var onFetchGetKeySuccess=function onFetchGetKeySuccess(key){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__common_notifications__["a" /* addNotificationData */])({type:__WEBPACK_IMPORTED_MODULE_11__constants_constants__["l" /* NOTIFICATION_TYPES */].INSERTER_SECURITY_NO_CERTIFICATE,value:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(key)?1:0}));dispatch(fetchGetKeySuccess(key));};};var fetchGetKey=function fetchGetKey(){return function(dispatch,getState){var userId=Object(__WEBPACK_IMPORTED_MODULE_4__account_userData__["g" /* getUserId */])(getState());var userSecret=Object(__WEBPACK_IMPORTED_MODULE_4__account_userData__["j" /* getUserSecret */])(getState());dispatch(onGetKey(userId,userSecret));};};var onGetKey=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_KEY',function(userId,secret){return __WEBPACK_IMPORTED_MODULE_3__utils_cryptoUtils__["a" /* CryptoUtils */].getKey(userId,secret);},function(){return{cryptoCall:true,onSuccess:onFetchGetKeySuccess,onFail:fetchGetKeyFailed};});var fetchSubmitFormFailedIncorrectJWK=function fetchSubmitFormFailedIncorrectJWK(error){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__common_submitForm__["c" /* fetchSubmitFormFailed */])("INCORRECT_JWK"));};};var fetchSetJWK=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_SET_JWK');var fetchPutKey=function fetchPutKey(jwk){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchSetJWK(jwk));var token=__WEBPACK_IMPORTED_MODULE_9__utils_storageApi__["a" /* StorageApi */].getLoginToken();dispatch(fetchSignToken(jwk,token));};};var fetchSignToken=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_SIGN_TOKEN',function(jwk,token){return __WEBPACK_IMPORTED_MODULE_3__utils_cryptoUtils__["a" /* CryptoUtils */].signStringWithJWK(jwk,token);},function(){return{cryptoCall:true,onSuccess:fetchVerifyJWK,onFail:fetchSubmitFormFailedIncorrectJWK};});var fetchVerifyJWK=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_VERIFY_JWK',function(data){return __WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* Api */].verifyJWK({signature:data});},function(){return{apiCall:true,onSuccess:onVerifyJWKSuccess,onFail:__WEBPACK_IMPORTED_MODULE_7__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_6__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_6__account_login__["l" /* onForbidden */]};});var onVerifyJWKSuccess=function onVerifyJWKSuccess(result){return function(dispatch,getState){if(result.passed){var userId=Object(__WEBPACK_IMPORTED_MODULE_4__account_userData__["g" /* getUserId */])(getState());var userSecret=Object(__WEBPACK_IMPORTED_MODULE_4__account_userData__["j" /* getUserSecret */])(getState());var jwk=getJWK(getState());dispatch(onPutKey(userId,jwk,userSecret));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__common_submitForm__["c" /* fetchSubmitFormFailed */])("INCORRECT_JWK"));}};};var onPutKey=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_PUT_KEY',function(userId,jwk,secret){return __WEBPACK_IMPORTED_MODULE_3__utils_cryptoUtils__["a" /* CryptoUtils */].putKey(userId,jwk,secret);},function(){return{cryptoCall:true,onSuccess:onPutKeySuccess,onFail:fetchSubmitFormFailedIncorrectJWK};});var onPutKeySuccess=function onPutKeySuccess(key){return function(dispatch){dispatch(fetchSetKey(key));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__common_submitForm__["k" /* resetSubmitFormData */])());};};var fetchSetKey=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_SET_KEY');//- State
var initialState={key:null,jwk:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_KEY:function FETCH_GET_KEY(state){return Object.assign({},state,{key:null,error:null,fetching:true});},FETCH_GET_KEY_FAILED:function FETCH_GET_KEY_FAILED(state,action){return Object.assign({},state,{key:null,error:action.payload,fetching:false});},FETCH_GET_KEY_SUCCESS:function FETCH_GET_KEY_SUCCESS(state,action){return Object.assign({},state,{key:action.payload,error:null,fetching:false});},FETCH_SET_KEY:function FETCH_SET_KEY(state,action){return Object.assign({},state,{key:action.payload});},FETCH_SET_JWK:function FETCH_SET_JWK(state,action){return Object.assign({},state,{jwk:action.payload});}},initialState));//- Epics
var handleCryptoEpic=function handleCryptoEpic(action$){return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["b" /* filter */])(function(action){return!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(action.meta)&&action.meta.cryptoCall;}),Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["d" /* mergeMap */])(function(action){return Object(__WEBPACK_IMPORTED_MODULE_1_rxjs__["c" /* from */])(action.payload).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["d" /* mergeMap */])(function(data){return Object(__WEBPACK_IMPORTED_MODULE_1_rxjs__["e" /* of */])(action.meta.onSuccess(data));}),Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function(error){return Object(__WEBPACK_IMPORTED_MODULE_1_rxjs__["e" /* of */])(action.meta.onFail(error.message));}));}));};//- Selectors
var getCertificate=function getCertificate(state){return state.certificate;};var getKey=function getKey(state){return getCertificate(state).key;};var getJWK=function getJWK(state){return getCertificate(state).jwk;};var getKeyLoading=function getKeyLoading(state){return getCertificate(state).fetching;};var getKeyError=function getKeyError(state){return getCertificate(state).error;};

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetUnreferencedAccreditationRequestsFailed */
/* unused harmony export fetchGetUnreferencedAccreditationRequestsSuccess */
/* unused harmony export onGetAccreditationRequestsByDomainsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return onGetAccreditationRequestsFilteredByDomains; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return onGetAccreditationRequestsByDomainsByPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return onGetAccreditationRequestsByDomains; });
/* unused harmony export fetchGetAccreditationRequestsByDomains */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return setFilterDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return setValidated; });
/* unused harmony export onChangeUnreferencedAccreditationRequestDomainSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeUnreferencedAccreditationRequestDomain; });
/* unused harmony export validateUnreferencedAccreditationRequestDomain */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return onValidateDomain; });
/* unused harmony export onChangeUnreferencedAccreditationRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return onRemoveUnreferencedAccreditationRequestDomain; });
/* unused harmony export onGetAccreditationRequestsByAGSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return onGetAccreditationRequestsFilteredByAGs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return onGetAccreditationRequestsByAGsByPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetAccreditationRequestsByAGs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return setFilterAG; });
/* unused harmony export onChangeUnreferencedAccreditationRequestAGSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return onChangeUnreferencedAccreditationRequestAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return onRemoveUnreferencedAccreditationRequestAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return resetAccreditationRequestsData; });
/* unused harmony export fetchGetLastRequestorsOfAccreditationRequestSuccess */
/* unused harmony export fetchGetLastRequestorsOfAccreditationRequestFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchGetLastRequestorsOfAccreditationRequest; });
/* unused harmony export getUnreferencedAccreditationRequests */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return loadingUnreferencedAccreditationRequests; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getUnreferencedAccreditationRequestsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCurrentPageForAccreditationRequests; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTotalPagesForAccreditationRequests; });
/* unused harmony export getAccreditationRequestsFilterDomain */
/* unused harmony export getAccreditationRequestsFilterAG */
/* unused harmony export getAccreditationRequestsValidated */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return loadingLastRequestorsOfAccreditationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getLastRequestorsOfAccreditationRequestData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_submitForm__ = __webpack_require__(7);
//- Actions
var fetchGetUnreferencedAccreditationRequestsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS_FAILED');var fetchGetUnreferencedAccreditationRequestsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS_SUCCESS');var onGetAccreditationRequestsByDomainsSuccess=function onGetAccreditationRequestsByDomainsSuccess(data){return function(dispatch,getState){var isEmpty=data.empty;var currentPage=data.number;var filterDomain=getAccreditationRequestsFilterDomain(getState());var validated=getAccreditationRequestsValidated(getState());if(!isEmpty&&currentPage!==0||currentPage===0){dispatch(fetchGetUnreferencedAccreditationRequestsSuccess(data));}else{dispatch(fetchGetAccreditationRequestsByDomains(validated,filterDomain,currentPage-1));}};};var onGetAccreditationRequestsFilteredByDomains=function onGetAccreditationRequestsFilteredByDomains(domain){return function(dispatch,getState){var validated=getAccreditationRequestsValidated(getState());dispatch(setFilterDomain(domain));dispatch(fetchGetAccreditationRequestsByDomains(validated,domain));};};var onGetAccreditationRequestsByDomainsByPage=function onGetAccreditationRequestsByDomainsByPage(page){return function(dispatch,getState){var domain=getAccreditationRequestsFilterDomain(getState());var validated=getAccreditationRequestsValidated(getState());dispatch(fetchGetAccreditationRequestsByDomains(validated,domain,page));};};var onGetAccreditationRequestsByDomains=function onGetAccreditationRequestsByDomains(){return function(dispatch,getState){var validated=getAccreditationRequestsValidated(getState());dispatch(fetchGetAccreditationRequestsByDomains(validated));};};var fetchGetAccreditationRequestsByDomains=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS',function(validated,domain,page,size){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAccreditationRequestsByDomains(validated,domain,page,size);},function(){return{apiCall:true,onSuccess:onGetAccreditationRequestsByDomainsSuccess,onFail:fetchGetUnreferencedAccreditationRequestsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var setFilterDomain=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_FILTER_DOMAIN');var setValidated=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_VALIDATED');var onChangeUnreferencedAccreditationRequestDomainSuccess=function onChangeUnreferencedAccreditationRequestDomainSuccess(){return function(dispatch,getState){var currentPage=getCurrentPageForAccreditationRequests(getState());var filterDomain=getAccreditationRequestsFilterDomain(getState());var validated=getAccreditationRequestsValidated(getState());dispatch(fetchGetAccreditationRequestsByDomains(validated,filterDomain,currentPage));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */])());};};var changeUnreferencedAccreditationRequestDomain=function changeUnreferencedAccreditationRequestDomain(domain,newDomain){return function(dispatch){dispatch(onChangeUnreferencedAccreditationRequest(domain,{domain:newDomain}));};};var validateUnreferencedAccreditationRequestDomain=function validateUnreferencedAccreditationRequestDomain(domain){return function(dispatch){dispatch(onChangeUnreferencedAccreditationRequest(domain,{newDomain:domain,verified:true}));};};var onValidateDomain=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("FETCH_VALIDATE_DOMAIN",function(domain,data,bavaManaged){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].validateDomain(domain,data,bavaManaged);},function(){return{apiCall:true,onSuccess:onChangeUnreferencedAccreditationRequestDomainSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onChangeUnreferencedAccreditationRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("FETCH_CHANGE_UNREFERENCED_ACCREDITATION_REQUEST_DOMAIN",function(domain,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateAccreditationRequestByDomain(domain,data);},function(){return{apiCall:true,onSuccess:onChangeUnreferencedAccreditationRequestDomainSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onRemoveUnreferencedAccreditationRequestDomain=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("FETCH_REMOVE_UNREFERENCED_ACCREDITATION_REQUEST_DOMAIN",function(domain){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeAccreditationRequestByDomain(domain);},function(){return{apiCall:true,onSuccess:onChangeUnreferencedAccreditationRequestDomainSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onGetAccreditationRequestsByAGSuccess=function onGetAccreditationRequestsByAGSuccess(data){return function(dispatch,getState){var isEmpty=data.empty;var currentPage=data.number;var filterAG=getAccreditationRequestsFilterAG(getState());if(!isEmpty&&currentPage!==0||currentPage===0){dispatch(fetchGetUnreferencedAccreditationRequestsSuccess(data));}else{dispatch(fetchGetAccreditationRequestsByAGs(filterAG,currentPage-1));}};};var onGetAccreditationRequestsFilteredByAGs=function onGetAccreditationRequestsFilteredByAGs(AG){return function(dispatch){dispatch(setFilterAG(AG));dispatch(fetchGetAccreditationRequestsByAGs(AG));};};var onGetAccreditationRequestsByAGsByPage=function onGetAccreditationRequestsByAGsByPage(page){return function(dispatch,getState){var AG=getAccreditationRequestsFilterAG(getState());dispatch(fetchGetAccreditationRequestsByAGs(AG,page));};};var fetchGetAccreditationRequestsByAGs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS',function(AG,page,size){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAccreditationRequestsByAGs(AG,page,size);},function(){return{apiCall:true,onSuccess:onGetAccreditationRequestsByAGSuccess,onFail:fetchGetUnreferencedAccreditationRequestsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var setFilterAG=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_FILTER_AG');var onChangeUnreferencedAccreditationRequestAGSuccess=function onChangeUnreferencedAccreditationRequestAGSuccess(){return function(dispatch,getState){var currentPage=getCurrentPageForAccreditationRequests(getState());var filterAG=getAccreditationRequestsFilterAG(getState());dispatch(fetchGetAccreditationRequestsByAGs(filterAG,currentPage));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */])());};};var onChangeUnreferencedAccreditationRequestAG=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("FETCH_CHANGE_UNREFERENCED_ACCREDITATION_REQUEST_DOMAIN",function(AGId,AGs){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateAccreditationRequestByAG(AGId,AGs);},function(){return{apiCall:true,onSuccess:onChangeUnreferencedAccreditationRequestAGSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onRemoveUnreferencedAccreditationRequestAG=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("FETCH_REMOVE_UNREFERENCED_ACCREDITATION_REQUEST_DOMAIN",function(AGs){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeAccreditationRequestByAG(AGs);},function(){return{apiCall:true,onSuccess:onChangeUnreferencedAccreditationRequestAGSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var resetAccreditationRequestsData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RESET_ACCREDITATION_REQUESTS_DATA');var fetchGetLastRequestorsOfAccreditationRequestSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_LAST_REQUESTORS_OF_ACCREDITATION_REQUEST_DOMAIN_SUCCESS');var fetchGetLastRequestorsOfAccreditationRequestFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_LAST_REQUESTORS_OF_ACCREDITATION_REQUEST_DOMAIN_FAILED');var fetchGetLastRequestorsOfAccreditationRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("FETCH_GET_LAST_REQUESTORS_OF_ACCREDITATION_REQUEST_DOMAIN",function(domain){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getLastRequestorsOfAccreditationRequestByDomain(domain);},function(){return{apiCall:true,onSuccess:fetchGetLastRequestorsOfAccreditationRequestSuccess,onFail:fetchGetLastRequestorsOfAccreditationRequestFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});//- State
var initialState={data:null,error:null,fetching:false,currentPage:null,totalPages:null,filterDomain:null,filterAG:null,validated:null,lastRequestorsData:null,fetchingLastRequestors:false,errorLastRequestors:null};//- Reducers
/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS:function FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS(state){return Object.assign({},state,{error:null,fetching:true,currentPage:null,totalPages:null});},FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS_FAILED:function FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false,currentPage:null,totalPages:null});},FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS_SUCCESS:function FETCH_GET_UNREFERENCED_ACCREDITATION_REQUESTS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload.content,error:null,fetching:false,currentPage:action.payload.number,totalPages:action.payload.totalPages});},SET_FILTER_DOMAIN:function SET_FILTER_DOMAIN(state,action){return Object.assign({},state,{filterDomain:action.payload});},SET_FILTER_AG:function SET_FILTER_AG(state,action){return Object.assign({},state,{filterAG:action.payload});},SET_VALIDATED:function SET_VALIDATED(state,action){return Object.assign({},state,{validated:action.payload});},RESET_ACCREDITATION_REQUESTS_DATA:function RESET_ACCREDITATION_REQUESTS_DATA(state){return Object.assign({},state,{data:null,error:null,validated:null});},FETCH_GET_LAST_REQUESTORS_OF_ACCREDITATION_REQUEST_DOMAIN:function FETCH_GET_LAST_REQUESTORS_OF_ACCREDITATION_REQUEST_DOMAIN(state){return Object.assign({},state,{lastRequestorsData:null,errorLastRequestors:null,fetchingLastRequestors:true});},FETCH_GET_LAST_REQUESTORS_OF_ACCREDITATION_REQUEST_DOMAIN_FAILED:function FETCH_GET_LAST_REQUESTORS_OF_ACCREDITATION_REQUEST_DOMAIN_FAILED(state,action){return Object.assign({},state,{lastRequestorsData:null,errorLastRequestors:action.payload,fetchingLastRequestors:false});},FETCH_GET_LAST_REQUESTORS_OF_ACCREDITATION_REQUEST_DOMAIN_SUCCESS:function FETCH_GET_LAST_REQUESTORS_OF_ACCREDITATION_REQUEST_DOMAIN_SUCCESS(state,action){return Object.assign({},state,{lastRequestorsData:action.payload,errorLastRequestors:null,fetchingLastRequestors:false});}},initialState));//- Selectors
var getUnreferencedAccreditationRequests=function getUnreferencedAccreditationRequests(state){return state.unreferencedAccreditationRequests;};var loadingUnreferencedAccreditationRequests=function loadingUnreferencedAccreditationRequests(state){return getUnreferencedAccreditationRequests(state).fetching;};var getUnreferencedAccreditationRequestsData=function getUnreferencedAccreditationRequestsData(state){return getUnreferencedAccreditationRequests(state).data;};var getCurrentPageForAccreditationRequests=function getCurrentPageForAccreditationRequests(state){return getUnreferencedAccreditationRequests(state).currentPage;};var getTotalPagesForAccreditationRequests=function getTotalPagesForAccreditationRequests(state){return getUnreferencedAccreditationRequests(state).totalPages;};var getAccreditationRequestsFilterDomain=function getAccreditationRequestsFilterDomain(state){return getUnreferencedAccreditationRequests(state).filterDomain;};var getAccreditationRequestsFilterAG=function getAccreditationRequestsFilterAG(state){return getUnreferencedAccreditationRequests(state).filterAG;};var getAccreditationRequestsValidated=function getAccreditationRequestsValidated(state){return getUnreferencedAccreditationRequests(state).validated;};var loadingLastRequestorsOfAccreditationRequest=function loadingLastRequestorsOfAccreditationRequest(state){return getUnreferencedAccreditationRequests(state).fetchingLastRequestors;};var getLastRequestorsOfAccreditationRequestData=function getLastRequestorsOfAccreditationRequestData(state){return getUnreferencedAccreditationRequests(state).lastRequestorsData;};

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = from;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isPromise__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isArrayLike__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isInteropObservable__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_isIterable__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fromArray__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fromPromise__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fromIterable__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fromObservable__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_subscribeTo__ = __webpack_require__(221);
/** PURE_IMPORTS_START _Observable,_util_isPromise,_util_isArrayLike,_util_isInteropObservable,_util_isIterable,_fromArray,_fromPromise,_fromIterable,_fromObservable,_util_subscribeTo PURE_IMPORTS_END */










function from(input, scheduler) {
    if (!scheduler) {
        if (input instanceof __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */]) {
            return input;
        }
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](Object(__WEBPACK_IMPORTED_MODULE_9__util_subscribeTo__["a" /* subscribeTo */])(input));
    }
    if (input != null) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__util_isInteropObservable__["a" /* isInteropObservable */])(input)) {
            return Object(__WEBPACK_IMPORTED_MODULE_8__fromObservable__["a" /* fromObservable */])(input, scheduler);
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isPromise__["a" /* isPromise */])(input)) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__fromPromise__["a" /* fromPromise */])(input, scheduler);
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_2__util_isArrayLike__["a" /* isArrayLike */])(input)) {
            return Object(__WEBPACK_IMPORTED_MODULE_5__fromArray__["a" /* fromArray */])(input, scheduler);
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_4__util_isIterable__["a" /* isIterable */])(input) || typeof input === 'string') {
            return Object(__WEBPACK_IMPORTED_MODULE_7__fromIterable__["a" /* fromIterable */])(input, scheduler);
        }
    }
    throw new TypeError((input !== null && typeof input || input) + ' is not observable');
}
//# sourceMappingURL=from.js.map


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StorageApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var LOGIN_TOKEN_ID="brainchain_user_token";var USER_ID="brainchain_user_id";var LANGUAGE_ID="brainchain_lang";var LAST_USED_SUB_ROLE="brainchain_last_used_sub_role";var LAST_USED_GROUP="brainchain_last_used_group";var ANCHOR_SECURITY_GOT_IT="brainchain_anchor_security_got_it";var BANK_DATA_COUNTRY_CODE="brainchain_bank_data_country_code";var StorageApi=function(){function StorageApi(){_classCallCheck(this,StorageApi);}_createClass(StorageApi,null,[{key:"setLoginToken",value:function setLoginToken(token){localStorage.setItem(LOGIN_TOKEN_ID,token);}},{key:"removeLoginToken",value:function removeLoginToken(){localStorage.removeItem(LOGIN_TOKEN_ID);}},{key:"getLoginToken",value:function getLoginToken(){return localStorage.getItem(LOGIN_TOKEN_ID);}},{key:"isLoginTokenAvailable",value:function isLoginTokenAvailable(){return!!localStorage.getItem(LOGIN_TOKEN_ID);}},{key:"setUserId",value:function setUserId(id){localStorage.setItem(USER_ID,id);}},{key:"removeUserId",value:function removeUserId(){localStorage.removeItem(USER_ID);}},{key:"getUserId",value:function getUserId(){return localStorage.getItem(USER_ID);}},{key:"setLastUsedSubRole",value:function setLastUsedSubRole(subRole){localStorage.setItem(LAST_USED_SUB_ROLE,subRole);}},{key:"getLastUsedSubRole",value:function getLastUsedSubRole(){return localStorage.getItem(LAST_USED_SUB_ROLE);}},{key:"removeLastUsedSubRole",value:function removeLastUsedSubRole(){localStorage.removeItem(LAST_USED_SUB_ROLE);}},{key:"setLastUsedGroup",value:function setLastUsedGroup(group){localStorage.setItem(LAST_USED_GROUP,group);}},{key:"getLastUsedGroup",value:function getLastUsedGroup(){return localStorage.getItem(LAST_USED_GROUP);}},{key:"removeLastUsedGroup",value:function removeLastUsedGroup(){localStorage.removeItem(LAST_USED_GROUP);}},{key:"setAnchorSecurityGotIt",value:function setAnchorSecurityGotIt(){var data=JSON.parse(localStorage.getItem(ANCHOR_SECURITY_GOT_IT)||null);var id=this.getUserId();if(id){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(data)){data.push(id);}else{data=[id];}localStorage.setItem(ANCHOR_SECURITY_GOT_IT,JSON.stringify(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniq(data)));}}},{key:"getAnchorSecurityGotIt",value:function getAnchorSecurityGotIt(){var data=JSON.parse(localStorage.getItem(ANCHOR_SECURITY_GOT_IT)||null);var id=this.getUserId();return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(data)&&id&&data.includes(id);}},{key:"removeUserData",value:function removeUserData(){this.removeUserId();this.removeLastUsedSubRole();this.removeLastUsedGroup();}},{key:"setLanguage",value:function setLanguage(language){localStorage.setItem(LANGUAGE_ID,language);}},{key:"getLanguage",value:function getLanguage(){return localStorage.getItem(LANGUAGE_ID);}},{key:"getBankDataCountryCode",value:function getBankDataCountryCode(){return localStorage.getItem(BANK_DATA_COUNTRY_CODE);}},{key:"setBankDataCountryCode",value:function setBankDataCountryCode(countryCode){localStorage.setItem(BANK_DATA_COUNTRY_CODE,countryCode);}}]);return StorageApi;}();

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetLevelsFailed */
/* unused harmony export fetchGetLevelsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetLevels; });
/* unused harmony export clearLevels */
/* unused harmony export getLevels */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getLevelsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadingLevels; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
//- Actions
var fetchGetLevelsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_LEVELS_FAILED');var fetchGetLevelsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_LEVELS_SUCCESS');var fetchGetLevels=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_LEVELS',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getLevels();},function(){return{apiCall:true,onSuccess:fetchGetLevelsSuccess,onFail:fetchGetLevelsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var clearLevels=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_LEVELS');//- State
var initialState={data:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_LEVELS:function FETCH_GET_LEVELS(state){return Object.assign({},state,{data:null,error:null,fetching:true});},FETCH_GET_LEVELS_FAILED:function FETCH_GET_LEVELS_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_LEVELS_SUCCESS:function FETCH_GET_LEVELS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});},CLEAR_LEVELS:function CLEAR_LEVELS(state){return Object.assign({},state,{data:null});}},initialState));//- Selectors
var getLevels=function getLevels(state){return state.levels;};var getLevelsData=function getLevelsData(state){return getLevels(state).data;};var loadingLevels=function loadingLevels(state){return getLevels(state).fetching;};

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetGlobalCertificatesFailed */
/* unused harmony export fetchGetGlobalCertificatesSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchGetGlobalCertificates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAddGlobalCertificate; });
/* unused harmony export onAddGlobalCertificate */
/* unused harmony export onAddGlobalCertificateSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchRemoveGlobalCertificate; });
/* unused harmony export onRemoveGlobalCertificate */
/* unused harmony export onRemoveGlobalCertificateSuccess */
/* unused harmony export fetchGetOrgCertificatesFailed */
/* unused harmony export fetchGetOrgCertificatesSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchGetOrgCertificates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchAddOrgCertificate; });
/* unused harmony export onAddOrgCertificate */
/* unused harmony export onAddOrgCertificateSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchRemoveOrgCertificate; });
/* unused harmony export onRemoveOrgCertificate */
/* unused harmony export onRemoveOrgCertificateSuccess */
/* unused harmony export getCertificate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return loadingCertificate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getOrgCertificates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getGlobalCertificates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getOrgCertificateDataById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getGlobalCertificateDataById; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//- Actions
var fetchGetGlobalCertificatesFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_GLOBAL_CERTIFICATES_FAILED');var fetchGetGlobalCertificatesSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_GLOBAL_CERTIFICATES_SUCCESS');var fetchGetGlobalCertificates=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_GLOBAL_CERTIFICATES',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getGlobalCertificates();},function(){return{apiCall:true,onSuccess:fetchGetGlobalCertificatesSuccess,onFail:fetchGetGlobalCertificatesFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchAddGlobalCertificate=function fetchAddGlobalCertificate(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onAddGlobalCertificate(data));};};var onAddGlobalCertificate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_ADD_GLOBAL_CERTIFICATE',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].addGlobalCertificate(data);},function(){return{apiCall:true,onSuccess:onAddGlobalCertificateSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onAddGlobalCertificateSuccess=function onAddGlobalCertificateSuccess(){return function(dispatch){dispatch(fetchGetGlobalCertificates());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["k" /* resetSubmitFormData */])());};};var fetchRemoveGlobalCertificate=function fetchRemoveGlobalCertificate(certId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onRemoveGlobalCertificate(certId));};};var onRemoveGlobalCertificate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_GLOBAL_CERTIFICATE',function(certId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeGlobalCertificate(certId);},function(){return{apiCall:true,onSuccess:onRemoveGlobalCertificateSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onRemoveGlobalCertificateSuccess=function onRemoveGlobalCertificateSuccess(){return function(dispatch){dispatch(fetchGetGlobalCertificates());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["k" /* resetSubmitFormData */])());};};var fetchGetOrgCertificatesFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_CERTIFICATES_FAILED');var fetchGetOrgCertificatesSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_CERTIFICATES_SUCCESS');var fetchGetOrgCertificates=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_CERTIFICATES',function(orgId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getOrgCertificates(orgId);},function(){return{apiCall:true,onSuccess:fetchGetOrgCertificatesSuccess,onFail:fetchGetOrgCertificatesFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchAddOrgCertificate=function fetchAddOrgCertificate(orgId,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onAddOrgCertificate(orgId,data));};};var onAddOrgCertificate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_ADD_ORG_CERTIFICATE',function(orgId,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].addOrgCertificate(orgId,data);},function(orgId,data){return{apiCall:true,onSuccess:onAddOrgCertificateSuccess(orgId),onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onAddOrgCertificateSuccess=function onAddOrgCertificateSuccess(orgId){return function(){return function(dispatch){dispatch(fetchGetOrgCertificates(orgId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["k" /* resetSubmitFormData */])());};};};var fetchRemoveOrgCertificate=function fetchRemoveOrgCertificate(orgId,certId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onRemoveOrgCertificate(orgId,certId));};};var onRemoveOrgCertificate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_ORG_CERTIFICATE',function(orgId,certId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeOrgCertificate(orgId,certId);},function(orgId,certId){return{apiCall:true,onSuccess:onRemoveOrgCertificateSuccess(orgId),onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onRemoveOrgCertificateSuccess=function onRemoveOrgCertificateSuccess(orgId){return function(){return function(dispatch){dispatch(fetchGetOrgCertificates(orgId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["k" /* resetSubmitFormData */])());};};};//- State
var initialState={orgCertificates:null,globalCertificates:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_GLOBAL_CERTIFICATES:function FETCH_GET_GLOBAL_CERTIFICATES(state){return Object.assign({},state,{globalCertificates:null,error:null,fetching:true});},FETCH_GET_GLOBAL_CERTIFICATES_FAILED:function FETCH_GET_GLOBAL_CERTIFICATES_FAILED(state,action){return Object.assign({},state,{globalCertificates:null,error:action.payload,fetching:false});},FETCH_GET_GLOBAL_CERTIFICATES_SUCCESS:function FETCH_GET_GLOBAL_CERTIFICATES_SUCCESS(state,action){return Object.assign({},state,{globalCertificates:action.payload,error:null,fetching:false});},FETCH_GET_ORG_CERTIFICATES:function FETCH_GET_ORG_CERTIFICATES(state){return Object.assign({},state,{orgCertificates:null,error:null,fetching:true});},FETCH_GET_ORG_CERTIFICATES_FAILED:function FETCH_GET_ORG_CERTIFICATES_FAILED(state,action){return Object.assign({},state,{orgCertificates:null,error:action.payload,fetching:false});},FETCH_GET_ORG_CERTIFICATES_SUCCESS:function FETCH_GET_ORG_CERTIFICATES_SUCCESS(state,action){return Object.assign({},state,{orgCertificates:action.payload,error:null,fetching:false});}},initialState));//- Selectors
var getCertificate=function getCertificate(state){return state.orgCertificate;};var loadingCertificate=function loadingCertificate(state){return getCertificate(state).fetching;};var getOrgCertificates=function getOrgCertificates(state){return getCertificate(state).orgCertificates;};var getGlobalCertificates=function getGlobalCertificates(state){return getCertificate(state).globalCertificates;};var getOrgCertificateDataById=function getOrgCertificateDataById(state,certId){var data=getOrgCertificates(state);if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(data)){return null;}return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(data,function(elem){return elem.id===certId;});};var getGlobalCertificateDataById=function getGlobalCertificateDataById(state,certId){var data=getGlobalCertificates(state);if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(data)){return null;}return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(data,function(elem){return elem.id===certId;});};

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToArray__ = __webpack_require__(218);
/** PURE_IMPORTS_START _Observable,_Subscription,_util_subscribeToArray PURE_IMPORTS_END */



function fromArray(input, scheduler) {
    if (!scheduler) {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToArray__["a" /* subscribeToArray */])(input));
    }
    else {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
            var sub = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
            var i = 0;
            sub.add(scheduler.schedule(function () {
                if (i === input.length) {
                    subscriber.complete();
                    return;
                }
                subscriber.next(input[i++]);
                if (!subscriber.closed) {
                    sub.add(this.schedule());
                }
            }));
            return sub;
        });
    }
}
//# sourceMappingURL=fromArray.js.map


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InnerSubscriber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


var InnerSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        _this.index = 0;
        return _this;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));

//# sourceMappingURL=InnerSubscriber.js.map


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export onActivateSuccess */
/* unused harmony export onActivateAccount */
/* unused harmony export onSubmitFormFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchActivateAccount; });
/* unused harmony export onGetApplicantTokenSuccess */
/* unused harmony export fetchGetApplicantTokenSuccess */
/* unused harmony export fetchGetApplicantToken */
/* unused harmony export onGetApplicantToken */
/* unused harmony export fetchGetApplicantTokenFailed */
/* unused harmony export onResendActivation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchResendActivation; });
/* unused harmony export getApplicantToken */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTokenFromLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getInvitedApplicantDataFromLocation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_handleApiCall__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__login__ = __webpack_require__(17);
//- Actions
var onActivateSuccess=function onActivateSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__login__["k" /* logout */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());};};var onActivateAccount=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_ACTIVATE_ACCOUNT',function(token,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].activateAccount(token,data);},function(){return{apiCall:true,onSuccess:onActivateSuccess,onFail:onSubmitFormFailed};});var onSubmitFormFailed=function onSubmitFormFailed(error){return function(dispatch){if(error===__WEBPACK_IMPORTED_MODULE_4__common_handleApiCall__["c" /* UNAUTHORIZED */]){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */])("ACTIVATION_NOT_NEEDED"));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */])(error));}};};var fetchActivateAccount=function fetchActivateAccount(token,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onActivateAccount(token,data));};};var onGetApplicantTokenSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_APPLICANT_TOKEN_SUCCESS');var fetchGetApplicantTokenSuccess=function fetchGetApplicantTokenSuccess(data){return function(dispatch){//TODO: if we need to get role to check token type, do it by fetchGetUserDataByToken
// if (ROLES[role] !== ROLES.APPLICANT){
//     dispatch(fetchSubmitFormFailed("INCORRECT_ACCOUNT_TYPE"));
// } else {
dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["k" /* resetSubmitFormData */])());dispatch(onGetApplicantTokenSuccess(data.token));// }
};};//TODO: Api.getToken was changed! Need to refactor logic or remove unused code
var fetchGetApplicantToken=function fetchGetApplicantToken(login,password){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onGetApplicantToken(login,password));};};var onGetApplicantToken=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_APPLICANT_TOKEN',function(login,password){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getToken(login,password);},function(){return{apiCall:true,onSuccess:fetchGetApplicantTokenSuccess,onFail:fetchGetApplicantTokenFailed};});var fetchGetApplicantTokenFailed=function fetchGetApplicantTokenFailed(result){return function(dispatch){if(result===__WEBPACK_IMPORTED_MODULE_4__common_handleApiCall__["c" /* UNAUTHORIZED */]){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */])("INCORRECT_USERNAME_OR_PASSWORD"));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */])(result));}};};var onResendActivation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_RESEND_ACTIVATION',function(email){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].resendActivation(email);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */]};});var fetchResendActivation=function fetchResendActivation(email){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onResendActivation(email));};};//- State
var initialState={applicantToken:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_APPLICANT_TOKEN:function FETCH_GET_APPLICANT_TOKEN(state){return Object.assign({},state,{applicantToken:null});},FETCH_GET_APPLICANT_TOKEN_SUCCESS:function FETCH_GET_APPLICANT_TOKEN_SUCCESS(state,action){return Object.assign({},state,{applicantToken:action.payload});}},initialState));//- Selectors
var getApplicantToken=function getApplicantToken(state){return state.activation.applicantToken;};var getTokenFromLocation=function getTokenFromLocation(location){var searchParams=__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search);return searchParams.token;};var getInvitedApplicantDataFromLocation=function getInvitedApplicantDataFromLocation(location){var searchParams=__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search);if(searchParams&&searchParams.token&&searchParams.email){return searchParams;}return null;};

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DOMAIN_REGEXP_HTTP=/^(?:https?:)?(?:[\\/]{2})?(?:www\.)?([^\\/?]+)/;var DomainInput=function(_Component){_inherits(DomainInput,_Component);function DomainInput(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DomainInput);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DomainInput.__proto__||Object.getPrototypeOf(DomainInput)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(e){_this.props.onChange(e.target.value);},_this.handleBlur=function(e){var data=e.target.value;var domainMatch=data.match(DOMAIN_REGEXP_HTTP);if(domainMatch&&domainMatch.length>1){data=domainMatch[1];}if(_this.props.onBlur){_this.props.onBlur(data);}else{_this.props.onChange(data);}},_this.handleKeyDown=function(e){if(e.key==='Enter'){_this.handleBlur(e);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DomainInput,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'text',id:this.props.id||'',className:this.props.className||'domain-input',value:this.props.value||'',onChange:this.handleChange,onBlur:this.handleBlur,onKeyDown:this.handleKeyDown,placeholder:this.props.placeholder,disabled:this.props.disabled,required:this.props.required});}}]);return DomainInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DomainInput.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,required:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onBlur:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (DomainInput);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetStaffMembersFailed */
/* unused harmony export fetchGetStaffMembersSuccess */
/* unused harmony export onGetStaffMembersSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchGetStaffMembers; });
/* unused harmony export fetchGetAllStaffMembersFailed */
/* unused harmony export fetchGetAllStaffMembersSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetAllStaffMembers; });
/* unused harmony export onGetStaffMembersForCurrentPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchRegisterStaffMember; });
/* unused harmony export onRegisterStaffMemberSuccess */
/* unused harmony export onRegisterStaffMember */
/* unused harmony export onChangeAnchorSuccess */
/* unused harmony export onChangeAnchor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchChangeAnchor; });
/* unused harmony export fetchRemoveStaffMember */
/* unused harmony export onRemoveStaffMemberSuccess */
/* unused harmony export onRemoveStaffMember */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setStaffMemberToRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return removeStaffMember; });
/* unused harmony export getStaffMembers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return loadingStaffMembers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCurrentPageForStaff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getTotalPagesForStaff; });
/* unused harmony export getActiveStaffMembers */
/* unused harmony export getAllStaffMembersData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAllActiveStaffMembers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getStaffMembersData; });
/* unused harmony export getStaffMemberToRemoveId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getStaffMemberToRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getStaffMemberToRemoveName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAvailableStaffMembersForChangeAnchor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__account_userData__ = __webpack_require__(35);
//- Actions
var fetchGetStaffMembersFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_STAFF_MEMBERS_FAILED');var fetchGetStaffMembersSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_STAFF_MEMBERS_SUCCESS');var onGetStaffMembersSuccess=function onGetStaffMembersSuccess(data){return function(dispatch){var isEmpty=data.empty;var currentPage=data.number;if(!isEmpty&&currentPage!==0||currentPage===0){dispatch(fetchGetStaffMembersSuccess(data));}else{dispatch(fetchGetStaffMembers(currentPage-1));}};};var fetchGetStaffMembers=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_STAFF_MEMBERS',function(page,size){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getStaffMembers(page,size);},function(){return{apiCall:true,onSuccess:onGetStaffMembersSuccess,onFail:fetchGetStaffMembersFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var fetchGetAllStaffMembersFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ALL_STAFF_MEMBERS_FAILED');var fetchGetAllStaffMembersSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ALL_STAFF_MEMBERS_SUCCESS');// TODO: remove hardcoded values, add correct request for all active employees
var fetchGetAllStaffMembers=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ALL_STAFF_MEMBERS',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getStaffMembers(0,500);},function(){return{apiCall:true,onSuccess:fetchGetAllStaffMembersSuccess,onFail:fetchGetAllStaffMembersFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var onGetStaffMembersForCurrentPage=function onGetStaffMembersForCurrentPage(){return function(dispatch,getState){var currentPage=getCurrentPageForStaff(getState());dispatch(fetchGetStaffMembers(currentPage));};};var fetchRegisterStaffMember=function fetchRegisterStaffMember(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onRegisterStaffMember(data));};};var onRegisterStaffMemberSuccess=function onRegisterStaffMemberSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_activeModal__["_16" /* hideModal */])());dispatch(onGetStaffMembersForCurrentPage());};};var onRegisterStaffMember=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REGISTER_STAFF_MEMBER',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].registerStaff(data);},function(){return{apiCall:true,onSuccess:onRegisterStaffMemberSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var onChangeAnchorSuccess=function onChangeAnchorSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__account_role__["h" /* fetchGetSubRoles */])());};};var onChangeAnchor=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CHANGE_ANCHOR',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].changeAnchor(data);},function(){return{apiCall:true,onSuccess:onChangeAnchorSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var fetchChangeAnchor=function fetchChangeAnchor(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onChangeAnchor(data));};};var fetchRemoveStaffMember=function fetchRemoveStaffMember(staffMemberId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onRemoveStaffMember(staffMemberId));};};var onRemoveStaffMemberSuccess=function onRemoveStaffMemberSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_activeModal__["_16" /* hideModal */])());dispatch(onGetStaffMembersForCurrentPage());};};var onRemoveStaffMember=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_STAFF_MEMBER',function(staffMemberId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeStaffMember(staffMemberId);},function(){return{apiCall:true,onSuccess:onRemoveStaffMemberSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var setStaffMemberToRemove=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('STAFF_MEMBER_TO_REMOVE_SET',function(staffMemberId){return staffMemberId;});var removeStaffMember=function removeStaffMember(){return function(dispatch,getState){dispatch(fetchRemoveStaffMember(getStaffMemberToRemoveId(getState())));//dispatch(setStaffMemberToRemove(null));
};};//- State
var initialState={fetching:false,data:null,allStaffMembersData:null,allStaffMembersFetching:null,error:null,staffMemberToRemoveId:null,currentPage:null,totalPages:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_STAFF_MEMBERS:function FETCH_GET_STAFF_MEMBERS(state){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,error:null,fetching:true});},FETCH_GET_STAFF_MEMBERS_FAILED:function FETCH_GET_STAFF_MEMBERS_FAILED(state,action){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,error:action.payload,fetching:false});},FETCH_GET_STAFF_MEMBERS_SUCCESS:function FETCH_GET_STAFF_MEMBERS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload.content,currentPage:action.payload.number,totalPages:action.payload.totalPages,error:null,fetching:false});},STAFF_MEMBER_TO_REMOVE_SET:function STAFF_MEMBER_TO_REMOVE_SET(state,action){return Object.assign({},state,{staffMemberToRemoveId:action.payload});},FETCH_GET_ALL_STAFF_MEMBERS:function FETCH_GET_ALL_STAFF_MEMBERS(state){return Object.assign({},state,{allStaffMembersData:null,allStaffMembersFetching:true});},FETCH_GET_ALL_STAFF_MEMBERS_FAILED:function FETCH_GET_ALL_STAFF_MEMBERS_FAILED(state){return Object.assign({},state,{allStaffMembersData:null,allStaffMembersFetching:false});},FETCH_GET_ALL_STAFF_MEMBERS_SUCCESS:function FETCH_GET_ALL_STAFF_MEMBERS_SUCCESS(state,action){return Object.assign({},state,{allStaffMembersData:action.payload.content,allStaffMembersFetching:false});}},initialState));//- Selectors
var getStaffMembers=function getStaffMembers(state){return state.staffMembers;};var loadingStaffMembers=function loadingStaffMembers(state){return getStaffMembers(state).fetching;};var getCurrentPageForStaff=function getCurrentPageForStaff(state){return getStaffMembers(state).currentPage;};var getTotalPagesForStaff=function getTotalPagesForStaff(state){return getStaffMembers(state).totalPages;};var getActiveStaffMembers=function getActiveStaffMembers(state){return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(getStaffMembersData(state),function(member){return member.active;});};var getAllStaffMembersData=function getAllStaffMembersData(state){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(getStaffMembers(state).allStaffMembersData)){return null;}return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(getStaffMembers(state).allStaffMembersData,function(member){return{id:member.id,firstName:member.identityAlias.firstName,lastName:member.identityAlias.lastName,email:member.email,active:member.active};});};var getAllActiveStaffMembers=function getAllActiveStaffMembers(state){return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(getAllStaffMembersData(state),function(member){return member.active;});};var getStaffMembersData=function getStaffMembersData(state){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(getStaffMembers(state).data)){return null;}return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(getStaffMembers(state).data,function(member){return{id:member.id,firstName:member.identityAlias.firstName,lastName:member.identityAlias.lastName,email:member.email,active:member.active};});};var getStaffMemberToRemoveId=function getStaffMemberToRemoveId(state){return getStaffMembers(state).staffMemberToRemoveId;};var getStaffMemberToRemove=function getStaffMemberToRemove(state){return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(getStaffMembersData(state),function(member){return member.id===getStaffMemberToRemoveId(state);});};var getStaffMemberToRemoveName=function getStaffMemberToRemoveName(state){var staffMemberToRemove=getStaffMemberToRemove(state);if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(staffMemberToRemove)){return null;}return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(staffMemberToRemove.firstName)||__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(staffMemberToRemove.lastName)?staffMemberToRemove.email:staffMemberToRemove.firstName+" "+staffMemberToRemove.lastName;};var getAvailableStaffMembersForChangeAnchor=function getAvailableStaffMembersForChangeAnchor(state){var activeMembers=getAllActiveStaffMembers(state);var anchorId=Object(__WEBPACK_IMPORTED_MODULE_7__account_userData__["g" /* getUserId */])(state);return activeMembers.filter(function(member){return member.id!==anchorId;});};

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetTitleLangsFailed */
/* unused harmony export fetchGetTitleLangsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetTitleLangs; });
/* unused harmony export getTitleLangs */
/* unused harmony export getTitleLangsData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getOptionalTitleLangsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadingTitleLangs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
//- Actions
var fetchGetTitleLangsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_TITLE_LANGS_FAILED');var fetchGetTitleLangsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_TITLE_LANGS_SUCCESS');var fetchGetTitleLangs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_TITLE_LANGS',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getTitleCodes();},function(){return{apiCall:true,onSuccess:fetchGetTitleLangsSuccess,onFail:fetchGetTitleLangsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});//- State
var initialState={data:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_TITLE_LANGS:function FETCH_GET_TITLE_LANGS(state){return Object.assign({},state,{data:null,error:null,fetching:true});},FETCH_GET_TITLE_LANGS_FAILED:function FETCH_GET_TITLE_LANGS_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_TITLE_LANGS_SUCCESS:function FETCH_GET_TITLE_LANGS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});}},initialState));//- Selectors
var getTitleLangs=function getTitleLangs(state){return state.titleLangs;};var getTitleLangsData=function getTitleLangsData(state){return getTitleLangs(state).data;};var getOptionalTitleLangsData=function getOptionalTitleLangsData(state){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(getTitleLangsData(state))){return null;}return getTitleLangsData(state).optional;};var loadingTitleLangs=function loadingTitleLangs(state){return getTitleLangs(state).fetching;};

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetDuePaymentsForBAsFailed */
/* unused harmony export fetchGetDuePaymentsForBAsSuccess */
/* unused harmony export onFetchGetDuePaymentsForBAs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetDuePaymentsForBAs; });
/* unused harmony export fetchPayDuePaymentsForBASuccess */
/* unused harmony export onFetchPayDuePaymentsForBA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchPayDuePaymentsForBA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return onUpdateContinentFilterForBAsDuePayments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return updateContinentFilterForBAsDuePayments; });
/* unused harmony export fetchGetDuePaymentsForUniversitiesFailed */
/* unused harmony export fetchGetDuePaymentsForUniversitiesSuccess */
/* unused harmony export onGetDuePaymentsForUniversitiesSuccess */
/* unused harmony export onFetchGetDuePaymentsForUniversities */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetDuePaymentsForUniversities; });
/* unused harmony export fetchPayDuePaymentsForUniversitySuccess */
/* unused harmony export onFetchPayDuePaymentsForUniversity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchPayDuePaymentsForUniversity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return onUpdateCountryFilterForUniversitiesDuePayments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateCountryFilterForUniversitiesDuePayments; });
/* unused harmony export fetchGetDuePaymentsForSystemFailed */
/* unused harmony export fetchGetDuePaymentsForSystemSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return onFetchGetDuePaymentsForSystem; });
/* unused harmony export fetchPayDuePaymentForSystemSuccess */
/* unused harmony export onFetchPayDuePaymentsForSystem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchPayDuePaymentsForSystem; });
/* unused harmony export setNameFilterForBAsDuePayments */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return updateNameFilterForBAsDuePayments; });
/* unused harmony export setNameFilterForUniversitiesDuePayments */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return updateNameFilterForUniversitiesDuePayments; });
/* unused harmony export getDuePayments */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return loadingBAsDuePayments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getBAsDuePaymentsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getContinentFilterForBAsDuePayments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return loadingUniversitiesDuePayments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCurrentPageForUniversitiesDuePayments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getTotalPagesForUniversitiesDuePayments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getUniversitiesDuePaymentsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCountryFilterForUniversitiesDuePayments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getSystemDuePayments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return loadingSystemDuePayments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getNameFilterForBAsDuePayments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getNameFilterForUniversitiesDuePayments; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_location__ = __webpack_require__(21);
//- Actions
var fetchGetDuePaymentsForBAsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BA_S_DUE_PAYMENTS_FAILED');var fetchGetDuePaymentsForBAsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BA_S_DUE_PAYMENTS_SUCCESS');var onFetchGetDuePaymentsForBAs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BA_S_DUE_PAYMENTS',function(countries,name){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getDuePaymentsForBAs(countries,name);},function(){return{apiCall:true,onSuccess:fetchGetDuePaymentsForBAsSuccess,onFail:fetchGetDuePaymentsForBAsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var fetchGetDuePaymentsForBAs=function fetchGetDuePaymentsForBAs(){return function(dispatch,getState){var continentFilter=getContinentFilterForBAsDuePayments(getState());var countries=__WEBPACK_IMPORTED_MODULE_5__constants_constants__["k" /* LOCATION_MAP */][continentFilter];var name=getNameFilterForBAsDuePayments(getState());dispatch(onFetchGetDuePaymentsForBAs(countries,name));};};var fetchPayDuePaymentsForBASuccess=function fetchPayDuePaymentsForBASuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_activeModal__["_16" /* hideModal */])());dispatch(fetchGetDuePaymentsForBAs());};};var onFetchPayDuePaymentsForBA=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_PAY_BA_DUE_PAYMENTS',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].payDuePaymentsForBA(id,data);},function(){return{apiCall:true,onSuccess:fetchPayDuePaymentsForBASuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var fetchPayDuePaymentsForBA=function fetchPayDuePaymentsForBA(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onFetchPayDuePaymentsForBA(id,data));};};var onUpdateContinentFilterForBAsDuePayments=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_CONTINENT_FILTER_FOR_BA_S_DUE_PAYMENTS');var updateContinentFilterForBAsDuePayments=function updateContinentFilterForBAsDuePayments(continentFilter){return function(dispatch,getState){var countries=__WEBPACK_IMPORTED_MODULE_5__constants_constants__["k" /* LOCATION_MAP */][continentFilter];var name=getNameFilterForBAsDuePayments(getState());dispatch(onFetchGetDuePaymentsForBAs(countries,name));dispatch(onUpdateContinentFilterForBAsDuePayments(continentFilter));};};var fetchGetDuePaymentsForUniversitiesFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_UNI_S_DUE_PAYMENTS_FAILED');var fetchGetDuePaymentsForUniversitiesSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_UNI_S_DUE_PAYMENTS_SUCCESS');var onGetDuePaymentsForUniversitiesSuccess=function onGetDuePaymentsForUniversitiesSuccess(data){return function(dispatch){var isEmpty=data.empty;var currentPage=data.number;if(!isEmpty&&currentPage!==0||currentPage===0){dispatch(fetchGetDuePaymentsForUniversitiesSuccess(data));}else{dispatch(fetchGetDuePaymentsForUniversities(currentPage-1));}};};var onFetchGetDuePaymentsForUniversities=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_UNI_S_DUE_PAYMENTS',function(page,countries,name){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getDuePaymentsForUniversities(page,countries,name);},function(){return{apiCall:true,onSuccess:onGetDuePaymentsForUniversitiesSuccess,onFail:fetchGetDuePaymentsForUniversitiesFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var fetchGetDuePaymentsForUniversities=function fetchGetDuePaymentsForUniversities(page){return function(dispatch,getState){var countryCode=getCountryFilterForUniversitiesDuePayments(getState());var name=getNameFilterForUniversitiesDuePayments(getState());dispatch(onFetchGetDuePaymentsForUniversities(page,!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(countryCode)?[countryCode]:null,name));};};var fetchPayDuePaymentsForUniversitySuccess=function fetchPayDuePaymentsForUniversitySuccess(){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_activeModal__["_16" /* hideModal */])());var currentPage=getCurrentPageForUniversitiesDuePayments(getState());dispatch(fetchGetDuePaymentsForUniversities(currentPage));};};var onFetchPayDuePaymentsForUniversity=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_PAY_UNI_DUE_PAYMENTS',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].payDuePaymentsForUniversity(id,data);},function(){return{apiCall:true,onSuccess:fetchPayDuePaymentsForUniversitySuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var fetchPayDuePaymentsForUniversity=function fetchPayDuePaymentsForUniversity(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onFetchPayDuePaymentsForUniversity(id,data));};};var onUpdateCountryFilterForUniversitiesDuePayments=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_CONTINENT_FILTER_FOR_UNI_S_DUE_PAYMENTS');var updateCountryFilterForUniversitiesDuePayments=function updateCountryFilterForUniversitiesDuePayments(countryCode){return function(dispatch,getState){var countriesList=countryCode?[countryCode]:Object(__WEBPACK_IMPORTED_MODULE_7__common_location__["e" /* getCountriesData */])(getState());var currentPage=getCurrentPageForUniversitiesDuePayments(getState());var name=getNameFilterForUniversitiesDuePayments(getState());dispatch(onFetchGetDuePaymentsForUniversities(currentPage,countriesList,name));dispatch(onUpdateCountryFilterForUniversitiesDuePayments(countryCode));};};var fetchGetDuePaymentsForSystemFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_SYSTEM_DUE_PAYMENTS_FAILED');var fetchGetDuePaymentsForSystemSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_SYSTEM_DUE_PAYMENTS_SUCCESS');var onFetchGetDuePaymentsForSystem=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_SYSTEM_DUE_PAYMENTS',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getDuePaymentsForSystem();},function(){return{apiCall:true,onSuccess:fetchGetDuePaymentsForSystemSuccess,onFail:fetchGetDuePaymentsForSystemFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var fetchPayDuePaymentForSystemSuccess=function fetchPayDuePaymentForSystemSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_activeModal__["_16" /* hideModal */])());dispatch(onFetchGetDuePaymentsForSystem());};};var onFetchPayDuePaymentsForSystem=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_PAY_SYSTEM_DUE_PAYMENTS',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].payDuePaymentForSystem(data);},function(){return{apiCall:true,onSuccess:fetchPayDuePaymentForSystemSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var fetchPayDuePaymentsForSystem=function fetchPayDuePaymentsForSystem(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onFetchPayDuePaymentsForSystem(data));};};var setNameFilterForBAsDuePayments=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('NAME_FILTER_FOR_BAS_DUE_PAYMENTS_SET');var updateNameFilterForBAsDuePayments=function updateNameFilterForBAsDuePayments(name){return function(dispatch,getState){var continentFilter=getContinentFilterForBAsDuePayments(getState());var countries=__WEBPACK_IMPORTED_MODULE_5__constants_constants__["k" /* LOCATION_MAP */][continentFilter];dispatch(onFetchGetDuePaymentsForBAs(countries,name));dispatch(setNameFilterForBAsDuePayments(name));};};var setNameFilterForUniversitiesDuePayments=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('NAME_FILTER_FOR_UNIVERSITIES_DUE_PAYMENTS_SET');var updateNameFilterForUniversitiesDuePayments=function updateNameFilterForUniversitiesDuePayments(name){return function(dispatch,getState){var countryCode=getCountryFilterForUniversitiesDuePayments(getState());var currentPage=getCurrentPageForUniversitiesDuePayments(getState());dispatch(onFetchGetDuePaymentsForUniversities(currentPage,!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(countryCode)?[countryCode]:null,name));dispatch(setNameFilterForUniversitiesDuePayments(name));};};//- State
var initialState={BAsData:null,BAsContinentFilter:null,BAsFetching:false,BAsError:null,BAsNameFilter:'',universitiesData:null,universitiesCountryFilter:null,universitiesFetching:false,universitiesError:null,universitiesCurrentPage:null,universitiesTotalPages:null,universitiesNameFilter:'',systemData:null,systemFetching:false,systemError:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_BA_S_DUE_PAYMENTS:function FETCH_GET_BA_S_DUE_PAYMENTS(state){return Object.assign({},state,{BAsData:null,BAsError:null,BAsFetching:true});},FETCH_GET_BA_S_DUE_PAYMENTS_FAILED:function FETCH_GET_BA_S_DUE_PAYMENTS_FAILED(state,action){return Object.assign({},state,{BAsData:null,BAsError:action.payload,BAsFetching:false});},FETCH_GET_BA_S_DUE_PAYMENTS_SUCCESS:function FETCH_GET_BA_S_DUE_PAYMENTS_SUCCESS(state,action){return Object.assign({},state,{BAsData:action.payload.content,BAsError:null,BAsFetching:false});},FETCH_GET_UNI_S_DUE_PAYMENTS:function FETCH_GET_UNI_S_DUE_PAYMENTS(state){return Object.assign({},state,{universitiesData:null,universitiesCurrentPage:null,universitiesTotalPages:null,universitiesError:null,universitiesFetching:true});},FETCH_GET_UNI_S_DUE_PAYMENTS_FAILED:function FETCH_GET_UNI_S_DUE_PAYMENTS_FAILED(state,action){return Object.assign({},state,{universitiesData:null,universitiesCurrentPage:null,universitiesTotalPages:null,universitiesError:action.payload,universitiesFetching:false});},FETCH_GET_UNI_S_DUE_PAYMENTS_SUCCESS:function FETCH_GET_UNI_S_DUE_PAYMENTS_SUCCESS(state,action){return Object.assign({},state,{universitiesData:action.payload.content,universitiesCurrentPage:action.payload.number,universitiesTotalPages:action.payload.totalPages,universitiesError:null,universitiesFetching:false});},UPDATE_CONTINENT_FILTER_FOR_BA_S_DUE_PAYMENTS:function UPDATE_CONTINENT_FILTER_FOR_BA_S_DUE_PAYMENTS(state,action){return Object.assign({},state,{BAsContinentFilter:action.payload});},UPDATE_CONTINENT_FILTER_FOR_UNI_S_DUE_PAYMENTS:function UPDATE_CONTINENT_FILTER_FOR_UNI_S_DUE_PAYMENTS(state,action){return Object.assign({},state,{universitiesCountryFilter:action.payload});},FETCH_GET_SYSTEM_DUE_PAYMENTS:function FETCH_GET_SYSTEM_DUE_PAYMENTS(state){return Object.assign({},state,{systemData:null,systemFetching:true,systemError:null});},FETCH_GET_SYSTEM_DUE_PAYMENTS_SUCCESS:function FETCH_GET_SYSTEM_DUE_PAYMENTS_SUCCESS(state,action){return Object.assign({},state,{systemData:action.payload,systemFetching:false,systemError:null});},FETCH_GET_SYSTEM_DUE_PAYMENTS_FAILED:function FETCH_GET_SYSTEM_DUE_PAYMENTS_FAILED(state,action){return Object.assign({},state,{systemFetching:false,systemError:action.payload});},NAME_FILTER_FOR_BAS_DUE_PAYMENTS_SET:function NAME_FILTER_FOR_BAS_DUE_PAYMENTS_SET(state,action){return Object.assign({},state,{BAsNameFilter:action.payload});},NAME_FILTER_FOR_UNIVERSITIES_DUE_PAYMENTS_SET:function NAME_FILTER_FOR_UNIVERSITIES_DUE_PAYMENTS_SET(state,action){return Object.assign({},state,{universitiesNameFilter:action.payload});}},initialState));//- Selectors
var getDuePayments=function getDuePayments(state){return state.duePayments;};var loadingBAsDuePayments=function loadingBAsDuePayments(state){return getDuePayments(state).BAsFetching;};var getBAsDuePaymentsData=function getBAsDuePaymentsData(state){var data=getDuePayments(state).BAsData;if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(data)){return null;}return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(data,function(elem){var total=[];var transactionsByType=elem.transactionStatistic[__WEBPACK_IMPORTED_MODULE_5__constants_constants__["w" /* TRANSACTION_TYPES */].PAYED_CONSENT_REQUEST_REMUNERATION]||[];__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(transactionsByType,function(transaction){var index=total.findIndex(function(el){return el.currency===transaction.currency;});if(index!==-1){total[index].amount-=transaction.amount;}else{total.push({currency:transaction.currency,amount:Math.abs(transaction.amount)});}});return{id:elem.target.id,name:elem.target.firstName+" "+elem.target.lastName,paymentAmount:elem.target.balance,totalPay:total,wireData:elem.target.financialData};});};var getContinentFilterForBAsDuePayments=function getContinentFilterForBAsDuePayments(state){return getDuePayments(state).BAsContinentFilter;};var loadingUniversitiesDuePayments=function loadingUniversitiesDuePayments(state){return getDuePayments(state).universitiesFetching;};var getCurrentPageForUniversitiesDuePayments=function getCurrentPageForUniversitiesDuePayments(state){return getDuePayments(state).universitiesCurrentPage;};var getTotalPagesForUniversitiesDuePayments=function getTotalPagesForUniversitiesDuePayments(state){return getDuePayments(state).universitiesTotalPages;};var getUniversitiesDuePaymentsData=function getUniversitiesDuePaymentsData(state){var data=getDuePayments(state).universitiesData;if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(data)){return null;}return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(data,function(elem){var total=[];var transactionsByType=elem.transactionStatistic[__WEBPACK_IMPORTED_MODULE_5__constants_constants__["w" /* TRANSACTION_TYPES */].PAYED_CONSENT_REQUEST_REMUNERATION]||[];__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(transactionsByType,function(transaction){var index=total.findIndex(function(el){return el.currency===transaction.currency;});if(index!==-1){total[index].amount-=transaction.amount;}else{total.push({currency:transaction.currency,amount:-transaction.amount});}});return{id:elem.target.id,name:elem.target.name,paymentAmount:elem.target.balance,totalPay:total,wireData:elem.target.financialData};});};var getCountryFilterForUniversitiesDuePayments=function getCountryFilterForUniversitiesDuePayments(state){return getDuePayments(state).universitiesCountryFilter;};var getSystemDuePayments=function getSystemDuePayments(state){var data=getDuePayments(state).systemData;if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(data)){return null;}var total=[];var transactionsByType=data.transactionStatistic[__WEBPACK_IMPORTED_MODULE_5__constants_constants__["w" /* TRANSACTION_TYPES */].PAYED_CONSENT_REQUEST_REMUNERATION]||[];__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(transactionsByType,function(transaction){var index=total.findIndex(function(el){return el.currency===transaction.currency;});if(index!==-1){total[index].amount-=transaction.amount;}else{total.push({currency:transaction.currency,amount:-transaction.amount});}});return[{id:data.target.id,paymentAmount:data.target.balance,totalPay:total}];};var loadingSystemDuePayments=function loadingSystemDuePayments(state){return getDuePayments(state).systemFetching;};var getNameFilterForBAsDuePayments=function getNameFilterForBAsDuePayments(state){return getDuePayments(state).BAsNameFilter;};var getNameFilterForUniversitiesDuePayments=function getNameFilterForUniversitiesDuePayments(state){return getDuePayments(state).universitiesNameFilter;};

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetCurrenciesFailed */
/* unused harmony export fetchGetCurrenciesSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetCurrencies; });
/* unused harmony export fetchConvertMoneyFailed */
/* unused harmony export fetchConvertMoneySuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchConvertMoney; });
/* unused harmony export getCurrencies */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCurrenciesData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getConvertedMoney; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
//- Actions
var fetchGetCurrenciesFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_CURRENCIES_FAILED');var fetchGetCurrenciesSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_CURRENCIES_SUCCESS');var fetchGetCurrencies=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_CURRENCIES',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getCurrencies();},function(){return{apiCall:true,onSuccess:fetchGetCurrenciesSuccess,onFail:fetchGetCurrenciesFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchConvertMoneyFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CONVERT_MONEY_FAILED');var fetchConvertMoneySuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CONVERT_MONEY_SUCCESS');var fetchConvertMoney=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CONVERT_MONEY',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].convertMoney(data);},function(){return{apiCall:true,onSuccess:fetchConvertMoneySuccess,onFail:fetchConvertMoneyFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});//- State
var initialState={data:null,convertedMoneyData:null,fetchingConvert:false,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_CURRENCIES:function FETCH_GET_CURRENCIES(state){return Object.assign({},state,{data:null,error:null,fetching:true});},FETCH_GET_CURRENCIES_FAILED:function FETCH_GET_CURRENCIES_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_CURRENCIES_SUCCESS:function FETCH_GET_CURRENCIES_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});},FETCH_CONVERT_MONEY:function FETCH_CONVERT_MONEY(state){return Object.assign({},state,{convertedMoneyData:null,error:null,fetchingConvert:true});},FETCH_CONVERT_MONEY_FAILED:function FETCH_CONVERT_MONEY_FAILED(state,action){return Object.assign({},state,{convertedMoneyData:null,error:action.payload,fetchingConvert:false});},FETCH_CONVERT_MONEY_SUCCESS:function FETCH_CONVERT_MONEY_SUCCESS(state,action){return Object.assign({},state,{convertedMoneyData:action.payload.amount,error:null,fetchingConvert:false});}},initialState));//- Selectors
var getCurrencies=function getCurrencies(state){return state.currencies;};var getCurrenciesData=function getCurrenciesData(state){return getCurrencies(state).data;};var getConvertedMoney=function getConvertedMoney(state){return getCurrencies(state).convertedMoneyData;};

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetAliasesFailed */
/* unused harmony export fetchGetAliasesSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchGetAliases; });
/* unused harmony export fetchGetDefaultAliasFailed */
/* unused harmony export fetchGetDefaultAliasSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchGetDefaultAlias; });
/* unused harmony export onChangeAliasSuccess */
/* unused harmony export onUpdateDefaultAliasSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchUpdateDefaultAlias; });
/* unused harmony export onUpdateDefaultAlias */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchUpdateAlias; });
/* unused harmony export onUpdateAlias */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchAddAlias; });
/* unused harmony export onAddAlias */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchRemoveAlias; });
/* unused harmony export onRemoveAlias */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchSetDefaultAlias; });
/* unused harmony export onSetDefaultAlias */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearDefaultAlias; });
/* unused harmony export getAliases */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return loadingAliases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getAliasesData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getDefaultAliasData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getAliasDataById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getDefaultAliasName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//- Actions
var fetchGetAliasesFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ALIASES_FAILED');var fetchGetAliasesSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ALIASES_SUCCESS');var fetchGetAliases=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ALIASES',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAliases();},function(){return{apiCall:true,onSuccess:fetchGetAliasesSuccess,onFail:fetchGetAliasesFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchGetDefaultAliasFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_DEFAULT_ALIAS_FAILED');var fetchGetDefaultAliasSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_DEFAULT_ALIAS_SUCCESS');var fetchGetDefaultAlias=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_DEFAULT_ALIAS',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getDefaultAlias();},function(){return{apiCall:true,onSuccess:fetchGetDefaultAliasSuccess,onFail:fetchGetDefaultAliasFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onChangeAliasSuccess=function onChangeAliasSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__common_activeModal__["_16" /* hideModal */])());dispatch(fetchGetAliases());};};var onUpdateDefaultAliasSuccess=function onUpdateDefaultAliasSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(fetchGetDefaultAlias());};};var fetchUpdateDefaultAlias=function fetchUpdateDefaultAlias(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onUpdateDefaultAlias(id,data));};};var onUpdateDefaultAlias=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_UPDATE_DEFAULT_ALIAS',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateAlias(id,data);},function(){return{apiCall:true,onSuccess:onUpdateDefaultAliasSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchUpdateAlias=function fetchUpdateAlias(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onUpdateAlias(id,data));};};var onUpdateAlias=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_UPDATE_ALIAS',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateAlias(id,data);},function(){return{apiCall:true,onSuccess:onChangeAliasSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchAddAlias=function fetchAddAlias(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onAddAlias(data));};};var onAddAlias=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_ADD_ALIAS',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].addAlias(data);},function(){return{apiCall:true,onSuccess:onChangeAliasSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchRemoveAlias=function fetchRemoveAlias(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onRemoveAlias(id));};};var onRemoveAlias=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_ALIAS',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeAlias(id);},function(){return{apiCall:true,onSuccess:onChangeAliasSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchSetDefaultAlias=function fetchSetDefaultAlias(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onSetDefaultAlias(data));};};var onSetDefaultAlias=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_SET_DEFAULT_ALIAS',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].setDefaultAlias(data);},function(){return{apiCall:true,onSuccess:onChangeAliasSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var clearDefaultAlias=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_DEFAULT_ALIAS');//- State
var initialState={fetching:false,data:null,defaultAliasData:null,error:null};//- Reducers
/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_ALIASES:function FETCH_GET_ALIASES(state){return Object.assign({},state,{data:null,error:null,fetching:true});},FETCH_GET_ALIASES_FAILED:function FETCH_GET_ALIASES_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_ALIASES_SUCCESS:function FETCH_GET_ALIASES_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});},FETCH_GET_DEFAULT_ALIAS:function FETCH_GET_DEFAULT_ALIAS(state){return Object.assign({},state,{error:null,fetching:true});},FETCH_GET_DEFAULT_ALIAS_FAILED:function FETCH_GET_DEFAULT_ALIAS_FAILED(state,action){return Object.assign({},state,{defaultAliasData:null,error:action.payload,fetching:false});},FETCH_GET_DEFAULT_ALIAS_SUCCESS:function FETCH_GET_DEFAULT_ALIAS_SUCCESS(state,action){return Object.assign({},state,{defaultAliasData:action.payload,error:null,fetching:false});},CLEAR_DEFAULT_ALIAS:function CLEAR_DEFAULT_ALIAS(state){return Object.assign({},state,{defaultAliasData:null});}},initialState));//- Selectors
var getAliases=function getAliases(state){return state.aliases;};var loadingAliases=function loadingAliases(state){return getAliases(state).fetching;};var getAliasesData=function getAliasesData(state){return getAliases(state).data;};var getDefaultAliasData=function getDefaultAliasData(state){return getAliases(state).defaultAliasData;};var getAliasDataById=function getAliasDataById(state,id){if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(getAliasesData(state))){return null;}return getAliasesData(state).find(function(elem){return elem.id===id;});};var getDefaultAliasName=function getDefaultAliasName(state){var defaultAlias=getDefaultAliasData(state);if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(defaultAlias)){return null;}return{firstName:defaultAlias.firstName,lastName:defaultAlias.lastName};};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(137);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(107);
util.inherits = __webpack_require__(84);
/*</replacement>*/

var Readable = __webpack_require__(301);
var Writable = __webpack_require__(185);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AVAILABLE_MANAGED_OPTIONS; });
/* unused harmony export fetchGetValidatedDomainsSuccess */
/* unused harmony export fetchGetValidatedDomainsFailed */
/* unused harmony export onFetchGetValidatedDomains */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetValidatedDomains; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchGetValidatedDomainsByCountry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchGetValidatedDomainsByNameAndDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setValidatedDomainsCountryFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setValidatedDomainsNameFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setValidatedDomainsDomainFilter; });
/* unused harmony export fetchValidatedDomainSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return onFetchAddValidatedDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return onFetchEditValidatedDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return onFetchRemoveValidatedDomain; });
/* unused harmony export getValidatedDomains */
/* unused harmony export getValidatedDomainsCountryFilter */
/* unused harmony export getValidatedDomainsNameFilter */
/* unused harmony export getValidatedDomainsDomainFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getValidatedDomainsCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getValidatedDomainsTotalPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return loadingValidatedDomains; });
/* unused harmony export getValidatedDomainsData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getValidatedDomainsFormattedData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var AVAILABLE_MANAGED_OPTIONS={SELF_MANAGED:'self_managed',BAVA_MANAGED:'bava_managed'};//- Actions
var fetchGetValidatedDomainsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_VALIDATED_DOMAINS_SUCCESS');var fetchGetValidatedDomainsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_VALIDATED_DOMAINS_FAILED');var onFetchGetValidatedDomains=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_VALIDATED_DOMAINS',function(countryCode,name,domain,page){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getValidatedDomains(countryCode,name,domain,page);},function(){return{apiCall:true,onSuccess:fetchGetValidatedDomainsSuccess,onFail:fetchGetValidatedDomainsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchGetValidatedDomains=function fetchGetValidatedDomains(page){return function(dispatch,getState){var countryCode=getValidatedDomainsCountryFilter(getState());var name=getValidatedDomainsNameFilter(getState());var domain=getValidatedDomainsDomainFilter(getState());dispatch(onFetchGetValidatedDomains(countryCode,name,domain,page));};};var fetchGetValidatedDomainsByCountry=function fetchGetValidatedDomainsByCountry(countryCode){return function(dispatch,getState){var name=getValidatedDomainsNameFilter(getState());var domain=getValidatedDomainsDomainFilter(getState());dispatch(setValidatedDomainsCountryFilter(countryCode));dispatch(onFetchGetValidatedDomains(countryCode,name,domain));};};var fetchGetValidatedDomainsByNameAndDomain=function fetchGetValidatedDomainsByNameAndDomain(name,domain){return function(dispatch,getState){var countryCode=getValidatedDomainsCountryFilter(getState());dispatch(setValidatedDomainsNameFilter(name));dispatch(setValidatedDomainsDomainFilter(domain));dispatch(onFetchGetValidatedDomains(countryCode,name,domain));};};var setValidatedDomainsCountryFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_VALIDATED_DOMAINS_COUNTRY_FILTER',function(countryCode){return countryCode;});var setValidatedDomainsNameFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_VALIDATED_DOMAINS_NAME_FILTER',function(name){return name;});var setValidatedDomainsDomainFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_VALIDATED_DOMAINS_DOMAIN_FILTER',function(domain){return domain;});var fetchValidatedDomainSuccess=function fetchValidatedDomainSuccess(){return function(dispatch){dispatch(fetchGetValidatedDomains());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */])());};};var onFetchAddValidatedDomain=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_ADD_VALIDATED_DOMAIN',function(data,bavaManaged){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].addValidatedDomain(data,bavaManaged);},function(){return{apiCall:true,onSuccess:fetchValidatedDomainSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onFetchEditValidatedDomain=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_ADD_VALIDATED_DOMAIN',function(domain,data,bavaManaged){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].editValidatedDomain(domain,data,bavaManaged);},function(){return{apiCall:true,onSuccess:fetchValidatedDomainSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onFetchRemoveValidatedDomain=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_VALIDATED_DOMAIN',function(domain,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeValidatedDomain(domain,data);},function(){return{apiCall:true,onSuccess:fetchValidatedDomainSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});//- State
var initialState={data:null,error:null,fetching:false,currentPage:null,totalPages:null,filterCountry:null,filterName:null,filterDomain:null};//- Reducers
/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_VALIDATED_DOMAINS:function FETCH_GET_VALIDATED_DOMAINS(state){return Object.assign({},state,{error:null,fetching:true,currentPage:null,totalPages:null});},FETCH_GET_VALIDATED_DOMAINS_SUCCESS:function FETCH_GET_VALIDATED_DOMAINS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload.content,error:null,fetching:false,currentPage:action.payload.number,totalPages:action.payload.totalPages});},FETCH_GET_VALIDATED_DOMAINS_FAILED:function FETCH_GET_VALIDATED_DOMAINS_FAILED(state,action){return Object.assign({},state,{error:action.payload,fetching:false});},SET_VALIDATED_DOMAINS_COUNTRY_FILTER:function SET_VALIDATED_DOMAINS_COUNTRY_FILTER(state,action){return Object.assign({},state,{filterCountry:action.payload});},SET_VALIDATED_DOMAINS_NAME_FILTER:function SET_VALIDATED_DOMAINS_NAME_FILTER(state,action){return Object.assign({},state,{filterName:action.payload});},SET_VALIDATED_DOMAINS_DOMAIN_FILTER:function SET_VALIDATED_DOMAINS_DOMAIN_FILTER(state,action){return Object.assign({},state,{filterDomain:action.payload});}},initialState));//- Selectors
var getValidatedDomains=function getValidatedDomains(state){return state.validatedDomains;};var getValidatedDomainsCountryFilter=function getValidatedDomainsCountryFilter(state){return getValidatedDomains(state).filterCountry;};var getValidatedDomainsNameFilter=function getValidatedDomainsNameFilter(state){return getValidatedDomains(state).filterName;};var getValidatedDomainsDomainFilter=function getValidatedDomainsDomainFilter(state){return getValidatedDomains(state).filterDomain;};var getValidatedDomainsCurrentPage=function getValidatedDomainsCurrentPage(state){return getValidatedDomains(state).currentPage;};var getValidatedDomainsTotalPages=function getValidatedDomainsTotalPages(state){return getValidatedDomains(state).totalPages;};var loadingValidatedDomains=function loadingValidatedDomains(state){return getValidatedDomains(state).fetching;};var getValidatedDomainsData=function getValidatedDomainsData(state){return getValidatedDomains(state).data;};var getValidatedDomainsFormattedData=function getValidatedDomainsFormattedData(state){var data=getValidatedDomainsData(state);if(!data){return null;}return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(data,function(validatedDomain){return{requestsNumber:validatedDomain.amount,orgType:validatedDomain.organization.type,orgName:validatedDomain.organization.name,orgDomain:validatedDomain.organization.domain,orgCountry:validatedDomain.organization.address.countryCode,orgCity:validatedDomain.organization.address.city,orgPostal:validatedDomain.organization.address.postal,orgStreet:validatedDomain.organization.address.street,fullyRegistered:validatedDomain.organization.fullyRegistered,contactName:validatedDomain.organization.contacts.name,contactEmail:validatedDomain.organization.contacts.email,contactPhone:validatedDomain.organization.contacts.phone,managedBy:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(validatedDomain.organization.managingOrganizationId)?AVAILABLE_MANAGED_OPTIONS.SELF_MANAGED:AVAILABLE_MANAGED_OPTIONS.BAVA_MANAGED};});};

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_Observable__ = __webpack_require__(26);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_Observable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_observable_ConnectableObservable__ = __webpack_require__(211);
/* unused harmony reexport ConnectableObservable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_operators_groupBy__ = __webpack_require__(213);
/* unused harmony reexport GroupedObservable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_symbol_observable__ = __webpack_require__(72);
/* unused harmony reexport observable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_Subject__ = __webpack_require__(40);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_Subject__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_BehaviorSubject__ = __webpack_require__(214);
/* unused harmony reexport BehaviorSubject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_ReplaySubject__ = __webpack_require__(153);
/* unused harmony reexport ReplaySubject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internal_AsyncSubject__ = __webpack_require__(119);
/* unused harmony reexport AsyncSubject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_scheduler_asap__ = __webpack_require__(219);
/* unused harmony reexport asapScheduler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__internal_scheduler_async__ = __webpack_require__(43);
/* unused harmony reexport asyncScheduler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__internal_scheduler_queue__ = __webpack_require__(215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__internal_scheduler_queue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__internal_scheduler_animationFrame__ = __webpack_require__(362);
/* unused harmony reexport animationFrameScheduler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__internal_scheduler_VirtualTimeScheduler__ = __webpack_require__(365);
/* unused harmony reexport VirtualTimeScheduler */
/* unused harmony reexport VirtualAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__internal_Scheduler__ = __webpack_require__(216);
/* unused harmony reexport Scheduler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__internal_Subscription__ = __webpack_require__(34);
/* unused harmony reexport Subscription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__internal_Subscriber__ = __webpack_require__(23);
/* unused harmony reexport Subscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__internal_Notification__ = __webpack_require__(118);
/* unused harmony reexport Notification */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__internal_util_pipe__ = __webpack_require__(151);
/* unused harmony reexport pipe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__internal_util_noop__ = __webpack_require__(116);
/* unused harmony reexport noop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__internal_util_identity__ = __webpack_require__(73);
/* unused harmony reexport identity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__internal_util_isObservable__ = __webpack_require__(366);
/* unused harmony reexport isObservable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__internal_util_ArgumentOutOfRangeError__ = __webpack_require__(92);
/* unused harmony reexport ArgumentOutOfRangeError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__internal_util_EmptyError__ = __webpack_require__(93);
/* unused harmony reexport EmptyError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__internal_util_ObjectUnsubscribedError__ = __webpack_require__(117);
/* unused harmony reexport ObjectUnsubscribedError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__internal_util_UnsubscriptionError__ = __webpack_require__(210);
/* unused harmony reexport UnsubscriptionError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__internal_util_TimeoutError__ = __webpack_require__(220);
/* unused harmony reexport TimeoutError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__internal_observable_bindCallback__ = __webpack_require__(367);
/* unused harmony reexport bindCallback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__internal_observable_bindNodeCallback__ = __webpack_require__(368);
/* unused harmony reexport bindNodeCallback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__internal_observable_combineLatest__ = __webpack_require__(157);
/* unused harmony reexport combineLatest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__internal_observable_concat__ = __webpack_require__(120);
/* unused harmony reexport concat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__internal_observable_defer__ = __webpack_require__(159);
/* unused harmony reexport defer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__internal_observable_empty__ = __webpack_require__(42);
/* unused harmony reexport empty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__internal_observable_forkJoin__ = __webpack_require__(374);
/* unused harmony reexport forkJoin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__internal_observable_from__ = __webpack_require__(55);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_33__internal_observable_from__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__internal_observable_fromEvent__ = __webpack_require__(375);
/* unused harmony reexport fromEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__internal_observable_fromEventPattern__ = __webpack_require__(376);
/* unused harmony reexport fromEventPattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__internal_observable_generate__ = __webpack_require__(377);
/* unused harmony reexport generate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__internal_observable_iif__ = __webpack_require__(378);
/* unused harmony reexport iif */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__internal_observable_interval__ = __webpack_require__(379);
/* unused harmony reexport interval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__internal_observable_merge__ = __webpack_require__(228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_39__internal_observable_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__internal_observable_never__ = __webpack_require__(229);
/* unused harmony reexport never */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__internal_observable_of__ = __webpack_require__(154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_41__internal_observable_of__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__internal_observable_onErrorResumeNext__ = __webpack_require__(380);
/* unused harmony reexport onErrorResumeNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__internal_observable_pairs__ = __webpack_require__(381);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__internal_observable_race__ = __webpack_require__(230);
/* unused harmony reexport race */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__internal_observable_range__ = __webpack_require__(382);
/* unused harmony reexport range */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__internal_observable_throwError__ = __webpack_require__(156);
/* unused harmony reexport throwError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__internal_observable_timer__ = __webpack_require__(231);
/* unused harmony reexport timer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__internal_observable_using__ = __webpack_require__(383);
/* unused harmony reexport using */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__internal_observable_zip__ = __webpack_require__(160);
/* unused harmony reexport zip */
/* unused harmony reexport EMPTY */
/* unused harmony reexport NEVER */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__internal_config__ = __webpack_require__(115);
/* unused harmony reexport config */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */





















































//# sourceMappingURL=index.js.map


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return observable; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var observable = typeof Symbol === 'function' && Symbol.observable || '@@observable';
//# sourceMappingURL=observable.js.map


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function identity(x) {
    return x;
}
//# sourceMappingURL=identity.js.map


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = multicast;
/* unused harmony export MulticastOperator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_ConnectableObservable__ = __webpack_require__(211);
/** PURE_IMPORTS_START _observable_ConnectableObservable PURE_IMPORTS_END */

function multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === 'function') {
            subjectFactory = subjectOrSubjectFactory;
        }
        else {
            subjectFactory = function subjectFactory() {
                return subjectOrSubjectFactory;
            };
        }
        if (typeof selector === 'function') {
            return source.lift(new MulticastOperator(subjectFactory, selector));
        }
        var connectable = Object.create(source, __WEBPACK_IMPORTED_MODULE_0__observable_ConnectableObservable__["a" /* connectableObservableDescriptor */]);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
var MulticastOperator = /*@__PURE__*/ (function () {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function (subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}());

//# sourceMappingURL=multicast.js.map


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetNotificationFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getSysAdminNotifications; });
/* unused harmony export fetchGetUnreferencedAccreditationRequestsByDomainsNotificationSuccess */
/* unused harmony export fetchGetUnreferencedAccreditationRequestsByDomainsNotification */
/* unused harmony export fetchGetPendingOrganizationsNotificationSuccess */
/* unused harmony export fetchGetPendingOrganizationsNotification */
/* unused harmony export fetchGetGlobalCertificatesNotificationSuccess */
/* unused harmony export fetchGetGlobalCertificatesNotification */
/* unused harmony export fetchGetOrgsWithoutCertificatesNotificationSuccess */
/* unused harmony export fetchGetOrgsWithoutCertificatesNotification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchGetInsertorNotifications; });
/* unused harmony export fetchGetPendingAccreditationRequestsNotificationSuccess */
/* unused harmony export fetchGetPendingAccreditationRequestsNotification */
/* unused harmony export fetchGetReviewFailedAccreditationsNotificationSuccess */
/* unused harmony export fetchGetReviewFailedAccreditationsNotification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchGetValidatorNotifications; });
/* unused harmony export fetchGetValidateAccreditationsNotificationSuccess */
/* unused harmony export fetchGetValidateAccreditationsNotification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getApplicantNotifications; });
/* unused harmony export fetchGetPendingAccreditationsNotificationSuccess */
/* unused harmony export fetchGetPendingAccreditationsNotification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addNotificationData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAnchorNotifications; });
/* unused harmony export fetchGetUnreferencedAccreditationRequestsByAGsNotificationSuccess */
/* unused harmony export fetchGetUnreferencedAccreditationRequestsByAGsNotification */
/* unused harmony export fetchGetPendingConsentsNotificationSuccess */
/* unused harmony export fetchGetPendingConsentsNotification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchGetRejectedAccreditationsNotifications; });
/* unused harmony export fetchGetRejectedByApplicantsAccreditationsNotificationSuccess */
/* unused harmony export fetchGetRejectedByApplicantsAccreditationsNotification */
/* unused harmony export fetchGetRejectedByValidatorsAccreditationsNotificationSuccess */
/* unused harmony export fetchGetRejectedByValidatorsAccreditationsNotification */
/* unused harmony export getNotifications */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return loadingNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getNotificationsData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__consent_organizationConsents__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_storageApi__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__accreditation_certificate__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__organization_organization__ = __webpack_require__(29);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//- Actions
var fetchGetNotificationFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATIONS_FAILED');var clearState=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_STATE');var getSysAdminNotifications=function getSysAdminNotifications(){return function(dispatch,getState){dispatch(clearState());dispatch(fetchGetPendingOrganizationsNotification());dispatch(fetchGetOrgsWithoutCertificatesNotification());var subRoles=Object(__WEBPACK_IMPORTED_MODULE_4__account_role__["s" /* getSubRoles */])(getState());if(subRoles.includes(__WEBPACK_IMPORTED_MODULE_4__account_role__["c" /* SUB_ROLES */].ROOT)||subRoles.includes(__WEBPACK_IMPORTED_MODULE_4__account_role__["c" /* SUB_ROLES */].PA)){dispatch(fetchGetUnreferencedAccreditationRequestsByDomainsNotification());dispatch(fetchGetGlobalCertificatesNotification());}};};var fetchGetUnreferencedAccreditationRequestsByDomainsNotificationSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATIONS_SUCCESS',function(data){return{data:data,type:__WEBPACK_IMPORTED_MODULE_3__constants_constants__["l" /* NOTIFICATION_TYPES */].UNREFERENCED_ACCREDITATION_REQUESTS_BY_DOMAINS};});var fetchGetUnreferencedAccreditationRequestsByDomainsNotification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATION',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAccreditationRequestsByDomains(false);},function(){return{apiCall:true,onSuccess:fetchGetUnreferencedAccreditationRequestsByDomainsNotificationSuccess,onFail:fetchGetNotificationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchGetPendingOrganizationsNotificationSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATIONS_SUCCESS',function(data){return{data:data,type:__WEBPACK_IMPORTED_MODULE_3__constants_constants__["l" /* NOTIFICATION_TYPES */].PENDING_ORGANIZATIONS};});var fetchGetPendingOrganizationsNotification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATION',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getOrgs(false);},function(){return{apiCall:true,onSuccess:fetchGetPendingOrganizationsNotificationSuccess,onFail:fetchGetNotificationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchGetGlobalCertificatesNotificationSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATIONS_SUCCESS',function(data){return{data:{length:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(data)||data.length===0?1:0},type:__WEBPACK_IMPORTED_MODULE_3__constants_constants__["l" /* NOTIFICATION_TYPES */].ADMIN_SECURITY_NOTIFICATIONS};});var fetchGetGlobalCertificatesNotification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATION',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getGlobalCertificates();},function(){return{apiCall:true,onSuccess:fetchGetGlobalCertificatesNotificationSuccess,onFail:fetchGetNotificationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchGetOrgsWithoutCertificatesNotificationSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATIONS_SUCCESS',function(data){return{data:data,type:__WEBPACK_IMPORTED_MODULE_3__constants_constants__["l" /* NOTIFICATION_TYPES */].ADMIN_SECURITY_NOTIFICATIONS};});var fetchGetOrgsWithoutCertificatesNotification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATION',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getOrgsWithoutCertificates();},function(){return{apiCall:true,onSuccess:fetchGetOrgsWithoutCertificatesNotificationSuccess,onFail:fetchGetNotificationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchGetInsertorNotifications=function fetchGetInsertorNotifications(){return function(dispatch,getState){dispatch(clearState());var groups=Object(__WEBPACK_IMPORTED_MODULE_4__account_role__["p" /* getGroupsForSubRole */])(getState());__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(groups,function(group){dispatch(fetchGetReviewFailedAccreditationsNotification(group.id,true));dispatch(fetchGetReviewFailedAccreditationsNotification(group.id,false));dispatch(fetchGetPendingAccreditationRequestsNotification(group.id));});var key=Object(__WEBPACK_IMPORTED_MODULE_8__accreditation_certificate__["d" /* getKey */])(getState());var accreditationSigningRequired=Object(__WEBPACK_IMPORTED_MODULE_9__organization_organization__["v" /* isAccreditationSigningRequired */])(getState());dispatch(addNotificationData({type:__WEBPACK_IMPORTED_MODULE_3__constants_constants__["l" /* NOTIFICATION_TYPES */].INSERTER_SECURITY_NO_CERTIFICATE,value:!accreditationSigningRequired||!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(key)?0:1}));};};var fetchGetPendingAccreditationRequestsNotificationSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATIONS_SUCCESS',function(data){return{data:data,type:__WEBPACK_IMPORTED_MODULE_3__constants_constants__["l" /* NOTIFICATION_TYPES */].PENDING_ACCREDITATION_REQUESTS};});var fetchGetPendingAccreditationRequestsNotification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATION',function(groupId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getPendingAccreditationRequests(groupId,null);},function(){return{apiCall:true,onSuccess:fetchGetPendingAccreditationRequestsNotificationSuccess,onFail:fetchGetNotificationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchGetReviewFailedAccreditationsNotificationSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATIONS_SUCCESS',function(data){return{data:data,type:__WEBPACK_IMPORTED_MODULE_3__constants_constants__["l" /* NOTIFICATION_TYPES */].REVIEW_FAILED_ACCREDITATIONS};});var fetchGetReviewFailedAccreditationsNotification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATION',function(groupId,isInternal){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAccreditationsForReviewByGroupId(groupId,0,isInternal);},function(){return{apiCall:true,onSuccess:fetchGetReviewFailedAccreditationsNotificationSuccess,onFail:fetchGetNotificationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchGetValidatorNotifications=function fetchGetValidatorNotifications(){return function(dispatch,getState){dispatch(clearState());var groups=Object(__WEBPACK_IMPORTED_MODULE_4__account_role__["p" /* getGroupsForSubRole */])(getState());__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(groups,function(group){dispatch(fetchGetValidateAccreditationsNotification(group.id));});};};var fetchGetValidateAccreditationsNotificationSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATIONS_SUCCESS',function(data){return{data:data,type:__WEBPACK_IMPORTED_MODULE_3__constants_constants__["l" /* NOTIFICATION_TYPES */].VALIDATE_ACCREDITATIONS};});var fetchGetValidateAccreditationsNotification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATION',function(groupId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAccreditationsForValidation(groupId);},function(){return{apiCall:true,onSuccess:fetchGetValidateAccreditationsNotificationSuccess,onFail:fetchGetNotificationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var getApplicantNotifications=function getApplicantNotifications(){return function(dispatch){dispatch(clearState());dispatch(fetchGetPendingAccreditationsNotification());dispatch(fetchGetPendingConsentsNotification());};};var fetchGetPendingAccreditationsNotificationSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATIONS_SUCCESS',function(data){return{data:data,type:__WEBPACK_IMPORTED_MODULE_3__constants_constants__["l" /* NOTIFICATION_TYPES */].PENDING_ACCREDITATIONS};});var fetchGetPendingAccreditationsNotification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATION',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getPendingAccreditations();},function(){return{apiCall:true,onSuccess:fetchGetPendingAccreditationsNotificationSuccess,onFail:fetchGetNotificationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var addNotificationData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('ADD_NOTIFICATION_DATA');var getAnchorNotifications=function getAnchorNotifications(){return function(dispatch){dispatch(clearState());dispatch(fetchGetUnreferencedAccreditationRequestsByAGsNotification());var anchorSecurityGotIt=__WEBPACK_IMPORTED_MODULE_7__utils_storageApi__["a" /* StorageApi */].getAnchorSecurityGotIt();dispatch(addNotificationData({type:__WEBPACK_IMPORTED_MODULE_3__constants_constants__["l" /* NOTIFICATION_TYPES */].ANCHOR_SECURITY_GOT_IT,value:anchorSecurityGotIt?0:1}));};};var fetchGetUnreferencedAccreditationRequestsByAGsNotificationSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATIONS_SUCCESS',function(data){return{data:data,type:__WEBPACK_IMPORTED_MODULE_3__constants_constants__["l" /* NOTIFICATION_TYPES */].UNREFERENCED_ACCREDITATION_REQUESTS_BY_AGS};});var fetchGetUnreferencedAccreditationRequestsByAGsNotification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATION',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAccreditationRequestsByAGs();},function(){return{apiCall:true,onSuccess:fetchGetUnreferencedAccreditationRequestsByAGsNotificationSuccess,onFail:fetchGetNotificationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchGetPendingConsentsNotificationSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATIONS_SUCCESS',function(data){return{data:data,type:__WEBPACK_IMPORTED_MODULE_3__constants_constants__["l" /* NOTIFICATION_TYPES */].PENDING_CONSENTS};});var fetchGetPendingConsentsNotification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATION',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getRequestsByStatus(__WEBPACK_IMPORTED_MODULE_6__consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].PENDING);},function(){return{apiCall:true,onSuccess:fetchGetPendingConsentsNotificationSuccess,onFail:fetchGetNotificationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchGetRejectedAccreditationsNotifications=function fetchGetRejectedAccreditationsNotifications(groupId){return function(dispatch){dispatch(clearState());dispatch(fetchGetRejectedByApplicantsAccreditationsNotification(groupId));dispatch(fetchGetRejectedByValidatorsAccreditationsNotification(groupId,false));};};var fetchGetRejectedByApplicantsAccreditationsNotificationSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATIONS_SUCCESS',function(data){return{data:data,type:__WEBPACK_IMPORTED_MODULE_3__constants_constants__["l" /* NOTIFICATION_TYPES */].REJECTED_BY_APPLICANTS_ACCREDITATIONS};});var fetchGetRejectedByApplicantsAccreditationsNotification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATION',function(groupId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAccreditationsForReviewByGroupId(groupId,0,false);},function(){return{apiCall:true,onSuccess:fetchGetRejectedByApplicantsAccreditationsNotificationSuccess,onFail:fetchGetNotificationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var fetchGetRejectedByValidatorsAccreditationsNotificationSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATIONS_SUCCESS',function(data){return{data:data,type:__WEBPACK_IMPORTED_MODULE_3__constants_constants__["l" /* NOTIFICATION_TYPES */].REJECTED_BY_VALIDATORS_ACCREDITATIONS};});var fetchGetRejectedByValidatorsAccreditationsNotification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_NOTIFICATION',function(groupId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAccreditationsForReviewByGroupId(groupId,0,true);},function(){return{apiCall:true,onSuccess:fetchGetRejectedByValidatorsAccreditationsNotificationSuccess,onFail:fetchGetNotificationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});//- State
var initialState={data:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_NOTIFICATION:function FETCH_GET_NOTIFICATION(state){return Object.assign({},state,{error:null,fetching:true});},FETCH_GET_NOTIFICATIONS_FAILED:function FETCH_GET_NOTIFICATIONS_FAILED(state,action){return Object.assign({},state,{error:action.payload,fetching:false});},FETCH_GET_NOTIFICATIONS_SUCCESS:function FETCH_GET_NOTIFICATIONS_SUCCESS(state,action){var currentValue=state.data&&state.data[action.payload.type]?state.data[action.payload.type]:0;var nextValue=currentValue+(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(action.payload.data.totalElements)?action.payload.data.totalElements:action.payload.data.length);return Object.assign({},state,{data:Object.assign({},state.data,_defineProperty({},action.payload.type,nextValue)),error:null,fetching:false});},ADD_NOTIFICATION_DATA:function ADD_NOTIFICATION_DATA(state,action){return Object.assign({},state,{data:Object.assign({},state.data,_defineProperty({},action.payload.type,action.payload.value))});},CLEAR_STATE:function CLEAR_STATE(state){return Object.assign({},state,{data:null});}},initialState));//- Selectors
var getNotifications=function getNotifications(state){return state.notifications;};var loadingNotifications=function loadingNotifications(state){return getNotifications(state).fetching;};var getNotificationsData=function getNotificationsData(state){return getNotifications(state).data;};

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchPriceByOrgTypeAndCountryFailed */
/* unused harmony export fetchPriceByOrgTypeAndCountrySuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetPriceByOrgTypeAndCountry; });
/* unused harmony export fetchGetPresetsFailed */
/* unused harmony export fetchGetPresetsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetPresets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setDefaultCurrencyAndPricingPreset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setCurrentPreset; });
/* unused harmony export setDefaultCurrency */
/* unused harmony export getFinance */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPresetsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCurrentPresetId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDefaultCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentPresetData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__organization_organizations__ = __webpack_require__(30);
//- Actions
var fetchPriceByOrgTypeAndCountryFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PRICE_BY_ORG_TYPE_AND_COUNTRY_FAILED');var fetchPriceByOrgTypeAndCountrySuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PRICE_BY_ORG_TYPE_AND_COUNTRY_SUCCESS');var fetchGetPriceByOrgTypeAndCountry=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PRICE_BY_ORG_TYPE_AND_COUNTRY',function(orgType,countryCode){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getPriceByOrgTypeAndCountry(orgType,countryCode);},function(){return{apiCall:true,onSuccess:fetchPriceByOrgTypeAndCountrySuccess,onFail:fetchPriceByOrgTypeAndCountryFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchGetPresetsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PRESETS_FAILED');var fetchGetPresetsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PRESETS_SUCCESS');var fetchGetPresets=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PRESETS',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getPresets();},function(){return{apiCall:true,onSuccess:fetchGetPresetsSuccess,onFail:fetchGetPresetsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var setDefaultCurrencyAndPricingPreset=function setDefaultCurrencyAndPricingPreset(){return function(dispatch,getState){var data=Object(__WEBPACK_IMPORTED_MODULE_4__organization_organizations__["I" /* getOrganizationData */])(getState());dispatch(setCurrentPreset(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(data,"pricing.pricingPreset.id")));dispatch(setDefaultCurrency(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(data,"balance.currency")));};};var setCurrentPreset=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_CURRENT_PRESET');var setDefaultCurrency=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_DEFAULT_CURRENCY');//- State
var initialState={presetsData:null,currentPresetId:null,defaultCurrency:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_PRICE_BY_ORG_TYPE_AND_COUNTRY:function FETCH_GET_PRICE_BY_ORG_TYPE_AND_COUNTRY(state){return Object.assign({},state,{currentPresetId:null,defaultCurrency:null,error:null,fetching:true});},FETCH_GET_PRICE_BY_ORG_TYPE_AND_COUNTRY_FAILED:function FETCH_GET_PRICE_BY_ORG_TYPE_AND_COUNTRY_FAILED(state,action){return Object.assign({},state,{currentPresetId:null,defaultCurrency:null,error:action.payload,fetching:false});},FETCH_GET_PRICE_BY_ORG_TYPE_AND_COUNTRY_SUCCESS:function FETCH_GET_PRICE_BY_ORG_TYPE_AND_COUNTRY_SUCCESS(state,action){return Object.assign({},state,{currentPresetId:action.payload.pricingPreset.id,defaultCurrency:action.payload.currency,error:null,fetching:false});},FETCH_GET_PRESETS:function FETCH_GET_PRESETS(state){return Object.assign({},state,{presetsData:null,error:null,fetching:true});},FETCH_GET_PRESETS_FAILED:function FETCH_GET_PRESETS_FAILED(state,action){return Object.assign({},state,{presetsData:null,error:action.payload,fetching:false});},FETCH_GET_PRESETS_SUCCESS:function FETCH_GET_PRESETS_SUCCESS(state,action){return Object.assign({},state,{presetsData:action.payload,error:null,fetching:false});},SET_CURRENT_PRESET:function SET_CURRENT_PRESET(state,action){return Object.assign({},state,{currentPresetId:action.payload});},SET_DEFAULT_CURRENCY:function SET_DEFAULT_CURRENCY(state,action){return Object.assign({},state,{defaultCurrency:action.payload});}},initialState));//- Selectors
var getFinance=function getFinance(state){return state.finance;};var getPresetsData=function getPresetsData(state){return getFinance(state).presetsData;};var getCurrentPresetId=function getCurrentPresetId(state){return getFinance(state).currentPresetId;};var getDefaultCurrency=function getDefaultCurrency(state){return getFinance(state).defaultCurrency;};var getCurrentPresetData=function getCurrentPresetData(state){var data=getPresetsData(state);var currentPresetId=getCurrentPresetId(state);return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(data,function(elem){return elem.id===currentPresetId;});};

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(503);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(506);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(507);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(102);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageNotFoundComponent__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__PageNotFoundComponent__["a" /* default */]));

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SelectBase */
/* unused harmony export Async */
/* unused harmony export makeAsyncSelect */
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export makeCreatableSelect */
/* unused harmony export createFilter */
/* unused harmony export makeAnimated */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return components; });
/* unused harmony export mergeStyles */
/* unused harmony export defaultTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_memoize_one__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emotion__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raf__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_autosize__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__);









function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, cssKey, state, className) {
  var arr = [cssKey, className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (_typeof(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }

  return inputValue;
} // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      __WEBPACK_IMPORTED_MODULE_5_raf___default()(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        scrollTo(scrollParent, scrollDown);
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  } // fulfil contract with flow: implicit return value of undefined


  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {}, _defineProperty(_ref3, alignToControl(placement), '100%'), _defineProperty(_ref3, "backgroundColor", colors.neutral0), _defineProperty(_ref3, "borderRadius", borderRadius), _defineProperty(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty(_ref3, "marginBottom", spacing.menuGutter), _defineProperty(_ref3, "marginTop", spacing.menuGutter), _defineProperty(_ref3, "position", 'absolute'), _defineProperty(_ref3, "width", '100%'), _defineProperty(_ref3, "zIndex", 1), _ref3;
}; // NOTE: internal only

var MenuPlacer =
/*#__PURE__*/
function (_Component) {
  _inherits(MenuPlacer, _Component);

  function MenuPlacer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MenuPlacer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPlacement", function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getUpdatedProps", function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread({}, _this.props, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    });

    return _this;
  }

  _createClass(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(MenuPlacer, "contextTypes", {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  var cn = cx(
  /*#__PURE__*/
  Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('menu', props)), {
    menu: true
  }, className);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cn
  }, innerProps, {
    ref: innerRef
  }), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('menuList', props)), {
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('noOptionsMessage', props)), {
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('loadingMessage', props)), {
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal =
/*#__PURE__*/
function (_Component2) {
  _inherits(MenuPortal, _Component2);

  function MenuPortal() {
    var _getPrototypeOf3;

    var _this2;

    _classCallCheck(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(MenuPortal)).call.apply(_getPrototypeOf3, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "state", {
      placement: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "getPortalPlacement", function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    });

    return _this2;
  }

  _createClass(MenuPortal, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    } // callback for occassions where the menu must "flip"

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          controlElement = _this$props2.controlElement,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className:
        /*#__PURE__*/

        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('menuPortal', state))
      }, children);
      return appendTo ? Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["createPortal"])(menuWrapper, appendTo) : menuWrapper;
    }
  }]);

  return MenuPortal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(MenuPortal, "childContextTypes", {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    } // end fast-deep-equal
    // Custom handling for React


    for (i = length; i-- !== 0;) {
      key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    } // fast-deep-equal index.js 2.0.1


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
}

var diacritics = [{
  base: 'A',
  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
}, {
  base: 'AA',
  letters: /[\uA732]/g
}, {
  base: 'AE',
  letters: /[\u00C6\u01FC\u01E2]/g
}, {
  base: 'AO',
  letters: /[\uA734]/g
}, {
  base: 'AU',
  letters: /[\uA736]/g
}, {
  base: 'AV',
  letters: /[\uA738\uA73A]/g
}, {
  base: 'AY',
  letters: /[\uA73C]/g
}, {
  base: 'B',
  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
}, {
  base: 'C',
  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
}, {
  base: 'D',
  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
}, {
  base: 'DZ',
  letters: /[\u01F1\u01C4]/g
}, {
  base: 'Dz',
  letters: /[\u01F2\u01C5]/g
}, {
  base: 'E',
  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
}, {
  base: 'F',
  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
}, {
  base: 'G',
  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
}, {
  base: 'H',
  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
}, {
  base: 'I',
  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
}, {
  base: 'J',
  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
}, {
  base: 'K',
  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
}, {
  base: 'L',
  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
}, {
  base: 'LJ',
  letters: /[\u01C7]/g
}, {
  base: 'Lj',
  letters: /[\u01C8]/g
}, {
  base: 'M',
  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
}, {
  base: 'N',
  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
}, {
  base: 'NJ',
  letters: /[\u01CA]/g
}, {
  base: 'Nj',
  letters: /[\u01CB]/g
}, {
  base: 'O',
  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
}, {
  base: 'OI',
  letters: /[\u01A2]/g
}, {
  base: 'OO',
  letters: /[\uA74E]/g
}, {
  base: 'OU',
  letters: /[\u0222]/g
}, {
  base: 'P',
  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
}, {
  base: 'Q',
  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
}, {
  base: 'R',
  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
}, {
  base: 'S',
  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
}, {
  base: 'T',
  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
}, {
  base: 'TZ',
  letters: /[\uA728]/g
}, {
  base: 'U',
  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
}, {
  base: 'V',
  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
}, {
  base: 'VY',
  letters: /[\uA760]/g
}, {
  base: 'W',
  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
}, {
  base: 'X',
  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
}, {
  base: 'Y',
  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
}, {
  base: 'Z',
  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
}, {
  base: 'a',
  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
}, {
  base: 'aa',
  letters: /[\uA733]/g
}, {
  base: 'ae',
  letters: /[\u00E6\u01FD\u01E3]/g
}, {
  base: 'ao',
  letters: /[\uA735]/g
}, {
  base: 'au',
  letters: /[\uA737]/g
}, {
  base: 'av',
  letters: /[\uA739\uA73B]/g
}, {
  base: 'ay',
  letters: /[\uA73D]/g
}, {
  base: 'b',
  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
}, {
  base: 'c',
  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
}, {
  base: 'd',
  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
}, {
  base: 'dz',
  letters: /[\u01F3\u01C6]/g
}, {
  base: 'e',
  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
}, {
  base: 'f',
  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
}, {
  base: 'g',
  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
}, {
  base: 'h',
  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
}, {
  base: 'hv',
  letters: /[\u0195]/g
}, {
  base: 'i',
  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
}, {
  base: 'j',
  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
}, {
  base: 'k',
  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
}, {
  base: 'l',
  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
}, {
  base: 'lj',
  letters: /[\u01C9]/g
}, {
  base: 'm',
  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
}, {
  base: 'n',
  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
}, {
  base: 'nj',
  letters: /[\u01CC]/g
}, {
  base: 'o',
  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
}, {
  base: 'oi',
  letters: /[\u01A3]/g
}, {
  base: 'ou',
  letters: /[\u0223]/g
}, {
  base: 'oo',
  letters: /[\uA74F]/g
}, {
  base: 'p',
  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
}, {
  base: 'q',
  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
}, {
  base: 'r',
  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
}, {
  base: 's',
  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
}, {
  base: 't',
  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
}, {
  base: 'tz',
  letters: /[\uA729]/g
}, {
  base: 'u',
  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
}, {
  base: 'v',
  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
}, {
  base: 'vy',
  letters: /[\uA761]/g
}, {
  base: 'w',
  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
}, {
  base: 'x',
  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
}, {
  base: 'y',
  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
}, {
  base: 'z',
  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
}];
var stripDiacritics = function stripDiacritics(str) {
  for (var i = 0; i < diacritics.length; i++) {
    str = str.replace(diacritics[i].letters, diacritics[i].base);
  }

  return str;
};

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = _objectSpread({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var A11yText = function A11yText(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", _extends({
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
      zIndex: 9999,
      border: 0,
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: 1,
      width: 1,
      position: 'absolute',
      overflow: 'hidden',
      padding: 0,
      whiteSpace: 'nowrap',
      backgroundColor: 'red',
      color: 'blue'
    })
  }, props));
};

var DummyInput =
/*#__PURE__*/
function (_Component) {
  _inherits(DummyInput, _Component);

  function DummyInput() {
    _classCallCheck(this, DummyInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(DummyInput).apply(this, arguments));
  }

  _createClass(DummyInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          inProp = _this$props.in,
          out = _this$props.out,
          onExited = _this$props.onExited,
          appear = _this$props.appear,
          enter = _this$props.enter,
          exit = _this$props.exit,
          innerRef = _this$props.innerRef,
          emotion = _this$props.emotion,
          props = _objectWithoutProperties(_this$props, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({
        ref: innerRef
      }, props, {
        className:
        /*#__PURE__*/

        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
          // get rid of any default styles
          background: 0,
          border: 0,
          fontSize: 'inherit',
          outline: 0,
          padding: 0,
          // important! without `width` browsers won't allow focus
          width: 1,
          // remove cursor on desktop
          color: 'transparent',
          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
          left: -100,
          opacity: 0,
          position: 'relative',
          transform: 'scale(0)'
        })
      }));
    }
  }]);

  return DummyInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var NodeResolver =
/*#__PURE__*/
function (_Component) {
  _inherits(NodeResolver, _Component);

  function NodeResolver() {
    _classCallCheck(this, NodeResolver);

    return _possibleConstructorReturn(this, _getPrototypeOf(NodeResolver).apply(this, arguments));
  }

  _createClass(NodeResolver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.innerRef(Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return NodeResolver;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;

var ScrollLock =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollLock, _Component);

  function ScrollLock() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollLock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollLock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "originalStyles", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listenerOptions", {
      capture: false,
      passive: false
    });

    return _this;
  }

  _createClass(ScrollLock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;
      var _this$props = this.props,
          accountForScrollbars = _this$props.accountForScrollbars,
          touchScrollTarget = _this$props.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      } // apply the lock styles and padding if this is the first scroll lock


      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
      } // account for touch devices


      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target

        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      } // increment active scroll locks


      activeScrollLocks += 1;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;
      var _this$props2 = this.props,
          accountForScrollbars = _this$props2.accountForScrollbars,
          touchScrollTarget = _this$props2.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style; // safely decrement active scroll locks

      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      } // remove touch listeners


      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ScrollLock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(ScrollLock, "defaultProps", {
  accountForScrollbars: true
});

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
var ScrollBlock =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ScrollBlock, _PureComponent);

  function ScrollBlock() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      touchScrollTarget: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
      if (ref === _this.state.touchScrollTarget) return;

      _this.setState({
        touchScrollTarget: ref
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blurSelectInput", function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    });

    return _this;
  }

  _createClass(ScrollBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isEnabled = _this$props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled

      if (!isEnabled) return children;
      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        onClick: this.blurSelectInput,
        className:
        /*#__PURE__*/

        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
          position: 'fixed',
          left: 0,
          bottom: 0,
          right: 0,
          top: 0
        })
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, children), touchScrollTarget ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollLock, {
        touchScrollTarget: touchScrollTarget
      }) : null);
    }
  }]);

  return ScrollBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var ScrollCaptor =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollCaptor, _Component);

  function ScrollCaptor() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollCaptor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollCaptor)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isBottom", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isTop", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollTarget", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "touchStart", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelScroll", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEventDelta", function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;
      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false; // reset bottom/top flags

      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }

      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      } // bottom limit


      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }

        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true; // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }

        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      } // cancel scroll


      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWheel", function (event) {
      _this.handleEventDelta(event, event.deltaY);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;

      _this.handleEventDelta(event, deltaY);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
      _this.scrollTarget = ref;
    });

    return _this;
  }

  _createClass(ScrollCaptor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: "startListening",
    value: function startListening(el) {
      // bail early if no scroll available
      if (!el) return;
      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "stopListening",
    value: function stopListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, this.props.children);
    }
  }]);

  return ScrollCaptor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var ScrollCaptorSwitch =
/*#__PURE__*/
function (_Component2) {
  _inherits(ScrollCaptorSwitch, _Component2);

  function ScrollCaptorSwitch() {
    _classCallCheck(this, ScrollCaptorSwitch);

    return _possibleConstructorReturn(this, _getPrototypeOf(ScrollCaptorSwitch).apply(this, arguments));
  }

  _createClass(ScrollCaptorSwitch, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isEnabled = _this$props2.isEnabled,
          props = _objectWithoutProperties(_this$props2, ["isEnabled"]);

      return isEnabled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollCaptor, props) : this.props.children;
    }
  }]);

  return ScrollCaptorSwitch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(ScrollCaptorSwitch, "defaultProps", {
  isEnabled: true
});

var instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label;

  switch (event) {
    case 'menu':
      return 'Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu, press Tab to select the option and exit the menu.';

    case 'input':
      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

    case 'value':
      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
  }
};
var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value;
  if (!value) return;

  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return "option ".concat(value, ", deselected.");

    case 'select-option':
      return "option ".concat(value, ", selected.");
  }
};
var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return "option ".concat(getOptionLabel(focusedOption), " focused, ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('container', props)), {
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(ValueContainer, _Component);

  function ValueContainer() {
    _classCallCheck(this, ValueContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValueContainer).apply(this, arguments));
  }

  _createClass(ValueContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          cx = _this$props.cx,
          isMulti = _this$props.isMulti,
          getStyles = _this$props.getStyles,
          hasValue = _this$props.hasValue;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('valueContainer', this.props)), {
          'value-container': true,
          'value-container--is-multi': isMulti,
          'value-container--has-value': hasValue
        }, className)
      }, children);
    }
  }]);

  return ValueContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]); // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('indicatorsContainer', props)), {
      'indicators': true
    }, className)
  }, children);
};

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
      display: 'inline-block',
      fill: 'currentColor',
      lineHeight: 1,
      stroke: 'currentColor',
      strokeWidth: 0
    })
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg, _extends({
    size: 20
  }, props), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg, _extends({
    size: 20
  }, props), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref2) {
  var isFocused = _ref2.isFocused,
      _ref2$theme = _ref2.theme,
      baseUnit = _ref2$theme.spacing.baseUnit,
      colors = _ref2$theme.colors;
  return {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('dropdownIndicator', props)), {
      'indicator': true,
      'dropdown-indicator': true
    }, className)
  }), children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('clearIndicator', props)), {
      'indicator': true,
      'clear-indicator': true
    }, className)
  }), children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref3) {
  var isDisabled = _ref3.isDisabled,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('indicatorSeparator', props)), {
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var keyframesName = 'react-select-loading-indicator';
var keyframesInjected = false;
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref4) {
  var isFocused = _ref4.isFocused,
      size = _ref4.size,
      _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      baseUnit = _ref4$theme.spacing.baseUnit;
  return {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref5) {
  var color = _ref5.color,
      delay = _ref5.delay,
      offset = _ref5.offset;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
      animationDuration: '1s',
      animationDelay: "".concat(delay, "ms"),
      animationIterationCount: 'infinite',
      animationName: keyframesName,
      animationTimingFunction: 'ease-in-out',
      backgroundColor: color,
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    })
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isFocused = props.isFocused,
      isRtl = props.isRtl,
      colors = props.theme.colors;
  var color = isFocused ? colors.neutral80 : colors.neutral20;

  if (!keyframesInjected) {
    // eslint-disable-next-line no-unused-expressions
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["b" /* injectGlobal */])("@keyframes ", keyframesName, "{0%,80%,100%{opacity:0;}40%{opacity:1;}};");
    keyframesInjected = true;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('loadingIndicator', props)), {
      'indicator': true,
      'loading-indicator': true
    }, className)
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingDot, {
    color: color,
    delay: 0,
    offset: isRtl
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingDot, {
    color: color,
    delay: 160,
    offset: true
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingDot, {
    color: color,
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css$1 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    ref: innerRef,
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('control', props)), {
      'control': true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('group', props)), {
      'group': true
    }, className)
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Heading, _extends({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      theme = props.theme,
      selectProps = props.selectProps,
      cleanProps = _objectWithoutProperties(props, ["className", "cx", "getStyles", "theme", "selectProps"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('groupHeading', _objectSpread({
      theme: theme
    }, cleanProps))), {
      'group-heading': true
    }, className)
  }, cleanProps));
};

var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80
  };
};

var inputStyle = function inputStyle(isHidden) {
  return {
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme,
      selectProps = _ref2.selectProps,
      props = _objectWithoutProperties(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('input', _objectSpread({
      theme: theme
    }, props)))
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_input_autosize___default.a, _extends({
    className: cx(null, {
      'input': true
    }, className),
    inputRef: innerRef,
    inputStyle: inputStyle(isHidden),
    disabled: isDisabled
  }, props)));
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
var MultiValueRemove =
/*#__PURE__*/
function (_Component) {
  _inherits(MultiValueRemove, _Component);

  function MultiValueRemove() {
    _classCallCheck(this, MultiValueRemove);

    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValueRemove).apply(this, arguments));
  }

  _createClass(MultiValueRemove, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          innerProps = _this$props.innerProps;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", innerProps, children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CrossIcon, {
        size: 14
      }));
    }
  }]);

  return MultiValueRemove;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var MultiValue =
/*#__PURE__*/
function (_Component2) {
  _inherits(MultiValue, _Component2);

  function MultiValue() {
    _classCallCheck(this, MultiValue);

    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValue).apply(this, arguments));
  }

  _createClass(MultiValue, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          components = _this$props2.components,
          cx = _this$props2.cx,
          data = _this$props2.data,
          getStyles = _this$props2.getStyles,
          innerProps = _this$props2.innerProps,
          isDisabled = _this$props2.isDisabled,
          removeProps = _this$props2.removeProps,
          selectProps = _this$props2.selectProps;
      var Container = components.Container,
          Label = components.Label,
          Remove = components.Remove;

      var containerInnerProps = _objectSpread({
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('multiValue', this.props)), {
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className)
      }, innerProps);

      var labelInnerProps = {
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('multiValueLabel', this.props)), {
          'multi-value__label': true
        }, className)
      };

      var removeInnerProps = _objectSpread({
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('multiValueRemove', this.props)), {
          'multi-value__remove': true
        }, className)
      }, removeProps);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container, {
        data: data,
        innerProps: containerInnerProps,
        selectProps: selectProps
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, {
        data: data,
        innerProps: labelInnerProps,
        selectProps: selectProps
      }, children), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Remove, {
        data: data,
        innerProps: removeInnerProps,
        selectProps: selectProps
      }));
    }
  }]);

  return MultiValue;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(MultiValue, "defaultProps", {
  cropWithEllipsis: true
});

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: isSelected ? colors.primary : colors.primary50
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    ref: innerRef,
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('option', props)), {
      'option': true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className)
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('placeholder', props)), {
      'placeholder': true
    }, className)
  }, innerProps), children);
};

var css$2 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('singleValue', props)), {
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _objectSpread({}, components, props.components);
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$2,
  valueContainer: valueContainerCSS
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = _objectSpread({}, source); // massage in target styles


  Object.keys(target).forEach(function (key) {
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4;
var baseUnit = 4;
/* Used to calculate consistent margin/padding on elements */

var controlHeight = 38;
/* The minimum height of the control */

var menuGutter = baseUnit * 2;
/* The amount of space between the control and menu */

var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};
var instanceId = 1;

var Select =
/*#__PURE__*/
function (_Component) {
  _inherits(Select, _Component);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, _props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      ariaLiveSelection: '',
      ariaLiveContext: '',
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      isComposing: false,
      menuOptions: {
        render: [],
        focusable: []
      },
      selectValue: []
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blockOptionHover", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearFocusValueOnUpdate", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "commonProps", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "components", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hasGroups", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchX", 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchY", 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputIsHiddenAfterUpdate", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "instancePrefix", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "openAfterFocus", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollToFocusedOptionOnUpdate", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "userIsDragging", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "controlRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getControlRef", function (ref) {
      _this.controlRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focusedOptionRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFocusedOptionRef", function (ref) {
      _this.focusedOptionRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "menuListRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getMenuListRef", function (ref) {
      _this.menuListRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInputRef", function (ref) {
      _this.inputRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cacheComponents", function (components$$1) {
      _this.components = defaultComponents({
        components: components$$1
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focus", _this.focusInput);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blur", _this.blurInput);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      onChange(newValue, _objectSpread({}, actionMeta, {
        name: name
      }));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setValue", function (newValue) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
      var option = arguments.length > 2 ? arguments[2] : undefined;
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti;

      _this.onInputChange('', {
        action: 'set-value'
      });

      if (closeMenuOnSelect) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.clearFocusValueOnUpdate = true;

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectOption", function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti;

      if (isMulti) {
        var selectValue = _this.state.selectValue;

        if (_this.isOptionSelected(newValue, selectValue)) {
          var candidate = _this.getOptionValue(newValue);

          _this.setValue(selectValue.filter(function (i) {
            return _this.getOptionValue(i) !== candidate;
          }), 'deselect-option', newValue);

          _this.announceAriaLiveSelection({
            event: 'deselect-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          _this.setValue([].concat(_toConsumableArray(selectValue), [newValue]), 'select-option', newValue);

          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        }
      } else {
        _this.setValue(newValue, 'select-option');

        _this.announceAriaLiveSelection({
          event: 'select-option',
          context: {
            value: _this.getOptionLabel(newValue)
          }
        });
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeValue", function (removedValue) {
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      _this.onChange(selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      }), {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.announceAriaLiveSelection({
        event: 'remove-value',
        context: {
          value: removedValue ? _this.getOptionLabel(removedValue) : ''
        }
      });

      _this.focusInput();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearValue", function () {
      var isMulti = _this.props.isMulti;

      _this.onChange(isMulti ? [] : null, {
        action: 'clear'
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popValue", function () {
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];

      _this.announceAriaLiveSelection({
        event: 'pop-value',
        context: {
          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
        }
      });

      _this.onChange(selectValue.slice(0, selectValue.length - 1), {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionLabel", function (data) {
      return _this.props.getOptionLabel(data);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionValue", function (data) {
      return _this.props.getOptionValue(data);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyles", function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getElementId", function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getActiveDescendentId", function () {
      var menuIsOpen = _this.props.menuIsOpen;
      var _this$state = _this.state,
          menuOptions = _this$state.menuOptions,
          focusedOption = _this$state.focusedOption;
      if (!focusedOption || !menuIsOpen) return undefined;
      var index = menuOptions.focusable.indexOf(focusedOption);
      var option = menuOptions.render[index];
      return option && option.key;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveSelection", function (_ref2) {
      var event = _ref2.event,
          context = _ref2.context;

      _this.setState({
        ariaLiveSelection: valueEventAriaMessage(event, context)
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveContext", function (_ref3) {
      var event = _ref3.event,
          context = _ref3.context;

      _this.setState({
        ariaLiveContext: instructionsAriaMessage(event, _objectSpread({}, context, {
          label: _this.props['aria-label']
        }))
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseDown", function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseMove", function (event) {
      _this.blockOptionHover = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlMouseDown", function (event) {
      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if (event.currentTarget.tagName !== 'INPUT') {
          _this.onMenuClose();
        }
      }

      if (event.currentTarget.tagName !== 'INPUT') {
        event.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorMouseDown", function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
      event.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorMouseDown", function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.stopPropagation();
      _this.openAfterFocus = false;
      setTimeout(function () {
        return _this.focusInput();
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onScroll", function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionStart", function () {
      _this.setState({
        isComposing: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionEnd", function () {
      _this.setState({
        isComposing: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (_ref4) {
      var touches = _ref4.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (_ref5) {
      var touches = _ref5.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchEnd", function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (event) {
      var inputValue = event.currentTarget.value;
      _this.inputIsHiddenAfterUpdate = false;

      _this.onInputChange(inputValue, {
        action: 'input-change'
      });

      _this.onMenuOpen();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputFocus", function (event) {
      var _this$props5 = _this.props,
          isSearchable = _this$props5.isSearchable,
          isMulti = _this$props5.isMulti;

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.inputIsHiddenAfterUpdate = false;

      _this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });

      _this.setState({
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputBlur", function (event) {
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur'
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onOptionHover", function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "shouldHideSelectedOptions", function () {
      var _this$props6 = _this.props,
          hideSelectedOptions = _this$props6.hideSelectedOptions,
          isMulti = _this$props6.isMulti;
      if (hideSelectedOptions === undefined) return isMulti;
      return hideSelectedOptions;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyDown", function (event) {
      var _this$props7 = _this.props,
          isMulti = _this$props7.isMulti,
          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
          escapeClearsValue = _this$props7.escapeClearsValue,
          inputValue = _this$props7.inputValue,
          isClearable = _this$props7.isClearable,
          isDisabled = _this$props7.isDisabled,
          menuIsOpen = _this$props7.menuIsOpen,
          onKeyDown = _this$props7.onKeyDown,
          tabSelectsValue = _this$props7.tabSelectsValue,
          openMenuOnFocus = _this$props7.openMenuOnFocus;
      var _this$state2 = _this.state,
          isComposing = _this$state2.isComposing,
          focusedOption = _this$state2.focusedOption,
          focusedValue = _this$state2.focusedValue,
          selectValue = _this$state2.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (menuIsOpen) {
            if (!focusedOption) return;
            if (isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.inputIsHiddenAfterUpdate = false;

            _this.onInputChange('', {
              action: 'menu-close'
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    });

    var value = _props.value;
    _this.cacheComponents = Object(__WEBPACK_IMPORTED_MODULE_1_memoize_one__["a" /* default */])(_this.cacheComponents, exportedEqual).bind(_assertThisInitialized(_assertThisInitialized(_this)));

    _this.cacheComponents(_props.components);

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var _selectValue = cleanValue(value);

    var _menuOptions = _this.buildMenuOptions(_props, _selectValue);

    _this.state.menuOptions = _menuOptions;
    _this.state.selectValue = _selectValue;
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props8 = this.props,
          options = _this$props8.options,
          value = _this$props8.value,
          inputValue = _this$props8.inputValue; // re-cache custom components

      this.cacheComponents(nextProps.components); // rebuild the menu options

      if (nextProps.value !== value || nextProps.options !== options || nextProps.inputValue !== inputValue) {
        var selectValue = cleanValue(nextProps.value);
        var menuOptions = this.buildMenuOptions(nextProps, selectValue);
        var focusedValue = this.getNextFocusedValue(selectValue);
        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
        this.setState({
          menuOptions: menuOptions,
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue
        });
      } // some updates should toggle the state of the input visibility


      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props9 = this.props,
          isDisabled = _this$props9.isDisabled,
          menuIsOpen = _this$props9.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }

      this.scrollToFocusedOptionOnUpdate = false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    // ==============================
    // Consumer Handlers
    // ==============================
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      var _this$props10 = this.props,
          isSearchable = _this$props10.isSearchable,
          isMulti = _this$props10.isMulti;
      this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });
      this.onInputChange('', {
        action: 'menu-close'
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================

  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers

  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this$state3 = this.state,
          menuOptions = _this$state3.menuOptions,
          selectValue = _this$state3.selectValue,
          isFocused = _this$state3.isFocused;
      var isMulti = this.props.isMulti;
      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.inputIsHiddenAfterUpdate = false;
      this.onMenuOpen();
      this.setState({
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      });
      this.announceAriaLiveContext({
        event: 'menu'
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$props11 = this.props,
          isMulti = _this$props11.isMulti,
          isSearchable = _this$props11.isSearchable;
      var _this$state4 = this.state,
          selectValue = _this$state4.selectValue,
          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing

      if (!isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'value'
        });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });
      }

      this.setState({
        inputIsHidden: nextFocus === -1 ? false : true,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var _this$state5 = this.state,
          focusedOption = _this$state5.focusedOption,
          menuOptions = _this$state5.menuOptions;
      var options = menuOptions.focusable;
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'menu'
        });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    // ==============================
    // Getters
    // ==============================
    value: function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return _objectSpread({}, defaultTheme, this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          getStyles = this.getStyles,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var classNamePrefix = props.classNamePrefix,
          isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var selectValue = this.state.selectValue;
      var hasValue = this.hasValue();

      var getValue = function getValue() {
        return selectValue;
      };

      var cx = classNames.bind(null, classNamePrefix);
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props,
        theme: this.getTheme()
      };
    }
  }, {
    key: "getNextFocusedValue",
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }

      var _this$state6 = this.state,
          focusedValue = _this$state6.focusedValue,
          lastSelectValue = _this$state6.selectValue;
      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }

      return null;
    }
  }, {
    key: "getNextFocusedOption",
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;
      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: "countOptions",
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props12 = this.props,
          isClearable = _this$props12.isClearable,
          isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled$$1(option, selectValue) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      var _this2 = this;

      if (selectValue.indexOf(option) > -1) return true;

      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }

      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this2.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var inputValue = this.props.inputValue;
        var selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: inputValue,
          selectValue: selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel$$1(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: "startListeningComposition",
    // ==============================
    // Composition Handlers
    // ==============================
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    // ==============================
    // Touch Handlers
    // ==============================
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "buildMenuOptions",
    // ==============================
    // Menu Options
    // ==============================
    value: function buildMenuOptions(props, selectValue) {
      var _this3 = this;

      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
          options = props.options;

      var toOption = function toOption(option, id) {
        var isDisabled = _this3.isOptionDisabled(option, selectValue);

        var isSelected = _this3.isOptionSelected(option, selectValue);

        var label = _this3.getOptionLabel(option);

        var value = _this3.getOptionValue(option);

        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({
          label: label,
          value: value,
          data: option
        }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this3.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this3.selectOption(option);
        };
        var optionId = "".concat(_this3.getElementId('option'), "-").concat(id);
        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this3.hasGroups) _this3.hasGroups = true;
          var items = item.options;
          var children = items.map(function (child, i) {
            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
            if (option && !option.isDisabled) acc.focusable.push(child);
            return option;
          }).filter(Boolean);

          if (children.length) {
            var groupId = "".concat(_this3.getElementId('group'), "-").concat(itemIndex);
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, "".concat(itemIndex));

          if (option) {
            acc.render.push(option);
            if (!option.isDisabled) acc.focusable.push(item);
          }
        }

        return acc;
      }, {
        render: [],
        focusable: []
      });
    } // ==============================
    // Renderers
    // ==============================

  }, {
    key: "constructAriaLiveMessage",
    value: function constructAriaLiveMessage() {
      var _this$state7 = this.state,
          ariaLiveContext = _this$state7.ariaLiveContext,
          selectValue = _this$state7.selectValue,
          focusedValue = _this$state7.focusedValue,
          focusedOption = _this$state7.focusedOption;
      var _this$props13 = this.props,
          options = _this$props13.options,
          menuIsOpen = _this$props13.menuIsOpen,
          inputValue = _this$props13.inputValue,
          screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
        focusedValue: focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue: selectValue
      }) : ''; // An aria live message representing the currently focused option in the select.

      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
        focusedOption: focusedOption,
        getOptionLabel: this.getOptionLabel,
        options: options
      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.

      var resultsMsg = resultsAriaMessage({
        inputValue: inputValue,
        screenReaderMessage: screenReaderStatus({
          count: this.countOptions()
        })
      });
      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props14 = this.props,
          isDisabled = _this$props14.isDisabled,
          isSearchable = _this$props14.isSearchable,
          inputId = _this$props14.inputId,
          inputValue = _this$props14.inputValue,
          tabIndex = _this$props14.tabIndex;
      var Input = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;
      var id = inputId || this.getElementId('input');

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DummyInput, {
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          readOnly: true,
          disabled: isDisabled,
          tabIndex: tabIndex,
          value: ""
        });
      } // aria attributes makes the JSX "noisy", separated for clarity


      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };
      var _this$commonProps = this.commonProps,
          cx = _this$commonProps.cx,
          theme = _this$commonProps.theme,
          selectProps = _this$commonProps.selectProps;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Input, _extends({
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        selectProps: selectProps,
        spellCheck: "false",
        tabIndex: tabIndex,
        theme: theme,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _this$components = this.components,
          MultiValue = _this$components.MultiValue,
          MultiValueContainer = _this$components.MultiValueContainer,
          MultiValueLabel = _this$components.MultiValueLabel,
          MultiValueRemove = _this$components.MultiValueRemove,
          SingleValue = _this$components.SingleValue,
          Placeholder = _this$components.Placeholder;
      var commonProps = this.commonProps;
      var _this$props15 = this.props,
          controlShouldRenderValue = _this$props15.controlShouldRenderValue,
          isDisabled = _this$props15.isDisabled,
          isMulti = _this$props15.isMulti,
          inputValue = _this$props15.inputValue,
          placeholder = _this$props15.placeholder;
      var _this$state8 = this.state,
          selectValue = _this$state8.selectValue,
          focusedValue = _this$state8.focusedValue,
          isFocused = _this$state8.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Placeholder, _extends({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused
        }), placeholder);
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt) {
          var isFocused = opt === focusedValue;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MultiValue, _extends({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isFocused,
            isDisabled: isDisabled,
            key: _this4.getOptionValue(opt),
            removeProps: {
              onClick: function onClick() {
                return _this4.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this4.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this4.formatOptionLabel(opt, 'value'));
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SingleValue, _extends({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props16 = this.props,
          isDisabled = _this$props16.isDisabled,
          isLoading = _this$props16.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClearIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props17 = this.props,
          isDisabled = _this$props17.isDisabled,
          isLoading = _this$props17.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$components2 = this.components,
          DropdownIndicator = _this$components2.DropdownIndicator,
          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorSeparator, _extends({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropdownIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this5 = this;

      var _this$components3 = this.components,
          Group = _this$components3.Group,
          GroupHeading = _this$components3.GroupHeading,
          Menu$$1 = _this$components3.Menu,
          MenuList$$1 = _this$components3.MenuList,
          MenuPortal$$1 = _this$components3.MenuPortal,
          LoadingMessage$$1 = _this$components3.LoadingMessage,
          NoOptionsMessage$$1 = _this$components3.NoOptionsMessage,
          Option = _this$components3.Option;
      var commonProps = this.commonProps;
      var _this$state9 = this.state,
          focusedOption = _this$state9.focusedOption,
          menuOptions = _this$state9.menuOptions;
      var _this$props18 = this.props,
          captureMenuScroll = _this$props18.captureMenuScroll,
          inputValue = _this$props18.inputValue,
          isLoading = _this$props18.isLoading,
          loadingMessage = _this$props18.loadingMessage,
          minMenuHeight = _this$props18.minMenuHeight,
          maxMenuHeight = _this$props18.maxMenuHeight,
          menuIsOpen = _this$props18.menuIsOpen,
          menuPlacement = _this$props18.menuPlacement,
          menuPosition = _this$props18.menuPosition,
          menuPortalTarget = _this$props18.menuPortalTarget,
          menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
          noOptionsMessage = _this$props18.noOptionsMessage,
          onMenuScrollToTop = _this$props18.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Option, _extends({}, commonProps, props, {
          isFocused: isFocused
        }), _this5.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            var type = item.type,
                group = _objectWithoutProperties(item, ["type"]);

            var headingId = "".concat(item.key, "-heading");
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Group, _extends({}, commonProps, group, {
              Heading: GroupHeading,
              headingProps: {
                id: headingId
              },
              label: _this5.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option);
            }));
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingMessage$$1, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NoOptionsMessage$$1, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuPlacer, _extends({}, commonProps, menuPlacementProps), function (_ref6) {
        var ref = _ref6.ref,
            _ref6$placerProps = _ref6.placerProps,
            placement = _ref6$placerProps.placement,
            maxHeight = _ref6$placerProps.maxHeight;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Menu$$1, _extends({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this5.onMenuMouseDown,
            onMouseMove: _this5.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollCaptorSwitch, {
          isEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollBlock, {
          isEnabled: menuShouldBlockScroll
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuList$$1, _extends({}, commonProps, {
          innerRef: _this5.getMenuListRef,
          isLoading: isLoading,
          maxHeight: maxHeight
        }), menuUI))));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuPortal$$1, _extends({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this6 = this;

      var _this$props19 = this.props,
          delimiter = _this$props19.delimiter,
          isDisabled = _this$props19.isDisabled,
          isMulti = _this$props19.isMulti,
          name = _this$props19.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this6.getOptionValue(opt)
            });
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            name: name,
            type: "hidden"
          });
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(A11yText, {
        "aria-live": "assertive"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        id: "aria-selection-event"
      }, "\xA0", this.state.ariaLiveSelection), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        id: "aria-context"
      }, "\xA0", this.constructAriaLiveMessage()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$components4 = this.components,
          Control = _this$components4.Control,
          IndicatorsContainer = _this$components4.IndicatorsContainer,
          SelectContainer = _this$components4.SelectContainer,
          ValueContainer = _this$components4.ValueContainer;
      var _this$props20 = this.props,
          className = _this$props20.className,
          id = _this$props20.id,
          isDisabled = _this$props20.isDisabled,
          menuIsOpen = _this$props20.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectContainer, _extends({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Control, _extends({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueContainer, _extends({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorsContainer, _extends({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Select, "defaultProps", defaultProps);

var defaultProps$1 = {
  defaultInputValue: '',
  defaultMenuIsOpen: false,
  defaultValue: null
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(StateManager, _Component);

    function StateManager() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, StateManager);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StateManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);

        _this.setState({
          value: value
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputChange", function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);

        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuOpen", function () {
        _this.callProp('onMenuOpen');

        _this.setState({
          menuIsOpen: true
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuClose", function () {
        _this.callProp('onMenuClose');

        _this.setState({
          menuIsOpen: false
        });
      });

      return _this;
    }

    _createClass(StateManager, [{
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      } // FIXME: untyped flow code, return any

    }, {
      key: "getProp",
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      } // FIXME: untyped flow code, return any

    }, {
      key: "callProp",
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _this$props;

          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_this$props = this.props)[name].apply(_this$props, args);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            defaultInputValue = _this$props2.defaultInputValue,
            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
            defaultValue = _this$props2.defaultValue,
            props = _objectWithoutProperties(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);

    return StateManager;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _defineProperty(_class, "defaultProps", defaultProps$1), _temp;
};

var defaultProps$2 = {
  cacheOptions: false,
  defaultOptions: false,
  filterOption: null
};
var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Async, _Component);

    function Async(props) {
      var _this;

      _classCallCheck(this, Async);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Async).call(this));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "lastRequest", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mounted", false);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "optionsCache", {});

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (newValue, actionMeta) {
        var _this$props = _this.props,
            cacheOptions = _this$props.cacheOptions,
            onInputChange = _this$props.onInputChange; // TODO

        var inputValue = handleInputChange(newValue, actionMeta, onInputChange);

        if (!inputValue) {
          delete _this.lastRequest;

          _this.setState({
            inputValue: '',
            loadedInputValue: '',
            loadedOptions: [],
            isLoading: false,
            passEmptyOptions: false
          });

          return;
        }

        if (cacheOptions && _this.optionsCache[inputValue]) {
          _this.setState({
            inputValue: inputValue,
            loadedInputValue: inputValue,
            loadedOptions: _this.optionsCache[inputValue],
            isLoading: false,
            passEmptyOptions: false
          });
        } else {
          var request = _this.lastRequest = {};

          _this.setState({
            inputValue: inputValue,
            isLoading: true,
            passEmptyOptions: !_this.state.loadedInputValue
          }, function () {
            _this.loadOptions(inputValue, function (options) {
              if (!_this.mounted) return;

              if (options) {
                _this.optionsCache[inputValue] = options;
              }

              if (request !== _this.lastRequest) return;
              delete _this.lastRequest;

              _this.setState({
                isLoading: false,
                loadedInputValue: inputValue,
                loadedOptions: options || [],
                passEmptyOptions: false
              });
            });
          });
        }

        return inputValue;
      });

      _this.state = {
        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
        inputValue: typeof props.inputValue !== 'undefined' ? props.inputValue : '',
        isLoading: props.defaultOptions === true ? true : false,
        loadedOptions: [],
        passEmptyOptions: false
      };
      return _this;
    }

    _createClass(Async, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        this.mounted = true;
        var defaultOptions = this.props.defaultOptions;
        var inputValue = this.state.inputValue;

        if (defaultOptions === true) {
          this.loadOptions(inputValue, function (options) {
            if (!_this2.mounted) return;
            var isLoading = !!_this2.lastRequest;

            _this2.setState({
              defaultOptions: options || [],
              isLoading: isLoading
            });
          });
        }
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        // if the cacheOptions prop changes, clear the cache
        if (nextProps.cacheOptions !== this.props.cacheOptions) {
          this.optionsCache = {};
        }

        if (nextProps.defaultOptions !== this.props.defaultOptions) {
          this.setState({
            defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: "loadOptions",
      value: function loadOptions(inputValue, callback) {
        var loadOptions = this.props.loadOptions;
        if (!loadOptions) return callback();
        var loader = loadOptions(inputValue, callback);

        if (loader && typeof loader.then === 'function') {
          loader.then(callback, function () {
            return callback();
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var _this$props2 = this.props,
            loadOptions = _this$props2.loadOptions,
            props = _objectWithoutProperties(_this$props2, ["loadOptions"]);

        var _this$state = this.state,
            defaultOptions = _this$state.defaultOptions,
            inputValue = _this$state.inputValue,
            isLoading = _this$state.isLoading,
            loadedInputValue = _this$state.loadedInputValue,
            loadedOptions = _this$state.loadedOptions,
            passEmptyOptions = _this$state.passEmptyOptions;
        var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this3.select = _ref;
          },
          options: options,
          isLoading: isLoading,
          onInputChange: this.handleInputChange
        }));
      }
    }]);

    return Async;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _defineProperty(_class, "defaultProps", defaultProps$2), _temp;
};
var SelectState = manageState(Select);
var Async = makeAsyncSelect(SelectState);

var compareOption = function compareOption() {
  var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var option = arguments.length > 1 ? arguments[1] : undefined;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(option.value).toLowerCase();
  var optionLabel = String(option.label).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};

var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return "Create \"".concat(inputValue, "\"");
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
var defaultProps$3 = _objectSpread({
  allowCreateWhileLoading: false,
  createOptionPosition: 'last'
}, builtins);
var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Creatable, _Component);

    function Creatable(props) {
      var _this;

      _classCallCheck(this, Creatable);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Creatable).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
        var _this$props = _this.props,
            getNewOptionData = _this$props.getNewOptionData,
            inputValue = _this$props.inputValue,
            isMulti = _this$props.isMulti,
            onChange = _this$props.onChange,
            onCreateOption = _this$props.onCreateOption,
            value = _this$props.value;

        if (actionMeta.action !== 'select-option') {
          return onChange(newValue, actionMeta);
        }

        var newOption = _this.state.newOption;
        var valueArray = Array.isArray(newValue) ? newValue : [newValue];

        if (valueArray[valueArray.length - 1] === newOption) {
          if (onCreateOption) onCreateOption(inputValue);else {
            var newOptionData = getNewOptionData(inputValue, inputValue);
            var newActionMeta = {
              action: 'create-option'
            };

            if (isMulti) {
              onChange([].concat(_toConsumableArray(cleanValue(value)), [newOptionData]), newActionMeta);
            } else {
              onChange(newOptionData, newActionMeta);
            }
          }
          return;
        }

        onChange(newValue, actionMeta);
      });

      var options = props.options || [];
      _this.state = {
        newOption: undefined,
        options: options
      };
      return _this;
    }

    _createClass(Creatable, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
            createOptionPosition = nextProps.createOptionPosition,
            formatCreateLabel = nextProps.formatCreateLabel,
            getNewOptionData = nextProps.getNewOptionData,
            inputValue = nextProps.inputValue,
            isLoading = nextProps.isLoading,
            isValidNewOption = nextProps.isValidNewOption,
            value = nextProps.value;
        var options = nextProps.options || [];
        var newOption = this.state.newOption;

        if (isValidNewOption(inputValue, cleanValue(value), options)) {
          newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
        } else {
          newOption = undefined;
        }

        this.setState({
          newOption: newOption,
          options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(_toConsumableArray(options)) : [].concat(_toConsumableArray(options), [newOption]) : options
        });
      }
    }, {
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var props = _extends({}, this.props);

        var options = this.state.options;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          options: options,
          onChange: this.onChange
        }));
      }
    }]);

    return Creatable;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _defineProperty(_class, "defaultProps", defaultProps$3), _temp;
}; // TODO: do this in package entrypoint

var SelectCreatable = makeCreatableSelect(Select);
var Creatable = manageState(SelectCreatable);

var SelectCreatable$1 = makeCreatableSelect(Select);
var SelectCreatableState = manageState(SelectCreatable$1);
var AsyncCreatable = makeAsyncSelect(SelectCreatableState);

// strip transition props off before spreading onto select component
// note we need to be explicit about innerRef for flow
var AnimatedInput = function AnimatedInput(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        appear = _ref.appear,
        enter = _ref.enter,
        exit = _ref.exit,
        props = _objectWithoutProperties(_ref, ["in", "onExited", "appear", "enter", "exit"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, props);
  };
};

var Fade = function Fade(_ref) {
  var Tag = _ref.component,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 1 : _ref$duration,
      inProp = _ref.in,
      onExited = _ref.onExited,
      props = _objectWithoutProperties(_ref, ["component", "duration", "in", "onExited"]);

  var transition = {
    entering: {
      opacity: 0
    },
    entered: {
      opacity: 1,
      transition: "opacity ".concat(duration, "ms")
    },
    exiting: {
      opacity: 0
    },
    exited: {
      opacity: 0
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"], {
    mountOnEnter: true,
    unmountOnExit: true,
    in: inProp,
    timeout: duration
  }, function (state) {
    var innerProps = {
      style: _objectSpread({}, transition[state])
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
      innerProps: innerProps
    }, props));
  });
}; // ==============================
// Collapse Transition
// ==============================

var collapseDuration = 260;
// wrap each MultiValue with a collapse transition; decreases width until
// finally removing from DOM
var Collapse =
/*#__PURE__*/
function (_Component) {
  _inherits(Collapse, _Component);

  function Collapse() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Collapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Collapse)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "duration", collapseDuration);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "rafID", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      width: 'auto'
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "transition", {
      exiting: {
        width: 0,
        transition: "width ".concat(_this.duration, "ms ease-out")
      },
      exited: {
        width: 0
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getWidth", function (ref) {
      if (ref && isNaN(_this.state.width)) {
        /*
          Here we're invoking requestAnimationFrame with a callback invoking our
          call to getBoundingClientRect and setState in order to resolve an edge case
          around portalling. Certain portalling solutions briefly remove children from the DOM
          before appending them to the target node. This is to avoid us trying to call getBoundingClientrect
          while the Select component is in this state.
        */
        // cannot use `offsetWidth` because it is rounded
        _this.rafID = window.requestAnimationFrame(function () {
          var _ref$getBoundingClien = ref.getBoundingClientRect(),
              width = _ref$getBoundingClien.width;

          _this.setState({
            width: width
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyle", function (width) {
      return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: width
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTransition", function (state) {
      return _this.transition[state];
    });

    return _this;
  }

  _createClass(Collapse, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.rafID) {
        window.cancelAnimationFrame(this.rafID);
      }
    } // width must be calculated; cannot transition from `undefined` to `number`

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          inProp = _this$props.in;
      var width = this.state.width;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"], {
        enter: false,
        mountOnEnter: true,
        unmountOnExit: true,
        in: inProp,
        timeout: this.duration
      }, function (state) {
        var style = _objectSpread({}, _this2.getStyle(width), _this2.getTransition(state));

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          ref: _this2.getWidth,
          style: style
        }, children);
      });
    }
  }]);

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        props = _objectWithoutProperties(_ref, ["in", "onExited"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Collapse, {
      in: inProp,
      onExited: onExited
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
      cropWithEllipsis: inProp
    }, props)));
  };
};

var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({
      component: WrappedComponent,
      duration: props.isMulti ? collapseDuration : 1
    }, props));
  };
};

var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({
      component: WrappedComponent
    }, props));
  };
};

// make ValueContainer a transition group
var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__["TransitionGroup"], _extends({
      component: WrappedComponent
    }, props));
  };
};

var makeAnimated = function makeAnimated() {
  var externalComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var components$$1 = defaultComponents({
    components: externalComponents
  });

  var Input = components$$1.Input,
      MultiValue = components$$1.MultiValue,
      Placeholder = components$$1.Placeholder,
      SingleValue = components$$1.SingleValue,
      ValueContainer = components$$1.ValueContainer,
      rest = _objectWithoutProperties(components$$1, ["Input", "MultiValue", "Placeholder", "SingleValue", "ValueContainer"]);

  return _objectSpread({
    Input: AnimatedInput(Input),
    MultiValue: AnimatedMultiValue(MultiValue),
    Placeholder: AnimatedPlaceholder(Placeholder),
    SingleValue: AnimatedSingleValue(SingleValue),
    ValueContainer: AnimatedValueContainer(ValueContainer)
  }, rest);
};

var AnimatedComponents = makeAnimated();
var Input$1 = AnimatedComponents.Input;
var MultiValue$1 = AnimatedComponents.MultiValue;
var Placeholder$1 = AnimatedComponents.Placeholder;
var SingleValue$1 = AnimatedComponents.SingleValue;
var ValueContainer$1 = AnimatedComponents.ValueContainer;
var index = Object(__WEBPACK_IMPORTED_MODULE_1_memoize_one__["a" /* default */])(makeAnimated, exportedEqual);

var index$1 = manageState(Select);

/* harmony default export */ __webpack_exports__["b"] = (index$1);



/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(679);
var v4 = __webpack_require__(680);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setResetPasswordEmail; });
/* unused harmony export fetchSendResetPasswordEmail */
/* unused harmony export onResetPasswordSuccess */
/* unused harmony export fetchResetPassword */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchChangePassword; });
/* unused harmony export onChangePasswordSuccess */
/* unused harmony export onChangePassword */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchUpdateEmail; });
/* unused harmony export onUpdateEmail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return onSubmitChangeEmail; });
/* unused harmony export onSubmitFormFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sendResetPasswordEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sendResetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getResetPasswordEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_handleApiCall__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_login__ = __webpack_require__(17);
//- Actions
var setResetPasswordEmail=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RESET_PASSWORD_EMAIL_SET',function(email){return email;});var fetchSendResetPasswordEmail=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_SEND_RESET_PASSWORD_EMAIL',function(email){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].sendResetPasswordEmail(email);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */]};});var onResetPasswordSuccess=function onResetPasswordSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());};};var fetchResetPassword=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_RESET_PASSWORD',function(token,password){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].resetPassword(token,password);},function(){return{apiCall:true,onSuccess:onResetPasswordSuccess,onFail:onSubmitFormFailed};});var fetchChangePassword=function fetchChangePassword(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onChangePassword(data));};};var onChangePasswordSuccess=function onChangePasswordSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["k" /* resetSubmitFormData */])());};};var onChangePassword=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CHANGE_PASSWORD',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].changePassword(data);},function(){return{apiCall:true,onSuccess:onChangePasswordSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});var fetchUpdateEmail=function fetchUpdateEmail(email){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onUpdateEmail(email));};};var onUpdateEmail=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_UPDATE_EMAIL',function(email){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].changeEmail(email);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});var onSubmitChangeEmail=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CHANGE_EMAIL_SUBMIT',function(token){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].submitChangeEmail(token);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:function onFail(error){return function(dispatch){if(error===__WEBPACK_IMPORTED_MODULE_3__common_handleApiCall__["c" /* UNAUTHORIZED */]){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */])("IRRELEVANT_LINK_EMAIL"));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */])(error));}};}};});var onSubmitFormFailed=function onSubmitFormFailed(error){return function(dispatch){if(error===__WEBPACK_IMPORTED_MODULE_3__common_handleApiCall__["c" /* UNAUTHORIZED */]){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */])("IRRELEVANT_LINK"));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */])(error));}};};var sendResetPasswordEmail=function sendResetPasswordEmail(email){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchSendResetPasswordEmail(email));};};var sendResetPassword=function sendResetPassword(token,password){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchResetPassword(token,password));};};//- State
var initialState={resetPasswordEmail:''};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({RESET_PASSWORD_EMAIL_SET:function RESET_PASSWORD_EMAIL_SET(state,action){return Object.assign({},state,{resetPasswordEmail:action.payload});}},initialState));//- Selectors
var getResetPasswordEmail=function getResetPasswordEmail(state){return state.restoreAccount.resetPasswordEmail;};

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetAccreditationGroupsFailed */
/* unused harmony export fetchGetAccreditationGroupsSuccess */
/* unused harmony export onGetAccreditationGroupsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetAccreditationGroups; });
/* unused harmony export onGetAccreditationGroupsForCurrentPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchRegisterAccreditationGroup; });
/* unused harmony export onRegisterAccreditationGroup */
/* unused harmony export onChangeAccreditationGroupSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchRemoveAccreditationGroup; });
/* unused harmony export onRemoveAccreditationGroupSuccess */
/* unused harmony export onRemoveAccreditationGroup */
/* unused harmony export getAccreditationGroups */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return loadingAccreditationGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCurrentPageForAccreditationGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getTotalPagesForAccreditationGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAccreditationGroupsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAccreditationGroupsDataForSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_activeModal__ = __webpack_require__(6);
//- Actions
var fetchGetAccreditationGroupsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_GROUPS_FAILED');var fetchGetAccreditationGroupsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_GROUPS_SUCCESS');var onGetAccreditationGroupsSuccess=function onGetAccreditationGroupsSuccess(data){return function(dispatch){var isEmpty=data.empty;var currentPage=data.number;if(!isEmpty&&currentPage!==0||currentPage===0){dispatch(fetchGetAccreditationGroupsSuccess(data));}else{dispatch(fetchGetAccreditationGroups(currentPage-1));}};};var fetchGetAccreditationGroups=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_GROUPS',function(page){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAccreditationGroups(page);},function(){return{apiCall:true,onSuccess:onGetAccreditationGroupsSuccess,onFail:fetchGetAccreditationGroupsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var onGetAccreditationGroupsForCurrentPage=function onGetAccreditationGroupsForCurrentPage(){return function(dispatch,getState){var currentPage=getCurrentPageForAccreditationGroups(getState());dispatch(fetchGetAccreditationGroups(currentPage));};};var fetchRegisterAccreditationGroup=function fetchRegisterAccreditationGroup(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onRegisterAccreditationGroup(data));};};var onRegisterAccreditationGroup=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REGISTER_ACCREDITATION_GROUP',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].registerAccreditationGroup(data);},function(){return{apiCall:true,onSuccess:onChangeAccreditationGroupSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var onChangeAccreditationGroupSuccess=function onChangeAccreditationGroupSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(onGetAccreditationGroupsForCurrentPage());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_activeModal__["_16" /* hideModal */])());};};var fetchRemoveAccreditationGroup=function fetchRemoveAccreditationGroup(groupId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onRemoveAccreditationGroup(groupId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_activeModal__["_16" /* hideModal */])());};};var onRemoveAccreditationGroupSuccess=function onRemoveAccreditationGroupSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(onGetAccreditationGroupsForCurrentPage());};};var onRemoveAccreditationGroup=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_ACCREDITATION_GROUP',function(groupId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeAccreditationGroup(groupId);},function(){return{apiCall:true,onSuccess:onRemoveAccreditationGroupSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});//- State
var initialState={fetching:false,data:null,error:null,currentPage:null,totalPages:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_ACCREDITATION_GROUPS:function FETCH_GET_ACCREDITATION_GROUPS(state){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,error:null,fetching:true});},FETCH_GET_ACCREDITATION_GROUPS_FAILED:function FETCH_GET_ACCREDITATION_GROUPS_FAILED(state,action){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,error:action.payload,fetching:false});},FETCH_GET_ACCREDITATION_GROUPS_SUCCESS:function FETCH_GET_ACCREDITATION_GROUPS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload.content,currentPage:action.payload.number,totalPages:action.payload.totalPages,error:null,fetching:false});}},initialState));//- Selectors
var getAccreditationGroups=function getAccreditationGroups(state){return state.accreditationGroups;};var loadingAccreditationGroups=function loadingAccreditationGroups(state){return getAccreditationGroups(state).fetching;};var getCurrentPageForAccreditationGroups=function getCurrentPageForAccreditationGroups(state){return getAccreditationGroups(state).currentPage;};var getTotalPagesForAccreditationGroups=function getTotalPagesForAccreditationGroups(state){return getAccreditationGroups(state).totalPages;};var getAccreditationGroupsData=function getAccreditationGroupsData(state){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(getAccreditationGroups(state).data)){return null;}return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(getAccreditationGroups(state).data,function(accreditationGroup){return{id:accreditationGroup.id,name:accreditationGroup.name,inserterCount:accreditationGroup.inserterCount,validatorCount:accreditationGroup.validatorCount};});};var getAccreditationGroupsDataForSelect=function getAccreditationGroupsDataForSelect(state){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(getAccreditationGroups(state).data)){return null;}return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(getAccreditationGroups(state).data,function(accreditationGroup){return{value:accreditationGroup.id,label:accreditationGroup.name};});};

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetAccreditationGroupFailed */
/* unused harmony export fetchGetAccreditationGroupSuccess */
/* unused harmony export fetchGetAccreditationGroup */
/* unused harmony export fetchGetAccreditationGroupValidatorsSuccess */
/* unused harmony export fetchGetAccreditationGroupValidators */
/* unused harmony export fetchGetAccreditationGroupInsertersSuccess */
/* unused harmony export fetchGetAccreditationGroupInserters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchGetAccreditationGroupData; });
/* unused harmony export updateAccreditationGroupEmployees */
/* unused harmony export onChangeEmployeesInAccreditationGroupSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAddEmployeeToAccreditationGroup; });
/* unused harmony export onAddEmployeeToAccreditationGroup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchRemoveEmployeeFromAccreditationGroup; });
/* unused harmony export removeEmployeeFromAccreditationGroup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchEditAccreditationGroup; });
/* unused harmony export onEditAccreditationGroupSuccess */
/* unused harmony export onEditAccreditationGroup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setAccreditationGroupId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return resetAccreditationGroupData; });
/* unused harmony export getAccreditationGroup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return loadingAccreditationGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getFetchingErrorAccreditationGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAccreditationGroupData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getAccreditationGroupName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAccreditationGroupId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_userData__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
//- Actions
var fetchGetAccreditationGroupFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_GROUP_FAILED');var fetchGetAccreditationGroupSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_GROUP_SUCCESS');var fetchGetAccreditationGroup=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_GROUP',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAccreditationGroup(id);},function(){return{apiCall:true,onSuccess:fetchGetAccreditationGroupSuccess,onFail:fetchGetAccreditationGroupFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_6__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_6__account_login__["l" /* onForbidden */]};});var fetchGetAccreditationGroupValidatorsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_GROUP_VALIDATORS_SUCCESS');var fetchGetAccreditationGroupValidators=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_GROUP_VALIDATORS',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getEmployeesByAccreditationGroupAndRole(id,__WEBPACK_IMPORTED_MODULE_4__account_role__["c" /* SUB_ROLES */].VALIDATOR);},function(){return{apiCall:true,onSuccess:fetchGetAccreditationGroupValidatorsSuccess,onFail:fetchGetAccreditationGroupFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_6__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_6__account_login__["l" /* onForbidden */]};});var fetchGetAccreditationGroupInsertersSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_GROUP_INSERTERS_SUCCESS');var fetchGetAccreditationGroupInserters=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_GROUP_INSERTERS',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getEmployeesByAccreditationGroupAndRole(id,__WEBPACK_IMPORTED_MODULE_4__account_role__["c" /* SUB_ROLES */].INSERTER);},function(){return{apiCall:true,onSuccess:fetchGetAccreditationGroupInsertersSuccess,onFail:fetchGetAccreditationGroupFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_6__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_6__account_login__["l" /* onForbidden */]};});var fetchGetAccreditationGroupData=function fetchGetAccreditationGroupData(){return function(dispatch,getState){var accreditationGroupId=getAccreditationGroupId(getState());if(!__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNil(accreditationGroupId)&&accreditationGroupId!==''){dispatch(fetchGetAccreditationGroup(accreditationGroupId));dispatch(fetchGetAccreditationGroupInserters(accreditationGroupId));dispatch(fetchGetAccreditationGroupValidators(accreditationGroupId));}else{dispatch(fetchGetAccreditationGroupFailed("ID_IS_NULL"));}};};var updateAccreditationGroupEmployees=function updateAccreditationGroupEmployees(employeeId){return function(dispatch,getState){var accreditationGroupId=getAccreditationGroupId(getState());dispatch(fetchGetAccreditationGroupInserters(accreditationGroupId));dispatch(fetchGetAccreditationGroupValidators(accreditationGroupId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());if(employeeId===Object(__WEBPACK_IMPORTED_MODULE_3__account_userData__["g" /* getUserId */])(getState())){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__account_role__["h" /* fetchGetSubRoles */])());}};};var onChangeEmployeesInAccreditationGroupSuccess=function onChangeEmployeesInAccreditationGroupSuccess(employeeId){return function(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_activeModal__["_16" /* hideModal */])());dispatch(updateAccreditationGroupEmployees(employeeId));};};};var fetchAddEmployeeToAccreditationGroup=function fetchAddEmployeeToAccreditationGroup(groupId,employeeId,role){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onAddEmployeeToAccreditationGroup(groupId,employeeId,role));};};var onAddEmployeeToAccreditationGroup=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_ADD_EMPLOYEE_TO_ACCREDITATION_GROUP',function(groupId,employeeId,role){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].addEmployeeToAccreditationGroup(groupId,employeeId,role);},function(groupId,employeeId){return{apiCall:true,onSuccess:onChangeEmployeesInAccreditationGroupSuccess(employeeId),onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_6__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_6__account_login__["l" /* onForbidden */]};});var fetchRemoveEmployeeFromAccreditationGroup=function fetchRemoveEmployeeFromAccreditationGroup(groupId,employeeId,role){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(removeEmployeeFromAccreditationGroup(groupId,employeeId,role));};};var removeEmployeeFromAccreditationGroup=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_EMPLOYEE_FROM_ACCREDITATION_GROUP',function(groupId,employeeId,role){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeEmployeeFromAccreditationGroup(groupId,employeeId,role);},function(groupId,employeeId){return{apiCall:true,onSuccess:onChangeEmployeesInAccreditationGroupSuccess(employeeId),onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_6__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_6__account_login__["l" /* onForbidden */]};});var fetchEditAccreditationGroup=function fetchEditAccreditationGroup(groupId,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onEditAccreditationGroup(groupId,data));};};var onEditAccreditationGroupSuccess=function onEditAccreditationGroupSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_activeModal__["_16" /* hideModal */])());dispatch(fetchGetAccreditationGroupData());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());};};var onEditAccreditationGroup=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_EDIT_ACCREDITATION_GROUP',function(groupId,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].editAccreditationGroup(groupId,data);},function(){return{apiCall:true,onSuccess:onEditAccreditationGroupSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_6__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_6__account_login__["l" /* onForbidden */]};});var setAccreditationGroupId=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('ACCREDITATION_GROUP_ID_SET',function(id){return id;});var resetAccreditationGroupData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('ACCREDITATION_GROUP_DATA_RESET');//- State
var initialState={error:null,fetching:false,success:false,data:null,id:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({ACCREDITATION_GROUP_ID_SET:function ACCREDITATION_GROUP_ID_SET(state,action){return Object.assign({},state,{id:action.payload});},FETCH_GET_ACCREDITATION_GROUP:function FETCH_GET_ACCREDITATION_GROUP(state){return Object.assign({},state,{error:null,fetching:true,success:false});},FETCH_GET_ACCREDITATION_GROUP_FAILED:function FETCH_GET_ACCREDITATION_GROUP_FAILED(state,action){return Object.assign({},state,{error:action.payload,fetching:false,success:false});},FETCH_GET_ACCREDITATION_GROUP_SUCCESS:function FETCH_GET_ACCREDITATION_GROUP_SUCCESS(state,action){return Object.assign({},state,{error:null,fetching:false,success:true,data:Object.assign({},state.data,action.payload)});},FETCH_GET_ACCREDITATION_GROUP_INSERTERS_SUCCESS:function FETCH_GET_ACCREDITATION_GROUP_INSERTERS_SUCCESS(state,action){return Object.assign({},state,{error:null,fetching:false,success:true,data:Object.assign({},state.data,{inserters:action.payload.content})});},FETCH_GET_ACCREDITATION_GROUP_VALIDATORS_SUCCESS:function FETCH_GET_ACCREDITATION_GROUP_VALIDATORS_SUCCESS(state,action){return Object.assign({},state,{error:null,fetching:false,success:true,data:Object.assign({},state.data,{validators:action.payload.content})});},ACCREDITATION_GROUP_DATA_RESET:function ACCREDITATION_GROUP_DATA_RESET(state){return Object.assign({},state,{data:null});}},initialState));//- Selectors
var getAccreditationGroup=function getAccreditationGroup(state){return state.accreditationGroup;};var loadingAccreditationGroup=function loadingAccreditationGroup(state){return getAccreditationGroup(state).fetching||__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNil(getAccreditationGroup(state).data)||__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNil(getAccreditationGroup(state).data.inserters)||__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNil(getAccreditationGroup(state).data.validators)||__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNil(getAccreditationGroup(state).data.name);};var getFetchingErrorAccreditationGroup=function getFetchingErrorAccreditationGroup(state){return getAccreditationGroup(state).error;};var getAccreditationGroupData=function getAccreditationGroupData(state){return getAccreditationGroup(state).data;};var getAccreditationGroupName=function getAccreditationGroupName(state){if(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNil(getAccreditationGroupData(state))){return null;}return getAccreditationGroupData(state).name;};var getAccreditationGroupId=function getAccreditationGroupId(state){return getAccreditationGroup(state).id;};

/***/ }),
/* 84 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetDepartmentFailed */
/* unused harmony export fetchGetDepartmentSuccess */
/* unused harmony export fetchGetDepartment */
/* unused harmony export fetchGetDepartmentBOsSuccess */
/* unused harmony export fetchGetDepartmentBOs */
/* unused harmony export fetchGetDepartmentHMsSuccess */
/* unused harmony export fetchGetDepartmentHMs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchGetDepartmentData; });
/* unused harmony export updateDepartmentEmployees */
/* unused harmony export onChangeEmployeesInDepartmentSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAddEmployeeToDepartment; });
/* unused harmony export onAddEmployeeToDepartment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchRemoveEmployeeFromDepartment; });
/* unused harmony export removeEmployeeFromDepartment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchEditDepartment; });
/* unused harmony export onEditDepartmentSuccess */
/* unused harmony export onEditDepartment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setDepartmentId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return resetDepartmentData; });
/* unused harmony export getDepartment */
/* unused harmony export getDepartmentData */
/* unused harmony export getDepartmentHMsData */
/* unused harmony export getDepartmentBOsData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return loadingDepartment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getFetchingErrorDepartment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDepartmentAndStaffData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDepartmentName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDepartmentEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDepartmentId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_userData__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
//- Actions
var fetchGetDepartmentFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_DEPARTMENT_FAILED');var fetchGetDepartmentSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_DEPARTMENT_SUCCESS');var fetchGetDepartment=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_DEPARTMENT',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getDepartment(id);},function(){return{apiCall:true,onSuccess:fetchGetDepartmentSuccess,onFail:fetchGetDepartmentFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_6__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_6__account_login__["l" /* onForbidden */]};});var fetchGetDepartmentBOsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_DEPARTMENT_BOS_SUCCESS');var fetchGetDepartmentBOs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_DEPARTMENT_BOS',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getEmployeesByDepartmentAndRole(id,__WEBPACK_IMPORTED_MODULE_4__account_role__["c" /* SUB_ROLES */].BO);},function(){return{apiCall:true,onSuccess:fetchGetDepartmentBOsSuccess,onFail:fetchGetDepartmentFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_6__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_6__account_login__["l" /* onForbidden */]};});var fetchGetDepartmentHMsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_DEPARTMENT_HMS_SUCCESS');var fetchGetDepartmentHMs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_DEPARTMENT_HMS',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getEmployeesByDepartmentAndRole(id,__WEBPACK_IMPORTED_MODULE_4__account_role__["c" /* SUB_ROLES */].HM);},function(){return{apiCall:true,onSuccess:fetchGetDepartmentHMsSuccess,onFail:fetchGetDepartmentFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_6__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_6__account_login__["l" /* onForbidden */]};});var fetchGetDepartmentData=function fetchGetDepartmentData(){return function(dispatch,getState){var departmentId=getDepartmentId(getState());if(!__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNil(departmentId)&&departmentId!==''){dispatch(fetchGetDepartment(departmentId));dispatch(fetchGetDepartmentHMs(departmentId));dispatch(fetchGetDepartmentBOs(departmentId));}else{dispatch(fetchGetDepartmentFailed("ID_IS_NULL"));}};};var updateDepartmentEmployees=function updateDepartmentEmployees(employeeId){return function(dispatch,getState){var departmentId=getDepartmentId(getState());dispatch(fetchGetDepartmentHMs(departmentId));dispatch(fetchGetDepartmentBOs(departmentId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());if(employeeId===Object(__WEBPACK_IMPORTED_MODULE_3__account_userData__["g" /* getUserId */])(getState())){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__account_role__["h" /* fetchGetSubRoles */])());}};};var onChangeEmployeesInDepartmentSuccess=function onChangeEmployeesInDepartmentSuccess(employeeId){return function(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_activeModal__["_16" /* hideModal */])());dispatch(updateDepartmentEmployees(employeeId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());};};};var fetchAddEmployeeToDepartment=function fetchAddEmployeeToDepartment(departmentId,employeeId,role){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onAddEmployeeToDepartment(departmentId,employeeId,role));};};var onAddEmployeeToDepartment=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_ADD_EMPLOYEE_TO_DEPARTMENT',function(departmentId,employeeId,role){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].addEmployeeToDepartment(departmentId,employeeId,role);},function(departmentId,employeeId){return{apiCall:true,onSuccess:onChangeEmployeesInDepartmentSuccess(employeeId),onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_6__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_6__account_login__["l" /* onForbidden */]};});var fetchRemoveEmployeeFromDepartment=function fetchRemoveEmployeeFromDepartment(departmentId,employeeId,role){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(removeEmployeeFromDepartment(departmentId,employeeId,role));};};var removeEmployeeFromDepartment=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_EMPLOYEE_FROM_DEPARTMENT',function(departmentId,employeeId,role){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeEmployeeFromDepartment(departmentId,employeeId,role);},function(departmentId,employeeId){return{apiCall:true,onSuccess:onChangeEmployeesInDepartmentSuccess(employeeId),onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_6__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_6__account_login__["l" /* onForbidden */]};});var fetchEditDepartment=function fetchEditDepartment(departmentId,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onEditDepartment(departmentId,data));};};var onEditDepartmentSuccess=function onEditDepartmentSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_activeModal__["_16" /* hideModal */])());dispatch(fetchGetDepartmentData());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());};};var onEditDepartment=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_EDIT_DEPARTMENT',function(departmentId,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].editDepartment(departmentId,data);},function(){return{apiCall:true,onSuccess:onEditDepartmentSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_6__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_6__account_login__["l" /* onForbidden */]};});var setDepartmentId=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('DEPARTMENT_ID_SET',function(id){return id;});var resetDepartmentData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('DEPARTMENT_DATA_RESET');//- State
var initialState={error:null,fetching:false,success:false,departmentData:null,departmentHMsData:null,departmentBOsData:null,id:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({DEPARTMENT_ID_SET:function DEPARTMENT_ID_SET(state,action){return Object.assign({},state,{id:action.payload});},FETCH_GET_DEPARTMENT:function FETCH_GET_DEPARTMENT(state){return Object.assign({},state,{error:null,fetching:true,success:false});},FETCH_GET_DEPARTMENT_FAILED:function FETCH_GET_DEPARTMENT_FAILED(state,action){return Object.assign({},state,{error:action.payload,fetching:false,success:false});},FETCH_GET_DEPARTMENT_SUCCESS:function FETCH_GET_DEPARTMENT_SUCCESS(state,action){return Object.assign({},state,{error:null,fetching:false,success:true,departmentData:action.payload});},FETCH_GET_DEPARTMENT_HMS_SUCCESS:function FETCH_GET_DEPARTMENT_HMS_SUCCESS(state,action){return Object.assign({},state,{error:null,fetching:false,success:true,departmentHMsData:action.payload.content});},FETCH_GET_DEPARTMENT_BOS_SUCCESS:function FETCH_GET_DEPARTMENT_BOS_SUCCESS(state,action){return Object.assign({},state,{error:null,fetching:false,success:true,departmentBOsData:action.payload.content});},DEPARTMENT_DATA_RESET:function DEPARTMENT_DATA_RESET(state){return Object.assign({},state,{departmentData:null,departmentHMsData:null,departmentBOsData:null});}},initialState));//- Selectors
var getDepartment=function getDepartment(state){return state.department;};var getDepartmentData=function getDepartmentData(state){return getDepartment(state).departmentData;};var getDepartmentHMsData=function getDepartmentHMsData(state){return getDepartment(state).departmentHMsData;};var getDepartmentBOsData=function getDepartmentBOsData(state){return getDepartment(state).departmentBOsData;};var loadingDepartment=function loadingDepartment(state){return getDepartment(state).fetching||__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNil(getDepartmentData(state))||__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNil(getDepartmentHMsData(state))||__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNil(getDepartmentBOsData(state))||__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNil(getDepartmentData(state).name);};var getFetchingErrorDepartment=function getFetchingErrorDepartment(state){return getDepartment(state).error;};var getDepartmentAndStaffData=function getDepartmentAndStaffData(state){return Object.assign({},getDepartmentData(state),{hms:getDepartmentHMsData(state),bos:getDepartmentBOsData(state)});};var getDepartmentName=function getDepartmentName(state){if(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNil(getDepartmentData(state))){return null;}return getDepartmentData(state).name;};var getDepartmentEmail=function getDepartmentEmail(state){if(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isNil(getDepartmentData(state))){return null;}return getDepartmentData(state).email;};var getDepartmentId=function getDepartmentId(state){return getDepartment(state).id;};

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export onSetStartAccreditationRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return setStartAccreditationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cleanStartAccreditationRequest; });
/* unused harmony export onSetNextAsStartAccreditationRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return setNextAsStartAccreditationRequestForProcessing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanProcessedStatus; });
/* unused harmony export incrementNumberOfProcessedAccreditationRequests */
/* unused harmony export fetchGetAccreditationRequestsForValidationFailed */
/* unused harmony export fetchGetAccreditationRequestsForValidationSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getAccreditationRequestsForProcessing; });
/* unused harmony export fetchGetAccreditationRequestsForValidation */
/* unused harmony export onProcessAccreditationRequestSuccess */
/* unused harmony export onConfirmAccreditationRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchConfirmAccreditationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchRejectAccreditationRequest; });
/* unused harmony export fetchGetAccreditationRequestsPerCountryForValidationFailed */
/* unused harmony export fetchGetAccreditationRequestsPerCountryForValidationSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchGetAccreditationRequestsPerCountryForValidation; });
/* unused harmony export setAccreditationRequestsForValidationCountryFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearAccreditationRequestsForValidationCountryFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return onUpdateAccreditationRequestsForValidationCountryFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return onFetchGetAccreditationRequestsPerDomainForValidation; });
/* unused harmony export fetchGetAccreditationRequestsPerDomainForValidationFailed */
/* unused harmony export fetchGetAccreditationRequestsPerDomainForValidationSuccess */
/* unused harmony export fetchGetAccreditationRequestsPerDomainForValidation */
/* unused harmony export setAccreditationRequestsForValidationDomainFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearAccreditationRequestsForValidationDomainFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return onUpdateAccreditationRequestsForValidationDomainFilter; });
/* unused harmony export getPendingAccreditationRequests */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getPendingAccreditationRequestsData; });
/* unused harmony export getCurrentPageForAccreditationRequestsList */
/* unused harmony export getTotalPagesForAccreditationRequestsList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getLeftAccreditationRequestsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return loadingPendingAccreditationRequestsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCurrentAccreditationRequestIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getNumberOfProcessedAccreditationRequests; });
/* unused harmony export getAccreditationRequestDataByIndex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCurrentAccreditationRequestId; });
/* unused harmony export getAccreditationIndexById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getPendingAccreditationRequestsPerCountryData; });
/* unused harmony export loadingPendingAccreditationRequestsPerCountryData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getPendingAccreditationRequestsPerDomainData; });
/* unused harmony export loadingPendingAccreditationRequestsPerDomainData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getPendingAccreditationRequestsCountryFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getPendingAccreditationRequestsDomainFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getPendingAccreditationRequestsPerContinentData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_location__ = __webpack_require__(21);
//- Actions
var onSetStartAccreditationRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_START_ACCREDITATION_REQUEST');var setStartAccreditationRequest=function setStartAccreditationRequest(id){return function(dispatch,getState){var index=getAccreditationIndexById(getState(),id);dispatch(onSetStartAccreditationRequest(index));dispatch(cleanProcessedStatus());};};var cleanStartAccreditationRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAN_START_ACCREDITATION_REQUEST');var onSetNextAsStartAccreditationRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_NEXT_AS_START_ACCREDITATION_REQUEST');var setNextAsStartAccreditationRequestForProcessing=function setNextAsStartAccreditationRequestForProcessing(){return function(dispatch,getState){var list=getPendingAccreditationRequestsData(getState());var currentPage=getCurrentPageForAccreditationRequestsList(getState());var groupId=Object(__WEBPACK_IMPORTED_MODULE_5__account_role__["k" /* getCurrentGroup */])(getState());if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(list)&&list.length>0){var currentIndex=getCurrentAccreditationRequestIndex(getState());if(currentIndex<list.length-1){dispatch(onSetNextAsStartAccreditationRequest(currentIndex+1));dispatch(getAccreditationRequestsForProcessing(groupId,currentPage));}else{var totalPages=getTotalPagesForAccreditationRequestsList(getState());if(currentPage<totalPages-1){dispatch(onSetNextAsStartAccreditationRequest(0));dispatch(getAccreditationRequestsForProcessing(groupId,currentPage+1));}else{dispatch(cleanStartAccreditationRequest());}}}};};var cleanProcessedStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAN_PROCESSED_STATUS');var incrementNumberOfProcessedAccreditationRequests=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('NUMBER_OF_PROCESSED_ACCREDITATION_REQUESTS_INCREMENT');var fetchGetAccreditationRequestsForValidationFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_REQUESTS_FOR_VALIDATION_FAILED');var fetchGetAccreditationRequestsForValidationSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_REQUESTS_FOR_VALIDATION_SUCCESS');var getAccreditationRequestsForProcessing=function getAccreditationRequestsForProcessing(group,page){return function(dispatch,getState){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(group)){var countryFilter=getPendingAccreditationRequestsCountryFilter(getState());var domainFilter=getPendingAccreditationRequestsDomainFilter(getState());dispatch(fetchGetAccreditationRequestsForValidation(group,countryFilter,domainFilter,page));}};};var fetchGetAccreditationRequestsForValidation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_REQUESTS_FOR_VALIDATION',function(groupId,countryFilter,domainFilter,page){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getPendingAccreditationRequests(groupId,countryFilter,domainFilter,page);},function(){return{apiCall:true,onSuccess:fetchGetAccreditationRequestsForValidationSuccess,onFail:fetchGetAccreditationRequestsForValidationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});var onProcessAccreditationRequestSuccess=function onProcessAccreditationRequestSuccess(){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());var currentPage=getCurrentPageForAccreditationRequestsList(getState());var groupId=Object(__WEBPACK_IMPORTED_MODULE_5__account_role__["k" /* getCurrentGroup */])(getState());dispatch(getAccreditationRequestsForProcessing(groupId,currentPage));dispatch(incrementNumberOfProcessedAccreditationRequests());};};var onConfirmAccreditationRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CONFIRM_ACCREDITATION_REQUEST',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].confirmAccreditationRequest(id,data);},function(){return{apiCall:true,onSuccess:onProcessAccreditationRequestSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});var fetchConfirmAccreditationRequest=function fetchConfirmAccreditationRequest(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onConfirmAccreditationRequest(id,data));};};var fetchRejectAccreditationRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_ACCREDITATION',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].rejectAccreditationRequest(id);},function(){return{apiCall:true,onSuccess:onProcessAccreditationRequestSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});var fetchGetAccreditationRequestsPerCountryForValidationFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_REQUESTS_PER_COUNTRY_FOR_VALIDATION_FAILED');var fetchGetAccreditationRequestsPerCountryForValidationSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_REQUESTS_PER_COUNTRY_FOR_VALIDATION_SUCCESS');var fetchGetAccreditationRequestsPerCountryForValidation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_REQUESTS_PER_COUNTRY_FOR_VALIDATION',function(groupId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getStaticsticsForPendingAccreditationRequests(groupId);},function(){return{apiCall:true,onSuccess:fetchGetAccreditationRequestsPerCountryForValidationSuccess,onFail:fetchGetAccreditationRequestsPerCountryForValidationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});var setAccreditationRequestsForValidationCountryFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_ACCREDITATION_REQUESTS_FOR_VALIDATION_COUNTRY_FILTER');var clearAccreditationRequestsForValidationCountryFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_ACCREDITATION_REQUESTS_FOR_VALIDATION_COUNTRY_FILTER');var onUpdateAccreditationRequestsForValidationCountryFilter=function onUpdateAccreditationRequestsForValidationCountryFilter(countryFilter){return function(dispatch,getState){dispatch(setAccreditationRequestsForValidationCountryFilter(countryFilter));var groupId=Object(__WEBPACK_IMPORTED_MODULE_5__account_role__["k" /* getCurrentGroup */])(getState());dispatch(fetchGetAccreditationRequestsForValidation(groupId,countryFilter));dispatch(fetchGetAccreditationRequestsPerDomainForValidation(groupId,countryFilter));dispatch(clearAccreditationRequestsForValidationDomainFilter());};};var onFetchGetAccreditationRequestsPerDomainForValidation=function onFetchGetAccreditationRequestsPerDomainForValidation(groupId){return function(dispatch,getState){var countryFilter=getPendingAccreditationRequestsCountryFilter(getState());dispatch(fetchGetAccreditationRequestsPerDomainForValidation(groupId,countryFilter));};};var fetchGetAccreditationRequestsPerDomainForValidationFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_REQUESTS_PER_DOMAIN_FOR_VALIDATION_FAILED');var fetchGetAccreditationRequestsPerDomainForValidationSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_REQUESTS_PER_DOMAIN_FOR_VALIDATION_SUCCESS');var fetchGetAccreditationRequestsPerDomainForValidation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_REQUESTS_PER_DOMAIN_FOR_VALIDATION',function(groupId,countryCode){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getStaticsticsForPendingAccreditationRequests(groupId,countryCode,'DOMAIN');},function(){return{apiCall:true,onSuccess:fetchGetAccreditationRequestsPerDomainForValidationSuccess,onFail:fetchGetAccreditationRequestsPerDomainForValidationFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});var setAccreditationRequestsForValidationDomainFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_ACCREDITATION_REQUESTS_FOR_VALIDATION_DOMAIN_FILTER');var clearAccreditationRequestsForValidationDomainFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_ACCREDITATION_REQUESTS_FOR_VALIDATION_DOMAIN_FILTER');var onUpdateAccreditationRequestsForValidationDomainFilter=function onUpdateAccreditationRequestsForValidationDomainFilter(domain){return function(dispatch,getState){dispatch(setAccreditationRequestsForValidationDomainFilter(domain));var groupId=Object(__WEBPACK_IMPORTED_MODULE_5__account_role__["k" /* getCurrentGroup */])(getState());var countryFilter=getPendingAccreditationRequestsCountryFilter(getState());dispatch(fetchGetAccreditationRequestsForValidation(groupId,countryFilter,domain));};};//- State
var initialState={data:null,error:null,fetching:false,currentAccreditationRequestIndex:null,processed:0,currentPage:null,totalPages:null,leftNumber:null,requestsPerCountry:null,fetchingRequestsPerCountry:false,requestsPerDomain:null,fetchingRequestsPerDomain:false,countryFilter:null,domainFilter:null};//- Reducers
/* harmony default export */ __webpack_exports__["e"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_ACCREDITATION_REQUESTS_FOR_VALIDATION:function FETCH_GET_ACCREDITATION_REQUESTS_FOR_VALIDATION(state){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,leftNumber:null,error:null,fetching:true});},FETCH_GET_ACCREDITATION_REQUESTS_FOR_VALIDATION_FAILED:function FETCH_GET_ACCREDITATION_REQUESTS_FOR_VALIDATION_FAILED(state,action){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,error:action.payload,fetching:false});},FETCH_GET_ACCREDITATION_REQUESTS_FOR_VALIDATION_SUCCESS:function FETCH_GET_ACCREDITATION_REQUESTS_FOR_VALIDATION_SUCCESS(state,action){return Object.assign({},state,{data:action.payload.content,currentPage:action.payload.number,totalPages:action.payload.totalPages,leftNumber:action.payload.totalElements,error:null,fetching:false});},SET_START_ACCREDITATION_REQUEST:function SET_START_ACCREDITATION_REQUEST(state,action){return Object.assign({},state,{currentAccreditationRequestIndex:action.payload});},SET_NEXT_AS_START_ACCREDITATION_REQUEST:function SET_NEXT_AS_START_ACCREDITATION_REQUEST(state,action){return Object.assign({},state,{currentAccreditationRequestIndex:action.payload});},CLEAN_PROCESSED_STATUS:function CLEAN_PROCESSED_STATUS(state){return Object.assign({},state,{processed:0});},CLEAN_START_ACCREDITATION_REQUEST:function CLEAN_START_ACCREDITATION_REQUEST(state){return Object.assign({},state,{currentAccreditationRequestIndex:null});},NUMBER_OF_PROCESSED_ACCREDITATION_REQUESTS_INCREMENT:function NUMBER_OF_PROCESSED_ACCREDITATION_REQUESTS_INCREMENT(state){return Object.assign({},state,{processed:state.processed+1});},ACCREDITATION_GROUP_LIST_RESET:function ACCREDITATION_GROUP_LIST_RESET(state){return Object.assign({},state,{data:null});},FETCH_GET_ACCREDITATION_REQUESTS_PER_COUNTRY_FOR_VALIDATION:function FETCH_GET_ACCREDITATION_REQUESTS_PER_COUNTRY_FOR_VALIDATION(state){return Object.assign({},state,{requestsPerCountry:null,error:null,fetchingRequestsPerCountry:true});},FETCH_GET_ACCREDITATION_REQUESTS_PER_COUNTRY_FOR_VALIDATION_FAILED:function FETCH_GET_ACCREDITATION_REQUESTS_PER_COUNTRY_FOR_VALIDATION_FAILED(state,action){return Object.assign({},state,{requestsPerCountry:null,error:action.payload,fetchingRequestsPerCountry:false});},FETCH_GET_ACCREDITATION_REQUESTS_PER_COUNTRY_FOR_VALIDATION_SUCCESS:function FETCH_GET_ACCREDITATION_REQUESTS_PER_COUNTRY_FOR_VALIDATION_SUCCESS(state,action){return Object.assign({},state,{requestsPerCountry:action.payload,error:null,fetchingRequestsPerCountry:false});},FETCH_GET_ACCREDITATION_REQUESTS_PER_DOMAIN_FOR_VALIDATION:function FETCH_GET_ACCREDITATION_REQUESTS_PER_DOMAIN_FOR_VALIDATION(state){return Object.assign({},state,{requestsPerDomain:null,error:null,fetchingRequestsPerDomain:true});},FETCH_GET_ACCREDITATION_REQUESTS_PER_DOMAIN_FOR_VALIDATION_FAILED:function FETCH_GET_ACCREDITATION_REQUESTS_PER_DOMAIN_FOR_VALIDATION_FAILED(state,action){return Object.assign({},state,{requestsPerDomain:null,error:action.payload,fetchingRequestsPerDomain:false});},FETCH_GET_ACCREDITATION_REQUESTS_PER_DOMAIN_FOR_VALIDATION_SUCCESS:function FETCH_GET_ACCREDITATION_REQUESTS_PER_DOMAIN_FOR_VALIDATION_SUCCESS(state,action){return Object.assign({},state,{requestsPerDomain:action.payload,error:null,fetchingRequestsPerDomain:false});},SET_ACCREDITATION_REQUESTS_FOR_VALIDATION_COUNTRY_FILTER:function SET_ACCREDITATION_REQUESTS_FOR_VALIDATION_COUNTRY_FILTER(state,action){return Object.assign({},state,{countryFilter:action.payload});},SET_ACCREDITATION_REQUESTS_FOR_VALIDATION_DOMAIN_FILTER:function SET_ACCREDITATION_REQUESTS_FOR_VALIDATION_DOMAIN_FILTER(state,action){return Object.assign({},state,{domainFilter:action.payload});},CLEAR_ACCREDITATION_REQUESTS_FOR_VALIDATION_COUNTRY_FILTER:function CLEAR_ACCREDITATION_REQUESTS_FOR_VALIDATION_COUNTRY_FILTER(state){return Object.assign({},state,{countryFilter:null});},CLEAR_ACCREDITATION_REQUESTS_FOR_VALIDATION_DOMAIN_FILTER:function CLEAR_ACCREDITATION_REQUESTS_FOR_VALIDATION_DOMAIN_FILTER(state){return Object.assign({},state,{domainFilter:null});}},initialState));//- Selectors
var getPendingAccreditationRequests=function getPendingAccreditationRequests(state){return state.pendingAccreditationRequests;};var getPendingAccreditationRequestsData=function getPendingAccreditationRequestsData(state){return getPendingAccreditationRequests(state).data;};var getCurrentPageForAccreditationRequestsList=function getCurrentPageForAccreditationRequestsList(state){return getPendingAccreditationRequests(state).currentPage;};var getTotalPagesForAccreditationRequestsList=function getTotalPagesForAccreditationRequestsList(state){return getPendingAccreditationRequests(state).totalPages;};var getLeftAccreditationRequestsNumber=function getLeftAccreditationRequestsNumber(state){return getPendingAccreditationRequests(state).leftNumber;};var loadingPendingAccreditationRequestsList=function loadingPendingAccreditationRequestsList(state){return getPendingAccreditationRequests(state).fetching;};var getCurrentAccreditationRequestIndex=function getCurrentAccreditationRequestIndex(state){return getPendingAccreditationRequests(state).currentAccreditationRequestIndex;};var getNumberOfProcessedAccreditationRequests=function getNumberOfProcessedAccreditationRequests(state){return getPendingAccreditationRequests(state).processed;};var getAccreditationRequestDataByIndex=function getAccreditationRequestDataByIndex(state,index){var data=getPendingAccreditationRequestsData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(index)||index<0||index>data.length-1){return null;}else{return data[index];}};var getCurrentAccreditationRequestId=function getCurrentAccreditationRequestId(state){var index=getCurrentAccreditationRequestIndex(state);var data=getAccreditationRequestDataByIndex(state,index);if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return data.id;}};var getAccreditationIndexById=function getAccreditationIndexById(state,id){var accreditationRequestsList=getPendingAccreditationRequestsData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(accreditationRequestsList)){return null;}var index=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(accreditationRequestsList,function(elem){return elem.id===id;});if(index<0){return null;}else{return index;}};var getPendingAccreditationRequestsPerCountryData=function getPendingAccreditationRequestsPerCountryData(state){return getPendingAccreditationRequests(state).requestsPerCountry;};var loadingPendingAccreditationRequestsPerCountryData=function loadingPendingAccreditationRequestsPerCountryData(state){return getPendingAccreditationRequests(state).fetchingRequestsPerCountry;};var getPendingAccreditationRequestsPerDomainData=function getPendingAccreditationRequestsPerDomainData(state){return getPendingAccreditationRequests(state).requestsPerDomain;};var loadingPendingAccreditationRequestsPerDomainData=function loadingPendingAccreditationRequestsPerDomainData(state){return getPendingAccreditationRequests(state).fetchingRequestsPerDomain;};var getPendingAccreditationRequestsCountryFilter=function getPendingAccreditationRequestsCountryFilter(state){return getPendingAccreditationRequests(state).countryFilter;};var getPendingAccreditationRequestsDomainFilter=function getPendingAccreditationRequestsDomainFilter(state){return getPendingAccreditationRequests(state).domainFilter;};var getPendingAccreditationRequestsPerContinentData=function getPendingAccreditationRequestsPerContinentData(state){var countryData=getPendingAccreditationRequests(state).requestsPerCountry;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(countryData)){return null;}var locationData=Object(__WEBPACK_IMPORTED_MODULE_6__common_location__["g" /* getLocationData */])(state);var continentData=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(locationData,function(value,key){return{value:key,count:0};});__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(countryData,function(el){var continent=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findKey(locationData,function(countries){return countries.includes(el.value);});continentData[continent].count+=el.count;});return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(continentData);};

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetCommissionsFailed */
/* unused harmony export fetchGetCommissionSuccess */
/* unused harmony export onGetCommissionsSuccess */
/* unused harmony export onFetchGetCommissions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchGetCommissions; });
/* unused harmony export onGetCommissionsForCurrentPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAddCommission; });
/* unused harmony export onAddCommission */
/* unused harmony export onRemoveCommissionSuccess */
/* unused harmony export onRemoveCommission */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return removeCommission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setCommissionToRemove; });
/* unused harmony export fetchGetBAsListFailed */
/* unused harmony export fetchGetBAsListSuccess */
/* unused harmony export onFetchGetBAsListSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetBAsList; });
/* unused harmony export fetchGetCommissionDataFailed */
/* unused harmony export fetchGetCommissionDataSuccess */
/* unused harmony export onFetchGetCommissionDataSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchGetCommissionData; });
/* unused harmony export fetchUpdateCommissionSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchUpdateCommission; });
/* unused harmony export onfetchUpdateCommission */
/* unused harmony export onUpdateCommissionsCountryFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return updateCommissionsCountryFilter; });
/* unused harmony export onUpdateCommissionsBAFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return updateCommissionsBAFilter; });
/* unused harmony export getCommissions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return loadingCommissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getCurrentPageForCommissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getTotalPagesForCommissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCommissionsData; });
/* unused harmony export getCommissionToRemoveId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCommissionToRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return loadingBAsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getBAsList; });
/* unused harmony export getCurrentCommissionData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getCurrentCommissionDataFormatted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return loadingCurrentCommission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCommissionsCountryFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCommissionsBAFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_location__ = __webpack_require__(21);
//- Actions
var fetchGetCommissionsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_COMMISSIONS_FAILED');var fetchGetCommissionSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_COMMISSIONS_SUCCESS');var onGetCommissionsSuccess=function onGetCommissionsSuccess(data){return function(dispatch,getState){var isEmpty=data.empty;var currentPage=data.number;if(!isEmpty&&currentPage!==0||currentPage===0){data.content=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(data.content,function(elem){var baData=elem.businessAmbassador;var contractData=elem.businessAmbassadorContract;return{id:contractData.id,baId:baData.id,firstName:baData.firstName,lastName:baData.lastName,continent:Object(__WEBPACK_IMPORTED_MODULE_7__common_location__["c" /* getContinentByCountry */])(contractData.countryCodes[0],getState()),countryCodes:contractData.countryCodes,commissionPercent:contractData.commissionPercent,dateFrom:contractData.dateFrom,dateTo:contractData.dateTo};});dispatch(fetchGetCommissionSuccess(data));}else{dispatch(fetchGetCommissions(currentPage-1));}};};var onFetchGetCommissions=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_COMMISSIONS',function(page,filters){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getCommissions(page,filters);},function(){return{apiCall:true,onSuccess:onGetCommissionsSuccess,onFail:fetchGetCommissionsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var fetchGetCommissions=function fetchGetCommissions(page){return function(dispatch,getState){var BAFilter=getCommissionsBAFilter(getState());var countryFilter=getCommissionsCountryFilter(getState());var filters={baId:BAFilter,countries:countryFilter||Object(__WEBPACK_IMPORTED_MODULE_7__common_location__["e" /* getCountriesData */])(getState())};dispatch(onFetchGetCommissions(page,filters));};};var onGetCommissionsForCurrentPage=function onGetCommissionsForCurrentPage(){return function(dispatch,getState){var currentPage=getCurrentPageForCommissions(getState());dispatch(fetchGetCommissions(currentPage));};};var fetchAddCommission=function fetchAddCommission(baId,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onAddCommission(baId,data));};};var onAddCommission=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_ADD_COMMISSION',function(baId,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].addCommission(baId,data);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var onRemoveCommissionSuccess=function onRemoveCommissionSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_activeModal__["_16" /* hideModal */])());dispatch(onGetCommissionsForCurrentPage());};};var onRemoveCommission=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_COMMISSION',function(baId,commissionId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeCommission(baId,commissionId);},function(){return{apiCall:true,onSuccess:onRemoveCommissionSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var removeCommission=function removeCommission(){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());var data=getCommissionToRemove(getState());dispatch(onRemoveCommission(data.baId,data.id));};};var setCommissionToRemove=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('COMMISSION_TO_REMOVE_SET',function(commissionId){return commissionId;});var fetchGetBAsListFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BA_S_LIST_FAILED');var fetchGetBAsListSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BA_S_LIST_SUCCESS');var onFetchGetBAsListSuccess=function onFetchGetBAsListSuccess(data){return function(dispatch){var BAsList=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(data,function(elem){return{id:elem.id,firstName:elem.firstName,lastName:elem.lastName};});dispatch(fetchGetBAsListSuccess(BAsList));};};var fetchGetBAsList=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BA_S_LIST',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getBusinessAmbassadors();},function(){return{apiCall:true,onSuccess:onFetchGetBAsListSuccess,onFail:fetchGetBAsListFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var fetchGetCommissionDataFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_COMMISSION_DATA_FAILED');var fetchGetCommissionDataSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_COMMISSION_DATA_SUCCESS');var onFetchGetCommissionDataSuccess=function onFetchGetCommissionDataSuccess(data){return function(dispatch,getState){data["continent"]=Object(__WEBPACK_IMPORTED_MODULE_7__common_location__["c" /* getContinentByCountry */])(data.countryCodes[0],getState());dispatch(fetchGetCommissionDataSuccess(data));};};var fetchGetCommissionData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_COMMISSION_DATA',function(baId,commissionId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getCommissionData(baId,commissionId);},function(){return{apiCall:true,onSuccess:onFetchGetCommissionDataSuccess,onFail:fetchGetCommissionDataFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var fetchUpdateCommissionSuccess=function fetchUpdateCommissionSuccess(data){return function(dispatch,getState){data["continent"]=Object(__WEBPACK_IMPORTED_MODULE_7__common_location__["c" /* getContinentByCountry */])(data.countryCodes[0],getState());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(fetchGetCommissionDataSuccess(data));};};var fetchUpdateCommission=function fetchUpdateCommission(baId,commissionId,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onfetchUpdateCommission(baId,commissionId,data));};};var onfetchUpdateCommission=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_UPDATE_COMMISSION',function(baId,commissionId,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateCommission(baId,commissionId,data);},function(){return{apiCall:true,onSuccess:fetchUpdateCommissionSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var onUpdateCommissionsCountryFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_COMMISSIONS_COUNTRY_FILTER');var updateCommissionsCountryFilter=function updateCommissionsCountryFilter(countryFilter){return function(dispatch,getState){var BAFilter=getCommissionsBAFilter(getState());var filters={baId:BAFilter,countries:countryFilter||Object(__WEBPACK_IMPORTED_MODULE_7__common_location__["e" /* getCountriesData */])(getState())};dispatch(onFetchGetCommissions(0,filters));dispatch(onUpdateCommissionsCountryFilter(countryFilter));};};var onUpdateCommissionsBAFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_COMMISSIONS_BA_FILTER');var updateCommissionsBAFilter=function updateCommissionsBAFilter(BAFilter){return function(dispatch,getState){var countryFilter=getCommissionsCountryFilter(getState());var filters={baId:BAFilter,countries:countryFilter||Object(__WEBPACK_IMPORTED_MODULE_7__common_location__["e" /* getCountriesData */])(getState())};dispatch(onFetchGetCommissions(0,filters));dispatch(onUpdateCommissionsBAFilter(BAFilter));};};//- State
var initialState={data:null,countryFilter:null,BAFilter:null,fetching:false,error:null,commissionToRemoveId:null,currentPage:null,totalPages:null,BAsList:null,BAsFetching:false,currentCommissionData:null,currentCommissionFetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_COMMISSIONS:function FETCH_GET_COMMISSIONS(state){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,error:null,fetching:true});},FETCH_GET_COMMISSIONS_FAILED:function FETCH_GET_COMMISSIONS_FAILED(state,action){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,error:action.payload,fetching:false});},FETCH_GET_COMMISSIONS_SUCCESS:function FETCH_GET_COMMISSIONS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload.content,currentPage:action.payload.number,totalPages:action.payload.totalPages,error:null,fetching:false});},COMMISSION_TO_REMOVE_SET:function COMMISSION_TO_REMOVE_SET(state,action){return Object.assign({},state,{commissionToRemoveId:action.payload});},FETCH_GET_BA_S_LIST:function FETCH_GET_BA_S_LIST(state){return Object.assign({},state,{BAsList:null,error:null,BAsFetching:true});},FETCH_GET_BA_S_LIST_FAILED:function FETCH_GET_BA_S_LIST_FAILED(state,action){return Object.assign({},state,{BAsList:null,error:action.payload,BAsFetching:false});},FETCH_GET_BA_S_LIST_SUCCESS:function FETCH_GET_BA_S_LIST_SUCCESS(state,action){return Object.assign({},state,{BAsList:action.payload,error:null,BAsFetching:false});},FETCH_GET_COMMISSION_DATA:function FETCH_GET_COMMISSION_DATA(state){return Object.assign({},state,{currentCommissionData:null,error:null,currentCommissionFetching:true});},FETCH_GET_COMMISSION_DATA_FAILED:function FETCH_GET_COMMISSION_DATA_FAILED(state,action){return Object.assign({},state,{currentCommissionData:null,error:action.payload,currentCommissionFetching:false});},FETCH_GET_COMMISSION_DATA_SUCCESS:function FETCH_GET_COMMISSION_DATA_SUCCESS(state,action){return Object.assign({},state,{currentCommissionData:action.payload,error:null,currentCommissionFetching:false});},UPDATE_COMMISSIONS_COUNTRY_FILTER:function UPDATE_COMMISSIONS_COUNTRY_FILTER(state,action){return Object.assign({},state,{countryFilter:action.payload});},UPDATE_COMMISSIONS_BA_FILTER:function UPDATE_COMMISSIONS_BA_FILTER(state,action){return Object.assign({},state,{BAFilter:action.payload});}},initialState));//- Selectors
var getCommissions=function getCommissions(state){return state.commissions;};var loadingCommissions=function loadingCommissions(state){return getCommissions(state).fetching;};var getCurrentPageForCommissions=function getCurrentPageForCommissions(state){return getCommissions(state).currentPage;};var getTotalPagesForCommissions=function getTotalPagesForCommissions(state){return getCommissions(state).totalPages;};var getCommissionsData=function getCommissionsData(state){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(getCommissions(state).data)){return null;}return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(getCommissions(state).data,function(data){return{id:data.id,baId:data.baId,name:data.firstName+" "+data.lastName,continent:data.continent,countries:data.countryCodes,commission:data.commissionPercent,dateFrom:__WEBPACK_IMPORTED_MODULE_6_moment___default()(data.dateFrom).format('L'),dateTo:__WEBPACK_IMPORTED_MODULE_6_moment___default()(data.dateTo).format('L')};});};var getCommissionToRemoveId=function getCommissionToRemoveId(state){return getCommissions(state).commissionToRemoveId;};var getCommissionToRemove=function getCommissionToRemove(state){var id=getCommissionToRemoveId(state);return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(getCommissionsData(state),function(data){return data.id===id;});};var loadingBAsList=function loadingBAsList(state){return getCommissions(state).BAsFetching;};var getBAsList=function getBAsList(state){return getCommissions(state).BAsList;};var getCurrentCommissionData=function getCurrentCommissionData(state){return getCommissions(state).currentCommissionData;};var getCurrentCommissionDataFormatted=function getCurrentCommissionDataFormatted(state){var data=getCurrentCommissionData(state);if(!data){return null;}return{id:data.id,baId:data.businessAmbassadorId,continent:data.continent,countries:data.countryCodes,commission:data.commissionPercent,dateFrom:__WEBPACK_IMPORTED_MODULE_6_moment___default()(data.dateFrom),dateTo:__WEBPACK_IMPORTED_MODULE_6_moment___default()(data.dateTo)};};var loadingCurrentCommission=function loadingCurrentCommission(state){return getCommissions(state).currentCommissionFetching;};var getCommissionsCountryFilter=function getCommissionsCountryFilter(state){return getCommissions(state).countryFilter;};var getCommissionsBAFilter=function getCommissionsBAFilter(state){return getCommissions(state).BAFilter;};

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPANIES_CREDITS_SORTING; });
/* unused harmony export fetchGetCompaniesCreditsFailed */
/* unused harmony export fetchGetCompaniesCreditsSuccess */
/* unused harmony export onGetCompaniesCreditsSuccess */
/* unused harmony export onFetchGetCompaniesCredits */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetCompaniesCredits; });
/* unused harmony export onUpdateCompaniesCreditsSorting */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return updateCompaniesCreditsSorting; });
/* unused harmony export onUpdateCompaniesCreditsNameFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return updateCompaniesCreditsNameFilter; });
/* unused harmony export updateCompanyCreditsCountryFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return onUpdateCompanyCreditsCountryFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return onUpdateCompanyCreditsCountryFilterByContinent; });
/* unused harmony export getCompanyCreditsByCountryFilter */
/* unused harmony export onFetchGetCompanyHistoryFailed */
/* unused harmony export onFetchGetCompanyHistorySuccess */
/* unused harmony export onGetCompanyHistorySuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return onFetchGetCompanyHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCompanyHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setSelectedCompanyId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return setSelectedCompanyName; });
/* unused harmony export getCompaniesCredits */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return loadingCompaniesCredits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCurrentPageForCompaniesCredits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getTotalPagesForCompaniesCredits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCompaniesCreditsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCompaniesCreditsSorting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCompaniesCreditsNameFilter; });
/* unused harmony export getCompaniesCreditsCountryFilter */
/* unused harmony export getSelectedCompanyId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCompanyHistoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return loadingCompanyHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCompanyHistoryCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCompanyHistoryTotalPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getSelectedCompanyName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_constants__ = __webpack_require__(24);
var COMPANIES_CREDITS_SORTING={NAME:"NAME",CREATED_AT:"CREATED_AT"};//- Actions
var fetchGetCompaniesCreditsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_COMPANIES_CREDITS_FAILED');var fetchGetCompaniesCreditsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_COMPANIES_CREDITS_SUCCESS');var onGetCompaniesCreditsSuccess=function onGetCompaniesCreditsSuccess(data){return function(dispatch){var isEmpty=data.empty;var currentPage=data.number;if(!isEmpty&&currentPage!==0||currentPage===0){dispatch(fetchGetCompaniesCreditsSuccess(data));}else{dispatch(fetchGetCompaniesCredits(currentPage-1));}};};var onFetchGetCompaniesCredits=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_COMPANIES_CREDITS',function(page,sorting,name,countries){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getCompaniesCredits(page,sorting,name,countries);},function(){return{apiCall:true,onSuccess:onGetCompaniesCreditsSuccess,onFail:fetchGetCompaniesCreditsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchGetCompaniesCredits=function fetchGetCompaniesCredits(page){return function(dispatch,getState){var sorting=getCompaniesCreditsSorting(getState());var name=getCompaniesCreditsNameFilter(getState());var countries=getCompaniesCreditsCountryFilter(getState());dispatch(onFetchGetCompaniesCredits(page,sorting,name,countries));};};var onUpdateCompaniesCreditsSorting=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_COMPANIES_CREDITS_SORTING');var updateCompaniesCreditsSorting=function updateCompaniesCreditsSorting(sorting){return function(dispatch,getState){var name=getCompaniesCreditsNameFilter(getState());var countries=getCompaniesCreditsCountryFilter(getState());dispatch(onFetchGetCompaniesCredits(0,sorting,name,countries));dispatch(onUpdateCompaniesCreditsSorting(sorting));};};var onUpdateCompaniesCreditsNameFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_COMPANIES_CREDITS_NAME_FILTER');var updateCompaniesCreditsNameFilter=function updateCompaniesCreditsNameFilter(name){return function(dispatch,getState){var sorting=getCompaniesCreditsSorting(getState());var countries=getCompaniesCreditsCountryFilter(getState());dispatch(onFetchGetCompaniesCredits(0,sorting,name,countries));dispatch(onUpdateCompaniesCreditsNameFilter(name));};};var updateCompanyCreditsCountryFilter=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_COMPANIES_CREDITS_COUNTRY_FILTER');var onUpdateCompanyCreditsCountryFilter=function onUpdateCompanyCreditsCountryFilter(country){return function(dispatch){var countries=country?[country]:null;dispatch(updateCompanyCreditsCountryFilter(countries));dispatch(getCompanyCreditsByCountryFilter(countries));};};var onUpdateCompanyCreditsCountryFilterByContinent=function onUpdateCompanyCreditsCountryFilterByContinent(continent){return function(dispatch){var countries=continent?__WEBPACK_IMPORTED_MODULE_4__constants_constants__["k" /* LOCATION_MAP */][continent]:null;dispatch(updateCompanyCreditsCountryFilter(countries));dispatch(getCompanyCreditsByCountryFilter(countries));};};var getCompanyCreditsByCountryFilter=function getCompanyCreditsByCountryFilter(countries){return function(dispatch,getState){var sorting=getCompaniesCreditsSorting(getState());var name=getCompaniesCreditsNameFilter(getState());dispatch(onFetchGetCompaniesCredits(0,sorting,name,countries));};};var onFetchGetCompanyHistoryFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_COMPANY_HISTORY_FAILED');var onFetchGetCompanyHistorySuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_COMPANY_HISTORY_SUCCESS');var onGetCompanyHistorySuccess=function onGetCompanyHistorySuccess(data){return function(dispatch,getState){var isEmpty=data.empty;var currentPage=data.number;var id=getSelectedCompanyId(getState());if(!isEmpty&&currentPage!==0||currentPage===0){dispatch(onFetchGetCompanyHistorySuccess(data));}else{dispatch(onFetchGetCompanyHistory(currentPage-1,id));}};};var onFetchGetCompanyHistory=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_COMPANY_HISTORY',function(page,id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getCompanyCreditsHistory(page,id);},function(){return{apiCall:true,onSuccess:onGetCompanyHistorySuccess,onFail:onFetchGetCompanyHistoryFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var getCompanyHistory=function getCompanyHistory(page){return function(dispatch,getState){var id=getSelectedCompanyId(getState());dispatch(onFetchGetCompanyHistory(page,id));};};var setSelectedCompanyId=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SELECTED_COMPANY_ID_SET');var setSelectedCompanyName=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SELECTED_COMPANY_NAME_SET');//- State
var initialState={data:null,fetching:false,error:null,currentPage:null,totalPages:null,sorting:COMPANIES_CREDITS_SORTING.NAME,nameFilter:null,selectedCompanyName:null,selectedCompanyId:null,countryFilter:null,companyHistory:null,companyHistoryFetching:false,companyHistoryError:null,companyHistoryCurrentPage:null,companyHistoryTotalPages:null};//- Reducers
/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_COMPANIES_CREDITS:function FETCH_GET_COMPANIES_CREDITS(state){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,error:null,fetching:true});},FETCH_GET_COMPANIES_CREDITS_FAILED:function FETCH_GET_COMPANIES_CREDITS_FAILED(state,action){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,error:action.payload,fetching:false});},FETCH_GET_COMPANIES_CREDITS_SUCCESS:function FETCH_GET_COMPANIES_CREDITS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload.content,currentPage:action.payload.number,totalPages:action.payload.totalPages,error:null,fetching:false});},UPDATE_COMPANIES_CREDITS_SORTING:function UPDATE_COMPANIES_CREDITS_SORTING(state,action){return Object.assign({},state,{sorting:action.payload});},UPDATE_COMPANIES_CREDITS_NAME_FILTER:function UPDATE_COMPANIES_CREDITS_NAME_FILTER(state,action){return Object.assign({},state,{nameFilter:action.payload});},UPDATE_COMPANIES_CREDITS_COUNTRY_FILTER:function UPDATE_COMPANIES_CREDITS_COUNTRY_FILTER(state,action){return Object.assign({},state,{countryFilter:action.payload});},FETCH_GET_COMPANY_HISTORY:function FETCH_GET_COMPANY_HISTORY(state){return Object.assign({},state,{companyHistory:null,companyHistoryFetching:true,companyHistoryError:null,companyHistoryCurrentPage:null,companyHistoryTotalPages:null});},FETCH_GET_COMPANY_HISTORY_FAILED:function FETCH_GET_COMPANY_HISTORY_FAILED(state,action){return Object.assign({},state,{companyHistory:null,companyHistoryFetching:false,companyHistoryError:action.payload,companyHistoryCurrentPage:null,companyHistoryTotalPages:null});},FETCH_GET_COMPANY_HISTORY_SUCCESS:function FETCH_GET_COMPANY_HISTORY_SUCCESS(state,action){return Object.assign({},state,{companyHistory:action.payload.content,companyHistoryFetching:false,companyHistoryError:null,companyHistoryCurrentPage:action.payload.number,companyHistoryTotalPages:action.payload.totalPages});},SELECTED_COMPANY_ID_SET:function SELECTED_COMPANY_ID_SET(state,action){return Object.assign({},state,{selectedCompanyId:action.payload});},SELECTED_COMPANY_NAME_SET:function SELECTED_COMPANY_NAME_SET(state,action){return Object.assign({},state,{selectedCompanyName:action.payload});}},initialState));//- Selectors
var getCompaniesCredits=function getCompaniesCredits(state){return state.companiesCredits;};var loadingCompaniesCredits=function loadingCompaniesCredits(state){return getCompaniesCredits(state).fetching;};var getCurrentPageForCompaniesCredits=function getCurrentPageForCompaniesCredits(state){return getCompaniesCredits(state).currentPage;};var getTotalPagesForCompaniesCredits=function getTotalPagesForCompaniesCredits(state){return getCompaniesCredits(state).totalPages;};var getCompaniesCreditsData=function getCompaniesCreditsData(state){var data=getCompaniesCredits(state).data;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(data,function(elem){var totalCredit=[];__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(elem.transactionStatistic,function(transactions){__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(transactions,function(transaction){var index=totalCredit.findIndex(function(el){return el.currency===transaction.currency;});if(index!==-1){totalCredit[index].amount+=transaction.amount;}else{totalCredit.push({currency:transaction.currency,amount:transaction.amount});}});});return{id:elem.target.id,name:elem.target.name,joinDate:elem.target.createdAt,openCredit:elem.target.balance,totalCredit:totalCredit,contactData:{firstName:elem.target.anchor.identityAlias.firstName,lastName:elem.target.anchor.identityAlias.lastName,email:elem.target.anchor.email,phoneNumber:elem.target.anchor.identityAlias.phoneNumber}};});};var getCompaniesCreditsSorting=function getCompaniesCreditsSorting(state){return getCompaniesCredits(state).sorting;};var getCompaniesCreditsNameFilter=function getCompaniesCreditsNameFilter(state){return getCompaniesCredits(state).nameFilter;};var getCompaniesCreditsCountryFilter=function getCompaniesCreditsCountryFilter(state){return getCompaniesCredits(state).countryFilter;};var getSelectedCompanyId=function getSelectedCompanyId(state){return getCompaniesCredits(state).selectedCompanyId;};var getCompanyHistoryData=function getCompanyHistoryData(state){var data=getCompaniesCredits(state).companyHistory;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(data,function(elem){return{createdAt:elem.transaction.createdAt,delta:elem.transaction.delta,comment:elem.transaction.metadata.comment};});};var loadingCompanyHistory=function loadingCompanyHistory(state){return getCompaniesCredits(state).companyHistoryFetching;};var getCompanyHistoryCurrentPage=function getCompanyHistoryCurrentPage(state){return getCompaniesCredits(state).companyHistoryCurrentPage;};var getCompanyHistoryTotalPages=function getCompanyHistoryTotalPages(state){return getCompaniesCredits(state).companyHistoryTotalPages;};var getSelectedCompanyName=function getSelectedCompanyName(state){return getCompaniesCredits(state).selectedCompanyName;};

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFunction;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isFunction(x) {
    return typeof x === 'function';
}
//# sourceMappingURL=isFunction.js.map


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Action__ = __webpack_require__(357);
/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */


var AsyncAction = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (this.closed) {
            return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && this.delay === delay && this.pending === false) {
            return id;
        }
        clearInterval(id);
    };
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function () {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
            actions.splice(index, 1);
        }
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
        }
        this.delay = null;
    };
    return AsyncAction;
}(__WEBPACK_IMPORTED_MODULE_1__Action__["a" /* Action */]));

//# sourceMappingURL=AsyncAction.js.map


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Scheduler__ = __webpack_require__(216);
/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */


var AsyncScheduler = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = __WEBPACK_IMPORTED_MODULE_1__Scheduler__["a" /* Scheduler */].now;
        }
        var _this = _super.call(this, SchedulerAction, function () {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
                return AsyncScheduler.delegate.now();
            }
            else {
                return now();
            }
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
            return AsyncScheduler.delegate.schedule(work, delay, state);
        }
        else {
            return _super.prototype.schedule.call(this, work, delay, state);
        }
    };
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (action = actions.shift());
        this.active = false;
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(__WEBPACK_IMPORTED_MODULE_1__Scheduler__["a" /* Scheduler */]));

//# sourceMappingURL=AsyncScheduler.js.map


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArgumentOutOfRangeError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function ArgumentOutOfRangeErrorImpl() {
    Error.call(this);
    this.message = 'argument out of range';
    this.name = 'ArgumentOutOfRangeError';
    return this;
}
ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;
//# sourceMappingURL=ArgumentOutOfRangeError.js.map


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmptyError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function EmptyErrorImpl() {
    Error.call(this);
    this.message = 'no elements in sequence';
    this.name = 'EmptyError';
    return this;
}
EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
var EmptyError = EmptyErrorImpl;
//# sourceMappingURL=EmptyError.js.map


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSymbolIterator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return iterator; });
/* unused harmony export $$iterator */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator = /*@__PURE__*/ getSymbolIterator();
var $$iterator = iterator;
//# sourceMappingURL=iterator.js.map


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeMap;
/* unused harmony export MergeMapOperator */
/* unused harmony export MergeMapSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_subscribeToResult__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InnerSubscriber__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__observable_from__ = __webpack_require__(55);
/** PURE_IMPORTS_START tslib,_util_subscribeToResult,_OuterSubscriber,_InnerSubscriber,_map,_observable_from PURE_IMPORTS_END */






function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (typeof resultSelector === 'function') {
        return function (source) { return source.pipe(mergeMap(function (a, i) { return Object(__WEBPACK_IMPORTED_MODULE_5__observable_from__["a" /* from */])(project(a, i)).pipe(Object(__WEBPACK_IMPORTED_MODULE_4__map__["a" /* map */])(function (b, ii) { return resultSelector(a, b, i, ii); })); }, concurrent)); };
    }
    else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return function (source) { return source.lift(new MergeMapOperator(project, concurrent)); };
}
var MergeMapOperator = /*@__PURE__*/ (function () {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}());

var MergeMapSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
        var innerSubscriber = new __WEBPACK_IMPORTED_MODULE_3__InnerSubscriber__["a" /* InnerSubscriber */](this, undefined, undefined);
        this.add(innerSubscriber);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_subscribeToResult__["a" /* subscribeToResult */])(this, ish, value, index, innerSubscriber);
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__["a" /* OuterSubscriber */]));

//# sourceMappingURL=mergeMap.js.map


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultIfEmpty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) {
        defaultValue = null;
    }
    return function (source) { return source.lift(new DefaultIfEmptyOperator(defaultValue)); };
}
var DefaultIfEmptyOperator = /*@__PURE__*/ (function () {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}());
var DefaultIfEmptySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        var _this = _super.call(this, destination) || this;
        _this.defaultValue = defaultValue;
        _this.isEmpty = true;
        return _this;
    }
    DefaultIfEmptySubscriber.prototype._next = function (value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function () {
        if (this.isEmpty) {
            this.destination.next(this.defaultValue);
        }
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=defaultIfEmpty.js.map


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = filter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
var FilterOperator = /*@__PURE__*/ (function () {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}());
var FilterSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.destination.next(value);
        }
    };
    return FilterSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=filter.js.map


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPE_DELIMITER; });
var DEFAULT_NAMESPACE = '/';
var ACTION_TYPE_DELIMITER = '||';

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) return false;

  var proto = value;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SERVER_ERROR_CODE */
/* unused harmony export SERVICE_UNAVAILABLE_CODE */
/* unused harmony export BAD_REQUEST_CODE */
/* unused harmony export UNAUTHORIZED_CODE */
/* unused harmony export FORBIDDEN_CODE */
/* unused harmony export SERVER_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UNAUTHORIZED; });
/* unused harmony export FORBIDDEN */
/* unused harmony export ORGANIZATION_CANNOT_WORK_WITH_ACCREDITATIONS */
/* unused harmony export APPLICANT_ACCREDITATION_REQUEST_CANNOT_BE_MODIFIED_IF_ORG_REFERENCED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOTP_CODE_REQUIRED; });
/* unused harmony export TOTP_CODE_INVALID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OAUTH_REQUEST_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleApiCallEpic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operators__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_constants__ = __webpack_require__(24);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//- Constants
var EMPTY_CONTENT="0";var SERVER_ERROR_CODE=500;var SERVICE_UNAVAILABLE_CODE=503;var BAD_REQUEST_CODE=400;var UNAUTHORIZED_CODE=401;var FORBIDDEN_CODE=403;var SERVER_ERROR="500";var UNAUTHORIZED="401";var FORBIDDEN="403";var ORGANIZATION_CANNOT_WORK_WITH_ACCREDITATIONS="ORGANIZATION_CANNOT_WORK_WITH_ACCREDITATIONS";var APPLICANT_ACCREDITATION_REQUEST_CANNOT_BE_MODIFIED_IF_ORG_REFERENCED="APPLICANT_ACCREDITATION_REQUEST_CANNOT_BE_MODIFIED_IF_ORG_REFERENCED";var TOTP_CODE_REQUIRED="TOTP_CODE_REQUIRED";var TOTP_CODE_INVALID="TOTP_CODE_INVALID";var OAUTH_REQUEST_TYPE="OAUTH_REQUEST_TYPE";var ApiCallFieldsError=function(_Error){_inherits(ApiCallFieldsError,_Error);function ApiCallFieldsError(fieldsErrors){var _ref;_classCallCheck(this,ApiCallFieldsError);for(var _len=arguments.length,params=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){params[_key-1]=arguments[_key];}var _this=_possibleConstructorReturn(this,(_ref=ApiCallFieldsError.__proto__||Object.getPrototypeOf(ApiCallFieldsError)).call.apply(_ref,[this].concat(params)));_this.name='ApiCallFieldsError';_this.fieldsErrors=fieldsErrors;return _this;}return ApiCallFieldsError;}(Error);//- Epics
var handleApiCallEpic=function handleApiCallEpic(action$){return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["b" /* filter */])(function(action){return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(action.meta)&&action.meta.apiCall;}),Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["d" /* mergeMap */])(function(action){return Object(__WEBPACK_IMPORTED_MODULE_0_rxjs__["c" /* from */])(action.payload).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["d" /* mergeMap */])(function(response){if(!response.ok){if(action.meta.type===OAUTH_REQUEST_TYPE){switch(response.status){case SERVER_ERROR_CODE:throw new Error(__WEBPACK_IMPORTED_MODULE_5__constants_constants__["m" /* OAUTH_ERRORS */].SERVER_ERROR);case SERVICE_UNAVAILABLE_CODE:throw new Error(__WEBPACK_IMPORTED_MODULE_5__constants_constants__["m" /* OAUTH_ERRORS */].TEMPORARILY_UNAVAILABLE);case BAD_REQUEST_CODE:throw new Error(__WEBPACK_IMPORTED_MODULE_5__constants_constants__["m" /* OAUTH_ERRORS */].INVALID_REQUEST);default:break;}return response.json().then(function(data){throw new Error(data.error||data.message||response.statusText);});}switch(response.status){case SERVER_ERROR_CODE:throw new Error(SERVER_ERROR);case UNAUTHORIZED_CODE:return response.json().then(function(data){if(data.error===TOTP_CODE_REQUIRED||data.error===TOTP_CODE_INVALID){throw new Error(data.error);}else{throw new Error(UNAUTHORIZED);}});case FORBIDDEN_CODE:return response.json().then(function(data){if(data.error===ORGANIZATION_CANNOT_WORK_WITH_ACCREDITATIONS||data.error===APPLICANT_ACCREDITATION_REQUEST_CANNOT_BE_MODIFIED_IF_ORG_REFERENCED){throw new Error(data.error);}else{throw new Error(FORBIDDEN);}});case BAD_REQUEST_CODE:return response.json().then(function(data){if(data.hasOwnProperty('fieldsErrors')&&data.fieldsErrors){throw new ApiCallFieldsError(data.fieldsErrors,data.error);}else{throw new Error(data.error);}});default:break;}return response.json().then(function(data){throw new Error(data.error||data.message||response.statusText);});}var responseType=response.headers.get('Content-Type');if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(responseType)&&responseType.startsWith('application/json')){return Object(__WEBPACK_IMPORTED_MODULE_0_rxjs__["c" /* from */])(response.json());}else{return Object(__WEBPACK_IMPORTED_MODULE_0_rxjs__["c" /* from */])(EMPTY_CONTENT);}}),Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["d" /* mergeMap */])(function(result){return Object(__WEBPACK_IMPORTED_MODULE_0_rxjs__["e" /* of */])(action.meta.onSuccess(result));}),Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["a" /* catchError */])(function(error){if(error.message===ORGANIZATION_CANNOT_WORK_WITH_ACCREDITATIONS){return Object(__WEBPACK_IMPORTED_MODULE_0_rxjs__["e" /* of */])(action.meta.onFail(error.message),Object(__WEBPACK_IMPORTED_MODULE_4__account_role__["x" /* setOrgPermissionsMissing */])(true));}if(error.message===SERVER_ERROR){return Object(__WEBPACK_IMPORTED_MODULE_0_rxjs__["e" /* of */])(Object(__WEBPACK_IMPORTED_MODULE_3__account_login__["n" /* onServerError */])());}if(error.message===UNAUTHORIZED&&action.meta.onUnauthorized){return Object(__WEBPACK_IMPORTED_MODULE_0_rxjs__["e" /* of */])(action.meta.onFail(error.message),action.meta.onUnauthorized());}if(error.message===FORBIDDEN&&action.meta.onForbidden){return Object(__WEBPACK_IMPORTED_MODULE_0_rxjs__["e" /* of */])(action.meta.onForbidden());}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(error.fieldsErrors)&&action.meta.onSetFieldsErrors){return Object(__WEBPACK_IMPORTED_MODULE_0_rxjs__["e" /* of */])(action.meta.onFail(error.message),action.meta.onSetFieldsErrors(error.fieldsErrors));}return Object(__WEBPACK_IMPORTED_MODULE_0_rxjs__["e" /* of */])(action.meta.onFail(error.message));}));}));};

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CryptoUtils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idb__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_idb__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var KEY_DB_NAME='KeyDB';var KEY_DB_VERSION=1;var KEY_OBJ_STORE='keys';var SIGN_ALGORITHM={name:'RSA-PSS',hash:'SHA-256',saltLength:32};var KW_ALGORITHM={name:'AES-KW',length:256};var CryptoUtils=function(){function CryptoUtils(){_classCallCheck(this,CryptoUtils);}_createClass(CryptoUtils,null,[{key:'putKey',value:function putKey(userId,jwk,secret){var _this=this;// Create a wrapping key from secret
var wrappingKeyPromise=this._importWrappingKey(secret);// Import the key itself in JWK format
var importKeyPromise=this._importJWK(jwk);return Promise.all([wrappingKeyPromise,importKeyPromise]).then(function(keys){// Encrypt the key for storage
var wrapKeyPromise=crypto.subtle.wrapKey('jwk',keys[1],keys[0],KW_ALGORITHM);return Promise.all([keys[1],wrapKeyPromise]);}).then(function(keys){// Store the key in the DB
return _this._runInDB('readwrite',function(keyStore){keyStore.put({userId:userId,key:keys[1]});return Promise.resolve(keys[0]);});});}},{key:'getKey',value:function getKey(userId,secret){var _this2=this;// Create a wrapping key from secret
return this._importWrappingKey(secret).then(function(wrappingKey){return _this2._runInDB('readonly',function(keyStore){// Get the encrypted key
return keyStore.get(userId).then(function(data){if(!data){return null;}// Decrypt the key for usage
return crypto.subtle.unwrapKey('jwk',data.key,wrappingKey,KW_ALGORITHM,SIGN_ALGORITHM,false,['sign']);});});});}},{key:'hasKey',value:function hasKey(userId){return this._runInDB('readonly',function(keyStore){return keyStore.get(userId).then(function(data){return!!data;});});}},{key:'signStringWithJWK',value:function signStringWithJWK(jwk,str){var _this3=this;return this._importJWK(jwk).then(function(key){return _this3.signString(key,str);});}},{key:'signString',value:function signString(key,str){var _this4=this;return crypto.subtle.sign(SIGN_ALGORITHM,key,this._getStringEncoder()(str).buffer).then(function(signature){return _this4._arrayBufferToBase64(signature);});}},{key:'signAccreditation',value:function signAccreditation(key,obj){var _this5=this;if(!obj.verifiedIdentity){obj.verifiedIdentity={};}var vidSignPromise=crypto.subtle.sign(SIGN_ALGORITHM,key,this._verifiedIdentityToArray(obj.verifiedIdentity).buffer).then(function(signature){obj.verifiedIdentity.signature=_this5._arrayBufferToBase64(signature);});var accSignPromise=crypto.subtle.sign(SIGN_ALGORITHM,key,this._accreditationToArray(obj).buffer).then(function(signature){obj.signature=_this5._arrayBufferToBase64(signature);});return Promise.all([vidSignPromise,accSignPromise]).then(function(){return obj;});}},{key:'_runInDB',value:function _runInDB(trType,callback){return __WEBPACK_IMPORTED_MODULE_0_idb___default.a.open(KEY_DB_NAME,KEY_DB_VERSION,function(upgradeDB){var keyStore=upgradeDB.createObjectStore(KEY_OBJ_STORE,{keyPath:'userId'});keyStore.createIndex('UserIndex','userId',{unique:true});}).then(function(db){var tx=db.transaction(KEY_OBJ_STORE,trType);var keyStore=tx.objectStore(KEY_OBJ_STORE);return callback(keyStore).then(function(result){return Promise.all([result,tx.complete]);}).then(function(values){db.close();return values[0];});});}},{key:'_importJWK',value:function _importJWK(jwk){return crypto.subtle.importKey('jwk',jwk,SIGN_ALGORITHM,true,['sign']);}},{key:'_importWrappingKey',value:function _importWrappingKey(secret){var secretBytes=this._base64ToArrayBuffer(secret);return crypto.subtle.importKey('raw',secretBytes,KW_ALGORITHM,false,['wrapKey','unwrapKey']);}},{key:'_verifiedIdentityToArray',value:function _verifiedIdentityToArray(vid){var enc=this._getStringEncoder();var parts=['countryCode','nationalId','firstName','lastName'].map(function(k){return enc(vid[k]);});return this._buildArrayFromParts(parts);}},{key:'_accreditationToArray',value:function _accreditationToArray(accreditationRequest){var enc=this._getStringEncoder();var vid=accreditationRequest.verifiedIdentity||{};var acc=accreditationRequest.accreditationData||{};var vidPrefix=this._verifiedIdentityToArray(vid);var basicAccParts=['level','issuedAt'].map(function(k){return enc(acc[k]);});var titles=acc.titles||{};var titleParts=['original',titles.original];var titleKeys=Object.keys(titles);titleKeys.sort();titleKeys.forEach(function(k){if(k!=='original'){titleParts.push(k);titleParts.push(titles[k]);}});titleParts=titleParts.map(enc);var accParts=this._buildArrayFromParts(basicAccParts.concat(titleParts));return this._concatUInt8Arrays(vidPrefix,accParts);}},{key:'_getStringEncoder',value:function _getStringEncoder(){var enc=new TextEncoder('utf-8');return function(s){return enc.encode(s||'');};}},{key:'_concatUInt8Arrays',value:function _concatUInt8Arrays(a,b){var array=new Uint8Array(a.length+b.length);array.set(a,0);array.set(b,a.length);return array;}},{key:'_buildArrayFromParts',value:function _buildArrayFromParts(parts){var totalPartSize=parts.reduce(function(acc,x){return acc+x.byteLength;},0);// parts.length is for 0xFF separators
var totalSize=totalPartSize+parts.length;var array=new Uint8Array(totalSize);var offset=0;parts.forEach(function(x){array.set(x,offset);offset+=x.byteLength;array[offset]=0xFF;++offset;});return array;}},{key:'_base64ToArrayBuffer',value:function _base64ToArrayBuffer(base64){var binary=atob(base64);var len=binary.length;var bytes=new Uint8Array(len);for(var i=0;i<len;++i){bytes[i]=binary.charCodeAt(i);}return bytes.buffer;}},{key:'_arrayBufferToBase64',value:function _arrayBufferToBase64(buffer){var binary='';var bytes=new Uint8Array(buffer);var len=bytes.byteLength;for(var i=0;i<len;++i){binary+=String.fromCharCode(bytes[i]);}return window.btoa(binary);}}]);return CryptoUtils;}();

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_popper__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(9);





/* eslint react/no-find-dom-node: 0 */
// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md






var propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  dropup: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["j" /* deprecated */])(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, 'Please use the prop "direction" with the value "up".'),
  direction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']),
  group: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  nav: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  addonType: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['prepend', 'append'])]),
  size: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_9__utils__["t" /* tagPropType */],
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  inNavbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  setActiveFromChild: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  isOpen: false,
  direction: 'down',
  nav: false,
  active: false,
  addonType: false,
  inNavbar: false,
  setActiveFromChild: false
};
var childContextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired
};

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Dropdown, _React$Component);

  function Dropdown(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.addEvents = _this.addEvents.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleDocumentClick = _this.handleDocumentClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.removeEvents = _this.removeEvents.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      toggle: this.props.toggle,
      isOpen: this.props.isOpen,
      direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
      inNavbar: this.props.inNavbar
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.handleProps();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      this.handleProps();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeEvents();
  };

  _proto.getContainer = function getContainer() {
    if (this._$container) return this._$container;
    this._$container = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
  };

  _proto.getMenuCtrl = function getMenuCtrl() {
    if (this._$menuCtrl) return this._$menuCtrl;
    this._$menuCtrl = this.getContainer().querySelector('[aria-expanded]');
    return this._$menuCtrl;
  };

  _proto.getMenuItems = function getMenuItems() {
    return [].slice.call(this.getContainer().querySelectorAll('[role="menuitem"]'));
  };

  _proto.addEvents = function addEvents() {
    var _this2 = this;

    ['click', 'touchstart', 'keyup'].forEach(function (event) {
      return document.addEventListener(event, _this2.handleDocumentClick, true);
    });
  };

  _proto.removeEvents = function removeEvents() {
    var _this3 = this;

    ['click', 'touchstart', 'keyup'].forEach(function (event) {
      return document.removeEventListener(event, _this3.handleDocumentClick, true);
    });
  };

  _proto.handleDocumentClick = function handleDocumentClick(e) {
    if (e && (e.which === 3 || e.type === 'keyup' && e.which !== __WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].tab)) return;
    var container = this.getContainer();

    if (container.contains(e.target) && container !== e.target && (e.type !== 'keyup' || e.which === __WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].tab)) {
      return;
    }

    this.toggle(e);
  };

  _proto.handleKeyDown = function handleKeyDown(e) {
    var _this4 = this;

    if (/input|textarea/i.test(e.target.tagName) || __WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].tab === e.which && e.target.getAttribute('role') !== 'menuitem') {
      return;
    }

    e.preventDefault();
    if (this.props.disabled) return;

    if (this.getMenuCtrl() === e.target) {
      if (!this.props.isOpen && [__WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].space, __WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].enter, __WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].up, __WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].down].indexOf(e.which) > -1) {
        this.toggle(e);
        setTimeout(function () {
          return _this4.getMenuItems()[0].focus();
        });
      }
    }

    if (this.props.isOpen && e.target.getAttribute('role') === 'menuitem') {
      if ([__WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].tab, __WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].esc].indexOf(e.which) > -1) {
        this.toggle(e);
        this.getMenuCtrl().focus();
      } else if ([__WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].space, __WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].enter].indexOf(e.which) > -1) {
        e.target.click();
        this.getMenuCtrl().focus();
      } else if ([__WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].down, __WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].up].indexOf(e.which) > -1 || [__WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].n, __WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].p].indexOf(e.which) > -1 && e.ctrlKey) {
        var $menuitems = this.getMenuItems();
        var index = $menuitems.indexOf(e.target);

        if (__WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].up === e.which || __WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].p === e.which && e.ctrlKey) {
          index = index !== 0 ? index - 1 : $menuitems.length - 1;
        } else if (__WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].down === e.which || __WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].n === e.which && e.ctrlKey) {
          index = index === $menuitems.length - 1 ? 0 : index + 1;
        }

        $menuitems[index].focus();
      } else if (__WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].end === e.which) {
        var _$menuitems = this.getMenuItems();

        _$menuitems[_$menuitems.length - 1].focus();
      } else if (__WEBPACK_IMPORTED_MODULE_9__utils__["o" /* keyCodes */].home === e.which) {
        var _$menuitems2 = this.getMenuItems();

        _$menuitems2[0].focus();
      } else if (e.which >= 48 && e.which <= 90) {
        var _$menuitems3 = this.getMenuItems();

        var charPressed = String.fromCharCode(e.which).toLowerCase();

        for (var i = 0; i < _$menuitems3.length; i += 1) {
          var firstLetter = _$menuitems3[i].textContent && _$menuitems3[i].textContent[0].toLowerCase();

          if (firstLetter === charPressed) {
            _$menuitems3[i].focus();

            break;
          }
        }
      }
    }
  };

  _proto.handleProps = function handleProps() {
    if (this.props.isOpen) {
      this.addEvents();
    } else {
      this.removeEvents();
    }
  };

  _proto.toggle = function toggle(e) {
    if (this.props.disabled) {
      return e && e.preventDefault();
    }

    return this.props.toggle(e);
  };

  _proto.render = function render() {
    var _classNames;

    var _omit = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["q" /* omit */])(this.props, ['toggle', 'disabled', 'inNavbar', 'direction']),
        className = _omit.className,
        cssModule = _omit.cssModule,
        dropup = _omit.dropup,
        isOpen = _omit.isOpen,
        group = _omit.group,
        size = _omit.size,
        nav = _omit.nav,
        setActiveFromChild = _omit.setActiveFromChild,
        active = _omit.active,
        addonType = _omit.addonType,
        attrs = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_omit, ["className", "cssModule", "dropup", "isOpen", "group", "size", "nav", "setActiveFromChild", "active", "addonType"]);

    var direction = this.props.direction === 'down' && dropup ? 'up' : this.props.direction;
    attrs.tag = attrs.tag || (nav ? 'li' : 'div');
    var subItemIsActive = false;

    if (setActiveFromChild) {
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.map(this.props.children[1].props.children, function (dropdownItem) {
        if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
      });
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_8_classnames___default()(className, direction !== 'down' && "drop" + direction, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, (_classNames = {}, _classNames["input-group-" + addonType] = addonType, _classNames['btn-group'] = group, _classNames["btn-group-" + size] = !!size, _classNames.dropdown = !group && !addonType, _classNames.show = isOpen, _classNames['nav-item'] = nav, _classNames)), cssModule);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_popper__["b" /* Manager */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attrs, {
      className: classes,
      onKeyDown: this.handleKeyDown
    }));
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
Dropdown.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfirmPassword__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__ConfirmPassword__["a" /* default */]));

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdditionalTitle__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__AdditionalTitle__["a" /* default */]));

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(136).Buffer))

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetDepartmentsFailed */
/* unused harmony export fetchGetDepartmentsSuccess */
/* unused harmony export onGetDepartmentsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetDepartments; });
/* unused harmony export onGetDepartmentsForCurrentPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchRegisterDepartment; });
/* unused harmony export onRegisterDepartment */
/* unused harmony export onChangeDepartmentSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchRemoveDepartment; });
/* unused harmony export onRemoveDepartment */
/* unused harmony export getDepartments */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return loadingDepartments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCurrentPageForDepartments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTotalPagesForDepartments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDepartmentsData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//- Actions
var fetchGetDepartmentsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_DEPARTMENTS_FAILED');var fetchGetDepartmentsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_DEPARTMENTS_SUCCESS');var onGetDepartmentsSuccess=function onGetDepartmentsSuccess(data){return function(dispatch){var isEmpty=data.empty;var currentPage=data.number;if(!isEmpty&&currentPage!==0||currentPage===0){dispatch(fetchGetDepartmentsSuccess(data));}else{dispatch(fetchGetDepartments(currentPage-1));}};};var fetchGetDepartments=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_DEPARTMENTS',function(page){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getDepartments(page);},function(){return{apiCall:true,onSuccess:onGetDepartmentsSuccess,onFail:fetchGetDepartmentsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});var onGetDepartmentsForCurrentPage=function onGetDepartmentsForCurrentPage(){return function(dispatch,getState){var currentPage=getCurrentPageForDepartments(getState());dispatch(fetchGetDepartments(currentPage));};};var fetchRegisterDepartment=function fetchRegisterDepartment(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onRegisterDepartment(data));};};var onRegisterDepartment=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REGISTER_DEPARTMENT',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].registerDepartment(data);},function(){return{apiCall:true,onSuccess:onChangeDepartmentSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});var onChangeDepartmentSuccess=function onChangeDepartmentSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(onGetDepartmentsForCurrentPage());};};var fetchRemoveDepartment=function fetchRemoveDepartment(departmentId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onRemoveDepartment(departmentId));};};var onRemoveDepartment=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_DEPARTMENT',function(departmentId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeDepartment(departmentId);},function(){return{apiCall:true,onSuccess:onChangeDepartmentSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});//- State
var initialState={fetching:false,data:null,error:null,currentPage:null,totalPages:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_DEPARTMENTS:function FETCH_GET_DEPARTMENTS(state){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,error:null,fetching:true});},FETCH_GET_DEPARTMENTS_FAILED:function FETCH_GET_DEPARTMENTS_FAILED(state,action){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,error:action.payload,fetching:false});},FETCH_GET_DEPARTMENTS_SUCCESS:function FETCH_GET_DEPARTMENTS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload.content,currentPage:action.payload.number,totalPages:action.payload.totalPages,error:null,fetching:false});}},initialState));//- Selectors
var getDepartments=function getDepartments(state){return state.departments;};var loadingDepartments=function loadingDepartments(state){return getDepartments(state).fetching;};var getCurrentPageForDepartments=function getCurrentPageForDepartments(state){return getDepartments(state).currentPage;};var getTotalPagesForDepartments=function getTotalPagesForDepartments(state){return getDepartments(state).totalPages;};var getDepartmentsData=function getDepartmentsData(state){if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(getDepartments(state).data)){return null;}return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(getDepartments(state).data,function(department){return{id:department.id,name:department.name,email:department.email,hrManagerCount:department.hrManagerCount,businessOwnerCount:department.businessOwnerCount};});};

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetVIDsFailed */
/* unused harmony export fetchGetVIDsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetVIDs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchGetVIDsForList; });
/* unused harmony export onUpdateVIDSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchUpdateVID; });
/* unused harmony export onUpdateVID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchActivateVID; });
/* unused harmony export onActivateVID */
/* unused harmony export getVIDs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getVIDsLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getVIDsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isVIDEditable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return loadingVIDs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pendingAccreditations__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//- Actions
var fetchGetVIDsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ALL_VIDS_FAILED');var fetchGetVIDsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ALL_VIDS_SUCCESS');var fetchGetVIDs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ALL_VIDS',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAllVIDs();},function(){return{apiCall:true,onSuccess:fetchGetVIDsSuccess,onFail:fetchGetVIDsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchGetVIDsForList=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ALL_VIDS_FOR_LIST',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAllVIDs();},function(){return{apiCall:true,onSuccess:fetchGetVIDsSuccess,onFail:fetchGetVIDsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onUpdateVIDSuccess=function onUpdateVIDSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["k" /* resetSubmitFormData */])());dispatch(fetchGetVIDsForList());};};var fetchUpdateVID=function fetchUpdateVID(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onUpdateVID(id,data));};};var onUpdateVID=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_VID_ACCREDITATION',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateVID(id,data);},function(){return{apiCall:true,onSuccess:onUpdateVIDSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchActivateVID=function fetchActivateVID(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onActivateVID(id));};};var onActivateVID=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_VID_ACTIVATE',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].activateVID(id);},function(){return{apiCall:true,onSuccess:onUpdateVIDSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});//- State
var initialState={data:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_ALL_VIDS:function FETCH_GET_ALL_VIDS(state){return Object.assign({},state,{data:null,error:null,fetching:true});},FETCH_GET_ALL_VIDS_FOR_LIST:function FETCH_GET_ALL_VIDS_FOR_LIST(state){return Object.assign({},state,{error:null,fetching:true});},FETCH_GET_ALL_VIDS_FAILED:function FETCH_GET_ALL_VIDS_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_ALL_VIDS_SUCCESS:function FETCH_GET_ALL_VIDS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});}},initialState));//- Selectors
var getVIDs=function getVIDs(state){return state.VIDs;};var getVIDsLoading=function getVIDsLoading(state){return getVIDs(state).fetching;};var getVIDsData=function getVIDsData(state){return getVIDs(state).data;};var isVIDEditable=function isVIDEditable(state,id){var data=getVIDsData(state);var accreditationData=Object(__WEBPACK_IMPORTED_MODULE_4__pendingAccreditations__["e" /* getPendingAccreditationDataById */])(state,id);if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(accreditationData)||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(accreditationData.verifiedIdentity)||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(data)){return null;}var accreditationVID=Object(__WEBPACK_IMPORTED_MODULE_4__pendingAccreditations__["e" /* getPendingAccreditationDataById */])(state,id).verifiedIdentity;return!data.find(function(elem){return elem.countryCode===accreditationVID.countryCode&&elem.nationalId===accreditationVID.nationalId;});};var loadingVIDs=function loadingVIDs(state){return getVIDs(state).fetching;};

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetPriorConsentsFailed */
/* unused harmony export fetchGetPriorConsentsSuccess */
/* unused harmony export fetchGetPriorConsents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return onGetPriorConsents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return onCreatePriorConsent; });
/* unused harmony export fetchCreatePriorConsent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setFilterDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resetPriorConsentsData; });
/* unused harmony export getPriorConsents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadingPriorConsents; });
/* unused harmony export getPriorConsentsData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPriorConsentsList; });
/* unused harmony export getFilterDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_login__ = __webpack_require__(17);
//- Actions
var fetchGetPriorConsentsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PRIOR_CONSENTS_FAILED');var fetchGetPriorConsentsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PRIOR_CONSENTS_SUCCESS');var fetchGetPriorConsents=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PRIOR_CONSENTS',function(date){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getPriorConsents(date);},function(){return{apiCall:true,onSuccess:fetchGetPriorConsentsSuccess,onFail:fetchGetPriorConsentsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});var onGetPriorConsents=function onGetPriorConsents(){return function(dispatch,getState){var filterDate=getFilterDate(getState());dispatch(fetchGetPriorConsents(filterDate));};};var onCreatePriorConsent=function onCreatePriorConsent(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchCreatePriorConsent(data));};};var fetchCreatePriorConsent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CREATE_PRIOR_CONSENT',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].createPriorConsent(data);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});var setFilterDate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_FILTER_DATE');var resetPriorConsentsData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RESET_PRIOR_CONSENTS_DATA');//- State
var initialState={data:null,error:null,fetching:false,dateFilter:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_PRIOR_CONSENTS:function FETCH_GET_PRIOR_CONSENTS(state){return Object.assign({},state,{data:null,error:null,fetching:true});},FETCH_GET_PRIOR_CONSENTS_FAILED:function FETCH_GET_PRIOR_CONSENTS_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_PRIOR_CONSENTS_SUCCESS:function FETCH_GET_PRIOR_CONSENTS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload.content,error:null,fetching:false});},SET_FILTER_DATE:function SET_FILTER_DATE(state,action){return Object.assign({},state,{dateFilter:action.payload});},RESET_PRIOR_CONSENTS_DATA:function RESET_PRIOR_CONSENTS_DATA(state){return Object.assign({},state,{data:null,dateFilter:null,error:null});}},initialState));//- Selectors
var getPriorConsents=function getPriorConsents(state){return state.priorConsents;};var loadingPriorConsents=function loadingPriorConsents(state){return getPriorConsents(state).fetching;};var getPriorConsentsData=function getPriorConsentsData(state){return getPriorConsents(state).data;};var getPriorConsentsList=function getPriorConsentsList(state){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(getPriorConsentsData(state),function(consent){return{id:consent.id,targetType:consent.targetType,targetId:consent.targetId,metadata:consent.metadata,enabledTill:consent.enabledTill,grantedPeriodDays:consent.grantedPeriodDays};});};var getFilterDate=function getFilterDate(state){return getPriorConsents(state).dateFilter;};

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REQUEST_SUBMITTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REQUEST_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REQUEST_IN_PROCESS; });
/* unused harmony export fetchGetAccreditationRequestsFailed */
/* unused harmony export fetchGetAccreditationRequestsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchGetAccreditationRequests; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return onCreateAccreditationRequest; });
/* unused harmony export fetchCreateAccreditationRequest */
/* unused harmony export getAccreditationRequests */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return loadingAccreditationRequests; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAccreditationRequestsData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_submitForm__ = __webpack_require__(7);
var REQUEST_SUBMITTED='REQUEST_SUBMITTED';var REQUEST_REJECTED='REQUEST_REJECTED';var REQUEST_IN_PROCESS='REQUEST_IN_PROCESS';//- Actions
var fetchGetAccreditationRequestsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_REQUESTS_FAILED');var fetchGetAccreditationRequestsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_REQUESTS_SUCCESS');var fetchGetAccreditationRequests=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_REQUESTS',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAccreditationRequests();},function(){return{apiCall:true,onSuccess:fetchGetAccreditationRequestsSuccess,onFail:fetchGetAccreditationRequestsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onCreateAccreditationRequest=function onCreateAccreditationRequest(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchCreateAccreditationRequest(data));};};var fetchCreateAccreditationRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CREATE_ACCREDITATION_REQUEST',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].createAccreditationRequest(data);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});//- State
var initialState={data:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["d"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_ACCREDITATION_REQUESTS:function FETCH_GET_ACCREDITATION_REQUESTS(state){return Object.assign({},state,{error:null,fetching:true});},FETCH_GET_ACCREDITATION_REQUESTS_FAILED:function FETCH_GET_ACCREDITATION_REQUESTS_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_ACCREDITATION_REQUESTS_SUCCESS:function FETCH_GET_ACCREDITATION_REQUESTS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});}},initialState));//- Selectors
var getAccreditationRequests=function getAccreditationRequests(state){return state.accreditationRequests;};var loadingAccreditationRequests=function loadingAccreditationRequests(state){return getAccreditationRequests(state).fetching;};var getAccreditationRequestsData=function getAccreditationRequestsData(state){return getAccreditationRequests(state).data;};

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetAssistantsFailed */
/* unused harmony export fetchGetAssistantsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetAssistants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return onCreateAssistant; });
/* unused harmony export fetchCreateAssistant */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return onRemoveAssistant; });
/* unused harmony export fetchRemoveAssistantSuccess */
/* unused harmony export fetchRemoveAssistant */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return onEditAssistant; });
/* unused harmony export fetchEditAssistantSuccess */
/* unused harmony export fetchEditAssistant */
/* unused harmony export getAssistants */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadingAssistants; });
/* unused harmony export getAssistantsData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return geAssistantsFormattedData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_constants__ = __webpack_require__(24);
//- Actions
var fetchGetAssistantsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ASSISTANTS_FAILED');var fetchGetAssistantsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ASSISTANTS_SUCCESS');var fetchGetAssistants=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ASSISTANTS',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAssistants();},function(){return{apiCall:true,onSuccess:fetchGetAssistantsSuccess,onFail:fetchGetAssistantsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onCreateAssistant=function onCreateAssistant(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchCreateAssistant(data));};};var fetchCreateAssistant=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_ADD_ASSISTANT',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].addAssistant(data);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onRemoveAssistant=function onRemoveAssistant(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchRemoveAssistant(id));};};var fetchRemoveAssistantSuccess=function fetchRemoveAssistantSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(fetchGetAssistants());};};var fetchRemoveAssistant=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_ASSISTANT',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeAssistant(id);},function(){return{apiCall:true,onSuccess:fetchRemoveAssistantSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onEditAssistant=function onEditAssistant(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchEditAssistant(id,data));};};var fetchEditAssistantSuccess=function fetchEditAssistantSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(fetchGetAssistants());};};var fetchEditAssistant=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_EDIT_ASSISTANT',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].editAssistant(id,data);},function(){return{apiCall:true,onSuccess:fetchEditAssistantSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});//- State
var initialState={fetching:false,data:null,error:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_ASSISTANTS:function FETCH_GET_ASSISTANTS(state){return Object.assign({},state,{error:null,fetching:true});},FETCH_GET_ASSISTANTS_FAILED:function FETCH_GET_ASSISTANTS_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_ASSISTANTS_SUCCESS:function FETCH_GET_ASSISTANTS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});}},initialState));//- Selectors
var getAssistants=function getAssistants(state){return state.assistants;};var loadingAssistants=function loadingAssistants(state){return getAssistants(state).fetching;};var getAssistantsData=function getAssistantsData(state){return getAssistants(state).data;};var geAssistantsFormattedData=function geAssistantsFormattedData(state){var data=getAssistantsData(state);if(!data){return null;}return!data?null:data.map(function(assistant){var roles=[];if(assistant.permissions.hasFinancialManagerPermission){roles.push(__WEBPACK_IMPORTED_MODULE_4__constants_constants__["b" /* ASSISTANT_TYPES */].FINANCIAL_ASSISTANT);}if(assistant.permissions.hasProcessingManagerPermission){roles.push(__WEBPACK_IMPORTED_MODULE_4__constants_constants__["b" /* ASSISTANT_TYPES */].PROCESS_ASSISTANT);}return{id:assistant.id,email:assistant.email,firstName:assistant.identityAlias.firstName,lastName:assistant.identityAlias.lastName,countryCode:assistant.identityAlias.countryCode,roles:roles,hasRootPermission:assistant.permissions.hasRootPermission};});};

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetPaymentsHistoryForBAsFailed */
/* unused harmony export fetchGetPaymentsHistoryForBAsSuccess */
/* unused harmony export onGetPaymentsHistoryForBAsSuccess */
/* unused harmony export onFetchGetPaymentsHistoryForBAs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetPaymentsHistoryForBAs; });
/* unused harmony export onUpdateDateFromFilterForBAsPaymentsHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return updateDateFromFilterForBAsPaymentsHistory; });
/* unused harmony export onUpdateDateToFilterForBAsPaymentsHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return updateDateToFilterForBAsPaymentsHistory; });
/* unused harmony export onUpdateNameFilterForBAsPaymentsHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return updateNameFilterForBAsPaymentsHistory; });
/* unused harmony export updateCountryFilterForBAsPaymentsHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return onUpdateCountryFilterForBAsPaymentsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return onUpdateCountryFilterByContinentForBAsPaymentsHistory; });
/* unused harmony export getBAsPaymentHistoryByCountryFilter */
/* unused harmony export fetchGetPaymentsHistoryForUniversitiesFailed */
/* unused harmony export fetchGetPaymentsHistoryForUniversitiesSuccess */
/* unused harmony export onGetPaymentsHistoryForUniversitiesSuccess */
/* unused harmony export onFetchGetPaymentsHistoryForUniversities */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetPaymentsHistoryForUniversities; });
/* unused harmony export onUpdateDateFromFilterForUniversitiesPaymentsHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateDateFromFilterForUniversitiesPaymentsHistory; });
/* unused harmony export onUpdateDateToFilterForUniversitiesPaymentsHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return updateDateToFilterForUniversitiesPaymentsHistory; });
/* unused harmony export onUpdateNameFilterForUniversitiesPaymentsHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return updateNameFilterForUniversitiesPaymentsHistory; });
/* unused harmony export updateCountryFilterForUniversitiesPaymentsHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return onUpdateCountryFilterForUniversitiesPaymentsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return onUpdateCountryFilterByContinentForUniversitiesPaymentsHistory; });
/* unused harmony export getUniversitiesPaymentHistoryByCountryFilter */
/* unused harmony export getPaymentsHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return loadingBAsPaymentsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCurrentPageForBAsPaymentsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getTotalPagesForBAsPaymentsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBAsPaymentsHistoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDateFromFilterForBAsPaymentsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDateToFilterForBAsPaymentsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getNameFilterForBAsPaymentsHistory; });
/* unused harmony export getCountryFilterForBAsPaymentsHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return loadingUniversitiesPaymentsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCurrentPageForUniversitiesPaymentsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getTotalPagesForUniversitiesPaymentsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getUniversitiesPaymentsHistoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDateFromFilterForUniversitiesPaymentsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getDateToFilterForUniversitiesPaymentsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getNameFilterForUniversitiesPaymentsHistory; });
/* unused harmony export getCountryFilterForUniversitiesPaymentsHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_constants__ = __webpack_require__(24);
var NO_COMMENT='No Comment';//- Actions
var fetchGetPaymentsHistoryForBAsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BA_S_PAYMENTS_HISTORY_FAILED');var fetchGetPaymentsHistoryForBAsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BA_S_PAYMENTS_HISTORY_SUCCESS');var onGetPaymentsHistoryForBAsSuccess=function onGetPaymentsHistoryForBAsSuccess(data){return function(dispatch){var isEmpty=data.empty;var currentPage=data.number;if(!isEmpty&&currentPage!==0||currentPage===0){dispatch(fetchGetPaymentsHistoryForBAsSuccess(data));}else{dispatch(fetchGetPaymentsHistoryForBAs(currentPage-1));}};};var onFetchGetPaymentsHistoryForBAs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BA_S_PAYMENTS_HISTORY',function(page,filters){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getPaymentsHistoryForBAs(page,filters);},function(){return{apiCall:true,onSuccess:onGetPaymentsHistoryForBAsSuccess,onFail:fetchGetPaymentsHistoryForBAsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchGetPaymentsHistoryForBAs=function fetchGetPaymentsHistoryForBAs(page){return function(dispatch,getState){var dateFromFilter=getDateFromFilterForBAsPaymentsHistory(getState());var dateToFilter=getDateToFilterForBAsPaymentsHistory(getState());var nameFilter=getNameFilterForBAsPaymentsHistory(getState());var countries=getCountryFilterForBAsPaymentsHistory(getState());var filters={dateFrom:dateFromFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateFromFilter).utc().format():null,dateTo:dateToFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateToFilter).utc().format():null,name:nameFilter,countries:countries};dispatch(onFetchGetPaymentsHistoryForBAs(page,filters));};};var onUpdateDateFromFilterForBAsPaymentsHistory=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_DATE_FROM_FILTER_FOR_BA_S_PAYMENTS_HISTORY');var updateDateFromFilterForBAsPaymentsHistory=function updateDateFromFilterForBAsPaymentsHistory(dateFromFilter){return function(dispatch,getState){var dateToFilter=getDateToFilterForBAsPaymentsHistory(getState());var nameFilter=getNameFilterForBAsPaymentsHistory(getState());var countries=getCountryFilterForBAsPaymentsHistory(getState());var filters={dateFrom:dateFromFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateFromFilter).utc().format():null,dateTo:dateToFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateToFilter).utc().format():null,name:nameFilter,countries:countries};dispatch(onFetchGetPaymentsHistoryForBAs(0,filters));dispatch(onUpdateDateFromFilterForBAsPaymentsHistory(dateFromFilter));};};var onUpdateDateToFilterForBAsPaymentsHistory=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_DATE_TO_FILTER_FOR_BA_S_PAYMENTS_HISTORY');var updateDateToFilterForBAsPaymentsHistory=function updateDateToFilterForBAsPaymentsHistory(dateToFilter){return function(dispatch,getState){var dateFromFilter=getDateFromFilterForBAsPaymentsHistory(getState());var nameFilter=getNameFilterForBAsPaymentsHistory(getState());var countries=getCountryFilterForBAsPaymentsHistory(getState());var filters={dateFrom:dateFromFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateFromFilter).utc().format():null,dateTo:dateToFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateToFilter).utc().format():null,name:nameFilter,countries:countries};dispatch(onFetchGetPaymentsHistoryForBAs(0,filters));dispatch(onUpdateDateToFilterForBAsPaymentsHistory(dateToFilter));};};var onUpdateNameFilterForBAsPaymentsHistory=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_NAME_FILTER_FOR_BA_S_PAYMENTS_HISTORY');var updateNameFilterForBAsPaymentsHistory=function updateNameFilterForBAsPaymentsHistory(nameFilter){return function(dispatch,getState){var dateFromFilter=getDateFromFilterForBAsPaymentsHistory(getState());var dateToFilter=getDateToFilterForBAsPaymentsHistory(getState());var countries=getCountryFilterForBAsPaymentsHistory(getState());var filters={dateFrom:dateFromFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateFromFilter).utc().format():null,dateTo:dateToFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateToFilter).utc().format():null,name:nameFilter,countries:countries};dispatch(onFetchGetPaymentsHistoryForBAs(0,filters));dispatch(onUpdateNameFilterForBAsPaymentsHistory(nameFilter));};};var updateCountryFilterForBAsPaymentsHistory=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_COUNTRY_FILTER_FOR_BA_S_PAYMENTS_HISTORY');var onUpdateCountryFilterForBAsPaymentsHistory=function onUpdateCountryFilterForBAsPaymentsHistory(country){return function(dispatch){var countries=country?[country]:null;dispatch(updateCountryFilterForBAsPaymentsHistory(countries));dispatch(getBAsPaymentHistoryByCountryFilter(countries));};};var onUpdateCountryFilterByContinentForBAsPaymentsHistory=function onUpdateCountryFilterByContinentForBAsPaymentsHistory(continent){return function(dispatch){var countries=continent?__WEBPACK_IMPORTED_MODULE_5__constants_constants__["k" /* LOCATION_MAP */][continent]:null;dispatch(updateCountryFilterForBAsPaymentsHistory(countries));dispatch(getBAsPaymentHistoryByCountryFilter(countries));};};var getBAsPaymentHistoryByCountryFilter=function getBAsPaymentHistoryByCountryFilter(countries){return function(dispatch,getState){var dateFromFilter=getDateFromFilterForBAsPaymentsHistory(getState());var dateToFilter=getDateToFilterForBAsPaymentsHistory(getState());var nameFilter=getNameFilterForBAsPaymentsHistory(getState());var filters={dateFrom:dateFromFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateFromFilter).utc().format():null,dateTo:dateToFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateToFilter).utc().format():null,name:nameFilter,countries:countries};dispatch(onFetchGetPaymentsHistoryForBAs(0,filters));};};var fetchGetPaymentsHistoryForUniversitiesFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_UNI_S_PAYMENTS_HISTORY_FAILED');var fetchGetPaymentsHistoryForUniversitiesSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_UNI_S_PAYMENTS_HISTORY_SUCCESS');var onGetPaymentsHistoryForUniversitiesSuccess=function onGetPaymentsHistoryForUniversitiesSuccess(data){return function(dispatch){var isEmpty=data.empty;var currentPage=data.number;if(!isEmpty&&currentPage!==0||currentPage===0){dispatch(fetchGetPaymentsHistoryForUniversitiesSuccess(data));}else{dispatch(fetchGetPaymentsHistoryForUniversities(currentPage-1));}};};var onFetchGetPaymentsHistoryForUniversities=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_UNI_S_PAYMENTS_HISTORY',function(page,filters){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getPaymentsHistoryForUniversities(page,filters);},function(){return{apiCall:true,onSuccess:onGetPaymentsHistoryForUniversitiesSuccess,onFail:fetchGetPaymentsHistoryForUniversitiesFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchGetPaymentsHistoryForUniversities=function fetchGetPaymentsHistoryForUniversities(page){return function(dispatch,getState){var dateFromFilter=getDateFromFilterForUniversitiesPaymentsHistory(getState());var dateToFilter=getDateToFilterForUniversitiesPaymentsHistory(getState());var nameFilter=getNameFilterForUniversitiesPaymentsHistory(getState());var countries=getCountryFilterForUniversitiesPaymentsHistory(getState());var filters={dateFrom:dateFromFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateFromFilter).utc().format():null,dateTo:dateToFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateToFilter).utc().format():null,name:nameFilter,countries:countries};dispatch(onFetchGetPaymentsHistoryForUniversities(page,filters));};};var onUpdateDateFromFilterForUniversitiesPaymentsHistory=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_DATE_FROM_FILTER_FOR_UNI_S_PAYMENTS_HISTORY');var updateDateFromFilterForUniversitiesPaymentsHistory=function updateDateFromFilterForUniversitiesPaymentsHistory(dateFromFilter){return function(dispatch,getState){var dateToFilter=getDateToFilterForUniversitiesPaymentsHistory(getState());var nameFilter=getNameFilterForUniversitiesPaymentsHistory(getState());var countries=getCountryFilterForUniversitiesPaymentsHistory(getState());var filters={dateFrom:dateFromFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateFromFilter).utc().format():null,dateTo:dateToFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateToFilter).utc().format():null,name:nameFilter,countries:countries};dispatch(onFetchGetPaymentsHistoryForUniversities(0,filters));dispatch(onUpdateDateFromFilterForUniversitiesPaymentsHistory(dateFromFilter));};};var onUpdateDateToFilterForUniversitiesPaymentsHistory=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_DATE_TO_FILTER_FOR_UNI_S_PAYMENTS_HISTORY');var updateDateToFilterForUniversitiesPaymentsHistory=function updateDateToFilterForUniversitiesPaymentsHistory(dateToFilter){return function(dispatch,getState){var dateFromFilter=getDateFromFilterForUniversitiesPaymentsHistory(getState());var nameFilter=getNameFilterForUniversitiesPaymentsHistory(getState());var countries=getCountryFilterForUniversitiesPaymentsHistory(getState());var filters={dateFrom:dateFromFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateFromFilter).utc().format():null,dateTo:dateToFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateToFilter).utc().format():null,name:nameFilter,countries:countries};dispatch(onFetchGetPaymentsHistoryForUniversities(0,filters));dispatch(onUpdateDateToFilterForUniversitiesPaymentsHistory(dateToFilter));};};var onUpdateNameFilterForUniversitiesPaymentsHistory=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_NAME_FILTER_FOR_UNI_S_PAYMENTS_HISTORY');var updateNameFilterForUniversitiesPaymentsHistory=function updateNameFilterForUniversitiesPaymentsHistory(nameFilter){return function(dispatch,getState){var dateFromFilter=getDateFromFilterForUniversitiesPaymentsHistory(getState());var dateToFilter=getDateToFilterForUniversitiesPaymentsHistory(getState());var countries=getCountryFilterForUniversitiesPaymentsHistory(getState());var filters={dateFrom:dateFromFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateFromFilter).utc().format():null,dateTo:dateToFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateToFilter).utc().format():null,name:nameFilter,countries:countries};dispatch(onFetchGetPaymentsHistoryForUniversities(0,filters));dispatch(onUpdateNameFilterForUniversitiesPaymentsHistory(nameFilter));};};var updateCountryFilterForUniversitiesPaymentsHistory=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_COUNTRY_FILTER_FOR_UNI_S_PAYMENTS_HISTORY');var onUpdateCountryFilterForUniversitiesPaymentsHistory=function onUpdateCountryFilterForUniversitiesPaymentsHistory(country){return function(dispatch){var countries=country?[country]:null;dispatch(updateCountryFilterForUniversitiesPaymentsHistory(countries));dispatch(getUniversitiesPaymentHistoryByCountryFilter(countries));};};var onUpdateCountryFilterByContinentForUniversitiesPaymentsHistory=function onUpdateCountryFilterByContinentForUniversitiesPaymentsHistory(continent){return function(dispatch){var countries=continent?__WEBPACK_IMPORTED_MODULE_5__constants_constants__["k" /* LOCATION_MAP */][continent]:null;dispatch(updateCountryFilterForUniversitiesPaymentsHistory(countries));dispatch(getUniversitiesPaymentHistoryByCountryFilter(countries));};};var getUniversitiesPaymentHistoryByCountryFilter=function getUniversitiesPaymentHistoryByCountryFilter(countries){return function(dispatch,getState){var dateFromFilter=getDateFromFilterForUniversitiesPaymentsHistory(getState());var dateToFilter=getDateToFilterForUniversitiesPaymentsHistory(getState());var nameFilter=getNameFilterForUniversitiesPaymentsHistory(getState());var filters={dateFrom:dateFromFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateFromFilter).utc().format():null,dateTo:dateToFilter?__WEBPACK_IMPORTED_MODULE_4_moment___default()(dateToFilter).utc().format():null,name:nameFilter,countries:countries};dispatch(onFetchGetPaymentsHistoryForUniversities(0,filters));};};//- State
var initialState={BAsData:null,BAsDateFromFilter:null,BAsDateToFilter:null,BAsNameFilter:'',BAsCountryFilter:null,BAsFetching:false,BAsError:null,BAsCurrentPage:null,BAsTotalPages:null,universitiesData:null,universitiesDateFromFilter:null,universitiesDateToFilter:null,universitiesNameFilter:'',universitiesCountryFilter:null,universitiesFetching:false,universitiesError:null,universitiesCurrentPage:null,universitiesTotalPages:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_BA_S_PAYMENTS_HISTORY:function FETCH_GET_BA_S_PAYMENTS_HISTORY(state){return Object.assign({},state,{BAsData:null,BAsCurrentPage:null,BAsTotalPages:null,BAsError:null,BAsFetching:true});},FETCH_GET_BA_S_PAYMENTS_HISTORY_FAILED:function FETCH_GET_BA_S_PAYMENTS_HISTORY_FAILED(state,action){return Object.assign({},state,{BAsData:null,BAsCurrentPage:null,BAsTotalPages:null,BAsError:action.payload,BAsFetching:false});},FETCH_GET_BA_S_PAYMENTS_HISTORY_SUCCESS:function FETCH_GET_BA_S_PAYMENTS_HISTORY_SUCCESS(state,action){return Object.assign({},state,{BAsData:action.payload.content,BAsCurrentPage:action.payload.number,BAsTotalPages:action.payload.totalPages,BAsError:null,BAsFetching:false});},FETCH_GET_UNI_S_PAYMENTS_HISTORY:function FETCH_GET_UNI_S_PAYMENTS_HISTORY(state){return Object.assign({},state,{universitiesData:null,universitiesCurrentPage:null,universitiesTotalPages:null,universitiesError:null,universitiesFetching:true});},FETCH_GET_UNI_S_PAYMENTS_HISTORY_FAILED:function FETCH_GET_UNI_S_PAYMENTS_HISTORY_FAILED(state,action){return Object.assign({},state,{universitiesData:null,universitiesCurrentPage:null,universitiesTotalPages:null,universitiesError:action.payload,universitiesFetching:false});},FETCH_GET_UNI_S_PAYMENTS_HISTORY_SUCCESS:function FETCH_GET_UNI_S_PAYMENTS_HISTORY_SUCCESS(state,action){return Object.assign({},state,{universitiesData:action.payload.content,universitiesCurrentPage:action.payload.number,universitiesTotalPages:action.payload.totalPages,universitiesError:null,universitiesFetching:false});},UPDATE_DATE_FROM_FILTER_FOR_BA_S_PAYMENTS_HISTORY:function UPDATE_DATE_FROM_FILTER_FOR_BA_S_PAYMENTS_HISTORY(state,action){return Object.assign({},state,{BAsDateFromFilter:action.payload});},UPDATE_DATE_TO_FILTER_FOR_BA_S_PAYMENTS_HISTORY:function UPDATE_DATE_TO_FILTER_FOR_BA_S_PAYMENTS_HISTORY(state,action){return Object.assign({},state,{BAsDateToFilter:action.payload});},UPDATE_NAME_FILTER_FOR_BA_S_PAYMENTS_HISTORY:function UPDATE_NAME_FILTER_FOR_BA_S_PAYMENTS_HISTORY(state,action){return Object.assign({},state,{BAsNameFilter:action.payload});},UPDATE_DATE_FROM_FILTER_FOR_UNI_S_PAYMENTS_HISTORY:function UPDATE_DATE_FROM_FILTER_FOR_UNI_S_PAYMENTS_HISTORY(state,action){return Object.assign({},state,{universitiesDateFromFilter:action.payload});},UPDATE_DATE_TO_FILTER_FOR_UNI_S_PAYMENTS_HISTORY:function UPDATE_DATE_TO_FILTER_FOR_UNI_S_PAYMENTS_HISTORY(state,action){return Object.assign({},state,{universitiesDateToFilter:action.payload});},UPDATE_NAME_FILTER_FOR_UNI_S_PAYMENTS_HISTORY:function UPDATE_NAME_FILTER_FOR_UNI_S_PAYMENTS_HISTORY(state,action){return Object.assign({},state,{universitiesNameFilter:action.payload});},UPDATE_COUNTRY_FILTER_FOR_UNI_S_PAYMENTS_HISTORY:function UPDATE_COUNTRY_FILTER_FOR_UNI_S_PAYMENTS_HISTORY(state,action){return Object.assign({},state,{universitiesCountryFilter:action.payload});},UPDATE_COUNTRY_FILTER_FOR_BA_S_PAYMENTS_HISTORY:function UPDATE_COUNTRY_FILTER_FOR_BA_S_PAYMENTS_HISTORY(state,action){return Object.assign({},state,{BAsCountryFilter:action.payload});}},initialState));//- Selectors
var getPaymentsHistory=function getPaymentsHistory(state){return state.paymentsHistory;};var loadingBAsPaymentsHistory=function loadingBAsPaymentsHistory(state){return getPaymentsHistory(state).BAsFetching;};var getCurrentPageForBAsPaymentsHistory=function getCurrentPageForBAsPaymentsHistory(state){return getPaymentsHistory(state).BAsCurrentPage;};var getTotalPagesForBAsPaymentsHistory=function getTotalPagesForBAsPaymentsHistory(state){return getPaymentsHistory(state).BAsTotalPages;};var getBAsPaymentsHistoryData=function getBAsPaymentsHistoryData(state){var data=getPaymentsHistory(state).BAsData;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(data,function(elem){return{id:elem.transaction.transactionId,name:elem.target.firstName+' '+elem.target.lastName,paymentAmount:{currency:elem.transaction.delta.currency,amount:Math.abs(elem.transaction.delta.amount)},totalPay:elem.totalByTransactionType.map(function(transaction){return Object.assign({},transaction,{amount:Math.abs(transaction.amount)});}),paymentDate:elem.transaction.createdAt,comment:elem.transaction.metadata.comment===NO_COMMENT?null:elem.transaction.metadata.comment};});};var getDateFromFilterForBAsPaymentsHistory=function getDateFromFilterForBAsPaymentsHistory(state){return getPaymentsHistory(state).BAsDateFromFilter;};var getDateToFilterForBAsPaymentsHistory=function getDateToFilterForBAsPaymentsHistory(state){return getPaymentsHistory(state).BAsDateToFilter;};var getNameFilterForBAsPaymentsHistory=function getNameFilterForBAsPaymentsHistory(state){return getPaymentsHistory(state).BAsNameFilter;};var getCountryFilterForBAsPaymentsHistory=function getCountryFilterForBAsPaymentsHistory(state){return getPaymentsHistory(state).BAsCountryFilter;};var loadingUniversitiesPaymentsHistory=function loadingUniversitiesPaymentsHistory(state){return getPaymentsHistory(state).universitiesFetching;};var getCurrentPageForUniversitiesPaymentsHistory=function getCurrentPageForUniversitiesPaymentsHistory(state){return getPaymentsHistory(state).universitiesCurrentPage;};var getTotalPagesForUniversitiesPaymentsHistory=function getTotalPagesForUniversitiesPaymentsHistory(state){return getPaymentsHistory(state).universitiesTotalPages;};var getUniversitiesPaymentsHistoryData=function getUniversitiesPaymentsHistoryData(state){var data=getPaymentsHistory(state).universitiesData;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(data,function(elem){return{id:elem.transaction.transactionId,name:elem.target.name,paymentAmount:{currency:elem.transaction.delta.currency,amount:-elem.transaction.delta.amount},totalPay:elem.totalByTransactionType.map(function(transaction){return Object.assign({},transaction,{amount:-transaction.amount});}),paymentDate:elem.transaction.createdAt,comment:elem.transaction.metadata.comment===NO_COMMENT?null:elem.transaction.metadata.comment};});};var getDateFromFilterForUniversitiesPaymentsHistory=function getDateFromFilterForUniversitiesPaymentsHistory(state){return getPaymentsHistory(state).universitiesDateFromFilter;};var getDateToFilterForUniversitiesPaymentsHistory=function getDateToFilterForUniversitiesPaymentsHistory(state){return getPaymentsHistory(state).universitiesDateToFilter;};var getNameFilterForUniversitiesPaymentsHistory=function getNameFilterForUniversitiesPaymentsHistory(state){return getPaymentsHistory(state).universitiesNameFilter;};var getCountryFilterForUniversitiesPaymentsHistory=function getCountryFilterForUniversitiesPaymentsHistory(state){return getPaymentsHistory(state).universitiesCountryFilter;};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling(value) {
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
        }
        else if (_enable_super_gross_mode_that_will_cause_bad_things) {
            /*@__PURE__*/ console.log('RxJS: Back to a better error behavior. Thank you. <3');
        }
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling() {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    },
};
//# sourceMappingURL=config.js.map


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function noop() { }
//# sourceMappingURL=noop.js.map


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjectUnsubscribedError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function ObjectUnsubscribedErrorImpl() {
    Error.call(this);
    this.message = 'object unsubscribed';
    this.name = 'ObjectUnsubscribedError';
    return this;
}
ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;
//# sourceMappingURL=ObjectUnsubscribedError.js.map


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_empty__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observable_of__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_throwError__ = __webpack_require__(156);
/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */



var Notification = /*@__PURE__*/ (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return Object(__WEBPACK_IMPORTED_MODULE_1__observable_of__["a" /* of */])(this.value);
            case 'E':
                return Object(__WEBPACK_IMPORTED_MODULE_2__observable_throwError__["a" /* throwError */])(this.error);
            case 'C':
                return Object(__WEBPACK_IMPORTED_MODULE_0__observable_empty__["b" /* empty */])();
        }
        throw new Error('unexpected notification kind value');
    };
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());

//# sourceMappingURL=Notification.js.map


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncSubject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscription__ = __webpack_require__(34);
/** PURE_IMPORTS_START tslib,_Subject,_Subscription PURE_IMPORTS_END */



var AsyncSubject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        _this.hasNext = false;
        _this.hasCompleted = false;
        return _this;
    }
    AsyncSubject.prototype._subscribe = function (subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return __WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */].EMPTY;
        }
        else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return __WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */].EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function (error) {
        if (!this.hasCompleted) {
            _super.prototype.error.call(this, error);
        }
    };
    AsyncSubject.prototype.complete = function () {
        this.hasCompleted = true;
        if (this.hasNext) {
            _super.prototype.next.call(this, this.value);
        }
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]));

//# sourceMappingURL=AsyncSubject.js.map


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = concat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_isScheduler__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__of__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__from__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operators_concatAll__ = __webpack_require__(227);
/** PURE_IMPORTS_START _util_isScheduler,_of,_from,_operators_concatAll PURE_IMPORTS_END */




function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    if (observables.length === 1 || (observables.length === 2 && Object(__WEBPACK_IMPORTED_MODULE_0__util_isScheduler__["a" /* isScheduler */])(observables[1]))) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__from__["a" /* from */])(observables[0]);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__operators_concatAll__["a" /* concatAll */])()(__WEBPACK_IMPORTED_MODULE_1__of__["a" /* of */].apply(void 0, observables));
}
//# sourceMappingURL=concat.js.map


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNumeric;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray__ = __webpack_require__(41);
/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */

function isNumeric(val) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__isArray__["a" /* isArray */])(val) && (val - parseFloat(val) + 1) >= 0;
}
//# sourceMappingURL=isNumeric.js.map


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_operators_audit__ = __webpack_require__(232);
/* unused harmony reexport audit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_operators_auditTime__ = __webpack_require__(384);
/* unused harmony reexport auditTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_operators_buffer__ = __webpack_require__(385);
/* unused harmony reexport buffer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_operators_bufferCount__ = __webpack_require__(386);
/* unused harmony reexport bufferCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_operators_bufferTime__ = __webpack_require__(387);
/* unused harmony reexport bufferTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_operators_bufferToggle__ = __webpack_require__(388);
/* unused harmony reexport bufferToggle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_operators_bufferWhen__ = __webpack_require__(389);
/* unused harmony reexport bufferWhen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internal_operators_catchError__ = __webpack_require__(390);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__internal_operators_catchError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_operators_combineAll__ = __webpack_require__(391);
/* unused harmony reexport combineAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__internal_operators_combineLatest__ = __webpack_require__(392);
/* unused harmony reexport combineLatest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__internal_operators_concat__ = __webpack_require__(393);
/* unused harmony reexport concat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__internal_operators_concatAll__ = __webpack_require__(227);
/* unused harmony reexport concatAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__internal_operators_concatMap__ = __webpack_require__(233);
/* unused harmony reexport concatMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__internal_operators_concatMapTo__ = __webpack_require__(394);
/* unused harmony reexport concatMapTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__internal_operators_count__ = __webpack_require__(395);
/* unused harmony reexport count */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__internal_operators_debounce__ = __webpack_require__(396);
/* unused harmony reexport debounce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__internal_operators_debounceTime__ = __webpack_require__(397);
/* unused harmony reexport debounceTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__internal_operators_defaultIfEmpty__ = __webpack_require__(96);
/* unused harmony reexport defaultIfEmpty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__internal_operators_delay__ = __webpack_require__(398);
/* unused harmony reexport delay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__internal_operators_delayWhen__ = __webpack_require__(399);
/* unused harmony reexport delayWhen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__internal_operators_dematerialize__ = __webpack_require__(400);
/* unused harmony reexport dematerialize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__internal_operators_distinct__ = __webpack_require__(401);
/* unused harmony reexport distinct */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__internal_operators_distinctUntilChanged__ = __webpack_require__(235);
/* unused harmony reexport distinctUntilChanged */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__internal_operators_distinctUntilKeyChanged__ = __webpack_require__(402);
/* unused harmony reexport distinctUntilKeyChanged */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__internal_operators_elementAt__ = __webpack_require__(403);
/* unused harmony reexport elementAt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__internal_operators_endWith__ = __webpack_require__(404);
/* unused harmony reexport endWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__internal_operators_every__ = __webpack_require__(405);
/* unused harmony reexport every */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__internal_operators_exhaust__ = __webpack_require__(406);
/* unused harmony reexport exhaust */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__internal_operators_exhaustMap__ = __webpack_require__(407);
/* unused harmony reexport exhaustMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__internal_operators_expand__ = __webpack_require__(408);
/* unused harmony reexport expand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__internal_operators_filter__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_30__internal_operators_filter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__internal_operators_finalize__ = __webpack_require__(409);
/* unused harmony reexport finalize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__internal_operators_find__ = __webpack_require__(237);
/* unused harmony reexport find */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__internal_operators_findIndex__ = __webpack_require__(410);
/* unused harmony reexport findIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__internal_operators_first__ = __webpack_require__(411);
/* unused harmony reexport first */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__internal_operators_groupBy__ = __webpack_require__(213);
/* unused harmony reexport groupBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__internal_operators_ignoreElements__ = __webpack_require__(412);
/* unused harmony reexport ignoreElements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__internal_operators_isEmpty__ = __webpack_require__(413);
/* unused harmony reexport isEmpty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__internal_operators_last__ = __webpack_require__(414);
/* unused harmony reexport last */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__internal_operators_map__ = __webpack_require__(48);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_39__internal_operators_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__internal_operators_mapTo__ = __webpack_require__(415);
/* unused harmony reexport mapTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__internal_operators_materialize__ = __webpack_require__(416);
/* unused harmony reexport materialize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__internal_operators_max__ = __webpack_require__(417);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__internal_operators_merge__ = __webpack_require__(418);
/* unused harmony reexport merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__internal_operators_mergeAll__ = __webpack_require__(158);
/* unused harmony reexport mergeAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__internal_operators_mergeMap__ = __webpack_require__(95);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_45__internal_operators_mergeMap__["a"]; });
/* unused harmony reexport flatMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__internal_operators_mergeMapTo__ = __webpack_require__(419);
/* unused harmony reexport mergeMapTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__internal_operators_mergeScan__ = __webpack_require__(420);
/* unused harmony reexport mergeScan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__internal_operators_min__ = __webpack_require__(421);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__internal_operators_multicast__ = __webpack_require__(74);
/* unused harmony reexport multicast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__internal_operators_observeOn__ = __webpack_require__(217);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_50__internal_operators_observeOn__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__internal_operators_onErrorResumeNext__ = __webpack_require__(422);
/* unused harmony reexport onErrorResumeNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__internal_operators_pairwise__ = __webpack_require__(423);
/* unused harmony reexport pairwise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__internal_operators_partition__ = __webpack_require__(424);
/* unused harmony reexport partition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__internal_operators_pluck__ = __webpack_require__(426);
/* unused harmony reexport pluck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__internal_operators_publish__ = __webpack_require__(427);
/* unused harmony reexport publish */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__internal_operators_publishBehavior__ = __webpack_require__(428);
/* unused harmony reexport publishBehavior */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__internal_operators_publishLast__ = __webpack_require__(429);
/* unused harmony reexport publishLast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__internal_operators_publishReplay__ = __webpack_require__(430);
/* unused harmony reexport publishReplay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__internal_operators_race__ = __webpack_require__(431);
/* unused harmony reexport race */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__internal_operators_reduce__ = __webpack_require__(124);
/* unused harmony reexport reduce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__internal_operators_repeat__ = __webpack_require__(432);
/* unused harmony reexport repeat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__internal_operators_repeatWhen__ = __webpack_require__(433);
/* unused harmony reexport repeatWhen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__internal_operators_retry__ = __webpack_require__(434);
/* unused harmony reexport retry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__internal_operators_retryWhen__ = __webpack_require__(435);
/* unused harmony reexport retryWhen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__internal_operators_refCount__ = __webpack_require__(152);
/* unused harmony reexport refCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__internal_operators_sample__ = __webpack_require__(436);
/* unused harmony reexport sample */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__internal_operators_sampleTime__ = __webpack_require__(437);
/* unused harmony reexport sampleTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__internal_operators_scan__ = __webpack_require__(163);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__internal_operators_sequenceEqual__ = __webpack_require__(438);
/* unused harmony reexport sequenceEqual */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__internal_operators_share__ = __webpack_require__(439);
/* unused harmony reexport share */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__internal_operators_shareReplay__ = __webpack_require__(440);
/* unused harmony reexport shareReplay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__internal_operators_single__ = __webpack_require__(441);
/* unused harmony reexport single */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__internal_operators_skip__ = __webpack_require__(442);
/* unused harmony reexport skip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__internal_operators_skipLast__ = __webpack_require__(443);
/* unused harmony reexport skipLast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__internal_operators_skipUntil__ = __webpack_require__(444);
/* unused harmony reexport skipUntil */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__internal_operators_skipWhile__ = __webpack_require__(445);
/* unused harmony reexport skipWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__internal_operators_startWith__ = __webpack_require__(446);
/* unused harmony reexport startWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__internal_operators_subscribeOn__ = __webpack_require__(447);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_78__internal_operators_subscribeOn__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__internal_operators_switchAll__ = __webpack_require__(449);
/* unused harmony reexport switchAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__internal_operators_switchMap__ = __webpack_require__(164);
/* unused harmony reexport switchMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__internal_operators_switchMapTo__ = __webpack_require__(450);
/* unused harmony reexport switchMapTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__internal_operators_take__ = __webpack_require__(161);
/* unused harmony reexport take */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__internal_operators_takeLast__ = __webpack_require__(162);
/* unused harmony reexport takeLast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__internal_operators_takeUntil__ = __webpack_require__(451);
/* unused harmony reexport takeUntil */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__internal_operators_takeWhile__ = __webpack_require__(452);
/* unused harmony reexport takeWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__internal_operators_tap__ = __webpack_require__(236);
/* unused harmony reexport tap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__internal_operators_throttle__ = __webpack_require__(238);
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__internal_operators_throttleTime__ = __webpack_require__(453);
/* unused harmony reexport throttleTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__internal_operators_throwIfEmpty__ = __webpack_require__(123);
/* unused harmony reexport throwIfEmpty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__internal_operators_timeInterval__ = __webpack_require__(454);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__internal_operators_timeout__ = __webpack_require__(455);
/* unused harmony reexport timeout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__internal_operators_timeoutWith__ = __webpack_require__(239);
/* unused harmony reexport timeoutWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__internal_operators_timestamp__ = __webpack_require__(456);
/* unused harmony reexport timestamp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__internal_operators_toArray__ = __webpack_require__(457);
/* unused harmony reexport toArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__internal_operators_window__ = __webpack_require__(458);
/* unused harmony reexport window */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__internal_operators_windowCount__ = __webpack_require__(459);
/* unused harmony reexport windowCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__internal_operators_windowTime__ = __webpack_require__(460);
/* unused harmony reexport windowTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__internal_operators_windowToggle__ = __webpack_require__(461);
/* unused harmony reexport windowToggle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__internal_operators_windowWhen__ = __webpack_require__(462);
/* unused harmony reexport windowWhen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__internal_operators_withLatestFrom__ = __webpack_require__(463);
/* unused harmony reexport withLatestFrom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__internal_operators_zip__ = __webpack_require__(464);
/* unused harmony reexport zip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__internal_operators_zipAll__ = __webpack_require__(465);
/* unused harmony reexport zipAll */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */








































































































//# sourceMappingURL=index.js.map


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return throwIfEmpty; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tap__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_EmptyError__ = __webpack_require__(93);
/** PURE_IMPORTS_START _tap,_util_EmptyError PURE_IMPORTS_END */


var throwIfEmpty = function (errorFactory) {
    if (errorFactory === void 0) {
        errorFactory = defaultErrorFactory;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__tap__["a" /* tap */])({
        hasValue: false,
        next: function () { this.hasValue = true; },
        complete: function () {
            if (!this.hasValue) {
                throw errorFactory();
            }
        }
    });
};
function defaultErrorFactory() {
    return new __WEBPACK_IMPORTED_MODULE_1__util_EmptyError__["a" /* EmptyError */]();
}
//# sourceMappingURL=throwIfEmpty.js.map


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reduce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scan__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLast__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultIfEmpty__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_pipe__ = __webpack_require__(151);
/** PURE_IMPORTS_START _scan,_takeLast,_defaultIfEmpty,_util_pipe PURE_IMPORTS_END */




function reduce(accumulator, seed) {
    if (arguments.length >= 2) {
        return function reduceOperatorFunctionWithSeed(source) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__util_pipe__["a" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0__scan__["a" /* scan */])(accumulator, seed), Object(__WEBPACK_IMPORTED_MODULE_1__takeLast__["a" /* takeLast */])(1), Object(__WEBPACK_IMPORTED_MODULE_2__defaultIfEmpty__["a" /* defaultIfEmpty */])(seed))(source);
        };
    }
    return function reduceOperatorFunction(source) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_pipe__["a" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0__scan__["a" /* scan */])(function (acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), Object(__WEBPACK_IMPORTED_MODULE_1__takeLast__["a" /* takeLast */])(1))(source);
    };
}
//# sourceMappingURL=reduce.js.map


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return typeof value === 'function';
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value instanceof Map;
});

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Manager__ = __webpack_require__(535);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Target__ = __webpack_require__(536);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__Target__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popper__ = __webpack_require__(537);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Popper__["a"]; });
/* unused harmony reexport placements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Arrow__ = __webpack_require__(538);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__Arrow__["a"]; });





/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = __webpack_require__(548);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _ReplaceTransition = __webpack_require__(552);

var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);

var _TransitionGroup = __webpack_require__(262);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = __webpack_require__(260);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  ReplaceTransition: _ReplaceTransition2.default,
  CSSTransition: _CSSTransition2.default
};

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STATUSES; });
/* unused harmony export COLOR_BY_STATUS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CustomSelect_css__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CustomSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CustomSelect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_uuid__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _COLOR_BY_STATUS;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var STATUSES={ERROR:'error',WARNING:'warning',INFO:'info',SUCCESS:'success'};var COLOR_BY_STATUS=(_COLOR_BY_STATUS={},_defineProperty(_COLOR_BY_STATUS,STATUSES.ERROR,'red'),_defineProperty(_COLOR_BY_STATUS,STATUSES.WARNING,'orange'),_defineProperty(_COLOR_BY_STATUS,STATUSES.INFO,'#5f9fff'),_defineProperty(_COLOR_BY_STATUS,STATUSES.SUCCESS,'greenyellow'),_COLOR_BY_STATUS);var customStyles={control:function control(styles,state){return Object.assign({},styles,{borderColor:!state.selectProps.status&&state.isFocused?'#80bdff':'#ced4da',boxShadow:!state.selectProps.status&&state.isFocused?'0 0 0 0.2rem rgba(0,123,255,.25)':'none',lineHeight:'1',cursor:'pointer',border:state.selectProps.status?'2px solid '+COLOR_BY_STATUS[state.selectProps.status]:'1px solid #ced4da',":hover":{border:state.selectProps.status?'2px solid '+COLOR_BY_STATUS[state.selectProps.status]:'1px solid #ced4da'},margin:state.selectProps.status?'-1px':0});},valueContainer:function valueContainer(styles,state){return Object.assign({},styles,{padding:'.375rem .75rem',height:state.isMulti?null:'36px'});},placeholder:function placeholder(styles){return Object.assign({},styles,{color:'#495057',marginLeft:'4px',marginRight:'2px'});},clearIndicator:function clearIndicator(styles){return Object.assign({},styles,{padding:'4px',cursor:'pointer'});},dropdownIndicator:function dropdownIndicator(styles){return Object.assign({},styles,{padding:'4px',cursor:'pointer'// padding: '0 5px 0 0'
});},indicatorSeparator:function indicatorSeparator(styles){return Object.assign({},styles,{display:'none'// marginTop: '2px',
// marginBottom: '2px',
// backgroundColor: '#ced4da'
});},singleValue:function singleValue(styles){return Object.assign({},styles,{height:'21px',padding:'3px 0'});},option:function option(styles,state){return Object.assign({},styles,{":hover":{backgroundColor:state.isSelected?'#89aa11':'rgba(137, 170, 17, 0.44)'},backgroundColor:state.isSelected?'#89aa11':'white',cursor:'pointer',paddingTop:'0',paddingBottom:'0'});},menu:function menu(styles){return Object.assign({},styles,{marginTop:'0',marginBottom:'0',borderRadius:'0',zIndex:1000});},menuList:function menuList(styles){return Object.assign({},styles,{paddingTop:'0',paddingBottom:'0'});}};var Option=function(_Component){_inherits(Option,_Component);function Option(){_classCallCheck(this,Option);return _possibleConstructorReturn(this,(Option.__proto__||Object.getPrototypeOf(Option)).apply(this,arguments));}_createClass(Option,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:this.props.data.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* components */].Option,this.props));}}]);return Option;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var CustomSelect=function(_Component2){_inherits(CustomSelect,_Component2);function CustomSelect(props){_classCallCheck(this,CustomSelect);var _this2=_possibleConstructorReturn(this,(CustomSelect.__proto__||Object.getPrototypeOf(CustomSelect)).call(this,props));_this2.renderOptions=function(value,label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Haha ',label);};_this2.state={id:__WEBPACK_IMPORTED_MODULE_7_uuid___default()()};return _this2;}_createClass(CustomSelect,[{key:'render',value:function render(){var id=this.props.id||this.state.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["b" /* default */],{key:'select',id:id,styles:this.props.customStyles||customStyles,ref:this.props.innerRef,className:this.props.className,isSearchable:this.props.isSearchable||false,value:this.props.selectedOption||null,onChange:this.props.onSelect,onInputChange:this.props.onInputChange,placeholder:this.props.placeholder,isDisabled:this.props.disabled,options:this.props.options,onFocus:this.props.onFocus,onBlur:this.props.onBlur,status:this.props.status,menuPlacement:this.props.menuPlacement,isMulti:this.props.isMulti,closeMenuOnSelect:this.props.closeMenuOnSelect,components:{Option:Option},openMenuOnFocus:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["H" /* Popover */],{className:'select-error-popover',key:'popover',placement:"bottom",isOpen:this.props.requiredFieldError&&(!this.props.selectedOption||this.props.selectedOption.length===0),target:"[id='"+id+"']"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["I" /* PopoverBody */],{className:'popover-body'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].required_field_error_message))));}}]);return CustomSelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CustomSelect.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,innerRef:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,selectedOption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,isSearchable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,status:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,requiredFieldError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,menuPlacement:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,customStyles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isMulti:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,closeMenuOnSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onFocus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onBlur:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onInputChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["b"] = (CustomSelect);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROFESSIONAL_FORM_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PERSONAL_FORM_MODE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PersonalData_css__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PersonalData_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PersonalData_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PROFESSIONAL_FORM_MODE="PROFESSIONAL_FORM_MODE";var PERSONAL_FORM_MODE="PERSONAL_FORM_MODE";var PersonalData=function(_Component){_inherits(PersonalData,_Component);function PersonalData(props){_classCallCheck(this,PersonalData);var _this=_possibleConstructorReturn(this,(PersonalData.__proto__||Object.getPrototypeOf(PersonalData)).call(this,props));_this.handleChangeContinent=function(selectedOption){_this.props.onContinentSet(selectedOption.value);_this.props.handleChangeByValue('countryCode')('');};_this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(params.content,function(option){return option.value===_this.props[params.value];}),options:params.content,onSelect:params.onChange,placeholder:params.placeholder,disabled:params.isDisabled,requiredFieldError:_this.props.requiredFieldError===params.value})));};_this.handleChangeCountry=function(selectedOption){_this.props.handleChangeByValue('countryCode')(selectedOption.value);};_this.state={};_this.getFormGroup=_this.getFormGroup.bind(_this);return _this;}_createClass(PersonalData,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.countryCode&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.continents)&&this.props.continents.length!==0){this.props.setContinentByCountry(this.props.countryCode);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.countryCode&&(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.continents)||this.props.continents.length===0)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(nextProps.continents)){this.props.setContinentByCountry(nextProps.countryCode);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'personal-data-container'},this.renderFormGroups());}},{key:'getFieldsList',value:function getFieldsList(){var emailTitle=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label);switch(this.props.mode){case PROFESSIONAL_FORM_MODE:emailTitle=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].professional_email_label);break;case PERSONAL_FORM_MODE:emailTitle=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].personal_email_label);break;default:break;}return[{value:"firstName",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)},{value:"lastName",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)},{value:"email",title:emailTitle,type:'email',isDisabled:!this.props.isEmailEditable},{value:"phoneNumber",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].phone_number_label)},{value:"continentCode",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label)+'*',onChange:this.handleChangeContinent,type:'select',content:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getLocationOptions(this.props.continents,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),isDisabled:!this.props.continents},{value:"countryCode",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)+'*',onChange:this.handleChangeCountry,type:'select',content:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getLocationOptions(this.props.countries,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isDisabled:!this.props.countries}];}},{key:'renderFormGroups',value:function renderFormGroups(){return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.getFieldsList(),this.getFormGroup)));}},{key:'getFormGroup',value:function getFormGroup(params){if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.fields)&&!this.props.fields.includes(params.value)){return;}if(params.type==='select'){return this.getSelectFormGroup(params);}if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var title=params.title+(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.requiredFields)&&this.props.requiredFields.includes(params.value)?"*":"");var id=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':id,sm:3},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:this.props[params.value],onChange:params.onChange||this.props.handleChange(params.value),placeholder:params.title,disabled:params.isDisabled,required:!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.requiredFields)?this.props.requiredFields.includes(params.value):false},params.content)));}}]);return PersonalData;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PersonalData.propTypes={firstName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,lastName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,email:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,mode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,isEmailEditable:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,phoneNumber:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,continentCode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,countryCode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,continents:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,requiredFields:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,requiredFieldError:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,fields:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,onContinentSet:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,setContinentByCountry:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleChangeByValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["c"] = (PersonalData);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LicenseAgreementModal__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["F" /* MODAL_LICENSE_AGREEMENT */],translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__LicenseAgreementModal__["a" /* default */]));

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProgressBar_css__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProgressBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ProgressBar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProgressBar=function(_Component){_inherits(ProgressBar,_Component);function ProgressBar(props){_classCallCheck(this,ProgressBar);var _this=_possibleConstructorReturn(this,(ProgressBar.__proto__||Object.getPrototypeOf(ProgressBar)).call(this,props));_this.state={max:_this.props.total||_this.props.left+_this.props.validated};return _this;}_createClass(ProgressBar,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.total!==nextProps.total&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(nextProps.total)){this.setState({max:nextProps.total});}else if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.props.left)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(nextProps.left)){this.setState({max:nextProps.left+nextProps.validated});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditations-validation-progress-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accreditations-validation-progress-label'},this.props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["K" /* Progress */],{multi:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["K" /* Progress */],{bar:true,color:'secondary',max:this.state.max,value:this.props.skipped},this.props.skipped>0?this.props.skipped:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["K" /* Progress */],{bar:true,color:'primary',max:this.state.max,value:this.props.validated},this.props.validated>0?this.props.validated:'')));}}]);return ProgressBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProgressBar.propTypes={left:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,validated:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,skipped:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ProgressBar);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(848);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint prefer-template: 0 */






var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          open: _this.open
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);
    _this.open = _this.open.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["g" /* onDocumentDragOver */], false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      }
      window.addEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["g" /* onDocumentDragOver */]);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      window.removeEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      evt.persist();
      if (this.props.onDragStart && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isDragDataWithFiles */])(evt)) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      evt.persist();

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isDragDataWithFiles */])(evt)) {
        Promise.resolve(this.props.getDataTransferItems(evt)).then(function (draggedFiles) {
          if (evt.isPropagationStopped()) {
            return;
          }

          _this2.setState({
            draggedFiles: draggedFiles,
            // Do not rely on files for the drag state. It doesn't work in Safari.
            isDragActive: true
          });
        });

        if (this.props.onDragEnter) {
          this.props.onDragEnter.call(this, evt);
        }
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.persist();

      try {
        // The file dialog on Chrome allows users to drag files from the dialog onto
        // the dropzone, causing the browser the crash when the file dialog is closed.
        // A drop effect of 'none' prevents the file from being dropped
        evt.dataTransfer.dropEffect = this.isFileDialogActive ? 'none' : 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isDragDataWithFiles */])(evt)) {
        this.props.onDragOver.call(this, evt);
      }

      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this3 = this;

      evt.preventDefault();
      evt.persist();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this3.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isDragDataWithFiles */])(evt)) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this4 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          accept = _props.accept,
          getDataTransferItems = _props.getDataTransferItems;

      // Stop default browser behavior

      evt.preventDefault();

      // Persist event for later usage
      evt.persist();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isDragDataWithFiles */])(evt)) {
        Promise.resolve(getDataTransferItems(evt)).then(function (fileList) {
          var acceptedFiles = [];
          var rejectedFiles = [];

          if (evt.isPropagationStopped()) {
            return;
          }

          fileList.forEach(function (file) {
            if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* fileAccepted */])(file, accept) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* fileMatchSize */])(file, _this4.props.maxSize, _this4.props.minSize)) {
              acceptedFiles.push(file);
            } else {
              rejectedFiles.push(file);
            }
          });

          if (!multiple && acceptedFiles.length > 1) {
            // if not in multi mode add any extra accepted files to rejected.
            // This will allow end users to easily ignore a multi file drop in "single" mode.
            rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(0)));
          }

          // Update `acceptedFiles` and `rejectedFiles` state
          // This will make children render functions receive the appropriate
          // values
          _this4.setState({ acceptedFiles: acceptedFiles, rejectedFiles: rejectedFiles }, function () {
            if (onDrop) {
              onDrop.call(_this4, acceptedFiles, rejectedFiles, evt);
            }

            if (rejectedFiles.length > 0 && onDropRejected) {
              onDropRejected.call(_this4, rejectedFiles, evt);
            }

            if (acceptedFiles.length > 0 && onDropAccepted) {
              onDropAccepted.call(_this4, acceptedFiles, evt);
            }
          });
        });
      }
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      // if onClick prop is given, run it first

      if (onClick) {
        onClick.call(this, evt);
      }

      // if disableClick is not set and the event hasn't been default prefented within
      // the onClick listener, open the file dialog
      if (!disableClick && !evt.isDefaultPrevented()) {
        evt.stopPropagation();

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* isIeOrEdge */])()) {
          setTimeout(this.open, 0);
        } else {
          this.open();
        }
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick(evt);
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      var _this5 = this;

      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      // execute the timeout only if the FileDialog is opened in the browser

      if (this.isFileDialogActive) {
        setTimeout(function () {
          if (_this5.fileInputEl != null) {
            // Returns an object as FileList
            var files = _this5.fileInputEl.files;


            if (!files.length) {
              _this5.isFileDialogActive = false;

              if (typeof onFileDialogCancel === 'function') {
                onFileDialogCancel();
              }
            }
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          _rest$className = rest.className,
          className = _rest$className === undefined ? '' : _rest$className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* allFilesAccepted */])(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].default;
        activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        acceptStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].accepted;
        rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].rejected;
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].disabled;
      }

      var appliedStyle = _extends({ position: 'relative' }, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, appliedStyle, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, appliedStyle, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: _extends({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          opacity: 0.00001,
          pointerEvents: 'none'
        }, inputProps.style),
        multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["h" /* supportMultiple */] && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Destructure custom props away from props used for the div element
      /* eslint-disable no-unused-vars */

      var acceptedFiles = props.acceptedFiles,
          preventDropOnDocument = props.preventDropOnDocument,
          disableClick = props.disableClick,
          onDropAccepted = props.onDropAccepted,
          onDropRejected = props.onDropRejected,
          onFileDialogCancel = props.onFileDialogCancel,
          maxSize = props.maxSize,
          minSize = props.minSize,
          getDataTransferItems = props.getDataTransferItems,
          divProps = _objectWithoutProperties(props, ['acceptedFiles', 'preventDropOnDocument', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize', 'getDataTransferItems']);
      /* eslint-enable no-unused-vars */

      /* eslint-disable jsx-a11y/no-static-element-interactions */
      /* eslint-disable jsx-a11y/click-events-have-key-events */


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */
        , {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */
        , inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dropzone);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),

  /**
   * Contents of the dropzone
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable the dropzone entirely
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Allow dropping multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `name` attribute for the input tag
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum file size (in bytes)
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * className
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drag is active
   */
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be accepted
   */
  acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be rejected
   */
  rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when dropzone is disabled
   */
  disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS styles to apply
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDrop callback
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragStart callback
   */
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragOver callback
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disableClick: false,
  inputProps: {},
  multiple: true,
  maxSize: Infinity,
  minSize: 0,
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */]
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(852)
var ieee754 = __webpack_require__(853)
var isArray = __webpack_require__(300)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104)))

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(136)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return uploadBulkAccreditationsAsFile; });
/* unused harmony export fetchUploadBulkAccreditationsAsFile */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return uploadBulkAccreditationsAsJSON; });
/* unused harmony export fetchUploadBulkAccreditationsAsJSON */
/* unused harmony export fetchUploadBulkAccreditationsSuccess */
/* unused harmony export fetchUploadBulkAccreditationsFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getJobs; });
/* unused harmony export fetchGetJobsSuccess */
/* unused harmony export fetchGetJobsFailed */
/* unused harmony export fetchGetJobs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchRemoveBulk; });
/* unused harmony export getBulk */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loadingBulkJobs; });
/* unused harmony export getBulkJobs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBulkJobsFormattedData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_activeModal__ = __webpack_require__(6);
var MAX_FILE_SIZE=104857600;//- Actions
var uploadBulkAccreditationsAsFile=function uploadBulkAccreditationsAsFile(data){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());if(data.get('file').size>MAX_FILE_SIZE){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */])(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_7__common_localization__["e" /* getTranslation */])(getState()),'bulk_upload.exceeded_upload_size_alert')));}else{var groupId=Object(__WEBPACK_IMPORTED_MODULE_4__account_role__["k" /* getCurrentGroup */])(getState());data.append('accredGroupId',groupId);dispatch(fetchUploadBulkAccreditationsAsFile(data));}};};var fetchUploadBulkAccreditationsAsFile=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_BULK_ACCREDITATIONS_UPLOAD',function(groupId,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].fetchUploadBulkAccreditationsAsFile(groupId,data);},function(){return{apiCall:true,onSuccess:fetchUploadBulkAccreditationsSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var uploadBulkAccreditationsAsJSON=function uploadBulkAccreditationsAsJSON(data){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__common_activeModal__["_16" /* hideModal */])());var groupId=Object(__WEBPACK_IMPORTED_MODULE_4__account_role__["k" /* getCurrentGroup */])(getState());data['accreditationGroupId']=groupId;dispatch(fetchUploadBulkAccreditationsAsJSON(data));};};var fetchUploadBulkAccreditationsAsJSON=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_BULK_ACCREDITATIONS_UPLOAD',function(groupId,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].fetchUploadBulkAccreditationsAsJSON(groupId,data);},function(){return{apiCall:true,onSuccess:fetchUploadBulkAccreditationsSuccess,onFail:fetchUploadBulkAccreditationsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var fetchUploadBulkAccreditationsSuccess=function fetchUploadBulkAccreditationsSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(getJobs());};};var fetchUploadBulkAccreditationsFailed=function fetchUploadBulkAccreditationsFailed(error){return function(dispatch){switch(error){case"REQUEST_BODY_INVALID":dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */])("INCORRECT_FILE_CONTENT"));break;default:dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */])(error));break;}};};var getJobs=function getJobs(){return function(dispatch,getState){var groupId=Object(__WEBPACK_IMPORTED_MODULE_4__account_role__["k" /* getCurrentGroup */])(getState());if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(groupId)){dispatch(fetchGetJobs(groupId));}};};var fetchGetJobsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_JOBS_SUCCESS');var fetchGetJobsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_JOBS_FAILED');var fetchGetJobs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_JOBS',function(groupId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getBulkJobs(groupId);},function(){return{apiCall:true,onSuccess:fetchGetJobsSuccess,onFail:fetchGetJobsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var fetchRemoveBulk=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_BULK',function(bulkId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeBulk(bulkId);},function(){return{apiCall:true,onSuccess:getJobs,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});//- State
var initialState={data:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_JOBS:function FETCH_GET_JOBS(state){return Object.assign({},state,{fetching:true,error:null});},FETCH_GET_JOBS_SUCCESS:function FETCH_GET_JOBS_SUCCESS(state,action){return Object.assign({},state,{fetching:false,error:null,data:action.payload});},FETCH_GET_JOBS_FAILED:function FETCH_GET_JOBS_FAILED(state,action){return Object.assign({},state,{fetching:false,error:action.payload,data:null});}},initialState));//- Selectors
var getBulk=function getBulk(state){return state.bulk;};var loadingBulkJobs=function loadingBulkJobs(state){return getBulk(state).fetching;};var getBulkJobs=function getBulkJobs(state){return getBulk(state).data;};var getBulkJobsFormattedData=function getBulkJobsFormattedData(state){return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(getBulkJobs(state),function(jobData){return{id:jobData.id,fileName:jobData.fileName,createdAt:__WEBPACK_IMPORTED_MODULE_6_moment___default()(jobData.createdAt).format("MMMM Do YYYY, HH:mm"),processedPersent:Math.floor(jobData.processedEntriesCount/jobData.totalEntriesCount*100),processedEntriesCount:jobData.processedEntriesCount,totalEntriesCount:jobData.totalEntriesCount,finished:jobData.finished,globalError:jobData.finished&&jobData.processedEntriesCount<jobData.totalEntriesCount,errors:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.chain(jobData.errors).map(function(error){return error.split(':')[1].trim();}).uniq().value()};});};

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetCertifiedAccreditationsFailed */
/* unused harmony export fetchGetCertifiedAccreditationsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetCertifiedAccreditations; });
/* unused harmony export onUpdateCertifiedAccreditationSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchUpdateCertifiedAccreditation; });
/* unused harmony export onUpdateCertifiedAccreditation */
/* unused harmony export onRemoveCertifiedAccreditationSuccess */
/* unused harmony export onRemoveCertifiedAccreditation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return removeCertificateAccreditation; });
/* unused harmony export getCertifiedAccreditations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return loadingCertifiedAccreditations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCertifiedAccreditationsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCertifiedAccreditationDataById; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//- Actions
var fetchGetCertifiedAccreditationsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_CERTIFIED_ACCREDITATIONS_FAILED');var fetchGetCertifiedAccreditationsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_CERTIFIED_ACCREDITATIONS_SUCCESS');var fetchGetCertifiedAccreditations=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_CERTIFIED_ACCREDITATIONS',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getCertifiedAccreditations();},function(){return{apiCall:true,onSuccess:fetchGetCertifiedAccreditationsSuccess,onFail:fetchGetCertifiedAccreditationsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onUpdateCertifiedAccreditationSuccess=function onUpdateCertifiedAccreditationSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__common_activeModal__["_16" /* hideModal */])());dispatch(fetchGetCertifiedAccreditations());};};var fetchUpdateCertifiedAccreditation=function fetchUpdateCertifiedAccreditation(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onUpdateCertifiedAccreditation(id,data));};};var onUpdateCertifiedAccreditation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_UPDATE_CERTIFIED_ACCREDITATION',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateCertifiedAccreditation(id,data);},function(){return{apiCall:true,onSuccess:onUpdateCertifiedAccreditationSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onRemoveCertifiedAccreditationSuccess=function onRemoveCertifiedAccreditationSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__common_activeModal__["_16" /* hideModal */])());dispatch(fetchGetCertifiedAccreditations());};};var onRemoveCertifiedAccreditation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_CERTIFIED_ACCREDITATION',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeCertifiedAccreditation(id);},function(){return{apiCall:true,onSuccess:onRemoveCertifiedAccreditationSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var removeCertificateAccreditation=function removeCertificateAccreditation(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onRemoveCertifiedAccreditation(id));};};//- State
var initialState={fetching:false,data:null,error:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_CERTIFIED_ACCREDITATIONS:function FETCH_GET_CERTIFIED_ACCREDITATIONS(state){return Object.assign({},state,{error:null,fetching:true});},FETCH_GET_CERTIFIED_ACCREDITATIONS_FAILED:function FETCH_GET_CERTIFIED_ACCREDITATIONS_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_CERTIFIED_ACCREDITATIONS_SUCCESS:function FETCH_GET_CERTIFIED_ACCREDITATIONS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});}},initialState));//- Selectors
var getCertifiedAccreditations=function getCertifiedAccreditations(state){return state.certifiedAccreditations;};var loadingCertifiedAccreditations=function loadingCertifiedAccreditations(state){return getCertifiedAccreditations(state).fetching;};var getCertifiedAccreditationsData=function getCertifiedAccreditationsData(state){var data=getCertifiedAccreditations(state).data;if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(data)){return null;}return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(data,function(accreditation){return{id:accreditation.id,titleOriginal:accreditation.accreditationData.titles.original,titleEn:accreditation.accreditationData.titles.en,additionalTitles:Object.assign({},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pickBy(accreditation.accreditationData.titles,function(value,key){return key!=='en'&&key!=='original';})),dateIssued:accreditation.accreditationData.issuedAt,issuedByName:accreditation.organization.name,issuedByCountry:accreditation.organization.address.countryCode,level:accreditation.accreditationData.level,expose:accreditation.expose};});};var getCertifiedAccreditationDataById=function getCertifiedAccreditationDataById(state,id){if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(getCertifiedAccreditationsData(state))){return null;}return getCertifiedAccreditationsData(state).find(function(elem){return elem.id===id;});};

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetPendingAccreditationsFailed */
/* unused harmony export fetchGetPendingAccreditationsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetPendingAccreditations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchValidatePendingAccreditation; });
/* unused harmony export onValidatePendingAccreditation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchDiscardPendingAccreditation; });
/* unused harmony export onDiscardPendingAccreditation */
/* unused harmony export getPendingAccreditations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return loadingPendingAccreditations; });
/* unused harmony export getPendingAccreditationsData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPendingAccreditationsListData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getPendingAccreditationDataFormatted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPendingAccreditationDataById; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_utils__ = __webpack_require__(12);
//- Actions
var fetchGetPendingAccreditationsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PENDING_ACCREDITATIONS_FAILED');var fetchGetPendingAccreditationsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PENDING_ACCREDITATIONS_SUCCESS');var fetchGetPendingAccreditations=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PENDING_ACCREDITATIONS',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getPendingAccreditations();},function(){return{apiCall:true,onSuccess:fetchGetPendingAccreditationsSuccess,onFail:fetchGetPendingAccreditationsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchValidatePendingAccreditation=function fetchValidatePendingAccreditation(accreditationId,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onValidatePendingAccreditation(accreditationId,data));};};var onValidatePendingAccreditation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_VALIDATE_PENDING_ACCREDITATION',function(accreditationId,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].validatePendingAccreditation(accreditationId,data);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchDiscardPendingAccreditation=function fetchDiscardPendingAccreditation(accreditationId){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onDiscardPendingAccreditation(accreditationId));};};var onDiscardPendingAccreditation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_DISCARD_PENDING_ACCREDITATION',function(accreditationId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].discardPendingAccreditation(accreditationId);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});//- State
var initialState={fetching:false,data:null,error:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_PENDING_ACCREDITATIONS:function FETCH_GET_PENDING_ACCREDITATIONS(state){return Object.assign({},state,{data:null,error:null,fetching:true});},FETCH_GET_PENDING_ACCREDITATIONS_FAILED:function FETCH_GET_PENDING_ACCREDITATIONS_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_PENDING_ACCREDITATIONS_SUCCESS:function FETCH_GET_PENDING_ACCREDITATIONS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});}},initialState));//- Selectors
var getPendingAccreditations=function getPendingAccreditations(state){return state.pendingAccreditations;};var loadingPendingAccreditations=function loadingPendingAccreditations(state){return getPendingAccreditations(state).fetching;};var getPendingAccreditationsData=function getPendingAccreditationsData(state){return getPendingAccreditations(state).data;};var getPendingAccreditationsListData=function getPendingAccreditationsListData(state){var data=getPendingAccreditationsData(state);if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(data)){return null;}return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(data,function(accreditation){return{id:accreditation.id,titleOriginal:accreditation.accreditationData.titles.original,titleEn:accreditation.accreditationData.titles.en,additionalTitles:Object.assign({},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.pickBy(accreditation.accreditationData.titles,function(value,key){return key!=='en'&&key!=='original';})),dateIssued:accreditation.accreditationData.issuedAt,issuedByName:accreditation.organization.name,issuedByCountry:accreditation.organization.address.countryCode,level:accreditation.accreditationData.level};});};var getPendingAccreditationDataFormatted=function getPendingAccreditationDataFormatted(state,id){var data=getPendingAccreditationsData(state);if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(data)){return;}var accreditation=data.find(function(elem){return elem.id===id;});if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(accreditation)||!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(accreditation,'accreditationData.titles')||!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(accreditation,'verifiedIdentity')||!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(accreditation,'organization.address')){return null;}return Object.assign({},__WEBPACK_IMPORTED_MODULE_5__utils_utils__["a" /* Utils */].getAccreditationFormattedData(accreditation),{email:accreditation.email,issuedByName:accreditation.organization.name,issuedByCountry:accreditation.organization.address.countryCode,accreditationGroupId:accreditation.accreditationGroupId,original:__WEBPACK_IMPORTED_MODULE_5__utils_utils__["a" /* Utils */].getAccreditationFormattedData(accreditation.original)});};var getPendingAccreditationDataById=function getPendingAccreditationDataById(state,id){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(getPendingAccreditationsData(state))){return null;}return getPendingAccreditationsData(state).find(function(elem){return elem.id===id;});};

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetSelfStudyBooksFailed */
/* unused harmony export fetchGetSelfStudyBooksSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetSelfStudyBooks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return onCreateSelfStudyBook; });
/* unused harmony export fetchCreateSelfStudyBook */
/* unused harmony export getApplicantSelfStudyBooks */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadingApplicantSelfStudyBooks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getApplicantSelfStudyBooksData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_submitForm__ = __webpack_require__(7);
//- Actions
var fetchGetSelfStudyBooksFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_SELF_STUDY_BOOKS_FAILED');var fetchGetSelfStudyBooksSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_SELF_STUDY_BOOKS_SUCCESS');var fetchGetSelfStudyBooks=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_SELF_STUDY_BOOKS',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getApplicantSelfStudyBooks();},function(){return{apiCall:true,onSuccess:fetchGetSelfStudyBooksSuccess,onFail:fetchGetSelfStudyBooksFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onCreateSelfStudyBook=function onCreateSelfStudyBook(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchCreateSelfStudyBook(data));};};var fetchCreateSelfStudyBook=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CREATE_SELF_STUDY_BOOK',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].addApplicantSelfStudyBooks(data);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onSetFieldsErrors:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["l" /* setFieldErrors */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});//- State
var initialState={fetching:false,data:null,error:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_SELF_STUDY_BOOKS:function FETCH_GET_SELF_STUDY_BOOKS(state){return Object.assign({},state,{error:null,fetching:true});},FETCH_GET_SELF_STUDY_BOOKS_FAILED:function FETCH_GET_SELF_STUDY_BOOKS_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_SELF_STUDY_BOOKS_SUCCESS:function FETCH_GET_SELF_STUDY_BOOKS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload.content,error:null,fetching:false});}},initialState));//- Selectors
var getApplicantSelfStudyBooks=function getApplicantSelfStudyBooks(state){return state.applicantSelfStudyBooks;};var loadingApplicantSelfStudyBooks=function loadingApplicantSelfStudyBooks(state){return getApplicantSelfStudyBooks(state).fetching;};var getApplicantSelfStudyBooksData=function getApplicantSelfStudyBooksData(state){return getApplicantSelfStudyBooks(state).data;};

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetSelfStudyBookByIdFailed */
/* unused harmony export fetchGetSelfStudyBookByIdSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetSelfStudyBookById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return onUpdateSelfStudyBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return onUpdateSelfStudyBookFromList; });
/* unused harmony export fetchUpdateSelfStudyBookFromList */
/* unused harmony export fetchUpdateSelfStudyBook */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return onRemoveSelfStudyBook; });
/* unused harmony export onRemoveSelfStudyBookSuccess */
/* unused harmony export fetchRemoveSelfStudyBook */
/* unused harmony export getApplicantSelfStudyBook */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadingSelfStudyBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSelfStudyBookData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applicantSelfStudyBooks__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_login__ = __webpack_require__(17);
//- Actions
var fetchGetSelfStudyBookByIdFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_SELF_STUDY_BOOK_BY_ID_FAILED');var fetchGetSelfStudyBookByIdSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_SELF_STUDY_BOOK_BY_ID_SUCCESS');var fetchGetSelfStudyBookById=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_SELF_STUDY_BOOK_BY_ID',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getApplicantSelfStudyBook(id);},function(){return{apiCall:true,onSuccess:fetchGetSelfStudyBookByIdSuccess,onFail:fetchGetSelfStudyBookByIdFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});var onUpdateSelfStudyBook=function onUpdateSelfStudyBook(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchUpdateSelfStudyBook(id,data));};};var onUpdateSelfStudyBookFromList=function onUpdateSelfStudyBookFromList(id,data){return function(dispatch){dispatch(fetchUpdateSelfStudyBookFromList(id,data));};};var fetchUpdateSelfStudyBookFromList=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_UPDATE_SELF_STUDY_BOOK_FROM_LIST',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateSelfStudyBook(id,data);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_3__applicantSelfStudyBooks__["b" /* fetchGetSelfStudyBooks */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});var fetchUpdateSelfStudyBook=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_UPDATE_SELF_STUDY_BOOK',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateSelfStudyBook(id,data);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onSetFieldsErrors:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["l" /* setFieldErrors */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});var onRemoveSelfStudyBook=function onRemoveSelfStudyBook(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchRemoveSelfStudyBook(id));};};var onRemoveSelfStudyBookSuccess=function onRemoveSelfStudyBookSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__applicantSelfStudyBooks__["b" /* fetchGetSelfStudyBooks */])());};};var fetchRemoveSelfStudyBook=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_SELF_STUDY_BOOK',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeSelfStudyBook(id);},function(){return{apiCall:true,onSuccess:onRemoveSelfStudyBookSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_4__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_4__account_login__["l" /* onForbidden */]};});//- State
var initialState={data:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_SELF_STUDY_BOOK_BY_ID:function FETCH_GET_SELF_STUDY_BOOK_BY_ID(state){return Object.assign({},state,{data:null,error:null,fetching:true});},FETCH_GET_SELF_STUDY_BOOK_BY_ID_FAILED:function FETCH_GET_SELF_STUDY_BOOK_BY_ID_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_SELF_STUDY_BOOK_BY_ID_SUCCESS:function FETCH_GET_SELF_STUDY_BOOK_BY_ID_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});}},initialState));//- Selectors
var getApplicantSelfStudyBook=function getApplicantSelfStudyBook(state){return state.applicantSelfStudyBook;};var loadingSelfStudyBook=function loadingSelfStudyBook(state){return getApplicantSelfStudyBook(state).fetching;};var getSelfStudyBookData=function getSelfStudyBookData(state){return getApplicantSelfStudyBook(state).data;};

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchAccreditationRequestByIdFailed */
/* unused harmony export fetchAccreditationRequestByIdSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAccreditationRequestById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return onUpdateAccreditationRequest; });
/* unused harmony export fetchUpdateAccreditationRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return onRemoveAccreditationRequest; });
/* unused harmony export onEditAccreditationRequestSuccess */
/* unused harmony export fetchRemoveAccreditationRequest */
/* unused harmony export getAccreditationRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadingAccreditationRequest; });
/* unused harmony export getAccreditationRequestData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAccreditationRequestDataFormatted; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__accreditationRequests__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//- Actions
var fetchAccreditationRequestByIdFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_REQUEST_BY_ID_FAILED');var fetchAccreditationRequestByIdSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_REQUEST_BY_ID_SUCCESS');var fetchAccreditationRequestById=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ACCREDITATION_REQUEST_BY_ID',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAccreditationRequestById(id);},function(){return{apiCall:true,onSuccess:fetchAccreditationRequestByIdSuccess,onFail:fetchAccreditationRequestByIdFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var onUpdateAccreditationRequest=function onUpdateAccreditationRequest(id,data,fullUpdateRequired){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchUpdateAccreditationRequest(id,data,fullUpdateRequired));};};var fetchUpdateAccreditationRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_UPDATE_ACCREDITATION_REQUEST',function(id,data,fullUpdateRequired){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateAccreditationRequest(id,data,fullUpdateRequired);},function(){return{apiCall:true,onSuccess:onEditAccreditationRequestSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var onRemoveAccreditationRequest=function onRemoveAccreditationRequest(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchRemoveAccreditationRequest(id));};};var onEditAccreditationRequestSuccess=function onEditAccreditationRequestSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__accreditationRequests__["e" /* fetchGetAccreditationRequests */])());};};var fetchRemoveAccreditationRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_ACCREDITATION_REQUEST',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeAccreditationRequest(id);},function(){return{apiCall:true,onSuccess:onEditAccreditationRequestSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});//- State
var initialState={data:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_ACCREDITATION_REQUEST_BY_ID:function FETCH_GET_ACCREDITATION_REQUEST_BY_ID(state){return Object.assign({},state,{data:null,error:null,fetching:true});},FETCH_GET_ACCREDITATION_REQUEST_BY_ID_FAILED:function FETCH_GET_ACCREDITATION_REQUEST_BY_ID_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_ACCREDITATION_REQUEST_BY_ID_SUCCESS:function FETCH_GET_ACCREDITATION_REQUEST_BY_ID_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});}},initialState));//- Selectors
var getAccreditationRequest=function getAccreditationRequest(state){return state.accreditationRequest;};var loadingAccreditationRequest=function loadingAccreditationRequest(state){return getAccreditationRequest(state).fetching;};var getAccreditationRequestData=function getAccreditationRequestData(state){return getAccreditationRequest(state).data;};var getAccreditationRequestDataFormatted=function getAccreditationRequestDataFormatted(state){var data=getAccreditationRequestData(state);if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(data)||!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.has(data,'accreditationData.titles')||!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.has(data,'verifiedIdentity')){return null;}var accreditationRequestData={orgName:data.orgName,orgDomain:data.orgDomain,accreditationGroupName:data.accreditationGroupName,managingOrganizationId:data.managingOrganizationId,titleOrig:data.accreditationData.titles.original,titleEn:data.accreditationData.titles.en,titlesAdditional:{},dateIssued:data.accreditationData.issuedAt,level:data.accreditationData.level,verifiedIdentity:data.verifiedIdentity,expose:data.expose};var additionalTitles=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pickBy(data.accreditationData.titles,function(value,key){return key!=='en'&&key!=='original';});__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.mapValues(additionalTitles,function(value,key){accreditationRequestData.titlesAdditional[key]=value;});return accreditationRequestData;};

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetOrgsWithoutCertificatesFailed */
/* unused harmony export fetchGetOrgsWithoutCertificatesSuccess */
/* unused harmony export onFetchAddFirstOrgCertificate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetOrgsWithoutCertificates; });
/* unused harmony export updateCertificatesData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAddFirstOrgCertificate; });
/* unused harmony export onAddFirstOrgCertificate */
/* unused harmony export onAddFirstOrgCertificateSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return removeOrgWithoutCertificatesFromPage; });
/* unused harmony export updateOrgsWithoutCertificatesPage */
/* unused harmony export getOrgsWithoutCertificates */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return loadingOrgsWithoutCertificates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentPageForOrgsWithoutCertificates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTotalPagesForOrgsWithoutCertificates; });
/* unused harmony export getOrgsWithoutCertificatesData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOrgsWithoutCertificatesFormattedData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFirstCertificatesData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_activeModal__ = __webpack_require__(6);
//- Actions
var fetchGetOrgsWithoutCertificatesFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORGS_WITHOUT_CERTIFICATES_FAILED');var fetchGetOrgsWithoutCertificatesSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORGS_WITHOUT_CERTIFICATES_SUCCESS');var onFetchAddFirstOrgCertificate=function onFetchAddFirstOrgCertificate(page){return function(data){return function(dispatch){if(data.content.length===0&&page&&page>0){dispatch(fetchGetOrgsWithoutCertificates(0));}else{dispatch(fetchGetOrgsWithoutCertificatesSuccess(data));}};};};var fetchGetOrgsWithoutCertificates=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORGS_WITHOUT_CERTIFICATES',function(page){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getOrgsWithoutCertificates(page);},function(page){return{apiCall:true,onSuccess:onFetchAddFirstOrgCertificate(page),onFail:fetchGetOrgsWithoutCertificatesFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var updateCertificatesData=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_CERTIFICATES_DATA');var fetchAddFirstOrgCertificate=function fetchAddFirstOrgCertificate(orgId,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onAddFirstOrgCertificate(orgId,data));};};var onAddFirstOrgCertificate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_ADD_ORG_CERTIFICATE',function(orgId,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].addOrgCertificate(orgId,data);},function(orgId,data){return{apiCall:true,onSuccess:onAddFirstOrgCertificateSuccess(orgId),onFail:__WEBPACK_IMPORTED_MODULE_4__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onAddFirstOrgCertificateSuccess=function onAddFirstOrgCertificateSuccess(orgId){return function(data){return function(dispatch,getState){var certificatesData=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(getFirstCertificatesData(getState()));certificatesData[orgId]=data;dispatch(updateCertificatesData(certificatesData));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__common_submitForm__["k" /* resetSubmitFormData */])());};};};var removeOrgWithoutCertificatesFromPage=function removeOrgWithoutCertificatesFromPage(orgId){return function(dispatch,getState){var data=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(getOrgsWithoutCertificatesData(getState()));data=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(data,function(elem){return elem.id!==orgId;});dispatch(updateOrgsWithoutCertificatesPage(data));if(data.length===0){dispatch(fetchGetOrgsWithoutCertificates(0));}};};var updateOrgsWithoutCertificatesPage=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_ORGS_WITHOUT_CERTIFICATES_PAGE');//- State
var initialState={fetching:false,data:null,error:null,currentPage:null,totalPages:null,certificatesData:{}};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_ORGS_WITHOUT_CERTIFICATES:function FETCH_GET_ORGS_WITHOUT_CERTIFICATES(state){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,error:null,fetching:true});},FETCH_GET_ORGS_WITHOUT_CERTIFICATES_FAILED:function FETCH_GET_ORGS_WITHOUT_CERTIFICATES_FAILED(state,action){return Object.assign({},state,{data:null,currentPage:null,totalPages:null,error:action.payload,fetching:false});},FETCH_GET_ORGS_WITHOUT_CERTIFICATES_SUCCESS:function FETCH_GET_ORGS_WITHOUT_CERTIFICATES_SUCCESS(state,action){return Object.assign({},state,{data:action.payload.content,currentPage:action.payload.number,totalPages:action.payload.totalPages,error:null,fetching:false});},UPDATE_CERTIFICATES_DATA:function UPDATE_CERTIFICATES_DATA(state,action){return Object.assign({},state,{certificatesData:action.payload});},UPDATE_ORGS_WITHOUT_CERTIFICATES_PAGE:function UPDATE_ORGS_WITHOUT_CERTIFICATES_PAGE(state,action){return Object.assign({},state,{data:action.payload});}},initialState));//- Selectors
var getOrgsWithoutCertificates=function getOrgsWithoutCertificates(state){return state.orgsWithoutCertificates;};var loadingOrgsWithoutCertificates=function loadingOrgsWithoutCertificates(state){return getOrgsWithoutCertificates(state).fetching;};var getCurrentPageForOrgsWithoutCertificates=function getCurrentPageForOrgsWithoutCertificates(state){return getOrgsWithoutCertificates(state).currentPage;};var getTotalPagesForOrgsWithoutCertificates=function getTotalPagesForOrgsWithoutCertificates(state){return getOrgsWithoutCertificates(state).totalPages;};var getOrgsWithoutCertificatesData=function getOrgsWithoutCertificatesData(state){return getOrgsWithoutCertificates(state).data;};var getOrgsWithoutCertificatesFormattedData=function getOrgsWithoutCertificatesFormattedData(state){var data=getOrgsWithoutCertificatesData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(data,function(org){return{id:org.id,anchorName:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(org.anchor.identityAlias)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(org.anchor.identityAlias.firstName)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(org.anchor.identityAlias.lastName)?"":org.anchor.identityAlias.firstName+" "+org.anchor.identityAlias.lastName,anchorEmail:org.anchor.email,orgName:org.name};});};var getFirstCertificatesData=function getFirstCertificatesData(state){return getOrgsWithoutCertificates(state).certificatesData;};

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetBusinessAmbassadorsFailed */
/* unused harmony export fetchGetBusinessAmbassadorsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetBusinessAmbassadors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return onCreateBusinessAmbassador; });
/* unused harmony export fetchCreateBusinessAmbassador */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return onRemoveBusinessAmbassador; });
/* unused harmony export fetchRemoveBusinessAmbassadorSuccess */
/* unused harmony export fetchRemoveBusinessAmbassador */
/* unused harmony export getBusinessAmbassadors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadingBusinessAmbassadors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBusinessAmbassadorsData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_submitForm__ = __webpack_require__(7);
//- Actions
var fetchGetBusinessAmbassadorsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BUSINESS_AMBASSADORS_FAILED');var fetchGetBusinessAmbassadorsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BUSINESS_AMBASSADORS_SUCCESS');var fetchGetBusinessAmbassadors=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BUSINESS_AMBASSADORS',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getBusinessAmbassadors();},function(){return{apiCall:true,onSuccess:fetchGetBusinessAmbassadorsSuccess,onFail:fetchGetBusinessAmbassadorsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onCreateBusinessAmbassador=function onCreateBusinessAmbassador(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchCreateBusinessAmbassador(data));};};var fetchCreateBusinessAmbassador=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_ADD_BUSINESS_AMBASSADORS',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].addBusinessAmbassador(data);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onRemoveBusinessAmbassador=function onRemoveBusinessAmbassador(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchRemoveBusinessAmbassador(id));};};var fetchRemoveBusinessAmbassadorSuccess=function fetchRemoveBusinessAmbassadorSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["k" /* resetSubmitFormData */])());dispatch(fetchGetBusinessAmbassadors());};};var fetchRemoveBusinessAmbassador=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_ASSISTANT',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeBusinessAmbassador(id);},function(){return{apiCall:true,onSuccess:fetchRemoveBusinessAmbassadorSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});//- State
var initialState={fetching:false,data:null,error:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_BUSINESS_AMBASSADORS:function FETCH_GET_BUSINESS_AMBASSADORS(state){return Object.assign({},state,{error:null,fetching:true});},FETCH_GET_BUSINESS_AMBASSADORS_FAILED:function FETCH_GET_BUSINESS_AMBASSADORS_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_BUSINESS_AMBASSADORS_SUCCESS:function FETCH_GET_BUSINESS_AMBASSADORS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});}},initialState));//- Selectors
var getBusinessAmbassadors=function getBusinessAmbassadors(state){return state.businessAmbassadors;};var loadingBusinessAmbassadors=function loadingBusinessAmbassadors(state){return getBusinessAmbassadors(state).fetching;};var getBusinessAmbassadorsData=function getBusinessAmbassadorsData(state){return getBusinessAmbassadors(state).data;};

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* unused harmony export compose */
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(331);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;

  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.REPLACE });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';

  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var store = createStore.apply(undefined, args);
      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(undefined, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */
function isCrushed() {}

if (false) {
  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hostReportError;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function hostReportError(err) {
    setTimeout(function () { throw err; });
}
//# sourceMappingURL=hostReportError.js.map


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rxSubscriber; });
/* unused harmony export $$rxSubscriber */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function')
    ? /*@__PURE__*/ Symbol.for('rxSubscriber')
    : '@@rxSubscriber';
var $$rxSubscriber = rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pipe;
/* harmony export (immutable) */ __webpack_exports__["b"] = pipeFromArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(116);
/** PURE_IMPORTS_START _noop PURE_IMPORTS_END */

function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (!fns) {
        return __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* noop */];
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
//# sourceMappingURL=pipe.js.map


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = refCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
    };
}
var RefCountOperator = /*@__PURE__*/ (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=refCount.js.map


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReplaySubject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_queue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscription__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__operators_observeOn__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_ObjectUnsubscribedError__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubjectSubscription__ = __webpack_require__(212);
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */







var ReplaySubject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) {
            bufferSize = Number.POSITIVE_INFINITY;
        }
        if (windowTime === void 0) {
            windowTime = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this._events = [];
        _this._infiniteTimeWindow = false;
        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        _this._windowTime = windowTime < 1 ? 1 : windowTime;
        if (windowTime === Number.POSITIVE_INFINITY) {
            _this._infiniteTimeWindow = true;
            _this.next = _this.nextInfiniteTimeWindow;
        }
        else {
            _this.next = _this.nextTimeWindow;
        }
        return _this;
    }
    ReplaySubject.prototype.nextInfiniteTimeWindow = function (value) {
        var _events = this._events;
        _events.push(value);
        if (_events.length > this._bufferSize) {
            _events.shift();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype.nextTimeWindow = function (value) {
        this._events.push(new ReplayEvent(this._getNow(), value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        var _infiniteTimeWindow = this._infiniteTimeWindow;
        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var len = _events.length;
        var subscription;
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_5__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        else if (this.isStopped || this.hasError) {
            subscription = __WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Subscription */].EMPTY;
        }
        else {
            this.observers.push(subscriber);
            subscription = new __WEBPACK_IMPORTED_MODULE_6__SubjectSubscription__["a" /* SubjectSubscription */](this, subscriber);
        }
        if (scheduler) {
            subscriber.add(subscriber = new __WEBPACK_IMPORTED_MODULE_4__operators_observeOn__["a" /* ObserveOnSubscriber */](subscriber, scheduler));
        }
        if (_infiniteTimeWindow) {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i]);
            }
        }
        else {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i].value);
            }
        }
        if (this.hasError) {
            subscriber.error(this.thrownError);
        }
        else if (this.isStopped) {
            subscriber.complete();
        }
        return subscription;
    };
    ReplaySubject.prototype._getNow = function () {
        return (this.scheduler || __WEBPACK_IMPORTED_MODULE_2__scheduler_queue__["a" /* queue */]).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        while (spliceCount < eventsCount) {
            if ((now - _events[spliceCount].time) < _windowTime) {
                break;
            }
            spliceCount++;
        }
        if (eventsCount > _bufferSize) {
            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
            _events.splice(0, spliceCount);
        }
        return _events;
    };
    return ReplaySubject;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]));

var ReplayEvent = /*@__PURE__*/ (function () {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}());
//# sourceMappingURL=ReplaySubject.js.map


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = of;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_isScheduler__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromArray__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__empty__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scalar__ = __webpack_require__(155);
/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_empty,_scalar PURE_IMPORTS_END */




function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = args[args.length - 1];
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util_isScheduler__["a" /* isScheduler */])(scheduler)) {
        args.pop();
    }
    else {
        scheduler = undefined;
    }
    switch (args.length) {
        case 0:
            return Object(__WEBPACK_IMPORTED_MODULE_2__empty__["b" /* empty */])(scheduler);
        case 1:
            return scheduler ? Object(__WEBPACK_IMPORTED_MODULE_1__fromArray__["a" /* fromArray */])(args, scheduler) : Object(__WEBPACK_IMPORTED_MODULE_3__scalar__["a" /* scalar */])(args[0]);
        default:
            return Object(__WEBPACK_IMPORTED_MODULE_1__fromArray__["a" /* fromArray */])(args, scheduler);
    }
}
//# sourceMappingURL=of.js.map


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scalar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

function scalar(value) {
    var result = new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        subscriber.next(value);
        subscriber.complete();
    });
    result._isScalar = true;
    result.value = value;
    return result;
}
//# sourceMappingURL=scalar.js.map


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throwError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

function throwError(error, scheduler) {
    if (!scheduler) {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) { return subscriber.error(error); });
    }
    else {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) { return scheduler.schedule(dispatch, 0, { error: error, subscriber: subscriber }); });
    }
}
function dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}
//# sourceMappingURL=throwError.js.map


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export combineLatest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CombineLatestOperator; });
/* unused harmony export CombineLatestSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isScheduler__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fromArray__ = __webpack_require__(59);
/** PURE_IMPORTS_START tslib,_util_isScheduler,_util_isArray,_OuterSubscriber,_util_subscribeToResult,_fromArray PURE_IMPORTS_END */






var NONE = {};
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = null;
    var scheduler = null;
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isScheduler__["a" /* isScheduler */])(observables[observables.length - 1])) {
        scheduler = observables.pop();
    }
    if (typeof observables[observables.length - 1] === 'function') {
        resultSelector = observables.pop();
    }
    if (observables.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_2__util_isArray__["a" /* isArray */])(observables[0])) {
        observables = observables[0];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_5__fromArray__["a" /* fromArray */])(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
}
var CombineLatestOperator = /*@__PURE__*/ (function () {
    function CombineLatestOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    CombineLatestOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
    };
    return CombineLatestOperator;
}());

var CombineLatestSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, resultSelector) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.active = 0;
        _this.values = [];
        _this.observables = [];
        return _this;
    }
    CombineLatestSubscriber.prototype._next = function (observable) {
        this.values.push(NONE);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            this.active = len;
            this.toRespond = len;
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                this.add(Object(__WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__["a" /* subscribeToResult */])(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
        if ((this.active -= 1) === 0) {
            this.destination.complete();
        }
    };
    CombineLatestSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond
            ? 0
            : oldVal === NONE ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.resultSelector) {
                this._tryResultSelector(values);
            }
            else {
                this.destination.next(values.slice());
            }
        }
    };
    CombineLatestSubscriber.prototype._tryResultSelector = function (values) {
        var result;
        try {
            result = this.resultSelector.apply(this, values);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));

//# sourceMappingURL=combineLatest.js.map


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeMap__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_identity__ = __webpack_require__(73);
/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */


function mergeAll(concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__mergeMap__["a" /* mergeMap */])(__WEBPACK_IMPORTED_MODULE_1__util_identity__["a" /* identity */], concurrent);
}
//# sourceMappingURL=mergeAll.js.map


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__from__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__empty__ = __webpack_require__(42);
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */



function defer(observableFactory) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var input;
        try {
            input = observableFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = input ? Object(__WEBPACK_IMPORTED_MODULE_1__from__["a" /* from */])(input) : Object(__WEBPACK_IMPORTED_MODULE_2__empty__["b" /* empty */])();
        return source.subscribe(subscriber);
    });
}
//# sourceMappingURL=defer.js.map


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = zip;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZipOperator; });
/* unused harmony export ZipSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromArray__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_symbol_iterator__ = __webpack_require__(94);
/** PURE_IMPORTS_START tslib,_fromArray,_util_isArray,_Subscriber,_OuterSubscriber,_util_subscribeToResult,_.._internal_symbol_iterator PURE_IMPORTS_END */







function zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = observables[observables.length - 1];
    if (typeof resultSelector === 'function') {
        observables.pop();
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__fromArray__["a" /* fromArray */])(observables, undefined).lift(new ZipOperator(resultSelector));
}
var ZipOperator = /*@__PURE__*/ (function () {
    function ZipOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    ZipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
    };
    return ZipOperator;
}());

var ZipSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ZipSubscriber, _super);
    function ZipSubscriber(destination, resultSelector, values) {
        if (values === void 0) {
            values = Object.create(null);
        }
        var _this = _super.call(this, destination) || this;
        _this.iterators = [];
        _this.active = 0;
        _this.resultSelector = (typeof resultSelector === 'function') ? resultSelector : null;
        _this.values = values;
        return _this;
    }
    ZipSubscriber.prototype._next = function (value) {
        var iterators = this.iterators;
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_isArray__["a" /* isArray */])(value)) {
            iterators.push(new StaticArrayIterator(value));
        }
        else if (typeof value[__WEBPACK_IMPORTED_MODULE_6__internal_symbol_iterator__["a" /* iterator */]] === 'function') {
            iterators.push(new StaticIterator(value[__WEBPACK_IMPORTED_MODULE_6__internal_symbol_iterator__["a" /* iterator */]]()));
        }
        else {
            iterators.push(new ZipBufferIterator(this.destination, this, value));
        }
    };
    ZipSubscriber.prototype._complete = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                this.add(iterator.subscribe(iterator, i));
            }
            else {
                this.active--;
            }
        }
    };
    ZipSubscriber.prototype.notifyInactive = function () {
        this.active--;
        if (this.active === 0) {
            this.destination.complete();
        }
    };
    ZipSubscriber.prototype.checkIterators = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
                return;
            }
        }
        var shouldComplete = false;
        var args = [];
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            var result = iterator.next();
            if (iterator.hasCompleted()) {
                shouldComplete = true;
            }
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.resultSelector) {
            this._tryresultSelector(args);
        }
        else {
            destination.next(args);
        }
        if (shouldComplete) {
            destination.complete();
        }
    };
    ZipSubscriber.prototype._tryresultSelector = function (args) {
        var result;
        try {
            result = this.resultSelector.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__Subscriber__["a" /* Subscriber */]));

var StaticIterator = /*@__PURE__*/ (function () {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function () {
        return true;
    };
    StaticIterator.prototype.next = function () {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function () {
        var nextResult = this.nextResult;
        return nextResult && nextResult.done;
    };
    return StaticIterator;
}());
var StaticArrayIterator = /*@__PURE__*/ (function () {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[__WEBPACK_IMPORTED_MODULE_6__internal_symbol_iterator__["a" /* iterator */]] = function () {
        return this;
    };
    StaticArrayIterator.prototype.next = function (value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
    };
    StaticArrayIterator.prototype.hasValue = function () {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function () {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}());
var ZipBufferIterator = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        _this.observable = observable;
        _this.stillUnsubscribed = true;
        _this.buffer = [];
        _this.isComplete = false;
        return _this;
    }
    ZipBufferIterator.prototype[__WEBPACK_IMPORTED_MODULE_6__internal_symbol_iterator__["a" /* iterator */]] = function () {
        return this;
    };
    ZipBufferIterator.prototype.next = function () {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) {
            return { value: null, done: true };
        }
        else {
            return { value: buffer.shift(), done: false };
        }
    };
    ZipBufferIterator.prototype.hasValue = function () {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function () {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function () {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        }
        else {
            this.destination.complete();
        }
    };
    ZipBufferIterator.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function (value, index) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__["a" /* subscribeToResult */])(this, this.observable, this, index);
    };
    return ZipBufferIterator;
}(__WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=zip.js.map


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = take;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ArgumentOutOfRangeError__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__observable_empty__ = __webpack_require__(42);
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */




function take(count) {
    return function (source) {
        if (count === 0) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__observable_empty__["b" /* empty */])();
        }
        else {
            return source.lift(new TakeOperator(count));
        }
    };
}
var TakeOperator = /*@__PURE__*/ (function () {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new __WEBPACK_IMPORTED_MODULE_2__util_ArgumentOutOfRangeError__["a" /* ArgumentOutOfRangeError */];
        }
    }
    TakeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}());
var TakeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    TakeSubscriber.prototype._next = function (value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=take.js.map


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLast;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ArgumentOutOfRangeError__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__observable_empty__ = __webpack_require__(42);
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */




function takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__observable_empty__["b" /* empty */])();
        }
        else {
            return source.lift(new TakeLastOperator(count));
        }
    };
}
var TakeLastOperator = /*@__PURE__*/ (function () {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new __WEBPACK_IMPORTED_MODULE_2__util_ArgumentOutOfRangeError__["a" /* ArgumentOutOfRangeError */];
        }
    }
    TakeLastOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}());
var TakeLastSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.ring = new Array();
        _this.count = 0;
        return _this;
    }
    TakeLastSubscriber.prototype._next = function (value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) {
            ring.push(value);
        }
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function () {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for (var i = 0; i < total; i++) {
                var idx = (count++) % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=takeLast.js.map


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scan;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function scan(accumulator, seed) {
    var hasSeed = false;
    if (arguments.length >= 2) {
        hasSeed = true;
    }
    return function scanOperatorFunction(source) {
        return source.lift(new ScanOperator(accumulator, seed, hasSeed));
    };
}
var ScanOperator = /*@__PURE__*/ (function () {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) {
            hasSeed = false;
        }
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}());
var ScanSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this._seed = _seed;
        _this.hasSeed = hasSeed;
        _this.index = 0;
        return _this;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function () {
            return this._seed;
        },
        set: function (value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function (value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        }
        else {
            return this._tryNext(value);
        }
    };
    ScanSubscriber.prototype._tryNext = function (value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        }
        catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=scan.js.map


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = switchMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__observable_from__ = __webpack_require__(55);
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult,_map,_observable_from PURE_IMPORTS_END */






function switchMap(project, resultSelector) {
    if (typeof resultSelector === 'function') {
        return function (source) { return source.pipe(switchMap(function (a, i) { return Object(__WEBPACK_IMPORTED_MODULE_5__observable_from__["a" /* from */])(project(a, i)).pipe(Object(__WEBPACK_IMPORTED_MODULE_4__map__["a" /* map */])(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
    }
    return function (source) { return source.lift(new SwitchMapOperator(project)); };
}
var SwitchMapOperator = /*@__PURE__*/ (function () {
    function SwitchMapOperator(project) {
        this.project = project;
    }
    SwitchMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project));
    };
    return SwitchMapOperator;
}());
var SwitchMapSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.index = 0;
        return _this;
    }
    SwitchMapSubscriber.prototype._next = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
        }
        var innerSubscriber = new __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__["a" /* InnerSubscriber */](this, undefined, undefined);
        this.add(innerSubscriber);
        this.innerSubscription = Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__["a" /* subscribeToResult */])(this, result, value, index, innerSubscriber);
    };
    SwitchMapSubscriber.prototype._complete = function () {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapSubscriber.prototype._unsubscribe = function () {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    return SwitchMapSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=switchMap.js.map


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isFunction__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_identity__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_isNull__ = __webpack_require__(471);





function createAction(type) {
  var payloadCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_2__utils_identity__["a" /* default */];
  var metaCreator = arguments[2];

  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_1__utils_isFunction__["a" /* default */])(payloadCreator) || Object(__WEBPACK_IMPORTED_MODULE_3__utils_isNull__["a" /* default */])(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');

  var finalPayloadCreator = Object(__WEBPACK_IMPORTED_MODULE_3__utils_isNull__["a" /* default */])(payloadCreator) || payloadCreator === __WEBPACK_IMPORTED_MODULE_2__utils_identity__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__utils_identity__["a" /* default */] : function (head) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return head instanceof Error ? head : payloadCreator.apply(undefined, [head].concat(args));
  };

  var hasMeta = Object(__WEBPACK_IMPORTED_MODULE_1__utils_isFunction__["a" /* default */])(metaCreator);
  var typeString = type.toString();

  var actionCreator = function actionCreator() {
    var payload = finalPayloadCreator.apply(undefined, arguments);
    var action = { type: type };

    if (payload instanceof Error) {
      action.error = true;
    }

    if (payload !== undefined) {
      action.payload = payload;
    }

    if (hasMeta) {
      action.meta = metaCreator.apply(undefined, arguments);
    }

    return action;
  };

  actionCreator.toString = function () {
    return typeString;
  };

  return actionCreator;
}

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value;
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isMap__ = __webpack_require__(126);


function ownKeys(object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isMap__["a" /* default */])(object)) {
    return Array.from(object.keys());
  }

  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(170);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  'aria-label': __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  block: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["t" /* tagPropType */],
  innerRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  close: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  color: 'secondary',
  tag: 'button'
};

var Button =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Button, _React$Component);

  function Button(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = Button.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        ariaLabel = _this$props['aria-label'],
        block = _this$props.block,
        className = _this$props.className,
        close = _this$props.close,
        cssModule = _this$props.cssModule,
        color = _this$props.color,
        outline = _this$props.outline,
        size = _this$props.size,
        Tag = _this$props.tag,
        innerRef = _this$props.innerRef,
        attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["active", "aria-label", "block", "className", "close", "cssModule", "color", "outline", "size", "tag", "innerRef"]);

    if (close && typeof attributes.children === 'undefined') {
      attributes.children = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
        "aria-hidden": true
      }, "\xD7");
    }

    var btnOutlineColor = "btn" + (outline ? '-outline' : '') + "-" + color;
    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, {
      close: close
    }, close || 'btn', close || btnOutlineColor, size ? "btn-" + size : false, block ? 'btn-block' : false, {
      active: active,
      disabled: this.props.disabled
    }), cssModule);

    if (attributes.href && Tag === 'button') {
      Tag = 'a';
    }

    var defaultAriaLabel = close ? 'Close' : null;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      type: Tag === 'button' && attributes.onClick ? 'button' : undefined
    }, attributes, {
      className: classes,
      ref: innerRef,
      onClick: this.onClick,
      "aria-label": ariaLabel || defaultAriaLabel
    }));
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);









var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"].propTypes, {
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["t" /* tagPropType */],
  baseClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  baseClassActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func])
});

var defaultProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"].defaultProps, {
  tag: 'div',
  baseClass: 'fade',
  baseClassActive: 'show',
  timeout: __WEBPACK_IMPORTED_MODULE_7__utils__["e" /* TransitionTimeouts */].Fade,
  appear: true,
  enter: true,
  exit: true,
  in: true
});

function Fade(props) {
  var Tag = props.tag,
      baseClass = props.baseClass,
      baseClassActive = props.baseClassActive,
      className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      innerRef = props.innerRef,
      otherProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["tag", "baseClass", "baseClassActive", "className", "cssModule", "children", "innerRef"]);

  var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["r" /* pick */])(otherProps, __WEBPACK_IMPORTED_MODULE_7__utils__["c" /* TransitionPropTypeKeys */]);
  var childProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["q" /* omit */])(otherProps, __WEBPACK_IMPORTED_MODULE_7__utils__["c" /* TransitionPropTypeKeys */]);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"], transitionProps, function (status) {
    var isActive = status === 'entered';
    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, baseClass, isActive && baseClassActive), cssModule);
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: classes
    }, childProps, {
      ref: innerRef
    }), children);
  });
}

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(9);











var CarouselItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(CarouselItem, _React$Component);

  function CarouselItem(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      startAnimation: false
    };
    _this.onEnter = _this.onEnter.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onEntering = _this.onEntering.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onExit = _this.onExit.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onExiting = _this.onExiting.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onExited = _this.onExited.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = CarouselItem.prototype;

  _proto.onEnter = function onEnter(node, isAppearing) {
    this.setState({
      startAnimation: false
    });
    this.props.onEnter(node, isAppearing);
  };

  _proto.onEntering = function onEntering(node, isAppearing) {
    // getting this variable triggers a reflow
    var offsetHeight = node.offsetHeight;
    this.setState({
      startAnimation: true
    });
    this.props.onEntering(node, isAppearing);
    return offsetHeight;
  };

  _proto.onExit = function onExit(node) {
    this.setState({
      startAnimation: false
    });
    this.props.onExit(node);
  };

  _proto.onExiting = function onExiting(node) {
    this.setState({
      startAnimation: true
    });
    node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
    this.props.onExiting(node);
  };

  _proto.onExited = function onExited(node) {
    node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
    this.props.onExited(node);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        isIn = _this$props.in,
        children = _this$props.children,
        cssModule = _this$props.cssModule,
        slide = _this$props.slide,
        Tag = _this$props.tag,
        className = _this$props.className,
        transitionProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["in", "children", "cssModule", "slide", "tag", "className"]);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      enter: slide,
      exit: slide,
      in: isIn,
      onEnter: this.onEnter,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }), function (status) {
      var direction = _this2.context.direction;
      var isActive = status === __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* TransitionStatuses */].ENTERED || status === __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* TransitionStatuses */].EXITING;
      var directionClassName = (status === __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* TransitionStatuses */].ENTERING || status === __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* TransitionStatuses */].EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
      var orderClassName = status === __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* TransitionStatuses */].ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
      var itemClasses = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Tag, {
        className: itemClasses
      }, children);
    });
  };

  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

CarouselItem.propTypes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"].propTypes, {
  tag: __WEBPACK_IMPORTED_MODULE_9__utils__["t" /* tagPropType */],
  in: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  slide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
});
CarouselItem.defaultProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"].defaultProps, {
  tag: 'div',
  timeout: __WEBPACK_IMPORTED_MODULE_9__utils__["e" /* TransitionTimeouts */].Carousel,
  slide: true
});
CarouselItem.contextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (CarouselItem);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PersonalData__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{continentCode:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_location__["e" /* getCountriesData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},setContinentByCountry:function setContinentByCountry(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_location__["i" /* setCurrentContinentByCountry */])(countryCode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__PersonalData__["c" /* default */]));

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchCheckTokenFailed */
/* unused harmony export fetchCheckTokenSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchCheckToken; });
/* unused harmony export fetchCheckEmailAvailabilityFailed */
/* unused harmony export fetchCheckEmailAvailabilitySuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchCheckEmailAvailability; });
/* unused harmony export getTokenCheck */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isActualToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isEmailAvailable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
//- Actions
var fetchCheckTokenFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CHECK_TOKEN_FAILED');var fetchCheckTokenSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CHECK_TOKEN_SUCCESS');var fetchCheckToken=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CHECK_TOKEN',function(token){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getUserDataByToken(token);},function(){return{apiCall:true,onSuccess:fetchCheckTokenSuccess,onFail:fetchCheckTokenFailed};});var fetchCheckEmailAvailabilityFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CHECK_EMAIL_AVAILABILITY_FAILED');var fetchCheckEmailAvailabilitySuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CHECK_EMAIL_AVAILABILITY_SUCCESS');var fetchCheckEmailAvailability=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CHECK_EMAIL_AVAILABILITY',function(email){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].checkEmailAvailability(email);},function(){return{apiCall:true,onSuccess:fetchCheckEmailAvailabilitySuccess,onFail:fetchCheckEmailAvailabilityFailed};});//- State
var initialState={isActualToken:null,isEmailAvailable:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_CHECK_TOKEN:function FETCH_CHECK_TOKEN(state){return Object.assign({},state,{isActualToken:null,error:null,fetching:true});},FETCH_CHECK_TOKEN_FAILED:function FETCH_CHECK_TOKEN_FAILED(state,action){return Object.assign({},state,{isActualToken:false,error:action.payload,fetching:false});},FETCH_CHECK_TOKEN_SUCCESS:function FETCH_CHECK_TOKEN_SUCCESS(state){return Object.assign({},state,{isActualToken:true,error:null,fetching:false});},FETCH_CHECK_EMAIL_AVAILABILITY:function FETCH_CHECK_EMAIL_AVAILABILITY(state){return Object.assign({},state,{isEmailAvailable:null,error:null,fetching:true});},FETCH_CHECK_EMAIL_AVAILABILITY_FAILED:function FETCH_CHECK_EMAIL_AVAILABILITY_FAILED(state,action){return Object.assign({},state,{isEmailAvailable:false,error:action.payload,fetching:false});},FETCH_CHECK_EMAIL_AVAILABILITY_SUCCESS:function FETCH_CHECK_EMAIL_AVAILABILITY_SUCCESS(state){return Object.assign({},state,{isEmailAvailable:true,error:null,fetching:false});}},initialState));//- Selectors
var getTokenCheck=function getTokenCheck(state){return state.tokenCheck;};var isLoading=function isLoading(state){return getTokenCheck(state).fetching;};var isActualToken=function isActualToken(state){return getTokenCheck(state).isActualToken;};var isEmailAvailable=function isEmailAvailable(state){return getTokenCheck(state).isEmailAvailable;};

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetSecurityFailed */
/* unused harmony export fetchGetSecuritySuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchGetSecurity; });
/* unused harmony export fetchGenerate2FASecretFailed */
/* unused harmony export fetchGenerate2FASecretSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchGenerate2FASecret; });
/* unused harmony export onUpdateSecuritySuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchEnable2FA; });
/* unused harmony export onEnable2FA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchDisable2FA; });
/* unused harmony export onDisable2FA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearSecurity; });
/* unused harmony export getSecurity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return is2FAEnable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getSecurityLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getQRCodeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getQRCodeDataLoading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login__ = __webpack_require__(17);
//- Actions
var fetchGetSecurityFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_SECURITY_FAILED');var fetchGetSecuritySuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_SECURITY_SUCCESS');var fetchGetSecurity=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_SECURITY',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getSecurityState();},function(){return{apiCall:true,onSuccess:fetchGetSecuritySuccess,onFail:fetchGetSecurityFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__login__["l" /* onForbidden */]};});var fetchGenerate2FASecretFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GENERATE_2FA_SECRET_FAILED');var fetchGenerate2FASecretSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GENERATE_2FA_SECRET_SUCCESS');var fetchGenerate2FASecret=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GENERATE_2FA_SECRET',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].generate2FASecret();},function(){return{apiCall:true,onSuccess:fetchGenerate2FASecretSuccess,onFail:fetchGenerate2FASecretFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__login__["l" /* onForbidden */]};});var onUpdateSecuritySuccess=function onUpdateSecuritySuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(fetchGetSecurity());};};var fetchEnable2FA=function fetchEnable2FA(checkCode){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onEnable2FA(checkCode));};};var onEnable2FA=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_ENABLE_2FA',function(checkCode){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].enable2FA(checkCode);},function(){return{apiCall:true,onSuccess:onUpdateSecuritySuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__login__["l" /* onForbidden */]};});var fetchDisable2FA=function fetchDisable2FA(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onDisable2FA());};};var onDisable2FA=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_DISABLE_2FA',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].disable2FA();},function(){return{apiCall:true,onSuccess:onUpdateSecuritySuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__login__["l" /* onForbidden */]};});var clearSecurity=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_SECURITY');//- State
var initialState={fetching:false,error:null,is2FAEnable:null,QRCodeData:null,fetchingQRCodeData:false};//- Reducers
/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_SECURITY:function FETCH_GET_SECURITY(state){return Object.assign({},state,{error:null,fetching:true});},FETCH_GET_SECURITY_FAILED:function FETCH_GET_SECURITY_FAILED(state,action){return Object.assign({},state,{is2FAEnable:null,error:action.payload,fetching:false});},FETCH_GET_SECURITY_SUCCESS:function FETCH_GET_SECURITY_SUCCESS(state,action){return Object.assign({},state,{is2FAEnable:action.payload.enabled,error:null,fetching:false});},FETCH_GENERATE_2FA_SECRET:function FETCH_GENERATE_2FA_SECRET(state){return Object.assign({},state,{QRCodeData:null,error:null,fetchingQRCodeData:true});},FETCH_GENERATE_2FA_SECRET_FAILED:function FETCH_GENERATE_2FA_SECRET_FAILED(state,action){return Object.assign({},state,{QRCodeData:null,error:action.payload,fetchingQRCodeData:false});},FETCH_GENERATE_2FA_SECRET_SUCCESS:function FETCH_GENERATE_2FA_SECRET_SUCCESS(state,action){return Object.assign({},state,{QRCodeData:action.payload,error:null,fetchingQRCodeData:false});},CLEAR_SECURITY:function CLEAR_SECURITY(state){return Object.assign({},state,{is2FAEnable:null,QRCodeData:null});}},initialState));//- Selectors
var getSecurity=function getSecurity(state){return state.security;};var is2FAEnable=function is2FAEnable(state){return getSecurity(state).is2FAEnable;};var getSecurityLoading=function getSecurityLoading(state){return getSecurity(state).fetching;};var getQRCodeData=function getQRCodeData(state){return getSecurity(state).QRCodeData;};var getQRCodeDataLoading=function getQRCodeDataLoading(state){return getSecurity(state).fetchingQRCodeData;};

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__ = __webpack_require__(30);
var mapStateToProps=function mapStateToProps(state,_ref){var validated=_ref.validated;return{current:validated?Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["x" /* getCurrentPageForValidatedOrgs */])(state):Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["w" /* getCurrentPageForNotValidatedOrgs */])(state),total:validated?Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["L" /* getTotalPagesForValidatedOrgs */])(state):Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["K" /* getTotalPagesForNotValidatedOrgs */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var validated=_ref2.validated,countryFilter=_ref2.countryFilter;return{getDataForPage:function getDataForPage(page){dispatch(validated?Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["m" /* fetchGetValidatedOrgs */])(page,countryFilter):Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["j" /* fetchGetNotValidatedOrgs */])(page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={control:function control(styles,_ref){var isFocused=_ref.isFocused;return Object.assign({},styles,{borderColor:isFocused?'#80bdff':'#ced4da',boxShadow:isFocused?'0 0 0 0.2rem rgba(0,123,255,.25)':'none',lineHeight:'1','&:hover':{borderColor:isFocused?'#80bdff':'#ced4da'}});},valueContainer:function valueContainer(styles){return Object.assign({},styles,{padding:'.375rem .75rem',height:'36px'});},placeholder:function placeholder(styles){return Object.assign({},styles,{color:'#495057',marginLeft:'4px',marginRight:'2px'});},clearIndicator:function clearIndicator(styles){return Object.assign({},styles,{padding:'4px',cursor:'pointer'});},dropdownIndicator:function dropdownIndicator(styles){return Object.assign({},styles,{padding:'4px',cursor:'pointer'});},indicatorSeparator:function indicatorSeparator(styles){return Object.assign({},styles,{marginTop:'2px',marginBottom:'2px',backgroundColor:'#ced4da'});},singleValue:function singleValue(styles){return Object.assign({},styles,{height:'21px',padding:'3px 0'});},option:function option(styles,_ref2){var isSelected=_ref2.isSelected;return Object.assign({},styles,{":hover":{backgroundColor:isSelected?'#89aa11':'rgba(137, 170, 17, 0.44)'},backgroundColor:isSelected?'#89aa11':'white',cursor:'pointer',paddingTop:'0',paddingBottom:'0'});},menu:function menu(styles){return Object.assign({},styles,{marginTop:'0',marginBottom:'0',borderRadius:'0'});},menuList:function menuList(styles){return Object.assign({},styles,{paddingTop:'0',paddingBottom:'0'});}};var SelectWithSearch=function(_Component){_inherits(SelectWithSearch,_Component);function SelectWithSearch(){var _ref3;var _temp,_this,_ret;_classCallCheck(this,SelectWithSearch);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=SelectWithSearch.__proto__||Object.getPrototypeOf(SelectWithSearch)).call.apply(_ref3,[this].concat(args))),_this),_this.getOptionByValue=function(value){var option=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this.props.options,['value',value]);return option||null;},_this.handleChange=function(option){if(!option){_this.props.onChange(undefined);return;}_this.props.onChange(option.value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SelectWithSearch,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["b" /* default */],{className:'select-with-search '+(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.className)?'':this.props.className),value:this.getOptionByValue(this.props.value),options:this.props.options,isClearable:true,placeholder:this.props.placeholder,styles:styles,isDisabled:this.props.isDisabled,onChange:this.handleChange}));}}]);return SelectWithSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelectWithSearch.propTypes={className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,placeholder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,isDisabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,options:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,onChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SelectWithSearch);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LabelWithPages=function(_Component){_inherits(LabelWithPages,_Component);function LabelWithPages(props){_classCallCheck(this,LabelWithPages);var _this=_possibleConstructorReturn(this,(LabelWithPages.__proto__||Object.getPrototypeOf(LabelWithPages)).call(this,props));_this.state={total:null};return _this;}_createClass(LabelWithPages,[{key:'componentWillMount',value:function componentWillMount(){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNull(this.props.total)){this.setState({total:this.props.total});}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(nextProps.total!==this.props.total&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNull(nextProps.total)){this.setState({total:nextProps.total});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},this.props.label+' ','(',__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].pages_label).replace('{currentNumber}',this.props.currentIndex+1).replace('{totalNumber}',this.state.total||this.props.left+this.props.processed||''),')');}}]);return LabelWithPages;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);LabelWithPages.propTypes={left:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,total:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,processed:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,currentIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (LabelWithPages);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccreditationsList_css__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccreditationsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AccreditationsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__accreditationModal_removeAccreditationModal_RemoveAccreditationModal_container__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_paginationComponent_PaginationAccreditations_container__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccreditationsList=function(_Component){_inherits(AccreditationsList,_Component);function AccreditationsList(props){_classCallCheck(this,AccreditationsList);var _this=_possibleConstructorReturn(this,(AccreditationsList.__proto__||Object.getPrototypeOf(AccreditationsList)).call(this,props));_this.renderHeader=function(){if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.showHeader)&&!_this.props.showHeader){return null;}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'accreditation_list.label'));}};_this.getAccreditationsByPage=function(page){_this.props.onLoadAccreditations(_this.props.group,page);};_this.handleClick=function(id){return function(){_this.setState({redirect:true});_this.props.onStartValidation(id);};};_this.handleRemoveAccreditation=function(accreditation){return function(e){e.stopPropagation();_this.setState({accreditationToRemove:accreditation});_this.props.onRemoveAccreditation();};};_this.handleCancelRemovingAccreditation=function(){_this.setState({accreditationToRemove:null});};_this.handleChangeContinentFilter=function(selectedOption){_this.setState({continentFilter:selectedOption.value});};_this.handleChangeCountryFilter=function(selectedOption){_this.props.onUpdateCountryFilter(selectedOption.value);};_this.handleChangeDomainFilter=function(selectedOption){_this.props.onUpdateDomainFilter(selectedOption.value);};_this.state={redirect:false,accreditationToRemove:null,continentFilter:null};return _this;}_createClass(AccreditationsList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditations-list-container'},this.renderHeader(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditations-list-filters-container'},this.renderFilters()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_paginationComponent_PaginationAccreditations_container__["a" /* default */],{getDataForPage:this.getAccreditationsByPage}),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__accreditationModal_removeAccreditationModal_RemoveAccreditationModal_container__["a" /* default */],{data:this.state.accreditationToRemove,onCancelRemoving:this.handleCancelRemovingAccreditation}));}},{key:'renderFilters',value:function renderFilters(){var _this2=this;if(this.props.isOrgBava&&this.props.showCountryFilter){var requestsPerContinentOptions=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.props.requestsPerContinent,function(elem){return{value:elem.value,label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continents+"."+elem.value)+' ('+elem.count+')'};});var continentsOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(requestsPerContinentOptions));var requestsPerCountryOptions=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.chain(this.props.requestsPerCountry).filter(function(elem){return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this2.state.continentFilter)||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.includes(_this2.props.locationData[_this2.state.continentFilter],elem.value);}).map(function(elem){return{value:elem.value,label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].countries+'.'+elem.value)+' ('+elem.count+')'};}).value();requestsPerCountryOptions=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.orderBy(requestsPerCountryOptions,"label","asc");var countriesOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(requestsPerCountryOptions));var requestsPerDomainOptions=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.props.requestsPerDomain,function(elem){return{value:elem.value,label:elem.value+' ('+elem.count+')'};});requestsPerDomainOptions=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.orderBy(requestsPerDomainOptions,"label","asc");var domainOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(requestsPerDomainOptions));return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-container',key:'continent-filter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(continentsOptions,function(option){return option.value===_this2.state.continentFilter;}),options:continentsOptions,onSelect:this.handleChangeContinentFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-container',key:'country-filter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(countriesOptions,function(option){return option.value===_this2.props.countryFilter;}),options:countriesOptions,onSelect:this.handleChangeCountryFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-container',key:'domain-filter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(domainOptions,function(option){return option.value===_this2.props.domainFilter;}),options:domainOptions,onSelect:this.handleChangeDomainFilter}))];}}},{key:'renderContent',value:function renderContent(){if(this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.data)||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edu-org-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,this.props.noDataLabelPath)),!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.groupsNumber)&&this.props.groupsNumber>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'accreditation_list.no_data_to_review_hint')):null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["N" /* Table */],{className:'accreditations-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'accreditation_list.title_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'accreditation_list.date_issued_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'accreditation_list.level_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'accreditation_list.applicant_name_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'accreditation_list.location_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),this.props.canRemoveAccreditations?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.renderAccreditationsData()),this.state.redirect?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Redirect */],{to:'/'+this.props.redirectPath,push:true}):null);}},{key:'renderAccreditationsData',value:function renderAccreditationsData(){var _this3=this;if(!this.props.loading){return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.props.data,function(accreditationData,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index,className:'accreditations-list-row',onClick:_this3.handleClick(accreditationData.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'accreditation-title-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this3.props.translation,'accreditation_list.title_label')+":"},accreditationData.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'accreditation-date-issued-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this3.props.translation,'accreditation_list.date_issued_label')+":"},accreditationData.date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'accreditation-level-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this3.props.translation,'accreditation_list.level_label')+":"},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this3.props.translation,'levels.'+accreditationData.level)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'accreditation-applicant-name-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this3.props.translation,'accreditation_list.applicant_name_label')+":"},accreditationData.applicantName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'accreditation-location-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this3.props.translation,'accreditation_list.location_label')+":"},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this3.props.translation,'countries.'+accreditationData.location)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'control-cell create-icon-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'create',key:'create'+index,title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this3.props.translation,'accreditation_list.edit_label'),className:'create-accreditation-icon'})),_this3.props.canRemoveAccreditations?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'control-cell remove-icon-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'trash',key:'clear'+index,className:'remove-accreditation-icon',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this3.props.translation,'accreditation_list.remove_label'),onClick:_this3.handleRemoveAccreditation(accreditationData)})):null);});}}},{key:'componentDidMount',value:function componentDidMount(){this.props.onLoadAccreditations(this.props.group);if(this.props.isOrgBava){this.props.onLoadARsPerCountry(this.props.group);this.props.onLoadARsPerDomain(this.props.group);}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.group!==prevProps.group){this.props.onLoadAccreditations(this.props.group);if(this.props.isOrgBava){this.props.onClearCountryFilter();this.props.onClearDomainFilter();this.props.onLoadARsPerCountry(this.props.group);this.props.onLoadARsPerDomain(this.props.group);}}}}]);return AccreditationsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var AccreditationShape=__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,date:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,level:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,applicantName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired});AccreditationsList.propTypes={data:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(AccreditationShape),showHeader:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,loading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,redirectPath:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,canRemoveAccreditations:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,groupsNumber:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,isOrgBava:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,requestsPerCountry:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,requestsPerContinent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,locationData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,showCountryFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,countryFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onStartValidation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onLoadAccreditations:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onRemoveAccreditation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onUnmount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onLoadARsPerCountry:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onUpdateCountryFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onClearCountryFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onLoadARsPerDomain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onUpdateDomainFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onClearDomainFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (AccreditationsList);

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(301);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(185);
exports.Duplex = __webpack_require__(69);
exports.Transform = __webpack_require__(304);
exports.PassThrough = __webpack_require__(861);


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(137);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(107);
util.inherits = __webpack_require__(84);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(860)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(302);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(138).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(303);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(69);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(69);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104), __webpack_require__(858).setImmediate, __webpack_require__(37)))

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(138).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(188).isArray;

module.exports = {

  copyOptions: function (options) {
    var key, copy = {};
    for (key in options) {
      if (options.hasOwnProperty(key)) {
        copy[key] = options[key];
      }
    }
    return copy;
  },

  ensureFlagExists: function (item, options) {
    if (!(item in options) || typeof options[item] !== 'boolean') {
      options[item] = false;
    }
  },

  ensureSpacesExists: function (options) {
    if (!('spaces' in options) || (typeof options.spaces !== 'number' && typeof options.spaces !== 'string')) {
      options.spaces = 0;
    }
  },

  ensureAlwaysArrayExists: function (options) {
    if (!('alwaysArray' in options) || (typeof options.alwaysArray !== 'boolean' && !isArray(options.alwaysArray))) {
      options.alwaysArray = false;
    }
  },

  ensureKeyExists: function (key, options) {
    if (!(key + 'Key' in options) || typeof options[key + 'Key'] !== 'string') {
      options[key + 'Key'] = options.compact ? '_' + key : key;
    }
  },

  checkFnExists: function (key, options) {
    return key + 'Fn' in options;
  }

};


/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = {

  isArray: function(value) {
    if (Array.isArray) {
      return Array.isArray(value);
    }
    // fallback for older browsers like  IE 8
    return Object.prototype.toString.call( value ) === '[object Array]';
  }

};


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddCertificateModal_css__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddCertificateModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AddCertificateModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dropzone__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddCertificateModal=function(_Component){_inherits(AddCertificateModal,_Component);function AddCertificateModal(props){_classCallCheck(this,AddCertificateModal);var _this=_possibleConstructorReturn(this,(AddCertificateModal.__proto__||Object.getPrototypeOf(AddCertificateModal)).call(this,props));_this.formatIsCorrect=function(file){return file.name.endsWith('.crt');};_this.onDragEnter=function(){_this.setState({isEnter:true});_this.cleanState();};_this.onDragLeave=function(){_this.setState({isEnter:false});};_this.onDrop=function(filesArray){_this.setState({isEnter:false});if(filesArray.length!==1){_this.setState({error:true});return;}var file=filesArray[0];if(_this.formatIsCorrect(file)){_this.props.onSetLoading();var reader=new FileReader();reader.readAsText(file);reader.onloadend=function(){_this.setState({fileContent:reader.result,file:file});_this.props.onStopLoading();};}else{_this.setState({error:true});}};_this.cleanState=function(){_this.setState({file:null,fileContent:null,error:false});};_this.onAddCertificate=function(){_this.props.onAddCertificate(_this.state.fileContent,_this.props.orgId||null);};_this.state={isEnter:false,file:null,fileContent:null,error:false};return _this;}_createClass(AddCertificateModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen,toggle:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-certificate-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'certificate.about_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_dropzone__["a" /* default */],{className:'org-certificate-drop-zone',activeClassName:'org-certificate-drop-zone-active',onDrop:this.onDrop,multiple:false,onDragEnter:this.onDragEnter,onDragLeave:this.onDragLeave,onClick:this.cleanState},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-certificate-drop-zone-content-container '+(this.state.isEnter?'org-certificate-drop-zone-content-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.drag_and_drop_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.or_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.browse_label'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'certificate-result-label'},this.state.error?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.error_label'):"",!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.state.file)?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.uploaded_file_label')+": "+this.state.file.name:"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit',onClick:this.onAddCertificate,disabled:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.state.fileContent)},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'certificate.add_button')))));}}]);return AddCertificateModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AddCertificateModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,orgId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onAddCertificate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSetLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onStopLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (AddCertificateModal);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PeriodSelect__ = __webpack_require__(970);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__PeriodSelect__["a" /* default */]));

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetConsentByIdFailed */
/* unused harmony export fetchGetConsentByIdSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetConsentById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchUpdateConsent; });
/* unused harmony export fetchUpdateConsentSuccess */
/* unused harmony export onUpdateConsent */
/* unused harmony export getConsent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loadingConsent; });
/* unused harmony export getConsentData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFormattedConsent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__consents__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_activeModal__ = __webpack_require__(6);
//- Actions
var fetchGetConsentByIdFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_CONSENT_BY_ID_FAILED');var fetchGetConsentByIdSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_CONSENT_BY_ID_SUCCESS');var fetchGetConsentById=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_CONSENT_BY_ID',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getConsentById(id);},function(){return{apiCall:true,onSuccess:fetchGetConsentByIdSuccess,onFail:fetchGetConsentByIdFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var fetchUpdateConsent=function fetchUpdateConsent(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onUpdateConsent(id,data));};};var fetchUpdateConsentSuccess=function fetchUpdateConsentSuccess(){return function(dispatch,getState){var currentStatus=Object(__WEBPACK_IMPORTED_MODULE_5__consents__["l" /* getCurrentStatus */])(getState());var currentPage=Object(__WEBPACK_IMPORTED_MODULE_5__consents__["k" /* getCurrentPageForConsents */])(getState());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__consents__["p" /* getRequestsByStatus */])(currentStatus,currentPage));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__consents__["r" /* incrementNumberOfProcessedConsents */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_activeModal__["_16" /* hideModal */])());};};var onUpdateConsent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GRANT_REQUEST',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateConsent(id,data);},function(){return{apiCall:true,onSuccess:fetchUpdateConsentSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});//- State
var initialState={data:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_CONSENT_BY_ID:function FETCH_GET_CONSENT_BY_ID(state){return Object.assign({},state,{data:null,error:null,fetching:true});},FETCH_GET_CONSENT_BY_ID_FAILED:function FETCH_GET_CONSENT_BY_ID_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_CONSENT_BY_ID_SUCCESS:function FETCH_GET_CONSENT_BY_ID_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});}},initialState));//- Selectors
var getConsent=function getConsent(state){return state.consent;};var loadingConsent=function loadingConsent(state){return getConsent(state).fetching;};var getConsentData=function getConsentData(state){return getConsent(state).data;};var getFormattedConsent=function getFormattedConsent(state){var data=getConsentData(state);if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(data)){return null;}return{id:data.id,email:data.contactEmail,firstName:data.requester?data.requester.identityAlias.firstName:null,lastName:data.requester?data.requester.identityAlias.lastName:null,companyName:data.organization.name,message:data.requestComment,companyCountry:data.organization.address.countryCode,job:data.jobDescription.internalReference?data.jobDescription.internalReference+" - "+data.jobDescription.title:data.jobDescription.title,requestDate:data.createdAt};};

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TARGET_TYPE_LABEL_PATH; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PriorConsentsList_css__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PriorConsentsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PriorConsentsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_paginationComponent_PaginationPendingConsents_container__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__removePriorConsentModal_RemovePriorConsentModal_container__ = __webpack_require__(995);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _TARGET_TYPE_LABEL_PA;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var TARGET_TYPE_LABEL_PATH=(_TARGET_TYPE_LABEL_PA={},_defineProperty(_TARGET_TYPE_LABEL_PA,__WEBPACK_IMPORTED_MODULE_9__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].ANYONE,'prior_consents.anyone_label'),_defineProperty(_TARGET_TYPE_LABEL_PA,__WEBPACK_IMPORTED_MODULE_9__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].ORGANIZATION,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].org_label),_defineProperty(_TARGET_TYPE_LABEL_PA,__WEBPACK_IMPORTED_MODULE_9__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].PERSON,'consents.person_label'),_TARGET_TYPE_LABEL_PA);var PriorConsentsList=function(_Component){_inherits(PriorConsentsList,_Component);function PriorConsentsList(props){_classCallCheck(this,PriorConsentsList);var _this=_possibleConstructorReturn(this,(PriorConsentsList.__proto__||Object.getPrototypeOf(PriorConsentsList)).call(this,props));_this.renderTable=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prior-consents-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prior-consents-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.prior_consents_no_data_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["N" /* Table */],{className:'prior-consents-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.target_type_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.target_data_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.auto_grant_till_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.duration_label')),_this.props.editingDisabled?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderPendingConsentsData()));};_this.renderPendingConsentsData=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_this.props.data,function(consentData,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:"prior-consents-list-row "+(_this.props.editingDisabled?'disabled ':'')+(__WEBPACK_IMPORTED_MODULE_10_moment___default()().startOf('day').isAfter(__WEBPACK_IMPORTED_MODULE_10_moment___default()(consentData.enabledTill))?'expired ':''),key:index,onClick:_this.handleRowClick(consentData.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'target-type-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.target_type_label')+':'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,TARGET_TYPE_LABEL_PATH[consentData.targetType])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'target-data-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.target_data_label')+':'},_this.getTargetData(consentData)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'auto-grant-till-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.auto_grant_till_label')+':'},__WEBPACK_IMPORTED_MODULE_10_moment___default()(consentData.enabledTill).format('LL')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'duration-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.duration_label')+':'},_this.getGrantedPeriodDays(consentData.grantedPeriodDays)),_this.props.editingDisabled?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'edit-icon-td',onClick:_this.handleRowClick(consentData.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'create',key:consentData.id,title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.edit_prior_consent_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'remove-icon-td',onClick:_this.handleRemoveIconClick(consentData)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'trash',key:consentData.id,title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.remove_prior_consent_label')})));});};_this.getTargetData=function(consentData){switch(consentData.targetType){case __WEBPACK_IMPORTED_MODULE_9__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].PERSON:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'target-data'},!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(consentData.metadata.firstName)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(consentData.metadata.lastName)?consentData.metadata.firstName+' '+consentData.metadata.lastName+'\n':'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+consentData.targetId},consentData.targetId));case __WEBPACK_IMPORTED_MODULE_9__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].ORGANIZATION:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'target-data'},consentData.targetId);default:return;}};_this.getGrantedPeriodDays=function(periodDays){var label=periodDays===1?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.day_label'):__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.days_label');return periodDays+' '+label;};_this.handleAddButtonClick=function(){_this.setState({redirect:true});};_this.handleRowClick=function(id){return function(){if(_this.props.editingDisabled){return;}_this.setState({selectedPriorConsentId:id});};};_this.handleRemoveIconClick=function(data){return function(e){e.stopPropagation();_this.setState({priorConsentToRemove:data});_this.props.onRemoveIconClick();};};_this.resetPriorConsentToRemove=function(){_this.setState({priorConsentToRemove:null});};_this.state={redirect:false,selectedPriorConsentId:null,priorConsentToRemove:null};return _this;}_createClass(PriorConsentsList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}},{key:'render',value:function render(){if(this.state.redirect){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["d" /* Redirect */],{to:'/add-prior-consent',push:true});}if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.state.selectedPriorConsentId)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["d" /* Redirect */],{to:'/edit-prior-consent?id='+this.state.selectedPriorConsentId,push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prior-consents-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'prior_consents.remove_prior_consent_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'prior_consents.prior_consents_label')),this.props.addingDisabled?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-prior-consent-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleAddButtonClick},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].add_button))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_paginationComponent_PaginationPendingConsents_container__["a" /* default */],null),this.renderTable(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__removePriorConsentModal_RemovePriorConsentModal_container__["a" /* default */],{data:this.state.priorConsentToRemove,onCancelRemoving:this.resetPriorConsentToRemove})));}}]);return PriorConsentsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PriorConsentsList.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,addingDisabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,editingDisabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onRemoveIconClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onUnmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["b"] = (PriorConsentsList);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetPriorConsentByIdFailed */
/* unused harmony export fetchGetPriorConsentByIdSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetPriorConsentById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return onUpdatePriorConsent; });
/* unused harmony export fetchUpdatePriorConsent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return onRemovePriorConsent; });
/* unused harmony export onRemovePriorConsentSuccess */
/* unused harmony export fetchRemovePriorConsent */
/* unused harmony export getPriorConsent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadingPriorConsent; });
/* unused harmony export getPriorConsentData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFormattedPriorConsent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__priorConsents__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__account_login__ = __webpack_require__(17);
//- Actions
var fetchGetPriorConsentByIdFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PRIOR_CONSENT_BY_ID_FAILED');var fetchGetPriorConsentByIdSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PRIOR_CONSENT_BY_ID_SUCCESS');var fetchGetPriorConsentById=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PRIOR_CONSENT_BY_ID',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getPriorConsentById(id);},function(){return{apiCall:true,onSuccess:fetchGetPriorConsentByIdSuccess,onFail:fetchGetPriorConsentByIdFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var onUpdatePriorConsent=function onUpdatePriorConsent(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchUpdatePriorConsent(id,data));};};var fetchUpdatePriorConsent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_UPDATE_PRIOR_CONSENT',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updatePriorConsent(id,data);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});var onRemovePriorConsent=function onRemovePriorConsent(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchRemovePriorConsent(id));};};var onRemovePriorConsentSuccess=function onRemovePriorConsentSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__priorConsents__["e" /* onGetPriorConsents */])());};};var fetchRemovePriorConsent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_PRIOR_CONSENT',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removePriorConsent(id);},function(){return{apiCall:true,onSuccess:onRemovePriorConsentSuccess,onFail:__WEBPACK_IMPORTED_MODULE_3__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_5__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_5__account_login__["l" /* onForbidden */]};});//- State
var initialState={data:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_PRIOR_CONSENT_BY_ID:function FETCH_GET_PRIOR_CONSENT_BY_ID(state){return Object.assign({},state,{data:null,error:null,fetching:true});},FETCH_GET_PRIOR_CONSENT_BY_ID_FAILED:function FETCH_GET_PRIOR_CONSENT_BY_ID_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_PRIOR_CONSENT_BY_ID_SUCCESS:function FETCH_GET_PRIOR_CONSENT_BY_ID_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});}},initialState));//- Selectors
var getPriorConsent=function getPriorConsent(state){return state.priorConsent;};var loadingPriorConsent=function loadingPriorConsent(state){return getPriorConsent(state).fetching;};var getPriorConsentData=function getPriorConsentData(state){return getPriorConsent(state).data;};var getFormattedPriorConsent=function getFormattedPriorConsent(state){var data=getPriorConsentData(state);if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(data)){return null;}return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(data,['targetType','targetId','metadata','enabledTill','grantedPeriodDays','responseComment','createdAt']);};

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelfStudyDetails_css__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelfStudyDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SelfStudyDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_datepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(22);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var requiredSelectFields=['domain'];var ACTION_TYPES={ADD:'add',EDIT:'edit'};var fields=['domain','title','publisher','isbn','studyDate','expose'];var SelfStudyDetails=function(_Component){_inherits(SelfStudyDetails,_Component);function SelfStudyDetails(props){_classCallCheck(this,SelfStudyDetails);var _this=_possibleConstructorReturn(this,(SelfStudyDetails.__proto__||Object.getPrototypeOf(SelfStudyDetails)).call(this,props));_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Form */],{className:'self-study-book-form',onSubmit:_this.handleSubmit},_this.renderFormGroups(),_this.renderStudyDateFormGroup(),_this.renderExposeCheckbox(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn',disabled:_this.saveButtonDisabled()},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,_this.props.actionType===ACTION_TYPES.ADD?__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].add_button:__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button))));};_this.saveButtonDisabled=function(){if(_this.props.actionType===ACTION_TYPES.ADD){return false;}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)){return true;}return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.every(fields,function(field){if(field==='studyDate'){return __WEBPACK_IMPORTED_MODULE_8_moment_moment___default()(_this.props.data[field]).format('L')===__WEBPACK_IMPORTED_MODULE_8_moment_moment___default()(_this.state[field]).format('L');}return _this.props.data.hasOwnProperty(field)?_this.props.data[field]===_this.state[field]:_this.state[field]==='';});};_this.renderFormGroups=function(){var paramsList=[{value:"domain",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'self_study.domain_label'),type:'select',isRequired:true,content:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_6__constants_constants__["f" /* BOOK_DOMAINS */],function(option){return{value:option,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'self_study.domains.'+option),title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'self_study.domains_examples.'+option)};}),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'self_study.domain_select_placeholder'),onChange:_this.handleChangeSelect('domain')},{value:"title",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].title_label),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].title_label)},{value:"publisher",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'self_study.publisher_label'),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'self_study.publisher_label')},{value:"isbn",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'self_study.isbn_label'),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'self_study.isbn_label'),errorMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'self_study.error_messages.isbn_alert')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.getFormGroup=function(params){if(params.type==='select'){return _this.getSelectFormGroup(params);}if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this.renderPopover(params),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.state,params.value),onChange:params.onChange||_this.handleChange(params.value),placeholder:params.placeholder,disabled:params.isDisabled,required:params.isRequired,invalid:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.errors)?false:_this.props.errors.includes(params.value)},params.content),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* FormFeedback */],null,params.errorMessage||'')));};_this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this.renderPopover(params),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];}),options:params.content,onSelect:params.onChange,placeholder:params.placeholder,disabled:params.isDisabled,requiredFieldError:_this.state.requiredFieldError===params.value})));};_this.renderStudyDateFormGroup=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:'study-date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':'study-date',sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'self_study.study_date_label'),'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_datepicker__["a" /* default */],{customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{id:'study-date'}),selected:_this.state.studyDate,showMonthDropdown:true,showYearDropdown:true,dropdownMode:'select',required:true,onChange:_this.handleChangeStudyDate,maxDate:__WEBPACK_IMPORTED_MODULE_8_moment_moment___default()()})));};_this.renderPopover=function(params){switch(params.value){case'isbn':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'self-study-book-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'isbn-hint-icon-container',className:'self-study-book-hint-icon-container',onClick:_this.togglePopover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["H" /* Popover */],{placement:'bottom',isOpen:_this.state.popoverOpen,target:'isbn-hint-icon-container',toggle:_this.togglePopover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["I" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'self_study.isbn_format_hint'))));case'domain':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'self-study-book-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'domain-hint-icon-container',className:'self-study-book-hint-icon-container',onClick:_this.toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'info',className:'info-icon',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["w" /* Modal */],{isOpen:_this.state.modalOpen,className:'domain-hint-modal',toggle:_this.toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'domain-hint-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].examples_label))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["x" /* ModalBody */],null,_this.renderDomainExamplesTable(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:_this.toggleModal},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].okey_button))))));default:return null;}};_this.renderDomainExamplesTable=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["N" /* Table */],{bordered:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_6__constants_constants__["f" /* BOOK_DOMAINS */].slice(0,-1),function(domain,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'domain-column'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'self_study.domains.'+domain)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'self_study.domains_examples.'+domain)));})));};_this.togglePopover=function(){_this.setState({popoverOpen:!_this.state.popoverOpen});};_this.toggleModal=function(){_this.setState({modalOpen:!_this.state.modalOpen});};_this.renderExposeCheckbox=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{check:true,key:'expose',className:'checkbox-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["L" /* Row */],{key:'expose'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{check:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:'checkbox',checked:_this.state.expose,onChange:_this.toggleExpose}),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'self_study.expose_self_study_book_label')))));};_this.handleChangeSelect=function(fieldName){return function(selectedOption){_this.setState(_defineProperty({},fieldName,selectedOption.value));};};_this.handleChange=function(fieldName){return function(e){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.errors)&&_this.props.errors.includes(fieldName)){_this.props.onChangeFieldWithError(fieldName);}_this.setState(_defineProperty({},fieldName,e.target.value));};};_this.handleChangeStudyDate=function(date){_this.setState({studyDate:date});};_this.toggleExpose=function(){_this.setState({expose:!_this.state.expose});};_this.handleSubmit=function(e){e.preventDefault();if(_this.checkRequiredSelectFields()){return;}var data={domain:_this.state.domain,title:_this.state.title,publisher:_this.state.publisher,studyDate:_this.state.studyDate.format("YYYY-MM-DD"),expose:_this.state.expose};if(_this.state.isbn!==''){data.isbn=_this.state.isbn;}switch(_this.props.actionType){case ACTION_TYPES.ADD:_this.props.onProcess(data);break;case ACTION_TYPES.EDIT:_this.props.onProcess(_this.props.id,data);break;default:break;}};_this.resetData=function(){_this.setState({domain:'',title:'',publisher:'',isbn:'',studyDate:__WEBPACK_IMPORTED_MODULE_8_moment_moment___default()(),expose:false});};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(requiredSelectFields,function(field){if(!_this.state[field]&&!error){error=field;}});_this.setState({requiredFieldError:error});return error;};_this.state={domain:'',title:'',publisher:'',isbn:'',studyDate:__WEBPACK_IMPORTED_MODULE_8_moment_moment___default()(),expose:false,requiredFieldError:null,popoverOpen:false,modalOpen:false};return _this;}_createClass(SelfStudyDetails,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.actionType===ACTION_TYPES.EDIT&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.id)){this.props.onMount(this.props.id);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!this.props.success&&nextProps.success&&nextProps.actionType===ACTION_TYPES.ADD){this.resetData();}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(nextProps.data)){this.setState({domain:nextProps.data.domain,title:nextProps.data.title,publisher:nextProps.data.publisher,isbn:nextProps.data.isbn||'',studyDate:__WEBPACK_IMPORTED_MODULE_8_moment_moment___default()(nextProps.data.studyDate),expose:nextProps.data.expose});}}},{key:'render',value:function render(){if(this.props.success){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["d" /* Redirect */],{to:'/self-study-books',push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'self-study-book-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'self_study.'+this.props.actionType+'_self_study_book_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/self-study-books',label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].back_button)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'self-study-book-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'self_study.'+this.props.actionType+'_self_study_book_label')),this.renderContent())));}}]);return SelfStudyDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelfStudyDetails.propTypes={id:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,loading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,actionType:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,success:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,errors:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,onProcess:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,onMount:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onChangeFieldWithError:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["b"] = (SelfStudyDetails);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBulkRequestsJobs; });
/* unused harmony export fetchGetBulkRequestsSuccess */
/* unused harmony export fetchGetBulkRequestsFailed */
/* unused harmony export fetchGetBulkRequestsJobs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return onRemoveBulkConsentRequest; });
/* unused harmony export fetchRemoveBulkConsentRequestSuccess */
/* unused harmony export fetchRemoveBulkConsentRequest */
/* unused harmony export fetchResumeBulkConsentRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return onResumeBulkConsentRequest; });
/* unused harmony export fetchResumeBulkConsentRequestSuccess */
/* unused harmony export getBulkConsentRequests */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadingBulkConsentRequests; });
/* unused harmony export getBulkConsentRequestsData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBulkConsentRequestsFormattedData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_submitForm__ = __webpack_require__(7);
//- Actions
var getBulkRequestsJobs=function getBulkRequestsJobs(){return function(dispatch,getState){var departmentId=Object(__WEBPACK_IMPORTED_MODULE_3__account_role__["k" /* getCurrentGroup */])(getState());if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(departmentId)){dispatch(fetchGetBulkRequestsJobs(departmentId));}};};var fetchGetBulkRequestsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BULK_REQUESTS_JOBS_SUCCESS');var fetchGetBulkRequestsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BULK_REQUESTS_JOBS_FAILED');var fetchGetBulkRequestsJobs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BULK_REQUESTS_JOBS',function(groupId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getBulkRequestsJobs(groupId);},function(){return{apiCall:true,onSuccess:fetchGetBulkRequestsSuccess,onFail:fetchGetBulkRequestsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onRemoveBulkConsentRequest=function onRemoveBulkConsentRequest(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchRemoveBulkConsentRequest(id));};};var fetchRemoveBulkConsentRequestSuccess=function fetchRemoveBulkConsentRequestSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(getBulkRequestsJobs());};};var fetchRemoveBulkConsentRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REMOVE_BULK_CONSENT_REQUEST',function(bulkId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].removeBulkRequestJob(bulkId);},function(){return{apiCall:true,onSuccess:fetchRemoveBulkConsentRequestSuccess,onFail:__WEBPACK_IMPORTED_MODULE_6__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchResumeBulkConsentRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_RESUME_BULK_CONSENT_REQUEST',function(bulkId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].resumeBulkRequestJob(bulkId);},function(){return{apiCall:true,onSuccess:fetchResumeBulkConsentRequestSuccess,onFail:__WEBPACK_IMPORTED_MODULE_6__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var onResumeBulkConsentRequest=function onResumeBulkConsentRequest(id){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchResumeBulkConsentRequest(id));};};var fetchResumeBulkConsentRequestSuccess=function fetchResumeBulkConsentRequestSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(getBulkRequestsJobs());};};//- State
var initialState={data:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_BULK_REQUESTS_JOBS:function FETCH_GET_BULK_REQUESTS_JOBS(state){return Object.assign({},state,{fetching:true,error:null});},FETCH_GET_BULK_REQUESTS_JOBS_SUCCESS:function FETCH_GET_BULK_REQUESTS_JOBS_SUCCESS(state,action){return Object.assign({},state,{fetching:false,error:null,data:action.payload});},FETCH_GET_BULK_REQUESTS_JOBS_FAILED:function FETCH_GET_BULK_REQUESTS_JOBS_FAILED(state,action){return Object.assign({},state,{fetching:false,error:action.payload,data:null});}},initialState));//- Selectors
var getBulkConsentRequests=function getBulkConsentRequests(state){return state.bulkConsentRequests;};var loadingBulkConsentRequests=function loadingBulkConsentRequests(state){return getBulkConsentRequests(state).fetching;};var getBulkConsentRequestsData=function getBulkConsentRequestsData(state){return getBulkConsentRequests(state).data;};var getBulkConsentRequestsFormattedData=function getBulkConsentRequestsFormattedData(state){return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(getBulkConsentRequestsData(state),function(jobData){return{id:jobData.id,processedPersent:Math.floor(jobData.processedEntriesCount/jobData.totalEntriesCount*100),processedEntriesCount:jobData.processedEntriesCount,createdConsentRequestsCount:jobData.createdConsentRequestsCount,totalEntriesCount:jobData.totalEntriesCount,finished:jobData.finished,error:jobData.error,jobTitle:jobData.jobDescription.title,jobReference:jobData.jobDescription.internalReference,requesterEmail:jobData.requester.email,departmentName:jobData.department.name,departmentEmail:jobData.department.email,createdAt:__WEBPACK_IMPORTED_MODULE_5_moment___default()(jobData.createdAt).format("MMMM Do YYYY, HH:mm")};});};

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetOrgsForRequestSuccess */
/* unused harmony export fetchGetOrgsForRequestFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchGetOrgsForRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return resetOrganizations; });
/* unused harmony export fetchGetAGsForRequestSuccess */
/* unused harmony export fetchGetAGsForRequestFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetAGsForRequest; });
/* unused harmony export fetchGetOrgByDomainSuccess */
/* unused harmony export fetchGetOrgByDomainFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetOrgByDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return resetAccreditationGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return resetOrganization; });
/* unused harmony export getAccreditationRequestOrgData */
/* unused harmony export getOrgsForRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAGsForRequestError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getOrgsSelectOptionsForRequests; });
/* unused harmony export getAGsForRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAGsSelectOptionsForRequests; });
/* unused harmony export getOrgByDomainData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getOrgByDomainOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getOrgByDomainCountryOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getOrgByDomainNameOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return loadingOrgByDomain; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_location__ = __webpack_require__(21);
//- Actions
var fetchGetOrgsForRequestSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORGS_FOR_REQUEST_SUCCESS');var fetchGetOrgsForRequestFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORGS_FOR_REQUEST_FAILED');var fetchGetOrgsForRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORGS_FOR_REQUEST',function(country,orgName){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getOrgsForRequest(country,orgName);},function(){return{apiCall:true,onSuccess:fetchGetOrgsForRequestSuccess,onFail:fetchGetOrgsForRequestFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var resetOrganizations=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORGS_FOR_REQUEST');var fetchGetAGsForRequestSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_AGS_FOR_REQUEST_SUCCESS');var fetchGetAGsForRequestFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_AGS_FOR_REQUEST_FAILED');var fetchGetAGsForRequest=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_AGS_FOR_REQUEST',function(orgId){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAGsForRequest(orgId);},function(){return{apiCall:true,onSuccess:fetchGetAGsForRequestSuccess,onFail:fetchGetAGsForRequestFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var fetchGetOrgByDomainSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_BY_DOMAIN_SUCCESS');var fetchGetOrgByDomainFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_BY_DOMAIN_FAILED');var fetchGetOrgByDomain=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_ORG_BY_DOMAIN',function(domain){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getOrgByDomain(domain);},function(){return{apiCall:true,onSuccess:fetchGetOrgByDomainSuccess,onFail:fetchGetOrgByDomainFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});var resetAccreditationGroups=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RESET_ACCREDITATION_GROUPS');var resetOrganization=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RESET_ORGANIZATION');//- State
var initialState={organizations:null,accreditationGroups:null,error:null,fetching:false,organization:null,AGError:null};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_ORGS_FOR_REQUEST:function FETCH_GET_ORGS_FOR_REQUEST(state){return Object.assign({},state,{organizations:null});},FETCH_GET_ORGS_FOR_REQUEST_SUCCESS:function FETCH_GET_ORGS_FOR_REQUEST_SUCCESS(state,action){return Object.assign({},state,{organizations:action.payload});},FETCH_GET_ORGS_FOR_REQUEST_FAILED:function FETCH_GET_ORGS_FOR_REQUEST_FAILED(state,action){return Object.assign({},state,{organizations:null,error:action.payload});},FETCH_GET_AGS_FOR_REQUEST:function FETCH_GET_AGS_FOR_REQUEST(state){return Object.assign({},state,{accreditationGroups:null,AGError:null});},FETCH_GET_AGS_FOR_REQUEST_SUCCESS:function FETCH_GET_AGS_FOR_REQUEST_SUCCESS(state,action){return Object.assign({},state,{accreditationGroups:action.payload,AGError:null});},FETCH_GET_AGS_FOR_REQUEST_FAILED:function FETCH_GET_AGS_FOR_REQUEST_FAILED(state,action){return Object.assign({},state,{accreditationGroups:null,AGError:action.payload});},FETCH_GET_ORG_BY_DOMAIN:function FETCH_GET_ORG_BY_DOMAIN(state){return Object.assign({},state,{organization:null,error:null,fetching:true});},FETCH_GET_ORG_BY_DOMAIN_SUCCESS:function FETCH_GET_ORG_BY_DOMAIN_SUCCESS(state,action){return Object.assign({},state,{organization:action.payload,error:null,fetching:false});},FETCH_GET_ORG_BY_DOMAIN_FAILED:function FETCH_GET_ORG_BY_DOMAIN_FAILED(state,action){return Object.assign({},state,{organization:null,error:action.payload,fetching:false});},RESET_ACCREDITATION_GROUPS:function RESET_ACCREDITATION_GROUPS(state){return Object.assign({},state,{accreditationGroups:null,AGError:null});},RESET_ORGANIZATION:function RESET_ORGANIZATION(state){return Object.assign({},state,{organization:null});}},initialState));//- Selectors
var getAccreditationRequestOrgData=function getAccreditationRequestOrgData(state){return state.accreditationRequestOrgData;};var getOrgsForRequest=function getOrgsForRequest(state){return getAccreditationRequestOrgData(state).organizations;};var getAGsForRequestError=function getAGsForRequestError(state){return getAccreditationRequestOrgData(state).AGError;};var getOrgsSelectOptionsForRequests=function getOrgsSelectOptionsForRequests(state){var data=getOrgsForRequest(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)){return null;}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(data,function(org){return{value:org.id,label:org.name,bavaManaged:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(org.managingOrganizationId)};});};var getAGsForRequest=function getAGsForRequest(state){return getAccreditationRequestOrgData(state).accreditationGroups;};var getAGsSelectOptionsForRequests=function getAGsSelectOptionsForRequests(state){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(getAGsForRequest(state))){return null;}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(getAGsForRequest(state),function(AG){return{value:AG.id,label:AG.name};});};var getOrgByDomainData=function getOrgByDomainData(state){return getAccreditationRequestOrgData(state).organization;};var getOrgByDomainOption=function getOrgByDomainOption(state){var org=getOrgByDomainData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(org)){return null;}return org.id;};var getOrgByDomainCountryOption=function getOrgByDomainCountryOption(state){var org=getOrgByDomainData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(org)){return null;}return{countryCode:org.address.countryCode,continent:Object(__WEBPACK_IMPORTED_MODULE_4__common_location__["c" /* getContinentByCountry */])(org.address.countryCode,state)};};var getOrgByDomainNameOption=function getOrgByDomainNameOption(state){var org=getOrgByDomainData(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(org)){return null;}return org.name;};var loadingOrgByDomain=function loadingOrgByDomain(state){return getAccreditationRequestOrgData(state).fetching;};

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AVAILABLE_ACTIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ValidateDomainModal_css__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ValidateDomainModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ValidateDomainModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reducers_accreditation_validatedDomains__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_domainInput_DomainInput__ = __webpack_require__(63);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _SUBMIT_LABEL_PATH_BY;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var AVAILABLE_ACTIONS={EDIT:'edit',ADD:'add',VALIDATE:'validate'};var SUBMIT_LABEL_PATH_BY_ACTION=(_SUBMIT_LABEL_PATH_BY={},_defineProperty(_SUBMIT_LABEL_PATH_BY,AVAILABLE_ACTIONS.EDIT,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button),_defineProperty(_SUBMIT_LABEL_PATH_BY,AVAILABLE_ACTIONS.ADD,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].add_button),_defineProperty(_SUBMIT_LABEL_PATH_BY,AVAILABLE_ACTIONS.VALIDATE,'accreditation_requests.validate_button'),_SUBMIT_LABEL_PATH_BY);var ADDRESS_FIELDS=['orgCity','orgPostal','orgStreet'];var CONTACT_FIELDS=['contactName','contactEmail','contactPhone'];var ValidateDomainModal=function(_Component){_inherits(ValidateDomainModal,_Component);function ValidateDomainModal(props){_classCallCheck(this,ValidateDomainModal);var _this=_possibleConstructorReturn(this,(ValidateDomainModal.__proto__||Object.getPrototypeOf(ValidateDomainModal)).call(this,props));_this.getOrganizationFormGroup=function(){var paramsList=[{value:'orgType',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.org_type_label')+'*',type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["o" /* ORGANIZATION_TYPES */],function(value){return{code:value.code,name:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,value.name)};})),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'register_org.org_type_placeholder'),isRequired:true,onChange:_this.handleChangeOrgTypeSelect,isDisabled:!!_this.state.fullyRegistered},{value:'orgName',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.name_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.name_label'),isDisabled:!!_this.state.fullyRegistered},{value:'orgDomain',type:'domain',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label)+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label),isDisabled:!!_this.state.fullyRegistered},{value:'orgContinent',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label)+'*',type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),onChange:_this.handleChangeContinent,isRequired:true,isDisabled:!_this.props.continents||!!_this.state.fullyRegistered},{value:'orgCountry',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)+'*',type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isRequired:true,isDisabled:!_this.props.countries||!!_this.state.fullyRegistered},{value:'managedBy',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'validated_domains.managed_by_label'),type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(__WEBPACK_IMPORTED_MODULE_11__reducers_accreditation_validatedDomains__["a" /* AVAILABLE_MANAGED_OPTIONS */]).map(function(value){return{code:value,name:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'validated_domains.'+value+'_label')};}))}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.getAddressFormGroup=function(){var paramsList=[{value:'orgCity',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.city_label'),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.city_label'),isDisabled:!!_this.state.fullyRegistered},{value:'orgPostal',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.postal_label'),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.postal_label'),isDisabled:!!_this.state.fullyRegistered},{value:'orgStreet',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.street_label'),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.street_label'),isDisabled:!!_this.state.fullyRegistered}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.getContactFormGroup=function(){var paramsList=[{value:'contactName',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'validated_domains.contact_name_label'),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'validated_domains.contact_name_label')},{value:'contactEmail',type:'email',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'validated_domains.contact_email_label'),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'validated_domains.contact_email_label')},{value:'contactPhone',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'validated_domains.contact_phone_label'),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'validated_domains.contact_phone_label')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.getFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}switch(params.type){case'select':return _this.getSelectFormGroup(params);case'domain':return _this.getOrganizationDomainFormGroup(params);default:var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:4},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:_this.state[params.value]||'',onChange:params.onChange||_this.handleChange(params.value),placeholder:params.placeholder||params.title,disabled:params.isDisabled,required:params.isRequired},params.content)));}};_this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:4},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];}),options:params.content,onSelect:params.onChange||_this.handleChangeSelect(params.value),placeholder:params.placeholder,disabled:params.isDisabled,requiredFieldError:_this.state.requiredFieldError===params.value})));};_this.getOrganizationDomainFormGroup=function(params){var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:4},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_domainInput_DomainInput__["a" /* default */],{id:id,value:_this.state[params.value],onChange:_this.handleChangeDomainInput,placeholder:params.placeholder||params.title,disabled:params.isDisabled,required:params.isRequired})));};_this.handleChangeDomainInput=function(data){_this.setState({orgDomain:data});};_this.handleChange=function(fieldName){return function(e){_this.setState(_defineProperty({},fieldName,e.target.value));};};_this.handleChangeSelect=function(fieldName){return function(selectedOption){_this.setState(_defineProperty({},fieldName,selectedOption.value));};};_this.handleChangeContinent=function(selectedOption){_this.props.onContinentSet(selectedOption.value);_this.setState({orgCountry:''});};_this.toggleSection=function(sectionKey){return function(){_this.setState(_defineProperty({},sectionKey,!_this.state[sectionKey]));};};_this.handleCancel=function(e){e.preventDefault();_this.cleanState();_this.props.onCancel();if(_this.props.onClose){_this.props.onClose();}};_this.handleSubmit=function(e){e.preventDefault();var data={type:_this.state.orgType,name:_this.state.orgName,domain:_this.state.orgDomain,address:{countryCode:_this.state.orgCountry,city:_this.state.orgCity,postal:_this.state.orgPostal,street:_this.state.orgStreet},contacts:{name:_this.state.contactName,email:_this.state.contactEmail,phone:_this.state.contactPhone}};var bavaManaged=_this.state.managedBy===__WEBPACK_IMPORTED_MODULE_11__reducers_accreditation_validatedDomains__["a" /* AVAILABLE_MANAGED_OPTIONS */].BAVA_MANAGED;_this.props.onSubmit(data,bavaManaged);};_this.cleanState=function(){_this.setState({orgType:__WEBPACK_IMPORTED_MODULE_8__reducers_organization_organizations__["b" /* EDU_ORG */],orgName:'',orgDomain:'',orgContinent:_this.props.continentCode,orgCountry:'',orgCity:'',orgPostal:'',orgStreet:'',contactName:'',contactEmail:'',contactPhone:'',managedBy:__WEBPACK_IMPORTED_MODULE_11__reducers_accreditation_validatedDomains__["a" /* AVAILABLE_MANAGED_OPTIONS */].BAVA_MANAGED,addressSectionOpen:false,contactSectionOpen:false,fullyRegistered:null});};_this.state={orgType:__WEBPACK_IMPORTED_MODULE_8__reducers_organization_organizations__["b" /* EDU_ORG */],orgName:'',orgDomain:'',orgContinent:_this.props.continentCode,orgCountry:'',orgCity:'',orgPostal:'',orgStreet:'',contactName:'',contactEmail:'',contactPhone:'',managedBy:__WEBPACK_IMPORTED_MODULE_11__reducers_accreditation_validatedDomains__["a" /* AVAILABLE_MANAGED_OPTIONS */].BAVA_MANAGED,addressSectionOpen:false,contactSectionOpen:false,fullyRegistered:null};return _this;}_createClass(ValidateDomainModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(this.props.data,nextProps.data)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.data)){this.setState(Object.assign({},nextProps.data));this.props.onContinentSetByCountry(nextProps.data.orgCountry);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.some(ADDRESS_FIELDS,function(field){return!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(nextProps.data[field]);})){this.setState({addressSectionOpen:true});}if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.some(CONTACT_FIELDS,function(field){return!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(nextProps.data[field]);})){this.setState({contactSectionOpen:true});}}if(this.state.orgContinent!==nextProps.continentCode){this.setState({orgContinent:nextProps.continentCode});}if(!this.props.success&&nextProps.success){this.cleanState();this.props.onCancel();this.props.onContinentSet('');if(this.props.onClose){this.props.onClose();}}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'validate-domain-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validate-domain-modal-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'validated_domains.validate_domain_label'))),!!this.state.fullyRegistered?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'warning'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'validated_domains.fully_registered_org_hint')):null,this.getOrganizationFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-label-container olive-green',onClick:this.toggleSection('addressSectionOpen')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'section-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.address_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'keyboard_arrow_'+(this.state.addressSectionOpen?'down':'right')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["i" /* Collapse */],{isOpen:this.state.addressSectionOpen},this.getAddressFormGroup()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-label-container olive-green',onClick:this.toggleSection('contactSectionOpen')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'section-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.contact_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'keyboard_arrow_'+(this.state.contactSectionOpen?'down':'right')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["i" /* Collapse */],{isOpen:this.state.contactSectionOpen},this.getContactFormGroup()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',type:'submit',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,SUBMIT_LABEL_PATH_BY_ACTION[this.props.action]))));}}]);return ValidateDomainModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ValidateDomainModal.propTypes={action:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,continentCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,success:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onContinentSet:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onContinentSetByCountry:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["b"] = (ValidateDomainModal);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DUE_PAYMENTS_MODE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DuePaymentsList_css__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DuePaymentsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DuePaymentsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__wireDataModal_BAWireDataModal_container__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__wireDataModal_UniversityWireDataModal_container__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__duePaymentsConfirmModal_BADuePaymentsConfirmModal_container__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__duePaymentsConfirmModal_UniversityDuePaymentsConfirmModal_container__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__duePaymentsConfirmModal_SystemDuePaymentsConfirmModal_container__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_paginationComponent_PaginationUniversitiesDuePayments_container__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _NO_DATA_LABEL,_NO_FILTER_DATA_LABEL,_NAME_LABEL,_WIRE_DATA_LABEL;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var DUE_PAYMENTS_MODE={BA:"BA",UNI:"UNI",SYSTEM:"SYSTEM"};var NO_DATA_LABEL=(_NO_DATA_LABEL={},_defineProperty(_NO_DATA_LABEL,DUE_PAYMENTS_MODE.BA,"no_ba_s_label"),_defineProperty(_NO_DATA_LABEL,DUE_PAYMENTS_MODE.UNI,"no_uni_s_label"),_defineProperty(_NO_DATA_LABEL,DUE_PAYMENTS_MODE.SYSTEM,"no_payments_for_system"),_NO_DATA_LABEL);var NO_FILTER_DATA_LABEL=(_NO_FILTER_DATA_LABEL={},_defineProperty(_NO_FILTER_DATA_LABEL,DUE_PAYMENTS_MODE.BA,"no_payments_for_ba_s_label"),_defineProperty(_NO_FILTER_DATA_LABEL,DUE_PAYMENTS_MODE.UNI,"no_payments_for_uni_s_label"),_NO_FILTER_DATA_LABEL);var NAME_LABEL=(_NAME_LABEL={},_defineProperty(_NAME_LABEL,DUE_PAYMENTS_MODE.BA,"ba_label"),_defineProperty(_NAME_LABEL,DUE_PAYMENTS_MODE.UNI,"uni_label"),_NAME_LABEL);var WIRE_DATA_LABEL=(_WIRE_DATA_LABEL={},_defineProperty(_WIRE_DATA_LABEL,DUE_PAYMENTS_MODE.BA,"ba_wire_data_label"),_defineProperty(_WIRE_DATA_LABEL,DUE_PAYMENTS_MODE.UNI,"uni_wire_data_label"),_WIRE_DATA_LABEL);var DuePaymentsList=function(_Component){_inherits(DuePaymentsList,_Component);function DuePaymentsList(props){_classCallCheck(this,DuePaymentsList);var _this=_possibleConstructorReturn(this,(DuePaymentsList.__proto__||Object.getPrototypeOf(DuePaymentsList)).call(this,props));_initialiseProps.call(_this);_this.state={currentWireData:null,currentId:null,currentPaidAmount:null,currentName:null};return _this;}_createClass(DuePaymentsList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.props.onUnmount){this.props.onUnmount();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'due-payments-component-container'},this.renderFilter(),this.props.mode===DUE_PAYMENTS_MODE.UNI?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_paginationComponent_PaginationUniversitiesDuePayments_container__["a" /* default */],null):null,this.renderContent(),this.renderWireModal(),this.renderConfirmModal());}},{key:'renderContent',value:function renderContent(){if(this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'due-payments-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.props.data)||this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'due-payments-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'system_payment.'+this.getNoDataLabel())));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["N" /* Table */],{className:'due-payments-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,this.props.mode!==DUE_PAYMENTS_MODE.SYSTEM?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'system_payment.'+NAME_LABEL[this.props.mode])):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'system_payment.amount_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'centered'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'system_payment.total_aggregated_pay_label')),this.props.mode!==DUE_PAYMENTS_MODE.SYSTEM?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'system_payment.'+WIRE_DATA_LABEL[this.props.mode])):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'record-payment-th'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'system_payment.record_payment_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.renderPaymentsData()));}},{key:'renderPaymentsData',value:function renderPaymentsData(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(this.props.data,function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},_this2.props.mode!==DUE_PAYMENTS_MODE.SYSTEM?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'name-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'system_payment.'+NAME_LABEL[_this2.props.mode])+':'},data.name):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'amount-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'system_payment.amount_label')+':'},data.paymentAmount.amount+" "+__WEBPACK_IMPORTED_MODULE_6__constants_constants__["g" /* CURRENCIES */][data.paymentAmount.currency]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'total-pay-td centered','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'system_payment.total_aggregated_pay_label')+':'},_this2.getTotalPayLabel(data.totalPay)),_this2.props.mode!==DUE_PAYMENTS_MODE.SYSTEM?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'wire-data-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'system_payment.'+WIRE_DATA_LABEL[_this2.props.mode])+':'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{color:'link',size:'sm',onClick:_this2.onShowWireDataClick(data.wireData,data.name)},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'system_payment.show_label'))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'record-payment-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'system_payment.record_payment_label')+':'},data.paymentAmount.amount>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{className:'olive-green-btn',size:'sm',onClick:_this2.onPaidButtonClick(data.id,data.name,data.paymentAmount)},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'system_payment.paid_button')):null));});}}]);return DuePaymentsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.renderFilter=function(){switch(_this3.props.mode){case DUE_PAYMENTS_MODE.UNI:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filters-container'},_this3.renderContinentAndCountryFilter(),_this3.renderNameFilter());case DUE_PAYMENTS_MODE.BA:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filters-container'},_this3.renderContinentFilter(),_this3.renderNameFilter());default:return null;}};this.renderNameFilter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'name-label'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this3.props.translation,'system_payment.name_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{className:'name-input',type:'text',value:_this3.props.nameFilter,onChange:_this3.onChangeNameFilter}));};this.onChangeNameFilter=function(e){_this3.props.onUpdateNameFilter(e.target.value);};this.renderWireModal=function(){var props={wireData:_this3.state.currentWireData,name:_this3.state.currentName};switch(_this3.props.mode){case DUE_PAYMENTS_MODE.UNI:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__wireDataModal_UniversityWireDataModal_container__["a" /* default */],props);case DUE_PAYMENTS_MODE.BA:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__wireDataModal_BAWireDataModal_container__["a" /* default */],props);default:return null;}};this.renderConfirmModal=function(){var props={id:_this3.state.currentId,name:_this3.state.currentName,amount:_this3.state.currentPaidAmount};switch(_this3.props.mode){case DUE_PAYMENTS_MODE.UNI:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__duePaymentsConfirmModal_UniversityDuePaymentsConfirmModal_container__["a" /* default */],props);case DUE_PAYMENTS_MODE.BA:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__duePaymentsConfirmModal_BADuePaymentsConfirmModal_container__["a" /* default */],props);case DUE_PAYMENTS_MODE.SYSTEM:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__duePaymentsConfirmModal_SystemDuePaymentsConfirmModal_container__["a" /* default */],props);default:return null;}};this.getNoDataLabel=function(){switch(_this3.props.mode){case DUE_PAYMENTS_MODE.BA:return(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(_this3.props.nameFilter)&&__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(_this3.props.continentFilter)?NO_DATA_LABEL:NO_FILTER_DATA_LABEL)[DUE_PAYMENTS_MODE.BA];case DUE_PAYMENTS_MODE.UNI:return(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(_this3.props.nameFilter)&&__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(_this3.props.continentCode)&&__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(_this3.props.countryFilter)?NO_DATA_LABEL:NO_FILTER_DATA_LABEL)[DUE_PAYMENTS_MODE.UNI];case DUE_PAYMENTS_MODE.SYSTEM:return NO_DATA_LABEL[DUE_PAYMENTS_MODE.SYSTEM];default:return;}};this.getTotalPayLabel=function(totalPay){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(totalPay)){return"-";}return totalPay.map(function(pay){return Math.abs(pay.amount)+" "+__WEBPACK_IMPORTED_MODULE_6__constants_constants__["g" /* CURRENCIES */][pay.currency];}).join(', ');};this.renderContinentFilter=function(){var options=[{value:null,label:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this3.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_13__utils_utils__["a" /* Utils */].getLocationOptions(_this3.props.continents,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this3.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continents))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'continent-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this3.props.translation,'system_payment.filter_by_region_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'continent-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(options,function(option){return option.value===_this3.props.continentFilter;}),options:options,onSelect:_this3.handleChangeContinentFilterSelect}));};this.renderContinentAndCountryFilter=function(){var continentsOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this3.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_13__utils_utils__["a" /* Utils */].getLocationOptions(_this3.props.continents,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this3.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continents))));var countriesOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this3.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_13__utils_utils__["a" /* Utils */].getLocationOptions(_this3.props.countries,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this3.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].countries))));return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'continent-filter-container',key:'continent-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this3.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continent_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'continent-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(continentsOptions,function(option){return option.value===_this3.props.continentCode||__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(option.value)&&__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(_this3.props.continentCode);}),options:continentsOptions,onSelect:_this3.handleChangeContinentSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'country-filter-container',key:'country-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this3.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'country-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(countriesOptions,function(option){return option.value===_this3.props.countryFilter;}),options:countriesOptions,onSelect:_this3.handleChangeCountrySelect}))];};this.handleChangeContinentFilterSelect=function(selectedOption){_this3.props.onChangeContinentFilter(selectedOption.value);};this.handleChangeContinentSelect=function(selectedOption){_this3.props.onSetContinent(selectedOption.value);_this3.props.onChangeCountryFilter(null);};this.handleChangeCountrySelect=function(selectedOption){_this3.props.onChangeCountryFilter(selectedOption.value);};this.onShowWireDataClick=function(wireData,name){return function(){_this3.setState({currentWireData:wireData,currentName:name});_this3.props.onShowWireDataModal();};};this.onPaidButtonClick=function(id,name,paymentAmount){return function(){_this3.setState({currentId:id,currentName:name,currentPaidAmount:paymentAmount});_this3.props.onShowDuePaymentsConfirmModal();};};};DuePaymentsList.propTypes={translation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,mode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,loading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,continentFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,continentCode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,name:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,onMount:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onUnmount:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onShowWireDataModal:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onShowDuePaymentsConfirmModal:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onChangeContinentFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onSetContinent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onChangeCountryFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onUpdateNameFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["b"] = (DuePaymentsList);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DuePaymentsConfirmModal_css__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DuePaymentsConfirmModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DuePaymentsConfirmModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_constants__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DuePaymentsConfirmModal=function(_Component){_inherits(DuePaymentsConfirmModal,_Component);function DuePaymentsConfirmModal(props){_classCallCheck(this,DuePaymentsConfirmModal);var _this=_possibleConstructorReturn(this,(DuePaymentsConfirmModal.__proto__||Object.getPrototypeOf(DuePaymentsConfirmModal)).call(this,props));_this.renderLabel=function(){if(_this.props.name){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'system_payment.due_payment_modal_label').replace('{name}',_this.props.name);}return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,_this.props.label);};_this.handleChangeComment=function(e){_this.setState({comment:e.target.value});};_this.handleChangeAmount=function(e){_this.setState({amount:e.target.value});};_this.handleBlur=function(){var newValue=Number(_this.state.amount);if(Number(newValue)<0){newValue=0;}_this.setState({amount:newValue.toFixed(2)});};_this.handleKeyDown=function(e){if(e.key==='Enter'){e.preventDefault();}};_this.handleSubmit=function(e){e.preventDefault();var data={delta:{amount:_this.state.amount,currency:_this.props.amount.currency}};if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.state.comment)){data.comment=_this.state.comment;}_this.props.onPayDuePayments(_this.props.id,data);};_this.state={amount:'',comment:''};return _this;}_createClass(DuePaymentsConfirmModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!nextProps.isOpen&&this.props.isOpen!==nextProps.isOpen){this.setState({amount:''});}if(nextProps.isOpen&&this.props.isOpen!==nextProps.isOpen){this.setState({amount:nextProps.amount.amount});}}},{key:'render',value:function render(){if(!this.props.id||!this.props.amount){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Form */],{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,this.renderLabel()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:4,className:'modal-label-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'system_payment.amount_label')+'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{type:'number',min:0,max:this.props.amount.amount,step:'any',value:this.state.amount,onChange:this.handleChangeAmount,onBlur:this.handleBlur,onKeyDown:this.handleKeyDown,required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:1,className:'due-payments-modal-currency-col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_6__constants_constants__["g" /* CURRENCIES */][this.props.amount.currency]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{type:'textarea',value:this.state.comment,onChange:this.handleChangeComment,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'finance.balance_change_comment_placeholder')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit',disabled:!this.state.amount||this.state.amount===''},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'system_payment.paid_button'))))));}}]);return DuePaymentsConfirmModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DuePaymentsConfirmModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,amount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onPayDuePayments:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (DuePaymentsConfirmModal);

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(323);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(201);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(205);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(148);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(343);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createEpicMiddleware__ = __webpack_require__(354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__createEpicMiddleware__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionsObservable__ = __webpack_require__(240);
/* unused harmony reexport ActionsObservable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StateObservable__ = __webpack_require__(242);
/* unused harmony reexport StateObservable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__combineEpics__ = __webpack_require__(466);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__combineEpics__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__operators__ = __webpack_require__(241);
/* unused harmony reexport ofType */






/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return empty; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_hostReportError__ = __webpack_require__(149);
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */


var empty = {
    closed: true,
    next: function (value) { },
    error: function (err) {
        if (__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
            throw err;
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_1__util_hostReportError__["a" /* hostReportError */])(err);
        }
    },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isObject;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isObject(x) {
    return x != null && typeof x === 'object';
}
//# sourceMappingURL=isObject.js.map


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnsubscriptionError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function UnsubscriptionErrorImpl(errors) {
    Error.call(this);
    this.message = errors ?
        errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '';
    this.name = 'UnsubscriptionError';
    this.errors = errors;
    return this;
}
UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
var UnsubscriptionError = UnsubscriptionErrorImpl;
//# sourceMappingURL=UnsubscriptionError.js.map


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConnectableObservable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return connectableObservableDescriptor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Subscription__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__operators_refCount__ = __webpack_require__(152);
/** PURE_IMPORTS_START tslib,_Subject,_Observable,_Subscriber,_Subscription,_operators_refCount PURE_IMPORTS_END */






var ConnectableObservable = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._refCount = 0;
        _this._isComplete = false;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function () {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new __WEBPACK_IMPORTED_MODULE_4__Subscription__["a" /* Subscription */]();
            connection.add(this.source
                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = __WEBPACK_IMPORTED_MODULE_4__Subscription__["a" /* Subscription */].EMPTY;
            }
            else {
                this._connection = connection;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_5__operators_refCount__["a" /* refCount */])()(this);
    };
    return ConnectableObservable;
}(__WEBPACK_IMPORTED_MODULE_2__Observable__["a" /* Observable */]));

var connectableProto = ConnectableObservable.prototype;
var connectableObservableDescriptor = {
    operator: { value: null },
    _refCount: { value: 0, writable: true },
    _subject: { value: null, writable: true },
    _connection: { value: null, writable: true },
    _subscribe: { value: connectableProto._subscribe },
    _isComplete: { value: connectableProto._isComplete, writable: true },
    getSubject: { value: connectableProto.getSubject },
    connect: { value: connectableProto.connect },
    refCount: { value: connectableProto.refCount }
};
var ConnectableSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    ConnectableSubscriber.prototype._error = function (err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function () {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    ConnectableSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) {
                connection.unsubscribe();
            }
        }
    };
    return ConnectableSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["b" /* SubjectSubscriber */]));
var RefCountOperator = /*@__PURE__*/ (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=ConnectableObservable.js.map


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubjectSubscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(34);
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */


var SubjectSubscription = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(__WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]));

//# sourceMappingURL=SubjectSubscription.js.map


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export groupBy */
/* unused harmony export GroupedObservable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscription__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Subject__ = __webpack_require__(40);
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription,_Observable,_Subject PURE_IMPORTS_END */





function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function (source) {
        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
var GroupByOperator = /*@__PURE__*/ (function () {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}());
var GroupBySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.elementSelector = elementSelector;
        _this.durationSelector = durationSelector;
        _this.subjectSelector = subjectSelector;
        _this.groups = null;
        _this.attemptedToUnsubscribe = false;
        _this.count = 0;
        return _this;
    }
    GroupBySubscriber.prototype._next = function (value) {
        var key;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function (value, key) {
        var groups = this.groups;
        if (!groups) {
            groups = this.groups = new Map();
        }
        var group = groups.get(key);
        var element;
        if (this.elementSelector) {
            try {
                element = this.elementSelector(value);
            }
            catch (err) {
                this.error(err);
            }
        }
        else {
            element = value;
        }
        if (!group) {
            group = (this.subjectSelector ? this.subjectSelector() : new __WEBPACK_IMPORTED_MODULE_4__Subject__["a" /* Subject */]());
            groups.set(key, group);
            var groupedObservable = new GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new GroupedObservable(key, group));
                }
                catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) {
            group.next(element);
        }
    };
    GroupBySubscriber.prototype._error = function (err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function () {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function (key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) {
                _super.prototype.unsubscribe.call(this);
            }
        }
    };
    return GroupBySubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
var GroupDurationSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        var _this = _super.call(this, group) || this;
        _this.key = key;
        _this.group = group;
        _this.parent = parent;
        return _this;
    }
    GroupDurationSubscriber.prototype._next = function (value) {
        this.complete();
    };
    GroupDurationSubscriber.prototype._unsubscribe = function () {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) {
            parent.removeGroup(key);
        }
    };
    return GroupDurationSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
var GroupedObservable = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.groupSubject = groupSubject;
        _this.refCountSubscription = refCountSubscription;
        return _this;
    }
    GroupedObservable.prototype._subscribe = function (subscriber) {
        var subscription = new __WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */]();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) {
            subscription.add(new InnerRefCountSubscription(refCountSubscription));
        }
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}(__WEBPACK_IMPORTED_MODULE_3__Observable__["a" /* Observable */]));

var InnerRefCountSubscription = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        parent.count++;
        return _this;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function () {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                parent.unsubscribe();
            }
        }
    };
    return InnerRefCountSubscription;
}(__WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */]));
//# sourceMappingURL=groupBy.js.map


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BehaviorSubject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ObjectUnsubscribedError__ = __webpack_require__(117);
/** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */



var BehaviorSubject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) {
            subscriber.next(this._value);
        }
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_2__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        else {
            return this._value;
        }
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]));

//# sourceMappingURL=BehaviorSubject.js.map


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return queue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QueueAction__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QueueScheduler__ = __webpack_require__(358);
/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */


var queue = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__QueueScheduler__["a" /* QueueScheduler */](__WEBPACK_IMPORTED_MODULE_0__QueueAction__["a" /* QueueAction */]);
//# sourceMappingURL=queue.js.map


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scheduler; });
var Scheduler = /*@__PURE__*/ (function () {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = Scheduler.now;
        }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function () { return Date.now(); };
    return Scheduler;
}());

//# sourceMappingURL=Scheduler.js.map


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = observeOn;
/* unused harmony export ObserveOnOperator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObserveOnSubscriber; });
/* unused harmony export ObserveOnMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Notification__ = __webpack_require__(118);
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */



function observeOn(scheduler, delay) {
    if (delay === void 0) {
        delay = 0;
    }
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
var ObserveOnOperator = /*@__PURE__*/ (function () {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}());

var ObserveOnSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(__WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* Notification */].createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(__WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* Notification */].createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(__WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* Notification */].createComplete());
    };
    return ObserveOnSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));

var ObserveOnMessage = /*@__PURE__*/ (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());

//# sourceMappingURL=observeOn.js.map


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeToArray; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var subscribeToArray = function (array) {
    return function (subscriber) {
        for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
            subscriber.next(array[i]);
        }
        if (!subscriber.closed) {
            subscriber.complete();
        }
    };
};
//# sourceMappingURL=subscribeToArray.js.map


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsapAction__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsapScheduler__ = __webpack_require__(361);
/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */


var asap = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__AsapScheduler__["a" /* AsapScheduler */](__WEBPACK_IMPORTED_MODULE_0__AsapAction__["a" /* AsapAction */]);
//# sourceMappingURL=asap.js.map


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeoutError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function TimeoutErrorImpl() {
    Error.call(this);
    this.message = 'Timeout has occurred';
    this.name = 'TimeoutError';
    return this;
}
TimeoutErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
var TimeoutError = TimeoutErrorImpl;
//# sourceMappingURL=TimeoutError.js.map


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeTo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscribeToArray__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__subscribeToPromise__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subscribeToIterable__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscribeToObservable__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArrayLike__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPromise__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isObject__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__symbol_iterator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__symbol_observable__ = __webpack_require__(72);
/** PURE_IMPORTS_START _Observable,_subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */










var subscribeTo = function (result) {
    if (result instanceof __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */]) {
        return function (subscriber) {
            if (result._isScalar) {
                subscriber.next(result.value);
                subscriber.complete();
                return undefined;
            }
            else {
                return result.subscribe(subscriber);
            }
        };
    }
    else if (result && typeof result[__WEBPACK_IMPORTED_MODULE_9__symbol_observable__["a" /* observable */]] === 'function') {
        return Object(__WEBPACK_IMPORTED_MODULE_4__subscribeToObservable__["a" /* subscribeToObservable */])(result);
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_5__isArrayLike__["a" /* isArrayLike */])(result)) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__subscribeToArray__["a" /* subscribeToArray */])(result);
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_6__isPromise__["a" /* isPromise */])(result)) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__subscribeToPromise__["a" /* subscribeToPromise */])(result);
    }
    else if (result && typeof result[__WEBPACK_IMPORTED_MODULE_8__symbol_iterator__["a" /* iterator */]] === 'function') {
        return Object(__WEBPACK_IMPORTED_MODULE_3__subscribeToIterable__["a" /* subscribeToIterable */])(result);
    }
    else {
        var value = Object(__WEBPACK_IMPORTED_MODULE_7__isObject__["a" /* isObject */])(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected."
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        throw new TypeError(msg);
    }
};
//# sourceMappingURL=subscribeTo.js.map


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeToPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hostReportError__ = __webpack_require__(149);
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */

var subscribeToPromise = function (promise) {
    return function (subscriber) {
        promise.then(function (value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function (err) { return subscriber.error(err); })
            .then(null, __WEBPACK_IMPORTED_MODULE_0__hostReportError__["a" /* hostReportError */]);
        return subscriber;
    };
};
//# sourceMappingURL=subscribeToPromise.js.map


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeToIterable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbol_iterator__ = __webpack_require__(94);
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */

var subscribeToIterable = function (iterable) {
    return function (subscriber) {
        var iterator = iterable[__WEBPACK_IMPORTED_MODULE_0__symbol_iterator__["a" /* iterator */]]();
        do {
            var item = iterator.next();
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) {
                break;
            }
        } while (true);
        if (typeof iterator.return === 'function') {
            subscriber.add(function () {
                if (iterator.return) {
                    iterator.return();
                }
            });
        }
        return subscriber;
    };
};
//# sourceMappingURL=subscribeToIterable.js.map


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeToObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbol_observable__ = __webpack_require__(72);
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */

var subscribeToObservable = function (obj) {
    return function (subscriber) {
        var obs = obj[__WEBPACK_IMPORTED_MODULE_0__symbol_observable__["a" /* observable */]]();
        if (typeof obs.subscribe !== 'function') {
            throw new TypeError('Provided object does not correctly implement Symbol.observable');
        }
        else {
            return obs.subscribe(subscriber);
        }
    };
};
//# sourceMappingURL=subscribeToObservable.js.map


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isArrayLike; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
//# sourceMappingURL=isArrayLike.js.map


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
//# sourceMappingURL=isPromise.js.map


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = concatAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeAll__ = __webpack_require__(158);
/** PURE_IMPORTS_START _mergeAll PURE_IMPORTS_END */

function concatAll() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__mergeAll__["a" /* mergeAll */])(1);
}
//# sourceMappingURL=concatAll.js.map


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = merge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isScheduler__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operators_mergeAll__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fromArray__ = __webpack_require__(59);
/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */




function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isScheduler__["a" /* isScheduler */])(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
            concurrent = observables.pop();
        }
    }
    else if (typeof last === 'number') {
        concurrent = observables.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */]) {
        return observables[0];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__operators_mergeAll__["a" /* mergeAll */])(concurrent)(Object(__WEBPACK_IMPORTED_MODULE_3__fromArray__["a" /* fromArray */])(observables, scheduler));
}
//# sourceMappingURL=merge.js.map


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NEVER */
/* unused harmony export never */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_noop__ = __webpack_require__(116);
/** PURE_IMPORTS_START _Observable,_util_noop PURE_IMPORTS_END */


var NEVER = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](__WEBPACK_IMPORTED_MODULE_1__util_noop__["a" /* noop */]);
function never() {
    return NEVER;
}
//# sourceMappingURL=never.js.map


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = race;
/* unused harmony export RaceOperator */
/* unused harmony export RaceSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fromArray__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_util_isArray,_fromArray,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    if (observables.length === 1) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isArray__["a" /* isArray */])(observables[0])) {
            observables = observables[0];
        }
        else {
            return observables[0];
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__fromArray__["a" /* fromArray */])(observables, undefined).lift(new RaceOperator());
}
var RaceOperator = /*@__PURE__*/ (function () {
    function RaceOperator() {
    }
    RaceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}());

var RaceSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasFirst = false;
        _this.observables = [];
        _this.subscriptions = [];
        return _this;
    }
    RaceSubscriber.prototype._next = function (observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            for (var i = 0; i < len && !this.hasFirst; i++) {
                var observable = observables[i];
                var subscription = Object(__WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__["a" /* subscribeToResult */])(this, observable, observable, i);
                if (this.subscriptions) {
                    this.subscriptions.push(subscription);
                }
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for (var i = 0; i < this.subscriptions.length; i++) {
                if (i !== outerIndex) {
                    var subscription = this.subscriptions[i];
                    subscription.unsubscribe();
                    this.remove(subscription);
                }
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));

//# sourceMappingURL=race.js.map


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler_async__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isNumeric__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isScheduler__ = __webpack_require__(47);
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */




function timer(dueTime, periodOrScheduler, scheduler) {
    if (dueTime === void 0) {
        dueTime = 0;
    }
    var period = -1;
    if (Object(__WEBPACK_IMPORTED_MODULE_2__util_isNumeric__["a" /* isNumeric */])(periodOrScheduler)) {
        period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_3__util_isScheduler__["a" /* isScheduler */])(periodOrScheduler)) {
        scheduler = periodOrScheduler;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_3__util_isScheduler__["a" /* isScheduler */])(scheduler)) {
        scheduler = __WEBPACK_IMPORTED_MODULE_1__scheduler_async__["a" /* async */];
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var due = Object(__WEBPACK_IMPORTED_MODULE_2__util_isNumeric__["a" /* isNumeric */])(dueTime)
            ? dueTime
            : (+dueTime - scheduler.now());
        return scheduler.schedule(dispatch, due, {
            index: 0, period: period, subscriber: subscriber
        });
    });
}
function dispatch(state) {
    var index = state.index, period = state.period, subscriber = state.subscriber;
    subscriber.next(index);
    if (subscriber.closed) {
        return;
    }
    else if (period === -1) {
        return subscriber.complete();
    }
    state.index = index + 1;
    this.schedule(state, period);
}
//# sourceMappingURL=timer.js.map


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = audit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_tryCatch__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_errorObject__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new AuditOperator(durationSelector));
    };
}
var AuditOperator = /*@__PURE__*/ (function () {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}());
var AuditSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        return _this;
    }
    AuditSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = Object(__WEBPACK_IMPORTED_MODULE_1__util_tryCatch__["a" /* tryCatch */])(this.durationSelector)(value);
            if (duration === __WEBPACK_IMPORTED_MODULE_2__util_errorObject__["a" /* errorObject */]) {
                this.destination.error(__WEBPACK_IMPORTED_MODULE_2__util_errorObject__["a" /* errorObject */].e);
            }
            else {
                var innerSubscription = Object(__WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__["a" /* subscribeToResult */])(this, duration);
                if (!innerSubscription || innerSubscription.closed) {
                    this.clearThrottle();
                }
                else {
                    this.add(this.throttled = innerSubscription);
                }
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function () {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function () {
        this.clearThrottle();
    };
    return AuditSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=audit.js.map


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = concatMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeMap__ = __webpack_require__(95);
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */

function concatMap(project, resultSelector) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__mergeMap__["a" /* mergeMap */])(project, resultSelector, 1);
}
//# sourceMappingURL=concatMap.js.map


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDate;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
//# sourceMappingURL=isDate.js.map


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = distinctUntilChanged;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_tryCatch__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_errorObject__ = __webpack_require__(46);
/** PURE_IMPORTS_START tslib,_Subscriber,_util_tryCatch,_util_errorObject PURE_IMPORTS_END */




function distinctUntilChanged(compare, keySelector) {
    return function (source) { return source.lift(new DistinctUntilChangedOperator(compare, keySelector)); };
}
var DistinctUntilChangedOperator = /*@__PURE__*/ (function () {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}());
var DistinctUntilChangedSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.hasKey = false;
        if (typeof compare === 'function') {
            _this.compare = compare;
        }
        return _this;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function (value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = Object(__WEBPACK_IMPORTED_MODULE_2__util_tryCatch__["a" /* tryCatch */])(this.keySelector)(value);
            if (key === __WEBPACK_IMPORTED_MODULE_3__util_errorObject__["a" /* errorObject */]) {
                return this.destination.error(__WEBPACK_IMPORTED_MODULE_3__util_errorObject__["a" /* errorObject */].e);
            }
        }
        var result = false;
        if (this.hasKey) {
            result = Object(__WEBPACK_IMPORTED_MODULE_2__util_tryCatch__["a" /* tryCatch */])(this.compare)(this.key, key);
            if (result === __WEBPACK_IMPORTED_MODULE_3__util_errorObject__["a" /* errorObject */]) {
                return this.destination.error(__WEBPACK_IMPORTED_MODULE_3__util_errorObject__["a" /* errorObject */].e);
            }
        }
        else {
            this.hasKey = true;
        }
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=distinctUntilChanged.js.map


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_noop__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isFunction__ = __webpack_require__(89);
/** PURE_IMPORTS_START tslib,_Subscriber,_util_noop,_util_isFunction PURE_IMPORTS_END */




function tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new DoOperator(nextOrObserver, error, complete));
    };
}
var DoOperator = /*@__PURE__*/ (function () {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TapSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}());
var TapSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TapSubscriber, _super);
    function TapSubscriber(destination, observerOrNext, error, complete) {
        var _this = _super.call(this, destination) || this;
        _this._tapNext = __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
        _this._tapError = __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
        _this._tapComplete = __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
        _this._tapError = error || __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
        _this._tapComplete = complete || __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
        if (Object(__WEBPACK_IMPORTED_MODULE_3__util_isFunction__["a" /* isFunction */])(observerOrNext)) {
            _this._context = _this;
            _this._tapNext = observerOrNext;
        }
        else if (observerOrNext) {
            _this._context = observerOrNext;
            _this._tapNext = observerOrNext.next || __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
            _this._tapError = observerOrNext.error || __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
            _this._tapComplete = observerOrNext.complete || __WEBPACK_IMPORTED_MODULE_2__util_noop__["a" /* noop */];
        }
        return _this;
    }
    TapSubscriber.prototype._next = function (value) {
        try {
            this._tapNext.call(this._context, value);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(value);
    };
    TapSubscriber.prototype._error = function (err) {
        try {
            this._tapError.call(this._context, err);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.error(err);
    };
    TapSubscriber.prototype._complete = function () {
        try {
            this._tapComplete.call(this._context);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        return this.destination.complete();
    };
    return TapSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=tap.js.map


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export find */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FindValueOperator; });
/* unused harmony export FindValueSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function find(predicate, thisArg) {
    if (typeof predicate !== 'function') {
        throw new TypeError('predicate is not a function');
    }
    return function (source) { return source.lift(new FindValueOperator(predicate, source, false, thisArg)); };
}
var FindValueOperator = /*@__PURE__*/ (function () {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function (observer, source) {
        return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}());

var FindValueSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.yieldIndex = yieldIndex;
        _this.thisArg = thisArg;
        _this.index = 0;
        return _this;
    }
    FindValueSubscriber.prototype.notifyComplete = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
        this.unsubscribe();
    };
    FindValueSubscriber.prototype._next = function (value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) {
                this.notifyComplete(this.yieldIndex ? index : value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function () {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));

//# sourceMappingURL=find.js.map


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultThrottleConfig; });
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



var defaultThrottleConfig = {
    leading: true,
    trailing: false
};
function throttle(durationSelector, config) {
    if (config === void 0) {
        config = defaultThrottleConfig;
    }
    return function (source) { return source.lift(new ThrottleOperator(durationSelector, config.leading, config.trailing)); };
}
var ThrottleOperator = /*@__PURE__*/ (function () {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}());
var ThrottleSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.durationSelector = durationSelector;
        _this._leading = _leading;
        _this._trailing = _trailing;
        _this._hasValue = false;
        return _this;
    }
    ThrottleSubscriber.prototype._next = function (value) {
        this._hasValue = true;
        this._sendValue = value;
        if (!this._throttled) {
            if (this._leading) {
                this.send();
            }
            else {
                this.throttle(value);
            }
        }
    };
    ThrottleSubscriber.prototype.send = function () {
        var _a = this, _hasValue = _a._hasValue, _sendValue = _a._sendValue;
        if (_hasValue) {
            this.destination.next(_sendValue);
            this.throttle(_sendValue);
        }
        this._hasValue = false;
        this._sendValue = null;
    };
    ThrottleSubscriber.prototype.throttle = function (value) {
        var duration = this.tryDurationSelector(value);
        if (duration) {
            this.add(this._throttled = Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(this, duration));
        }
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
        try {
            return this.durationSelector(value);
        }
        catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    ThrottleSubscriber.prototype.throttlingDone = function () {
        var _a = this, _throttled = _a._throttled, _trailing = _a._trailing;
        if (_throttled) {
            _throttled.unsubscribe();
        }
        this._throttled = null;
        if (_trailing) {
            this.send();
        }
    };
    ThrottleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.throttlingDone();
    };
    ThrottleSubscriber.prototype.notifyComplete = function () {
        this.throttlingDone();
    };
    return ThrottleSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=throttle.js.map


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timeoutWith;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler_async__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isDate__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_1__scheduler_async__["a" /* async */];
    }
    return function (source) {
        var absoluteTimeout = Object(__WEBPACK_IMPORTED_MODULE_2__util_isDate__["a" /* isDate */])(due);
        var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
        return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
var TimeoutWithOperator = /*@__PURE__*/ (function () {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}());
var TimeoutWithSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.absoluteTimeout = absoluteTimeout;
        _this.waitFor = waitFor;
        _this.withObservable = withObservable;
        _this.scheduler = scheduler;
        _this.action = null;
        _this.scheduleTimeout();
        return _this;
    }
    TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add(Object(__WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__["a" /* subscribeToResult */])(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
        var action = this.action;
        if (action) {
            this.action = action.schedule(this, this.waitFor);
        }
        else {
            this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
        }
    };
    TimeoutWithSubscriber.prototype._next = function (value) {
        if (!this.absoluteTimeout) {
            this.scheduleTimeout();
        }
        _super.prototype._next.call(this, value);
    };
    TimeoutWithSubscriber.prototype._unsubscribe = function () {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=timeoutWith.js.map


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionsObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__operators__ = __webpack_require__(241);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ActionsObservable = function (_Observable) {
  _inherits(ActionsObservable, _Observable);

  _createClass(ActionsObservable, null, [{
    key: 'of',
    value: function of() {
      return new this(__WEBPACK_IMPORTED_MODULE_0_rxjs__["e" /* of */].apply(undefined, arguments));
    }
  }, {
    key: 'from',
    value: function from(actions, scheduler) {
      return new this(Object(__WEBPACK_IMPORTED_MODULE_0_rxjs__["c" /* from */])(actions, scheduler));
    }
  }]);

  function ActionsObservable(actionsSubject) {
    _classCallCheck(this, ActionsObservable);

    var _this = _possibleConstructorReturn(this, (ActionsObservable.__proto__ || Object.getPrototypeOf(ActionsObservable)).call(this));

    _this.source = actionsSubject;
    return _this;
  }

  _createClass(ActionsObservable, [{
    key: 'lift',
    value: function lift(operator) {
      var observable = new ActionsObservable(this);
      observable.operator = operator;
      return observable;
    }
  }, {
    key: 'ofType',
    value: function ofType() {
      return __WEBPACK_IMPORTED_MODULE_1__operators__["a" /* ofType */].apply(undefined, arguments)(this);
    }
  }]);

  return ActionsObservable;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs__["a" /* Observable */]);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ofType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operators__ = __webpack_require__(122);


var keyHasType = function keyHasType(type, key) {
  return type === key || typeof key === 'function' && type === key.toString();
};

var ofType = function ofType() {
  for (var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++) {
    keys[_key] = arguments[_key];
  }

  return function (source) {
    return source.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_rxjs_operators__["b" /* filter */])(function (_ref) {
      var type = _ref.type;

      var len = keys.length;
      if (len === 1) {
        return keyHasType(type, keys[0]);
      } else {
        for (var i = 0; i < len; i++) {
          if (keyHasType(type, keys[i])) {
            return true;
          }
        }
      }
      return false;
    }));
  };
};

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StateObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(71);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var StateObservable = function (_Observable) {
  _inherits(StateObservable, _Observable);

  function StateObservable(stateSubject, initialState) {
    _classCallCheck(this, StateObservable);

    var _this = _possibleConstructorReturn(this, (StateObservable.__proto__ || Object.getPrototypeOf(StateObservable)).call(this, function (subscriber) {
      var subscription = _this.__notifier.subscribe(subscriber);
      if (subscription && !subscription.closed) {
        subscriber.next(_this.value);
      }
      return subscription;
    }));

    _this.value = initialState;
    _this.__notifier = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["b" /* Subject */]();
    _this.__subscription = stateSubject.subscribe(function (value) {
      // We only want to update state$ if it has actually changed since
      // redux requires reducers use immutability patterns.
      // This is basically what distinctUntilChanged() does but it's so simple
      // we don't need to pull that code in
      if (value !== _this.value) {
        _this.value = value;
        _this.__notifier.next(value);
      }
    });
    return _this;
  }

  return StateObservable;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs__["a" /* Observable */]);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value.length === 0;
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value.toString();
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return typeof value === 'string';
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value === null || value === undefined;
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelcase__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_camelcase__);


var namespacer = '/';

/* harmony default export */ __webpack_exports__["a"] = (function (type) {
  return type.indexOf(namespacer) === -1 ? __WEBPACK_IMPORTED_MODULE_0_lodash_camelcase___default()(type) : type.split(namespacer).map(function (part) {
    return __WEBPACK_IMPORTED_MODULE_0_lodash_camelcase___default()(part);
  }).join(namespacer);
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMap__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ownKeys__ = __webpack_require__(167);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





function get(key, x) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isMap__["a" /* default */])(x) ? x.get(key) : x[key];
}

/* harmony default export */ __webpack_exports__["a"] = (function (predicate) {
  return function flatten(map) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$namespace = _ref.namespace,
        namespace = _ref$namespace === undefined ? __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_NAMESPACE */] : _ref$namespace,
        prefix = _ref.prefix;

    var partialFlatMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var partialFlatActionType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    function connectNamespace(type) {
      var _ref2;

      if (!partialFlatActionType) return type;
      var types = type.toString().split(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTION_TYPE_DELIMITER */]);
      var partials = partialFlatActionType.split(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTION_TYPE_DELIMITER */]);
      return (_ref2 = []).concat.apply(_ref2, _toConsumableArray(partials.map(function (p) {
        return types.map(function (t) {
          return '' + p + namespace + t;
        });
      }))).join(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTION_TYPE_DELIMITER */]);
    }

    function connectPrefix(type) {
      if (partialFlatActionType || !prefix) {
        return type;
      }

      return '' + prefix + namespace + type;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__ownKeys__["a" /* default */])(map).forEach(function (type) {
      var nextNamespace = connectPrefix(connectNamespace(type));
      var mapValue = get(type, map);

      if (predicate(mapValue)) {
        flatten(mapValue, { namespace: namespace, prefix: prefix }, partialFlatMap, nextNamespace);
      } else {
        partialFlatMap[nextNamespace] = mapValue;
      }
    });

    return partialFlatMap;
  };
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isFunction__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isPlainObject__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_identity__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_isNil__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_isUndefined__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_toString__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(98);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function handleAction(type) {
  var reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_3__utils_identity__["a" /* default */];
  var defaultState = arguments[2];

  var types = Object(__WEBPACK_IMPORTED_MODULE_6__utils_toString__["a" /* default */])(type).split(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* ACTION_TYPE_DELIMITER */]);
  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(!Object(__WEBPACK_IMPORTED_MODULE_5__utils_isUndefined__["a" /* default */])(defaultState), 'defaultState for reducer handling ' + types.join(', ') + ' should be defined');
  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_1__utils_isFunction__["a" /* default */])(reducer) || Object(__WEBPACK_IMPORTED_MODULE_2__utils_isPlainObject__["a" /* default */])(reducer), 'Expected reducer to be a function or object with next and throw reducers');

  var _ref = Object(__WEBPACK_IMPORTED_MODULE_1__utils_isFunction__["a" /* default */])(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_isNil__["a" /* default */])(aReducer) ? __WEBPACK_IMPORTED_MODULE_3__utils_identity__["a" /* default */] : aReducer;
  }),
      _ref2 = _slicedToArray(_ref, 2),
      nextReducer = _ref2[0],
      throwReducer = _ref2[1];

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];
    var actionType = action.type;

    if (!actionType || types.indexOf(Object(__WEBPACK_IMPORTED_MODULE_6__utils_toString__["a" /* default */])(actionType)) === -1) {
      return state;
    }

    return (action.error === true ? throwReducer : nextReducer)(state, action);
  };
}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(77);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(254);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(171);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(512)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 257 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.4
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // Avoid blurry text by using full pixel integers.
  // For pixel-perfect positioning, top/bottom prefers rounded
  // values, while left/right prefers floored values.
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.round(popper.top),
    bottom: Math.round(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(37)))

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dropdown__ = __webpack_require__(103);




var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};

var ButtonDropdown = function ButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    group: true
  }, props));
};

ButtonDropdown.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (ButtonDropdown);

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(2);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(51);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactLifecyclesCompat = __webpack_require__(174);

var _PropTypes = __webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;

    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null // allows for nested Transitions
    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return { status: EXITED };
    }
    return null;
  };

  // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null

  //   if (prevProps !== this.props) {
  //     const { status } = this.state

  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }

  //   return { nextStatus }
  // }

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;


      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var nextStatus = arguments[1];

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func

  // Name the function so it is clearer in the documentation
} : {};function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = (0, _reactLifecyclesCompat.polyfill)(Transition);

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactLifecyclesCompat = __webpack_require__(174);

var _ChildMapping = __webpack_require__(553);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }

  /**
   * The `<TransitionGroup>` component manages a set of `<Transition>` components
   * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
   * state machine for managing the mounting and unmounting of components over
   * time.
   *
   * Consider the example below using the `Fade` CSS transition from before.
   * As items are removed or added to the TodoList the `in` prop is toggled
   * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
   * component in a `<TransitionGroup>`, not just css.
   *
   * ## Example
   *
   * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual `<Transition>`
   * components. This means you can mix and match animations across different
   * list items.
   */
};
var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var handleExited = _this.handleExited.bind(_this);

    // Initial children should all be entering, dependent on appear
    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;

    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);

    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return { children: children };
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = values(this.state.children).map(childFactory);

    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
module.exports = exports['default'];

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func])
};
var defaultProps = {
  tag: 'div'
};

var CardBody = function CardBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      innerRef = props.innerRef,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "innerRef", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-body'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes,
    ref: innerRef
  }));
};

CardBody.propTypes = propTypes;
CardBody.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardBody);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CarouselItem__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);








var Carousel =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Carousel, _React$Component);

  function Carousel(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handleKeyPress = _this.handleKeyPress.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.renderItems = _this.renderItems.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.hoverStart = _this.hoverStart.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.hoverEnd = _this.hoverEnd.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.state = {
      direction: 'right',
      indicatorClicked: false
    };
    return _this;
  }

  var _proto = Carousel.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      direction: this.state.direction
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    // Set up the cycle
    if (this.props.ride === 'carousel') {
      this.setInterval();
    } // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.


    document.addEventListener('keyup', this.handleKeyPress);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setInterval(nextProps); // Calculate the direction to turn

    if (this.props.activeIndex + 1 === nextProps.activeIndex) {
      this.setState({
        direction: 'right'
      });
    } else if (this.props.activeIndex - 1 === nextProps.activeIndex) {
      this.setState({
        direction: 'left'
      });
    } else if (this.props.activeIndex > nextProps.activeIndex) {
      this.setState({
        direction: this.state.indicatorClicked ? 'left' : 'right'
      });
    } else if (this.props.activeIndex !== nextProps.activeIndex) {
      this.setState({
        direction: this.state.indicatorClicked ? 'right' : 'left'
      });
    }

    this.setState({
      indicatorClicked: false
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.clearInterval();
    document.removeEventListener('keyup', this.handleKeyPress);
  };

  _proto.setInterval = function (_setInterval) {
    function setInterval() {
      return _setInterval.apply(this, arguments);
    }

    setInterval.toString = function () {
      return _setInterval.toString();
    };

    return setInterval;
  }(function (props) {
    if (props === void 0) {
      props = this.props;
    }

    // make sure not to have multiple intervals going...
    this.clearInterval();

    if (props.interval) {
      this.cycleInterval = setInterval(function () {
        props.next();
      }, parseInt(props.interval, 10));
    }
  });

  _proto.clearInterval = function (_clearInterval) {
    function clearInterval() {
      return _clearInterval.apply(this, arguments);
    }

    clearInterval.toString = function () {
      return _clearInterval.toString();
    };

    return clearInterval;
  }(function () {
    clearInterval(this.cycleInterval);
  });

  _proto.hoverStart = function hoverStart() {
    if (this.props.pause === 'hover') {
      this.clearInterval();
    }

    if (this.props.mouseEnter) {
      var _this$props;

      (_this$props = this.props).mouseEnter.apply(_this$props, arguments);
    }
  };

  _proto.hoverEnd = function hoverEnd() {
    if (this.props.pause === 'hover') {
      this.setInterval();
    }

    if (this.props.mouseLeave) {
      var _this$props2;

      (_this$props2 = this.props).mouseLeave.apply(_this$props2, arguments);
    }
  };

  _proto.handleKeyPress = function handleKeyPress(evt) {
    if (this.props.keyboard) {
      if (evt.keyCode === 37) {
        this.props.previous();
      } else if (evt.keyCode === 39) {
        this.props.next();
      }
    }
  };

  _proto.renderItems = function renderItems(carouselItems, className) {
    var _this2 = this;

    var slide = this.props.slide;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      role: "listbox",
      className: className
    }, carouselItems.map(function (item, index) {
      var isIn = index === _this2.props.activeIndex;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(item, {
        in: isIn,
        slide: slide
      });
    }));
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props3 = this.props,
        cssModule = _this$props3.cssModule,
        slide = _this$props3.slide,
        className = _this$props3.className;
    var outerClasses = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'carousel', slide && 'slide'), cssModule);
    var innerClasses = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()('carousel-inner'), cssModule); // filter out booleans, null, or undefined

    var children = this.props.children.filter(function (child) {
      return child !== null && child !== undefined && typeof child !== 'boolean';
    });
    var slidesOnly = children.every(function (child) {
      return child.type === __WEBPACK_IMPORTED_MODULE_5__CarouselItem__["a" /* default */];
    }); // Rendering only slides

    if (slidesOnly) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: outerClasses,
        onMouseEnter: this.hoverStart,
        onMouseLeave: this.hoverEnd
      }, this.renderItems(children, innerClasses));
    } // Rendering slides and controls


    if (children[0] instanceof Array) {
      var _carouselItems = children[0];
      var _controlLeft = children[1];
      var _controlRight = children[2];
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: outerClasses,
        onMouseEnter: this.hoverStart,
        onMouseLeave: this.hoverEnd
      }, this.renderItems(_carouselItems, innerClasses), _controlLeft, _controlRight);
    } // Rendering indicators, slides and controls


    var indicators = children[0];

    var wrappedOnClick = function wrappedOnClick(e) {
      if (typeof indicators.props.onClickHandler === 'function') {
        _this3.setState({
          indicatorClicked: true
        }, function () {
          return indicators.props.onClickHandler(e);
        });
      }
    };

    var wrappedIndicators = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(indicators, {
      onClickHandler: wrappedOnClick
    });
    var carouselItems = children[1];
    var controlLeft = children[2];
    var controlRight = children[3];
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      className: outerClasses,
      onMouseEnter: this.hoverStart,
      onMouseLeave: this.hoverEnd
    }, wrappedIndicators, this.renderItems(carouselItems, innerClasses), controlLeft, controlRight);
  };

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Carousel.propTypes = {
  // the current active slide of the carousel
  activeIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  // a function which should advance the carousel to the next slide (via activeIndex)
  next: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  // a function which should advance the carousel to the previous slide (via activeIndex)
  previous: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  // controls if the left and right arrow keys should control the carousel
  keyboard: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
   */
  pause: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['hover', false]),
  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
  ride: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['carousel']),
  // the interval at which the carousel automatically cycles (default: 5000)
  // eslint-disable-next-line react/no-unused-prop-types
  interval: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  // called when the mouse enters the Carousel
  mouseEnter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  // called when the mouse exits the Carousel
  mouseLeave: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  // controls whether the slide animation on the Carousel works or not
  slide: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
Carousel.defaultProps = {
  interval: 5000,
  pause: 'hover',
  keyboard: true,
  slide: true
};
Carousel.childContextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (Carousel);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(9);





var CarouselControl = function CarouselControl(props) {
  var direction = props.direction,
      onClickHandler = props.onClickHandler,
      cssModule = props.cssModule,
      directionText = props.directionText,
      className = props.className;
  var anchorClasses = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, "carousel-control-" + direction), cssModule);
  var iconClasses = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_2_classnames___default()("carousel-control-" + direction + "-icon"), cssModule);
  var screenReaderClasses = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('sr-only'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    className: anchorClasses,
    role: "button",
    tabIndex: "0",
    onClick: function onClick(e) {
      e.preventDefault();
      onClickHandler();
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: iconClasses,
    "aria-hidden": "true"
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: screenReaderClasses
  }, directionText || direction));
};

CarouselControl.propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prev', 'next']).isRequired,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  directionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (CarouselControl);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(9);





var CarouselIndicators = function CarouselIndicators(props) {
  var items = props.items,
      activeIndex = props.activeIndex,
      cssModule = props.cssModule,
      onClickHandler = props.onClickHandler,
      className = props.className;
  var listClasses = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-indicators'), cssModule);
  var indicators = items.map(function (item, idx) {
    var indicatorClasses = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      active: activeIndex === idx
    }), cssModule);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      key: "" + (item.key || Object.values(item).join('')),
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler(idx);
      },
      className: indicatorClasses
    });
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", {
    className: listClasses
  }, indicators);
};

CarouselIndicators.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (CarouselIndicators);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(9);





var CarouselCaption = function CarouselCaption(props) {
  var captionHeader = props.captionHeader,
      captionText = props.captionText,
      cssModule = props.cssModule,
      className = props.className;
  var classes = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: classes
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, captionHeader), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, captionText));
};

CarouselCaption.propTypes = {
  captionHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  captionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (CarouselCaption);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_popper__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(9);











var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  arrowClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  hideArrow: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_10__utils__["t" /* tagPropType */],
  isOpen: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  fallbackPlacement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array]),
  flip: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  container: __WEBPACK_IMPORTED_MODULE_10__utils__["u" /* targetPropType */],
  target: __WEBPACK_IMPORTED_MODULE_10__utils__["u" /* targetPropType */].isRequired,
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  boundariesElement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* DOMElement */]])
};
var defaultProps = {
  boundariesElement: 'scrollParent',
  placement: 'auto',
  hideArrow: false,
  isOpen: false,
  offset: 0,
  fallbackPlacement: 'flip',
  flip: true,
  container: 'body',
  modifiers: {}
};
var childContextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired
};

var PopperContent =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(PopperContent, _React$Component);

  function PopperContent(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handlePlacementChange = _this.handlePlacementChange.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.setTargetNode = _this.setTargetNode.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.getTargetNode = _this.getTargetNode.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.getRef = _this.getRef.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.state = {};
    return _this;
  }

  var _proto = PopperContent.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      popperManager: {
        setTargetNode: this.setTargetNode,
        getTargetNode: this.getTargetNode
      }
    };
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
      this._element.childNodes[0].focus();
    }
  };

  _proto.setTargetNode = function setTargetNode(node) {
    this.targetNode = node;
  };

  _proto.getTargetNode = function getTargetNode() {
    return this.targetNode;
  };

  _proto.getContainerNode = function getContainerNode() {
    return Object(__WEBPACK_IMPORTED_MODULE_10__utils__["n" /* getTarget */])(this.props.container);
  };

  _proto.getRef = function getRef(ref) {
    this._element = ref;
  };

  _proto.handlePlacementChange = function handlePlacementChange(data) {
    if (this.state.placement !== data.placement) {
      this.setState({
        placement: data.placement
      });
    }

    return data;
  };

  _proto.renderChildren = function renderChildren() {
    var _this$props = this.props,
        cssModule = _this$props.cssModule,
        children = _this$props.children,
        isOpen = _this$props.isOpen,
        flip = _this$props.flip,
        target = _this$props.target,
        offset = _this$props.offset,
        fallbackPlacement = _this$props.fallbackPlacement,
        placementPrefix = _this$props.placementPrefix,
        _arrowClassName = _this$props.arrowClassName,
        hideArrow = _this$props.hideArrow,
        className = _this$props.className,
        tag = _this$props.tag,
        container = _this$props.container,
        modifiers = _this$props.modifiers,
        boundariesElement = _this$props.boundariesElement,
        attrs = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["cssModule", "children", "isOpen", "flip", "target", "offset", "fallbackPlacement", "placementPrefix", "arrowClassName", "hideArrow", "className", "tag", "container", "modifiers", "boundariesElement"]);

    var arrowClassName = Object(__WEBPACK_IMPORTED_MODULE_10__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_8_classnames___default()('arrow', _arrowClassName), cssModule);
    var placement = (this.state.placement || attrs.placement).split('-')[0];
    var popperClassName = Object(__WEBPACK_IMPORTED_MODULE_10__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_8_classnames___default()(className, placementPrefix ? placementPrefix + "-" + placement : placement), this.props.cssModule);

    var extendedModifiers = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
      offset: {
        offset: offset
      },
      flip: {
        enabled: flip,
        behavior: fallbackPlacement
      },
      preventOverflow: {
        boundariesElement: boundariesElement
      },
      update: {
        enabled: true,
        order: 950,
        fn: this.handlePlacementChange
      }
    }, modifiers);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_popper__["c" /* Popper */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      modifiers: extendedModifiers
    }, attrs, {
      component: tag,
      className: popperClassName,
      "x-placement": this.state.placement || attrs.placement
    }), children, !hideArrow && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_popper__["a" /* Arrow */], {
      className: arrowClassName
    }));
  };

  _proto.render = function render() {
    this.setTargetNode(Object(__WEBPACK_IMPORTED_MODULE_10__utils__["n" /* getTarget */])(this.props.target));

    if (this.props.isOpen) {
      return this.props.container === 'inline' ? this.renderChildren() : __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.createPortal(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", {
        ref: this.getRef
      }, this.renderChildren()), this.getContainerNode());
    }

    return null;
  };

  return PopperContent;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PopperContent.propTypes = propTypes;
PopperContent.defaultProps = defaultProps;
PopperContent.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (PopperContent);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TooltipPopoverWrapper__ = __webpack_require__(270);




var defaultProps = {
  placement: 'right',
  placementPrefix: 'bs-popover',
  trigger: 'click'
};

var Popover = function Popover(props) {
  var popperClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover', 'show', props.className);
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover-inner', props.innerClassName);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TooltipPopoverWrapper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    className: popperClasses,
    innerClassName: classes
  }));
};

Popover.propTypes = __WEBPACK_IMPORTED_MODULE_3__TooltipPopoverWrapper__["b" /* propTypes */];
Popover.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Popover);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return propTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PopperContent__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);







var propTypes = {
  placement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* PopperPlacements */]),
  target: __WEBPACK_IMPORTED_MODULE_6__utils__["u" /* targetPropType */].isRequired,
  container: __WEBPACK_IMPORTED_MODULE_6__utils__["u" /* targetPropType */],
  isOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  hideArrow: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  boundariesElement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* DOMElement */]]),
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  arrowClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  autohide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  delay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    show: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    hide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  }), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  modifiers: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  innerRef: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object]),
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
};
var DEFAULT_DELAYS = {
  show: 0,
  hide: 250
};
var defaultProps = {
  isOpen: false,
  hideArrow: false,
  autohide: false,
  delay: DEFAULT_DELAYS,
  toggle: function toggle() {},
  trigger: 'click'
};

function isInDOMSubtree(element, subtreeRoot) {
  return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
}

var TooltipPopoverWrapper =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TooltipPopoverWrapper, _React$Component);

  function TooltipPopoverWrapper(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._target = null;
    _this.addTargetEvents = _this.addTargetEvents.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleDocumentClick = _this.handleDocumentClick.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.removeTargetEvents = _this.removeTargetEvents.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.showWithDelay = _this.showWithDelay.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.hideWithDelay = _this.hideWithDelay.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.show = _this.show.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.hide = _this.hide.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onEscKeyDown = _this.onEscKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.getRef = _this.getRef.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = TooltipPopoverWrapper.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateTarget();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeTargetEvents();
  };

  _proto.onMouseOverTooltipContent = function onMouseOverTooltipContent() {
    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
    }
  };

  _proto.onMouseLeaveTooltipContent = function onMouseLeaveTooltipContent(e) {
    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }

      e.persist();
      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
    }
  };

  _proto.onEscKeyDown = function onEscKeyDown(e) {
    if (e.key === 'Escape') {
      this.hide(e);
    }
  };

  _proto.getRef = function getRef(ref) {
    var innerRef = this.props.innerRef;

    if (innerRef) {
      if (typeof innerRef === 'function') {
        innerRef(ref);
      } else if (typeof innerRef === 'object') {
        innerRef.current = ref;
      }
    }

    this._popover = ref;
  };

  _proto.getDelay = function getDelay(key) {
    var delay = this.props.delay;

    if (typeof delay === 'object') {
      return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
    }

    return delay;
  };

  _proto.show = function show(e) {
    if (!this.props.isOpen) {
      this.clearShowTimeout();
      this.toggle(e);
    }
  };

  _proto.showWithDelay = function showWithDelay(e) {
    if (this._hideTimeout) {
      this.clearHideTimeout();
    }

    this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay('show'));
  };

  _proto.hide = function hide(e) {
    if (this.props.isOpen) {
      this.clearHideTimeout();
      this.toggle(e);
    }
  };

  _proto.hideWithDelay = function hideWithDelay(e) {
    if (this._showTimeout) {
      this.clearShowTimeout();
    }

    this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
  };

  _proto.clearShowTimeout = function clearShowTimeout() {
    clearTimeout(this._showTimeout);
    this._showTimeout = undefined;
  };

  _proto.clearHideTimeout = function clearHideTimeout() {
    clearTimeout(this._hideTimeout);
    this._hideTimeout = undefined;
  };

  _proto.handleDocumentClick = function handleDocumentClick(e) {
    var triggers = this.props.trigger.split(' ');

    if (triggers.indexOf('legacy') > -1 && (this.props.isOpen || isInDOMSubtree(e.target, this._target))) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }

      if (this.props.isOpen && !isInDOMSubtree(e.target, this._popover)) {
        this.hideWithDelay(e);
      } else {
        this.showWithDelay(e);
      }
    } else if (triggers.indexOf('click') > -1 && isInDOMSubtree(e.target, this._target)) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }

      if (!this.props.isOpen) {
        this.showWithDelay(e);
      } else {
        this.hideWithDelay(e);
      }
    }
  };

  _proto.addTargetEvents = function addTargetEvents() {
    var _this2 = this;

    if (this.props.trigger) {
      var triggers = this.props.trigger.split(' ');

      if (triggers.indexOf('manual') === -1) {
        if (triggers.indexOf('click') > -1 || triggers.indexOf('legacy') > -1) {
          ['click', 'touchstart'].forEach(function (event) {
            return document.addEventListener(event, _this2.handleDocumentClick, true);
          });
        }

        if (this._target) {
          if (triggers.indexOf('hover') > -1) {
            this._target.addEventListener('mouseover', this.showWithDelay, true);

            this._target.addEventListener('mouseout', this.hideWithDelay, true);
          }

          if (triggers.indexOf('focus') > -1) {
            this._target.addEventListener('focusin', this.show, true);

            this._target.addEventListener('focusout', this.hide, true);
          }

          this._target.addEventListener('keydown', this.onEscKeyDown, true);
        }
      }
    }
  };

  _proto.removeTargetEvents = function removeTargetEvents() {
    var _this3 = this;

    if (this._target) {
      this._target.removeEventListener('mouseover', this.showWithDelay, true);

      this._target.removeEventListener('mouseout', this.hideWithDelay, true);

      this._target.removeEventListener('keydown', this.onEscKeyDown, true);

      this._target.removeEventListener('focusin', this.show, true);

      this._target.removeEventListener('focusout', this.hide, true);
    }

    ['click', 'touchstart'].forEach(function (event) {
      return document.removeEventListener(event, _this3.handleDocumentClick, true);
    });
  };

  _proto.updateTarget = function updateTarget() {
    var newTarget = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["n" /* getTarget */])(this.props.target);

    if (newTarget !== this._target) {
      this.removeTargetEvents();
      this._target = newTarget;
      this.addTargetEvents();
    }
  };

  _proto.toggle = function toggle(e) {
    if (this.props.disabled) {
      return e && e.preventDefault();
    }

    return this.props.toggle(e);
  };

  _proto.render = function render() {
    if (!this.props.isOpen) {
      return null;
    }

    this.updateTarget();
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        innerClassName = _this$props.innerClassName,
        target = _this$props.target,
        isOpen = _this$props.isOpen,
        hideArrow = _this$props.hideArrow,
        boundariesElement = _this$props.boundariesElement,
        placement = _this$props.placement,
        placementPrefix = _this$props.placementPrefix,
        arrowClassName = _this$props.arrowClassName,
        container = _this$props.container,
        modifiers = _this$props.modifiers,
        offset = _this$props.offset;
    var attributes = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["q" /* omit */])(this.props, Object.keys(propTypes));
    var popperClasses = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* mapToCssModules */])(className, cssModule);
    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* mapToCssModules */])(innerClassName, cssModule);
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PopperContent__["a" /* default */], {
      className: popperClasses,
      target: target,
      isOpen: isOpen,
      hideArrow: hideArrow,
      boundariesElement: boundariesElement,
      placement: placement,
      placementPrefix: placementPrefix,
      arrowClassName: arrowClassName,
      container: container,
      modifiers: modifiers,
      offset: offset,
      cssModule: cssModule
    }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      ref: this.getRef,
      className: classes,
      role: "tooltip",
      "aria-hidden": isOpen,
      onMouseOver: this.onMouseOverTooltipContent,
      onMouseLeave: this.onMouseLeaveTooltipContent,
      onKeyDown: this.onEscKeyDown
    })));
  };

  return TooltipPopoverWrapper;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

TooltipPopoverWrapper.propTypes = propTypes;
TooltipPopoverWrapper.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (TooltipPopoverWrapper);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'h3'
};

var PopoverHeader = function PopoverHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'popover-header'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

PopoverHeader.propTypes = propTypes;
PopoverHeader.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (PopoverHeader);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var PopoverBody = function PopoverBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'popover-body'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

PopoverBody.propTypes = propTypes;
PopoverBody.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (PopoverBody);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TooltipPopoverWrapper__ = __webpack_require__(270);




var defaultProps = {
  placement: 'top',
  autohide: true,
  placementPrefix: 'bs-tooltip',
  trigger: 'click hover focus'
};

var Tooltip = function Tooltip(props) {
  var popperClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip', 'show', props.className);
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip-inner', props.innerClassName);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TooltipPopoverWrapper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    className: popperClasses,
    innerClassName: classes
  }));
};

Tooltip.propTypes = __WEBPACK_IMPORTED_MODULE_3__TooltipPopoverWrapper__["b" /* propTypes */];
Tooltip.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputGroupText__ = __webpack_require__(275);







var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  addonType: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var InputGroupAddon = function InputGroupAddon(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      addonType = props.addonType,
      children = props.children,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag", "addonType", "children"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'input-group-' + addonType), cssModule); // Convenience to assist with transition

  if (typeof children === 'string') {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      className: classes
    }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__InputGroupText__["a" /* default */], {
      children: children
    }));
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes,
    children: children
  }));
};

InputGroupAddon.propTypes = propTypes;
InputGroupAddon.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (InputGroupAddon);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'span'
};

var InputGroupText = function InputGroupText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'input-group-text'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

InputGroupText.propTypes = propTypes;
InputGroupText.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (InputGroupText);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Fade__ = __webpack_require__(173);








var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  closeClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  color: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  fade: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  toggle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  tag: __WEBPACK_IMPORTED_MODULE_6__utils__["t" /* tagPropType */],
  transition: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_7__Fade__["a" /* default */].propTypes),
  innerRef: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func])
};
var defaultProps = {
  color: 'success',
  isOpen: true,
  tag: 'div',
  closeAriaLabel: 'Close',
  fade: true,
  transition: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_7__Fade__["a" /* default */].defaultProps, {
    unmountOnExit: true
  })
};

function Alert(props) {
  var className = props.className,
      closeClassName = props.closeClassName,
      closeAriaLabel = props.closeAriaLabel,
      cssModule = props.cssModule,
      Tag = props.tag,
      color = props.color,
      isOpen = props.isOpen,
      toggle = props.toggle,
      children = props.children,
      transition = props.transition,
      fade = props.fade,
      innerRef = props.innerRef,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "closeClassName", "closeAriaLabel", "cssModule", "tag", "color", "isOpen", "toggle", "children", "transition", "fade", "innerRef"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, 'alert', "alert-" + color, {
    'alert-dismissible': toggle
  }), cssModule);
  var closeClasses = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_5_classnames___default()('close', closeClassName), cssModule);

  var alertTransition = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_7__Fade__["a" /* default */].defaultProps, transition, {
    baseClass: fade ? transition.baseClass : '',
    timeout: fade ? transition.timeout : 0
  });

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Fade__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, alertTransition, {
    tag: Tag,
    className: classes,
    in: isOpen,
    role: "alert",
    innerRef: innerRef
  }), toggle ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("button", {
    type: "button",
    className: closeClasses,
    "aria-label": closeAriaLabel,
    onClick: toggle
  }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")) : null, children);
}

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Alert);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(9);






var _transitionStatusToCl;







var propTypes = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"].propTypes, {
  isOpen: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_9__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object])
});

var defaultProps = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"].defaultProps, {
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: __WEBPACK_IMPORTED_MODULE_9__utils__["e" /* TransitionTimeouts */].Collapse
});

var transitionStatusToClassHash = (_transitionStatusToCl = {}, _transitionStatusToCl[__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* TransitionStatuses */].ENTERING] = 'collapsing', _transitionStatusToCl[__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* TransitionStatuses */].ENTERED] = 'collapse show', _transitionStatusToCl[__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* TransitionStatuses */].EXITING] = 'collapsing', _transitionStatusToCl[__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* TransitionStatuses */].EXITED] = 'collapse', _transitionStatusToCl);

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var Collapse =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Collapse, _Component);

  function Collapse(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      height: null
    };
    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
      _this[name] = _this[name].bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    });
    return _this;
  }

  var _proto = Collapse.prototype;

  _proto.onEntering = function onEntering(node, isAppearing) {
    this.setState({
      height: getHeight(node)
    });
    this.props.onEntering(node, isAppearing);
  };

  _proto.onEntered = function onEntered(node, isAppearing) {
    this.setState({
      height: null
    });
    this.props.onEntered(node, isAppearing);
  };

  _proto.onExit = function onExit(node) {
    this.setState({
      height: getHeight(node)
    });
    this.props.onExit(node);
  };

  _proto.onExiting = function onExiting(node) {
    // getting this variable triggers a reflow
    var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars

    this.setState({
      height: 0
    });
    this.props.onExiting(node);
  };

  _proto.onExited = function onExited(node) {
    this.setState({
      height: null
    });
    this.props.onExited(node);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        Tag = _this$props.tag,
        isOpen = _this$props.isOpen,
        className = _this$props.className,
        navbar = _this$props.navbar,
        cssModule = _this$props.cssModule,
        children = _this$props.children,
        innerRef = _this$props.innerRef,
        otherProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["tag", "isOpen", "className", "navbar", "cssModule", "children", "innerRef"]);

    var height = this.state.height;
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["r" /* pick */])(otherProps, __WEBPACK_IMPORTED_MODULE_9__utils__["c" /* TransitionPropTypeKeys */]);
    var childProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["q" /* omit */])(otherProps, __WEBPACK_IMPORTED_MODULE_9__utils__["c" /* TransitionPropTypeKeys */]);
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      in: isOpen,
      onEntering: this.onEntering,
      onEntered: this.onEntered,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }), function (status) {
      var collapseClass = getTransitionClass(status);
      var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
      var style = height === null ? null : {
        height: height
      };
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, childProps, {
        style: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, childProps.style, style),
        className: classes,
        ref: _this2.props.innerRef
      }), children);
    });
  };

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UncontrolledDropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dropdown__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var omitKeys = ['defaultOpen'];

var UncontrolledDropdown =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledDropdown, _Component);

  function UncontrolledDropdown(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = UncontrolledDropdown.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, Object(__WEBPACK_IMPORTED_MODULE_7__utils__["q" /* omit */])(this.props, omitKeys)));
  };

  return UncontrolledDropdown;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);


UncontrolledDropdown.propTypes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
  defaultOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
}, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].propTypes);

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 280 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LanguageSelector_css__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LanguageSelector_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LanguageSelector_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(79);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customStyles={option:function option(provided,state){return Object.assign({},provided,{":hover":{backgroundColor:state.isSelected?'#89aa11':'rgba(137, 170, 17, 0.44)'},backgroundColor:state.isSelected?'#89aa11':'white',cursor:'pointer',width:'60px',paddingTop:'0',paddingBottom:'0'});},control:function control(provided){return Object.assign({},provided,{fontSize:'.9rem',cursor:'pointer',width:'60px',minHeight:'35px',height:'35px',border:'1px solid #aeb0b3',":hover":{border:'1px solid #aeb0b3'},boxShadow:'none'});},dropdownIndicator:function dropdownIndicator(provided){return Object.assign({},provided,{padding:'0 5px 0 0'});},indicatorSeparator:function indicatorSeparator(){return{display:'none'};},menu:function menu(styles){return Object.assign({},styles,{marginTop:'2px',marginBottom:'2p'});},menuList:function menuList(styles){return Object.assign({},styles,{paddingTop:'2px',paddingBottom:'2px'});}};var LanguageSelector=function(_Component){_inherits(LanguageSelector,_Component);function LanguageSelector(props){_classCallCheck(this,LanguageSelector);var _this=_possibleConstructorReturn(this,(LanguageSelector.__proto__||Object.getPrototypeOf(LanguageSelector)).call(this,props));_initialiseProps.call(_this);_this.state={selectedLanguage:props.selectedLanguage};return _this;}_createClass(LanguageSelector,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["b" /* default */],{styles:customStyles,className:'lang-select',isSearchable:false,value:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.props.languageList,function(lang){return lang.value===_this2.state.selectedLanguage;}),onChange:this.handleChange,components:this.getComponents(),options:this.props.languageList});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevState.selectedLanguage!==this.state.selectedLanguage){this.props.onLanguageSelect(this.state.selectedLanguage);}}}]);return LanguageSelector;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.getComponents=function(_){return{Option:function Option(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:props.data.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* components */].Option,props));}};};this.handleChange=function(selectedOption){_this3.setState({selectedLanguage:selectedOption.value});};};LanguageSelector.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,selectedLanguage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,languageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,onLanguageSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (LanguageSelector);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TwoFALoginModal__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_account_login__ = __webpack_require__(17);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_login__["e" /* getIs2FARequired */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),fetching:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_login__["h" /* getLoginFetchingStatus */])(state),error:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_login__["g" /* getLoginError */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_login__["a" /* clean2FARequiredStatus */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_login__["b" /* cleanLoginError */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__TwoFALoginModal__["a" /* default */]));

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchCheckOAuthRequestParamsFailed */
/* unused harmony export fetchCheckOAuthRequestParamsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchCheckOAuthRequestParams; });
/* unused harmony export fetchOAuthGiveAccessFailed */
/* unused harmony export fetchOAuthGiveAccessSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchOAuthGiveAccess; });
/* unused harmony export getOAuth */
/* unused harmony export getOAuthDataToRedirect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getOAuthRedirectTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOAuthLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getOAuthError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getOAuthClientData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_handleApiCall__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
//- Actions
var fetchCheckOAuthRequestParamsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CHECK_OAUTH_REQUEST_PARAMS_FAILED');var fetchCheckOAuthRequestParamsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CHECK_OAUTH_REQUEST_PARAMS_SUCCESS');var fetchCheckOAuthRequestParams=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_CHECK_OAUTH_REQUEST_PARAMS',function(params){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].checkOAuthRequest(params);},function(){return{apiCall:true,onSuccess:fetchCheckOAuthRequestParamsSuccess,onFail:fetchCheckOAuthRequestParamsFailed,type:__WEBPACK_IMPORTED_MODULE_2__common_handleApiCall__["a" /* OAUTH_REQUEST_TYPE */]};});var fetchOAuthGiveAccessFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_OAUTH_GIVE_ACCESS_FAILED');var fetchOAuthGiveAccessSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_OAUTH_GIVE_ACCESS_SUCCESS');var fetchOAuthGiveAccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_OAUTH_GIVE_ACCESS',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].sendOAuthGiveAccess(data);},function(){return{apiCall:true,onSuccess:fetchOAuthGiveAccessSuccess,onFail:fetchOAuthGiveAccessFailed,type:__WEBPACK_IMPORTED_MODULE_2__common_handleApiCall__["a" /* OAUTH_REQUEST_TYPE */]};});//- State
var initialState={requestData:null,dataToRedirect:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_CHECK_OAUTH_REQUEST_PARAMS:function FETCH_CHECK_OAUTH_REQUEST_PARAMS(state){return Object.assign({},state,{requestData:null,error:null,fetching:true});},FETCH_CHECK_OAUTH_REQUEST_PARAMS_FAILED:function FETCH_CHECK_OAUTH_REQUEST_PARAMS_FAILED(state,action){return Object.assign({},state,{requestData:null,error:action.payload,fetching:false});},FETCH_CHECK_OAUTH_REQUEST_PARAMS_SUCCESS:function FETCH_CHECK_OAUTH_REQUEST_PARAMS_SUCCESS(state,action){return Object.assign({},state,{requestData:action.payload,error:null,fetching:false});},FETCH_OAUTH_GIVE_ACCESS:function FETCH_OAUTH_GIVE_ACCESS(state){return Object.assign({},state,{dataToRedirect:null,error:null,fetching:true});},FETCH_OAUTH_GIVE_ACCESS_FAILED:function FETCH_OAUTH_GIVE_ACCESS_FAILED(state,action){return Object.assign({},state,{dataToRedirect:null,error:action.payload,fetching:false});},FETCH_OAUTH_GIVE_ACCESS_SUCCESS:function FETCH_OAUTH_GIVE_ACCESS_SUCCESS(state,action){return Object.assign({},state,{dataToRedirect:action.payload,error:null,fetching:false});}},initialState));//- Selectors
var getOAuth=function getOAuth(state){return state.oauth;};var getOAuthDataToRedirect=function getOAuthDataToRedirect(state){return getOAuth(state).dataToRedirect;};var getOAuthRedirectTo=function getOAuthRedirectTo(state){var requestData=getOAuthClientData(state);var dataToRedirect=getOAuthDataToRedirect(state);if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(requestData)&&requestData.redirectTo){return requestData.redirectTo;}if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(dataToRedirect)&&dataToRedirect.redirectTo){return dataToRedirect.redirectTo;}return null;};var getOAuthLoading=function getOAuthLoading(state){return getOAuth(state).fetching;};var getOAuthError=function getOAuthError(state){return getOAuth(state).error;};var getOAuthClientData=function getOAuthClientData(state){return getOAuth(state).requestData;};

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export onRegisterSuccess */
/* unused harmony export onRegisterApplicant */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchRegisterApplicant; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_localization__ = __webpack_require__(0);
//- Actions
var onRegisterSuccess=function onRegisterSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__login__["k" /* logout */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());};};var onRegisterApplicant=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_REGISTER_APPLICANT',function(language,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].registerApplicant(language,data);},function(){return{apiCall:true,onSuccess:onRegisterSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */]};});var fetchRegisterApplicant=function fetchRegisterApplicant(data){return function(dispatch,getState){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onRegisterApplicant(Object(__WEBPACK_IMPORTED_MODULE_4__common_localization__["d" /* getSelectedLanguage */])(getState()),data));};};

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDIT_MODE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AddAliasModal_css__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AddAliasModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AddAliasModal_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ADD_MODE="add";var EDIT_MODE="edit";var AddAliasModal=function(_Component){_inherits(AddAliasModal,_Component);function AddAliasModal(props){_classCallCheck(this,AddAliasModal);var _this=_possibleConstructorReturn(this,(AddAliasModal.__proto__||Object.getPrototypeOf(AddAliasModal)).call(this,props));_this.getButtonLabel=function(mode){switch(mode){case ADD_MODE:return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'aliases.add_button');case EDIT_MODE:return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'aliases.edit_button');default:return'';}};_this.getSuccessMessage=function(mode){switch(mode){case ADD_MODE:return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'aliases.add_success_message');case EDIT_MODE:return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'aliases.edit_success_message');default:return'';}};_this.renderAliasFormGroups=function(){var paramsList=[{value:"firstName",title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),isRequired:true},{value:"lastName",title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),isRequired:true},{value:"phoneNumber",title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].phone_number_label)},{value:"continentCode",title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label),onChange:_this.handleChangeContinent,type:'select',content:__WEBPACK_IMPORTED_MODULE_5__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continents),__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder)),isDisabled:!_this.props.continents,isRequired:true},{value:"countryCode",title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_5__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].countries),__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder)),isDisabled:!_this.props.countries,isRequired:true}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.getFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:_this.state[params.value],onChange:params.onChange||_this.handleChange(params.value),placeholder:params.title,required:params.isRequired,disabled:params.isDisabled},params.content)));};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleChangeContinent=function(e){_this.props.onContinentSet(e.target.value);_this.setState({countryCode:""});};_this.onCancelHandle=function(){_this.clearData();_this.props.onCancel();_this.props.onContinentSet("");};_this.clearData=function(){_this.setState({firstName:"",lastName:"",phoneNumber:"",countryCode:""});};_this.onSubmit=function(e){e.preventDefault();var data={firstName:_this.state.firstName,lastName:_this.state.lastName,phoneNumber:!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(_this.state.phoneNumber)&&_this.state.phoneNumber!==""?_this.state.phoneNumber:null,countryCode:_this.state.countryCode};switch(_this.props.mode){case ADD_MODE:_this.props.onAdd(data);break;case EDIT_MODE:data["exposePhone"]=_this.props.data.exposePhone;data["exposeEmail"]=_this.props.data.exposeEmail;_this.props.onEdit(_this.props.id,data);break;default:break;}};_this.state={firstName:"",lastName:"",phoneNumber:"",countryCode:""};return _this;}_createClass(AddAliasModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.mode===EDIT_MODE&&nextProps.isOpen&&!this.props.isOpen){this.setState({firstName:nextProps.data.firstName,lastName:nextProps.data.lastName,phoneNumber:nextProps.data.phoneNumber,countryCode:nextProps.data.countryCode});this.props.setCurrentContinentByCountry(nextProps.data.countryCode);}if(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(nextProps.data)&&nextProps.data!==this.props.data||!nextProps.isOpen&&this.props.isOpen){this.clearData();this.props.onContinentSet("");}if(nextProps.continentCode!==this.state.continentCode){this.setState({continentCode:nextProps.continentCode});}}},{key:'render',value:function render(){if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(this.props.mode)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen,toggle:this.onCancelHandle,className:'add-alias-modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:this.getSuccessMessage(this.props.mode)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.onSubmit},this.renderAliasFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.onCancelHandle},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit'},this.getButtonLabel(this.props.mode)))))));}else{return null;}}}]);return AddAliasModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AddAliasModal.propTypes={mode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,continentCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onContinentSet:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setCurrentContinentByCountry:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onAdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["c"] = (AddAliasModal);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetUserSettingsFailed */
/* unused harmony export fetchGetUserSettingsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGetUserSettings; });
/* unused harmony export onUpdateUserSettingsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchUpdateUserSettings; });
/* unused harmony export onUpdateUserSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearUserSettings; });
/* unused harmony export getUserSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUserSettingsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUserSettingsLoading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_login__ = __webpack_require__(17);
//- Actions
var fetchGetUserSettingsFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_USER_SETTINGS_FAILED');var fetchGetUserSettingsSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_USER_SETTINGS_SUCCESS');var fetchGetUserSettings=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_USER_SETTINGS',function(){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getUserSettings();},function(){return{apiCall:true,onSuccess:fetchGetUserSettingsSuccess,onFail:fetchGetUserSettingsFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var onUpdateUserSettingsSuccess=function onUpdateUserSettingsSuccess(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */])());dispatch(fetchGetUserSettings());};};var fetchUpdateUserSettings=function fetchUpdateUserSettings(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(onUpdateUserSettings(data));};};var onUpdateUserSettings=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_UPDATE_USER_SETTINGS',function(data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateUserSettings(data);},function(){return{apiCall:true,onSuccess:onUpdateUserSettingsSuccess,onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var clearUserSettings=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_USER_SETTINGS');//- State
var initialState={fetching:false,data:null};//- Reducers
/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_USER_SETTINGS:function FETCH_GET_USER_SETTINGS(state){return Object.assign({},state,{error:null,fetching:true});},FETCH_GET_USER_SETTINGS_FAILED:function FETCH_GET_USER_SETTINGS_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_USER_SETTINGS_SUCCESS:function FETCH_GET_USER_SETTINGS_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});},CLEAR_USER_SETTINGS:function CLEAR_USER_SETTINGS(state){return Object.assign({},state,{data:null});}},initialState));//- Selectors
var getUserSettings=function getUserSettings(state){return state.userSettings;};var getUserSettingsData=function getUserSettingsData(state){return getUserSettings(state).data;};var getUserSettingsLoading=function getUserSettingsLoading(state){return getUserSettings(state).fetching;};

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};


/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};



/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var math = __webpack_require__(290);

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math.gexp(math.glog(this.get(i) ) + math.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math.glog(this.get(0) ) - math.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math.gexp(math.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

module.exports = QRPolynomial;


/***/ }),
/* 290 */
/***/ (function(module, exports) {

var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

module.exports = QRMath;


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveOrgModal__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["Z" /* MODAL_REMOVE_ORG */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref){var validated=_ref.validated;return{onRemove:function onRemove(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_organization_organizations__["Q" /* onFetchRemoveOrg */])(validated)(id));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RemoveOrgModal__["a" /* default */]));

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputWithPopover__ = __webpack_require__(807);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__InputWithPopover__["a" /* default */]));

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProgressBar__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__ = __webpack_require__(38);
var mapStateToProps=function mapStateToProps(state){return{left:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["D" /* getLeftAccreditationsNumber */])(state),validated:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["F" /* getNumberOfValidatedAccreditations */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__ProgressBar__["a" /* default */]));

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LabelWithPages__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_accreditations__ = __webpack_require__(38);
var mapStateToProps=function mapStateToProps(state){return{left:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_accreditations__["D" /* getLeftAccreditationsNumber */])(state),processed:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_accreditations__["F" /* getNumberOfValidatedAccreditations */])(state),currentIndex:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_accreditations__["B" /* getCurrentAccreditationIndex */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__LabelWithPages__["a" /* default */]));

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ReviewAccreditation_css__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ReviewAccreditation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ReviewAccreditation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__additionalTitle_AdditionalTitle_container__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_progressBar_ProgressBar_container__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__accreditationModal_removeAccreditationModal_RemoveAccreditationModal_container__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__commonComponents_customSelect_CustomSelect__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_cryptoUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__commonComponents_labelWithPages_ProcessAccreditationLabel_container__ = __webpack_require__(294);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var requiredSelectFields=['personCountry'];var ReviewAccreditation=function(_Component){_inherits(ReviewAccreditation,_Component);function ReviewAccreditation(props){_classCallCheck(this,ReviewAccreditation);var _this=_possibleConstructorReturn(this,(ReviewAccreditation.__proto__||Object.getPrototypeOf(ReviewAccreditation)).call(this,props));_this.onMount=function(){_this.setDataFromProps(_this.props.data,_this.props.answer);_this.props.onGetLevels();_this.props.onGetAdditionalLangs();if(_this.props.isBava){_this.props.onGetManagedOrgs();}};_this.setDataFromProps=function(data,answer){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(answer)){var originalData=data;var fieldErrors=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(answer)?answer.fieldErrors:null;var keysArray=["titleOrig","titleEn","level","personFirstName","personLastName","email","personNationalId","orgContinent","orgCountry","orgId"];var state=Object.assign({},_this.getStateValueForArray(keysArray,originalData,fieldErrors),{titlesAdditional:_this.getTitlesAdditional(data.titlesAdditional,fieldErrors),dateIssued:__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.getStateValue("dateIssued",originalData,fieldErrors)),personCountry:_this.getStateValueForCountry(originalData,fieldErrors)});_this.setState(Object.assign({},state,{originalData:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state)}));_this.props.setContinentByCountry(_this.getStateValueForCountry(originalData,fieldErrors));}};_this.getStateValueForArray=function(keysArray,originalData,fieldErrors){var newValues={};keysArray.forEach(function(key){newValues[key]=_this.getStateValue(key,originalData,fieldErrors);});return newValues;};_this.getStateValue=function(key,originalData,fieldErrors){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(fieldErrors)||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(fieldErrors[key])){return originalData[key];}else{return fieldErrors[key].value;}};_this.getStateValueForCountry=function(originalData,fieldErrors){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(fieldErrors)||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(fieldErrors.personCountry)){return originalData.personCountry;}else{return fieldErrors.personCountry.value;}};_this.getTitlesAdditional=function(titles,fieldErrors){var titlesAdditional=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(titles,function(value,key){var titleValue=value;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(fieldErrors[key])){titleValue=fieldErrors[key].value;}titlesAdditional.push({id:__WEBPACK_IMPORTED_MODULE_7_uuid___default()(),lang:key,title:titleValue});});return titlesAdditional;};_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.answer)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Form */],{onSubmit:_this.onSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'next-accreditation-for-review-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'next-accreditation-for-review-button',color:'link',onClick:_this.props.onNext},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.next_accreditation_button'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],null,_this.renderAccreditationMessage()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:7},_this.renderOrganizationFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_label')),_this.renderTitlesFormGroups(),_this.renderAccreditationFormGroups(),_this.renderAdditionalTitlesFormGroups()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.person_label')),_this.renderPersonFormGroups())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{onClick:_this.props.onRemoveAccreditation,className:'review-remove-button',color:'secondary'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submit-button-group'},_this.renderHint(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{type:'submit',className:'review-accreditation-button olive-green-btn'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'review_accreditation.submit_button')))));}else{return null;}};_this.renderHint=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reinsert-accreditation-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'reinsert-accreditation-icon-container',className:'reinsert-accreditation-icon-container',onClick:_this.toggleHint},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["H" /* Popover */],{placement:'bottom',isOpen:_this.state.hintOpen,target:'reinsert-accreditation-icon-container',toggle:_this.toggleHint},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["I" /* PopoverBody */],{className:'reinsert-accreditation-hint-popover-body'},__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'review_accreditation.reinsert_accreditation_button_hint')))));};_this.renderOrganizationFormGroup=function(){if(!_this.props.isBava){return null;}var countries=[{value:null,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getLocationOptions(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].countries))));var proposedCountry=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(countries,function(country){return country.value===__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props,'answer.fieldErrors.orgCountry.value');});var oldCountry=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(countries,function(country){return country.value===_this.props.data.orgCountry;});var countriesByContinent=[{value:null,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.locationData[_this.state.orgContinent],__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].countries))));var paramsList=[{value:"orgContinent",type:"select",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label),content:[{value:null,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].continents)))),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),onChange:_this.handleOrgContinentChange,newField:true,popoverParams:{noPopover:true}},{value:"orgCountry",type:"select",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),content:countriesByContinent,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),newField:true,popoverParams:{proposedValueText:proposedCountry?proposedCountry.label:null,oldValueText:oldCountry?oldCountry.label:null,inputClassName:_this.getInputClassName(_this.props.data.countryCode,_this.fieldErrorsHasValue('orgCountry')?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props,'answer.fieldErrors.orgCountry.value'):null,_this.state.orgCountry),status:_this.getSelectStatus(_this.props.data.countryCode,_this.fieldErrorsHasValue('orgCountry')?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props,'answer.fieldErrors.orgCountry.value'):null,_this.state.orgCountry)}},{value:"orgId",type:"select",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)+'*',content:_this.props.managedOrgs,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)),isDisabled:_this.props.loadingManagedOrgs,isRequired:true,popoverParams:{proposedValueText:_this.state.proposedOrgIdLabel,oldValueText:_this.props.data.orgDomain,inputClassName:_this.getInputClassName(_this.props.data.orgId,_this.fieldErrorsHasValue('orgId')?_this.props.answer.fieldErrors.orgId.value:null,_this.state.orgId),status:_this.getSelectStatus(_this.props.data.orgId,_this.fieldErrorsHasValue('orgId')?_this.props.answer.fieldErrors.orgId.value:null,_this.state.orgId)}}];return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{key:'label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].org_label))].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.handleOrgContinentChange=function(selectedOption){_this.setState({orgContinent:selectedOption.value,orgCountry:null,orgId:null});};_this.renderTitlesFormGroups=function(){var paramsList=[{value:"titleOrig",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_orig_label')+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_orig_input_placeholder')},{value:"titleEn",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_en_label')+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_en_input_placeholder')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderAdditionalTitlesFormGroups=function(){var result=[];var title=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'additional-langs-title',key:'additional-langs-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.additional_translations_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'add',className:'add-additional-title-icon olive-green',onClick:_this.addAdditionalTitle,title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.add_additional_translations_label')})));_this.state.titlesAdditional.forEach(function(elem,id){var popoverParams={id:'additional_title_'+id,key:elem.lang,oldValueText:_this.props.data.titlesAdditional[elem.lang],proposedValueText:_this.fieldErrorsHasValue(elem.lang)?_this.props.answer.fieldErrors[elem.lang].value:null,inputClassName:_this.getInputClassName(_this.props.data.titlesAdditional[elem.lang],_this.fieldErrorsHasValue(elem.lang)?_this.props.answer.fieldErrors[elem.lang].value:null,elem.title),noPopover:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data.titlesAdditional[elem.lang])};result.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__additionalTitle_AdditionalTitle_container__["a" /* default */],{key:elem.id,id:elem.id,lang:elem.lang,title:elem.title,langs:_this.getAvailableLang(elem.id),onChangeLang:_this.handleChangeAdditionalTitleLang,onChangeTitle:_this.handleChangeAdditionalTitle,onRemove:_this.removeAdditionalTitle,inputId:popoverParams.id,inputOnClick:_this.openPopover(elem.lang),inputClassName:popoverParams.inputClassName||_this.getInputClassName(_this.props.data.titlesAdditional[elem.lang],null,elem.title),required:true,autoComplete:'off'}));result.push(_this.renderPopover(popoverParams));});return result.length!==0?[title].concat(result):[title];};_this.renderAccreditationFormGroups=function(){var params={value:"level",type:'select',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.level_label')+"*",isDisabled:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.levels),content:__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getLevelsOptions(_this.props.levels,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels')),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.level_input_placeholder'),popoverParams:{placement:"left",oldValueText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels.'+_this.props.data.level),proposedValueText:_this.fieldErrorsHasValue('level')?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels.'+_this.props.answer.fieldErrors.level.value):null,inputClassName:_this.getInputClassName(_this.props.data.level,_this.fieldErrorsHasValue('level')?_this.props.answer.fieldErrors.level.value:null,_this.state.level),status:_this.getSelectStatus(_this.props.data.level,_this.fieldErrorsHasValue('level')?_this.props.answer.fieldErrors.level.value:null,_this.state.level)}};return[_this.renderDateIssued(),_this.getFormGroup(params)];};_this.renderDateIssued=function(){var className=_this.getInputClassName(_this.props.data.dateIssued.format("YYYY-MM-DD"),_this.fieldErrorsHasValue('dateIssued')?_this.props.answer.fieldErrors.dateIssued.value:null,_this.state.dateIssued.format("YYYY-MM-DD"));var params={placement:"left",oldValueText:_this.props.data.dateIssued.format("L"),proposedValueText:_this.fieldErrorsHasValue('dateIssued')?__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.answer.fieldErrors.dateIssued.value).format("L"):null,id:'date_issued_id',key:'dateIssued'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:'date-issued'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':'date-issued',sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.date_issued_label'),'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:_this.openPopover('dateIssued')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_datepicker__["a" /* default */],{id:params.id,className:className,customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],null),selected:_this.state.dateIssued,showMonthDropdown:true,showYearDropdown:true,dropdownMode:'select',required:true,onChange:_this.handleChangeDate,shouldCloseOnSelect:false,maxDate:__WEBPACK_IMPORTED_MODULE_6_moment___default()()})),_this.renderPopover(params)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:1,className:'question-mark-icon-container',hidden:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(_this.state.dateIssued,_this.props.data.dateIssued)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'question-mark-icon',icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.show_details_label'),onClick:_this.togglePopover(params.key)})));};_this.renderPersonFormGroups=function(){var paramsList=[{value:"personFirstName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)},{value:"personLastName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)},{value:"email",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].isDateHistorical(_this.state.dateIssued)?"":"*"),type:"email",isRequired:!__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].isDateHistorical(_this.state.dateIssued),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)},{value:"personNationalId",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].national_id_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].national_id_label),popoverHintParams:{hintText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.national_id_hint')},formGroupHintText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.national_id_expose_hint')},{value:"personContinent",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label)+"*",type:'select',content:__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),onChange:_this.handleChangeContinent,isDisabled:!_this.props.continents,popoverParams:{inputClassName:"",noPopover:true,status:''}},{value:"personCountry",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)+"*",type:'select',content:__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isDisabled:!_this.props.countries,popoverParams:{placement:"left",oldValueText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].countries+"."+_this.props.data.personCountry),proposedValueText:_this.fieldErrorsHasValue('personCountry')?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].countries+"."+_this.props.answer.fieldErrors.personCountry.value):null,inputClassName:_this.getInputClassName(_this.props.data.personCountry,_this.fieldErrorsHasValue('personCountry')?_this.props.answer.fieldErrors.personCountry.value:null,_this.state.personCountry),status:_this.getSelectStatus(_this.props.data.personCountry,_this.fieldErrorsHasValue('personCountry')?_this.props.answer.fieldErrors.personCountry.value:null,_this.state.personCountry)}}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.getFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id='review_'+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.kebabCase(params.value);var popoverParams=Object.assign({},params.popoverParams,{id:id,key:params.value});var className=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(params.popoverParams)?params.popoverParams.inputClassName:_this.getInputClassName(_this.props.data[params.value],_this.fieldErrorsHasValue(params.value)?_this.props.answer.fieldErrors[params.value].value:null,_this.state[params.value]);var status=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(params.popoverParams)&&!params.newField?params.popoverParams.status:null;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title,_this.renderHintPopover(params.value,params.popoverHintParams)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:8},params.type==='select'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];}),options:params.content,onSelect:params.onChange||_this.handleChangeSelect(params.value),placeholder:params.placeholder,disabled:params.isDisabled,status:status,requiredFieldError:_this.state.requiredFieldError===params.value}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,className:className,value:_this.state[params.value],onChange:params.onChange||_this.handleChange(params.value),placeholder:params.placeholder,disabled:params.isDisabled,required:params.isRequired,autoComplete:'off'}),_this.renderPopover(popoverParams)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:1,className:'question-mark-icon-container',hidden:_this.state[params.value]===_this.props.data[params.value]||_this.state[params.value]===_this.props.continentCode||params.newField},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_iconContainer_IconContainer__["a" /* default */],{onClick:_this.togglePopover(popoverParams.key),className:'question-mark-icon',icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.show_details_label')}))),params.formGroupHintText?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group-hint',key:params.title+"form-group-hint"},params.formGroupHintText):null];};_this.renderHintPopover=function(fieldName,params){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(params)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-accreditation-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:fieldName+'-hint',className:'review-accreditation-hint-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Q" /* UncontrolledPopover */],{trigger:'legacy',placement:'top',target:fieldName+'-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["I" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(params.hintText)))));}};_this.getSelectStatus=function(oldValue,proposedValue,newValue){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(proposedValue)){return oldValue!==newValue?__WEBPACK_IMPORTED_MODULE_18__commonComponents_customSelect_CustomSelect__["a" /* STATUSES */].INFO:null;}else if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(oldValue)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(newValue)){if(proposedValue===''){return oldValue===newValue?__WEBPACK_IMPORTED_MODULE_18__commonComponents_customSelect_CustomSelect__["a" /* STATUSES */].ERROR:__WEBPACK_IMPORTED_MODULE_18__commonComponents_customSelect_CustomSelect__["a" /* STATUSES */].WARNING;}return proposedValue===newValue?__WEBPACK_IMPORTED_MODULE_18__commonComponents_customSelect_CustomSelect__["a" /* STATUSES */].SUCCESS:oldValue===newValue?__WEBPACK_IMPORTED_MODULE_18__commonComponents_customSelect_CustomSelect__["a" /* STATUSES */].ERROR:__WEBPACK_IMPORTED_MODULE_18__commonComponents_customSelect_CustomSelect__["a" /* STATUSES */].WARNING;}else return null;};_this.getInputClassName=function(oldValue,proposedValue,newValue){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(proposedValue)){return oldValue!==newValue?"propose-new-value-for-correct-field":'';}else if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(oldValue)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(newValue)){if(proposedValue===''){return oldValue===newValue?"leave-old-value":"propose-new-value";}return proposedValue===newValue?"agree-with-validator":oldValue===newValue?"leave-old-value":"propose-new-value";}else return'';};_this.renderPopover=function(params){if(_this.fieldErrorsHasValue(params.key)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["H" /* Popover */],{trigger:'focus',placement:params.placement||"top",target:params.id,isOpen:_this.state.openPopover===params.key,toggle:_this.togglePopover(params.key),key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["I" /* PopoverBody */],{className:'popover-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.popover.old_value_label'),': ',params.oldValueText||_this.props.data[params.key]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.popover.proposed_value_label'),': ',params.proposedValueText||_this.props.answer.fieldErrors[params.key].value),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.popover.message_label'),': ',_this.props.answer.fieldErrors[params.key].reason)));}else{if(!params.noPopover){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["H" /* Popover */],{trigger:'focus',placement:params.placement||"top",target:params.id,isOpen:_this.state.openPopover===params.key,toggle:_this.togglePopover(params.key),key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["I" /* PopoverBody */],{className:'popover-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.popover.old_value_label'),': ',params.oldValueText||_this.props.data[params.key])));}}};_this.openPopover=function(key){return function(){if(_this.state.openPopover!==key){_this.setState({openPopover:key});}};};_this.togglePopover=function(key){return function(){if(_this.state.openPopover===key){_this.setState({openPopover:null});}else{_this.setState({openPopover:key});}};};_this.fieldErrorsHasValue=function(value){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(_this.props.answer.fieldErrors,''+value);};_this.renderAccreditationMessage=function(){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.answer.message)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.props.answer.message)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,_this.props.massageLabelPath)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["a" /* Alert */],{className:'alert-warning'},_this.props.answer.message));}};_this.onSubmit=function(e){e.preventDefault();if(_this.checkRequiredSelectFields()){return;}var fieldErrors=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(_this.state.newFieldErrors);if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(fieldErrors,'dateIssued')){fieldErrors.dateIssued.value=fieldErrors.dateIssued.value.format("YYYY-MM-DD");}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(fieldErrors,'orgId')){fieldErrors['orgCountry']={value:_this.state.orgCountry};var org=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this.props.managedOrgs,function(_ref){var value=_ref.value;return value===fieldErrors['orgId'].value;});fieldErrors['orgId']={value:org?org.label:null};}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(fieldErrors,'titlesAdditional')){fieldErrors.titlesAdditional.value.forEach(function(elem){fieldErrors[elem.lang]={value:elem.title};});fieldErrors=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omit(fieldErrors,'titlesAdditional');}var titles={original:_this.state.titleOrig,en:_this.state.titleEn};_this.state.titlesAdditional.forEach(function(elem){if(elem.lang!==""&&elem.title!=="")titles[elem.lang]=elem.title;});var data={accreditationGroupId:_this.props.groupId,accreditationData:{titles:titles,issuedAt:_this.state.dateIssued.format("YYYY-MM-DD"),level:_this.state.level},verifiedIdentity:{firstName:_this.state.personFirstName,lastName:_this.state.personLastName,countryCode:_this.state.personCountry,nationalId:_this.state.personNationalId},answer:{fieldErrors:fieldErrors}};if(_this.state.email){data["email"]=_this.state.email;}if(_this.state.orgId){data.managedOrgId=_this.state.orgId;}if(_this.props.isSigningRequired){_this.props.onSetSubmitFormLoading();__WEBPACK_IMPORTED_MODULE_19__utils_cryptoUtils__["a" /* CryptoUtils */].signAccreditation(_this.props.signingKey,data).then(function(signingData){_this.props.onSubmit(_this.props.id,signingData);});}else{_this.props.onSubmit(_this.props.id,data);}};_this.toggleHint=function(){_this.setState({hintOpen:!_this.state.hintOpen});};_this.handleFieldErrors=function(fieldKey,newValue){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(_this.state.originalData,fieldKey)){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(_this.state.originalData[fieldKey],newValue)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(_this.state.newFieldErrors,fieldKey)){_this.setState({newFieldErrors:Object.assign({},_this.state.newFieldErrors,_defineProperty({},fieldKey,{value:_this.state.originalData[fieldKey]}))});}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(_this.state.originalData[fieldKey],newValue)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(_this.state.newFieldErrors,fieldKey)){_this.setState({newFieldErrors:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omit(_this.state.newFieldErrors,fieldKey)});}}};_this.handleChange=function(fieldKey){return function(e){_this.handleFieldErrors(fieldKey,e.target.value);_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleChangeDate=function(date){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(date)){return;}_this.handleFieldErrors('dateIssued',date);_this.setState({dateIssued:date});};_this.handleChangeContinent=function(selectedOption){_this.setState({personCountry:''});_this.props.onContinentSet(selectedOption.value);};_this.handleChangeSelect=function(fieldKey){return function(selectedOption){_this.handleFieldErrors(fieldKey,selectedOption.value);_this.setState(_defineProperty({},fieldKey,selectedOption.value));};};_this.handleChangeAdditionalTitle=function(id){return function(e){var newTitles=_this.state.titlesAdditional.map(function(elem){if(elem.id===id){elem.title=e.target.value;}return elem;});_this.handleFieldErrors('titlesAdditional',newTitles);_this.setState({titlesAdditional:newTitles});};};_this.handleChangeAdditionalTitleLang=function(id,value){var newTitles=_this.state.titlesAdditional.map(function(elem){if(elem.id===id){elem.lang=value;}return elem;});_this.setState({titlesAdditional:newTitles});};_this.addAdditionalTitle=function(){var newTitle={id:__WEBPACK_IMPORTED_MODULE_7_uuid___default()(),lang:'',title:''};_this.handleFieldErrors('titlesAdditional',[].concat(_toConsumableArray(_this.state.titlesAdditional),[newTitle]));_this.setState({titlesAdditional:[].concat(_toConsumableArray(_this.state.titlesAdditional),[newTitle])});};_this.removeAdditionalTitle=function(id){return function(){var newTitles=_this.state.titlesAdditional.filter(function(elem){return elem.id!==id;});_this.handleFieldErrors('titlesAdditional',newTitles);_this.setState({titlesAdditional:newTitles});};};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(requiredSelectFields,function(field){if(!_this.state[field]&&!error){error=field;}});_this.setState({requiredFieldError:error});return error;};_this.clearState=function(){_this.setState({});};_this.state={titleOrig:'',titleEn:'',titlesAdditional:[],dateIssued:__WEBPACK_IMPORTED_MODULE_6_moment___default()(),level:'',personFirstName:'',personLastName:'',email:'',personContinent:_this.props.continentCode,personCountry:'',personNationalId:'',openPopover:null,requiredFieldError:null,orgContinent:null,orgCountry:null,orgId:null,proposedOrgIdLabel:null,originalData:{},newFieldErrors:{},hintOpen:false};return _this;}_createClass(ReviewAccreditation,[{key:'componentDidMount',value:function componentDidMount(){this.onMount();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onContinentSet('');this.props.onUnmount();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.state.personContinent!==nextProps.continentCode){this.setState({personContinent:nextProps.continentCode});}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(nextProps.id)&&nextProps.id!==this.props.id){this.setState({openPopover:null});this.setDataFromProps(nextProps.data,nextProps.answer);}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(nextProps.data)){this.setDataFromProps(nextProps.data,nextProps.answer);}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(nextProps.data)&&this.props.data.orgId!==nextProps.data.orgId&&nextProps.data.orgId){var originalData=nextProps.data;var fieldErrors=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(nextProps.answer)?nextProps.answer.fieldErrors:null;var orgId=this.getStateValue("orgId",originalData,fieldErrors);this.setState({orgId:orgId,originalData:Object.assign({},this.state.originalData,{orgId:orgId})});}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState,nextContext){var _this2=this;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(nextProps.managedOrgs)&&(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNull(this.state.proposedOrgIdLabel)||// on first accreditation load
!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(nextProps,'answer.fieldErrors.orgId'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props,'answer.fieldErrors.orgId'))||// when switch to next accreditation and id is in list
__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(this.state.proposedOrgIdLabel)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(nextProps.managedOrgs,this.props.managedOrgs)// when switch to next accreditation and necessary orgs was loaded later
)){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(nextProps,'answer.fieldErrors.orgId')){var id=nextProps.answer.fieldErrors.orgId.value;var proposedOrg=nextProps.managedOrgs.find(function(org){return org.value===id;});this.setState({proposedOrgIdLabel:proposedOrg?proposedOrg.label:''});}}if(this.state.orgCountry!==nextState.orgCountry){this.props.onGetManagedOrgs(nextState.orgCountry);}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(this.props.managedOrgs,nextProps.managedOrgs)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(nextProps.managedOrgs)&&this.state.orgId&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.some(nextProps.managedOrgs,function(option){return option.value===_this2.state.orgId;})){this.setState({orgId:null});}}},{key:'render',value:function render(){if(!this.props.loading&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.id)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Redirect */],{to:'/review-accreditations'});}if(this.props.signingKeyLoading||this.props.orgLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}if(this.props.isSigningRequired&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.signingKey)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'review_accreditation.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'carrot-red'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,"insert_accreditation.no_certificate_message_start"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/security'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,"insert_accreditation.no_certificate_message_link")),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,"insert_accreditation.no_certificate_message_end")));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-accreditation-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'review_accreditation.success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/review-accreditations',label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation.back_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'review-accreditation-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__commonComponents_labelWithPages_ProcessAccreditationLabel_container__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'review_accreditation.label')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_progressBar_ProgressBar_container__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'review_accreditation.review_accreditation_progress_label')+":"}),this.renderContent())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__accreditationModal_removeAccreditationModal_RemoveAccreditationModal_container__["a" /* default */],{accreditationId:this.props.id}));}},{key:'getAvailableLang',value:function getAvailableLang(id){var disabledLangs=this.state.titlesAdditional.filter(function(elem){return elem.id!==id;}).map(function(elem){return elem.lang;});return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(this.props.additionalLangs).filter(function(lang){return!disabledLangs.includes(lang);});}}]);return ReviewAccreditation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ReviewAccreditation.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,groupId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,answer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,additionalLangs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,levels:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,continentCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,massageLabelPath:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,signingKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,signingKeyLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isSigningRequired:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,orgLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isBava:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,loadingManagedOrgs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,managedOrgs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onContinentSet:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setContinentByCountry:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetAdditionalLangs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetLevels:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onRemoveAccreditation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onNext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSetSubmitFormLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetOrganization:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetManagedOrgs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ReviewAccreditation);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveAccreditationModal__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_accreditations__ = __webpack_require__(38);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["J" /* MODAL_REMOVE_ACCREDITATION */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAccreditationRemove:function onAccreditationRemove(accreditationId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_accreditations__["n" /* fetchRemoveAccreditation */])(accreditationId));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RemoveAccreditationModal__["a" /* default */]));

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__ = __webpack_require__(38);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["C" /* getCurrentPageForAccreditationsList */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["J" /* getTotalPagesForAccreditationsList */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccreditationGroupsList__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_organization_accreditationGroups__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_accreditationGroup__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{groupId:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_accreditationGroup__["g" /* getAccreditationGroupId */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_accreditationGroups__["i" /* loadingAccreditationGroups */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_accreditationGroups__["e" /* getAccreditationGroupsData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_accreditationGroup__["l" /* setAccreditationGroupId */])(null));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_accreditationGroups__["b" /* fetchGetAccreditationGroups */])());},onAddButtonClick:function onAddButtonClick(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["e" /* MODAL_ADD_ACCREDITATION_GROUP */]}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["j" /* resetSubmitForm */])());},onAccreditationGroupSelect:function onAccreditationGroupSelect(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_accreditationGroup__["l" /* setAccreditationGroupId */])(id));},onAccreditationGroupRemove:function onAccreditationGroupRemove(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["K" /* MODAL_REMOVE_ACCREDITATION_GROUP */]}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["j" /* resetSubmitForm */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AccreditationGroupsList__["a" /* default */]));

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var sax = __webpack_require__(851);
var expat /*= require('node-expat');*/ = { on: function () { }, parse: function () { } };
var helper = __webpack_require__(187);
var isArray = __webpack_require__(188).isArray;

var options;
var pureJsParser = true;
var currentElement;

function validateOptions(userOptions) {
  options = helper.copyOptions(userOptions);
  helper.ensureFlagExists('ignoreDeclaration', options);
  helper.ensureFlagExists('ignoreInstruction', options);
  helper.ensureFlagExists('ignoreAttributes', options);
  helper.ensureFlagExists('ignoreText', options);
  helper.ensureFlagExists('ignoreComment', options);
  helper.ensureFlagExists('ignoreCdata', options);
  helper.ensureFlagExists('ignoreDoctype', options);
  helper.ensureFlagExists('compact', options);
  helper.ensureFlagExists('alwaysChildren', options);
  helper.ensureFlagExists('addParent', options);
  helper.ensureFlagExists('trim', options);
  helper.ensureFlagExists('nativeType', options);
  helper.ensureFlagExists('nativeTypeAttributes', options);
  helper.ensureFlagExists('sanitize', options);
  helper.ensureFlagExists('instructionHasAttributes', options);
  helper.ensureFlagExists('captureSpacesBetweenElements', options);
  helper.ensureAlwaysArrayExists(options);
  helper.ensureKeyExists('declaration', options);
  helper.ensureKeyExists('instruction', options);
  helper.ensureKeyExists('attributes', options);
  helper.ensureKeyExists('text', options);
  helper.ensureKeyExists('comment', options);
  helper.ensureKeyExists('cdata', options);
  helper.ensureKeyExists('doctype', options);
  helper.ensureKeyExists('type', options);
  helper.ensureKeyExists('name', options);
  helper.ensureKeyExists('elements', options);
  helper.ensureKeyExists('parent', options);
  helper.checkFnExists('doctype', options);
  helper.checkFnExists('instruction', options);
  helper.checkFnExists('cdata', options);
  helper.checkFnExists('comment', options);
  helper.checkFnExists('text', options);
  helper.checkFnExists('instructionName', options);
  helper.checkFnExists('elementName', options);
  helper.checkFnExists('attributeName', options);
  helper.checkFnExists('attributeValue', options);
  helper.checkFnExists('attributes', options);
  return options;
}

function nativeType(value) {
  var nValue = Number(value);
  if (!isNaN(nValue)) {
    return nValue;
  }
  var bValue = value.toLowerCase();
  if (bValue === 'true') {
    return true;
  } else if (bValue === 'false') {
    return false;
  }
  return value;
}

function addField(type, value) {
  var key;
  if (options.compact) {
    if (
      !currentElement[options[type + 'Key']] &&
      (isArray(options.alwaysArray) ? options.alwaysArray.indexOf(options[type + 'Key']) !== -1 : options.alwaysArray)
    ) {
      currentElement[options[type + 'Key']] = [];
    }
    if (currentElement[options[type + 'Key']] && !isArray(currentElement[options[type + 'Key']])) {
      currentElement[options[type + 'Key']] = [currentElement[options[type + 'Key']]];
    }
    if (type + 'Fn' in options && typeof value === 'string') {
      value = options[type + 'Fn'](value, currentElement);
    }
    if (type === 'instruction' && ('instructionFn' in options || 'instructionNameFn' in options)) {
      for (key in value) {
        if (value.hasOwnProperty(key)) {
          if ('instructionFn' in options) {
            value[key] = options.instructionFn(value[key], key, currentElement);
          } else {
            var temp = value[key];
            delete value[key];
            value[options.instructionNameFn(key, temp, currentElement)] = temp;
          }
        }
      }
    }
    if (isArray(currentElement[options[type + 'Key']])) {
      currentElement[options[type + 'Key']].push(value);
    } else {
      currentElement[options[type + 'Key']] = value;
    }
  } else {
    if (!currentElement[options.elementsKey]) {
      currentElement[options.elementsKey] = [];
    }
    var element = {};
    element[options.typeKey] = type;
    if (type === 'instruction') {
      for (key in value) {
        if (value.hasOwnProperty(key)) {
          break;
        }
      }
      element[options.nameKey] = 'instructionNameFn' in options ? options.instructionNameFn(key, value, currentElement) : key;
      if (options.instructionHasAttributes) {
        element[options.attributesKey] = value[key][options.attributesKey];
        if ('instructionFn' in options) {
          element[options.attributesKey] = options.instructionFn(element[options.attributesKey], key, currentElement);
        }
      } else {
        if ('instructionFn' in options) {
          value[key] = options.instructionFn(value[key], key, currentElement);
        }
        element[options.instructionKey] = value[key];
      }
    } else {
      if (type + 'Fn' in options) {
        value = options[type + 'Fn'](value, currentElement);
      }
      element[options[type + 'Key']] = value;
    }
    if (options.addParent) {
      element[options.parentKey] = currentElement;
    }
    currentElement[options.elementsKey].push(element);
  }
}

function manipulateAttributes(attributes) {
  if ('attributesFn' in options && attributes) {
    attributes = options.attributesFn(attributes, currentElement);
  }
  if ((options.trim || 'attributeValueFn' in options || 'attributeNameFn' in options || options.nativeTypeAttributes) && attributes) {
    var key;
    for (key in attributes) {
      if (attributes.hasOwnProperty(key)) {
        if (options.trim) attributes[key] = attributes[key].trim();
        if (options.nativeTypeAttributes) {
          attributes[key] = nativeType(attributes[key]);
        }
        if ('attributeValueFn' in options) attributes[key] = options.attributeValueFn(attributes[key], key, currentElement);
        if ('attributeNameFn' in options) {
          var temp = attributes[key];
          delete attributes[key];
          attributes[options.attributeNameFn(key, attributes[key], currentElement)] = temp;
        }
      }
    }
  }
  return attributes;
}

function onInstruction(instruction) {
  var attributes = {};
  if (instruction.body && (instruction.name.toLowerCase() === 'xml' || options.instructionHasAttributes)) {
    var attrsRegExp = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|(\w+))\s*/g;
    var match;
    while ((match = attrsRegExp.exec(instruction.body)) !== null) {
      attributes[match[1]] = match[2] || match[3] || match[4];
    }
    attributes = manipulateAttributes(attributes);
  }
  if (instruction.name.toLowerCase() === 'xml') {
    if (options.ignoreDeclaration) {
      return;
    }
    currentElement[options.declarationKey] = {};
    if (Object.keys(attributes).length) {
      currentElement[options.declarationKey][options.attributesKey] = attributes;
    }
    if (options.addParent) {
      currentElement[options.declarationKey][options.parentKey] = currentElement;
    }
  } else {
    if (options.ignoreInstruction) {
      return;
    }
    if (options.trim) {
      instruction.body = instruction.body.trim();
    }
    var value = {};
    if (options.instructionHasAttributes && Object.keys(attributes).length) {
      value[instruction.name] = {};
      value[instruction.name][options.attributesKey] = attributes;
    } else {
      value[instruction.name] = instruction.body;
    }
    addField('instruction', value);
  }
}

function onStartElement(name, attributes) {
  var element;
  if (typeof name === 'object') {
    attributes = name.attributes;
    name = name.name;
  }
  attributes = manipulateAttributes(attributes);
  if ('elementNameFn' in options) {
    name = options.elementNameFn(name, currentElement);
  }
  if (options.compact) {
    element = {};
    if (!options.ignoreAttributes && attributes && Object.keys(attributes).length) {
      element[options.attributesKey] = {};
      var key;
      for (key in attributes) {
        if (attributes.hasOwnProperty(key)) {
          element[options.attributesKey][key] = attributes[key];
        }
      }
    }
    if (
      !(name in currentElement) &&
      (isArray(options.alwaysArray) ? options.alwaysArray.indexOf(name) !== -1 : options.alwaysArray)
    ) {
      currentElement[name] = [];
    }
    if (currentElement[name] && !isArray(currentElement[name])) {
      currentElement[name] = [currentElement[name]];
    }
    if (isArray(currentElement[name])) {
      currentElement[name].push(element);
    } else {
      currentElement[name] = element;
    }
  } else {
    if (!currentElement[options.elementsKey]) {
      currentElement[options.elementsKey] = [];
    }
    element = {};
    element[options.typeKey] = 'element';
    element[options.nameKey] = name;
    if (!options.ignoreAttributes && attributes && Object.keys(attributes).length) {
      element[options.attributesKey] = attributes;
    }
    if (options.alwaysChildren) {
      element[options.elementsKey] = [];
    }
    currentElement[options.elementsKey].push(element);
  }
  element[options.parentKey] = currentElement; // will be deleted in onEndElement() if !options.addParent
  currentElement = element;
}

function onText(text) {
  if (options.ignoreText) {
    return;
  }
  if (!text.trim() && !options.captureSpacesBetweenElements) {
    return;
  }
  if (options.trim) {
    text = text.trim();
  }
  if (options.nativeType) {
    text = nativeType(text);
  }
  if (options.sanitize) {
    text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  addField('text', text);
}

function onComment(comment) {
  if (options.ignoreComment) {
    return;
  }
  if (options.trim) {
    comment = comment.trim();
  }
  addField('comment', comment);
}

function onEndElement(name) {
  var parentElement = currentElement[options.parentKey];
  if (!options.addParent) {
    delete currentElement[options.parentKey];
  }
  currentElement = parentElement;
}

function onCdata(cdata) {
  if (options.ignoreCdata) {
    return;
  }
  if (options.trim) {
    cdata = cdata.trim();
  }
  addField('cdata', cdata);
}

function onDoctype(doctype) {
  if (options.ignoreDoctype) {
    return;
  }
  doctype = doctype.replace(/^ /, '');
  if (options.trim) {
    doctype = doctype.trim();
  }
  addField('doctype', doctype);
}

function onError(error) {
  error.note = error; //console.error(error);
}

module.exports = function (xml, userOptions) {

  var parser = pureJsParser ? sax.parser(true, {}) : parser = new expat.Parser('UTF-8');
  var result = {};
  currentElement = result;

  options = validateOptions(userOptions);

  if (pureJsParser) {
    parser.opt = {strictEntities: true};
    parser.onopentag = onStartElement;
    parser.ontext = onText;
    parser.oncomment = onComment;
    parser.onclosetag = onEndElement;
    parser.onerror = onError;
    parser.oncdata = onCdata;
    parser.ondoctype = onDoctype;
    parser.onprocessinginstruction = onInstruction;
  } else {
    parser.on('startElement', onStartElement);
    parser.on('text', onText);
    parser.on('comment', onComment);
    parser.on('endElement', onEndElement);
    parser.on('error', onError);
    //parser.on('startCdata', onStartCdata);
    //parser.on('endCdata', onEndCdata);
    //parser.on('entityDecl', onEntityDecl);
  }

  if (pureJsParser) {
    parser.write(xml).close();
  } else {
    if (!parser.parse(xml)) {
      throw new Error('XML parsing error: ' + parser.getError());
    }
  }

  if (result[options.elementsKey]) {
    var temp = result[options.elementsKey];
    delete result[options.elementsKey];
    result[options.elementsKey] = temp;
    delete result.text;
  }

  return result;

};


/***/ }),
/* 300 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(137);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(300);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(183).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(302);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(138).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(107);
util.inherits = __webpack_require__(84);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(855);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(856);
var destroyImpl = __webpack_require__(303);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(69);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(186).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(69);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(186).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37), __webpack_require__(104)))

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(183).EventEmitter;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(137);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(69);

/*<replacement>*/
var util = __webpack_require__(107);
util.inherits = __webpack_require__(84);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var helper = __webpack_require__(187);
var isArray = __webpack_require__(188).isArray;

var currentElement, currentElementName;

function validateOptions(userOptions) {
  var options = helper.copyOptions(userOptions);
  helper.ensureFlagExists('ignoreDeclaration', options);
  helper.ensureFlagExists('ignoreInstruction', options);
  helper.ensureFlagExists('ignoreAttributes', options);
  helper.ensureFlagExists('ignoreText', options);
  helper.ensureFlagExists('ignoreComment', options);
  helper.ensureFlagExists('ignoreCdata', options);
  helper.ensureFlagExists('ignoreDoctype', options);
  helper.ensureFlagExists('compact', options);
  helper.ensureFlagExists('indentText', options);
  helper.ensureFlagExists('indentCdata', options);
  helper.ensureFlagExists('indentAttributes', options);
  helper.ensureFlagExists('indentInstruction', options);
  helper.ensureFlagExists('fullTagEmptyElement', options);
  helper.ensureFlagExists('noQuotesForNativeAttributes', options);
  helper.ensureSpacesExists(options);
  if (typeof options.spaces === 'number') {
    options.spaces = Array(options.spaces + 1).join(' ');
  }
  helper.ensureKeyExists('declaration', options);
  helper.ensureKeyExists('instruction', options);
  helper.ensureKeyExists('attributes', options);
  helper.ensureKeyExists('text', options);
  helper.ensureKeyExists('comment', options);
  helper.ensureKeyExists('cdata', options);
  helper.ensureKeyExists('doctype', options);
  helper.ensureKeyExists('type', options);
  helper.ensureKeyExists('name', options);
  helper.ensureKeyExists('elements', options);
  helper.checkFnExists('doctype', options);
  helper.checkFnExists('instruction', options);
  helper.checkFnExists('cdata', options);
  helper.checkFnExists('comment', options);
  helper.checkFnExists('text', options);
  helper.checkFnExists('instructionName', options);
  helper.checkFnExists('elementName', options);
  helper.checkFnExists('attributeName', options);
  helper.checkFnExists('attributeValue', options);
  helper.checkFnExists('attributes', options);
  helper.checkFnExists('fullTagEmptyElement', options);
  return options;
}

function writeIndentation(options, depth, firstLine) {
  return (!firstLine && options.spaces ? '\n' : '') + Array(depth + 1).join(options.spaces);
}

function writeAttributes(attributes, options, depth) {
  if (options.ignoreAttributes) {
    return '';
  }
  if ('attributesFn' in options) {
    attributes = options.attributesFn(attributes, currentElementName, currentElement);
  }
  var key, attr, attrName, quote, result = [];
  for (key in attributes) {
    if (attributes.hasOwnProperty(key) && attributes[key] !== null && attributes[key] !== undefined) {
      quote = options.noQuotesForNativeAttributes && typeof attributes[key] !== 'string' ? '' : '"';
      attr = '' + attributes[key]; // ensure number and boolean are converted to String
      attr = attr.replace(/"/g, '&quot;');
      attrName = 'attributeNameFn' in options ? options.attributeNameFn(key, attr, currentElementName, currentElement) : key;
      result.push((options.spaces && options.indentAttributes? writeIndentation(options, depth+1, false) : ' '));
      result.push(attrName + '=' + quote + ('attributeValueFn' in options ? options.attributeValueFn(attr, key, currentElementName, currentElement) : attr) + quote);
    }
  }
  if (attributes && Object.keys(attributes).length && options.spaces && options.indentAttributes) {
    result.push(writeIndentation(options, depth, false));
  }
  return result.join('');
}

function writeDeclaration(declaration, options, depth) {
  currentElement = declaration;
  currentElementName = 'xml';
  return options.ignoreDeclaration ? '' :  '<?' + 'xml' + writeAttributes(declaration[options.attributesKey], options, depth) + '?>';
}

function writeInstruction(instruction, options, depth) {
  if (options.ignoreInstruction) {
    return '';
  }
  var key;
  for (key in instruction) {
    if (instruction.hasOwnProperty(key)) {
      break;
    }
  }
  var instructionName = 'instructionNameFn' in options ? options.instructionNameFn(key, instruction[key], currentElementName, currentElement) : key;
  if (typeof instruction[key] === 'object') {
    currentElement = instruction;
    currentElementName = instructionName;
    return '<?' + instructionName + writeAttributes(instruction[key][options.attributesKey], options, depth) + '?>';
  } else {
    var instructionValue = instruction[key] ? instruction[key] : '';
    if ('instructionFn' in options) instructionValue = options.instructionFn(instructionValue, key, currentElementName, currentElement);
    return '<?' + instructionName + (instructionValue ? ' ' + instructionValue : '') + '?>';
  }
}

function writeComment(comment, options) {
  return options.ignoreComment ? '' : '<!--' + ('commentFn' in options ? options.commentFn(comment, currentElementName, currentElement) : comment) + '-->';
}

function writeCdata(cdata, options) {
  return options.ignoreCdata ? '' : '<![CDATA[' + ('cdataFn' in options ? options.cdataFn(cdata, currentElementName, currentElement) : cdata.replace(']]>', ']]]]><![CDATA[>')) + ']]>';
}

function writeDoctype(doctype, options) {
  return options.ignoreDoctype ? '' : '<!DOCTYPE ' + ('doctypeFn' in options ? options.doctypeFn(doctype, currentElementName, currentElement) : doctype) + '>';
}

function writeText(text, options) {
  if (options.ignoreText) return '';
  text = '' + text; // ensure Number and Boolean are converted to String
  text = text.replace(/&amp;/g, '&'); // desanitize to avoid double sanitization
  text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return 'textFn' in options ? options.textFn(text, currentElementName, currentElement) : text;
}

function hasContent(element, options) {
  var i;
  if (element.elements && element.elements.length) {
    for (i = 0; i < element.elements.length; ++i) {
      switch (element.elements[i][options.typeKey]) {
      case 'text':
        if (options.indentText) {
          return true;
        }
        break; // skip to next key
      case 'cdata':
        if (options.indentCdata) {
          return true;
        }
        break; // skip to next key
      case 'instruction':
        if (options.indentInstruction) {
          return true;
        }
        break; // skip to next key
      case 'doctype':
      case 'comment':
      case 'element':
        return true;
      default:
        return true;
      }
    }
  }
  return false;
}

function writeElement(element, options, depth) {
  currentElement = element;
  currentElementName = element.name;
  var xml = [], elementName = 'elementNameFn' in options ? options.elementNameFn(element.name, element) : element.name;
  xml.push('<' + elementName);
  if (element[options.attributesKey]) {
    xml.push(writeAttributes(element[options.attributesKey], options, depth));
  }
  var withClosingTag = element[options.elementsKey] && element[options.elementsKey].length || element[options.attributesKey] && element[options.attributesKey]['xml:space'] === 'preserve';
  if (!withClosingTag) {
    if ('fullTagEmptyElementFn' in options) {
      withClosingTag = options.fullTagEmptyElementFn(element.name, element);
    } else {
      withClosingTag = options.fullTagEmptyElement;
    }
  }
  if (withClosingTag) {
    xml.push('>');
    if (element[options.elementsKey] && element[options.elementsKey].length) {
      xml.push(writeElements(element[options.elementsKey], options, depth + 1));
      currentElement = element;
      currentElementName = element.name;
    }
    xml.push(options.spaces && hasContent(element, options) ? '\n' + Array(depth + 1).join(options.spaces) : '');
    xml.push('</' + elementName + '>');
  } else {
    xml.push('/>');
  }
  return xml.join('');
}

function writeElements(elements, options, depth, firstLine) {
  return elements.reduce(function (xml, element) {
    var indent = writeIndentation(options, depth, firstLine && !xml);
    switch (element.type) {
    case 'element': return xml + indent + writeElement(element, options, depth);
    case 'comment': return xml + indent + writeComment(element[options.commentKey], options);
    case 'doctype': return xml + indent + writeDoctype(element[options.doctypeKey], options);
    case 'cdata': return xml + (options.indentCdata ? indent : '') + writeCdata(element[options.cdataKey], options);
    case 'text': return xml + (options.indentText ? indent : '') + writeText(element[options.textKey], options);
    case 'instruction':
      var instruction = {};
      instruction[element[options.nameKey]] = element[options.attributesKey] ? element : element[options.instructionKey];
      return xml + (options.indentInstruction ? indent : '') + writeInstruction(instruction, options, depth);
    }
  }, '');
}

function hasContentCompact(element, options, anyContent) {
  var key;
  for (key in element) {
    if (element.hasOwnProperty(key)) {
      switch (key) {
      case options.parentKey:
      case options.attributesKey:
        break; // skip to next key
      case options.textKey:
        if (options.indentText || anyContent) {
          return true;
        }
        break; // skip to next key
      case options.cdataKey:
        if (options.indentCdata || anyContent) {
          return true;
        }
        break; // skip to next key
      case options.instructionKey:
        if (options.indentInstruction || anyContent) {
          return true;
        }
        break; // skip to next key
      case options.doctypeKey:
      case options.commentKey:
        return true;
      default:
        return true;
      }
    }
  }
  return false;
}

function writeElementCompact(element, name, options, depth, indent) {
  currentElement = element;
  currentElementName = name;
  var elementName = 'elementNameFn' in options ? options.elementNameFn(name, element) : name;
  if (typeof element === 'undefined' || element === null || element === '') {
    return 'fullTagEmptyElementFn' in options && options.fullTagEmptyElementFn(name, element) || options.fullTagEmptyElement ? '<' + elementName + '></' + elementName + '>' : '<' + elementName + '/>';
  }
  var xml = [];
  if (name) {
    xml.push('<' + elementName);
    if (typeof element !== 'object') {
      xml.push('>' + writeText(element,options) + '</' + elementName + '>');
      return xml.join('');
    }
    if (element[options.attributesKey]) {
      xml.push(writeAttributes(element[options.attributesKey], options, depth));
    }
    var withClosingTag = hasContentCompact(element, options, true) || element[options.attributesKey] && element[options.attributesKey]['xml:space'] === 'preserve';
    if (!withClosingTag) {
      if ('fullTagEmptyElementFn' in options) {
        withClosingTag = options.fullTagEmptyElementFn(name, element);
      } else {
        withClosingTag = options.fullTagEmptyElement;
      }
    }
    if (withClosingTag) {
      xml.push('>');
    } else {
      xml.push('/>');
      return xml.join('');
    }
  }
  xml.push(writeElementsCompact(element, options, depth + 1, false));
  currentElement = element;
  currentElementName = name;
  if (name) {
    xml.push((indent ? writeIndentation(options, depth, false) : '') + '</' + elementName + '>');
  }
  return xml.join('');
}

function writeElementsCompact(element, options, depth, firstLine) {
  var i, key, nodes, xml = [];
  for (key in element) {
    if (element.hasOwnProperty(key)) {
      nodes = isArray(element[key]) ? element[key] : [element[key]];
      for (i = 0; i < nodes.length; ++i) {
        switch (key) {
        case options.declarationKey: xml.push(writeDeclaration(nodes[i], options, depth)); break;
        case options.instructionKey: xml.push((options.indentInstruction ? writeIndentation(options, depth, firstLine) : '') + writeInstruction(nodes[i], options, depth)); break;
        case options.attributesKey: case options.parentKey: break; // skip
        case options.textKey: xml.push((options.indentText ? writeIndentation(options, depth, firstLine) : '') + writeText(nodes[i], options)); break;
        case options.cdataKey: xml.push((options.indentCdata ? writeIndentation(options, depth, firstLine) : '') + writeCdata(nodes[i], options)); break;
        case options.doctypeKey: xml.push(writeIndentation(options, depth, firstLine) + writeDoctype(nodes[i], options)); break;
        case options.commentKey: xml.push(writeIndentation(options, depth, firstLine) + writeComment(nodes[i], options)); break;
        default: xml.push(writeIndentation(options, depth, firstLine) + writeElementCompact(nodes[i], key, options, depth, hasContentCompact(nodes[i], options)));
        }
        firstLine = firstLine && !xml.length;
      }
    }
  }
  return xml.join('');
}

module.exports = function (js, options) {
  options = validateOptions(options);
  var xml = [];
  currentElement = js;
  currentElementName = '_root_';
  if (options.compact) {
    xml.push(writeElementsCompact(js, options, 0, true));
  } else {
    if (js[options.declarationKey]) {
      xml.push(writeDeclaration(js[options.declarationKey], options, 0));
    }
    if (js[options.elementsKey] && js[options.elementsKey].length) {
      xml.push(writeElements(js[options.elementsKey], options, 0, !xml.length));
    }
  }
  return xml.join('');
};


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveCertificateModal_css__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveCertificateModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RemoveCertificateModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveCertificateModal=function(_Component){_inherits(RemoveCertificateModal,_Component);function RemoveCertificateModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveCertificateModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveCertificateModal.__proto__||Object.getPrototypeOf(RemoveCertificateModal)).call.apply(_ref,[this].concat(args))),_this),_this.onRemoveCertificate=function(){_this.props.onRemoveCertificate(_this.props.certificate.id,_this.props.orgId||null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveCertificateModal,[{key:'render',value:function render(){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.props.certificate)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen,toggle:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'remove-certificate-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'certificate.remove_warning_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'certificate.are_you_sure_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:5},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'certificate.valid_till_label')+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.props.certificate.createdAt).format("MMMM Do YYYY, HH:mm"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:5},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'certificate.valid_from_label')+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.props.certificate.validFrom).format("MMMM Do YYYY, HH:mm"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:5},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'certificate.valid_till_label')+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.props.certificate.validTill).format("MMMM Do YYYY, HH:mm"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'remove-certificate-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.onRemoveCertificate},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'certificate.remove_button')))))));}else{return null;}}}]);return RemoveCertificateModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveCertificateModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,certificate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,certId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,orgId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onRemoveCertificate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RemoveCertificateModal);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrgFinanceManagement__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_finance_finance__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_finance_currencies__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_organizations__ = __webpack_require__(30);
var mapStateToProps=function mapStateToProps(state){return{convertedBalance:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_finance_currencies__["d" /* getConvertedMoney */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organizations__["F" /* getOrgFinanceData */])(state),currentPresetId:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_finance_finance__["e" /* getCurrentPresetId */])(state),currentPresetData:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_finance_finance__["d" /* getCurrentPresetData */])(state),presetsData:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_finance_finance__["g" /* getPresetsData */])(state),currenciesData:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_finance_currencies__["e" /* getCurrenciesData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChangePrice:function onChangePrice(id,data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organizations__["r" /* fetchUpdateOrgPrice */])(id,data));},onChangePreset:function onChangePreset(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_finance_finance__["h" /* setCurrentPreset */])(id));},onConvertMoney:function onConvertMoney(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_finance_currencies__["b" /* fetchConvertMoney */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__OrgFinanceManagement__["b" /* default */]));

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EDIT_ORG_MODE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VALIDATE_ORG_MODE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrgFinanceManagement_css__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrgFinanceManagement_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__OrgFinanceManagement_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_datepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EDIT_ORG_MODE="EDIT_ORG_MODE";var VALIDATE_ORG_MODE="VALIDATE_ORG_MODE";var OrgFinanceManagement=function(_Component){_inherits(OrgFinanceManagement,_Component);function OrgFinanceManagement(props){_classCallCheck(this,OrgFinanceManagement);var _this=_possibleConstructorReturn(this,(OrgFinanceManagement.__proto__||Object.getPrototypeOf(OrgFinanceManagement)).call(this,props));_this.saveButtonDisabled=function(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.data)){return true;}var annualFee=_this.props.data.annualFee?_this.props.data.annualFee:_this.props.currentPresetData.annualFee;var consentRequestFee=_this.props.data.consentRequestFee?_this.props.data.consentRequestFee:_this.props.currentPresetData.consentRequestFee;var sameDeviationDate=void 0;if(_this.state.deviationDateForever){sameDeviationDate=_this.state.deviationDateForever===_this.props.data.deviationDateForever;}else{sameDeviationDate=(_this.props.data.deviationDate?__WEBPACK_IMPORTED_MODULE_9_moment___default()(_this.props.data.deviationDate).format('L'):'')===_this.state.deviationInputValue;}return sameDeviationDate&&_this.state.balanceCurrency===_this.props.data.balanceCurrency&&(_this.props.data.paidTillDate?__WEBPACK_IMPORTED_MODULE_9_moment___default()(_this.props.data.paidTillDate).format('L'):'')===_this.state.paidTillInputValue&&_this.props.data.presetId===_this.props.currentPresetId&&Number(_this.getCurrentFee('annualFee'))===annualFee.amount&&Number(_this.getCurrentFee('consentRequestFee'))===consentRequestFee.amount&&_this.props.data.financialData===_this.state.financialData||!_this.isDateValid(_this.state.paidTillInputValue,true)||!_this.isDateValid(_this.state.deviationInputValue,true);};_this.getCurrentFee=function(fieldKey){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(_this.state[fieldKey])?_this.props.currentPresetData[fieldKey].amount:_this.state[fieldKey];};_this.renderFinancialDataFromGroup=function(){var hintText=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'part_1'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'register_org.financial_data_hint_part_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'part_2'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'register_org.financial_data_hint_part_2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'part_3'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'register_org.financial_data_hint_part_3'))];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validate-org-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'edit-finance-financial-data',className:'validate-org-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Q" /* UncontrolledPopover */],{placement:'bottom',trigger:'legacy',target:'edit-finance-financial-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["I" /* PopoverBody */],null,hintText))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':'financial-data-field',sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.financial_data_label')+"*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'textarea',id:'financial-data-field',value:_this.state.financialData,onChange:_this.handleChange('financialData'),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.financial_data_placeholder'),required:true})));};_this.renderPaidTillDateFormGroup=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validate-org-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'paid-till-icon-container',className:'validate-org-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'paid-till-info-icon',icon:'info',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Q" /* UncontrolledPopover */],{placement:'bottom',trigger:'legacy',target:'paid-till-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["I" /* PopoverBody */],{className:'validate-org-hint-popover-body'},__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.paid_till_alert'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.paid_till_date_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.data.paidTillDate)?6:8,className:'paid-till-input-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_datepicker__["a" /* default */],{customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{invalid:!_this.isDateValid(_this.state.paidTillInputValue,true)}),onBlur:_this.handleDateBlur('paidTillDate','paidTillInputValue'),onChange:_this.handleChangeDate('paidTillDate','paidTillInputValue'),onChangeRaw:_this.handleChange('paidTillInputValue'),value:_this.state.paidTillInputValue// NOTE: date in the past is invalid for DatePicker with minDate = NOW
,selected:_this.isDateValid(_this.state.paidTillInputValue,true)?_this.state.paidTillDate:null,showMonthDropdown:true,showYearDropdown:true,dropdownMode:'select',placeholderText:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].datepicker_placeholder),minDate:_this.props.data.paidTillDate?__WEBPACK_IMPORTED_MODULE_9_moment___default.a.max(__WEBPACK_IMPORTED_MODULE_9_moment___default()(),__WEBPACK_IMPORTED_MODULE_9_moment___default()(_this.props.data.paidTillDate)):__WEBPACK_IMPORTED_MODULE_9_moment___default()()})),!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.data.paidTillDate)&&_this.props.mode!==VALIDATE_ORG_MODE?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:_this.handleAddYearIconClick},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.add_year_label'))):null);};_this.isDateValid=function(value,strict){return value===''||__WEBPACK_IMPORTED_MODULE_9_moment___default()(value,'L',strict).isValid()&&__WEBPACK_IMPORTED_MODULE_9_moment___default()(value,'L').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_9_moment___default()().startOf('day'));};_this.renderPresetFormGroup=function(){var defaultAnnualFee=Number(_this.getCurrentFee("annualFee"))===_this.props.currentPresetData.annualFee.amount;var defaultConsentRequestFee=Number(_this.getCurrentFee("consentRequestFee"))===_this.props.currentPresetData.consentRequestFee.amount;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.preset_price_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getPresetsOptions(_this.props.presetsData),function(option){return option.value===_this.props.currentPresetId;}),options:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getPresetsOptions(_this.props.presetsData),onSelect:_this.handleChangePreset,isSearchable:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["i" /* Collapse */],{isOpen:!defaultAnnualFee||!defaultConsentRequestFee},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["q" /* FormText */],{color:'muted',className:'org-finance-edit-form-text'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.default_preset_label').replace('{annual_fee_amount}',_this.props.currentPresetData.annualFee.amount+__WEBPACK_IMPORTED_MODULE_6__constants_constants__["g" /* CURRENCIES */][_this.props.currentPresetData.annualFee.currency]).replace('{consent_request_fee_amount}',_this.props.currentPresetData.consentRequestFee.amount+__WEBPACK_IMPORTED_MODULE_6__constants_constants__["g" /* CURRENCIES */][_this.props.currentPresetData.annualFee.currency])))));};_this.renderBalanceFormGroup=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.balance_currency_label')),_this.props.mode!==VALIDATE_ORG_MODE?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{readOnly:true,value:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.convertedBalance)&&_this.props.data.balanceCurrency!==_this.state.balanceCurrency?_this.props.convertedBalance:_this.props.data.balance})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:_this.props.mode!==VALIDATE_ORG_MODE?2:8,className:'currency-select-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getCurrenciesOptions(_this.props.currenciesData),function(option){return option.value===_this.state.balanceCurrency;}),options:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getCurrenciesOptions(_this.props.currenciesData),onSelect:_this.handleChangeBalanceCurrency,isSearchable:false})));};_this.renderPriceFormGroups=function(){var defaultAnnualFee=Number(_this.getCurrentFee("annualFee"))===_this.props.currentPresetData.annualFee.amount;var defaultConsentRequestFee=Number(_this.getCurrentFee("consentRequestFee"))===_this.props.currentPresetData.consentRequestFee.amount;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:'annual-fee-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.annual_fee_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:7,className:'org-finance-edit-input-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* InputGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{className:'org-finance-edit-input '+(defaultAnnualFee?'default':''),type:'number',min:0,step:'any',value:_this.state.annualFee,onChange:_this.handleChange('annualFee'),onBlur:_this.handleBlur('annualFee'),invalid:Number(_this.state.annualFee)<0,required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["t" /* InputGroupAddon */],{addonType:'append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["u" /* InputGroupText */],null,__WEBPACK_IMPORTED_MODULE_6__constants_constants__["g" /* CURRENCIES */][_this.props.currentPresetData.annualFee.currency]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["i" /* Collapse */],{isOpen:defaultAnnualFee},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["q" /* FormText */],{color:'muted',className:'org-finance-edit-form-text'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.default_annual_fee_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:1,className:'org-finance-edit-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'restore',className:'org-finance-edit-icon'+(defaultAnnualFee?' default':''),title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.set_default_label'),onClick:_this.resetToDefault('annualFee')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:'request-cost-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{className:'label',sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.request_cost_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:7,className:'org-finance-edit-input-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* InputGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{className:'org-finance-edit-input '+(defaultConsentRequestFee?'default':''),type:'number',min:0,step:'any',value:_this.state.consentRequestFee,onChange:_this.handleChange('consentRequestFee'),onBlur:_this.handleBlur('consentRequestFee'),invalid:Number(_this.state.consentRequestFee)<0,required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["t" /* InputGroupAddon */],{addonType:'append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["u" /* InputGroupText */],null,__WEBPACK_IMPORTED_MODULE_6__constants_constants__["g" /* CURRENCIES */][_this.props.currentPresetData.consentRequestFee.currency]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["i" /* Collapse */],{isOpen:defaultConsentRequestFee},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["q" /* FormText */],{color:'muted',className:'org-finance-edit-form-text'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.default_consent_request_fee_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:1,className:'org-finance-edit-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'restore',className:'org-finance-edit-icon'+(defaultConsentRequestFee?' default':''),title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.set_default_label'),onClick:_this.resetToDefault('consentRequestFee')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,className:'deviation-form-group',key:'deviation-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.deviation_period_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_datepicker__["a" /* default */],{customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{invalid:!_this.isDateValid(_this.state.deviationInputValue,true)}),onBlur:_this.handleDateBlur('deviationDate','deviationInputValue'),onChange:_this.handleChangeDate('deviationDate','deviationInputValue'),onChangeRaw:_this.handleChange('deviationInputValue'),value:_this.state.deviationInputValue,selected:_this.state.deviationDate,showMonthDropdown:true,showYearDropdown:true,dropdownMode:'select',placeholderText:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].datepicker_placeholder),minDate:__WEBPACK_IMPORTED_MODULE_9_moment___default()(),disabled:defaultAnnualFee&&defaultConsentRequestFee||_this.state.deviationDateForever,required:(!defaultAnnualFee||!defaultConsentRequestFee)&&!_this.state.deviationDateForever}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{check:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'checkbox',checked:_this.state.deviationDateForever,onChange:_this.toggleCheckBox('deviationDateForever'),disabled:defaultAnnualFee&&defaultConsentRequestFee}),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.forever_label')))))];};_this.handleAddYearIconClick=function(){var startDate=__WEBPACK_IMPORTED_MODULE_9_moment___default()(_this.state.paidTillDate);if(!__WEBPACK_IMPORTED_MODULE_9_moment___default()(_this.state.paidTillDate,'L').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_9_moment___default()().startOf('day'))){startDate=__WEBPACK_IMPORTED_MODULE_9_moment___default()();}var newDate=startDate.add(1,'year');_this.setState({paidTillDate:newDate,paidTillInputValue:newDate.format('L')});};_this.toggleCheckBox=function(fieldKey){return function(){_this.setState(_defineProperty({},fieldKey,!_this.state[fieldKey]));};};_this.resetToDefault=function(fieldKey){return function(){_this.setState(_defineProperty({},fieldKey,Number(_this.props.currentPresetData[fieldKey].amount).toFixed(2)));};};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleBlur=function(fieldKey){return function(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(_this.state[fieldKey])){_this.resetToDefault(fieldKey)();}else{_this.setState(_defineProperty({},fieldKey,Number(_this.state[fieldKey]).toFixed(2)));}};};_this.handleDateBlur=function(dateFieldKey,inputFieldKey){return function(){if((__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.state[dateFieldKey])?'':_this.state[dateFieldKey].format('L'))!==_this.state[inputFieldKey]){if(_this.isDateValid(inputFieldKey,false)){var _this$setState5;_this.setState((_this$setState5={},_defineProperty(_this$setState5,inputFieldKey,__WEBPACK_IMPORTED_MODULE_9_moment___default()(_this.state[inputFieldKey],'L').format('L')),_defineProperty(_this$setState5,dateFieldKey,__WEBPACK_IMPORTED_MODULE_9_moment___default()(_this.state[inputFieldKey],'L')),_this$setState5));}else{_this.setState(_defineProperty({},inputFieldKey,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.state[dateFieldKey])?'':_this.state[dateFieldKey].format('L')));}}};};_this.handleChangeDate=function(dateFieldKey,inputFieldKey){return function(date){var _this$setState7;_this.setState((_this$setState7={},_defineProperty(_this$setState7,dateFieldKey,date),_defineProperty(_this$setState7,inputFieldKey,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(date)?'':date.format('L')),_this$setState7));};};_this.handleChangePreset=function(selectedOption){_this.props.onChangePreset(selectedOption.value);};_this.handleChangeBalanceCurrency=function(selectedOption){_this.setState({balanceCurrency:selectedOption.value});if(_this.props.data.balanceCurrency!==selectedOption.value){var data={amount:_this.props.data.balance,currencyFrom:_this.props.data.balanceCurrency,currencyTo:selectedOption.value};_this.props.onConvertMoney(data);}};_this.onFinanceEdit=function(e){e.preventDefault();var data={pricing:{pricingPreset:{id:_this.props.currentPresetId}},balance:{currency:_this.state.balanceCurrency},financialData:_this.state.financialData};if(_this.props.currentPresetData.annualFee.amount!==Number(_this.state.annualFee)){data.pricing.annualFee={amount:Number(_this.state.annualFee),currency:_this.props.currentPresetData.annualFee.currency};}if(_this.props.currentPresetData.consentRequestFee.amount!==Number(_this.state.consentRequestFee)){data.pricing.consentRequestFee={amount:Number(_this.state.consentRequestFee),currency:_this.props.currentPresetData.consentRequestFee.currency};}if(data.pricing.annualFee||data.pricing.consentRequestFee){data.pricing["validTill"]=_this.state.deviationDateForever?null:_this.state.deviationDate;}if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.state.paidTillDate)){data["paidTill"]=_this.state.paidTillDate.format('YYYY-MM-DD');}if(_this.props.onUpdateOrgFinanceDataSubmit){_this.props.onUpdateOrgFinanceDataSubmit();}_this.props.onChangePrice(_this.props.id,data);};_this.state={balanceCurrency:'USD',paidTillDate:null,paidTillInputValue:'',annualFee:'',consentRequestFee:'',deviationDate:null,deviationDateForever:false,deviationInputValue:'',financialData:''};return _this;}_createClass(OrgFinanceManagement,[{key:'componentWillMount',value:function componentWillMount(){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){if(this.props.currentPresetId===this.props.data.presetId){var annualFee=this.props.data.annualFee?this.props.data.annualFee:this.props.currentPresetData.annualFee;var consentRequestFee=this.props.data.consentRequestFee?this.props.data.consentRequestFee:this.props.currentPresetData.consentRequestFee;this.setState({balanceCurrency:this.props.data.balanceCurrency,paidTillDate:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data.paidTillDate)?__WEBPACK_IMPORTED_MODULE_9_moment___default()(this.props.data.paidTillDate):null,paidTillInputValue:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data.paidTillDate)?__WEBPACK_IMPORTED_MODULE_9_moment___default()(this.props.data.paidTillDate).format('L'):'',financialData:this.props.data.financialData,annualFee:annualFee.amount.toFixed(2),consentRequestFee:consentRequestFee.amount.toFixed(2),deviationDate:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data.deviationDate)?__WEBPACK_IMPORTED_MODULE_9_moment___default()(this.props.data.deviationDate):null,deviationInputValue:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data.deviationDate)?__WEBPACK_IMPORTED_MODULE_9_moment___default()(this.props.data.deviationDate).format('L'):'',deviationDateForever:this.props.data.deviationDateForever});}else{this.props.onChangePreset(this.props.data.presetId);this.setState({balanceCurrency:this.props.data.balanceCurrency,paidTillDate:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data.paidTillDate)?__WEBPACK_IMPORTED_MODULE_9_moment___default()(this.props.data.paidTillDate):null,paidTillInputValue:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data.paidTillDate)?__WEBPACK_IMPORTED_MODULE_9_moment___default()(this.props.data.paidTillDate).format('L'):'',deviationDate:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data.deviationDate)?__WEBPACK_IMPORTED_MODULE_9_moment___default()(this.props.data.deviationDate):null,deviationInputValue:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data.deviationDate)?__WEBPACK_IMPORTED_MODULE_9_moment___default()(this.props.data.deviationDate).format('L'):'',deviationDateForever:this.props.data.deviationDateForever,financialData:this.props.data.financialData});}}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.data)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.currentPresetData)&&(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.currentPresetData))){var annualFee=nextProps.data.annualFee?nextProps.data.annualFee:nextProps.currentPresetData.annualFee;var consentRequestFee=nextProps.data.consentRequestFee?nextProps.data.consentRequestFee:nextProps.currentPresetData.consentRequestFee;this.setState({annualFee:annualFee.amount.toFixed(2),consentRequestFee:consentRequestFee.amount.toFixed(2)});}else if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.currentPresetData)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.currentPresetData)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(this.props.currentPresetData,nextProps.currentPresetData)){var _annualFee=this.state.annualFee===""||Number(this.state.annualFee)===this.props.currentPresetData.annualFee.amount?nextProps.currentPresetData.annualFee.amount:Number(this.state.annualFee);var _consentRequestFee=this.state.consentRequestFee===""||Number(this.state.consentRequestFee)===this.props.currentPresetData.consentRequestFee.amount?nextProps.currentPresetData.consentRequestFee.amount:Number(this.state.consentRequestFee);this.setState({annualFee:_annualFee.toFixed(2),consentRequestFee:_consentRequestFee.toFixed(2)});}}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.props.onChangeSubmitStatus){this.props.onChangeSubmitStatus(this.saveButtonDisabled());}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onChangePreset();}},{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.currentPresetData)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{className:'org-finance-edit',onSubmit:this.onFinanceEdit},this.renderFinancialDataFromGroup(),this.renderPaidTillDateFormGroup(),this.renderBalanceFormGroup(),this.renderPresetFormGroup(),this.renderPriceFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{type:'submit',disabled:this.saveButtonDisabled(),className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button))));}}]);return OrgFinanceManagement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OrgFinanceManagement.defaultProps={mode:EDIT_ORG_MODE};OrgFinanceManagement.propTypes={mode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,convertedBalance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,currentPresetId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,currentPresetData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,presetsData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,currenciesData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onChangePreset:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onChangePrice:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onConvertMoney:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onUpdateOrgFinanceDataSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onChangeSubmitStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["b"] = (OrgFinanceManagement);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DepartmentsList__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_organization_departments__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_department__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_organization_organization__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{departmentId:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_department__["h" /* getDepartmentId */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_departments__["h" /* loadingDepartments */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_departments__["f" /* getDepartmentsData */])(state),orgPermissions:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_organization_organization__["p" /* getOrgPermissions */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_department__["m" /* setDepartmentId */])(null));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_departments__["b" /* fetchGetDepartments */])());},onAddButtonClick:function onAddButtonClick(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["h" /* MODAL_ADD_DEPARTMENT */]}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_submitForm__["j" /* resetSubmitForm */])());},onDepartmentSelect:function onDepartmentSelect(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_department__["m" /* setDepartmentId */])(id));},onDepartmentRemove:function onDepartmentRemove(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["W" /* MODAL_REMOVE_DEPARTMENT */]}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_submitForm__["j" /* resetSubmitForm */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__DepartmentsList__["a" /* default */]));

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AVAILABLE_ACTIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CertifiedAccreditationModal_css__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CertifiedAccreditationModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CertifiedAccreditationModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AVAILABLE_ACTIONS={SHOW_DETAILS:'show_details',REMOVE:'remove'};var CertifiedAccreditationModal=function(_Component){_inherits(CertifiedAccreditationModal,_Component);function CertifiedAccreditationModal(props){_classCallCheck(this,CertifiedAccreditationModal);var _this=_possibleConstructorReturn(this,(CertifiedAccreditationModal.__proto__||Object.getPrototypeOf(CertifiedAccreditationModal)).call(this,props));_this.renderLabel=function(){switch(_this.props.action){case AVAILABLE_ACTIONS.SHOW_DETAILS:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.accreditation_details_label'));case AVAILABLE_ACTIONS.REMOVE:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.remove_accreditation_alert'));default:return'';}};_this.getAdditionalTitlesData=function(){var result=[];__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(_this.props.data.additionalTitles,function(title,key){result.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'langs.'+key)+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,title))));});return result;};_this.renderButtons=function(){switch(_this.props.action){case AVAILABLE_ACTIONS.SHOW_DETAILS:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn right',onClick:_this.onCancelHandle},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].okey_button));case AVAILABLE_ACTIONS.REMOVE:return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'left',onClick:_this.onCancelHandle,key:'cancel'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn right',onClick:_this.onRemove,key:'remove'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))];default:return null;}};_this.onCancelHandle=function(){_this.clearData();_this.props.onCancel();};_this.onRemove=function(){_this.props.onRemove();};_this.clearData=function(){_this.setState({data:null});};_this.state={data:null};return _this;}_createClass(CertifiedAccreditationModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.data)){var newData=nextProps.data;this.setState({data:newData});}else{this.clearData();}}},{key:'render',value:function render(){if(this.state.data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen,toggle:this.onCancelHandle,className:'certified-accreditation-modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderLabel(),this.renderAccreditationData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},this.renderButtons())));}else{return null;}}},{key:'renderAccreditationData',value:function renderAccreditationData(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation.accreditation_title_orig_label')+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,this.props.data.titleOriginal))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation.accreditation_title_en_label')+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,this.props.data.titleEn))),this.getAdditionalTitlesData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation.date_issued_label')+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.props.data.dateIssued).format("L")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'applicant_accreditations_management.issued_by_label')+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,this.props.data.issuedByName+', '+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'countries.'+this.props.data.issuedByCountry)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation.level_label')+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'levels.'+this.props.data.level)))));}}]);return CertifiedAccreditationModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CertifiedAccreditationModal.propTypes={action:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["b"] = (CertifiedAccreditationModal);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__ = __webpack_require__(44);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__["k" /* getCurrentPageForConsents */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__["q" /* getTotalPagesForConsents */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__["p" /* getRequestsByStatus */])(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__["b" /* PENDING */],page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var actionType={CANCEL:"cancel",DISMISS:"dismiss"};var CancelConsentRequestModal=function(_Component){_inherits(CancelConsentRequestModal,_Component);function CancelConsentRequestModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CancelConsentRequestModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CancelConsentRequestModal.__proto__||Object.getPrototypeOf(CancelConsentRequestModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleCancelConsentRequest=function(e){e.preventDefault();_this.props.onAbandonConsentRequest(_this.props.id);},_this.handleCancel=function(){_this.props.onCancel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CancelConsentRequestModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.id)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'cancel-consent-request-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"consents.cancel_request_success_message")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"consents."+this.props.actionType+"_request_warning_label")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"consents."+this.props.actionType+"_request_are_you_sure_label")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'carrot-red-btn',onClick:this.handleCancelConsentRequest},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"consents."+this.props.actionType+"_request_button_label")))));}}]);return CancelConsentRequestModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CancelConsentRequestModal.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onAbandonConsentRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["b"] = (CancelConsentRequestModal);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PriorConsentDetails_css__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PriorConsentDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PriorConsentDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_datepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__periodSelect_PeriodSelect_container__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonComponents_domainInput_DomainInput__ = __webpack_require__(63);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MAX_PERIOD=__WEBPACK_IMPORTED_MODULE_10_moment_moment___default.a.duration(3,__WEBPACK_IMPORTED_MODULE_7__constants_constants__["d" /* AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST */].MONTH).add(1,'day');var MIN_PERIOD=__WEBPACK_IMPORTED_MODULE_10_moment_moment___default.a.duration(1,__WEBPACK_IMPORTED_MODULE_7__constants_constants__["d" /* AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST */].WEEK).subtract(1,'day');var DEFAULT_PERIOD_TYPE=__WEBPACK_IMPORTED_MODULE_7__constants_constants__["d" /* AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST */].MONTH;var DEFAULT_PERIOD_NUM='1';var requiredSelectFields=['targetType'];var TARGET_TYPE_OPTIONS=[{code:__WEBPACK_IMPORTED_MODULE_7__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].PERSON,name:'consents.person_label'},{code:__WEBPACK_IMPORTED_MODULE_7__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].ORGANIZATION,name:__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].org_label},{code:__WEBPACK_IMPORTED_MODULE_7__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].ANYONE,name:'prior_consents.anyone_label'}];var ACTION_TYPES={ADD:'add',EDIT:'edit'};var AddPriorConsent=function(_Component){_inherits(AddPriorConsent,_Component);function AddPriorConsent(props){_classCallCheck(this,AddPriorConsent);var _this=_possibleConstructorReturn(this,(AddPriorConsent.__proto__||Object.getPrototypeOf(AddPriorConsent)).call(this,props));_initialiseProps.call(_this);var now=__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()();_this.state={targetType:'',personEmail:'',orgDomain:'',metadata:{firstName:'',lastName:''},enabledTill:__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(),grantedPeriodDays:__WEBPACK_IMPORTED_MODULE_10_moment_moment___default.a.duration(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(now).add(+DEFAULT_PERIOD_NUM,DEFAULT_PERIOD_TYPE).diff(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(now),'days'),'days').asDays(),responseComment:'',periodType:DEFAULT_PERIOD_TYPE,periodNum:DEFAULT_PERIOD_NUM,popoverOpen:false,requiredFieldError:null};return _this;}_createClass(AddPriorConsent,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.actionType===ACTION_TYPES.EDIT&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.id)){this.props.onMount(this.props.id);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!this.props.success&&nextProps.success&&nextProps.actionType===ACTION_TYPES.ADD){this.resetData();}if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.data)){var period=this.getPeriodByDaysNumber(nextProps.data.grantedPeriodDays,nextProps.data.createdAt);this.setState({targetType:nextProps.data.targetType,personEmail:nextProps.data.targetType===__WEBPACK_IMPORTED_MODULE_7__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].PERSON?nextProps.data.targetId:'',orgDomain:nextProps.data.targetType===__WEBPACK_IMPORTED_MODULE_7__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].ORGANIZATION?nextProps.data.targetId:'',metadata:{firstName:nextProps.data.targetType===__WEBPACK_IMPORTED_MODULE_7__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].PERSON?nextProps.data.metadata.firstName:'',lastName:nextProps.data.targetType===__WEBPACK_IMPORTED_MODULE_7__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].PERSON?nextProps.data.metadata.lastName:''},enabledTill:__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(nextProps.data.enabledTill),grantedPeriodDays:nextProps.data.grantedPeriodDays,responseComment:nextProps.data.responseComment||'',periodType:period.periodType,periodNum:period.periodNum.toString()});}}},{key:'render',value:function render(){if(this.props.success){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Redirect */],{to:'/prior-consents',push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prior-consent-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'prior_consents.'+this.props.actionType+'_prior_consent_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/prior-consents',label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].back_button)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prior-consent-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'prior_consents.'+this.props.actionType+'_prior_consent_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prior-consents-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prior-consents-hint',key:'prior_consent_hint_part_1'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'prior_consents.prior_consents_hint_part_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prior-consents-hint',key:'prior_consent_hint_part_2'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'prior_consents.prior_consents_hint_part_2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prior-consents-hint',key:'prior_consent_hint_part_3'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'prior_consents.prior_consents_hint_part_3'))),this.renderContent())));}}]);return AddPriorConsent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.getPeriodByDaysNumber=function(daysNumber,createdAt){var duration=__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(createdAt).add(daysNumber,'d').diff(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(createdAt));var periodNum=1;var periodType=__WEBPACK_IMPORTED_MODULE_7__constants_constants__["d" /* AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST */].MONTH;var currentDuration=__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(createdAt).add(periodNum,periodType);while(currentDuration.clone().subtract(MAX_PERIOD).isBefore(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(createdAt))){if(duration===currentDuration.diff(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(createdAt))){return{periodType:periodType,periodNum:periodNum};}periodNum++;currentDuration=__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(createdAt).add(periodNum,periodType);}periodNum=1;periodType=__WEBPACK_IMPORTED_MODULE_7__constants_constants__["d" /* AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST */].WEEK;currentDuration=__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(createdAt).add(periodNum,periodType);while(currentDuration.clone().subtract(MAX_PERIOD).isBefore(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(createdAt))){if(duration===currentDuration.diff(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(createdAt))){return{periodType:periodType,periodNum:periodNum};}periodNum++;currentDuration=__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(createdAt).add(periodNum,periodType);}return{periodType:DEFAULT_PERIOD_TYPE,periodNum:DEFAULT_PERIOD_NUM};};this.renderContent=function(){if(_this2.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Form */],{className:'add-prior-consent-from',onSubmit:_this2.handleSubmit},_this2.renderTargetTypeSelect(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["i" /* Collapse */],{isOpen:_this2.state.targetType===__WEBPACK_IMPORTED_MODULE_7__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].PERSON},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'prior-consent-details-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'consents.person_label')),_this2.renderPersonDataFormGroups()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["i" /* Collapse */],{isOpen:_this2.state.targetType===__WEBPACK_IMPORTED_MODULE_7__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].ORGANIZATION},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'prior-consent-details-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)),_this2.renderOrganizationDataFormGroups()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'prior-consent-details-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'prior_consents.period_label')),_this2.renderEnabledTillFormGroup(),_this2.renderGrantedPeriodDaysFormGroup(),_this2.renderCommentFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn',disabled:_this2.saveButtonDisabled()},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,_this2.props.actionType===ACTION_TYPES.ADD?__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].add_button:__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button))));};this.saveButtonDisabled=function(){if(_this2.props.actionType===ACTION_TYPES.ADD){return false;}if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this2.props.data)){return true;}if(_this2.props.data.targetType!==_this2.state.targetType||__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(_this2.props.data.enabledTill).format('L')!==_this2.state.enabledTill.format('L')||_this2.props.data.grantedPeriodDays!==_this2.state.grantedPeriodDays||(_this2.props.data.responseComment||'')!==_this2.state.responseComment){return false;}switch(_this2.props.data.targetType){case __WEBPACK_IMPORTED_MODULE_7__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].PERSON:return _this2.state.personEmail===_this2.props.data.targetId&&_this2.state.metadata.firstName===_this2.props.data.metadata.firstName&&_this2.state.metadata.lastName===_this2.props.data.metadata.lastName;case __WEBPACK_IMPORTED_MODULE_7__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].ORGANIZATION:return _this2.state.orgDomain===_this2.props.data.targetId;default:return true;}};this.renderTargetTypeSelect=function(){var params={value:"targetType",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'prior_consents.target_type_label'),type:'select',isRequired:true,content:__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(TARGET_TYPE_OPTIONS,function(option){return Object.assign({},option,{name:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,option.name)});})),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'prior_consents.target_type_input_placeholder'),onChange:_this2.handleChangeSelect("targetType")};return _this2.getFormGroup(params);};this.renderPersonDataFormGroups=function(){var paramsList=[{value:"personEmail",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label),type:"email",isRequired:_this2.state.targetType===__WEBPACK_IMPORTED_MODULE_7__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].PERSON,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)},{value:"metadata.firstName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),onChange:_this2.handleMetadataChange('firstName')},{value:"metadata.lastName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),onChange:_this2.handleMetadataChange('lastName')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this2.getFormGroup)));};this.renderOrganizationDataFormGroups=function(){var params={value:"orgDomain",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label),isRequired:_this2.state.targetType===__WEBPACK_IMPORTED_MODULE_7__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].ORGANIZATION,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label)};return _this2.getOrganizationDomainFormGroup(params);};this.getOrganizationDomainFormGroup=function(params){var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this2.renderPopover(params),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__commonComponents_domainInput_DomainInput__["a" /* default */],{id:id,value:_this2.state[params.value],onChange:_this2.handleChangeDomainInput,placeholder:params.placeholder||params.title,disabled:params.isDisabled,required:params.isRequired})));};this.getFormGroup=function(params){if(params.type==='select'){return _this2.getSelectFormGroup(params);}if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this2.renderPopover(params),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.state,params.value),onChange:params.onChange||_this2.handleChange(params.value),placeholder:params.placeholder,disabled:params.isDisabled,required:params.isRequired},params.content)));};this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(params.content,function(option){return option.value===_this2.state[params.value];}),options:params.content,onSelect:params.onChange,placeholder:params.placeholder,disabled:params.isDisabled,requiredFieldError:_this2.state.requiredFieldError===params.value})));};this.renderPopover=function(params){if(params.value!=='orgDomain'){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prior-consent-details-domain-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'prior-consent-details-icon-container',className:'prior-consent-details-icon-container',onClick:_this2.togglePopover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["H" /* Popover */],{placement:'bottom',isOpen:_this2.state.popoverOpen,target:'prior-consent-details-icon-container',toggle:_this2.togglePopover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["I" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'register_org.domain_hint'))));};this.togglePopover=function(){_this2.setState({popoverOpen:!_this2.state.popoverOpen});};this.renderEnabledTillFormGroup=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:'enabled-till'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':'enabled-till',sm:3},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'prior_consents.auto_grant_till_label'),'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_datepicker__["a" /* default */],{customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{id:'enabled-till'}),selected:_this2.state.enabledTill,showMonthDropdown:true,showYearDropdown:true,dropdownMode:'select',required:true,onChange:_this2.handleChangeEnabledTill,minDate:__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()()})));};this.renderGrantedPeriodDaysFormGroup=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:'duration'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':'duration',sm:3},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'prior_consents.duration_label'),'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__periodSelect_PeriodSelect_container__["a" /* default */],{id:'prior-consent-period-select',showPopover:true,placement:'top',periodEndDateMessage:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'prior_consents.duration_alert')+' '+_this2.state.grantedPeriodDays+' '+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'prior_consents.days_label'),onPeriodNumChange:_this2.handlePeriodNumChange,onPeriodTypeChange:_this2.handlePeriodTypeChange,periodType:_this2.state.periodType,periodNum:_this2.state.periodNum})));};this.renderCommentFormGroup=function(){var params={value:"responseComment",type:"textarea",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'prior_consents.response_comment_label'),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'prior_consents.response_comment_placeholder')};return _this2.getFormGroup(params);};this.handlePeriodNumChange=function(nextPeriodNum){if(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()().add(nextPeriodNum,_this2.state.periodType).subtract(MAX_PERIOD).isBefore(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()())&&__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()().add(nextPeriodNum,_this2.state.periodType).subtract(MIN_PERIOD).isAfter(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()())){var now=__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()();_this2.setState({periodNum:nextPeriodNum,grantedPeriodDays:__WEBPACK_IMPORTED_MODULE_10_moment_moment___default.a.duration(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(now).add(+nextPeriodNum,_this2.state.periodType).diff(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(now),'days'),'days').asDays()});}};this.handlePeriodTypeChange=function(nextPeriodType){var nextPeriodNum=_this2.state.periodNum;if(!(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()().add(_this2.state.periodNum,nextPeriodType).subtract(MAX_PERIOD).isBefore(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()())&&__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()().add(_this2.state.periodNum,nextPeriodType).subtract(MIN_PERIOD).isAfter(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()()))){nextPeriodNum=DEFAULT_PERIOD_NUM;}var now=__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()();_this2.setState({periodType:nextPeriodType,periodNum:nextPeriodNum,grantedPeriodDays:__WEBPACK_IMPORTED_MODULE_10_moment_moment___default.a.duration(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(now).add(+nextPeriodNum,nextPeriodType).diff(__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(now),'days'),'days').asDays()});};this.handleChangeSelect=function(fieldName){return function(selectedOption){_this2.setState(_defineProperty({},fieldName,selectedOption.value));};};this.handleChange=function(fieldName){return function(e){_this2.setState(_defineProperty({},fieldName,e.target.value));};};this.handleChangeDomainInput=function(data){_this2.setState({orgDomain:data});};this.handleMetadataChange=function(fieldName){return function(e){_this2.setState({metadata:Object.assign({},_this2.state.metadata,_defineProperty({},fieldName,e.target.value))});};};this.handleChangeEnabledTill=function(date){_this2.setState({enabledTill:date});};this.handleSubmit=function(e){e.preventDefault();if(_this2.checkRequiredSelectFields()){return;}var data={targetType:_this2.state.targetType,grantedPeriodDays:_this2.state.grantedPeriodDays,enabledTill:__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(_this2.state.enabledTill).endOf('day'),responseComment:_this2.state.responseComment!==""?_this2.state.responseComment:null};if(_this2.state.targetType===__WEBPACK_IMPORTED_MODULE_7__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].PERSON){data.targetId=_this2.state.personEmail;data.metadata={};data.metadata.firstName=_this2.state.metadata.firstName;data.metadata.lastName=_this2.state.metadata.lastName;}if(_this2.state.targetType===__WEBPACK_IMPORTED_MODULE_7__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].ORGANIZATION){data.targetId=_this2.state.orgDomain;}switch(_this2.props.actionType){case ACTION_TYPES.ADD:_this2.props.onProcess(data);break;case ACTION_TYPES.EDIT:_this2.props.onProcess(_this2.props.id,data);break;default:break;}};this.resetData=function(){_this2.setState({targetType:'',personEmail:'',orgDomain:'',metadata:{firstName:'',lastName:''},enabledTill:__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(),grantedPeriodDays:__WEBPACK_IMPORTED_MODULE_10_moment_moment___default.a.duration(+DEFAULT_PERIOD_NUM,DEFAULT_PERIOD_TYPE,'days').asDays(),responseComment:'',periodType:DEFAULT_PERIOD_TYPE,periodNum:DEFAULT_PERIOD_NUM,popoverOpen:false});};this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(requiredSelectFields,function(field){if(!_this2.state[field]&&!error){error=field;}});_this2.setState({requiredFieldError:error});return error;};};AddPriorConsent.propTypes={id:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,loading:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,actionType:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,success:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,onProcess:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,onMount:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["b"] = (AddPriorConsent);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetPendingAccreditationRequestByIdFailed */
/* unused harmony export fetchGetPendingAccreditationRequestByIdSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetPendingAccreditationRequestById; });
/* unused harmony export getPendingAccreditationRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadingPendingAccreditationRequest; });
/* unused harmony export getPendingAccreditationRequestData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPendingAccreditationRequestDataFormatted; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pendingAccreditationRequests__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_location__ = __webpack_require__(21);
//- Actions
var fetchGetPendingAccreditationRequestByIdFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PENDING_ACCREDITATION_REQUEST_BY_ID_FAILED');var fetchGetPendingAccreditationRequestByIdSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PENDING_ACCREDITATION_REQUEST_BY_ID_SUCCESS');var fetchGetPendingAccreditationRequestById=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_PENDING_ACCREDITATION_REQUEST_BY_ID',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getAccreditationRequestForProcessing(id);},function(){return{apiCall:true,onSuccess:fetchGetPendingAccreditationRequestByIdSuccess,onFail:fetchGetPendingAccreditationRequestByIdFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_2__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_2__account_login__["l" /* onForbidden */]};});//- State
var initialState={data:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_PENDING_ACCREDITATION_REQUEST_BY_ID:function FETCH_GET_PENDING_ACCREDITATION_REQUEST_BY_ID(state){return Object.assign({},state,{data:null,error:null,fetching:true});},FETCH_GET_PENDING_ACCREDITATION_REQUEST_BY_ID_FAILED:function FETCH_GET_PENDING_ACCREDITATION_REQUEST_BY_ID_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_PENDING_ACCREDITATION_REQUEST_BY_ID_SUCCESS:function FETCH_GET_PENDING_ACCREDITATION_REQUEST_BY_ID_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});}},initialState));//- Selectors
var getPendingAccreditationRequest=function getPendingAccreditationRequest(state){return state.pendingAccreditationRequest;};var loadingPendingAccreditationRequest=function loadingPendingAccreditationRequest(state){return getPendingAccreditationRequest(state).fetching;};var getPendingAccreditationRequestData=function getPendingAccreditationRequestData(state){return getPendingAccreditationRequest(state).data;};var getPendingAccreditationRequestDataFormatted=function getPendingAccreditationRequestDataFormatted(state){var data=getPendingAccreditationRequestData(state);var listData=Object(__WEBPACK_IMPORTED_MODULE_4__pendingAccreditationRequests__["o" /* getPendingAccreditationRequestsData */])(state);if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(data)||!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(data,'accreditationData.titles')||!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(data,'verifiedIdentity')||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(listData)){return null;}var accreditationRequestData={titleOrig:data.accreditationData.titles.original,titleEn:data.accreditationData.titles.en,titlesAdditional:{},dateIssued:data.accreditationData.issuedAt,level:data.accreditationData.level,personFirstName:data.verifiedIdentity.firstName,personLastName:data.verifiedIdentity.lastName,personNationalId:data.verifiedIdentity.nationalId,personCountry:data.verifiedIdentity.countryCode,email:data.applicantEmail};var additionalTitles=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pickBy(data.accreditationData.titles,function(value,key){return key!=='en'&&key!=='original';});__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(additionalTitles,function(value,key){accreditationRequestData.titlesAdditional[key]=value;});//TODO: get org data from request details, but not from the list of requests
var request=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(listData,function(request){return request.id===data.id;});if(request&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(request,'organization.id')){accreditationRequestData.orgId=request.organization.id;accreditationRequestData.orgDomain=request.organization.domain;}if(request&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(request,'organization.address.countryCode')){accreditationRequestData.orgCountry=request.organization.address.countryCode;accreditationRequestData.orgContinent=Object(__WEBPACK_IMPORTED_MODULE_5__common_location__["c" /* getContinentByCountry */])(request.organization.address.countryCode,state);}return accreditationRequestData;};

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BusinessAmbassadorDetails_css__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BusinessAmbassadorDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BusinessAmbassadorDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_utils__ = __webpack_require__(12);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ACTION_TYPES={ADD:'add',EDIT:'edit'};var fields=['firstName','lastName','email','phoneNumber','financialData','balanceCurrency'];var BusinessAmbassadorDetails=function(_Component){_inherits(BusinessAmbassadorDetails,_Component);function BusinessAmbassadorDetails(props){_classCallCheck(this,BusinessAmbassadorDetails);var _this=_possibleConstructorReturn(this,(BusinessAmbassadorDetails.__proto__||Object.getPrototypeOf(BusinessAmbassadorDetails)).call(this,props));_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Form */],{className:'self-study-book-form',onSubmit:_this.handleSubmit},_this.renderFormGroups(),_this.renderCurrencyFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn',disabled:_this.saveButtonDisabled()},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,_this.props.actionType===ACTION_TYPES.ADD?__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].add_button:__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button))));};_this.saveButtonDisabled=function(){if(_this.props.actionType===ACTION_TYPES.ADD){return false;}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)){return true;}return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.every(fields,function(field){return _this.props.data.hasOwnProperty(field)?_this.props.data[field]===_this.state[field]:_this.state[field]==='';});};_this.renderFormGroups=function(){var paramsList=[{value:"firstName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)},{value:"lastName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)},{value:"email",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].email_label),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)},{value:"phoneNumber",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].phone_number_label),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].phone_number_label)},{value:"financialData",type:'textarea',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'business_ambassadors.financial_data_label'),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'business_ambassadors.financial_data_label')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.getFormGroup=function(params){if(params.type==='select'){return _this.getSelectFormGroup(params);}if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.state,params.value),onChange:params.onChange||_this.handleChange(params.value),placeholder:params.placeholder,disabled:params.isDisabled,required:params.isRequired},params.content),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* FormFeedback */],null,params.errorMessage||'')));};_this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];}),options:params.content,onSelect:params.onChange||_this.handleChangeSelect(params.value),placeholder:params.placeholder,disabled:params.isDisabled,requiredFieldError:_this.state.requiredFieldError===params.value})));};_this.renderCurrencyFormGroup=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':'balance-currency-select',sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"finance.balance_currency_label")+"*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:'balance-currency-select',selectedOption:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_10__utils_utils__["a" /* Utils */].getCurrenciesOptions(_this.props.currenciesData),function(option){return option.value===_this.state.balanceCurrency;}),options:__WEBPACK_IMPORTED_MODULE_10__utils_utils__["a" /* Utils */].getCurrenciesOptions(_this.props.currenciesData),onSelect:_this.handleChangeSelect("balanceCurrency"),requiredFieldError:_this.state.requiredFieldError==="balanceCurrency"})));};_this.handleChangeSelect=function(fieldName){return function(selectedOption){_this.setState(_defineProperty({},fieldName,selectedOption.value));};};_this.handleChange=function(fieldName){return function(e){_this.setState(_defineProperty({},fieldName,e.target.value));};};_this.handleSubmit=function(e){e.preventDefault();var data={firstName:_this.state.firstName,lastName:_this.state.lastName,financialData:_this.state.financialData,balance:{amount:0,currency:_this.state.balanceCurrency}};if(_this.state.email){data.email=_this.state.email;}if(_this.state.phoneNumber){data.phoneNumber=_this.state.phoneNumber;}switch(_this.props.actionType){case ACTION_TYPES.ADD:_this.props.onProcess(data);break;case ACTION_TYPES.EDIT:_this.props.onProcess(_this.props.id,data);break;default:break;}};_this.state={firstName:'',lastName:'',email:'',phoneNumber:'',financialData:'',balanceCurrency:'USD'};return _this;}_createClass(BusinessAmbassadorDetails,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.actionType===ACTION_TYPES.EDIT&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.id)){this.props.onMount(this.props.id);}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.data)){this.setState({firstName:this.props.data.firstName,lastName:this.props.data.lastName,email:this.props.data.email||'',phoneNumber:this.props.data.phoneNumber||'',financialData:this.props.data.financialData,balanceCurrency:this.props.data.balance.currency});}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(nextProps.data)){this.setState({firstName:nextProps.data.firstName,lastName:nextProps.data.lastName,email:nextProps.data.email||'',phoneNumber:nextProps.data.phoneNumber||'',financialData:nextProps.data.financialData,balanceCurrency:nextProps.data.balance.currency});}}},{key:'render',value:function render(){if(this.props.success){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["d" /* Redirect */],{to:'/business-ambassadors',push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ba-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'business_ambassadors.'+this.props.actionType+'_business_ambassador_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/business-ambassadors',label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].back_button)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ba-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'business_ambassadors.'+this.props.actionType+'_business_ambassador_label')),this.renderContent())));}}]);return BusinessAmbassadorDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BusinessAmbassadorDetails.propTypes={id:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,loading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,actionType:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,success:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,currenciesData:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,onProcess:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,onMount:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["b"] = (BusinessAmbassadorDetails);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGetBusinessAmbassadorByIdFailed */
/* unused harmony export fetchGetBusinessAmbassadorByIdSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGetBusinessAmbassadorById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return onUpdateBusinessAmbassador; });
/* unused harmony export fetchUpdateBusinessAmbassador */
/* unused harmony export getBusinessAmbassador */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadingBusinessAmbassador; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBusinessAmbassadorData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_login__ = __webpack_require__(17);
//- Actions
var fetchGetBusinessAmbassadorByIdFailed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BUSINESS_AMBASSADOR_BY_ID_FAILED');var fetchGetBusinessAmbassadorByIdSuccess=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BUSINESS_AMBASSADOR_BY_ID_SUCCESS');var fetchGetBusinessAmbassadorById=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_GET_BUSINESS_AMBASSADOR_BY_ID',function(id){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].getBusinessAmbassador(id);},function(){return{apiCall:true,onSuccess:fetchGetBusinessAmbassadorByIdSuccess,onFail:fetchGetBusinessAmbassadorByIdFailed,onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});var onUpdateBusinessAmbassador=function onUpdateBusinessAmbassador(id,data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["b" /* fetchSubmitForm */])());dispatch(fetchUpdateBusinessAmbassador(id,data));};};var fetchUpdateBusinessAmbassador=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_UPDATE_BUSINESS_AMBASSADOR',function(id,data){return __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* Api */].updateBusinessAmbassador(id,data);},function(){return{apiCall:true,onSuccess:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["d" /* fetchSubmitFormSuccess */],onFail:__WEBPACK_IMPORTED_MODULE_2__common_submitForm__["c" /* fetchSubmitFormFailed */],onUnauthorized:__WEBPACK_IMPORTED_MODULE_3__account_login__["k" /* logout */],onForbidden:__WEBPACK_IMPORTED_MODULE_3__account_login__["l" /* onForbidden */]};});//- State
var initialState={data:null,error:null,fetching:false};//- Reducers
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])({FETCH_GET_BUSINESS_AMBASSADOR_BY_ID:function FETCH_GET_BUSINESS_AMBASSADOR_BY_ID(state){return Object.assign({},state,{data:null,error:null,fetching:true});},FETCH_GET_BUSINESS_AMBASSADOR_BY_ID_FAILED:function FETCH_GET_BUSINESS_AMBASSADOR_BY_ID_FAILED(state,action){return Object.assign({},state,{data:null,error:action.payload,fetching:false});},FETCH_GET_BUSINESS_AMBASSADOR_BY_ID_SUCCESS:function FETCH_GET_BUSINESS_AMBASSADOR_BY_ID_SUCCESS(state,action){return Object.assign({},state,{data:action.payload,error:null,fetching:false});}},initialState));//- Selectors
var getBusinessAmbassador=function getBusinessAmbassador(state){return state.businessAmbassador;};var loadingBusinessAmbassador=function loadingBusinessAmbassador(state){return getBusinessAmbassador(state).fetching;};var getBusinessAmbassadorData=function getBusinessAmbassadorData(state){return getBusinessAmbassador(state).data;};

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommissionDetails_css__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommissionDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CommissionDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_datepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var requiredSelectFields=['baId','continent','countries'];var fields=['baId','continent','countries','commission','dateFrom','dateTo'];var ACTION_TYPES={ADD:'add',EDIT:'edit'};var CommissionDetails=function(_Component){_inherits(CommissionDetails,_Component);function CommissionDetails(props){_classCallCheck(this,CommissionDetails);var _this=_possibleConstructorReturn(this,(CommissionDetails.__proto__||Object.getPrototypeOf(CommissionDetails)).call(this,props));_this.renderContent=function(){if(_this.props.loading||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.BAsList)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Form */],{className:'commission-from',onSubmit:_this.handleSubmit},_this.renderBAsFormGroup(),_this.renderContinentAndCountriesFormGroups(),_this.renderCommissionFormGroup(),_this.renderPeriodFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn',disabled:_this.saveButtonDisabled()},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,_this.props.actionType===ACTION_TYPES.ADD?__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].add_button:__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button))));};_this.renderBAsFormGroup=function(){if(_this.props.actionType===ACTION_TYPES.ADD){var options=__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getBAsOptions(_this.props.BAsList);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'commissions.ba_label')+"*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(options,function(option){return option.value===_this.state.baId;}),options:options,onSelect:_this.handleChangeBA,isSearchable:false,requiredFieldError:_this.state.requiredFieldError==="baId"})));}else{var baData=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this.props.BAsList,function(elem){return elem.id===_this.props.baId;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'commissions.ba_label')+"*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:'text',value:baData?baData.firstName+" "+baData.lastName:"",readOnly:true})));}};_this.renderContinentAndCountriesFormGroups=function(){var continentOptions=__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continents));var selectedCountriesOptions=__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLocationOptions(_this.state.countries,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].countries));var countriesOptions=__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].countries));return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:'continent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continent_label)+"*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(continentOptions,function(option){return option.value===_this.state.continent;}),options:continentOptions,onSelect:_this.handleChangeContinent,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),disabled:!_this.props.continents,requiredFieldError:_this.state.requiredFieldError==="continent"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:'countries'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,"commissions.countries_label")+"*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{selectedOption:selectedCountriesOptions,options:countriesOptions,onSelect:_this.handleChangeCountries,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),disabled:!_this.props.countries,requiredFieldError:_this.state.requiredFieldError==="countries",isMulti:true,closeMenuOnSelect:false})))];};_this.renderCommissionFormGroup=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'commissions.commission_label')+" (%)*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:'number',min:0.1,max:80,step:0.1,value:_this.state.commission,onChange:_this.handleChangeCommission,required:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'commissions.commission_label')})));};_this.renderPeriodFormGroups=function(){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:'date-from'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'commissions.date_from_label')+"*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_datepicker__["a" /* default */],{customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],null),selected:_this.state.dateFrom,selectsStart:true,startDate:_this.state.dateFrom,endDate:_this.state.dateTo,showMonthDropdown:true,showYearDropdown:true,dropdownMode:'select',onChange:_this.handleChangeDate("dateFrom"),placeholderText:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'commissions.date_from_label'),minDate:__WEBPACK_IMPORTED_MODULE_9_moment_moment___default()(),required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:'date-to'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'commissions.date_to_label')+"*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_datepicker__["a" /* default */],{customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],null),selected:_this.state.dateTo,selectsEnd:true,startDate:_this.state.dateFrom,endDate:_this.state.dateTo,showMonthDropdown:true,showYearDropdown:true,dropdownMode:'select',onChange:_this.handleChangeDate("dateTo"),minDate:_this.state.dateFrom,placeholderText:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'commissions.date_to_label'),required:true})))];};_this.handleChangeBA=function(selectedOption){_this.setState({baId:selectedOption.value});};_this.handleChangeCommission=function(e){var commission=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.round(Number(e.target.value),1);_this.setState({commission:commission});};_this.handleChangeContinent=function(selectedOption){_this.setState({countries:[]});_this.props.onSetContinent(selectedOption.value);};_this.handleChangeCountries=function(selectedOptions){var countries=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(selectedOptions,function(selectedOption){return selectedOption.value;});_this.setState({countries:countries});};_this.handleChangeDate=function(fieldKey){return function(date){_this.setState(_defineProperty({},fieldKey,date));};};_this.saveButtonDisabled=function(){if(_this.props.actionType===ACTION_TYPES.ADD){return false;}if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.data)){return true;}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.every(fields,function(field){if(field==='dateFrom'||field==='dateTo'){return __WEBPACK_IMPORTED_MODULE_9_moment_moment___default()(_this.props.data[field]).format('L')===__WEBPACK_IMPORTED_MODULE_9_moment_moment___default()(_this.state[field]).format('L');}if(field==='countries'){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(_this.props.data[field]),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(_this.state[field]));}return _this.props.data.hasOwnProperty(field)?_this.props.data[field]===_this.state[field]:_this.state[field]==='';});};_this.handleSubmit=function(e){e.preventDefault();if(_this.checkRequiredSelectFields()){return;}var data={businessAmbassadorId:_this.state.baId,countryCodes:_this.state.countries,commissionPercent:_this.state.commission,dateFrom:_this.state.dateFrom.toISOString(),dateTo:_this.state.dateTo.toISOString()};switch(_this.props.actionType){case ACTION_TYPES.ADD:_this.props.onProcess(_this.state.baId,data);break;case ACTION_TYPES.EDIT:_this.props.onProcess(_this.props.baId,_this.props.id,data);break;default:break;}};_this.resetData=function(){_this.setState({baId:'',continent:'',countries:[],commission:'',dateFrom:null,dateTo:null,requiredFieldError:null});_this.props.onSetContinent('');};_this.checkRequiredSelectFields=function(){var error=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(requiredSelectFields,function(field){if(!_this.state[field]||field==="countries"&&_this.state.countries.length===0){return field;}});_this.setState({requiredFieldError:error});return error;};_this.state={baId:'',continent:'',countries:[],commission:'',dateFrom:null,dateTo:null,requiredFieldError:null};return _this;}_createClass(CommissionDetails,[{key:'componentWillMount',value:function componentWillMount(){this.props.onGetBAsList();if(this.props.actionType===ACTION_TYPES.EDIT&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.id)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.baId)){this.props.onGetCommissionData(this.props.baId,this.props.id);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.actionType===ACTION_TYPES.ADD&&!this.props.success&&nextProps.success){this.resetData();}if(nextProps.actionType===ACTION_TYPES.EDIT&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.data)){this.setState({baId:nextProps.data.baId,continent:nextProps.data.continent,countries:nextProps.data.countries,commission:nextProps.data.commission,dateFrom:__WEBPACK_IMPORTED_MODULE_9_moment_moment___default()(nextProps.data.dateFrom),dateTo:__WEBPACK_IMPORTED_MODULE_9_moment_moment___default()(nextProps.data.dateTo)});this.props.onSetContinent(nextProps.data.continent);}if(this.state.continent!==nextProps.currentContinent){this.setState({continent:nextProps.currentContinent});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}},{key:'render',value:function render(){if(this.props.success||this.props.actionType===ACTION_TYPES.EDIT&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.id)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Redirect */],{to:'/commissions'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'commission-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'commissions.'+this.props.actionType+'_commission_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/commissions',label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].back_button)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'commission-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'commissions.'+this.props.actionType+'_commission_label')),this.props.actionType===ACTION_TYPES.ADD?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'add-commission-hint'},__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'commissions.add_commission_hint'))):null,this.renderContent())));}}]);return CommissionDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CommissionDetails.propTypes={translation:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,actionType:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,id:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,baId:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,currentContinent:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,BAsList:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,loading:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,success:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,onProcess:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,onGetBAsList:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,onSetContinent:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,onUnmount:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["b"] = (CommissionDetails);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WireDataModal_css__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WireDataModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__WireDataModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WireDataModal=function(_Component){_inherits(WireDataModal,_Component);function WireDataModal(){_classCallCheck(this,WireDataModal);return _possibleConstructorReturn(this,(WireDataModal.__proto__||Object.getPrototypeOf(WireDataModal)).apply(this,arguments));}_createClass(WireDataModal,[{key:'render',value:function render(){if(!this.props.wireData){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'system_payment.wire_data_modal_label').replace("{name}",this.props.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],null,this.props.wireData),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wire-data-modal-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].okey_button)))));}}]);return WireDataModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);WireDataModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,wireData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (WireDataModal);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAYMENTS_HISTORY_MODE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentsHistoryList_css__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentsHistoryList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PaymentsHistoryList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_paginationComponent_PaginationUniversitiesPaymentsHistory_container__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_paginationComponent_PaginationBAsPaymentsHistory_container__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_datepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commentModal_CommentModal_container__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _NO_DATA_LABEL,_NAME_LABEL;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PAYMENTS_HISTORY_MODE={BA:"BA",UNI:"UNI"};var NO_DATA_LABEL=(_NO_DATA_LABEL={},_defineProperty(_NO_DATA_LABEL,PAYMENTS_HISTORY_MODE.BA,"no_payments_for_ba_s_label"),_defineProperty(_NO_DATA_LABEL,PAYMENTS_HISTORY_MODE.UNI,"no_payments_for_uni_s_label"),_NO_DATA_LABEL);var NAME_LABEL=(_NAME_LABEL={},_defineProperty(_NAME_LABEL,PAYMENTS_HISTORY_MODE.BA,"ba_label"),_defineProperty(_NAME_LABEL,PAYMENTS_HISTORY_MODE.UNI,"uni_label"),_NAME_LABEL);var PaymentsHistoryList=function(_Component){_inherits(PaymentsHistoryList,_Component);function PaymentsHistoryList(props){_classCallCheck(this,PaymentsHistoryList);var _this=_possibleConstructorReturn(this,(PaymentsHistoryList.__proto__||Object.getPrototypeOf(PaymentsHistoryList)).call(this,props));_this.onShowCommentModal=function(comment){return function(){_this.setState({selectedRowData:comment});_this.props.onShowComment();};};_this.renderFilters=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filters-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-from-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'date-from-label'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'system_payment.filter_date_from_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_datepicker__["a" /* default */],{className:'date-filter',customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],null),selected:_this.props.dateFromFilter,selectsStart:true,startDate:_this.props.dateFromFilter,endDate:_this.props.dateToFilter,showMonthDropdown:true,showYearDropdown:true,dropdownMode:'select',onChange:_this.props.onChangeDateFromFilter,maxDate:__WEBPACK_IMPORTED_MODULE_9_moment___default()()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-to-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'date-to-label'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'system_payment.filter_date_to_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_datepicker__["a" /* default */],{className:'date-filter',customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],null),selected:_this.props.dateToFilter,selectsEnd:true,startDate:_this.props.dateFromFilter,endDate:_this.props.dateToFilter,showMonthDropdown:true,showYearDropdown:true,dropdownMode:'select',onChange:function onChange(value){return _this.props.onChangeDateToFilter(__WEBPACK_IMPORTED_MODULE_9_moment___default()(value).endOf('day'));},minDate:_this.props.dateFromFilter,maxDate:__WEBPACK_IMPORTED_MODULE_9_moment___default()()}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'name-label'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'system_payment.name_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{className:'name-input',type:'text',value:_this.props.nameFilter,onChange:_this.onChangeNameFilter}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filters-container'},_this.renderContinentAndCountryFilter()));};_this.renderContinentAndCountryFilter=function(){var continentsOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_12__utils_utils__["a" /* Utils */].getLocationOptions(Object.keys(_this.props.locationData),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continents))));var countriesOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_12__utils_utils__["a" /* Utils */].getLocationOptions(_this.state.continentFilter?_this.props.locationData[_this.state.continentFilter]:null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].countries))));return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'continent-filter-container',key:'continent-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continent_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'continent-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(continentsOptions,function(option){return option.value===_this.state.continentFilter;}),options:continentsOptions,onSelect:_this.handleChangeContinentSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'country-filter-container',key:'country-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'country-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(countriesOptions,function(option){return option.value===_this.state.countryFilter;}),options:countriesOptions,onSelect:_this.handleChangeCountrySelect}))];};_this.handleChangeContinentSelect=function(selectedOption){if(_this.state.continentFilter!==selectedOption.value){_this.props.onChangeContinentFilter(selectedOption.value);_this.setState({countryFilter:null});}_this.setState({continentFilter:selectedOption.value});};_this.handleChangeCountrySelect=function(selectedOption){if(!selectedOption.value){_this.props.onChangeContinentFilter(_this.state.continentFilter);}else{_this.props.onChangeCountryFilter(selectedOption.value);}_this.setState({countryFilter:selectedOption.value});};_this.onChangeNameFilter=function(e){_this.props.onChangeNameFilter(e.target.value);};_this.state={selectedRowData:null,continentFilter:null,countryFilter:null};return _this;}_createClass(PaymentsHistoryList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'render',value:function render(){if(this.props.loading){}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'history-payments-component-container'},this.renderFilters(),this.props.mode===PAYMENTS_HISTORY_MODE.UNI?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_paginationComponent_PaginationUniversitiesPaymentsHistory_container__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_paginationComponent_PaginationBAsPaymentsHistory_container__["a" /* default */],null),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commentModal_CommentModal_container__["a" /* default */],{data:this.state.selectedRowData}));}},{key:'renderContent',value:function renderContent(){if(this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'history-payments-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.props.data)||this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'history-payments-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'system_payment.'+NO_DATA_LABEL[this.props.mode])));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["N" /* Table */],{className:'history-payments-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'system_payment.'+NAME_LABEL[this.props.mode])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'system_payment.total_aggregated_pay_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'system_payment.amount_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'system_payment.payment_date_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'comment-th'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'system_payment.comment_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.renderPaymentsData()));}},{key:'renderPaymentsData',value:function renderPaymentsData(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(this.props.data,function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'name-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'system_payment.'+NAME_LABEL[_this2.props.mode])+':'},data.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'total-pay-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'system_payment.total_aggregated_pay_label')+':'},data.totalPay.map(function(pay){return pay.amount+' '+__WEBPACK_IMPORTED_MODULE_6__constants_constants__["g" /* CURRENCIES */][pay.currency];}).join(', ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'amount-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'system_payment.amount_label')+':'},data.paymentAmount.amount+' '+__WEBPACK_IMPORTED_MODULE_6__constants_constants__["g" /* CURRENCIES */][data.paymentAmount.currency]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'payment-date-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'system_payment.payment_date_label')+':'},__WEBPACK_IMPORTED_MODULE_9_moment___default()(data.paymentDate).format('L')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'comment-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'system_payment.comment_label')+':'},!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(data.comment)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{color:'link',size:'sm',onClick:_this2.onShowCommentModal(data.comment)},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'system_payment.show_label')):null));});}}]);return PaymentsHistoryList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PaymentsHistoryList.propTypes={translation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,mode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,loading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,nameFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,dateFromFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,dateToFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,locationData:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,onMount:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onChangeDateFromFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onChangeDateToFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onChangeNameFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onShowComment:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onChangeContinentFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onChangeCountryFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["b"] = (PaymentsHistoryList);

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(321);
module.exports = __webpack_require__(326);


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(322).enable();
  window.Promise = __webpack_require__(324);
}

// fetch() polyfill for making API calls.
__webpack_require__(325);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(114);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(200);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(200);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 325 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_observable__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_thunk__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_App_container__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__registerServiceWorker__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_index__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_datepicker_dist_react_datepicker_css__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_datepicker_dist_react_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_datepicker_dist_react_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_common_localization__ = __webpack_require__(0);
// import {fetchGetTranslations} from "./reducers/common/localization";
var epicMiddleware=Object(__WEBPACK_IMPORTED_MODULE_4_redux_observable__["b" /* createEpicMiddleware */])();var store=Object(__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* createStore */])(__WEBPACK_IMPORTED_MODULE_8__reducers_index__["b" /* rootReducer */],Object(__WEBPACK_IMPORTED_MODULE_2_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_5_redux_thunk__["a" /* default */],epicMiddleware));epicMiddleware.run(__WEBPACK_IMPORTED_MODULE_8__reducers_index__["a" /* rootEpic */]);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__reducers_common_location__["b" /* fetchGetCountries */])());// TODO: use it when improve localization in future
// store.dispatch(fetchGetTranslations());
store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__reducers_common_localization__["a" /* changeLanguage */])(Object(__WEBPACK_IMPORTED_MODULE_14__reducers_common_localization__["c" /* getDefaultLanguage */])()));var WidgetContainer=Object(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["g" /* withRouter */])(__WEBPACK_IMPORTED_MODULE_6__components_App_container__["a" /* default */]);__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WidgetContainer,null))),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_7__registerServiceWorker__["a" /* unregister */])();

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.5.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(114),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.async_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112;n&&Symbol.for("react.placeholder");
var z="function"===typeof Symbol&&Symbol.iterator;function A(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var k=[d,c,e,g,h,f],l=0;a=Error(b.replace(/%s/g,function(){return k[l++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);A(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null,currentDispatcher:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
function L(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];e.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:I.current}}
function M(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=z&&a[z]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function V(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=M(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function W(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,aa,b);R(b)}function ba(a,b){var d=I.currentDispatcher;null===d?B("277"):void 0;return d.readContext(a,b)}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];W(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,V,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];W(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,Provider:null,Consumer:null,unstable_read:null};a.Provider={$$typeof:v,_context:a};a.Consumer=a;a.unstable_read=ba.bind(null,a);return a},forwardRef:function(a){return{$$typeof:y,render:a}},Fragment:r,StrictMode:t,unstable_AsyncMode:x,unstable_Profiler:u,createElement:L,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);
var k=void 0;a.type&&a.type.defaultProps&&(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];e.children=k}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.5.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,
assign:m}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.5.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(1),n=__webpack_require__(114),ba=__webpack_require__(329);function ca(a,b,c,d,e,f,g,k){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var h=[c,d,e,f,g,k],l=0;a=Error(b.replace(/%s/g,function(){return h[l++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function w(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:w("227");function da(a,b,c,d,e,f,g,k,h){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}
var ea=!1,fa=null,ha=!1,ia=null,ja={onError:function(a){ea=!0;fa=a}};function ka(a,b,c,d,e,f,g,k,h){ea=!1;fa=null;da.apply(ja,arguments)}function la(a,b,c,d,e,f,g,k,h){ka.apply(this,arguments);if(ea){if(ea){var l=fa;ea=!1;fa=null}else w("198"),l=void 0;ha||(ha=!0,ia=l)}}var ma=null,na={};
function oa(){if(ma)for(var a in na){var b=na[a],c=ma.indexOf(a);-1<c?void 0:w("96",a);if(!pa[c]){b.extractEvents?void 0:w("97",a);pa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,k=d;qa.hasOwnProperty(k)?w("99",k):void 0;qa[k]=f;var h=f.phasedRegistrationNames;if(h){for(e in h)h.hasOwnProperty(e)&&ra(h[e],g,k);e=!0}else f.registrationName?(ra(f.registrationName,g,k),e=!0):e=!1;e?void 0:w("98",d,a)}}}}
function ra(a,b,c){sa[a]?w("100",a):void 0;sa[a]=b;ta[a]=b.eventTypes[c].dependencies}var pa=[],qa={},sa={},ta={},ua=null,va=null,wa=null;function xa(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=wa(d);la(b,c,void 0,a);a.currentTarget=null}function ya(a,b){null==b?w("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function za(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Aa=null;function Ba(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)xa(a,b,c[e],d[e]);else c&&xa(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ca(a){return Ba(a,!0)}function Da(a){return Ba(a,!1)}
var Ea={injectEventPluginOrder:function(a){ma?w("101"):void 0;ma=Array.prototype.slice.call(a);oa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];na.hasOwnProperty(c)&&na[c]===d||(na[c]?w("102",c):void 0,na[c]=d,b=!0)}b&&oa()}};
function Fa(a,b){var c=a.stateNode;if(!c)return null;var d=ua(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?w("231",b,typeof c):void 0;
return c}function Ga(a,b){null!==a&&(Aa=ya(Aa,a));a=Aa;Aa=null;if(a&&(b?za(a,Ca):za(a,Da),Aa?w("95"):void 0,ha))throw b=ia,ha=!1,ia=null,b;}var Ha=Math.random().toString(36).slice(2),Ia="__reactInternalInstance$"+Ha,Ja="__reactEventHandlers$"+Ha;function Ka(a){if(a[Ia])return a[Ia];for(;!a[Ia];)if(a.parentNode)a=a.parentNode;else return null;a=a[Ia];return 7===a.tag||8===a.tag?a:null}function La(a){a=a[Ia];return!a||7!==a.tag&&8!==a.tag?null:a}
function Ma(a){if(7===a.tag||8===a.tag)return a.stateNode;w("33")}function Na(a){return a[Ja]||null}function Oa(a){do a=a.return;while(a&&7!==a.tag);return a?a:null}function Pa(a,b,c){if(b=Fa(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a)}
function Qa(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Oa(b);for(b=c.length;0<b--;)Pa(c[b],"captured",a);for(b=0;b<c.length;b++)Pa(c[b],"bubbled",a)}}function Ra(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Fa(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a))}function Ta(a){a&&a.dispatchConfig.registrationName&&Ra(a._targetInst,null,a)}
function Ua(a){za(a,Qa)}var Va=!("undefined"===typeof window||!window.document||!window.document.createElement);function Wa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ya={animationend:Wa("Animation","AnimationEnd"),animationiteration:Wa("Animation","AnimationIteration"),animationstart:Wa("Animation","AnimationStart"),transitionend:Wa("Transition","TransitionEnd")},Za={},$a={};
Va&&($a=document.createElement("div").style,"AnimationEvent"in window||(delete Ya.animationend.animation,delete Ya.animationiteration.animation,delete Ya.animationstart.animation),"TransitionEvent"in window||delete Ya.transitionend.transition);function ab(a){if(Za[a])return Za[a];if(!Ya[a])return a;var b=Ya[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in $a)return Za[a]=b[c];return a}
var bb=ab("animationend"),cb=ab("animationiteration"),db=ab("animationstart"),eb=ab("transitionend"),fb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),gb=null,hb=null,ib=null;
function jb(){if(ib)return ib;var a,b=hb,c=b.length,d,e="value"in gb?gb.value:gb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return ib=e.slice(a,1<d?1-d:void 0)}function kb(){return!0}function lb(){return!1}
function C(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?kb:lb;this.isPropagationStopped=lb;return this}
n(C.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=kb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=kb)},persist:function(){this.isPersistent=kb},isPersistent:lb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=lb;this._dispatchInstances=this._dispatchListeners=null}});C.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
C.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;mb(c);return c};mb(C);function nb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function ob(a){a instanceof this?void 0:w("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function mb(a){a.eventPool=[];a.getPooled=nb;a.release=ob}var pb=C.extend({data:null}),qb=C.extend({data:null}),rb=[9,13,27,32],sb=Va&&"CompositionEvent"in window,tb=null;Va&&"documentMode"in document&&(tb=document.documentMode);
var ub=Va&&"TextEvent"in window&&!tb,vb=Va&&(!sb||tb&&8<tb&&11>=tb),wb=String.fromCharCode(32),xb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},yb=!1;
function zb(a,b){switch(a){case "keyup":return-1!==rb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Ab(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Bb=!1;function Cb(a,b){switch(a){case "compositionend":return Ab(b);case "keypress":if(32!==b.which)return null;yb=!0;return wb;case "textInput":return a=b.data,a===wb&&yb?null:a;default:return null}}
function Db(a,b){if(Bb)return"compositionend"===a||!sb&&zb(a,b)?(a=jb(),ib=hb=gb=null,Bb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return vb&&"ko"!==b.locale?null:b.data;default:return null}}
var Eb={eventTypes:xb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(sb)b:{switch(a){case "compositionstart":e=xb.compositionStart;break b;case "compositionend":e=xb.compositionEnd;break b;case "compositionupdate":e=xb.compositionUpdate;break b}e=void 0}else Bb?zb(a,c)&&(e=xb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=xb.compositionStart);e?(vb&&"ko"!==c.locale&&(Bb||e!==xb.compositionStart?e===xb.compositionEnd&&Bb&&(f=jb()):(gb=d,hb="value"in gb?gb.value:gb.textContent,Bb=
!0)),e=pb.getPooled(e,b,c,d),f?e.data=f:(f=Ab(c),null!==f&&(e.data=f)),Ua(e),f=e):f=null;(a=ub?Cb(a,c):Db(a,c))?(b=qb.getPooled(xb.beforeInput,b,c,d),b.data=a,Ua(b)):b=null;return null===f?b:null===b?f:[f,b]}},Fb=null,Gb=null,Hb=null;function Ib(a){if(a=va(a)){"function"!==typeof Fb?w("280"):void 0;var b=ua(a.stateNode);Fb(a.stateNode,a.type,b)}}function Jb(a){Gb?Hb?Hb.push(a):Hb=[a]:Gb=a}function Kb(){if(Gb){var a=Gb,b=Hb;Hb=Gb=null;Ib(a);if(b)for(a=0;a<b.length;a++)Ib(b[a])}}
function Lb(a,b){return a(b)}function Mb(a,b,c){return a(b,c)}function Nb(){}var Ob=!1;function Pb(a,b){if(Ob)return a(b);Ob=!0;try{return Lb(a,b)}finally{if(Ob=!1,null!==Gb||null!==Hb)Nb(),Kb()}}var Qb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Rb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Qb[a.type]:"textarea"===b?!0:!1}
function Sb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Tb(a){if(!Va)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Ub(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Vb(a){var b=Ub(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Wb(a){a._valueTracker||(a._valueTracker=Vb(a))}function Xb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Ub(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var Yb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,Zb=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,$b=E?Symbol.for("react.element"):60103,ac=E?Symbol.for("react.portal"):60106,bc=E?Symbol.for("react.fragment"):60107,cc=E?Symbol.for("react.strict_mode"):60108,dc=E?Symbol.for("react.profiler"):60114,ec=E?Symbol.for("react.provider"):60109,fc=E?Symbol.for("react.context"):60110,gc=E?Symbol.for("react.async_mode"):60111,hc=E?Symbol.for("react.forward_ref"):60112,ic=E?Symbol.for("react.placeholder"):
60113,jc="function"===typeof Symbol&&Symbol.iterator;function kc(a){if(null===a||"object"!==typeof a)return null;a=jc&&a[jc]||a["@@iterator"];return"function"===typeof a?a:null}
function lc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case gc:return"AsyncMode";case bc:return"Fragment";case ac:return"Portal";case dc:return"Profiler";case cc:return"StrictMode";case ic:return"Placeholder"}if("object"===typeof a){switch(a.$$typeof){case fc:return"Context.Consumer";case ec:return"Context.Provider";case hc:return a=a.render,a=a.displayName||a.name||"",""!==a?"ForwardRef("+a+")":"ForwardRef"}if("function"===
typeof a.then&&(a=1===a._reactStatus?a._reactResult:null))return lc(a)}return null}function mc(a){var b="";do{a:switch(a.tag){case 4:case 0:case 1:case 2:case 3:case 7:case 10:var c=a._debugOwner,d=a._debugSource,e=lc(a.type);var f=null;c&&(f=lc(c.type));c=e;e="";d?e=" (at "+d.fileName.replace(Zb,"")+":"+d.lineNumber+")":f&&(e=" (created by "+f+")");f="\n    in "+(c||"Unknown")+e;break a;default:f=""}b+=f;a=a.return}while(a);return b}
var nc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,pc=Object.prototype.hasOwnProperty,qc={},rc={};
function sc(a){if(pc.call(rc,a))return!0;if(pc.call(qc,a))return!1;if(nc.test(a))return rc[a]=!0;qc[a]=!0;return!1}function tc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function uc(a,b,c,d){if(null===b||"undefined"===typeof b||tc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function F(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var G={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){G[a]=new F(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];G[b]=new F(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){G[a]=new F(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){G[a]=new F(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){G[a]=new F(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){G[a]=new F(a,3,!0,a,null)});
["capture","download"].forEach(function(a){G[a]=new F(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){G[a]=new F(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){G[a]=new F(a,5,!1,a.toLowerCase(),null)});var vc=/[\-:]([a-z])/g;function wc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(vc,
wc);G[b]=new F(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(vc,wc);G[b]=new F(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(vc,wc);G[b]=new F(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});G.tabIndex=new F("tabIndex",1,!1,"tabindex",null);
function xc(a,b,c,d){var e=G.hasOwnProperty(b)?G[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(uc(b,c,e,d)&&(c=null),d||null===e?sc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function yc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function zc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=yc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cc(a,b){b=b.checked;null!=b&&xc(a,"checked",b,!1)}
function Dc(a,b){Cc(a,b);var c=yc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Ec(a,b.type,c):b.hasOwnProperty("defaultValue")&&Ec(a,b.type,yc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Fc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Ec(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Gc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Hc(a,b,c){a=C.getPooled(Gc.change,a,b,c);a.type="change";Jb(c);Ua(a);return a}var Ic=null,Jc=null;function Kc(a){Ga(a,!1)}
function Lc(a){var b=Ma(a);if(Xb(b))return a}function Mc(a,b){if("change"===a)return b}var Nc=!1;Va&&(Nc=Tb("input")&&(!document.documentMode||9<document.documentMode));function Oc(){Ic&&(Ic.detachEvent("onpropertychange",Pc),Jc=Ic=null)}function Pc(a){"value"===a.propertyName&&Lc(Jc)&&(a=Hc(Jc,a,Sb(a)),Pb(Kc,a))}function Qc(a,b,c){"focus"===a?(Oc(),Ic=b,Jc=c,Ic.attachEvent("onpropertychange",Pc)):"blur"===a&&Oc()}function Rc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Lc(Jc)}
function Sc(a,b){if("click"===a)return Lc(b)}function Tc(a,b){if("input"===a||"change"===a)return Lc(b)}
var Uc={eventTypes:Gc,_isInputEventSupported:Nc,extractEvents:function(a,b,c,d){var e=b?Ma(b):window,f=void 0,g=void 0,k=e.nodeName&&e.nodeName.toLowerCase();"select"===k||"input"===k&&"file"===e.type?f=Mc:Rb(e)?Nc?f=Tc:(f=Rc,g=Qc):(k=e.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Sc);if(f&&(f=f(a,b)))return Hc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Ec(e,"number",e.value)}},Vc=C.extend({view:null,detail:null}),Wc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Xc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Wc[a])?!!b[a]:!1}function Yc(){return Xc}
var Zc=0,$c=0,ad=!1,bd=!1,cd=Vc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Yc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Zc;Zc=a.screenX;return ad?"mousemove"===a.type?a.screenX-b:0:(ad=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=$c;$c=a.screenY;return bd?"mousemove"===a.type?a.screenY-b:0:(bd=!0,0)}}),dd=cd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),ed={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},fd={eventTypes:ed,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ka(b):null):f=null;if(f===b)return null;var g=void 0,k=void 0,h=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)g=cd,k=ed.mouseLeave,h=ed.mouseEnter,l="mouse";
else if("pointerout"===a||"pointerover"===a)g=dd,k=ed.pointerLeave,h=ed.pointerEnter,l="pointer";var m=null==f?e:Ma(f);e=null==b?e:Ma(b);a=g.getPooled(k,f,c,d);a.type=l+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(h,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;l=0;for(g=b;g;g=Oa(g))l++;g=0;for(h=e;h;h=Oa(h))g++;for(;0<l-g;)b=Oa(b),l--;for(;0<g-l;)e=Oa(e),g--;for(;l--;){if(b===e||b===e.alternate)break a;b=Oa(b);e=Oa(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
f.alternate;if(null!==l&&l===e)break;b.push(f);f=Oa(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=Oa(d)}for(d=0;d<b.length;d++)Ra(b[d],"bubbled",a);for(d=f.length;0<d--;)Ra(f[d],"captured",c);return[a,c]}},gd=Object.prototype.hasOwnProperty;function hd(a,b){return a===b?0!==a||0!==b||1/a===1/b:a!==a&&b!==b}
function id(a,b){if(hd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!gd.call(b,c[d])||!hd(a[c[d]],b[c[d]]))return!1;return!0}function jd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 5===b.tag?2:3}function kd(a){2!==jd(a)?w("188"):void 0}
function ld(a){var b=a.alternate;if(!b)return b=jd(a),3===b?w("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return kd(e),a;if(g===d)return kd(e),b;g=g.sibling}w("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var k=e.child;k;){if(k===c){g=!0;c=e;d=f;break}if(k===d){g=!0;d=e;c=f;break}k=k.sibling}if(!g){for(k=f.child;k;){if(k===c){g=!0;c=f;d=e;break}if(k===d){g=!0;d=f;c=e;break}k=k.sibling}g?
void 0:w("189")}}c.alternate!==d?w("190"):void 0}5!==c.tag?w("188"):void 0;return c.stateNode.current===c?a:b}function md(a){a=ld(a);if(!a)return null;for(var b=a;;){if(7===b.tag||8===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var nd=C.extend({animationName:null,elapsedTime:null,pseudoElement:null}),od=C.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),pd=Vc.extend({relatedTarget:null});function qd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var rd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},sd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},td=Vc.extend({key:function(a){if(a.key){var b=rd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=qd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?sd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Yc,charCode:function(a){return"keypress"===
a.type?qd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?qd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),ud=cd.extend({dataTransfer:null}),vd=Vc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Yc}),wd=C.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),xd=cd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),yd=[["abort","abort"],[bb,"animationEnd"],[cb,"animationIteration"],[db,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[eb,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],zd={},Ad={};function Bd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};zd[a]=b;Ad[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Bd(a,!0)});yd.forEach(function(a){Bd(a,!1)});
var Cd={eventTypes:zd,isInteractiveTopLevelEventType:function(a){a=Ad[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Ad[a];if(!e)return null;switch(a){case "keypress":if(0===qd(c))return null;case "keydown":case "keyup":a=td;break;case "blur":case "focus":a=pd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=cd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
ud;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=vd;break;case bb:case cb:case db:a=nd;break;case eb:a=wd;break;case "scroll":a=Vc;break;case "wheel":a=xd;break;case "copy":case "cut":case "paste":a=od;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=dd;break;default:a=C}b=a.getPooled(e,b,c,d);Ua(b);return b}},Dd=Cd.isInteractiveTopLevelEventType,
Ed=[];function Fd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=5!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ka(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Sb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,k=0;k<pa.length;k++){var h=pa[k];h&&(h=h.extractEvents(d,b,f,e))&&(g=ya(g,h))}Ga(g,!1)}}var Gd=!0;
function H(a,b){if(!b)return null;var c=(Dd(a)?Hd:Id).bind(null,a);b.addEventListener(a,c,!1)}function Jd(a,b){if(!b)return null;var c=(Dd(a)?Hd:Id).bind(null,a);b.addEventListener(a,c,!0)}function Hd(a,b){Mb(Id,a,b)}
function Id(a,b){if(Gd){var c=Sb(b);c=Ka(c);null===c||"number"!==typeof c.tag||2===jd(c)||(c=null);if(Ed.length){var d=Ed.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Pb(Fd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Ed.length&&Ed.push(a)}}}var Kd={},Ld=0,Md="_reactListenersID"+(""+Math.random()).slice(2);
function Nd(a){Object.prototype.hasOwnProperty.call(a,Md)||(a[Md]=Ld++,Kd[a[Md]]={});return Kd[a[Md]]}function Pd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Qd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Rd(a,b){var c=Qd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Qd(c)}}function Sd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Sd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Td(){for(var a=window,b=Pd();b instanceof a.HTMLIFrameElement;){try{a=b.contentDocument.defaultView}catch(c){break}b=Pd(a.document)}return b}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=Va&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if($d||null==Xd||Xd!==Pd(c))return null;c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Zd&&id(Zd,c)?null:(Zd=c,a=C.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ua(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Nd(e);f=ta.onSelect;for(var g=0;g<f.length;g++){var k=f[g];if(!e.hasOwnProperty(k)||!e[k]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ma(b):window;switch(a){case "focus":if(Rb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":case "dragend":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Ea.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ua=Na;va=La;wa=Ma;Ea.injectEventPluginsByName({SimpleEventPlugin:Cd,EnterLeaveEventPlugin:fd,ChangeEventPlugin:Uc,SelectEventPlugin:be,BeforeInputEventPlugin:Eb});function ce(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function de(a,b){a=n({children:void 0},b);if(b=ce(b.children))a.children=b;return a}function ee(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+yc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function fe(a,b){null!=b.dangerouslySetInnerHTML?w("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ge(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?w("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:w("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:yc(c)}}
function he(a,b){var c=yc(b.value);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=""+yc(b.defaultValue))}function ie(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var je={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function ke(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function le(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ke(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var me=void 0,ne=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==je.svg||"innerHTML"in a)a.innerHTML=b;else{me=me||document.createElement("div");me.innerHTML="<svg>"+b+"</svg>";for(b=me.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function oe(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var pe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},qe=["Webkit","ms","Moz","O"];Object.keys(pe).forEach(function(a){qe.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);pe[b]=pe[a]})});
function re(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||pe.hasOwnProperty(e)&&pe[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var se=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function te(a,b){b&&(se[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?w("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?w("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:w("61")),null!=b.style&&"object"!==typeof b.style?w("62",""):void 0)}
function ue(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function ve(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Nd(a);b=ta[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Jd("scroll",a);break;case "focus":case "blur":Jd("focus",a);Jd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Tb(e)&&Jd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===fb.indexOf(e)&&H(e,a)}c[e]=!0}}}function we(){}var xe=null,ye=null;
function ze(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ae(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}function Be(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}
function Ce(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var De=[],Ee=-1;function I(a){0>Ee||(a.current=De[Ee],De[Ee]=null,Ee--)}function J(a,b){Ee++;De[Ee]=a.current;a.current=b}var Fe={},K={current:Fe},L={current:!1},Ge=Fe;
function He(a,b){var c=a.type.contextTypes;if(!c)return Fe;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function M(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ie(a){I(L,a);I(K,a)}function Je(a){I(L,a);I(K,a)}
function Ke(a,b,c){K.current!==Fe?w("168"):void 0;J(K,b,a);J(L,c,a)}function Le(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:w("108",lc(b)||"Unknown",e);return n({},c,d)}function Me(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Fe;Ge=K.current;J(K,b,a);J(L,L.current,a);return!0}
function Ne(a,b,c){var d=a.stateNode;d?void 0:w("169");c?(b=Le(a,b,Ge),d.__reactInternalMemoizedMergedChildContext=b,I(L,a),I(K,a),J(K,b,a)):I(L,a);J(L,c,a)}var Oe=null,Pe=null;function Qe(a){return function(b){try{return a(b)}catch(c){}}}
function Re(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Oe=Qe(function(a){return b.onCommitFiberRoot(c,a)});Pe=Qe(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Se(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.firstContextDependency=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}
function Te(a){a=a.prototype;return"object"===typeof a&&null!==a&&"object"===typeof a.isReactComponent&&null!==a.isReactComponent}
function Ue(a,b,c){var d=a.alternate;null===d?(d=new Se(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.childExpirationTime=a.childExpirationTime;d.expirationTime=b!==a.pendingProps?c:a.expirationTime;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.firstContextDependency=a.firstContextDependency;d.sibling=a.sibling;
d.index=a.index;d.ref=a.ref;return d}
function Ve(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=Te(d)?2:4;else if("string"===typeof d)f=7;else a:switch(d){case bc:return We(a.children,b,c,e);case gc:f=10;b|=3;break;case cc:f=10;b|=2;break;case dc:return d=new Se(15,a,e,b|4),d.type=dc,d.expirationTime=c,d;case ic:f=16;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case ec:f=12;break a;case fc:f=11;break a;case hc:f=13;break a;default:if("function"===typeof d.then){f=4;break a}}w("130",
null==d?d:typeof d,"")}b=new Se(f,a,e,b);b.type=d;b.expirationTime=c;return b}function We(a,b,c,d){a=new Se(9,a,d,b);a.expirationTime=c;return a}function Xe(a,b,c){a=new Se(8,a,null,b);a.expirationTime=c;return a}function Ye(a,b,c){b=new Se(6,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Ze(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c>b?a.earliestPendingTime=b:a.latestPendingTime<b&&(a.latestPendingTime=b);$e(b,a)}function $e(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d>a)&&(e=d);a=e;0!==a&&0!==c&&c<a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}var af=!1;
function bf(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function cf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function df(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function ef(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function ff(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bf(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bf(a.memoizedState),e=c.updateQueue=bf(c.memoizedState)):d=a.updateQueue=cf(e):null===e&&(e=c.updateQueue=cf(d));null===e||d===e?ef(d,b):null===d.lastUpdate||null===e.lastUpdate?(ef(d,b),ef(e,b)):(ef(d,b),e.lastUpdate=b)}
function gf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bf(a.memoizedState):hf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function hf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=cf(b));return b}
function jf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:af=!0}return d}
function kf(a,b,c,d,e){af=!1;b=hf(a,b);for(var f=b.baseState,g=null,k=0,h=b.firstUpdate,l=f;null!==h;){var m=h.expirationTime;if(m>e){if(null===g&&(g=h,f=l),0===k||k>m)k=m}else l=jf(a,b,h,l,c,d),null!==h.callback&&(a.effectTag|=32,h.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=h:(b.lastEffect.nextEffect=h,b.lastEffect=h));h=h.next}m=null;for(h=b.firstCapturedUpdate;null!==h;){var t=h.expirationTime;if(t>e){if(null===m&&(m=h,null===g&&(f=l)),0===k||k>t)k=t}else l=jf(a,b,h,l,c,d),
null!==h.callback&&(a.effectTag|=32,h.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=h:(b.lastCapturedEffect.nextEffect=h,b.lastCapturedEffect=h));h=h.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=k;a.memoizedState=l}
function lf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);mf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;mf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function mf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?w("191",c):void 0;c.call(d)}a=a.nextEffect}}
function nf(a,b){return{value:a,source:b,stack:mc(b)}}var of={current:null},pf=null,qf=null,rf=null;function sf(a,b){var c=a.type._context;J(of,c._currentValue,a);c._currentValue=b}function tf(a){var b=of.current;I(of,a);a.type._context._currentValue=b}function uf(a){pf=a;rf=qf=null;a.firstContextDependency=null}
function vf(a,b){if(rf!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)rf=a,b=1073741823;b={context:a,observedBits:b,next:null};null===qf?(null===pf?w("277"):void 0,pf.firstContextDependency=qf=b):qf=qf.next=b}return a._currentValue}var wf={},N={current:wf},xf={current:wf},yf={current:wf};function zf(a){a===wf?w("174"):void 0;return a}
function Af(a,b){J(yf,b,a);J(xf,a,a);J(N,wf,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:le(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=le(b,c)}I(N,a);J(N,b,a)}function Bf(a){I(N,a);I(xf,a);I(yf,a)}function Cf(a){zf(yf.current);var b=zf(N.current);var c=le(b,a.type);b!==c&&(J(xf,a,a),J(N,c,a))}function Df(a){xf.current===a&&(I(N,a),I(xf,a))}var Ef=(new aa.Component).refs;
function Ff(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Jf={isMounted:function(a){return(a=a._reactInternalFiber)?2===jd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gf();d=Hf(d,a);var e=df(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);ff(a,e);If(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gf();d=Hf(d,a);var e=df(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);ff(a,e);If(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gf();c=Hf(c,a);var d=df(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);ff(a,d);If(a,c)}};function Kf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!id(c,d)||!id(e,f):!0}function Lf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jf.enqueueReplaceState(b,b.state,null)}
function Mf(a,b,c,d){var e=a.stateNode,f=M(b)?Ge:K.current;e.props=c;e.state=a.memoizedState;e.refs=Ef;e.context=He(a,f);f=a.updateQueue;null!==f&&(kf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Ff(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&
e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(kf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Nf=Array.isArray;
function Of(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag&&3!==c.tag?w("110"):void 0,d=c.stateNode);d?void 0:w("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ef&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?w("284"):void 0;c._owner?void 0:w("254",a)}return a}
function Pf(a,b){"textarea"!==a.type&&w("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Qf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Ue(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function k(a,b,c,d){if(null===b||8!==b.tag)return b=Xe(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function h(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Of(a,b,c),d.return=a,d;d=Ve(c,a.mode,d);d.ref=Of(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||6!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Ye(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||9!==b.tag)return b=We(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function t(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Xe(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case $b:return c=Ve(b,a.mode,c),c.ref=Of(a,null,b),c.return=a,c;case ac:return b=Ye(b,a.mode,c),b.return=a,b}if(Nf(b)||kc(b))return b=We(b,a.mode,c,null),b.return=
a,b;Pf(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:k(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case $b:return c.key===e?c.type===bc?m(a,b,c.props.children,d,e):h(a,b,c,d):null;case ac:return c.key===e?l(a,b,c,d):null}if(Nf(c)||kc(c))return null!==e?null:m(a,b,c,d,null);Pf(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,k(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case $b:return a=a.get(null===d.key?c:d.key)||null,d.type===bc?m(b,a,d.props.children,e,d.key):h(b,a,d,e);case ac:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Nf(d)||kc(d))return a=a.get(c)||null,m(b,a,d,e,null);Pf(b,d)}return null}function y(e,g,h,k){for(var l=null,r=null,p=g,m=g=0,q=null;null!==p&&m<h.length;m++){p.index>m?(q=p,p=null):q=p.sibling;var v=x(e,p,h[m],k);if(null===v){null===p&&(p=q);break}a&&p&&null===v.alternate&&b(e,
p);g=f(v,g,m);null===r?l=v:r.sibling=v;r=v;p=q}if(m===h.length)return c(e,p),l;if(null===p){for(;m<h.length;m++)if(p=t(e,h[m],k))g=f(p,g,m),null===r?l=p:r.sibling=p,r=p;return l}for(p=d(e,p);m<h.length;m++)if(q=z(p,e,m,h[m],k))a&&null!==q.alternate&&p.delete(null===q.key?m:q.key),g=f(q,g,m),null===r?l=q:r.sibling=q,r=q;a&&p.forEach(function(a){return b(e,a)});return l}function u(e,g,h,k){var l=kc(h);"function"!==typeof l?w("150"):void 0;h=l.call(h);null==h?w("151"):void 0;for(var m=l=null,p=g,r=g=
0,q=null,v=h.next();null!==p&&!v.done;r++,v=h.next()){p.index>r?(q=p,p=null):q=p.sibling;var u=x(e,p,v.value,k);if(null===u){p||(p=q);break}a&&p&&null===u.alternate&&b(e,p);g=f(u,g,r);null===m?l=u:m.sibling=u;m=u;p=q}if(v.done)return c(e,p),l;if(null===p){for(;!v.done;r++,v=h.next())v=t(e,v.value,k),null!==v&&(g=f(v,g,r),null===m?l=v:m.sibling=v,m=v);return l}for(p=d(e,p);!v.done;r++,v=h.next())v=z(p,e,r,v.value,k),null!==v&&(a&&null!==v.alternate&&p.delete(null===v.key?r:v.key),g=f(v,g,r),null===
m?l=v:m.sibling=v,m=v);a&&p.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===bc&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case $b:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(9===k.tag?f.type===bc:k.type===f.type){c(a,k.sibling);d=e(k,f.type===bc?f.props.children:f.props,h);d.ref=Of(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===bc?(d=We(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=Ve(f,a.mode,h),h.ref=Of(a,d,f),h.return=a,a=h)}return g(a);case ac:a:{for(k=f.key;null!==d;){if(d.key===k)if(6===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Ye(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&8===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=Xe(f,a.mode,h),d.return=a,a=d),g(a);if(Nf(f))return y(a,d,f,h);if(kc(f))return u(a,d,f,h);l&&Pf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 3:case 0:h=a.type,w("152",h.displayName||h.name||"Component")}return c(a,d)}}var Rf=Qf(!0),Sf=Qf(!1),Tf=null,Uf=null,Vf=!1;function Wf(a,b){var c=new Se(7,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Xf(a,b){switch(a.tag){case 7:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 8:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Yf(a){if(Vf){var b=Uf;if(b){var c=b;if(!Xf(a,b)){b=Be(c);if(!b||!Xf(a,b)){a.effectTag|=2;Vf=!1;Tf=a;return}Wf(Tf,c)}Tf=a;Uf=Ce(b)}else a.effectTag|=2,Vf=!1,Tf=a}}
function Zf(a){for(a=a.return;null!==a&&7!==a.tag&&5!==a.tag;)a=a.return;Tf=a}function $f(a){if(a!==Tf)return!1;if(!Vf)return Zf(a),Vf=!0,!1;var b=a.type;if(7!==a.tag||"head"!==b&&"body"!==b&&!Ae(b,a.memoizedProps))for(b=Uf;b;)Wf(a,b),b=Be(b);Zf(a);Uf=Tf?Be(a.stateNode):null;return!0}function ag(){Uf=Tf=null;Vf=!1}
function bg(a){switch(a._reactStatus){case 1:return a._reactResult;case 2:throw a._reactResult;case 0:throw a;default:throw a._reactStatus=0,a.then(function(b){if(0===a._reactStatus){a._reactStatus=1;if("object"===typeof b&&null!==b){var c=b.default;b=void 0!==c&&null!==c?c:b}a._reactResult=b}},function(b){0===a._reactStatus&&(a._reactStatus=2,a._reactResult=b)}),a;}}var cg=Yb.ReactCurrentOwner;function O(a,b,c,d){b.child=null===a?Sf(b,null,c,d):Rf(b,a.child,c,d)}
function dg(a,b,c,d,e){c=c.render;var f=b.ref;if(!L.current&&b.memoizedProps===d&&f===(null!==a?a.ref:null))return eg(a,b,e);c=c(d,f);O(a,b,c,e);b.memoizedProps=d;return b.child}function fg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function gg(a,b,c,d,e){var f=M(c)?Ge:K.current;f=He(b,f);uf(b,e);c=c(d,f);b.effectTag|=1;O(a,b,c,e);b.memoizedProps=d;return b.child}
function hg(a,b,c,d,e){if(M(c)){var f=!0;Me(b)}else f=!1;uf(b,e);if(null===a)if(null===b.stateNode){var g=M(c)?Ge:K.current,k=c.contextTypes,h=null!==k&&void 0!==k;k=h?He(b,g):Fe;var l=new c(d,k);b.memoizedState=null!==l.state&&void 0!==l.state?l.state:null;l.updater=Jf;b.stateNode=l;l._reactInternalFiber=b;h&&(h=b.stateNode,h.__reactInternalMemoizedUnmaskedChildContext=g,h.__reactInternalMemoizedMaskedChildContext=k);Mf(b,c,d,e);d=!0}else{g=b.stateNode;k=b.memoizedProps;g.props=k;var m=g.context;
h=M(c)?Ge:K.current;h=He(b,h);var t=c.getDerivedStateFromProps;(l="function"===typeof t||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(k!==d||m!==h)&&Lf(b,g,d,h);af=!1;var x=b.memoizedState;m=g.state=x;var z=b.updateQueue;null!==z&&(kf(b,z,d,g,e),m=b.memoizedState);k!==d||x!==m||L.current||af?("function"===typeof t&&(Ff(b,c,t,d),m=b.memoizedState),(k=af||Kf(b,c,k,d,x,m,h))?(l||"function"!==
typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=m),g.props=d,g.state=m,g.context=h,d=k):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,k=
b.memoizedProps,g.props=k,m=g.context,h=M(c)?Ge:K.current,h=He(b,h),t=c.getDerivedStateFromProps,(l="function"===typeof t||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(k!==d||m!==h)&&Lf(b,g,d,h),af=!1,m=b.memoizedState,x=g.state=m,z=b.updateQueue,null!==z&&(kf(b,z,d,g,e),x=b.memoizedState),k!==d||m!==x||L.current||af?("function"===typeof t&&(Ff(b,c,t,d),x=b.memoizedState),(t=af||Kf(b,c,k,d,
m,x,h))?(l||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,x,h),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,h)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||k===a.memoizedProps&&m===a.memoizedState||(b.effectTag|=4),"function"!==
typeof g.getSnapshotBeforeUpdate||k===a.memoizedProps&&m===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=h,d=t):("function"!==typeof g.componentDidUpdate||k===a.memoizedProps&&m===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||k===a.memoizedProps&&m===a.memoizedState||(b.effectTag|=256),d=!1);return ig(a,b,c,d,f,e)}
function ig(a,b,c,d,e,f){fg(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Ne(b,c,!1),eg(a,b,f);d=b.stateNode;cg.current=b;var k=g?null:d.render();b.effectTag|=1;null!==a&&g&&(O(a,b,null,f),b.child=null);O(a,b,k,f);b.memoizedState=d.state;b.memoizedProps=d.props;e&&Ne(b,c,!0);return b.child}function jg(a){var b=a.stateNode;b.pendingContext?Ke(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ke(a,b.context,!1);Af(a,b.containerInfo)}
function ng(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function og(a,b,c,d){null!==a?w("155"):void 0;var e=b.pendingProps;if("object"===typeof c&&null!==c&&"function"===typeof c.then){c=bg(c);var f=c;f="function"===typeof f?Te(f)?3:1:void 0!==f&&null!==f&&f.$$typeof?14:4;f=b.tag=f;var g=ng(c,e);switch(f){case 1:return gg(a,b,c,g,d);case 3:return hg(a,b,c,g,d);case 14:return dg(a,b,c,g,d);default:w("283",c)}}f=He(b,K.current);uf(b,d);f=c(e,f);b.effectTag|=1;if("object"===typeof f&&null!==f&&"function"===typeof f.render&&void 0===f.$$typeof){b.tag=2;M(c)?
(g=!0,Me(b)):g=!1;b.memoizedState=null!==f.state&&void 0!==f.state?f.state:null;var k=c.getDerivedStateFromProps;"function"===typeof k&&Ff(b,c,k,e);f.updater=Jf;b.stateNode=f;f._reactInternalFiber=b;Mf(b,c,e,d);return ig(a,b,c,!0,g,d)}b.tag=0;O(a,b,f,d);b.memoizedProps=e;return b.child}
function eg(a,b,c){null!==a&&(b.firstContextDependency=a.firstContextDependency);var d=b.childExpirationTime;if(0===d||d>c)return null;null!==a&&b.child!==a.child?w("153"):void 0;if(null!==b.child){a=b.child;c=Ue(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Ue(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function pg(a,b,c){var d=b.expirationTime;if(!L.current&&(0===d||d>c)){switch(b.tag){case 5:jg(b);ag();break;case 7:Cf(b);break;case 2:M(b.type)&&Me(b);break;case 3:M(b.type._reactResult)&&Me(b);break;case 6:Af(b,b.stateNode.containerInfo);break;case 12:sf(b,b.memoizedProps.value)}return eg(a,b,c)}b.expirationTime=0;switch(b.tag){case 4:return og(a,b,b.type,c);case 0:return gg(a,b,b.type,b.pendingProps,c);case 1:var e=b.type._reactResult;d=b.pendingProps;a=gg(a,b,e,ng(e,d),c);b.memoizedProps=d;return a;
case 2:return hg(a,b,b.type,b.pendingProps,c);case 3:return e=b.type._reactResult,d=b.pendingProps,a=hg(a,b,e,ng(e,d),c),b.memoizedProps=d,a;case 5:jg(b);d=b.updateQueue;null===d?w("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;kf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)ag(),b=eg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)Uf=Ce(b.stateNode.containerInfo),Tf=b,e=Vf=!0;e?(b.effectTag|=2,b.child=Sf(b,null,d,c)):(O(a,b,d,c),ag());b=b.child}return b;
case 7:Cf(b);null===a&&Yf(b);d=b.type;e=b.pendingProps;var f=null!==a?a.memoizedProps:null,g=e.children;Ae(d,e)?g=null:null!==f&&Ae(d,f)&&(b.effectTag|=16);fg(a,b);1073741823!==c&&b.mode&1&&e.hidden?(b.expirationTime=1073741823,b.memoizedProps=e,b=null):(O(a,b,g,c),b.memoizedProps=e,b=b.child);return b;case 8:return null===a&&Yf(b),b.memoizedProps=b.pendingProps,null;case 16:return null;case 6:return Af(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Rf(b,null,d,c):O(a,b,d,c),b.memoizedProps=
d,b.child;case 13:return dg(a,b,b.type,b.pendingProps,c);case 14:return e=b.type._reactResult,d=b.pendingProps,a=dg(a,b,e,ng(e,d),c),b.memoizedProps=d,a;case 9:return d=b.pendingProps,O(a,b,d,c),b.memoizedProps=d,b.child;case 10:return d=b.pendingProps.children,O(a,b,d,c),b.memoizedProps=d,b.child;case 15:return d=b.pendingProps,O(a,b,d.children,c),b.memoizedProps=d,b.child;case 12:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;b.memoizedProps=e;sf(b,f);if(null!==g){var k=g.value;
f=k===f&&(0!==k||1/k===1/f)||k!==k&&f!==f?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,f):1073741823)|0;if(0===f){if(g.children===e.children&&!L.current){b=eg(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){k=g.firstContextDependency;if(null!==k){do{if(k.context===d&&0!==(k.observedBits&f)){if(2===g.tag||3===g.tag){var h=df(c);h.tag=2;ff(g,h)}if(0===g.expirationTime||g.expirationTime>c)g.expirationTime=c;h=g.alternate;null!==h&&(0===h.expirationTime||
h.expirationTime>c)&&(h.expirationTime=c);for(var l=g.return;null!==l;){h=l.alternate;if(0===l.childExpirationTime||l.childExpirationTime>c)l.childExpirationTime=c,null!==h&&(0===h.childExpirationTime||h.childExpirationTime>c)&&(h.childExpirationTime=c);else if(null!==h&&(0===h.childExpirationTime||h.childExpirationTime>c))h.childExpirationTime=c;else break;l=l.return}}h=g.child;k=k.next}while(null!==k)}else h=12===g.tag?g.type===b.type?null:g.child:g.child;if(null!==h)h.return=g;else for(h=g;null!==
h;){if(h===b){h=null;break}g=h.sibling;if(null!==g){g.return=h.return;h=g;break}h=h.return}g=h}}O(a,b,e.children,c);b=b.child}return b;case 11:return f=b.type,d=b.pendingProps,e=d.children,uf(b,c),f=vf(f,d.unstable_observedBits),e=e(f),b.effectTag|=1,O(a,b,e,c),b.memoizedProps=d,b.child;default:w("156")}}function qg(a){a.effectTag|=4}var rg=void 0,sg=void 0,tg=void 0;rg=function(){};sg=function(a,b,c){(b.updateQueue=c)&&qg(b)};tg=function(a,b,c,d){c!==d&&qg(b)};
function ug(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=mc(c));null!==c&&lc(c.type);b=b.value;null!==a&&2===a.tag&&lc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function vg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){wg(a,c)}else b.current=null}
function xg(a){"function"===typeof Pe&&Pe(a);switch(a.tag){case 2:case 3:vg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){wg(a,c)}break;case 7:vg(a);break;case 6:yg(a)}}function zg(a){return 7===a.tag||5===a.tag||6===a.tag}
function Ag(a){a:{for(var b=a.return;null!==b;){if(zg(b)){var c=b;break a}b=b.return}w("160");c=void 0}var d=b=void 0;switch(c.tag){case 7:b=c.stateNode;d=!1;break;case 5:b=c.stateNode.containerInfo;d=!0;break;case 6:b=c.stateNode.containerInfo;d=!0;break;default:w("161")}c.effectTag&16&&(oe(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||zg(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;7!==c.tag&&8!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||6===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(7===e.tag||8===e.tag)if(c)if(d){var f=b,g=e.stateNode,k=c;8===f.nodeType?f.parentNode.insertBefore(g,k):f.insertBefore(g,k)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?(k=f.parentNode,k.insertBefore(g,f)):(k=f,k.appendChild(g)),null===k.onclick&&(k.onclick=we)):b.appendChild(e.stateNode);else if(6!==e.tag&&null!==e.child){e.child.return=
e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function yg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?w("160"):void 0;switch(c.tag){case 7:d=c.stateNode;e=!1;break a;case 5:d=c.stateNode.containerInfo;e=!0;break a;case 6:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(7===b.tag||8===b.tag){a:for(var f=b,g=f;;)if(xg(g),null!==g.child&&6!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(6===b.tag?(d=b.stateNode.containerInfo,e=!0):xg(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;6===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function Bg(a,b){switch(b.tag){case 2:case 3:break;case 7:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Ja]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cc(c,d);ue(a,e);b=ue(a,d);for(e=0;e<f.length;e+=2){var g=f[e],k=f[e+1];"style"===g?re(c,k):"dangerouslySetInnerHTML"===g?ne(c,k):"children"===g?oe(c,k):xc(c,g,k,b)}switch(a){case "input":Dc(c,d);break;case "textarea":he(c,d);break;case "select":a=c._wrapperState.wasMultiple,
c._wrapperState.wasMultiple=!!d.multiple,f=d.value,null!=f?ee(c,!!d.multiple,f,!1):a!==!!d.multiple&&(null!=d.defaultValue?ee(c,!!d.multiple,d.defaultValue,!0):ee(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 8:null===b.stateNode?w("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 5:break;case 15:break;case 16:break;default:w("163")}}function Cg(a,b,c){c=df(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Dg(d);ug(a,b)};return c}
function Eg(a,b,c){c=df(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===Fg?Fg=new Set([this]):Fg.add(this);var c=b.value,d=b.stack;ug(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function Gg(a){switch(a.tag){case 2:M(a.type)&&Ie(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return M(a.type._reactResult)&&Ie(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return Bf(a),Je(a),b=a.effectTag,0!==(b&64)?w("285"):void 0,a.effectTag=b&-1025|64,a;case 7:return Df(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 6:return Bf(a),null;case 12:return tf(a),null;default:return null}}
var Hg={readContext:vf},Ig=Yb.ReactCurrentOwner,Jg=0,Kg=0,Lg=!1,P=null,Mg=null,Q=0,Ng=!1,R=null,Og=!1,Fg=null;function Pg(){if(null!==P)for(var a=P.return;null!==a;){var b=a;switch(b.tag){case 2:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ie(b);break;case 3:c=b.type._reactResult.childContextTypes;null!==c&&void 0!==c&&Ie(b);break;case 5:Bf(b);Je(b);break;case 7:Df(b);break;case 6:Bf(b);break;case 12:tf(b)}a=a.return}Mg=null;Q=0;Ng=!1;P=null}
function Qg(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){var e=b;b=a;var f=b.pendingProps;switch(b.tag){case 0:case 1:break;case 2:M(b.type)&&Ie(b);break;case 3:M(b.type._reactResult)&&Ie(b);break;case 5:Bf(b);Je(b);f=b.stateNode;f.pendingContext&&(f.context=f.pendingContext,f.pendingContext=null);if(null===e||null===e.child)$f(b),b.effectTag&=-3;rg(b);break;case 7:Df(b);var g=zf(yf.current),k=b.type;if(null!==e&&null!=b.stateNode){var h=e.memoizedProps;if(h!==f){var l=
b.stateNode,m=zf(N.current),t=l,x=k;var z=h;var y=f;l=g;var u=null;switch(x){case "input":z=zc(t,z);y=zc(t,y);u=[];break;case "option":z=de(t,z);y=de(t,y);u=[];break;case "select":z=n({},z,{value:void 0});y=n({},y,{value:void 0});u=[];break;case "textarea":z=fe(t,z);y=fe(t,y);u=[];break;default:"function"!==typeof z.onClick&&"function"===typeof y.onClick&&(t.onclick=we)}te(x,y);x=t=void 0;var v=null;for(t in z)if(!y.hasOwnProperty(t)&&z.hasOwnProperty(t)&&null!=z[t])if("style"===t){var r=z[t];for(x in r)r.hasOwnProperty(x)&&
(v||(v={}),v[x]="")}else"dangerouslySetInnerHTML"!==t&&"children"!==t&&"suppressContentEditableWarning"!==t&&"suppressHydrationWarning"!==t&&"autoFocus"!==t&&(sa.hasOwnProperty(t)?u||(u=[]):(u=u||[]).push(t,null));for(t in y){var p=y[t];r=null!=z?z[t]:void 0;if(y.hasOwnProperty(t)&&p!==r&&(null!=p||null!=r))if("style"===t)if(r){for(x in r)!r.hasOwnProperty(x)||p&&p.hasOwnProperty(x)||(v||(v={}),v[x]="");for(x in p)p.hasOwnProperty(x)&&r[x]!==p[x]&&(v||(v={}),v[x]=p[x])}else v||(u||(u=[]),u.push(t,
v)),v=p;else"dangerouslySetInnerHTML"===t?(p=p?p.__html:void 0,r=r?r.__html:void 0,null!=p&&r!==p&&(u=u||[]).push(t,""+p)):"children"===t?r===p||"string"!==typeof p&&"number"!==typeof p||(u=u||[]).push(t,""+p):"suppressContentEditableWarning"!==t&&"suppressHydrationWarning"!==t&&(sa.hasOwnProperty(t)?(null!=p&&ve(l,t),u||r===p||(u=[])):(u=u||[]).push(t,p))}v&&(u=u||[]).push("style",v);sg(e,b,u,k,h,f,g,m)}e.ref!==b.ref&&(b.effectTag|=128)}else if(f){u=zf(N.current);if($f(b)){f=b;l=f.stateNode;e=f.type;
h=f.memoizedProps;m=g;l[Ia]=f;l[Ja]=h;k=void 0;g=l;switch(e){case "iframe":case "object":H("load",g);break;case "video":case "audio":for(l=0;l<fb.length;l++)H(fb[l],g);break;case "source":H("error",g);break;case "img":case "image":case "link":H("error",g);H("load",g);break;case "form":H("reset",g);H("submit",g);break;case "details":H("toggle",g);break;case "input":Bc(g,h);H("invalid",g);ve(m,"onChange");break;case "select":g._wrapperState={wasMultiple:!!h.multiple};H("invalid",g);ve(m,"onChange");
break;case "textarea":ge(g,h),H("invalid",g),ve(m,"onChange")}te(e,h);l=null;for(k in h)h.hasOwnProperty(k)&&(u=h[k],"children"===k?"string"===typeof u?g.textContent!==u&&(l=["children",u]):"number"===typeof u&&g.textContent!==""+u&&(l=["children",""+u]):sa.hasOwnProperty(k)&&null!=u&&ve(m,k));switch(e){case "input":Wb(g);Fc(g,h,!0);break;case "textarea":Wb(g);ie(g,h);break;case "select":case "option":break;default:"function"===typeof h.onClick&&(g.onclick=we)}k=l;f.updateQueue=k;f=null!==k?!0:!1;
f&&qg(b)}else{h=b;e=k;m=f;l=9===g.nodeType?g:g.ownerDocument;u===je.html&&(u=ke(e));u===je.html?"script"===e?(e=l.createElement("div"),e.innerHTML="<script>\x3c/script>",l=e.removeChild(e.firstChild)):"string"===typeof m.is?l=l.createElement(e,{is:m.is}):(l=l.createElement(e),"select"===e&&m.multiple&&(l.multiple=!0)):l=l.createElementNS(u,e);e=l;e[Ia]=h;e[Ja]=f;a:for(h=e,m=b,l=m.child;null!==l;){if(7===l.tag||8===l.tag)h.appendChild(l.stateNode);else if(6!==l.tag&&null!==l.child){l.child.return=
l;l=l.child;continue}if(l===m)break;for(;null===l.sibling;){if(null===l.return||l.return===m)break a;l=l.return}l.sibling.return=l.return;l=l.sibling}m=e;l=k;h=f;t=g;v=ue(l,h);switch(l){case "iframe":case "object":H("load",m);g=h;break;case "video":case "audio":for(g=0;g<fb.length;g++)H(fb[g],m);g=h;break;case "source":H("error",m);g=h;break;case "img":case "image":case "link":H("error",m);H("load",m);g=h;break;case "form":H("reset",m);H("submit",m);g=h;break;case "details":H("toggle",m);g=h;break;
case "input":Bc(m,h);g=zc(m,h);H("invalid",m);ve(t,"onChange");break;case "option":g=de(m,h);break;case "select":m._wrapperState={wasMultiple:!!h.multiple};g=n({},h,{value:void 0});H("invalid",m);ve(t,"onChange");break;case "textarea":ge(m,h);g=fe(m,h);H("invalid",m);ve(t,"onChange");break;default:g=h}te(l,g);u=void 0;z=l;y=m;x=g;for(u in x)x.hasOwnProperty(u)&&(r=x[u],"style"===u?re(y,r):"dangerouslySetInnerHTML"===u?(r=r?r.__html:void 0,null!=r&&ne(y,r)):"children"===u?"string"===typeof r?("textarea"!==
z||""!==r)&&oe(y,r):"number"===typeof r&&oe(y,""+r):"suppressContentEditableWarning"!==u&&"suppressHydrationWarning"!==u&&"autoFocus"!==u&&(sa.hasOwnProperty(u)?null!=r&&ve(t,u):null!=r&&xc(y,u,r,v)));switch(l){case "input":Wb(m);Fc(m,h,!1);break;case "textarea":Wb(m);ie(m,h);break;case "option":null!=h.value&&m.setAttribute("value",""+yc(h.value));break;case "select":g=m;g.multiple=!!h.multiple;m=h.value;null!=m?ee(g,!!h.multiple,m,!1):null!=h.defaultValue&&ee(g,!!h.multiple,h.defaultValue,!0);break;
default:"function"===typeof g.onClick&&(m.onclick=we)}(f=ze(k,f))&&qg(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?w("166"):void 0;break;case 8:e&&null!=b.stateNode?tg(e,b,e.memoizedProps,f):("string"!==typeof f&&(null===b.stateNode?w("166"):void 0),g=zf(yf.current),zf(N.current),$f(b)?(f=b,k=f.stateNode,g=f.memoizedProps,k[Ia]=f,(f=k.nodeValue!==g)&&qg(b)):(k=b,f=(9===g.nodeType?g:g.ownerDocument).createTextNode(f),f[Ia]=k,b.stateNode=f));break;case 13:case 14:break;
case 16:break;case 9:break;case 10:break;case 15:break;case 6:Bf(b);rg(b);break;case 12:tf(b);break;case 11:break;case 4:w("167");default:w("156")}b=P=null;f=a;if(1073741823===Q||1073741823!==f.childExpirationTime){k=0;for(g=f.child;null!==g;){e=g.expirationTime;h=g.childExpirationTime;if(0===k||0!==e&&e<k)k=e;if(0===k||0!==h&&h<k)k=h;g=g.sibling}f.childExpirationTime=k}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gg(a,Q);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512)}if(null!==d)return d;if(null!==c)a=c;else break}return null}function Rg(a){var b=pg(a.alternate,a,Q);null===b&&(b=Qg(a));Ig.current=null;return b}
function Sg(a,b,c){Lg?w("243"):void 0;Lg=!0;Ig.currentDispatcher=Hg;var d=a.nextExpirationTimeToWorkOn;if(d!==Q||a!==Mg||null===P)Pg(),Mg=a,Q=d,P=Ue(Mg.current,null,Q),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==P&&!Tg();)P=Rg(P);else for(;null!==P;)P=Rg(P)}catch(t){if(null===P)e=!0,Dg(t);else{null===P?w("271"):void 0;var f=P,g=f.return;if(null===g)e=!0,Dg(t);else{a:{var k=g,h=f,l=t;g=Q;h.effectTag|=512;h.firstEffect=h.lastEffect=null;Ng=!0;l=nf(l,h);do{switch(k.tag){case 5:k.effectTag|=
1024;k.expirationTime=g;g=Cg(k,l,g);gf(k,g);break a;case 2:case 3:h=l;var m=k.stateNode;if(0===(k.effectTag&64)&&null!==m&&"function"===typeof m.componentDidCatch&&(null===Fg||!Fg.has(m))){k.effectTag|=1024;k.expirationTime=g;g=Eg(k,h,g);gf(k,g);break a}}k=k.return}while(null!==k)}P=Qg(f);continue}}}break}while(1);Lg=!1;rf=qf=pf=Ig.currentDispatcher=null;if(e)Mg=null,a.finishedWork=null;else if(null!==P)a.finishedWork=null;else{b=a.current.alternate;null===b?w("281"):void 0;Mg=null;if(Ng){e=a.latestPendingTime;
f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e>d||0!==f&&f>d||0!==g&&g>d){a.didError=!1;c=a.latestPingedTime;0!==c&&c<=d&&(a.latestPingedTime=0);c=a.earliestPendingTime;b=a.latestPendingTime;c===d?a.earliestPendingTime=b===d?a.latestPendingTime=0:b:b===d&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;b=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=d:c>d?a.earliestSuspendedTime=d:b<d&&(a.latestSuspendedTime=d);$e(d,a);a.expirationTime=a.expirationTime;return}if(!a.didError&&
!c){a.didError=!0;a.nextExpirationTimeToWorkOn=d;d=a.expirationTime=1;a.expirationTime=d;return}}a.pendingCommitExpirationTime=d;a.finishedWork=b}}
function wg(a,b){var c;a:{Lg&&!Og?w("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:case 3:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===Fg||!Fg.has(d))){a=nf(b,a);a=Eg(c,a,1);ff(c,a);If(c,1);c=void 0;break a}break;case 5:a=nf(b,a);a=Cg(c,a,1);ff(c,a);If(c,1);c=void 0;break a}c=c.return}5===a.tag&&(c=nf(b,a),c=Cg(a,c,1),ff(a,c),If(a,1));c=void 0}return c}
function Hf(a,b){0!==Kg?a=Kg:Lg?a=Og?1:Q:b.mode&1?(a=Ug?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1),null!==Mg&&a===Q&&(a+=1)):a=1;Ug&&(0===Vg||a>Vg)&&(Vg=a);return a}
function If(a,b){a:{if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;var c=a.alternate;null!==c&&(0===c.expirationTime||c.expirationTime>b)&&(c.expirationTime=b);var d=a.return;if(null===d&&5===a.tag)a=a.stateNode;else{for(;null!==d;){c=d.alternate;if(0===d.childExpirationTime||d.childExpirationTime>b)d.childExpirationTime=b;null!==c&&(0===c.childExpirationTime||c.childExpirationTime>b)&&(c.childExpirationTime=b);if(null===d.return&&5===d.tag){a=d.stateNode;break a}d=d.return}a=null}}if(null!==
a){!Lg&&0!==Q&&b<Q&&Pg();Ze(a,b);if(!Lg||Og||Mg!==a){b=a;a=a.expirationTime;if(null===b.nextScheduledRoot)b.expirationTime=a,null===T?(U=T=b,b.nextScheduledRoot=b):(T=T.nextScheduledRoot=b,T.nextScheduledRoot=U);else if(c=b.expirationTime,0===c||a<c)b.expirationTime=a;V||(W?Wg&&(Y=b,Z=1,Xg(b,1,!0)):1===a?Yg(1,null):Zg(b,a))}$g>ah&&($g=0,w("185"))}}function bh(a,b,c,d,e){var f=Kg;Kg=1;try{return a(b,c,d,e)}finally{Kg=f}}
var U=null,T=null,ch=0,dh=void 0,V=!1,Y=null,Z=0,Vg=0,eh=!1,fh=!1,gh=null,hh=null,W=!1,Wg=!1,Ug=!1,ih=null,jh=ba.unstable_now(),kh=(jh/10|0)+2,lh=kh,ah=50,$g=0,mh=null,nh=1;function oh(){kh=((ba.unstable_now()-jh)/10|0)+2}function Zg(a,b){if(0!==ch){if(b>ch)return;null!==dh&&ba.unstable_cancelScheduledWork(dh)}ch=b;a=ba.unstable_now()-jh;dh=ba.unstable_scheduleWork(ph,{timeout:10*(b-2)-a})}function Gf(){if(V)return lh;qh();if(0===Z||1073741823===Z)oh(),lh=kh;return lh}
function qh(){var a=0,b=null;if(null!==T)for(var c=T,d=U;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===T?w("244"):void 0;if(d===d.nextScheduledRoot){U=T=d.nextScheduledRoot=null;break}else if(d===U)U=e=d.nextScheduledRoot,T.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===T){T=c;T.nextScheduledRoot=U;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===T)break;if(1===a)break;
c=d;d=d.nextScheduledRoot}}Y=b;Z=a}function ph(a){if(a.didTimeout&&null!==U){oh();var b=U;do{var c=b.expirationTime;0!==c&&kh>=c&&(b.nextExpirationTimeToWorkOn=kh);b=b.nextScheduledRoot}while(b!==U)}Yg(0,a)}
function Yg(a,b){hh=b;qh();if(null!==hh)for(oh(),lh=kh;null!==Y&&0!==Z&&(0===a||a>=Z)&&(!eh||kh>=Z);)Xg(Y,Z,kh>=Z),qh(),oh(),lh=kh;else for(;null!==Y&&0!==Z&&(0===a||a>=Z);)Xg(Y,Z,!0),qh();null!==hh&&(ch=0,dh=null);0!==Z&&Zg(Y,Z);hh=null;eh=!1;$g=0;mh=null;if(null!==ih)for(a=ih,ih=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){fh||(fh=!0,gh=d)}}if(fh)throw a=gh,gh=null,fh=!1,a;}
function Xg(a,b,c){V?w("245"):void 0;V=!0;if(null===hh||c){var d=a.finishedWork;null!==d?rh(a,d,b):(a.finishedWork=null,Sg(a,!1,c),d=a.finishedWork,null!==d&&rh(a,d,b))}else d=a.finishedWork,null!==d?rh(a,d,b):(a.finishedWork=null,Sg(a,!0,c),d=a.finishedWork,null!==d&&(Tg()?a.finishedWork=d:rh(a,d,b)));V=!1}
function rh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===ih?ih=[d]:ih.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===mh?$g++:(mh=a,$g=0);Og=Lg=!0;a.current===b?w("177"):void 0;c=a.pendingCommitExpirationTime;0===c?w("261"):void 0;a.pendingCommitExpirationTime=0;d=b.expirationTime;var e=b.childExpirationTime;d=0===d||0!==e&&e<d?e:d;a.didError=!1;0===d?(a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=
0,a.latestPingedTime=0):(e=a.latestPendingTime,0!==e&&(e<d?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime<d&&(a.earliestPendingTime=a.latestPendingTime)),e=a.earliestSuspendedTime,0===e?Ze(a,d):d>a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,Ze(a,d)):d<e&&Ze(a,d));$e(0,a);Ig.current=null;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;xe=Gd;e=Td();if(Ud(e)){if("selectionStart"in e)var f=
{start:e.selectionStart,end:e.selectionEnd};else a:{f=(f=e.ownerDocument)&&f.defaultView||window;var g=f.getSelection&&f.getSelection();if(g&&0!==g.rangeCount){f=g.anchorNode;var k=g.anchorOffset,h=g.focusNode;g=g.focusOffset;try{f.nodeType,h.nodeType}catch(Xa){f=null;break a}var l=0,m=-1,t=-1,x=0,z=0,y=e,u=null;b:for(;;){for(var v;;){y!==f||0!==k&&3!==y.nodeType||(m=l+k);y!==h||0!==g&&3!==y.nodeType||(t=l+g);3===y.nodeType&&(l+=y.nodeValue.length);if(null===(v=y.firstChild))break;u=y;y=v}for(;;){if(y===
e)break b;u===f&&++x===k&&(m=l);u===h&&++z===g&&(t=l);if(null!==(v=y.nextSibling))break;y=u;u=y.parentNode}y=v}f=-1===m||-1===t?null:{start:m,end:t}}else f=null}f=f||{start:0,end:0}}else f=null;ye={focusedElem:e,selectionRange:f};Gd=!1;for(R=d;null!==R;){e=!1;f=void 0;try{for(;null!==R;){if(R.effectTag&256){var r=R.alternate;a:switch(k=R,k.tag){case 2:case 3:if(k.effectTag&256&&null!==r){var p=r.memoizedProps,D=r.memoizedState,S=k.stateNode;S.props=k.memoizedProps;S.state=k.memoizedState;var yh=S.getSnapshotBeforeUpdate(p,
D);S.__reactInternalSnapshotBeforeUpdate=yh}break a;case 5:case 7:case 8:case 6:break a;default:w("163")}}R=R.nextEffect}}catch(Xa){e=!0,f=Xa}e&&(null===R?w("178"):void 0,wg(R,f),null!==R&&(R=R.nextEffect))}for(R=d;null!==R;){r=!1;p=void 0;try{for(;null!==R;){var A=R.effectTag;A&16&&oe(R.stateNode,"");if(A&128){var B=R.alternate;if(null!==B){var q=B.ref;null!==q&&("function"===typeof q?q(null):q.current=null)}}switch(A&14){case 2:Ag(R);R.effectTag&=-3;break;case 6:Ag(R);R.effectTag&=-3;Bg(R.alternate,
R);break;case 4:Bg(R.alternate,R);break;case 8:D=R,yg(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}R=R.nextEffect}}catch(Xa){r=!0,p=Xa}r&&(null===R?w("178"):void 0,wg(R,p),null!==R&&(R=R.nextEffect))}q=ye;B=Td();A=q.focusedElem;p=q.selectionRange;if(B!==A&&A&&A.ownerDocument&&Sd(A.ownerDocument.documentElement,A)){null!==p&&Ud(A)&&(B=p.start,q=p.end,void 0===q&&(q=B),"selectionStart"in A?(A.selectionStart=B,A.selectionEnd=Math.min(q,A.value.length)):
(r=A.ownerDocument||document,B=(r?r.defaultView:window).getSelection(),D=A.textContent.length,q=Math.min(p.start,D),p=void 0===p.end?q:Math.min(p.end,D),!B.extend&&q>p&&(D=p,p=q,q=D),D=Rd(A,q),S=Rd(A,p),D&&S&&(1!==B.rangeCount||B.anchorNode!==D.node||B.anchorOffset!==D.offset||B.focusNode!==S.node||B.focusOffset!==S.offset)&&(r=r.createRange(),r.setStart(D.node,D.offset),B.removeAllRanges(),q>p?(B.addRange(r),B.extend(S.node,S.offset)):(r.setEnd(S.node,S.offset),B.addRange(r)))));B=[];for(q=A;q=q.parentNode;)1===
q.nodeType&&B.push({element:q,left:q.scrollLeft,top:q.scrollTop});"function"===typeof A.focus&&A.focus();for(A=0;A<B.length;A++)q=B[A],q.element.scrollLeft=q.left,q.element.scrollTop=q.top}ye=null;Gd=!!xe;xe=null;a.current=b;for(R=d;null!==R;){d=!1;A=void 0;try{for(B=c;null!==R;){var Sa=R.effectTag;if(Sa&36){var oc=R.alternate;q=R;r=B;switch(q.tag){case 2:case 3:var X=q.stateNode;if(q.effectTag&4)if(null===oc)X.props=q.memoizedProps,X.state=q.memoizedState,X.componentDidMount();else{var Ih=oc.memoizedProps,
Jh=oc.memoizedState;X.props=q.memoizedProps;X.state=q.memoizedState;X.componentDidUpdate(Ih,Jh,X.__reactInternalSnapshotBeforeUpdate)}var kg=q.updateQueue;null!==kg&&(X.props=q.memoizedProps,X.state=q.memoizedState,lf(q,kg,X,r));break;case 5:var lg=q.updateQueue;if(null!==lg){p=null;if(null!==q.child)switch(q.child.tag){case 7:p=q.child.stateNode;break;case 2:case 3:p=q.child.stateNode}lf(q,lg,p,r)}break;case 7:var Kh=q.stateNode;null===oc&&q.effectTag&4&&ze(q.type,q.memoizedProps)&&Kh.focus();break;
case 8:break;case 6:break;case 15:break;case 16:break;default:w("163")}}if(Sa&128){var Ac=R.ref;if(null!==Ac){var mg=R.stateNode;switch(R.tag){case 7:var Od=mg;break;default:Od=mg}"function"===typeof Ac?Ac(Od):Ac.current=Od}}var Lh=R.nextEffect;R.nextEffect=null;R=Lh}}catch(Xa){d=!0,A=Xa}d&&(null===R?w("178"):void 0,wg(R,A),null!==R&&(R=R.nextEffect))}Lg=Og=!1;"function"===typeof Oe&&Oe(b.stateNode);Sa=b.expirationTime;b=b.childExpirationTime;b=0===Sa||0!==b&&b<Sa?b:Sa;0===b&&(Fg=null);a.expirationTime=
b;a.finishedWork=null}function Tg(){return eh?!0:null===hh||hh.timeRemaining()>nh?!1:eh=!0}function Dg(a){null===Y?w("246"):void 0;Y.expirationTime=0;fh||(fh=!0,gh=a)}function sh(a,b){var c=W;W=!0;try{return a(b)}finally{(W=c)||V||Yg(1,null)}}function th(a,b){if(W&&!Wg){Wg=!0;try{return a(b)}finally{Wg=!1}}return a(b)}function uh(a,b,c){if(Ug)return a(b,c);W||V||0===Vg||(Yg(Vg,null),Vg=0);var d=Ug,e=W;W=Ug=!0;try{return a(b,c)}finally{Ug=d,(W=e)||V||Yg(1,null)}}
function vh(a){if(!a)return Fe;a=a._reactInternalFiber;a:{2!==jd(a)||2!==a.tag&&3!==a.tag?w("170"):void 0;var b=a;do{switch(b.tag){case 5:b=b.stateNode.context;break a;case 2:if(M(b.type)){b=b.stateNode.__reactInternalMemoizedMergedChildContext;break a}break;case 3:if(M(b.type._reactResult)){b=b.stateNode.__reactInternalMemoizedMergedChildContext;break a}}b=b.return}while(null!==b);w("171");b=void 0}if(2===a.tag){var c=a.type;if(M(c))return Le(a,c,b)}else if(3===a.tag&&(c=a.type._reactResult,M(c)))return Le(a,
c,b);return b}function wh(a,b,c,d,e){var f=b.current;c=vh(c);null===b.context?b.context=c:b.pendingContext=c;b=e;e=df(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);ff(f,e);If(f,d);return d}function xh(a,b,c,d){var e=b.current,f=Gf();e=Hf(f,e);return wh(a,b,c,e,d)}function zh(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 7:return a.child.stateNode;default:return a.child.stateNode}}
function Ah(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:ac,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Fb=function(a,b,c){switch(b){case "input":Dc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Na(d);e?void 0:w("90");Xb(d);Dc(d,e)}}}break;case "textarea":he(a,c);break;case "select":b=c.value,null!=b&&ee(a,!!c.multiple,b,!1)}};
function Bh(a){var b=2+25*(((Gf()-2+500)/25|0)+1);b<=Jg&&(b=Jg+1);this._expirationTime=Jg=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Bh.prototype.render=function(a){this._defer?void 0:w("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Ch;wh(a,b,null,c,d._onCommit);return d};
Bh.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Bh.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:w("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?w("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;b=c;V?w("253"):void 0;Y=a;Z=b;Xg(a,b,!0);Yg(1,null);b=this._next;this._next=null;b=a.firstBatch=b;null!==
b&&b._hasChildren&&b.render(b._children)}else this._next=null,this._defer=!1};Bh.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Ch(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Ch.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ch.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?w("191",c):void 0;c()}}};
function Dh(a,b,c){b=new Se(5,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Dh.prototype.render=function(a,b){var c=this._internalRoot,d=new Ch;b=void 0===b?null:b;null!==b&&d.then(b);xh(a,c,null,d._onCommit);return d};Dh.prototype.unmount=function(a){var b=this._internalRoot,c=new Ch;a=void 0===a?null:a;null!==a&&c.then(a);xh(null,b,null,c._onCommit);return c};Dh.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Ch;c=void 0===c?null:c;null!==c&&e.then(c);xh(b,d,a,e._onCommit);return e};
Dh.prototype.createBatch=function(){var a=new Bh(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Eh(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Lb=sh;Mb=uh;Nb=function(){V||0===Vg||(Yg(Vg,null),Vg=0)};
function Fh(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Dh(a,!1,b)}
function Gh(a,b,c,d,e){Eh(c)?void 0:w("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=zh(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Fh(c,d);if("function"===typeof e){var k=e;e=function(){var a=zh(f._internalRoot);k.call(a)}}th(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return zh(f._internalRoot)}
function Hh(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Eh(b)?void 0:w("200");return Ah(a,b,null,c)}
var Mh={createPortal:Hh,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?w("188"):w("268",Object.keys(a)));a=md(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){return Gh(null,a,b,!0,c)},render:function(a,b,c){return Gh(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?w("38"):void 0;return Gh(a,b,c,!1,d)},unmountComponentAtNode:function(a){Eh(a)?
void 0:w("40");return a._reactRootContainer?(th(function(){Gh(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Hh.apply(void 0,arguments)},unstable_batchedUpdates:sh,unstable_interactiveUpdates:uh,flushSync:function(a,b){V?w("187"):void 0;var c=W;W=!0;try{return bh(a,b)}finally{W=c,Yg(1,null)}},unstable_flushControlled:function(a){var b=W;W=!0;try{bh(a)}finally{(W=b)||V||Yg(1,null)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[La,
Ma,Na,qa,Ua,function(a){za(a,Ta)},Jb,Kb,Id,Ga]},unstable_createRoot:function(a,b){Eh(a)?void 0:w("278");return new Dh(a,!0,null!=b&&!0===b.hydrate)}};(function(a){var b=a.findFiberByHostInstance;return Re(n({},a,{findHostInstanceByFiber:function(a){a=md(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ka,bundleType:0,version:"16.5.0",rendererPackageName:"react-dom"});var Nh={default:Mh},Oh=Nh&&Mh||Nh;
module.exports=Oh.default||Oh;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(330);
} else {
  module.exports = require('./cjs/schedule.development.js');
}


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.5.0
 * schedule.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=!("undefined"===typeof window||!window.document||!window.document.createElement),f=Date,g="function"===typeof setTimeout?setTimeout:void 0,h="function"===typeof clearTimeout?clearTimeout:void 0,l="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,m="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,n="object"===typeof performance&&"function"===typeof performance.now;
exports.unstable_now=void 0;if(n){var p=performance;exports.unstable_now=function(){return p.now()}}else exports.unstable_now=function(){return f.now()};exports.unstable_scheduleWork=void 0;exports.unstable_cancelScheduledWork=void 0;
if(d){var q=null,r=null,t=-1,u=!1,v=!1,w=void 0,x=void 0,y=function(a){w=l(function(b){h(x);a(b)});x=g(function(){m(w);a(exports.unstable_now())},100)},z=0,A=33,B=33,C={didTimeout:!1,timeRemaining:function(){var a=z-exports.unstable_now();return 0<a?a:0}},E=function(a,b){var c=a.scheduledCallback,e=!1;try{c(b),e=!0}finally{exports.unstable_cancelScheduledWork(a),e||(u=!0,window.postMessage(D,"*"))}},D="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===
window&&a.data===D&&(u=!1,null!==q)){if(null!==q){var b=exports.unstable_now();if(!(-1===t||t>b)){a=-1;for(var c=[],e=q;null!==e;){var k=e.timeoutTime;-1!==k&&k<=b?c.push(e):-1!==k&&(-1===a||k<a)&&(a=k);e=e.next}if(0<c.length)for(C.didTimeout=!0,b=0,e=c.length;b<e;b++)E(c[b],C);t=a}}for(a=exports.unstable_now();0<z-a&&null!==q;)a=q,C.didTimeout=!1,E(a,C),a=exports.unstable_now();null===q||v||(v=!0,y(F))}},!1);var F=function(a){v=!1;var b=a-z+B;b<B&&A<B?(8>b&&(b=8),B=b<A?A:b):A=b;z=a+B;u||(u=!0,window.postMessage(D,
"*"))};exports.unstable_scheduleWork=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=exports.unstable_now()+b.timeout);if(-1===t||-1!==c&&c<t)t=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===q?q=a:(b=a.prev=r,null!==b&&(b.next=a));r=a;v||(v=!0,y(F));return a};exports.unstable_cancelScheduledWork=function(a){if(null!==a.prev||q===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,q=b):null!==c?(c.next=null,r=c):r=
q=null}}}else{var G=new Map;exports.unstable_scheduleWork=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=g(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})});G.set(a,c);return b};exports.unstable_cancelScheduledWork=function(a){var b=G.get(a.scheduledCallback);G.delete(a);h(b)}};


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(333);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(37), __webpack_require__(332)(module)))

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(148);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(336);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(352);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(204);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(349);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(346);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(344);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(37)))

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(206);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(348);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(204);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(205);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(353);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(148);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createEpicMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operators__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActionsObservable__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StateObservable__ = __webpack_require__(242);





function createEpicMiddleware() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (false) {
    throw new TypeError('Providing your root Epic to `createEpicMiddleware(rootEpic)` is no longer supported, instead use `epicMiddleware.run(rootEpic)`\n\nLearn more: https://redux-observable.js.org/MIGRATION.html#setting-up-the-middleware');
  }

  var epic$ = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["b" /* Subject */]();
  var store = void 0;

  var epicMiddleware = function epicMiddleware(_store) {
    if (false) {
      // https://github.com/redux-observable/redux-observable/issues/389
      require('./utils/console').warn('this middleware is already associated with a store. createEpicMiddleware should be called for every store.\n\nLearn more: https://goo.gl/2GQ7Da');
    }
    store = _store;
    var actionSubject$ = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["b" /* Subject */]().pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["e" /* observeOn */])(__WEBPACK_IMPORTED_MODULE_0_rxjs__["f" /* queueScheduler */]));
    var stateSubject$ = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["b" /* Subject */]().pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["e" /* observeOn */])(__WEBPACK_IMPORTED_MODULE_0_rxjs__["f" /* queueScheduler */]));
    var action$ = new __WEBPACK_IMPORTED_MODULE_2__ActionsObservable__["a" /* ActionsObservable */](actionSubject$);
    var state$ = new __WEBPACK_IMPORTED_MODULE_3__StateObservable__["a" /* StateObservable */](stateSubject$, store.getState());

    var result$ = epic$.pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["c" /* map */])(function (epic) {
      var output$ = 'dependencies' in options ? epic(action$, state$, options.dependencies) : epic(action$, state$);

      if (!output$) {
        throw new TypeError('Your root Epic "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
      }

      return output$;
    }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["d" /* mergeMap */])(function (output$) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_rxjs__["c" /* from */])(output$).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["f" /* subscribeOn */])(__WEBPACK_IMPORTED_MODULE_0_rxjs__["f" /* queueScheduler */]), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["e" /* observeOn */])(__WEBPACK_IMPORTED_MODULE_0_rxjs__["f" /* queueScheduler */]));
    }));

    result$.subscribe(store.dispatch);

    return function (next) {
      return function (action) {
        // Downstream middleware gets the action first,
        // which includes their reducers, so state is
        // updated before epics receive the action
        var result = next(action);

        // It's important to update the state$ before we emit
        // the action because otherwise it would be stale
        stateSubject$.next(store.getState());
        actionSubject$.next(action);

        return result;
      };
    };
  };

  epicMiddleware.run = function (rootEpic) {
    if (false) {
      require('./utils/console').warn('epicMiddleware.run(rootEpic) called before the middleware has been setup by redux. Provide the epicMiddleware instance to createStore() first.');
    }
    epic$.next(rootEpic);
  };

  return epicMiddleware;
}

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_rxSubscriber__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Observer__ = __webpack_require__(208);
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */



function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof __WEBPACK_IMPORTED_MODULE_0__Subscriber__["a" /* Subscriber */]) {
            return nextOrObserver;
        }
        if (nextOrObserver[__WEBPACK_IMPORTED_MODULE_1__symbol_rxSubscriber__["a" /* rxSubscriber */]]) {
            return nextOrObserver[__WEBPACK_IMPORTED_MODULE_1__symbol_rxSubscriber__["a" /* rxSubscriber */]]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new __WEBPACK_IMPORTED_MODULE_0__Subscriber__["a" /* Subscriber */](__WEBPACK_IMPORTED_MODULE_2__Observer__["a" /* empty */]);
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Subscriber__["a" /* Subscriber */](nextOrObserver, error, complete);
}
//# sourceMappingURL=toSubscriber.js.map


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueueAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncAction__ = __webpack_require__(90);
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */


var QueueAction = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        return scheduler.flush(this);
    };
    return QueueAction;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncAction__["a" /* AsyncAction */]));

//# sourceMappingURL=QueueAction.js.map


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Action; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(34);
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */


var Action = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return this;
    };
    return Action;
}(__WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]));

//# sourceMappingURL=Action.js.map


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueueScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__ = __webpack_require__(91);
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */


var QueueScheduler = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__["a" /* AsyncScheduler */]));

//# sourceMappingURL=QueueScheduler.js.map


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsapAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Immediate__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AsyncAction__ = __webpack_require__(90);
/** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */



var AsapAction = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = __WEBPACK_IMPORTED_MODULE_1__util_Immediate__["a" /* Immediate */].setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            __WEBPACK_IMPORTED_MODULE_1__util_Immediate__["a" /* Immediate */].clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}(__WEBPACK_IMPORTED_MODULE_2__AsyncAction__["a" /* AsyncAction */]));

//# sourceMappingURL=AsapAction.js.map


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Immediate; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var nextHandle = 1;
var tasksByHandle = {};
function runIfPresent(handle) {
    var cb = tasksByHandle[handle];
    if (cb) {
        cb();
    }
}
var Immediate = {
    setImmediate: function (cb) {
        var handle = nextHandle++;
        tasksByHandle[handle] = cb;
        Promise.resolve().then(function () { return runIfPresent(handle); });
        return handle;
    },
    clearImmediate: function (handle) {
        delete tasksByHandle[handle];
    },
};
//# sourceMappingURL=Immediate.js.map


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsapScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__ = __webpack_require__(91);
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */


var AsapScheduler = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__["a" /* AsyncScheduler */]));

//# sourceMappingURL=AsapScheduler.js.map


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export animationFrame */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimationFrameAction__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimationFrameScheduler__ = __webpack_require__(364);
/** PURE_IMPORTS_START _AnimationFrameAction,_AnimationFrameScheduler PURE_IMPORTS_END */


var animationFrame = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__AnimationFrameScheduler__["a" /* AnimationFrameScheduler */](__WEBPACK_IMPORTED_MODULE_0__AnimationFrameAction__["a" /* AnimationFrameAction */]);
//# sourceMappingURL=animationFrame.js.map


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationFrameAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncAction__ = __webpack_require__(90);
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */


var AnimationFrameAction = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function () { return scheduler.flush(null); }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncAction__["a" /* AsyncAction */]));

//# sourceMappingURL=AnimationFrameAction.js.map


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationFrameScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__ = __webpack_require__(91);
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */


var AnimationFrameScheduler = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__["a" /* AsyncScheduler */]));

//# sourceMappingURL=AnimationFrameScheduler.js.map


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VirtualTimeScheduler */
/* unused harmony export VirtualAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncAction__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AsyncScheduler__ = __webpack_require__(91);
/** PURE_IMPORTS_START tslib,_AsyncAction,_AsyncScheduler PURE_IMPORTS_END */



var VirtualTimeScheduler = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        if (SchedulerAction === void 0) {
            SchedulerAction = VirtualAction;
        }
        if (maxFrames === void 0) {
            maxFrames = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, SchedulerAction, function () { return _this.frame; }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while ((action = actions.shift()) && (this.frame = action.delay) <= maxFrames) {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        }
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(__WEBPACK_IMPORTED_MODULE_2__AsyncScheduler__["a" /* AsyncScheduler */]));

var VirtualAction = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) {
            index = scheduler.index += 1;
        }
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (!this.id) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.active = false;
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncAction__["a" /* AsyncAction */]));

//# sourceMappingURL=VirtualTimeScheduler.js.map


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isObservable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

function isObservable(obj) {
    return !!obj && (obj instanceof __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */] || (typeof obj.lift === 'function' && typeof obj.subscribe === 'function'));
}
//# sourceMappingURL=isObservable.js.map


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bindCallback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncSubject__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operators_map__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_isScheduler__ = __webpack_require__(47);
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_isArray,_util_isScheduler PURE_IMPORTS_END */





function bindCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (Object(__WEBPACK_IMPORTED_MODULE_4__util_isScheduler__["a" /* isScheduler */])(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe(Object(__WEBPACK_IMPORTED_MODULE_2__operators_map__["a" /* map */])(function (args) { return Object(__WEBPACK_IMPORTED_MODULE_3__util_isArray__["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        var subject;
        var params = {
            context: context,
            subject: subject,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
        };
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
            if (!scheduler) {
                if (!subject) {
                    subject = new __WEBPACK_IMPORTED_MODULE_1__AsyncSubject__["a" /* AsyncSubject */]();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        subject.error(err);
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                var state = {
                    args: args, subscriber: subscriber, params: params,
                };
                return scheduler.schedule(dispatch, 0, state);
            }
        });
    };
}
function dispatch(state) {
    var _this = this;
    var self = this;
    var args = state.args, subscriber = state.subscriber, params = state.params;
    var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new __WEBPACK_IMPORTED_MODULE_1__AsyncSubject__["a" /* AsyncSubject */]();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
            _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            subject.error(err);
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(state) {
    var value = state.value, subject = state.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(state) {
    var err = state.err, subject = state.subject;
    subject.error(err);
}
//# sourceMappingURL=bindCallback.js.map


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bindNodeCallback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncSubject__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operators_map__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isScheduler__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_isArray__ = __webpack_require__(41);
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_isScheduler,_util_isArray PURE_IMPORTS_END */





function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__util_isScheduler__["a" /* isScheduler */])(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe(Object(__WEBPACK_IMPORTED_MODULE_2__operators_map__["a" /* map */])(function (args) { return Object(__WEBPACK_IMPORTED_MODULE_4__util_isArray__["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var params = {
            subject: undefined,
            args: args,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
            context: this,
        };
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
            var context = params.context;
            var subject = params.subject;
            if (!scheduler) {
                if (!subject) {
                    subject = params.subject = new __WEBPACK_IMPORTED_MODULE_1__AsyncSubject__["a" /* AsyncSubject */]();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        var err = innerArgs.shift();
                        if (err) {
                            subject.error(err);
                            return;
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        subject.error(err);
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                return scheduler.schedule(dispatch, 0, { params: params, subscriber: subscriber, context: context });
            }
        });
    };
}
function dispatch(state) {
    var _this = this;
    var params = state.params, subscriber = state.subscriber, context = state.context;
    var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new __WEBPACK_IMPORTED_MODULE_1__AsyncSubject__["a" /* AsyncSubject */]();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var err = innerArgs.shift();
            if (err) {
                _this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
            }
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
            }
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}
//# sourceMappingURL=bindNodeCallback.js.map


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isInteropObservable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbol_observable__ = __webpack_require__(72);
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */

function isInteropObservable(input) {
    return input && typeof input[__WEBPACK_IMPORTED_MODULE_0__symbol_observable__["a" /* observable */]] === 'function';
}
//# sourceMappingURL=isInteropObservable.js.map


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isIterable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbol_iterator__ = __webpack_require__(94);
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */

function isIterable(input) {
    return input && typeof input[__WEBPACK_IMPORTED_MODULE_0__symbol_iterator__["a" /* iterator */]] === 'function';
}
//# sourceMappingURL=isIterable.js.map


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromPromise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToPromise__ = __webpack_require__(222);
/** PURE_IMPORTS_START _Observable,_Subscription,_util_subscribeToPromise PURE_IMPORTS_END */



function fromPromise(input, scheduler) {
    if (!scheduler) {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToPromise__["a" /* subscribeToPromise */])(input));
    }
    else {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
            var sub = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
            sub.add(scheduler.schedule(function () {
                return input.then(function (value) {
                    sub.add(scheduler.schedule(function () {
                        subscriber.next(value);
                        sub.add(scheduler.schedule(function () { return subscriber.complete(); }));
                    }));
                }, function (err) {
                    sub.add(scheduler.schedule(function () { return subscriber.error(err); }));
                });
            }));
            return sub;
        });
    }
}
//# sourceMappingURL=fromPromise.js.map


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromIterable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_iterator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToIterable__ = __webpack_require__(223);
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator,_util_subscribeToIterable PURE_IMPORTS_END */




function fromIterable(input, scheduler) {
    if (!input) {
        throw new Error('Iterable cannot be null');
    }
    if (!scheduler) {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToIterable__["a" /* subscribeToIterable */])(input));
    }
    else {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
            var sub = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
            var iterator;
            sub.add(function () {
                if (iterator && typeof iterator.return === 'function') {
                    iterator.return();
                }
            });
            sub.add(scheduler.schedule(function () {
                iterator = input[__WEBPACK_IMPORTED_MODULE_2__symbol_iterator__["a" /* iterator */]]();
                sub.add(scheduler.schedule(function () {
                    if (subscriber.closed) {
                        return;
                    }
                    var value;
                    var done;
                    try {
                        var result = iterator.next();
                        value = result.value;
                        done = result.done;
                    }
                    catch (err) {
                        subscriber.error(err);
                        return;
                    }
                    if (done) {
                        subscriber.complete();
                    }
                    else {
                        subscriber.next(value);
                        this.schedule();
                    }
                }));
            }));
            return sub;
        });
    }
}
//# sourceMappingURL=fromIterable.js.map


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromObservable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_observable__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToObservable__ = __webpack_require__(224);
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable,_util_subscribeToObservable PURE_IMPORTS_END */




function fromObservable(input, scheduler) {
    if (!scheduler) {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToObservable__["a" /* subscribeToObservable */])(input));
    }
    else {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
            var sub = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
            sub.add(scheduler.schedule(function () {
                var observable = input[__WEBPACK_IMPORTED_MODULE_2__symbol_observable__["a" /* observable */]]();
                sub.add(observable.subscribe({
                    next: function (value) { sub.add(scheduler.schedule(function () { return subscriber.next(value); })); },
                    error: function (err) { sub.add(scheduler.schedule(function () { return subscriber.error(err); })); },
                    complete: function () { sub.add(scheduler.schedule(function () { return subscriber.complete(); })); },
                }));
            }));
            return sub;
        });
    }
}
//# sourceMappingURL=fromObservable.js.map


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export forkJoin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__empty__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__operators_map__ = __webpack_require__(48);
/** PURE_IMPORTS_START tslib,_Observable,_util_isArray,_empty,_util_subscribeToResult,_OuterSubscriber,_operators_map PURE_IMPORTS_END */







function forkJoin() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var resultSelector;
    if (typeof sources[sources.length - 1] === 'function') {
        resultSelector = sources.pop();
    }
    if (sources.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_2__util_isArray__["a" /* isArray */])(sources[0])) {
        sources = sources[0];
    }
    if (sources.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_3__empty__["a" /* EMPTY */];
    }
    if (resultSelector) {
        return forkJoin(sources).pipe(Object(__WEBPACK_IMPORTED_MODULE_6__operators_map__["a" /* map */])(function (args) { return resultSelector.apply(void 0, args); }));
    }
    return new __WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */](function (subscriber) {
        return new ForkJoinSubscriber(subscriber, sources);
    });
}
var ForkJoinSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ForkJoinSubscriber, _super);
    function ForkJoinSubscriber(destination, sources) {
        var _this = _super.call(this, destination) || this;
        _this.sources = sources;
        _this.completed = 0;
        _this.haveValues = 0;
        var len = sources.length;
        _this.values = new Array(len);
        for (var i = 0; i < len; i++) {
            var source = sources[i];
            var innerSubscription = Object(__WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__["a" /* subscribeToResult */])(_this, source, null, i);
            if (innerSubscription) {
                _this.add(innerSubscription);
            }
        }
        return _this;
    }
    ForkJoinSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        if (!innerSub._hasValue) {
            innerSub._hasValue = true;
            this.haveValues++;
        }
    };
    ForkJoinSubscriber.prototype.notifyComplete = function (innerSub) {
        var _a = this, destination = _a.destination, haveValues = _a.haveValues, values = _a.values;
        var len = values.length;
        if (!innerSub._hasValue) {
            destination.complete();
            return;
        }
        this.completed++;
        if (this.completed !== len) {
            return;
        }
        if (haveValues === len) {
            destination.next(values);
        }
        destination.complete();
    };
    return ForkJoinSubscriber;
}(__WEBPACK_IMPORTED_MODULE_5__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=forkJoin.js.map


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fromEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isFunction__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operators_map__ = __webpack_require__(48);
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */




var toString = Object.prototype.toString;
function fromEvent(target, eventName, options, resultSelector) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__util_isFunction__["a" /* isFunction */])(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) {
        return fromEvent(target, eventName, options).pipe(Object(__WEBPACK_IMPORTED_MODULE_3__operators_map__["a" /* map */])(function (args) { return Object(__WEBPACK_IMPORTED_MODULE_1__util_isArray__["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        function handler(e) {
            if (arguments.length > 1) {
                subscriber.next(Array.prototype.slice.call(arguments));
            }
            else {
                subscriber.next(e);
            }
        }
        setupSubscription(target, eventName, handler, subscriber, options);
    });
}
function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
    var unsubscribe;
    if (isEventTarget(sourceObj)) {
        var source_1 = sourceObj;
        sourceObj.addEventListener(eventName, handler, options);
        unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
    }
    else if (isJQueryStyleEventEmitter(sourceObj)) {
        var source_2 = sourceObj;
        sourceObj.on(eventName, handler);
        unsubscribe = function () { return source_2.off(eventName, handler); };
    }
    else if (isNodeStyleEventEmitter(sourceObj)) {
        var source_3 = sourceObj;
        sourceObj.addListener(eventName, handler);
        unsubscribe = function () { return source_3.removeListener(eventName, handler); };
    }
    else if (sourceObj && sourceObj.length) {
        for (var i = 0, len = sourceObj.length; i < len; i++) {
            setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
        }
    }
    else {
        throw new TypeError('Invalid event target');
    }
    subscriber.add(unsubscribe);
}
function isNodeStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function isJQueryStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function isEventTarget(sourceObj) {
    return sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
//# sourceMappingURL=fromEvent.js.map


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fromEventPattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isFunction__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operators_map__ = __webpack_require__(48);
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */




function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) {
        return fromEventPattern(addHandler, removeHandler).pipe(Object(__WEBPACK_IMPORTED_MODULE_3__operators_map__["a" /* map */])(function (args) { return Object(__WEBPACK_IMPORTED_MODULE_1__util_isArray__["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var handler = function () {
            var e = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                e[_i] = arguments[_i];
            }
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue;
        try {
            retValue = addHandler(handler);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__util_isFunction__["a" /* isFunction */])(removeHandler)) {
            return undefined;
        }
        return function () { return removeHandler(handler, retValue); };
    });
}
//# sourceMappingURL=fromEventPattern.js.map


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_identity__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isScheduler__ = __webpack_require__(47);
/** PURE_IMPORTS_START _Observable,_util_identity,_util_isScheduler PURE_IMPORTS_END */



function generate(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
    var resultSelector;
    var initialState;
    if (arguments.length == 1) {
        var options = initialStateOrOptions;
        initialState = options.initialState;
        condition = options.condition;
        iterate = options.iterate;
        resultSelector = options.resultSelector || __WEBPACK_IMPORTED_MODULE_1__util_identity__["a" /* identity */];
        scheduler = options.scheduler;
    }
    else if (resultSelectorOrObservable === undefined || Object(__WEBPACK_IMPORTED_MODULE_2__util_isScheduler__["a" /* isScheduler */])(resultSelectorOrObservable)) {
        initialState = initialStateOrOptions;
        resultSelector = __WEBPACK_IMPORTED_MODULE_1__util_identity__["a" /* identity */];
        scheduler = resultSelectorOrObservable;
    }
    else {
        initialState = initialStateOrOptions;
        resultSelector = resultSelectorOrObservable;
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var state = initialState;
        if (scheduler) {
            return scheduler.schedule(dispatch, 0, {
                subscriber: subscriber,
                iterate: iterate,
                condition: condition,
                resultSelector: resultSelector,
                state: state
            });
        }
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                }
                catch (err) {
                    subscriber.error(err);
                    return undefined;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
            subscriber.next(value);
            if (subscriber.closed) {
                break;
            }
            try {
                state = iterate(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
        } while (true);
        return undefined;
    });
}
function dispatch(state) {
    var subscriber = state.subscriber, condition = state.condition;
    if (subscriber.closed) {
        return undefined;
    }
    if (state.needIterate) {
        try {
            state.state = state.iterate(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
    }
    else {
        state.needIterate = true;
    }
    if (condition) {
        var conditionResult = void 0;
        try {
            conditionResult = condition(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!conditionResult) {
            subscriber.complete();
            return undefined;
        }
        if (subscriber.closed) {
            return undefined;
        }
    }
    var value;
    try {
        value = state.resultSelector(state.state);
    }
    catch (err) {
        subscriber.error(err);
        return undefined;
    }
    if (subscriber.closed) {
        return undefined;
    }
    subscriber.next(value);
    if (subscriber.closed) {
        return undefined;
    }
    return this.schedule(state);
}
//# sourceMappingURL=generate.js.map


/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export iif */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defer__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__empty__ = __webpack_require__(42);
/** PURE_IMPORTS_START _defer,_empty PURE_IMPORTS_END */


function iif(condition, trueResult, falseResult) {
    if (trueResult === void 0) {
        trueResult = __WEBPACK_IMPORTED_MODULE_1__empty__["a" /* EMPTY */];
    }
    if (falseResult === void 0) {
        falseResult = __WEBPACK_IMPORTED_MODULE_1__empty__["a" /* EMPTY */];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__defer__["a" /* defer */])(function () { return condition() ? trueResult : falseResult; });
}
//# sourceMappingURL=iif.js.map


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export interval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler_async__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isNumeric__ = __webpack_require__(121);
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric PURE_IMPORTS_END */



function interval(period, scheduler) {
    if (period === void 0) {
        period = 0;
    }
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_1__scheduler_async__["a" /* async */];
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__util_isNumeric__["a" /* isNumeric */])(period) || period < 0) {
        period = 0;
    }
    if (!scheduler || typeof scheduler.schedule !== 'function') {
        scheduler = __WEBPACK_IMPORTED_MODULE_1__scheduler_async__["a" /* async */];
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        subscriber.add(scheduler.schedule(dispatch, period, { subscriber: subscriber, counter: 0, period: period }));
        return subscriber;
    });
}
function dispatch(state) {
    var subscriber = state.subscriber, counter = state.counter, period = state.period;
    subscriber.next(counter);
    this.schedule({ subscriber: subscriber, counter: counter + 1, period: period }, period);
}
//# sourceMappingURL=interval.js.map


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export onErrorResumeNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__from__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__empty__ = __webpack_require__(42);
/** PURE_IMPORTS_START _Observable,_from,_util_isArray,_empty PURE_IMPORTS_END */




function onErrorResumeNext() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_3__empty__["a" /* EMPTY */];
    }
    var first = sources[0], remainder = sources.slice(1);
    if (sources.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_2__util_isArray__["a" /* isArray */])(first)) {
        return onErrorResumeNext.apply(void 0, first);
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var subNext = function () { return subscriber.add(onErrorResumeNext.apply(void 0, remainder).subscribe(subscriber)); };
        return Object(__WEBPACK_IMPORTED_MODULE_1__from__["a" /* from */])(first).subscribe({
            next: function (value) { subscriber.next(value); },
            error: subNext,
            complete: subNext,
        });
    });
}
//# sourceMappingURL=onErrorResumeNext.js.map


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pairs */
/* unused harmony export dispatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(34);
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */


function pairs(obj, scheduler) {
    if (!scheduler) {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
            var keys = Object.keys(obj);
            for (var i = 0; i < keys.length && !subscriber.closed; i++) {
                var key = keys[i];
                if (obj.hasOwnProperty(key)) {
                    subscriber.next([key, obj[key]]);
                }
            }
            subscriber.complete();
        });
    }
    else {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
            var keys = Object.keys(obj);
            var subscription = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
            subscription.add(scheduler.schedule(dispatch, 0, { keys: keys, index: 0, subscriber: subscriber, subscription: subscription, obj: obj }));
            return subscription;
        });
    }
}
function dispatch(state) {
    var keys = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
    if (!subscriber.closed) {
        if (index < keys.length) {
            var key = keys[index];
            subscriber.next([key, obj[key]]);
            subscription.add(this.schedule({ keys: keys, index: index + 1, subscriber: subscriber, subscription: subscription, obj: obj }));
        }
        else {
            subscriber.complete();
        }
    }
}
//# sourceMappingURL=pairs.js.map


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export range */
/* unused harmony export dispatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

function range(start, count, scheduler) {
    if (start === void 0) {
        start = 0;
    }
    if (count === void 0) {
        count = 0;
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var index = 0;
        var current = start;
        if (scheduler) {
            return scheduler.schedule(dispatch, 0, {
                index: index, count: count, start: start, subscriber: subscriber
            });
        }
        else {
            do {
                if (index++ >= count) {
                    subscriber.complete();
                    break;
                }
                subscriber.next(current++);
                if (subscriber.closed) {
                    break;
                }
            } while (true);
        }
        return undefined;
    });
}
function dispatch(state) {
    var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
    if (index >= count) {
        subscriber.complete();
        return;
    }
    subscriber.next(start);
    if (subscriber.closed) {
        return;
    }
    state.index = index + 1;
    state.start = start + 1;
    this.schedule(state);
}
//# sourceMappingURL=range.js.map


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export using */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__from__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__empty__ = __webpack_require__(42);
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */



function using(resourceFactory, observableFactory) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var resource;
        try {
            resource = resourceFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var result;
        try {
            result = observableFactory(resource);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = result ? Object(__WEBPACK_IMPORTED_MODULE_1__from__["a" /* from */])(result) : __WEBPACK_IMPORTED_MODULE_2__empty__["a" /* EMPTY */];
        var subscription = source.subscribe(subscriber);
        return function () {
            subscription.unsubscribe();
            if (resource) {
                resource.unsubscribe();
            }
        };
    });
}
//# sourceMappingURL=using.js.map


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export auditTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduler_async__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audit__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_timer__ = __webpack_require__(231);
/** PURE_IMPORTS_START _scheduler_async,_audit,_observable_timer PURE_IMPORTS_END */



function auditTime(duration, scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_0__scheduler_async__["a" /* async */];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__audit__["a" /* audit */])(function () { return Object(__WEBPACK_IMPORTED_MODULE_2__observable_timer__["a" /* timer */])(duration, scheduler); });
}
//# sourceMappingURL=auditTime.js.map


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buffer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
var BufferOperator = /*@__PURE__*/ (function () {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}());
var BufferSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        var _this = _super.call(this, destination) || this;
        _this.buffer = [];
        _this.add(Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(_this, closingNotifier));
        return _this;
    }
    BufferSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=buffer.js.map


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bufferCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) {
        startBufferEvery = null;
    }
    return function bufferCountOperatorFunction(source) {
        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
    };
}
var BufferCountOperator = /*@__PURE__*/ (function () {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) {
            this.subscriberClass = BufferCountSubscriber;
        }
        else {
            this.subscriberClass = BufferSkipCountSubscriber;
        }
    }
    BufferCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}());
var BufferCountSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.buffer = [];
        return _this;
    }
    BufferCountSubscriber.prototype._next = function (value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer.length > 0) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
var BufferSkipCountSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.startBufferEvery = startBufferEvery;
        _this.buffers = [];
        _this.count = 0;
        return _this;
    }
    BufferSkipCountSubscriber.prototype._next = function (value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) {
            buffers.push([]);
        }
        for (var i = buffers.length; i--;) {
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function () {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while (buffers.length > 0) {
            var buffer = buffers.shift();
            if (buffer.length > 0) {
                destination.next(buffer);
            }
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=bufferCount.js.map


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bufferTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler_async__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isScheduler__ = __webpack_require__(47);
/** PURE_IMPORTS_START tslib,_scheduler_async,_Subscriber,_util_isScheduler PURE_IMPORTS_END */




function bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = __WEBPACK_IMPORTED_MODULE_1__scheduler_async__["a" /* async */];
    if (Object(__WEBPACK_IMPORTED_MODULE_3__util_isScheduler__["a" /* isScheduler */])(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) {
        bufferCreationInterval = arguments[1];
    }
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) {
        maxBufferSize = arguments[2];
    }
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
var BufferTimeOperator = /*@__PURE__*/ (function () {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}());
var Context = /*@__PURE__*/ (function () {
    function Context() {
        this.buffer = [];
    }
    return Context;
}());
var BufferTimeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.bufferTimeSpan = bufferTimeSpan;
        _this.bufferCreationInterval = bufferCreationInterval;
        _this.maxBufferSize = maxBufferSize;
        _this.scheduler = scheduler;
        _this.contexts = [];
        var context = _this.openContext();
        _this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (_this.timespanOnly) {
            var timeSpanOnlyState = { subscriber: _this, context: context, bufferTimeSpan: bufferTimeSpan };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
        else {
            var closeState = { subscriber: _this, context: context };
            var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: _this, scheduler: scheduler };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
        }
        return _this;
    }
    BufferTimeSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for (var i = 0; i < len; i++) {
            var context_1 = contexts[i];
            var buffer = context_1.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) {
                filledBufferContext = context_1;
            }
        }
        if (filledBufferContext) {
            this.onBufferFull(filledBufferContext);
        }
    };
    BufferTimeSubscriber.prototype._error = function (err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function () {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while (contexts.length > 0) {
            var context_2 = contexts.shift();
            destination.next(context_2.buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferTimeSubscriber.prototype._unsubscribe = function () {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function (context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function () {
        var context = new Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function (context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) {
            contexts.splice(contexts.indexOf(context), 1);
        }
    };
    return BufferTimeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__Subscriber__["a" /* Subscriber */]));
function dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) {
        subscriber.closeContext(prevContext);
    }
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
        action.schedule(state, bufferCreationInterval);
    }
}
function dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}
//# sourceMappingURL=bufferTime.js.map


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bufferToggle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = __webpack_require__(27);
/** PURE_IMPORTS_START tslib,_Subscription,_util_subscribeToResult,_OuterSubscriber PURE_IMPORTS_END */




function bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new BufferToggleOperator(openings, closingSelector));
    };
}
var BufferToggleOperator = /*@__PURE__*/ (function () {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}());
var BufferToggleSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.openings = openings;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add(Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(_this, openings));
        return _this;
    }
    BufferToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for (var i = 0; i < len; i++) {
            contexts[i].buffer.push(value);
        }
    };
    BufferToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context_1 = contexts.shift();
            context_1.subscription.unsubscribe();
            context_1.buffer = null;
            context_1.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context_2 = contexts.shift();
            this.destination.next(context_2.buffer);
            context_2.subscription.unsubscribe();
            context_2.buffer = null;
            context_2.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function (value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) {
                this.trySubscribe(closingNotifier);
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function (context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
        var context = { buffer: buffer, subscription: subscription };
        contexts.push(context);
        var innerSubscription = Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) {
            this.closeBuffer(context);
        }
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=bufferToggle.js.map


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bufferWhen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_tryCatch__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_errorObject__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_Subscription,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */






function bufferWhen(closingSelector) {
    return function (source) {
        return source.lift(new BufferWhenOperator(closingSelector));
    };
}
var BufferWhenOperator = /*@__PURE__*/ (function () {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}());
var BufferWhenSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.closingSelector = closingSelector;
        _this.subscribing = false;
        _this.openBuffer();
        return _this;
    }
    BufferWhenSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferWhenSubscriber.prototype._unsubscribe = function () {
        this.buffer = null;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function () {
        if (this.subscribing) {
            this.complete();
        }
        else {
            this.openBuffer();
        }
    };
    BufferWhenSubscriber.prototype.openBuffer = function () {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) {
            this.destination.next(buffer);
        }
        this.buffer = [];
        var closingNotifier = Object(__WEBPACK_IMPORTED_MODULE_2__util_tryCatch__["a" /* tryCatch */])(this.closingSelector)();
        if (closingNotifier === __WEBPACK_IMPORTED_MODULE_3__util_errorObject__["a" /* errorObject */]) {
            this.error(__WEBPACK_IMPORTED_MODULE_3__util_errorObject__["a" /* errorObject */].e);
        }
        else {
            closingSubscription = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
            this.closingSubscription = closingSubscription;
            this.add(closingSubscription);
            this.subscribing = true;
            closingSubscription.add(Object(__WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__["a" /* subscribeToResult */])(this, closingNotifier));
            this.subscribing = false;
        }
    };
    return BufferWhenSubscriber;
}(__WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=bufferWhen.js.map


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = catchError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return (operator.caught = caught);
    };
}
var CatchOperator = /*@__PURE__*/ (function () {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}());
var CatchSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        var _this = _super.call(this, destination) || this;
        _this.selector = selector;
        _this.caught = caught;
        return _this;
    }
    CatchSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            }
            catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            var innerSubscriber = new __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__["a" /* InnerSubscriber */](this, undefined, undefined);
            this.add(innerSubscriber);
            Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__["a" /* subscribeToResult */])(this, result, undefined, undefined, innerSubscriber);
        }
    };
    return CatchSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=catchError.js.map


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export combineAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_combineLatest__ = __webpack_require__(157);
/** PURE_IMPORTS_START _observable_combineLatest PURE_IMPORTS_END */

function combineAll(project) {
    return function (source) { return source.lift(new __WEBPACK_IMPORTED_MODULE_0__observable_combineLatest__["a" /* CombineLatestOperator */](project)); };
}
//# sourceMappingURL=combineAll.js.map


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export combineLatest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_isArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observable_combineLatest__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_from__ = __webpack_require__(55);
/** PURE_IMPORTS_START _util_isArray,_observable_combineLatest,_observable_from PURE_IMPORTS_END */



var none = {};
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') {
        project = observables.pop();
    }
    if (observables.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_0__util_isArray__["a" /* isArray */])(observables[0])) {
        observables = observables[0].slice();
    }
    return function (source) { return source.lift.call(Object(__WEBPACK_IMPORTED_MODULE_2__observable_from__["a" /* from */])([source].concat(observables)), new __WEBPACK_IMPORTED_MODULE_1__observable_combineLatest__["a" /* CombineLatestOperator */](project)); };
}
//# sourceMappingURL=combineLatest.js.map


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export concat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_concat__ = __webpack_require__(120);
/** PURE_IMPORTS_START _observable_concat PURE_IMPORTS_END */

function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function (source) { return source.lift.call(__WEBPACK_IMPORTED_MODULE_0__observable_concat__["a" /* concat */].apply(void 0, [source].concat(observables))); };
}
//# sourceMappingURL=concat.js.map


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export concatMapTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__concatMap__ = __webpack_require__(233);
/** PURE_IMPORTS_START _concatMap PURE_IMPORTS_END */

function concatMapTo(innerObservable, resultSelector) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__concatMap__["a" /* concatMap */])(function () { return innerObservable; }, resultSelector);
}
//# sourceMappingURL=concatMapTo.js.map


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export count */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function count(predicate) {
    return function (source) { return source.lift(new CountOperator(predicate, source)); };
}
var CountOperator = /*@__PURE__*/ (function () {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}());
var CountSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.count = 0;
        _this.index = 0;
        return _this;
    }
    CountSubscriber.prototype._next = function (value) {
        if (this.predicate) {
            this._tryPredicate(value);
        }
        else {
            this.count++;
        }
    };
    CountSubscriber.prototype._tryPredicate = function (value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.count++;
        }
    };
    CountSubscriber.prototype._complete = function () {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=count.js.map


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export debounce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function debounce(durationSelector) {
    return function (source) { return source.lift(new DebounceOperator(durationSelector)); };
}
var DebounceOperator = /*@__PURE__*/ (function () {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}());
var DebounceSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        _this.durationSubscription = null;
        return _this;
    }
    DebounceSubscriber.prototype._next = function (value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) {
                this._tryNext(value, result);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function () {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function (value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(this, duration);
        if (subscription && !subscription.closed) {
            this.add(this.durationSubscription = subscription);
        }
    };
    DebounceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = null;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = null;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=debounce.js.map


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export debounceTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_async__ = __webpack_require__(43);
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */



function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_async__["a" /* async */];
    }
    return function (source) { return source.lift(new DebounceTimeOperator(dueTime, scheduler)); };
}
var DebounceTimeOperator = /*@__PURE__*/ (function () {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}());
var DebounceTimeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.dueTime = dueTime;
        _this.scheduler = scheduler;
        _this.debouncedSubscription = null;
        _this.lastValue = null;
        _this.hasValue = false;
        return _this;
    }
    DebounceTimeSubscriber.prototype._next = function (value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function () {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function () {
        this.clearDebounce();
        if (this.hasValue) {
            var lastValue = this.lastValue;
            this.lastValue = null;
            this.hasValue = false;
            this.destination.next(lastValue);
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function () {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
function dispatchNext(subscriber) {
    subscriber.debouncedNext();
}
//# sourceMappingURL=debounceTime.js.map


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export delay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler_async__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isDate__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Notification__ = __webpack_require__(118);
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_Subscriber,_Notification PURE_IMPORTS_END */





function delay(delay, scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_1__scheduler_async__["a" /* async */];
    }
    var absoluteDelay = Object(__WEBPACK_IMPORTED_MODULE_2__util_isDate__["a" /* isDate */])(delay);
    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
    return function (source) { return source.lift(new DelayOperator(delayFor, scheduler)); };
}
var DelayOperator = /*@__PURE__*/ (function () {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}());
var DelaySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.delay = delay;
        _this.scheduler = scheduler;
        _this.queue = [];
        _this.active = false;
        _this.errored = false;
        return _this;
    }
    DelaySubscriber.dispatch = function (state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
            queue.shift().notification.observe(destination);
        }
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        }
        else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function (scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this, destination: this.destination, scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function (notification) {
        if (this.errored === true) {
            return;
        }
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) {
            this._schedule(scheduler);
        }
    };
    DelaySubscriber.prototype._next = function (value) {
        this.scheduleNotification(__WEBPACK_IMPORTED_MODULE_4__Notification__["a" /* Notification */].createNext(value));
    };
    DelaySubscriber.prototype._error = function (err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function () {
        this.scheduleNotification(__WEBPACK_IMPORTED_MODULE_4__Notification__["a" /* Notification */].createComplete());
    };
    return DelaySubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__Subscriber__["a" /* Subscriber */]));
var DelayMessage = /*@__PURE__*/ (function () {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}());
//# sourceMappingURL=delay.js.map


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export delayWhen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) {
        return function (source) {
            return new SubscriptionDelayObservable(source, subscriptionDelay)
                .lift(new DelayWhenOperator(delayDurationSelector));
        };
    }
    return function (source) { return source.lift(new DelayWhenOperator(delayDurationSelector)); };
}
var DelayWhenOperator = /*@__PURE__*/ (function () {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}());
var DelayWhenSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.delayDurationSelector = delayDurationSelector;
        _this.completed = false;
        _this.delayNotifierSubscriptions = [];
        _this.index = 0;
        return _this;
    }
    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) {
            this.destination.next(value);
        }
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function (value) {
        var index = this.index++;
        try {
            var delayNotifier = this.delayDurationSelector(value, index);
            if (delayNotifier) {
                this.tryDelay(delayNotifier, value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function () {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        if (subscriptionIdx !== -1) {
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
        }
        return subscription.outerValue;
    };
    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
        var notifierSubscription = Object(__WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__["a" /* subscribeToResult */])(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
    };
    DelayWhenSubscriber.prototype.tryComplete = function () {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
            this.destination.complete();
        }
    };
    return DelayWhenSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));
var SubscriptionDelayObservable = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(source, subscriptionDelay) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subscriptionDelay = subscriptionDelay;
        return _this;
    }
    SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}(__WEBPACK_IMPORTED_MODULE_2__Observable__["a" /* Observable */]));
var SubscriptionDelaySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.source = source;
        _this.sourceSubscribed = false;
        return _this;
    }
    SubscriptionDelaySubscriber.prototype._next = function (unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function (err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function () {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=delayWhen.js.map


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dematerialize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new DeMaterializeOperator());
    };
}
var DeMaterializeOperator = /*@__PURE__*/ (function () {
    function DeMaterializeOperator() {
    }
    DeMaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}());
var DeMaterializeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    DeMaterializeSubscriber.prototype._next = function (value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=dematerialize.js.map


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export distinct */
/* unused harmony export DistinctSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function distinct(keySelector, flushes) {
    return function (source) { return source.lift(new DistinctOperator(keySelector, flushes)); };
}
var DistinctOperator = /*@__PURE__*/ (function () {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}());
var DistinctSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.values = new Set();
        if (flushes) {
            _this.add(Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(_this, flushes));
        }
        return _this;
    }
    DistinctSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function (value) {
        if (this.keySelector) {
            this._useKeySelector(value);
        }
        else {
            this._finalizeNext(value, value);
        }
    };
    DistinctSubscriber.prototype._useKeySelector = function (value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function (key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));

//# sourceMappingURL=distinct.js.map


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export distinctUntilKeyChanged */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__distinctUntilChanged__ = __webpack_require__(235);
/** PURE_IMPORTS_START _distinctUntilChanged PURE_IMPORTS_END */

function distinctUntilKeyChanged(key, compare) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__distinctUntilChanged__["a" /* distinctUntilChanged */])(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
}
//# sourceMappingURL=distinctUntilKeyChanged.js.map


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export elementAt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_ArgumentOutOfRangeError__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filter__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throwIfEmpty__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultIfEmpty__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__take__ = __webpack_require__(161);
/** PURE_IMPORTS_START _util_ArgumentOutOfRangeError,_filter,_throwIfEmpty,_defaultIfEmpty,_take PURE_IMPORTS_END */





function elementAt(index, defaultValue) {
    if (index < 0) {
        throw new __WEBPACK_IMPORTED_MODULE_0__util_ArgumentOutOfRangeError__["a" /* ArgumentOutOfRangeError */]();
    }
    var hasDefaultValue = arguments.length >= 2;
    return function (source) {
        return source.pipe(Object(__WEBPACK_IMPORTED_MODULE_1__filter__["a" /* filter */])(function (v, i) { return i === index; }), Object(__WEBPACK_IMPORTED_MODULE_4__take__["a" /* take */])(1), hasDefaultValue
            ? Object(__WEBPACK_IMPORTED_MODULE_3__defaultIfEmpty__["a" /* defaultIfEmpty */])(defaultValue)
            : Object(__WEBPACK_IMPORTED_MODULE_2__throwIfEmpty__["a" /* throwIfEmpty */])(function () { return new __WEBPACK_IMPORTED_MODULE_0__util_ArgumentOutOfRangeError__["a" /* ArgumentOutOfRangeError */](); }));
    };
}
//# sourceMappingURL=elementAt.js.map


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export endWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_fromArray__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observable_scalar__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_empty__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__observable_concat__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_isScheduler__ = __webpack_require__(47);
/** PURE_IMPORTS_START _observable_fromArray,_observable_scalar,_observable_empty,_observable_concat,_util_isScheduler PURE_IMPORTS_END */





function endWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i] = arguments[_i];
    }
    return function (source) {
        var scheduler = array[array.length - 1];
        if (Object(__WEBPACK_IMPORTED_MODULE_4__util_isScheduler__["a" /* isScheduler */])(scheduler)) {
            array.pop();
        }
        else {
            scheduler = null;
        }
        var len = array.length;
        if (len === 1 && !scheduler) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__observable_concat__["a" /* concat */])(source, Object(__WEBPACK_IMPORTED_MODULE_1__observable_scalar__["a" /* scalar */])(array[0]));
        }
        else if (len > 0) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__observable_concat__["a" /* concat */])(source, Object(__WEBPACK_IMPORTED_MODULE_0__observable_fromArray__["a" /* fromArray */])(array, scheduler));
        }
        else {
            return Object(__WEBPACK_IMPORTED_MODULE_3__observable_concat__["a" /* concat */])(source, Object(__WEBPACK_IMPORTED_MODULE_2__observable_empty__["b" /* empty */])(scheduler));
        }
    };
}
//# sourceMappingURL=endWith.js.map


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export every */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function every(predicate, thisArg) {
    return function (source) { return source.lift(new EveryOperator(predicate, thisArg, source)); };
}
var EveryOperator = /*@__PURE__*/ (function () {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function (observer, source) {
        return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}());
var EverySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.source = source;
        _this.index = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function (value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) {
            this.notifyComplete(false);
        }
    };
    EverySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=every.js.map


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export exhaust */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function exhaust() {
    return function (source) { return source.lift(new SwitchFirstOperator()); };
}
var SwitchFirstOperator = /*@__PURE__*/ (function () {
    function SwitchFirstOperator() {
    }
    SwitchFirstOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}());
var SwitchFirstSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasCompleted = false;
        _this.hasSubscription = false;
        return _this;
    }
    SwitchFirstSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add(Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return SwitchFirstSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=exhaust.js.map


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export exhaustMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__observable_from__ = __webpack_require__(55);
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult,_map,_observable_from PURE_IMPORTS_END */






function exhaustMap(project, resultSelector) {
    if (resultSelector) {
        return function (source) { return source.pipe(exhaustMap(function (a, i) { return Object(__WEBPACK_IMPORTED_MODULE_5__observable_from__["a" /* from */])(project(a, i)).pipe(Object(__WEBPACK_IMPORTED_MODULE_4__map__["a" /* map */])(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
    }
    return function (source) {
        return source.lift(new ExhauseMapOperator(project));
    };
}
var ExhauseMapOperator = /*@__PURE__*/ (function () {
    function ExhauseMapOperator(project) {
        this.project = project;
    }
    ExhauseMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ExhaustMapSubscriber(subscriber, this.project));
    };
    return ExhauseMapOperator;
}());
var ExhaustMapSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ExhaustMapSubscriber, _super);
    function ExhaustMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.hasSubscription = false;
        _this.hasCompleted = false;
        _this.index = 0;
        return _this;
    }
    ExhaustMapSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.tryNext(value);
        }
    };
    ExhaustMapSubscriber.prototype.tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.hasSubscription = true;
        this._innerSub(result, value, index);
    };
    ExhaustMapSubscriber.prototype._innerSub = function (result, value, index) {
        var innerSubscriber = new __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__["a" /* InnerSubscriber */](this, undefined, undefined);
        this.add(innerSubscriber);
        Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__["a" /* subscribeToResult */])(this, result, value, index, innerSubscriber);
    };
    ExhaustMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
    };
    ExhaustMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    ExhaustMapSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    ExhaustMapSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return ExhaustMapSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=exhaustMap.js.map


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export expand */
/* unused harmony export ExpandOperator */
/* unused harmony export ExpandSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_tryCatch__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_errorObject__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (scheduler === void 0) {
        scheduler = undefined;
    }
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function (source) { return source.lift(new ExpandOperator(project, concurrent, scheduler)); };
}
var ExpandOperator = /*@__PURE__*/ (function () {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}());

var ExpandSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.scheduler = scheduler;
        _this.index = 0;
        _this.active = 0;
        _this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) {
            _this.buffer = [];
        }
        return _this;
    }
    ExpandSubscriber.dispatch = function (arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = Object(__WEBPACK_IMPORTED_MODULE_1__util_tryCatch__["a" /* tryCatch */])(this.project)(value, index);
            if (result === __WEBPACK_IMPORTED_MODULE_2__util_errorObject__["a" /* errorObject */]) {
                destination.error(__WEBPACK_IMPORTED_MODULE_2__util_errorObject__["a" /* errorObject */].e);
            }
            else if (!this.scheduler) {
                this.subscribeToProjection(result, value, index);
            }
            else {
                var state = { subscriber: this, result: result, value: value, index: index };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        }
        else {
            this.buffer.push(value);
        }
    };
    ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
        this.active++;
        this.add(Object(__WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__["a" /* subscribeToResult */])(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    ExpandSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) {
            this._next(buffer.shift());
        }
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    return ExpandSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));

//# sourceMappingURL=expand.js.map


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export finalize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscription__ = __webpack_require__(34);
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription PURE_IMPORTS_END */



function finalize(callback) {
    return function (source) { return source.lift(new FinallyOperator(callback)); };
}
var FinallyOperator = /*@__PURE__*/ (function () {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}());
var FinallySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        var _this = _super.call(this, destination) || this;
        _this.add(new __WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */](callback));
        return _this;
    }
    return FinallySubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=finalize.js.map


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__operators_find__ = __webpack_require__(237);
/** PURE_IMPORTS_START _operators_find PURE_IMPORTS_END */

function findIndex(predicate, thisArg) {
    return function (source) { return source.lift(new __WEBPACK_IMPORTED_MODULE_0__operators_find__["a" /* FindValueOperator */](predicate, source, true, thisArg)); };
}
//# sourceMappingURL=findIndex.js.map


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export first */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_EmptyError__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filter__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__take__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultIfEmpty__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__throwIfEmpty__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_identity__ = __webpack_require__(73);
/** PURE_IMPORTS_START _util_EmptyError,_filter,_take,_defaultIfEmpty,_throwIfEmpty,_util_identity PURE_IMPORTS_END */






function first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) { return source.pipe(predicate ? Object(__WEBPACK_IMPORTED_MODULE_1__filter__["a" /* filter */])(function (v, i) { return predicate(v, i, source); }) : __WEBPACK_IMPORTED_MODULE_5__util_identity__["a" /* identity */], Object(__WEBPACK_IMPORTED_MODULE_2__take__["a" /* take */])(1), hasDefaultValue ? Object(__WEBPACK_IMPORTED_MODULE_3__defaultIfEmpty__["a" /* defaultIfEmpty */])(defaultValue) : Object(__WEBPACK_IMPORTED_MODULE_4__throwIfEmpty__["a" /* throwIfEmpty */])(function () { return new __WEBPACK_IMPORTED_MODULE_0__util_EmptyError__["a" /* EmptyError */](); })); };
}
//# sourceMappingURL=first.js.map


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ignoreElements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new IgnoreElementsOperator());
    };
}
var IgnoreElementsOperator = /*@__PURE__*/ (function () {
    function IgnoreElementsOperator() {
    }
    IgnoreElementsOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}());
var IgnoreElementsSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IgnoreElementsSubscriber.prototype._next = function (unused) {
    };
    return IgnoreElementsSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=ignoreElements.js.map


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isEmpty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function isEmpty() {
    return function (source) { return source.lift(new IsEmptyOperator()); };
}
var IsEmptyOperator = /*@__PURE__*/ (function () {
    function IsEmptyOperator() {
    }
    IsEmptyOperator.prototype.call = function (observer, source) {
        return source.subscribe(new IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}());
var IsEmptySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function (value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=isEmpty.js.map


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export last */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_EmptyError__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filter__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__takeLast__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__throwIfEmpty__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultIfEmpty__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_identity__ = __webpack_require__(73);
/** PURE_IMPORTS_START _util_EmptyError,_filter,_takeLast,_throwIfEmpty,_defaultIfEmpty,_util_identity PURE_IMPORTS_END */






function last(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) { return source.pipe(predicate ? Object(__WEBPACK_IMPORTED_MODULE_1__filter__["a" /* filter */])(function (v, i) { return predicate(v, i, source); }) : __WEBPACK_IMPORTED_MODULE_5__util_identity__["a" /* identity */], Object(__WEBPACK_IMPORTED_MODULE_2__takeLast__["a" /* takeLast */])(1), hasDefaultValue ? Object(__WEBPACK_IMPORTED_MODULE_4__defaultIfEmpty__["a" /* defaultIfEmpty */])(defaultValue) : Object(__WEBPACK_IMPORTED_MODULE_3__throwIfEmpty__["a" /* throwIfEmpty */])(function () { return new __WEBPACK_IMPORTED_MODULE_0__util_EmptyError__["a" /* EmptyError */](); })); };
}
//# sourceMappingURL=last.js.map


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function mapTo(value) {
    return function (source) { return source.lift(new MapToOperator(value)); };
}
var MapToOperator = /*@__PURE__*/ (function () {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}());
var MapToSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        var _this = _super.call(this, destination) || this;
        _this.value = value;
        return _this;
    }
    MapToSubscriber.prototype._next = function (x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=mapTo.js.map


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export materialize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Notification__ = __webpack_require__(118);
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */



function materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new MaterializeOperator());
    };
}
var MaterializeOperator = /*@__PURE__*/ (function () {
    function MaterializeOperator() {
    }
    MaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}());
var MaterializeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    MaterializeSubscriber.prototype._next = function (value) {
        this.destination.next(__WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* Notification */].createNext(value));
    };
    MaterializeSubscriber.prototype._error = function (err) {
        var destination = this.destination;
        destination.next(__WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* Notification */].createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function () {
        var destination = this.destination;
        destination.next(__WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* Notification */].createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=materialize.js.map


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reduce__ = __webpack_require__(124);
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

function max(comparer) {
    var max = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
        : function (x, y) { return x > y ? x : y; };
    return Object(__WEBPACK_IMPORTED_MODULE_0__reduce__["a" /* reduce */])(max);
}
//# sourceMappingURL=max.js.map


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_merge__ = __webpack_require__(228);
/** PURE_IMPORTS_START _observable_merge PURE_IMPORTS_END */

function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function (source) { return source.lift.call(__WEBPACK_IMPORTED_MODULE_0__observable_merge__["a" /* merge */].apply(void 0, [source].concat(observables))); };
}
//# sourceMappingURL=merge.js.map


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mergeMapTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeMap__ = __webpack_require__(95);
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */

function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (typeof resultSelector === 'function') {
        return Object(__WEBPACK_IMPORTED_MODULE_0__mergeMap__["a" /* mergeMap */])(function () { return innerObservable; }, resultSelector, concurrent);
    }
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__mergeMap__["a" /* mergeMap */])(function () { return innerObservable; }, concurrent);
}
//# sourceMappingURL=mergeMapTo.js.map


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mergeScan */
/* unused harmony export MergeScanOperator */
/* unused harmony export MergeScanSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_tryCatch__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_errorObject__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InnerSubscriber__ = __webpack_require__(60);
/** PURE_IMPORTS_START tslib,_util_tryCatch,_util_errorObject,_util_subscribeToResult,_OuterSubscriber,_InnerSubscriber PURE_IMPORTS_END */






function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return function (source) { return source.lift(new MergeScanOperator(accumulator, seed, concurrent)); };
}
var MergeScanOperator = /*@__PURE__*/ (function () {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}());

var MergeScanSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this.acc = acc;
        _this.concurrent = concurrent;
        _this.hasValue = false;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeScanSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = Object(__WEBPACK_IMPORTED_MODULE_1__util_tryCatch__["a" /* tryCatch */])(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === __WEBPACK_IMPORTED_MODULE_2__util_errorObject__["a" /* errorObject */]) {
                destination.error(__WEBPACK_IMPORTED_MODULE_2__util_errorObject__["a" /* errorObject */].e);
            }
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeScanSubscriber.prototype._innerSub = function (ish, value, index) {
        var innerSubscriber = new __WEBPACK_IMPORTED_MODULE_5__InnerSubscriber__["a" /* InnerSubscriber */](this, undefined, undefined);
        this.add(innerSubscriber);
        Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__["a" /* subscribeToResult */])(this, ish, value, index, innerSubscriber);
    };
    MergeScanSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}(__WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__["a" /* OuterSubscriber */]));

//# sourceMappingURL=mergeScan.js.map


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reduce__ = __webpack_require__(124);
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

function min(comparer) {
    var min = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) < 0 ? x : y; }
        : function (x, y) { return x < y ? x : y; };
    return Object(__WEBPACK_IMPORTED_MODULE_0__reduce__["a" /* reduce */])(min);
}
//# sourceMappingURL=min.js.map


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export onErrorResumeNext */
/* unused harmony export onErrorResumeNextStatic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observable_from__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InnerSubscriber__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_observable_from,_util_isArray,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult PURE_IMPORTS_END */






function onErrorResumeNext() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i] = arguments[_i];
    }
    if (nextSources.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_2__util_isArray__["a" /* isArray */])(nextSources[0])) {
        nextSources = nextSources[0];
    }
    return function (source) { return source.lift(new OnErrorResumeNextOperator(nextSources)); };
}
function onErrorResumeNextStatic() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i] = arguments[_i];
    }
    var source = null;
    if (nextSources.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_2__util_isArray__["a" /* isArray */])(nextSources[0])) {
        nextSources = nextSources[0];
    }
    source = nextSources.shift();
    return Object(__WEBPACK_IMPORTED_MODULE_1__observable_from__["a" /* from */])(source, null).lift(new OnErrorResumeNextOperator(nextSources));
}
var OnErrorResumeNextOperator = /*@__PURE__*/ (function () {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}());
var OnErrorResumeNextSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.nextSources = nextSources;
        return _this;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function (error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function (innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function (err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function () {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
        var next = this.nextSources.shift();
        if (next) {
            var innerSubscriber = new __WEBPACK_IMPORTED_MODULE_4__InnerSubscriber__["a" /* InnerSubscriber */](this, undefined, undefined);
            this.add(innerSubscriber);
            Object(__WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__["a" /* subscribeToResult */])(this, next, undefined, undefined, innerSubscriber);
        }
        else {
            this.destination.complete();
        }
    };
    return OnErrorResumeNextSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=onErrorResumeNext.js.map


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pairwise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function pairwise() {
    return function (source) { return source.lift(new PairwiseOperator()); };
}
var PairwiseOperator = /*@__PURE__*/ (function () {
    function PairwiseOperator() {
    }
    PairwiseOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}());
var PairwiseSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasPrev = false;
        return _this;
    }
    PairwiseSubscriber.prototype._next = function (value) {
        if (this.hasPrev) {
            this.destination.next([this.prev, value]);
        }
        else {
            this.hasPrev = true;
        }
        this.prev = value;
    };
    return PairwiseSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=pairwise.js.map


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export partition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_not__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filter__ = __webpack_require__(97);
/** PURE_IMPORTS_START _util_not,_filter PURE_IMPORTS_END */


function partition(predicate, thisArg) {
    return function (source) {
        return [
            Object(__WEBPACK_IMPORTED_MODULE_1__filter__["a" /* filter */])(predicate, thisArg)(source),
            Object(__WEBPACK_IMPORTED_MODULE_1__filter__["a" /* filter */])(Object(__WEBPACK_IMPORTED_MODULE_0__util_not__["a" /* not */])(predicate, thisArg))(source)
        ];
    };
}
//# sourceMappingURL=partition.js.map


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = not;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
//# sourceMappingURL=not.js.map


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pluck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(48);
/** PURE_IMPORTS_START _map PURE_IMPORTS_END */

function pluck() {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i] = arguments[_i];
    }
    var length = properties.length;
    if (length === 0) {
        throw new Error('list of properties cannot be empty.');
    }
    return function (source) { return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* map */])(plucker(properties, length))(source); };
}
function plucker(props, length) {
    var mapper = function (x) {
        var currentProp = x;
        for (var i = 0; i < length; i++) {
            var p = currentProp[props[i]];
            if (typeof p !== 'undefined') {
                currentProp = p;
            }
            else {
                return undefined;
            }
        }
        return currentProp;
    };
    return mapper;
}
//# sourceMappingURL=pluck.js.map


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export publish */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Subject__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multicast__ = __webpack_require__(74);
/** PURE_IMPORTS_START _Subject,_multicast PURE_IMPORTS_END */


function publish(selector) {
    return selector ?
        Object(__WEBPACK_IMPORTED_MODULE_1__multicast__["a" /* multicast */])(function () { return new __WEBPACK_IMPORTED_MODULE_0__Subject__["a" /* Subject */](); }, selector) :
        Object(__WEBPACK_IMPORTED_MODULE_1__multicast__["a" /* multicast */])(new __WEBPACK_IMPORTED_MODULE_0__Subject__["a" /* Subject */]());
}
//# sourceMappingURL=publish.js.map


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export publishBehavior */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BehaviorSubject__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multicast__ = __webpack_require__(74);
/** PURE_IMPORTS_START _BehaviorSubject,_multicast PURE_IMPORTS_END */


function publishBehavior(value) {
    return function (source) { return Object(__WEBPACK_IMPORTED_MODULE_1__multicast__["a" /* multicast */])(new __WEBPACK_IMPORTED_MODULE_0__BehaviorSubject__["a" /* BehaviorSubject */](value))(source); };
}
//# sourceMappingURL=publishBehavior.js.map


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export publishLast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncSubject__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multicast__ = __webpack_require__(74);
/** PURE_IMPORTS_START _AsyncSubject,_multicast PURE_IMPORTS_END */


function publishLast() {
    return function (source) { return Object(__WEBPACK_IMPORTED_MODULE_1__multicast__["a" /* multicast */])(new __WEBPACK_IMPORTED_MODULE_0__AsyncSubject__["a" /* AsyncSubject */]())(source); };
}
//# sourceMappingURL=publishLast.js.map


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export publishReplay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReplaySubject__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multicast__ = __webpack_require__(74);
/** PURE_IMPORTS_START _ReplaySubject,_multicast PURE_IMPORTS_END */


function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') {
        scheduler = selectorOrScheduler;
    }
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new __WEBPACK_IMPORTED_MODULE_0__ReplaySubject__["a" /* ReplaySubject */](bufferSize, windowTime, scheduler);
    return function (source) { return Object(__WEBPACK_IMPORTED_MODULE_1__multicast__["a" /* multicast */])(function () { return subject; }, selector)(source); };
}
//# sourceMappingURL=publishReplay.js.map


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export race */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_isArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observable_race__ = __webpack_require__(230);
/** PURE_IMPORTS_START _util_isArray,_observable_race PURE_IMPORTS_END */


function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function raceOperatorFunction(source) {
        if (observables.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_0__util_isArray__["a" /* isArray */])(observables[0])) {
            observables = observables[0];
        }
        return source.lift.call(__WEBPACK_IMPORTED_MODULE_1__observable_race__["a" /* race */].apply(void 0, [source].concat(observables)));
    };
}
//# sourceMappingURL=race.js.map


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export repeat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_empty__ = __webpack_require__(42);
/** PURE_IMPORTS_START tslib,_Subscriber,_observable_empty PURE_IMPORTS_END */



function repeat(count) {
    if (count === void 0) {
        count = -1;
    }
    return function (source) {
        if (count === 0) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__observable_empty__["b" /* empty */])();
        }
        else if (count < 0) {
            return source.lift(new RepeatOperator(-1, source));
        }
        else {
            return source.lift(new RepeatOperator(count - 1, source));
        }
    };
}
var RepeatOperator = /*@__PURE__*/ (function () {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}());
var RepeatSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RepeatSubscriber.prototype.complete = function () {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.complete.call(this);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=repeat.js.map


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export repeatWhen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_tryCatch__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_errorObject__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_Subject,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */






function repeatWhen(notifier) {
    return function (source) { return source.lift(new RepeatWhenOperator(notifier)); };
}
var RepeatWhenOperator = /*@__PURE__*/ (function () {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}());
var RepeatWhenSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        _this.sourceIsBeingSubscribedTo = true;
        return _this;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) {
            return _super.prototype.complete.call(this);
        }
    };
    RepeatWhenSubscriber.prototype.complete = function () {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) {
                this.subscribeToRetries();
            }
            if (!this.retriesSubscription || this.retriesSubscription.closed) {
                return _super.prototype.complete.call(this);
            }
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    RepeatWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this._unsubscribe = _unsubscribe;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
        this.notifications = new __WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]();
        var retries = Object(__WEBPACK_IMPORTED_MODULE_2__util_tryCatch__["a" /* tryCatch */])(this.notifier)(this.notifications);
        if (retries === __WEBPACK_IMPORTED_MODULE_3__util_errorObject__["a" /* errorObject */]) {
            return _super.prototype.complete.call(this);
        }
        this.retries = retries;
        this.retriesSubscription = Object(__WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__["a" /* subscribeToResult */])(this, retries);
    };
    return RepeatWhenSubscriber;
}(__WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=repeatWhen.js.map


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export retry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function retry(count) {
    if (count === void 0) {
        count = -1;
    }
    return function (source) { return source.lift(new RetryOperator(count, source)); };
}
var RetryOperator = /*@__PURE__*/ (function () {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}());
var RetrySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RetrySubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.error.call(this, err);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=retry.js.map


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export retryWhen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_tryCatch__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_errorObject__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_Subject,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */






function retryWhen(notifier) {
    return function (source) { return source.lift(new RetryWhenOperator(notifier, source)); };
}
var RetryWhenOperator = /*@__PURE__*/ (function () {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}());
var RetryWhenSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        return _this;
    }
    RetryWhenSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new __WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]();
                retries = Object(__WEBPACK_IMPORTED_MODULE_2__util_tryCatch__["a" /* tryCatch */])(this.notifier)(errors);
                if (retries === __WEBPACK_IMPORTED_MODULE_3__util_errorObject__["a" /* errorObject */]) {
                    return _super.prototype.error.call(this, __WEBPACK_IMPORTED_MODULE_3__util_errorObject__["a" /* errorObject */].e);
                }
                retriesSubscription = Object(__WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__["a" /* subscribeToResult */])(this, retries);
            }
            else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    RetryWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        this._unsubscribeAndRecycle();
        this._unsubscribe = _unsubscribe;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}(__WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=retryWhen.js.map


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sample */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function sample(notifier) {
    return function (source) { return source.lift(new SampleOperator(notifier)); };
}
var SampleOperator = /*@__PURE__*/ (function () {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function (subscriber, source) {
        var sampleSubscriber = new SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add(Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(sampleSubscriber, this.notifier));
        return subscription;
    };
    return SampleOperator;
}());
var SampleSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SampleSubscriber, _super);
    function SampleSubscriber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasValue = false;
        return _this;
    }
    SampleSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=sample.js.map


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sampleTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_async__ = __webpack_require__(43);
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */



function sampleTime(period, scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_async__["a" /* async */];
    }
    return function (source) { return source.lift(new SampleTimeOperator(period, scheduler)); };
}
var SampleTimeOperator = /*@__PURE__*/ (function () {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}());
var SampleTimeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.period = period;
        _this.scheduler = scheduler;
        _this.hasValue = false;
        _this.add(scheduler.schedule(dispatchNotification, period, { subscriber: _this, period: period }));
        return _this;
    }
    SampleTimeSubscriber.prototype._next = function (value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
function dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}
//# sourceMappingURL=sampleTime.js.map


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sequenceEqual */
/* unused harmony export SequenceEqualOperator */
/* unused harmony export SequenceEqualSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_tryCatch__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_errorObject__ = __webpack_require__(46);
/** PURE_IMPORTS_START tslib,_Subscriber,_util_tryCatch,_util_errorObject PURE_IMPORTS_END */




function sequenceEqual(compareTo, comparor) {
    return function (source) { return source.lift(new SequenceEqualOperator(compareTo, comparor)); };
}
var SequenceEqualOperator = /*@__PURE__*/ (function () {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}());

var SequenceEqualSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        var _this = _super.call(this, destination) || this;
        _this.compareTo = compareTo;
        _this.comparor = comparor;
        _this._a = [];
        _this._b = [];
        _this._oneComplete = false;
        _this.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, _this)));
        return _this;
    }
    SequenceEqualSubscriber.prototype._next = function (value) {
        if (this._oneComplete && this._b.length === 0) {
            this.emit(false);
        }
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function () {
        if (this._oneComplete) {
            this.emit(this._a.length === 0 && this._b.length === 0);
        }
        else {
            this._oneComplete = true;
        }
    };
    SequenceEqualSubscriber.prototype.checkValues = function () {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while (_a.length > 0 && _b.length > 0) {
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = Object(__WEBPACK_IMPORTED_MODULE_2__util_tryCatch__["a" /* tryCatch */])(comparor)(a, b);
                if (areEqual === __WEBPACK_IMPORTED_MODULE_3__util_errorObject__["a" /* errorObject */]) {
                    this.destination.error(__WEBPACK_IMPORTED_MODULE_3__util_errorObject__["a" /* errorObject */].e);
                }
            }
            else {
                areEqual = a === b;
            }
            if (!areEqual) {
                this.emit(false);
            }
        }
    };
    SequenceEqualSubscriber.prototype.emit = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function (value) {
        if (this._oneComplete && this._a.length === 0) {
            this.emit(false);
        }
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));

var SequenceEqualCompareToSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        return _this;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function (value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function (err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function () {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=sequenceEqual.js.map


/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export share */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__multicast__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__refCount__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subject__ = __webpack_require__(40);
/** PURE_IMPORTS_START _multicast,_refCount,_Subject PURE_IMPORTS_END */



function shareSubjectFactory() {
    return new __WEBPACK_IMPORTED_MODULE_2__Subject__["a" /* Subject */]();
}
function share() {
    return function (source) { return Object(__WEBPACK_IMPORTED_MODULE_1__refCount__["a" /* refCount */])()(Object(__WEBPACK_IMPORTED_MODULE_0__multicast__["a" /* multicast */])(shareSubjectFactory)(source)); };
}
//# sourceMappingURL=share.js.map


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export shareReplay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReplaySubject__ = __webpack_require__(153);
/** PURE_IMPORTS_START _ReplaySubject PURE_IMPORTS_END */

function shareReplay(bufferSize, windowTime, scheduler) {
    if (bufferSize === void 0) {
        bufferSize = Number.POSITIVE_INFINITY;
    }
    if (windowTime === void 0) {
        windowTime = Number.MAX_VALUE;
    }
    return function (source) { return source.lift(shareReplayOperator(bufferSize, windowTime, scheduler)); };
}
function shareReplayOperator(bufferSize, windowTime, scheduler) {
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new __WEBPACK_IMPORTED_MODULE_0__ReplaySubject__["a" /* ReplaySubject */](bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function (value) { subject.next(value); },
                error: function (err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function () {
                    isComplete = true;
                    subject.complete();
                },
            });
        }
        var innerSub = subject.subscribe(this);
        return function () {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && refCount === 0 && isComplete) {
                subscription.unsubscribe();
            }
        };
    };
}
//# sourceMappingURL=shareReplay.js.map


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export single */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_EmptyError__ = __webpack_require__(93);
/** PURE_IMPORTS_START tslib,_Subscriber,_util_EmptyError PURE_IMPORTS_END */



function single(predicate) {
    return function (source) { return source.lift(new SingleOperator(predicate, source)); };
}
var SingleOperator = /*@__PURE__*/ (function () {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}());
var SingleSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.seenValue = false;
        _this.index = 0;
        return _this;
    }
    SingleSubscriber.prototype.applySingleValue = function (value) {
        if (this.seenValue) {
            this.destination.error('Sequence contains more than one element');
        }
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this.tryNext(value, index);
        }
        else {
            this.applySingleValue(value);
        }
    };
    SingleSubscriber.prototype.tryNext = function (value, index) {
        try {
            if (this.predicate(value, index, this.source)) {
                this.applySingleValue(value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        }
        else {
            destination.error(new __WEBPACK_IMPORTED_MODULE_2__util_EmptyError__["a" /* EmptyError */]);
        }
    };
    return SingleSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=single.js.map


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export skip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function skip(count) {
    return function (source) { return source.lift(new SkipOperator(count)); };
}
var SkipOperator = /*@__PURE__*/ (function () {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}());
var SkipSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    SkipSubscriber.prototype._next = function (x) {
        if (++this.count > this.total) {
            this.destination.next(x);
        }
    };
    return SkipSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=skip.js.map


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export skipLast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ArgumentOutOfRangeError__ = __webpack_require__(92);
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError PURE_IMPORTS_END */



function skipLast(count) {
    return function (source) { return source.lift(new SkipLastOperator(count)); };
}
var SkipLastOperator = /*@__PURE__*/ (function () {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) {
            throw new __WEBPACK_IMPORTED_MODULE_2__util_ArgumentOutOfRangeError__["a" /* ArgumentOutOfRangeError */];
        }
    }
    SkipLastOperator.prototype.call = function (subscriber, source) {
        if (this._skipCount === 0) {
            return source.subscribe(new __WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */](subscriber));
        }
        else {
            return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
        }
    };
    return SkipLastOperator;
}());
var SkipLastSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        var _this = _super.call(this, destination) || this;
        _this._skipCount = _skipCount;
        _this._count = 0;
        _this._ring = new Array(_skipCount);
        return _this;
    }
    SkipLastSubscriber.prototype._next = function (value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) {
            this._ring[count] = value;
        }
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=skipLast.js.map


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export skipUntil */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function skipUntil(notifier) {
    return function (source) { return source.lift(new SkipUntilOperator(notifier)); };
}
var SkipUntilOperator = /*@__PURE__*/ (function () {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function (destination, source) {
        return source.subscribe(new SkipUntilSubscriber(destination, this.notifier));
    };
    return SkipUntilOperator;
}());
var SkipUntilSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        var _this = _super.call(this, destination) || this;
        _this.hasValue = false;
        var innerSubscriber = new __WEBPACK_IMPORTED_MODULE_2__InnerSubscriber__["a" /* InnerSubscriber */](_this, undefined, undefined);
        _this.add(innerSubscriber);
        _this.innerSubscription = innerSubscriber;
        Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__["a" /* subscribeToResult */])(_this, notifier, undefined, undefined, innerSubscriber);
        return _this;
    }
    SkipUntilSubscriber.prototype._next = function (value) {
        if (this.hasValue) {
            _super.prototype._next.call(this, value);
        }
    };
    SkipUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
        if (this.innerSubscription) {
            this.innerSubscription.unsubscribe();
        }
    };
    SkipUntilSubscriber.prototype.notifyComplete = function () {
    };
    return SkipUntilSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=skipUntil.js.map


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export skipWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function skipWhile(predicate) {
    return function (source) { return source.lift(new SkipWhileOperator(predicate)); };
}
var SkipWhileOperator = /*@__PURE__*/ (function () {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}());
var SkipWhileSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.skipping = true;
        _this.index = 0;
        return _this;
    }
    SkipWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (this.skipping) {
            this.tryCallPredicate(value);
        }
        if (!this.skipping) {
            destination.next(value);
        }
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=skipWhile.js.map


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export startWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_fromArray__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observable_scalar__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_empty__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__observable_concat__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_isScheduler__ = __webpack_require__(47);
/** PURE_IMPORTS_START _observable_fromArray,_observable_scalar,_observable_empty,_observable_concat,_util_isScheduler PURE_IMPORTS_END */





function startWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i] = arguments[_i];
    }
    return function (source) {
        var scheduler = array[array.length - 1];
        if (Object(__WEBPACK_IMPORTED_MODULE_4__util_isScheduler__["a" /* isScheduler */])(scheduler)) {
            array.pop();
        }
        else {
            scheduler = null;
        }
        var len = array.length;
        if (len === 1 && !scheduler) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__observable_concat__["a" /* concat */])(Object(__WEBPACK_IMPORTED_MODULE_1__observable_scalar__["a" /* scalar */])(array[0]), source);
        }
        else if (len > 0) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__observable_concat__["a" /* concat */])(Object(__WEBPACK_IMPORTED_MODULE_0__observable_fromArray__["a" /* fromArray */])(array, scheduler), source);
        }
        else {
            return Object(__WEBPACK_IMPORTED_MODULE_3__observable_concat__["a" /* concat */])(Object(__WEBPACK_IMPORTED_MODULE_2__observable_empty__["b" /* empty */])(scheduler), source);
        }
    };
}
//# sourceMappingURL=startWith.js.map


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subscribeOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_SubscribeOnObservable__ = __webpack_require__(448);
/** PURE_IMPORTS_START _observable_SubscribeOnObservable PURE_IMPORTS_END */

function subscribeOn(scheduler, delay) {
    if (delay === void 0) {
        delay = 0;
    }
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new SubscribeOnOperator(scheduler, delay));
    };
}
var SubscribeOnOperator = /*@__PURE__*/ (function () {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function (subscriber, source) {
        return new __WEBPACK_IMPORTED_MODULE_0__observable_SubscribeOnObservable__["a" /* SubscribeOnObservable */](source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}());
//# sourceMappingURL=subscribeOn.js.map


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubscribeOnObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_asap__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isNumeric__ = __webpack_require__(121);
/** PURE_IMPORTS_START tslib,_Observable,_scheduler_asap,_util_isNumeric PURE_IMPORTS_END */




var SubscribeOnObservable = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) {
            delayTime = 0;
        }
        if (scheduler === void 0) {
            scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_asap__["a" /* asap */];
        }
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.delayTime = delayTime;
        _this.scheduler = scheduler;
        if (!Object(__WEBPACK_IMPORTED_MODULE_3__util_isNumeric__["a" /* isNumeric */])(delayTime) || delayTime < 0) {
            _this.delayTime = 0;
        }
        if (!scheduler || typeof scheduler.schedule !== 'function') {
            _this.scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_asap__["a" /* asap */];
        }
        return _this;
    }
    SubscribeOnObservable.create = function (source, delay, scheduler) {
        if (delay === void 0) {
            delay = 0;
        }
        if (scheduler === void 0) {
            scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_asap__["a" /* asap */];
        }
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function (arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    SubscribeOnObservable.prototype._subscribe = function (subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source, subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}(__WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */]));

//# sourceMappingURL=SubscribeOnObservable.js.map


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export switchAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__switchMap__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_identity__ = __webpack_require__(73);
/** PURE_IMPORTS_START _switchMap,_util_identity PURE_IMPORTS_END */


function switchAll() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__switchMap__["a" /* switchMap */])(__WEBPACK_IMPORTED_MODULE_1__util_identity__["a" /* identity */]);
}
//# sourceMappingURL=switchAll.js.map


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export switchMapTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__switchMap__ = __webpack_require__(164);
/** PURE_IMPORTS_START _switchMap PURE_IMPORTS_END */

function switchMapTo(innerObservable, resultSelector) {
    return resultSelector ? Object(__WEBPACK_IMPORTED_MODULE_0__switchMap__["a" /* switchMap */])(function () { return innerObservable; }, resultSelector) : Object(__WEBPACK_IMPORTED_MODULE_0__switchMap__["a" /* switchMap */])(function () { return innerObservable; });
}
//# sourceMappingURL=switchMapTo.js.map


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeUntil */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function takeUntil(notifier) {
    return function (source) { return source.lift(new TakeUntilOperator(notifier)); };
}
var TakeUntilOperator = /*@__PURE__*/ (function () {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function (subscriber, source) {
        var takeUntilSubscriber = new TakeUntilSubscriber(subscriber);
        var notifierSubscription = Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(takeUntilSubscriber, this.notifier);
        if (notifierSubscription && !takeUntilSubscriber.seenValue) {
            takeUntilSubscriber.add(notifierSubscription);
            return source.subscribe(takeUntilSubscriber);
        }
        return takeUntilSubscriber;
    };
    return TakeUntilOperator;
}());
var TakeUntilSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.seenValue = false;
        return _this;
    }
    TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.seenValue = true;
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function () {
    };
    return TakeUntilSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=takeUntil.js.map


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function takeWhile(predicate) {
    return function (source) { return source.lift(new TakeWhileOperator(predicate)); };
}
var TakeWhileOperator = /*@__PURE__*/ (function () {
    function TakeWhileOperator(predicate) {
        this.predicate = predicate;
    }
    TakeWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate));
    };
    return TakeWhileOperator;
}());
var TakeWhileSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.index = 0;
        return _this;
    }
    TakeWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) {
            destination.next(value);
        }
        else {
            destination.complete();
        }
    };
    return TakeWhileSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=takeWhile.js.map


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export throttleTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_async__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__throttle__ = __webpack_require__(238);
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async,_throttle PURE_IMPORTS_END */




function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_async__["a" /* async */];
    }
    if (config === void 0) {
        config = __WEBPACK_IMPORTED_MODULE_3__throttle__["a" /* defaultThrottleConfig */];
    }
    return function (source) { return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing)); };
}
var ThrottleTimeOperator = /*@__PURE__*/ (function () {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}());
var ThrottleTimeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        var _this = _super.call(this, destination) || this;
        _this.duration = duration;
        _this.scheduler = scheduler;
        _this.leading = leading;
        _this.trailing = trailing;
        _this._hasTrailingValue = false;
        _this._trailingValue = null;
        return _this;
    }
    ThrottleTimeSubscriber.prototype._next = function (value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        }
        else {
            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
            if (this.leading) {
                this.destination.next(value);
            }
        }
    };
    ThrottleTimeSubscriber.prototype._complete = function () {
        if (this._hasTrailingValue) {
            this.destination.next(this._trailingValue);
            this.destination.complete();
        }
        else {
            this.destination.complete();
        }
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function () {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
function dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}
//# sourceMappingURL=throttleTime.js.map


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timeInterval */
/* unused harmony export TimeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduler_async__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scan__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_defer__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map__ = __webpack_require__(48);
/** PURE_IMPORTS_START _scheduler_async,_scan,_observable_defer,_map PURE_IMPORTS_END */




function timeInterval(scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_0__scheduler_async__["a" /* async */];
    }
    return function (source) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__observable_defer__["a" /* defer */])(function () {
            return source.pipe(Object(__WEBPACK_IMPORTED_MODULE_1__scan__["a" /* scan */])(function (_a, value) {
                var current = _a.current;
                return ({ value: value, current: scheduler.now(), last: current });
            }, { current: scheduler.now(), value: undefined, last: undefined }), Object(__WEBPACK_IMPORTED_MODULE_3__map__["a" /* map */])(function (_a) {
                var current = _a.current, last = _a.last, value = _a.value;
                return new TimeInterval(value, current - last);
            }));
        });
    };
}
var TimeInterval = /*@__PURE__*/ (function () {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}());

//# sourceMappingURL=timeInterval.js.map


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timeout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduler_async__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_TimeoutError__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timeoutWith__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__observable_throwError__ = __webpack_require__(156);
/** PURE_IMPORTS_START _scheduler_async,_util_TimeoutError,_timeoutWith,_observable_throwError PURE_IMPORTS_END */




function timeout(due, scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_0__scheduler_async__["a" /* async */];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__timeoutWith__["a" /* timeoutWith */])(due, Object(__WEBPACK_IMPORTED_MODULE_3__observable_throwError__["a" /* throwError */])(new __WEBPACK_IMPORTED_MODULE_1__util_TimeoutError__["a" /* TimeoutError */]()), scheduler);
}
//# sourceMappingURL=timeout.js.map


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timestamp */
/* unused harmony export Timestamp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduler_async__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map__ = __webpack_require__(48);
/** PURE_IMPORTS_START _scheduler_async,_map PURE_IMPORTS_END */


function timestamp(scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_0__scheduler_async__["a" /* async */];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__map__["a" /* map */])(function (value) { return new Timestamp(value, scheduler.now()); });
}
var Timestamp = /*@__PURE__*/ (function () {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}());

//# sourceMappingURL=timestamp.js.map


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reduce__ = __webpack_require__(124);
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

function toArrayReducer(arr, item, index) {
    if (index === 0) {
        return [item];
    }
    arr.push(item);
    return arr;
}
function toArray() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__reduce__["a" /* reduce */])(toArrayReducer, []);
}
//# sourceMappingURL=toArray.js.map


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export window */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new WindowOperator(windowBoundaries));
    };
}
var WindowOperator = /*@__PURE__*/ (function () {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) {
            windowSubscriber.add(Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToResult__["a" /* subscribeToResult */])(windowSubscriber, this.windowBoundaries));
        }
        return sourceSubscription;
    };
    return WindowOperator;
}());
var WindowSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.window = new __WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]();
        destination.next(_this.window);
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this._complete();
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
    };
    WindowSubscriber.prototype._unsubscribe = function () {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function () {
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var destination = this.destination;
        var newWindow = this.window = new __WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=window.js.map


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export windowCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subject__ = __webpack_require__(40);
/** PURE_IMPORTS_START tslib,_Subscriber,_Subject PURE_IMPORTS_END */



function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) {
        startWindowEvery = 0;
    }
    return function windowCountOperatorFunction(source) {
        return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
    };
}
var WindowCountOperator = /*@__PURE__*/ (function () {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}());
var WindowCountSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowSize = windowSize;
        _this.startWindowEvery = startWindowEvery;
        _this.windows = [new __WEBPACK_IMPORTED_MODULE_2__Subject__["a" /* Subject */]()];
        _this.count = 0;
        destination.next(_this.windows[0]);
        return _this;
    }
    WindowCountSubscriber.prototype._next = function (value) {
        var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len && !this.closed; i++) {
            windows[i].next(value);
        }
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
            windows.shift().complete();
        }
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new __WEBPACK_IMPORTED_MODULE_2__Subject__["a" /* Subject */]();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().error(err);
            }
        }
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function () {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().complete();
            }
        }
        this.destination.complete();
    };
    WindowCountSubscriber.prototype._unsubscribe = function () {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
//# sourceMappingURL=windowCount.js.map


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export windowTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_async__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscriber__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_isNumeric__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_isScheduler__ = __webpack_require__(47);
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_async,_Subscriber,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */






function windowTime(windowTimeSpan) {
    var scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_async__["a" /* async */];
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if (Object(__WEBPACK_IMPORTED_MODULE_5__util_isScheduler__["a" /* isScheduler */])(arguments[3])) {
        scheduler = arguments[3];
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_5__util_isScheduler__["a" /* isScheduler */])(arguments[2])) {
        scheduler = arguments[2];
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_4__util_isNumeric__["a" /* isNumeric */])(arguments[2])) {
        maxWindowSize = arguments[2];
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_5__util_isScheduler__["a" /* isScheduler */])(arguments[1])) {
        scheduler = arguments[1];
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_4__util_isNumeric__["a" /* isNumeric */])(arguments[1])) {
        windowCreationInterval = arguments[1];
    }
    return function windowTimeOperatorFunction(source) {
        return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
var WindowTimeOperator = /*@__PURE__*/ (function () {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}());
var CountedSubject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](CountedSubject, _super);
    function CountedSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._numberOfNextedValues = 0;
        return _this;
    }
    CountedSubject.prototype.next = function (value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function () {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]));
var WindowTimeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowTimeSpan = windowTimeSpan;
        _this.windowCreationInterval = windowCreationInterval;
        _this.maxWindowSize = maxWindowSize;
        _this.scheduler = scheduler;
        _this.windows = [];
        var window = _this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = { subscriber: _this, window: window, context: null };
            var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: _this, scheduler: scheduler };
            _this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
        }
        else {
            var timeSpanOnlyState = { subscriber: _this, window: window, windowTimeSpan: windowTimeSpan };
            _this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
        return _this;
    }
    WindowTimeSubscriber.prototype._next = function (value) {
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len; i++) {
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) {
                    this.closeWindow(window_1);
                }
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        while (windows.length > 0) {
            windows.shift().error(err);
        }
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function () {
        var windows = this.windows;
        while (windows.length > 0) {
            var window_2 = windows.shift();
            if (!window_2.closed) {
                window_2.complete();
            }
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function () {
        var window = new CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function (window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__Subscriber__["a" /* Subscriber */]));
function dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) {
        subscriber.closeWindow(window);
    }
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = { action: action, subscription: null };
    var timeSpanState = { subscriber: subscriber, window: window, context: context };
    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) {
        context.action.remove(context.subscription);
    }
    subscriber.closeWindow(window);
}
//# sourceMappingURL=windowTime.js.map


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export windowToggle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscription__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_tryCatch__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_errorObject__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_Subject,_Subscription,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */







function windowToggle(openings, closingSelector) {
    return function (source) { return source.lift(new WindowToggleOperator(openings, closingSelector)); };
}
var WindowToggleOperator = /*@__PURE__*/ (function () {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}());
var WindowToggleSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.openings = openings;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add(_this.openSubscription = Object(__WEBPACK_IMPORTED_MODULE_6__util_subscribeToResult__["a" /* subscribeToResult */])(_this, openings, openings));
        return _this;
    }
    WindowToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for (var i = 0; i < len; i++) {
                contexts[i].window.next(value);
            }
        }
    };
    WindowToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context_1 = contexts[index];
                context_1.window.error(err);
                context_1.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context_2 = contexts[index];
                context_2.window.complete();
                context_2.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    WindowToggleSubscriber.prototype._unsubscribe = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context_3 = contexts[index];
                context_3.window.unsubscribe();
                context_3.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = Object(__WEBPACK_IMPORTED_MODULE_3__util_tryCatch__["a" /* tryCatch */])(closingSelector)(innerValue);
            if (closingNotifier === __WEBPACK_IMPORTED_MODULE_4__util_errorObject__["a" /* errorObject */]) {
                return this.error(__WEBPACK_IMPORTED_MODULE_4__util_errorObject__["a" /* errorObject */].e);
            }
            else {
                var window_1 = new __WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]();
                var subscription = new __WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */]();
                var context_4 = { window: window_1, subscription: subscription };
                this.contexts.push(context_4);
                var innerSubscription = Object(__WEBPACK_IMPORTED_MODULE_6__util_subscribeToResult__["a" /* subscribeToResult */])(this, closingNotifier, context_4);
                if (innerSubscription.closed) {
                    this.closeWindow(this.contexts.length - 1);
                }
                else {
                    innerSubscription.context = context_4;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        }
        else {
            this.closeWindow(this.contexts.indexOf(outerValue));
        }
    };
    WindowToggleSubscriber.prototype.notifyError = function (err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
        if (inner !== this.openSubscription) {
            this.closeWindow(this.contexts.indexOf(inner.context));
        }
    };
    WindowToggleSubscriber.prototype.closeWindow = function (index) {
        if (index === -1) {
            return;
        }
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}(__WEBPACK_IMPORTED_MODULE_5__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=windowToggle.js.map


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export windowWhen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_tryCatch__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_errorObject__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_Subject,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */






function windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new WindowOperator(closingSelector));
    };
}
var WindowOperator = /*@__PURE__*/ (function () {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}());
var WindowSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.closingSelector = closingSelector;
        _this.openWindow();
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
        if (this.closingNotification) {
            this.closingNotification.unsubscribe();
        }
    };
    WindowSubscriber.prototype.openWindow = function (innerSub) {
        if (innerSub === void 0) {
            innerSub = null;
        }
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var window = this.window = new __WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]();
        this.destination.next(window);
        var closingNotifier = Object(__WEBPACK_IMPORTED_MODULE_2__util_tryCatch__["a" /* tryCatch */])(this.closingSelector)();
        if (closingNotifier === __WEBPACK_IMPORTED_MODULE_3__util_errorObject__["a" /* errorObject */]) {
            var err = __WEBPACK_IMPORTED_MODULE_3__util_errorObject__["a" /* errorObject */].e;
            this.destination.error(err);
            this.window.error(err);
        }
        else {
            this.add(this.closingNotification = Object(__WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__["a" /* subscribeToResult */])(this, closingNotifier));
        }
    };
    return WindowSubscriber;
}(__WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=windowWhen.js.map


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export withLatestFrom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = __webpack_require__(28);
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function withLatestFrom() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (source) {
        var project;
        if (typeof args[args.length - 1] === 'function') {
            project = args.pop();
        }
        var observables = args;
        return source.lift(new WithLatestFromOperator(observables, project));
    };
}
var WithLatestFromOperator = /*@__PURE__*/ (function () {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}());
var WithLatestFromSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        var _this = _super.call(this, destination) || this;
        _this.observables = observables;
        _this.project = project;
        _this.toRespond = [];
        var len = observables.length;
        _this.values = new Array(len);
        for (var i = 0; i < len; i++) {
            _this.toRespond.push(i);
        }
        for (var i = 0; i < len; i++) {
            var observable = observables[i];
            _this.add(Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(_this, observable, observable, i));
        }
        return _this;
    }
    WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) {
                toRespond.splice(found, 1);
            }
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function () {
    };
    WithLatestFromSubscriber.prototype._next = function (value) {
        if (this.toRespond.length === 0) {
            var args = [value].concat(this.values);
            if (this.project) {
                this._tryProject(args);
            }
            else {
                this.destination.next(args);
            }
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function (args) {
        var result;
        try {
            result = this.project.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));
//# sourceMappingURL=withLatestFrom.js.map


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export zip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_zip__ = __webpack_require__(160);
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */

function zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function zipOperatorFunction(source) {
        return source.lift.call(__WEBPACK_IMPORTED_MODULE_0__observable_zip__["b" /* zip */].apply(void 0, [source].concat(observables)));
    };
}
//# sourceMappingURL=zip.js.map


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export zipAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_zip__ = __webpack_require__(160);
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */

function zipAll(project) {
    return function (source) { return source.lift(new __WEBPACK_IMPORTED_MODULE_0__observable_zip__["a" /* ZipOperator */](project)); };
}
//# sourceMappingURL=zipAll.js.map


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return combineEpics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(71);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/**
  Merges all epics into a single one.
 */
var combineEpics = function combineEpics() {
  for (var _len = arguments.length, epics = Array(_len), _key = 0; _key < _len; _key++) {
    epics[_key] = arguments[_key];
  }

  var merger = function merger() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["d" /* merge */].apply(undefined, _toConsumableArray(epics.map(function (epic) {
      var output$ = epic.apply(undefined, args);
      if (!output$) {
        throw new TypeError('combineEpics: one of the provided Epics "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
      }
      return output$;
    })));
  };

  // Technically the `name` property on Function's are supposed to be read-only.
  // While some JS runtimes allow it anyway (so this is useful in debugging)
  // some actually throw an exception when you attempt to do so.
  try {
    Object.defineProperty(merger, 'name', {
      value: 'combineEpics(' + epics.map(function (epic) {
        return epic.name || '<anonymous>';
      }).join(', ') + ')'
    });
  } catch (e) {}

  return merger;
};

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_account_userData__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_organization_organization__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{isAuthorised:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_login__["f" /* getLoginAuthoriseStatus */])(state),role:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["n" /* getCurrentRole */])(state),subRole:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["o" /* getCurrentSubRole */])(state),userId:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_userData__["g" /* getUserId */])(state),userEmail:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_userData__["f" /* getUserEmail */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["e" /* getTranslation */])(state),loadingTranslation:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["g" /* loadingTranslation */])(state),loadingUserData:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_userData__["k" /* isLoading */])(state),loadingOrganizationData:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_organization_organization__["z" /* loadingOrgForApp */])(state),isForbidden:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_login__["i" /* isForbidden */])(state),isServerError:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_login__["j" /* isServerError */])(state),orgPermissions:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_organization_organization__["p" /* getOrgPermissions */])(state),subRoles:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["s" /* getSubRoles */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onLogOut:function onLogOut(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_login__["k" /* logout */])());},onRefreshForbidden:function onRefreshForbidden(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_login__["m" /* onRefreshForbidden */])());},onGetOrgBalance:function onGetOrgBalance(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_organization_organization__["e" /* fetchGetOrgBalance */])());},onSetUser:function onSetUser(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_userData__["b" /* fetchGetUserData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]));

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isFunction__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isSymbol__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_isEmpty__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_toString__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_isString__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(98);








function isValidActionType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_5__utils_isString__["a" /* default */])(type) || Object(__WEBPACK_IMPORTED_MODULE_1__utils_isFunction__["a" /* default */])(type) || Object(__WEBPACK_IMPORTED_MODULE_2__utils_isSymbol__["a" /* default */])(type);
}

function isValidActionTypes(types) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_isEmpty__["a" /* default */])(types)) {
    return false;
  }
  return types.every(isValidActionType);
}

function combineActions() {
  for (var _len = arguments.length, actionsTypes = Array(_len), _key = 0; _key < _len; _key++) {
    actionsTypes[_key] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
  var combinedActionType = actionsTypes.map(__WEBPACK_IMPORTED_MODULE_4__utils_toString__["a" /* default */]).join(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* ACTION_TYPE_DELIMITER */]);
  return { toString: function toString() {
      return combinedActionType;
    } };
}

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol' || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.prototype.toString.call(value) === '[object Symbol]';
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value === null;
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isPlainObject__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isFunction__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_identity__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_isArray__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_isString__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_isNil__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_getLastElement__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_camelCase__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_arrayToObject__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_flattenActionMap__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_unflattenActionCreators__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__createAction__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(98);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
















function createActions(actionMap) {
  for (var _len = arguments.length, identityActions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    identityActions[_key - 1] = arguments[_key];
  }

  var options = Object(__WEBPACK_IMPORTED_MODULE_1__utils_isPlainObject__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_getLastElement__["a" /* default */])(identityActions)) ? identityActions.pop() : {};
  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(identityActions.every(__WEBPACK_IMPORTED_MODULE_5__utils_isString__["a" /* default */]) && (Object(__WEBPACK_IMPORTED_MODULE_5__utils_isString__["a" /* default */])(actionMap) || Object(__WEBPACK_IMPORTED_MODULE_1__utils_isPlainObject__["a" /* default */])(actionMap)), 'Expected optional object followed by string action types');
  if (Object(__WEBPACK_IMPORTED_MODULE_5__utils_isString__["a" /* default */])(actionMap)) {
    return actionCreatorsFromIdentityActions([actionMap].concat(identityActions), options);
  }
  return _extends({}, actionCreatorsFromActionMap(actionMap, options), actionCreatorsFromIdentityActions(identityActions, options));
}

function actionCreatorsFromActionMap(actionMap, options) {
  var flatActionMap = Object(__WEBPACK_IMPORTED_MODULE_10__utils_flattenActionMap__["a" /* default */])(actionMap, options);
  var flatActionCreators = actionMapToActionCreators(flatActionMap);
  return Object(__WEBPACK_IMPORTED_MODULE_11__utils_unflattenActionCreators__["a" /* default */])(flatActionCreators, options);
}

function actionMapToActionCreators(actionMap) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      prefix = _ref.prefix,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === undefined ? __WEBPACK_IMPORTED_MODULE_13__constants__["b" /* DEFAULT_NAMESPACE */] : _ref$namespace;

  function isValidActionMapValue(actionMapValue) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_isFunction__["a" /* default */])(actionMapValue) || Object(__WEBPACK_IMPORTED_MODULE_6__utils_isNil__["a" /* default */])(actionMapValue)) {
      return true;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_4__utils_isArray__["a" /* default */])(actionMapValue)) {
      var _actionMapValue = _slicedToArray(actionMapValue, 2),
          _actionMapValue$ = _actionMapValue[0],
          payload = _actionMapValue$ === undefined ? __WEBPACK_IMPORTED_MODULE_3__utils_identity__["a" /* default */] : _actionMapValue$,
          meta = _actionMapValue[1];

      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_isFunction__["a" /* default */])(payload) && Object(__WEBPACK_IMPORTED_MODULE_2__utils_isFunction__["a" /* default */])(meta);
    }

    return false;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_9__utils_arrayToObject__["a" /* default */])(Object.keys(actionMap), function (partialActionCreators, type) {
    var actionMapValue = actionMap[type];
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(isValidActionMapValue(actionMapValue), 'Expected function, undefined, null, or array with payload and meta ' + ('functions for ' + type));
    var prefixedType = prefix ? '' + prefix + namespace + type : type;
    var actionCreator = Object(__WEBPACK_IMPORTED_MODULE_4__utils_isArray__["a" /* default */])(actionMapValue) ? __WEBPACK_IMPORTED_MODULE_12__createAction__["a" /* default */].apply(undefined, [prefixedType].concat(_toConsumableArray(actionMapValue))) : Object(__WEBPACK_IMPORTED_MODULE_12__createAction__["a" /* default */])(prefixedType, actionMapValue);
    return _extends({}, partialActionCreators, _defineProperty({}, type, actionCreator));
  });
}

function actionCreatorsFromIdentityActions(identityActions, options) {
  var actionMap = Object(__WEBPACK_IMPORTED_MODULE_9__utils_arrayToObject__["a" /* default */])(identityActions, function (partialActionMap, type) {
    return _extends({}, partialActionMap, _defineProperty({}, type, __WEBPACK_IMPORTED_MODULE_3__utils_identity__["a" /* default */]));
  });
  var actionCreators = actionMapToActionCreators(actionMap, options);
  return Object(__WEBPACK_IMPORTED_MODULE_9__utils_arrayToObject__["a" /* default */])(Object.keys(actionCreators), function (partialActionCreators, type) {
    return _extends({}, partialActionCreators, _defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_camelCase__["a" /* default */])(type), actionCreators[type]));
  });
}

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return Array.isArray(value);
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (array) {
  return array[array.length - 1];
});

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsAstral = '[' + rsAstralRange + ']',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
  rsUpper + '+' + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = camelCase;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flattenWhenNode__ = __webpack_require__(248);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__flattenWhenNode__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */]));

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unflattenActionCreators;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isEmpty__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__camelCase__ = __webpack_require__(247);




function unflattenActionCreators(flatActionCreators) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === undefined ? __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_NAMESPACE */] : _ref$namespace,
      prefix = _ref.prefix;

  function unflatten(flatActionType) {
    var partialNestedActionCreators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var partialFlatActionTypePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var nextNamespace = Object(__WEBPACK_IMPORTED_MODULE_2__camelCase__["a" /* default */])(partialFlatActionTypePath.shift());
    if (Object(__WEBPACK_IMPORTED_MODULE_1__isEmpty__["a" /* default */])(partialFlatActionTypePath)) {
      partialNestedActionCreators[nextNamespace] = flatActionCreators[flatActionType];
    } else {
      if (!partialNestedActionCreators[nextNamespace]) {
        partialNestedActionCreators[nextNamespace] = {};
      }
      unflatten(flatActionType, partialNestedActionCreators[nextNamespace], partialFlatActionTypePath);
    }
  }

  var nestedActionCreators = {};
  Object.getOwnPropertyNames(flatActionCreators).forEach(function (type) {
    var unprefixedType = prefix ? type.replace('' + prefix + namespace, '') : type;
    return unflatten(type, nestedActionCreators, unprefixedType.split(namespace));
  });

  return nestedActionCreators;
}

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_curry__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAction__ = __webpack_require__(165);



/* unused harmony default export */ var _unused_webpack_default_export = (function (type, payloadCreator) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_curry___default()(Object(__WEBPACK_IMPORTED_MODULE_1__createAction__["a" /* default */])(type, payloadCreator), payloadCreator.length);
});

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var BIND_FLAG = 1,
    BIND_KEY_FLAG = 2,
    CURRY_BOUND_FLAG = 4,
    CURRY_FLAG = 8,
    CURRY_RIGHT_FLAG = 16,
    PARTIAL_FLAG = 32,
    PARTIAL_RIGHT_FLAG = 64,
    ARY_FLAG = 128,
    REARG_FLAG = 256,
    FLIP_FLAG = 512;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', ARY_FLAG],
  ['bind', BIND_FLAG],
  ['bindKey', BIND_KEY_FLAG],
  ['curry', CURRY_FLAG],
  ['curryRight', CURRY_RIGHT_FLAG],
  ['flip', FLIP_FLAG],
  ['partial', PARTIAL_FLAG],
  ['partialRight', PARTIAL_RIGHT_FLAG],
  ['rearg', REARG_FLAG]
];

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
    reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      result++;
    }
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var objectCreate = Object.create;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/* Used to set `toString` methods. */
var defineProperty = (function() {
  var func = getNative(Object, 'defineProperty'),
      name = getNative.name;

  return (name && name.length > 2) ? func : undefined;
}());

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & ARY_FLAG,
      isBind = bitmask & BIND_FLAG,
      isBindKey = bitmask & BIND_KEY_FLAG,
      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
      isFlip = bitmask & FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

  if (!(bitmask & CURRY_BOUND_FLAG)) {
    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
  }

  var result = wrapFunc(func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity);
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *  The bitmask may be composed of the following flags:
 *     1 - `_.bind`
 *     2 - `_.bindKey`
 *     4 - `_.curry` or `_.curryRight` of a bound function
 *     8 - `_.curry`
 *    16 - `_.curryRight`
 *    32 - `_.partial`
 *    64 - `_.partialRight`
 *   128 - `_.rearg`
 *   256 - `_.ary`
 *   512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] == null
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  return setWrapToString(result, func, bitmask);
}

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length,
      lastIndex = length - 1;

  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
var setWrapToString = !defineProperty ? identity : function(wrapper, reference, bitmask) {
  var source = (reference + '');
  return defineProperty(wrapper, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)))
  });
};

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value === undefined;
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduce_reducers__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduce_reducers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduce_reducers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isPlainObject__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_isMap__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ownKeys__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_flattenReducerMap__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handleAction__ = __webpack_require__(249);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }









function get(key, x) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__utils_isMap__["a" /* default */])(x) ? x.get(key) : x[key];
}

function handleActions(handlers, defaultState) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_2__utils_isPlainObject__["a" /* default */])(handlers) || Object(__WEBPACK_IMPORTED_MODULE_3__utils_isMap__["a" /* default */])(handlers), 'Expected handlers to be a plain object.');
  var flattenedReducerMap = Object(__WEBPACK_IMPORTED_MODULE_5__utils_flattenReducerMap__["a" /* default */])(handlers, options);
  var reducers = Object(__WEBPACK_IMPORTED_MODULE_4__utils_ownKeys__["a" /* default */])(flattenedReducerMap).map(function (type) {
    return Object(__WEBPACK_IMPORTED_MODULE_6__handleAction__["a" /* default */])(type, get(type, flattenedReducerMap), defaultState);
  });
  var reducer = __WEBPACK_IMPORTED_MODULE_0_reduce_reducers___default.a.apply(undefined, _toConsumableArray(reducers));
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];
    return reducer(state, action);
  };
}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (previous, current) {
    return reducers.reduce(function (p, r) {
      return r(p, current);
    }, previous);
  };
};

module.exports = exports["default"];

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMap__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasGeneratorInterface__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flattenWhenNode__ = __webpack_require__(248);





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__flattenWhenNode__["a" /* default */])(function (node) {
  return (Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(node) || Object(__WEBPACK_IMPORTED_MODULE_1__isMap__["a" /* default */])(node)) && !Object(__WEBPACK_IMPORTED_MODULE_2__hasGeneratorInterface__["a" /* default */])(node);
}));

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasGeneratorInterface;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ownKeys__ = __webpack_require__(167);


function hasGeneratorInterface(handler) {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_0__ownKeys__["a" /* default */])(handler);
  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
    return ownKey === 'next' || ownKey === 'throw';
  });
  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
}

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(487);
var objectAssign = __webpack_require__(114);
var decodeComponent = __webpack_require__(488);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return translations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translation_en__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translation_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translation_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translation_nl__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translation_nl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translation_nl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translation_fr__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translation_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translation_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translation_de__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translation_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__translation_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__translation_es__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__translation_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__translation_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_locale_en_gb__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_locale_en_gb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_locale_en_gb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_nl__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_nl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_locale_nl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_fr__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_locale_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_locale_de__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment_locale_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_locale_es__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment_locale_es__);
/*
    When you add any other then default "en" language make sure you've added:
    1) import of language: import "./translation_code"
    2) import of moment locale : import "moment/locale/momentLocale_code"
    3) language with it's momentLocale to json (or just momentLocale: 'en'), it will be used for dates locale
    c.f. example for "ru"
*/var translations={en:{label:'English',translation:__WEBPACK_IMPORTED_MODULE_0__translation_en___default.a,momentLocale:'en-gb'},nl:{label:"Nederlands",translation:__WEBPACK_IMPORTED_MODULE_1__translation_nl___default.a,momentLocale:'nl'},fr:{label:"Français",translation:__WEBPACK_IMPORTED_MODULE_2__translation_fr___default.a,momentLocale:'fr'},de:{label:"Deutsch",translation:__WEBPACK_IMPORTED_MODULE_3__translation_de___default.a,momentLocale:'de'},es:{label:"Español",translation:__WEBPACK_IMPORTED_MODULE_4__translation_es___default.a,momentLocale:'es'}};

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = {"TranslationReviewVersion":{"version":"Language Bundle Version","version_Number":"30/09/2020"},"login":{"label":"Welcome to BrainChain","login_button":"Log in","forgot_password_label":"Forgot your password?","haven_t_account_label":"No account yet?","create_it_now_label":"Create account here!","create_account_alert":"Which type of Account would you like to create?","applicant_button":"Applicant","company_button":"Organization","back_to_login_button":"Return to Login page","create_an_label":"Create an","applicant_account_hint":"Account if you want to manage your diplomas in BrainChain to have them instantly and automatically recognized, worldwide.","create_a_label":"Create an","company_account_hint":"Account if your Company plans to enjoy automated vetting of job applicant's diplomas with BrainChain.","more_info_label":"To find out more, visit "},"oauth":{"label":"Welcome to BrainChain","sign_in_label":"You must log in to continue.","incorrect_request_params_label":"Invalid parameters","access_info_label":"{client_name} will get access to your name, phone number and email address.","logged_in_data_label":"You are logged in as {user_name}, {user_email}.","accept_label":"Continue","reject_label":"Deny","use_another_account_label":"Use another account"},"reset_password":{"label":"Reset password","submit_button":"Reset","incorrect_link_alert":"Incorrect link","expired_link_alert":"Link has expired.","success_message":"Your password has been successfully changed."},"change_password":{"label":"Email & Password","change_password":"Change password","old_password_label":"Old password","old_password_input_placeholder":"Old password","submit_button":"Update password","success_message":"Your password has been successfully updated.","change_password_alert":"You will now be guided to the login page to log in with your new password.","change_email":"Change Email","change_email_hint":"Please enter the Email you use to apply to jobs.","update_email":"Update Email","change_email_alert":"We sent a link to your new email address to confirm it. Please check your mail box.","finish_change_email":"Email was successfully changed. You can use it to login into your account."},"restore_account":{"label":"Please enter the email of the account to restore!","submit_button":"Restore","success_message":"Your new password is waiting for you in your Inbox!","link_to_help_text":"Make sure you have activated your account. If you have any issues, you can visit ","link_to_help":"help","link_to_help_end":"."},"register_applicant":{"label":"Applicant account registration","message":"Please complete the data below to create your account","success_message":"We sent you an activation mail. Click the link inside to complete this process.","submit_button":"Count me in!","back_button":"Return to login page."},"account_management":{"label":"My Personal Settings","open_account_management_menu_label":"Open personal settings menu","close_account_management_menu_label":"Hide personal settings menu"},"org_management":{"label":"Organization account settings"},"aliases":{"label":"Aliases","expose_phone_label":"Share Phone Number for potential jobs","expose_email_label":"Share Email for potential jobs","default_alias_label":"Default alias","set_as_default_alias_label":"Set as default alias","edit_alias_label":"Change alias","delete_alias_label":"Remove alias","add_button":"Add alias","add_success_message":"Alias created successfully!","edit_button":"Change alias","edit_success_message":"Alias updated successfully!","remove_title":"Are you sure you want to remove this alias?","remove_success_message":"Alias removed successfully!","edit_default_alias":"Personal data","change_default_alias":"Change personal data"},"org_staff":{"staff":{"table_label":"Staff members","register_button":"Send invitation","remove_modal_alert":"Are you sure you want to remove {name} from the staff members list?","send_invite_button":"Send invitation","create_success_message":"Organization staff registered successfully!","remove_success_message":"Organization staff removed successfully!","no_data_label":"There are no staff members."},"accreditation_groups":{"table_label":"Accreditation groups (Faculties)","accreditation_group_name_label":"Accreditation group name(Faculty)","create_accreditation_group_button":"Create accreditation group","create_accreditation_group_success_message":"Accreditation group(Faculty) created successfully!","edit_accreditation_group_success_message":"Accreditation group(Faculty) updated successfully!","inserters_label":"Insertors","validators_label":"Validators","employee_input_placeholder":"Select Employee...","role_input_placeholder":"Select Role...","employee_label":"Employee","employees_label":"Employees","role_label":"Role","remove_employee_from_group_alert":"Are you sure you want to remove this Employee from the Accreditation group(Faculty)?","remove_group_alert":"Are you sure you want to remove this Accreditation group(Faculty)?","remove_employee_from_group_success_message":"Employee removed from Accreditation group(Faculty) successfully!","remove_group_success_message":"Accreditation group(Faculty) removed successfully!","add_employee_to_group_success_message":"Employee added to the group successfully!","no_data_label":"There are no #Faculties# defined yet.","accreditation_groups_definition_label":"#Faculties# are a way for universities to logically structure their  programmes.","accreditation_group_no_data_label":"There are no staff members in this Accreditation group(Faculty).","accreditation_group_examples_label":"Mechanical Engineering;Political Sciences;Economic Sciences;Biology","different_from_departments_label":"This is different from #Departments#","digital_key_hint":"Kind reminder: Insertors need the digital key (a .jwk file) on the computer they insert Diplomas, to digitally encrypt them. Please do not forget to safely pass on this key with the Insertor, and remind them this key needs to be imported just once, before all their work starts.","no_inserters_label":"No Insertors assigned","no_validators_label":"No Validators assigned","no_staff_assigned_label":"Faculties without assigned Insertors can not enter Diplomas; Faculties without assigned Validators will have their inserted Diplomas stuck till a Faculty Validator is appointed. Therefore, please ensure that for each Faculty, at least one Insertor and one Validator gets assigned."},"departments":{"table_label":"Departments","department_name_label":"Department name","department_email_label":"Department Email","create_department_button":"Create department","create_department_success_message":"Department created successfully!","edit_department_success_message":"Department updated successfully!","hms_label":"Hiring Managers","bos_label":"Business Owners","employee_input_placeholder":"Select Employee...","role_input_placeholder":"Select Role...","employee_label":"Employee","employees_label":"Employees","role_label":"Role","remove_employee_from_department_alert":"Are you sure you want to remove this Employee from the Department?","remove_department_alert":"Are you sure you want to remove this Department?","remove_employee_from_department_success_message":"Employee removed from Department successfully!","remove_department_success_message":"Department removed successfully!","add_employee_to_department_success_message":"Employee added to Department successfully!","no_data_label":"There are no #Departments# defined yet.","department_no_data_label":"There are no staff members in this Department.","departments_definition_label_uni":"#Departments# reflect how a university organizes itself as any other organization.","departments_definition_label_company":"#Departments# reflect how a company organizes itself in its functional groups.","departments_examples_label":"Human Resources (HR);IT;Finance","departments_definition_label_part_2":"#Departments# allow companies to use BrainChain in an organized fashion; it allows their staff members to keep track of who verified Diplomas of people they consider hiring.","different_from_accreditation_groups_label":"This is different from #Faculties#"},"change_anchor":{"title":"Change Anchor","modal_alert_message":"You can transfer the Anchor rights to any active staff member.","modal_alert_warning":"(Warning: After this action, you will lose partial access rights. If you apply this change, you will be brought back to the Landing page if you still are Insertor or Validator. If not, you will be guided to your employee page.)","success_message":"Anchor changed successfully!","submit_button":"Change Anchor"}},"activation":{"label":"Account activation","activate_applicant_label":"Choose a password to activate your account","linked_employee_label":"Choose Email and password for your Applicant account. Your Employee account will be linked to it.","activate_personal_data_label":"Please fill in the below data to activate your account","activate_password_label":"Please set a password to finish activation of your account","haven_t_applicant_account_label":"You don't have an Applicant account yet?","create_it_now_label":"Create it now!","linked_button":"Proceed","birth_date_label":"Date of birth","password_label":"Password","enter_password_label":"New password","confirm_password_label":"Confirm password","enter_password_input_placeholder":"New password","confirm_password_input_placeholder":"Confirm new password","activate_button":"Activate account","enter_password_error_alert":"The password must contain minimum 6 and maximum 32 characters!","confirm_password_error_alert":"Bonus points for effort but... 1 password suffices :-) . Please type the same password twice!","activation_link_expired_alert":"Activation link has expired","activation_link_irrelevant_message":"You already completed your registration.","activation_link_irrelevant_forgot_password_message_start":"If you forgot your password, you can click ","activation_link_irrelevant_forgot_password_message_link":"here","activation_link_irrelevant_forgot_password_message_end":" to reset it.","activation_link_irrelevant_log_in_message_start":"If this is a mistake, and you remember you password, you can log in by following ","activation_link_irrelevant_log_in_message_link":"this link","activation_link_irrelevant_log_in_message_end":".","incorrect_activation_link_alert":"Incorrect activation link","activation_success_message":"Activation succeeded!","back_button":"Return to employee account activation."},"resend_activation":{"success_message":"Activation is successfully sent again!","employee_label":"Resend activation Email to {email}?","anchor_label":"Resend activation Email to {email}?","title":"Resend activation","submit_button":"Resend","label":"Please enter the Email of the account we can resend activation to"},"orgs":{"label":"Validated Organizations","anchor_label":"Anchor","location_label":"Location","org_label":"Organization","org_type_label":"Organization type","add_org":"Add organization","name_label":"Name","has_accreditation_groups_label":"Has Accreditation groups(Faculties)","verifies_identities_label":"Verifies identities","provides_mooc_certificates_label":"Issues MOOC Certificates","street_label":"Street & Nº","postal_label":"Postal","city_label":"City","company_code_label":"Company code","vat_number_label":"VAT Number","address_label":"Address","permissions_label":"Permissions","unknown_label":"Unknown","no_data_label":"There are no organizations.","no_data_to_validate_label":"There are no organizations to validate.","validate_organizations_label":"Validate pending organization registration requests","validate_organization_label":"Validate organization","validate_organization_button":"Validate","validate_organization_alert":"Are you sure you want to validate this organization?","back_button":"Return to list of not validated organizations.","next_org_button":"Next organization","validate_org_success_message":"Organization was successfully validated!","financial_data_label":"Financial data","financial_data_placeholder":"Bank Name, Bank Account Nr, …","inspect_organization_button":"Inspect","validate_org_progress_label":"Validated","orgs_payments_list_label":"Financial data of Organizations","general_data_validated":"Basic data - validated","financial_data_validated":"Financial data - validated","already_validated":"Partially validated data - Pending full validation by co-assistant.","remove_org_alert":"Are you sure you want to remove this organization?","remove_org_success_message":"Organization removed successfully!"},"register_org":{"register_org_label":"Register Organization and Anchor","invite_next_button":"Send and Invite next","send_invitation_button":"Send invitation","success_message":"Organization and Anchor registered successfully!","org_type_placeholder":"Select org type...","register_button":"Register","company_registration_label":"Register Company and Anchor","proceed_button":"Proceed","register_org_by_anchor_alert":"Don't forget to wire company credit (any amount) from the Bank Account declared in this profile. This will allow BrainChain to validate your registration.","register_org_by_anchor_hint":"After Account activation, you can at all times manage financial information in the financial section of the Organization Account settings.","domain_hint":"An internet Domain is the first part of the web address of an organization. E.g. apple.com or ibm.de If you want to register the whole company with all its subdomains, you can use a wildcard() at the end instead of using the extension of a specific country, e.g. apple.* or ibm.*","back_button":"Return to login page.","company_code_hint":"In some countries, companies are first and foremost known by a unique registration code as identifier, next to -or in absence of- a VAT Nº.","financial_data_hint_part_1":"Please provide all the data to ensure that we at our end can assess the wiring came indeed from your organization.","financial_data_hint_part_2":"Like: Your Bank Name and your Identifier at your Bank (= a client code / your Bank Account Number / ... ).","financial_data_hint_part_3":"This data is needed to separate real companies from fake ones and internet bots, as well as to comply our reporting to mandatory anti-fraud standards."},"edit_org":{"org_edit_success_message":"Organization updated successfully!","anchor_edit_success_message":"Anchor changed successfully!","back_button":"Return to list of organizations.","edit_anchor_button":"Change anchor","edit_anchor_alert":"Please change anchor's Email prior to other editing.","bava_label":"BAVA","bava_organization_label":"BAVA organization","bava_set_success_message":"Organization marked as BAVA!","bava_removed_success_message":"BAVA flag removed successfully!"},"request_credentials_verification":{"label":"Request to verify diplomas","success_alert":"Request succeeded","applicant_data_label":"Applicant data","choose_way_label":"Choose your preferred way to locate candidates","your_data_label":"Your data","hide_your_name_label":"Hide your name to the Applicant","company_data_label":"Organization data","reason_for_request_label":"Reason for request","reason_for_request_placeholder":"Write your message here ...","get_email_label":"Let me know via Email when the applicant replies to the request","submit_button":"Process request","way_label":"Way","company_name_label":"Organization name","modal_title_label":"Regarding","investigate_applicant_label":"The Applicant you want to investigate, is not yet part of the BrainChain Database. Would you like us to request his/her University to add him/her?","ask_colleague_label":"A colleague of yours ({firstName} {lastName}) has a valid pending request for this Applicant. Would you like to liaise with your Colleague, or do you prefer to issue your own consent request?","request_button":"Request my own","ask_colleague_button":"I will liaise with my colleague","manager_label":"Manager","visible_data_message":"The following data will be visible to Applicant.","upload_file_label":"Upload File","emails_label":"Emails","manual_input_label":"Manual Input","manual_input_hint":"Provide applicants' Emails separated by commas, semicolons, line breaks or spaces.","reference_to_bulk_list_start":"You can post a request for a single Email or a series of Emails at once. \nThere are 2 ways to pass on a series of Emails: either by entering them yourself in the field below, or by uploading a document. For its correct format: see the \"?\" icon below.\nIf you go for the series of Emails, you can check their processing status at ","reference_to_bulk_list_link":"Bulk Consent requests","reference_to_bulk_list_end":".","stay_on_this_page_label":"Stay on current page","go_to_home_page_label":"Go to Home page","success_modal_label":"Your Request succeeded! Would you like to stay on this page or go to Home page?","request_unavailable_alert":"Credential verification functionality is currently unavailable. Contact your Organization's Anchor to resolve the problem."},"main":{"home_page_label":"Home page","edu_org_staff_page_button":"Staff management","current_sub_role_label":"Role","current_group_label":"Group","log_out_button":"Log out","orgs_page_button":"Validated Organizations","insert_accreditation_page_button":"Insert new Diploma(-s)","validate_accreditations_page_button":"Validate Diplomas","review_accreditations_page_button":"Review failed Diplomas","accreditation_groups_page_button":"Accreditation groups(Faculties)","departments_page_button":"Departments","staff_members_page_button":"Staff members","limit_access_label":"Your organization has limited access to certain functionality. Should this be unexpected, please contact the organization Anchor.","non_validated_org_access_label":"You don't have access to this functionality, because your organization has not yet been validated.","payment_label":"Payment","help_label":"Help","bulk_jobs_list_page_button":"Bulk Diploma upload","validate_organizations_page_button":"Pending Organizations","certified_accreditations_page_button":"Certified Diplomas","pending_accreditations_page_button":"Pending Diplomas","vids_page_button":"Verified Identities","org_management_button":"Organization account settings","verification_request_page_button":"Request Consent","pending_consents_page_button":"Pending Consents","active_consents_page_button":"Active Consents","consent_requests_page_button":"Consents Requested","prior_consents_page_button":"Prior Consents","applicant_accreditations_select_button":"Diplomas","applicant_consents_select_button":"Consents","consents_history_page_button":"Consents History","self_study_books_page_button":"Books (Self-Study)","bulk_consent_requests_page_button":"Bulk Consent requests","inserter_accreditations_select_button":"Diplomas","insert_accreditation_shirt_page_button":"Insert","review_accreditations_shirt_page_button":"Review","bulk_jobs_list_shirt_page_button":"Bulk upload","organizations_select_button":"Organizations","orgs_shirt_page_button":"Validated","validate_organizations_shirt_page_button":"Pending","accreditation_requests_list_page_button":"Diploma verification requests","validated_accreditation_requests_list_page_button":"Validated Edu Domains","pending_accreditation_requests_list_page_button":"Pending Edu Domains","pending_accreditation_requests_page_button":"Pending Diploma verification requests","organization_select_button":"Organization","accreditation_groups_management_page_button":"Management of Diploma Groups","groups_management_page_button":"Departments & Faculties","validated_accreditation_requests_by_domain_shirt_page_button":"Validated","pending_accreditation_requests_by_domain_shirt_page_button":"Pending","security_page_button":"Security","register_org_shirt_page_button":"Register new","payments_page_button":"Payments","orgs_payments_page_button":"Financial data of Organizations","assistants_page_button":"Assistants","business_ambassadors_page_button":"Business Ambassadors","commissions_list_page_button":"Commissions","system_payment_select_button":"Payment","due_payments_page_button":"Due Payments","payments_history_shirt_page_button":"History","payments_history_page_button":"Payments History","validated_domains_page_button":"Validated Domains","domains_page_button":"University Domains"},"roles":{"admin_label":"SysAdmin","employee_label":"Employee","applicant_label":"Applicant","anchor_label":"Anchor","inserter_label":"Insertor","validator_label":"Validator","hm_label":"Hiring Manager","bo_label":"Business Owner"},"home":{"welcome_label":"Welcome to BrainChain!","account_and_support_label":"Account settings and support","admin_pages_label":"Admin pages","choose_role_label":"Choose your role for this session","anchor_pages_label":"Anchor pages","inserter_pages_label":"Insertor pages","validator_pages_label":"Validator pages","hm_pages_label":"Hiring Manager pages","bo_pages_label":"Business Owner pages","applicant_pages_label":"Applicant pages","account_page_about":"Manage your personal settings","support_page_about":"Find your answer or mail us","register_org_page_about":"Create new organization","organizations_page_about":"Manage Organizations Settings","validate_organizations_page_about":"Validate new Organizations","payment_page_about":"Financial Management & Pricing","organization_staff_page_about":"Manage Organization staff","accreditation_groups_page_about":"Manage Organization Accreditation Groups (Faculties)","departments_page_about":"Manage Organization Departments","review_accreditations_page_about":"Interactions with Validators & Applicants","bulk_accreditations_upload_page_about":"Insert Diplomas from file","validate_accreditations_page_about":"Interactions with Insertors & Applicants","credentials_verification_request_page_about":"Create new Consent Request for Applicant","consent_requests_page_about":"Manage Consent Requests for your Organization","certified_accreditations_page_about":"Manage your certified Diplomas","pending_accreditations_page_about":"Manage new incoming degrees","verified_identities_page_about":"Manage your Verified Identities","pending_consents_page_about":"Companies considering hiring you - you decide","active_consents_page_about":"All Companies allowed to admire your diploma","prior_consents_page_about":"Companies you want to work for","consents_history_page_about":"Complete history of Granted and Rejected consent requests","self_study_books_page_about":"Manage your Self-Study books","bulk_consent_requests_page_about":"Manage Bulk Consent Requests for your Organization","accreditation_requests_list_anchor_page_about":"Link orphaned Diploma Verification Requests to existing Faculties","validated_accreditation_requests_list_admin_page_about":"Validated Domains (Self-managed and BAVA-managed)","pending_accreditation_requests_list_admin_page_about":"Access Incoming Domain Verification Requests (Applicant)","accreditation_requests_list_admin_page_about":"Manage Diploma Verification Request unlinked to an Organization","accreditation_requests_list_applicant_page_about":"Manage Diploma Verification Request","security_page_anchor_about":"Digital signing of Diplomas","security_page_inserter_about":"Install digital key","security_page_admin_about":"Add pending Root/Uni certificates","orgs_payments_page_about":"Account, Tariffs and Credit","assistants_page_about":"Manage Assistants","business_ambassadors_page_about":"Manage Business Ambassadors","commissions_list_page_about":"Manage Commissions","due_payments_page_about":"Manage Due Payments","payments_history_page_about":"Manage Payments History and Company Credit","default_departments_hint":"To accommodate smaller companies, the 'Company Anchor' can request BrainChain to confirm Diplomas without further setup. For bigger companies, who typically have dedicated profiles for vetting people, we advise to create an \"HR Department\" (with a label of your choosing), and subsequently couple these dedicated Recruiters to that Department. This avoids the main BrainChain contact in the Company (= the BrainChain Anchor) would have to deal with that.","not_validated_yet":"Your company is not yet fully validated by BrainChain. Until that process concludes, not all functionality will be accessible in full."},"payment":{"title":"Payment information","total_money_label":"Total flowback to {orgName} so far, earned by joining BrainChain: ","list_label":"To pay the annual license, please wire:","account_id_label":"to the following (IBAN) account Nr: {iban}","bank_details_label":"Bank and project details","about_us_label":"Should you bank require more information about our bank or BrainChain:","bank_data_label":"Our Bank data:","project_label":"BrainChain Project:","org_label":"Organization: WickedWare","org_address":"Address: Virsuliskiu g. 17-9, 05108 Vilnius, Lithuania","create_account_label":"with the following wire message (if this is the first time you pay): ","create_account_message_label":"{orgName} - Create Account","annual_fee_label":"with the following wire message (if this is NOT the first time you pay): ","annual_fee_message_label":"{orgName} - Annual license","edu_org_message_label":"What will your educational organization get","edu_org_message_company_checks":"Every time a company checks one of your Alumni, we charge the company a very small flat fee. With that fee, we pay the costs to keep BrainChain in good operational condition, AND 20% flows back to you. Those amounts are flushed once per year.","edu_org_message_list_title":"This is how we build a healthy non-profit eco system that is beneficial to universities:","edu_org_message_list_item_one":"Instead of having to validate time and again your alumni, you do it just once (on this platform) and we assume that burden from then onwards, for as long as they work.","edu_org_message_list_item_two":"After that one-time entry, every time your alumni get vetted (= when they go after a new job), the university gets 20% of the vetting fees charged to companies.","edu_org_message_joining":"It means by joining BrainChain, the university is relieved of the vetting burden while getting a sustainable source of revenue.","edu_org_message_note_title":"Note:","edu_org_message_note":"If your credit is higher than the annual fee, it will be automatically deducted, saving you the effort to wire. You will get a mail explaining this operation at the same moment.","wire_label":"To pay the annual license, please wire","annual_license_cost_label":"Annual license cost","wire_delay_label":"Please note international wirings may take a few days.","bank_data_by_location":{"LT":{"iban_number":"LT643500010003938827","bank_data":"Name: 'Paysera LT', UAB \nBank address: Menulio g. 7, Vilnius, LT-04326, Lithuania"},"BE":{"iban_number":"BE13736065627739 (BIC: KREDBEBB)","bank_data":"Name: Alverman BV \nBank address: Beekstraat 5, 2300 Turnhout, Belgium \nAlverman VAT Nr (= company ID): \"BE0736567322\""}}},"finance":{"label":"Finance","balance_label":"Balance","balance_currency_label":"Balance currency","balance_change_comment_placeholder":"Leave your comment here...","change_label":"Change","change_balance_label":"Balance change","increase_label":"Increase","decrease_label":"Decrease","change_balance_submit_button":"Accept changes","preset_price_label":"Preset price","paid_till_date_label":"Paid till","annual_fee_label":"Annual fee","request_cost_label":"Diploma vetting request cost","pay_annual_fee_button":"Pay 1 year","pay_annual_fee_success_message":"Annual fee paid successfully!","change_finance_success_message":"Organization finances changed successfully!","org_finance_label":"Organization price","accept_price_and_send_invitation":"Accept price and send invitation","accept_price_and_validate":"Accept price and validate","prices_label":"Prices","change_balance_modal_label":"A Balance increase is to reflect the company paid its annual license fee (Checked offline by the SA/FA). A Balance decrease is when money is wired back to a company offline (Executed offline by SA/FA). The date the annual license fee is due, this fee is automatically subtracted from the open company credit.","set_default_label":"Restore default value","default_annual_fee_label":"Default annual fee","default_consent_request_fee_label":"Default consent request fee","deviation_period_label":"Deviation period","forever_label":"Forever","default_preset_label":"Nominal Presets: annual fee - {annual_fee_amount}, consent request - {consent_request_fee_amount}","agreed_deviation_label":"Agreed Deviation: annual fee - {annual_fee_amount}, consent request - {consent_request_fee_amount}","till_label":"till","period_label":"Period","pay_annual_license_alert":"Please, pay the annual license to continue creating consent requests.","top_up_balance_alert":"Please, top up your balance to continue creating consent request.","contact_anchor_alert":"Some of the functionality is unavailable. Contact your Organization's Anchor to resolve the problem.","add_year_label":"Add year","paid_till_alert":"Organizations without a 'Paid Till' date in the #future# will not get any money from vetting Diplomas."},"help":{"label":"Should you have problems or questions, feel free to reach out to {email}.","email":"BenevolentEars@brainchainmission.org","questions_and_answers_label":"Q & A","question_activation_email":"I didn't receive my activation email","answer_activation_email_start":"If you didn't receive your activation email, you can request it again ","answer_activation_email_link":"here","answer_activation_email_end":"."},"page_not_found":{"page_not_found_label":"Page not found","sorry_label":"Apologies - this pages seems to be on a permanent holiday!","cause_label":"Either you don't have access to this page or it doesn't exist anymore."},"server_error":{"server_error_label":"Internal Server Error","sorry_label":"Ooops, something went South :-/","cause_label":"You mind try again later? Our server is resting."},"sub_role_missing":{"no_access_label":"It seems in this role you no longer have access to this functionality.","continue_label":"To continue, you will be redirected to Home Page."},"org_permissions_missing":{"no_access_label":"It seems your Organization no longer has access to this functionality.","continue_label":"To continue, you will be redirected to Home Page."},"accreditation_list":{"label":"Diplomas","title_label":"Title","date_issued_label":"Date issued","level_label":"Level","applicant_name_label":"Applicant Name","location_label":"Location","no_data_to_validate_message":"No Diplomas to validate.","no_data_to_review_message":"No Diplomas to review.","show_accreditations_by_label":"Show accreditations rejected by","validators_label":"Validators","applicants_label":"Applicants","edit_label":"Edit Diploma","remove_label":"Remove Diploma","no_data_to_review_hint":"There are still other faculties you can check"},"bulk_jobs_list":{"label":"Bulk Upload Diplomas","no_data_message":"No bulk upload of Diplomas yet","created_at_label":"Created at","processed_label":"Processed","finished_label":"Finished","file_name_label":"File name","status_label":"Status","in_progress_label":"In progress...","remove_bulk_success_message":"Bulk file removed successfully!","remove_bulk_alert":"Are you sure you want to remove this file from the list?","remove_bulk_button":"Stop showing this file","entries_number_label":"Number of entries","error_label":"Error","global_error_label":"Global error","requestor_label":"Requestor","bulk_consent_requests_label":"Bulk Consent requests","no_bulk_consents_data_label":"No Bulk Consent requests uploaded yet","created_requests_label":"Created requests","file_reading_process_label":"File reading in process.","signing_process_label":"Working hard digitally signing the accreditations...","dont_close_tab_label":"Depending on file size, this process can take a while. Please be patient till completion. ","insufficient_balance_error_alert_part_1":"Only {processed} of {total} consent requests could be processed due to insufficient credit.","insufficient_balance_error_alert_part_2":"Please top up at least {amount} before flushing the remaining ones.","flush_remaining_label":"Flush remaining"},"accreditation":{"accreditation_group_input_placeholder":"Choose Accreditation group(Faculty)...","accreditation_title_orig_label":"Original Title","accreditation_title_orig_input_placeholder":"Original Title","accreditation_title_en_label":"English Title","accreditation_title_en_input_placeholder":"English Title","additional_translations_label":"Additional Translations","add_additional_translations_label":"Add new Title Translation","date_issued_label":"Date issued","level_label":"Level","level_input_placeholder":"Choose level...","person_label":"Person","language_input_placeholder":"Language","translation_input_placeholder":"Translation","title_label":"Title","accreditation_label":"Diploma","popover":{"message_placeholder":"Please leave a message here...","old_value_label":"Old content","proposed_value_label":"Proposed content","message_label":"Message","proposed_value_input_placeholder":"Insert proposed content here...","discard_changes_label":"Discard changes","edit_field_label":"Edit field"},"remove_accreditation_success_message":"Diploma removed successfully!","remove_accreditation_alert":"Are you sure you want to remove this Diploma?","next_accreditation_button":"Next Diploma","back_button":"Return to list of Diplomas","show_details_label":"Show field details"},"insert_accreditation":{"label":"Insert Diploma","success_message":"Diploma inserted successfully!","submit_button":"Ready for validation!","no_certificate_message_start":"You have not yet installed the University key to digitally sign the Diplomas. Please revert to the '","no_certificate_message_link":"Security","no_certificate_message_end":"' section first."},"certificate":{"label":"Certificates","add_button":"Add certificate","about_label":"To add a certificate, please upload the file with extension '.crt'.","no_data_label":"There are no Certificates","created_at_label":"Created at","valid_from_label":"Valid from","valid_till_label":"Valid till","remove_button":"Remove certificate","are_you_sure_label":"Are you sure you want to remove this certificate?","remove_warning_label":"Warning!!! If you delete the certificate, ALL the Diplomas signed by this certificate will immediately be forever invalidated!","insert_certificate_label":"Certificate to sign the accreditation","insert_certificate_about_label":"To start inserting accreditations, you must upload a certificate key with extension '.jwk'. If you don't have this file yet, contact your Organization's Anchor.","change_certificate_button":"Insert new Private Digital Key","add_certificate_key_button":"Add Certificate Key","insert_key_button":"Insert Key","key_already_installed_button":"Private Digital Key is already installed.","no_root_certificate_label":"You have no root certificate installed yet.","root_certificate_hint":"The BrainChain root certificate file -called ca.crt- is generated by the System Administrator offline and subsequently imported here. This ensures when University Insertors import the University key in their browser (= the uni.jwk file), a validation handshake can be made between them. Without an imported root certificate, this will result in errors.","no_certificates_needed_label":"No certificates needed - No Diploma signing by this Organization","no_org_certificate_label_start":"The University key (uni.crt) file has not yet been installed - please do so in the '","no_org_certificate_label_link":"Security","no_org_certificate_label_end":"' section after the University has been properly validated."},"validate_accreditation":{"label":"Validate Diploma","success_message":"Diploma validated successfully!","submit_button_validate":"Validate Diploma","common_message_label":"Leave comment for Reviewer","common_message_placeholder":"Leave your comment here...","submit_button_invalidate":"Send Back for Review","or_label":"OR","validate_accreditation_message":"Are you sure you want to discard the changes and accept this Diploma?","submit_button_invalidate_title":"Please mark the incorrect fields and/or leave a message for the Reviewer"},"review_accreditation":{"label":"Review failed Diploma","success_message":"Diploma re-inserted successfully!","submit_button":"Re-Insert for validation","message_label":"Message from Validator","feedback_from_validator_label":"Feedback from Validator","feedback_from_applicant_label":"Feedback from Applicant","review_accreditation_progress_label":"Processed","reinsert_accreditation_button_hint":"Please only re-insert this accreditation with changes that reflect the $consensus$ you achieved with the the Validator $offline$. When such consensus is not possible, you can choose 'Remove' - the Accreditation will then be shown as 'Rejected' in the Applicant's interface."},"bulk_upload":{"drag_and_drop_label":"Drag & drop file here","or_label":"Or","browse_label":"#Click here# to point to your file","error_label":"Whoops! Failed to take file in: Incorrect file format","uploaded_file_label":"Uploaded file","max_file_size_message":"Maximum file size","exceeded_upload_size_alert":"This file is way too big to drag through the wire...","file_format_info_label":"File format info","file_format_details_label":"File format details","consent_request_bulk_error_label":"Please select file to proceed","consent_request_bulk_empty_file_label":"The file is empty"},"bulk_file_format_details":{"use_csv_message":"Please adhere to the CSV file format.","file_header_message":"Your file should have the following header: ","additional_titles_label":"languages codes of additional translations ","language_code_label":"language code","provide_data_message":"This means that you should provide:","applicant_data_message":"Applicant data: email, first name, last name, country code, National ID Nº (like a SSN in the US)","accreditation_data_message":"Diploma data: the date when the Diploma was issued, its level, its original title, the title in English and (additional, optional) title translations.","file_entries_message":"Each next line should contain Diploma details in line with the header format.","liaise_it_staff":"Please liaise with IT staff to ensure proper formatting.","back_button":"Back to Bulk Diploma upload","csv_file_example_label":"CSV-formatted file example","download_example_button":"Download example","values_details_label":"Values details","email_details":"For historical(= older than 2 months) Diplomas, Email is optional.","date_issued_details":"Date of issuance can not lie in the future.","levels_label":"Diploma levels","titles_label":"Additional Diploma titles","header_name_label":"Header name","required_label":"Required","format_label":"Format","mean_label":"Value","code_label":"Code","email_mean_label":"Applicant email","first_name_mean_label":"Applicant First Name","last_name_mean_label":"Applicant Last Name","country_code_mean_label":"Applicant country code","national_id_mean_label":"Applicant National ID Nº","date_issued_mean_label":"The date when the Diploma was issued (**)","level_mean_label":"Diploma level","original_mean_label":"Original Diploma title","en_mean_label":"Diploma title in English","lang_code_mean_label":"Additional Diploma titles (see table with additional titles)","email_format":"applicant@email.com","string_format":"String","country_code_format":"ISO 3166-1 alpha-2 code","date_format":"YYYY-MM-DD","level_format":"Level code (see table with Diploma levels)","optional-fields-highlighted-label":"Optional fields are highlighted with","gray_label":"gray","use_xml_message":"Please adhere to the XML file format.","csv_file_format_label":"CSV file format","xml_file_format_label":"XML file format","then_provide_message":"Then you should provide:","tag_name_label":"Tag name","attributes_label":"Attributes","accreditations_meaning_label":"Container for the list of accreditations","accreditation_meaning_label":"Container for the accreditation details","titles_meaning_label":"Container for accreditation title translations","title_meaning_label":"Title translation. The language attribute is a language code of the -original or additional- translation, see table with additional titles","title_details":"The Original accreditation Title is required.","xml_file_example_label":"XML-formatted file example","consent_bulk_file_info_label":"Please adhere to the TXT or CSV file format. You should provide a file with applicants' Email addresses, separated by commas, semicolons, line breaks or spaces."},"applicant_accreditations_management":{"certified_accreditations_label":"Certified Accreditations","issued_by_label":"Issued By","expose_certified_accreditations":"Expose","no_data_label_part_1":"There are no $Certified Diplomas$. $Certified Diplomas$ are diplomas confirmed by your university. If none are present, you can request this under “Diploma Verification Requests”. ","no_data_label_part_2":"We bundle such requests with other Alumni till your university joins BrainChain. Via our ","no_data_label_part_3":"website","no_data_label_part_4":" you can also urge your University to join should this not yet be the case!","accreditation_details_label":"Diploma details","remove_accreditation_alert":"Are you sure you want to remove this Diploma?","remove_accreditation_success_massage":"Diploma removed successfully!","pending_accreditations_label":"Pending Diplomas","accept_accreditation_button_label":"Accept Diploma","send_back_accreditation_button_label":"Send Back for Review","discard_accreditation_message":"Are you sure you want to discard this Diploma?","discard_accreditation_warning_message":"Warning! In the case of refusal, the Diploma will be completely removed!","discard_accreditation_button_label":"Discard Diploma","vids_label":"Verified Identities","expose_fn_ln_country":"Expose name and country","expose_national_id":"Expose national ID","expose_nid_option_full":"My full National Identification Nº can be exposed","expose_nid_option_short":"Only expose last 4 digits of my National Identification Nº","expose_nid_option_not_expose":"Never expose my National Identification Nº","no_vids_label":"There are no $Verified Identities$. $Verified Identities$ are identities confirmed by your University and come with confirmed diplomas.","active_vid_label":"Active","active_vid_title_checked":"Active Verified Identity","active_vid_title_unchecked":"Activate Verified Identity","show_details_label":"Show Diploma details","no_pending_accreditations_label":"There are no $Pending Diplomas$. After you requested your University to confirm your degree, and after your University confirmed it, your Diploma(-s) will be listed here with a status indicating this (temporal!) one-sided validation. Potential employers can already see them, but they will be marked as such till they got confirmed from both sides (yours as well!)."},"license_agreement":{"agree_label":"I accept the terms of","agree_link":"the license agreement."},"consents":{"status":{"ALL":"All","PENDING":"Pending","GRANTED":"Granted","REJECTED":"Rejected","REVOKED":"Revoked","EXPIRED":"Expired","CANCELED":"Canceled","ABANDONED":"Abandoned"},"status_title":{"PENDING":"Pending request","GRANTED":"Granted request","REJECTED":"Rejected request","REVOKED":"Revoked request","EXPIRED":"Expired request","CANCELED":"Canceled request","ABANDONED":"Abandoned request"},"no_data_label":"There are no Consent Requests","show_consents_list_label":"Open list of consent requests","hide_consents_list_label":"Return to consent request details","no_selected_consent_request_label":"Select a consent request in the list to see details","edit_label":"Edit Consent Request","cancel_request_success_message":"Cancel request successfully!","request_details_label":"Request details","target_label":"Beneficiary","created_by_label":"Created by","hidden_for_applicant_label":"Hidden from Applicant","credentials_label":"Credentials","issued_at_label":"Issued at","cancel_request_button_label":"Cancel request","cancel_request_warning_label":"Warning! You will no longer see this Consent Request in the list after canceling.","cancel_request_are_you_sure_label":"Are you sure you want to cancel this Consent Request?","applicant_response_label":"Applicant Response","last_update_label":"Last update","expires_label":"Expires","expired_label":"Expired","revoked_label":"Revoked","pending_consents_label":"Pending Consents","periods":{"week_label":"Week","month_label":"Month","year_label":"Year","forever_label":"Forever"},"consent_end_date_alert":"Your consent will expire on","active_consents_label":"Active consents","requested_label":"Requested","valid_till_label":"Valid till","grant_consent_button":"Grant Consent","current_expire_date_label":"Current expire date","next_expire_date_label":"Next expire date","extend_consent_button":"Extend consent","remove_consent_label":"Revoke Consent","remove_consent_button":"Revoke","remove_consent_success_label":"Consent revoked successfully!","remove_modal_alert":"Are you sure you what to remove this consent?","person_label":"Person","none_label":"None","no_active_consents_label":"You have no active consents yet","no_pending_consents_label":"You have no pending consents yet","next_consent_button":"Next Request","status_filter_label":"Status","job_label":"Job","job_filter_placeholder":"Enter Job Title to search","job_title_label":"Job Title","internal_job_reference":"Internal Job Reference","expose_job_reference":"Share Internal Job Reference with Applicant","note_to_applicants_label":"Note to Applicant(s)","consents_history_label":"Consultation History","show_consents_with_status_label":"Show consents with status","consents_history_no_data_label":"Your consultation history is empty","status_label":"Status","expired_on_label":"Expired on","dismiss_request_button_label":"Dismiss request","dismiss_request_warning_label":"Warning! You will no longer see this Consent Request in the list after dismissing.","dismiss_request_are_you_sure_label":"Are you sure you want to dismiss this Consent Request?","self_study_books_label":"Self-Study books","accreditations_label":"Diplomas","remove_bulk_consent_requests":"Are you sure you want to remove this file?","verified_by_applicant_only_label":"Validated by: Applicant only"},"prior_consents":{"prior_consents_label":"Prior consents","prior_consents_no_data_label":"You have no prior consents yet.","target_type_label":"Beneficiary Type","target_data_label":"Beneficiary","auto_grant_till_label":"Auto-grant till","duration_label":"Duration","anyone_label":"Anyone","day_label":"day","days_label":"days","add_prior_consent_label":"Create prior consent","edit_prior_consent_label":"Edit prior consent","target_type_input_placeholder":"Select Beneficiary type...","add_prior_consent_success_message":"Prior consent created successfully!","edit_prior_consent_success_message":"Prior consent updated successfully!","period_label":"Period","duration_alert":"Consent duration period will be","response_comment_label":"Auto-response to requestors","response_comment_placeholder":"Leave your comment here...","remove_prior_consent_label":"Remove Prior Consent","remove_prior_consent_success_message":"Prior consent removed successfully!","remove_prior_consent_alert":"Are you sure you want to remove this Prior consent?","prior_consents_hint_part_1":"A prior consent is a consent you configure now and will be executed immediately and automatically, without bothering you again at the time it is requested by a Company.","prior_consents_hint_part_2":"It means companies you add below, who consider hiring you, will get immediate confirmation of the Diploma(-s) you chose to expose ... at least till the given 'Auto-grant till' date.","prior_consents_hint_part_3":"The 'Duration' field specifies how long such consent is valid. E.g. if you set that for one month, it means colleagues of the first requestor -other HR managers, business owners , your potential boss(!) , .... - from the same company can check it as well within that month after that first request. Once that month passed however, a new request needs to be made by them, which BrainChain then cross-checks against the 'Auto-grant till' date!"},"approve_consent_after_request":{"label":"Approve Consent after Request","success_alert":"Successful approval of consent request","consent_requestor_label":"Consent Requestor","grant_title_label":"Grant","refuse_title_label":"Refuse","grant_button":"Grant","refuse_button":"Refuse","company_name_label":"Company name","company_country_label":"Company country","request_date":"Request Date","period_label":"Period","period_input_placeholder":"Choose period...","reason_label":"Reason","reason_input_placeholder":"Choose reason...","reasons":{"TIMING1":"I'm not looking for a job","TIMING2":"I will only be free in at least a year from now","INTEREST":"I am not interested to work for this company","MISMATCH":"This job seems not to align with my skills","ANOTHER":"Another reason"},"comment_label":"Leave a comment for requestor","comment_placeholder":"Write your message here...","back_button":"Return ","approve_consent_progress_label":"Granted"},"notification_settings":{"label":"Notifications","notification_settings_label":"Notification settings","notification_new_accreditation_enabled":"Send me an Email when I need to review new diplomas","notification_consent_request_enabled":"Send me an Email when a potential employer ask us to confirm your diploma","notification_settings_update_success_alert":"Notification settings updated successfully!","no_settings_label":"You currently have no have no notification settings to configure.","preferred_language":"Preferred notifications language"},"security_settings":{"label":"Security","2fa_label":"2-Factor Authentication","current_status_label":"Current status:","2fa_disabled_label":"2-Factor Authentication disabled.","2fa_enabled_label":"2-Factor Authentication enabled.","disable_2fa_submit_button":"Disable 2-Factor Authentication","enable_2fa_submit_button":"Enable 2-Factor Authentication","disable_2fa_are_you_sure_message":"Are you sure you want to disable 2-Factor Authentication? After disabling 2-Factor Authentication, login just requires Email and password without a verification code.","disable_2fa_success_message":"2-Factor Authentication disabled successfully!","enable_2fa_scan_qr_code_message":"To enable 2-Factor Authentication, scan the QR-code using Google Authenticator, or another application if your choosing. The application provides you with verification codes for logging into your account.","links_label":"Link to Authentication Apps","google_authenticator_android_label":"Google Authenticator for Android","google_authenticator_ios_label":"Google Authenticator for iOS","free_otp_android_label":"FreeOTP Authenticator for Android","free_otp_ios_label":"FreeOTP Authenticator for iOS","update_warning":"You should scan the new QR-code every time you enable 2-Factor Authentication to get an updated code.","enable_2fa_check_code_message":"To make sure that everything works correctly, please enter the verification code you get after scanning the QR-code","enable_2fa_parameters_label":"Authentication parameters","issuer_label":"Issuer","secret_label":"Secret","algorithm_label":"Algorithm","digits_label":"Digits","_comment_on_digit_label":"The number of characters allowed (not just numbers)","period_label":"Period","_comment_on_period_label":"Meaning: Duration (not '.')","check_code_label":"Verification code","enable_2fa_success_message":"2-Factor Authentication enabled successfully!","2fa_contact_support_message":"If for some reason you have lost access to the application and cannot get the verification code, you can contact support.","verification_code_details_label":"The verification code must contain six digits.","verification_code_enter_label":"To get the correct 2-factor authentication code, please check with the code generator application you chose when you enabled this setting."},"self_study":{"table_label":"Self-study books","no_data_label":"You have no $Self-study books$ at the moment.  Books you read or study on your own, can be added here and require no external confirmation. They show interest and effort, no proof of formal education.","domain_label":"Domain","publisher_label":"Publisher","study_date_label":"Study date","isbn_label":"ISBN","domains":{"ADMINISTRATION_AND_MANAGEMENT":"Administration & Management","COMMUNICATION":"Communication","CULTURE_AND_SPORTS_AND_ENTERTAINMENT":"Culture, Sports & Entertainment","GOV":"Gov","IT":"IT","LAND_AND_SEA_AND_AIR":"Land & Sea & Air","LEGAL":"Legal","LIFE_AND_DEATH":"Life & Death","MANUFACTURING_AND_WORKING_WITH_MATERIALS":"Manufacturing & Working with Materials","SALES_AND_MARKETING":"Sales & Marketing","SERVICES":"Services","STEM":"STEM","OTHER":"Other"},"domains_examples":{"ADMINISTRATION_AND_MANAGEMENT":"Clerks, secretaries, executives, ...","COMMUNICATION":"Journalism, Audio/Video, ...","CULTURE_AND_SPORTS_AND_ENTERTAINMENT":"Tourism, actor, stripper, hospitality, ...","GOV":"Education, Army, Police, city clerk, ...","IT":"Developer, ML, AI, web designer, DBA, software architect, ...","LAND_AND_SEA_AND_AIR":"Farmer, fisher, astronaut, pilot, flight attendants, gardener, ...","LEGAL":"Notary, lawyer, ...","LIFE_AND_DEATH":"Doctor, vet, therapist, dentist, nurse, sniper, coroner, ...","MANUFACTURING_AND_WORKING_WITH_MATERIALS":"Lumberjack, welder, textile, car assembly, mining, construction worker, ...","SALES_AND_MARKETING":"Baker, car parts, immo, rental, promotion, ...","SERVICES":"Cleaning, hairdresser, recruitment, insurances, banker, transport, accounting, distribution, ...","STEM":"Science (Pharma), Technology(car mechanics, electrician), Engineering (agricultural engineer, architect), Math"},"add_self_study_book_success_message":"Self-Study book added successfully!","edit_self_study_book_success_message":"Self-Study book updated successfully!","add_self_study_book_label":"Add book to Self-Study Repertoire","edit_self_study_book_label":"Edit Self-Study book","domain_select_placeholder":"Select domain...","expose_self_study_book_label":"Expose Self-Study book","remove_self_study_book_alert":"Are you sure you want to remove this Self-Study book?","remove_self_study_book_success_message":"Self-Study book removed successfully!","isbn_format_hint":"The ISBN10/13 standard is an international book identification schema. Please stick with this format.","expose_label":"Expose","error_messages":{"isbn_alert":"Please use ISBN10 or ISBN13 format."}},"notifications":{"pending_organizations":"You have {number} pending Organizations","review_failed_accreditations":"You have {number} failed Diplomas Verifications to review","validate_accreditations":"You have {number} pending Diploma Verifications","pending_accreditations":"You have {number} pending Diploma Verifications","pending_consents":"You have {number} pending Consents","pending_accreditation_requests":"You have {number} pending Diploma Verification Requests","unreferenced_accreditation_requests_by_ags":"You have {number} Diplomas verification Requests without a linked Accreditation Group(Faculty)","unreferenced_accreditation_requests_by_domains":"You have {number} Diploma Verification Requests without a linked University"},"accreditation_requests":{"create_accreditation_request_label":"Create Diploma Verification Request","create_accreditation_request_success_message":"Diploma Verification Request created successfully!","create_accreditation_request_hint":"If your Alma Mater is already part of the BrainChain Platform, please select it in the below fields. If not, please go with 'Input manually'. Of crucial importance there is to enter the correct and current internet domain  (it may have changed over the years!) of your Alma Mater.","domain_hint":"An internet Domain is the first part of the web address of an organization. E.g. apple.com or ibm.de.","accreditation_group_hint":"An Accreditation Group is typically the name of the #faculty# you graduated at. Like #Civil Engineering# or #Psychology#, depending on how your Alma Mater chose to organise itself.","national_id_hint":"Countries identify their citizens with a uniquely coded number. This to avoid ambiguity, even for people with the exact same name. Obviously for knowing who owns which degree, this matters. It gives us the perfect means to ensure EVEN someone with the exact same name as you, will never be able to steal your identity, or claim he earned your degree.","national_id_expose_hint":"The National ID will only be exposed in full to the Applicant. The Applicant can change the expose settings at any time.","manual_org_input_mode_label":"Input org data manually","select_org_input_mode_label":"Select org","manual_accreditation_group_input_mode_label":"Input accreditation group manually","select_accreditation_group_input_mode_label":"Select accreditation group","manual_vid_input_mode_label":"Input VID data manually","select_vid_input_mode_label":"Select VID","vid_label":"Verified Identity","status":{"REQUEST_SUBMITTED":"Submitted","REQUEST_IN_PROCESS":"Under Consideration","REQUEST_REJECTED":"Rejected"},"status_label":"Request Status","expose_label":"Exposed Diploma","edit_accreditation_request_label":"Edit accreditation request","remove_accreditation_request_label":"Remove accreditation request","accreditation_requests_no_data_label":"You have no accreditation requests yet","accreditation_requests_label":"Diploma Verification requests","accreditation_request_remove_alert":"Are you sure you want to remove this Diploma Verification Request?","edit_accreditation_request_success_message":"Diploma Verification request updated successfully!","pending_accreditation_requests_by_domain_label":"Pending Diploma Verification requests by Domain","validated_accreditation_requests_by_domain_label":"Validated Diploma Verification requests by Domain","accreditation_requests_list_no_data_label":"There are no accreditation requests yet.","organization_domain_label":"Organization Domain","accreditation_requests_number_label":"Diploma Verification requests number","filter_by_domain_label":"Filter by domain","filter_label":"Filter","accreditation_requests_remove_alert":"Are you sure you want to remove this Diploma Verification Request?","remove_accreditation_request_success_message":"Diploma Verification request removed successfully!","remove_accreditation_requests_success_message":"Diploma Verification requests removed successfully!","update_accreditation_requests_success_message":"Diploma Verification requests' domain updated successfully!","accreditation_requests_warning_alert":"This Organization has {number} diploma verification requests. If this Organization is saved without the permission to insert Diplomas, all pending Applicant Diploma Verification requests will be removed!","proceed_button":"Proceed","accreditation_requests_by_group_label":"Diploma Verification requests by Group","accreditation_requests_by_group_hint_part_1":"Here you can couple the Diploma Verification Requests coming from Applicants (lists below) to existing Accreditation Groups(Faculties) at your University.","accreditation_requests_by_group_hint_part_2":"Once coupled, they will be routed to the correct Insertor(-s).","accreditation_requests_by_group_hint_part_3":"Note that you can bundle multiple request of same Accreditation Group(Faculty).","set_accreditation_group_for_selected_button":"Set Accreditation Group(Faculty) for selected Requests","reject_selected_button":"Reject selected","reject_accreditation_requests_alert":"Are you sure you want to reject all selected Diploma Verification Requests?","reject_button":"Reject","set_accreditation_group_for_selected_requests_label":"Set Accreditation Group(Faculty) for selected Diploma Verification Requests","set_accreditation_group_for_selected_requests_success_message":"Accreditation Group(Faculty) reference added successfully!","expose_accreditation_request_label":"Expose Diploma Verification Request","pending_accreditation_requests_label":"Pending Diploma Verification Requests","pending_accreditation_requests_no_data_label":"There are no Pending Diploma Verification Requests yet","pending_accreditation_requests_hint_part_1":"If the data is correct, you can simply #Confirm# the Request. If you are not sure, you can click #Next# to skip the current request for now.","pending_accreditation_requests_hint_part_2":"If the Diploma data contains errors, they can be corrected before insertion.","back_button":"Return to the list of Pending Diploma Verification Requests","process_accreditation_request":"Process Diploma Verification Request","next_accreditation_request_label":"Next Diploma Verification Request","confirm_accreditation_request_button":"Confirm and Insert","reject_accreditation_request_alert":"Are you sure you want to reject this Diploma Verification Request?","organization_label":"Organization","applicant_email_label":"Applicant Email","expose_hint":"You can choose to already expose Diploma verification requests to potential employers, even if they will be marked as 'not-validated' yet till also the University has confirmed them.","created_at_label":"Request Date","org_by_domain_error_alert":"Mmmm, it seems this Organization cannot insert Diplomas.","accreditations_pending_approval_label":"Diploma Verifications pending approval","accreditation_requests_details_label":"Diploma Verification Request details","reject_accreditation_request_success_message":"Diploma Verification Requests rejected successfully!","confirm_accreditation_request_success_message":"Diploma Verification Request approved successfully!","pending_accreditations_progress_label":"Inserted","validated_accreditations_progress_label":"Validated","validate_button":"Validate","accreditation_requests_validate_alert":"Are you sure you want to approve this Diploma Verification Request?","validate_accreditation_requests_success_message":"Diploma Verification requests approved successfully!","pending_accreditation_requests_list_no_data_label":"There are no pending Diploma verification requests.","validated_accreditation_requests_list_no_data_label":"There are no approved Diploma verification requests yet.","last_requestors_button":"Latest Applicants","applicant_accreditation_consent_label":"I hereby consent the BrainChain Accreditation Vetting Authority (BAVA) to manage the verification process and keep me notified."},"security":{"label":"Security","got_it_button":"Got it","anchor_info_part_1":"All communication with BrainChain is done safely by using a strong digital encryption key. This safely wraps Diploma data to prevent peeking and tampering. You get this key - a file with extension '.jwk' - at simple request from BrainChain.","anchor_info_part_2":"Your role as Anchor means you should share these keys in a safe way(= preferably offline, for example on a USB stick), with all Insertors you appoint.","anchor_info_part_3":"Without this key, they will not be able to insert Diplomas.","inserter_info_part_1":"All communication with BrainChain is done safely by using a strong digital encryption key. This safely wraps Diploma data to prevent peeking and tampering. Your Organization Anchor gets this key from BrainChain and passes it on to you; this key is a file with extension '.jwk'.","inserter_info_part_2":"All you need to do to get started, is drop or import that file, below, on the very computer you will use to insert Diplomas.","inserter_info_part_3":"This is a one time effort per computer you use for this purpose.","inserter_info_part_4":"Once the digital key installed, the diploma encryption & signing will be done in the background transparently, without any further required action.","admin_root_certificates_label":"Manage BrainChain Root Certificate","admin_universities_label":"Validated Universities - awaiting we upload their server-side key","admin_universities_info_part_1":"The BrainChain root certificate aside, there is a 2nd component that Universities need us (BrainChain) to install serverside: the generated university-specific certificate uni.crt.","admin_universities_info_part_2":"Below is the list of already validated Universities that haven't got this key installed yet, and are waiting for it from us. This can be done right after University Validation: now! After this key is installed on our side, do not forget to also send the University Anchor his own uni.jwk file. This needs to be generated by the SA offline.","add_valid_till_label":"Add/Valid Till","add_certificate_button":"Add uni.crt","mail_anchor_label":"Mail Anchor uni.jwk","is_uni_key_sent_label":"Uni key sent?","confirm_sent_button":"Confirm sent","mail_subject_label":"Your BrainChain digital key to safely sign Diplomas","mail_body_part_1":"Dear {anchor},","mail_body_part_2":"All communication with BrainChain is done safely by using a strong digital encryption key. This safely wraps Diploma data to prevent peeking and tampering. This key - a file with extension '.jwk' - is added in attach.","mail_body_part_3":"Your role as Anchor means you should share these keys in a safe way(=preferably offline, for example on a USB stick), with all Insertors you appoint.","mail_body_part_4":"Without this key, they will not be able to insert Diplomas.","mail_body_part_5":"Should you forget this, the BrainChain application will remind you under the Security section","mail_body_part_6":"Team BrainChain"},"assistants":{"assistants_label":"Assistants","no_data_label":"There are no Assistants yet.","roles_label":"Roles","location_label":"Location","process_assistant_label":"Process Assistant","financial_assistant_label":"Financial Assistant","add_assistant_page_label":"Add Assistant","roles_select_placeholder":"Select Assistant roles...","remove_assistant_alert":"Are you sure you want to remove this Assistant?","edit_assistant_alert":"Edit Assistant"},"business_ambassadors":{"business_ambassadors_label":"Business Ambassadors","no_data_label":"There are no Business Ambassadors yet.","financial_data_label":"Financial data","add_business_ambassador_label":"Add Business Ambassador","edit_business_ambassador_label":"Edit Business Ambassador","add_business_ambassador_success_message":"Business Ambassador added successfully!","edit_business_ambassador_success_message":"Business Ambassador updated successfully!","remove_ambassador_alert":"Are you sure you want to remove this Business Ambassador?"},"commissions":{"commissions_list_label":"Commissions","countries_label":"Countries","commission_label":"Commission","date_from_label":"Date from","date_to_label":"Date to","no_data_label":"There are no Commissions.","remove_commission_success_message":"Commission removed successfully!","remove_commission_alert":"Are you sure you want to remove this Commission?","add_commission_label":"Add Commission","edit_commission_label":"Edit Commission","add_commission_success_message":"Commission created successfully!","edit_commission_success_message":"Commission updated successfully!","ba_label":"Business Ambassador","ba_short_label":"BA","add_commission_hint":"New commissions can be defined below for #previously defined# Business Ambassadors."},"system_payment":{"due_payments_label":"Due Payments","ba_s_due_payments_label":"Due Payments to Business Ambassadors","uni_s_due_payments_label":"Due Payments to Education WorldWide","system_due_payments_label":"Due payment to WickedWare","system_due_payments_hint":"This number represents the amount to be wired off the WickedWare 'BrainChain' account to the WickedWare Savings (LT773500010003830341) account. This is the outstanding sum of the consumed companies credit.","filter_by_region_label":"Filter by Region","ba_label":"BA","uni_label":"Uni","amount_label":"Amount Due","total_aggregated_pay_label":"Total Aggregated Pay","ba_wire_data_label":"BA Wire Data","uni_wire_data_label":"Uni Wire Data","record_payment_label":"Record Payment","paid_button":"Confirm paid offline","no_ba_s_label":"There are no BAs.","no_uni_s_label":"There are no Universities.","no_payments_for_ba_s_label":"No payments to BAs fall within these criteria","no_payments_for_uni_s_label":"No payments to Universities fall within these criteria","no_payments_for_system":"There are no due payments for WickedWare.","show_label":"Show","due_payments_paid_success_message":"Due payments paid successfully!","payments_history_label":"Payments History","uni_s_payments_history_label":"Payments History for Education WorldWide","ba_s_payments_history_label":"Payments History for Business Ambassadors","payment_date_label":"Payment date","filter_date_from_label":"Date from","filter_date_to_label":"to","name_label":"Name","company_credit_label":"Company Credit","date_joined_label":"Date Joined","open_credit_label":"Open Credit","total_credit_label":"Total used Credit","contact_label":"Contact","no_companies_credits_label":"No Companies Credits fall within these criteria.","order_by_label":"Order by","due_payment_modal_label":"Due payment for {name}","wire_data_modal_label":"Wire data for {name}","comment_label":"Comment","no_company_credits":"No Credits for this Company","date_label":"Date","value_of_change_label":"Value of change","credit_history_label":"Credit History for {name}"},"validated_domains":{"validated_domains_label":"Validated Edu Domains","no_data_label":"There are no Validated Domains.","filter_by_name_label":"Filter by name","organization_name_label":"Organization Name","managed_by_label":"Managed by","applicant_requests_label":"Applicant requests","bava_managed_label":"BAVA-managed","self_managed_label":"Self-managed","add_domain_button":"Add domain","validate_domain_label":"Validate domain","contact_name_label":"Contact name","contact_email_label":"Contact email","contact_phone_label":"Contact phone","add_success_message":"Validated domain added successfully!","edit_success_message":"Validated domain updated successfully!","edit_domain_label":"Edit organization details","remove_domain_alert":"Are you sure you want to remove this Validated Domain? Note that this means all its degrees in people's profiles will also get deleted!","remove_success_message":"Validated domain removed successfully!","fully_registered_org_hint":"You can change this Organization in the list of Organizations."},"shared":{"add_button":"Add","cancel_button":"Cancel","remove_button":"Remove","first_name_label":"First name","last_name_label":"Last name","email_label":"Email","personal_email_label":"Personal email","professional_email_label":"Professional email","password_label":"Password","department_label":"Department","continent_input_placeholder":"Select region...","country_input_placeholder":"Select country...","continent_label":"Region","continent_filter_label":"Region(Filter)","country_label":"Country","fetching_message":"Loading...","success_message":"Success","national_id_label":"National ID Nº","company_label":"Company","edu_org_label":"Educational Organization","org_label":"Organization","employee_count_label":"Number of employees","name_label":"Name","accreditation_group_label":"Accreditation group(Faculty)","okey_button":"OK","yes_label":"Yes","no_label":"No","edit_button":"Edit","domain_label":"Internet Domain","datepicker_placeholder":"Click to select a date","save_changes_button":"Save changes","back_button":"Back","company_domain_label":"Company domain","search_label":"Search","about_label":"About","title_label":"Title","phone_number_label":"Phone number","required_field_error_message":"Please fill out this field","pages_label":"{currentNumber} of {totalNumber}","examples_label":"Examples","location_label":"Location","all_label":"All","filter_options_label":"Filter options"},"errors":{"IRRELEVANT_LINK_EMAIL":"You have already changed your email using this link!","INCORRECT_JWK":"Incorrect certificate key","DEFAULT_ERROR":"Error","INCORRECT_ACCOUNT_TYPE":"Incorrect Account type","INCORRECT_USERNAME_OR_PASSWORD":"Incorrect username or password","IRRELEVANT_LINK":"You have already reset your password using this link!","INCORRECT_FILE_CONTENT":"Incorrect file content","INCORRECT_DOMAIN":"Provided domain is invalid","BAVA_ACCREDITATION_FLOW_FORBIDDEN":"Diploma operations related to BAVA are forbidden.","BAVA_ACCREDITATION_MISSING_PARAMS":"The Organization-ID should be provided in the Diploma.","BAVA_MISSING":"The Bava organization is not registered","BAVA_CANNOT_BE_CHANGED":"The Bava organization cannot be changed","RELATED_ACCREDITATIONS_EXISTS":"The managed state cannot be changed for organizations with existing diploma verification requests","REQUEST_BODY_INVALID":"Incorrect data. Please make sure you entered all fields correctly.","REQUEST_PARAM_MISSING":"Required request parameter is missing","REQUEST_PARAM_INVALID":"Request parameter value is invalid","OPERATION_NOT_PERMITTED":"Operation not permitted","OAUTH_CLIENT_ERROR":"OAuth request invalid","OAUTH_GRANT_TYPE_INVALID":"OAuth grant type invalid","NEGATIVE_BALANCE":"The credit balance cannot be negative.","ACCREDITATION_GROUP_ROLE_INVALID":"Invalid Accreditation Group)(Faculty) role","ACCREDITATION_GROUP_ACCREDITATION_REQUEST_ADDITION_ERROR":"It is not possible to add this Faculty to the Accreditation request.","ACCREDITATION_GROUP_STAFF_ADDITION_ERROR":"Cannot add specified staff for specified Accreditation Group(Faculty)","ACCREDITATION_GROUP_STAFF_REMOVAL_ERROR":"Cannot remove specified staff from specified Accreditation Group(Faculty)","ACCREDITATION_GROUP_NAME_MISSING":"#Please specify an Accreditation Group (a.k.a. Faculty) name as there exists no default option for this organization.#","DEPARTMENT_ROLE_INVALID":"Invalid Department role","DEPARTMENT_STAFF_ADDITION_ERROR":"Cannot add specified staff for specified Department","DEPARTMENT_STAFF_REMOVAL_ERROR":"Cannot remove specified staff from specified Department","UNSUFFICIENT_BALANCE":"Insufficient balance - please contact the responsible (financial colleague) to resolve this problem","TIME_PERIOD_INVALID":"Period is invalid","CONSENT_REQUEST_STATUS_INVALID":"It seems like this request has already been processed or canceled","ABANDONING_OTHERS_REQUEST":"You cannot perform this operation","PRIOR_CONSENT_EXISTS":"Prior Consent for the same Beneficiary already exists","INCORRECT_ORGANIZATION_PAID_TILL_STATE":"Incorrect value for 'Paid till' date; the new 'Paid till' date should be more recent than its previous value.","EXPIRED_ORGANIZATION_PAID_TILL":"The Organization's 'Paid till' date has expired.","ORGANIZATION_EMAIL_INVALID":"Organization staff Email invalid","STAFF_REMOVAL_ERROR":"This staff cannot be removed","NO_ANCHOR_LEFT":"Anchor cannot self-delete!","ACTIVE_STAFF_MISSING":"Cannot find an active staff with specified ID","NON_STAFF_USER_EXISTS":"Specified user already exists and he is not a colleague!","STAFF_DIFFERENT_ORGANIZATION":"A person with this Email works in a different Organization.","STAFF_ALREADY_EXISTS":"A colleague with this Email already works in your organization","ORGANIZATION_ALREADY_EXISTS":"Organization name and/or domain is already in use","ORGANIZATION_IS_BAVA_MANAGED":"#As long as this Organisation is BAVA-managed, it can not have Accreditation Groups; all Diploma's will resort under 'AllFaculties' till the Organization joins, at which point a Diploma migration effort is to be organized.#","ORGANIZATION_CANNOT_BE_REMOVED":"BAVA-managed organizations can be removed but BAVA (and its daughter Vetting authorities) itself can not be removed","ORGANIZATION_CANNOT_BE_UPDATED":"An organization with this name and/or domain has already been registered.","ORGANIZATION_CERTIFICATE_MISSING":"There are no valid certificates for this organization","ORGANIZATION_ACCREDITATION_INCORRECT_STATUS":"Incorrect accreditation status","ORGANIZATION_ACCREDITATION_FLOW_FORBIDDEN":"Organization has no permissions to insert accreditation","ORGANIZATION_EQUAL_MANAGED_STATE":"The organization was already in this state.","USER_ALREADY_EXISTS":"Account already exists","ACTIVATION_NOT_NEEDED":"Account is unknown or already active","ALIAS_REQUIRED":"Cannot activate the user without a complete Alias","APPLICANT_TOKEN_REQUIRED":"Applicant's Token is missing","APPLICANT_NOT_FOUND":"There is no one with this Email address registered in BrainChain yet.","OLD_PASSWORD_INVALID":"Invalid old password","EMAIL_ALREADY_IN_USE":"Email address is already in use","USER_INACTIVE":"Account is unknown or inactive","NO_ALIASES_LEFT":"At least one Alias should exist","PASSWORD_TOO_SIMPLE":"Password is too simple","CAN_NOT_REMOVE_LAST_ROOT_ADMIN":"Last root admin can not be removed","BUSINESS_AMBASSADOR_CONTRACT_INTERSECTION":"For every [Country, BA] combination, only one Commission can be specified.","BUSINESS_AMBASSADOR_CONTRACT_HUGE_TOTAL_PERCENT":"The total commission percentage got bigger than expected for some country(-s) over a period of time.","VALIDATING_OWN_WORK":"You cannot validate your own work (Ask dead artists!)","DELETING_OTHERS_WORK":"You cannot perform this operation","ACCREDITATION_SIGNATURE_INVALID":"Provided signature is invalid","ACCREDITATION_SIGNATURE_MISSING":"Required signature is missing","ORIGINAL_ACCREDITATION_NOT_FOUND":"Apologies, the original data of this Accreditation (Diploma) could not be retrieved","APPLICANT_ACCREDITATION_REQUEST_ACCREDITATION_GROUP_ID_INVALID":"Invalid Accreditation Group(Faculty) ID for specified Organization","APPLICANT_ACCREDITATION_REQUEST_ACCREDITATION_GROUP_MISMATCH":"The Accreditation Group(Faculty) provided by the Applicant differs from the Group used to insert new accreditations.","APPLICANT_ACCREDITATION_REQUEST_STATUS_INVALID":"The status of the Applicant diploma verification request does not allow for inserting.","ACCREDITATION_BULK_JOB_NOT_FINISHED":"Please wait until the bulk upload is finished.","CREATE_CONSENT_REQUEST_BULK_JOB_NOT_FINISHED":"You cannot perform this until the job is finished","ACCREDITATION_BULK_JOB_MISSING_REQUIRED_HEADERS":"Missing the required header row.","ACCREDITATION_BULK_JOB_INVALID_RECORD_SIZE":"Columns don't match the header.","ACCREDITATION_BULK_JOB_INVALID_RECORD_FORMAT":"Invalid record format","ACCREDITATION_BULK_JOB_INVALID_XML_DOCUMENT_FORMAT":"Invalid XML document format","CURRENCY_NOT_SUPPORTED":"This currency is not supported","DIGITAL_CERTIFICATE_UNSUPPORTED_FORMAT":"The format of this digital certificate format is not supported","DIGITAL_CERTIFICATE_NOT_YET_VALID":"The digital certificate is not yet valid","DIGITAL_CERTIFICATE_EXPIRED":"The digital certificate has expired","DIGITAL_CERTIFICATE_VERIFICATION_FAILED":"The digital certificate is not properly signed","UNSUPPORTED_CONTENT_TYPE":"Unsupported content type","FAILED_TO_PARSE_BODY":"Failed to parse the request body","FILE_TOO_LARGE":"The uploaded file is too large","BUSINESS_AMBASSADOR_NOT_FOUND":"Business ambassador not found","BUSINESS_AMBASSADOR_CONTRACT_NOT_FOUND":"Business ambassador contract not found","ACCREDITATION_GROUP_NOT_FOUND":"Accreditation Group(Faculty) not found","ACCREDITATION_GROUP_CONTAIN_REQUESTS":"This Faculty (Accreditation Group) contains unprocessed requests and can therefore not be removed.","DEPARTMENT_NOT_FOUND":"Department not found","ORGANIZATION_NOT_FOUND":"Organization not found","STAFF_NOT_FOUND":"Staff member not found","ALIAS_NOT_FOUND":"Alias not found","ACCREDITATION_NOT_FOUND":"Diploma  not found","VERIFIED_IDENTITY_NOT_FOUND":"Verified Identity not found","ACCREDITATION_BULK_JOB_NOT_FOUND":"Bulk Job not found","CREATE_CONSENT_REQUEST_BULK_JOB_NOT_FOUND":"Bulk Job not found","NO_HANDLER_FOUND":"No handler found","PRICING_PRESET_NOT_FOUND":"Pricing Preset not found","USER_NOT_FOUND":"The User you're looking for did not register with BrainChain yet.","CONSENT_REQUEST_NOT_FOUND":"The consent Request was not found","PRIOR_CONSENT_NOT_FOUND":"The Prior Consent was not found","SELF_STUDY_BOOK_NOT_FOUND":"The Self Study Book was not found","DIGITAL_CERTIFICATE_NOT_FOUND":"The Digital Certificate was not found","APPLICANT_ACCREDITATION_REQUEST_NOT_FOUND":"The Applicant Diploma Verification Request was not found","TOKEN_NOT_FOUND":"No Token found","TOKEN_EXPIRED":"Token expired","TOKEN_INVALID":"Token invalid","TOKEN_VALIDATION_ERROR":"Token validation problem","TOTP_CODE_INVALID":"Verification code invalid","TOTP_CODE_REQUIRED":"TOTP code required","AUTHENTICATION_FAILED":"Authentication failed","ORGANIZATION_NOT_VERIFIED":"Organization is not verified","USER_ALREADY_ACTIVE":"This Account is already active","ORGANIZATION_CANNOT_WORK_WITH_ACCREDITATIONS":"This Organization cannot work with Diplomas","ACCESS_DENIED":"Access denied","APPLICANT_ACCREDITATION_REQUEST_CANNOT_BE_MODIFIED_IF_ORG_REFERENCED":"The Applicant Diploma Verification Request cannot be modified anymore as meanwhile the concerned Organization registered in BrainChain.","APPLICANT_ACCREDITATION_REQUEST_ORG_CHANGE_FORBIDDEN":"The Organization of an Applicant Diploma Verification Request can not be changed.","APPLICANT_ACCREDITATION_REQUEST_AMOUNT_TOO_LARGE":"Maximum amount of Diploma Verification Requests is reached.","UNAUTHORIZED":"Unauthorized","INTERNAL_SERVER_ERROR":"Internal Server Error"},"continents":{"AF":"Africa","NA":"North America","OC":"Oceania","AN":"Antarctica","AS":"Asia","EU":"Europe","SA":"South America"},"countries":{"AD":"Andorra","AE":"United Arab Emirates","AF":"Afghanistan","AG":"Antigua and Barbuda","AI":"Anguilla","AL":"Albania","AM":"Armenia","AO":"Angola","AQ":"Antarctica","AR":"Argentina","AS":"American Samoa","AT":"Austria","AU":"Australia","AW":"Aruba","AX":"Aland Islands","AZ":"Azerbaijan","BA":"Bosnia and Herzegovina","BB":"Barbados","BD":"Bangladesh","BE":"Belgium","BF":"Burkina Faso","BG":"Bulgaria","BH":"Bahrain","BI":"Burundi","BJ":"Benin","BL":"Saint Bartholomeus","BM":"Bermuda","BN":"Brunei Darussalam","BO":"Bolivia, Plurinational State of","BQ":"Bonaire, Sint Eustatius and Saba","BR":"Brazil","BS":"Bahamas","BT":"Bhutan","BV":"Bouvet Island","BW":"Botswana","BY":"Belarus","BZ":"Belize","CA":"Canada","CC":"Cocos (Keeling) Islands","CD":"Congo, the Democratic Republic of the","CF":"Central African Republic","CG":"Congo","CH":"Switzerland","CI":"Côte d'Ivoire","CK":"Cook Islands","CL":"Chile","CM":"Cameroon","CN":"China","CO":"Colombia","CR":"Costa Rica","CU":"Cuba","CV":"Cape Verde","CW":"Curaçao","CX":"Christmas Island","CY":"Cyprus","CZ":"Czech Republic","DE":"Germany","DJ":"Djibouti","DK":"Denmark","DM":"Dominica","DO":"Dominican Republic","DZ":"Algeria","EC":"Ecuador","EE":"Estonia","EG":"Egypt","EH":"Western Sahara","ER":"Eritrea","ES":"Spain","ET":"Ethiopia","FI":"Finland","FJ":"Fiji","FK":"Falkland Islands (Malvinas)","FM":"Micronesia, Federated States of","FO":"Faroe Islands","FR":"France","GA":"Gabon","GB":"United Kingdom","GD":"Grenada","GE":"Georgia","GF":"French Guiana","GG":"Guernsey","GH":"Ghana","GI":"Gibraltar","GL":"Greenland","GM":"Gambia","GN":"Guinea","GP":"Guadeloupe","GQ":"Equatorial Guinea","GR":"Greece","GS":"South Georgia and the South Sandwich Islands","GT":"Guatemala","GU":"Guam","GW":"Guinea-Bissau","GY":"Guyana","HK":"Hong Kong","HM":"Heard Island and McDonald Islands","HN":"Honduras","HR":"Croatia","HT":"Haiti","HU":"Hungary","ID":"Indonesia","IE":"Ireland","IL":"Israel","IM":"Isle of Man","IN":"India","IO":"British Indian Ocean Territory","IQ":"Iraq","IR":"Iran, Islamic Republic of","IS":"Iceland","IT":"Italy","JE":"Jersey","JM":"Jamaica","JO":"Jordan","JP":"Japan","KE":"Kenya","KG":"Kyrgyzstan","KH":"Cambodia","KI":"Kiribati","KM":"Comoros","KN":"Saint Kitts and Nevis","KP":"Korea, Democratic People's Republic of","KR":"Korea, Republic of","KW":"Kuwait","KY":"Cayman Islands","KZ":"Kazakhstan","LA":"Lao People's Democratic Republic","LB":"Lebanon","LC":"Saint Lucia","LI":"Liechtenstein","LK":"Sri Lanka","LR":"Liberia","LS":"Lesotho","LT":"Lithuania","LU":"Luxembourg","LV":"Latvia","LY":"Libya","MA":"Morocco","MC":"Monaco","MD":"Moldova, Republic of","ME":"Montenegro","MF":"Saint Martin (French part)","MG":"Madagascar","MH":"Marshall Islands","MK":"Macedonia, the Former Yugoslav Republic of","ML":"Mali","MM":"Myanmar","MN":"Mongolia","MO":"Macao","MP":"Northern Mariana Islands","MQ":"Martinique","MR":"Mauritania","MS":"Montserrat","MT":"Malta","MU":"Mauritius","MV":"Maldives","MW":"Malawi","MX":"Mexico","MY":"Malaysia","MZ":"Mozambique","NA":"Namibia","NC":"New Caledonia","NE":"Niger","NF":"Norfolk Island","NG":"Nigeria","NI":"Nicaragua","NL":"Netherlands","NO":"Norway","NP":"Nepal","NR":"Nauru","NU":"Niue","NZ":"New Zealand","OM":"Oman","PA":"Panama","PE":"Peru","PF":"French Polynesia","PG":"Papua New Guinea","PH":"Philippines","PK":"Pakistan","PL":"Poland","PM":"Saint Pierre and Miquelon","PN":"Pitcairn","PR":"Puerto Rico","PS":"Palestine, State of","PT":"Portugal","PW":"Palau","PY":"Paraguay","QA":"Qatar","RE":"Réunion","RO":"Romania","RS":"Serbia","RU":"Russian Federation","RW":"Rwanda","SA":"Saudi Arabia","SB":"Solomon Islands","SC":"Seychelles","SD":"Sudan","SE":"Sweden","SG":"Singapore","SH":"Saint Helena, Ascension and Tristan da Cunha","SI":"Slovenia","SJ":"Svalbard and Jan Mayen","SK":"Slovakia","SL":"Sierra Leone","SM":"San Marino","SN":"Senegal","SO":"Somalia","SR":"Suriname","SS":"South Sudan","ST":"Sao Tome and Principe","SV":"El Salvador","SX":"Sint Maarten (Dutch part)","SY":"Syrian Arab Republic","SZ":"Swaziland","TC":"Turks and Caicos Islands","TD":"Chad","TF":"French Southern Territories","TG":"Togo","TH":"Thailand","TJ":"Tajikistan","TK":"Tokelau","TL":"Timor-Leste","TM":"Turkmenistan","TN":"Tunisia","TO":"Tonga","TR":"Turkey","TT":"Trinidad and Tobago","TV":"Tuvalu","TW":"Taiwan, Province of China","TZ":"Tanzania, United Republic of","UA":"Ukraine","UG":"Uganda","UM":"United States Minor Outlying Islands","US":"United States","UY":"Uruguay","UZ":"Uzbekistan","VA":"Holy See (Vatican City State)","VC":"Saint Vincent and the Grenadines","VE":"Venezuela, Bolivarian Republic of","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","VN":"Viet Nam","VU":"Vanuatu","WF":"Wallis and Futuna","WS":"Samoa","YE":"Yemen","YT":"Mayotte","ZA":"South Africa","ZM":"Zambia","ZW":"Zimbabwe"},"levels":{"SECONDARY_SCHOOL":"Secondary school","TECHNICAL":"Technical","BACHELOR":"Bachelor","MASTER":"Master","POST_GRADUATE":"Post Graduate","PHD":"PhD","TRAINING_CERTIFICATION":"Training with certification","SELF_WITH_CERTIFICATION":"Self-study with certification","SELF_WITHOUT_CERTIFICATION":"Self-study without certification"},"langs":{"en":"English","de":"Deutsch","es":"Español","nl":"Nederlands","fr":"Français","pt":"Portuguese","ru":"Русский","ja":"日本語"}}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = {"TranslationReviewVersion":{"version":"Versie Taalbundel","version_Number":"02/08/2020"},"login":{"label":"BrainChain heet u welkom!","login_button":"Log in","forgot_password_label":"Paswoord vergeten?","haven_t_account_label":"Nog geen account?","create_it_now_label":"Maak uw account aan!","create_account_alert":"Welk type Account wilt u aanmaken?","applicant_button":"Job Zoeker","company_button":"Organisatie","back_to_login_button":"Terugkeren naar Login","create_an_label":"Creëer een","applicant_account_hint":"Account als u uw diploma's in BrainChain wil beheren om die wereldwijd onmiddellijk erkend te zien.","create_a_label":"Creëer een","company_account_hint":"Account als uw organisatie de diploma's van alle sollicitanten automatisch wil controleren met BrainChain.","more_info_label":"Voor meer informatie, "},"oauth":{"label":"BrainChain heet u welkom!","sign_in_label":"Om verder te gaan, moet u eerst inloggen.","incorrect_request_params_label":"Ongeldige parameters","access_info_label":"{client_name} krijgt toegang tot uw naam, telefoon nummer en Email adres.","logged_in_data_label":"U bent ingelogd als {user_name}, {user_email}.","accept_label":"Verder gaan","reject_label":"Weigeren","use_another_account_label":"Gebruik een andere Account"},"reset_password":{"label":"Reset paswoord","submit_button":"Reset","incorrect_link_alert":"Foutieve link","expired_link_alert":"Deze link is intussen verlopen.","success_message":"Uw paswoord is met succes gewijzigd."},"change_password":{"label":"Email & Paswoord","change_password":"Nieuw paswoord","old_password_label":"Oud paswoord","old_password_input_placeholder":"Oud paswoord","submit_button":"Update paswoord","success_message":"Uw paswoord is met succes gewijzigd.","change_password_alert":"U wordt nu naar de login pagina geleid om in te loggen met uw nieuw paswoord.","change_email":"Nieuw Email","change_email_hint":"Voer het Email adres in waarmee u op vacatures solliciteert.","update_email":"Update Email","change_email_alert":"Een confirmatie link is naar uw nieuw Email adres verstuurd. Kijkt u even na?","finish_change_email":"Uw Email is met success veranderd. U kan die nu gebruiken om in te loggen."},"restore_account":{"label":"Geef hier de Email in van de te herstellen account.","submit_button":"Herstel","success_message":"Uw nieuw paswoord ligt op u te wachten in uw Inbox!","link_to_help_text":"Vergeet zeker uw Account niet te activeren. In geval van problemen verwijzen we u graag door naar ","link_to_help":" help","link_to_help_end":"."},"register_applicant":{"label":"Account registratie job applicant","message":"Vervolledig onderstaande velden om uw account aan te maken","success_message":"De activatie mail is verzonden. Klik aub op de link in die mail om dit proces af te ronden.","submit_button":"Registreer mij","back_button":"Terugkeren naar Login pagina."},"account_management":{"label":"Mijn persoonlijke instellingen","open_account_management_menu_label":"Open menu Persoonlijke Instellingen","close_account_management_menu_label":"Verberg menu Persoonlijke Instellingen"},"org_management":{"label":"Organisatie Account settings"},"aliases":{"label":"Aliassen","expose_phone_label":"Geïnteresseerde werkgevers mogen mijn Telefoonnummer zien.","expose_email_label":"Geïnteresseerde werkgevers mogen mijn Email zien.","default_alias_label":"Default alias","set_as_default_alias_label":"Als default alias instellen","edit_alias_label":"Alias veranderen","delete_alias_label":"Alias verwijderen","add_button":"Alias toevoegen","add_success_message":"Alias met succes aangemaakt!","edit_button":"Alias wijzigen","edit_success_message":"Alias met succes gewijzigd!","remove_title":"Bent u zeker dat u deze alias wil verwijderen?","remove_success_message":"Alias met succes verwijderd!","edit_default_alias":"Persoonlijke gegevens","change_default_alias":"Persoonlijke gegevens aanpassen"},"org_staff":{"staff":{"table_label":"Personeelsleden","register_button":"Verstuur uitnodiging","remove_modal_alert":"Bent u zeker dat u {name} wenst te verwijderen van de personeelsleden?","send_invite_button":"Verstuur uitnodiging","create_success_message":"Personeelslid met succes aangemaakt!","remove_success_message":"Personeelslid met succes verwijderd!","no_data_label":"Er zijn geen personeelsleden."},"accreditation_groups":{"table_label":"Accreditatie groepen","accreditation_group_name_label":"Accreditatie groep naam","create_accreditation_group_button":"Maak accreditatie groep aan","create_accreditation_group_success_message":"Accreditatie groep succesvol aangemaakt!","edit_accreditation_group_success_message":"Accreditatie groep succesvol aangepast!","inserters_label":"Insertors","validators_label":"Validators","employee_input_placeholder":"Kies personeelslid...","role_input_placeholder":"Kies rol...","employee_label":"Personeelslid","employees_label":"personeelsleden","role_label":"Rol","remove_employee_from_group_alert":"Bent u zeker dat u dit personeelslid wenst te verwijderen van de accreditatie groep?","remove_group_alert":"Bent u zeker dat u deze accreditatie groep wenst te verwijderen?","remove_employee_from_group_success_message":"Personeelslid met succes verwijderd van de accreditatie groep!","remove_group_success_message":"Accreditatie groep met succes verwijderd!","add_employee_to_group_success_message":"Personeelslid met succes toegevoegd aan de groep!","no_data_label":"Er werden nog geen #Faculteiten# aangemaakt.","accreditation_groups_definition_label":"Universiteiten gebruiken #Faculteiten# om de verschillende types opleidingen logisch te organiseren.","accreditation_group_no_data_label":"Er zitten geen personeelsleden in deze accreditatie groep.","accreditation_group_examples_label":"Ingenieur Mechanica; Politieke Wetenschappen; Biologie","different_from_departments_label":"Niet hetzelfde als een #Department#","no_inserters_label":"Nog geen Insertor(s) aangeduid","no_validators_label":"Nog geen Validator(s) aangeduid","no_staff_assigned_label":"Faculteiten zonder Insertor kunnen geen Diploma's invoeren, en de Diploma's van Faculteiten zonder Validator blijven hangende tot ook die aangeduid is. Voorzie daarom voor élke Faculteit minimum 1 Insertor en Validator.","digital_key_hint":"Herinnering: Insertors gebruiken een digitale sleutel (een .jwk bestand) op hun computer om de Diploma's die ze invoegen, te encrypteren. Vergeet daarom aub niet die sleutel aan de Insertor door te geven, en de Insertor er aan te herinneren deze eenmalig te importeren voor alle werk begint."},"departments":{"table_label":"Departementen","department_name_label":"Departement naam","department_email_label":"Departement Email","create_department_button":"Creëer Departement","create_department_success_message":"Departement succesvol aangemaakt!","edit_department_success_message":"Departement succesvol aangepast!","hms_label":"Recruitment Managers","bos_label":"Business Owners","employee_input_placeholder":"Kies werknemer...","role_input_placeholder":"Kies Rol...","employee_label":"Werknemer","employees_label":"werknemers","role_label":"Rol","remove_employee_from_department_alert":"Bent u zeker dat u deze werknemer uit dit Departement wil verwijderen?","remove_department_alert":"Bent u zeker dat u dit Departement wilt verwijderen?","remove_employee_from_department_success_message":"Werknemer succesvol verwijderd uit het Departement!","remove_department_success_message":"Departement succesvol verwijderd!","add_employee_to_department_success_message":"Werknemer succesvol aan Departement toegevoegd!","no_data_label":"Er zijn nog geen #Departementen# aangemaakt.","department_no_data_label":"Dit Departement heeft geen werknemers.","departments_definition_label_uni":"#Departementen# zijn een reflectie van hoe een Universiteit zich zoals elk ander bedrijf opdeelt.","departments_definition_label_company":"#Departementen# zijn een reflectie van hoe een Universiteit zich opdeelt in zijn functionele groepen.","departments_examples_label":"Human Resources (HR);IT;Boekhouding","departments_definition_label_part_2":"De opdeling in #Departementen# laat bedrijven toe op een gestructureerde manier bij te houden wie in BrainChain Diploma's verifieert van (potentiële) job kandidaten.","different_from_accreditation_groups_label":"Dit is verschillend van een #Faculteit#"},"change_anchor":{"title":"Verander Anker persoon","modal_alert_message":"U kan de rechten van de huidige Anker persoon doorgeven aan een ander personeelslid.","modal_alert_warning":"(Pas op: Na deze handeling zal u niet meer overal toegang krijgen.)","success_message":"Anker persoon met succes aangepast!","submit_button":"Verander Anker persoon"}},"activation":{"label":"Account activatie","activate_applicant_label":"Kies een paswoord in om uw account te activeren","linked_employee_label":"Kies Email en paswoord voor uw Job Applicant account. Uw werknemers account zal hieraan gelinkt worden.","activate_personal_data_label":"Vul onderstaande data in om uw account te activeren.","activate_password_label":"Tot slot: Kies een paswoord voor uw account","haven_t_applicant_account_label":"U heeft nog geen Applicant account?","create_it_now_label":"Maak er nu een aan!","linked_button":"Verder","birth_date_label":"Geboortedatum","password_label":"Paswoord","enter_password_label":"Nieuw paswoord","confirm_password_label":"Bevestig paswoord","enter_password_input_placeholder":"Nieuw paswoord","confirm_password_input_placeholder":"Bevestig nieuw paswoord","activate_button":"Activeer account","enter_password_error_alert":"Het paswoord moet minstens 6 en maximaal 32 karakters bevatten!","confirm_password_error_alert":"1 paswoord volstaat - geef aub 2 keer hetzelfde in! :-) ","activation_link_expired_alert":"De activatie link is intussen niet meer geldig.","activation_link_irrelevant_message":"Het registratie proces was reeds voltooid! U hoeft niets mee te doen. ","activation_link_irrelevant_forgot_password_message_start":"Hier klikken als u uw paswoord bent vergeten.","activation_link_irrelevant_forgot_password_message_link":" hier","activation_link_irrelevant_forgot_password_message_end":"  om het te resetten.","activation_link_irrelevant_log_in_message_start":"Indien dit een vergissing was en u zich uw paswoord nog herinnert, kan u om in te loggen klikken op deze ","activation_link_irrelevant_log_in_message_link":"link","activation_link_irrelevant_log_in_message_end":".","incorrect_activation_link_alert":"Foutieve activatie link","activation_success_message":"Activatie geslaagd!","back_button":"Keer terug naar werknemer account Activatie."},"resend_activation":{"success_message":"Activatie is met succes opnieuw verzonden!","employee_label":"Activatie Email opnieuw sturen naar {email}?","anchor_label":"Activatie Email opnieuw sturen naar {email}?","title":"Stuur een nieuwe activatie Email","submit_button":"Stuur opnieuw","label":"Naar welk Emailadres mag de activatie Email opnieuw verzonden worden? "},"orgs":{"label":"Organizaties","anchor_label":"Anker persoon","location_label":"Locatie","org_label":"Organizatie","org_type_label":"Organizatie type","add_org":"Voeg Organizatie toe","name_label":"Naam","has_accreditation_groups_label":"Heeft Accreditatie groepen","verifies_identities_label":"Verifieert identiteiten","provides_mooc_certificates_label":"Verstrekt MOOC Certificaten","street_label":"Straat & Nr","postal_label":"Postcode","city_label":"Stad","company_code_label":"Ondernemingsnummer","vat_number_label":"BTW Nummer","address_label":"Adres","permissions_label":"Rechten","unknown_label":"Niet gekend","no_data_label":"Er zijn geen organizaties.","no_data_to_validate_label":"Geen Organizaties (meer) te valideren.","validate_organizations_label":"Valideer Organizaties","validate_organization_label":"Valideer Organizatie","validate_organization_button":"Valideer","validate_organization_alert":"Bent u zeker dat u deze Organizatie wil valideren?","back_button":"Keer terug naar de lijst van (nog) niet gevalideerde Organizaties.","next_org_button":"Volgende Organizatie","validate_org_success_message":"Organizatie succesvol gevalideerd!","financial_data_label":"Financiële data","financial_data_placeholder":"Bank Naam, Bank Account Nº, …","inspect_organization_button":"Inspecteer","validate_org_progress_label":"Gevalideerd","orgs_payments_list_label":"Financiële data van Organizaties","general_data_validated":"Basis data - gevalideerd","financial_data_validated":"Financiële data - gevalideerd","already_validated":"Partieel gevalideerde data. Klaar voor volledige validatie door co-assistent.","remove_org_alert":"Bent u zeker deze organizatie te willen verwijderen?","remove_org_success_message":"Organizatie met succes verwijderd!"},"register_org":{"register_org_label":"Registreer Organizatie en Anker persoon","invite_next_button":"Volgende uitnodiging","send_invitation_button":"Stuur uitnodiging","success_message":"Organizatie en Anker succesvol geregistreerd!","org_type_placeholder":"Kies org type...","register_button":"Registreren","company_registration_label":"Registreer Organizatie en Anker","proceed_button":"Ga verder","register_org_by_anchor_alert":"Vergeet aub niet -gelijk welk- bedrag door te storten vanuit de opgegeven Bank Account. Dit wordt immers door BrainChain gebruikt om de Account registratie te valideren.","register_org_by_anchor_hint":"Na Account activatie kan u gelijk wanneer terugkeren om alle financiële settings te beheren. Dit als onderdeel van de Organizatie Account settings.","domain_hint":"Het internet domein van een organizatie is het eerste deel in het webadres van die organizatie, bvb . apple.com or ibm.de Indien u in een keer ook al de subdomeinen wil registreren, kan u een asterisk gebruiken i.p.v. een land-code, bvb apple.* of ibm.*","back_button":"Terugkeren naar Login .","company_code_hint":"Er zijn landen waar bedrijven in de eerste plaats worden geïdentificeerd a.d.h.v. een unieke registratie code, naast -of in afwezigheid van- een BTW Nr.","financial_data_hint_part_1":"Voorzie aub genoeg informatie zodat wij van onze kant kunnen bevestigen dat de overschrijving inderdaad van uw Organizatie komt.","financial_data_hint_part_2":"Zoals: uw bank naam, uw klantnummer bij de bank, uw bankrekening nummer, ...","financial_data_hint_part_3":"Deze gegevens helpen ons echte bedrijven zoals het uwe te onderscheiden van nepbedrijven en internet robots. Daarnaast laat dit ons toe ons te voldoen aan de ons opgelegde anti-wiswas rapportering."},"edit_org":{"org_edit_success_message":"Organizatie succesvol aangepast!","anchor_edit_success_message":"Anker succesvol aangepast!","back_button":"Terug naar lijst van Organizaties.","edit_anchor_button":"Verander Anker","edit_anchor_alert":"Pas aub eerst de Anker Email aan - vòòr andere aanpassingen.","bava_label":"BAVA","bava_organization_label":"BAVA organizatie","bava_set_success_message":"Organisatie gemarkeerd als BAVA!","bava_removed_success_message":"BAVA-vlag met succes verwijderd!"},"request_credentials_verification":{"label":"Verzoek om diploma's te verifiëren","success_alert":"Verzoek succesvol","applicant_data_label":"Job Applicant gegevens","choose_way_label":"Via welke weg wil je een kandidaat vinden?","your_data_label":"Jouw gegevens","hide_your_name_label":"Mijn naam niet tonen aan de Job Applicant","company_data_label":"Organizatie gegevens","reason_for_request_label":"Reden voor het verzoek","reason_for_request_placeholder":"Voeg een begeleidende boodschap toe...","get_email_label":"Stuur mij een Email als de Job Applicant op het verzoek reageert.","submit_button":"Behandel request","way_label":"Manier","company_name_label":"Organizatie Naam","modal_title_label":"Betreffende","investigate_applicant_label":"De kandidaat in kwestie zit nog niet in BrainChain. Had u graag gehad dat wij zijn/haar universiteit vragen hem/haar toe te voegen?","ask_colleague_label":"Een van uw collega's ({firstName} {lastName}) heeft een geldig verzoek voor deze kandidaat. Loopt u daar graag even langs, of maakt u liever uw eigen verzoek aan?","request_button":"Zelf aanmaken","ask_colleague_button":"Ik ga mijn collega zoeken","manager_label":"Manager","visible_data_message":"De kandidaat zal deze gegevens zien: ","upload_file_label":"Bestand toevoegen","emails_label":"Emails","manual_input_label":"Manuele Input","manual_input_hint":"Geef de Emails van kandidaten in, gescheiden door: een komma, een puntkomma, een return of een spatie.","reference_to_bulk_list_start":"Een verzoek kan gaan om 1 enkele Email of meerdere Emails tegelijk.  \nDeze Emails kunnen manueel worden ingegeven in het veld hieronder, of doorgegeven worden via een bestand. Voor het correcte formaat in dat bestand: cf. het \"?\" icoon onderaan. \nIndien u voor een gebundeld verzoek gaat, kan u de voortgangsstatus checken bij  ","reference_to_bulk_list_link":"Gebundelde verzoeken tot inzage","reference_to_bulk_list_end":".","stay_on_this_page_label":"Blijf op deze pagina","go_to_home_page_label":"Ga naar de start pagina","success_modal_label":"Uw verzoek is rond - wil u hier blijven of teruggaan naar de start pagina?","request_unavailable_alert":"Diploma verificatie is momenteel niet mogelijk - gelieve de Anker persoon van uw Organizatie te contacteren om dit op te lossen."},"main":{"home_page_label":"Start pagina","edu_org_staff_page_button":"Beheer Personeel","current_sub_role_label":"Rol","current_group_label":"Groep","log_out_button":"Uitloggen","orgs_page_button":"Gevalideerde Organizaties","insert_accreditation_page_button":"Invoegen nieuwe Diploma(-s)","validate_accreditations_page_button":"Diploma Valideren","review_accreditations_page_button":"Nakijken gefaalde Diplomas","accreditation_groups_page_button":"Diploma groepen","departments_page_button":"Departementen","staff_members_page_button":"Personeel","limit_access_label":"Uw organizatie heeft beperkte toegang tot bepaalde funktionaliteit. Indien dit onverwacht is, gelieve u te wenden tot de Anker persoon.","non_validated_org_access_label":"U heeft (nog) geen toegang tot deze funktionaliteit omdat uw organizatie nog niet gevalideerd is.","payment_label":"Betaling","help_label":"Help","bulk_jobs_list_page_button":"Bulk upload Diplomas","validate_organizations_page_button":"Valideer Organizatie","certified_accreditations_page_button":"Gecertifieerd Diploma","pending_accreditations_page_button":"Hangende Diplomas","vids_page_button":"Geverifieerde Identiteiten","org_management_button":"Organizatie Account settings","verification_request_page_button":"Verzoek inzage","pending_consents_page_button":"Hangende verzoeken","active_consents_page_button":"Goedgekeurde verzoeken","consent_requests_page_button":"Aangevraagde verzoeken","prior_consents_page_button":"A priori goedgekeurd","applicant_accreditations_select_button":"Diploma's","applicant_consents_select_button":"Goedkeuringen","consents_history_page_button":"Geschiedenis van goedkeuringen","self_study_books_page_button":"Boeken (Zelfstudie)","bulk_consent_requests_page_button":"Gebundelde verzoeken tot inzage","inserter_accreditations_select_button":"Diploma's","insert_accreditation_shirt_page_button":"Toevoegen","review_accreditations_shirt_page_button":"Nakijken","bulk_jobs_list_shirt_page_button":"Gebundelde upload","organizations_select_button":"Organizaties","orgs_shirt_page_button":"Gevalideerde","validate_organizations_shirt_page_button":"Hangende","accreditation_requests_list_page_button":"Diploma inzage verzoeken","validated_accreditation_requests_list_page_button":"Gevalideerde Edu domeinen","pending_accreditation_requests_list_page_button":"Hangende Edu Domeinen","pending_accreditation_requests_page_button":"Hangende Diploma verificatie verzoeken","organization_select_button":"Organizatie","accreditation_groups_management_page_button":"Beheer van Diploma groepen","groups_management_page_button":"Departementen & Faculteiten","validated_accreditation_requests_by_domain_shirt_page_button":"Gevalideerd","pending_accreditation_requests_by_domain_shirt_page_button":"Hangende","security_page_button":"Security","register_org_shirt_page_button":"Registeer nieuwe","payments_page_button":"Betalingen","orgs_payments_page_button":"Financiële data van organisaties","assistants_page_button":"Assistenten","business_ambassadors_page_button":"Business Ambassadors","commissions_list_page_button":"Commissies","system_payment_select_button":"Betaling","due_payments_page_button":"Te betalen","payments_history_shirt_page_button":"Geschiedenis","payments_history_page_button":"Historiek Betalingen","validated_domains_page_button":"Gevalideerde domeinen","domains_page_button":"Domeinen van Universiteiten"},"roles":{"admin_label":"SysAdmin","employee_label":"Werknemer","applicant_label":"Job Applicant","anchor_label":"Anker","inserter_label":"Insertor","validator_label":"Validator","hm_label":"Hiring Manager","bo_label":"Business Owner"},"home":{"welcome_label":"BrainChain heet u welkom!","account_and_support_label":"Account settings en support","admin_pages_label":"Admin pagina's","choose_role_label":"Kies uw functie voor deze sessie","anchor_pages_label":"Anker Pagina's","inserter_pages_label":"Insertor Pagina's","validator_pages_label":"Validator Pagina's","hm_pages_label":"Recruitment Manager Pagina's","bo_pages_label":"Business Owner Pagina's","applicant_pages_label":"Job Applicant Pagina's","account_page_about":"Beheer persoonlijke instellingen","support_page_about":"Vind uw antwoord of mail ons","register_org_page_about":"Maak nieuwe Organizatie aan","organizations_page_about":"Beheer organisatie-instellingen","validate_organizations_page_about":"Valideer nieuwe organizaties","payment_page_about":"Financieel Beheer & Prijszetting","organization_staff_page_about":"Personeelsbeheer van de organizatie","accreditation_groups_page_about":"Beheer van de Diploma groepen in uw organizatie","departments_page_about":"Beheer van de Departementen in uw Organizatie","review_accreditations_page_about":"Interacties met Validator(s) & Job Applicant(en)","bulk_accreditations_upload_page_about":"Diploma's via een file toevoegen","validate_accreditations_page_about":"Interacties met Insertor(s) & Job Applicant(en)","credentials_verification_request_page_about":"Maak nieuw inzage verzoek aan voor de Job Applicant","consent_requests_page_about":"Beheer inzage verzoeken van uw Organizatie","certified_accreditations_page_about":"Beheer van uw gecertifieerde diploma's","pending_accreditations_page_about":"Beheer inkomende diploma's","verified_identities_page_about":"Beheer van geverifieerde identiteiten","pending_consents_page_about":"Bedrijven die jou in overweging nemen - jij beslist","active_consents_page_about":"Alle bedrijven die jouw Diploma mogen bewonderen","prior_consents_page_about":"Bedrijven waar jij voor wil werken","consents_history_page_about":"Volledige Historiek van aanvaarde en geweigerde Diploma inzage verzoeken","self_study_books_page_about":"Beheer van uw zelfstudie boeken","bulk_consent_requests_page_about":"Beheer van gebundelde verzoeken tot inzage voor uw Organizatie","accreditation_requests_list_anchor_page_about":"Link losstaand Job Applicant Diploma verificatie verzoek met bestaande Faculteiten","validated_accreditation_requests_list_admin_page_about":"Gevalideerde domeinen (in eigen beheer en door BAVA beheerd)","pending_accreditation_requests_list_admin_page_about":"Toegang tot nieuwe domeinverificatie verzoeken (sollicitant)","accreditation_requests_list_admin_page_about":"Beheer van Diploma verzoeken die nog niet aan een Organizatie gelinkt zijn","accreditation_requests_list_applicant_page_about":"Beheer van Diploma verzoeken","security_page_anchor_about":"Diploma's digitaal ondertekenen","security_page_inserter_about":"Installeer digitale sleutel","security_page_admin_about":"Toevoegen root certificaat (universiteit)","orgs_payments_page_about":"Account, tarieven en krediet","assistants_page_about":"Beheer Assistenten","business_ambassadors_page_about":"Beheer Business Ambassadors","commissions_list_page_about":"Beheer Commissies","due_payments_page_about":"Beheer Open Betalingen","payments_history_page_about":"Beheer Betalingshistoriek en Organizatie krediet","default_departments_hint":"Bij kleine bedrijven kan het BrainChain Anker zélf Diploma verificatie verzoeken aanvragen; grotere bedrijven worden aangeraden een \"HR Departement\" (het label kan u kiezen) aan te maken, en daar een aantal recruiters aan te koppelen. Grotere bedrijven hebben voor aannames immers aparte profielen - en zo moet de BrainChain contactpersoon zich daar niet mee bezig houden (= het BrainChain Anker).","not_validated_yet":"Uw bedrijf is nog niet volledig door BrainChain gevalideerd - tot dit rond is, is niet alle funktionaliteit beschikbaar."},"payment":{"title":"Betalingsinformatie","total_money_label":"Totaal bedrag dat {orgName} reeds van BrainChain gekregen heeft: ","list_label":"Om de jaarlijkse licentie over te schrijven:","account_id_label":"naar de volgende IBAN rekening: {iban}","bank_details_label":"Bank- en project details","about_us_label":"Indien uw bank meer informatie nodig heeft over onze bankinstelling of BrainChain:","bank_data_label":"Onze Bankgegevens:","project_label":"BrainChain Project:","org_label":"Organizatie: WickedWare","org_address":"Adres: Virsuliskiu g. 17-9, 05108 Vilnius, Litouwen","create_account_label":"met de volgende betalingsmededeling (als dit de 1e keer is dat u betaalt): ","create_account_message_label":"{orgName} - Creëer Account","annual_fee_label":"met de volgende betalingsmededeling: ","annual_fee_message_label":"{orgName} - Jaarlijkse licentie","edu_org_message_label":"Wat dit opbrengt voor uw educatieve organizatie","edu_org_message_company_checks":"Telkens iemand het diploma van een van uw alumni wil nakijken, wordt hen een zeer kleine fee aangerekend. Van dat geld storten wij op het einde van het jaar 20% door naar jullie (universiteiten), en wordt de rest aangewend om de BrainChain missie in gezonde operationele modus te houden. ","edu_org_message_list_title":"Op deze manier bouwen we gezond non-profit ecosysteem waar de universiteiten beter van worden: ","edu_org_message_list_item_one":"In plaats van dat jullie zelf diplomas van jullie alumni telkens opnieuw moeten valideren wanneer iemand van werk verandert, wordt jullie gevraagd dat slechts 1 keer te doen in BrainChain… die dat van dan af overneemt gedurende gans hun loopbaan! ","edu_org_message_list_item_two":"Na die eenmalige ingaven, vloeit er telkens 20% van de fee die bedrijven wordt aangerekend terug naar jullie. Dit gebeurt typisch als iemand van job verandert of ergens solliciteert.","edu_org_message_joining":"Dit is de ideale wereld; onderwijs verdient geld met minder te werken!","edu_org_message_note_title":"Noteer:","edu_org_message_note":"In de meeste gevallen zal dat opgebouwd krediet vele malen hoger zijn dan de jaarlijkse licentie. In dat geval wordt die automatisch verrekend en krijgt U daar telkens een bevestigingsmail van. ","wire_label":"Voor de jaarlijkse licentie, gelieve  over te schrijven ","annual_license_cost_label":"Jaarlijkse licentie kost","wire_delay_label":"Noteer dat internationale betalingen enkele dagen kunnen duren. ","bank_data_by_location":{"LT":{"iban_number":"LT643500010003938827","bank_data":"Naam: 'Paysera LT', UAB \nBank adres: Menulio g. 7, Vilnius, LT-04326, Litouwen"},"BE":{"iban_number":"BE13736065627739 (BIC: KREDBEBB)","bank_data":"Naam: Alverman BV \nAdres: Beekstraat 5, 2300 Turnhout, Belgium \nAlverman BTW Nr: \"BE0736567322\""}}},"finance":{"label":"Financiën","balance_label":"Balans","balance_currency_label":"Balans munteenheid","balance_change_comment_placeholder":"Laat uw bericht hier achter...","change_label":"Aanpassen","change_balance_label":"Balans aanpassen","increase_label":"Verhogen","decrease_label":"Verlagen","change_balance_submit_button":"Aanpassingen aanvaarden","preset_price_label":"Prijs vooraf instellen","paid_till_date_label":"Betaald tot","annual_fee_label":"Jaarlijkse fee","request_cost_label":"Diploma vetting kost","pay_annual_fee_button":"Betaal 1 jaar","pay_annual_fee_success_message":"Betaal de jaarlijkse fee met succes!","change_finance_success_message":"Organizatie financiën met succes aangepast!","org_finance_label":"Prijs voor de Organizatie","accept_price_and_send_invitation":"Aanvaard prijs en stuur uitnodiging","accept_price_and_validate":"Aanvaard prijs en valideer","prices_label":"Prijszetting","change_balance_modal_label":"Krediet toevoegen geeft weer dat het bedrijf zijn jaarlijkse licentie betaald heeft (Dit werd dan vooraf offline geverifieerd door de SA/FA). Krediet afnemen geeft weer dat geld offline terug is overgeschreven NAAR het bedrijf (tevens uitgevoerd door de SA/FA). Wanneer de jaarlijkse licentie betaald moet worden, wordt dit automatisch afgetrokken van het openstaand krediet op de dag zelf.","set_default_label":"Terugzetten naar standaard waarde","default_annual_fee_label":"Standaardprijs voor jaarlijkse licentie","default_consent_request_fee_label":"Standaardprijs voor een inzage verzoek","deviation_period_label":"Duur Afwijking","forever_label":"Voor altijd","default_preset_label":"Standaardprijzen: jaarlijkse licentie - {annual_fee_amount}, inzage verzoek - {consent_request_fee_amount}","agreed_deviation_label":"Overeengekomen Afwijking: jaarlijkse licentie - {annual_fee_amount}, inzage verzoek - {consent_request_fee_amount}","till_label":"tot","period_label":"Periode","pay_annual_license_alert":"Gelieve de jaarlijkse licentie te betalen om diploma verificaties te kunnen blijven aanvragen.","top_up_balance_alert":"Gelieve uw krediet balans aan te zuiveren om diploma verificaties te kunnen blijven aanvragen.","contact_anchor_alert":"Niet alle funktionaliteit is thans beschikbaar - gelieve uw Organizatie Anker te contacteren om dit probleem op te lossen. ","add_year_label":"Jaar toevoegen","paid_till_alert":"Organisaties zonder een 'Betaald tot' datum in de #toekomst# krijgen geen geld voor het verifiëren van diploma's."},"help":{"label":"Als u ergens tegen aan loopt, of vragen heeft, kan u ons op dit adres aanschrijven: {email}.","email":"BenevolentEars@brainchainmission.org","questions_and_answers_label":"Q & A","question_activation_email":"Ik kreeg geen activatie Email","answer_activation_email_start":"Indien u nog geen activatie Email kreeg, kan u hier een nieuwe vragen ","answer_activation_email_link":" hier","answer_activation_email_end":"."},"page_not_found":{"page_not_found_label":"Deze Pagina heeft zijn pensioenleeftijd bereikt...","sorry_label":"Onze excuzes - deze pagina vinden zelfs wij niet terug!","cause_label":"Ofwel heeft u hier geen toegang, ofwel bestaat deze pagina niet meer."},"server_error":{"server_error_label":"Interne Server Fout","sorry_label":"Oooops - server blijkt uit de bocht gevlogen :-/ ","cause_label":"Probeert u opnieuw later."},"sub_role_missing":{"no_access_label":"Het lijkt er op dat u in deze functie hier geen toegang meer toe heeft.","continue_label":"Om verder te gaan, wordt u naar de Home Pagina geleid."},"org_permissions_missing":{"no_access_label":"Het lijkt er op dat uw Organizatie hier geen toegang meer toe heeft.","continue_label":"Om verder te gaan, wordt u naar de Home Pagina geleid."},"accreditation_list":{"label":"Diploma's","title_label":"Titel","date_issued_label":"Aflever Datum","level_label":"Niveau","applicant_name_label":"Job Applicant Naam","location_label":"Locatie","no_data_to_validate_message":"Geen Diploma's te valideren.","no_data_to_review_message":"Geen Diploma's na te kijken.","show_accreditations_by_label":"Toon Diploma's geweigerd door","validators_label":"Validators","applicants_label":"Sollicitanten","edit_label":"Wijzig Diploma","remove_label":"Verwijder Diploma","no_data_to_review_hint":"Er zijn nog andere faculteiten die u kan nakijken"},"bulk_jobs_list":{"label":"Gebundelde Upload van Diploma's","no_data_message":"Er zijn nog geen gebundelde Accreditaties geuploadet.","created_at_label":"Opgemaakt te ","processed_label":"Verwerkt","finished_label":"Gedaan!","file_name_label":"Bestandsnaam","status_label":"Status","in_progress_label":"Bezig...","remove_bulk_success_message":"Bulk succesvol verwijderd!","remove_bulk_alert":"Bent u zeker dat u deze file uit de list wilt verwijderen?","remove_bulk_button":"Dit bestand niet meer tonen","entries_number_label":"Aantal ingaven","error_label":"Error","global_error_label":"Global error","requestor_label":"Requestor","bulk_consent_requests_label":"Gebundelde inzage aanvragen","no_bulk_consents_data_label":"Nog geen gebundelde aanvragen geuploadet","created_requests_label":"Aanvragen aangemaakt","file_reading_process_label":"Bestand wordt ingelezen...","signing_process_label":"Hard aan het werk met de Diploma's elektronisch te signeren ...","dont_close_tab_label":"Afhankelijk van de bestandsgrootte kan dit proces even duren. Gelieve tot dit klaar is even geduld te hebben.","insufficient_balance_error_alert_part_1":"Slechts {processed} van de {total} diploma verificatie verzoeken konden worden aangevraagd omdat er onvoldoende krediet open staat.","insufficient_balance_error_alert_part_2":"Gelieve minstens {amount} aan te zuiveren om ook de rest aan te vragen.","flush_remaining_label":"Flush de rest"},"accreditation":{"accreditation_group_input_placeholder":"Kies Accreditatie groep...","accreditation_title_orig_label":"Oorspronkelijke Titel","accreditation_title_orig_input_placeholder":"Oorspronkelijke Titel","accreditation_title_en_label":"Engelse vertaling Titel ","accreditation_title_en_input_placeholder":"Engelse vertaling Titel","additional_translations_label":"Bijkomende vertalingen","add_additional_translations_label":"Voeg vertaling voor titel toe","date_issued_label":"Aflever datum","level_label":"Niveau","level_input_placeholder":"Kies niveau...","person_label":"Persoon","language_input_placeholder":"Taal","translation_input_placeholder":"Vertaling","title_label":"Titel","accreditation_label":"Accreditatie","popover":{"message_placeholder":"Laat uw bericht hier achter...","old_value_label":"Oude inhoud","proposed_value_label":"Nieuw voorstel","message_label":"Boodschap","proposed_value_input_placeholder":"Wat had u in gedachten?","discard_changes_label":"Negeer aanpassingen","edit_field_label":"Pas veld aan"},"remove_accreditation_success_message":"Accreditatie succesvol verwijderd!","remove_accreditation_alert":"Wenst u deze accreditatie zeker te verwijderen?","next_accreditation_button":"Volgende Accreditatie","back_button":"Terugkeren naar Accreditatie lijst","show_details_label":"Toon veld details"},"insert_accreditation":{"label":"Voeg Accreditatie toe","success_message":"Accreditatie succesvol toegevoegd!","submit_button":"Klaar voor validatie!","no_certificate_message_start":"U heeft de digitale sleutel van de Universiteit nog niet geïnstalleerd. Gelieve dit eerst in de '","no_certificate_message_link":"sectie Security","no_certificate_message_end":"' in orde te brengen."},"certificate":{"label":"Certificaat","add_button":"Toevoegen Certificaat","about_label":"Om een Certificaat toe te voegen, importeert u het bestand met extensie '.crt'.","no_data_label":"Er zijn geen Certificaten","created_at_label":"Aangemaakt op","valid_from_label":"Geldig van","valid_till_label":"Geldig tot","remove_button":"Certificaat verwijderen","are_you_sure_label":"Bent u zeker dat u dit Certificaat wilt verwijderen?","remove_warning_label":"Belangrijke waarschuwing: indien u dit Certificaat verwijdert, zullen ALLE Diploma's die u hier mee ondertekend heeft, onmiddellijk hun geldigheid verliezen!","insert_certificate_label":"Certificaat om het Diploma mee te ondertekenen","insert_certificate_about_label":"Om Diploma's toe te kunnen voegen, moet u eerst een 'Certificaat sleutel' met extensie '.jwk' importeren. Gelieve uw Anker te contacteren indien u dit bestand nog niet heeft.","change_certificate_button":"Voeg uw nieuwe privé digitale sleutel toe.","add_certificate_key_button":"Voegvoegen Certificaat sleutel","insert_key_button":"Toevoegen sleutel","key_already_installed_button":"Privé digitale sleutel reeds geïnstalleerd.","no_root_certificate_label":"U heeft nog geen root certificaat geïnstalleerd.","root_certificate_hint":"Het BrainChain root certificaat ('ca.crt') wordt door de BrainChain System Admin offline gegenereerd en vervolgens hier geïmporteerd. Dit garandeert dat wanneer een Insertor deze sleutel (= een uni.jwk bestand) in zijn browser importeert, deze 2 sleutels elkaar begrijpen. Zonder een geïmporteerd root certificaat gaat dit fouten blijven geven.","no_certificates_needed_label":"Geen certificaat nodig - deze organizatie verzegelt geen Diploma's. ","no_org_certificate_label_start":"De Universiteitssleutel (uni.crt) werd nog niet geïnstalleerd - gelieve dit in de '","no_org_certificate_label_link":" Security sectie","no_org_certificate_label_end":"' te doen nadat de Universiteit gevalideerd werd."},"validate_accreditation":{"label":"Valideer Diploma","success_message":"Diploma succesvol gevalideerd!","submit_button_validate":"Valideer Diploma","common_message_label":"Nota voor de Reviewer:","common_message_placeholder":"Laat hier uw boodschap na...","submit_button_invalidate":"Klaar om na te kijken!","or_label":"OFWEL","validate_accreditation_message":"Wilt u de aanpassingen negeren en dit Diploma aanvaarden?","submit_button_invalidate_title":"Gelieve foute velden te markeren en/of een bericht voor de Reviewer na te laten."},"review_accreditation":{"label":"Nakijken teruggestuurd Diploma","success_message":"Diploma met succes opnieuw toegevoegd!","submit_button":"Terug klaar voor Validatie!","message_label":"Nota van de Validator","feedback_from_validator_label":"Feedback van de Validator","feedback_from_applicant_label":"Feedback van de Job Applicant","review_accreditation_progress_label":" Behandeld","reinsert_accreditation_button_hint":"Voer deze accreditatie alleen opnieuw in met wijzigingen die de $consensus$ weerspiegelen die u met de validator $offline$ hebt bereikt. Als een dergelijke consensus niet mogelijk is, kunt u 'Verwijderen' kiezen - de Accreditatie wordt dan weergegeven als 'Geweigerd' in de interface van de aanvrager."},"bulk_upload":{"drag_and_drop_label":"Sleep en drop uw bestand hier","or_label":"Ofwel","browse_label":"#Hier klikken# om naar uw bestand te wijzen","error_label":"Whoops! Dit bestand is fout geformatteerd.","uploaded_file_label":"Ge-upload bestand","max_file_size_message":"Maximale bestandsgrootte","exceeded_upload_size_alert":"Dit bestand is helaas te groot om door de draad te sleuren...","file_format_info_label":"Bestandsformaat info","file_format_details_label":"Bestandsformaat details","consent_request_bulk_error_label":"Selecteer bestand om verder te gaan","consent_request_bulk_empty_file_label":"Het bestand is leeg"},"bulk_file_format_details":{"use_csv_message":"Gebruik aub het aangegeven CSV bestandsformaat.","file_header_message":"De file moet de volgende header hebben: ","additional_titles_label":"bijkomende vertalingen taalcodes","language_code_label":"taalcode","provide_data_message":"Dit betekent dat u het volgende moet voorzien:","applicant_data_message":"Job Applicant data: Email, voornaam, achternaam, land code, National ID Nº - bvb. RRN(BE) of BSN (NL)","accreditation_data_message":"Diploma gegevens: Accreditatie datum, level, originele titel, titel in het Engels, en (optioneel) vertaalde titels.","file_entries_message":"Elke lijn hierna moet het Diplomaformaat van de header volgen.","liaise_it_staff":"Consulteer uw IT collega om een correcte formattering te verzekeren.","back_button":"Terug naar bulk-upload Accreditaties","csv_file_example_label":"Voorbeeld van een correct geformatteerde CSV-file","download_example_button":"Download Voorbeeld","values_details_label":"Detail van de waarden","email_details":"Voor historische(= ouder dan 2 maand) Accreditaties, is Email optioneel.","date_issued_details":"Datum van uitreiking kan niet in de toekomst liggen.","levels_label":"Accreditatie levels","titles_label":"Bijkomende Accreditatie titels","header_name_label":"Header naam","required_label":"Vereist","format_label":"Formaat","mean_label":"Waarde","code_label":"Code","email_mean_label":"Applicant email","first_name_mean_label":"Applicant voornaam","last_name_mean_label":"Applicant achternaam","country_code_mean_label":"Applicant landcode","national_id_mean_label":"Applicant Nationaal ID Nº vb RRN(BE) of BSN(NL)","date_issued_mean_label":"Uitreikingsdatum Diploma (**)","level_mean_label":"Accreditatie level","original_mean_label":"Originele Accreditatie titel","en_mean_label":"Originele Accreditatie titel","lang_code_mean_label":"Bijkomende Accreditatie titels (Cf. tabel met bijkomende titels)","email_format":"applicant@email.com","string_format":"tekst","country_code_format":"ISO 3166-1 alpha-2 code","date_format":"YYYY-MM-DD","level_format":"Level code (cf. tabel met Accreditatie levels)","optional-fields-highlighted-label":"Optionele velden zijn gemarkeerd met ","gray_label":"grijs","use_xml_message":"Gelieve het xml bestandsformaat te respecteren.","csv_file_format_label":"CSV bestandsformaat","xml_file_format_label":"XML bestandsformaat","then_provide_message":"Wat u moet voorzien: ","tag_name_label":"Label Naam","attributes_label":"Attributen","accreditations_meaning_label":"Container voor de Diploma's","accreditation_meaning_label":"Container voor de Diploma details","titles_meaning_label":"Container voor de vertalingen van de Diploma titel","title_meaning_label":"Titel vertaling. Het attribuut is een code voor de gebruikte -originele of bijkomende- taal (zie tabel).","title_details":"De originele titel is een verplicht veld.","xml_file_example_label":"Voorbeeldbestand in XML formaat.","consent_bulk_file_info_label":"Hou je aub aan het TXT of CSV formaat. Het bestand moet de Job Applicant Emails bevatten, van elkaar gescheiden door komma's, puntkomma's, returns of spaties."},"applicant_accreditations_management":{"certified_accreditations_label":"Gevalideerde Diploma's","issued_by_label":"Uitgereikt door","expose_certified_accreditations":"Toon","no_data_label_part_1":"Er zijn geen $Geverifieerde Diploma's$. $Geverifieerde Diploma's$ zijn Diploma's die door uw Universiteit geconfirmeerd werden. Indien de uwe hier niet vermeld staan, kan u dit aanvragen onder 'Diploma Verificatie Verzoeken'.","no_data_label_part_2":"Wij bundelen zulke verzoeken met die van andere Alumni tot uw Alma Mater ook lid van BrainChain wordt. Via onze ","no_data_label_part_3":"website","no_data_label_part_4":" kan u uw universiteit aanmanen ook deel van BrainChain te worden!","accreditation_details_label":"Diploma details","remove_accreditation_alert":"Weet u zeker dat u dit diploma wilt verwijderen?","remove_accreditation_success_massage":"Diploma succesvol verwijderd!","pending_accreditations_label":"Hangende Diploma's","accept_accreditation_button_label":"Aanvaard Diploma","send_back_accreditation_button_label":"Stuur terug om na te kijken","discard_accreditation_message":"Bent u zeker dat u dit Diploma wil negeren?","discard_accreditation_warning_message":"Opgepast, bij weigering zal dit Diploma volledig verwijderd worden!","discard_accreditation_button_label":"Negeer Diploma","vids_label":"Gecontroleerde Identiteiten","expose_fn_ln_country":"Toon naam en land","expose_national_id":"Toon nationaal identificatie Nº (RRN of BSN)","expose_nid_option_full":"Mijn volledige identificatie mag getoond worden","expose_nid_option_short":"Enkel de laatste 4 cijfers van mijn identificatie mogen getoond worden. ","expose_nid_option_not_expose":"Mijn nationale identificatie mag nooit getoond worden.","no_vids_label":"Er zijn geen $Geverifieerde Identiteiten$. $Geverifieerde Identiteiten$ zijn identiteiten die door uw universiteit samen met uw Diploma's bevestigd worden.","active_vid_label":"Actueel","active_vid_title_checked":"Actieve geverifieerde identiteit","active_vid_title_unchecked":"Activeer Geverifieerde Identiteit (VID)","show_details_label":"Toon Diploma details","no_pending_accreditations_label":"Er zijn geen $hangende Diploma's$. Nadat je je universiteit hebt gevraagd om je diploma te bevestigen en zij dat ook gedaan hebben, worden die Diploma (-s) hier opgelijst, maar met een status die deze (tijdelijke!) eenzijdige validatie aangeeft. Potentiële werkgevers kunnen ze dan al zien, maar ze zullen als zodanig aangegeven worden totdat ze van beide kanten (ook de uwe!) bevestigd werden."},"license_agreement":{"agree_label":"Ik aanvaard de termen in","agree_link":"de licentie overeenkomst."},"consents":{"status":{"ALL":"Alles","PENDING":"Hangend","GRANTED":"Goedgekeurd","REJECTED":"Geweigerd","REVOKED":"Teruggeroepen","EXPIRED":"Vervallen","CANCELED":"Gecanceld","ABANDONED":"Opgegeven"},"status_title":{"PENDING":"Hangend Verzoek","GRANTED":"Goedgekeurd Verzoek","REJECTED":"Geweigerd Verzoek","REVOKED":"Teruggeroepen Verzoek","EXPIRED":"Vervallen Verzoek","CANCELED":"Gecanceld Verzoek","ABANDONED":"Opgegeven Verzoek"},"no_data_label":"Er zijn geen inzage verzoeken","show_consents_list_label":"Open lijst met inzage verzoeken","hide_consents_list_label":"Terugkeren naar details van inzage verzoek","no_selected_consent_request_label":"Kies een inzage verzoek uit de lijst voor meer details","edit_label":"Wijzig inzage verzoek","cancel_request_success_message":"Verzoek met succes gecanceld!","request_details_label":"Verzoek details","target_label":"Begunstigde","created_by_label":"Aangemaakt door","hidden_for_applicant_label":"Verborgen voor de Job Applicant","credentials_label":"Credentials","issued_at_label":"Uitgereikt op","cancel_request_button_label":"Cancel verzoek","cancel_request_warning_label":"Opgepast! Als u dit cancelt, verdwijnt dit verzoek uit de lijst.","cancel_request_are_you_sure_label":"Zeker dat u dit inzage verzoek wilt cancelen?","applicant_response_label":"Job Applicant reaktie","last_update_label":"Laatste update","expires_label":"Vervalt","expired_label":"Vervallen","revoked_label":"Teruggeroepen","pending_consents_label":"Hangende verzoeken","periods":{"week_label":"Week","month_label":"Maand","year_label":"Jaar","forever_label":"Voor altijd"},"consent_end_date_alert":"Uw verzoek zal vervallen op ","active_consents_label":"Actieve verzoeken","requested_label":"Verzocht","valid_till_label":"Geldig tot","grant_consent_button":"Goedkeuren verzoek","current_expire_date_label":"Huidige vervaldag","next_expire_date_label":"Volgende vervaldag","extend_consent_button":"Verzoek Verlengen","remove_consent_label":"Verzoek intrekken","remove_consent_button":"Intrekken","remove_consent_success_label":"Verzoek succesvol ingetrokken!","remove_modal_alert":"Zeker dat u dit Verzoek wil intrekken?","person_label":"Persoon","none_label":"Geen","no_active_consents_label":"U heeft nog geen actieve Verzoeken","no_pending_consents_label":"U heeft nog geen hangende Verzoeken","next_consent_button":"Volgend Verzoek","status_filter_label":"Status","job_label":"Job","job_filter_placeholder":"Geef gezochte Job Titel in","job_title_label":"Job Titel","internal_job_reference":"Interne Job Reference","expose_job_reference":"Interne Job Reference mag met Job Applicant gedeeld worden.","note_to_applicants_label":"Bericht aan de Job Applicant(s)","consents_history_label":"Consultatie Geschiedenis","show_consents_with_status_label":"Toon verzoeken met hun status","consents_history_no_data_label":"Uw Verzoek geschiedenis is leeg","status_label":"Status","expired_on_label":"Vervallen op","dismiss_request_button_label":"Verzoek afwijzen","dismiss_request_warning_label":"Opgepast! Dit Verzoek afwijzen haalt dit voorgoed uit de lijst.","dismiss_request_are_you_sure_label":"Zeker dat u dit Verzoek wil afwijzen? ","self_study_books_label":"Zelfstudie boeken","accreditations_label":"Diploma's","remove_bulk_consent_requests":"Wilt u dit bestand zeker verwijderen?","verified_by_applicant_only_label":"Gevalideerd door: Job Applicant (enkel)"},"prior_consents":{"prior_consents_label":"A priori goedgekeurde verzoeken","prior_consents_no_data_label":"U heeft nog geen à priori goedgekeurde verzoeken","target_type_label":"Type Begunstigde","target_data_label":"Begunstigde","auto_grant_till_label":"Automatisch goedkeuren tot","duration_label":"Duur","anyone_label":"Gelijk wie","day_label":"Dag","days_label":"Dagen","add_prior_consent_label":"Aanmaken à priori goedgekeurd verzoek","edit_prior_consent_label":"Wijzigen à priori goedgekeurd verzoek","target_type_input_placeholder":"Selecteer Begunstigde Type...","add_prior_consent_success_message":"A priori goedgekeurd verzoek succesvol aangemaakt!","edit_prior_consent_success_message":"A priori goedgekeurd verzoek succesvol gewijzigd!","period_label":"Periode","duration_alert":"De periode van automatische goedkeuring is","response_comment_label":"Automatisch antwoord naar aanvragers","response_comment_placeholder":"Laat uw bericht hier na...","remove_prior_consent_label":"Verwijder vooraf goedgekeurde inzage","remove_prior_consent_success_message":"A priori goedgekeurd verzoek succesvol verwijderd!","remove_prior_consent_alert":"Wilt u zeker dit à priori goedgekeurd verzoek verwijderen?","prior_consents_hint_part_1":"Een à priori goedgekeurd verzoek is een 'vooraf-goedkeuring' die je hier kan instellen. Het maakt dat wanneer de bedrijven die je daarvoor hier opgeeft, Diploma inzage vragen, dat ook onmiddellijk en automatisch krijgen.","prior_consents_hint_part_2":"Bedrijven die je hier toevoegt en overwegen jou aan te nemen, krijgen onmiddellijk inzage in de Diploma's die je opengesteld hebt. Dit tot de (optioneel instelbare) grensdatum.","prior_consents_hint_part_3":"De (optioneel) instelbare duur geeft de geldigheidsperiode van automatische goedkeuring aan. Bvb. als dat wordt ingesteld op een maand, krijgen collega's van de 1e aanvrager (HR collega's, jouw toekomstige baas, ... - als die maar van hetzelfde bedrijf zijn) ook inzage, zolang dat binnen die maand gebeurt. Echter eens die maand verlopen, wordt terug geverifieerd of een nieuw inkomend verzoek nog binnen de periode valt van de ingestelde automatische vooraf-goedkeuring!"},"approve_consent_after_request":{"label":"Geef goedkeuring na verzoek","success_alert":"Goedkeuring op verzoek is geslaagd","consent_requestor_label":"Verzoek aanvrager","grant_title_label":"Toekennen","refuse_title_label":"Wijgeren","grant_button":"Toekennen","refuse_button":"Wijgeren","company_name_label":"Naam Organizatie","company_country_label":"Land Organizatie","request_date":"Datum verzoek","period_label":"Periode","period_input_placeholder":"Kies periode...","reason_label":"Reden","reason_input_placeholder":"Kies reden...","reasons":{"TIMING1":"Ik ben niet op zoek naar (ander) werk.","TIMING2":"Ik ben hoogstens over een jaar vrij.","INTEREST":"Ik ben niet geïnteresseerd voor dit bedrijf te werken.","MISMATCH":"Deze job lijkt me geen goede fit.","ANOTHER":"Andere reden"},"comment_label":"Laat een bericht na voor de aanvrager","comment_placeholder":"Laat uw bericht hier na...","back_button":"Terugkeren ","approve_consent_progress_label":"Goedgekeurd"},"notification_settings":{"label":"Meldingen","notification_settings_label":"Meldingen settings","notification_new_accreditation_enabled":"Stuur mij een Email wanneer Diploma's nagekeken moeten worden","notification_consent_request_enabled":"Stuur mij een Email wanneer een potentiële werkgever BrainChain vraagt uw Diploma te bevestigen.","notification_settings_update_success_alert":"Meldingen settings met succes gewijzigd!","no_settings_label":"Momenteel moet u voor meldingen niets instellen.","preferred_language":"Voorkeur taal Meldingen"},"security_settings":{"label":"Beveiliging","2fa_label":"2-Factor Authentificatie","current_status_label":"Huidige status:","2fa_disabled_label":"2-Factor Authentificatie uitgeschakeld.","2fa_enabled_label":"2-Factor Authentication geactiveerd.","disable_2fa_submit_button":"Uitschakelen 2-Factor Authentication","enable_2fa_submit_button":"Activeren 2-Factor Authentication","disable_2fa_are_you_sure_message":"Wilt u 2FA zeker uitschakelen? Nadien kan u gewoon inloggen met login en paswoord zonder verificatie code.","disable_2fa_success_message":"2FA met succes uitgeschakeld!","enable_2fa_scan_qr_code_message":"Om 2FA in te schakelen, scan de QR-code met Google Authenticator or een andere app naar keuze. Via de gekozen app krijg je verificatie codes om te kunnen inloggen.","links_label":"Links naar Authentication Apps","google_authenticator_android_label":"Google Authenticator voor Android","google_authenticator_ios_label":"Google Authenticator voor iOS","free_otp_android_label":"FreeOTP Authenticator voor Android","free_otp_ios_label":"FreeOTP Authenticator voor iOS","update_warning":"Een nieuwe QR-code moet worden ingescand telkens je 2FA inschakelt voor een hernieuwde code.","enable_2fa_check_code_message":"Om zeker te zijn dat alles correct werkt, geef de verificatie-code in die je krijgt na het inscannen van de QR-code.","enable_2fa_parameters_label":"Authentificatie parameters","issuer_label":"Verstrekker","secret_label":"Geheim","algorithm_label":"Algoritme","digits_label":"Karakters","period_label":"Periode","check_code_label":"Verificatie code","enable_2fa_success_message":"2-Factor Authentication met succes geactiveerd!","2fa_contact_support_message":"Als u om een of andere reden geen toegang meer krijgt tot de QR app, en dus geen verificatiecode meer kan krijgen, contacteer Support.","verification_code_details_label":"De verificatie code moet 6 cijfers bevatten.","verification_code_enter_label":"Voor de correcte 2FA code, gebruikt u de QR app die u koos bij het instellen van 2FA."},"self_study":{"table_label":"Zelfstudie boeken","no_data_label":"Er zijn momenteel geen $Zelfstudie boeken$ opgegeven. Zelfstudie boeken kunnen hier opgelijst worden en vereisen geen externe conformatie. Dit maakt het mogelijk (andere/ruimere) interesses aan te geven en staan los van uw officiële Diploma's.","domain_label":"Domein","publisher_label":"Uitgever","study_date_label":"Studie datum","isbn_label":"ISBN","domains":{"ADMINISTRATION_AND_MANAGEMENT":"Administratie & Management","COMMUNICATION":"Communicatie","CULTURE_AND_SPORTS_AND_ENTERTAINMENT":"Cultuur, Sport & Entertainment","GOV":"Overheid","IT":"IT","LAND_AND_SEA_AND_AIR":"Land & Zee & Lucht","LEGAL":"Legal","LIFE_AND_DEATH":"Leven & Dood","MANUFACTURING_AND_WORKING_WITH_MATERIALS":"Fabriceren en werken met materialen","SALES_AND_MARKETING":"Sales & Marketing","SERVICES":"Diensten","STEM":"STEM","OTHER":"Ander"},"domains_examples":{"ADMINISTRATION_AND_MANAGEMENT":"bediende, secretaresse, executives, ...","COMMUNICATION":"Journalistiek, Audio / Video, ...","CULTURE_AND_SPORTS_AND_ENTERTAINMENT":"Toerisme, acteur, stripper, horeca, ...","GOV":"Onderwijs, Leger, Politie, stadsambtenaar, ...","IT":"ontwikkelaar, ML, AI, web designer, DBA, software architect, ...","LAND_AND_SEA_AND_AIR":"landbouwer, visser, astronaut, piloot, stewardess, tuinman, ...","LEGAL":"notaris, advocaat, ...","LIFE_AND_DEATH":"dokter, dierenarts, therapeut, tandarts, verpleegster, sluipschutter, lijkschouwer, ...","MANUFACTURING_AND_WORKING_WITH_MATERIALS":"houthakker, lasser, textiel, autoassemblage, mijnbouw, bouwvakker, ...","SALES_AND_MARKETING":"bakker, verkoop auto-onderdelen, immo, verhuur, ...","SERVICES":"Schoonmaak, kapper, recruiter, verzekeringen, bankier, transport, boekhouding, distributie, ...","STEM":"Wetenschappen (Pharma), Technologie (automechanieker, elektricien), ingenieurs (landbouwingenieur, architect), Wiskunde"},"add_self_study_book_success_message":"Zelfstudie boek met succes toegevoegd!","edit_self_study_book_success_message":"Zelfstudie boek met succes gewijzigd!","add_self_study_book_label":"Toevoegen zelfstudie boek aan repertoire","edit_self_study_book_label":"Wijzig zelfstudie boek","domain_select_placeholder":"Selecteer domein...","expose_self_study_book_label":"Zelfstudie boek mag getoond worden","remove_self_study_book_alert":"Bent u zeker dit zelfstudieboek te verwijderen?","remove_self_study_book_success_message":"Zelfstudieboek succesvol verwijderd!","isbn_format_hint":"De ISBN10/13 standaard is een internationaal boek identificatie schema. Gelieve u aan dit formaat te houden.","expose_label":"Toon","error_messages":{"isbn_alert":"Gebruik aub het ISBN10 of ISBN13 formaat."}},"notifications":{"pending_organizations":"U heeft {number} openstaande Organizaties","review_failed_accreditations":"U dient {number} Diploma's opnieuw na te kijken.","validate_accreditations":"U heeft {number} openstaande Diploma's te valideren. ","pending_accreditations":"U heeft {number} openstaande Diploma's te valideren. ","pending_consents":"U heeft {number} openstaande verzoeken.","pending_accreditation_requests":"U heeft {number} openstaande Diploma verzoeken.","unreferenced_accreditation_requests_by_ags":"U heeft {number} Diploma verzoeken zonder gelinkte Faculteit.","unreferenced_accreditation_requests_by_domains":"U heeft {number} Diploma verzoeken zonder gelinkte Universiteit."},"accreditation_requests":{"create_accreditation_request_label":"Aanmaken Diploma verzoek","create_accreditation_request_success_message":"Diploma verzoek succesvol aangemaakt!","create_accreditation_request_hint":"Als uw Alma Mater al met BrainChain meedoet, kan u die in onderstaande velden selecteren. Indien niet, kies 'manuele input'. Het belangrijkste veld daar is het internet domein. Kijk dat aub goed na - dit is mogelijks in de loop der jaren veranderd.","domain_hint":"Een internet domein is het 1e deel van een web adres (URL) van een Organizatie. Bvb. 'apple.com', of 'ibm.de'","accreditation_group_hint":"Een Diploma groep, of Accreditatie groep, is typisch de naam van de #Faculteit# waar je bent afgestudeerd. Bvb. #Psychologie#, #Economie# of #Burgerlijk Ingenieur#, afhankelijk van hoe uw Alma Mater zich organizeert.","national_id_hint":"Alle landen hebben een unieke identificatie code voor hun burgers. Dit is nodig om dubbelzinnigheid te vermijden en diefstal van identiteit te voorkomen, zélfs voor mensen met dezelfde naam, of voor mensen die zich als u willen voordoen. Om bijgevolg te vermijden dat iemand anders kan doen alsof hij uw Diploma behaald heeft, is het dus zeer belangrijk van dit correct in te geven. Dit stelt ons in staat om zélfs mensen met dezelfde naam als u te kunnen onderscheiden, en in een keer te voorkomen dat iemand zich met uw naam kan registreren en zich als u kan voordoen. Bvb in België is dat het RRN (Rijks Register Nummer, op de achterkant van uw identiteitskaart) ; in Nederland is dat het BSN (Burger Service Nummer).","national_id_expose_hint":"De nationale identificatie wordt enkel volledig getoond aan de Applicant. De Applicant kan te allen tijden instellen wat er van zijn nationale identificatie getoond mag worden.","manual_org_input_mode_label":"Manueel ingeven van Organizatie gegevens.","select_org_input_mode_label":"Select org","manual_accreditation_group_input_mode_label":"Manuele Ingave Faculteit","select_accreditation_group_input_mode_label":"Selecteer Factulteit","manual_vid_input_mode_label":"Geeft geverifieerde identificatie (VID) manueel in","select_vid_input_mode_label":"Selecteer geverifieerde identificatie (VID)","vid_label":"Geverifieerde Identificatie (VID)","status":{"REQUEST_SUBMITTED":"Verzonden","REQUEST_IN_PROCESS":"In beschouwing","REQUEST_REJECTED":"Geweigerd"},"status_label":"Verzoek Status","expose_label":"Mag getoond worden","edit_accreditation_request_label":"Wijzig Diploma verzoek","remove_accreditation_request_label":"Verwijder Diploma verzoek","accreditation_requests_no_data_label":"U heeft nog geen Diploma verzoeken","accreditation_requests_label":"Diploma verzoeken","accreditation_request_remove_alert":"Wilt u zeker dit Diploma verzoek verwijderen?","edit_accreditation_request_success_message":"Diploma verzoek succesvol gewijzigd!","pending_accreditation_requests_by_domain_label":"Hangende Diploma inzage verzoeken per Domain","validated_accreditation_requests_by_domain_label":"Gevalideerde Diploma inzage verzoeken per Domain","accreditation_requests_list_no_data_label":"Er zijn nog geen Diploma verzoeken","organization_domain_label":"Organizatie Domein","accreditation_requests_number_label":"Diploma verzoek nummer","filter_by_domain_label":"Filteren naar domein","filter_label":"Filteren","accreditation_requests_remove_alert":"Wilt u dit Diploma verzoek zeker verwijderen?","remove_accreditation_request_success_message":"Diploma verzoek succesvol verwijderd!","remove_accreditation_requests_success_message":"Diploma verzoeken succesvol verwijderd!","update_accreditation_requests_success_message":"Domain van Diploma verzoek succesvol gewijzigd!","accreditation_requests_warning_alert":"Deze Organizatie heeft {number} openstaande Diploma verzoeken. Als de Organizatie wordt bewaard zonder de mogelijkheid Diploma's te kunnen ingeven, zullen alle openstaande Diploma verzoeken van Job Applicanten verwijderd worden. ","proceed_button":"Verdergaan","accreditation_requests_by_group_label":"Diploma verzoek volgens groep","accreditation_requests_by_group_hint_part_1":"Hier kan u inkomende Diploma verzoeken van Job Applicants (cf. lijst) koppelen aan bestaande Faculteiten van de Universiteit.","accreditation_requests_by_group_hint_part_2":"Eens gekoppeld, zullen deze bij de juiste Insertor(-en) terecht komen.","accreditation_requests_by_group_hint_part_3":"Merk op dat u verzoeken van dezelfde Faculteit kan bundelen.","set_accreditation_group_for_selected_button":"Stel Faculteit in voor de geselecteerde verzoeken.","reject_selected_button":"Weiger geselecteerde","reject_accreditation_requests_alert":"Wilt u zeker alle geselecteerde Diploma verzoeken weigeren?","reject_button":"Wijger","set_accreditation_group_for_selected_requests_label":"Stel Faculteit in voor geselecteerde Diploma verzoeken","set_accreditation_group_for_selected_requests_success_message":"Faculteit referentie succesvol toegevoegd!","expose_accreditation_request_label":"Toon Diploma verzoek","pending_accreditation_requests_label":"Hangend Diploma verzoek","pending_accreditation_requests_no_data_label":"Er zijn nog geen openstaande Diploma verzoeken.","pending_accreditation_requests_hint_part_1":"Als de gegevens juist zijn, kan u het verzoek simpelweg #Bevestigen#; indien u niet zeker bent, kan u #Volgende# klikken om dit verzoek even over te slaan.","pending_accreditation_requests_hint_part_2":"Als de Diploma gegevens fouten bevat, kan u die rechtzetten voor het toevoegen.","back_button":"Terug naar de lijst van openstaande Diploma verzoeken. ","process_accreditation_request":"Behandel Diploma verzoek.","next_accreditation_request_label":"Volgend Diploma verzoek","confirm_accreditation_request_button":"Confirmeren en invoegen","reject_accreditation_request_alert":"Wilt u dit Diploma verzoek zeker verwerpen?","organization_label":"Organizatie","applicant_email_label":"Job Applicant Email","expose_hint":"U kan ervoor kiezen ook nog niet gevalideerde diploma's aan potentiële werkgevers te tonen. Zij zullen voorlopig wel nog als niet-gevalideerd aangegeven worden, tot ze ook door de Universiteit gevalideerd werden.","created_at_label":"Verzoek Datum","org_by_domain_error_alert":"Mmmm. Deze Organizatie mag geen Diploma's toekennen.","accreditations_pending_approval_label":"Diploma's die op goedkeuring wachten","accreditation_requests_details_label":"Diploma verzoek details","reject_accreditation_request_success_message":"Diploma verzoek succesvol verworpen!","confirm_accreditation_request_success_message":"Diploma verzoek succesvol aanvaard!","pending_accreditations_progress_label":"Ingevoegd","validated_accreditations_progress_label":"Gevalideerd","validate_button":"Valideer","accreditation_requests_validate_alert":"Bent u zeker dit Diploma inzage verzoek te willen goedkeuren?","validate_accreditation_requests_success_message":"Diploma inzage verzoek succesvol goedgekeurd!","pending_accreditation_requests_list_no_data_label":"Er zijn geen Diploma inzage verzoeken meer.","validated_accreditation_requests_list_no_data_label":"Er zijn nog geen goedgekeurde Diploma inzage verzoeken.","last_requestors_button":"Laatste verzoekers","applicant_accreditation_consent_label":"Hierbij geef ik toestemming aan de BrainChain Accreditation Vetting Authority (BAVA) om de verificatie te beheren en mij op de hoogte te houden."},"security":{"label":"Security","got_it_button":"Begrepen!","anchor_info_part_1":"Alle communicatie met BrainChain is bijzonder sterk beveiligd door encryptie met een sterke digitale sleutel. Dit encapsuleert Diploma data om inzage en gefoefel ONMOGELIJK te maken. Zulke sleutel (een bestand met extensie .jwk) kan verkregen worden op eenvoudig verzoek aan BrainChain.","anchor_info_part_2":"Jouw rol als Anker houdt in dat je deze sleutels op een veilige manier (= bij voorkeur offline, zoals met een USB stick) deelt met alle Insertor(s) die je aanstelt.","anchor_info_part_3":"Zonder deze sleutel kunnen zij geen Diploma's invoegen.","inserter_info_part_1":"Alle communicatie met BrainChain is bijzonder sterk beveiligd door encryptie met een sterke digitale sleutel. Dit encapsuleert Diploma data om inzage en gefoefel ONMOGELIJK te maken. Deze sleutel (een bestand met extensie .jwk) is door BrainChain aangemaakt en het is de rol van het Anker van je Organizatie die aan jou door te geven.","inserter_info_part_2":"Het enige wat moet gebeuren om te kunnen starten, is hieronder die sleutel importeren of droppen, op de computer die je plant te gaan gebruiken om Diploma's in te voegen.","inserter_info_part_3":"Dit moet je slechts één keer doen per computer die je hiervoor wil gebruiken.","inserter_info_part_4":"Eens de digitale key geïnstalleerd is, is geen verdere actie vereist; Diploma's digitaal versleutelen wordt vanaf dan volledig transparent in de achtergrond door de applicatie opgenomen.","admin_root_certificates_label":"Beheer van het BrainChain root Certificaat.","admin_universities_label":"Reeds gevalideerde universiteiten - deze zijn aan het wachten op ons om hun server-side key te uploaden.","admin_universities_info_part_1":"Naast het BrainChain root Certificaat is er een 2e component die wij als BrainChain aan onze kant moeten installeren: een universiteits-specifiek Certifikaat 'uni.crt' .","admin_universities_info_part_2":"Hieronder is een lijst van reeds gevalideerde Universiteiten die deze sleutel nog niet geïnstalleerd hebben en hierop aan het wachten zijn! Dit kan nu (= na validatie) onmiddellijk gedaan worden! Vergeet aub niet na deze sleutel hier te installeren, ook naar het Anker zijn eigen 'uni.jwk' te mailen. Deze wordt offline door de SA gegenereerd.","add_valid_till_label":"Toevoegen/Geldig tot","add_certificate_button":"Toevoegen uni.crt","mail_anchor_label":"Mail uni.jwk naar Anker ","is_uni_key_sent_label":"Uni sleutel verzonden?","confirm_sent_button":"Bevestig verzonden","mail_subject_label":"Uw digitale BrainChain sleutel om veilig Diploma's te versleutelen.","mail_body_part_1":"Beste {anchor},","mail_body_part_2":"Alle communicatie met BrainChain is bijzonder sterk beveiligd door encryptie met een sterke digitale sleutel. Dit encapsuleert Diploma data om inzage en gefoefel ONMOGELIJK te maken. Deze sleutel (een bestand met extensie .jwk) is door BrainChain aangemaakt en vindt u in bijlage van deze mail.","mail_body_part_3":"Jouw rol als Anker houdt in dat je deze sleutels op een veilige manier (= bij voorkeur offline, zoals met een USB stick) deelt met alle Insertor(s) die je aanstelt.","mail_body_part_4":"Zonder deze sleutel kunnen zij geen Diploma's invoegen.","mail_body_part_5":"Moest je dit vergeten, zal de BrainChain applicatie je hieraan herinneren in de Security sectie.","mail_body_part_6":"Team BrainChain"},"assistants":{"assistants_label":"Assistenten","no_data_label":"Er zijn nog geen Assistenten.","roles_label":"Rollen","location_label":"Locatie","process_assistant_label":"Proces Assistent","financial_assistant_label":"Financiële Assistent","add_assistant_page_label":"Toevoegen Assistent","roles_select_placeholder":"Selecteer Assistent rol...","remove_assistant_alert":"Wilt u zeker deze Assistent verwijderen?","edit_assistant_alert":"Wijzigen Assistent"},"business_ambassadors":{"business_ambassadors_label":"Business Ambassadors","no_data_label":"Er zijn nog geen Business Ambassadors.","financial_data_label":"Financiële data","add_business_ambassador_label":"Toevoegen Business Ambassador","edit_business_ambassador_label":"Wijzigen Business Ambassador","add_business_ambassador_success_message":"Business Ambassador met succes toegevoegd!","edit_business_ambassador_success_message":"Business Ambassador met succes gewijzigd!","remove_ambassador_alert":"Wilt u zeker deze Business Ambassador verwijderen?"},"commissions":{"commissions_list_label":"Commissies","countries_label":"Landen","commission_label":"Commissie","date_from_label":"Vanaf Datum","date_to_label":"Tot Datum","no_data_label":"Er zijn geen commissies.","remove_commission_success_message":"Commissie met succes verwijderd!","remove_commission_alert":"Wilt u zeker deze commissie verwijderen?","add_commission_label":"Toevoegen Commission","edit_commission_label":"Wijzigen Commission","add_commission_success_message":"Commissie met succes aangemaakt!","edit_commission_success_message":"commissie met succes gewijzigd!","ba_label":"Business Ambassador","ba_short_label":"BA","add_commission_hint":"Nieuwe commissies kunnen hieronder worden gedefinieerd voor # eerder gedefinieerde # business ambassadors."},"system_payment":{"due_payments_label":"Te Betalen","ba_s_due_payments_label":"Te Betalen aan Business Ambassadors","uni_s_due_payments_label":"Te Betalen aan Educatie wereldwijd","system_due_payments_label":"Te Betalen aan WickedWare","system_due_payments_hint":"Dit nummer staat voor het bedrag dat van de WickedWare 'BrainChain'-rekening naar de WickedWare' Savings'-rekening (LT773500010003830341) moet worden overgemaakt. Dit is de som van het openstaande verbruikte bedrijfskrediet.","filter_by_region_label":"Filter naar Regio","ba_label":"BA","uni_label":"Uni","amount_label":"Verschuldigd bedrag","total_aggregated_pay_label":"Totaal betaald bedrag","ba_wire_data_label":"BA Overschrijvingsgegevens","uni_wire_data_label":"Uni Overschrijvingsgegevens","record_payment_label":"Opnemen betaling","paid_button":"Bevestig offline betaald","no_ba_s_label":"Er zijn geen BAs.","no_uni_s_label":"Er zijn geen Universiteiten.","no_payments_for_ba_s_label":"Geen betalingen aan BA's vallen onder deze criteria","no_payments_for_uni_s_label":"Geen betalingen aan Universiteiten vallen onder deze criteria","no_payments_for_system":"Er zijn geen verschuldigde betalingen voor WickedWare.","show_label":"Tonen","due_payments_paid_success_message":"Openstaande betalingen met succes uitgevoerd!","payments_history_label":"Betalingshistoriek","uni_s_payments_history_label":"Betalingshistoriek voor Educatie wereldwijd","ba_s_payments_history_label":"Betalingshistoriek voor BAs","payment_date_label":"Datum Betaling","filter_date_from_label":"Datum van","filter_date_to_label":"tot","name_label":"Naam","company_credit_label":"Bedrijfs krediet","date_joined_label":"Toetredingsdatum","open_credit_label":"Open Krediet","total_credit_label":"Total gebruikt krediet","contact_label":"Contact","no_companies_credits_label":"Er zijn geen bedrijfskredieten die binnen deze criteria vallen.","order_by_label":"Ordenen volgens","due_payment_modal_label":"Openstaande betaling voor {name}","wire_data_modal_label":"Overschrijvingsgegevens voor {name}","comment_label":"Commentaar","no_company_credits":"Geen kredietgeschiedenis voor dit bedrijf","date_label":"Datum","value_of_change_label":"Waarde van verandering","credit_history_label":"Kredietgeschiedenis voor {name}"},"validated_domains":{"validated_domains_label":"Gevalideerde Edu-domeinen","no_data_label":"Er zijn geen gevalideerde domeinen.","filter_by_name_label":"Filteren op naam","organization_name_label":"Organisatie Naam","managed_by_label":"Beheerd door","applicant_requests_label":"Verzoeken van werkzoekenden","bava_managed_label":"BAVA-managed","self_managed_label":"In eigen beheer","add_domain_button":"Toevoegen domein","validate_domain_label":"Domein valideren","contact_name_label":"Contact naam","contact_email_label":"Contact Email","contact_phone_label":"Contact telefoon","add_success_message":"Gevalideerd domein succesvol toegevoegd!","edit_success_message":"Gevalideerd domein succesvol bijgewerkt!","edit_domain_label":"Organizatie details bewerken","remove_domain_alert":"Weet u zeker dat u dit gevalideerde domein wilt verwijderen? Merk op dat dit betekent dat alle diploma's in de profielen van mensen ook worden verwijderd!","remove_success_message":"Gevalideerd domein succesvol verwijderd!","fully_registered_org_hint":"U kunt deze organisatie wijzigen in de lijst met organisaties."},"shared":{"add_button":"Toevoegen","cancel_button":"Annuleer","remove_button":"Verwijder","first_name_label":"Voornaam","last_name_label":"Achternaam","email_label":"Email","personal_email_label":"Privé Email","professional_email_label":"Werk Email","password_label":"Paswoord","department_label":"Departement","continent_input_placeholder":"Kies regio...","country_input_placeholder":"Kies land...","continent_label":"Regio","continent_filter_label":"Regio(Filter)","country_label":"Land","fetching_message":"Bezig...","success_message":"Succes","national_id_label":"Nationaal ID [RRN(BE)/BSN(NL)]","company_label":"Bedrijf","edu_org_label":"Educatieve Instelling","org_label":"Organizatie","employee_count_label":"Aantal werknemers","name_label":"Naam","accreditation_group_label":"Accreditatie groep","okey_button":"OK","yes_label":"Ja","no_label":"Nee","edit_button":"Aanpassen","domain_label":"Internet Domein","datepicker_placeholder":"Klikken voor datum selectie","save_changes_button":"Bewaren","back_button":"Terug","company_domain_label":"Organizatie domein","search_label":"Zoek","about_label":"Over","title_label":"Titel","phone_number_label":"Telefoonnummer","required_field_error_message":"Veld aub invullen","pages_label":"{currentNumber} van {totalNumber}","examples_label":"Voorbeelden","location_label":"Locatie","all_label":"Alles","filter_options_label":"Filter opties"},"errors":{"IRRELEVANT_LINK_EMAIL":"U heeft deze link reeds gebruikt om u Email te veranderen!!","INCORRECT_JWK":"Foute certificaat sleutel","DEFAULT_ERROR":"Fout","INCORRECT_ACCOUNT_TYPE":"Fout Account type","INCORRECT_USERNAME_OR_PASSWORD":"Foute gebruikersnaam of wachtwoord","IRRELEVANT_LINK":"U heeft deze link reeds gebruikt om uw paswoord te resetten!","INCORRECT_FILE_CONTENT":"Foute bestands inhoud","INCORRECT_DOMAIN":"Opgegeven domein is ongeldig","BAVA_ACCREDITATION_FLOW_FORBIDDEN":"Diplomabewerkingen met betrekking tot BAVA zijn verboden.","BAVA_ACCREDITATION_MISSING_PARAMS":"De organisatie-ID moet in het diploma worden vermeld.","BAVA_MISSING":"De Bava-organisatie is niet geregistreerd.","BAVA_CANNOT_BE_CHANGED":"De Bava-organisatie kan niet worden gewijzigd.","RELATED_ACCREDITATIONS_EXISTS":"De beheerde staat kan niet worden gewijzigd voor organisaties met bestaande diploma inzage verzoeken.","REQUEST_BODY_INVALID":"Foute velden. Kijkt u aub even na of alles correct ingevuld is.","REQUEST_PARAM_MISSING":"Er ontbreekt een verplichte parameter","REQUEST_PARAM_INVALID":"Ongeldige Parameter waarde","OPERATION_NOT_PERMITTED":"Operatie niet toegestaan","OAUTH_CLIENT_ERROR":"OAuth verzoek niet geldig","OAUTH_GRANT_TYPE_INVALID":"OAuth toekenningstype niet geldig","NEGATIVE_BALANCE":"Het creditsaldo mag niet negatief zijn.","ACCREDITATION_GROUP_ROLE_INVALID":"Ongeldige Accreditatiegroep rol","ACCREDITATION_GROUP_ACCREDITATION_REQUEST_ADDITION_ERROR":"Het is niet mogelijk om deze faculteit toe te voegen aan het Accreditatieverzoek.","ACCREDITATION_GROUP_STAFF_ADDITION_ERROR":"Deze collega kan niet aan die Accreditatie groep toegevoegd worden.","ACCREDITATION_GROUP_STAFF_REMOVAL_ERROR":"Deze collega kan niet verwijderd worden van die Accreditatie groep.","ACCREDITATION_GROUP_NAME_MISSING":"#Geef een naam voor Accreditatiegroep (ook faculteit genoemd) op, want er bestaat geen standaardoptie voor deze organisatie.#","DEPARTMENT_ROLE_INVALID":"Ongeldige Departementsrol","DEPARTMENT_STAFF_ADDITION_ERROR":"Deze collega kan niet worden toegevoegd aan dit Departement.","DEPARTMENT_STAFF_REMOVAL_ERROR":"Deze collega kan niet worden verwijderd van dit Departement.","UNSUFFICIENT_BALANCE":"Onvoldoende krediet - contacteer de verantwoordelijke om dit aan te zuiveren","TIME_PERIOD_INVALID":"Ongeldige Periode","CONSENT_REQUEST_STATUS_INVALID":"Dit verzoek werd reeds behandeld of gecanceld.","ABANDONING_OTHERS_REQUEST":"Dit kan u helaas niet doen.","PRIOR_CONSENT_EXISTS":"Een vooraf-goedkeuring voor deze begunstigde bestaat reeds.","INCORRECT_ORGANIZATION_PAID_TILL_STATE":"Onjuiste waarde voor 'Betaald tot'-datum; de nieuwe 'Betaald tot'-datum moet recenter zijn dan de vorige waarde.","EXPIRED_ORGANIZATION_PAID_TILL":"De 'Betaald tot'-datum van de organisatie is verstreken.","ORGANIZATION_EMAIL_INVALID":"Ongeldige Werk Email.","STAFF_REMOVAL_ERROR":"Deze collega kan niet worden verwijderd","NO_ANCHOR_LEFT":"Een Anker kan zichzelf niet verwijderen.","ACTIVE_STAFF_MISSING":"Met deze ID kan geen (actieve) collega gevonden worden.","NON_STAFF_USER_EXISTS":"Deze gebruiker bestaat reeds maar is geen collega.","STAFF_DIFFERENT_ORGANIZATION":"Een collega met deze Email werkt reeds in een andere Organizatie.","STAFF_ALREADY_EXISTS":"Een collega met deze Email is reeds opgegeven.","ORGANIZATION_ALREADY_EXISTS":"Organizatie naam en/of domein reeds in gebruik","ORGANIZATION_IS_BAVA_MANAGED":"Zolang deze organisatie door BAVA wordt beheerd, kan ze geen Accreditatiegroepen (ook 'Faculteiten') hebben; alle Diploma's zullen onder 'AlleFaculteiten' vallen totdat de Organisatie toetreedt. Op dat moment zal een Diploma-migratie moeten worden georganiseerd.","ORGANIZATION_CANNOT_BE_REMOVED":"Organisaties onder BAVA-beheer kunnen worden verwijderd, maar BAVA (en haar dochter instanties) zélf, kunnen niet worden verwijderd.","ORGANIZATION_CANNOT_BE_UPDATED":"Er is al een organisatie met deze naam en / of domein geregistreerd","ORGANIZATION_CERTIFICATE_MISSING":"Er zijn geen geldige certificaten voor deze Organizatie.","ORGANIZATION_ACCREDITATION_INCORRECT_STATUS":"Onjuiste accreditatiestatus","ORGANIZATION_ACCREDITATION_FLOW_FORBIDDEN":"Deze Organizatie mag geen Diploma's uitreiken.","ORGANIZATION_EQUAL_MANAGED_STATE":"De organisatie was al in deze staat.","USER_ALREADY_EXISTS":"Account bestaat reeds. ","ACTIVATION_NOT_NEEDED":"Account is ongekend of reeds aktief.","ALIAS_REQUIRED":"Gebruiker kan niet worden geactiveerd zonder volledige alias.","APPLICANT_TOKEN_REQUIRED":"Token van Applicant ontbreekt.","APPLICANT_NOT_FOUND":"Met deze Email heeft zich nog niemand in BrainChain geregistreerd.","OLD_PASSWORD_INVALID":"Ongeldig oud paswoord","EMAIL_ALREADY_IN_USE":"Email adres reeds in gebruik","USER_INACTIVE":"Ongekende of niet aktieve Account","NO_ALIASES_LEFT":"Minstens 1 alias zou moeten bestaan","PASSWORD_TOO_SIMPLE":"Te eenvoudig paswoord...","CAN_NOT_REMOVE_LAST_ROOT_ADMIN":"De laatste root admin kan niet worden verwijderd","BUSINESS_AMBASSADOR_CONTRACT_INTERSECTION":"Voor elke [Land, BA] -combinatie kan slechts één commissie worden gespecificeerd.","BUSINESS_AMBASSADOR_CONTRACT_HUGE_TOTAL_PERCENT":"Het totale commissiepercentage werd groter dan verwacht voor een bepaald land(-en) over een bepaalde periode.","VALIDATING_OWN_WORK":"U kan uw eigen werk niet valideren.","DELETING_OTHERS_WORK":"Dit kan u niet doen. ","ACCREDITATION_SIGNATURE_INVALID":"Aangereikte handtekening is ongeldig.","ACCREDITATION_SIGNATURE_MISSING":"Vereiste handtekening ontbreekt.","ORIGINAL_ACCREDITATION_NOT_FOUND":"Excuses, de originele gegevens van deze Accreditatie (Diploma) konden niet worden terug gevonden.","APPLICANT_ACCREDITATION_REQUEST_ACCREDITATION_GROUP_ID_INVALID":"Ongeldige Faculteit voor deze Organizatie","APPLICANT_ACCREDITATION_REQUEST_ACCREDITATION_GROUP_MISMATCH":"De Faculteit door de Job Applicant aangereikt verschilt van die voor nieuwe Diploma's.","APPLICANT_ACCREDITATION_REQUEST_STATUS_INVALID":"De status van het Diploma verzoek van de Job Applicant is ongeldig en belet invoeging.","ACCREDITATION_BULK_JOB_NOT_FINISHED":"Wacht aub even tot de bulk upload volledig gedaan is.","CREATE_CONSENT_REQUEST_BULK_JOB_NOT_FINISHED":"U kan dit niet doen tot het uploaden voltooid is.","ACCREDITATION_BULK_JOB_MISSING_REQUIRED_HEADERS":"De vereiste headers ontbreken.","ACCREDITATION_BULK_JOB_INVALID_RECORD_SIZE":"De kolommen komen niet met de koplijn overeen","ACCREDITATION_BULK_JOB_INVALID_RECORD_FORMAT":"Bestand ongeldig geformatteerd.","ACCREDITATION_BULK_JOB_INVALID_XML_DOCUMENT_FORMAT":"Ongeldig XML Dokument formaat.","CURRENCY_NOT_SUPPORTED":"Deze munteenheid wordt niet ondersteund.","DIGITAL_CERTIFICATE_UNSUPPORTED_FORMAT":"Het formaat van dit digitaal certificaat wordt niet ondersteund.","DIGITAL_CERTIFICATE_NOT_YET_VALID":"Het digitaal Certificaat is nog niet geldig.","DIGITAL_CERTIFICATE_EXPIRED":"Het digitaal Certificaat is vervallen.","DIGITAL_CERTIFICATE_VERIFICATION_FAILED":"Het digitaal Certificaat werd niet correct ondertekend.","UNSUPPORTED_CONTENT_TYPE":"De inhoud van dit Bestand wordt niet ondersteund.","FAILED_TO_PARSE_BODY":"De bestandsinhoud kon niet verwerkt worden.","FILE_TOO_LARGE":"Bestand is te groot om op te laden.","BUSINESS_AMBASSADOR_NOT_FOUND":"Business ambassador niet gevonden","BUSINESS_AMBASSADOR_CONTRACT_NOT_FOUND":"Business ambassador contract niet gevonden","ACCREDITATION_GROUP_NOT_FOUND":"Faculteit (Accreditatie groep) niet gevonden","ACCREDITATION_GROUP_CONTAIN_REQUESTS":"Deze faculteit (Accreditatiegroep) bevat onverwerkte verzoeken en kan daarom niet worden verwijderd.","DEPARTMENT_NOT_FOUND":"Departement niet gevonden","ORGANIZATION_NOT_FOUND":"Organizatie niet gevonden","STAFF_NOT_FOUND":"Collega niet gevonden.","ALIAS_NOT_FOUND":"Alias niet gevonden","ACCREDITATION_NOT_FOUND":"Accreditatie niet gevonden.","VERIFIED_IDENTITY_NOT_FOUND":"Geverifieerde Identiteit niet gevonden.","ACCREDITATION_BULK_JOB_NOT_FOUND":"Bulk Job niet gevonden","CREATE_CONSENT_REQUEST_BULK_JOB_NOT_FOUND":"Gebundelde Job niet gevonden.","NO_HANDLER_FOUND":"Geen helper-toepassing gevonden","PRICING_PRESET_NOT_FOUND":"Geen standaard prijszetting gevonden.","USER_NOT_FOUND":"Deze gebruiker heeft zich nog niet in het systeem geregistreerd.","CONSENT_REQUEST_NOT_FOUND":"Inzage verzoek niet gevonden.","PRIOR_CONSENT_NOT_FOUND":"Vooraf ingestelde goedkeuring niet gevonden.","SELF_STUDY_BOOK_NOT_FOUND":"Zelfstudie boek niet gevonden.","DIGITAL_CERTIFICATE_NOT_FOUND":"Digitaal Certificaat niet gevonden.","APPLICANT_ACCREDITATION_REQUEST_NOT_FOUND":"Job Applicant Diploma verzoek niet gevonden.","TOKEN_NOT_FOUND":"Geen Token gevonden","TOKEN_EXPIRED":"Token is verlopen","TOKEN_INVALID":"Token niet geldig","TOKEN_VALIDATION_ERROR":"Token validatie probleem","TOTP_CODE_INVALID":"Ongeldige verificatie code.","TOTP_CODE_REQUIRED":"TOTP code vereist","AUTHENTICATION_FAILED":"Mislukte Authenticatie","ORGANIZATION_NOT_VERIFIED":"Organizatie is niet geverifieerd","USER_ALREADY_ACTIVE":"Deze Account is reeds actief.","ORGANIZATION_CANNOT_WORK_WITH_ACCREDITATIONS":"Deze Organizatie kan niet met Accreditaties werken.","ACCESS_DENIED":"Toegang geweigerd","APPLICANT_ACCREDITATION_REQUEST_CANNOT_BE_MODIFIED_IF_ORG_REFERENCED":"Het Diploma verzoek kan niet meer gewijzigd worden omdat intussen de betrokken Organizatie in BrainChain geregistreerd is.","APPLICANT_ACCREDITATION_REQUEST_ORG_CHANGE_FORBIDDEN":"De Organizatie van een Job Applicant Diploma verzoek kan niet gewijzigd worden.","APPLICANT_ACCREDITATION_REQUEST_AMOUNT_TOO_LARGE":"Maximum aantal Diploma verzoeken bereikt.","UNAUTHORIZED":"Niet toegestaan","INTERNAL_SERVER_ERROR":"Fout in de buik van de Server"},"continents":{"AF":"Afrika","NA":"Noord-Amerika","OC":"Oceanië","AN":"Antarctica","AS":"Azië","EU":"Europa","SA":"Zuid-America"},"countries":{"AD":"Andorra","AE":"Verenigde Arabische Emiraten","AF":"Afghanistan","AG":"Antigua en Barbuda","AI":"Anguilla","AL":"Albanië","AM":"Armenië","AO":"Angola","AQ":"Antarctica","AR":"Argentinië","AS":"American Samoa","AT":"Oostenrijk","AU":"Australië","AW":"Aruba","AX":"Aland Eilanden","AZ":"Azerbeijan","BA":"Bosnië en Herzegovina","BB":"Barbados","BD":"Bangladesh","BE":"België","BF":"Burkina Faso","BG":"Bulgarije","BH":"Bahrain","BI":"Burundi","BJ":"Benin","BL":"Sint Bartholomeus","BM":"Bermuda","BN":"Brunei Darussalam","BO":"Bolivië, Plurinational State of","BQ":"Bonaire, Sint Eustatius and Saba","BR":"Brazilië","BS":"Bahamas","BT":"Bhutan","BV":"Bouvet Island","BW":"Botswana","BY":"Wit-Rusland","BZ":"Belize","CA":"Canada","CC":"Cocos (Keeling) Islands","CD":"Congo, the Republic of the","CF":"Centraal Afrikaanse Republiek","CG":"Congo","CH":"Zwitserland","CI":"Côte d'Ivoire","CK":"Cook Islands","CL":"Chili","CM":"Cameroon","CN":"China","CO":"Colombia","CR":"Costa Rica","CU":"Cuba","CV":"Cape Verde","CW":"Curaçao","CX":"Christmas Island","CY":"Cyprus","CZ":"Czech Republic","DE":"Duitsland","DJ":"Djibouti","DK":"Denemarken","DM":"Dominica","DO":"Dominicaanse Republiek","DZ":"Algerije","EC":"Ecuador","EE":"Estland","EG":"Egypte","EH":"Westelijke Sahara","ER":"Eritrea","ES":"Spanje","ET":"Ethiopië","FI":"Finland","FJ":"Fiji","FK":"Falkland Islands (Malvinas)","FM":"Micronesië, Federated States of","FO":"Faroe Eilanden","FR":"Frankrijk","GA":"Gabon","GB":"UK","GD":"Grenada","GE":"Georgië","GF":"French Guiana","GG":"Guernsey","GH":"Ghana","GI":"Gibraltar","GL":"Groenland","GM":"Gambia","GN":"Guinea","GP":"Guadeloupe","GQ":"Equatoriaal Guinea","GR":"Griekenland","GS":"Zuid-Georgië en de Zuidelijke Sandwish Eilanden","GT":"Guatemala","GU":"Guam","GW":"Guinea-Bissau","GY":"Guyana","HK":"Hong Kong","HM":"Heard Island and McDonald Islands","HN":"Honduras","HR":"Kroatië","HT":"Haïti","HU":"Hongarije","ID":"Indonesië","IE":"Ierland","IL":"Israel","IM":"Isle of Man","IN":"Indië","IO":"British Indian Ocean Territory","IQ":"Irak","IR":"Iran, Islamic Republic of","IS":"IJsland","IT":"Italië","JE":"Jersey","JM":"Jamaica","JO":"Jordan","JP":"Japan","KE":"Kenya","KG":"Kyrgyzstan","KH":"Cambodia","KI":"Kiribati","KM":"Comoros","KN":"Saint Kitts and Nevis","KP":"Korea, Democratic People's Republic of","KR":"Korea, Republic of","KW":"Koeweit","KY":"Cayman Eilanden","KZ":"Kazakhstan","LA":"Lao People's Democratic Republic","LB":"Libanon","LC":"Saint Lucia","LI":"Liechtenstein","LK":"Sri Lanka","LR":"Libië","LS":"Lesoto","LT":"Litouwen","LU":"Luxemburg","LV":"Letland","LY":"Libië","MA":"Marokko","MC":"Monaco","MD":"Moldova, Republic of","ME":"Montenegro","MF":"Sint Maarten (Frans gedeelte)","MG":"Madagascar","MH":"Marshall Eilanden","MK":"Macedonië","ML":"Mali","MM":"Myanmar","MN":"Mongolië","MO":"Macao","MP":"Noordelijke Mariana Eilanden","MQ":"Martinique","MR":"Mauritanië","MS":"Montserrat","MT":"Malta","MU":"Mauritius","MV":"Malediven","MW":"Malawi","MX":"Mexico","MY":"Malaysia","MZ":"Mozambique","NA":"Namibia","NC":"New Caledonia","NE":"Niger","NF":"Norfolk Island","NG":"Nigeria","NI":"Nicaragua","NL":"Nederland","NO":"Noorwegen","NP":"Nepal","NR":"Nauru","NU":"Niue","NZ":"Nieuw Zeeland","OM":"Oman","PA":"Panama","PE":"Peru","PF":"Frans Polynesië","PG":"Papua Nieuw Guinea","PH":"Filippijnen","PK":"Pakistan","PL":"Polen","PM":"Saint Pierre and Miquelon","PN":"Pitcairn","PR":"Puerto Rico","PS":"Palestina, State of","PT":"Portugal","PW":"Palau","PY":"Paraguay","QA":"Qatar","RE":"Réunion","RO":"Roemenië","RS":"Servië","RU":"Russische Federatie","RW":"Rwanda","SA":"Saudi Arabië","SB":"Solomon Islands","SC":"Seychelles","SD":"Sudan","SE":"Zweden","SG":"Singapore","SH":"Sint Helena, Ascension and Tristan da Cunha","SI":"Slovenië","SJ":"Svalbard en Jan Mayen","SK":"Slovakije","SL":"Sierra Leone","SM":"San Marino","SN":"Senegal","SO":"Somalië","SR":"Suriname","SS":"Sui Sudan","ST":"Sao Tome en Principe","SV":"El Salvador","SX":"Sint Maarten (Dutch part)","SY":"Syrië - Arabische Republiek","SZ":"Swaziland","TC":"Turks and Caicos Islands","TD":"Chad","TF":"French Southern Territories","TG":"Togo","TH":"Thailand","TJ":"Tajikistan","TK":"Tokelau","TL":"Timor-Leste","TM":"Turkmenistan","TN":"Tunisia","TO":"Tonga","TR":"Turkije","TT":"Trinidad en Tobago","TV":"Tuvalu","TW":"Taiwan","TZ":"Tanzania, United Republic of","UA":"Ukraïne","UG":"Uganda","UM":"United States Minor Outlying Islands","US":"US - United States","UY":"Uruguay","UZ":"Uzbekistan","VA":"Holy See (Vatican City State)","VC":"Saint Vincent and the Grenadines","VE":"Venezuela, Bolivarian Republic of","VG":"Virgin Islands, UK","VI":"Virgin Islands, U.S.","VN":"Vietnam","VU":"Vanuatu","WF":"Wallis en Futuna","WS":"Samoa","YE":"Yemen","YT":"Mayotte","ZA":"Zuid- Africa","ZM":"Zambia","ZW":"Zimbabwe"},"levels":{"SECONDARY_SCHOOL":"Middelbare school","TECHNICAL":"Technisch","BACHELOR":"Bachelor","MASTER":"Master","POST_GRADUATE":"Post Graduaat","PHD":"PhD","TRAINING_CERTIFICATION":"Opleiding met certificatie","SELF_WITH_CERTIFICATION":"Zelf-studie met certificatie","SELF_WITHOUT_CERTIFICATION":"Zelf-studie zonder certificatie"},"langs":{"en":"English","de":"Deutsch","es":"Español","nl":"Nederlands","fr":"Français","pt":"Portuguese","ru":"Русский","ja":"日本語"}}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports = {"TranslationReviewVersion":{"version":"Langue Bundle Version","version_Number":"02/08/2020"},"login":{"label":"Bienvenue à BrainChain","login_button":"Se connecter","forgot_password_label":"Mot de passe oublié?","haven_t_account_label":"Pas encore de compte?","create_it_now_label":"Créez un compte ici!","create_account_alert":"Quel type de compte voulez-vous créer?","applicant_button":"Candidat","company_button":"Organisation","back_to_login_button":"Retour au login","create_an_label":"Créer un","applicant_account_hint":"compte si vous souhaitez gérer vos diplômes dans BrainChain pour largement faciliter votre recherche d’emploi.","create_a_label":"Créez un","company_account_hint":"compte si votre entreprise envisage de bénéficier de la vérification automatisée des diplômes de candidats avec BrainChain.","more_info_label":"Pour en savoir plus, visitez"},"oauth":{"label":"Bienvenue à BrainChain","sign_in_label":"Vous devez vous connecter pour continuer.","incorrect_request_params_label":"Paramètres de requête non valides","access_info_label":"{client_name} aura accès à votre nom, à votre numéro de téléphone et à votre Email.","logged_in_data_label":"Vous êtes connecté en tant que {user_name}, {user_email}.","accept_label":"Continuer","reject_label":"Refuser","use_another_account_label":"Utiliser un autre compte"},"reset_password":{"label":"Réinitialiser le mot de passe","submit_button":"Reset","incorrect_link_alert":"Lien incorrect","expired_link_alert":"Ce lien a expiré entre-temps.","success_message":"Votre mot de passe a été modifié avec succès."},"change_password":{"label":"Email & mot de passe","change_password":"Changer le mot de passe","old_password_label":"Ancien mot de passe","old_password_input_placeholder":"Ancien mot de passe","submit_button":"Mettre à jour le mot de passe","success_message":"Votre mot de passe a été mis à jour avec succès.","change_password_alert":"Vous allez être guidé vers la page login pour vous connecter avec votre nouveau mot de passe.","change_email":"Changer le Email","change_email_hint":"Veuillez saisir l'adresse Email avec laquelle vous postulez aux emplois.","update_email":"Mettre à jour le Email","change_email_alert":"Nous avons envoyé un lien à votre nouvelle adresse Email pour le confirmer. Veuillez vérifier votre boîte de réception.","finish_change_email":"Votre Email a été changé avec succès. Vous pouvez l'utiliser pour vous connecter à votre compte."},"restore_account":{"label":"Veuillez entrer l'email du compte à restaurer!","submit_button":"Restaurez","success_message":"Votre nouveau mot de passe vous attend dans votre boîte de réception!","link_to_help_text":"Assurez-vous d'avoir activé votre compte. Si vous avez des problèmes, vous pouvez visiter ","link_to_help":"aide","link_to_help_end":"."},"register_applicant":{"label":"Enregistrement du compte du candidat","message":"Veuillez compléter les données ci-dessous pour créer votre compte","success_message":"Nous vous avons envoyé un mail d'activation. Cliquez sur le lien dans l'Email afin de terminer ce processus.","submit_button":"Enregistrez-moi!","back_button":"Retour au login"},"account_management":{"label":"Réglages personnels","open_account_management_menu_label":"Ouvrir menu Réglages personnels","close_account_management_menu_label":"Supprimer menu Réglages personnels"},"org_management":{"label":"Préférences du compte d'organisation"},"aliases":{"label":"Alias","expose_phone_label":"Partager le numéro de téléphone pour emplois potentiels","expose_email_label":"Révéler Email pour emplois potentiels","default_alias_label":"Alias par défaut","set_as_default_alias_label":"Choisir comme alias par défaut","edit_alias_label":"Changer d'alias","delete_alias_label":"Supprimer alias","add_button":"Ajouter alias","add_success_message":"Alias créé avec succès!","edit_button":"Changer alias","edit_success_message":"Alias​ mis à jour avec succès!","remove_title":"Êtes-vous sûr de vouloir supprimer cet alias?","remove_success_message":"Alias supprimé avec succès!","edit_default_alias":"Données personnelles","change_default_alias":"Modifier données personnelles"},"org_staff":{"staff":{"table_label":"Membres du personnel","register_button":"Envoyer une invitation","remove_modal_alert":"Êtes-vous sûr de vouloir supprimer {name} de la liste des membres du personnel?","send_invite_button":"Envoyer invitation","create_success_message":"Membre du personnel enregistré avec succès!","remove_success_message":"Membre du personnel supprimé avec succès!","no_data_label":"Il n'y a pas de membres du personnel"},"accreditation_groups":{"table_label":"Groupes d'accréditation","accreditation_group_name_label":"Nom du groupe d'accréditation","create_accreditation_group_button":"Créer un groupe d'accréditation","create_accreditation_group_success_message":"Groupe d'accréditation créé avec succès!","edit_accreditation_group_success_message":"Groupe d'accréditation mis à jour avec succès!","inserters_label":"insérateurs","validators_label":"Validateurs","employee_input_placeholder":"Sélectionnez membre du personnel ...","role_input_placeholder":"Sélectionnez un rôle ...","employee_label":"Membre du personnel","employees_label":"Membres du personnel","role_label":"Rôle","remove_employee_from_group_alert":"Souhaitez-vous vraiment supprimer ce membre du personnel du groupe d'accréditation?","remove_group_alert":"Êtes-vous sûr de vouloir supprimer ce groupe d'accréditation?","remove_employee_from_group_success_message":"Membre du personnel supprimé avec succès du groupe d'accréditation!","remove_group_success_message":"Groupe d'accréditation supprimé avec succès!","add_employee_to_group_success_message":"Membre du personnel ajouté au groupe avec succès!","no_data_label":"Il n'y a toujours pas de #Facultés# définies.","accreditation_groups_definition_label":"Les 'Facultés' sont pour les universités un moyen d'organiser leurs programmes d'enseignement.","accreditation_group_no_data_label":"Il n'y a aucun membre du personnel dans cette Faculté.","accreditation_group_examples_label":"Génie mécanique; Sciences politiques; Sciences économiques; Biologie","different_from_departments_label":"Ceci est différent de #Départements# ","no_inserters_label":"Aucun insérateur assigné","no_validators_label":"Aucun validateur assigné","no_staff_assigned_label":"Facultés sans insérateur(-s) assigné(-s) ne peuvent pas insérer de diplômes; Facultés sans validateur(-s) assigné(-s) auront leurs diplômes insérés bloqués jusqu'à ce qu'un validateur pour cette faculté soit nommé. Par conséquent, veuillez assurer que pour chaque faculté, au moins un insérateur et un validateur sont assignés.","digital_key_hint":"Rappel gentil: insérateurs ont besoin de la clé numérique (un fichier .jwk) à l'ordinateur même sur lequel ils insèrent des diplômes pour le cryptage numérique. N'oubliez pas de transmettre cette clé -en toute sécurité- avec l'insérateur, et veuillez leur rappeler que cette clé ne doit être importée qu'une seule fois, avant que tout le travail ne commence."},"departments":{"table_label":"Départements","department_name_label":"Nom du Département","department_email_label":"Addresse Email du Département","create_department_button":"Créer un Département","create_department_success_message":"Département créé avec succès!","edit_department_success_message":"Département mis à jour avec succès!","hms_label":"Responsables du recrutement","bos_label":"Chef de groupe","employee_input_placeholder":"Sélectionnez membre du personnel ...","role_input_placeholder":"Sélectionnez rôle ...","employee_label":"Membre du personnel","employees_label":"Membres du personnel","role_label":"Rôle","remove_employee_from_department_alert":"Voulez-vous vraiment supprimer ce membre du personnel du département?","remove_department_alert":"Êtes-vous sûr de vouloir supprimer ce département?","remove_employee_from_department_success_message":"Collègue supprimé du département avec succès!","remove_department_success_message":"Département supprimé avec succès!","add_employee_to_department_success_message":"Employé ajouté au département avec succès!","no_data_label":"Il n'y a toujours pas de #Départements# définis.","department_no_data_label":"Il n'y a pas de membres du personnel dans ce département.","departments_definition_label_uni":"Des Départements reflètent la façon dont une université s'organise comme toute autre organisation.","departments_definition_label_company":"Des départements reflètent la façon dont une entreprise s'organise dans ses groupes fonctionnels.","departments_examples_label":"Ressources humaines (RH); TI; Finance","departments_definition_label_part_2":"Des départements sont définis pour permettre aux entreprises d'utiliser BrainChain; leur personnel peut vérifier les diplômes des personnes que l'on envisage d'embaucher.","different_from_accreditation_groups_label":"Ceci est différent des facultés"},"change_anchor":{"title":"Changer Ancre","modal_alert_message":"Vous pouvez transférer les droits de l'Ancre à un membre actif du personnel.","modal_alert_warning":"(Attention: après cette opération, vous perdrez des droits d'accès partiels.)","success_message":"L'ancre a été modifiée avec succès!","submit_button":"Changer Ancre"}},"activation":{"label":"Activation du compte","activate_applicant_label":"Choisissez un mot de passe pour activer votre compte","linked_employee_label":"Choisissez l'adresse e-mail et le mot de passe de votre compte candidat. Votre compte professionel y sera associé.","activate_personal_data_label":"Veuillez remplir les données ci-dessous pour activer votre compte","activate_password_label":"Veuillez choisir un mot de passe pour achever l'activation de votre compte","haven_t_applicant_account_label":"Vous n'avez pas encore de compte candidat?","create_it_now_label":"Créez-le maintenant!","linked_button":"Suivant","birth_date_label":"Date de naissance","password_label":"Mot de passe","enter_password_label":"Nouveau mot de passe","confirm_password_label":"Confirmer le mot de passe","enter_password_input_placeholder":"Nouveau mot de passe","confirm_password_input_placeholder":"Confirmer le nouveau mot de passe","activate_button":"Activer le compte","enter_password_error_alert":"Le mot de passe doit se composer de 6 à 32 caractères!","confirm_password_error_alert":"Admirable mais ... 1 mot de passe suffira. Veuillez insérer deux fois le même mot de passe! :-) ","activation_link_expired_alert":"Lien d'activation expiré","activation_link_irrelevant_message":"Vous avez déjà achevé avec succès votre enregistrement.","activation_link_irrelevant_forgot_password_message_start":"Si vous avez oublié votre mot de passe, vous pouvez cliquer ","activation_link_irrelevant_forgot_password_message_link":"ici","activation_link_irrelevant_forgot_password_message_end":"pour le réinitialiser.","activation_link_irrelevant_log_in_message_start":"S'il s'agit d'une erreur et que vous vous souvenez de votre mot de passe, vous pouvez vous connecter en suivant","activation_link_irrelevant_log_in_message_link":"ce lien","activation_link_irrelevant_log_in_message_end":".","incorrect_activation_link_alert":"Lien d'activation incorrect","activation_success_message":"Activation réussie!","back_button":"Retour à l'activation du compte professionnel."},"resend_activation":{"success_message":"Activation envoyée de nouveau avec succès!","employee_label":"Envoyer de nouveau Email d'activation à {email}?","anchor_label":"Envoyer de nouveau Email d'activation à {email}?","title":"Envoyer de nouveau activation","submit_button":"Envoyer de nouveau","label":"Veuillez entrer l' Email du compte pour envoyer de nouveau l'activation"},"orgs":{"label":"Organisations","anchor_label":"Ancre","location_label":"Lieu","org_label":"Organisation","org_type_label":"Type d'organisation","add_org":"Ajouter une organisation","name_label":"Nom","has_accreditation_groups_label":"Gestion de groupes d'accréditation","verifies_identities_label":"Gestion d'identités","provides_mooc_certificates_label":"Fournir des certificats MOOC","street_label":"Rue & Nº","postal_label":"Code Postal","city_label":"Ville","company_code_label":"Numéro d'entreprise","vat_number_label":"Numéro TVA","address_label":"Adresse","permissions_label":"Autorisations","unknown_label":"Inconnu","no_data_label":"Il n'y a pas d'organisations.","no_data_to_validate_label":"Il n'y a aucune organisation à valider.","validate_organizations_label":"Valider organisations","validate_organization_label":"Valider organisation","validate_organization_button":"Valider","validate_organization_alert":"Êtes-vous sûr de vouloir valider cette organisation?","back_button":"Retour à la liste des organisations non validées","next_org_button":"Organisation suivante","validate_org_success_message":"Organisation validée avec succès!","financial_data_label":"Données financières","financial_data_placeholder":"Nom de la banque, numéro de compte bancaire, …","inspect_organization_button":"Vérifier","validate_org_progress_label":"Valider","orgs_payments_list_label":"Données financières des organisations","general_data_validated":"Données de base - validées","financial_data_validated":"Données financières - validées","already_validated":"Données partiellement validées - En attente de validation complète par le co-assistant.","remove_org_alert":"Voulez-vous vraiment supprimer cette organisation?","remove_org_success_message":"Organisation supprimée avec succès!"},"register_org":{"register_org_label":"Enregistrer Organisation et Ancre","invite_next_button":"Invitation suivante","send_invitation_button":"Envoyer invitation","success_message":"Organisation et Ancre enregistrées avec succès!","org_type_placeholder":"Sélectionnez le type d'organisation ...","register_button":"Enregistrer","company_registration_label":"Enregistrer Organisation et Ancre","proceed_button":"Suivant","register_org_by_anchor_alert":"N'oubliez pas de transférer (du crédit de votre Organisation)  n'importe quel montant du compte bancaire enregistré. Cela permettra à BrainChain de valider et de finaliser votre inscription.","register_org_by_anchor_hint":"Après avoir activé votre compte, vous pourrez à tout moment vérifier et gérer toutes les informations financières dans la 'Gestion des données financières' (configuration du compte de l'organisation).","domain_hint":"Le domaine Internet est la première partie de l'adresse Web d'une Organisation. Par exemple '.apple.com' ou 'ibm.de'. Si vous souhaitez d'un seul coup enregistrer la société entière avec tous ses sous-domaines, vous pouvez mettre un astérisque au lieu de l'extension du pays spécifique, par exemple 'apple.*' ou 'ibm.*' ","back_button":"Retour au login","company_code_hint":"Dans certains pays en absence d'un numéro TVA, les entreprises sont connues par un autre code d'enregistrement unique comme identifiant.","financial_data_hint_part_1":"Veuillez fournir toutes les données requises afin que nous puissions garantir la transaction provient de votre organisation.","financial_data_hint_part_2":"Comme: votre nom de banque et votre identifiant dans votre banque (= un code client / votre numéro de compte bancaire / ...).","financial_data_hint_part_3":"Ces données sont nécessaires pour distinguer les entreprises légitimes des fausses et des robots, pour que nous conformions aux rapports obligatoires (normes anti-fraude imposées)."},"edit_org":{"org_edit_success_message":"Organisation mise à jour avec succès!","anchor_edit_success_message":"Ancre adaptée avec succès!","back_button":"Retour à la liste des Organisations.","edit_anchor_button":"Changer Ancre","edit_anchor_alert":"Veuillez tout d'abord changer l'Email de l'Ancre avant tout le reste.","bava_label":"BAVA","bava_organization_label":"Organisation BAVA","bava_set_success_message":"Organisation marquée comme BAVA!","bava_removed_success_message":"Le drapeau BAVA a été supprimé avec succès!"},"request_credentials_verification":{"label":"Demande de vérification des Diplômes","success_alert":"Demande réussie","applicant_data_label":"Données du candidad","choose_way_label":"Par quelle voie comptez-vous trouvez un candidat?","your_data_label":"Vos données","hide_your_name_label":"Masquer mon nom au candidat","company_data_label":"Données de l'organisation","reason_for_request_label":"Motif de la demande","reason_for_request_placeholder":"Ajouter un message ici...","get_email_label":"Recevoir Email lorsque le candidat répond à la demande","submit_button":"Traiter la demande","way_label":"Manière","company_name_label":"Nom de l'organisation","modal_title_label":"Concernant","investigate_applicant_label":"Le candidat en question ne fait pas encore partie de la plate-forme BrainChain. Souhaitez-vous que nous demandions à son université de l'ajouter?","ask_colleague_label":"L'un de vos collègues, {firstName} {lastName}, a une demande valide pour ce candidat. Souhaitez-vous concerter avec lui ou préférez-vous soumettre votre propre demande?","request_button":"Soumettre ma propre demande","ask_colleague_button":"Demander à mon collègue","manager_label":"Manager","visible_data_message":"Le candidat aura accès aux données suivantes.","upload_file_label":"Téléverser fichier","emails_label":"Emails","manual_input_label":"Entrée manuelle","manual_input_hint":"Introduisez les addresses Emails des candidats: leurs Emails, séparés par des virgules, des points-virgules, des sauts de ligne ou des espaces.","reference_to_bulk_list_start":"Vous demande peut se rapporter à un seul email ou une série d'Emails à la fois. \n Il y a 2 façons de transmettre une série de Emails: soit en les insérant manuellement au champ ci-dessous, soit en téléversant un document (pour le format correct: voir l'icône \" ? \" ci-dessous). \nSi vous optez pour la série d’ Emails, vous pouvez vérifier leur statut de traitement à ","reference_to_bulk_list_link":"Demande de consentements en vrac","reference_to_bulk_list_end":".","stay_on_this_page_label":"Rester sur la page actuelle","go_to_home_page_label":"Retourner vers la page d'accueil","success_modal_label":"Votre demande a réussi! Souhaitez-vous rester sur cette page ou retourner vers la page d'accueil?","request_unavailable_alert":"La fonctionnalité de demande de consentement n'est pas disponible en ce moment. Veuillez contacter l'ancre de votre organisation pour résoudre le problème."},"main":{"home_page_label":"Page d'accueil","edu_org_staff_page_button":"Gestion du personnel","current_sub_role_label":"Rôle","current_group_label":"Groupe","log_out_button":"Log out","orgs_page_button":"Organisations validées","insert_accreditation_page_button":"Insérer nouveau diplôme (-s)","validate_accreditations_page_button":"Valider Accréditations","review_accreditations_page_button":"Reviser Accréditations échouées","accreditation_groups_page_button":"Groupes d'accréditation","departments_page_button":"Départements","staff_members_page_button":"Personnel","limit_access_label":"Votre organisation a accès limité à certaine fonctionnalité. Si ceci vous étonne, veuillez contacter l'Ancre de votre organisation.","non_validated_org_access_label":"Vous n'avez pas accès à cette fonctionnalité, parce que votre organisation n'a pas encore été validée.","payment_label":"Paiement","help_label":"Aide","bulk_jobs_list_page_button":"Importer en vrac les accréditations","validate_organizations_page_button":"Valider organisations","certified_accreditations_page_button":"Accréditations certifiées","pending_accreditations_page_button":"Accréditations pendantes","vids_page_button":"Identités vérifiées","org_management_button":"Configuration du compte de l'organisation","verification_request_page_button":"Demande de consentement","pending_consents_page_button":"Consentements pendants","active_consents_page_button":"Consentements actifs","consent_requests_page_button":"Consentements demandés","prior_consents_page_button":"Consentement Préalable","applicant_accreditations_select_button":"Diplômes","applicant_consents_select_button":"Consentements","consents_history_page_button":"Historique des consentements","self_study_books_page_button":"Livres d'auto-apprentissage","bulk_consent_requests_page_button":"Demande en vrac de consentements","inserter_accreditations_select_button":"Diplômes","insert_accreditation_shirt_page_button":"Insérer","review_accreditations_shirt_page_button":"Réviser","bulk_jobs_list_shirt_page_button":"Transfert groupé","organizations_select_button":"Organisations","orgs_shirt_page_button":"Validées","validate_organizations_shirt_page_button":"Pendantes","accreditation_requests_list_page_button":"Demandes de vérification de diplômes","validated_accreditation_requests_list_page_button":"Domaines Edu validés","pending_accreditation_requests_list_page_button":"Domaines Edu en attente","pending_accreditation_requests_page_button":"Demandes de consentement pendantes","organization_select_button":"Organisation","accreditation_groups_management_page_button":"Gestion de Facultés","groups_management_page_button":"Départements et facultés","validated_accreditation_requests_by_domain_shirt_page_button":"Validés","pending_accreditation_requests_by_domain_shirt_page_button":"Pendants","security_page_button":"Sécurité","register_org_shirt_page_button":"Enregistrer nouveau","payments_page_button":"Paiements","orgs_payments_page_button":"Données financières des organisations","assistants_page_button":"Assistants","business_ambassadors_page_button":"Ambassadeurs d'affaires","commissions_list_page_button":"Commissions","system_payment_select_button":"Paiement","due_payments_page_button":"Paiements dus","payments_history_shirt_page_button":"Histoire","payments_history_page_button":"Historique des paiements","validated_domains_page_button":"Domaines validés","domains_page_button":"Domaines des universités"},"roles":{"admin_label":"SysAdmin","employee_label":"Employé","applicant_label":"Candidat","anchor_label":"Ancre","inserter_label":"insérateur","validator_label":"Validateur","hm_label":"Responsable du recrutement","bo_label":"Chef de groupe"},"home":{"welcome_label":"Bienvenue à BrainChain","account_and_support_label":"Configuration du compte et support","admin_pages_label":"Pages Admin","choose_role_label":"Choisissez le rôle dans lequel vous voulez travailler","anchor_pages_label":"Pages de l' Ancre","inserter_pages_label":"Pages de l'insérateur","validator_pages_label":"Pages du Validateur","hm_pages_label":"Pages du Responsable du recrutement","bo_pages_label":"Pages du Chef de groupe","applicant_pages_label":"Pages du candidat","account_page_about":"Gestion des paramètres personnels","support_page_about":"Trouvez votre réponse ou envoyez-nous un mail","register_org_page_about":"Créer une nouvelle organisation","organizations_page_about":"Gestion des paramètres des organisations","validate_organizations_page_about":"Valider nouvelles organisations","payment_page_about":"Gestion financière et tarification","organization_staff_page_about":"Gestion du personnel de votre organisation","accreditation_groups_page_about":"Gestion de groupes de diplômes de votre organisation","departments_page_about":"Gestion des départements de votre organisation","review_accreditations_page_about":"Interactions avec Validateurs et Candidats","bulk_accreditations_upload_page_about":"Insérer des diplômes à partir d'un fichier CSV","validate_accreditations_page_about":"Interactions avec Insérateurs et Candidats","credentials_verification_request_page_about":"Créer nouvelle demande de consentement pour candidat","consent_requests_page_about":"Gestion de demandes de consentement pour votre organisation","certified_accreditations_page_about":"Gestion de vos diplômes certifiés","pending_accreditations_page_about":"Gestion des nouveaux diplômes","verified_identities_page_about":"Gestion des identités vérifiées","pending_consents_page_about":"Organisations envisageant de vous embaucher - vous décidez","active_consents_page_about":"Organisations autorisées à vérifier votre diplôme","prior_consents_page_about":"Organisations pour lesquelles vous souhaitez travailler","consents_history_page_about":"Historique complet des demandes de consentement accordées et rejetées","self_study_books_page_about":" Gestion de vos livres d'auto-apprentissage","bulk_consent_requests_page_about":"Gestion des demandes de consentements en vrac pour votre Organisation","accreditation_requests_list_anchor_page_about":"Lier les demandes de vérification du diplôme orphelins aux facultés existantes","validated_accreditation_requests_list_admin_page_about":"Domaines validés (auto-gérés et gérés par BAVA)","pending_accreditation_requests_list_admin_page_about":"Accéder nouvelles demandes de vérification de domaine (candidat)","accreditation_requests_list_admin_page_about":"Gestion des demandes de vérification de diplômes sans référence à une organisation","accreditation_requests_list_applicant_page_about":"Gestion de demandes de vérification de diplômes","security_page_anchor_about":"Signature numérique des diplômes","security_page_inserter_about":"Installer la clé numérique","security_page_admin_about":"Ajouter certificats racines/ des Universités pendants","orgs_payments_page_about":"Compte, tarifs et crédit","assistants_page_about":"Gestion des Assistants","business_ambassadors_page_about":"Gestion des Ambassadeurs d'affaires","commissions_list_page_about":"Gestion des Commissions","due_payments_page_about":"Gestion des paiements dus","payments_history_page_about":"Gestion de l'historique des paiements et du crédit d'entreprise","default_departments_hint":"Pour accommoder les petites entreprises, le Anchre même (le principal contact dans l'organisation) peut faire des demandes de consentement sans aucune autre configuration. Pour les grandes entreprises, nous conseillons de créer au moins un 'Département RH' (étiquette de votre choix), pour ensuite ajouter des recruteurs dédiés par département crée. Puisque les grandes entreprises ont généralement des profils dédiés uniquement à filtrer les personnes qu'elles envisagent d'embaucher.","not_validated_yet":"Votre entreprise n'est pas encore entièrement validée par BrainChain. Jusqu'à la fin de ce processus, accès à toute fonctionnalité sera limitée."},"payment":{"title":"Informations sur le paiement","total_money_label":"Montant total gagné par {orgName}, jusqu'à présent, grâce à BrainChain:","list_label":"Pour payer la licence annuelle, veuillez virer:","account_id_label":"au numéro de compte (IBAN) suivant: {iban}","bank_details_label":"Détails relatifs à la banque et au projet","about_us_label":"Si votre banque a besoin d'informations supplémentaires sur notre banque ou sur BrainChain:","bank_data_label":"Nos données bancaires:","project_label":"BrainChain Project:","org_label":"Organisation: WickedWare","org_address":"Adresse: Virsuliskiu g. 17-9, 05108 Vilnius, Lituanie","create_account_label":"avec le message filaire suivant (s'il s'agit de la première fois que vous payez): ","create_account_message_label":"{orgName} - Create Account","annual_fee_label":"avec le message filaire suivant (si ce n'est pas la première fois que vous payez): ","annual_fee_message_label":"{orgName} - Licence annuelle","edu_org_message_label":"Ce que votre organisation éducative recevra","edu_org_message_company_checks":"Chaque fois que le Diplôme de l'un de vos alumni est vérifié, nous facturons au client une cotisation minime. Nous vous en remboursons 20% au bout de l'année. Le reste permettra de maintenir BrainChain en bon état de fonctionnement! ","edu_org_message_list_title":"Voilà comment nous construisons un système écologique sain, à but non lucratif, et qui profite aux universités:","edu_org_message_list_item_one":"Au lieu de devoir re-valider les diplômes de vos alumni à chaque fois qu'ils changent de travail, vous ne le ferez qu'une fois sur la plate-forme BrainChain. C'est nous qui assumerons ce fardeau tout le reste de leur carrière.","edu_org_message_list_item_two":"Après cette validation unique, chaque fois que l'un de vos alumni est examiné (= lorsqu'ils cherchent un nouvel emploi), l'université reçoit 20% de frais facturés aux entreprises.","edu_org_message_joining":"Ceci signifie qu'en rejoignant BrainChain, l'université est relevée du fardeau de la vérification (à chaque fois!) tout en obtenant une source de revenus durable.","edu_org_message_note_title":"Note:","edu_org_message_note":"Si votre crédit est supérieur à la license annuelle, il sera automatiquement réduit en ce moment, ce qui vous évitera de virer la license annuelle. Evidemment à chaque fois, vous recevrez un courrier expliquant ceci.","wire_label":"Pour payer la licence annuelle, veuillez virer","annual_license_cost_label":"Coût annuel de la licence","wire_delay_label":"Notez que les virements internationales peuvent prendre quelques jours.","bank_data_by_location":{"LT":{"iban_number":"LT643500010003938827","bank_data":"Nom: 'Paysera LT', UAB \nAdresse de la banque: Menulio g. 7, Vilnius, LT-04326, Lituanie"},"BE":{"iban_number":"BE13736065627739 (BIC: KREDBEBB)","bank_data":"Nom: Alverman BV \nAdresse de la banque: Beekstraat 5, 2300 Turnhout, Belgium \nAlverman Nº TVA (= identification de l'organisation): \"BE0736567322\""}}},"finance":{"label":"Finances","balance_label":"Bilan","balance_currency_label":"Devise","balance_change_comment_placeholder":"Laissez votre message ici...","change_label":"Changer","change_balance_label":"Changer le bilan","increase_label":"Augmenter","decrease_label":"Diminuer","change_balance_submit_button":"Accepter modifs","preset_price_label":" Prix prédéfini","paid_till_date_label":"Payé jusqu'à","annual_fee_label":"Cotisation annuelle","request_cost_label":"Coût de la demande de vérification","pay_annual_fee_button":"Payez un an","pay_annual_fee_success_message":"Cotisation annuelle payée avec succès!","change_finance_success_message":"Finances de l'organisation adaptées avec succès!","org_finance_label":"Prix  pour l'organisation","accept_price_and_send_invitation":"Accepter le prix et envoyer une invitation","accept_price_and_validate":" Accepter le prix et valider","prices_label":"Prix","change_balance_modal_label":"Une augmentation du solde reflète le fait que la société a payé sa cotisation annuelle (vérifiée hors ligne par le SA / FA). Une diminution du solde se produit lorsque le SA/FA renvoie de l'argent à une entreprise hors ligne. À la date d'échéance de la cotisation annuelle, cette cotisation est automatiquement soustraite du crédit de l'entreprise.","set_default_label":"Restaurer la valeur par défaut","default_annual_fee_label":"Cotisation par défaut","default_consent_request_fee_label":"Coût par défaut de demande de consentement","deviation_period_label":"Période de déviation","forever_label":"Pour toujours","default_preset_label":"Valeurs par défaut nominales: cotisation annuelle - {annual_fee_amount}, demande de consentement - {consent_request_fee_amount}","agreed_deviation_label":"Déviation accordée: cotisation annuelle - {annual_fee_amount}, demande de consentement - {consent_request_fee_amount}","till_label":"jusqu'à","period_label":"Période","pay_annual_license_alert":"Veuillez payer la cotisation annuelle pour continuer à créer des demandes de consentement.","top_up_balance_alert":"Veuillez recharger votre crédit pour continuer à créer des demandes de consentement.","contact_anchor_alert":"Certaines fonctionnalités ne sont pas disponibles. Contactez l'ancre de votre organisation pour résoudre le problème.","add_year_label":"Ajouter année","paid_till_alert":"Les organisations qui n'ont pas de date 'payé jusqu'à ' dans le #futur#, ne recevront aucun argent des demande de vérification de diplôme."},"help":{"label":"Si vous avez des problèmes ou des questions, n'hésitez pas à contacter {email}.","email":"BenevolentEars@brainchainmission.org","questions_and_answers_label":"Questions et Réponses","question_activation_email":"Je n'ai pas reçu mon Email d'activation","answer_activation_email_start":"Si vous n'avez pas reçu votre Email d'activation, vous pouvez le demander de nouveau ","answer_activation_email_link":"ici","answer_activation_email_end":"."},"page_not_found":{"page_not_found_label":"Page introuvable","sorry_label":"Toutes nos excuses - même nous ne retrouvons pas cette page!","cause_label":"Soit vous n'avez pas accès à cette page, soit elle n'existe plus."},"server_error":{"server_error_label":"Erreur interne du serveur","sorry_label":"Ooops, le serveur refuse le service - quelque chose ondule de la toiture :-/","cause_label":"Vous voulez bien essayer à nouveau plus tard? Notre serveur fait son sommeil de beauté."},"sub_role_missing":{"no_access_label":"Il semble que dans ce rôle, vous n’ayez plus accès à cette fonctionnalité.","continue_label":"Pour continuer, vous serez redirigé vers la page d'accueil."},"org_permissions_missing":{"no_access_label":"Il semble que votre organisation n'ait plus accès à cette fonctionnalité.","continue_label":"Pour continuer, vous serez redirigé vers la page d'accueil."},"accreditation_list":{"label":"Accréditations","title_label":"Titre","date_issued_label":"Date d'émission","level_label":"Niveau","applicant_name_label":"Nom du candidat","location_label":"Lieu","no_data_to_validate_message":"Pas d'accréditations à valider.","no_data_to_review_message":"Pas d'accréditations à reviser.","show_accreditations_by_label":"Afficher accréditations rejetées par","validators_label":"Validateurs","applicants_label":"Candidats","edit_label":"Changer Diplôme","remove_label":"Supprimer Diplôme","no_data_to_review_hint":"Il y a encore d'autres facultés que vous pouvez vérifier"},"bulk_jobs_list":{"label":"Télécharger Diplômes en vrac","no_data_message":"Rien n'a été téléchargé pour le moment","created_at_label":"Créé à","processed_label":"Traités","finished_label":"Terminés","file_name_label":"Nom du fichier","status_label":"Statut","in_progress_label":"En cours ...","remove_bulk_success_message":"Vrac supprimé avec succès!","remove_bulk_alert":"Êtes-vous sûr de vouloir supprimer ce fichier de la liste?","remove_bulk_button":"Arrêter de montrer ce fichier","entries_number_label":"Nombre d'entrées","error_label":"Erreur","global_error_label":"Erreur globale","requestor_label":"Demandeur","bulk_consent_requests_label":"Demandes de Consentement en vrac","no_bulk_consents_data_label":"Aucune demande de consentement en vrac n'a été téléchargée","created_requests_label":"Demandes créées","file_reading_process_label":"Lecture du fichier en cours.","signing_process_label":"Fort occupé à signer tous les Diplômes ...","dont_close_tab_label":"Veuillez ne pas abandonner cette page avant la fin du processus. Cela peut prendre quelque temps, en fonction de la taille du fichier.","insufficient_balance_error_alert_part_1":"Seules {processed} des {total} demandes de consentement ont pu être traitées en raison d'un crédit insuffisant.","insufficient_balance_error_alert_part_2":"Veuillez recharger au moins {amount} avant de procéder les autres. ","flush_remaining_label":"Procéder le reste. "},"accreditation":{"accreditation_group_input_placeholder":"Choisissez un groupe d'accréditation ...","accreditation_title_orig_label":"Titre original","accreditation_title_orig_input_placeholder":"Titre original","accreditation_title_en_label":"Titre anglais","accreditation_title_en_input_placeholder":"Titre anglais","additional_translation_label":"Traduction supplémentaire","add_additional_translations_label":"Ajouter une traduction supplémentaire du titre ","date_issued_label":"Date d'émission","level_label":"Niveau","level_input_placeholder":"Choisissez le niveau ...","person_label":"Personne","language_input_placeholder":"Langue","translation_input_placeholder":"Traduction","title_label":"Titre","accreditation_label":"Accréditation","popover":{"message_placeholder":"Veuillez ajouter un message ici ...","old_value_label":"Contenu ancien","proposed_value_label":"Nouvelle proposition","message_label":"Message","proposed_value_input_placeholder":"insérez votre proposition ici ...","discard_changes_label":"Annuler les modifs","edit_field_label":"Modifier le champ"},"remove_accreditation_success_message":"Diplôme supprimée avec succès!","remove_accreditation_alert":"Êtes-vous sûr de vouloir supprimer ce Diplôme?","next_accreditation_button":"Diplôme Suivant","back_button":"Retour à la liste des Diplômes","show_details_label":"Afficher détails du champ"},"insert_accreditation":{"label":"Insérer Diplôme","success_message":"Diplôme inséré avec succès!","submit_button":"Prêt à être validé!","no_certificate_message_start":"Vous n'avez pas encore installé la clé numérique (unique par université) pour signer les diplômes. Veuillez joindre '","no_certificate_message_link":" la section ","no_certificate_message_end":"' Sécurité d'abord."},"certificate":{"label":"Certificates","add_button":"Ajouter un certificat","about_label":"Pour ajouter un certificat, téléchargez le fichier généré à l'extension '.crt' .","no_data_label":"Il n'y a pas de certificats.","created_at_label":"Créé","valid_from_label":"Valable à partir de","valid_till_label":"Valable jusqu'à","remove_button":"Supprimer Certificat","are_you_sure_label":" Êtes-vous sûr de vouloir supprimer ce certificat?","remove_warning_label":"Attention! Si vous supprimez ce certificat, tous les diplômes s'y rapportant cesseront d'être valides!","insert_certificate_label":"Certificat pour signer le Diplôme","insert_certificate_about_label":"Avant de pouvoir insérer un diplôme, vous devez d'abord télécharger la clé du certificat (fichier à l'extension '.jwk'). Si vous n'avez toujours pas ce fichier, contactez votre Ancre.","change_certificate_button":"Insérer nouvelle clé privée","add_certificate_key_button":"Ajouter Certificat clé","insert_key_button":"Insérer clé","key_already_installed_button":"La clé numérique privée est déjà installée.","no_root_certificate_label":"Vous n'avez pas encore installé un certificat racine.","root_certificate_hint":"Le certificat racine de BrainChain -appelé ca.crt- est généré par l'administrateur système hors ligne et ensuite importé ici. Pour garantir une validation mutuelle, les Insérateurs de l'université doivent importer la clé unique de l'université (= le fichier uni.jwk) dans leur navigateur. Sans certificat racine importé, cela entraînera des erreurs.","no_certificates_needed_label":"Aucun certificat requis - Cette organisation ne signe pas de diplômes","no_org_certificate_label_start":"Le clé numérique de l'université (= le fichier uni.crt) n'a pas encore été installé - veuillez le faire dans la section'","no_org_certificate_label_link":"Sécurité ","no_org_certificate_label_end":" ' après que l'Université a été correctement validée."},"validate_accreditation":{"label":"Valider Diplôme","success_message":"Diplôme validé avec succès!","submit_button_validate":"Valider Diplôme","common_message_label":"Note pour le réviseur","common_message_placeholder":"Laissez votre commentaire ici ...","submit_button_invalidate":"Envoyer pour révision","or_label":"OU","validate_accreditation_message":"Voulez-vous vraiment ignorer les modifications et accepter ce Diplôme?","submit_button_invalidate_title":"Veuillez marquer les champs incorrects, ou laisser un message au réviseur."},"review_accreditation":{"label":"Révision du Diplôme échoué","success_message":"Diplôme réinséré avec succès!","submit_button":"Réinsérer pour validation","message_label":"Message du validateur","feedback_from_validator_label":"Réaction du validateur","feedback_from_applicant_label":"Réaction du candidat","review_accreditation_progress_label":"Traité","reinsert_accreditation_button_hint":"Veuillez réinsérer cette accréditation uniquement avec des modifications qui reflètent le $consensus$ que vous avez obtenu avec le validateur $hors ligne$. Lorsqu'un tel consensus n'est pas possible, veuillez choisir 'Supprimer' - l'accréditation sera alors affichée comme 'Rejetée' dans l'interface du candidat."},"bulk_upload":{"drag_and_drop_label":"Glissez-déposez votre fichier ici","or_label":"Ou","browse_label":"#Cliquez ici # pour pointer vers votre fichier","error_label":"Oufti! Échec de réception du fichier: le format du fichier est incorrect","uploaded_file_label":"Fichier téléchargé","max_file_size_message":"Taille maximale du fichier","exceeded_upload_size_alert":"Hélas, ce fichier est trop volumineux pour être transféré ...","file_format_info_label":"Informations sur le format du fichier","file_format_details_label":"Détails sur le format de fichier","consent_request_bulk_error_label":"Sélectionner un fichier pour continuer","consent_request_bulk_empty_file_label":"Le fichier est vide"},"bulk_file_format_details":{"use_csv_message":"Veuillez respecter le format de fichier (CSV/XML) spécifié.","file_header_message":"Votre fichier devrait avoir l'en-tête suivant:","additional_titles_label":"Codes de langues des traductions supplémentaires","language_code_label":"code de langue","provide_data_message":"Cela signifie que vous devez fournir:","applicant_data_message":"Données du Candidat: adresse Email, prénom, nom de famille, code pays, numéro d'identification nationale","accreditation_data_message":"Données du Diplôme: date d'émission du Diplôme, niveau, titre original, titre en anglais et (facultativement) ses traductions dans d'autres langues.","file_entries_message":"Chaque ligne suivante doit se conformer au format de l'en-tête.","liaise_it_staff":"Veuillez contacter un employé du personnel IT afin de garantir un formatage correct.","back_button":"Retour au téléchargement de Diplômes en vrac","csv_file_example_label":"Exemple d'un fichier au format CSV correct","download_example_button":"Exemple de téléchargement","values_details_label":"Détails des valeurs","email_details":"Pour les Diplômes historiques (= de plus de 2 mois), l'adresse Email est facultative.","date_issued_details":"La date d'émission ne peut pas se situer dans le futur.","levels_label":"Niveaux de Diplôme","titles_label":"Titres des diplômes supplémentaires","header_name_label":"Nom de l'en-tête","required_label":"Obligatoire","format_label":"Format","mean_label":"Valeur","code_label":"Code","email_mean_label":"Email du candidat","first_name_mean_label":"Prénom du candidat","last_name_mean_label":"Nom de famille du candidat","country_code_mean_label":"Code du pays du candidat","national_id_mean_label":"N° d'identification national du candidat","date_issued_mean_label":"Date à laquelle le Diplôme a été délivré (**)","level_mean_label":"Niveau du Diplôme","original_mean_label":"Titre original du Diplôme","en_mean_label":"Titre anglais du Diplôme","lang_code_mean_label":"Traductions supplémentaires du titre du Diplôme (voir tableau avec titres supplémentaires)","email_format":"candidat@email.com","string_format":"Texte","country_code_format":"Code ISO 3166-1 alpha-2","date_format":"AAAA-MM-JJ","level_format":"Code du niveau (voir tableau avec les niveaux de Diplôme)","optional-fields-highlighted-label":"Les champs facultatifs marqués en évidence avec","gray_label":"gris","use_xml_message":"Veuillez vous conformer au format de fichier XML.","csv_file_format_label":"format de fichier CSV","xml_file_format_label":"format de fichier XML","then_provide_message":" Ensuite, vous devriez fournir:","tag_name_label":"Nom de la balise","attributes_label":"Attributs","accreditations_meaning_label":"Conteneur pour la liste des Diplômes","accreditation_meaning_label":"Conteneur pour les détails spécifications du Diplôme","titles_meaning_label":"Conteneur des traductions du titre du Diplôme","title_meaning_label":"Traduction du titre. L'attribut est le code de la langue utilisée - langue originale ou traduction supplémentaire (voir tableau).","title_details":"Le titre original du Diplôme original est un champ obligatoire.","xml_file_example_label":"Exemple de fichier au format XML","consent_bulk_file_info_label":"Veuillez respecter le format de fichier TXT ou CSV. Le fichier doit comprendre les adresses Emails des candidats, séparées par des virgules, des points-virgules, des sauts de ligne ou des espaces."},"applicant_accreditations_management":{"certified_accreditations_label":"Accréditations Certifiées","issued_by_label":"Delivré par","expose_certified_accreditations":"Exposer","no_data_label_part_1":"Il n'y a pas de $Diplômes Certifiés$. $Diplômes Certifiés$ sont des diplômes confirmés par votre université. Si aucun n'est présent, vous pouvez en faire la demande sous 'Demandes de vérification de diplôme'. ","no_data_label_part_2":"Nous regroupons ces demandes avec d'autres diplômés jusqu'à ce que votre université rejoigne BrainChain. Via notre ","no_data_label_part_3":"site Internet","no_data_label_part_4":",  vous pouvez également inciter votre université à s'engager avec BrainChain si cela n'est toujours pas le cas!","accreditation_details_label":"Détails du Diplôme","remove_accreditation_alert":"Voulez-vous vraiment supprimer ce diplôme?","remove_accreditation_success_massage":"Diplôme supprimé avec succès!","pending_accreditations_label":"Diplômes en attente","accept_accreditation_button_label":"Accepter Diplôme","send_back_accreditation_button_label":"Envoyer pour révision","discard_accreditation_message":"Êtes-vous sûr de vouloir supprimer ce Diplôme?","discard_accreditation_warning_message":"Attention! En cas de refus, le Diplôme sera (complètement) supprimé!","discard_accreditation_button_label":"Supprimer Diplôme","vids_label":"Identités vérifiées","expose_fn_ln_country":"Révéler Nom et Pays","expose_national_id":"Révéler Nº d'Identification National","expose_nid_option_full":"Mon numéro d'identification nationale peut être exposé en entier","expose_nid_option_short":"N'exposer que les 4 derniers chiffres de mon identification nationale","expose_nid_option_not_expose":"Ne jamais exposer mon identification nationale","no_vids_label":"Il n'y a pas d' $Identités Vérifiées$. $Identités Vérifiées$ sont des identités confirmées par votre université et accompagnées de diplômes confirmés.","active_vid_label":"Actives","active_vid_title_checked":"'Identité vérifiée active","active_vid_title_unchecked":"'Activez l'identité vérifiée","show_details_label":"Montrer les détails du diplôme","no_pending_accreditations_label":"Il n'y a pas de $Diplômes en attente$. Après avoir demandé à votre université de confirmer votre diplôme, et après que votre université l'a confirmé, vos diplômes seront répertoriés ici avec un statut indiquant cette validation unilatérale (temporelle!). Les employeurs potentiels peuvent déjà les voir, mais ils seront marqués comme tels jusqu'à ce qu'ils soient confirmés des deux côtés (le vôtre aussi!)."},"license_agreement":{"agree_label":"J'accepte les termes du","agree_link":"contrat de licence."},"consents":{"status":{"ALL":"Tous","PENDING":"Pendant","GRANTED":"Approuvé","REJECTED":"Refusé","REVOKED":"Révoqué","EXPIRED":"Expiré","CANCELED":"Annulé","ABANDONED":"Abandonné"},"status_title":{"PENDING":"Demande Pendante","GRANTED":"Demande Approuvée","REJECTED":"Demande Refusée","REVOKED":"Demande Révoquée","EXPIRED":"Demande Expirée","CANCELED":"Demande Annulée","ABANDONED":"Demande Abandonnée"},"no_data_label":"Il n'y a pas de demande de consentement.","show_consents_list_label":"Ouvrir la liste des demandes de consentement","hide_consents_list_label":"Retour aux détails de la demande de consentement","no_selected_consent_request_label":"Sélectionnez une demande de consentement dans la liste afin de voir ses détails.","edit_label":"Modifier la demande de consentement","cancel_request_success_message":"Demande annulée avec succès!","request_details_label":" Détails de la demande","target_label":"Bénéficiaire","created_by_label":"Créé par","hidden_for_applicant_label":"Masquer aux candidats","credentials_label":"Diplômes","issued_at_label":"Délivrés par","cancel_request_button_label":"Annuler la demande","cancel_request_warning_label":"Attention! Vous ne verrez plus cette demande de consentement dans la liste après votre annulation.","cancel_request_are_you_sure_label":"Êtes-vous sûr de vouloir annuler la demande de consentement?","applicant_response_label":"Réponse du candidat","last_update_label":"Dernière mise à jour","expires_label":"Expire","expired_label":"Expiré","revoked_label":"Révoqué","pending_consents_label":"Consentements pendants","periods":{"week_label":"Semaine","month_label":"Mois","year_label":"Année","forever_label":"Pour toujours"},"consent_end_date_alert":"Votre consentement expirera le","active_consents_label":" Consentements actifs","requested_label":"Demandé","valid_till_label":"Valable jusqu'au","grant_consent_button":"Approuver le consentement","current_expire_date_label":"Date d'expiration actuelle","next_expire_date_label":"Date d'expiration suivante","extend_consent_button":"Prolonger le consentement","remove_consent_label":"Révoquer le consentement","remove_consent_button":"Révoquer","remove_consent_success_label":"Consentement révoqué avec succès!","remove_modal_alert":"Vous êtes sûr de vouloir supprimer ce consentement?","person_label":"Personne","none_label":"Aucun","no_active_consents_label":"Vous n'avez pas encore de consentement actifs.","no_pending_consents_label":"Vous n'avez pas encore de consentement pendants","next_consent_button":"Demande suivante","status_filter_label":"Statut","job_label":"Job","job_filter_placeholder":"Entrez le titre du Job pour la recherche","job_title_label":"Titre du job","internal_job_reference":"Référence interne du Job","expose_job_reference":"Partager la référence interne du Job avec le candidat","note_to_applicants_label":"Note au(x) candidat(s)","consents_history_label":"Historique des consultations","show_consents_with_status_label":"Montrer les consentements avec leur statut","consents_history_no_data_label":"Votre historique de consultation est vide","status_label":"Statut","expired_on_label":"Expiré le","dismiss_request_button_label":"Rejeter la demande","dismiss_request_warning_label":"Attention! Vous ne verrez plus cette demande de consentement dans la liste après sa suppression.","dismiss_request_are_you_sure_label":"Êtes-vous sûr de vouloir rejeter la demande de consentement?","self_study_books_label":"Livres d'auto-apprentissage","accreditations_label":"Diplômes","remove_bulk_consent_requests":"Êtes-vous sûr de vouloir supprimer ce fichier?","verified_by_applicant_only_label":"Vérifié par: Vérifié uniquement par le Candidat"},"prior_consents":{"prior_consents_label":"Consentements préalables","prior_consents_no_data_label":"Vous n'avez pas encore de consentements préalables","target_type_label":"Type de bénéficiaire","target_data_label":"Bénéficiaire","auto_grant_till_label":"Auto-accorder jusqu'à","duration_label":"Durée","anyone_label":"A n'importe qui","day_label":"journée","days_label":"journées","add_prior_consent_label":"Créer consentement préalable","edit_prior_consent_label":"Changer consentement préalable","target_type_input_placeholder":"Sélectionner type de bénéficiaire ...","add_prior_consent_success_message":"Consentement préalable créé avec succès!","edit_prior_consent_success_message":"Consentement préalable mis à jour avec succès!","period_label":"Durée","duration_alert":"La durée du consentement sera","response_comment_label":"Réponse automatique aux demandeurs","response_comment_placeholder":" Laissez votre message ici ...","remove_prior_consent_label":"Supprimer consentement préalable","remove_prior_consent_success_message":"Consentement préalable supprimé avec succès!","remove_prior_consent_alert":"Êtes-vous sûr de vouloir supprimer ce consentement préalable?","prior_consents_hint_part_1":"Un consentement préalable est un consentement que vous configurez maintenant et qui sera exécuté immédiatement et automatiquement, sans vous déranger à nouveau au moment où il est demandé par une entreprise.","prior_consents_hint_part_2":"Cela signifie que les entreprises que vous ajoutez ci-dessous, qui envisagent de vous embaucher, recevront une confirmation immédiate des diplômes que vous avez choisi de révéler ... au moins jusqu'à la date «Auto-accorder jusqu'à» .","prior_consents_hint_part_3":"Le champ «Durée» spécifie la durée de validité de ce consentement. Par exemple, si vous choisissez un mois, cela signifie que les collègues du premier demandeur - d'autres collègues RH, votre patron potentiel (!), .... - de la même entreprise peuvent également le vérifier dans le mois qui suit le premier consentement. Par ailleurs, une fois ce mois écoulé, une nouvelle demande doit être faite par eux, que BrainChain vérifie ensuite par rapport à la date «Auto-accorder jusqu'à»!"},"approve_consent_after_request":{"label":"Approuver le consentement après la demande","success_alert":"Approbation réussie de la demande de consentement","consent_requestor_label":"Demandeur du consentement","grant_title_label":"Accorder","refuse_title_label":"Refuser","grant_button":"Accorder","refuse_button":"Refuser","company_name_label":"Nom de l'organisation","company_country_label":"Pays de l'organisation","request_date":"Date de la demande","period_label":"Durée","period_input_placeholder":"Choisir une période ...","reason_label":"Motif","reason_input_placeholder":"Choisir motif ...","reasons":{"TIMING1":"Je ne suis pas à le recherche d'un (autre) Job","TIMING2":"Je ne serai libre que dans au moins un an d'ici","INTEREST":"Cela ne m' intéresse pas de travailler pour cette organisation","MISMATCH":"Ce Job semble ne pas trop aligné à mes compétences","ANOTHER":"Autre raison"},"comment_label":" Laisser un message au demandeur","comment_placeholder":"Laisser votre message ici...","back_button":"Retour","approve_consent_progress_label":"Accordé"},"notification_settings":{"label":"Notifications","notification_settings_label":"Paramètres de notification","notification_new_accreditation_enabled":"Envoyez-moi un Email si je dois vérifier de nouveaux diplômes","notification_consent_request_enabled":"Envoyez-moi un e-mail si employeur potentiel nous demande de confirmer votre diplôme","notification_settings_update_success_alert":"Paramètres de notification mis à jour avec succès","no_settings_label":"Pour le moment, aucun paramètre de notification n'est requis.","preferred_language":"Langue préférée pour les notifications"},"security_settings":{"label":"Sécurisation","2fa_label":"Authentification à 2 facteurs","current_status_label":"Statut actuel:","2fa_disabled_label":"Authentification à 2 facteurs désactivée.","2fa_enabled_label":"Authentification à 2 facteurs activée.","disable_2fa_submit_button":"Désactiver authentification à 2 facteurs","enable_2fa_submit_button":"Activer authentification à 2 facteurs","disable_2fa_are_you_sure_message":"Êtes-vous sûr de vouloir désactiver l'authentification à 2 facteurs? Après avoir désactivé cette authentification, vous pouvez vous connecter à votre compte en utilisant uniquement votre Email mot de passe, sans entrer de code de vérification.","disable_2fa_success_message":"Authentification à 2 facteurs désactivée avec succès!","enable_2fa_scan_qr_code_message":"Pour activer l'authentification à 2 facteurs, lisez le code QR à l'aide du Google Authenticator ou d'une autre application qui vous convient. L'application choisie vous permettra de recevoir des codes de vérification pour vous connecter à votre compte.","links_label":" Liens vous connectant aux applications d'authentification","google_authenticator_android_label":"Google Authenticator pour Android","google_authenticator_ios_label":"Google Authenticator pour iOS","free_otp_android_label":"FreeOTP Authenticator pour Android","free_otp_ios_label":"FreeOTP Authenticator pour iOS","update_warning":"Vous devez lire un nouveau code QR chaque fois que vous activez l’authentification à 2 facteurs pour obtenir un code mis à jour.","enable_2fa_check_code_message":"Pour vous assurer que tout fonctionne correctement, vous pouvez entrer le code de vérification reçu après avoir lu le code QR.","enable_2fa_parameters_label":"Paramètres d'authentification","issuer_label":"Délivré par","secret_label":"Secret","algorithm_label":"Algorithme","digits_label":"Caractères","period_label":"Durée","check_code_label":"Code de vérification","enable_2fa_success_message":"Authentification à 2 facteurs activée avec succès!","2fa_contact_support_message":"Si, pour une raison quelconque, vous avez perdu l'accès à l'application QR et si donc vous ne pouvez plus obtenir de code de vérification, contactez le support.","verification_code_details_label":"Le code de vérification doit comporter six caractères.","verification_code_enter_label":"Pour obtenir le code d'authentification à 2 facteurs correct, veuillez consulter l'application du générateur de code que vous avez choisie lors de son activation."},"self_study":{"table_label":" Livres d'auto-apprentissage","no_data_label":"Vous n'avez pas de $livres d’auto-apprentissage$ pour le moment. Les livres que vous lisez ou étudiez par vous-même peuvent être ajoutés ici et ne nécessitent aucune confirmation externe. Ceci montre votre intérêt et effort; aucune preuve d'éducation formelle.","domain_label":"Domaine","publisher_label":"Éditeur","study_date_label":"Date de la lecture","isbn_label":"ISBN","domains":{"ADMINISTRATION_AND_MANAGEMENT":"Administration & gestion","COMMUNICATION":"Communication","CULTURE_AND_SPORTS_AND_ENTERTAINMENT":"Culture, sport & divertissement","GOV":"Gouvernement","IT":"IT","LAND_AND_SEA_AND_AIR":"Terre & Mer & Air","LEGAL":"Loi","LIFE_AND_DEATH":"Vie & mort","MANUFACTURING_AND_WORKING_WITH_MATERIALS":"Fabrication & travail des matériaux","SALES_AND_MARKETING":"Ventes & Marketing","SERVICES":"Services","STEM":"STEM","OTHER":"Autre"},"domains_examples":{"ADMINISTRATION_AND_MANAGEMENT":"employé de bureau, secrétaires, cadres, ...","COMMUNICATION":"Journalisme, Audio / Vidéo, ...","CULTURE_AND_SPORTS_AND_ENTERTAINMENT":"tourisme, acteur, strip-teaseuse, hôtellerie, ...","GOV":"éducation, armée, police, greffier municipal, ...","IT":"développeur, ML, AI, concepteur web, DBA, architecte logiciel, ...","LAND_AND_SEA_AND_AIR":"agriculteur, pêcheur, astronaute, pilote, hôtesses de l'air, jardinier, ...","LEGAL":"notaire, avocat, ...","LIFE_AND_DEATH":"médecin, vétérinaire, thérapeute, dentiste, infirmière, tireur d'élite, coroner, ...","MANUFACTURING_AND_WORKING_WITH_MATERIALS":"bûcheron, soudeur, textile, assemblage automobile, minier, ouvrier du bâtiment, ...","SALES_AND_MARKETING":"boulanger, pièces auto, immo, location, promotion, ...","SERVICES":"Service de nettoyage, coiffeur, recrutement, assurances, banquier, transport, comptabilité, distribution, ...","STEM":"Science (Pharma), Technologie (mécanique automobile, électricien), Ingénierie (ingénieur agricole, architecte), Mathématiques"},"add_self_study_book_success_message":"Livre d’auto-apprentissage ajouté avec succès!","edit_self_study_book_success_message":"Livre d’auto-apprentissage mis à jour avec succès!","add_self_study_book_label":"Ajouter livre au répertoire d'auto-apprentissage","edit_self_study_book_label":"Modifier livre d'auto-apprentissage","domain_select_placeholder":"Sélectionnez domaine ...","expose_self_study_book_label":"Révéler livre d'auto-apprentissage","remove_self_study_book_alert":" Êtes-vous sûr de vouloir supprimer ce livre d'auto-apprentissage?","remove_self_study_book_success_message":"Livre d'auto-apprentissage supprimé avec succès!","isbn_format_hint":"La norme ISBN 10/13 est un code international d’identification de livres. Veuillez adhérer à ce format.","expose_label":"Révéler","error_messages":{"isbn_alert":"Veuillez utiliser le format ISBN10 ou ISBN13."}},"notifications":{"pending_organizations":"Vous avez {number} d'organisations en attente","review_failed_accreditations":"Vous avez {number} de Diplômes échoués à réexaminer","validate_accreditations":"Vous avez {number} de Diplômes à valider","pending_accreditations":"Vous avez {number} de Diplômes en attente","pending_consents":"Vous avez {number} de Consentements en attente","pending_accreditation_requests":"Vous avez {number} de demandes de Diplômes en attente","unreferenced_accreditation_requests_by_ags":"Vous avez {number} demandes de vérification de Diplômes sans lien avec aucune groupe de Diplôme (Faculté).","unreferenced_accreditation_requests_by_domains":"Vous avez {numéro} demandes de vérification de Diplômes sans lien avec une université quelconque"},"accreditation_requests":{"create_accreditation_request_label":"Créer une demande de vérification de Diplôme","create_accreditation_request_success_message":"Demande de vérification de Diplôme créée avec succès!","create_accreditation_request_hint":"Si votre Alma Mater fait déjà partie de la plate-forme BrainChain, vous pouvez  le 'Sélectionner' dans les champs ci-dessous. Si ceci n'est pas le cas, veuillez aller avec 'Entrée Manuelle' et assurez-vous d'entrer le domaine internet correct et actuel  (il a peut-être changé avec le temps) de votre Alma Mater.","domain_hint":"Un domaine Internet est la première partie de l'adresse Web d'une organisation. Par exemple, 'apple.com' ou 'ibm.de'.","accreditation_group_hint":"Un groupe de Diplômes est essentiellement le nom de la #Faculté# qui a délivré votre Diplôme. Par exemple, #Economie# ou #Psychologie#, selon la manière dont  votre Alma Mater s'est organisée.","national_id_hint":"Tous les pays identifient leurs citoyens moyennant un numéro unique. Ceci afin d'éviter toute ambiguïté, le cas échéant par exemple pour les personnes portant le même nom. Cela s'impose pour savoir à qui appartient quel Diplôme, cela est très important. Puisque cela nous permet de vous garantir que même une personne portant exactement le même nom que vous, ne sera jamais en mesure de vous voler votre identité ou de prétendre avoir obtenu votre Diplôme! ","national_id_expose_hint":"Le numéro d'identité nationale ne sera exposé en sa totalité qu'au candidat. Le candidat pourra modifier les paramètres de visibilité à tout moment.","manual_org_input_mode_label":"Entrer données de l'organisation manuellement","select_org_input_mode_label":"Choisir organisation","manual_accreditation_group_input_mode_label":"Entrer (groupe de Diplôme) Faculté manuellement","select_accreditation_group_input_mode_label":"Choisir (groupe de Diplôme) Faculté","manual_vid_input_mode_label":"Entrer les données VID ('Identité Vérifiée') manuellement","select_vid_input_mode_label":"Choisir VID","vid_label":"Identité Verifiée","status":{"REQUEST_SUBMITTED":"Demande soumise","REQUEST_IN_PROCESS":"En cours","REQUEST_REJECTED":"Demande rejetée"},"status_label":"Statut de la demande","expose_label":"Révéler Diplôme","edit_accreditation_request_label":"Modifier demande de vérification de Diplôme","remove_accreditation_request_label":"Supprimer la demande de vérification de Diplôme","accreditation_requests_no_data_label":"Vous n'avez pas encore de demandes de vérification du Diplôme","accreditation_requests_label":"Demandes de vérification du Diplôme","accreditation_request_remove_alert":"Êtes-vous sûr de vouloir supprimer cette demande de vérification du Diplôme?","edit_accreditation_request_success_message":"Demande de vérification du Diplôme mise à jour avec succès!","pending_accreditation_requests_by_domain_label":"Pending Diploma Verification requests by Domain","validated_accreditation_requests_by_domain_label":"Validated Diploma Verification requests by Domain","accreditation_requests_list_no_data_label":"Il n'y a pas encore de demandes de vérification du Diplôme.","organization_domain_label":"Domaine de l'organisation","accreditation_requests_number_label":"Nombre de demandes de vérification du Diplômes","filter_by_domain_label":"Filtrer par Domaine","filter_label":"Filtrer","accreditation_requests_remove_alert":"Êtes-vous sûr de vouloir supprimer cette demande de vérification du Diplôme?","remove_accreditation_request_success_message":"Demande de vérification du Diplôme supprimée avec succès!","remove_accreditation_requests_success_message":"Demandes de vérification du Diplôme supprimées avec succès!","update_accreditation_requests_success_message":"Le domaine des demandes de Diplômes a été mis à jour avec succès!","accreditation_requests_warning_alert":"Il paraît que cette organisation a {number} de demandes du Diplômes. Si cette organisation est enregistrée sans avoir la permission d'enregistrer des Diplômes, toutes les demandes de vérification du Diplômes pendantes des candidats seront supprimées!","proceed_button":"Continuer","accreditation_requests_by_group_label":"Demandes de vérification des Diplômes par groupe","accreditation_requests_by_group_hint_part_1":"Ici, vous pouvez lier les demandes de vérification des candidats (liste ci-dessous) à une Faculté (groupe de Diplômes) existante de votre université.","accreditation_requests_by_group_hint_part_2":"Une fois liées, ils seront acheminées vers l(es)' insérateur(-s) approprié(s).","accreditation_requests_by_group_hint_part_3":"Notez que vous pouvez grouper plusieurs demandes du même groupe de Diplôme (de la même Faculté).","set_accreditation_group_for_selected_button":"Fixer (le groupe de Diplômes) la Faculté pour les demandes sélectionnées","reject_selected_button":"Rejeter sélection","reject_accreditation_requests_alert":" Êtes-vous sûr de vouloir rejeter toutes les demandes de vérification du Diplômes sélectionnées?","reject_button":"Rejeter","set_accreditation_group_for_selected_requests_label":"Fixer la Faculté pour les demandes de vérification des Diplômes sélectionnées","set_accreditation_group_for_selected_requests_success_message":"Référence de la Faculté ajoutée avec succès!","expose_accreditation_request_label":"Révéler demande de vérification du Diplôme","pending_accreditation_requests_label":"Demande de vérification du Diplôme en attente","pending_accreditation_requests_no_data_label":"Il n'y a pas de demande de vérification du Diplôme.","pending_accreditation_requests_hint_part_1":"Si les données sont correctes, vous pouvez tout simplement #Confirmer# la demande. Si vous n'êtes pas sûr, vous pouvez cliquer sur #Suivant# pour ignorer la demande en question.","pending_accreditation_requests_hint_part_2":"Si les données du Diplôme à certifier contiennent des informations erronées, vous pouvez les corriger avant de les insérer.","back_button":"Retour à la liste des demandes (de vérification) des Diplômes en attente","process_accreditation_request":"Traiter la demande","next_accreditation_request_label":"Demande suivante","confirm_accreditation_request_button":"Confirmer et insérer","reject_accreditation_request_alert":"Êtes-vous sûr de vouloir rejeter cette demande de vérification du Diplôme?","organization_label":"Organisation","applicant_email_label":"Email du Candidat","expose_hint":"Vous pouvez choisir de déjà exposer les diplôme non-validés à des employeurs potentiels, mais ils seront marqués comme 'non-validés' jusqu'à ce que l'Université les ait également confirmés.","created_at_label":"Date de la demande","org_by_domain_error_alert":"Oufti! Il paraît que cette organisation ne dispose pas de la permission d'insérer des Diplômes.","accreditations_pending_approval_label":"Diplômes en attente d'approbation","accreditation_requests_details_label":"Détails de la demande de vérification du Diplôme","reject_accreditation_request_success_message":"Demandes de vérification du Diplôme rejetées avec succès!","confirm_accreditation_request_success_message":"Demande de vérification du Diplôme confirmée avec succès!","pending_accreditations_progress_label":"Inséré","validated_accreditations_progress_label":"Validé","validate_button":"Valider","accreditation_requests_validate_alert":"Voulez-vous valider cette demande de vérification de diplôme?","validate_accreditation_requests_success_message":"Demandes de vérification de diplôme validées avec succès!","pending_accreditation_requests_list_no_data_label":"Il n'y a aucune demande de vérification de diplôme en attente.","validated_accreditation_requests_list_no_data_label":"Il n'y a pas encore de demande de vérification de diplôme approuvée.","last_requestors_button":"Derniers candidats","applicant_accreditation_consent_label":"J'accepte par la présente la BAVA (BrainChain Accreditation Vetting Authority) de gérer la vérification et de me tenir informé."},"security":{"label":"Sécurité","got_it_button":"OK","anchor_info_part_1":"Toutes les communications avec BrainChain se font en toute sécurité en utilisant une clé de cryptage numérique forte. Cela enveloppe en toute sécurité les données du diplôme pour éviter de jeter un œil furtif et de les falsifier. Vous obtenez cette clé - un fichier avec l'extension «.jwk» - sur simple demande de BrainChain.","anchor_info_part_2":"Votre rôle en tant qu'Ancre signifie que vous devez partager ces clés de manière prudente (= de préférence hors ligne, par exemple sur une clé USB), avec tous les Insérateurs que vous nommez.","anchor_info_part_3":"Sans cette clé, ces Insérateurs ne pourront pas insérer de diplômes.","inserter_info_part_1":"Toutes les communications avec BrainChain se font en toute sécurité en utilisant une clé de cryptage numérique forte. Cela enveloppe en toute sécurité les données du diplôme pour éviter de jeter un œil furtif et de falsifier. Votre ancre obtient cette clé de BrainChain et vous la transmet; cette clé est un fichier avec l'extension «.jwk» .","inserter_info_part_2":"Pour commencer, il vous suffit de déposer ou d'importer ce fichier ci-dessous, sur le même ordinateur  que vous utiliserez pour insérer les diplômes.","inserter_info_part_3":"Il s'agit d'un effort unique par ordinateur que vous utilisez pour ce but.","inserter_info_part_4":"Une fois la clé installée, le cryptage et la signature du diplôme seront effectués en arrière-plan de manière transparente, sans aucune autre action requise.","admin_root_certificates_label":"Gestion du le certificat racine BrainChain","admin_universities_label":"Universités validées - en attendant que l'on leur télécharge leur clé côté serveur","admin_universities_info_part_1":"A côté du certificat racine BrainChain, il existe un deuxième composant dont les universités ont besoin qu'on installe chez nous du côté serveur: le certificat généré unique à chaque université :uni.crt.","admin_universities_info_part_2":"Vous trouverez ci-dessous la liste des universités validées qui n'ont pas encore installé cette clé et qui l'attendent. Cela peut être fait juste après la validation universitaire: maintenant! Une fois cette clé installée, n'oubliez pas de envoyer également à l'Anchre de l'Université son propre fichier uni.jwk. Ce clé doit être généré par le SA hors ligne.","add_valid_till_label":"Ajouter / Valide jusqu'à","add_certificate_button":"Ajouter uni.crt","mail_anchor_label":"Envoyer Anchre le uni.jwk ","is_uni_key_sent_label":"Clé Uni enoyé?","confirm_sent_button":"Confirmer envoi","mail_subject_label":"Votre clé numérique BrainChain pour signer des diplômes en toute sécurité","mail_body_part_1":"Cher {anchor},","mail_body_part_2":"Toutes les communications avec BrainChain se font en toute sécurité en utilisant une clé de cryptage numérique forte. Cela enveloppe en toute sécurité les données du diplôme pour éviter de jeter un œil furtif et de falsifier. Cette clé - un fichier avec extension «.jwk» - est ajoutée à ce courrier.","mail_body_part_3":"Votre rôle en tant qu'Ancre signifie que vous devez partager ces clés de manière prudente (= de préférence hors ligne, par exemple sur une clé USB), avec tous les Insérateurs que vous nommez.","mail_body_part_4":"Sans cette clé, ils ne pourront pas insérer de diplômes.","mail_body_part_5":"Si vous l'oublieriez, l'application BrainChain vous en rappellera dans la section Sécurité","mail_body_part_6":"Équipe BrainChain"},"assistants":{"assistants_label":"Assistants","no_data_label":"Il n'y a pas encore d'assistants.","roles_label":"Rôles","location_label":"Location","process_assistant_label":"Assistant de processus (PA)","financial_assistant_label":"Assistant financier (FA)","add_assistant_page_label":"Ajouter Assistant","roles_select_placeholder":"Sélectionner le rôle d'assistant...","remove_assistant_alert":"Voulez-vous vraiment supprimer cet assistant?","edit_assistant_alert":"Modifier Assistant"},"business_ambassadors":{"business_ambassadors_label":"Ambassadeurs d'affaires","no_data_label":"Il n'y a pas encore d'ambassadeur d'affaires.","financial_data_label":"Données financières","add_business_ambassador_label":"Ajouter Ambassadeur d'affaires","edit_business_ambassador_label":"Modifier Ambassadeur d'affaires","add_business_ambassador_success_message":"Ambassadeur d'affaires ajouté avec succès!","edit_business_ambassador_success_message":"Ambassadeur d'affaires modifié avec succès!!","remove_ambassador_alert":"Voulez-vous vraiment supprimer cet Ambassadeur d'affaires?"},"commissions":{"commissions_list_label":"Commissions","countries_label":"Pays","commission_label":"Commission","date_from_label":"Date 'de' ","date_to_label":"Date 'à' ","no_data_label":"Il n'y a pas de commissions.","remove_commission_success_message":"Commission supprimée avec succès!","remove_commission_alert":"Voulez-vous vraiment supprimer cette commission?","add_commission_label":"Ajouter Commission","edit_commission_label":"Modifier Commission","add_commission_success_message":"Commission créée avec succès!","edit_commission_success_message":"Commission modifié avec succès!","ba_label":"Ambassadeur d'affaires","ba_short_label":"BA","add_commission_hint":"De nouvelles commissions peuvent être définies ci-dessous pour les # Ambassadeurs d'affaires #définis précédemment."},"system_payment":{"due_payments_label":"Paiements Dus","ba_s_due_payments_label":"Paiements dus aux ambassadeurs d'affaires","uni_s_due_payments_label":"Paiements dus à l'éducation partout dans le monde","system_due_payments_label":"Paiement du à WickedWare","system_due_payments_hint":"Ce numéro représente le montant à transférer du compte WickedWare 'BrainChain' sur le compte 'Épargne' WickedWare (LT773500010003830341). Il s'agit de l'encours des crédits d'entreprises consommés","filter_by_region_label":"Filtrer par Région","ba_label":"BA","uni_label":"Uni","amount_label":"Montant dû","total_aggregated_pay_label":"Paiement total agrégé","ba_wire_data_label":"BA - données de virement","uni_wire_data_label":"Uni - données de virement","record_payment_label":"Enregistrer Paiement","paid_button":"Confirmation du paiement hors ligne","no_ba_s_label":"Il n'y a pas de BA.","no_uni_s_label":"Il n'y a pas d'universités.","no_payments_for_ba_s_label":"Aucun paiement aux BA ne répond à ces critères","no_payments_for_uni_s_label":"Aucun paiement aux Universités ne répond à ces critères","no_payments_for_system":"Il n'y a aucun paiement dû pour WickedWare.","show_label":"Montrer","due_payments_paid_success_message":"Paiements dus payés avec succès!","payments_history_label":"Historique des paiements","uni_s_payments_history_label":"Historique des paiements à l'éducation partout dans le monde","ba_s_payments_history_label":"Historique des paiements aux Ambassadeurs d'affaires","payment_date_label":"Date de Paiement","filter_date_from_label":"Date 'de'","filter_date_to_label":"à","name_label":"Nom","company_credit_label":"Crédit de l'organisation","date_joined_label":"Date de rejoignement","open_credit_label":"Crédit ouvert","total_credit_label":"Crédit total consommé","contact_label":"Contact","no_companies_credits_label":"Aucun crédit d'organisation répond à ces critères.","order_by_label":"Trier par","due_payment_modal_label":"Paiement du pour {name}","wire_data_modal_label":"Données de virement de {name}","comment_label":"Commentaire","no_company_credits":"Aucune historique de crédit pour cet entreprise,","date_label":"Date","value_of_change_label":"Valeur du changement","credit_history_label":"Historique de crédit pour {name}"},"validated_domains":{"validated_domains_label":"Domaines Edu validés","no_data_label":"Il n'y a pas de domaines validés.","filter_by_name_label":"Filtrer par nom","organization_name_label":"Nom de l'organisation","managed_by_label":"Géré par","applicant_requests_label":"Demandes des candidats","bava_managed_label":"Géré par BAVA","self_managed_label":"Autogéré","add_domain_button":"Ajouter domaine","validate_domain_label":"Valider domaine","contact_name_label":"Nom du Contact","contact_email_label":"Email du Contact","contact_phone_label":"Numéro du Contact","add_success_message":"Domaine validé ajouté avec succès!","edit_success_message":"Domaine validé mis à jour avec succès!","edit_domain_label":"Modifier les détails de l'organisation","remove_domain_alert":"Êtes-vous sûr de vouloir supprimer ce domaine validé? Notez que cela signifie que tous ses diplômes dans les profils des personnes seront également supprimés!","remove_success_message":"Domaine validé supprimé avec succès!","fully_registered_org_hint":"Vous pouvez modifier cette organisation dans la liste des organisations."},"shared":{"add_button":"Ajouter","cancel_button":"Annuler","remove_button":"Supprimer","first_name_label":"Prénom","last_name_label":"Nom","email_label":"Email","personal_email_label":"Email personnel","professional_email_label":"Email professionnel","password_label":"Mot de Passe","department_label":"Département","continent_input_placeholder":"Sélectionner une région ...","country_input_placeholder":"Sélectionner un pays ...","continent_label":"Région","continent_filter_label":"Région(Filtre)","country_label":"Pays","fetching_message":"Chargement en cours ...","success_message":"Succès","national_id_label":"N° d'identification national","company_label":"Entreprise","edu_org_label":"Organisation éducative","org_label":"Organisation","employee_count_label":"Nombre d'employés","name_label":"Nom","accreditation_group_label":"Groupe d'accréditation (Faculté)","okey_button":"OK","yes_label":"Oui","no_label":"Non","edit_button":"Modifier","domain_label":"Domaine Internet","datepicker_placeholder":"Cliquez pour sélectionner une date","save_changes_button":"Sauvegarder modifs","back_button":"Retourner","company_domain_label":"Domaine de l'organisation","search_label":"Chercher","about_label":"A propos de","title_label":"Titre","phone_number_label":"Numéro de téléphone","required_field_error_message":"Veuillez remplir ce champ","pages_label":" {currentNumber} de {totalNumber}","examples_label":"Exemples","location_label":"Location","all_label":"Tout","filter_options_label":"Options de filtrage"},"errors":{"IRRELEVANT_LINK_EMAIL":"Vous avez déjà changé votre adresse Email en utilisant ce lien!","INCORRECT_JWK":"Clé de certificat incorrecte","DEFAULT_ERROR":"Erreur","INCORRECT_ACCOUNT_TYPE":"Type de compte incorrect","INCORRECT_USERNAME_OR_PASSWORD":"Nom d'utilisateur ou mot de passe incorrect","IRRELEVANT_LINK":"Vous avez déjà réinitialisé votre mot de passe en utilisant ce lien!","INCORRECT_FILE_CONTENT":"Contenu du fichier incorrect","INCORRECT_DOMAIN":"Le domaine fourni n'est pas valide.","BAVA_ACCREDITATION_FLOW_FORBIDDEN":"Les opérations de diplôme liées à BAVA sont interdites.","BAVA_ACCREDITATION_MISSING_PARAMS":"L'identifiant de l'organisation doit être fourni dans le diplôme.","BAVA_MISSING":"L'organisation Bava n'est pas enregistrée.","BAVA_CANNOT_BE_CHANGED":"L'organisation Bava ne peut pas être modifiée.","RELATED_ACCREDITATIONS_EXISTS":"'L'état géré ne peut pas être modifié pour les organisations ayant des demandes de vérification du Diplôme existantes","REQUEST_BODY_INVALID":"Données incorrectes. Assurez-vous d'avoir correctement rempli tous les champs.","REQUEST_PARAM_MISSING":" Il mangue le paramètre de requête requis","REQUEST_PARAM_INVALID":"(La valeur) du paramètre de la requête est invalide","OPERATION_NOT_PERMITTED":"Opération non autorisée","OAUTH_CLIENT_ERROR":"Demande OAuth non valide","OAUTH_GRANT_TYPE_INVALID":"Le type de subvention OAuth est invalide","NEGATIVE_BALANCE":"Le solde créditeur ne peut pas être négatif.","ACCREDITATION_GROUP_ROLE_INVALID":"Rôle du groupe de Diplômes (Faculté) invalide","ACCREDITATION_GROUP_ACCREDITATION_REQUEST_ADDITION_ERROR":"Il n'est pas possible d'ajouter cette faculté à la demande d'accréditation.","ACCREDITATION_GROUP_STAFF_ADDITION_ERROR":"Impossible d'ajouter le collègue spécifié à ce groupe de Diplômes (Faculté)","ACCREDITATION_GROUP_STAFF_REMOVAL_ERROR":"Impossible de supprimer le collègue spécifié de ce groupe de Diplômes (Faculté)","ACCREDITATION_GROUP_NAME_MISSING":"#Veuillez spécifier un nom de groupe d'accréditation (alias Faculté) puisqu' il n'existe pas d'option par défaut pour cette organisation.#","DEPARTMENT_ROLE_INVALID":"Rôle département invalide","DEPARTMENT_STAFF_ADDITION_ERROR":"Impossible d'ajouter le collègue au Département spécifié","DEPARTMENT_STAFF_REMOVAL_ERROR":"Impossible de supprimer le collègue spécifié du Département en question","UNSUFFICIENT_BALANCE":"Solde insuffisant, contactez le responsable pour résoudre le problème","TIME_PERIOD_INVALID":"La période n'est pas valide","CONSENT_REQUEST_STATUS_INVALID":"Oufti, il paraît que cette demande a déjà été traitée ou annulée.","ABANDONING_OTHERS_REQUEST":"Vous ne pouvez pas exécuter cette opération","PRIOR_CONSENT_EXISTS":"Un consentement préalable pour le même bénéficiaire existe déjà","INCORRECT_ORGANIZATION_PAID_TILL_STATE":"Valeur incorrecte pour la date 'Payé jusqu'à' ; la nouvelle valeur doit être plus récente que sa valeur précédente.","EXPIRED_ORGANIZATION_PAID_TILL":"La date 'Payé jusqu'à' de l'organisation a expiré.","ORGANIZATION_EMAIL_INVALID":"Adresse Email du collègue non valide","STAFF_REMOVAL_ERROR":"Ce collègue ne peut pas être supprimé","NO_ANCHOR_LEFT":"L'Ancre ne peut pas se supprimer elle-même!","ACTIVE_STAFF_MISSING":"Impossible de trouver un collègue à l'ID spécifiée","NON_STAFF_USER_EXISTS":"La personne spécifiée existe déjà mais ... n'est pas un collègue!","STAFF_DIFFERENT_ORGANIZATION":"Une personne avec cette adresse Email travaille dans une autre organisation.","STAFF_ALREADY_EXISTS":"Un collègue avec cette adresse Email fonctionne déjà dans votre organisation","ORGANIZATION_ALREADY_EXISTS":"Le nom de l'organisation et / ou du domaine internet est déjà pris","ORGANIZATION_IS_BAVA_MANAGED":"Tant que cette organisation est gérée par BAVA, elle ne peut pas avoir de groupes d'accréditation; tous les diplômes auront recours à 'ToutesFacultés' jusqu'à l'adhésion de l'Organisation. À ce moment, un effort de migration de diplômes est en ordre.","ORGANIZATION_CANNOT_BE_REMOVED":"Les organisations gérées par BAVA peuvent être supprimées, mais BAVA (et ses autorités de vérification filles) même ne peut pas être supprimée.","ORGANIZATION_CANNOT_BE_UPDATED":"Une organisation portant ce nom et / ou ce domaine a déjà été enregistrée.","ORGANIZATION_CERTIFICATE_MISSING":"Il n'y a pas de certificats valides pour cette organisation","ORGANIZATION_ACCREDITATION_INCORRECT_STATUS":"Statut d'accréditation incorrect","ORGANIZATION_ACCREDITATION_FLOW_FORBIDDEN":"L'organisation n'est pas autorisée à insérer un Diplôme","ORGANIZATION_EQUAL_MANAGED_STATE":"Cet organisation se trouvait déjà dans cet état.","USER_ALREADY_EXISTS":"Le compte existe déjà","ACTIVATION_NOT_NEEDED":"Le compte est inconnu ou déjà actif","ALIAS_REQUIRED":"Impossible d'activer l'utilisateur sans un alias complet","APPLICANT_TOKEN_REQUIRED":"Il manque le Token du candidat.","APPLICANT_NOT_FOUND":"Avec cette adresse Email, personne  n'est encore enregistré dans BrainChain.","OLD_PASSWORD_INVALID":"Ancien mot de passe invalide","EMAIL_ALREADY_IN_USE":"Cette adresse Email est déjà utilisée","USER_INACTIVE":"Ce compte est inconnu ou inactif","NO_ALIASES_LEFT":"Il faut au moins un alias","PASSWORD_TOO_SIMPLE":"Le mot de passe est trop simple","CAN_NOT_REMOVE_LAST_ROOT_ADMIN":"Le dernier administrateur racine ne peut pas être supprimé.","BUSINESS_AMBASSADOR_CONTRACT_INTERSECTION":"Pour chaque combinaison [Pays, BA], une seule Commission ne peut être spécifiée.","BUSINESS_AMBASSADOR_CONTRACT_HUGE_TOTAL_PERCENT":"Le pourcentage de commission total est devenu plus élevé que prévu pour certains pays sur une période donnée.","VALIDATING_OWN_WORK":"Vous ne pouvez pas valider votre propre travail (demandez-le aux artistes morts! ;-)","DELETING_OTHERS_WORK":"Vous ne pouvez pas effectuer cette opération","ACCREDITATION_SIGNATURE_INVALID":"La signature fournie n'est pas valide","ACCREDITATION_SIGNATURE_MISSING":"Il manque la signature requise","ORIGINAL_ACCREDITATION_NOT_FOUND":"Excuses, les données originales de cette accréditation (diplôme) n'ont pas pu être récupérées.","APPLICANT_ACCREDITATION_REQUEST_ACCREDITATION_GROUP_ID_INVALID":"L'identifiant de la faculté n'est pas valide pour l'organisation spécifiée","APPLICANT_ACCREDITATION_REQUEST_ACCREDITATION_GROUP_MISMATCH":"La Faculté désignée par le candidat diffère de celle utilisée pour insérer les nouveaux Diplômes.","APPLICANT_ACCREDITATION_REQUEST_STATUS_INVALID":"Statut de la demande de vérification du Diplôme du candidat invalide son insertion","ACCREDITATION_BULK_JOB_NOT_FINISHED":"Veuillez patienter jusqu'à la fin du téléchargement.","CREATE_CONSENT_REQUEST_BULK_JOB_NOT_FINISHED":"Vous ne pouvez pas exécuter ceci tant que le procès n'est pas terminé","ACCREDITATION_BULK_JOB_MISSING_REQUIRED_HEADERS":"Il manque l'en-tête requis.","ACCREDITATION_BULK_JOB_INVALID_RECORD_SIZE":"Les colonnes ne correspondent pas à l'en-tête.","ACCREDITATION_BULK_JOB_INVALID_RECORD_FORMAT":"Format de fichier non valide","ACCREDITATION_BULK_JOB_INVALID_XML_DOCUMENT_FORMAT":"Format de document XML non valide","CURRENCY_NOT_SUPPORTED":"La devise n'est pas supportée","DIGITAL_CERTIFICATE_UNSUPPORTED_FORMAT":"Le format du certificat n'est pas supporté","DIGITAL_CERTIFICATE_NOT_YET_VALID":"Le certificat n'est pas encore valide","DIGITAL_CERTIFICATE_EXPIRED":"Le certificat a expiré","DIGITAL_CERTIFICATE_VERIFICATION_FAILED":"Le certificat n'a pas été correctement signé","UNSUPPORTED_CONTENT_TYPE":"Ce type de format n'est pas supporté","FAILED_TO_PARSE_BODY":"Erreur dans le format de la demande","FILE_TOO_LARGE":"Le fichier téléchargé est trop volumineux","BUSINESS_AMBASSADOR_NOT_FOUND":"Ambassadeur d'affaires introuvable","BUSINESS_AMBASSADOR_CONTRACT_NOT_FOUND":"Contrat de l'Ambassadeur d'affaires introuvable ","ACCREDITATION_GROUP_NOT_FOUND":"Groupe de Diplômes (Faculté) introuvable","ACCREDITATION_GROUP_CONTAIN_REQUESTS":"Cette Faculté (Groupe d'accréditation) contient des demandes non-traitées et ne peut donc pas être supprimée.","DEPARTMENT_NOT_FOUND":"Département introuvable","ORGANIZATION_NOT_FOUND":"Organisation non trouvée","STAFF_NOT_FOUND":"Collègue introuvable","ALIAS_NOT_FOUND":"Alias introuvable","ACCREDITATION_NOT_FOUND":"Diplôme introuvable","VERIFIED_IDENTITY_NOT_FOUND":"Identité vérifiée introuvable","ACCREDITATION_BULK_JOB_NOT_FOUND":"Téléchargement en vrac introuvable","CREATE_CONSENT_REQUEST_BULK_JOB_NOT_FOUND":"Fichier de téléchargement en vrac introuvable","NO_HANDLER_FOUND":"Aucun agent logiciel trouvé","PRICING_PRESET_NOT_FOUND":"Prix prédéfini non trouvé","USER_NOT_FOUND":"L'utilisateur que vous recherchez ne s'est pas encore enregistré dans le système","CONSENT_REQUEST_NOT_FOUND":"Demande de consentement non trouvée","PRIOR_CONSENT_NOT_FOUND":"Consentement préalable introuvable","SELF_STUDY_BOOK_NOT_FOUND":"Livre d'auto-apprentissage non trouvé","DIGITAL_CERTIFICATE_NOT_FOUND":"Certificat introuvable","APPLICANT_ACCREDITATION_REQUEST_NOT_FOUND":"Demande de vérification du Diplôme du candidat introuvable","TOKEN_NOT_FOUND":"Aucun token retrouvé","TOKEN_EXPIRED":"Le token a expiré","TOKEN_INVALID":"Token invalide","TOKEN_VALIDATION_ERROR":"Problème de validation du Token","TOTP_CODE_INVALID":"Code de vérification invalide","TOTP_CODE_REQUIRED":"Code TOTP requis","AUTHENTICATION_FAILED":"L'authentification a échoué","ORGANIZATION_NOT_VERIFIED":"Cet organisation n'a pas été vérifiée","USER_ALREADY_ACTIVE":"Ce compte est déjà actif","ORGANIZATION_CANNOT_WORK_WITH_ACCREDITATIONS":"Cette organisation ne peut pas gérer les accréditations","ACCESS_DENIED":"Accès refusé","APPLICANT_ACCREDITATION_REQUEST_CANNOT_BE_MODIFIED_IF_ORG_REFERENCED":"La demande de vérification du Diplôme du candidat ne peut pas être modifiée puisque entre-temps, l'organisation concernée s'est enregistrée dans BrainChain.","APPLICANT_ACCREDITATION_REQUEST_ORG_CHANGE_FORBIDDEN":"L'organisation d'une demande de vérification du Diplôme de candidat ne peut pas être modifiée.","APPLICANT_ACCREDITATION_REQUEST_AMOUNT_TOO_LARGE":"Le nombre maximum de demandes de vérification de Diplômes est atteint.","UNAUTHORIZED":"Non autorisé","INTERNAL_SERVER_ERROR":"Erreur de serveur interne"},"continents":{"AF":"Afrique","NA":"Amérique du Nord","OC":"Océanie","AN":"Antarctique","AS":"Asie","EU":"Europe","SA":"Amérique du Sud"},"countries":{"AD":"Andorre","AE":"Emirats Arabes Unis","AF":"Afghanistan","AG":"Antigua et Barbuda","AI":"Anguilla","AL":"Albanie","AM":"Arménie","AO":"Angola","AQ":"Antarctique","AR":"Argentine","AS":"Samoa américaines","AT":"Autriche","AU":"Australie","AW":"Aruba","AXE":"Iles Aland","AZ":"Azerbaïdjan","BA":"Bosnie-Herzégovine","BB":"Barbados","BD":"Bangladesh","BE":"Belgique","BF":"Burkina Faso","BG":"Bulgarie","BH":"Bahreïn","BI":"Burundi","BJ":"Bénin","BL":"Saint Bartholomeus","BM":"Bermudes","BN":"Brunéi Darussalam","BO":"Bolivie, Etat plurinational de","BQ":"Bonaire, Sint Eustatius et Saba","BR":"Brésil","BS":"Bahamas","BT":"Bhoutan","BV":"île de Bouvet","BW":"Botswana","BY":"Biélorussie","BZ":"Belize","CA":"Canada","CC":"Îles Cocos (Keeling)","CD":"Congo, République démocratique du","CF":"République centrafricaine","CG":"Congo","CH":"Suisse","CI":"Côte d'Ivoire","CK":"Iles Cook","CL":"Chili","CM":"Cameroun","CN":"Chine","CO":"Colombie","CR":"Costa Rica","CU":"Cuba","CV":"Cap Vert","CW":"Curaçao","CX":"Christmas Island","CY":"Chypre","CZ":"République tchèque","DE":"Allemagne","DJ":"Djibouti","DK":"Danemark","DM":"Dominique","DO":"République dominicaine","DZ":"Algérie","EC":"Equateur","EE":"Estonie","EG":"Egypte","EH":"Sahara Occidental","ER":"Érythrée","ES":"Espagne","ET":"Ethiopie","FI":"Finlande","FJ":"Fidji","FK":"Iles Falkland (Malvinas)","FM":"Micronésie, États fédérés de","FO":"Iles Féroé","FR":"France","GA":"Gabon","GB":"Royaume-Uni","GD":"Grenade","GE":"Géorgie","GF":"Guyane française","GG":"Guernesey","GH":"Ghana","GI":"Gibraltar","GL":"Groenland","GM":"Gambie","GN":"Guinée","GP":"Guadeloupe","GQ":"Guinée équatoriale","GR":"Grèce","GS":"Géorgie du Sud et les îles Sandwich du Sud","GT":"Guatemala","GU":"Guam","GW":"Guinée-Bissau","GY":"Guyana","HK":"Hong Kong","HM":"Îles Heard et McDonald","HN":"Honduras","HR":"Croatie","HT":"Haïti","HU":"Hongrie","ID":"Indonésie","IE":"Irlande","IL":"Israël","IM":"Ile de Man","IN":"Inde","IO":"Territoire britannique de l'océan Indien","IQ":"Irak","IR":"Iran, République islamique d '","IS":"Islande","IT":"Italie","JE":"Jersey","JM":"Jamaïque","JO":"Jordanie","JP":"Japon","KE":"Kenya","KG":"Kirghizistan","KH":"Cambodge","KI":"Kiribati","KM":"Comores","KN":"Saint-Kitts-et-Nevis","KP":"Corée, République populaire démocratique de","KR":"Corée, République de","KW":"Koweït","KY":"Iles Caïmans","KZ":"Kazakhstan","LA":"République démocratique populaire lao","LB":"Liban","LC":"Sainte-Lucie","LI":"Liechtenstein","LK":"Sri Lanka","LR":"Libéria","LS":"Lesotho","LT":"Lituanie","LU":"Luxembourg","LV":"Lettonie","LY":"Libye","MA":"Maroc","MC":"Monaco","MD":"Moldavie, République de","ME":"Monténégro","MF":"Saint-Martin (partie française)","MG":"Madagascar","MH":"Iles Marshall","MK":"Macédoine, ancienne République yougoslave de","ML":"Mali","MM":"Myanmar","MN":"Mongolie","MO":"Macao","MP":"Îles Mariannes du Nord","MQ":"Martinique","MR":"Mauritanie","MS":"Montserrat","MT":"Malte","MU":"Maurice","MV":"Maldives","MW":"Malawi","MX":"Mexique","MY":"Malaisie","MZ":"Mozambique","NA":"Namibie","NC":"Nouvelle-Calédonie","NE":"Nigéria","NF":"Île de Norfolk","NG":"Nigéria","NI":"Nicaragua","NL":"Pays-Bas","NO":"Norvège","NP":"Népal","NR":"Nauru","NU":"Niue","NZ":"Nouvelle-Zélande","OM":"Oman","PA":"Panama","PE":"Pérou","PF":"Polynésie française","PG":"Papouasie-Nouvelle-Guinée","PH":"Philippines","PK":"Pakistan","PL":"Pologne","PM":"Saint-Pierre-et-Miquelon","PN":"Pitcairn","PR":"Porto Rico","PS":"Palestine, Etat de","PT":"Portugal","PW":"Palau","PY":"Paraguay","QA":"Qatar","RE":"Réunion","RO":"Roumanie","RS":"Serbie","RU":"Fédération de Russie","RW":"Rwanda","SA":"Arabie Saoudite","SB":"Iles Salomon","SC":"Seychelles","SD":"Soudan","SE":"Suède","SG":"Singapour","SH":"Sainte-Hélène, Ascension et Tristan da Cunha","SI":"Slovénie","SJ":"Svalbard et Jan Mayen","SK":"Slovaquie","SL":"Sierra Leone","SM":"Saint-Marin","SN":"Sénégal","SO":"Somalie","SR":"Suriname","SS":"Sud-Soudan","ST":"Sao Tomé et Principe","SV":"El Salvador","SX":"Sint Maarten (partie néerlandaise)","SY":"République arabe syrienne","SZ":"Swaziland","TC":"Îles Turques et Caïques","TD":"Tchad","TF":"Terres Australes Françaises","TG":"Togo","TH":"Thaïlande","TJ":"Tadjikistan","TK":"Tokelau","TL":"Timor-Leste","TM":"Turkménistan","TN":"Tunisie","TO":"Tonga","TR":"Turquie","TT":"Trinité et Tobago","TV":"Tuvalu","TW":"Taiwan, province de Chine","TZ":"Tanzanie, République-Unie de","UA":"Ukraine","UG":"Uganda","UM":"Îles mineures éloignées des États-Unis","US":"États-Unis","UY":"Uruguay","UZ":"Ouzbékistan","VA":"Saint-Siège (État de la Cité du Vatican)","VC":"Saint-Vincent-et-les Grenadines","VE":"Venezuela, République bolivarienne du","VG":"Iles Vierges Britanniques","VI":"Îles Vierges américaines","VN":"Viet Nam","VU":"Vanuatu","WF":"Wallis et Futuna","WS":"Samoa","YE":"Yémen","YT":"Mayotte","ZA":"Afrique du Sud","ZM":"Zambie","ZW":"Zimbabwe"},"levels":{"SECONDARY_SCHOOL":"Ecole secondaire","TECHNICAL":"Technique","BACHELOR":"Bachelor","MASTER":"Master","POST_GRADUATE":"Post Graduate","PHD":"Doctorat","TRAINING_CERTIFICATION":"Formation avec Certification","SELF_WITH_CERTIFICATION":"Auto-apprentissage avec Certification","SELF_WITHOUT_CERTIFICATION":"Auto-apprentissage sans Certification"},"langs":{"en":"English","de":"Deutsch","es":"Español","nl":"Nederlands","fr":"Français","pt":"Portuguese","ru":"Русский","ja":"日本語"}}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = {"TranslationReviewVersion":{"version":"Sprachpaket-Version","version_Number":"02/08/2020"},"login":{"label":"Willkommen bei BrainChain","login_button":"Anmelden","forgot_password_label":"Passwort vergessen?","haven_t_account_label":"Noch kein Konto?","create_it_now_label":"Konto erstellen!","create_account_alert":"Welche Konto Art möchten Sie erstellen?","applicant_button":"Bewerber","company_button":"Unternehmen","back_to_login_button":"Zurück zur Anmeldeseite","create_an_label":"Erstelle Sie ein","applicant_account_hint":" Konto, wenn Sie Ihr/e Diplom/e in BrainChain verwalten möchten, um Ihre Jobsuche erheblich zu erleichtern.","create_a_label":"Erstelle Sie ein","company_account_hint":" Konto, wenn Ihr Unternehmen die automatische Prüfung von Bewerbern bei BrainChain nutzen möchte.","more_info_label":"Weitere Informationen finden Sie unter"},"oauth":{"label":"Willkommen bei BrainChain","sign_in_label":"Sie müssen angemeldet sein, um fortzufahren.","incorrect_request_params_label":"Ungültige Anforderungsparameter","access_info_label":"{client_name} erhält Zugang zu Ihrem Namen, Ihrer Telefonnummer und Ihrer Email-Adresse.","logged_in_data_label":"Sie sind angemeldet als {user_name}, {user_email}.","accept_label":"Fortsetzen","reject_label":"Verweigern","use_another_account_label":"Ein anderes Konto Benutzen"},"reset_password":{"label":"Passwort zurücksetzen","submit_button":"Zurücksetzen","incorrect_link_alert":"Falscher Link","expired_link_alert":"Link ist abgelaufen.","success_message":"Ihr Passwort wurde erfolgreich geändert."},"change_password":{"label":"Email & Passwort","change_password":"Passwort ändern","old_password_label":"Altes Passwort","old_password_input_placeholder":"Altes Passwort","submit_button":"Passwort aktualisieren","success_message":"Ihr Passwort wurde erfolgreich aktualisiert.","change_password_alert":"Sie werden nun zur Anmeldeseite geleitet, um sich mit Ihrem neuen Passwort anzumelden.","change_email":"Email ändern","change_email_hint":"Bitte geben Sie die EMail-Adresse ein, mit der Sie sich für Jobs bewerben.","update_email":"Email aktualisieren","change_email_alert":"Wir haben einen Link zu Ihrer neuen Email-Adresse gesendet, um dies zu bestätigen. Bitte überprüfen Sie Ihre Mailbox.","finish_change_email":"Email wurde erfolgreich geändert. Sie können diese verwenden, um sich in Ihr Konto anzumelden."},"restore_account":{"label":"Bitte geben Sie die Email-Adresse des Kontos ein, das Sie wiederherstellen möchten!","submit_button":"Wiederherstellen","success_message":"Ihr neues Passwort wartet auf Sie in Ihrem Posteingang!","link_to_help_text":"Stellen Sie sicher, dass Sie Ihr Konto aktiviert haben. Bei Problemen wenden Sie sich bitte an:","link_to_help":"Hilfe","link_to_help_end":" ."},"register_applicant":{"label":"Registrierung des Bewerbers","message":"Bitte füllen Sie die folgenden Daten aus, um Ihr Konto zu erstellen","success_message":"Wir haben Ihnen eine Aktivierungsmail gesendet. Klicken Sie auf den Link, um diesen Vorgang abzuschließen.","submit_button":"Registrieren!","back_button":"Zurück zur Anmeldeseite"},"account_management":{"label":"Konto Einstellungen","open_account_management_menu_label":"Öffnen Menü #Konto Einstellungen#' ","close_account_management_menu_label":"Menü #Konto Einstellungen# ausblenden"},"org_management":{"label":"Einstellungen des Organisationskontos"},"aliases":{"label":"Aliasse","expose_phone_label":"Telefonnummer teilen für potenzielle Jobs","expose_email_label":"Email teilen für potenzielle Jobs","default_alias_label":"Standardalias","set_as_default_alias_label":"Als Standardalias festlegen","edit_alias_label":"Alias Ändern","delete_alias_label":"Alias entfernen","add_button":"Alias ​​hinzufügen","add_success_message":"Alias ​​erfolgreich erstellt!","edit_button":"Alias ​​ändern","edit_success_message":"Alias ​​erfolgreich aktualisiert!","remove_title":"Möchten Sie diesen Alias wirklich entfernen?","remove_success_message":"Alias ​​erfolgreich entfernt!","edit_default_alias":"Persönliche Daten","change_default_alias":"Persönliche Daten ändern"},"org_staff":{"staff":{"table_label":"Mitarbeiter","register_button":"Einladung senden","remove_modal_alert":"Möchten Sie {Name} wirklich aus der Mitarbeiterliste entfernen?","send_invite_button":"Einladung senden","create_success_message":"Mitarbeiter erfolgreich registriert!","remove_success_message":"Mitarbeiter erfolgreich entfernt!","no_data_label":"Es gibt keine Mitarbeiter."},"accreditation_groups":{"table_label":"Akkreditierungsgruppen (Fakultäten)","accreditation_group_name_label":" Name der Fakultät ","create_accreditation_group_button":"Fakultät erstellen","create_accreditation_group_success_message":"Fakultät erfolgreich erstellt!","edit_accreditation_group_success_message":"Fakultät erfolgreich aktualisiert!","inserters_label":"Insertors","validators_label":"Validators","employee_input_placeholder":"Mitarbeiter auswählen ...","role_input_placeholder":"Rolle auswählen ...","employee_label":"Mitarbeiter","employees_label":"Mitarbeiter","role_label":"Rolle","remove_employee_from_group_alert":"Möchten Sie diesen Mitarbeiter wirklich aus der Fakultät entfernen?","remove_group_alert":"Möchten Sie diese Fakultät wirklich entfernen?","remove_employee_from_group_success_message":"Mitarbeiter erfolgreich aus der Fakultät entfernt!","remove_group_success_message":"Fakultät erfolgreich entfernt!","add_employee_to_group_success_message":"Mitarbeiter erfolgreich zur Fakultät hinzugefügt!","no_data_label":"Es sind noch keine #Fakultäten# festgelegt.","accreditation_groups_definition_label":"#Fakultäten# sind eine Art und Weise, wie Universitäten ihre Bildungsprogramme organisieren.","accreditation_group_no_data_label":"Diese Fakultät enthält keine Mitarbeiter. ","accreditation_group_examples_label":"Maschinenbau, Politikwissenschaften, Wirtschaftswissenschaften, Biologie","different_from_departments_label":"Dies unterscheidet sich von #Abteilungen# ","no_inserters_label":"Keine Insertors zugewiesen","no_validators_label":"Keine Validators zugewiesen","no_staff_assigned_label":"Fakultäten ohne zugewiesene Insertors können keine Diplome eingeben; für Fakultäten ohne zugewiesene Validators bleiben die eingefügten Diplome ausstehen, bis ein Fakultätsvalidator zugewiesen wird. Stellen Sie daher bitte sicher, dass für jede Fakultät mindestens ein Insertor und ein Validator zugewiesen werden.","digital_key_hint":"Freundliche Erinnerung: Um Diplome digital zu verschlüsseln, brauchen Insertors den digitalen Schlüssel (eine .jwk-Datei) auf dem Computer auf dem sie sie eingeben. Bitte vergessen Sie nicht diesen Schlüssel dem Insertor(-en) auf sichere Weise zu geben, und erinnern Sie ihn daran dass dieser Schlüssel nur einmal importiert werden muss, bevor alle Arbeiten anfangen können."},"departments":{"table_label":"Abteilungen","department_name_label":"Abteilungsname","department_email_label":"Abteilungs-Email","create_department_button":"Abteilung erstellen","create_department_success_message":"Abteilung erfolgreich erstellt!","edit_department_success_message":"Abteilung erfolgreich aktualisiert!","hms_label":"Rekrutierungsmanager","bos_label":"Business Owner","employee_input_placeholder":"Mitarbeiter auswählen ...","role_input_placeholder":"Rolle auswählen ...","employee_label":"Mitarbeiter","employees_label":"Mitarbeiter","role_label":"Rolle","remove_employee_from_department_alert":"Möchten Sie diesen Mitarbeiter wirklich aus der Abteilung entfernen?","remove_department_alert":"Möchten Sie diese Abteilung wirklich entfernen?","remove_employee_from_department_success_message":"Mitarbeiter erfolgreich aus der Abteilung entfernt!","remove_department_success_message":"Abteilung erfolgreich entfernt!","add_employee_to_department_success_message":"Mitarbeiter erfolgreich zur Abteilung hinzugefügt!","no_data_label":"Es sind noch keine #Abteilungen# definiert.","department_no_data_label":"In dieser Abteilung gibt es keine Mitarbeiter.","departments_definition_label_uni":"#Abteilungen# spiegeln wie sich eine Universität organisiert, so wie jede andere Organisation.","departments_definition_label_company":"#Abteilungen# spiegeln, wie Unternehmen sich in seinen Funktionsgruppen organisieren.","departments_examples_label":"Personal (HR); IT; Finanzen","departments_definition_label_part_2":"#Abteilungen# ermöglichen den Unternehmen BrainChain auf organisierte Weise zu nutzen; ihre Mitarbeiter können Diplome von Personen überprüfen die sie anstellen möchten.","different_from_accreditation_groups_label":"Die unterscheiden sich von den #Fakultäten#"},"change_anchor":{"title":"Anker Person ändern","modal_alert_message":"Sie können die Ankerrechte auf jeden aktiven Mitarbeiter übertragen.","modal_alert_warning":"(Warnung: Nach dieser Aktion verlieren Sie teilweise Zugriffsrechte.)","success_message":"Anker erfolgreich geändert!","submit_button":"Anker ändern"}},"activation":{"label":"Kontoaktivierung","activate_applicant_label":"Wählen Sie ein Passwort, um Ihr Konto zu aktivieren","linked_employee_label":"Wählen Sie Email und Passwort für Ihr Bewerberkonto. Ihr Mitarbeiterkonto wird damit verknüpft.","activate_personal_data_label":"Bitte geben Sie die folgenden Daten ein, um Ihr Konto zu aktivieren","activate_password_label":"Bitte geben Sie ein Passwort ein, um die Aktivierung Ihres Kontos abzuschließen","haven_t_applicant_account_label":"Sie haben noch keinen Bewerber Konto?","create_it_now_label":"Jetzt erstellen!","linked_button":"Weiter","birth_date_label":"Geburtsdatum","password_label":"Passwort","enter_password_label":"Neues Passwort","confirm_password_label":"Passwort bestätigen","enter_password_input_placeholder":"Neues Passwort","confirm_password_input_placeholder":"Neues Passwort bestätigen","activate_button":"Konto aktivieren","enter_password_error_alert":"Das Passwort muss mindestens 6 und maximal 32 Zeichen enthalten!","confirm_password_error_alert":"Bewundernswert, aber ... Ein Kennwort reicht aus. Geben Sie dasselbe Kennwort zweimal ein!","activation_link_expired_alert":"Aktivierungslink ist abgelaufen","activation_link_irrelevant_message":"Sie haben Ihre Registrierung bereits abgeschlossen.","activation_link_irrelevant_forgot_password_message_start":"Wenn Sie Ihr Passwort vergessen haben, können Sie hier klicken","activation_link_irrelevant_forgot_password_message_link":"hier","activation_link_irrelevant_forgot_password_message_end":"um es zurückzusetzen.","activation_link_irrelevant_log_in_message_start":"Wenn dies ein Irrtum ist und Sie sich an Ihr Passwort erinnern, können Sie sich anmelden mit ","activation_link_irrelevant_log_in_message_link":"dieser Link","activation_link_irrelevant_log_in_message_end":".","incorrect_activation_link_alert":"Falscher Aktivierungslink","activation_success_message":"Aktivierung erfolgreich!","back_button":"Rückkehr zur Aktivierung des Mitarbeiterkontos."},"resend_activation":{"success_message":"Aktivierung wurde nochmals erfolgreich gesendet!","employee_label":"Aktivierungs-Email nochmals nach {email} senden?","anchor_label":"Aktivierungs-Email erneut nach {email} senden?","title":"Aktivierung nochmals senden","submit_button":"Nochmals senden","label":"Bitte geben Sie die Email-Adresse des Kontos ein, um die Aktivierung erneut zu senden."},"orgs":{"label":"Organisationen","anchor_label":"Anker","location_label":"Ort","org_label":"Organisation","org_type_label":"Organisationstyp","add_org":"Organisation hinzufügen","name_label":"Name","has_accreditation_groups_label":"Hat Akkreditierungsgruppen(Fakultäten)","verifies_identities_label":"Überprüft Identitäten ","provides_mooc_certificates_label":"Stellt MOOC-Zertifikate aus","street_label":"Straße & Nr","postal_label":"Postleitzahl","city_label":"Stadt","company_code_label":"Buchungskreis","vat_number_label":"MwSt Nº","address_label":"Adresse","permissions_label":"Berechtigungen","unknown_label":"Unbekannt","no_data_label":"Es gibt keine Organisationen.","no_data_to_validate_label":"Es gibt keine Organisationen mehr zu überprüfen.","validate_organizations_label":"Organisationen bestätigen","validate_organization_label":"Organisation bestätigen","validate_organization_button":"Bestätigen","validate_organization_alert":"Möchten Sie diese Organisation wirklich bestätigen?","back_button":"Rückkehr zur Liste der nicht bestätigten Organisationen.","next_org_button":"Nächste Organisation","validate_org_success_message":"Organisation wurde erfolgreich validiert!","financial_data_label":"Finanzdaten","financial_data_placeholder":"Bank Name, Kontonummer,…","inspect_organization_button":"Prüfen","validate_org_progress_label":"Bestätigt","orgs_payments_list_label":"Finanzdaten von Organisationen","general_data_validated":"Validierte Grunddaten ","financial_data_validated":"Validierte Finanzdaten ","already_validated":"Teilweise validierte Daten. Bis zur vollständigen Validierung durch den Co-Assistenten.","remove_org_alert":"Sind Sie sicher dass Sie diese Organisation entfernen wollen?","remove_org_success_message":"Organisation erfolgreich entfernt!"},"register_org":{"register_org_label":"Organisation und Anker registrieren","invite_next_button":"Nächste einladen","send_invitation_button":"Einladung senden","success_message":"Organisation und Anker erfolgreich registriert!","org_type_placeholder":"Organisationstyp auswählen ...","register_button":"Registrieren","company_registration_label":"Firma und Anker eintragen","proceed_button":"Vortfahren","register_org_by_anchor_alert":"Vergessen Sie nicht, einen Firmenkredit (beliebigen Betrag) von dem in diesem Profil angegebenen Bankkonto zu überweisen. Auf diese Weise kann BrainChain Ihre Registrierung bestätigen und beenden.","register_org_by_anchor_hint":"Nach der Aktivierung des Kontos können Sie die Finanzinformationen jederzeit im Finanzbereich der Einstellungen des Organisationskontos verwalten.","domain_hint":"Eine Internet-Domäne ist der erste Teil der Webadresse einer Organisation. z.B. 'apple.com' oder 'ibm.de'. Wenn Sie das gesamte Unternehmen mit all seiner Unterdomänen registrieren möchten, können Sie am Ende einen Platzhalter (*) verwenden, anstatt die Durchwahl eines bestimmten Landes zu verwenden, z.B. 'apple.*' oder 'ibm.*'.","back_button":"Zurück zur Anmeldeseite.","company_code_hint":"In einigen Ländern sind Unternehmen in erster Linie unter einem eindeutigen Registrierungscode als Kennung bekannt, neben - oder ohne - einer Mehrwertsteuer-Nr.","financial_data_hint_part_1":"Bitte geben Sie alle Daten an, um sicherzustellen dass wir feststellen können das die Transaktion tatsächlich von Ihrer Organisation stammt.","financial_data_hint_part_2":"Wie: Ihr Bankname und Ihre Kennung bei Ihrer Bank (= ein Kundencode / Ihre Bankkontonummer / ...).","financial_data_hint_part_3":"Wir benötigen diese Daten, um echte Unternehmen wie Ihres von gefälschten und Internet-Bots zu trennen und die Meldepflicht gemäß Betrugsbekämpfungsstandards einzuhalten."},"edit_org":{"org_edit_success_message":"Organisation erfolgreich aktualisiert!","anchor_edit_success_message":"Anker erfolgreich geändert!","back_button":"Zurück zur Liste der Organisationen.","edit_anchor_button":"Anker ändern","edit_anchor_alert":"Bitte ändern Sie zuerst die Anker-Email, bevor Sie etwas anderes tun.","bava_label":"BAVA","bava_organization_label":"BAVA Organisation","bava_set_success_message":"Organisation als BAVA gekennzeichnet!","bava_removed_success_message":"BAVA-Flag erfolgreich entfernt!"},"request_credentials_verification":{"label":"Diplom-Validation anfordern","success_alert":"Anfrage erfolgreich","applicant_data_label":"Bewerberdaten","choose_way_label":"Einen Weg Wählen um einen Bewerber zu finden","your_data_label":"Deine Daten","hide_your_name_label":"Verbergen Sie dem Bewerber Ihren Namen","company_data_label":"Daten des Unternehmens","reason_for_request_label":"Grund der Anfrage","reason_for_request_placeholder":"Ihre Nachricht hinterlassen ...","get_email_label":"Erhalten Sie eine Email, wenn der Bewerber auf die Anfrage antwortet.","submit_button":"Anfrage bearbeiten","way_label":"Weg","company_name_label":"Name der Firma","modal_title_label":"Bezüglich","investigate_applicant_label":"Der Bewerber den Sie untersuchen möchten, ist noch nicht in BrainChain. Möchten Sie dass wir seine Universität darum bitten ihn hinzufügen?","ask_colleague_label":"Ein Kollege von Ihnen  {firstName} {lastName} hat eine gültige ausstehende Einwilligung für diesen Bewerber. Möchten Sie Ihren Kollegen bitten den Bewerber zu überprüfen, oder möchten Sie lieber Ihre eigene Diplom-Validation anfordern?","request_button":"Eigene Anfrage","ask_colleague_button":"Meinem Kollegen bitten","manager_label":"Manager","visible_data_message":"Die folgenden Daten sind für den Bewerber sichtbar.","upload_file_label":"Datei hoch laden","emails_label":"Emails","manual_input_label":"Manuelle Eingabe","manual_input_hint":"Geben Sie die Emails der Bewerber durch Kommata, Semikolons, Zeilenumbrüche oder Leerzeichen getrennt an.","reference_to_bulk_list_start":"Sie können eine Anforderung für eine einzelne Email oder eine Reihe von Emails gleichzeitig machen. \nEs gibt zwei Möglichkeiten eine Reihe von Emails einzugeben: Sie können sie entweder selbst in das unten stehende Feld eingeben, oder ein Dokument hoch laden. Informationen zum korrekten Format finden Sie unten unter dem Symbol '?'. \nWenn Sie sich für die Serie von Emails entscheiden, können Sie deren Verarbeitungsstatus überprüfen unter ","reference_to_bulk_list_link":"Sammelupload","reference_to_bulk_list_end":".","stay_on_this_page_label":"Auf der aktuellen Seite bleiben","go_to_home_page_label":"Zur Startseite gehen","success_modal_label":"Ihre Anfrage war erfolgreich! Möchten Sie auf dieser Seite bleiben oder zur Startseite gehen?","request_unavailable_alert":"Das Anfordern der Diplom-Validationsanfragen ist nicht verfügbar. Wenden Sie sich an den Anker Ihrer Organisation um das Problem zu beheben."},"main":{"home_page_label":"Startseite","edu_org_staff_page_button":"Mitarbeiter verwalten","current_sub_role_label":"Rolle","current_group_label":"Gruppe","log_out_button":"Abmelden","orgs_page_button":"Organisationen","insert_accreditation_page_button":"Neues Diplom(-e) einfügen ","validate_accreditations_page_button":"Diplom überprüfen","review_accreditations_page_button":"Überprüfung fehlgeschlagener Diplome","accreditation_groups_page_button":" Fakultäten","departments_page_button":"Abteilungen","staff_members_page_button":"Mitarbeiter","limit_access_label":"Ihre Organisation hat nur eingeschränkten Zugriff auf bestimmte Funktionen. Sollte dies unerwartet sein, wenden Sie sich bitte an den Organisationsanker.","non_validated_org_access_label":"Sie haben keinen Zugriff auf diese Funktionalität, da Ihre Organisation noch nicht bestätigt wurde.","payment_label":"Zahlung","help_label":"Hilfe","bulk_jobs_list_page_button":"Sammelupload Diplome","validate_organizations_page_button":"Organisationen bestätigen","certified_accreditations_page_button":"Zertifizierte Diplome","pending_accreditations_page_button":"Anstehende Diplome","vids_page_button":"Verifizierte Identitäten","org_management_button":"Einstellungen des Organisationskontos","verification_request_page_button":"Einwilligungsanfrage","pending_consents_page_button":"Ausstehende Einwilligung","active_consents_page_button":"Aktive Einwilligungen","consent_requests_page_button":"Angefragte Einwilligungen","prior_consents_page_button":"Vorherige Einwilligung","applicant_accreditations_select_button":"Diplome","applicant_consents_select_button":"Einwilligung","consents_history_page_button":"Einwilligungsgeschichte","self_study_books_page_button":"Bücher (Selbststudium)","bulk_consent_requests_page_button":"Einwilligungssammelanfrage","inserter_accreditations_select_button":"Diplome","insert_accreditation_shirt_page_button":"Einfügen","review_accreditations_shirt_page_button":"Überprüfen","bulk_jobs_list_shirt_page_button":"Sammelupload","organizations_select_button":"Unternehmen","orgs_shirt_page_button":"Bestätigt","validate_organizations_shirt_page_button":"Ausstehend","accreditation_requests_list_page_button":"Diplom-Validation Anforderungen","validated_accreditation_requests_list_page_button":"Validierte Edu-Domänen","pending_accreditation_requests_list_page_button":"Ausstehende Edu-Domänen","pending_accreditation_requests_page_button":"Ausstehende Diplom-Validationsanfragen","organization_select_button":"Organisation","accreditation_groups_management_page_button":"Fakultätsmanagement","groups_management_page_button":"Abteilungen & Fakultäten","validated_accreditation_requests_by_domain_shirt_page_button":"Bestätigt","pending_accreditation_requests_by_domain_shirt_page_button":"Ausstehend","security_page_button":"Sicherheit","register_org_shirt_page_button":"Neu registrieren","payments_page_button":"Zahlungen","orgs_payments_page_button":"Finanzdaten von Organisationen","assistants_page_button":"Assistenten","business_ambassadors_page_button":"Geschäftsbotschafter","commissions_list_page_button":"Provisionen","system_payment_select_button":"Zahlung","due_payments_page_button":"Fällige Zahlungen","payments_history_shirt_page_button":"Geschichte","payments_history_page_button":"Zahlungsverlauf","validated_domains_page_button":"Validierte Domänen","domains_page_button":"Domänen von Universitäten"},"roles":{"admin_label":"SysAdmin","employee_label":"Mitarbeiter","applicant_label":"Bewerber","anchor_label":"Anker","inserter_label":"Insertor","validator_label":"Validator","hm_label":"Rekrutierungsmanager","bo_label":"Business Owner"},"home":{"welcome_label":"Willkommen bei BrainChain","account_and_support_label":"Kontoeinstellungen und Support","admin_pages_label":"Administrator-Seiten","choose_role_label":"Wählen Sie die Funktion für diese Sitzung","anchor_pages_label":"Anker Seiten","inserter_pages_label":"Insertor Seiten","validator_pages_label":"Validator Seiten","hm_pages_label":"Personalchef Seiten","bo_pages_label":"Gruppenführer Seiten","applicant_pages_label":"Bewerber Seiten","account_page_about":"Verwaltung persönlichen Einstellungen","support_page_about":"Finden Sie Ihre Antwort oder mailen Sie uns","register_org_page_about":"Neue Organisation erstellen","organizations_page_about":"Organisationseinstellungen verwalten","validate_organizations_page_about":"Bestätigung neuer Organisationen","payment_page_about":"Finanzmanagement & Preisgestaltung","organization_staff_page_about":"Personalmanagement Ihrer Organisation","accreditation_groups_page_about":"Fakultätsmanagement Ihrer Organisation","departments_page_about":"Abteilungenmanagement Ihrer Organisation ","review_accreditations_page_about":"Interaktionen mit Validators & Bewerber","bulk_accreditations_upload_page_about":"Einfügen von Diplome aus CSV-Datei","validate_accreditations_page_about":"Interaktionen mit Insertors & Bewerber","credentials_verification_request_page_about":"Erstellen Sie eine neue Einwilligungsanfrage für den Bewerber","consent_requests_page_about":"Einwilligungsanfragen für Ihre Organisation verwalten","certified_accreditations_page_about":"Verwaltung zertifizierte Diplome","pending_accreditations_page_about":"Verwaltung neuer Diplome","verified_identities_page_about":"Verwaltung verifizierte Identitäten","pending_consents_page_about":"Unternehmen die sich überlegen, Sie einzustellen - Sie entscheiden","active_consents_page_about":"Alle Unternehmen die Ihr Diplom anschauen dürfen","prior_consents_page_about":"Unternehmen für die Sie arbeiten möchten","consents_history_page_about":"Vollständige Geschichte der erteilten und abgelehnten Einwilligungen","self_study_books_page_about":"Verwaltung von Selbststudienbücher","bulk_consent_requests_page_about":"Verwaltung von Sammelanfrage für Ihre Organisation","accreditation_requests_list_anchor_page_about":"Verknüpfen Sie verwaiste Bewerber-Diplom-Überprüfungsanfragen mit bestehenden Fakultäten","validated_accreditation_requests_list_admin_page_about":"Validierte Domänen (selbst-verwaltet und BAVA-verwaltet)","pending_accreditation_requests_list_admin_page_about":"Zugriff auf neue Domain-Überprüfungsanforderungen (Bewerber)","accreditation_requests_list_admin_page_about":"Verwaltung einer Bewerber Diplom-Validationsanfrage, nicht an eine Organisation gebunden","accreditation_requests_list_applicant_page_about":"Verwaltung von Diplom-Validationsanfragen","security_page_anchor_about":"Digitale Signatur von Diplomen","security_page_inserter_about":"Digitalen Schlüssel Installieren ","security_page_admin_about":"Ausstehende Root- / Uni-Zertifikate hinzufügen","orgs_payments_page_about":"Konto, Tarife und Kredit","assistants_page_about":"Assistenten verwalten","business_ambassadors_page_about":"Geschäftsbotschafter verwalten","commissions_list_page_about":"Provisionen verwalten","due_payments_page_about":"Fällige Zahlungen verwalten","payments_history_page_about":"Zahlungsverlauf und Unternehmensguthaben verwalten","default_departments_hint":"Der BrainChain Anker kann bei kleinen Unternehmen selbst Diplom-Validationsanfragen  anfordern. Größeren Unternehmen wird empfohlen, eine 'Personalabteilung' (Label ist frei) einzurichten und Personal damit zu verknüpfen. Immerhin haben größere Unternehmen separate Profile für Bewerbungen - und der BrainChain-Ansprechpartner(= der BrainChain-Anker) sollte sich nicht damit befassen.","not_validated_yet":"Ihr Unternehmen ist von BrainChain noch nicht vollständig validiert. Bis dieser Prozess abgeschlossen ist, sind nicht alle Funktionen vollständig verfügbar."},"payment":{"title":"Zahlungsinformationen","total_money_label":"Der Gesamtbetrag, den BrainChain an {orgName} gespendet hat:","list_label":"Um die Jahreslizenz zu bezahlen, überweisen Sie bitte:","account_id_label":"an das folgende (IBAN-) Konto Nr.: {iban}","bank_details_label":"Bank- und Projektdetails","about_us_label":"Sollten Sie weitere Informationen über unsere Bank oder BrainChain benötigen:","bank_data_label":"Unsere Bankdaten:","project_label":"BrainChain-Projekt:","org_label":"Organisation: WickedWare","org_address":"Adresse: Virsuliskiu g. 17-9, 05108 Vilnius, Litauen","create_account_label":"mit folgendem Verwendungszweck  (bei erstmaliger Zahlung): ","create_account_message_label":"{orgName} - Konto erstellen","annual_fee_label":"mit folgendem Verwendungszweck (bei NICHT erstmaliger Zahlung): ","annual_fee_message_label":"{orgName} - Jahreslizenz","edu_org_message_label":"Was sich daraus für Ihre Bildungsorganisation ergibt:","edu_org_message_company_checks":"Jedes Mal, wenn ein Unternehmen einen Ihrer Alumni überprüft, berechnen wir dem Unternehmen eine sehr geringe Pauschalgebühr. Mit dieser Gebühr zahlen wir die Kosten um BrainChain in einem guten Betriebszustand zu halten, und 20% fließen einmal pro Jahr zu Ihnen zurück. ","edu_org_message_list_title":"So bauen wir ein gesundes, gemeinnütziges Ökosystem auf, das den Universitäten zugute kommt:","edu_org_message_list_item_one":"Anstatt Ihre Alumni immer wieder zu überprüfen, tun Sie dies nur einmal (auf dieser Plattform) und wir übernehmen diese Last von da an, solange Ihre Alumni arbeiten.","edu_org_message_list_item_two":"Nach diesem einmaligen Eintrag erhält die Universität bei jeder Überprüfung Ihrer Alumni (d.h. wenn sie einen neuen Job suchen) 20% der Prüfungsgebühren für Unternehmen.","edu_org_message_joining":"Durch den Beitritt zu BrainChain wird die Universität von der Prüfungslast entlastet und erhält eine nachhaltige Einnahmequelle.","edu_org_message_note_title":"Hinweis:","edu_org_message_note":"Normalerweise ist Ihre Gutschrift um das Mehrfache höher als die Jahresgebühr. In diesem Fall wird das automatisch abgerechnet. Sie erhalten zur gleichen Zeit eine Email darüber, in der dieser Vorgang erläutert wird.","wire_label":"Um die Jahreslizenz zu bezahlen, überweisen Sie bitte","wire_delay_label":"Bitte beachten Sie, dass internationale Transaktionen einige Tage dauern können.","annual_license_cost_label":"Jährliche Lizenzkosten","bank_data_by_location":{"LT":{"iban_number":"LT643500010003938827","bank_data":"Name: 'Paysera LT', UAB \nBankanschrift: Menulio g. 7, Vilnius, LT-04326, Litauen"},"BE":{"iban_number":"BE13736065627739 (BIC: KREDBEBB)","bank_data":"Name: Alverman BV \nBankadresse: Beekstraat 5, 2300 Turnhout, Belgium \nAlverman MwSt Nr (= company ID): \"BE0736567322\""}}},"finance":{"label":"Finanzen","balance_label":"Balance","balance_currency_label":"Kontowährung","balance_change_comment_placeholder":"Ihre Nachricht hinterlassen ...","change_label":"Ändern","change_balance_label":"Balance ändern","increase_label":"Erhöhen","decrease_label":"Verringern","change_balance_submit_button":"Änderungen akzeptieren","preset_price_label":"Voreingestellter Preis","paid_till_date_label":"Bezahlt bis Datum","annual_fee_label":"Jahresgebühr","request_cost_label":"Kosten der Diplom-Validationsanfrage","pay_annual_fee_button":"Jahresgebühr zahlen","pay_annual_fee_success_message":"Jahresgebühr erfolgreich bezahlt!","change_finance_success_message":"Organisationsfinanzen erfolgreich geändert","org_finance_label":"Organisationspreis","accept_price_and_send_invitation":"Preis annehmen und Einladung senden","accept_price_and_validate":"Preis akzeptieren und bestätigen","prices_label":"Preise","change_balance_modal_label":"Das Hinzufügen von Guthaben zeigt dass das Unternehmen seine jährliche Lizenz bezahlt hat (dies wurde dann von der SA / FA im Voraus offline überprüft). Die Aufnahme von Krediten zeigt, dass das Geld offline an das Unternehmen zurücküberwiesen wurde (ebenfalls von der SA / FA durchgeführt). Wenn die Jahreslizenz bezahlt werden muss, wird diese automatisch vom ausstehenden Guthaben am Tag selbst abgezogen.","set_default_label":"Standardwert wiederherstellen","default_annual_fee_label":"Standardjahresgebühr","default_consent_request_fee_label":"Standardgebühr für Diplom-Validationsanfragen","deviation_period_label":"Abweichungsperiode","forever_label":"Für immer","default_preset_label":"Nominale Voreinstellungen: Jahresgebühr - {annual_fee_amount}, Zustimmungsanforderung - {consent_request_fee_amount}","agreed_deviation_label":"Vereinbarte Abweichung: Jahresgebühr - {annual_fee_amount}, Diplom-Validationsanfragen - {consent_request_fee_amount}","till_label":"bis","period_label":"Periode","pay_annual_license_alert":"Bitte zahlen Sie die Jahresgebühr, um weitere Diplom-Validationsanfragen zu erstellen.","top_up_balance_alert":"Bitte füllen Sie Ihr Guthaben auf, um weitere Diplom-Validationsanfragen auszustellen.","contact_anchor_alert":"Bestimmte Funktionalität ist nicht verfügbar. Wenden Sie sich an den Anker Ihrer Organisation um das Problem zu beheben. ","add_year_label":"Jahr hinzufügen","paid_till_alert":"Organisationen ohne 'Bezahlt bis' Datum in der #Zukunft#, erhalten kein Geld für die Diplom-Validationsanfragen."},"help":{"label":"Sollten Sie Probleme oder Fragen haben, wenden Sie sich bitte an {email}.","email":"BenevolentEars@brainchainmission.org","questions_and_answers_label":"Fragen und Antworten","question_activation_email":"Ich habe meine Aktivierungs-Email nicht erhalten","answer_activation_email_start":"Wenn Sie Ihre Aktivierungs-Email nicht erhalten haben, können Sie sie erneut anfordern ","answer_activation_email_link":" hier","answer_activation_email_end":" ."},"page_not_found":{"page_not_found_label":"Seite nicht gefunden","sorry_label":"Entschuldigung - auch wir finden diese Seite nicht zurück!","cause_label":"Entweder haben Sie keinen Zugriff auf diese Seite, oder sie existiert nicht mehr."},"server_error":{"server_error_label":"Fehler vom Bauch des Servers","sorry_label":"Ooops, etwas ist schief gelaufen : - /","cause_label":"Möchten Sie es später nochmals versuchen? Unser Server ruht sich aus."},"sub_role_missing":{"no_access_label":"In dieser Rolle haben Sie keinen Zugriff mehr auf diese Funktionalität.","continue_label":"Um fortzufahren werden Sie zur Homepage weitergeleitet."},"org_permissions_missing":{"no_access_label":"Oops, Ihre Organisation hat keinen Zugriff mehr auf diese Funktionalität.","continue_label":"Um fortzufahren werden Sie zur Homepage weitergeleitet."},"accreditation_list":{"label":"Diplome","title_label":"Titel","date_issued_label":"Ausstellungsdatum","level_label":"Niveau","applicant_name_label":"Name des Bewerbers","location_label":"Ort","no_data_to_validate_message":"Keine Diplome zu bestätigen.","no_data_to_review_message":"Keine Diplome zu überprüfen.","show_accreditations_by_label":"Diplome anzeigen, abgelehnt von","validators_label":"Validators","applicants_label":"Bewerbern","edit_label":"Diplom ändern","remove_label":"Diplom Löschen","no_data_to_review_hint":"Es gibt noch andere Fakultäten die Sie überprüfen können."},"bulk_jobs_list":{"label":"Sammeldiplome hoch laden","no_data_message":"Es wurde noch keine Sammeldiplome hochgeladen","created_at_label":"Erstellt am","processed_label":"Erledigt","finished_label":"Fertig!","file_name_label":"Dateiname","status_label":"Status","in_progress_label":"In Bearbeitung ...","remove_bulk_success_message":"Masse erfolgreich entfernt!","remove_bulk_alert":"Möchten Sie diese Datei wirklich aus der Liste entfernen?","remove_bulk_button":"Diese Datei nicht mehr anzeigen","entries_number_label":"Anzahl der Einträge","error_label":"Fehler","global_error_label":"Globaler Fehler","requestor_label":"Antragsteller","bulk_consent_requests_label":"Sammelanfrage","no_bulk_consents_data_label":"Es wurde noch keine Sammelanfrage hochgeladen","created_requests_label":"Erstellte Diplom-Validationsanfragen","file_reading_process_label":"Datei wird gelesen.","signing_process_label":"Sehr beschäftigt, um die Diplome zu unterschreiben ...","dont_close_tab_label":"Bitte verlassen Sie diese Seite erst nach Abschluss dieses Vorgangs. Je nach Dateigröße kann dies einige Zeit dauern.","insufficient_balance_error_alert_part_1":"Aufgrund unzureichender Gutschrift konnten nur {amount} von {total} Diplom-Validationsanfragen bearbeitet werden.","insufficient_balance_error_alert_part_2":"Bitte füllen Sie mindestens {amount} auf, bevor Sie die restlichen Anfragen verarbeiten können","flush_remaining_label":"Die restlichen Anfragen verarbeiten"},"accreditation":{"accreditation_group_input_placeholder":" Fakultät auswählen ...","accreditation_title_orig_label":" Originaltitel ","accreditation_title_orig_input_placeholder":" Originaltitel ","accreditation_title_en_label":" Englischer Titel ","accreditation_title_en_input_placeholder":" Englischer Titel","additional_translations_label":"Zusätzliche Übersetzungen","add_additional_translations_label":"Zusätzliche Titelübersetzung hinzufügen","date_issued_label":"Ausgabedatum","level_label":"Niveau","level_input_placeholder":"Niveau auswählen ...","person_label":"Person","language_input_placeholder":"Sprache","translation_input_placeholder":"Übersetzung","title_label":"Titel","accreditation_label":" Diplom","popover":{"message_placeholder":"Bitte bearbeiten Sie Ihre Nachricht hier: ...","old_value_label":"Alter Inhalt","proposed_value_label":"Neuer Inhalt","message_label":"Nachricht","proposed_value_input_placeholder":"Geben Sie Ihren vorgeschlagenen Inhalt hier ein ...","discard_changes_label":"Änderungen verwerfen","edit_field_label":"Feld bearbeiten"},"remove_accreditation_success_message":"Diplom erfolgreich entfernt!","remove_accreditation_alert":"Möchten Sie diese Diplom wirklich entfernen?","next_accreditation_button":"Nächste Diplom","back_button":"Zurück zur Liste der Diplome","show_details_label":"Felddetails anzeigen"},"insert_accreditation":{"label":"Diplom einfügen","success_message":"Diplom erfolgreich eingefügt!","submit_button":"Bereit zur Bestätigung!","no_certificate_message_start":"Sie haben den Universitätsschlüssel noch nicht installiert, um Diplome digital zu signieren. Bitte gehen Sie zuerst zum'","no_certificate_message_link":"Sicherheit","no_certificate_message_end":"' Abschnitt."},"certificate":{"label":"Zertifikate","add_button":"Zertifikat hinzufügen","about_label":"Um ein Zertifikat hinzuzufügen, laden Sie eine generierte Datei mit der Erweiterung '.crt' hoch.","no_data_label":"Es gibt keine Zertifikate","created_at_label":"Hergestellt in","valid_from_label":"Gültig ab","valid_till_label":"Gültig bis","remove_button":"Zertifikat entfernen","are_you_sure_label":"Möchten Sie dieses Zertifikat wirklich entfernen?","remove_warning_label":"Warnung! Wenn Sie dieses Zertifikat löschen, verlieren alle von ihm unterzeichneten Diplome ihre Gültigkeit!","insert_certificate_label":"Zertifikat zur Diplomunterzeichnung","insert_certificate_about_label":"Um ein Diplom einzufügen, müssen Sie eine Datei mit einem Zertifikatsschlüssel mit der Erweiterung '.jwk' hochladen. Wenn Sie diese Datei noch nicht haben, wenden Sie sich bitte an den Anker Ihrer Organisation.","change_certificate_button":"Neuen privaten digitalen Schlüssel einfügen","add_certificate_key_button":"Zertifikatschlüssel hinzufügen","insert_key_button":"Schlüssel einfügen","key_already_installed_button":"Der private digitale Schlüssel ist bereits installiert.","no_root_certificate_label":"Sie haben noch kein Stammzertifikat (root certificate) installiert.","root_certificate_hint":"Die BrainChain-Stammzertifikatsdatei (ca.crt genannt) wird vom Systemadministrator offline generiert und anschließend hier importiert. Dies stellt sicher dass beim Importieren in ihren Browser des Universitätsschlüssels(= die Datei uni.jwk), von dem Universitätsinsertor,  ein Validierungs-Handshake zwischen ihnen durchgeführt werden kann. Ohne ein importiertes Stammzertifikat führt dies zu Fehlern.","no_certificates_needed_label":"Keine Zertifikate erforderlich - Diese Organisation signiert keine Diplome digital","no_org_certificate_label_start":"Die Universitätsschlüsseldatei (uni.crt) wurde noch nicht installiert - bitte tun Sie dies in dem '","no_org_certificate_label_link":"Sicherheit","no_org_certificate_label_end":"' Abschnitt nach der gründlichen Validierung der Universität."},"validate_accreditation":{"label":"Diplom bestätigen","success_message":"Diplom erfolgreich bestätigt!","submit_button_validate":"Diplom bestätigen","common_message_label":"Kommentar für Rezensent hinterlassen","common_message_placeholder":"Lassen Sie Ihren Kommentar hier ...","submit_button_invalidate":"Zur Überprüfung zurücksenden","or_label":"oder","validate_accreditation_message":"Möchten Sie die Änderungen wirklich verwerfen und das Diplom akzeptieren?","submit_button_invalidate_title":"Bitte markieren Sie falsche Felder bzw. hinterlassen Sie dem Prüfer eine Nachricht."},"review_accreditation":{"label":"Überprüfung fehlgeschlagener Diplome","success_message":"Diplom erfolgreich erneut eingefügt!","submit_button":"Zur Bestätigung erneut einfügen","message_label":"Nachricht vom Validator","feedback_from_validator_label":"Feedback vom Validator","feedback_from_applicant_label":"Feedback vom Bewerber","review_accreditation_progress_label":"Verarbeitet","reinsert_accreditation_button_hint":"Bitte fügen Sie dieses Diplom nur erneut ein mit Änderungen die den $Konsens$ widerspiegeln den Sie mit dem Validator $offline$ erzielt haben. Wenn ein solcher Konsens nicht möglich ist, können Sie \"Entfernen\" wählen. Das Diplom wird dann in der Benutzeroberfläche des Antragstellers als \"Abgelehnt\" angezeigt."},"bulk_upload":{"drag_and_drop_label":"Datei hierher ziehen und ablegen","or_label":"oder","browse_label":"#Klicken Sie hier #, um auf Ihre Datei hinzuweisen","error_label":"Ooops! Datei konnte nicht angenommen werden: Falsches Dateiformat","uploaded_file_label":"Hochgeladene Datei","max_file_size_message":"Maximale Dateigröße","exceeded_upload_size_alert":"Diese Datei ist zu groß, um durch sie den Draht zu ziehen...","file_format_info_label":"Dateiformat Informationen","file_format_details_label":"Details zum Dateiformat","consent_request_bulk_error_label":"Bitte Datei auswählen um fortzufahren","consent_request_bulk_empty_file_label":"Die Datei ist leer"},"bulk_file_format_details":{"use_csv_message":"Bitte beachten Sie das CSV-Dateiformat.","file_header_message":"Ihre Datei sollte den folgenden Header haben:","additional_titles_label":"Codes für zusätzliche Übersetzungssprachen","language_code_label":"Sprachcode","provide_data_message":"Dies bedeutet, dass Sie Folgendes angeben sollten:","applicant_data_message":"Bewerber Daten: Email-Adresse, Vorname, Nachname, Ländercode, Personalausweisnummer","accreditation_data_message":"Diplomdaten: das Datum der Diplomausstellung, das Niveau, der ursprüngliche Titel, der Titel in Englisch und (zusätzlich) Titelübersetzungen. ","file_entries_message":"Jede nächste Zeile sollte Diplomdetails enthalten, die dem Header-Format entsprechen.","liaise_it_staff":"Bitte wenden Sie sich an das IT-Personal um eine korrekte Formatierung zu gewährleisten.","back_button":"Zurück zu 'Massenakkreditierungen hoch laden' ","csv_file_example_label":"Beispiel für eine CSV-formatierte Datei","download_example_button":"Beispiel herunterladen","values_details_label":"Inhaltdetails","email_details":"Für historische Diplome (d.h. älter als 2 Monate) ist die Email optional.","date_issued_details":"Das Ausstellungsdatum kann nicht in der Zukunft liegen.","levels_label":"Diplomniveaus","titles_label":"Zusätzliche Diplom Titel","header_name_label":"Headername","required_label":"Erforderlich","format_label":"Format","mean_label":"Inhalt","code_label":"Code","email_mean_label":"Email des Bewerbers","first_name_mean_label":"Vorname des Bewerbers","last_name_mean_label":"Nachname des Bewerbers","country_code_mean_label":"Ländercode des Bewerbers","national_id_mean_label":"Personalausweisnummer des Bewerbers","date_issued_mean_label":"Diplom Ausstellungsdatum (**)","level_mean_label":"Diplomniveau","original_mean_label":"Originaltitel des Diploms","en_mean_label":"Diplomtitel in englischer Sprache","lang_code_mean_label":"Zusätzliche Diplomtitel (Siehe Tabelle mit zusätzlichen Titel)","email_format":"bewerber@email.com","string_format":"Text","country_code_format":"ISO 3166-1 Alpha-2-Code","date_format":"JJJJ-MM-TT","level_format":"Niveau Code (siehe Tabelle mit Diplomstufen)","optional-fields-highlighted-label":"Optionale Felder werden hervorgehoben","gray_label":"in grau","use_xml_message":"Bitte beachten Sie das XML-Dateiformat.","csv_file_format_label":"CSV-Dateiformat","xml_file_format_label":"XML-Dateiformat","then_provide_message":"Dann sollten Sie folgendes angeben:","tag_name_label":"Verlinke den Namen","attributes_label":"Attribute","accreditations_meaning_label":"Container für die Liste der Diplom-Validationen","accreditation_meaning_label":"Behälter für Details der Diplom-Validation","titles_meaning_label":"Container für Titelübersetzungen der Diplom-Validierungen","title_meaning_label":"Titelübersetzung. Das Sprachattribut ist ein Sprachcode -original oder zusätzlich- der Übersetzung (siehe Tabelle mit zusätzlichen Titeln)","title_details":"Der Original-Diplom-Titel ist erforderlich.","xml_file_example_label":"XML-formatiertes Dateibeispiel","consent_bulk_file_info_label":"Bitte beachten Sie das TXT- oder CSV-Dateiformat. Sie sollten eine Datei mit den Email-Adressen der Bewerber bereitstellen, die durch Kommata, Semikolons, Zeilenumbrüche oder Leerzeichen getrennt sind."},"applicant_accreditations_management":{"certified_accreditations_label":"Zertifizierte Diplome","issued_by_label":"Herausgegeben von","expose_certified_accreditations":"Ausstellen","no_data_label_part_1":"Es gibt keine $Validierten Diplome$. $Validierte Diplome$ sind von Ihrer Universität bestätigte Diplome. Wenn keine vorhanden sind, können Sie dies unter 'Diplom-Validationsanfragen' anfordern.","no_data_label_part_2":"Wir bündeln solche Anfragen mit anderen Alumni, bis Ihre Universität sich bei BrainChain anschliesst. Über unsere ","no_data_label_part_3":"Website","no_data_label_part_4":" können Sie auch Ihre Universität zum anschliessen auffordern, falls dies noch nicht der Fall ist!","accreditation_details_label":" Details des Diploms ","remove_accreditation_alert":"Möchten Sie dieses Diplom wirklich entfernen?","remove_accreditation_success_massage":"Diplom erfolgreich entfernt!","pending_accreditations_label":"Ausstehende Diplome","accept_accreditation_button_label":"Diplom annehmen","send_back_accreditation_button_label":"Zur Überprüfung zurücksenden","discard_accreditation_message":"Möchten Sie dieses Diplom wirklich verwerfen?","discard_accreditation_warning_message":"Achtung! Im Falle einer Ablehnung wird das Diplom vollständig aufgehoben!","discard_accreditation_button_label":"Diplom verwerfen","vids_label":"Verifizierte Identitäten","expose_fn_ln_country":"Name und Land aufdecken","expose_national_id":"Personalausweis aufdecken","expose_nid_option_full":"Meine vollständige nationale Identifikationsnummer kann gezeigt werden","expose_nid_option_short":"Zeigen Sie nur die letzten 4 Ziffern meiner nationalen Identifikationsnummer","expose_nid_option_not_expose":"Niemals meine nationale Identifikationsnummer zeigen","no_vids_label":"Es gibt keine $Verifizierten Identitäten$. $Verifizierte Identitäten$ sind von Ihrer Universität bestätigte Identitäten und kommen mit bestätigten Diplomen.","active_vid_label":"Aktiv","active_vid_title_checked":"Aktive verifizierte Identität","active_vid_title_unchecked":"Als aktive verifizierte Identität festlegen","show_details_label":"Details zum Diplom anzeigen","no_pending_accreditations_label":"Es gibt keine $ausstehende Diplome$. Nachdem Sie Ihre Universität aufgefordert haben, Ihren Abschluss zu bestätigen, und nachdem Ihre Universität ihn bestätigt hat, werden Ihre Diplome hier mit einem Status aufgeführt, der diese (zeitliche!) Einseitige Validierung angibt. Potenzielle Arbeitgeber können sie bereits sehen, aber sie werden so gekennzeichnet, bis sie von beiden Seiten bestätigt wurden (auch von Ihnen!)."},"license_agreement":{"agree_label":"Ich akzeptiere die Bedingungen von","agree_link":"der Lizenzvereinbarung."},"consents":{"status":{"ALL":"Alle","PENDING":"Ausstehend","GRANTED":"Erteilt","REJECTED":"Abgelehnt","REVOKED":"Widerrufen","EXPIRED":"Abgelaufen","CANCELED":"Storniert","ABANDONED":"Storniert"},"status_title":{"PENDING":"Ausstehende Anfrage","GRANTED":"Erteilte Anfrage","REJECTED":"Abgelehnte Anfrage","REVOKED":"Widerrufene Anfrage","EXPIRED":"Abgelaufene Anfrage","CANCELED":"Stornierte Anfrage","ABANDONED":"Stornierte Anfrage"},"no_data_label":"Es gibt keine Einwilligungsanfragen","show_consents_list_label":"Liste von Einwilligungsanfragen öffnen","hide_consents_list_label":"Zurück zu den Details der Einwilligungsanfrage","no_selected_consent_request_label":"Wählen Sie eine Einwilligungsanfrage in der Liste aus, um Details anzuzeigen","edit_label":"Einwilligungsanfrage bearbeiten","cancel_request_success_message":"Anfrage erfolgreich storniert","request_details_label":"Anfrage Details","target_label":"Begünstigter","created_by_label":"Erstellt von","hidden_for_applicant_label":"Dem Bewerber verborgen","credentials_label":"Diplome","issued_at_label":"Ausgestellt am","cancel_request_button_label":"Anfrage stornieren","cancel_request_warning_label":"Warnung! Nach dem Stornieren wird diese Anfrage nicht mehr in der Liste angezeigt.","cancel_request_are_you_sure_label":"Möchten Sie die Anfrage wirklich stornieren?","applicant_response_label":"Antwort des Bewerbers","last_update_label":"Letztes Update","expires_label":"läuft ab","expired_label":"Abgelaufen","revoked_label":"Widerrufen","pending_consents_label":"Ausstehende Einwilligung","periods":{"week_label":"Woche","month_label":"Monat","year_label":"Jahr","forever_label":"unbegrenzt"},"consent_end_date_alert":"Ihre Einwilligung erlischt am","active_consents_label":"Aktive Einwilligungen","requested_label":"Angefordert","valid_till_label":"Gültig bis","grant_consent_button":"Einwilligung erteilen","current_expire_date_label":"Aktuelles Ablaufdatum","next_expire_date_label":"Nächstes Verfallsdatum","extend_consent_button":"Einwilligung verlängern","remove_consent_label":"Einwilligung widerrufen","remove_consent_button":"Widerrufen","remove_consent_success_label":"Einwilligung erfolgreich widerrufen!","remove_modal_alert":"Sind Sie sicher, dass Sie diese Einwilligung entfernen möchten?","person_label":"Person","none_label":"Keiner","no_active_consents_label":"Sie haben noch keine aktiven Einwilligungen","no_pending_consents_label":"Sie haben noch keine ausstehenden Einwilligungen","next_consent_button":"Nächste Anfrage","status_filter_label":"Status","job_label":"Job","job_filter_placeholder":"Geben Sie den Jobtitel für die Suche ein","job_title_label":"Jobtitel","internal_job_reference":"Interne Stellenreferenz","expose_job_reference":"Interne Stellenreferenz mit dem Bewerber teilen","note_to_applicants_label":"Hinweis für Bewerber","consents_history_label":"Beratungshistorie","show_consents_with_status_label":"Einwilligungen mit Status anzeigen","consents_history_no_data_label":"Ihre Beratungshistorie ist leer","status_label":"Status","expired_on_label":"Abgelaufen am","dismiss_request_button_label":"Anfrage ablehnen","dismiss_request_warning_label":"Warnung! Sie werden diese Einwilligungsanfrage nach dem Entlassen nicht mehr in der Liste sehen.","dismiss_request_are_you_sure_label":"Möchten Sie die Einwilligungsanfrage wirklich ablehnen?","self_study_books_label":"Selbststudiumbücher ","accreditations_label":"Diplome","remove_bulk_consent_requests":"Möchten Sie diese Datei wirklich entfernen?","verified_by_applicant_only_label":"Geprüft von: Nur Bewerber"},"prior_consents":{"prior_consents_label":"Vorherige Einwilligung","prior_consents_no_data_label":"Sie haben noch keine vorherigen Einwilligungen","target_type_label":"Art des Begünstigten","target_data_label":"Begünstigter","auto_grant_till_label":"Auto-Erteilung bis","duration_label":"Dauer","anyone_label":"Jedermann","day_label":"Tag","days_label":"Tage","add_prior_consent_label":"Vorherige Zustimmung erstellen","edit_prior_consent_label":"Vorherige Zustimmung bearbeiten","target_type_input_placeholder":"Begünstigten Art auswählen...","add_prior_consent_success_message":"Vorherige Zustimmung erfolgreich erstellt!","edit_prior_consent_success_message":"Vorherige Einwilligung erfolgreich aktualisiert!","period_label":"Zeitraum","duration_alert":"Die Zustimmungsfrist beträgt","response_comment_label":"Automatische Antwort an Anfrager","response_comment_placeholder":"Bitte lassen Sie hier Ihren Kommentar hinter ...","remove_prior_consent_label":"Vorherige Zustimmung entfernen","remove_prior_consent_success_message":"Vorherige Zustimmung erfolgreich entfernt!","remove_prior_consent_alert":"Möchten Sie diese vorherige Zustimmung wirklich entfernen?","prior_consents_hint_part_1":"Eine 'Vorherige Einwilligung' ist eine Einwilligung die Sie jetzt konfigurieren können und die sofort und automatisch ausgeführt wird, ohne Sie erneut zu stören zum Zeitpunkt der Anforderung durch ein Unternehmen .","prior_consents_hint_part_2":"Dies bedeutet dass Unternehmen, die Sie unten hinzufügen, sofort eine Bestätigung für die Diplome erhalten, die Sie aussetzen. Bis zum festgelegten Datum 'Automatisch gewähren bis'...","prior_consents_hint_part_3":"Das Feld 'Dauer' gibt an, wie lange eine Einwilligung gültig ist. Z.b. Wenn Sie das für einen Monat festlegen, bedeutet das dass Kollegen des ersten Anfragers (andere Personalmanager, Ihr potenzieller Chef!), .... von demselben Unternehmen, dies auch innerhalb dieses Monats nach dieser ersten Einwilligung überprüfen können. Nach Ablauf dieses Monats muss jedoch eine neue Anfrage von Ihnen gestellt werden, die BrainChain dann mit dem Datum der 'Automatischen gewähren bis' vergleicht!"},"approve_consent_after_request":{"label":"Einwilligung nach Anfrage genehmigen","success_alert":"Erfolgreiche Genehmigung der Einwilligungsanfrage","consent_requestor_label":"Zustimmungsanfragsteller","grant_title_label":"Erteilen","refuse_title_label":"Weigern","grant_button":"Erteilen","refuse_button":"Weigern","company_name_label":"Name des Unternehmens","company_country_label":"Land des Unternehmens","request_date":"Antragsdatum","period_label":"Zeitraum","period_input_placeholder":"Zeitraum wählen ...","reason_label":"Grund","reason_input_placeholder":"Grund wählen...","reasons":{"TIMING1":"Ich suche keinen Job","TIMING2":"Ich werde erst in mindestens einem Jahr frei sein","INTEREST":"Ich bin nicht daran interessiert, für dieses Unternehmen zu arbeiten","MISMATCH":"Dieser Job scheint nicht mit meinen Fähigkeiten übereinzustimmen","ANOTHER":"Andere Gründe"},"comment_label":"Bitte einen Kommentar hinterlassen für den Anfragsteller","comment_placeholder":"Geben Sie hier Ihre Nachricht ein ...","back_button":"Zurück ","approve_consent_progress_label":"Erteilt"},"notification_settings":{"label":"Benachrichtigungen","notification_settings_label":"Benachrichtigungseinstellung","notification_new_accreditation_enabled":"Email Senden, wenn ich neue Diplome überprüfen muss","notification_consent_request_enabled":"Email Senden, wenn ein potenzieller Arbeitgeber uns auffordert Ihr Diplom zu bestätigen","notification_settings_update_success_alert":"Benachrichtigungseinstellungen erfolgreich aktualisiert!","no_settings_label":"Derzeit sind keine Benachrichtigungseinstellungen verfügbar!","preferred_language":"Bevorzugte Benachrichtigungssprache"},"security_settings":{"label":"Sicherheit","2fa_label":"2-Faktor-Authentifizierung(2FA)","current_status_label":"Aktueller Status:","2fa_disabled_label":"2-Faktor-Authentifizierung deaktiviert.","2fa_enabled_label":"2-Faktor-Authentifizierung aktiviert.","disable_2fa_submit_button":"2-Faktor-Authentifizierung deaktivieren ","enable_2fa_submit_button":"2-Faktor-Authentifizierung aktivieren","disable_2fa_are_you_sure_message":"Möchten Sie die 2-Faktor-Authentifizierung wirklich deaktivieren? Nach dem Deaktivieren der 2-Faktor-Authentifizierung können Sie sich mit Email-Adresse und Kennwort in Ihrem Konto anmelden, ohne einen Bestätigungscode eingeben zu müssen.","disable_2fa_success_message":"2-Faktor-Authentifizierung erfolgreich deaktiviert.","enable_2fa_scan_qr_code_message":"Zur aktivierung der 2-Faktor-Authentifizierung, scannen Sie den QR-Code mit Google Authenticator oder einer anderen Applikation, die Ihnen gefällt. Mit der Applikation können Sie Bestätigungscodes für die Anmeldung in Ihrem Konto erhalten.","links_label":"Links zu Authentifizierungs-Apps","google_authenticator_android_label":"Google Authenticator für Android","google_authenticator_ios_label":"Google Authenticator für iOS","free_otp_android_label":"FreeOTP Authenticator für Android","free_otp_ios_label":"FreeOTP Authenticator für iOS","update_warning":"Sie sollten den neuen QR-Code jedes Mal scannen, wenn Sie die 2-Faktor-Authentifizierung aktivieren, um einen aktualisierten Code zu erhalten.","enable_2fa_check_code_message":"Um sicherzustellen dass alles korrekt funktioniert, können Sie den tatsächlichen Bestätigungscode eingeben, den Sie nach dem Scannen des QR-Codes erhalten haben","enable_2fa_parameters_label":"Authentifizierungsparameter","issuer_label":"Aussteller","secret_label":"Geheimnis","algorithm_label":"Algorithmus","digits_label":"Ziffern","period_label":"Zeitraum","check_code_label":"Verifizierungs-Schlüssel","enable_2fa_success_message":"2-Faktor-Authentifizierung erfolgreich aktiviert!","2fa_contact_support_message":"Wenn Sie aus irgendeinem Grund den Zugriff auf die Anwendung verloren haben und den Bestätigungscode nicht erhalten können, können Sie sich an den Support wenden.","verification_code_details_label":"Der Bestätigungscode muss sechsstellig sein.","verification_code_enter_label":"Informationen zum richtigen 2-Faktor-Authentifizierungscode finden Sie in der Code-Generator-Applikation, die Sie beim Aktivieren dieser Einstellung ausgewählt haben."},"self_study":{"table_label":"Selbststudienbücher","no_data_label":"Im Moment haben Sie keine $Selbststudienbücher$. Bücher die Sie selbst lesen oder studieren, können hier hinzugefügt werden und erfordern keine externe Bestätigung. Solche Bücher zeigen Interesse und Anstrengung; keinen Beweis für formale Bildung.","domain_label":"Domäne","publisher_label":"Herausgeber","study_date_label":"Lesedatum","isbn_label":"ISBN","domains":{"ADMINISTRATION_AND_MANAGEMENT":"Verwaltung und Management","COMMUNICATION":"Kommunikation","CULTURE_AND_SPORTS_AND_ENTERTAINMENT":"Kultur, Sport und Bewirtung","GOV":"Regierung","IT":"IT","LAND_AND_SEA_AND_AIR":"Land & Meer & Luft","LEGAL":"Recht","LIFE_AND_DEATH":"Leben & Tod","MANUFACTURING_AND_WORKING_WITH_MATERIALS":"Herstellung und Arbeiten mit Materialien","SALES_AND_MARKETING":"Vertrieb & Marketing","SERVICES":"Dienstleistungen","STEM":"STEM","OTHER":"Anderer"},"domains_examples":{"ADMINISTRATION_AND_MANAGEMENT":"Angestellte, Sekretäre, Führung, ...","COMMUNICATION":"Journalismus, Audio / Video, ...","CULTURE_AND_SPORTS_AND_ENTERTAINMENT":"Tourismus, Schauspieler, Stripper, Gastfreundschaft, ...","GOV":"Bildung, Armee, Polizei, beamte, ...","IT":"Entwickler, ML, AI, Webdesigner, DBA, Softwarearchitekt, ...","LAND_AND_SEA_AND_AIR":"Bauer, Fischer, Astronaut, Pilot, Flugbegleiter, Gärtner, ...","LEGAL":"Notar, Anwalt, ...","LIFE_AND_DEATH":"Arzt, Tierarzt, Therapeut, Zahnarzt, Krankenschwester, Scharfschütze, Gerichtsmediziner, ...","MANUFACTURING_AND_WORKING_WITH_MATERIALS":"Holzfäller, Schweißer, Textil, Automontage, Bergbau, Bauarbeiter, ...","SALES_AND_MARKETING":"Bäcker, Autoteile, Immo, Vermietung, Promotion, ...","SERVICES":"Reinigung, Friseur, Rekrutierung, Versicherungen, Bankier, Transport, Buchhaltung, Vertrieb, ...","STEM":"Wissenschaft (Pharma), Technologie (Automechaniker, Elektriker), Ingenieurwesen (Agraringenieur, Architekt), Mathematik"},"add_self_study_book_success_message":"Selbststudienbuch erfolgreich hinzugefügt!","edit_self_study_book_success_message":"Selbststudienbuch erfolgreich aktualisiert!","add_self_study_book_label":"Buch zum Selbststudienrepertoire hinzufügen","edit_self_study_book_label":"Selbststudienbuch bearbeiten","domain_select_placeholder":"Domäne auswählen...","expose_self_study_book_label":"Selbststudienbuch offenlegen","remove_self_study_book_alert":"Möchten Sie dieses Selbststudienbuch wirklich entfernen?","remove_self_study_book_success_message":"Selbststudienbuch erfolgreich entfernt!","isbn_format_hint":"Der ISBN10 / 13-Standard ist ein internationales Buchidentifizierungsschema. Bitte bleiben Sie bei diesem Format.","expose_label":"Offenlegen","error_messages":{"isbn_alert":"Bitte beachten Sie das Format ISBN10 oder ISBN13."}},"notifications":{"pending_organizations":"Sie haben {number} ausstehende Organisationen","review_failed_accreditations":"Sie haben {number} fehlgeschlagene Diplome zu überprüfen","validate_accreditations":"Sie haben {number} ausstehende Diplome","pending_accreditations":"Sie haben {number} ausstehende Diplome","pending_consents":"Sie haben {number} ausstehende Einwilligungen","pending_accreditation_requests":"Sie haben {number} ausstehende Diplom-Validationsanfragen","unreferenced_accreditation_requests_by_ags":"Sie haben {number} Diplom-Validationsanfragen ohne verknüpfte Fakultät","unreferenced_accreditation_requests_by_domains":"Sie haben {number} Diplom-Validationsanfragen ohne verbundene Universität"},"accreditation_requests":{"create_accreditation_request_label":"Diplom-Validationsanfrage erstellen","create_accreditation_request_success_message":"Diplom-Validationsanfrage erfolgreich erstellt!","create_accreditation_request_hint":"Falls Ihre Alma Mater bereits Teil der BrainChain-Plattform ist, können Sie sie in den folgenden Feldern auswählen. Falls nicht, gehen Sie bitte zu 'Manuelle Eingabe' und stellen Sie sicher, dass Sie die aktuelle Internetdomäne korrekt eingeben - Ihre Alma Mater hat diese Domäne im Laufe der Jahre möglicherweise geändert.","domain_hint":"Eine Internet-Domäne ist der erste Teil der Webadresse einer Organisation. Z.B. 'apple.com' oder 'ibm.de'.","accreditation_group_hint":"Eine Akkreditierungsgruppe ist in der Regel der Name der #Fakultät#, an der Sie Ihren Abschluss erworben haben. Wie #Bauingenieurwesen# oder #Psychologie#, je nachdem, wie Ihre Alma Mater sich organisiert.","national_id_hint":"Länder identifizieren ihre Bürger mit einer eindeutig codierten Nummer. Dies vermeidet Mehrdeutigkeiten - auch bei Personen mit genau demselben Namen. Natürlich ist es wichtig zu wissen, wer welchen Abschluss besitzt. Es gibt uns das perfekte Mittel, um sicherzustellen, dass AUCH jemand mit genau demselben Namen wie Sie niemals in der Lage sein wird, Ihre Identität zu stehlen. Oder behaupten, er hätte Ihren Abschluss erworben.","national_id_expose_hint":"Die nationale Identifikationsnummer ist nur für den Bewerber vollständig sichtbar. Bewerber können die Veröffentlichungs-Einstellungen jederzeit ändern.","manual_org_input_mode_label":"Organisationsdaten manuell eingeben","select_org_input_mode_label":"Organisation auswählen","manual_accreditation_group_input_mode_label":"Geben Sie die Diplomgruppe (Fakultät) manuell ein","select_accreditation_group_input_mode_label":"Diplomgruppe (Fakultät) auswählen","manual_vid_input_mode_label":"Geben Sie die VID-Daten manuell ein","select_vid_input_mode_label":"VID wählen","vid_label":"Verifizierte Identität","status":{"REQUEST_SUBMITTED":"Eingereicht","REQUEST_IN_PROCESS":"In Bearbeitung","REQUEST_REJECTED":"Abgelehnt"},"status_label":"Anfrage Status","expose_label":"Ausgestelltes Diplom","edit_accreditation_request_label":"Diplom-Validationsanfrage bearbeiten","remove_accreditation_request_label":"Diplom-Validationsanfrage entfernen","accreditation_requests_no_data_label":"Sie haben noch keine Diplom-Validationsanfragen","accreditation_requests_label":"Diplom-Validationsanfragen","accreditation_request_remove_alert":"Möchten Sie diese Anfrage zur Diplom-Validation wirklich entfernen?","edit_accreditation_request_success_message":"Diplom-Validationsanfragen erfolgreich aktualisiert!","pending_accreditation_requests_by_domain_label":"Ausstehender Diplom-Validationsanfragen nach Domain","validated_accreditation_requests_by_domain_label":"Validierte Diplom-Validationsanfragen nach Domain","accreditation_requests_list_no_data_label":"Es gibt noch keine Diplom-Validationsanfragen","organization_domain_label":"Organisationsdomäne","accreditation_requests_number_label":"Diplom-Validationsanfragen Nummer","filter_by_domain_label":"nach Domäne filtern","filter_label":"Filtern","accreditation_requests_remove_alert":"Sind Sie sicher, dass Sie diese Diplom-Validationsanfrage entfernen möchten?","remove_accreditation_request_success_message":"Diplom-Validationsantrag erfolgreich entfernt!","remove_accreditation_requests_success_message":"Diplom-Validationsanfragen erfolgreich entfernt!","update_accreditation_requests_success_message":"Domäne der Diplom-Validationsanfragen erfolgreich aktualisiert!","accreditation_requests_warning_alert":"Diese Organisation hat {number} Diplom-Validationsanfragen. Wenn Sie diese Organisation ohne die Erlaubnis zum Einfügen von Diplome speichern, werden alle ausstehenden Diplom-Validationsanfragen entfernt!","proceed_button":"Nächster","accreditation_requests_by_group_label":"Diplom-Validationsanfragen nach Fakultät","accreditation_requests_by_group_hint_part_1":"Hier können Sie die Diplom-Validationsanfragen von Bewerbern (Liste unten) mit bestehenden Akkreditierungsgruppen (Fakultäten) an Ihrer Universität koppeln.","accreditation_requests_by_group_hint_part_2":"Sobald sie gekoppelt sind, werden sie an den richtigen Insertor(-s) weitergeleitet..","accreditation_requests_by_group_hint_part_3":"Beachten Sie, dass Sie mehrere Anfragen derselben Akkreditierungsgruppe (Fakultät) bündeln können.","set_accreditation_group_for_selected_button":"Akkreditierungsgruppe (Fakultät) für ausgewählte Anfragen festlegen","reject_selected_button":"Ausgewählte ablehnen","reject_accreditation_requests_alert":"Möchten Sie wirklich alle ausgewählten Diplom-Validationsanfragen ablehnen?","reject_button":"Ablehnen","set_accreditation_group_for_selected_requests_label":"Festlegen der Akkreditierungsgruppe (Fakultät) für ausgewählte Diplom-Validationsanfragen","set_accreditation_group_for_selected_requests_success_message":"Referenz der Akkreditierungsgruppe (Fakultät) erfolgreich hinzugefügt!","expose_accreditation_request_label":"Diplom-Validationsanfrage offenlegen","pending_accreditation_requests_label":"Ausstehende Diplom-Validationsanfragen","pending_accreditation_requests_no_data_label":"Es gibt noch keine ausstehenden Diplom-Validationsanträge","pending_accreditation_requests_hint_part_1":"Wenn die Daten korrekt sind, können Sie die Anfrage einfach #Bestätigen#. Wenn Sie sich nicht sicher sind, können Sie auf #Weiter# klicken, um die aktuelle Anfrage zu überspringen.","pending_accreditation_requests_hint_part_2":"Wenn die Angaben zum Diplom falsch sind, können Sie sie vor dem Einfügen korrigieren.","back_button":"Zurück zur Liste der ausstehenden Diplom-Validationsanfragen","process_accreditation_request":"Diplom-Validationsanfrage bearbeiten","next_accreditation_request_label":"Nächste Diplom-Validationsanfrage","confirm_accreditation_request_button":"Bestätigen und einfügen","reject_accreditation_request_alert":"Möchten Sie diese Diplom-Validationsanfrage wirklich ablehnen?","organization_label":"Organisation","applicant_email_label":"Email des Bewerbers","expose_hint":"Sie können auch bereits noch nicht validierte Diplome offenlegen an potenzielle Arbeitgeber. Diese werden jedoch als 'nicht validiert' gekennzeichnet, bis auch die Universität sie bestätigt hat.","created_at_label":"Anforderungsdatum","org_by_domain_error_alert":"Diese Organisation hat keine Erlaubnis, Diplome einzufügen.","accreditations_pending_approval_label":"Ausstehende Diplome","accreditation_requests_details_label":"Diplom-Validationsanfrage Details","reject_accreditation_request_success_message":"Diplom-Validationsanfrage erfolgreich abgelehnt!","confirm_accreditation_request_success_message":"Diplom-Validationsanfrage erfolgreich bestätigt!","pending_accreditations_progress_label":"Eingefügt","validated_accreditations_progress_label":"Validierte","validate_button":"Validieren","accreditation_requests_validate_alert":"Sind Sie sicher, dass Sie diese Diplom-Validationsanfragen validieren möchten?","validate_accreditation_requests_success_message":"Diplom-Validationsanfragen erfolgreich validiert!","pending_accreditation_requests_list_no_data_label":"Es gibt keine ausstehende Diplom-Validationsanfragen.","validated_accreditation_requests_list_no_data_label":"Es gibt noch keine validierten Diplom-Validationsanfragen.","last_requestors_button":"Letzte Bewerber","applicant_accreditation_consent_label":"Hiermit erkläre ich mich mit der BAVA (BrainChain Accreditation Verification Authority) einverstanden, die Überprüfung durchzuführen und mich auf dem Laufenden zu halten."},"security":{"label":"Sicherheit","got_it_button":"Verstanden!","anchor_info_part_1":"Jede Kommunikation mit BrainChain wird mit einem sicheren digitalen Schlüssel verschlüsselt. Dadurch werden Diplomdaten sicher verpackt, um Schnüffeln und Manipulieren zu verhindern. Sie erhalten diesen Schlüssel - eine Datei mit der Erweiterung '.jwk' - auf einfache Anfrage von BrainChain.","anchor_info_part_2":"Ihre Rolle als Anker bedeutet, dass Sie diese Schlüssel auf sichere Weise (= vorzugsweise offline, z. B. auf einem USB-Stick) mit allen von Ihnen ernannten Insertors teilen sollten.","anchor_info_part_3":"Ohne diesen Schlüssel können sie keine Diplome einfügen.","inserter_info_part_1":"Jede Kommunikation mit BrainChain wird mit einem sicheren digitalen Schlüssel verschlüsselt. Dadurch werden Diplomdaten sicher verpackt, um Schnüffeln und Manipulieren zu verhindern. Ihr Anker erhält diesen Schlüssel von BrainChain und gibt ihn an Sie weiter. Dieser Schlüssel ist eine Datei mit der Erweiterung '.jwk'.","inserter_info_part_2":"Das einzige was Sie tun müssen um anfangen zu können, ist, diese Datei zu löschen oder zu importieren auf demselben Computer, auf dem Sie Diplome einfügen.","inserter_info_part_3":"Das ist ein einmaliger Aufwand, pro Computer den Sie für diesen Zweck verwenden.","inserter_info_part_4":"Sobald der Schlüssel installiert ist, erfolgt die Verschlüsselung und Signatur des Diploms transparent im Hintergrund, ohne dass weitere Maßnahmen erforderlich sind.","admin_root_certificates_label":"Verwaltung des BrainChain-Stammzertifikats","admin_universities_label":"Validierte Universitäten - warten darauf, dass wir ihren serverseitigen Schlüssel hochladen","admin_universities_info_part_1":"Abgesehen vom BrainChain-Stammzertifikat gibt es eine zweite Komponente, die wir serverseitig installieren müssen für Universitäten: das generierte universitätsspezifische Zertifikat uni.crt.","admin_universities_info_part_2":"Unten finden Sie eine Liste der validierten Universitäten für die dieser Schlüssel noch nicht installiert ist und die auf ihn warten. Das kann direkt nach der Validierung der Universität gemacht werden: jetzt! Vergessen Sie nach der Installation dieses Schlüssels nicht, dem Universitäts-Anker auch seine eigene uni.jwk-Datei zu senden. Dies muss von der SA offline generiert werden.","add_valid_till_label":"Hinzufügen / Gültig bis","add_certificate_button":"uni.crt Hinzufügen","mail_anchor_label":"Mail Anker uni.jwk","is_uni_key_sent_label":"Uni Schlüssel gesendet?","confirm_sent_button":"Gesendet Bestätigen","mail_subject_label":"Ihr digitaler BrainChain-Schlüssel zum sicheren Signieren von Diplomen","mail_body_part_1":"Lieber {anchor},","mail_body_part_2":"Jede Kommunikation mit BrainChain wird mit einem sicheren digitalen Schlüssel verschlüsselt. Dadurch werden Diplomdaten sicher verpackt, um Schnüffeln und Manipulieren zu verhindern. Dieser Schlüssel - eine Datei mit der Erweiterung '.jwk' - wird im Anhang hinzugefügt.","mail_body_part_3":"Ihre Rolle als Anker bedeutet, dass Sie diese Schlüssel auf sichere Weise (= vorzugsweise offline, z. B. auf einem USB-Stick) mit allen von Ihnen ernannten Insertors teilen sollten.","mail_body_part_4":"Ohne diesen Schlüssel können sie keine Diplome einfügen.","mail_body_part_5":"Wenn Sie das vergessen, werden Sie von BrainChain im Abschnitt Sicherheit daran erinnert.","mail_body_part_6":"Team BrainChain"},"assistants":{"assistants_label":"Assistenten","no_data_label":"Es gibt noch keine Assistenten.","roles_label":"Rollen","location_label":"Standort","process_assistant_label":"Prozessassistent","financial_assistant_label":"Finanzassistent","add_assistant_page_label":"Assistent hinzufügen","roles_select_placeholder":"Wählen Sie Assistentenrollen...","remove_assistant_alert":"Möchten Sie diesen Assistenten wirklich entfernen?","edit_assistant_alert":"Bearbeiten Assistent"},"business_ambassadors":{"business_ambassadors_label":"Geschäftsbotschafter","no_data_label":"Es gibt noch keine Geschäftsbotschafter.","financial_data_label":"Finanzdaten","add_business_ambassador_label":"Geschäftsbotschafter hinzufügen","edit_business_ambassador_label":"Geschäftsbotschafter bearbeiten","add_business_ambassador_success_message":"Geschäftsbotschafter erfolgreich hinzugefügt!","edit_business_ambassador_success_message":"Geschäftsbotschafter erfolgreich aktualisiert!","remove_ambassador_alert":"Möchten Sie diesen Geschäftsbotschafter wirklich entfernen?"},"commissions":{"commissions_list_label":"Provisionen","countries_label":"Länder","commission_label":"Provision","date_from_label":"Datum von","date_to_label":"Datum bis","no_data_label":"Es gibt keine Provisionen.","remove_commission_success_message":"Provisionen erfolgreich entfernt!","remove_commission_alert":"Sind Sie sicher, dass Sie diese Provisionen entfernen möchten?","add_commission_label":"Provisionen hinzufügen","edit_commission_label":"Provisionen bearbeiten","add_commission_success_message":"Provisionen erfolgreich erstellt!","edit_commission_success_message":"Provisionen erfolgreich aktualisiert!","ba_label":"Geschäftsbotschafter","ba_short_label":"BA","add_commission_hint":"Für # bereits definierte # Geschäftsbotschafter können nachfolgend neue Provisionen definiert werden"},"system_payment":{"due_payments_label":"Fällige Zahlungen","ba_s_due_payments_label":"Fällige Zahlungen an Geschäftsbotschafter","uni_s_due_payments_label":"Fällige Zahlungen an Bildung weltweit","system_due_payments_label":"Fällige Zahlung an WickedWare","system_due_payments_hint":"Diese Zahl gibt den Betrag an, der vom WickedWare-Konto 'BrainChain' auf das WickedWare-Konto 'Savings' (LT773500010003830341) überwiesen werden soll. Dies ist eine Summe der ausstehenden verbrauchten Unternehmenskredite.","filter_by_region_label":"Nach Region filtern","ba_label":"BA","uni_label":"Uni","amount_label":"Offener Betrag","total_aggregated_pay_label":"Gesamtvergütung","ba_wire_data_label":"BA-Transaktionsdaten","uni_wire_data_label":"Uni-Transaktionsdaten","record_payment_label":"Zahlung aufnehmen","paid_button":"Bestätigen Sie die offline Zahlung","no_ba_s_label":"Es gibt keine BAs.","no_uni_s_label":"Es gibt keine Universitäten.","no_payments_for_ba_s_label":"Keine Zahlungen an BAs fallen unter diesen Kriterien","no_payments_for_uni_s_label":"Keine Zahlungen an Universitäten fallen unter diesen Kriterien","no_payments_for_system":"Für WickedWare sind keine Zahlungen fällig.","show_label":"Zeigen","due_payments_paid_success_message":"Fällige Zahlungen erfolgreich bezahlt!","payments_history_label":"Zahlungsverlauf","uni_s_payments_history_label":"Zahlungsverlauf für Bildung weltweit","ba_s_payments_history_label":"Zahlungsverlauf für Geschäftsbotschafter","payment_date_label":"Zahlungsdatum","filter_date_from_label":"Datum von","filter_date_to_label":"bis","name_label":"Name","company_credit_label":"Organisationskredit","date_joined_label":"Beitrittsdatum","open_credit_label":"Offene Guthaben","total_credit_label":"Insgesamt verwendetes Guthaben","contact_label":"Kontakt","no_companies_credits_label":"Keine Organisationsguthaben fallen unter diesen Kriterien.","order_by_label":"Sortieren nach","due_payment_modal_label":"Fällige Zahlung für {name}","wire_data_modal_label":"Transaktionsdaten für {name}","comment_label":"Kommentar","no_company_credits":"Keine Kredit-Historie für dieses Unternehmen","date_label":"Datum","value_of_change_label":"Wert der Änderung","credit_history_label":"Kredit-Historie für {name}"},"validated_domains":{"validated_domains_label":"Validierte Edu-Domänen","no_data_label":"Es gibt keine validierten Domänen","filter_by_name_label":"Nach Namen filtern","organization_name_label":"Name der Organisation,","managed_by_label":"Verwaltet von","applicant_requests_label":"Anfragen von Bewerber","bava_managed_label":"BAVA-verwaltet","self_managed_label":"Selbst verwaltet","add_domain_button":"Domain hinzufügen","validate_domain_label":"Domain Validieren","contact_name_label":"Kontaktname","contact_email_label":"Kontakt Email","contact_phone_label":"Kontakt Telefon","add_success_message":"Validierte Domain erfolgreich hinzugefügt!","edit_success_message":"Validierte Domain erfolgreich aktualisiert!","edit_domain_label":"Organisationsdetails bearbeiten","remove_domain_alert":"Möchten Sie diese validierte Domain wirklich entfernen? Beachten Sie dass dies bedeutet dass alle Diplome in den Profilen der Personen auch gelöscht werden!","remove_success_message":"Validierte Domain erfolgreich entfernt!","fully_registered_org_hint":"Sie können diese Organisation in der Liste der Organisationen ändern."},"shared":{"add_button":"Hinzufügen","cancel_button":"Abbrechen","remove_button":"Entfernen","first_name_label":"Vorname","last_name_label":"Nachname","email_label":"Email","personal_email_label":"Private Email","professional_email_label":"Berufliche  Email","password_label":"Passwort","department_label":"Abteilung","continent_input_placeholder":"Region auswählen ...","country_input_placeholder":"Land auswählen ...","continent_label":"Region","continent_filter_label":"Region (Filter)","country_label":"Land","fetching_message":"Laden ...","success_message":"Erfolg","national_id_label":"Personalausweisnummer","company_label":"Unternehmen","edu_org_label":"Bildungsorganisation","org_label":"Organisation","employee_count_label":"Anzahl der Mitarbeiter","name_label":"Name","accreditation_group_label":"Akkreditierungsgruppe (Fakultät)","okey_button":"OK","yes_label":"Ja","no_label":"Nein","edit_button":"Bearbeiten","domain_label":"Internetdomäne","datepicker_placeholder":"Klicken um ein Datum auszuwählen","save_changes_button":"Änderungen speichern","back_button":"Zurück","company_domain_label":"Unternehmensdomäne","search_label":"Suchen","about_label":"Über","title_label":"Titel","phone_number_label":"Telefonnummer","required_field_error_message":"Bitte füllen Sie dieses Feld aus","pages_label":"{currentNumber} von {totalNumber}","examples_label":"Beispiele","location_label":"Standorte","all_label":"Alle","filter_options_label":"Filteroptionen"},"errors":{"IRRELEVANT_LINK_EMAIL":"Sie haben Ihre Email-Adresse über diesen Link bereits geändert!","INCORRECT_JWK":"Falscher Zertifikatsschlüssel","DEFAULT_ERROR":"Fehler","INCORRECT_ACCOUNT_TYPE":"Falscher Kontotyp","INCORRECT_USERNAME_OR_PASSWORD":"Falscher Benutzername oder Passwort","IRRELEVANT_LINK":"Sie haben Ihr Passwort über diesen Link bereits zurückgesetzt!","INCORRECT_FILE_CONTENT":"Falscher Dateiinhalt","INCORRECT_DOMAIN":"Die angegebene Domain ist ungültig.","BAVA_ACCREDITATION_FLOW_FORBIDDEN":"Operationen mit Diplomen im Zusammenhang mit BAVA sind verboten.","BAVA_ACCREDITATION_MISSING_PARAMS":"Die Organisations-ID sollte im Diplom angegeben werden.","BAVA_MISSING":"Die Bava-Organisation ist nicht registriert.","BAVA_CANNOT_BE_CHANGED":"Die Bava-Organisation kann nicht geändert werden.","RELATED_ACCREDITATIONS_EXISTS":"Der verwaltete Status kann nicht geändert werden für Organisationen mit vorhandenen Diplom-Validationsanfragen ","REQUEST_BODY_INVALID":"Falsche Daten. Bitte stellen Sie sicher, dass Sie alle Felder korrekt ausgefüllt haben.","REQUEST_PARAM_MISSING":"Erforderlicher Anforderungsparameter fehlt","REQUEST_PARAM_INVALID":"Der Wert des Anforderungsparameters ist ungültig","OPERATION_NOT_PERMITTED":"Operation unzulässig","OAUTH_CLIENT_ERROR":"OAuth-Anfrage ungültig","OAUTH_GRANT_TYPE_INVALID":"OAuth einer Zuschussart ungültig","NEGATIVE_BALANCE":"Das Guthaben kann nicht negativ sein.","ACCREDITATION_GROUP_ROLE_INVALID":"Ungültige Akkreditierungsgruppenrolle","ACCREDITATION_GROUP_ACCREDITATION_REQUEST_ADDITION_ERROR":"Es ist nicht möglich, diese Fakultät zur Diplom-Validationsanfragen hinzuzufügen.","ACCREDITATION_GROUP_STAFF_ADDITION_ERROR":"Angegebenes Personal kann für angegebene Akkreditierungsgruppe nicht hinzugefügt werden","ACCREDITATION_GROUP_STAFF_REMOVAL_ERROR":"Angegebenes Personal kann nicht aus der angegebenen Akkreditierungsgruppe entfernt werden","ACCREDITATION_GROUP_NAME_MISSING":"#Bitte geben Sie einen Namen für die Akkreditierungsgruppe an (a.k.a. Fakultät), da für diese Organisation keine Standardoption vorhanden ist.#","DEPARTMENT_ROLE_INVALID":"Ungültige Abteilungsrolle","DEPARTMENT_STAFF_ADDITION_ERROR":"Angegebenes Personal für angegebene Abteilung kann nicht hinzugefügt werden","DEPARTMENT_STAFF_REMOVAL_ERROR":"Angegebenes Personal kann nicht aus der angegebenen Abteilung entfernt werden","UNSUFFICIENT_BALANCE":"Das Guthaben reicht nicht aus. Bitte wenden Sie sich an die verantwortliche Person bzw. Abteilung um das Problem zu beheben","TIME_PERIOD_INVALID":"Zeitraum ist ungültig","CONSENT_REQUEST_STATUS_INVALID":"Diese Anfrage wurde bereits bearbeitet oder storniert","ABANDONING_OTHERS_REQUEST":"Sie können diesen Vorgang nicht ausführen","PRIOR_CONSENT_EXISTS":"Eine vorherige Einwilligung für denselben Begünstigten besteht bereits","INCORRECT_ORGANIZATION_PAID_TILL_STATE":"Falsche Angabe für 'Bezahlt bis' Datum; Das neue Datum 'Bezahlt bis' sollte aktueller sein als die vorherige Angabe.","EXPIRED_ORGANIZATION_PAID_TILL":"Das 'Bezahlt bis' Datum der Organisation ist abgelaufen.","ORGANIZATION_EMAIL_INVALID":"Ungültige berufliche Email","STAFF_REMOVAL_ERROR":"Dieses Personal kann nicht entfernt werden","NO_ANCHOR_LEFT":"Anker kann sich nicht selbst löschen!","ACTIVE_STAFF_MISSING":"Mitarbeiter mit der angegebenen ID kann nicht gefunden werden","NON_STAFF_USER_EXISTS":"Angegebener Benutzer ist bereits vorhanden aber er ist kein Mitarbeiter!","STAFF_DIFFERENT_ORGANIZATION":"Eine Person mit dieser Email arbeitet schon in einer anderen Organisation.","STAFF_ALREADY_EXISTS":"Ein Kollege mit dieser Email arbeitet bereits in Ihrer Organisation","ORGANIZATION_ALREADY_EXISTS":"Organisationsname bzw. Domäne wird bereits verwendet","ORGANIZATION_IS_BAVA_MANAGED":"Solange diese Organisation von der BAVA verwaltet wird, kann sie keine Akkreditierungsgruppen haben. Alle Diplome werden bis zum Beitritt der Organisation unter \"AllFaculties\" zusammengefasst. Ab diesem Zeitpunkt soll eine Diplom-Migrationsmaßnahme organisiert werden.","ORGANIZATION_CANNOT_BE_REMOVED":"Von BAVA verwaltete Organisationen können entfernt werden, aber BAVA (und seine Tochterprüfungsbehörden) selbst können nicht entfernt werden.","ORGANIZATION_CANNOT_BE_UPDATED":"Eine Organisation mit diesem Namen und / oder Domain wurde bereits registriert.","ORGANIZATION_CERTIFICATE_MISSING":"Für diese Organisation gibt es keine gültigen Zertifikate","ORGANIZATION_ACCREDITATION_INCORRECT_STATUS":"Falscher Akkreditierungsstatus","ORGANIZATION_ACCREDITATION_FLOW_FORBIDDEN":"Die Organisation hat keine Erlaubnis, Diplome einzufügen","ORGANIZATION_EQUAL_MANAGED_STATE":"Die Organisation befand sich bereits in diesem Zustand.","USER_ALREADY_EXISTS":"Konto ist bereits vorhanden","ACTIVATION_NOT_NEEDED":"Konto ist unbekannt oder bereits aktiv","ALIAS_REQUIRED":"Benutzer kann nicht ohne vollständigen Alias aktiviert werden","APPLICANT_TOKEN_REQUIRED":"Das Token des Bewerbers fehlt","APPLICANT_NOT_FOUND":"Es ist noch niemand mit dieser Email-Adresse in BrainChain registriert.","OLD_PASSWORD_INVALID":"Ungültiges altes Passwort","EMAIL_ALREADY_IN_USE":"Email-Adresse wird bereits verwendet","USER_INACTIVE":"Konto ist unbekannt oder inaktiv","NO_ALIASES_LEFT":"Es sollte mindestens ein Alias vorhanden sein","PASSWORD_TOO_SIMPLE":"Passwort ist zu einfach","CAN_NOT_REMOVE_LAST_ROOT_ADMIN":"Der letzte Root-Administrator kann nicht entfernt werden","BUSINESS_AMBASSADOR_CONTRACT_INTERSECTION":"Für jede [Land, BA] -Kombination kann nur eine Kommission angegeben werden.","BUSINESS_AMBASSADOR_CONTRACT_HUGE_TOTAL_PERCENT":"Der Gesamtprovisionsprozentsatz wurde im Laufe der Zeit für einige Länder größer als erwartet.","VALIDATING_OWN_WORK":"Sie können Ihre eigene Arbeit nicht genehmigen  (Fragen Sie verstorbene Künstler!)","DELETING_OTHERS_WORK":"Sie können diesen Vorgang nicht ausführen","ACCREDITATION_SIGNATURE_INVALID":"Die angegebene Unterschrift ist ungültig","ACCREDITATION_SIGNATURE_MISSING":"Erforderliche Unterschrift fehlt","ORIGINAL_ACCREDITATION_NOT_FOUND":"Entschuldigung, die Originaldaten dieser Akkreditierung (Diplom) konnten nicht abgerufen werden.","APPLICANT_ACCREDITATION_REQUEST_ACCREDITATION_GROUP_ID_INVALID":"Ungültige ID der Akkreditierungsgruppe (Fakultät) für die angegebene Organisation","APPLICANT_ACCREDITATION_REQUEST_ACCREDITATION_GROUP_MISMATCH":"Die vom Bewerber zur Verfügung gestellte Akkreditierungsgruppe (Fakultät) unterscheidet sich von der Gruppe, die zum Einfügen neuer Diplome verwendet wird.","APPLICANT_ACCREDITATION_REQUEST_STATUS_INVALID":"Der Status der Diplom-Validationsanfrage des Bewerbers erlaubt keine Einfügung.","ACCREDITATION_BULK_JOB_NOT_FINISHED":"Bitte warten Sie bis der Bulk Upload abgeschlossen ist.","CREATE_CONSENT_REQUEST_BULK_JOB_NOT_FINISHED":"Bitte warten Sie, bis der Sammelupload abgeschlossen ist.","ACCREDITATION_BULK_JOB_MISSING_REQUIRED_HEADERS":"Erforderliche Kopfzeile fehlt.","ACCREDITATION_BULK_JOB_INVALID_RECORD_SIZE":"Spalten stimmen nicht mit der Kopfzeile überein.","ACCREDITATION_BULK_JOB_INVALID_RECORD_FORMAT":"Ungültiges Datensatzformat","ACCREDITATION_BULK_JOB_INVALID_XML_DOCUMENT_FORMAT":"Ungültiges XML-Dokumentformat","CURRENCY_NOT_SUPPORTED":"Währung wird nicht unterstützt","DIGITAL_CERTIFICATE_UNSUPPORTED_FORMAT":"Das digitale Zertifikatformat wird nicht unterstützt","DIGITAL_CERTIFICATE_NOT_YET_VALID":"Digitales Zertifikat ist noch nicht gültig","DIGITAL_CERTIFICATE_EXPIRED":"Digitales Zertifikat ist abgelaufen","DIGITAL_CERTIFICATE_VERIFICATION_FAILED":"Das digitale Zertifikat ist nicht ordnungsgemäß signiert","UNSUPPORTED_CONTENT_TYPE":"Nicht unterstützter Inhaltstyp","FAILED_TO_PARSE_BODY":"Fehler beim Parsen der Datei","FILE_TOO_LARGE":"Die hochgeladene Datei ist zu groß","BUSINESS_AMBASSADOR_NOT_FOUND":"Geschäftsbotschafter nicht gefunden","BUSINESS_AMBASSADOR_CONTRACT_NOT_FOUND":"Geschäftsbotschaftervertrag nicht gefunden","ACCREDITATION_GROUP_NOT_FOUND":"Akkreditierungsgruppe (Fakultät) nicht gefunden","ACCREDITATION_GROUP_CONTAIN_REQUESTS":"Diese Fakultät (Akkreditierungsgruppe) enthält unverarbeitete Anfragen und kann daher nicht entfernt werden.","DEPARTMENT_NOT_FOUND":"Abteilung nicht gefunden","ORGANIZATION_NOT_FOUND":"Organisation nicht gefunden","STAFF_NOT_FOUND":"Mitarbeiter nicht gefunden","ALIAS_NOT_FOUND":"Alias nicht gefunden","ACCREDITATION_NOT_FOUND":"Diplom nicht gefunden","VERIFIED_IDENTITY_NOT_FOUND":"Verifizierte Identität nicht gefunden","ACCREDITATION_BULK_JOB_NOT_FOUND":"Sammelupload nicht gefunden","CREATE_CONSENT_REQUEST_BULK_JOB_NOT_FOUND":"Sammelupload nicht gefunden","NO_HANDLER_FOUND":"Kein Handler gefunden","PRICING_PRESET_NOT_FOUND":"Preisvorgabe nicht gefunden","USER_NOT_FOUND":"Der von Ihnen gesuchte Benutzer hat sich noch nicht bei BrainChain registriert.","CONSENT_REQUEST_NOT_FOUND":"Einwilligungsanfrage nicht gefunden","PRIOR_CONSENT_NOT_FOUND":"Vorherige Einwilligung nicht gefunden","SELF_STUDY_BOOK_NOT_FOUND":"Selbststudienbuch nicht gefunden","DIGITAL_CERTIFICATE_NOT_FOUND":"Digitales Zertifikat nicht gefunden","APPLICANT_ACCREDITATION_REQUEST_NOT_FOUND":"Bewerber Diplom-Validationsanfragen nicht gefunden","TOKEN_NOT_FOUND":"Kein Token gefunden","TOKEN_EXPIRED":"Token abgelaufen","TOKEN_INVALID":"Token ungültig","TOKEN_VALIDATION_ERROR":"Token-Validierungsproblem","TOTP_CODE_INVALID":"Bestätigungscode ungültig","TOTP_CODE_REQUIRED":"TOTP-Code erforderlich","AUTHENTICATION_FAILED":"Authentifizierung fehlgeschlagen","ORGANIZATION_NOT_VERIFIED":"Organisation wird nicht überprüft","USER_ALREADY_ACTIVE":"Dieser Konto ist bereits aktiv","ORGANIZATION_CANNOT_WORK_WITH_ACCREDITATIONS":"Diese Organisation kann nicht mit Diplome arbeiten","ACCESS_DENIED":"Zugriff verweigert","APPLICANT_ACCREDITATION_REQUEST_CANNOT_BE_MODIFIED_IF_ORG_REFERENCED":"Die Diplom-Validationsanfragen des Bewerbers können nicht mehr geändert werden, da die betroffene Organisation inzwischen in BrainChain registriert ist.","APPLICANT_ACCREDITATION_REQUEST_ORG_CHANGE_FORBIDDEN":"Die Organisation eines Diplom-Validationsanfragen eines Bewerbers kann nicht geändert werden.","APPLICANT_ACCREDITATION_REQUEST_AMOUNT_TOO_LARGE":"Die maximale Anzahl an Diplom-Validationsanfragen wurde erreicht.","UNAUTHORIZED":"Nicht autorisiert","INTERNAL_SERVER_ERROR":"Interner Serverfehler"},"continents":{"AF":"Afrika","NA":"Nordamerika","OC":"Ozeanien","AN":"Antarktika","AS":"Asien","EU":"Europa","SA":"Südamerika"},"countries":{"AD":"Andorra","AE":"Vereinigte Arabische Emirate","AF":"Afghanistan","AG":"Antigua und Barbuda","AI":"Anguilla","AL":"Albanien","AM":"Armenien","AO":"Angola","AQ":"Antarktika","AR":"Argentinien","AS":"Amerikanisch-Samoa","AT":"Österreich","AU":"Australien","AW":"Aruba","AX":"Aland Islands","AZ":"Aserbaidschan","BA":"Bosnien und Herzegowina","BB":"Barbados","BD":"Bangladesch","BE":"Belgien","BF":"Burkina Faso","BG":"Bulgarien","BH":"Bahrain","BI":"Burundi","BJ":"Benin","BL":"St. Bartholomeus","BM":"Bermuda","BN":"Brunei Darussalam","BO":"Bolivien, plurinationaler Staat","BQ":"Bonaire, Sint Eustatius und Saba","BR":"Brasilien","BS":"Bahamas","BT":"Bhutan","BV":"Bouvet Island","BW":"Botswana","BY":"Belarus","BZ":"Belize","CA":"Kanada","CC":"Kokosinseln","CD":"Kongo, die Demokratische Republik","CF":"Zentralafrikanische Republik","CG":"Kongo","CH":"Schweiz","CI":"Côte d'Ivoire","CK":"Cookinseln","CL":"Chile","CM":"Kamerun","CN":"China","CO":"Kolumbien","CR":"Costa Rica","CU":"Kuba","CV":"Kap Verde","CW":"Curaçao","CX":"Weihnachtsinsel","CY":"Zypern","CZ":"Tschechische Republik","DE":"Deutschland","DJ":"Dschibuti","DK":"Dänemark","DM":"Dominica","DO":"Dominikanische Republik","DZ":"Algerien","EC":"Ecuador","EE":"Estland","EG":"Ägypten","EH":"Westsahara","ER":"Eritrea","ES":"Spanien","ET":"Äthiopien","FI":"Finnland","FJ":"Fidschi","FK":"Falklandinseln (Malvinas)","FM":"Mikronesien, Föderierte Staaten von","FO":"Färöer","FR":"Frankreich","GA":"Gabun","GB":"Großbritannien","GD":"Grenada","GE":"Georgia","GF":"Französisch-Guayana","GG":"Guernsey","GH":"Ghana","GI":"Gibraltar","GL":"Grönland","GM":"Gambia","GN":"Guinea","GP":"Guadeloupe","GQ":"Äquatorialguinea","GR":"Griechenland","GS":"Südgeorgien und die Südsandwichinseln","GT":"Guatemala","GU":"Guam","GW":"Guinea-Bissau","GY":"Guyana","HK":"Hong Kong","HM":"Heard Island und McDonald Islands","HN":"Honduras","HR":"Kroatien","HT":"Haiti","HU":"Ungarn","ID":"Indonesien","IE":"Irland","IL":"Israel","IM":"Isle of Man","IN":"Indien","IO":"Britisches Territorium im Indischen Ozean","IQ":"Irak","IR":"Iran, Islamische Republik","IS":"Island","IT":"Italien","JE":"Jersey","JM":"Jamaica","JO":"Jordan","JP":"Japan","KE":"Kenia","KG":"Kirgisistan","KH":"Kambodscha","KI":"Kiribati","KM":"Komoren","KN":"St. Kitts und Nevis","KP":"Korea, Demokratische Volksrepublik","KR":"Korea, Republik","KW":"Kuwait","KY":"Kaimaninseln","KZ":"Kasachstan","LA":"Demokratische Volksrepublik Laos","LB":"Libanon","LC":"Saint Lucia","LI":"Liechtenstein","LK":"Sri Lanka","LR":"Liberia","LS":"Lesotho","LT":"Litauen","LU":"Luxemburg","LV":"Lettland","LY":"Libyen","MA":"Marokko","MC":"Monaco","MD":"Republik Moldau","ME":"Montenegro","MF":"Saint Martin (französischer Teil)","MG":"Madagaskar","MH":"Marshall Islands","MK":"Mazedonien, die ehemalige jugoslawische Republik","ML":"Mali","MM":"Myanmar","MN":"Mongolei","MO":"Macao","MP":"Nördliche Marianen","MQ":"Martinique","MR":"Mauretanien","MS":"Montserrat","MT":"Malta","MU":"Mauritius","MV":"Malediven","MW":"Malawi","MX":"Mexiko","MY":"Malaysia","MZ":"Mosambik","NA":"Namibia","NC":"Neukaledonien","NE":"Niger","NF":"Norfolkinsel","NG":"Nigeria","NI":"Nicaragua","NL":"Niederlande","NO":"Norwegen","NP":"Nepal","NR":"Nauru","NU":"Niue","NZ":"Neuseeland","OM":"Oman","PA":"Panama","PE":"Peru","PF":"Französisch Polynesien","PG":"Papua-Neuguinea","PH":"Philippinen","PK":"Pakistan","PL":"Polen","PM":"Saint Pierre und Miquelon","PN":"Pitcairn","PR":"Puerto Rico","PS":"Palästina, Bundesstaat","PT":"Portugal","PW":"Palau","PY":"Paraguay","QA":"Katar","RE":"Réunion","RO":"Rumänien","RS":"Serbien","RU":"Russische Föderation","RW":"Ruanda","SA":"Saudi-Arabien","SB":"Solomon Islands","SC":"Seychellen","SD":"Sudan","SE":"Schweden","SG":"Singapur","SH":"St. Helena, Ascension und Tristan da Cunha","SI":"Slowenien","SJ":"Svalbard und Jan Mayen","SK":"Slowakei","SL":"Sierra Leone","SM":"San Marino","SN":"Senegal","SO":"Somalia","SR":"Suriname","SS":"Südsudan","ST":"Sao Tome und Principe","SV":"El Salvador","SX":"Sint Maarten (niederländischer Teil)","SY":"Syrische Arabische Republik","SZ":"Swasiland","TC":"Turks- und Caicosinseln","TD":"Tschad","TF":"Französische Südgebiete","TG":"Togo","TH":"Thailand","TJ":"Tadschikistan","TK":"Tokelau","TL":"Timor-Leste","TM":"Turkmenistan","TN":"Tunesien","TO":"Tonga","TR":"Türkei","TT":"Trinidad und Tobago","TV":"Tuvalu","TW":"Taiwan, Provinz China","TZ":"Tansania, Vereinigte Republik","UA":"Ukraine","UG":"Uganda","UM":"Kleinere vorgelagerte Inseln der Vereinigten Staaten","US":"Vereinigte Staaten","UY":"Uruguay","UZ":"Usbekistan","VA":"Heiliger Stuhl (Staat Vatikanstadt)","VC":"St. Vincent und die Grenadinen","VE":"Venezuela, Bolivarische Republik","VG":"Britische Jungferninseln","VI":"Virgin Islands, USA","VN":"Vietnam","VU":"Vanuatu","WF":"Wallis und Futuna","WS":"Samoa","YE":"Jemen","YT":"Mayotte","ZA":"Südafrika","ZM":"Sambia","ZW":"Simbabwe"},"levels":{"SECONDARY_SCHOOL":"Gymnasium","TECHNICAL":"Technical","BACHELOR":"Bachelor","MASTER":"Master","POST_GRADUATE":"Postgraduate","PHD":"PhD","TRAINING_CERTIFICATION":"Training mit Zertifizierung","SELF_WITH_CERTIFICATION":"Selbststudium mit Zertifizierung","SELF_WITHOUT_CERTIFICATION":"Selbststudium ohne Zertifizierung"},"langs":{"en":"English","de":"Deutsch","es":"Español","nl":"Nederlands","fr":"Français","pt":"Portuguese","ru":"Русский","ja":"日本語"}}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports = {"TranslationReviewVersion":{"version":"Versión del paquete de idiomas","version_Number":"02/08/2020"},"login":{"label":"Bienvenido a BrainChain","login_button":"Iniciar sesión","forgot_password_label":"¿Olvidó su contraseña?","haven_t_account_label":"¿Aún no tiene cuenta?","create_it_now_label":"¡Cree una cuenta aquí!","create_account_alert":"¿Qué cuenta quiere crear?","applicant_button":"Solicitante","company_button":"Empresa","back_to_login_button":"Volver a iniciar sesión","create_an_label":"Cree una","applicant_account_hint":"cuenta si desea administrar su diploma en BrainChain para facilitar enormemente su búsqueda de empleo.","create_a_label":"Cree una","company_account_hint":"cuenta si su empresa planea disfrutar de la verificación automatizada de solicitantes de empleo con BrainChain.","more_info_label":"Para saber más, visite"},"oauth":{"label":"Bienvenido a BrainChain","sign_in_label":"Hay que iniciar una sesión para continuar.","incorrect_request_params_label":"Parámetros de solicitud no válidos","access_info_label":"{client_name} tendrá acceso a su nombre y appelidos, su número de teléfono y su Email.","logged_in_data_label":"Usted ha iniciado sesión como {user_name}, {user_email}.","accept_label":"Siguiente","reject_label":"Rechazar","use_another_account_label":"Usar otra cuenta"},"reset_password":{"label":"Restablecer contraseña","submit_button":"Reset","incorrect_link_alert":"Enlace incorrecto","expired_link_alert":"El enlace ha caducado.","success_message":"Su contraseña se ha cambiado correctamente."},"change_password":{"label":"Email & Contraseña","change_password":"Cambiar contraseña","old_password_label":"Contraseña anterior","old_password_input_placeholder":"Contraseña anterior","submit_button":"Actualizar contraseña","success_message":"Su contraseña se ha actualizado correctamente.","change_password_alert":"Ahora será guiado a la página de inicio de sesión para iniciar sesión con su nueva contraseña.","change_email":"Cambiar Email","change_email_hint":"Ingrese el correo electrónico con el que se postula a los trabajos.","update_email":"Actualizar Email","change_email_alert":"Le hemos enviado un enlace a su nuevo Email para confirmarlo. Por favor, revise su correo.","finish_change_email":"El Email se ha cambiado con éxito. Puede utilizarlo para iniciar sesión en su cuenta."},"restore_account":{"label":"Por favor tecle el Email de la cuenta para restaurar","submit_button":"Restaurar","success_message":"¡Su nueva contraseña está esperando en su bandeja!","link_to_help_text":"Asegúrese de tener una cuenta activa. Si tiene algún problema, puede visitar:","link_to_help":"ayuda","link_to_help_end":"."},"register_applicant":{"label":"Registro de cuenta del candidato","message":"A continuación complete sus datos para crear su cuenta","success_message":"Le hemos enviado un correo de activación. Presione el enlace que se encuentra allí para completar este proceso.","submit_button":"¡Acceder!","back_button":"Volver a inicio de sesión."},"account_management":{"label":"Mi configuración personal","open_account_management_menu_label":"Abrir menú de configuración personal","close_account_management_menu_label":"Ocultar menú de configuración personal"},"org_management":{"label":"Configuración de la cuenta de la Organización"},"aliases":{"label":"Alias","expose_phone_label":"Compartir número de teléfono para trabajos potenciales","expose_email_label":"Revelar Email para potenciales trabajos","default_alias_label":"Alias estándar","set_as_default_alias_label":"Establecer como alias estándar","edit_alias_label":"Cambiar alias","delete_alias_label":"Eliminar alias","add_button":"Añadir alias","add_success_message":"¡El alias se ha creado correctamente!","edit_button":"Cambiar alias","edit_success_message":"Alias ​​actualizado correctamente!","remove_title":"Por favor, confirme la eliminación de este alias.","remove_success_message":"¡El alias se ha eliminado correctamente!","edit_default_alias":"Datos personales","change_default_alias":"Cambiar datos personales"},"org_staff":{"staff":{"table_label":"miembros del personal","register_button":"Enviar invitación","remove_modal_alert":"Por favor, confirme la eliminación de {nombre} de la lista de miembros del personal.","send_invite_button":"Enviar invitación","create_success_message":"¡El personal de la Organización se ha registrado correctamente!","remove_success_message":"¡Eliminación llevada a término con éxito!","no_data_label":"No hay miembros del personal."},"accreditation_groups":{"table_label":"Grupos de diploma (Facultad)","accreditation_group_name_label":"Nombre del grupo de diploma (Facultad)","create_accreditation_group_button":"Crear grupo de diploma (Facultad)","create_accreditation_group_success_message":"¡El grupo de diploma (Facultad) se ha creado correctamente!","edit_accreditation_group_success_message":"¡El grupo de diploma (Facultad) se ha actualizado correctamente!","inserters_label":"Insertadores","validators_label":"Validadores","employee_input_placeholder":"Seleccionar empleado ...","role_input_placeholder":"Seleccionar rol ...","employee_label":"Empleado","employees_label":"Empleados","role_label":"Rol","remove_employee_from_group_alert":"¿Está seguro de que desea eliminar a este empleado del grupo de diploma (Facultad)?","remove_group_alert":"¿Está seguro de que desea eliminar este grupo de diploma (Facultad)?","remove_employee_from_group_success_message":"¡Eliminación llevada a término con éxito!","remove_group_success_message":"¡El grupo de diploma (Facultad) se ha eliminado correctamente!","add_employee_to_group_success_message":"¡Empleado agregado al grupo con éxito!","no_data_label":"No hay #Facultades# definidas todavía.","accreditation_groups_definition_label":"Las #Facultades# son una forma en que las universidades organizan sus programas de educación formal.","accreditation_group_no_data_label":"No hay miembros del personal en este grupo de diploma (Facultad).","accreditation_group_examples_label":"Ingeniería Mecánica; Ciencias Políticas; Ciencias Económicas; Biología","different_from_departments_label":"Esto es diferente de los #Departamentos#","no_inserters_label":"No hay Insertadores asignados","no_validators_label":"No hay Validadores asignados","no_staff_assigned_label":"Las facultades sin Insertadores asignados no pueden ingresar diplomas; Las facultades sin Validadores asignados tendrán sus Diplomas insertados en espera hasta que se designe un Validador de Facultad. Por lo tanto, asegúrese de que para cada Facultad, se asigne al menos un Insertor y un Validador.","digital_key_hint":"Recordatorio amable: los Insertadores necesitan la clave digital (un archivo .jwk) en la computadora donde insertan los Diplomas, para encriptarlos digitalmente. No olvide pasar esta clave de manera segura con el Insertador, y recuérdeles que esta clave debe importarse sólo una vez, antes de que comience todo su trabajo."},"departments":{"table_label":"Departamentos","department_name_label":"Nombre del departamento","department_email_label":"Correo electrónico del departamento","create_department_button":"Crear departamento","create_department_success_message":"¡El departamento se ha creado correctamente!","edit_department_success_message":"¡Departamento actualizado con éxito!","hms_label":"Gerentes de contratación","bos_label":"Responsable","employee_input_placeholder":"Seleccionar empleado ...","role_input_placeholder":"Seleccionar rol ...","employee_label":"Empleado","employees_label":"Empleados","role_label":"Rol","remove_employee_from_department_alert":"¿Está seguro de que desea eliminar a este empleado del Departamento?","remove_department_alert":"¿Está seguro de que desea eliminar este Departamento?","remove_employee_from_department_success_message":"Empleado eliminado del Departamento con éxito!","remove_department_success_message":"Departamento eliminado correctamente","add_employee_to_department_success_message":"¡Empleado agregado al Departamento con éxito!","no_data_label":"Todavía no hay #Departamentos# definidos.","department_no_data_label":"Faltan miembros del personal en este Departamento","departments_definition_label_uni":"Los #Departamentos# reflejan cómo se organiza una universidad, como cualquier otra organización.","departments_definition_label_company":"Los #Departamentos# reflejan cómo se organiza una organización en sus grupos funcionales.","departments_examples_label":"Recursos humanos (RR. HH.); TI; Finanzas","departments_definition_label_part_2":"Los #Departamentos# se definen para permitir a las empresas utilizar BrainChain; los miembros de su personal pueden verificar los diplomas de las personas que consideran contratar.","different_from_accreditation_groups_label":"Esto es diferente de #Facultades#"},"change_anchor":{"title":"Cambiar Administrador de Universidad (Ancla)","modal_alert_message":"Puede transferir los derechos del Administrador de Universidad (Ancla) a cualquier miembro activo del personal.","modal_alert_warning":"(Advertencia: después de esta acción, perderá los derechos de acceso parcial.)","success_message":"¡El ancla ha sido modificado con éxito!","submit_button":"Cambiar Administrador de Universidad (Ancla)"}},"activation":{"label":"Activación de cuenta","activate_applicant_label":"Elija una contraseña para activar su cuenta","linked_employee_label":"Elija el Email y la contraseña para su cuenta de candidado. Su cuenta de empleado estará vinculada a él","activate_personal_data_label":"A continuación complete los datos para activar su cuenta","activate_password_label":"Configure una contraseña para finalizar la activación de su cuenta","haven_t_applicant_account_label":"¿Aún no tiene una cuenta de candidato?","create_it_now_label":"¡Créela ahora!","linked_button":"¡Siguiente!","birth_date_label":"Fecha de nacimiento","password_label":"Contraseña","enter_password_label":"Nueva contraseña","confirm_password_label":"Confirmar contraseña","enter_password_input_placeholder":"Nueva contraseña","confirm_password_input_placeholder":"Confirmar nueva contraseña","activate_button":"Activar cuenta","enter_password_error_alert":"¡La contraseña debe contener un mínimo de 6 y un máximo de 32 caracteres!","confirm_password_error_alert":"Bien pero ... una contraseña es suficiente. ¡Intente escribir la misma contraseña dos veces!","activation_link_expired_alert":"El enlace de activación ha caducado","activation_link_irrelevant_message":"Su registro ya está completo.","activation_link_irrelevant_forgot_password_message_start":"Si olvidó su contraseña, puede pulsar","activation_link_irrelevant_forgot_password_message_link":"aquí","activation_link_irrelevant_forgot_password_message_end":"para restablecerlo.","activation_link_irrelevant_log_in_message_start":"Si esto es un error y recuerda su contraseña, puede iniciar sesión siguiendo","activation_link_irrelevant_log_in_message_link":"enlace","activation_link_irrelevant_log_in_message_end":".","incorrect_activation_link_alert":"Enlace de activación erróneo","activation_success_message":" ¡La activación se ha realizado correctamente! ","back_button":"Volver a la activación de la cuenta del empleado."},"resend_activation":{"success_message":"¡La activación renovada se ha enviado con éxito!","employee_label":"¿Reenviar el Email de activación a {email}?","anchor_label":"¿Reenviar el Email de activación a {email}?","title":"Reenviar activación","submit_button":"Reenviar","label":"Por favor tecle el Email de la cuenta para reenviar la activación."},"orgs":{"label":"Organizaciones","anchor_label":"Ancla","location_label":"Ubicación","org_label":"Organización","org_type_label":"Tipo de Organización","add_org":"Agregar Organización","name_label":"Nombre","has_accreditation_groups_label":"Tiene grupos de certificatión","verifies_identities_label":"Verificar identidades","provides_mooc_certificates_label":"Proporcionar certificados MOOC","street_label":"Calle y Nr.","postal_label":"Código Postal","city_label":"Ciudad","company_code_label":"Código de la empresa","vat_number_label":"Número de IVA","address_label":"Dirección","permissions_label":"Permisos","unknown_label":"Desconocida","no_data_label":"No hay Organizaciones","no_data_to_validate_label":"No hay Organizaciones para validar.","validate_organizations_label":"Validar Organizaciones","validate_organization_label":"Validar Organización","validate_organization_button":"Validar","validate_organization_alert":"¿Está seguro de que desea validar esta Organización?","back_button":"Volver a la lista de Organizaciones no validadas","next_org_button":"Organización siguiente","validate_org_success_message":"¡La Organización se ha validado con éxito!","financial_data_label":"Datos financieros","financial_data_placeholder":"Nombre del banco, número de cuenta bancaria, ...","inspect_organization_button":"Revisar","validate_org_progress_label":"Validar","orgs_payments_list_label":"Datos financieros de organizaciones","general_data_validated":"Datos básicos validados","financial_data_validated":"Datos financieros validados","already_validated":"Datos parcialmente validados - Pendiente de validación completa por parte del co-asistente.","remove_org_alert":"¿Seguro que quiere eliminar esta organización?","remove_org_success_message":"Organización eliminada con éxito!"},"register_org":{"register_org_label":"Registrar Organización y Administrador de Universidad (Ancla)","invite_next_button":"Invite, y pase a la siguiente Organización","send_invitation_button":"Enviar invitación","success_message":"¡Organización y Administrador de Universidad(Ancla) registrados correctamente!","org_type_placeholder":"Seleccione el tipo de organización ...","register_button":"Regístrese","company_registration_label":"Registrar Empresa y Ancla","proceed_button":"Siguiente","register_org_by_anchor_alert":"No olvide transferir el crédito de la empresa (cualquier monto) desde la cuenta bancaria declarada en este perfil. Esto le permitirá a BrainChain validar y finalizar su registro.","register_org_by_anchor_hint":"Después de la activación de la cuenta, puede administrar en todo momento la información financiera en la sección financiera de la configuración de la cuenta de la Organización.","domain_hint":"Un dominio de Internet es la primera parte de la dirección web de una Organización. P.ej. 'apple.com' o 'ibm.de'. Si desea registrar a toda la compañía con todos sus subdominios, puede usar un comodín (*) al final en lugar de usar la extensión de un país específico, por ejemplo. 'apple. *' o 'ibm. *'. ","back_button":"Volver a iniciar sesión.","company_code_hint":"En algunos países, las empresas se conocen principalmente por un código de registro único como identificador, junto a (o en ausencia de) su Numero IVA.","financial_data_hint_part_1":"Proporcione todos los datos para que podamos asegurarnos de que la transacción proviene de su organización.","financial_data_hint_part_2":"Por ejemplo: su nombre de banco y su identificador en su banco (= un código de cliente / su número de cuenta bancaria / ...).","financial_data_hint_part_3":"Estos datos son necesarios para separar a las compañías reales de las falsas y los bots de Internet, así como para cumplir con nuestros informes según los estándares obligatorios contra el fraude."},"edit_org":{"org_edit_success_message":"¡Organización actualizada correctamente!","anchor_edit_success_message":"¡El Administrador de Universidad (Ancla) ha sido modificado con éxito!","back_button":"Volver a la lista de Organizaciones","edit_anchor_button":"Cambiar Administrador de Universidad (Ancla)","edit_anchor_alert":"Por favor, cambie el Email del Administrador de Universidad(Ancla) antes de editar.","bava_label":"BAVA","bava_organization_label":"Organización BAVA","bava_set_success_message":"Organización marcada como BAVA!","bava_removed_success_message":"¡Bandera de BAVA eliminada con éxito!"},"request_credentials_verification":{"label":"Solicitar verificación de diploma.","success_alert":"Solicitud procesada con éxito","applicant_data_label":"Datos del solicitante","choose_way_label":"Elija la forma en que desea localizar un solicitante","your_data_label":"Su información","hide_your_name_label":"Oculte su nombre al solicitante","company_data_label":"Datos de la compañia","reason_for_request_label":"Razón de la solicitud","reason_for_request_placeholder":"Escriba su mensaje aquí...","get_email_label":"Recibir un Email cuando el solicitante responda a la solicitud","submit_button":"Procesar solicitud","way_label":"Opción","company_name_label":"Nombre de empresa","modal_title_label":"Con respecto a","investigate_applicant_label":"El solicitante que desea investigar, aún no forma parte de la plataforma BrainChain. ¿Quiere Ud. que le pidamos a su Universidad que lo agregue?","ask_colleague_label":"Un colega suyo {firstName} {lastName} tiene una solicitud pendiente de validar para este solicitante. ¿Le gustaría pedirle a su colega que verifique al solicitante o prefiere solicitar Ud. mismo su consentimiento?","request_button":"Solicitarlo yo mismo","ask_colleague_button":"Preguntar a mi colega","manager_label":"Manager","visible_data_message":"Los siguientes datos serán visibles para el solicitante.","upload_file_label":"Subir archivo","emails_label":"Emails","manual_input_label":"Entrada manual","manual_input_hint":"Proporcione Emails de los solicitantes separados por comas, puntos y comas, saltos de línea o espacios.","reference_to_bulk_list_start":"Puede publicar una solicitud para un solo Email o una serie de Emails a la vez. \nHay 2 formas de pasar una serie de Emails: ingresándolos usted mismo en el campo siguiente, o cargando un documento (para su formato correcto: sírvase del ícono '?' a continuación). \nSi va para la serie de Emails, puede verificar el estado del procesamiento de solicitudes en","reference_to_bulk_list_link":"Solicitante de consentimiento a granel","reference_to_bulk_list_end":".","stay_on_this_page_label":"Permanecer en la página actual","go_to_home_page_label":"Volver a iniciar sesión","success_modal_label":"Solicitud completatada con éxito. ¿Desea permanecer aquí o ir a la página de inicio?","request_unavailable_alert":"La funcionalidad de verificación de diploma no está disponible. Póngase en contacto con el Ancla de su organización para resolver el problema."},"main":{"home_page_label":"Página de inicio","edu_org_staff_page_button":"Gestión de personal","current_sub_role_label":"Rol","current_group_label":"Grupo","log_out_button":"Cerrar sesión","orgs_page_button":"Organizaciones","insert_accreditation_page_button":"Insertar nuevo(-s) Diploma (-s)","validate_accreditations_page_button":"Validar certificationes","review_accreditations_page_button":"Revisar certificationes fallidas","accreditation_groups_page_button":"Grupos de certificatión","departments_page_button":"Departamentos","staff_members_page_button":"Empleados","limit_access_label":"Su Organización tiene acceso limitado a ciertas funciones. Comuníquese con el Administrador de Universidad de la Organización.","non_validated_org_access_label":"Ud. no tiene acceso a esta función porque su Organización aún no ha sido validada.","payment_label":"Pago","help_label":"Ayuda","bulk_jobs_list_page_button":"Subida Masiva de Certificaciones a granel","validate_organizations_page_button":"Validar Organizaciones","certified_accreditations_page_button":"Certificaciones validadas","pending_accreditations_page_button":"Certificaciones pendientes","vids_page_button":"Identidades verificadas","org_management_button":"Configuración de la cuenta de la Organización","verification_request_page_button":"Solicitar consentimiento","pending_consents_page_button":"Consentimientos pendientes","active_consents_page_button":"Consentimientos activos","consent_requests_page_button":"Consentimientos Solicitados","prior_consents_page_button":"Consentimientos previos","applicant_accreditations_select_button":"Diplomas","applicant_consents_select_button":"Consentimientos","consents_history_page_button":"Historia de los consentimientos","self_study_books_page_button":"Libros (autoestudio)","bulk_consent_requests_page_button":"Solicitante de consentimiento a granel","inserter_accreditations_select_button":"Diplomas","insert_accreditation_shirt_page_button":"Insertar","review_accreditations_shirt_page_button":"Revisar","bulk_jobs_list_shirt_page_button":"Carga masiva","organizations_select_button":"Organizaciones","orgs_shirt_page_button":"Validado","validate_organizations_shirt_page_button":"Pendiente","accreditation_requests_list_page_button":"Solicitudes de diploma","validated_accreditation_requests_list_page_button":"Dominios de educación validados","pending_accreditation_requests_list_page_button":"Dominios de educación pendientes","pending_accreditation_requests_page_button":"Solicitudes de verificación de Diploma pendientes","organization_select_button":"Organización","accreditation_groups_management_page_button":"Gestión de facultades","groups_management_page_button":"Departamentos y facultades","validated_accreditation_requests_by_domain_shirt_page_button":"Validado","pending_accreditation_requests_by_domain_shirt_page_button":"Pendiente","security_page_button":"Seguridad","register_org_shirt_page_button":"Registrar nuevo","payments_page_button":"Pagos","orgs_payments_page_button":"Datos financieros de organizaciones","assistants_page_button":"Asistentes","business_ambassadors_page_button":"Embajadores de negocios","commissions_list_page_button":"Comisiones","system_payment_select_button":"Pago","due_payments_page_button":"Pagos adeudados","payments_history_shirt_page_button":"Historia","payments_history_page_button":"Historial de pagos","validated_domains_page_button":"Dominios Validados","domains_page_button":"Dominios de universidades"},"roles":{"admin_label":"SysAdmin","employee_label":"Empleado","applicant_label":"Candidato","anchor_label":"Administrador de Universidad","inserter_label":"Insertador","validator_label":"Validador","hm_label":"Gerente de Recursos Humanos","bo_label":"Responsable"},"home":{"welcome_label":"Bienvenido a BrainChain","account_and_support_label":"Configuraciones de cuenta y soporte","admin_pages_label":"Páginas de administración","choose_role_label":"Elige el rol en el que quieres empezar a trabajar","anchor_pages_label":"Páginas del Ancla","inserter_pages_label":"Páginas del Insertor","validator_pages_label":"Páginas del Validator","hm_pages_label":"Páginas del Gerente de Contrataciones","bo_pages_label":"Páginas del líder del equipo.","applicant_pages_label":"Páginas del Solicitante","account_page_about":"Gestión de cuenta personal.","support_page_about":"Encuentre su respuesta o envíe un correo","register_org_page_about":"Crear nueva Organización","organizations_page_about":"Gestión de configuraciones de organizaciones","validate_organizations_page_about":"Validar nuevas Organizaciones.","payment_page_about":"Gestión Financiera y Precios","organization_staff_page_about":"Gestión del personal de su Organización.","accreditation_groups_page_about":"Gestionar los grupos de acreditación(facultades) de su Organización.","departments_page_about":"Gestión de los departamentos de su Organización.","review_accreditations_page_about":"Interacciones con Validadores y Solicitantes","bulk_accreditations_upload_page_about":"Insertar acreditaciones del archivo CSV","validate_accreditations_page_about":"Interacciones con Insertadores y Solicitantes","credentials_verification_request_page_about":"Crear nueva solicitud de consentimiento para el solicitante","consent_requests_page_about":"Administrar solicitudes de consentimiento para su Organización","certified_accreditations_page_about":"Administre sus acreditaciones certificadas","pending_accreditations_page_about":"Gestión de nuevos diplomas.","verified_identities_page_about":"Administre sus identidades verificadas","pending_consents_page_about":"Empresas que consideran contratarle: Usted decide","active_consents_page_about":"Todas las empresas pueden verificar su diploma.","prior_consents_page_about":"Empresas para las que Usted quiere trabajar","consents_history_page_about":"Historial completo de solicitudes de consentimiento otorgado y rechazado","self_study_books_page_about":"Administre sus libros de autoestudio","bulk_consent_requests_page_about":"Administrar solicitudes de consentimiento masivo para su Organización","accreditation_requests_list_anchor_page_about":"Vincular solicitudes de verificación de diplomas huérfanos a Facultades existentes","validated_accreditation_requests_list_admin_page_about":"Dominios validados (auto-gestionados y administrados por BAVA)","pending_accreditation_requests_list_admin_page_about":"Acceso a nuevas solicitudes de verificación de dominio (solicitante )","accreditation_requests_list_admin_page_about":"Gestión de la solicitud de acreditación del solicitante, sin referencia a una organización","accreditation_requests_list_applicant_page_about":"Gestión de la solicitud de verificación de un diploma","security_page_anchor_about":"Firma digital de diplomas","security_page_inserter_about":"Instalar llave digital","security_page_admin_about":"Agregar certificados Raíz/de Universidad pendientes","orgs_payments_page_about":"Cuenta, Tarifas y Crédito","assistants_page_about":"Gerencia de Asistentes","business_ambassadors_page_about":"Gestión de Embajadores de Negocios","commissions_list_page_about":"Gestión de Comisiones","due_payments_page_about":"Gestión de pagos vencidos","payments_history_page_about":"Gestión del historial de pagos y crédito de la empresa","default_departments_hint":"Para dar cabida a las pequeñas empresas, el 'Ancla de la compañía' puede solicitar a BrainChain que confirme los diplomas sin necesidad de una configuración adicional. Para compañías más grandes, recomendamos crear un 'Departamento de Recursos Humanos' (con una etiqueta de su elección), y luego asignar algunos reclutadores dedicados a ese Departamento. Esto es debido a que las compañías más grandes generalmente tienen perfiles dedicados para examinar a las personas que consideran contratar, además de la persona de contacto de BrainChain en la Compañía (= el ancla de BrainChain).","not_validated_yet":"Su empresa se encuentra en la etapa de validación. Algunas funciones están restringidas. Espere hasta que BrainChain procese su solicitud."},"payment":{"title":"Información de pago","total_money_label":"Cantidad total que ya ha sido devangada por {orgName} por medio de su afiliación a BrainChain:","list_label":"Para pagar la licencia anual, por favor envíe:","account_id_label":"a la siguiente cuenta (IBAN) Nr: {iban}","bank_details_label":"Detalles del banco y del proyecto.","about_us_label":"Si su banco requiere más información sobre nuestro banco o BrainChain:","bank_data_label":"Nuestros datos bancarios:","project_label":"BrainChain Project:","org_label":"Organización: WickedWare","org_address":"Dirección: Virsuliskiu g. 17-9, 05108 Vilnius, Lituania","create_account_label":"con el siguiente mensaje de transferencia (si es la primera vez que paga): ","create_account_message_label":"{orgName} - Crear cuenta","annual_fee_label":"con el siguiente mensaje de transferencia (si NO es la primera vez que paga): ","annual_fee_message_label":"{orgName} - Licencia anual","edu_org_message_label":"¿Qué obtendrá su Organización Educativa","edu_org_message_company_checks":"Cada vez que una empresa verifica a uno de sus Alumnos, le cobramos a la compañía una tarifa fija muy pequeña. Con esa tarifa, cubrimos los gastos para mantener BrainChain en buenas condiciones operativas, y el 20% regresa a usted. Esas cantidades se actualizan una vez al año.","edu_org_message_list_title":"Así es como construimos un ecosistema saludable sin fines de lucro que es beneficioso para las universidades:","edu_org_message_list_item_one":"En lugar de tener que validar una y otra vez a sus ex-alumnos, lo hace sólo una vez (en esta plataforma) y a partir de entonces nosotros asumimos esa carga durante el tiempo que trabajan.","edu_org_message_list_item_two":"Después de esa entrada única, cada vez que sus alumnos son examinados (= cuando buscan un nuevo empleo), la universidad obtiene el 20% de las tarifas de verificación cargadas a las empresas.","edu_org_message_joining":"Significa que al unirse a BrainChain, la universidad se libera de la carga de la investigación y obtiene una fuente de ingresos sostenible.","edu_org_message_note_title":"Nota:","edu_org_message_note":"Si su crédito es más alto que la tarifa anual, se deducirá automáticamente, lo que le ahorrará el esfuerzo de transferencia. Recibirá un correo explicando esta operación en el mismo momento en que se produzca.","wire_label":"Para pagar la cuota anual, por favor efectúe una transferencia","annual_license_cost_label":"Coste de licencia anual","wire_delay_label":"Tenga en cuenta que las transacciones internacionales pueden demorarse algunos días.","bank_data_by_location":{"LT":{"iban_number":"LT643500010003938827","bank_data":"Nombre: 'Paysera LT', UAB \nDirección del banco: Menulio g. 7, Vilnius, LT-04326, Lituania"},"BE":{"iban_number":"BE13736065627739 (BIC: KREDBEBB)","bank_data":"Nombre: Alverman BV \nDirección del banco: Beekstraat 5, 2300 Turnhout, Belgium \nAlverman IVA Nº (= ID de la compañía): \"BE0736567322\""}}},"finance":{"label":"Finanzas","balance_label":"Balance","balance_currency_label":"Moneda del saldo","balance_change_comment_placeholder":"Deje su comentario aquí...","change_label":"Cambiar","change_balance_label":"Cambio de balance","increase_label":"Aumento","decrease_label":"Disminución","change_balance_submit_button":"Aceptar cambios","preset_price_label":"Precio preestablecido","paid_till_date_label":"Pagado hasta","annual_fee_label":"Cuota anual","request_cost_label":"Costo de solicitud de acreditación.","pay_annual_fee_button":"Pagar un año","pay_annual_fee_success_message":"¡Cuota anual pagada con éxito!","change_finance_success_message":"Las finanzas de la Organización se cambian con éxito.!","org_finance_label":"Precio de Organizacion","accept_price_and_send_invitation":"Aceptar precio y enviar invitación.","accept_price_and_validate":"Aceptar precio y validar.","prices_label":"Precios","change_balance_modal_label":"Un aumento de saldo refleja que la compañía pagó su licencia anual (verificado fuera de línea por la SA / FA). Una disminución del saldo se produce cuando el dinero se transfiere a una empresa fuera de línea (ejecutado fuera de línea por SA / FA). Llegada la fecha de vencimiento de la licencia anual, el importe se resta automáticamente del crédito abierto de la compañía.","set_default_label":"Restaurar valor predeterminado","default_annual_fee_label":"Cuota anual predeterminada","default_consent_request_fee_label":"Tarifa de solicitud de consentimiento predeterminada","deviation_period_label":"Período de desviación","forever_label":"Indifidamente","default_preset_label":"Valores predeterminados: tarifa anual - {annual_fee_amount}, solicitud de consentimiento - {consent_request_fee_amount}","agreed_deviation_label":"Desviación acordada: tarifa anual - {annual_fee_amount}, solicitud de consentimiento - {consent_request_fee_amount}","till_label":"hasta","period_label":"Período","pay_annual_license_alert":"Por favor, pague la licencia anual para continuar creando solicitudes de consentimiento.","top_up_balance_alert":"Por favor, recargue su saldo para continuar creando la solicitud de consentimiento.","contact_anchor_alert":"Alguna funcionalidad no está disponible. Póngase en contacto con el Ancla de su organización para resolver el problema.","add_year_label":"Agregar año","paid_till_alert":"Las organizaciones que no tengan una \"Pagado hasta\" en el #futuro# no obtendrán dinero por la verificación de diploma."},"help":{"label":"Si tiene problemas o preguntas, no dude en comunicarse con {email}.","email":"BenevolentEars@brainchainmission.org","questions_and_answers_label":"Preguntas y respuestas","question_activation_email":"No he recibido mi correo de activación","answer_activation_email_start":"Si no ha recibido su correo de activación, puede volver a solicitarlo ","answer_activation_email_link":"aquí","answer_activation_email_end":"."},"page_not_found":{"page_not_found_label":"Página no encontrada","sorry_label":"Perdón, ¡No podemos encontrar esta página!","cause_label":"O bien no tiene Ud. acceso a esta página, o la página no existe."},"server_error":{"server_error_label":"Error interno del servidor","sorry_label":"Ooops, algo salió mal :-/","cause_label":"¿Le importaría intentarlo más tarde? Nuestro servidor está en reposo."},"sub_role_missing":{"no_access_label":"Parece que en este rol ya no tiene Ud. acceso a esta función","continue_label":"Para continuar, será Ud. redirigido a la página de inicio."},"org_permissions_missing":{"no_access_label":"Desafortunadamente, su Organización ya no tiene acceso a esta función.","continue_label":"Para continuar, será Ud. redirigido a la página de inicio."},"accreditation_list":{"label":"Certificaciones","title_label":"Título","date_issued_label":"Fecha de emisión","level_label":"Nivel","applicant_name_label":"Nombre del candidato","location_label":"Ubicación","no_data_to_validate_message":"No hay certificaciones para validar.","no_data_to_review_message":"No hay certificaciones para revisar.","show_accreditations_by_label":"Mostrar certificaciones rechazadas por","validators_label":"Validadores","applicants_label":"Candidatos","edit_label":"Editar diploma","remove_label":"Suprimir diploma","no_data_to_review_hint":"Todavía hay otras facultades que puede consultar"},"bulk_jobs_list":{"label":"Carga masiva de Certificaciones","no_data_message":"No se han cargado aún grandes volúmenes de Certificaciones","created_at_label":"Creado en","processed_label":"Procesado","finished_label":"Terminado","file_name_label":"Nombre de archivo","status_label":"Estado","in_progress_label":"En progreso ...","remove_bulk_success_message":"¡El volumen se ha eliminado con éxito!","remove_bulk_alert":"¿Está seguro de que desea eliminar este archivo de la lista?","remove_bulk_button":"Dejar de mostrar este archivo","entries_number_label":"Número de entradas","error_label":"Error","global_error_label":"Error global","requestor_label":"Solicitante","bulk_consent_requests_label":"Solicitante de consentimiento a granel","no_bulk_consents_data_label":"Aún no se han cargado solicitudes de consentimiento masivo","created_requests_label":"Solicitudes creadas","file_reading_process_label":"Archivo de lectura en proceso.","signing_process_label":"Trabajando duro para firmar los diplomas ...","dont_close_tab_label":"Por favor, no abandone esta página hasta el final de este proceso. Esto puede llevar algún tiempo dependiendo del tamaño del archivo.","insufficient_balance_error_alert_part_1":"Sólo se pudieron procesar {processed} de {total} solicitudes de consentimiento, debido a que el crédito es insuficiente.","insufficient_balance_error_alert_part_2":"Rellene al menos {amount} antes de procesar el resto.","flush_remaining_label":"Procesar el resto"},"accreditation":{"accreditation_group_input_placeholder":"Elegir grupo de Certificación ...","accreditation_title_orig_label":"Título original","accreditation_title_orig_input_placeholder":"Título original","accreditation_title_en_label":"Título en inglés","accreditation_title_en_input_placeholder":"Título en inglés","additional_translation_label":"Traducción adicional","add_additional_translations_label":"Añadir traducción adicional de título","date_issued_label":"Fecha de emisión","level_label":"Nivel","level_input_placeholder":"Elegir nivel ...","person_label":"Persona","language_input_placeholder":"Idioma","translation_input_placeholder":"Traducción","title_label":"Título","accreditation_label":"Certificación","popover":{"message_placeholder":"Por favor agregue un mensaje aquí ...","old_value_label":"Valor anterior","proposed_value_label":"Valor propuesto","message_label":"Mensaje","proposed_value_input_placeholder":"Inserte su valor propuesto aquí ...","discard_changes_label":"Descartar los cambios","edit_field_label":"Editar el campo"},"remove_accreditation_success_message":"¡La Certificatión se ha eliminada con éxito!","remove_accreditation_alert":"¿Está seguro de que desea eliminar esta Certificación?","next_accreditation_button":"Siguiente Certificación","back_button":"Volver a la lista de Certificaciones","show_details_label":"Mostrar detalles del campo"},"insert_accreditation":{"label":"Insertar Certificación","success_message":"¡La Certificación ha sido insertada correctamente!","submit_button":"¡Listo para la validación!","no_certificate_message_start":"Aún no ha instalado la clave de la Universidad para firmar digitalmente los Diplomas. Por favor primero regrese a '","no_certificate_message_link":"la sección de","no_certificate_message_end":" 'Seguridad"},"certificate":{"label":"Certificados","add_button":"Añadir certificado","about_label":"Para añadir un certificado, cargue el archivo generado con la extensión '.crt'.","no_data_label":"No hay certificados","created_at_label":"Creado en","valid_from_label":"Válido desde","valid_till_label":"Válido hasta","remove_button":"Eliminar certificado","are_you_sure_label":"¿Está seguro de que desea eliminar este certificado?","remove_warning_label":"¡Aviso! Si borra el certificado, todos los diplomas firmados por él dejarán de ser válidos.","insert_certificate_label":"Certificado para firmar el diploma","insert_certificate_about_label":"Para comenzar a insertar diplomas, primero debe cargar una clave de certificado con la extensión '.jwk'. Si aún no tiene este archivo, comuníquese con el ancla de su Organización.","change_certificate_button":" Insertar nueva clave digital privada","add_certificate_key_button":"Añadir clave de certificado","insert_key_button":"Insertar clave","key_already_installed_button":"La clave digital privada ya está instalada.","no_root_certificate_label":"Aún no tiene un certificado Raíz instalado.","root_certificate_hint":"El administrador del sistema genera el archivo de certificado Raíz de BrainChain, llamado ca.crt, fuera de línea y posteriormente se importa aquí. Esto garantiza que cuando los Insertadores universitarios importen la clave de la universidad en su navegador (= el archivo uni.jwk), se pueda hacer un reconocimiento de validación entre ellos. Sin un certificado Raíz importado, esto generará errores.","no_certificates_needed_label":"No se necesitan certificados: esta organización no firma diplomas","no_org_certificate_label_start":"El archivo de clave universitaria (uni.crt) aún no se ha instalado; hágalo en la'","no_org_certificate_label_link":"Sección de seguridad","no_org_certificate_label_end":"' después de que la universidad haya sido validada adecuadamente."},"validate_accreditation":{"label":"Validar Certificación","success_message":"¡Certificación validada con éxito!","submit_button_validate":"Validar Certificación","common_message_label":"Dejar comentario para el revisor","common_message_placeholder":"Deje su comentario aquí ...","submit_button_invalidate":"Enviar de vuelta para revisión","or_label":"o","validate_accreditation_message":"¿Está seguro de que desea descartar los cambios y aceptar esta Certificación?","submit_button_invalidate_title":"Marque algún campo como incorrecto o deje el mensaje para el revisor."},"review_accreditation":{"label":"Revisión de Certificación fallida","success_message":"¡La Certificación se reinsertó con éxito!","submit_button":"Reinsertar para validación","message_label":"Mensaje del validador","feedback_from_validator_label":"Comentarios del validador","feedback_from_applicant_label":"Comentarios del solicitante","review_accreditation_progress_label":"Procesado","reinsert_accreditation_button_hint":"Vuelva a insertar esta acreditación únicamente con cambios que reflejen el $consenso$ que logró con el Validador $fuera de línea$. Cuando consenso no sea posible, puede elegir 'Eliminar'; la acreditación se mostrará como 'Rechazada' en la interfaz del solicitante."},"bulk_upload":{"drag_and_drop_label":"Arrastre y suelte el archivo aquí","or_label":"O","browse_label":"#Haga clic aquí # para señalar su archivo","error_label":"Ooops! Error al tomar el archivo: Formato de archivo incorrecto","uploaded_file_label":"Archivo cargado","max_file_size_message":"Tamaño máximo de archivo","exceeded_upload_size_alert":"Este archivo es demasiado grande para subirlo online ... ","file_format_info_label":"Información de formato de archivo","file_format_details_label":"Detalles del formato de archivo","consent_request_bulk_error_label":"Por favor seleccione un archivo para proceder","consent_request_bulk_empty_file_label":"El archivo está vacío"},"bulk_file_format_details":{"use_csv_message":"Por favor, respete el formato de archivo CSV.","file_header_message":"Su archivo debe tener el siguiente encabezado:","additional_titles_label":"Códigos de idiomas de traducciones adicionales","language_code_label":"Código de idioma","provide_data_message":"Esto significa que debe proporcionar:","applicant_data_message":"Datos del candidato: Email, nombre, apellido, código de país, Nº del Documento Nacional de Identidad","accreditation_data_message":"Datos de Certificación: la fecha en que se emitió la Certificación, su nivel, su título original, el título en inglés y (adicionalmente) la traducción de títulos.","file_entries_message":"Cada línea siguiente debe contener los detalles de Certificación en línea con el formato del encabezado.","liaise_it_staff":"Póngase en contacto con el personal de TI para garantizar un formato adecuado.","back_button":"Volver a 'carga de Certificaciones en bloque' ","csv_file_example_label":"Ejemplo de archivo con formato CSV","download_example_button":"Descargar ejemplo","values_details_label":"Detalles de valores","email_details":"Para las Certificaciones históricas (= más de 2 meses), el Email es opcional.","date_issued_details":"La fecha de emisión no puede estar en el futuro.","levels_label":"Niveles de Certificación","titles_label":"Títulos de Certificación adicionales","header_name_label":"Nombre del encabezado","required_label":"Obligatorio","format_label":"Formato","mean_label":"Valor","code_label":"Código","email_mean_label":"Email del candidato","first_name_mean_label":"Nombre del candidato","last_name_mean_label":"Apellidos del candidato","country_code_mean_label":"Código de país del candidato","national_id_mean_label":"Nº del Documento Nacional de Identidad del candidato","date_issued_mean_label":"La fecha en que se emitió la Certificación (**)","level_mean_label":"Nivel de Certificación","original_mean_label":"Título de Certificación original","en_mean_label":"Título de Certificación original","lang_code_mean_label":"Títulos de Certificación adicionales (ver tabla con títulos adicionales)","email_format":"candidato@email.com","string_format":"texto","country_code_format":"ISO 3166-1-alpha-2-code","date_format":"YYYY-MM-DD","level_format":"Código de nivel (consulte la tabla con niveles de Certificación)","optional-fields-highlighted-label":"Los campos opcionales están resaltados con","gray_label":"gris","use_xml_message":"Por favor, respete el formato de archivo XML.","csv_file_format_label":"formato de archivo CSV","xml_file_format_label":"formato de archivo XML","then_provide_message":" Luego debe proporcionar:","tag_name_label":"Nombre de etiqueta","attributes_label":"Atributos","accreditations_meaning_label":"Contenedor para la lista de diplomas","accreditation_meaning_label":"Contenedor para los detalles de los diplomas","titles_meaning_label":" Contenedor para las traducciones del título del diploma","title_meaning_label":"Traducción del título. El atributo de idioma es un código de idioma de la traducción (original o adicional). Consulte la tabla con títulos adicionales","title_details":"Se requiere el título original del diploma.","xml_file_example_label":"Ejemplo de archivo con formato XML.","consent_bulk_file_info_label":"Por favor, respete el formato de archivo TXT o CSV. Debe proporcionar un archivo con los Emails de los solicitantes, separados por comas, puntos y coma, saltos de línea o espacios."},"applicant_accreditations_management":{"certified_accreditations_label":"Certificaciones Validadas","issued_by_label":"Emitido por","expose_certified_accreditations":"Revela","no_data_label_part_1":"No hay $ Diplomas Certificados $. $ Diplomas Certificados $ son diplomas confirmados por su universidad. Si no hay ninguno presente, puede solicitarlo en 'Solicitudes de verificación de diploma'. ","no_data_label_part_2":"Agrupamos dichas solicitudes con otros Alumni hasta que su universidad se una a BrainChain a través de nuestro ","no_data_label_part_3":"sitio web.","no_data_label_part_4":" ¡También puede instar a su Universidad a unirse si éste aún no es el caso!","accreditation_details_label":"Detalles de la Certificación","remove_accreditation_alert":"¿Está seguro de que desea eliminar este diploma?","remove_accreditation_success_massage":"¡Diploma eliminado con éxito!","pending_accreditations_label":"Certificaciones pendientes","accept_accreditation_button_label":"Aceptar la Certificación","send_back_accreditation_button_label":"Enviar de vuelta para revisión","discard_accreditation_message":"¿Está seguro de que desea descartar esta Certificación?","discard_accreditation_warning_message":"¡Advertencia! ¡En caso de rechazo, la Certificación se eliminará completamente!","discard_accreditation_button_label":"Descartar la Certificación","vids_label":"Identidades verificadas","expose_fn_ln_country":"Revela nombre y país","expose_national_id":"Revela el Nº de Documento Nacional de Identidad","expose_nid_option_full":"Mi identificación nacional completa puede ser revelada","expose_nid_option_short":"Sólo deseo revelar los últimos 4 dígitos de mi Identificación Nacional","expose_nid_option_not_expose":"Nunca revelo mi Identificación Nacional","no_vids_label":"No hay $ Identidades Verificadas $. $ Identidades Verificadas $ son identidades confirmadas por su universidad y vienen con diplomas confirmados.","active_vid_label":"Activo","active_vid_title_checked":"Identidad activa verificada","active_vid_title_unchecked":"Establecer identidad activa verificada","show_details_label":"Mostrar detalles del diploma","no_pending_accreditations_label":"No hay $Diplomas pendientes$. Después de que solicitó a su Universidad que confirmara su diploma, y después de que su Universidad lo confirmó, su(s) Diploma(s) se enumerará aquí con un estado que indica esta validación unilateral (¡temporal!). Los empleadores potenciales ya pueden verlos, pero serán marcados como tales hasta que sean confirmados por ambos lados (el suyo también)."},"license_agreement":{"agree_label":"Acepto los términos de","agree_link":"el acuerdo de licencia."},"consents":{"status":{"ALL":"Todos","PENDING":"Pendiente","GRANTED":"Otorgado","REJECTED":"Rechazado","REVOKED":"Revocado","EXPIRED":"Caducado","CANCELED":"Cancelado","ABANDONED":"Cancelado"},"status_title":{"PENDING":"Solicitud pendiente","GRANTED":" Revisión del diploma","REJECTED":"Solicitud rechazada","REVOKED":"Solicitud revocada","EXPIRED":"Solicitud caducada","CANCELED":"Solicitud cancelada","ABANDONED":"Solicitud cancelada"},"no_data_label":"No hay solicitudes de consentimiento","show_consents_list_label":"Abrir la lista de solicitudes de consentimiento","hide_consents_list_label":"Volver a los detalles de la solicitud de consentimiento","no_selected_consent_request_label":"Seleccione una solicitud de consentimiento en la lista para ver los detalles","edit_label":"Editar solicitud de consentimiento","cancel_request_success_message":"Solicitud cancelada con éxito!","request_details_label":"Detalles de la solicitud","target_label":"Beneficiario","created_by_label":"Creado por","hidden_for_applicant_label":"Oculto al solicitante","credentials_label":"Diplomas","issued_at_label":"Emitido en","cancel_request_button_label":"Cancelar solicitud","cancel_request_warning_label":"¡Aviso! Ya no verá esta Solicitud de consentimiento en la lista después de cancelarla","cancel_request_are_you_sure_label":" ¿Está seguro de que desea cancelar la Solicitud de consentimiento?","applicant_response_label":" Respuesta del solicitante","last_update_label":"Última actualización","expires_label":"Caducada","expired_label":"Caducada","revoked_label":"Revocado","pending_consents_label":"Consentimientos pendientes","periods":{"week_label":"Semana","month_label":"Mes","year_label":"Año","forever_label":"Siempre"},"consent_end_date_alert":"Su consentimiento caducará el","active_consents_label":"Consentimientos activos","requested_label":"Solicitado","valid_till_label":"Válida hasta","grant_consent_button":"Otorga el consentimiento","current_expire_date_label":"Fecha de caducidad actual","next_expire_date_label":"Fecha de caducidad siguiente","extend_consent_button":"Extiende el consentimiento","remove_consent_label":"Revocar el consentimiento","remove_consent_button":"Revocar","remove_consent_success_label":"¡Consentimiento revocado con éxito!","remove_modal_alert":"¿Está seguro de que debe eliminar este consentimiento?","person_label":"Persona","none_label":"Ninguno","no_active_consents_label":"Aún no tiene ningún consentimiento activo","no_pending_consents_label":"Aún no tiene ningún consentimiento pendiente","next_consent_button":"Siguiente Solicitud","status_filter_label":"Estado","job_label":"Empleo","job_filter_placeholder":"Teclee el título del empleo para buscar","job_title_label":"Título del empleo","internal_job_reference":"Referencia de empleo interna","expose_job_reference":"Compartir referencia de empleo interna con el solicitante","note_to_applicants_label":"Nota al solicitante(s)","consents_history_label":"Historial de consultas","show_consents_with_status_label":"Mostrar los consentimientos con su estado","consents_history_no_data_label":"Su historial de consultas está vacío","status_label":"Estado","expired_on_label":"Caducó el","dismiss_request_button_label":"Descartar solicitud","dismiss_request_warning_label":"¡Aviso! Ya no verá esta solicitud de consentimiento en la lista después de descartarla.","dismiss_request_are_you_sure_label":"¿Está seguro de que desea descartar la Solicitud de consentimiento?","self_study_books_label":" Libros de autoestudio","accreditations_label":"Certificaciones","remove_bulk_consent_requests":" ¿Está seguro de que desea eliminar este archivo?","verified_by_applicant_only_label":"Verificado por: Sólo el solicitante"},"prior_consents":{"prior_consents_label":" Consentimientos previos","prior_consents_no_data_label":"Aún no tiene un consentimiento previo","target_type_label":"Tipo de beneficiario","target_data_label":"Beneficiario","auto_grant_till_label":"Otorgar automáticamente hasta","duration_label":"Duración","anyone_label":"Cualquiera","day_label":"Día","days_label":"Días","add_prior_consent_label":"Crear consentimiento previo","edit_prior_consent_label":"Editar consentimiento previo","target_type_input_placeholder":"Seleccionar tipo de beneficiario...","add_prior_consent_success_message":"Consentimiento previo creado con éxito! ","edit_prior_consent_success_message":"¡Consentimiento previo actualizado con éxito!","period_label":"Período","duration_alert":"La duración del consentimiento será","response_comment_label":"Respuesta automática a los solicitantes","response_comment_placeholder":"Deje su comentario aquí ...","remove_prior_consent_label":"Eliminar el consentimiento previo","remove_prior_consent_success_message":"Consentimiento previo eliminado con éxito ","remove_prior_consent_alert":" ¿Está seguro de que desea eliminar este consentimiento previo?","prior_consents_hint_part_1":"Un consentimiento previo es un consentimiento que se configura ahora y se ejecutará de forma inmediata y automática, sin molestarlo nuevamente en el momento en que lo solicite una empresa.","prior_consents_hint_part_2":"Significa que las compañías que agregue debajo, que consideren contratarlo, recibirán una confirmación inmediata del Diploma(-s) que eligió revelar ... al menos hasta la fecha dada de 'Auto-concesión hasta'.","prior_consents_hint_part_3":"El campo 'Duración' especifica cuánto tiempo es válido dicho consentimiento. P.e. si lo configura para un mes, significa que los compañeros de trabajo del primer solicitante (otros gerentes de recursos humanos, su jefe potencial (!), ...) de la misma compañía también pueden verificarlo dentro de ese mes después de esa primera solicitud. Sin embargo, una vez que pasó ese mes, deben hacer una nueva solicitud, que BrainChain luego verifica con la fecha de 'Auto-concesión hasta'."},"approve_consent_after_request":{"label":"Aprobar el consentimiento después de la solicitud","success_alert":"Aprobación exitosa de consentimiento después de la solicitud","consent_requestor_label":"Solicitante de Consentimiento","grant_title_label":"Otogar","refuse_title_label":"Rechazar","grant_button":"Otogar","refuse_button":"Rechazar","company_name_label":"Nombre de la Organización","company_country_label":"País de la Organización","request_date":"Fecha de solicitud","period_label":"Período","period_input_placeholder":"Elegir período ... ","reason_label":"Razón","reason_input_placeholder":"Elija el motivo ...","reasons":{"TIMING1":"No estoy buscando trabajo","TIMING2":"So estaré disponible laboralmente como mínimo hasta dentro de un año a partir de ahora","INTEREST":"No estoy interesado en trabajar para esta empresa","MISMATCH":"Este trabajo no parece coincidir con mis habilidades","ANOTHER":"Otra razón"},"comment_label":"Dejar un comentario para el solicitante","comment_placeholder":"Escriba su mensaje aquí ...","back_button":"Volver","approve_consent_progress_label":"Otorgado"},"notification_settings":{"label":"Notificaciones","notification_settings_label":"Configuración de notificaciones","notification_new_accreditation_enabled":"Enviarme un correo electrónico cuando necesite revisar nuevos diplomas","notification_consent_request_enabled":"Enviarme un correo electrónico cuando un empleador potencial nos solicite que confirmemos su diploma","notification_settings_update_success_alert":"¡La configuración de notificaciones se ha actualizado correctamente!","no_settings_label":"No tiene configuraciones de notificación disponibles en este momento.","preferred_language":"Idioma de notificaciones preferido"},"security_settings":{"label":"Seguridad","2fa_label":"Autentificación dos factores (2FA)","current_status_label":"Estado actual:","2fa_disabled_label":"Autentificación de dos factores deshabilitada.","2fa_enabled_label":"Autentificación de dos factores habilitada.","disable_2fa_submit_button":"Deshabilitar la autentificación de dos factores","enable_2fa_submit_button":"Habilitar la autentificación de dos factores","disable_2fa_are_you_sure_message":"¿Está seguro de que desea desactivar la autentificación de dos factores? Después de desactivar la autentificación de dos factores, puede iniciar sesión en su cuenta con su Email y la contraseña sin introducir un código de verificación.","disable_2fa_success_message":" La autentificación de dos factores se ha deshabilitado correctamente.","enable_2fa_scan_qr_code_message":"Para habilitar la autentificación de dos factores, escanee el código QR usando Google Authenticator u otra aplicación que sea conveniente para usted. La aplicación le permitirá recibir códigos de verificación para iniciar sesión en su cuenta","links_label":"Enlaces a aplicaciones de autentificación","google_authenticator_android_label":"Google Authenticator para Android","google_authenticator_ios_label":"Google Authenticator para iOS","free_otp_android_label":"FreeOTP Authenticator para Android","free_otp_ios_label":"FreeOTP Authenticator para iOS","update_warning":"Debe escanear el nuevo código QR cada vez que habilite la autentificación de dos factores para obtener un código actualizado.","enable_2fa_check_code_message":"Para asegurarse de que todo funciona correctamente, puede introducir el código de verificación real recibido después de escanear el código QR","enable_2fa_parameters_label":"Parámetros de autentificación","issuer_label":"Editor","secret_label":"Secreto","algorithm_label":"Algoritmo","digits_label":"Dígitos","period_label":"Período","check_code_label":"Código de verificación","enable_2fa_success_message":"Autentificación de dos factores habilitada con éxito !","2fa_contact_support_message":"Si, por algún motivo, ha perdido el acceso a la aplicación y no puede obtener un código de verificación, póngase en contacto con el servicio de asistencia.","verification_code_details_label":"El código de verificación debe tener seis dígitos.","verification_code_enter_label":"Para obtener el código de autentificación de dos factores correcto, consulte la aplicación del generador de códigos que eligió al habilitar esta configuración"},"self_study":{"table_label":"Libros de auto-estudio","no_data_label":"No tiene $Libros de auto-estudio$ por el momento. Los libros que lee o estudia por su cuenta, se pueden agregar aquí y no requieren confirmación externa. Muestran interés y esfuerzo, no hay prueba de educación formal.","domain_label":"Dominio","publisher_label":"Editor","study_date_label":"Fecha de lectura ","isbn_label":"ISBN","domains":{"ADMINISTRATION_AND_MANAGEMENT":"Administración & Dirección","COMMUNICATION":"Comunicación","CULTURE_AND_SPORTS_AND_ENTERTAINMENT":"Cultura, Deporte & Entretenimiento","GOV":"Gobierno","IT":"TI","LAND_AND_SEA_AND_AIR":"Tierra & Mar & Aire","LEGAL":"Ley","LIFE_AND_DEATH":"Vida & Muerte","MANUFACTURING_AND_WORKING_WITH_MATERIALS":"Fabricación & Trabajo con Materiales","SALES_AND_MARKETING":"Ventas & Marketing","SERVICES":"Servicios","STEM":"STEM","OTHER":"Otros"},"domains_examples":{"ADMINISTRATION_AND_MANAGEMENT":"Empleados, secretarias, director, ...","COMMUNICATION":"Periodismo, Audio / Video, ...","CULTURE_AND_SPORTS_AND_ENTERTAINMENT":"Turismo, actor, estripista, Industria del catering, ...","GOV":"Educación, Ejército, Policía, secretario municipal, ...","IT":"Desarrollador, ML, AI, diseñador web, DBA, arquitecto de software, ...","LAND_AND_SEA_AND_AIR":"Agricultor, pescador, astronauta, piloto, auxiliares de vuelo, jardinero, ...","LEGAL":"Notario, abogado, ...","LIFE_AND_DEATH":"Médico, veterinario, terapeuta, dentista, enfermera, francotirador, juez de instrucción, ...","MANUFACTURING_AND_WORKING_WITH_MATERIALS":"Leñador, soldador, textil, montaje de automóviles, minería, trabajadores de la construcción, ...","SALES_AND_MARKETING":"Panadería, piezas de automóvil, immo, alquiler, promoción, ...","SERVICES":"Servicio de limpieza, peluquería, contratación, seguros, banquero, transporte, contabilidad, distribución, ...","STEM":"Ciencias (Farmacéutica), Tecnología (mecánico de automóviles, electricista), Ingeniería (ingeniero agrícola, arquitecto), Matemáticas"},"add_self_study_book_success_message":"Libro de auto-estudio añadido con éxito!","edit_self_study_book_success_message":"  Libro de auto-estudio actualizado con éxito!","add_self_study_book_label":"Añadir libro al repertorio de auto-estudio","edit_self_study_book_label":"Editar libro de auto-estudio","domain_select_placeholder":"Seleccionar dominio ...","expose_self_study_book_label":"Exponer libro de auto-estudio ","remove_self_study_book_alert":"¿Está seguro de que quiere eliminar este libro de auto-estudio?","remove_self_study_book_success_message":"¡ Libro de auto-estudio eliminado con éxito!","isbn_format_hint":"El estándar ISBN10 / 13 es un esquema internacional de identificación de libros. Por favor, siga con este formato.","expose_label":"Exponer","error_messages":{"isbn_alert":"Adhiérase al formato ISBN10 o ISBN13."}},"notifications":{"pending_organizations":"Tiene {number} Organizaciones pendientes","review_failed_accreditations":"Tiene {number} verificaciones de diploma fallidas para revisar ","validate_accreditations":"Tiene {number} verificaciones de diploma pendientes","pending_accreditations":"Tiene {number} verificaciones de diploma pendientes","pending_consents":"Tiene {number} Consentimientos pendientes ","pending_accreditation_requests":"Tiene {number} solicitudes de verificación de diploma pendientes ","unreferenced_accreditation_requests_by_ags":"Tiene {number} Solicitudes de verificación de diploma sin referencia","unreferenced_accreditation_requests_by_domains":"Tiene {number} Solicitudes de verificación de diploma sin referencia"},"accreditation_requests":{"create_accreditation_request_label":"Crear solicitud de verificación de diploma","create_accreditation_request_success_message":"Solicitud de verificación de diploma creada con éxito!","create_accreditation_request_hint":"Si su Alma Mater ya forma parte de la plataforma BrainChain, lo puede lo 'Seleccionar' en los siguientes campos. De lo contrario, vaya a 'Ingresar manualmente' y asegúrese de ingresar el ACTUAL dominio de Internet (puede haber cambiado con los años) de su Alma Mater correctamente","domain_hint":"Un dominio de Internet es la primera parte de la dirección web de una Organización. P.ej. 'apple.com' o 'ibm.de'.","accreditation_group_hint":"Un grupo de acreditación suele ser el nombre de la #Facultad# en la que se graduó. Como #Ingeniería Civil# o #Psicología#, dependiendo de cómo se organice su Alma Mater.","national_id_hint":"Todos los países identifican a sus ciudadanos con un número único. Esto es para evitar la ambigüedad, incluso para personas con el mismo nombre. Obviamente, para saber quién posee qué grado, esto importa realmente. Nos proporciona un medio para garantizar que incluso alguien con el mismo nombre que el suyo nunca podrá robar su identidad o reclamar que obtuvo su título.","national_id_expose_hint":"La identificación nacional sólo se revela en su totalidad al solicitante. Los solicitantes podrán cambiar la configuración de revelación en todo momento.","manual_org_input_mode_label":"Introduzca los datos de la Organización manualmente","select_org_input_mode_label":"Seleccione Organización","manual_accreditation_group_input_mode_label":"Entrada de grupo de acreditación (facultad) manualmente","select_accreditation_group_input_mode_label":"Seleccione grupo de acreditación (facultad)","manual_vid_input_mode_label":"Ingrese los datos VID manualmente","select_vid_input_mode_label":"Seleccione VID","vid_label":"Identidad verificada","status":{"REQUEST_SUBMITTED":"Presentado","REQUEST_IN_PROCESS":"En proceso","REQUEST_REJECTED":"Rechazado"},"status_label":"Estado de la solicitud","expose_label":"Diploma revelado","edit_accreditation_request_label":"Editar solicitud de verificación de diploma","remove_accreditation_request_label":"Eliminar solicitud de verificación de diploma","accreditation_requests_no_data_label":"Aún no tiene solicitudes de verificación de diploma.","accreditation_requests_label":"Solicitud de verificación de diploma","accreditation_request_remove_alert":"¿Está seguro de que desea eliminar esta solicitud de verificación de diploma?","edit_accreditation_request_success_message":"Solicitud de verificación de diploma actualizada con éxito!","pending_accreditation_requests_by_domain_label":"Solicitudes de verificación de diploma pendientes por dominio","validated_accreditation_requests_by_domain_label":"Solicitudes de verificación de diploma validadas por dominio","accreditation_requests_list_no_data_label":"Todavía no hay solicitudes de verificación de diploma","organization_domain_label":"Dominio de la Organización","accreditation_requests_number_label":"Número de solicitudes de verificación de diploma","filter_by_domain_label":"Filtrar por dominio","filter_label":"Filtrar","accreditation_requests_remove_alert":"¿Está seguro de que desea eliminar las solicitudes de verificación de este diploma?","remove_accreditation_request_success_message":"¡ Solicitud de verificación de diploma eliminada con éxito!","remove_accreditation_requests_success_message":"¡ Solicitudes de verificación de diploma eliminadas con éxito!","update_accreditation_requests_success_message":"¡El dominio de las solicitudes de verificación de diploma se ha actualizado correctamente!","accreditation_requests_warning_alert":"Esta Organización tiene {número} solicitudes de acreditación. Si guarda esta Organización sin el permiso para insertar Diplomas, se eliminarán todas las solicitudes de verificación de Diploma pendientes del solicitante.","proceed_button":"Siguiente","accreditation_requests_by_group_label":"Solicitud de verificación de diploma por grupo.","accreditation_requests_by_group_hint_part_1":"Aquí puede acoplar las solicitudes de verificación de diploma realizadas por los solicitantes (listas a continuación) a los grupos de acreditación (facultades) 'existentes' en su Universidad.","accreditation_requests_by_group_hint_part_2":"Una vez acopladas, se asignará una ruta al Insertor(-s) correcto.","accreditation_requests_by_group_hint_part_3":"Nota: puede agrupar varias solicitudes del mismo Grupo de Acreditación (facultad).","set_accreditation_group_for_selected_button":"Establecer grupo de acreditación (facultad) para las solicitudes seleccionadas","reject_selected_button":"Rechazar lo seleccionado","reject_accreditation_requests_alert":"¿Está seguro de que desea rechazar todas las solicitudes de verificación de diploma seleccionadas?","reject_button":"Rechazar","set_accreditation_group_for_selected_requests_label":"Establecer el Grupo de Acreditación (facultad) para las solicitudes de verificación de Diplomas seleccionadas","set_accreditation_group_for_selected_requests_success_message":"Grupo de acreditación (facultad) de referencia agregada con éxito!","expose_accreditation_request_label":"Exponer solicitud de verificación de diploma","pending_accreditation_requests_label":"Solicitudes de verificación de diploma pendientes","pending_accreditation_requests_no_data_label":"Aún no hay solicitudes de verificación de diploma pendientes","pending_accreditation_requests_hint_part_1":"Si los datos son correctos, simplemente puede #Confirmar# la solicitud. Si no está seguro, puede pinchar en #Siguiente# para omitir la solicitud actual.","pending_accreditation_requests_hint_part_2":"Si los datos del Diploma tienen detalles incorrectos, puede corregirlos antes de la inserción.","back_button":"Volver a la lista de solicitudes de verificación de diploma pendientes","process_accreditation_request":"Proceso de solicitud de verificación del Diploma","next_accreditation_request_label":"Siguiente solicitud de verificación de diploma","confirm_accreditation_request_button":"Confirmar e insertar","reject_accreditation_request_alert":"¿Está seguro de que desea rechazar esta solicitud de verificación de diploma?","organization_label":"Organización","applicant_email_label":"Email del solicitante","expose_hint":"Usted también puede exponer los Diplomas aún no validados a posibles empleadores, pero se marcarán como 'no validados' hasta que la Universidad los haya confirmado.","created_at_label":"Fecha de solicitud","org_by_domain_error_alert":"Parece que esta Organización no tiene permisos para insertar diplomas.","accreditations_pending_approval_label":"Verificación de diploma pendiente de aprobación","accreditation_requests_details_label":"Detalles de la solicitud de verificación de diploma.","reject_accreditation_request_success_message":"Solicitudes de verificación de diploma rechazadas con éxito.","confirm_accreditation_request_success_message":"Solicitud de verificación de diploma confirmada con éxito!","pending_accreditations_progress_label":"Insertado","validated_accreditations_progress_label":"Validado","validate_button":"Validar","accreditation_requests_validate_alert":"¿Está Usted seguro de querer validar esta solicitud de verificación de diploma?","validate_accreditation_requests_success_message":"¡Solicitudes de verificación de diploma validadas con éxito!","pending_accreditation_requests_list_no_data_label":"No hay solicitudes de verificación de Diploma pendientes.","validated_accreditation_requests_list_no_data_label":"Todavía no hay solicitudes de verificación de Diploma aprobadas.","last_requestors_button":"Últimos solicitantes","applicant_accreditation_consent_label":"Por la presente, doy mi consentimiento a la Autoridad de Verificación de Acreditación BrainChain (BAVA) para gestionar la verificación y mantenerme informado."},"security":{"label":"Seguridad","got_it_button":"¡Entendido!","anchor_info_part_1":"Toda la comunicación con BrainChain se realiza de manera segura mediante el uso de una fuerte clave de cifrado digital. Esto envuelve de forma segura los datos del Diploma para evitar observación y manipulación. Obtenga esta clave, un archivo con la extensión '.jwk', a través de una simple solicitud a BrainChain.","anchor_info_part_2":"Su rol como Ancla significa que debe compartir estas claves de manera segura (= preferiblemente fuera de línea, por ejemplo en una memoria USB), con todos los Insertadores que designe.","anchor_info_part_3":"Sin esta clave, no podrán insertar Diplomas.","inserter_info_part_1":"Toda la comunicación con BrainChain se realiza de manera segura mediante el uso de una fuerte clave de cifrado digital. Esto envuelve de forma segura los datos del Diploma para evitar observación y manipulación. Su Ancla obtiene esta clave de BrainChain y se la pasa a usted; esta clave es un archivo con extensión '.jwk'.","inserter_info_part_2":"Todo lo que necesita hacer para comenzar es soltar o importar ese archivo debajo, en el misma ordenador que usará para insertar Diplomas.","inserter_info_part_3":"Ésta es una operación única a realizar en el ordenador que Usted utiliza para este propósito.","inserter_info_part_4":"Una vez instalada la clave, la encriptación y firma del diploma se realizará en segundo plano de forma transparente, sin que ninguna otra acción sea requerida.","admin_root_certificates_label":"Gestión del certificado Raíz de BrainChain","admin_universities_label":"Universidades validadas: en espera de que carguemos su clave del lado del servidor","admin_universities_info_part_1":"Además del certificado Raíz de BrainChain, hay un segundo componente que las universidades necesitan que instalemos en el servidor: el certificado generado por la universidad - uni.crt.","admin_universities_info_part_2":"Debajo está la lista de universidades validadas que aún no tienen esta clave instalada y la están esperando. Esto se puede hacer justo después de la validación universitaria: ¡ahora! Después de instalar esta clave, no olvide enviar también al Ancla de la Universidad su propio archivo uni.jwk. Esto debe ser generado por la SA fuera de línea.","add_valid_till_label":"Agregar / Válido hasta","add_certificate_button":"Agregar uni.crt","mail_anchor_label":"Mail Ancla uni.jwk","is_uni_key_sent_label":"Clave Uni enviada?","confirm_sent_button":"Confirmar envío","mail_subject_label":"Su clave digital BrainChain para firmar Diplomas de forma segura","mail_body_part_1":"Querido {anchor},","mail_body_part_2":"Toda la comunicación con BrainChain se realiza de manera segura mediante el uso de una fuerte clave de cifrado digital. Esto envuelve de forma segura los datos del Diploma para evitar observación y manipulación. Esta clave, un archivo con la extensión '.jwk', se agrega aquí. ","mail_body_part_3":"Su rol como Ancla significa que debe compartir estas claves de manera segura (= preferiblemente fuera de línea, por ejemplo en una memoria USB), con todos los Insertadores que designe.","mail_body_part_4":"Sin esta clave, no podrán insertar Diplomas.","mail_body_part_5":"Si olvida esto, la aplicación BrainChain se lo recordará en la sección Seguridad.","mail_body_part_6":"Equipo BrainChain"},"assistants":{"assistants_label":"Asistentes","no_data_label":"No hay asistentes todavía.","roles_label":"Roles","location_label":"Ubicación","process_assistant_label":"Asistente de proceso","financial_assistant_label":"Asistente financiero","add_assistant_page_label":"Agregar asistente","roles_select_placeholder":"Seleccionar roles de Asistente...","remove_assistant_alert":"¿Seguro que quiere eliminar este asistente?","edit_assistant_alert":"Editar Asistente"},"business_ambassadors":{"business_ambassadors_label":"Embajadores de negocios","no_data_label":"No hay embajadores de negocios todavía.","financial_data_label":"Datos financieros","add_business_ambassador_label":"Agregar Embajador de negocios","edit_business_ambassador_label":"Editar Embajadores de negocios","add_business_ambassador_success_message":"Embajador de negocios agregado con éxito.","edit_business_ambassador_success_message":"Embajador de negocios actualizado con éxito.","remove_ambassador_alert":"¿Seguro que quiere eliminar este Embajador de negocios?"},"commissions":{"commissions_list_label":"Comisiones","countries_label":"Países","commission_label":"Comisión","date_from_label":"Fecha de","date_to_label":"Fecha hasta","no_data_label":"No hay Comisiones.","remove_commission_success_message":"Comisión eliminada con éxito.","remove_commission_alert":"¿Está seguro de que quierer eliminar esta Comisión?","add_commission_label":"Agregar comisión","edit_commission_label":"Editar Comisión","add_commission_success_message":"Comisión creada con éxito.","edit_commission_success_message":"Comisión actualizada con éxito","ba_label":"Embajador de negocios","ba_short_label":"BA","add_commission_hint":"Para los embajadores comerciales # ya definidos#, nuevas comisiones se pueden definir a continuación"},"system_payment":{"due_payments_label":"Pagos adeudados","ba_s_due_payments_label":"Pagos adeudados a Embajadores de negocios","uni_s_due_payments_label":"Pagos adeudados a la educación mundial","system_due_payments_label":"Pago adeudado a WickedWare","system_due_payments_hint":"Este número representa la cantidad que se transferirá de la cuenta WickedWare 'BrainChain' a la cuenta WickedWare 'Savings' (LT773500010003830341). Esta es la suma pendiente de crédito de empresas consumidas.","filter_by_region_label":"Filtrar por región","ba_label":"BA","uni_label":"Uni","amount_label":"Monto adeudado","total_aggregated_pay_label":"Pago agregado total","ba_wire_data_label":"BA datos de transacciones","uni_wire_data_label":"Uni datos de transacciones","record_payment_label":"Registro de pago","paid_button":"Confirme pago fuera de línea","no_ba_s_label":"No hay BAs.","no_uni_s_label":"No hay Universidades.","no_payments_for_ba_s_label":"No hay pagos a BA dentro de estos criterios","no_payments_for_uni_s_label":"No hay pagos a Universidades dentro de estos criterios","no_payments_for_system":"No hay pagos adeudados para WickedWare.","show_label":"Mostrar","due_payments_paid_success_message":"¡Pagos vencidos pagados con éxito!","payments_history_label":"Historial de pagos","uni_s_payments_history_label":"Historial de pagos para la educación en todo el mundo","ba_s_payments_history_label":"Historial de pagos para embajadores de negocios","payment_date_label":"Fecha de pago","filter_date_from_label":"Fecha de","filter_date_to_label":"hasta","name_label":"Nombre","company_credit_label":"Crédito de la organización","date_joined_label":"Fecha de Ingreso","open_credit_label":"Crédito abierto","total_credit_label":"Total de crédito usado","contact_label":"Contacto","no_companies_credits_label":"No hay créditos de organización dentro de estos criterios.","order_by_label":"Ordenar por","due_payment_modal_label":"Pago adeudado por {name}","wire_data_modal_label":"Datos de transacción para {name}","comment_label":"Comentario","no_company_credits":"No historial de credito para esta empresa.","date_label":"Fecha","value_of_change_label":"Valor del cambio","credit_history_label":"Historial de crédito de {name}"},"validated_domains":{"validated_domains_label":"Dominios Edu Validados","no_data_label":"No hay dominios validados","filter_by_name_label":"Filtrar por nombre","organization_name_label":"Nombre de la Organización,","managed_by_label":"Gestionado por","applicant_requests_label":"Solicitudes de solicitantes","bava_managed_label":"Gestionado por BAVA","self_managed_label":"Auto-gestionado","add_domain_button":"Agregar dominio","validate_domain_label":"Validar dominio","contact_name_label":"Nombre de contacto","contact_email_label":"Email de contacto","contact_phone_label":"Teléfono de contacto","add_success_message":"¡Dominio validado agregado con éxito!","edit_success_message":"Dominio validado actualizado con éxito!","edit_domain_label":"Editar detalles de la organización","remove_domain_alert":"¿Seguro que quiere eliminar este dominio validado? ¡Tenga en cuenta que esto significa que todos sus diplomas en los perfiles de las personas también se eliminarán!","remove_success_message":"¡Dominio validado eliminado con éxito!","fully_registered_org_hint":"Puede cambiar esta Organización en la lista de Organizaciones."},"shared":{"add_button":"+","cancel_button":"Cancelar","remove_button":"Retirar","first_name_label":"Nombre de pila","last_name_label":"Apellidos","email_label":"Email","personal_email_label":"Email personal","professional_email_label":"Email profesional","password_label":"Contraseña","department_label":"Departamento","continent_input_placeholder":"Seleccionar región ...","country_input_placeholder":"Seleccionar país ...","continent_label":"Región","continent_filter_label":"Región (Filtro)","country_label":"País","fetching_message":"Cargando ...","success_message":"Éxito","national_id_label":"Nº de Documento Nacional de Identidad","company_label":"Empresa","edu_org_label":"Organización educativa","org_label":"Organización","employee_count_label":"Número de empleados","name_label":"Nombre","accreditation_group_label":"Grupo de Certificación","okey_button":"OK","yes_label":"Sí","no_label":"No","edit_button":"Editar","domain_label":"Dominio de Internet","datepicker_placeholder":"Pinchar aquí para seleccionar una fecha","save_changes_button":"Guardar cambios","back_button":"Volver","company_domain_label":"Dominio de la empresa","search_label":"Buscar","about_label":"Sobre","title_label":"Título","phone_number_label":"Número de teléfono","required_field_error_message":"Por favor rellene este campo","pages_label":"{currentNumber} de {totalNumber}","examples_label":"Ejemplos","location_label":"Ubicación","all_label":"Todas","filter_options_label":"Opciones de filtro"},"errors":{"IRRELEVANT_LINK_EMAIL":"¡Ya has cambiado tu email usando este enlace!","INCORRECT_JWK":"Clave de certificado incorrecta","DEFAULT_ERROR":"Error","INCORRECT_ACCOUNT_TYPE":"Tipo de cuenta incorrecto","INCORRECT_USERNAME_OR_PASSWORD":"Nombre de usuario o contraseña incorrectos","IRRELEVANT_LINK":"¡Ya has restablecido tu contraseña usando este enlace!","INCORRECT_FILE_CONTENT":"Contenido de archivo incorrecto","INCORRECT_DOMAIN":"El dominio proporcionado no es válido.","BAVA_ACCREDITATION_FLOW_FORBIDDEN":"Las operaciones de diploma relacionadas con BAVA están prohibidas.","BAVA_ACCREDITATION_MISSING_PARAMS":"La identificación de la organización debe figurar en el diploma.","BAVA_MISSING":"La organización Bava no está registrada.","BAVA_CANNOT_BE_CHANGED":"La organización Bava no se puede cambiar.","RELATED_ACCREDITATIONS_EXISTS":"El estado gestionado no se puede cambiar para organizaciones con solicitudes de verificación de diploma existentes.","REQUEST_BODY_INVALID":"Datos Incorrectos. Por favor, asegúrese de haber introducido todos los campos correctamente.","REQUEST_PARAM_MISSING":"Falta el parámetro de solicitud requerido","REQUEST_PARAM_INVALID":"El valor del parámetro de solicitud no es válido","OPERATION_NOT_PERMITTED":"Operación no permitida","OAUTH_CLIENT_ERROR":"Solicitud de OAuth inválida","OAUTH_GRANT_TYPE_INVALID":"Tipo de concesión OAuth no válido","NEGATIVE_BALANCE":"El saldo acreedor no puede ser negativo.","ACCREDITATION_GROUP_ROLE_INVALID":"Rol de grupo de Certificación no válido","ACCREDITATION_GROUP_ACCREDITATION_REQUEST_ADDITION_ERROR":"No es posible agregar esta Facultad a la solicitud de Acreditación.","ACCREDITATION_GROUP_STAFF_ADDITION_ERROR":"No se puede agregar el personal especificado para el Grupo de Certificación especificado","ACCREDITATION_GROUP_STAFF_REMOVAL_ERROR":"No se puede eliminar el personal especificado de un grupo de Certificación específico","ACCREDITATION_GROUP_NAME_MISSING":"#Especifique un nombre de Grupo de Acreditación (también conocido como Facultad) ya que no existe una opción predeterminada para esta organización.#","DEPARTMENT_ROLE_INVALID":"Rol de departamento no válido","DEPARTMENT_STAFF_ADDITION_ERROR":"No se puede agregar el personal especificado para el Departamento específico","DEPARTMENT_STAFF_REMOVAL_ERROR":"No se puede eliminar el personal especificado del Departamento específico","UNSUFFICIENT_BALANCE":"Saldo insuficiente: póngase en contacto con el responsable (Departamento financiero) para resolver este problema","TIME_PERIOD_INVALID":"El período es inválido","CONSENT_REQUEST_STATUS_INVALID":"Aparentemente esta solicitud ya ha sido procesada o cancelada","ABANDONING_OTHERS_REQUEST":"Ud. no puede realizar esta operación.","PRIOR_CONSENT_EXISTS":"Ya existe un consentimiento previo para el mismo beneficiario.","INCORRECT_ORGANIZATION_PAID_TILL_STATE":"Valor incorrecto para la fecha 'Pagado hasta'; la nueva fecha de 'Pagado hasta' debe ser más reciente que su valor anterior.","EXPIRED_ORGANIZATION_PAID_TILL":"La fecha de pago de la organización ha expirado.","ORGANIZATION_EMAIL_INVALID":"Email del personal de la Organización no válido","STAFF_REMOVAL_ERROR":"Esta persona no se puede eliminar","NO_ANCHOR_LEFT":"¡El Administrador de Universidad no se puede eliminar automáticamente!","ACTIVE_STAFF_MISSING":"No se puede encontrar personal activo con la ID especificada","NON_STAFF_USER_EXISTS":"¡El usuario especificado ya existe y no es un colega!","STAFF_DIFFERENT_ORGANIZATION":"Una persona con este Email ya trabaja en una Organización diferente.","STAFF_ALREADY_EXISTS":"Ya existe un colega con este Email ya funciona en su Organización","ORGANIZATION_ALREADY_EXISTS":"El nombre de la organización y/o el dominio ya están en uso","ORGANIZATION_IS_BAVA_MANAGED":"Mientras esta Organización sea administrada por BAVA, no puede tener Grupos de Acreditación; todos los Diplomados recurrirán a 'TodasFacultades' hasta que la Organización se una. En ese momento, un esfuerzo de migración de Diploma está en orden.","ORGANIZATION_CANNOT_BE_REMOVED":"Las organizaciones gestionadas por BAVA pueden eliminarse, pero BAVA (y sus autoridades de verificación filiales) no pueden eliminarse.","ORGANIZATION_CANNOT_BE_UPDATED":"Ya se ha registrado una organización con este nombre y / o dominio.","ORGANIZATION_CERTIFICATE_MISSING":"No existen certificados válidos para esta Organización.","ORGANIZATION_ACCREDITATION_INCORRECT_STATUS":"Estado de acreditación incorrecto","ORGANIZATION_ACCREDITATION_FLOW_FORBIDDEN":"La Organización no tiene permisos para insertar diplomas.","ORGANIZATION_EQUAL_MANAGED_STATE":"La organización ya estaba en este estado.","USER_ALREADY_EXISTS":"Esta cuenta ya existe","ACTIVATION_NOT_NEEDED":"Esta cuenta es desconocida o ya está activa","ALIAS_REQUIRED":"No se puede activar al usuario sin un Alias ​​completo","APPLICANT_TOKEN_REQUIRED":"Falta el token del candidato","APPLICANT_NOT_FOUND":"No hay nadie con esta dirección de correo electrónico registrada en BrainChain.","OLD_PASSWORD_INVALID":"Contraseña antigua no válida","EMAIL_ALREADY_IN_USE":"Este Email ya está en uso","USER_INACTIVE":"Esta cuenta es desconocida o está inactiva","NO_ALIASES_LEFT":"Debe existir al menos un alias","PASSWORD_TOO_SIMPLE":"La contraseña es demasiado simple","CAN_NOT_REMOVE_LAST_ROOT_ADMIN":"El último administrador raíz no se puede eliminar.","BUSINESS_AMBASSADOR_CONTRACT_INTERSECTION":"Para cada combinación [País, BA], solo se puede especificar una Comisión.","BUSINESS_AMBASSADOR_CONTRACT_HUGE_TOTAL_PERCENT":"El porcentaje de comisión total aumentó más de lo esperado para algunos países durante un período de tiempo.","VALIDATING_OWN_WORK":"¡ Ud. no puede validar su propio trabajo!","DELETING_OTHERS_WORK":"Ud. no puede realizar esta operación","ACCREDITATION_SIGNATURE_INVALID":"La firma facilitada no es válida","ACCREDITATION_SIGNATURE_MISSING":"Falta la firma requerida","ORIGINAL_ACCREDITATION_NOT_FOUND":"Disculpas, los datos originales de esta Acreditación (Diploma) no se pudieron recuperar.","APPLICANT_ACCREDITATION_REQUEST_ACCREDITATION_GROUP_ID_INVALID":"La Identificación del grupo de acreditación no es válida para la Organización especificada.","APPLICANT_ACCREDITATION_REQUEST_ACCREDITATION_GROUP_MISMATCH":"El grupo de acreditación (facultad) proporcionado por el solicitante difiere del grupo utilizado para insertar nuevos diplomas.","APPLICANT_ACCREDITATION_REQUEST_STATUS_INVALID":"El estado de la solicitud de verificación de diploma del solicitante no permite la inserción.","ACCREDITATION_BULK_JOB_NOT_FINISHED":"Espere hasta que finalice la carga masiva.","CREATE_CONSENT_REQUEST_BULK_JOB_NOT_FINISHED":"No puede ud. realizar esto hasta que la tarea haya finalizado.","ACCREDITATION_BULK_JOB_MISSING_REQUIRED_HEADERS":"Falta la fila del encabezado requerida","ACCREDITATION_BULK_JOB_INVALID_RECORD_SIZE":"Las columnas no coinciden con el encabezado.","ACCREDITATION_BULK_JOB_INVALID_RECORD_FORMAT":"Formato de registro no válido","ACCREDITATION_BULK_JOB_INVALID_XML_DOCUMENT_FORMAT":"Formato de documento XML no válido","CURRENCY_NOT_SUPPORTED":"La moneda no es compatible","DIGITAL_CERTIFICATE_UNSUPPORTED_FORMAT":"El formato del certificado digital no es compatible","DIGITAL_CERTIFICATE_NOT_YET_VALID":"El certificado digital aún no es válido","DIGITAL_CERTIFICATE_EXPIRED":"El certificado digital ha caducado.","DIGITAL_CERTIFICATE_VERIFICATION_FAILED":"El certificado digital no está debidamente firmado","UNSUPPORTED_CONTENT_TYPE":"Tipo de contenido no admitido","FAILED_TO_PARSE_BODY":"Error al analizar el cuerpo de la solicitud","FILE_TOO_LARGE":"El archivo cargado es demasiado grande","BUSINESS_AMBASSADOR_NOT_FOUND":"Embajador de negocios no encontrado","BUSINESS_AMBASSADOR_CONTRACT_NOT_FOUND":"Contrato de embajador comercial no encontrado","ACCREDITATION_GROUP_NOT_FOUND":"No se ha encontrado el grupo de Certificación","ACCREDITATION_GROUP_CONTAIN_REQUESTS":"Esta Facultad (Grupo de Acreditación) contiene solicitudes sin procesar y, por lo tanto, no se puede eliminar.","DEPARTMENT_NOT_FOUND":"Departamento no encontrado","ORGANIZATION_NOT_FOUND":"Organización no encontrada","STAFF_NOT_FOUND":"No se ha encontrado al miembro del personal","ALIAS_NOT_FOUND":"Alias no encontrado","ACCREDITATION_NOT_FOUND":"No se ha encontrado la Certificación","VERIFIED_IDENTITY_NOT_FOUND":"No se encontró la identidad verificada","ACCREDITATION_BULK_JOB_NOT_FOUND":"No se ha encontrado el volumen a cargar","CREATE_CONSENT_REQUEST_BULK_JOB_NOT_FOUND":"Trabajo a granel no encontrado","NO_HANDLER_FOUND":"No se ha encontrado un gestor","PRICING_PRESET_NOT_FOUND":"Precio preestablecido no encontrado","USER_NOT_FOUND":"El usuario que está Ud. buscando no se ha registrado en BrainChain todavía.","CONSENT_REQUEST_NOT_FOUND":"La solicitud de consentimiento no se ha encontrado","PRIOR_CONSENT_NOT_FOUND":"El consentimiento previo no se ha encontrado","SELF_STUDY_BOOK_NOT_FOUND":"Libro de auto-estudio no encontrado","DIGITAL_CERTIFICATE_NOT_FOUND":"El certificado digital no se ha encontrado","APPLICANT_ACCREDITATION_REQUEST_NOT_FOUND":"No se ha encontrado la Solicitud de verificación de diploma del solicitante","TOKEN_NOT_FOUND":"No se ha encontrado ningún token","TOKEN_EXPIRED":"Token caducado","TOKEN_INVALID":"Token inválido","TOKEN_VALIDATION_ERROR":"Problema de validación de token","TOTP_CODE_INVALID":"Código de verificación inválido","TOTP_CODE_REQUIRED":"Se requiere un código TOTP ","AUTHENTICATION_FAILED":"La autentificación ha fallado","ORGANIZATION_NOT_VERIFIED":"La Organización no está verificada.","USER_ALREADY_ACTIVE":"Esta cuenta ya está activa","ORGANIZATION_CANNOT_WORK_WITH_ACCREDITATIONS":"Esta Organización no puede trabajar con Certificationes","ACCESS_DENIED":"Acceso denegado","APPLICANT_ACCREDITATION_REQUEST_CANNOT_BE_MODIFIED_IF_ORG_REFERENCED":"La Solicitud de Acreditación del Solicitante ya no puede modificarse como la Organización en cuestión registrada en BrainChain.","APPLICANT_ACCREDITATION_REQUEST_ORG_CHANGE_FORBIDDEN":"La Organización de una Solicitud de Acreditación de Solicitante no puede ser modificada.","APPLICANT_ACCREDITATION_REQUEST_AMOUNT_TOO_LARGE":"Se ha alcanzado la cantidad máxima de solicitudes de verificación de diploma.","UNAUTHORIZED":"No autorizado","INTERNAL_SERVER_ERROR":"Error interno del servidor"},"continents":{"AF":"África","NA":"América del Norte","OC":"Oceanía","AN":"Antártida","AS":"Asia","EU":"Europa","SA":"Sudamérica"},"countries":{"AD":"Andorra","AE":"Emiratos Árabes Unidos","AF":"Afganistán","AG":"Antigua y Barbuda","AI":"Anguila","AL":"Albania","AM":"Armenia","AO":"Angola","AQ":"Antártida","AR":"Argentina","AS":"Samoa Americana","AT":"Austria","AU":"Australia","AW":"Aruba","AX":"Islas Aland","AZ":"Azerbaiyán","BA":"Bosnia y Herzegovina","BB":"Barbados","BD":"Bangladesh","BE":"Bélgica","BF":"Burkina Faso","BG":"Bulgaria","BH":"Bahrein","BI":"Burundi","BJ":"Benin","BL":"San Bartolomé","BM":"Bermudas","BN":"Brunei Darussalam","BO":"Bolivia, Estado Plurinacional de","BQ":"Bonaire, San Eustaquio y Saba","BR":"Brasil","BS":"Bahamas","BT":"Bután","BV":"Isla Bouvet","BW":"Botswana","BY":"Bielorrusia","BZ":"Belice","CA":"Canadá","CC":"Islas Cocos (Keeling)","CD":"Congo, República Democrática del","CF":"República Centroafricana","CG":"Congo","CH":"Suiza","CI":"Costa de Marfil","CK":"Islas Cook","CL":"Chile","CM":"Camerún","CN":"China","CO":"Colombia","CR":"Costa Rica","CU":"Cuba","CV":"Cabo Verde","CW":"Curaçao","CX":"Isla de Navidad","CY":"Chipre","CZ":"República Checa","DE":"Alemania","DJ":"Djibouti","DK":"Dinamarca","DM":"Dominica","DO":"República Dominicana","DZ":"Argelia","EC":"Ecuador","EE":"Estonia","EG":"Egipto","EH":"Sahara Occidental","ER":"Eritrea","ES":"España","ET":"Etiopía","FI":"Finlandia","FJ":"Fiji","FK":"Islas Malvinas","FM":"Micronesia, Estados Federados de","FO":"Islas Feroe","FR":"Francia","GA":"Gabón","GB":"Reino Unido","GD":"Granada","GE":"Georgia","GF":"Guayana Francesa","GG":"Guernsey","GH":"Ghana","GI":"Gibraltar","GL":"Groenlandia","GM":"Gambia","GN":"Guinea","GP":"Guadalupe","GQ":"Guinea Ecuatorial","GR":"Grecia","GS":"Islas Georgia del Sur y Sandwich del Sur","GT":"Guatemala","GU":"Guam","GW":"Guinea-Bissau","GY":"Guyana","HK":"Hong Kong","HM":"Islas Heard y McDonald","HN":"Honduras","HR":"Croacia","HT":"Haití","HU":"Hungría","ID":"Indonesia","IE":"Irlanda","IL":"Israel","IM":"Isla de Man","IN":"India","IO":"Territorio Británico del Océano Índico","IQ":"Iraq","IR":"Irán, República Islámica de","IS":"Islandia","IT":"Italia","JE":"Jersey","JM":"Jamaica","JO":"Jordania","JP":"Japón","KE":"Kenia","KG":"Kirguistán","KH":"Camboya","KI":"Kiribati","KM":"Comoras","KN":"San Cristóbal y Nieves","KP":"Corea, República Popular Democrática de","KR":"República de Corea","KW":"Kuwait","KY":"Islas Caimán","KZ":"Kazajstán","LA":"República Democrática Popular de Lao","LB":"Líbano","LC":"Santa Lucía","LI":"Liechtenstein","LK":"Sri Lanka","LR":"Liberia","LS":"Lesotho","LT":"Lituania","LU":"Luxemburgo","LV":"Letonia","LY":"Libia","MA":"Marruecos","MC":"Mónaco","MD":"Moldova, República de","ME":"Montenegro","MF":"San Martín (parte francesa)","MG":"Madagascar","MH":"Islas Marshall","MK":"Macedonia, ex República Yugoslava de","ML":"Mali","MM":"Myanmar","MN":"Mongolia","MO":"Macao","MP":"Islas Marianas del Norte","MQ":"Martinica","MR":"Mauritania","MS":"Montserrat","MT":"Malta","MU":"Mauricio","MV":"Maldivas","MW":"Malawi","MX":"México","MY":"Malasia","MZ":"Mozambique","NA":"Namibia","NC":"Nueva Caledonia","NE":"Niger","NF":"Isla Norfolk","NG":"Nigeria","NI":"Nicaragua","NL":"Países Bajos","NO":"Noruega","NP":"Nepal","NR":"Nauru","NU":"Niue","NZ":"Nueva Zelanda","OM":"Omán","PA":"Panamá","PE":"Perú","PF":"Polinesia Francesa","PG":"Papúa Nueva Guinea","PH":"Filipinas","PK":"Pakistán","PL":"Polonia","PM":"San Pedro y Miquelón","PN":"Pitcairn","PR":"Puerto Rico","PS":"Estado de Palestina","PT":"Portugal","PW":"Palau","PY":"Paraguay","QA":"Qatar","RE":"Reunión","RO":"Rumanía","RS":"Serbia","RU":"Federación Rusa","RW":"Ruanda","SA":"Arabia Saudita","SB":"Islas Salomón","SC":"Seychelles","SD":"Sudán","SE":"Suecia","SG":"Singapur","SH":"Santa Elena, Ascensión y Tristán da Cunha","SI":"Eslovenia","SJ":"Svalbard y Jan Mayen","SK":"Eslovaquia","SL":"Sierra Leona","SM":"San Marino","SN":"Senegal","SO":"Somalia","SR":"Suriname","SS":"Sudán del Sur","ST":"Santo Tomé y Príncipe","SV":"El Salvador","SX":"Sint Maarten (parte holandesa)","SY":"República Árabe Siria","SZ":"Swazilandia","TC":"Islas Turcas y Caicos","TD":"Chad","TF":"Territorios franceses del sur","TG":"Togo","TH":"Tailandia","TJ":"Tayikistán","TK":"Tokelau","TL":"Timor-Leste","TM":"Turkmenistán","TN":"Túnez","TO":"Tonga","TR":"Turquía","TT":"Trinidad y Tobago","TV":"Tuvalu","TW":"Taiwán, Provincia de China","TZ":"Tanzania, República Unida de","UA":"Ucrania","UG":"Uganda","UM":"Islas menores alejadas de los Estados Unidos","US":"Estados Unidos de América","UY":"Uruguay","UZ":"Uzbekistán","VA":"Santa Sede (Estado de la Ciudad del Vaticano)","VC":"San Vicente y las Granadinas","VE":"Venezuela, República Bolivariana de","VG":"Islas Vírgenes Británicas","VI":"Islas Vírgenes, EE.UU.","VN":"Viet Nam","VU":"Vanuatu","WF":"Wallis y Futuna","WS":"Samoa","YE":"Yemen","YT":"Mayotte","ZA":"Sudáfrica","ZM":"Zambia","ZW":"Zimbabwe"},"levels":{"SECONDARY_SCHOOL":"Escuela secundaria","TECHNICAL":"Técnico","BACHELOR":"Licenciado","MASTER":"Master","POST_GRADUATE":"Postgrado","PHD":"PhD","TRAINING_CERTIFICATION":"Formación con certificación","SELF_WITH_CERTIFICATION":"Autoestudio con certificación","SELF_WITHOUT_CERTIFICATION":"Autoestudio sin certificación"},"langs":{"en":"English","de":"Deutsch","es":"Español","nl":"Nederlands","fr":"Français","pt":"Portuguese","ru":"Русский","ja":"日本語"}}

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(16)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(16)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(16)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(16)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(16)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function() {
  function toArray(arr) {
    return Array.prototype.slice.call(arr);
  }

  function promisifyRequest(request) {
    return new Promise(function(resolve, reject) {
      request.onsuccess = function() {
        resolve(request.result);
      };

      request.onerror = function() {
        reject(request.error);
      };
    });
  }

  function promisifyRequestCall(obj, method, args) {
    var request;
    var p = new Promise(function(resolve, reject) {
      request = obj[method].apply(obj, args);
      promisifyRequest(request).then(resolve, reject);
    });

    p.request = request;
    return p;
  }

  function promisifyCursorRequestCall(obj, method, args) {
    var p = promisifyRequestCall(obj, method, args);
    return p.then(function(value) {
      if (!value) return;
      return new Cursor(value, p.request);
    });
  }

  function proxyProperties(ProxyClass, targetProp, properties) {
    properties.forEach(function(prop) {
      Object.defineProperty(ProxyClass.prototype, prop, {
        get: function() {
          return this[targetProp][prop];
        },
        set: function(val) {
          this[targetProp][prop] = val;
        }
      });
    });
  }

  function proxyRequestMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function(prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function() {
        return promisifyRequestCall(this[targetProp], prop, arguments);
      };
    });
  }

  function proxyMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function(prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function() {
        return this[targetProp][prop].apply(this[targetProp], arguments);
      };
    });
  }

  function proxyCursorRequestMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function(prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function() {
        return promisifyCursorRequestCall(this[targetProp], prop, arguments);
      };
    });
  }

  function Index(index) {
    this._index = index;
  }

  proxyProperties(Index, '_index', [
    'name',
    'keyPath',
    'multiEntry',
    'unique'
  ]);

  proxyRequestMethods(Index, '_index', IDBIndex, [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
  ]);

  proxyCursorRequestMethods(Index, '_index', IDBIndex, [
    'openCursor',
    'openKeyCursor'
  ]);

  function Cursor(cursor, request) {
    this._cursor = cursor;
    this._request = request;
  }

  proxyProperties(Cursor, '_cursor', [
    'direction',
    'key',
    'primaryKey',
    'value'
  ]);

  proxyRequestMethods(Cursor, '_cursor', IDBCursor, [
    'update',
    'delete'
  ]);

  // proxy 'next' methods
  ['advance', 'continue', 'continuePrimaryKey'].forEach(function(methodName) {
    if (!(methodName in IDBCursor.prototype)) return;
    Cursor.prototype[methodName] = function() {
      var cursor = this;
      var args = arguments;
      return Promise.resolve().then(function() {
        cursor._cursor[methodName].apply(cursor._cursor, args);
        return promisifyRequest(cursor._request).then(function(value) {
          if (!value) return;
          return new Cursor(value, cursor._request);
        });
      });
    };
  });

  function ObjectStore(store) {
    this._store = store;
  }

  ObjectStore.prototype.createIndex = function() {
    return new Index(this._store.createIndex.apply(this._store, arguments));
  };

  ObjectStore.prototype.index = function() {
    return new Index(this._store.index.apply(this._store, arguments));
  };

  proxyProperties(ObjectStore, '_store', [
    'name',
    'keyPath',
    'indexNames',
    'autoIncrement'
  ]);

  proxyRequestMethods(ObjectStore, '_store', IDBObjectStore, [
    'put',
    'add',
    'delete',
    'clear',
    'get',
    'getAll',
    'getKey',
    'getAllKeys',
    'count'
  ]);

  proxyCursorRequestMethods(ObjectStore, '_store', IDBObjectStore, [
    'openCursor',
    'openKeyCursor'
  ]);

  proxyMethods(ObjectStore, '_store', IDBObjectStore, [
    'deleteIndex'
  ]);

  function Transaction(idbTransaction) {
    this._tx = idbTransaction;
    this.complete = new Promise(function(resolve, reject) {
      idbTransaction.oncomplete = function() {
        resolve();
      };
      idbTransaction.onerror = function() {
        reject(idbTransaction.error);
      };
      idbTransaction.onabort = function() {
        reject(idbTransaction.error);
      };
    });
  }

  Transaction.prototype.objectStore = function() {
    return new ObjectStore(this._tx.objectStore.apply(this._tx, arguments));
  };

  proxyProperties(Transaction, '_tx', [
    'objectStoreNames',
    'mode'
  ]);

  proxyMethods(Transaction, '_tx', IDBTransaction, [
    'abort'
  ]);

  function UpgradeDB(db, oldVersion, transaction) {
    this._db = db;
    this.oldVersion = oldVersion;
    this.transaction = new Transaction(transaction);
  }

  UpgradeDB.prototype.createObjectStore = function() {
    return new ObjectStore(this._db.createObjectStore.apply(this._db, arguments));
  };

  proxyProperties(UpgradeDB, '_db', [
    'name',
    'version',
    'objectStoreNames'
  ]);

  proxyMethods(UpgradeDB, '_db', IDBDatabase, [
    'deleteObjectStore',
    'close'
  ]);

  function DB(db) {
    this._db = db;
  }

  DB.prototype.transaction = function() {
    return new Transaction(this._db.transaction.apply(this._db, arguments));
  };

  proxyProperties(DB, '_db', [
    'name',
    'version',
    'objectStoreNames'
  ]);

  proxyMethods(DB, '_db', IDBDatabase, [
    'close'
  ]);

  // Add cursor iterators
  // TODO: remove this once browsers do the right thing with promises
  ['openCursor', 'openKeyCursor'].forEach(function(funcName) {
    [ObjectStore, Index].forEach(function(Constructor) {
      // Don't create iterateKeyCursor if openKeyCursor doesn't exist.
      if (!(funcName in Constructor.prototype)) return;

      Constructor.prototype[funcName.replace('open', 'iterate')] = function() {
        var args = toArray(arguments);
        var callback = args[args.length - 1];
        var nativeObject = this._store || this._index;
        var request = nativeObject[funcName].apply(nativeObject, args.slice(0, -1));
        request.onsuccess = function() {
          callback(request.result);
        };
      };
    });
  });

  // polyfill getAll
  [Index, ObjectStore].forEach(function(Constructor) {
    if (Constructor.prototype.getAll) return;
    Constructor.prototype.getAll = function(query, count) {
      var instance = this;
      var items = [];

      return new Promise(function(resolve) {
        instance.iterateCursor(query, function(cursor) {
          if (!cursor) {
            resolve(items);
            return;
          }
          items.push(cursor.value);

          if (count !== undefined && items.length == count) {
            resolve(items);
            return;
          }
          cursor.continue();
        });
      });
    };
  });

  var exp = {
    open: function(name, version, upgradeCallback) {
      var p = promisifyRequestCall(indexedDB, 'open', [name, version]);
      var request = p.request;

      if (request) {
        request.onupgradeneeded = function(event) {
          if (upgradeCallback) {
            upgradeCallback(new UpgradeDB(request.result, event.oldVersion, request.transaction));
          }
        };
      }

      return p.then(function(db) {
        return new DB(db);
      });
    },
    delete: function(name) {
      return promisifyRequestCall(indexedDB, 'deleteDatabase', [name]);
    }
  };

  if (true) {
    module.exports = exp;
    module.exports.default = module.exports;
  }
  else {
    self.idb = exp;
  }
}());


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_storageApi__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App_css__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Logo_png__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__logo_sm_png__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__logo_sm_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__logo_sm_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mantra_png__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mantra_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__mantra_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_homePage_HomePage_container__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commonComponents_userSubRoleMissingModal_UserSubRoleMissingModal_container__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonComponents_orgPermissionsMissingModal_OrgPermissionsMissingModal_container__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__commonComponents_pageNotFoundComponent_PageNotFoundComponent_container__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__commonComponents_serverErrorComponent_ServerErrorComponent_container__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__commonComponents_helpComponent_HelpComponent_container__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__commonComponents_paymentComponent_PaymentComponent_container__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__navBarWithRoles_NavBarWithRoles_container__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__languageSelector_LanguageSelector_container__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__accountManagement_oauthUserLogin_OAuthUserLogin_container__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__accountManagement_login_Login_container__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__accountManagement_activateUserAccount_ActivateUserAccount_container__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__accountManagement_restoreAccount_RestoreAccount_container__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__accountManagement_resetPassword_ResetPassword_container__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__accountManagement_changeEmailFinish_ChangeEmailFinish_container__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__accountManagement_resendActivation_ResendActivation_container__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__accountManagement_registerApplicant_RegisterApplicant_container__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__accountManagement_registerInvitedApplicant_RegisterInvitedApplicant_container__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__accountManagement_accountManagementComponent_AccountManagementComponent_container__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__organizationManagement_orgsList_OrgsList_container__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__organizationManagement_registerOrg_RegisterOrg_container__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__staffMemberManagement_staffList_StaffList_container__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__accreditationManagement_insertAccreditation_InsertAccreditation_container__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__accreditationManagement_validateAccreditation_ValidateAccreditation_container__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__accreditationManagement_reviewAccreditation_ReviewAccreditationRejectedByValidator_container__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__accreditationManagement_reviewAccreditation_ReviewAccreditationRejectedByApplicant_container__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__accreditationManagement_accreditationsList_AccreditationsListForValidate_container__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__accreditationManagement_rejectedAccreditationsManagementComponent_RejectedAccreditationsManagementComponent_container__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__staffMemberManagement_AccreditationGroupsList_AccreditationGroupsList_container__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__staffMemberManagement_AccreditationGroupDetails_AccreditationGroupDetails_container__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__accreditationManagement_bulkJobsList_BulkJobsList_container__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__organizationManagement_orgDetails_OrgDetails_container__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__commonComponents_bulkFileFormatDetails_BulkFileFormatDetails_container__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__organizationManagement_orgsListToValidate_OrgsToValidateList_container__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__organizationManagement_orgModal_validateOrg_ValidateOrg_container__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__staffMemberManagement_departmentsList_DepartmentsList_container__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__staffMemberManagement_departmentDetails_DepartmentDetails_container__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__applicantAccreditationsManagement_certifiedAccreditationsList_CertifiedAccreditationsList_container__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__applicantAccreditationsManagement_pendingAccreditationsList_PendingAccreditationsList_container__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__applicantAccreditationsManagement_validatePendingAccreditation_ValidatePendingAccreditation_container__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__applicantAccreditationsManagement_VIDsList_VIDsList_container__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__organizationManagement_registerOrgByAnchor_RegisterOrgByAnchor_container__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__accountManagement_createAccount_CreateAccount_container__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__organizationManagement_orgSettings_OrgSettings_container__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__consentManagement_credentialsVerificationRequest_CredentialsVerificationRequest_container__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__consentManagement_consentsList_pendingConsentsList_PendingConsentsList_container__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__consentManagement_approveConsentAfterRequest_ApproveConsentAfterRequest_container__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__organizationConsentManagement_consentRequestsList_ConsentRequestsList_container__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__consentManagement_consentsList_priorConsentsList_PriorConsentsList_container__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__consentManagement_priorConsentDetails_AddPriorConsent_container__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__consentManagement_priorConsentDetails_EditPriorConsent_container__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__consentManagement_consentsList_historyConsentsList_HistoryConsentsList_container__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__selfStudyManagement_selfStudyList_SelfStudyList_container__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__selfStudyManagement_selfStudyDetails_SelfStudyAdd_container__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__selfStudyManagement_selfStudyDetails_SelfStudyEdit_container__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__consentManagement_bulkConsentRequestsList_BulkConsentRequestsList_container__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__commonComponents_collapseWithArrow_CollapseWithArrow__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__applicantAccreditationsManagement_createAccreditationRequest_CreateAccreditationRequest_container__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__applicantAccreditationsManagement_accreditationRequestsList_AccreditationRequestsList_conatiner__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__applicantAccreditationsManagement_editAccreditationRequest_EditAccreditationRequest_container__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__accreditationManagement_accreditationRequestsByDomainsList_PendingAccreditationRequestsByDomainsList_container__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__accreditationManagement_accreditationRequestsByGroupList_AccreditationRequestsByGroupList_container__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__accreditationManagement_pendingAccreditationRequestsList_PendingAccreditationRequestsList_container__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__accreditationManagement_processAccreditationRequest_ProcessAccreditationRequest_container__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__staffMemberManagement_groupsManagement_GroupsManagementComponent_container__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__consentManagement_currentConsents_CurrentConsents__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__securityManagement_anchorSecurityComponent_AnchorSecurityComponent_container__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__securityManagement_insertorSecurityComponent_InsertorSecurityComponent_container__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__securityManagement_adminSecurityComponent_AdminSecurityComponent_container__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__organizationManagement_orgsPaymentsList_OrgsPaymentsList_container__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__organizationManagement_orgPaymentsDetails_OrgPaymentsDetails_container__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__assistantsManagement_assistantsList_AssistantsList_container__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__assistantsManagement_addAssistantComponent_AddAssistantComponent_container__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__businessAmbassadorsManagement_businessAmbassadorsList_BusinessAmbassadorsList_container__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__businessAmbassadorsManagement_businessAmbassadorDetails_AddBusinessAmbassador_container__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__businessAmbassadorsManagement_businessAmbassadorDetails_EditBusinessAmbassador_container__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__paymentManagement_commissionsList_CommissionsList_container__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__paymentManagement_commissionDetails_AddCommission_container__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__paymentManagement_commissionDetails_EditCommission_container__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__paymentManagement_systemPaymentComponent_duePaymentsComponent_DuePaymentsComponent_container__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__paymentManagement_systemPaymentComponent_paymentsHistoryComponent_PaymentsHistoryComponent_container__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__accreditationManagement_validatedDomainsList_ValidatedDomainsList_container__ = __webpack_require__(1175);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.redirectToMainPage=function(){_this.props.history.push("/home");};_this.refreshPage=function(){_this.props.history.go(0);_this.props.onRefreshForbidden();};_this.renderMantra=function(){var className='mantra-container';if(_this.props.isAuthorised&&_this.props.location.pathname!=="/home"&&_this.props.location.pathname!=="/login"){className+=' hidden';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mantra',alt:'',src:__WEBPACK_IMPORTED_MODULE_13__mantra_png___default.a}));};_this.renderCollapse=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["i" /* Collapse */],{className:'app-collapse',isOpen:_this.state.collapsed,navbar:true},_this.renderNavs());};_this.renderNavs=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["y" /* Nav */],{className:'mr-auto',hidden:!_this.props.isAuthorised||_this.props.location.pathname==="/home"},_this.getNavItems()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["y" /* Nav */],{className:'nav-with-dropdown',hidden:_this.props.isAuthorised},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* NavItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["A" /* NavLink */],{tag:__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],to:'/support',onClick:_this.closeCollapse},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.help_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["y" /* Nav */],{className:'nav-with-nav-items',hidden:_this.props.isAuthorised},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* NavItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["A" /* NavLink */],{tag:__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],to:'/support',onClick:_this.closeCollapse},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.help_label')))),_this.renderUserMenu(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["y" /* Nav */],{className:'ml-auto language-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__languageSelector_LanguageSelector_container__["a" /* default */],null))));};_this.renderUserMenu=function(){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["y" /* Nav */],{key:'nav-with-dropdown',className:'nav-with-dropdown',hidden:!_this.props.isAuthorised},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["P" /* UncontrolledDropdown */],{className:'account-dropdown',nav:true,inNavbar:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* DropdownToggle */],{nav:true,caret:true,title:_this.props.userEmail},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'person-icon',icon:'person'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'user-email'},_this.props.userEmail)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["k" /* DropdownMenu */],{right:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["j" /* DropdownItem */],{key:'account',tag:__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],to:'/account'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'account_management.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["j" /* DropdownItem */],{tag:'a',target:'_blank',href:'http://brainchainmission.org/user-forum-2'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.help_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["j" /* DropdownItem */],{divider:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["j" /* DropdownItem */],{onClick:_this.onLogOut,tag:__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],to:'/login'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.log_out_button'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["y" /* Nav */],{key:'nav-with-nav-items',className:'nav-with-nav-items',hidden:!_this.props.isAuthorised},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-items-divider'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* NavItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["A" /* NavLink */],{tag:__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],to:'/account',activeClassName:'active',onClick:_this.closeCollapse},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'account_management.label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* NavItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["A" /* NavLink */],{target:'_blank',href:'http://brainchainmission.org/user-forum-2',onClick:_this.closeCollapse},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.help_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-items-divider'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* NavItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["A" /* NavLink */],{onClick:_this.onLogOut,tag:__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],to:'/login'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.log_out_button'))))];};_this.getNavItems=function(){var params=_this.getNavItemsParams();if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(params)){return null;}var result=[];params.forEach(function(elem,id){switch(elem.type){case"DROPDOWN":if(elem.hidden){break;}result.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["P" /* UncontrolledDropdown */],{className:'dropdown-in-nav',nav:true,inNavbar:true,key:"dropdown"+id,setActiveFromChild:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* DropdownToggle */],{nav:true,caret:true},elem.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["k" /* DropdownMenu */],{right:true},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(elem.children,function(child,childId){if(child.hidden){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["j" /* DropdownItem */],{key:childId,tag:__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],to:child.to,active:_this.props.location.pathname===child.to},child.title);}))));result.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_70__commonComponents_collapseWithArrow_CollapseWithArrow__["a" /* default */],{title:elem.title,className:'nav-item-with-collapse',key:"collapse"+id},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(elem.children,function(child,childId){if(child.hidden){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* NavItem */],{key:childId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["A" /* NavLink */],{tag:__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],to:child.to,activeClassName:'active',onClick:_this.closeCollapse},child.title));})));break;case"NAV":if(!elem.hidden){result.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* NavItem */],{key:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["A" /* NavLink */],{tag:__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],to:elem.to,activeClassName:'active',onClick:_this.closeCollapse},elem.title)));}break;default:break;}});return result;};_this.getNavItemsParams=function(){switch(_this.props.role){case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["b" /* ROLES */].SYS_ADMIN:return[{type:"DROPDOWN",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.organizations_select_button'),children:[{to:"/register-org",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.register_org_shirt_page_button'),hidden:!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.includes(_this.props.subRoles,__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].FA)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.includes(_this.props.subRoles,__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)},{to:"/organizations",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.orgs_shirt_page_button')},{to:"/validate-organizations",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.validate_organizations_shirt_page_button')},{to:"/security",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.security_page_button'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].PA)}]},{type:"DROPDOWN",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.domains_page_button'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].PA),children:[{to:"/validated-domains",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.validated_accreditation_requests_by_domain_shirt_page_button')},{to:"/pending-accreditation-requests-by-domains",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.pending_accreditation_requests_by_domain_shirt_page_button')}]},{type:"DROPDOWN",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.assistants_page_button'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT),children:[{type:"NAV",to:"/assistants-management",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.assistants_page_button'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)},{type:"NAV",to:"/business-ambassadors",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.business_ambassadors_page_button'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)}]},{type:"DROPDOWN",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.system_payment_select_button'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].FA),children:[{to:"/commissions",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.commissions_list_page_button'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)},{to:"/organizations-payments",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.orgs_payments_page_button'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].FA)},{to:"/due-payments",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.due_payments_page_button')},{to:"/payments-history",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.payments_history_shirt_page_button')}]}];case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["b" /* ROLES */].EMPLOYEE:switch(_this.props.subRole){case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["a" /* NO_SUB_ROLES */]:return null;case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ANCHOR:return[{type:"DROPDOWN",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.organization_select_button'),children:[{to:"/org-settings",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.org_management_button')},{to:"/organization-staff",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.staff_members_page_button')},{to:"/payment",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.payment_label')},{to:"/groups-management",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.departments_page_button'),hidden:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.orgPermissions)||_this.props.orgPermissions.hasIVs},{to:"/groups-management",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.groups_management_page_button'),hidden:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.orgPermissions)||!_this.props.orgPermissions.hasIVs},{to:"/security",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.security_page_button'),hidden:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.orgPermissions)||!_this.props.orgPermissions.hasIVs}]},{type:"NAV",to:"/accreditation-requests-by-group",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.accreditation_requests_list_page_button'),hidden:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.orgPermissions)||!_this.props.orgPermissions.hasIVs}];case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].INSERTER:return[{type:"DROPDOWN",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.inserter_accreditations_select_button'),children:[{to:"/insert-accreditation",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.insert_accreditation_shirt_page_button')},{to:"/review-accreditations",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.review_accreditations_shirt_page_button')},{to:"/bulk-accreditations-upload",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.bulk_jobs_list_shirt_page_button')},{to:"/pending-accreditation-requests",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.pending_accreditation_requests_page_button')},{to:"/security",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.security_page_button')}]}];case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].VALIDATOR:return[{type:"NAV",to:"/validate-accreditations",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.validate_accreditations_page_button')}];case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].BO:return[{type:"NAV",to:"/consent-requests",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.consent_requests_page_button')},{type:"NAV",to:"/bulk-consent-requests",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.bulk_consent_requests_page_button')}];case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].HM:return[{type:"NAV",to:"/credentials-verification-request",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.verification_request_page_button')},{type:"NAV",to:"/consent-requests",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.consent_requests_page_button')},{type:"NAV",to:"/bulk-consent-requests",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.bulk_consent_requests_page_button')}];default:break;}break;case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["b" /* ROLES */].APPLICANT:return[{type:"DROPDOWN",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.applicant_accreditations_select_button'),children:[{to:"/certified-accreditations",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.certified_accreditations_page_button')},{to:"/pending-accreditations",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.pending_accreditations_page_button')},{to:"/verified-identities",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.vids_page_button')},{to:"/accreditation-requests-list",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.accreditation_requests_list_page_button')}]},{type:"DROPDOWN",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.applicant_consents_select_button'),children:[{to:"/pending-consents",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.pending_consents_page_button')},{to:"/active-consents",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.active_consents_page_button')},{to:"/prior-consents",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.prior_consents_page_button')},{to:"/consents-history",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.consents_history_page_button')}]},{type:"NAV",to:"/self-study-books",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'main.self_study_books_page_button')}];default:break;}};_this.getCommonRoutes=function(){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'home',exact:true,path:'/home',render:_this.renderAuthorisedView('home')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'account',exact:true,path:'/account',render:_this.renderAuthorisedView("account")})];};_this.getRoutes=function(){switch(_this.props.role){case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["b" /* ROLES */].SYS_ADMIN:return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'organizations',exact:true,path:'/organizations',render:_this.renderAuthorisedView("organizations")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'validate-organizations',exact:true,path:'/validate-organizations',render:_this.renderAuthorisedView("validate-organizations")}),!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.includes(_this.props.subRoles,__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].FA)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.includes(_this.props.subRoles,__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'register-org',exact:true,path:'/register-org',render:_this.renderAuthorisedView("register-org")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'organization',exact:true,path:'/organization',render:_this.renderAuthorisedView("organization")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'validate-organization',exact:true,path:'/validate-organization',render:_this.renderAuthorisedView("validate-organization")}),/*!this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.PA) ? null :
                        <Route
                            key="validated-accreditation-requests-by-domains"
                            exact
                            path="/validated-accreditation-requests-by-domains"
                            render={this.renderAuthorisedView("validated-accreditation-requests-by-domains")}
                        />,*/!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].PA)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'pending-accreditation-requests-by-domains',exact:true,path:'/pending-accreditation-requests-by-domains',render:_this.renderAuthorisedView("pending-accreditation-requests-by-domains")}),!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].PA)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'security',exact:true,path:'/security',render:_this.renderAuthorisedView("security")}),!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].FA)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'organizations-payments',exact:true,path:'/organizations-payments',render:_this.renderAuthorisedView("organizations-payments")}),!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].FA)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'organization-payments',exact:true,path:'/organization-payments',render:_this.renderAuthorisedView("organization-payments")}),!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'assistants-management',exact:true,path:'/assistants-management',render:_this.renderAuthorisedView("assistants-management")}),!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'add-assistant',exact:true,path:'/add-assistant',render:_this.renderAuthorisedView("add-assistant")}),!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'business-ambassadors',exact:true,path:'/business-ambassadors',render:_this.renderAuthorisedView("business-ambassadors")}),!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'add-business-ambassador',exact:true,path:'/add-business-ambassador',render:_this.renderAuthorisedView("add-business-ambassador")}),!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'edit-business-ambassador',exact:true,path:'/edit-business-ambassador',render:_this.renderAuthorisedView("edit-business-ambassador")}),!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'commissions',exact:true,path:'/commissions',render:_this.renderAuthorisedView("commissions")}),!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'add-commission',exact:true,path:'/add-commission',render:_this.renderAuthorisedView("add-commission")}),!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'edit-commission',exact:true,path:'/edit-commission',render:_this.renderAuthorisedView("edit-commission")}),!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].FA)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'due-payments',exact:true,path:'/due-payments',render:_this.renderAuthorisedView("due-payments")}),!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].FA)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'payments-history',exact:true,path:'/payments-history',render:_this.renderAuthorisedView("payments-history")}),!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].PA)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'validated-domains',exact:true,path:'/validated-domains',render:_this.renderAuthorisedView("validated-domains")})].concat(_toConsumableArray(_this.getCommonRoutes()));case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["b" /* ROLES */].EMPLOYEE:switch(_this.props.subRole){case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["a" /* NO_SUB_ROLES */]:return[].concat(_toConsumableArray(_this.getCommonRoutes()));case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ANCHOR:return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'organization-staff',exact:true,path:'/organization-staff',render:_this.renderAuthorisedView("organization-staff")}),!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.orgPermissions)&&_this.props.orgPermissions.hasIVs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'accreditation-group',exact:true,path:'/accreditation-group',render:_this.renderAuthorisedView("accreditation-group")}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'payment',exact:true,path:'/payment',render:_this.renderAuthorisedView("payment")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'department',exact:true,path:'/department',render:_this.renderAuthorisedView("department")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'org-settings',exact:true,path:'/org-settings',render:_this.renderAuthorisedView("org-settings")}),!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.orgPermissions)&&_this.props.orgPermissions.hasIVs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'accreditation-requests-by-group',exact:true,path:'/accreditation-requests-by-group',render:_this.renderAuthorisedView("accreditation-requests-by-group")}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'groups-management',exact:true,path:'/groups-management',render:_this.renderAuthorisedView("groups-management")}),!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.orgPermissions)&&_this.props.orgPermissions.hasIVs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'security',exact:true,path:'/security',render:_this.renderAuthorisedView("security")}):null].concat(_toConsumableArray(_this.getCommonRoutes()));case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].INSERTER:return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'insert-accreditation',exact:true,path:'/insert-accreditation',render:_this.renderAuthorisedView("insert-accreditation")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'review-accreditations',exact:true,path:'/review-accreditations',render:_this.renderAuthorisedView("review-accreditations")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'review-accreditation/validator',exact:true,path:'/review-accreditation/validator',render:_this.renderAuthorisedView("review-accreditation-rejected-by-validator")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'review-accreditation/applicant',exact:true,path:'/review-accreditation/applicant',render:_this.renderAuthorisedView("review-accreditation-rejected-by-applicant")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'bulk-accreditations-upload',exact:true,path:'/bulk-accreditations-upload',render:_this.renderAuthorisedView("bulk-accreditations-upload")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'bulk-accreditations-upload-format-details',exact:true,path:'/bulk-accreditations-upload/format-details',render:_this.renderAuthorisedView("bulk-accreditations-upload-format-details")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'pending-accreditation-requests',exact:true,path:'/pending-accreditation-requests',render:_this.renderAuthorisedView("pending-accreditation-requests")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'process-accreditation-requests',exact:true,path:'/process-accreditation-requests',render:_this.renderAuthorisedView("process-accreditation-requests")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'security',exact:true,path:'/security',render:_this.renderAuthorisedView("security")})].concat(_toConsumableArray(_this.getCommonRoutes()));case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].VALIDATOR:return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'validate-accreditations',exact:true,path:'/validate-accreditations',render:_this.renderAuthorisedView("validate-accreditations")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'validate-accreditation',exact:true,path:'/validate-accreditation',render:_this.renderAuthorisedView("validate-accreditation")})].concat(_toConsumableArray(_this.getCommonRoutes()));case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].HM:return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'credentials-verification-request',exact:true,path:'/credentials-verification-request',render:_this.renderAuthorisedView("credentials-verification-request")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'consent-requests',exact:true,path:'/consent-requests',render:_this.renderAuthorisedView("consent-requests")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'bulk-consent-requests',exact:true,path:'/bulk-consent-requests',render:_this.renderAuthorisedView("bulk-consent-requests")})].concat(_toConsumableArray(_this.getCommonRoutes()));case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].BO:return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'consent-requests',exact:true,path:'/consent-requests',render:_this.renderAuthorisedView("consent-requests")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'bulk-consent-requests',exact:true,path:'/bulk-consent-requests',render:_this.renderAuthorisedView("bulk-consent-requests")})].concat(_toConsumableArray(_this.getCommonRoutes()));default:break;}break;case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["b" /* ROLES */].APPLICANT:return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'certified-accreditations',exact:true,path:'/certified-accreditations',render:_this.renderAuthorisedView("certified-accreditations")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'pending-accreditations',exact:true,path:'/pending-accreditations',render:_this.renderAuthorisedView("pending-accreditations")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'validate-pending-accreditation',exact:true,path:'/validate-pending-accreditation',render:_this.renderAuthorisedView("validate-pending-accreditation")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'verified-identities',exact:true,path:'/verified-identities',render:_this.renderAuthorisedView("verified-identities")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'pending-consents',exact:true,path:'/pending-consents',render:_this.renderAuthorisedView("pending-consents")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'approve-consent',exact:true,path:'/approve-consent',render:_this.renderAuthorisedView("approve-consent")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'active-consents',exact:true,path:'/active-consents',render:_this.renderAuthorisedView("active-consents")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'prior-consents',exact:true,path:'/prior-consents',render:_this.renderAuthorisedView("prior-consents")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'add-prior-consent',exact:true,path:'/add-prior-consent',render:_this.renderAuthorisedView("add-prior-consent")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'edit-prior-consent',exact:true,path:'/edit-prior-consent',render:_this.renderAuthorisedView("edit-prior-consent")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'consents-history',exact:true,path:'/consents-history',render:_this.renderAuthorisedView("consents-history")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'self-study-books',exact:true,path:'/self-study-books',render:_this.renderAuthorisedView("self-study-books")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'add-self-study-book',exact:true,path:'/add-self-study-book',render:_this.renderAuthorisedView("add-self-study-book")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'edit-self-study-book',exact:true,path:'/edit-self-study-book',render:_this.renderAuthorisedView("edit-self-study-book")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'create-accreditation-request',exact:true,path:'/create-accreditation-request',render:_this.renderAuthorisedView("create-accreditation-request")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'accreditation-requests-list',exact:true,path:'/accreditation-requests-list',render:_this.renderAuthorisedView("accreditation-requests-list")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{key:'edit-accreditation-request',exact:true,path:'/edit-accreditation-request',render:_this.renderAuthorisedView("edit-accreditation-request")})].concat(_toConsumableArray(_this.getCommonRoutes()));default:break;}};_this.onLogOut=function(){_this.redirectPathAfterLogin=null;_this.props.onLogOut();};_this.renderLoginView=function(view){return function(){if(!_this.props.isAuthorised){switch(view){case'login':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__accountManagement_login_Login_container__["a" /* default */],null);case'restore':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__accountManagement_restoreAccount_RestoreAccount_container__["a" /* default */],null);case'company-registration':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_55__organizationManagement_registerOrgByAnchor_RegisterOrgByAnchor_container__["a" /* default */],null));case'account-creation':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_56__accountManagement_createAccount_CreateAccount_container__["a" /* default */],null));case'resend-activation':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__accountManagement_resendActivation_ResendActivation_container__["a" /* default */],null));default:return _this.renderPageNotFound();}}else{return _this.getMainPage();}};};_this.renderRegistrationView=function(_ref){var location=_ref.location;var pathParams=__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search);if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(pathParams)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__accountManagement_registerApplicant_RegisterApplicant_container__["a" /* default */],null));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__accountManagement_registerInvitedApplicant_RegisterInvitedApplicant_container__["a" /* default */],{location:location}));}};_this.renderHelpView=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__commonComponents_helpComponent_HelpComponent_container__["a" /* default */],null));};_this.renderAuthorisedView=function(view){return function(_ref2){var location=_ref2.location;if(!_this.props.isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:'/login'});}if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(view)){return _this.getMainPage();}switch(view){case"home":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_homePage_HomePage_container__["a" /* default */],null);case"account":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__accountManagement_accountManagementComponent_AccountManagementComponent_container__["a" /* default */],{location:location});case"payment":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__commonComponents_paymentComponent_PaymentComponent_container__["a" /* default */],null));case"organizations":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__organizationManagement_orgsList_OrgsList_container__["a" /* default */],null));case"validate-organizations":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47__organizationManagement_orgsListToValidate_OrgsToValidateList_container__["a" /* default */],null));case"register-org":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__organizationManagement_registerOrg_RegisterOrg_container__["a" /* default */],null));case"organization-staff":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__staffMemberManagement_staffList_StaffList_container__["a" /* default */],null));case"accreditation-groups":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},_this.renderPermissionsWarning(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__staffMemberManagement_AccreditationGroupsList_AccreditationGroupsList_container__["a" /* default */],null));case"accreditation-group":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},_this.renderPermissionsWarning(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__staffMemberManagement_AccreditationGroupDetails_AccreditationGroupDetails_container__["a" /* default */],{location:location}));case"department":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_50__staffMemberManagement_departmentDetails_DepartmentDetails_container__["a" /* default */],{location:location}));case"insert-accreditation":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},_this.renderPermissionsWarning(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__accreditationManagement_insertAccreditation_InsertAccreditation_container__["a" /* default */],null));case"validate-accreditations":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},_this.renderPermissionsWarning(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__accreditationManagement_accreditationsList_AccreditationsListForValidate_container__["a" /* default */],null));case"validate-accreditation":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},_this.renderPermissionsWarning(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__accreditationManagement_validateAccreditation_ValidateAccreditation_container__["a" /* default */],null));case"review-accreditations":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},_this.renderPermissionsWarning(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__accreditationManagement_rejectedAccreditationsManagementComponent_RejectedAccreditationsManagementComponent_container__["a" /* default */],null));case"review-accreditation-rejected-by-validator":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},_this.renderPermissionsWarning(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__accreditationManagement_reviewAccreditation_ReviewAccreditationRejectedByValidator_container__["a" /* default */],null));case"review-accreditation-rejected-by-applicant":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},_this.renderPermissionsWarning(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__accreditationManagement_reviewAccreditation_ReviewAccreditationRejectedByApplicant_container__["a" /* default */],null));case"bulk-accreditations-upload":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__accreditationManagement_bulkJobsList_BulkJobsList_container__["a" /* default */],null));case"bulk-accreditations-upload-format-details":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46__commonComponents_bulkFileFormatDetails_BulkFileFormatDetails_container__["a" /* default */],null));case"organization":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__organizationManagement_orgDetails_OrgDetails_container__["a" /* default */],{location:location}));case"validate-organization":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__organizationManagement_orgModal_validateOrg_ValidateOrg_container__["a" /* default */],null));case"certified-accreditations":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_51__applicantAccreditationsManagement_certifiedAccreditationsList_CertifiedAccreditationsList_container__["a" /* default */],null));case"pending-accreditations":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52__applicantAccreditationsManagement_pendingAccreditationsList_PendingAccreditationsList_container__["a" /* default */],null));case"validate-pending-accreditation":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_53__applicantAccreditationsManagement_validatePendingAccreditation_ValidatePendingAccreditation_container__["a" /* default */],{location:location}));case"verified-identities":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_54__applicantAccreditationsManagement_VIDsList_VIDsList_container__["a" /* default */],null));case"org-settings":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__organizationManagement_orgSettings_OrgSettings_container__["a" /* default */],null));case"consent-requests":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_61__organizationConsentManagement_consentRequestsList_ConsentRequestsList_container__["a" /* default */],null);case"credentials-verification-request":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_58__consentManagement_credentialsVerificationRequest_CredentialsVerificationRequest_container__["a" /* default */],null));case"pending-consents":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_59__consentManagement_consentsList_pendingConsentsList_PendingConsentsList_container__["a" /* default */],null));case"approve-consent":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_60__consentManagement_approveConsentAfterRequest_ApproveConsentAfterRequest_container__["a" /* default */],null));case"active-consents":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_79__consentManagement_currentConsents_CurrentConsents__["a" /* default */],null));case"prior-consents":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__consentManagement_consentsList_priorConsentsList_PriorConsentsList_container__["a" /* default */],null));case"add-prior-consent":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_63__consentManagement_priorConsentDetails_AddPriorConsent_container__["a" /* default */],null));case"edit-prior-consent":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_64__consentManagement_priorConsentDetails_EditPriorConsent_container__["a" /* default */],{location:location}));case"self-study-books":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_66__selfStudyManagement_selfStudyList_SelfStudyList_container__["a" /* default */],null));case"add-self-study-book":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_67__selfStudyManagement_selfStudyDetails_SelfStudyAdd_container__["a" /* default */],null));case"edit-self-study-book":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_68__selfStudyManagement_selfStudyDetails_SelfStudyEdit_container__["a" /* default */],{location:location}));case"consents-history":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_65__consentManagement_consentsList_historyConsentsList_HistoryConsentsList_container__["a" /* default */],null));case"bulk-consent-requests":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_69__consentManagement_bulkConsentRequestsList_BulkConsentRequestsList_container__["a" /* default */],null));case"create-accreditation-request":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_71__applicantAccreditationsManagement_createAccreditationRequest_CreateAccreditationRequest_container__["a" /* default */],null));case"accreditation-requests-list":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__applicantAccreditationsManagement_accreditationRequestsList_AccreditationRequestsList_conatiner__["a" /* default */],null));case"edit-accreditation-request":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_73__applicantAccreditationsManagement_editAccreditationRequest_EditAccreditationRequest_container__["a" /* default */],{location:location}));case"pending-accreditation-requests-by-domains":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_74__accreditationManagement_accreditationRequestsByDomainsList_PendingAccreditationRequestsByDomainsList_container__["a" /* default */],null));case"accreditation-requests-by-group":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_75__accreditationManagement_accreditationRequestsByGroupList_AccreditationRequestsByGroupList_container__["a" /* default */],null));case"pending-accreditation-requests":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_76__accreditationManagement_pendingAccreditationRequestsList_PendingAccreditationRequestsList_container__["a" /* default */],null));case"process-accreditation-requests":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_77__accreditationManagement_processAccreditationRequest_ProcessAccreditationRequest_container__["a" /* default */],null));case"commissions":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_90__paymentManagement_commissionsList_CommissionsList_container__["a" /* default */],null));case"add-commission":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_91__paymentManagement_commissionDetails_AddCommission_container__["a" /* default */],null));case"edit-commission":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_92__paymentManagement_commissionDetails_EditCommission_container__["a" /* default */],{location:location}));case"due-payments":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_93__paymentManagement_systemPaymentComponent_duePaymentsComponent_DuePaymentsComponent_container__["a" /* default */],null));case"payments-history":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_94__paymentManagement_systemPaymentComponent_paymentsHistoryComponent_PaymentsHistoryComponent_container__["a" /* default */],null));case"groups-management":if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.orgPermissions)&&_this.props.orgPermissions.hasIVs){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_78__staffMemberManagement_groupsManagement_GroupsManagementComponent_container__["a" /* default */],null));}if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.orgPermissions)&&!_this.props.orgPermissions.hasIVs){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_49__staffMemberManagement_departmentsList_DepartmentsList_container__["a" /* default */],null));}return _this.renderPageNotFound();case"security":if(_this.props.role===__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["b" /* ROLES */].SYS_ADMIN){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_82__securityManagement_adminSecurityComponent_AdminSecurityComponent_container__["a" /* default */],null));}else if(_this.props.role===__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["b" /* ROLES */].EMPLOYEE){switch(_this.props.subRole){case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ANCHOR:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_80__securityManagement_anchorSecurityComponent_AnchorSecurityComponent_container__["a" /* default */],null));case __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].INSERTER:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_81__securityManagement_insertorSecurityComponent_InsertorSecurityComponent_container__["a" /* default */],null));default:break;}}return _this.renderPageNotFound();case"organizations-payments":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_83__organizationManagement_orgsPaymentsList_OrgsPaymentsList_container__["a" /* default */],null));case"organization-payments":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_84__organizationManagement_orgPaymentsDetails_OrgPaymentsDetails_container__["a" /* default */],{location:location}));case"assistants-management":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_85__assistantsManagement_assistantsList_AssistantsList_container__["a" /* default */],null));case"add-assistant":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_86__assistantsManagement_addAssistantComponent_AddAssistantComponent_container__["a" /* default */],null));case"business-ambassadors":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_87__businessAmbassadorsManagement_businessAmbassadorsList_BusinessAmbassadorsList_container__["a" /* default */],null));case"add-business-ambassador":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_88__businessAmbassadorsManagement_businessAmbassadorDetails_AddBusinessAmbassador_container__["a" /* default */],null));case"edit-business-ambassador":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_89__businessAmbassadorsManagement_businessAmbassadorDetails_EditBusinessAmbassador_container__["a" /* default */],{location:location}));case"validated-domains":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_95__accreditationManagement_validatedDomainsList_ValidatedDomainsList_container__["a" /* default */],null));default:return _this.renderPageNotFound();}};};_this.renderActivationView=function(_ref3){var location=_ref3.location;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__accountManagement_activateUserAccount_ActivateUserAccount_container__["a" /* default */],{location:location}));};_this.renderResetPasswordView=function(_ref4){var location=_ref4.location;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__accountManagement_resetPassword_ResetPassword_container__["a" /* default */],{location:location});};_this.renderChangeEmailView=function(_ref5){var location=_ref5.location;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__accountManagement_changeEmailFinish_ChangeEmailFinish_container__["a" /* default */],{location:location});};_this.getMainPage=function(){if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.redirectPathAfterLogin)&&_this.props.location.pathname==="/login"){var redirectPath=_this.redirectPathAfterLogin;_this.redirectPathAfterLogin=null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:redirectPath});}if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.role)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}return _this.props.location.pathname!=="/home"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:'/home'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_homePage_HomePage_container__["a" /* default */],null);};_this.renderPermissionsWarning=function(){return null;// if (!_.isNil(this.props.orgPermissions) && !this.props.orgPermissions.hasIVs) {
//     return (
//         <Alert color="warning">{_.get(this.props.translation, 'main.limit_access_label')}</Alert>
//     )
// }
};_this.renderPageNotFound=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__commonComponents_pageNotFoundComponent_PageNotFoundComponent_container__["a" /* default */],null));};_this.handleNavbarTogglerClick=function(){_this.setState({collapsed:!_this.state.collapsed});};_this.closeCollapse=function(){_this.setState({collapsed:false});};_this.redirectPathAfterLogin=null;_this.state={collapsed:false};return _this;}_createClass(App,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;if(this.props.location.pathname==='/activation'||this.props.location.pathname==='/resetPassword'||this.props.location.pathname==='/changeEmail'||this.props.location.pathname==='/applicant-registration'){this.onLogOut();}else if(__WEBPACK_IMPORTED_MODULE_8__utils_storageApi__["a" /* StorageApi */].isLoginTokenAvailable()){this.props.onSetUser();}if(this.props.location.pathname!=='/activation'&&this.props.location.pathname!=='/resetPassword'&&this.props.location.pathname!=='/changeEmail'&&this.props.location.pathname!=='/applicant-registration'&&this.props.location.pathname!=="/login"&&this.props.location.pathname!=="/login/restore"){this.redirectPathAfterLogin=this.props.location.pathname;}this.unlisten=this.props.history.listen(function(location){if(location.pathname!=='/login'&&location.pathname!=='/activation'&&location.pathname!=='/resetPassword'&&location.pathname!=='/applicant-registration'){if(_this2.props.subRole===__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["c" /* SUB_ROLES */].ANCHOR){_this2.props.onGetOrgBalance();}var userId=__WEBPACK_IMPORTED_MODULE_8__utils_storageApi__["a" /* StorageApi */].getUserId();if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(userId)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this2.props.userId)&&_this2.props.userId!==userId){_this2.refreshPage();}}if(location.pathname==='/activation'||location.pathname==='/resetPassword'||location.pathname==='/applicant-registration'){_this2.onLogOut();}});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.unlisten();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.isForbidden){this.refreshPage();}if(nextProps.isAuthorised!==this.props.isAuthorised){this.setState({collapsed:false});}}},{key:'render',value:function render(){if(this.props.location.pathname==="/oauth/authorize"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["B" /* Navbar */],{color:'dark',dark:true,expand:'md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["C" /* NavbarBrand */],{tag:__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],to:this.props.isAuthorised?"/home":"/login",target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'logo',alt:'',src:__WEBPACK_IMPORTED_MODULE_11__Logo_png___default.a,title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'main.home_page_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["y" /* Nav */],{className:'ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__languageSelector_LanguageSelector_container__["a" /* default */],null)),this.renderMantra()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__accountManagement_oauthUserLogin_OAuthUserLogin_container__["a" /* default */],{location:this.props.location}));}//TODO: check & fix all components layouts
//TODO: fix incorrect using of bootstrap layout (the content should not get out of the container)
if(this.props.isServerError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__commonComponents_serverErrorComponent_ServerErrorComponent_container__["a" /* default */],null));}if(this.props.isForbidden||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.translation)){return null;}if(this.props.loadingUserData||this.props.loadingOrganizationData||this.props.loadingTranslation){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["B" /* Navbar */],{color:'dark',dark:true,className:'navbar-expand-custom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["C" /* NavbarBrand */],{tag:__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],to:this.props.isAuthorised?"/home":"/login"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'logo',alt:'',src:__WEBPACK_IMPORTED_MODULE_11__Logo_png___default.a,title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'main.home_page_label')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'logo-sm',alt:'',src:__WEBPACK_IMPORTED_MODULE_12__logo_sm_png___default.a,title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'main.home_page_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["y" /* Nav */],{className:'ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__languageSelector_LanguageSelector_container__["a" /* default */],null)),this.renderMantra()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loading-app-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["M" /* Spinner */],{color:'secondary',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["B" /* Navbar */],{color:'dark',dark:true,className:'navbar-expand-custom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["C" /* NavbarBrand */],{tag:__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],to:this.props.isAuthorised?"/home":"/login"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'logo',alt:'',src:__WEBPACK_IMPORTED_MODULE_11__Logo_png___default.a,title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'main.home_page_label')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'logo-sm',alt:'',src:__WEBPACK_IMPORTED_MODULE_12__logo_sm_png___default.a,title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'main.home_page_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["y" /* Nav */],{className:'ml-auto language-select-with-collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__languageSelector_LanguageSelector_container__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["D" /* NavbarToggler */],{onClick:this.handleNavbarTogglerClick}),this.renderCollapse(),this.renderMantra()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__navBarWithRoles_NavBarWithRoles_container__["a" /* default */],{hidden:!this.props.isAuthorised||this.props.location.pathname==="/home"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],{key:'router-switch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/login',render:this.renderLoginView('login')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/activation',render:this.renderActivationView}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/login/restore',render:this.renderLoginView('restore')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/resetPassword',render:this.renderResetPasswordView}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/changeEmail',render:this.renderChangeEmailView}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/resend-activation',render:this.renderLoginView('resend-activation')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/account-creation',render:this.renderLoginView('account-creation')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/applicant-registration',render:this.renderRegistrationView}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/company-registration',render:this.renderLoginView('company-registration')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/support',render:this.renderHelpView}),this.getRoutes(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/',render:this.renderAuthorisedView()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commonComponents_userSubRoleMissingModal_UserSubRoleMissingModal_container__["a" /* default */],{onSubmit:this.redirectToMainPage,updateSubRolesOnly:this.props.location.pathname==="/home"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__commonComponents_orgPermissionsMissingModal_OrgPermissionsMissingModal_container__["a" /* default */],{onSubmit:this.redirectToMainPage}));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);App.propTypes={isAuthorised:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,role:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,subRole:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,userId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,userEmail:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,orgPermissions:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,onLogOut:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,translation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,loadingTranslation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,loadingUserData:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,loadingOrganizationData:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,isForbidden:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,onRefreshForbidden:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,isServerError:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,subRoles:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,onGetOrgBalance:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onSetUser:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(169);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(251);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(251);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(168);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(169);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(510);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(170);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(252);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(514);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(516);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(256);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(518);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(170);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(520);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(171);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(256);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(171);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(524);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(254);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  fluid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var Container = function Container(props) {
  var className = props.className,
      cssModule = props.cssModule,
      fluid = props.fluid,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "fluid", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, fluid ? 'container-fluid' : 'container'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Container);

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isFunction;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  noGutters: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  form: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
var defaultProps = {
  tag: 'div'
};

var Row = function Row(props) {
  var className = props.className,
      cssModule = props.cssModule,
      noGutters = props.noGutters,
      Tag = props.tag,
      form = props.form,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "noGutters", "tag", "form"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, noGutters ? 'no-gutters' : null, form ? 'form-row' : 'row'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Row);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isobject__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);







var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var stringOrNumberProp = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]);
var columnProps = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  size: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
  push: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["j" /* deprecated */])(stringOrNumberProp, 'Please use the prop "order"'),
  pull: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["j" /* deprecated */])(stringOrNumberProp, 'Please use the prop "order"'),
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);
var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_6__utils__["t" /* tagPropType */],
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  widths: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array
};
var defaultProps = {
  tag: 'div',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : "col-" + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
  }

  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
};

var Col = function Col(props) {
  var className = props.className,
      cssModule = props.cssModule,
      widths = props.widths,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "widths", "tag"]);

  var colClasses = [];
  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];
    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;

    if (__WEBPACK_IMPORTED_MODULE_2_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
      var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
      colClasses.push(Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_5_classnames___default()((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames)), cssModule));
    } else {
      var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);

      colClasses.push(_colClass);
    }
  });

  if (!colClasses.length) {
    colClasses.push('col');
  }

  var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, colClasses), cssModule);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Col);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  light: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  dark: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  inverse: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["j" /* deprecated */])(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, 'Please use the prop "dark"'),
  full: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  fixed: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  sticky: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  role: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  toggleable: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["j" /* deprecated */])(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]), 'Please use the prop "expand"'),
  expand: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string])
};
var defaultProps = {
  tag: 'nav',
  expand: false
};

var getExpandClass = function getExpandClass(expand) {
  if (expand === false) {
    return false;
  } else if (expand === true || expand === 'xs') {
    return 'navbar-expand';
  }

  return "navbar-expand-" + expand;
}; // To better maintain backwards compatibility while toggleable is deprecated.
// We must map breakpoints to the next breakpoint so that toggleable and expand do the same things at the same breakpoint.


var toggleableToExpand = {
  xs: 'sm',
  sm: 'md',
  md: 'lg',
  lg: 'xl'
};

var getToggleableClass = function getToggleableClass(toggleable) {
  if (toggleable === undefined || toggleable === 'xl') {
    return false;
  } else if (toggleable === false) {
    return 'navbar-expand';
  }

  return "navbar-expand-" + (toggleable === true ? 'sm' : toggleableToExpand[toggleable] || toggleable);
};

var Navbar = function Navbar(props) {
  var _classNames;

  var toggleable = props.toggleable,
      expand = props.expand,
      className = props.className,
      cssModule = props.cssModule,
      light = props.light,
      dark = props.dark,
      inverse = props.inverse,
      fixed = props.fixed,
      sticky = props.sticky,
      color = props.color,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["toggleable", "expand", "className", "cssModule", "light", "dark", "inverse", "fixed", "sticky", "color", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'navbar', getExpandClass(expand) || getToggleableClass(toggleable), (_classNames = {
    'navbar-light': light,
    'navbar-dark': inverse || dark
  }, _classNames["bg-" + color] = color, _classNames["fixed-" + fixed] = fixed, _classNames["sticky-" + sticky] = sticky, _classNames)), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Navbar);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'a'
};

var NavbarBrand = function NavbarBrand(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'navbar-brand'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

NavbarBrand.propTypes = propTypes;
NavbarBrand.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavbarBrand);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
var defaultProps = {
  tag: 'button',
  type: 'button'
};

var NavbarToggler = function NavbarToggler(props) {
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "children", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'navbar-toggler'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }), children || __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])('navbar-toggler-icon', cssModule)
  }));
};

NavbarToggler.propTypes = propTypes;
NavbarToggler.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavbarToggler);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tabs: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  pills: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  vertical: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  horizontal: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  justified: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  fill: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  navbar: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  card: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'ul',
  vertical: false
};

var getVerticalClass = function getVerticalClass(vertical) {
  if (vertical === false) {
    return false;
  } else if (vertical === true || vertical === 'xs') {
    return 'flex-column';
  }

  return "flex-" + vertical + "-column";
};

var Nav = function Nav(props) {
  var className = props.className,
      cssModule = props.cssModule,
      tabs = props.tabs,
      pills = props.pills,
      vertical = props.vertical,
      horizontal = props.horizontal,
      justified = props.justified,
      fill = props.fill,
      navbar = props.navbar,
      card = props.card,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tabs", "pills", "vertical", "horizontal", "justified", "fill", "navbar", "card", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, navbar ? 'navbar-nav' : 'nav', horizontal ? "justify-content-" + horizontal : false, getVerticalClass(vertical), {
    'nav-tabs': tabs,
    'card-header-tabs': card && tabs,
    'nav-pills': pills,
    'card-header-pills': card && pills,
    'nav-justified': justified,
    'nav-fill': fill
  }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Nav);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  active: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'li'
};

var NavItem = function NavItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "active", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'nav-item', active ? 'active' : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dropdown__ = __webpack_require__(103);




function NavDropdown(props) {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils__["v" /* warnOnce */])('The "NavDropdown" component has been deprecated.\nPlease use component "Dropdown" with nav prop.');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    nav: true
  }, props));
}

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Manager.childContextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Manager.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Manager.defaultProps = {
  tag: 'div'
};


/* harmony default export */ __webpack_exports__["a"] = (Manager);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Target.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Target);

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_popper_js__ = __webpack_require__(258);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var placements = __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */].placements;

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      if (_this.props.target) {
        return _this.props.target;
      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
      }
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return _extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled,
          positionFixed = _props.positionFixed;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
          element: this._arrowNode
        });
      }
      this._popper = new __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */](this._getTargetNode(), this._popperNode, {
        placement: placement,
        positionFixed: positionFixed,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          positionFixed = _props2.positionFixed,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'positionFixed', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
    }
  }]);

  return Popper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Popper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Popper.childContextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Popper.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(placements),
  eventsEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  positionFixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
  // the following check is needed for SSR
  __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(typeof Element !== 'undefined' ? Element : Object), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    getBoundingClientRect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    clientWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    clientHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  positionFixed: false,
  modifiers: {}
};


/* harmony default export */ __webpack_exports__["a"] = (Popper);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Arrow.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Arrow);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["t" /* tagPropType */],
  innerRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
var defaultProps = {
  tag: 'a'
};

var NavLink =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(NavLink, _React$Component);

  function NavLink(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = NavLink.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.href === '#') {
      e.preventDefault();
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        active = _this$props.active,
        Tag = _this$props.tag,
        innerRef = _this$props.innerRef,
        attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "cssModule", "active", "tag", "innerRef"]);

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, 'nav-link', {
      disabled: attributes.disabled,
      active: active
    }), cssModule);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      ref: innerRef,
      onClick: this.onClick,
      className: classes
    }));
  };

  return NavLink;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavLink.propTypes = propTypes;
NavLink.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  listTag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  listClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  'aria-label': __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
var defaultProps = {
  tag: 'nav',
  listTag: 'ol',
  'aria-label': 'breadcrumb'
};

var Breadcrumb = function Breadcrumb(props) {
  var className = props.className,
      listClassName = props.listClassName,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      ListTag = props.listTag,
      label = props['aria-label'],
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "listClassName", "cssModule", "children", "tag", "listTag", "aria-label"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className), cssModule);
  var listClasses = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()('breadcrumb', listClassName), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes,
    "aria-label": label
  }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ListTag, {
    className: listClasses
  }, children));
};

Breadcrumb.propTypes = propTypes;
Breadcrumb.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Breadcrumb);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  active: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'li'
};

var BreadcrumbItem = function BreadcrumbItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "active", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes,
    "aria-current": active ? 'page' : undefined
  }));
};

BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (BreadcrumbItem);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  'aria-label': __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
var defaultProps = {
  tag: 'div',
  role: 'group'
};

var ButtonGroup = function ButtonGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      vertical = props.vertical,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "size", "vertical", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (ButtonGroup);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  'aria-label': __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
var defaultProps = {
  tag: 'div',
  role: 'toolbar'
};

var ButtonToolbar = function ButtonToolbar(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'btn-toolbar'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ButtonToolbar.propTypes = propTypes;
ButtonToolbar.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (ButtonToolbar);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["t" /* tagPropType */],
  header: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var contextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  tag: 'button',
  toggle: true
};

var DropdownItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(DropdownItem, _React$Component);

  function DropdownItem(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.getTabIndex = _this.getTabIndex.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = DropdownItem.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled || this.props.header || this.props.divider) {
      e.preventDefault();
      return;
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }

    if (this.props.toggle) {
      this.context.toggle(e);
    }
  };

  _proto.getTabIndex = function getTabIndex() {
    if (this.props.disabled || this.props.header || this.props.divider) {
      return '-1';
    }

    return '0';
  };

  _proto.render = function render() {
    var tabIndex = this.getTabIndex();
    var role = tabIndex > -1 ? 'menuitem' : undefined;

    var _omit = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["q" /* omit */])(this.props, ['toggle']),
        className = _omit.className,
        cssModule = _omit.cssModule,
        divider = _omit.divider,
        Tag = _omit.tag,
        header = _omit.header,
        active = _omit.active,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_omit, ["className", "cssModule", "divider", "tag", "header", "active"]);

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, {
      disabled: props.disabled,
      'dropdown-item': !divider && !header,
      active: active,
      'dropdown-header': header,
      'dropdown-divider': divider
    }), cssModule);

    if (Tag === 'button') {
      if (header) {
        Tag = 'h6';
      } else if (divider) {
        Tag = 'div';
      } else if (props.href) {
        Tag = 'a';
      }
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
    }, props, {
      tabIndex: tabIndex,
      role: role,
      className: classes,
      onClick: this.onClick
    }));
  };

  return DropdownItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DropdownItem.propTypes = propTypes;
DropdownItem.defaultProps = defaultProps;
DropdownItem.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (DropdownItem);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_popper__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["t" /* tagPropType */],
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node.isRequired,
  right: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  flip: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  modifiers: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  persist: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var defaultProps = {
  tag: 'div',
  flip: true
};
var contextTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired
};
var noFlipModifier = {
  flip: {
    enabled: false
  }
};
var directionPositionMap = {
  up: 'top',
  left: 'left',
  right: 'right',
  down: 'bottom'
};

var DropdownMenu = function DropdownMenu(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      right = props.right,
      tag = props.tag,
      flip = props.flip,
      modifiers = props.modifiers,
      persist = props.persist,
      attrs = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "right", "tag", "flip", "modifiers", "persist"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, 'dropdown-menu', {
    'dropdown-menu-right': right,
    show: context.isOpen
  }), cssModule);
  var Tag = tag;

  if (persist || context.isOpen && !context.inNavbar) {
    Tag = __WEBPACK_IMPORTED_MODULE_6_react_popper__["c" /* Popper */];
    var position1 = directionPositionMap[context.direction] || 'bottom';
    var position2 = right ? 'end' : 'start';
    attrs.placement = position1 + "-" + position2;
    attrs.component = tag;
    attrs.modifiers = !flip ? Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, modifiers, noFlipModifier) : modifiers;
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    tabIndex: "-1",
    role: "menu"
  }, attrs, {
    "aria-hidden": !context.isOpen,
    className: classes,
    "x-placement": attrs.placement
  }));
};

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;
DropdownMenu.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (DropdownMenu);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_popper__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Button__ = __webpack_require__(172);










var propTypes = {
  caret: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  'aria-haspopup': __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  split: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_8__utils__["t" /* tagPropType */],
  nav: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  'aria-haspopup': true,
  color: 'secondary'
};
var contextTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired
};

var DropdownToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(DropdownToggle, _React$Component);

  function DropdownToggle(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = DropdownToggle.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.nav && !this.props.tag) {
      e.preventDefault();
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }

    this.context.toggle(e);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        color = _this$props.color,
        cssModule = _this$props.cssModule,
        caret = _this$props.caret,
        split = _this$props.split,
        nav = _this$props.nav,
        tag = _this$props.tag,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "color", "cssModule", "caret", "split", "nav", "tag"]);

    var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, {
      'dropdown-toggle': caret || split,
      'dropdown-toggle-split': split,
      'nav-link': nav
    }), cssModule);
    var children = props.children || __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "sr-only"
    }, ariaLabel);
    var Tag;

    if (nav && !tag) {
      Tag = 'a';
      props.href = '#';
    } else if (!tag) {
      Tag = __WEBPACK_IMPORTED_MODULE_9__Button__["a" /* default */];
      props.color = color;
      props.cssModule = cssModule;
    } else {
      Tag = tag;
    }

    if (this.context.inNavbar) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
        className: classes,
        onClick: this.onClick,
        "aria-expanded": this.context.isOpen,
        children: children
      }));
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_popper__["d" /* Target */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      className: classes,
      component: Tag,
      onClick: this.onClick,
      "aria-expanded": this.context.isOpen,
      children: children
    }));
  };

  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;
DropdownToggle.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (DropdownToggle);

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(2);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(549);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(551);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(260);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');
      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');
      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';

      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName,
        doneClassName = _getClassNames.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */
      addClass(node, className);
    }
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(550);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(51);

var _TransitionGroup = __webpack_require__(262);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  in: _propTypes2.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react2.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');

    return null;
  }
};

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = function (_React$Component) {
  _inherits(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReplaceTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react2.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  ReplaceTransition.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        inProp = _props.in,
        props = _objectWithoutProperties(_props, ['children', 'in']);

    var _React$Children$toArr = _react2.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;

    return _react2.default.createElement(
      _TransitionGroup2.default,
      props,
      inProp ? _react2.default.cloneElement(first, {
        key: 'first',
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered

      }) : _react2.default.cloneElement(second, {
        key: 'second',
        onEnter: this.handleExit,
        onEntering: this.handleExiting,
        onEntered: this.handleExited
      })
    );
  };

  return ReplaceTransition;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleEnter = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _this2.handleLifecycle('onEnter', 0, args);
  };

  this.handleEntering = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _this2.handleLifecycle('onEntering', 0, args);
  };

  this.handleEntered = function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _this2.handleLifecycle('onEntered', 0, args);
  };

  this.handleExit = function () {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _this2.handleLifecycle('onExit', 1, args);
  };

  this.handleExiting = function () {
    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _this2.handleLifecycle('onExiting', 1, args);
  };

  this.handleExited = function () {
    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return _this2.handleLifecycle('onExited', 1, args);
  };
};

ReplaceTransition.propTypes =  false ? propTypes : {};

exports.default = ReplaceTransition;
module.exports = exports['default'];

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(1);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);

  Object.keys(children).forEach(function (key) {
    var child = children[key];

    if (!(0, _react.isValidElement)(child)) return;

    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;

    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

    // item is new (entering)
    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, { in: false });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });

  return children;
}

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  color: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  pill: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  innerRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  color: 'secondary',
  pill: false,
  tag: 'span'
};

var Badge = function Badge(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      innerRef = props.innerRef,
      pill = props.pill,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "color", "innerRef", "pill", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);

  if (attributes.href && Tag === 'span') {
    Tag = 'a';
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes,
    ref: innerRef
  }));
};

Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  inverse: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  block: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["j" /* deprecated */])(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, 'Please use the props "body"'),
  body: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func])
};
var defaultProps = {
  tag: 'div'
};

var Card = function Card(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      block = props.block,
      body = props.body,
      inverse = props.inverse,
      outline = props.outline,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "color", "block", "body", "inverse", "outline", "tag", "innerRef"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card', inverse ? 'text-white' : false, block || body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + "-" + color : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes,
    ref: innerRef
  }));
};

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardGroup = function CardGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-group'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardGroup.propTypes = propTypes;
CardGroup.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (CardGroup);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardDeck = function CardDeck(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-deck'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardDeck.propTypes = propTypes;
CardDeck.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardDeck);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardColumns = function CardColumns(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-columns'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardColumns.propTypes = propTypes;
CardColumns.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (CardColumns);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CardBody__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);



function CardBlock(props) {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils__["v" /* warnOnce */])('The "CardBlock" component has been deprecated.\nPlease use component "CardBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CardBody__["a" /* default */], props);
}

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  innerRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'a'
};

var CardLink = function CardLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag", "innerRef"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-link'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    ref: innerRef,
    className: classes
  }));
};

CardLink.propTypes = propTypes;
CardLink.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (CardLink);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardFooter = function CardFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-footer'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardFooter.propTypes = propTypes;
CardFooter.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (CardFooter);

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardHeader = function CardHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-header'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardHeader.propTypes = propTypes;
CardHeader.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (CardHeader);

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  top: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'img'
};

var CardImg = function CardImg(props) {
  var className = props.className,
      cssModule = props.cssModule,
      top = props.top,
      bottom = props.bottom,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "top", "bottom", "tag"]);

  var cardImgClassName = 'card-img';

  if (top) {
    cardImgClassName = 'card-img-top';
  }

  if (bottom) {
    cardImgClassName = 'card-img-bottom';
  }

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, cardImgClassName), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardImg.propTypes = propTypes;
CardImg.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (CardImg);

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardImgOverlay = function CardImgOverlay(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-img-overlay'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardImgOverlay.propTypes = propTypes;
CardImgOverlay.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (CardImgOverlay);

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Carousel__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CarouselItem__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CarouselControl__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselIndicators__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CarouselCaption__ = __webpack_require__(267);











var propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array.isRequired,
  indicators: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  controls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  autoPlay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultActiveIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  activeIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  next: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  previous: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  goToIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var UncontrolledCarousel =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledCarousel, _Component);

  function UncontrolledCarousel(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.animating = false;
    _this.state = {
      activeIndex: props.defaultActiveIndex || 0
    };
    _this.next = _this.next.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.previous = _this.previous.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.goToIndex = _this.goToIndex.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onExiting = _this.onExiting.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onExited = _this.onExited.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = UncontrolledCarousel.prototype;

  _proto.onExiting = function onExiting() {
    this.animating = true;
  };

  _proto.onExited = function onExited() {
    this.animating = false;
  };

  _proto.next = function next() {
    if (this.animating) return;
    var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({
      activeIndex: nextIndex
    });
  };

  _proto.previous = function previous() {
    if (this.animating) return;
    var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
    this.setState({
      activeIndex: nextIndex
    });
  };

  _proto.goToIndex = function goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({
      activeIndex: newIndex
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        defaultActiveIndex = _this$props.defaultActiveIndex,
        autoPlay = _this$props.autoPlay,
        indicators = _this$props.indicators,
        controls = _this$props.controls,
        items = _this$props.items,
        goToIndex = _this$props.goToIndex,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["defaultActiveIndex", "autoPlay", "indicators", "controls", "items", "goToIndex"]);

    var activeIndex = this.state.activeIndex;
    var slides = items.map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CarouselItem__["a" /* default */], {
        onExiting: _this2.onExiting,
        onExited: _this2.onExited,
        key: item.src
      }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", {
        className: "d-block w-100",
        src: item.src,
        alt: item.altText
      }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CarouselCaption__["a" /* default */], {
        captionText: item.caption,
        captionHeader: item.header || item.caption
      }));
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Carousel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      activeIndex: activeIndex,
      next: this.next,
      previous: this.previous,
      ride: autoPlay ? 'carousel' : undefined
    }, props), indicators && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CarouselIndicators__["a" /* default */], {
      items: items,
      activeIndex: props.activeIndex || activeIndex,
      onClickHandler: goToIndex || this.goToIndex
    }), slides, controls && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CarouselControl__["a" /* default */], {
      direction: "prev",
      directionText: "Previous",
      onClickHandler: props.previous || this.previous
    }), controls && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CarouselControl__["a" /* default */], {
      direction: "next",
      directionText: "Next",
      onClickHandler: props.next || this.next
    }));
  };

  return UncontrolledCarousel;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

UncontrolledCarousel.propTypes = propTypes;
UncontrolledCarousel.defaultProps = {
  controls: true,
  indicators: true,
  autoPlay: true
};
/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledCarousel);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardSubtitle = function CardSubtitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-subtitle'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardSubtitle.propTypes = propTypes;
CardSubtitle.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (CardSubtitle);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'p'
};

var CardText = function CardText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-text'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardText.propTypes = propTypes;
CardText.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardText);

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var CardTitle = function CardTitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-title'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

CardTitle.propTypes = propTypes;
CardTitle.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (CardTitle);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]).isRequired,
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  valid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  invalid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  bsSize: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func])
};

function CustomInput(props) {
  var className = props.className,
      label = props.label,
      inline = props.inline,
      valid = props.valid,
      invalid = props.invalid,
      cssModule = props.cssModule,
      children = props.children,
      bsSize = props.bsSize,
      innerRef = props.innerRef,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "label", "inline", "valid", "invalid", "cssModule", "children", "bsSize", "innerRef"]);

  var type = attributes.type;
  var customClass = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, "custom-" + type, bsSize ? "custom-" + type + "-" + bsSize : false), cssModule);
  var validationClassNames = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(invalid && 'is-invalid', valid && 'is-valid'), cssModule);

  if (type === 'select') {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("select", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      ref: innerRef,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(validationClassNames, customClass)
    }), children);
  }

  if (type === 'file') {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      className: customClass
    }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      ref: innerRef,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(validationClassNames, Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])('custom-file-input', cssModule))
    })), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("label", {
      className: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])('custom-file-label', cssModule),
      htmlFor: attributes.id
    }, label || 'Choose file'));
  }

  if (type !== 'checkbox' && type !== 'radio' && type !== 'switch') {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      ref: innerRef,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(validationClassNames, customClass)
    }));
  }

  var wrapperClasses = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(customClass, Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()('custom-control', {
    'custom-control-inline': inline
  }), cssModule));
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: wrapperClasses
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    type: type === 'switch' ? 'checkbox' : type,
    ref: innerRef,
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(validationClassNames, Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])('custom-control-input', cssModule))
  })), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("label", {
    className: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])('custom-control-label', cssModule),
    htmlFor: attributes.id
  }, label), children);
}

CustomInput.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (CustomInput);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(9);



var PopperTargetHelper = function PopperTargetHelper(props, context) {
  context.popperManager.setTargetNode(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* getTarget */])(props.target));
  return null;
};

PopperTargetHelper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};
PopperTargetHelper.propTypes = {
  target: __WEBPACK_IMPORTED_MODULE_1__utils__["u" /* targetPropType */].isRequired
};
/* unused harmony default export */ var _unused_webpack_default_export = (PopperTargetHelper);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UncontrolledPopover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Popover__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var omitKeys = ['defaultOpen'];

var UncontrolledPopover =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledPopover, _Component);

  function UncontrolledPopover(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = UncontrolledPopover.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Popover__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, Object(__WEBPACK_IMPORTED_MODULE_7__utils__["q" /* omit */])(this.props, omitKeys)));
  };

  return UncontrolledPopover;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);


UncontrolledPopover.propTypes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
  defaultOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
}, __WEBPACK_IMPORTED_MODULE_6__Popover__["a" /* default */].propTypes);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopoverHeader__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);



function PopoverTitle(props) {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils__["v" /* warnOnce */])('The "PopoverTitle" component has been deprecated.\nPlease use component "PopoverHeader".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PopoverHeader__["a" /* default */], props);
}

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopoverBody__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);



function PopoverContent(props) {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils__["v" /* warnOnce */])('The "PopoverContent" component has been deprecated.\nPlease use component "PopoverBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PopoverBody__["a" /* default */], props);
}

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_tonumber__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_tonumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_tonumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);







var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  bar: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  multi: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_6__utils__["t" /* tagPropType */],
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  max: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  animated: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  barClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div',
  value: 0,
  max: 100
};

var Progress = function Progress(props) {
  var children = props.children,
      className = props.className,
      barClassName = props.barClassName,
      cssModule = props.cssModule,
      value = props.value,
      max = props.max,
      animated = props.animated,
      striped = props.striped,
      color = props.color,
      bar = props.bar,
      multi = props.multi,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["children", "className", "barClassName", "cssModule", "value", "max", "animated", "striped", "color", "bar", "multi", "tag"]);

  var percent = __WEBPACK_IMPORTED_MODULE_5_lodash_tonumber___default()(value) / __WEBPACK_IMPORTED_MODULE_5_lodash_tonumber___default()(max) * 100;
  var progressClasses = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'progress'), cssModule);
  var progressBarClasses = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? "bg-" + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);
  var ProgressBar = multi ? children : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: progressBarClasses,
    style: {
      width: percent + "%"
    },
    role: "progressbar",
    "aria-valuenow": value,
    "aria-valuemin": "0",
    "aria-valuemax": max,
    children: children
  });

  if (bar) {
    return ProgressBar;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: progressClasses,
    children: ProgressBar
  }));
};

Progress.propTypes = propTypes;
Progress.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Progress);

/***/ }),
/* 575 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Portal__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Fade__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(9);











function noop() {}

var FadePropTypes = __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */].propTypes);
var propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  centered: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  keyboard: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  labelledBy: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  backdrop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['static'])]),
  onEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onExit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onOpened: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onClosed: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  wrapClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  modalClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  backdropClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  contentClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  external: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  fade: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  backdropTransition: FadePropTypes,
  modalTransition: FadePropTypes,
  innerRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func])
};
var propsToOmit = Object.keys(propTypes);
var defaultProps = {
  isOpen: false,
  autoFocus: true,
  centered: false,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop,
  onClosed: noop,
  modalTransition: {
    timeout: __WEBPACK_IMPORTED_MODULE_9__utils__["e" /* TransitionTimeouts */].Modal
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: __WEBPACK_IMPORTED_MODULE_9__utils__["e" /* TransitionTimeouts */].Fade // uses standard fade transition

  }
};

var Modal =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Modal, _React$Component);

  function Modal(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._element = null;
    _this._originalBodyPadding = null;
    _this.getFocusableChildren = _this.getFocusableChildren.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleBackdropClick = _this.handleBackdropClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleBackdropMouseDown = _this.handleBackdropMouseDown.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleEscape = _this.handleEscape.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleTab = _this.handleTab.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onOpened = _this.onOpened.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.onClosed = _this.onClosed.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.state = {
      isOpen: props.isOpen
    };

    if (props.isOpen) {
      _this.init();
    }

    return _this;
  }

  var _proto = Modal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onEnter) {
      this.props.onEnter();
    }

    if (this.state.isOpen && this.props.autoFocus) {
      this.setFocus();
    }

    this._isMounted = true;
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen && !this.props.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen
      });
    }
  };

  _proto.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
    if (nextState.isOpen && !this.state.isOpen) {
      this.init();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
      this.setFocus();
    }

    if (this._element && prevProps.zIndex !== this.props.zIndex) {
      this._element.style.zIndex = this.props.zIndex;
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onExit) {
      this.props.onExit();
    }

    if (this.state.isOpen) {
      this.destroy();
    }

    this._isMounted = false;
  };

  _proto.onOpened = function onOpened(node, isAppearing) {
    this.props.onOpened();
    (this.props.modalTransition.onEntered || noop)(node, isAppearing);
  };

  _proto.onClosed = function onClosed(node) {
    // so all methods get called before it is unmounted
    this.props.onClosed();
    (this.props.modalTransition.onExited || noop)(node);
    this.destroy();

    if (this._isMounted) {
      this.setState({
        isOpen: false
      });
    }
  };

  _proto.setFocus = function setFocus() {
    if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
      this._dialog.parentNode.focus();
    }
  };

  _proto.getFocusableChildren = function getFocusableChildren() {
    return this._element.querySelectorAll(__WEBPACK_IMPORTED_MODULE_9__utils__["l" /* focusableElements */].join(', '));
  };

  _proto.getFocusedChild = function getFocusedChild() {
    var currentFocus;
    var focusableChildren = this.getFocusableChildren();

    try {
      currentFocus = document.activeElement;
    } catch (err) {
      currentFocus = focusableChildren[0];
    }

    return currentFocus;
  } // not mouseUp because scrollbar fires it, shouldn't close when user scrolls
  ;

  _proto.handleBackdropClick = function handleBackdropClick(e) {
    if (e.target === this._mouseDownElement) {
      e.stopPropagation();
      if (!this.props.isOpen || this.props.backdrop !== true) return;
      var backdrop = this._dialog ? this._dialog.parentNode : null;

      if (backdrop && e.target === backdrop && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  };

  _proto.handleTab = function handleTab(e) {
    if (e.which !== 9) return;
    var focusableChildren = this.getFocusableChildren();
    var totalFocusable = focusableChildren.length;
    var currentFocus = this.getFocusedChild();
    var focusedIndex = 0;

    for (var i = 0; i < totalFocusable; i += 1) {
      if (focusableChildren[i] === currentFocus) {
        focusedIndex = i;
        break;
      }
    }

    if (e.shiftKey && focusedIndex === 0) {
      e.preventDefault();
      focusableChildren[totalFocusable - 1].focus();
    } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
      e.preventDefault();
      focusableChildren[0].focus();
    }
  };

  _proto.handleBackdropMouseDown = function handleBackdropMouseDown(e) {
    this._mouseDownElement = e.target;
  };

  _proto.handleEscape = function handleEscape(e) {
    if (this.props.isOpen && this.props.keyboard && e.keyCode === 27 && this.props.toggle) {
      e.preventDefault();
      e.stopPropagation();
      this.props.toggle(e);
    }
  };

  _proto.init = function init() {
    try {
      this._triggeringElement = document.activeElement;
    } catch (err) {
      this._triggeringElement = null;
    }

    this._element = document.createElement('div');

    this._element.setAttribute('tabindex', '-1');

    this._element.style.position = 'relative';
    this._element.style.zIndex = this.props.zIndex;
    this._originalBodyPadding = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["m" /* getOriginalBodyPadding */])();
    Object(__WEBPACK_IMPORTED_MODULE_9__utils__["h" /* conditionallyUpdateScrollbar */])();
    document.body.appendChild(this._element);

    if (Modal.openCount === 0) {
      document.body.className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(document.body.className, Object(__WEBPACK_IMPORTED_MODULE_9__utils__["p" /* mapToCssModules */])('modal-open', this.props.cssModule));
    }

    Modal.openCount += 1;
  };

  _proto.destroy = function destroy() {
    if (this._element) {
      document.body.removeChild(this._element);
      this._element = null;
    }

    if (this._triggeringElement) {
      if (this._triggeringElement.focus) this._triggeringElement.focus();
      this._triggeringElement = null;
    }

    if (Modal.openCount <= 1) {
      var modalOpenClassName = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["p" /* mapToCssModules */])('modal-open', this.props.cssModule); // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`

      var modalOpenClassNameRegex = new RegExp("(^| )" + modalOpenClassName + "( |$)");
      document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
    }

    Modal.openCount -= 1;
    Object(__WEBPACK_IMPORTED_MODULE_9__utils__["s" /* setScrollbarWidth */])(this._originalBodyPadding);
  };

  _proto.renderModalDialog = function renderModalDialog() {
    var _classNames,
        _this2 = this;

    var attributes = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["q" /* omit */])(this.props, propsToOmit);
    var dialogBaseClass = 'modal-dialog';
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      className: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()(dialogBaseClass, this.props.className, (_classNames = {}, _classNames["modal-" + this.props.size] = this.props.size, _classNames[dialogBaseClass + "-centered"] = this.props.centered, _classNames)), this.props.cssModule),
      role: "document",
      ref: function ref(c) {
        _this2._dialog = c;
      }
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()('modal-content', this.props.contentClassName), this.props.cssModule)
    }, this.props.children));
  };

  _proto.render = function render() {
    if (this.state.isOpen) {
      var _this$props = this.props,
          wrapClassName = _this$props.wrapClassName,
          modalClassName = _this$props.modalClassName,
          backdropClassName = _this$props.backdropClassName,
          cssModule = _this$props.cssModule,
          isOpen = _this$props.isOpen,
          backdrop = _this$props.backdrop,
          role = _this$props.role,
          labelledBy = _this$props.labelledBy,
          external = _this$props.external,
          innerRef = _this$props.innerRef;
      var modalAttributes = {
        onClick: this.handleBackdropClick,
        onMouseDown: this.handleBackdropMouseDown,
        onKeyUp: this.handleEscape,
        onKeyDown: this.handleTab,
        style: {
          display: 'block'
        },
        'aria-labelledby': labelledBy,
        role: role,
        tabIndex: '-1'
      };
      var hasTransition = this.props.fade;

      var modalTransition = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */].defaultProps, this.props.modalTransition, {
        baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
        timeout: hasTransition ? this.props.modalTransition.timeout : 0
      });

      var backdropTransition = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */].defaultProps, this.props.backdropTransition, {
        baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
        timeout: hasTransition ? this.props.backdropTransition.timeout : 0
      });

      var Backdrop = backdrop && (hasTransition ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, backdropTransition, {
        in: isOpen && !!backdrop,
        cssModule: cssModule,
        className: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()('modal-backdrop', backdropClassName), cssModule)
      })) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()('modal-backdrop', 'show', backdropClassName), cssModule)
      }));
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Portal__["a" /* default */], {
        node: this._element
      }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["p" /* mapToCssModules */])(wrapClassName)
      }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, modalAttributes, modalTransition, {
        in: isOpen,
        onEntered: this.onOpened,
        onExited: this.onClosed,
        cssModule: cssModule,
        className: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()('modal', modalClassName), cssModule),
        innerRef: innerRef
      }), external, this.renderModalDialog()), Backdrop));
    }

    return null;
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.openCount = 0;
/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(9);





var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};

var Portal =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Portal, _React$Component);

  function Portal() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Portal.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.defaultNode) {
      document.body.removeChild(this.defaultNode);
    }

    this.defaultNode = null;
  };

  _proto.render = function render() {
    if (!__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* canUseDOM */]) {
      return null;
    }

    if (!this.props.node && !this.defaultNode) {
      this.defaultNode = document.createElement('div');
      document.body.appendChild(this.defaultNode);
    }

    return __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.createPortal(this.props.children, this.props.node || this.defaultNode);
  };

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Portal.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  wrapTag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  toggle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  charCode: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'h5',
  wrapTag: 'div',
  closeAriaLabel: 'Close',
  charCode: 215
};

var ModalHeader = function ModalHeader(props) {
  var closeButton;

  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      toggle = props.toggle,
      Tag = props.tag,
      WrapTag = props.wrapTag,
      closeAriaLabel = props.closeAriaLabel,
      charCode = props.charCode,
      close = props.close,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "children", "toggle", "tag", "wrapTag", "closeAriaLabel", "charCode", "close"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'modal-header'), cssModule);

  if (!close && toggle) {
    var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
    closeButton = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button", {
      type: "button",
      onClick: toggle,
      className: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])('close', cssModule),
      "aria-label": closeAriaLabel
    }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      "aria-hidden": "true"
    }, closeIcon));
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(WrapTag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])('modal-title', cssModule)
  }, children), close || closeButton);
};

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (ModalHeader);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var ModalBody = function ModalBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'modal-body'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ModalBody);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var ModalFooter = function ModalFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'modal-footer'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (ModalFooter);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  bordered: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  borderless: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  inverse: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["j" /* deprecated */])(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, 'Please use the prop "dark"'),
  dark: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  responsiveTag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  innerRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
var defaultProps = {
  tag: 'table',
  responsiveTag: 'div'
};

var Table = function Table(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      bordered = props.bordered,
      borderless = props.borderless,
      striped = props.striped,
      inverse = props.inverse,
      dark = props.dark,
      hover = props.hover,
      responsive = props.responsive,
      Tag = props.tag,
      ResponsiveTag = props.responsiveTag,
      innerRef = props.innerRef,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "size", "bordered", "borderless", "striped", "inverse", "dark", "hover", "responsive", "tag", "responsiveTag", "innerRef"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, borderless ? 'table-borderless' : false, striped ? 'table-striped' : false, dark || inverse ? 'table-dark' : false, hover ? 'table-hover' : false), cssModule);
  var table = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    ref: innerRef,
    className: classes
  }));

  if (responsive) {
    var responsiveClassName = responsive === true ? 'table-responsive' : "table-responsive-" + responsive;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ResponsiveTag, {
      className: responsiveClassName
    }, table);
  }

  return table;
};

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  flush: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'ul'
};

var ListGroup = function ListGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      flush = props.flush,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag", "flush"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'list-group', flush ? 'list-group-flush' : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ListGroup.propTypes = propTypes;
ListGroup.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (ListGroup);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["t" /* tagPropType */],
  innerRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};
var defaultProps = {
  tag: 'form'
};

var Form =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Form, _Component);

  function Form(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.getRef = _this.getRef.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.submit = _this.submit.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = Form.prototype;

  _proto.getRef = function getRef(ref) {
    if (this.props.innerRef) {
      this.props.innerRef(ref);
    }

    this.ref = ref;
  };

  _proto.submit = function submit() {
    if (this.ref) {
      this.ref.submit();
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        inline = _this$props.inline,
        Tag = _this$props.tag,
        innerRef = _this$props.innerRef,
        attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "cssModule", "inline", "tag", "innerRef"]);

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, inline ? 'form-inline' : false), cssModule);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      ref: innerRef,
      className: classes
    }));
  };

  return Form;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  valid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tooltip: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
var defaultProps = {
  tag: 'div',
  valid: undefined
};

var FormFeedback = function FormFeedback(props) {
  var className = props.className,
      cssModule = props.cssModule,
      valid = props.valid,
      tooltip = props.tooltip,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "valid", "tooltip", "tag"]);

  var validMode = tooltip ? 'tooltip' : 'feedback';
  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, valid ? "valid-" + validMode : "invalid-" + validMode), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

FormFeedback.propTypes = propTypes;
FormFeedback.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (FormFeedback);

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  row: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var FormGroup = function FormGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      row = props.row,
      disabled = props.disabled,
      check = props.check,
      inline = props.inline,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "row", "disabled", "check", "inline", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

FormGroup.propTypes = propTypes;
FormGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (FormGroup);

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  color: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'small',
  color: 'muted'
};

var FormText = function FormText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      color = props.color,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "inline", "color", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, !inline ? 'form-text' : false, color ? "text-" + color : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

FormText.propTypes = propTypes;
FormText.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (FormText);

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);





/* eslint react/prefer-stateless-function: 0 */




var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  state: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["j" /* deprecated */])(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, 'Please use the props "valid" and "invalid" to indicate the state.'),
  valid: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  invalid: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["t" /* tagPropType */],
  innerRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  static: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["j" /* deprecated */])(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, 'Please use the prop "plaintext"'),
  plaintext: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  addon: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};
var defaultProps = {
  type: 'text'
};

var Input =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Input, _React$Component);

  function Input(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.getRef = _this.getRef.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.focus = _this.focus.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = Input.prototype;

  _proto.getRef = function getRef(ref) {
    if (this.props.innerRef) {
      this.props.innerRef(ref);
    }

    this.ref = ref;
  };

  _proto.focus = function focus() {
    if (this.ref) {
      this.ref.focus();
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        type = _this$props.type,
        bsSize = _this$props.bsSize,
        state = _this$props.state,
        valid = _this$props.valid,
        invalid = _this$props.invalid,
        tag = _this$props.tag,
        addon = _this$props.addon,
        staticInput = _this$props.static,
        plaintext = _this$props.plaintext,
        innerRef = _this$props.innerRef,
        attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "cssModule", "type", "bsSize", "state", "valid", "invalid", "tag", "addon", "static", "plaintext", "innerRef"]);

    var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
    var isNotaNumber = new RegExp('\\D', 'g');
    var fileInput = type === 'file';
    var textareaInput = type === 'textarea';
    var selectInput = type === 'select';
    var Tag = tag || (selectInput || textareaInput ? type : 'input');
    var formControlClass = 'form-control';

    if (plaintext || staticInput) {
      formControlClass = formControlClass + "-plaintext";
      Tag = tag || 'input';
    } else if (fileInput) {
      formControlClass = formControlClass + "-file";
    } else if (checkInput) {
      if (addon) {
        formControlClass = null;
      } else {
        formControlClass = 'form-check-input';
      }
    }

    if (state && typeof valid === 'undefined' && typeof invalid === 'undefined') {
      if (state === 'danger') {
        invalid = true;
      } else if (state === 'success') {
        valid = true;
      }
    }

    if (attributes.size && isNotaNumber.test(attributes.size)) {
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["v" /* warnOnce */])('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
      bsSize = attributes.size;
      delete attributes.size;
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? "form-control-" + bsSize : false, formControlClass), cssModule);

    if (Tag === 'input' || tag && typeof tag === 'function') {
      attributes.type = type;
    }

    if (attributes.children && !(plaintext || staticInput || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["v" /* warnOnce */])("Input with a type of \"" + type + "\" cannot have children. Please use \"value\"/\"defaultValue\" instead.");
      delete attributes.children;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      ref: innerRef,
      className: classes
    }));
  };

  return Input;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  size: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var InputGroup = function InputGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      size = props.size,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag", "size"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'input-group', size ? "input-group-" + size : null), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

InputGroup.propTypes = propTypes;
InputGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (InputGroup);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputGroupAddon__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_7__utils__["t" /* tagPropType */],
  addonType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node,
  groupClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  groupAttributes: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};

var InputGroupButton = function InputGroupButton(props) {
  Object(__WEBPACK_IMPORTED_MODULE_7__utils__["v" /* warnOnce */])('The "InputGroupButton" component has been deprecated.\nPlease use component "InputGroupAddon".');

  var children = props.children,
      groupClassName = props.groupClassName,
      groupAttributes = props.groupAttributes,
      propsWithoutGroup = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["children", "groupClassName", "groupAttributes"]);

  if (typeof children === 'string') {
    var cssModule = propsWithoutGroup.cssModule,
        tag = propsWithoutGroup.tag,
        addonType = propsWithoutGroup.addonType,
        attributes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(propsWithoutGroup, ["cssModule", "tag", "addonType"]);

    var allGroupAttributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, groupAttributes, {
      cssModule: cssModule,
      tag: tag,
      addonType: addonType
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__InputGroupAddon__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, allGroupAttributes, {
      className: groupClassName
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      children: children
    })));
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__InputGroupAddon__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    children: children
  }));
};

InputGroupButton.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (InputGroupButton);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dropdown__ = __webpack_require__(103);



var propTypes = {
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var InputGroupButtonDropdown = function InputGroupButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Dropdown__["a" /* default */], props);
};

InputGroupButtonDropdown.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (InputGroupButtonDropdown);

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isobject__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);







var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var stringOrNumberProp = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]);
var columnProps = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
  size: stringOrNumberProp,
  push: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["j" /* deprecated */])(stringOrNumberProp, 'Please use the prop "order"'),
  pull: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["j" /* deprecated */])(stringOrNumberProp, 'Please use the prop "order"'),
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);
var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  hidden: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  for: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_6__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  widths: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array
};
var defaultProps = {
  tag: 'label',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : "col-" + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
  }

  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
};

var Label = function Label(props) {
  var className = props.className,
      cssModule = props.cssModule,
      hidden = props.hidden,
      widths = props.widths,
      Tag = props.tag,
      check = props.check,
      size = props.size,
      htmlFor = props.for,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "hidden", "widths", "tag", "check", "size", "for"]);

  var colClasses = [];
  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];
    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;
    var colClass;

    if (__WEBPACK_IMPORTED_MODULE_5_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
      colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
      colClasses.push(Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames))), cssModule);
    } else {
      colClass = getColumnSizeClass(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });
  var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? "col-form-label-" + size : false, colClasses, colClasses.length ? 'col-form-label' : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    htmlFor: htmlFor
  }, attributes, {
    className: classes
  }));
};

Label.propTypes = propTypes;
Label.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Label);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  body: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  heading: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  left: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  list: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  middle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  object: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  right: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  top: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

var Media = function Media(props) {
  var body = props.body,
      bottom = props.bottom,
      className = props.className,
      cssModule = props.cssModule,
      heading = props.heading,
      left = props.left,
      list = props.list,
      middle = props.middle,
      object = props.object,
      right = props.right,
      tag = props.tag,
      top = props.top,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["body", "bottom", "className", "cssModule", "heading", "left", "list", "middle", "object", "right", "tag", "top"]);

  var defaultTag;

  if (heading) {
    defaultTag = 'h4';
  } else if (attributes.href) {
    defaultTag = 'a';
  } else if (attributes.src || object) {
    defaultTag = 'img';
  } else if (list) {
    defaultTag = 'ul';
  } else {
    defaultTag = 'div';
  }

  var Tag = tag || defaultTag;
  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, {
    'media-body': body,
    'media-heading': heading,
    'media-left': left,
    'media-right': right,
    'media-top': top,
    'media-bottom': bottom,
    'media-middle': middle,
    'media-object': object,
    'media-list': list,
    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
  }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

Media.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Media);

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  listClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  listTag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  'aria-label': __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
var defaultProps = {
  tag: 'nav',
  listTag: 'ul',
  'aria-label': 'pagination'
};

var Pagination = function Pagination(props) {
  var _classNames;

  var className = props.className,
      listClassName = props.listClassName,
      cssModule = props.cssModule,
      size = props.size,
      Tag = props.tag,
      ListTag = props.listTag,
      label = props['aria-label'],
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "listClassName", "cssModule", "size", "tag", "listTag", "aria-label"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className), cssModule);
  var listClasses = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(listClassName, 'pagination', (_classNames = {}, _classNames["pagination-" + size] = !!size, _classNames)), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, {
    className: classes,
    "aria-label": label
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ListTag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: listClasses
  })));
};

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Pagination);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */]
};
var defaultProps = {
  tag: 'li'
};

var PaginationItem = function PaginationItem(props) {
  var active = props.active,
      className = props.className,
      cssModule = props.cssModule,
      disabled = props.disabled,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["active", "className", "cssModule", "disabled", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'page-item', {
    active: active,
    disabled: disabled
  }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

PaginationItem.propTypes = propTypes;
PaginationItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (PaginationItem);

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  'aria-label': __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  next: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */]
};
var defaultProps = {
  tag: 'a'
};

var PaginationLink = function PaginationLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      next = props.next,
      previous = props.previous,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "next", "previous", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'page-link'), cssModule);
  var defaultAriaLabel;

  if (previous) {
    defaultAriaLabel = 'Previous';
  } else if (next) {
    defaultAriaLabel = 'Next';
  }

  var ariaLabel = props['aria-label'] || defaultAriaLabel;
  var defaultCaret;

  if (previous) {
    defaultCaret = "\xAB";
  } else if (next) {
    defaultCaret = "\xBB";
  }

  var children = props.children;

  if (children && Array.isArray(children) && children.length === 0) {
    children = null;
  }

  if (!attributes.href && Tag === 'a') {
    Tag = 'button';
  }

  if (previous || next) {
    children = [__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      "aria-hidden": "true",
      key: "caret"
    }, children || defaultCaret), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      className: "sr-only",
      key: "sr"
    }, ariaLabel)];
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes,
    "aria-label": ariaLabel
  }), children);
};

PaginationLink.propTypes = propTypes;
PaginationLink.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (PaginationLink);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);







var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_6__utils__["t" /* tagPropType */],
  activeTab: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};
var childContextTypes = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};

var TabContent =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TabContent, _Component);

  TabContent.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.activeTab !== nextProps.activeTab) {
      return {
        activeTab: nextProps.activeTab
      };
    }

    return null;
  };

  function TabContent(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      activeTab: _this.props.activeTab
    };
    return _this;
  }

  var _proto = TabContent.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      activeTabId: this.state.activeTab
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        Tag = _this$props.tag;
    var attributes = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["q" /* omit */])(this.props, Object.keys(propTypes));
    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_5_classnames___default()('tab-content', className), cssModule);
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
      className: classes
    }));
  };

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__["polyfill"])(TabContent);
/* unused harmony default export */ var _unused_webpack_default_export = (TabContent);
TabContent.propTypes = propTypes;
TabContent.defaultProps = defaultProps;
TabContent.childContextTypes = childContextTypes;

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  tabId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};
var defaultProps = {
  tag: 'div'
};
var contextTypes = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};
function TabPane(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      tabId = props.tabId,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tabId", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()('tab-pane', className, {
    active: tabId === context.activeTabId
  }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
}
TabPane.propTypes = propTypes;
TabPane.defaultProps = defaultProps;
TabPane.contextTypes = contextTypes;

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  fluid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var Jumbotron = function Jumbotron(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      fluid = props.fluid,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag", "fluid"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

Jumbotron.propTypes = propTypes;
Jumbotron.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Jumbotron);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  active: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'li'
};

var handleDisabledOnClick = function handleDisabledOnClick(e) {
  e.preventDefault();
};

var ListGroupItem = function ListGroupItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      active = props.active,
      disabled = props.disabled,
      action = props.action,
      color = props.color,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag", "active", "disabled", "action", "color"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? "list-group-item-" + color : false, 'list-group-item'), cssModule); // Prevent click event when disabled.

  if (disabled) {
    attributes.onClick = handleDisabledOnClick;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ListGroupItem.propTypes = propTypes;
ListGroupItem.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (ListGroupItem);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'h5'
};

var ListGroupItemHeading = function ListGroupItemHeading(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'list-group-item-heading'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ListGroupItemHeading.propTypes = propTypes;
ListGroupItemHeading.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (ListGroupItemHeading);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'p'
};

var ListGroupItemText = function ListGroupItemText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'list-group-item-text'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, attributes, {
    className: classes
  }));
};

ListGroupItemText.propTypes = propTypes;
ListGroupItemText.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (ListGroupItemText);

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Alert__ = __webpack_require__(276);






var UncontrolledAlert =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledAlert, _Component);

  function UncontrolledAlert(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isOpen: true
    };
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = UncontrolledAlert.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Alert__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, this.props));
  };

  return UncontrolledAlert;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledAlert);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonDropdown__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var omitKeys = ['defaultOpen'];

var UncontrolledButtonDropdown =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledButtonDropdown, _Component);

  function UncontrolledButtonDropdown(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = UncontrolledButtonDropdown.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ButtonDropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, Object(__WEBPACK_IMPORTED_MODULE_7__utils__["q" /* omit */])(this.props, omitKeys)));
  };

  return UncontrolledButtonDropdown;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);


UncontrolledButtonDropdown.propTypes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
  defaultOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
}, __WEBPACK_IMPORTED_MODULE_6__ButtonDropdown__["a" /* default */].propTypes);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Collapse__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(9);







var omitKeys = ['toggleEvents', 'defaultOpen'];
var propTypes = {
  defaultOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  toggler: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  toggleEvents: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string)
};
var defaultProps = {
  toggleEvents: __WEBPACK_IMPORTED_MODULE_6__utils__["i" /* defaultToggleEvents */]
};

var UncontrolledCollapse =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledCollapse, _Component);

  function UncontrolledCollapse(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.togglers = null;
    _this.removeEventListeners = null;
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    return _this;
  }

  var _proto = UncontrolledCollapse.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.togglers = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["k" /* findDOMElements */])(this.props.toggler);

    if (this.togglers.length) {
      this.removeEventListeners = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["f" /* addMultipleEventListeners */])(this.togglers, this.toggle, this.props.toggleEvents);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.togglers.length && this.removeEventListeners) {
      this.removeEventListeners();
    }
  };

  _proto.toggle = function toggle(e) {
    this.setState(function (_ref) {
      var isOpen = _ref.isOpen;
      return {
        isOpen: !isOpen
      };
    });
    e.preventDefault();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Collapse__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      isOpen: this.state.isOpen
    }, Object(__WEBPACK_IMPORTED_MODULE_6__utils__["q" /* omit */])(this.props, omitKeys)));
  };

  return UncontrolledCollapse;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

UncontrolledCollapse.propTypes = propTypes;
UncontrolledCollapse.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (UncontrolledCollapse);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UncontrolledDropdown__ = __webpack_require__(278);





var UncontrolledNavDropdown = function UncontrolledNavDropdown(props) {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils__["v" /* warnOnce */])('The "UncontrolledNavDropdown" component has been deprecated.\nPlease use component "UncontrolledDropdown" with nav prop.');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UncontrolledDropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    nav: true
  }, props));
};

/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledNavDropdown);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tooltip__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(9);








var omitKeys = ['defaultOpen'];

var UncontrolledTooltip =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledTooltip, _Component);

  function UncontrolledTooltip(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    _this.toggle = _this.toggle.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = UncontrolledTooltip.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Tooltip__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, Object(__WEBPACK_IMPORTED_MODULE_7__utils__["q" /* omit */])(this.props, omitKeys)));
  };

  return UncontrolledTooltip;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);


UncontrolledTooltip.propTypes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
  defaultOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
}, __WEBPACK_IMPORTED_MODULE_6__Tooltip__["a" /* default */].propTypes);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);






var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5__utils__["t" /* tagPropType */],
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
var defaultProps = {
  tag: 'div',
  type: 'border',
  children: 'Loading...'
};

var Spinner = function Spinner(props) {
  var className = props.className,
      cssModule = props.cssModule,
      type = props.type,
      size = props.size,
      color = props.color,
      children = props.children,
      Tag = props.tag,
      attributes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["className", "cssModule", "type", "size", "color", "children", "tag"]);

  var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, size ? "spinner-" + type + "-" + size : false, "spinner-" + type, color ? "text-" + color : false), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "status"
  }, attributes, {
    className: classes
  }), children && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* mapToCssModules */])('sr-only', cssModule)
  }, children));
};

Spinner.propTypes = propTypes;
Spinner.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Add=function(_Component){_inherits(Add,_Component);function Add(){_classCallCheck(this,Add);return _possibleConstructorReturn(this,(Add.__proto__||Object.getPrototypeOf(Add)).apply(this,arguments));}_createClass(Add,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}));}}]);return Add;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Add);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckBox=function(_Component){_inherits(CheckBox,_Component);function CheckBox(){_classCallCheck(this,CheckBox);return _possibleConstructorReturn(this,(CheckBox.__proto__||Object.getPrototypeOf(CheckBox)).apply(this,arguments));}_createClass(CheckBox,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"}));}}]);return CheckBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CheckBox);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckBoxOutlineBlank=function(_Component){_inherits(CheckBoxOutlineBlank,_Component);function CheckBoxOutlineBlank(){_classCallCheck(this,CheckBoxOutlineBlank);return _possibleConstructorReturn(this,(CheckBoxOutlineBlank.__proto__||Object.getPrototypeOf(CheckBoxOutlineBlank)).apply(this,arguments));}_createClass(CheckBoxOutlineBlank,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}));}}]);return CheckBoxOutlineBlank;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CheckBoxOutlineBlank);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Clear=function(_Component){_inherits(Clear,_Component);function Clear(){_classCallCheck(this,Clear);return _possibleConstructorReturn(this,(Clear.__proto__||Object.getPrototypeOf(Clear)).apply(this,arguments));}_createClass(Clear,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}));}}]);return Clear;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Clear);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Create=function(_Component){_inherits(Create,_Component);function Create(){_classCallCheck(this,Create);return _possibleConstructorReturn(this,(Create.__proto__||Object.getPrototypeOf(Create)).apply(this,arguments));}_createClass(Create,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}));}}]);return Create;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Create);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Info=function(_Component){_inherits(Info,_Component);function Info(){_classCallCheck(this,Info);return _possibleConstructorReturn(this,(Info.__proto__||Object.getPrototypeOf(Info)).apply(this,arguments));}_createClass(Info,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"}));}}]);return Info;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Info);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Person=function(_Component){_inherits(Person,_Component);function Person(){_classCallCheck(this,Person);return _possibleConstructorReturn(this,(Person.__proto__||Object.getPrototypeOf(Person)).apply(this,arguments));}_createClass(Person,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}));}}]);return Person;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Person);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RadioButtonChecked=function(_Component){_inherits(RadioButtonChecked,_Component);function RadioButtonChecked(){_classCallCheck(this,RadioButtonChecked);return _possibleConstructorReturn(this,(RadioButtonChecked.__proto__||Object.getPrototypeOf(RadioButtonChecked)).apply(this,arguments));}_createClass(RadioButtonChecked,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}));}}]);return RadioButtonChecked;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RadioButtonChecked);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RadioButtonUnchecked=function(_Component){_inherits(RadioButtonUnchecked,_Component);function RadioButtonUnchecked(){_classCallCheck(this,RadioButtonUnchecked);return _possibleConstructorReturn(this,(RadioButtonUnchecked.__proto__||Object.getPrototypeOf(RadioButtonUnchecked)).apply(this,arguments));}_createClass(RadioButtonUnchecked,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}));}}]);return RadioButtonUnchecked;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RadioButtonUnchecked);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ArrowBack=function(_Component){_inherits(ArrowBack,_Component);function ArrowBack(){_classCallCheck(this,ArrowBack);return _possibleConstructorReturn(this,(ArrowBack.__proto__||Object.getPrototypeOf(ArrowBack)).apply(this,arguments));}_createClass(ArrowBack,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"}));}}]);return ArrowBack;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ArrowBack);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QuestionMark=function(_Component){_inherits(QuestionMark,_Component);function QuestionMark(){_classCallCheck(this,QuestionMark);return _possibleConstructorReturn(this,(QuestionMark.__proto__||Object.getPrototypeOf(QuestionMark)).apply(this,arguments));}_createClass(QuestionMark,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M12,3c-4.97,0-9,4.03-9,9c0,4.97,4.03,9,9,9s9-4.03,9-9C21,7.03,16.97,3,12,3z M12.97,18.21h-1.63v-1.64h1.63V18.21z M15.55,10.9c-0.24,0.44-0.71,0.96-1.41,1.58c-0.46,0.42-0.76,0.73-0.91,0.92c-0.15,0.2-0.25,0.43-0.31,0.67 c-0.07,0.26-0.11,0.68-0.12,1.25h-1.37c-0.01-0.19-0.01-0.33-0.01-0.43c0-0.56,0.08-1.06,0.24-1.46c0.12-0.31,0.3-0.62,0.56-0.93 c0.19-0.24,0.54-0.56,1.03-1c0.5-0.45,0.82-0.8,0.97-1.06c0.15-0.26,0.23-0.54,0.23-0.86c0-0.56-0.21-1.05-0.65-1.47 c-0.44-0.43-0.97-0.64-1.6-0.64c-0.62,0-1.13,0.19-1.53,0.59c-0.42,0.38-0.67,0.98-0.81,1.79L8.38,9.67 c0.13-1.09,0.53-1.94,1.19-2.51c0.65-0.59,1.52-0.88,2.6-0.88c1.14,0,2.05,0.32,2.72,0.93c0.69,0.63,1.02,1.38,1.02,2.27 C15.91,10,15.79,10.47,15.55,10.9z"}));}}]);return QuestionMark;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (QuestionMark);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var KeyboardArrowRight=function(_Component){_inherits(KeyboardArrowRight,_Component);function KeyboardArrowRight(){_classCallCheck(this,KeyboardArrowRight);return _possibleConstructorReturn(this,(KeyboardArrowRight.__proto__||Object.getPrototypeOf(KeyboardArrowRight)).apply(this,arguments));}_createClass(KeyboardArrowRight,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"none",d:"M0 0h24v24H0V0z"}));}}]);return KeyboardArrowRight;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (KeyboardArrowRight);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var KeyboardArrowDown=function(_Component){_inherits(KeyboardArrowDown,_Component);function KeyboardArrowDown(){_classCallCheck(this,KeyboardArrowDown);return _possibleConstructorReturn(this,(KeyboardArrowDown.__proto__||Object.getPrototypeOf(KeyboardArrowDown)).apply(this,arguments));}_createClass(KeyboardArrowDown,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"none",d:"M0 0h24v24H0V0z"}));}}]);return KeyboardArrowDown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (KeyboardArrowDown);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Add=function(_Component){_inherits(Add,_Component);function Add(){_classCallCheck(this,Add);return _possibleConstructorReturn(this,(Add.__proto__||Object.getPrototypeOf(Add)).apply(this,arguments));}_createClass(Add,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",viewBox:"0 0 74 74"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style",{type:"text/css"},".st0{fill:none;stroke:#9c9c9c;stroke-width:3;stroke-miterlimit:10;}.st1{fill:#9c9c9c;}"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{className:"st0",d:"M62.5,4.3h-49c-4.4,0-8,3.6-8,8v30c0,4.4,3.6,8,8,8h22.1c-2.5-6,0.4-14.5,8.9-14.5c8.5,0,11.4,8.6,8.9,14.5h9.1\r c4.4,0,8-3.6,8-8v-30C70.5,7.9,66.9,4.3,62.5,4.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{className:"st0",cx:"44.4",cy:"45.8",r:"10.1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{className:"st1",d:"M35.4,53.7L31.9,66c-0.4,1.6,2.4,2.4,2.9,0.8l3.4-12.3C38.7,52.9,35.8,52.1,35.4,53.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{className:"st1",d:"M42.4,55.9l-3.4,12.3c-0.4,1.6,2.4,2.4,2.9,0.8l3.4-12.3C45.7,55.1,42.8,54.3,42.4,55.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{className:"st1",d:"M36.4,65.2l2.4,4.1c0.9,1.5,3.5-0.1,2.6-1.5L39,63.7C38.1,62.2,35.5,63.7,36.4,65.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{className:"st1",d:"M36.7,63.5l-4.3,2.4c-1.6,0.8-0.1,3.5,1.4,2.6l4.3-2.4C39.7,65.3,38.3,62.6,36.7,63.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{className:"st1",d:"M52.7,53.7l3.7,12.2c0.5,1.6-2.4,2.5-2.9,0.9l-3.7-12.2C49.4,52.9,52.2,52,52.7,53.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{className:"st1",d:"M45.8,56l3.7,12.2c0.5,1.6-2.4,2.5-2.9,0.9l-3.7-12.2C42.4,55.3,45.3,54.4,45.8,56z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{className:"st1",d:"M51.9,65.2l-2.3,4.2c-0.8,1.5-3.5,0-2.6-1.5l2.3-4.2C50.2,62.2,52.8,63.7,51.9,65.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{className:"st1",d:"M51.6,63.5l4.4,2.3c1.6,0.8,0.2,3.5-1.4,2.7l-4.4-2.3C48.6,65.3,50,62.7,51.6,63.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{className:"st1",d:"M59.9,14.4H16.3c-1.9,0-1.9,3,0,3h43.6C61.8,17.4,61.8,14.4,59.9,14.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{className:"st1",d:"M60.3,25.8h-44c-1.9,0-1.9,3,0,3h44C62.2,28.8,62.2,25.8,60.3,25.8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{className:"st1",d:"M36.4,37.4h-20c-1.9,0-1.9,3,0,3h20C38.3,40.4,38.3,37.4,36.4,37.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{className:"st1",d:"M60,37.3h-6.9c-1.9,0-1.9,3,0,3H60C61.9,40.3,61.9,37.3,60,37.3z"}));}}]);return Add;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Add);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Search=function(_Component){_inherits(Search,_Component);function Search(){_classCallCheck(this,Search);return _possibleConstructorReturn(this,(Search.__proto__||Object.getPrototypeOf(Search)).apply(this,arguments));}_createClass(Search,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}));}}]);return Search;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Search);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Visibility=function(_Component){_inherits(Visibility,_Component);function Visibility(){_classCallCheck(this,Visibility);return _possibleConstructorReturn(this,(Visibility.__proto__||Object.getPrototypeOf(Visibility)).apply(this,arguments));}_createClass(Visibility,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"}));}}]);return Visibility;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Visibility);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckCircleOutline=function(_Component){_inherits(CheckCircleOutline,_Component);function CheckCircleOutline(){_classCallCheck(this,CheckCircleOutline);return _possibleConstructorReturn(this,(CheckCircleOutline.__proto__||Object.getPrototypeOf(CheckCircleOutline)).apply(this,arguments));}_createClass(CheckCircleOutline,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"none",d:"M0 0h24v24H0V0zm0 0h24v24H0V0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"}));}}]);return CheckCircleOutline;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CheckCircleOutline);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HighlightOff=function(_Component){_inherits(HighlightOff,_Component);function HighlightOff(){_classCallCheck(this,HighlightOff);return _possibleConstructorReturn(this,(HighlightOff.__proto__||Object.getPrototypeOf(HighlightOff)).apply(this,arguments));}_createClass(HighlightOff,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"}));}}]);return HighlightOff;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HighlightOff);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Add=function(_Component){_inherits(Add,_Component);function Add(){_classCallCheck(this,Add);return _possibleConstructorReturn(this,(Add.__proto__||Object.getPrototypeOf(Add)).apply(this,arguments));}_createClass(Add,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{width:"24",height:"24",viewBox:"0 0 100 100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"a",d:"M 35.00,13.16 C 35.00,13.16 84.00,13.16 84.00,13.16 95.98,13.02 97.98,15.02 98.00,27.00 98.00,27.00 98.00,67.00 98.00,67.00 98.00,71.16 98.73,79.51 96.26,82.77 93.53,86.39 89.03,85.99 85.00,86.00 85.00,86.00 23.00,86.00 23.00,86.00 17.99,86.00 5.88,87.45 3.02,82.77 1.80,80.77 2.00,77.31 2.00,75.00 2.00,75.00 2.00,24.00 2.00,24.00 2.03,17.97 1.70,15.42 8.02,13.16 8.02,13.16 35.00,13.16 35.00,13.16 Z M 19.00,18.00 C 16.46,18.00 9.45,17.56 7.60,19.02 5.62,20.59 6.00,24.70 6.00,27.00 6.00,27.00 6.00,74.00 6.00,74.00 6.14,81.49 8.26,80.99 15.00,81.00 15.00,81.00 47.00,81.00 47.00,81.00 47.00,81.00 47.00,18.00 47.00,18.00 47.00,18.00 19.00,18.00 19.00,18.00 Z M 80.00,81.00 C 82.54,81.00 89.55,81.44 91.40,79.98 93.38,78.41 93.00,74.30 93.00,72.00 93.00,72.00 93.00,25.00 93.00,25.00 92.86,17.51 90.74,18.01 84.00,18.00 84.00,18.00 52.00,18.00 52.00,18.00 52.00,18.00 52.00,81.00 52.00,81.00 52.00,81.00 80.00,81.00 80.00,81.00 Z M 80.00,27.00 C 85.05,27.03 87.04,26.55 88.00,32.00 88.00,32.00 57.00,32.00 57.00,32.00 57.00,32.00 57.00,27.00 57.00,27.00 57.00,27.00 80.00,27.00 80.00,27.00 Z M 88.00,37.00 C 88.00,37.00 88.00,42.00 88.00,42.00 88.00,42.00 57.00,42.00 57.00,42.00 57.00,42.00 57.00,37.00 57.00,37.00 57.00,37.00 88.00,37.00 88.00,37.00 Z M 88.00,47.00 C 88.00,47.00 88.00,52.00 88.00,52.00 88.00,52.00 57.00,52.00 57.00,52.00 57.00,52.00 57.00,47.00 57.00,47.00 57.00,47.00 88.00,47.00 88.00,47.00 Z M 88.00,57.00 C 88.00,57.00 88.00,62.00 88.00,62.00 88.00,62.00 57.00,62.00 57.00,62.00 57.00,62.00 57.00,57.00 57.00,57.00 57.00,57.00 88.00,57.00 88.00,57.00 Z M 88.00,67.00 C 88.00,67.00 88.00,72.00 88.00,72.00 88.00,72.00 57.00,72.00 57.00,72.00 57.00,72.00 57.00,67.00 57.00,67.00 57.00,67.00 88.00,67.00 88.00,67.00 Z"}));}}]);return Add;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Add);

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Trash=function(_Component){_inherits(Trash,_Component);function Trash(){_classCallCheck(this,Trash);return _possibleConstructorReturn(this,(Trash.__proto__||Object.getPrototypeOf(Trash)).apply(this,arguments));}_createClass(Trash,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}));}}]);return Trash;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Trash);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotificationCircle=function(_Component){_inherits(NotificationCircle,_Component);function NotificationCircle(){_classCallCheck(this,NotificationCircle);return _possibleConstructorReturn(this,(NotificationCircle.__proto__||Object.getPrototypeOf(NotificationCircle)).apply(this,arguments));}_createClass(NotificationCircle,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{viewBox:"0 0 30 30",width:"30",height:"30"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{cx:"15",cy:"15",r:"15"}));}}]);return NotificationCircle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NotificationCircle);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Restore=function(_Component){_inherits(Restore,_Component);function Restore(){_classCallCheck(this,Restore);return _possibleConstructorReturn(this,(Restore.__proto__||Object.getPrototypeOf(Restore)).apply(this,arguments));}_createClass(Restore,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"}));}}]);return Restore;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Restore);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Lock=function(_Component){_inherits(Lock,_Component);function Lock(){_classCallCheck(this,Lock);return _possibleConstructorReturn(this,(Lock.__proto__||Object.getPrototypeOf(Lock)).apply(this,arguments));}_createClass(Lock,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"}));}}]);return Lock;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Lock);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Save=function(_Component){_inherits(Save,_Component);function Save(){_classCallCheck(this,Save);return _possibleConstructorReturn(this,(Save.__proto__||Object.getPrototypeOf(Save)).apply(this,arguments));}_createClass(Save,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"}));}}]);return Save;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Save);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Payment=function(_Component){_inherits(Payment,_Component);function Payment(){_classCallCheck(this,Payment);return _possibleConstructorReturn(this,(Payment.__proto__||Object.getPrototypeOf(Payment)).apply(this,arguments));}_createClass(Payment,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"}));}}]);return Payment;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Payment);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PlayCircleOutline=function(_Component){_inherits(PlayCircleOutline,_Component);function PlayCircleOutline(){_classCallCheck(this,PlayCircleOutline);return _possibleConstructorReturn(this,(PlayCircleOutline.__proto__||Object.getPrototypeOf(PlayCircleOutline)).apply(this,arguments));}_createClass(PlayCircleOutline,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"}));}}]);return PlayCircleOutline;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PlayCircleOutline);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddYear=function(_Component){_inherits(AddYear,_Component);function AddYear(){_classCallCheck(this,AddYear);return _possibleConstructorReturn(this,(AddYear.__proto__||Object.getPrototypeOf(AddYear)).apply(this,arguments));}_createClass(AddYear,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0zm0 0h24v24H0z",fill:"none"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z"}));}}]);return AddYear;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AddYear);

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Logo.96ff4c62.png";

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-sm.a07a34e8.png";

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HomePage__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_organization_organization__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_notifications__ = __webpack_require__(75);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),role:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["n" /* getCurrentRole */])(state),currentSubRole:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["o" /* getCurrentSubRole */])(state),subRoles:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["s" /* getSubRoles */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["r" /* getLoading */])(state),orgPermissions:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_organization_organization__["p" /* getOrgPermissions */])(state),loadingNotifications:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_notifications__["k" /* loadingNotifications */])(state),notifications:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_notifications__["i" /* getNotificationsData */])(state),orgType:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_organization_organization__["t" /* getOrgType */])(state),balance:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_organization_organization__["l" /* getOrgBalance */])(state),consentRequestFee:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_organization_organization__["i" /* getConsentRequestFee */])(state),paidTillDate:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_organization_organization__["u" /* getPaidTillDate */])(state),operationAvailability:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_organization_organization__["k" /* getOperationAvailability */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getSysAdminNotifications:function getSysAdminNotifications(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_notifications__["j" /* getSysAdminNotifications */])());},getInsertorNotification:function getInsertorNotification(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_notifications__["d" /* fetchGetInsertorNotifications */])());},getValidatorNotifications:function getValidatorNotifications(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_notifications__["f" /* fetchGetValidatorNotifications */])());},getApplicantNotifications:function getApplicantNotifications(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_notifications__["h" /* getApplicantNotifications */])());},getAnchorNotifications:function getAnchorNotifications(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_notifications__["g" /* getAnchorNotifications */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__HomePage__["a" /* default */]));

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HomePage_css__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HomePage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__HomePage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__subRolesSwitch_SubRolesSwitch_container__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_reactstrap__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomePage=function(_Component){_inherits(HomePage,_Component);function HomePage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HomePage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HomePage.__proto__||Object.getPrototypeOf(HomePage)).call.apply(_ref,[this].concat(args))),_this),_this.getNotifications=function(props){switch(props.role){case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["b" /* ROLES */].SYS_ADMIN:_this.props.getSysAdminNotifications();break;case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["b" /* ROLES */].EMPLOYEE:_this.getEmployeeNotifications(props);break;case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["b" /* ROLES */].APPLICANT:_this.props.getApplicantNotifications();break;default:break;}},_this.getEmployeeNotifications=function(props){switch(props.currentSubRole){case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].INSERTER:_this.props.getInsertorNotification();break;case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].VALIDATOR:_this.props.getValidatorNotifications();break;case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ANCHOR:_this.props.getAnchorNotifications();break;default:break;}},_this.renderContent=function(){switch(_this.props.role){case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["b" /* ROLES */].SYS_ADMIN:return _this.renderAdminHomePage();case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["b" /* ROLES */].EMPLOYEE:return _this.renderEmployeeHomePage();case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["b" /* ROLES */].APPLICANT:return _this.renderApplicantHomePage();default:break;}},_this.renderWarning=function(){switch(_this.props.currentSubRole){case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ANCHOR:if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.paidTillDate)&&__WEBPACK_IMPORTED_MODULE_9_moment___default()(_this.props.paidTillDate).isBefore(__WEBPACK_IMPORTED_MODULE_9_moment___default()())){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'warning-alert-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_reactstrap__["a" /* Alert */],{color:'danger',className:'warning-alert'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'finance.pay_annual_license_alert')));}return;case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].HM:if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.operationAvailability)&&!_this.props.operationAvailability.canCreateConsentRequest){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'warning-alert-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_reactstrap__["a" /* Alert */],{color:'danger',className:'warning-alert'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'finance.contact_anchor_alert')));}return null;default:return null;}},_this.renderHint=function(){if(_this.props.currentSubRole===__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ANCHOR){var validated=_this.props.orgPermissions.validated;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hint-alert-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_reactstrap__["a" /* Alert */],{color:validated?"success":"warning",className:'hint-alert'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,validated?'home.default_departments_hint':'home.not_validated_yet')));}},_this.renderWelcomeMessage=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-welcome'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.welcome_label'));},_this.renderCommonData=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-account-and-support'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.account_and_support_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-cards-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{icon:'create',tag:'Link',to:'/account',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'account_management.label'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.account_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{icon:'info',tag:'a',to:'http://brainchainmission.org/user-forum-2',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.help_label'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.support_page_about')})));},_this.renderAdminHomePage=function(){if(_this.props.loading||_this.props.loadingNotifications){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loading-home-page-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}//TODO: change notifications for pending and validated ARR
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-admin-page-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.organizations_select_button')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-cards-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'admin-orgs-card',icon:'add',to:'/register-org',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'register_org.register_org_label'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.register_org_page_about'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].FA)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'admin-orgs-card',icon:'create',to:'/organizations',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.orgs_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.organizations_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'admin-orgs-card',icon:'check_box',to:'/validate-organizations',notification:_this.getNotificationByType(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["l" /* NOTIFICATION_TYPES */].PENDING_ORGANIZATIONS),title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.validate_organizations_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.validate_organizations_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'admin-orgs-card',icon:'lock',to:'/security',notification:_this.getNotificationByType(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["l" /* NOTIFICATION_TYPES */].ADMIN_SECURITY_NOTIFICATIONS),title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.security_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.security_page_admin_about'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].PA)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:"home-page-admin-subtitle"+(!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].FA)?' hidden':'')},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.payments_page_button')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-cards-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'admin-payment-card',icon:'create',to:'/organizations-payments',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.orgs_payments_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.orgs_payments_page_about'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].FA)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'admin-payment-card',icon:'create',to:'/commissions',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.commissions_list_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.commissions_list_page_about'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ROOT)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'admin-payment-card',icon:'payment',to:'/due-payments',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.due_payments_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.due_payments_page_about'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].FA)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'admin-payment-card',icon:'info',to:'/payments-history',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.payments_history_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.payments_history_page_about'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].FA)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:"home-page-admin-subtitle"+(!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].PA)?' hidden':'')},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.domains_page_button')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-cards-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'admin-arr-card',icon:'check_box',to:'/pending-accreditation-requests-by-domains',notification:_this.getNotificationByType(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["l" /* NOTIFICATION_TYPES */].UNREFERENCED_ACCREDITATION_REQUESTS_BY_DOMAINS),title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.pending_accreditation_requests_list_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.pending_accreditation_requests_list_admin_page_about'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].PA)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'admin-arr-card',icon:'create',to:'/validated-domains',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.validated_accreditation_requests_list_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.validated_accreditation_requests_list_admin_page_about'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].PA)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:"home-page-admin-subtitle"+(!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ROOT)?' hidden':'')},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.assistants_page_button')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-cards-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'admin-assistants-card',icon:'create',to:'/assistants-management',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.assistants_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.assistants_page_about'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ROOT)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'admin-assistants-card',icon:'create',to:'/business-ambassadors',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.business_ambassadors_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.business_ambassadors_page_about'),hidden:!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ROOT)})));},_this.renderEmployeeHomePage=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-employee-page-container'},_this.renderSubRoleSelect(),_this.renderSubRoleData());},_this.renderSubRoleSelect=function(){if(_this.props.subRoles&&_this.props.subRoles.length>1&&_this.props.role!==__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["b" /* ROLES */].SYS_ADMIN){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-sub-role-select-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.choose_role_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__subRolesSwitch_SubRolesSwitch_container__["a" /* default */],null));}},_this.renderSubRoleData=function(){if(_this.props.loading||_this.props.loadingNotifications){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loading-home-page-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}switch(_this.props.currentSubRole){case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].ANCHOR:return _this.renderAnchorData();case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].INSERTER:return _this.renderInserterData();case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].VALIDATOR:return _this.renderValidatorData();case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].HM:return _this.renderHMData();case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["c" /* SUB_ROLES */].BO:return _this.renderBOData();case __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["a" /* NO_SUB_ROLES */]:return;default:break;}},_this.renderAnchorData=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-anchor-data-container'},_this.props.subRoles&&_this.props.subRoles.length>1?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.anchor_pages_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-cards-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'anchor-card',icon:'info',to:'/payment',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.payment_label'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.payment_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'anchor-card',icon:'create',to:'/org-settings',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.org_management_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'anchor-card',icon:'person',to:'/organization-staff',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.staff_members_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.organization_staff_page_about')}),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.orgPermissions)&&_this.props.orgPermissions.hasIVs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'anchor-card',icon:'create',to:'/groups-management',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.groups_management_page_button')}):null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.orgPermissions)&&!_this.props.orgPermissions.hasIVs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'anchor-card',icon:'create',to:'/groups-management',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.departments_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.departments_page_about')}):null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.orgPermissions)&&_this.props.orgPermissions.hasIVs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'anchor-card',icon:'create',to:'/accreditation-requests-by-group',notification:_this.getNotificationByType(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["l" /* NOTIFICATION_TYPES */].UNREFERENCED_ACCREDITATION_REQUESTS_BY_AGS),title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.accreditation_requests_list_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.accreditation_requests_list_anchor_page_about')}):null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.orgPermissions)&&_this.props.orgPermissions.hasIVs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'anchor-card',icon:'lock',to:'/security',notification:_this.getNotificationByType(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["l" /* NOTIFICATION_TYPES */].ANCHOR_SECURITY_GOT_IT),title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.security_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.security_page_anchor_about')}):null));},_this.renderInserterData=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-inserter-data-container'},_this.props.subRoles&&_this.props.subRoles.length>1?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.inserter_pages_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-cards-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'inserter-card',icon:'add',to:'/insert-accreditation',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.insert_accreditation_page_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'inserter-card',icon:'create',to:'/review-accreditations',notification:_this.getNotificationByType(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["l" /* NOTIFICATION_TYPES */].REVIEW_FAILED_ACCREDITATIONS),title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.review_accreditations_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.review_accreditations_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'inserter-card',icon:'add',to:'/bulk-accreditations-upload',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.bulk_jobs_list_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.bulk_accreditations_upload_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'inserter-card',icon:'create',to:'/pending-accreditation-requests',notification:_this.getNotificationByType(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["l" /* NOTIFICATION_TYPES */].PENDING_ACCREDITATION_REQUESTS),title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.pending_accreditation_requests_page_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'inserter-card',icon:'lock',to:'/security',notification:_this.getNotificationByType(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["l" /* NOTIFICATION_TYPES */].INSERTER_SECURITY_NO_CERTIFICATE),title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.security_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.security_page_inserter_about')})));},_this.renderValidatorData=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-validator-data-container'},_this.props.subRoles&&_this.props.subRoles.length>1?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.validator_pages_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-cards-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'validator-card',icon:'check_box',to:'/validate-accreditations',notification:_this.getNotificationByType(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["l" /* NOTIFICATION_TYPES */].VALIDATE_ACCREDITATIONS),title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.validate_accreditations_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.validate_accreditations_page_about')})));},_this.renderHMData=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-hm-data-container'},_this.props.subRoles&&_this.props.subRoles.length>1?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.hm_pages_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-cards-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'hm-card',icon:'add',to:'/credentials-verification-request',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.verification_request_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.credentials_verification_request_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'hm-card',icon:'create',to:'/consent-requests',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.consent_requests_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.consent_requests_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'hm-card',icon:'create',to:'/bulk-consent-requests',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.bulk_consent_requests_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.bulk_consent_requests_page_about')})));},_this.renderBOData=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-bo-data-container'},_this.props.subRoles&&_this.props.subRoles.length>1?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.bo_pages_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-cards-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'bo-card',icon:'create',to:'/consent-requests',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.consent_requests_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.consent_requests_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'bo-card',icon:'create',to:'/bulk-consent-requests',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.bulk_consent_requests_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.bulk_consent_requests_page_about')})));},_this.renderApplicantHomePage=function(){if(_this.props.loading||_this.props.loadingNotifications){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loading-home-page-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-applicant-page-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.applicant_accreditations_select_button')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-cards-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'applicant-accreditations-card',icon:'create',to:'/certified-accreditations',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.certified_accreditations_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.certified_accreditations_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'applicant-accreditations-card',icon:'check_box',to:'/pending-accreditations',notification:_this.getNotificationByType(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["l" /* NOTIFICATION_TYPES */].PENDING_ACCREDITATIONS),title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.pending_accreditations_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.pending_accreditations_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'applicant-accreditations-card',icon:'create',to:'/verified-identities',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.vids_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.verified_identities_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'applicant-accreditations-card',icon:'create',to:'/self-study-books',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.self_study_books_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.self_study_books_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'applicant-accreditations-card',icon:'create',to:'/accreditation-requests-list',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.accreditation_requests_list_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.accreditation_requests_list_applicant_page_about')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'applicant-consents-title'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.applicant_consents_select_button')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-cards-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'applicant-consents-card',icon:'create',to:'/prior-consents',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.prior_consents_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.prior_consents_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'applicant-consents-card',icon:'check_box',to:'/pending-consents',notification:_this.getNotificationByType(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["l" /* NOTIFICATION_TYPES */].PENDING_CONSENTS),title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.pending_consents_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.pending_consents_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'applicant-consents-card',icon:'create',to:'/active-consents',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.active_consents_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.active_consents_page_about')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cardWithLink_CardWithLink_container__["a" /* default */],{tag:'Link',className:'applicant-consents-card',icon:'create',to:'/consents-history',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'main.consents_history_page_button'),text:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'home.consents_history_page_about')})));},_this.getNotificationByType=function(type){if(_this.props.loadingNotifications||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.notifications)){return null;}return{type:type,data:_this.props.notifications[type]};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HomePage,[{key:'componentWillMount',value:function componentWillMount(){this.getNotifications(this.props);}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(this.props.loading&&!nextProps.loading){this.getNotifications(nextProps);}}},{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.role)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-page-container'},this.renderWelcomeMessage(),this.renderWarning(),this.renderHint(),this.renderContent(),this.renderCommonData());}}]);return HomePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);HomePage.propTypes={loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,role:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,currentSubRole:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,subRoles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,orgPermissions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,loadingNotifications:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,notifications:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,balance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,consentRequestFee:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,paidTillDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,operationAvailability:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,getSysAdminNotifications:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getInsertorNotification:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getValidatorNotifications:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getApplicantNotifications:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getAnchorNotifications:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (HomePage);

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CardWithLink__ = __webpack_require__(644);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__CardWithLink__["a" /* default */]));

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CardWithLink_css__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CardWithLink_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CardWithLink_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CardWithLink=function(_Component){_inherits(CardWithLink,_Component);function CardWithLink(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CardWithLink);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CardWithLink.__proto__||Object.getPrototypeOf(CardWithLink)).call.apply(_ref,[this].concat(args))),_this),_this.renderCardContent=function(){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-with-link-icon-container',key:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__iconContainer_IconContainer__["a" /* default */],{className:'card-with-link-icon',icon:_this.props.icon})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-with-link-info-container',key:'info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-with-link-label'},_this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-with-link-text'},_this.props.text||'')),_this.renderNotification()];},_this.renderNotification=function(){if(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(_this.props.notification)||__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(_this.props.notification.data)||_this.props.notification.data===0){return null;}var titleText=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'notifications.'+_this.props.notification.type);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notifications-container',key:'notification',title:titleText?titleText.replace('{number}',_this.props.notification.data):null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Badge */],{pill:true},_this.props.notification.data)));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CardWithLink,[{key:'render',value:function render(){if(this.props.hidden){return null;}switch(this.props.tag){case'a':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["A" /* NavLink */],{className:"card-with-link-container "+(this.props.className||""),href:this.props.to,target:'_blank'},this.renderCardContent());case'Link':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["A" /* NavLink */],{className:"card-with-link-container "+(this.props.className||""),tag:__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],to:this.props.to},this.renderCardContent());default:return null;}}}]);return CardWithLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CardWithLink.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,to:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,notification:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,tag:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,hidden:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (CardWithLink);

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubRolesSwitch__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_notifications__ = __webpack_require__(75);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),selectedLanguage:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["d" /* getSelectedLanguage */])(state),currentSubRole:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_role__["o" /* getCurrentSubRole */])(state),subRoles:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_role__["s" /* getSubRoles */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChangeCurrentSubRole:function onChangeCurrentSubRole(subRole){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_role__["f" /* changeCurrentSubRole */])(subRole));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_notifications__["b" /* clearState */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__SubRolesSwitch__["a" /* default */]));

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubRolesSwitch_css__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubRolesSwitch_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SubRolesSwitch_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_account_role__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubRolesSwitch=function(_Component){_inherits(SubRolesSwitch,_Component);function SubRolesSwitch(props){_classCallCheck(this,SubRolesSwitch);var _this=_possibleConstructorReturn(this,(SubRolesSwitch.__proto__||Object.getPrototypeOf(SubRolesSwitch)).call(this,props));_this.onResizeWindow=function(){_this.updateIndicator(_this.props.currentSubRole);};_this.onChangeCurrentSubRole=function(subRole){return function(){_this.updateIndicator(subRole,true);_this.props.onChangeCurrentSubRole(subRole);};};_this.updateIndicator=function(subRole){var isAnimate=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var itemIndex=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.indexOf(_this.props.subRoles,subRole);var currentItemNode=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this.itemsRefs[itemIndex]);var leftPosition=0;var currentItemInfo=currentItemNode?currentItemNode.getBoundingClientRect():null;if(itemIndex>0&&currentItemInfo){var firstItemNode=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this.itemsRefs[0]);if(firstItemNode){var firstItemInfo=firstItemNode.getBoundingClientRect();leftPosition=currentItemInfo.x-firstItemInfo.x;}}_this.setState({indicatorCurrentSubRole:subRole,indicatorWidth:currentItemInfo?currentItemInfo.width:0,indicatorPosition:leftPosition,isIndicatorAnimated:isAnimate});};_this.itemsRefs=[];_this.state={indicatorCurrentSubRole:null,indicatorWidth:0,indicatorPosition:0,isIndicatorAnimated:false};return _this;}_createClass(SubRolesSwitch,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.onResizeWindow);this.updateIndicator(this.props.currentSubRole);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.currentSubRole!==this.props.currentSubRole&&this.state.indicatorCurrentSubRole!==this.props.currentSubRole){this.updateIndicator(this.props.currentSubRole);}else if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(prevProps.subRoles,this.props.subRoles)||!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(prevProps.selectedLanguage,this.props.selectedLanguage)){this.updateIndicator(this.props.currentSubRole);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.onResizeWindow);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sub-roles-switch-container  '+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toLower(this.props.currentSubRole)},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(this.props.subRoles,function(subRole,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sub-roles-switch-item',key:subRole,onClick:_this2.onChangeCurrentSubRole(subRole),ref:function ref(elem){_this2.itemsRefs[i]=elem;}},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'roles.'+__WEBPACK_IMPORTED_MODULE_5__reducers_account_role__["d" /* SUB_ROLES_TRANSLATIONS */][subRole]));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sub-roles-switch-indicator',style:{width:this.state.indicatorWidth,left:this.state.indicatorPosition,transition:this.state.isIndicatorAnimated?"":"none"}}));}}]);return SubRolesSwitch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubRolesSwitch.propTypes={currentSubRole:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,subRoles:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (SubRolesSwitch);

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserSubRoleMissingModal__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__ = __webpack_require__(20);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["u" /* isUserSubRoleMissing */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["z" /* setUserSubRoleMissing */])(false));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__UserSubRoleMissingModal__["a" /* default */]));

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserSubRoleMissingModal_css__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserSubRoleMissingModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UserSubRoleMissingModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserSubRoleMissingModal=function(_Component){_inherits(UserSubRoleMissingModal,_Component);function UserSubRoleMissingModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserSubRoleMissingModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserSubRoleMissingModal.__proto__||Object.getPrototypeOf(UserSubRoleMissingModal)).call.apply(_ref,[this].concat(args))),_this),_this.onSubmit=function(){_this.props.onCancel();if(!_this.props.updateSubRolesOnly){_this.props.onSubmit();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserSubRoleMissingModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,"sub_role_missing.no_access_label")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.updateSubRolesOnly?null:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,"sub_role_missing.continue_label"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-sub-role-missing-modal-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'user-sub-role-missing-modal-button olive-green-btn',onClick:this.onSubmit},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].okey_button)))));}}]);return UserSubRoleMissingModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UserSubRoleMissingModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,updateSubRolesOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (UserSubRoleMissingModal);

/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrgPermissionsMissingModal__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_organization_organization__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["t" /* isOrgPermissionsMissing */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_organization_organization__["f" /* fetchGetOrgForApp */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["x" /* setOrgPermissionsMissing */])(false));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__OrgPermissionsMissingModal__["a" /* default */]));

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrgPermissionsMissingModal_css__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrgPermissionsMissingModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__OrgPermissionsMissingModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrgPermissionsMissingModal=function(_Component){_inherits(OrgPermissionsMissingModal,_Component);function OrgPermissionsMissingModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OrgPermissionsMissingModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OrgPermissionsMissingModal.__proto__||Object.getPrototypeOf(OrgPermissionsMissingModal)).call.apply(_ref,[this].concat(args))),_this),_this.onSubmit=function(){_this.props.onCancel();_this.props.onSubmit();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OrgPermissionsMissingModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,"org_permissions_missing.no_access_label")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,"org_permissions_missing.continue_label"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-permissions-missing-modal-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'org-permissions-missing-modal-button olive-green-btn',onClick:this.onSubmit},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].okey_button)))));}}]);return OrgPermissionsMissingModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OrgPermissionsMissingModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (OrgPermissionsMissingModal);

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageNotFoundComponent_css__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageNotFoundComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PageNotFoundComponent_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageNotFoundComponent=function(_Component){_inherits(PageNotFoundComponent,_Component);function PageNotFoundComponent(){_classCallCheck(this,PageNotFoundComponent);return _possibleConstructorReturn(this,(PageNotFoundComponent.__proto__||Object.getPrototypeOf(PageNotFoundComponent)).apply(this,arguments));}_createClass(PageNotFoundComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-not-found-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'page_not_found.page_not_found_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'page_not_found.sorry_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'page_not_found.cause_label')));}}]);return PageNotFoundComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PageNotFoundComponent.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PageNotFoundComponent);

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ServerErrorComponent__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__ServerErrorComponent__["a" /* default */]));

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ServerErrorComponent_css__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ServerErrorComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ServerErrorComponent_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ServerErrorComponent=function(_Component){_inherits(ServerErrorComponent,_Component);function ServerErrorComponent(){_classCallCheck(this,ServerErrorComponent);return _possibleConstructorReturn(this,(ServerErrorComponent.__proto__||Object.getPrototypeOf(ServerErrorComponent)).apply(this,arguments));}_createClass(ServerErrorComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-error-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,"500 - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'server_error.server_error_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'server_error.sorry_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'server_error.cause_label')));}}]);return ServerErrorComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ServerErrorComponent.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ServerErrorComponent);

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelpComponent__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_account_login__ = __webpack_require__(17);
var mapStateToProps=function mapStateToProps(state){return{isAuthorised:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_login__["f" /* getLoginAuthoriseStatus */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__HelpComponent__["a" /* default */]));

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelpComponent_css__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelpComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__HelpComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HelpComponent=function(_Component){_inherits(HelpComponent,_Component);function HelpComponent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HelpComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HelpComponent.__proto__||Object.getPrototypeOf(HelpComponent)).call.apply(_ref,[this].concat(args))),_this),_this.renderUnauthorizedInfo=function(){if(!_this.props.isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'help-unauthorized-info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/login',label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'login.back_to_login_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'help.questions_and_answers_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'help-unauthorized-info-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'help.question_activation_email')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'help.answer_activation_email_start'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:'/resend-activation'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'help.answer_activation_email_link')),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'help.answer_activation_email_end')))));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HelpComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'help-container'},this.renderUnauthorizedInfo());}}]);return HelpComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);HelpComponent.propTypes={isAuthorised:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (HelpComponent);

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaymentComponent__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_organization_organization__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_location__ = __webpack_require__(21);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),orgName:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organization__["o" /* getOrgName */])(state),orgType:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organization__["t" /* getOrgType */])(state),price:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organization__["q" /* getOrgPrice */])(state),orgPermissions:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organization__["p" /* getOrgPermissions */])(state),orgCountryCode:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organization__["m" /* getOrgCountryCode */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["e" /* getCountriesData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},setCurrentContinentByCountry:function setCurrentContinentByCountry(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["i" /* setCurrentContinentByCountry */])(countryCode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaymentComponent__["a" /* default */]));

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentComponent_css__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PaymentComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_storageApi__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var requiredSelectFields=['countryCode'];var customStyles={option:function option(provided,state){return Object.assign({},provided,{":hover":{backgroundColor:state.isSelected?'#89aa11':'rgba(137, 170, 17, 0.44)'},backgroundColor:state.isSelected?'#89aa11':'white',cursor:'pointer',fontSize:'.9rem',paddingTop:'0',paddingBottom:'0',textOverflow:'ellipsis',overflow:'hidden'});},control:function control(provided,state){return Object.assign({},provided,{fontSize:'.875rem',cursor:'pointer',minHeight:'calc(1.5em + .5rem + 2px)',height:'calc(1.5em + .5rem + 2px)',border:'1px solid #ced4da',":hover":{border:'1px solid #ced4da'},borderColor:state.isFocused?'#80bdff':'#ced4da',boxShadow:state.isFocused?'0 0 0 0.2rem rgba(0,123,255,.25)':'none'});},dropdownIndicator:function dropdownIndicator(provided){return Object.assign({},provided,{padding:'0 5px 0 0'});},indicatorSeparator:function indicatorSeparator(){return{display:'none'};},menu:function menu(styles){return Object.assign({},styles,{marginTop:'0',marginBottom:'0',borderRadius:'0'});},menuList:function menuList(styles){return Object.assign({},styles,{paddingTop:'0',paddingBottom:'0'});}};var PaymentComponent=function(_Component){_inherits(PaymentComponent,_Component);function PaymentComponent(props){_classCallCheck(this,PaymentComponent);var _this=_possibleConstructorReturn(this,(PaymentComponent.__proto__||Object.getPrototypeOf(PaymentComponent)).call(this,props));_this.renderLocationForm=function(){var continentParams={value:"continentCode",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label),onChange:_this.handleChangeContinent,type:'select',content:__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),isDisabled:!_this.props.continents,isRequired:true};var countryParams={value:"countryCode",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),onChange:_this.handleChangeCountry,type:'select',content:__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isDisabled:!_this.props.countries,isRequired:true};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["n" /* Form */],{onSubmit:_this.handleChangeLocationSubmit,className:'location-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'location-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'location-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'location-controls-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'location-select-container'},_this.getSelectElement(continentParams)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'location-select-container'},_this.getSelectElement(countryParams)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["c" /* Button */],{type:'submit',color:'link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'save-location-icon',icon:'save',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'discard-location-icon',icon:'clear',onClick:_this.handleDiscardLocationChange,title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)}))));};_this.getSelectElement=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,key:params.title,selectedOption:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];}),options:params.content,onSelect:params.onChange,placeholder:params.placeholder,disabled:params.isDisabled,requiredFieldError:_this.state.requiredFieldError===params.value,customStyles:customStyles});};_this.handleChangeContinent=function(selectedOption){_this.props.onContinentSet(selectedOption.value);_this.setState({countryCode:""});};_this.handleChangeCountry=function(selectedOption){_this.setState({countryCode:selectedOption.value});};_this.renderPriceData=function(){if(_this.props.price.annualFee&&_this.props.price.annualFee.amount!==_this.props.price.pricingPreset.annualFee.amount||_this.props.price.consentRequestFee&&_this.props.price.consentRequestFee.amount!==_this.props.price.pricingPreset.consentRequestFee.amount){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{key:'default-preset'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'finance.default_preset_label').replace('{annual_fee_amount}',_this.props.price.pricingPreset.annualFee.amount+__WEBPACK_IMPORTED_MODULE_7__constants_constants__["g" /* CURRENCIES */][_this.props.price.pricingPreset.annualFee.currency]).replace('{consent_request_fee_amount}',_this.props.price.pricingPreset.consentRequestFee.amount+__WEBPACK_IMPORTED_MODULE_7__constants_constants__["g" /* CURRENCIES */][_this.props.price.pricingPreset.consentRequestFee.currency])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{key:'agreed-deviation'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'finance.agreed_deviation_label').replace('{annual_fee_amount}',(_this.props.price.annualFee?_this.props.price.annualFee.amount:_this.props.price.pricingPreset.annualFee.amount)+__WEBPACK_IMPORTED_MODULE_7__constants_constants__["g" /* CURRENCIES */][_this.props.price.annualFee?_this.props.price.annualFee.currency:_this.props.price.pricingPreset.annualFee.currency]).replace('{consent_request_fee_amount}',(_this.props.price.consentRequestFee?_this.props.price.consentRequestFee.amount:_this.props.price.pricingPreset.consentRequestFee.amount)+__WEBPACK_IMPORTED_MODULE_7__constants_constants__["g" /* CURRENCIES */][_this.props.price.consentRequestFee?_this.props.price.consentRequestFee.currency:_this.props.price.pricingPreset.consentRequestFee.currency])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{key:'period'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'finance.period_label')+': ',__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.price.validTill)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'finance.forever_label'):__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'finance.till_label')+' '+__WEBPACK_IMPORTED_MODULE_12_moment___default()(_this.props.price.validTill).format('L')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{key:'list-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'payment.list_label'))];}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{key:'request-cost'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'finance.request_cost_label')+": "+_this.props.price.pricingPreset.consentRequestFee.amount+__WEBPACK_IMPORTED_MODULE_7__constants_constants__["g" /* CURRENCIES */][_this.props.price.pricingPreset.consentRequestFee.currency]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{key:'list-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'payment.list_label')+' '+_this.props.price.pricingPreset.annualFee.amount+__WEBPACK_IMPORTED_MODULE_7__constants_constants__["g" /* CURRENCIES */][_this.props.price.pricingPreset.annualFee.currency])];};_this.toggle=function(){_this.setState({isOpenBankInfo:!_this.state.isOpenBankInfo});};_this.getEduOrgNotes=function(){if(_this.props.orgType===__WEBPACK_IMPORTED_MODULE_6__reducers_organization_organizations__["b" /* EDU_ORG */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'payment.edu_org_message_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'payment.edu_org_message_company_checks')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'payment.edu_org_message_list_title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'payment.edu_org_message_list_item_one')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'payment.edu_org_message_list_item_two'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'payment.edu_org_message_joining')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'payment.edu_org_message_note_title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'payment.edu_org_message_note')));}};_this.handleChangeLocation=function(){_this.setState({isEditCountry:true});};_this.handleChangeLocationSubmit=function(e){e.preventDefault();if(_this.checkRequiredSelectFields()){return;}_this.setState({isEditCountry:false,bankDataCountryCode:_this.state.countryCode,requiredFieldError:null});__WEBPACK_IMPORTED_MODULE_11__utils_storageApi__["a" /* StorageApi */].setBankDataCountryCode(_this.state.countryCode);};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(requiredSelectFields,function(field){if(!_this.state[field]&&!error){error=field;}});_this.setState({requiredFieldError:error});return error;};_this.handleDiscardLocationChange=function(){if(_this.state.countryCode!==_this.state.bankDataCountryCode){_this.props.setCurrentContinentByCountry(_this.state.bankDataCountryCode);}_this.setState({isEditCountry:false,countryCode:_this.state.bankDataCountryCode,requiredFieldError:null});};var bankDataCountryCode=__WEBPACK_IMPORTED_MODULE_11__utils_storageApi__["a" /* StorageApi */].getBankDataCountryCode()||_this.props.orgCountryCode;_this.state={isOpenBankInfo:false,continentCode:"",countryCode:bankDataCountryCode,isEditCountry:false,bankDataCountryCode:bankDataCountryCode,requiredFieldError:null};return _this;}_createClass(PaymentComponent,[{key:'componentDidMount',value:function componentDidMount(){this.props.setCurrentContinentByCountry(this.state.bankDataCountryCode);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.continentCode!==this.state.continentCode){this.setState({continentCode:nextProps.continentCode});}}},{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.price)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.title')),this.props.orgPermissions.hasIVs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.total_money_label').replace("{orgName}",this.props.orgName)+"0"):null,this.props.orgPermissions.hasIVs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'finance.prices_label')),this.state.isEditCountry?this.renderLocationForm():__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'location-info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)+": ",__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].countries)[this.state.bankDataCountryCode]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'edit-location-icon',icon:'create',onClick:this.handleChangeLocation,title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].edit_button)})),this.renderPriceData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'payment-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.account_id_label').replace("{iban}",__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getBankDataByCountry(this.state.bankDataCountryCode,this.props.translation),'iban_number')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'payment-info-icon',icon:'info',onClick:this.toggle,title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.bank_details_label')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["i" /* Collapse */],{isOpen:this.state.isOpenBankInfo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["d" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["e" /* CardBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.about_us_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.bank_data_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bank-data-container'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getBankDataByCountry(this.state.bankDataCountryCode,this.props.translation),'bank_data')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.create_account_label')+' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.create_account_message_label').replace("{orgName}",this.props.orgName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.annual_fee_label')+' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.annual_fee_message_label').replace("{orgName}",this.props.orgName)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.getEduOrgNotes(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.wire_delay_label')));}}]);return PaymentComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PaymentComponent.propTypes={orgName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,orgType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,orgPermissions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,orgCountryCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,continentCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onContinentSet:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setCurrentContinentByCountry:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PaymentComponent);

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var shallowEqual = function shallowEqual(newValue, oldValue) {
  return newValue === oldValue;
};

var simpleIsEqual = function simpleIsEqual(newArgs, lastArgs) {
  return newArgs.length === lastArgs.length && newArgs.every(function (newArg, index) {
    return shallowEqual(newArg, lastArgs[index]);
  });
};

function index (resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = simpleIsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var result = function result() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export flush */
/* unused harmony export hydrate */
/* unused harmony export cx */
/* unused harmony export merge */
/* unused harmony export getRegisteredStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return injectGlobal; });
/* unused harmony export keyframes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return css; });
/* unused harmony export sheet */
/* unused harmony export caches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__(669);


var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = Object(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(context),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    caches = _createEmotion.caches;



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(37)))

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_hash__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__);






var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    return oldProcessStyleValue(key, value);
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'function':
        if (false) {
          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
        }

        toAdd = classnames([arg()]);
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};
var isBrowser = typeof document !== 'undefined';

/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = "production" === 'production'; // the big drawback here is that the css won't be editable in devtools

    this.tags = [];
    this.ctr = 0;
    this.opts = options;
  }

  var _proto = StyleSheet.prototype;

  _proto.inject = function inject() {
    if (this.injected) {
      throw new Error('already injected!');
    }

    this.tags[0] = makeStyleTag(this.opts);
    this.injected = true;
  };

  _proto.speedy = function speedy(bool) {
    if (this.ctr !== 0) {
      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
      throw new Error("cannot change speedy now");
    }

    this.isSpeedy = !!bool;
  };

  _proto.insert = function insert(rule, sourceMap) {
    // this is the ultrafast version, works across browsers
    if (this.isSpeedy) {
      var tag = this.tags[this.tags.length - 1];
      var sheet = sheetForTag(tag);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn('illegal rule', rule); // eslint-disable-line no-console
        }
      }
    } else {
      var _tag = makeStyleTag(this.opts);

      this.tags.push(_tag);

      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
    }

    this.ctr++;

    if (this.ctr % 65000 === 0) {
      this.tags.push(makeStyleTag(this.opts));
    }
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0; // todo - look for remnants in document.styleSheets

    this.injected = false;
  };

  return StyleSheet;
}();

function createEmotion(context, options) {
  if (context.__SECRET_EMOTION__ !== undefined) {
    return context.__SECRET_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (false) {
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var current;

  function insertRule(rule) {
    current += rule;

    if (isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default()(insertRule);
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new StyleSheet(options);

  if (isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        if (this === undefined && "production" !== 'production') {
          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    if (Array.isArray(obj)) {
      obj.forEach(function (interpolation) {
        string += handleInterpolation.call(this, interpolation, false);
      }, this);
    } else {
      Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] !== 'object') {
          if (caches.registered[obj[key]] !== undefined) {
            string += key + "{" + caches.registered[obj[key]] + "}";
          } else {
            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
          }
        } else {
          if (key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
            obj[key].forEach(function (value) {
              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
            });
          } else {
            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
          }
        }
      }, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name;
  var stylesWithLabel;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createClassName = function createClassName(styles, identifierName) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__emotion_hash__["a" /* default */])(styles + identifierName) + identifierName;
  };

  if (false) {
    var oldCreateClassName = createClassName;
    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

    createClassName = function createClassName(styles, identifierName) {
      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
        currentSourceMap = sourceMap;
        return '';
      }), identifierName);
    };
  }

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += "-" + p1;
      return '';
    });
    name = createClassName(styles, identifierName);
    return styles;
  };

  if (false) {
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    if (caches.inserted[name] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[name] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + "-" + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert("." + selector, styles);
    return selector;
  };

  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = "animation-" + name;
    insert('', "@keyframes " + animation + "{" + styles + "}");
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    var styles = createStyles.apply(this, arguments);
    insert('', styles);
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function cx() {
    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classNames[_key2] = arguments[_key2];
    }

    return merge(classnames(classNames));
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  function hydrate(ids) {
    ids.forEach(hydrateSingleId);
  }

  function flush() {
    if (isBrowser) {
      sheet.flush();
      sheet.inject();
    }

    caches.inserted = {};
    caches.registered = {};
  }

  if (isBrowser) {
    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
    Array.prototype.forEach.call(chunks, function (node) {
      // $FlowFixMe
      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
    });
  }

  var emotion = {
    flush: flush,
    hydrate: hydrate,
    cx: cx,
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    css: css,
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_EMOTION__ = emotion;
  return emotion;
}

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e, m).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        switch (d.constructor) {
          case Array:
            for (var c = 0, e = d.length; c < e; ++c) {
              T(d[c]);
            }

            break;

          case Function:
            S[A++] = d;
            break;

          case Boolean:
            Y = !!d | 0;
        }

    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(676)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104)))

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(279);
var bytesToUuid = __webpack_require__(280);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(279);
var bytesToUuid = __webpack_require__(280);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavBarWithRoles__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_organization_organization__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{role:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["n" /* getCurrentRole */])(state),currentSubRole:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["o" /* getCurrentSubRole */])(state),subRoles:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["s" /* getSubRoles */])(state),currentGroup:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["k" /* getCurrentGroup */])(state),groups:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["p" /* getGroupsForSubRole */])(state),balance:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_organization_organization__["l" /* getOrgBalance */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["r" /* getLoading */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChangeCurrentSubRole:function onChangeCurrentSubRole(subRole){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["f" /* changeCurrentSubRole */])(subRole));},onChangeCurrentGroup:function onChangeCurrentGroup(group){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["e" /* changeCurrentGroup */])(group));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__NavBarWithRoles__["a" /* default */]));

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavBarWithRoles_css__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavBarWithRoles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__NavBarWithRoles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__organizationConsentManagement_consentRequestsFilter_ConsentRequestsFilter_container__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_constants__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customStyles={option:function option(provided,state){return Object.assign({},provided,{":hover":{backgroundColor:state.isSelected?'#89aa11':'rgba(137, 170, 17, 0.44)'},backgroundColor:state.isSelected?'#89aa11':'white',cursor:'pointer',width:'140px',fontSize:'.9rem',paddingTop:'0',paddingBottom:'0',textOverflow:'ellipsis',overflow:'hidden'});},control:function control(provided,state){return Object.assign({},provided,{fontSize:'.875rem',cursor:'pointer',width:'140px',minHeight:'calc(1.5em + .5rem + 2px)',height:'calc(1.5em + .5rem + 2px)',border:'1px solid #ced4da',":hover":{border:'1px solid #ced4da'},borderColor:state.isFocused?'#80bdff':'#ced4da',boxShadow:state.isFocused?'0 0 0 0.2rem rgba(0,123,255,.25)':'none'});},dropdownIndicator:function dropdownIndicator(provided){return Object.assign({},provided,{padding:'0 5px 0 0'});},indicatorSeparator:function indicatorSeparator(){return{display:'none'};},menu:function menu(styles){return Object.assign({},styles,{marginTop:'0',marginBottom:'0',borderRadius:'0'});},menuList:function menuList(styles){return Object.assign({},styles,{paddingTop:'0',paddingBottom:'0'});}};var NavBarWithRoles=function(_Component){_inherits(NavBarWithRoles,_Component);function NavBarWithRoles(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavBarWithRoles);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavBarWithRoles.__proto__||Object.getPrototypeOf(NavBarWithRoles)).call.apply(_ref,[this].concat(args))),_this),_this.getBalanceLabel=function(){if(_this.props.currentSubRole===__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["c" /* SUB_ROLES */].ANCHOR&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.balance)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Nav */],{className:'ml-auto nav-bar-balance-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.balance_label')+": "+_this.props.balance.amount+__WEBPACK_IMPORTED_MODULE_9__constants_constants__["g" /* CURRENCIES */][_this.props.balance.currency]));}},_this.getSubRolesOptions=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_this.props.subRoles,function(role){return{value:role,label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'roles.'+__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["d" /* SUB_ROLES_TRANSLATIONS */][role])};});},_this.getSubRoleSelectedOption=function(){var selectedElem=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this.props.subRoles,function(role){return role===_this.props.currentSubRole;});if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(selectedElem)){return null;}return{value:selectedElem,label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'roles.'+__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["d" /* SUB_ROLES_TRANSLATIONS */][selectedElem])};},_this.getGroupsOptions=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_this.props.groups,function(elem){return{value:elem.id,label:elem.name,title:elem.name};});},_this.getComponents=function(_){return{Option:function Option(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:props.data.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* components */].Option,props));}};},_this.getGroupSelectedOption=function(){var selectedElem=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this.props.groups,function(elem){return elem.id===_this.props.currentGroup;});if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(selectedElem)){return null;}return{value:selectedElem.id,label:selectedElem.name};},_this.handleChangeSubRole=function(selectedOption){_this.props.onChangeCurrentSubRole(selectedOption.value);},_this.handleChangeGroup=function(selectedOption){_this.props.onChangeCurrentGroup(selectedOption.value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavBarWithRoles,[{key:'render',value:function render(){if(this.props.hidden||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.currentSubRole)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.role)||this.props.role!==__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["b" /* ROLES */].EMPLOYEE||this.props.currentSubRole===__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["a" /* NO_SUB_ROLES */]){return null;}if(this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["B" /* Navbar */],{color:'light',light:true,className:'navbar-expand-custom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["D" /* NavbarToggler */],{id:'sub-roles-navbar-toggler',className:'sub-roles-navbar-toggler'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* UncontrolledCollapse */],{className:'sub-roles-collapse',navbar:true,toggler:'#sub-roles-navbar-toggler'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Nav */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__organizationConsentManagement_consentRequestsFilter_ConsentRequestsFilter_container__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Nav */],{className:'ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loading-nav-bar-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message))))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["B" /* Navbar */],{color:'light',light:true,className:'navbar-expand-custom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["D" /* NavbarToggler */],{id:'sub-roles-navbar-toggler',className:'sub-roles-navbar-toggler'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["O" /* UncontrolledCollapse */],{className:'sub-roles-collapse',navbar:true,toggler:'#sub-roles-navbar-toggler'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Nav */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__organizationConsentManagement_consentRequestsFilter_ConsentRequestsFilter_container__["a" /* default */],null)),this.getBalanceLabel(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Nav */],{className:this.props.currentSubRole!==__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["c" /* SUB_ROLES */].ANCHOR?"ml-auto":""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sub-roles-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'main.current_sub_role_label')+':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:this.getSubRoleSelectedOption().label||""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["b" /* default */],{styles:customStyles,options:this.getSubRolesOptions(),value:this.getSubRoleSelectedOption(),onChange:this.handleChangeSubRole,components:this.getComponents(),isSearchable:false})))),this.props.currentSubRole===__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["c" /* SUB_ROLES */].ANCHOR||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.currentGroup)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Nav */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'groups-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,this.props.currentSubRole===__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["c" /* SUB_ROLES */].INSERTER||this.props.currentSubRole===__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["c" /* SUB_ROLES */].VALIDATOR?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'main.current_group_label')+':':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].department_label)+':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:this.getGroupSelectedOption().label||""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["b" /* default */],{styles:customStyles,options:this.getGroupsOptions(),value:this.getGroupSelectedOption(),onChange:this.handleChangeGroup,components:this.getComponents(),isSearchable:false}))))));}}]);return NavBarWithRoles;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NavBarWithRoles.propTypes={hidden:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,loading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,role:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,currentSubRole:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,subRoles:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,currentGroup:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,groups:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,balance:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onChangeCurrentSubRole:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onChangeCurrentGroup:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (NavBarWithRoles);

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConsentRequestsFilter__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__ = __webpack_require__(49);
var mapStateToProps=function mapStateToProps(state){return{isVisible:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["j" /* getConsentRequestsFilterVisibility */])(state),currentStatus:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["j" /* getCurrentConsentRequestsFilterStatus */])(state),currentJob:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["i" /* getCurrentConsentRequestsFilterJob */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChangeStatus:function onChangeStatus(status){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["q" /* setCurrentConsentRequestsFilterStatus */])(status));},onChangeJob:function onChangeJob(job){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["p" /* setCurrentConsentRequestsFilterJob */])(job));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ConsentRequestsFilter__["a" /* default */]));

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_consent_organizationConsents__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ConsentRequestsFilter_css__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ConsentRequestsFilter_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ConsentRequestsFilter_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_select__ = __webpack_require__(79);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customStyles={option:function option(provided,state){return Object.assign({},provided,{":hover":{backgroundColor:state.isSelected?'#89aa11':'rgba(137, 170, 17, 0.44)'},backgroundColor:state.isSelected?'#89aa11':'white',cursor:'pointer',width:'140px',fontSize:'.9rem',paddingTop:'0',paddingBottom:'0',textOverflow:'ellipsis',overflow:'hidden'});},control:function control(provided,state){return Object.assign({},provided,{fontSize:'.875rem',cursor:'pointer',width:'140px',minHeight:'calc(1.5em + .5rem + 2px)',height:'calc(1.5em + .5rem + 2px)',border:'1px solid #ced4da',":hover":{border:'1px solid #ced4da'},borderColor:state.isFocused?'#80bdff':'#ced4da',boxShadow:state.isFocused?'0 0 0 0.2rem rgba(0,123,255,.25)':'none'});},dropdownIndicator:function dropdownIndicator(provided){return Object.assign({},provided,{padding:'0 5px 0 0'});},indicatorSeparator:function indicatorSeparator(){return{display:'none'};},menu:function menu(styles){return Object.assign({},styles,{marginTop:'0',marginBottom:'0',borderRadius:'0'});},menuList:function menuList(styles){return Object.assign({},styles,{paddingTop:'0',paddingBottom:'0'});}};var ConsentRequestsFilter=function(_Component){_inherits(ConsentRequestsFilter,_Component);function ConsentRequestsFilter(props){_classCallCheck(this,ConsentRequestsFilter);var _this=_possibleConstructorReturn(this,(ConsentRequestsFilter.__proto__||Object.getPrototypeOf(ConsentRequestsFilter)).call(this,props));_this.handleChangeStatus=function(selectedOption){_this.props.onChangeStatus(selectedOption.value);};_this.handleChangeJob=function(e){_this.setState({job:e.target.value});};_this.handleInputKeyPress=function(e){if(e.key==='Enter'){_this.setJobFilter();}};_this.handleInputBlur=function(e){var relatedTarget=e.relatedTarget;var searchButtonNode=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this.buttonSearchRef);if(_this.props.currentJob!==_this.state.job&&relatedTarget!==searchButtonNode){_this.setJobFilter();}};_this.setJobFilter=function(){_this.props.onChangeJob(_this.state.job);};_this.state={job:""};return _this;}_createClass(ConsentRequestsFilter,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.state.job!==nextProps.currentJob){this.setState({job:nextProps.currentJob||""});}}},{key:'render',value:function render(){var _this2=this;if(this.props.isVisible){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-requests-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-requests-filter-status-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'consents.status_filter_label')+':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["b" /* default */],{styles:customStyles,options:this.getStatusOptions(),value:{value:this.props.currentStatus,label:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'consents.status.'+this.props.currentStatus)},onChange:this.handleChangeStatus,isSearchable:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-requests-filter-job-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'consents.job_title_label')+':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* InputGroup */],{size:'sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{bsSize:'sm',placeholder:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'consents.job_filter_placeholder'),value:this.state.job,onChange:this.handleChangeJob,onKeyPress:this.handleInputKeyPress,onBlur:this.handleInputBlur}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["t" /* InputGroupAddon */],{addonType:'append',className:'job-filter-clear-addon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{onClick:this.setJobFilter,color:'secondary',title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].search_label),ref:function ref(elem){return _this2.buttonSearchRef=elem;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'job-filter-search-icon',icon:'search'}))))));}else{return null;}}},{key:'getStatusOptions',value:function getStatusOptions(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.chain(__WEBPACK_IMPORTED_MODULE_5__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */]).mapValues(function(value,key){return{value:value,label:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this3.props.translation,'consents.status.'+key)};}).values().value();}}]);return ConsentRequestsFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsentRequestsFilter.propTypes={isVisible:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,currentStatus:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,currentJob:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,onChangeStatus:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onChangeJob:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ConsentRequestsFilter);

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LanguageSelector__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{selectedLanguage:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["d" /* getSelectedLanguage */])(state),languageList:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["f" /* getTranslationsList */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onLanguageSelect:function onLanguageSelect(language){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["a" /* changeLanguage */])(language));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__LanguageSelector__["a" /* default */]));

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OAuthUserLogin__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_oauth_oauth__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_account_userData__ = __webpack_require__(35);
var mapStateToProps=function mapStateToProps(state,_ref){var location=_ref.location;return{locationParams:__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search),oauthError:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_oauth_oauth__["e" /* getOAuthError */])(state),oauthLoading:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_oauth_oauth__["f" /* getOAuthLoading */])(state),requestData:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_oauth_oauth__["d" /* getOAuthClientData */])(state),redirectTo:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_oauth_oauth__["g" /* getOAuthRedirectTo */])(state),isAuthorised:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_login__["f" /* getLoginAuthoriseStatus */])(state),loginError:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_login__["g" /* getLoginError */])(state),loginLoading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_login__["h" /* getLoginFetchingStatus */])(state),userDataLoading:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_account_userData__["k" /* isLoading */])(state),is2FARequired:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_login__["e" /* getIs2FARequired */])(state),userEmail:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_account_userData__["f" /* getUserEmail */])(state),userData:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_account_userData__["h" /* getUserPersonalData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onLogIn:function onLogIn(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_login__["d" /* fetchAuthorize */])(data));},onUnmount:function onUnmount(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_login__["b" /* cleanLoginError */])());},onCheckRequestParams:function onCheckRequestParams(params){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_oauth_oauth__["b" /* fetchCheckOAuthRequestParams */])(params));},onGiveAccess:function onGiveAccess(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_oauth_oauth__["c" /* fetchOAuthGiveAccess */])(data));},onLogout:function onLogout(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_login__["k" /* logout */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__OAuthUserLogin__["a" /* default */]));

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OAuthUserLogin_css__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OAuthUserLogin_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__OAuthUserLogin_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__login_twoFALoginModal_TwoFALoginModal_container__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_constants__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OAuthUserLogin=function(_Component){_inherits(OAuthUserLogin,_Component);function OAuthUserLogin(props){_classCallCheck(this,OAuthUserLogin);var _this=_possibleConstructorReturn(this,(OAuthUserLogin.__proto__||Object.getPrototypeOf(OAuthUserLogin)).call(this,props));_this.renderContent=function(){if(!_this.props.isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'oauth-login-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'warning'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'oauth.sign_in_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Form */],{onSubmit:_this.onLogIn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'oauth.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':'oauth-login-email'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:'email',value:_this.state.email,onChange:_this.handleEmailChange,required:true,placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':'oauth-login-password'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].password_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:'password',value:_this.state.password,onChange:_this.handlePasswordChange,required:true,placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].password_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{type:'submit',block:true,className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'login.login_button'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'other-abilities-account-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["A" /* NavLink */],{target:'_blank',className:'forgot-password-nav-link',tag:__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],to:'/login/restore'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'login.forgot_password_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'create-new-account-container'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'login.haven_t_account_label')+" ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["A" /* NavLink */],{target:'_blank',className:'forgot-password-nav-link',tag:__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],to:'/account-creation'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'login.create_it_now_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'warning',className:'fetching-label',hidden:!_this.props.loginLoading||_this.props.is2FARequired},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger',className:'error-label',hidden:!_this.props.loginError||_this.props.is2FARequired},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].errors)[_this.props.loginError]||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].defaultError)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__login_twoFALoginModal_TwoFALoginModal_container__["a" /* default */],{onSubmit:_this.onLogInWithVerification}));}else{var accessInfo=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'oauth.access_info_label').split('{client_name}');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'oauth-access-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Form */],{onSubmit:_this.onAccept},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'oauth.logged_in_data_label').replace('{user_name}',_this.props.userData.firstName+' '+_this.props.userData.lastName).replace('{user_email}',_this.props.userEmail)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'oauth-access-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,accessInfo[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,_this.props.requestData?_this.props.requestData.client_name:null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,accessInfo[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'oauth-access-control-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{color:'secondary',onClick:_this.onReject},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'oauth.reject_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'oauth.accept_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'use-another-account-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{color:'link',onClick:_this.props.onLogout},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'oauth.use_another_account_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'warning',className:'fetching-label',hidden:!_this.props.oauthLoading},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}};_this.renderErrorAlert=function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'oauth-error-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},text));};_this.renderSpinner=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loading-oauth-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["M" /* Spinner */],{color:'secondary',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)}));};_this.handleEmailChange=function(e){_this.setState({email:e.target.value});};_this.handlePasswordChange=function(e){_this.setState({password:e.target.value});};_this.onLogIn=function(e){e.preventDefault();var data={'username':_this.state.email,'password':_this.state.password};_this.props.onLogIn(data);};_this.onLogInWithVerification=function(verificationCode){var data={'username':_this.state.email,'password':_this.state.password,'totpcode':verificationCode};_this.props.onLogIn(data);};_this.onAccept=function(e){e.preventDefault();var data=_this.props.locationParams;data["scope"]=_this.props.requestData.scope;data["state"]=_this.props.requestData.state;_this.props.onGiveAccess(data);};_this.onReject=function(){_this.setState({isRejected:true});};_this.state={email:'',password:'',isRejected:false};return _this;}_createClass(OAuthUserLogin,[{key:'componentWillMount',value:function componentWillMount(){this.props.onCheckRequestParams(this.props.location.search);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}},{key:'render',value:function render(){if(this.props.oauthLoading||this.props.userDataLoading){return this.renderSpinner();}if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.redirectTo)){// if backend send path to redirect
window.location=this.props.redirectTo;return this.renderSpinner();}if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.oauthError)){// special backend errors
if(this.props.oauthError===__WEBPACK_IMPORTED_MODULE_8__constants_constants__["m" /* OAUTH_ERRORS */].SERVER_ERROR||this.props.oauthError===__WEBPACK_IMPORTED_MODULE_8__constants_constants__["m" /* OAUTH_ERRORS */].TEMPORARILY_UNAVAILABLE){// redirect if 500 & 503
window.location=this.props.locationParams.redirect_uri+('?error='+this.props.oauthError+'&state='+this.props.locationParams.state);return this.renderSpinner();}else if(this.props.oauthError===__WEBPACK_IMPORTED_MODULE_8__constants_constants__["m" /* OAUTH_ERRORS */].INVALID_REQUEST){// error message if 400
return this.renderErrorAlert(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'oauth.incorrect_request_params_label'));}else{return this.renderErrorAlert(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].errors)[this.props.oauthError]||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].defaultError));}}if(this.state.isRejected){// redirect if ACCESS_DENIED
window.location=this.props.locationParams.redirect_uri+('?error='+__WEBPACK_IMPORTED_MODULE_8__constants_constants__["m" /* OAUTH_ERRORS */].ACCESS_DENIED+'&state='+this.props.locationParams.state);return this.renderSpinner();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'oauth-login-container'},this.renderContent());}}]);return OAuthUserLogin;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OAuthUserLogin.propTypes={locationParams:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,oauthError:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,oauthLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,requestData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,redirectTo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,isAuthorised:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,loginError:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,loginLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,userDataLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,is2FARequired:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,userEmail:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,userData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onLogIn:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onUnmount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onCheckRequestParams:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onGiveAccess:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onLogout:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (OAuthUserLogin);

/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TwoFALoginModal_css__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TwoFALoginModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TwoFALoginModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TwoFALoginModal=function(_Component){_inherits(TwoFALoginModal,_Component);function TwoFALoginModal(props){_classCallCheck(this,TwoFALoginModal);var _this=_possibleConstructorReturn(this,(TwoFALoginModal.__proto__||Object.getPrototypeOf(TwoFALoginModal)).call(this,props));_this.handleChangeVerificationCode=function(e){var regexp=/^[0-9]{0,6}$/;var value=e.target.value;if(regexp.test(value)){_this.setState({verificationCode:value});}};_this.onSubmit=function(e){e.preventDefault();if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.state.verificationCode)&&_this.state.verificationCode.length===6){_this.props.onSubmit(_this.state.verificationCode);}};_this.state={verificationCode:""};return _this;}_createClass(TwoFALoginModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen,toggle:this.props.onCancel,className:'two-fa-login-modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'warning',className:'two-fa-alert',hidden:!this.props.fetching},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'danger',className:'two-fa-alert',hidden:!this.props.error},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].errors)[this.props.error]||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].defaultError)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.onSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center two-fa-login-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security_settings.2fa_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security_settings.verification_code_enter_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security_settings.check_code_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{value:this.state.verificationCode,onChange:this.handleChangeVerificationCode,type:'text',size:'6',placeholder:'_ _ _ _ _ _',required:true,invalid:this.state.verificationCode.length<6&&this.state.verificationCode.length>0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["o" /* FormFeedback */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security_settings.verification_code_details_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'two-fa-login-modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',disabled:this.state.verificationCode.length<6&&this.state.verificationCode.length>0},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'login.login_button'))))));}}]);return TwoFALoginModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TwoFALoginModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TwoFALoginModal);

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Login__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_account_restoreAccount__ = __webpack_require__(81);
var mapStateToProps=function mapStateToProps(state){return{error:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_login__["g" /* getLoginError */])(state),fetching:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_login__["h" /* getLoginFetchingStatus */])(state),is2FARequired:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_login__["e" /* getIs2FARequired */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onLogIn:function onLogIn(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_login__["d" /* fetchAuthorize */])(data));},onForgotPassword:function onForgotPassword(email){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_restoreAccount__["h" /* setResetPasswordEmail */])(email));},onUnmount:function onUnmount(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_login__["b" /* cleanLoginError */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__Login__["a" /* default */]));

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Login_css__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Login_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__twoFALoginModal_TwoFALoginModal_container__ = __webpack_require__(282);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Login=function(_Component){_inherits(Login,_Component);function Login(props){_classCallCheck(this,Login);var _this=_possibleConstructorReturn(this,(Login.__proto__||Object.getPrototypeOf(Login)).call(this,props));_this.handleEmailChange=function(e){_this.setState({email:e.target.value});};_this.handlePasswordChange=function(e){_this.setState({password:e.target.value});};_this.handlePasswordReset=function(){_this.props.onForgotPassword(_this.state.email);};_this.onLogIn=function(e){e.preventDefault();var data={'username':_this.state.email,'password':_this.state.password};_this.props.onLogIn(data);};_this.onLogInWithVerification=function(verificationCode){var data={'username':_this.state.email,'password':_this.state.password,'totpcode':verificationCode};_this.props.onLogIn(data);};_this.handleRegisterApplicantClick=function(){_this.setState({registerApplicant:true});};_this.state={email:'',password:'',registerApplicant:false};return _this;}_createClass(Login,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}},{key:'render',value:function render(){if(this.state.registerApplicant){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Redirect */],{to:'/account-creation',push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Form */],{onSubmit:this.onLogIn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'login.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':'login-email'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:'email',value:this.state.email,onChange:this.handleEmailChange,required:true,placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':'login-password'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].password_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:'password',value:this.state.password,onChange:this.handlePasswordChange,required:true,placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].password_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{type:'submit',block:true,className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'login.login_button'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'other-abilities-account-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["A" /* NavLink */],{className:'forgot-password-nav-link',tag:__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],to:'/login/restore',onClick:this.handlePasswordReset},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'login.forgot_password_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'create-new-account-container'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'login.haven_t_account_label')+" ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'register_applicant.success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{className:'applicant-registration-button',color:'link',onClick:this.handleRegisterApplicantClick},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'login.create_it_now_label')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'warning',className:'fetching-label',hidden:!this.props.fetching||this.props.is2FARequired},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger',className:'error-label',hidden:!this.props.error||this.props.is2FARequired},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].errors)[this.props.error]||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].defaultError)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__twoFALoginModal_TwoFALoginModal_container__["a" /* default */],{onSubmit:this.onLogInWithVerification}));}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Login.propTypes={error:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,fetching:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,is2FARequired:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onLogIn:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onUnmount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Login);

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormWrapper_css__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormWrapper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FormWrapper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormWrapper=function(_Component){_inherits(FormWrapper,_Component);function FormWrapper(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FormWrapper);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FormWrapper.__proto__||Object.getPrototypeOf(FormWrapper)).call.apply(_ref,[this].concat(args))),_this),_this.getAlert=function(){if(_this.props.disabled){return null;}if(_this.props.fetching){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'warning',className:'notification-alert fetching-label'},_this.props.loadingMessage||__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}else if(_this.props.success&&_this.props.showSuccessAlert){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'success',className:'notification-alert success-label',toggle:_this.props.onResetState},_this.props.successMessage||__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].success_message));}else if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(_this.props.error)){var errorLabel=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].errors)[_this.props.error]||__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].defaultError);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger',className:'notification-alert error-label',toggle:_this.props.onCloseAlert},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(errorLabel)));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FormWrapper,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onResetState();}},{key:'componentWillMount',value:function componentWillMount(){this.props.onResetState();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.fetching!==nextProps.fetching&&!this.props.hideOverlay){this.overlayRef.style.visibility=!nextProps.fetching?"hidden":"visible";}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-wrapper-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'form-wrapper-content-overlay',ref:function ref(element){return _this2.overlayRef=element;}}),this.getAlert(),this.props.children);}}]);return FormWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FormWrapper.propTypes={error:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,fetching:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,success:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,showSuccessAlert:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,successMessage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,loadingMessage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,hideOverlay:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onResetState:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onCloseAlert:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};FormWrapper.defaultProps={showSuccessAlert:true};/* harmony default export */ __webpack_exports__["a"] = (FormWrapper);

/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_account_activation__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActivateUserAccount__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_account_userData__ = __webpack_require__(35);
var mapStateToProps=function mapStateToProps(state,_ref){var location=_ref.location;return{loading:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_userData__["d" /* getLoadingDataByToken */])(state),role:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_userData__["i" /* getUserRole */])(state),error:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_userData__["e" /* getUserDataError */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),token:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_activation__["e" /* getTokenFromLocation */])(location),translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGetUserData:function onGetUserData(token){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_userData__["c" /* fetchGetUserDataByToken */])(token));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__ActivateUserAccount__["a" /* default */]));

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__activateEmployeeAccount_ActivateEmployeeAccount_container__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__activateApplicantAccount_ActivateApplicantAccount_container__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_account_role__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActivateUserAccount=function(_Component){_inherits(ActivateUserAccount,_Component);function ActivateUserAccount(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ActivateUserAccount);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ActivateUserAccount.__proto__||Object.getPrototypeOf(ActivateUserAccount)).call.apply(_ref,[this].concat(args))),_this),_this.getTokenIrrelevantMessage=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'irrelevant-employee-activation-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'activation.activation_link_irrelevant_message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'activation.activation_link_irrelevant_forgot_password_message_start')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/login/restore'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'activation.activation_link_irrelevant_forgot_password_message_link'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'activation.activation_link_irrelevant_forgot_password_message_end'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'activation.activation_link_irrelevant_log_in_message_start')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/login'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'activation.activation_link_irrelevant_log_in_message_link'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'activation.activation_link_irrelevant_log_in_message_end'))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ActivateUserAccount,[{key:'componentWillMount',value:function componentWillMount(){this.props.onGetUserData(this.props.token);}},{key:'render',value:function render(){if(!this.props.token){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'incorrect-activation-employee-container'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'activation.incorrect_activation_link_alert'));}if(this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}if(this.props.success){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Redirect */],{to:'/login'});}if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.error)){return this.getTokenIrrelevantMessage();}switch(__WEBPACK_IMPORTED_MODULE_7__reducers_account_role__["b" /* ROLES */][this.props.role]){case __WEBPACK_IMPORTED_MODULE_7__reducers_account_role__["b" /* ROLES */].SYS_ADMIN:case __WEBPACK_IMPORTED_MODULE_7__reducers_account_role__["b" /* ROLES */].EMPLOYEE:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__activateEmployeeAccount_ActivateEmployeeAccount_container__["a" /* default */],{token:this.props.token});case __WEBPACK_IMPORTED_MODULE_7__reducers_account_role__["b" /* ROLES */].APPLICANT:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__activateApplicantAccount_ActivateApplicantAccount_container__["a" /* default */],{token:this.props.token});default:return null;}}}]);return ActivateUserAccount;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ActivateUserAccount.propTypes={loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,role:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,success:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,token:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onGetUserData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ActivateUserAccount);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_account_activation__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActivateEmployeeAccount__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_account_userData__ = __webpack_require__(35);
var mapStateToProps=function mapStateToProps(state){return{data:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_userData__["h" /* getUserPersonalData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onActivate:function onActivate(token,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_activation__["b" /* fetchActivateAccount */])(token,data));},onShowLicenseAgreement:function onShowLicenseAgreement(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["F" /* MODAL_LICENSE_AGREEMENT */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__ActivateEmployeeAccount__["a" /* default */]));

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActivateEmployeeAccount_css__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActivateEmployeeAccount_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ActivateEmployeeAccount_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__personalData_PersonalData_container__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__personalData_PersonalData__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__confirmPassword_ConfirmPasswordActivation_container__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_licenseAgreement_LicenseAgreementModal_container__ = __webpack_require__(133);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var requiredSelectFields=[];var ActivateEmployeeAccount=function(_Component){_inherits(ActivateEmployeeAccount,_Component);function ActivateEmployeeAccount(props){_classCallCheck(this,ActivateEmployeeAccount);var _this=_possibleConstructorReturn(this,(ActivateEmployeeAccount.__proto__||Object.getPrototypeOf(ActivateEmployeeAccount)).call(this,props));_this.handleClickLicenseAgreement=function(e){e.preventDefault();_this.props.onShowLicenseAgreement();};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.setAgreementTrue=function(){_this.setState({isAgreeWithLicense:true});};_this.handleChangeByValue=function(fieldKey){return function(value){_this.setState(_defineProperty({},fieldKey,value));};};_this.handleChangeAgreement=function(){_this.setState({isAgreeWithLicense:!_this.state.isAgreeWithLicense});};_this.onActivate=function(e){e.preventDefault();if(_this.checkRequiredSelectFields()){return;}if(_this.state.password!==''&&_this.state.password===_this.state.passwordConfirm&&__WEBPACK_IMPORTED_MODULE_9__utils_utils__["a" /* Utils */].isValidPassword(_this.state.password)){var data={password:_this.state.password,email:_this.state.email,identityAlias:{firstName:_this.state.firstName,lastName:_this.state.lastName,phoneNumber:!__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isNil(_this.state.phoneNumber)&&_this.state.phoneNumber!==""?_this.state.phoneNumber:null,countryCode:_this.state.countryCode}};_this.props.onActivate(_this.props.token,data);}};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.map(requiredSelectFields,function(field){if(!_this.state[field]&&!error){error=field;}});_this.setState({requiredFieldError:error});return error;};_this.state={firstName:'',lastName:'',email:'',phoneNumber:'',countryCode:'',password:'',passwordConfirm:'',isAgreeWithLicense:false,requiredFieldError:null};if(!__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isNil(_this.props.data)){_this.state.firstName=_this.props.data.firstName||'';_this.state.lastName=_this.props.data.lastName||'';_this.state.email=_this.props.data.email||'';_this.state.countryCode=_this.props.data.countryCode||'';}return _this;}_createClass(ActivateEmployeeAccount,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isNil(this.props.data)&&!__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isNil(nextProps.data)){this.setState(Object.assign({},nextProps.data));}}},{key:'render',value:function render(){var fields=['firstName','lastName','email'];if(!this.props.data.hasOwnProperty('countryCode')){fields.push('continentCode','countryCode');requiredSelectFields.push('countryCode');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activation-employee-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this.props.translation,'activation.activation_success_alert')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this.props.translation,'activation.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["n" /* Form */],{onSubmit:this.onActivate,key:'activate-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this.props.translation,'activation.activate_personal_data_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__personalData_PersonalData_container__["a" /* default */],{handleChange:this.handleChange,handleChangeByValue:this.handleChangeByValue,firstName:this.state.firstName,lastName:this.state.lastName,email:this.state.email,phoneNumber:this.state.phoneNumber,countryCode:this.state.countryCode,fields:fields,requiredFields:fields,requiredFieldError:this.state.requiredFieldError,mode:__WEBPACK_IMPORTED_MODULE_4__personalData_PersonalData__["b" /* PROFESSIONAL_FORM_MODE */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this.props.translation,'activation.activate_password_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__confirmPassword_ConfirmPasswordActivation_container__["a" /* default */],{handleChange:this.handleChange,password:this.state.password,passwordConfirm:this.state.passwordConfirm}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submit-activation-employee-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'license-agreement-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["v" /* Label */],{className:'checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["r" /* Input */],{type:'checkbox',checked:this.state.isAgreeWithLicense,onChange:this.handleChangeAgreement}),__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this.props.translation,"license_agreement.agree_label"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'',className:'license-agreement-link',onClick:this.handleClickLicenseAgreement},__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this.props.translation,"license_agreement.agree_link")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn',disabled:!this.state.isAgreeWithLicense},__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this.props.translation,'activation.activate_button'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_licenseAgreement_LicenseAgreementModal_container__["a" /* default */],{onAgree:this.setAgreementTrue}));}}]);return ActivateEmployeeAccount;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ActivateEmployeeAccount.propTypes={token:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onActivate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onShowLicenseAgreement:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ActivateEmployeeAccount);

/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfirmPassword_css__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfirmPassword_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ConfirmPassword_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfirmPassword=function(_Component){_inherits(ConfirmPassword,_Component);function ConfirmPassword(){_classCallCheck(this,ConfirmPassword);return _possibleConstructorReturn(this,(ConfirmPassword.__proto__||Object.getPrototypeOf(ConfirmPassword)).apply(this,arguments));}_createClass(ConfirmPassword,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirm-password-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':'new-password',sm:3},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'activation.enter_password_label'),'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:'password',id:'new-password',value:this.props.password,onChange:this.props.handleChange('password'),required:true,placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'activation.enter_password_input_placeholder'),invalid:this.props.password!==""?!__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].isValidPassword(this.props.password):false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* FormFeedback */],null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'activation.enter_password_error_alert')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':'new-password-confirm',sm:3},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'activation.confirm_password_label'),'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:'password',id:'new-password-confirm',value:this.props.passwordConfirm,onChange:this.props.handleChange('passwordConfirm'),required:true,placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'activation.confirm_password_input_placeholder'),invalid:this.props.password!==""&&this.props.passwordConfirm!==""?this.props.password!==this.props.passwordConfirm:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* FormFeedback */],null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'activation.confirm_password_error_alert')))));}}]);return ConfirmPassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConfirmPassword.propTypes={password:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,passwordConfirm:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ConfirmPassword);

/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LicenseAgreementModal_css__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LicenseAgreementModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LicenseAgreementModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__license_LicenseComponent__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LicenseAgreementModal=function(_Component){_inherits(LicenseAgreementModal,_Component);function LicenseAgreementModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LicenseAgreementModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LicenseAgreementModal.__proto__||Object.getPrototypeOf(LicenseAgreementModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleAgree=function(){_this.props.onAgree();_this.props.onCancel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LicenseAgreementModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'license-agreement-modal',isOpen:this.props.isOpen,toggle:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'licence-agreement-modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__iconContainer_IconContainer__["a" /* default */],{icon:'clear',className:'licence-agreement-modal-close-icon',onClick:this.props.onCancel,title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'license-content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__license_LicenseComponent__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'license-agreement-modal-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleAgree},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"license_agreement.agree_label")+' '+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"license_agreement.agree_link")))));}}]);return LicenseAgreementModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);LicenseAgreementModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onAgree:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (LicenseAgreementModal);

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LicenseComponent=function(_Component){_inherits(LicenseComponent,_Component);function LicenseComponent(){_classCallCheck(this,LicenseComponent);return _possibleConstructorReturn(this,(LicenseComponent.__proto__||Object.getPrototypeOf(LicenseComponent)).apply(this,arguments));}_createClass(LicenseComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'24pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'BrainChain Customer Agreement')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'8pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'16pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'Owner\'s note.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'8pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'Beloved customer, ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'I feel your pain; '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Oblique',fontStyle:'italic',color:'#262626'}},'yet another Software License'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},' I will likely read with... less attention than it might deserve according to certain people in black robes, but: you have to agree with it to use this Software.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'From our end, I have been explained this is in order to make sure the company cannot be held liable for \u201Cfunny stuff from crazy people\u201D. ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'But even if that is indeed a valid concern, it doesn\'t mean that I believe as an industry, we should make a better effort in making texts like the below '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Oblique',fontStyle:'italic',color:'#262626'}},'actual'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},' license clearer, instead of just letting our own users, the very people we claim to treasure, hanging with texts that seem to have as intent to keep people at the dark side of what they are expected to agree with.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'So: I decided to explain you in plain wording what its intent is - straight and pure. Like good coffee.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Verdana'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'I therefore'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'hope companies would start issuing, as preamble to those dreadful texts, a short note like this one to explain in layman\u2019s terms their \u2018why\u2019.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(Or even better -  if you allow me to state the obvious and challenge the collective legal system: why not develop legal speak that is readable by humans? The opposite intent of manifest obfuscation does not strike me as a democratic virtue.)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'8pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'So, for BrainChain it all boils down to this: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'This is Software about people\u2019s accreditations(Diplomas). It means people inserting or validating accreditations should not fraud or try to trick the system, nor should anyone else for that matter. ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'From our side, we walk the mile to make sure fraud gets as close to impossible as we can. We respectfully ask you to join us in this cause, and to reach out if you suspect naughty behaviour. In the contact section, there\u2019s a contact form to report perceived violations. ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'You can do this at benevolentears@brainchainmission.org')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'8pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'From our end, we will go after such fraud attempts with everything we\'ve got - not just coffee. ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'8pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'Rest me to wish you the best & Godspeed!')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'Team BrainChain ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'8pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'______________________')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'Last Updated: December 29th, 2018')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#0d69aa'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'This BrainChain Customer Agreement (this \u201C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#262626'}},'Agreement'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201D) contains the terms and conditions that govern your access to and use of the Service Offerings (as defined below) and is an agreement between the applicable Contracting Party specified in Section 14 below (also referred to as \u201C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#262626'}},'BrainChain'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201D, \u201C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#262626'}},'we'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201D, \u201C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#262626'}},'us'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201D, or \u201C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#262626'}},'our'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201D) and you or the entity you represent (\u201C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#262626'}},'you'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201D or \u201C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#262626'}},'your'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201D). This Agreement takes effect when you click an \u201CI Accept\u201D button or check box presented with these terms or, if earlier, when you use any of the Service Offerings (the \u201C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#262626'}},'Effective Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201D). You represent to us that you are lawfully able to enter into contracts (e.g., you are not a minor). If you are entering into this Agreement for an entity, such as the company you work for, you represent to us that you have legal authority to bind that entity. Please see Section 14 for definitions of certain capitalized terms used in this Agreement.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'1. Use of the Service Offerings.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'1.1 Generally. You may access and use the Service Offerings in accordance with this Agreement. Service Level Agreements and Service Terms apply to certain Service Offerings. You will comply with the terms of this Agreement and all laws, rules and regulations applicable to your use of the Service Offerings.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'1.2 Your Account. To access the Services, you must have a BrainChain or HireForceOne account associated with a valid email address and a valid form of payment. ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'1.3 Third-Party Content. Third-Party Content may be used by you at your election. Third-Party Content is governed by this Agreement and, if applicable, separate terms and conditions accompanying such Third-Party Content, which terms and conditions may include separate fees and charges.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'2. Changes.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'2.1 To the Service Offerings. We may change or discontinue any or all of the Service Offerings or change or remove functionality of any or all of the Service Offerings from time to time. We will notify you of any material change to or discontinuation of the Service Offerings.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'2.2 To the APIs. We may change or discontinue any APIs for the Services from time to time. For any discontinuation of or material change to an API for a Service, we will use commercially reasonable efforts to continue supporting the previous version of such API for 12 months after the change or discontinuation (except if doing so (a) would pose a security or intellectual property issue, (b) is economically or technically burdensome, or (c) would cause us to violate the law or requests of governmental entities).')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'2.3 To the Service Level Agreements. We may change, discontinue or add Service Level Agreements from time to time in accordance with Section 12.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'3. Security and Data Privacy.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'3.1 BrainChain Security. Without limiting Section 10 or your obligations under Section 4.2, we will implement reasonable and appropriate measures designed to help you secure Your Content against accidental or unlawful loss, access or disclosure.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'3.2 Data Privacy. You consent to the storage of Your Content. We will not access or use Your Content except as necessary to maintain or provide the Service Offerings, or as necessary to comply with the law or a binding order of a governmental body. We will not (a) disclose Your Content, except after explicit prior consent from your end, to any government or third party or (b) subject to Section 3.3, move Your Content except in each case as necessary to comply with the law or a binding order of a governmental body. Unless it would violate the law or a binding order of a governmental body, we will give you notice of any legal requirement or order referred to in this Section 3.2. We will only use your Account Information in accordance with the Privacy Policy, and you consent to such usage. The Privacy Policy does not apply to Your Content.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'3.3 Service Attributes. To provide billing and administration services, we may process Service Attributes where you use the Service Offerings. To provide you with support services initiated by you and investigate fraud, abuse or violations of this Agreement, we may process Service Attributes where we maintain our support and investigation personnel.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'4. Your Responsibilities.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'4.1 Your Accounts. Except to the extent caused by our breach of this Agreement, (a) you are responsible for all activities that occur under your account, regardless of whether the activities are authorized by you or undertaken by you, your employees or a third party (including your contractors, agents or End Users), and (b) we and our affiliates are not responsible for unauthorized access to your account.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'4.2 Your Content. You will ensure that Your Content and your and End Users\u2019 use of Your Content or the Service Offerings will not violate any of the Policies or any applicable law. You are solely responsible for the development, content, operation, maintenance, and use of Your Content.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'4.3 Your Security and Backup. You are responsible for properly configuring and using the Service Offerings and otherwise taking appropriate action to secure, protect and backup your accounts and Your Content in a manner that will provide appropriate security and protection, which might include use of encryption to protect Your Content from unauthorized access and routinely archiving Your Content.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'4.4 Log-In Credentials or Account Keys. BrainChain log-in credentials or private keys generated by the Services are for your internal use only and you will not sell, transfer or sublicense them to any other entity or person, except that you may disclose your private key to your agents and subcontractors performing work on your behalf.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'4.5 End Users. You will be deemed to have taken any action that you permit, assist or facilitate any person or entity to take related to this Agreement, Your Content or use of the Service Offerings. You are responsible for End Users\u2019 use of Your Content and the Service Offerings. You will ensure that all End Users comply with your obligations under this Agreement and that the terms of your agreement with each End User are consistent with this Agreement. If you become aware of any violation of your obligations under this Agreement caused by an End User, you will immediately suspend access to Your Content and the Service Offerings by such End User. We do not provide any support or services to End Users unless we have a separate agreement with you or an End User obligating us to provide such support or services.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'5. Fees and Payment.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'5.1 Service Fees. We calculate and bill fees and charges annually. We may bill you more frequently for fees accrued if we suspect that your account is fraudulent or at risk of non-payment. You will pay us the applicable fees and charges for use of the Service Offerings as described on the brainchainmission.org Site using one of the payment methods we support. All amounts payable by you under this Agreement will be paid to us without setoff or counterclaim, and without any deduction or withholding. Fees and charges for any new Service or new feature of a Service will be effective when we post updated fees and charges on the brainchainmission.org Site, unless we expressly state otherwise in a notice. We may increase or add new fees and charges for any existing Services you are using by giving you at least 30 days\u2019 prior notice. We may elect to charge you interest at the rate of 1.5% per month (or the highest rate permitted by law, if less) on all late payments.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'5.2 Taxes. Each party will be responsible, as required under applicable law, for identifying and paying all taxes and other governmental fees and charges (and any penalties, interest, and other additions thereto) that are imposed on that party upon or with respect to the transactions and payments under this Agreement. All fees payable by you are exclusive of Indirect Taxes. We may charge and you will pay applicable Indirect Taxes that we are legally obligated or authorized to collect from you. You will provide such information to us as reasonably required to determine whether we are obligated to collect Indirect Taxes from you. We will not collect, and you will not pay, any Indirect Tax for which you furnish us a properly completed exemption certificate or a direct payment permit certificate for which we may claim an available exemption from such Indirect Tax. All payments made by you to us under this Agreement will be made free and clear of any deduction or withholding, as may be required by law. If any such deduction or withholding (including but not limited to cross-border withholding taxes) is required on any payment, you will pay such additional amounts as are necessary so that the net amount received by us is equal to the amount then due and payable under this Agreement. We will provide you with such tax forms as are reasonably requested in order to reduce or eliminate the amount of any withholding or deduction for taxes in respect of payments made under this Agreement.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'6. Temporary Suspension.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'6.1 Generally. We may suspend your or any End User\u2019s right to access or use any portion or all of the Service Offerings immediately upon notice to you if we determine:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(a) your or an End User\u2019s use of the Service Offerings (i) poses a security risk to the Service Offerings or any third party, (ii) could adversely impact our systems, the Service Offerings or the systems or Content of any other BrainChain customer, (iii) could subject us, our affiliates, or any third party to liability, or (iv) could be fraudulent;')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(b) you are, or any End User is, in breach of this Agreement;')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(c) you are in breach of your payment obligations under Section 5; or')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(d) you have ceased to operate in the ordinary course, made an assignment for the benefit of creditors or similar disposition of your assets, or become the subject of any bankruptcy, reorganization, liquidation, dissolution or similar proceeding.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'6.2 Effect of Suspension. If we suspend your right to access or use any portion or all of the Service Offerings:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(a) you remain responsible for all fees and charges you incur during the period of suspension; and')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(b) you will not be entitled to any service credits under the Service Level Agreements for any period of suspension.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'7. Term; Termination.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'7.1 Term. The term of this Agreement will commence on the Effective Date and will remain in effect until terminated under this Section 7. Any notice of termination of this Agreement by either party to the other must include a Termination Date that complies with the notice periods in Section 7.2.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'7.2 Termination.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(a) Termination for Convenience. You may terminate this Agreement for any reason by providing us notice and closing your account for all Services for which we provide an account closing mechanism. We may terminate this Agreement for any reason by providing you at least 30 days\u2019 advance notice.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(b) Termination for Cause.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(i) By Either Party. Either party may terminate this Agreement for cause if the other party is in material breach of this Agreement and the material breach remains uncured for a period of 30 days from receipt of notice by the other party. No later than the Termination Date, you will close your account.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(ii) By Us. We may also terminate this Agreement immediately upon notice to you (A) for cause if we have the right to suspend under Section 6, (B) if our relationship with a third-party partner who provides software or other technology we use to provide the Service Offerings expires, terminates or requires us to change the way we provide the software or other technology as part of the Services, or (C) in order to comply with the law or requests of governmental entities.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'7.3 Effect of Termination.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(a) Generally. Upon the Termination Date:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(i) except as provided in Section 7.3(b), all your rights under this Agreement immediately terminate;')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(ii) you remain responsible for all fees and charges you have incurred through the Termination Date and are responsible for any fees and charges you incur during the post-termination period described in Section 7.3(b);')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(iii) you will immediately return or, if instructed by us, destroy all BrainChain Content in your possession; and')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(iv) Sections 4.1, 5, 7.3, 8 (except the license granted to you in Section 8.3), 9, 10, 11, 13 and 14 will continue to apply in accordance with their terms.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(b) Post-Termination. Unless we terminate your use of the Service Offerings pursuant to Section 7.2(b), during the 30 days following the Termination Date:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(i) we will not take action to remove from the BrainChain systems any of Your Content as a result of the termination; and')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(ii) we will allow you to retrieve Your Content from the Services only if you have paid all amounts due under this Agreement.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'For any use of the Services after the Termination Date, the terms of this Agreement will apply and you will pay the applicable fees at the rates under Section 5.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'8. Proprietary Rights.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'8.1 Your Content. Except as provided in this Section 8, we obtain no rights under this Agreement from you (or your licensors) to Your Content. You consent to our use of Your Content to provide the Service Offerings to you and any End Users.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'8.2 Adequate Rights. You represent and warrant to us that: (a) you or your licensors own all right, title, and interest in and to Your Content and Suggestions; (b) you have all rights in Your Content and Suggestions necessary to grant the rights contemplated by this Agreement; and (c) none of Your Content or End Users\u2019 use of Your Content or the Service Offerings will violate the Acceptable Use Policy.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'8.3 Service Offerings License. We or our licensors own all right, title, and interest in and to the Service Offerings, and all related technology and intellectual property rights. Subject to the terms of this Agreement, we grant you a limited, revocable, non-exclusive, non-sublicensable, non-transferrable license to do the following: (a) access and use the Services solely in accordance with this Agreement; and (b) copy and use the BrainChain Content solely in connection with your permitted use of the Services. Except as provided in this Section 8.3, you obtain no rights under this Agreement from us, our affiliates or our licensors to the Service Offerings, including any related intellectual property rights. Some BrainChain Content and Third-Party Content may be provided to you under a separate license, such as the Apache License, Version 2.0, or other open source license. In the event of a conflict between this Agreement and any separate license, the separate license will prevail with respect to the BrainChain Content or Third-Party Content that is the subject of such separate license.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'8.4 License Restrictions. Neither you nor any End User will use the Service Offerings in any manner or for any purpose other than as expressly permitted by this Agreement. Neither you nor any End User will, or will attempt to (a) modify, distribute, alter, tamper with, repair, or otherwise create derivative works of any Content included in the Service Offerings (except to the extent Content included in the Service Offerings is provided to you under a separate license that expressly permits the creation of derivative works), (b) reverse engineer, disassemble, or decompile the Service Offerings or apply any other process or procedure to derive the source code of any software included in the Service Offerings (except to the extent applicable law doesn\u2019t allow this restriction), (c) access or use the Service Offerings in a way intended to avoid incurring fees or exceeding usage limits or quotas, or (d) resell or sublicense the Service Offerings. You may only use the BrainChain Marks in accordance with the Trademark Use Guidelines. You will not misrepresent or embellish the relationship between us and you (including by expressing or implying that we support, sponsor, endorse, or contribute to you or your business endeavors). You will not imply any relationship or affiliation between us and you except as expressly permitted by this Agreement.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'8.5 Suggestions. If you provide any Suggestions to us or our affiliates, we and our affiliates will be entitled to use the Suggestions without restriction. You hereby irrevocably assign to us all right, title, and interest in and to the Suggestions and agree to provide us any assistance we require to document, perfect, and maintain our rights in the Suggestions.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'9. Indemnification.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'9.1 General. You will defend, indemnify, and hold harmless us, our affiliates and licensors, and each of their respective employees, officers, directors, and representatives from and against any Losses arising out of or relating to any third-party claim concerning: (a) your or any End Users\u2019 use of the Service Offerings (including any activities under your BrainChain account and use by your employees and personnel); (b) breach of this Agreement or violation of applicable law by you, End Users or Your Content; or (c) a dispute between you and any End User. You will reimburse us for reasonable attorneys\u2019 fees, as well as our employees\u2019 and contractors\u2019 time and materials spent responding to any third party subpoena or other compulsory legal order or process associated with third party claims described in (a) through (c) above at our then-current hourly rates.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'9.2 Intellectual Property.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(a) Subject to the limitations in this Section 9, BrainChain will defend you and your employees, officers, and directors against any third-party claim alleging that the Services infringe or misappropriate that third party\u2019s intellectual property rights, and will pay the amount of any adverse final judgment or settlement.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(b) Subject to the limitations in this Section 9, you will defend us, our affiliates, and their respective employees, officers, and directors against any third-party claim alleging that any of Your Content infringes or misappropriates that third party\u2019s intellectual property rights, and will pay the amount of any adverse final judgment or settlement.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(c) Neither party will have obligations or liability under this Section 9.2 arising from infringement by combinations of the Services or Your Content, as applicable, with any other product, service, software, data, content or method. In addition, we will have no obligations or liability arising from your or any End User\u2019s use of the Services after we have notified you to discontinue such use. The remedies provided in this Section 9.2 are the sole and exclusive remedies for any third-party claims of infringement or misappropriation of intellectual property rights by the Services or by Your Content.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(d) For any claim covered by Section 9.2(a), we will, at its election, either: (i) procure the rights to use that portion of the Services alleged to be infringing; (ii) replace the alleged infringing portion of the Services with a non-infringing alternative; (iii) modify the alleged infringing portion of the Services to make it non-infringing; or (iv) terminate the allegedly infringing portion of the Services or this Agreement.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'9.3 Process. The obligations under this Section 9 will apply only if the party seeking defense or indemnity: (a) gives the other party prompt written notice of the claim; (b) permits the other party to control the defense and settlement of the claim; and (c) reasonably cooperates with the other party (at the other party\u2019s expense) in the defense and settlement of the claim. In no event will a party agree to any settlement of any claim that involves any commitment, other than the payment of money, without the written consent of the other party.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'10. Disclaimers.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'THE SERVICE OFFERINGS ARE PROVIDED \u201CAS IS.\u201D EXCEPT TO THE EXTENT PROHIBITED BY LAW, OR TO THE EXTENT ANY STATUTORY RIGHTS APPLY THAT CANNOT BE EXCLUDED, LIMITED OR WAIVED, WE AND OUR AFFILIATES AND LICENSORS (A) MAKE NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY OR OTHERWISE REGARDING THE SERVICE OFFERINGS OR THE THIRD-PARTY CONTENT, AND (B) DISCLAIM ALL WARRANTIES, INCLUDING ANY IMPLIED OR EXPRESS WARRANTIES (I) OF MERCHANTABILITY, SATISFACTORY QUALITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR QUIET ENJOYMENT, (II) ARISING OUT OF ANY COURSE OF DEALING OR USAGE OF TRADE, (III) THAT THE SERVICE OFFERINGS OR THIRD-PARTY CONTENT WILL BE UNINTERRUPTED, ERROR FREE OR FREE OF HARMFUL COMPONENTS, AND (IV) THAT ANY CONTENT WILL BE SECURE OR NOT OTHERWISE LOST OR ALTERED.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'11. Limitations of Liability.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'WE AND OUR AFFILIATES AND LICENSORS WILL NOT BE LIABLE TO YOU FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES (INCLUDING DAMAGES FOR LOSS OF PROFITS, REVENUES, CUSTOMERS, OPPORTUNITIES, GOODWILL, USE, OR DATA), EVEN IF A PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. FURTHER, NEITHER WE NOR ANY OF OUR AFFILIATES OR LICENSORS WILL BE RESPONSIBLE FOR ANY COMPENSATION, REIMBURSEMENT, OR DAMAGES ARISING IN CONNECTION WITH: (A) YOUR INABILITY TO USE THE SERVICES, INCLUDING AS A RESULT OF ANY (I) TERMINATION OR SUSPENSION OF THIS AGREEMENT OR YOUR USE OF OR ACCESS TO THE SERVICE OFFERINGS, (II) OUR DISCONTINUATION OF ANY OR ALL OF THE SERVICE OFFERINGS, OR, (III) WITHOUT LIMITING ANY OBLIGATIONS UNDER THE SERVICE LEVEL AGREEMENTS, ANY UNANTICIPATED OR UNSCHEDULED DOWNTIME OF ALL OR A PORTION OF THE SERVICES FOR ANY REASON; (B) THE COST OF PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; (C) ANY INVESTMENTS, EXPENDITURES, OR COMMITMENTS BY YOU IN CONNECTION WITH THIS AGREEMENT OR YOUR USE OF OR ACCESS TO THE SERVICE OFFERINGS; OR (D) ANY UNAUTHORIZED ACCESS TO, ALTERATION OF, OR THE DELETION, DESTRUCTION, DAMAGE, LOSS OR FAILURE TO STORE ANY OF YOUR CONTENT OR OTHER DATA. IN ANY CASE, EXCEPT FOR PAYMENT OBLIGATIONS UNDER SECTION 9.2, OUR AND OUR AFFILIATES\u2019 AND LICENSORS\u2019 AGGREGATE LIABILITY UNDER THIS AGREEMENT WILL NOT EXCEED THE AMOUNT YOU ACTUALLY PAY US UNDER THIS AGREEMENT FOR THE SERVICE THAT GAVE RISE TO THE CLAIM DURING THE 12 MONTHS BEFORE THE LIABILITY AROSE. THE LIMITATIONS IN THIS SECTION 11 APPLY ONLY TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'12. Modifications to the Agreement.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'We may modify this Agreement (including any Policies) at any time by posting a revised version on the brainchainmission.org Site or by otherwise notifying you in accordance with Section 13.10; provided, however, that we will provide at least 90 days\u2019 advance notice in accordance with Section 13.10 for adverse changes to any Service Level Agreement. Subject to the 90 day advance notice requirement with respect to adverse changes to Service Level Agreements, the modified terms will become effective upon posting or, if we notify you by email, as stated in the email message. By continuing to use the Service Offerings after the effective date of any modifications to this Agreement, you agree to be bound by the modified terms. It is your responsibility to check the BrainChain Site regularly for modifications to this Agreement. We last modified this Agreement on the date listed at the end of this Agreement.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'13. Miscellaneous.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'13.1 Assignment. You will not assign or otherwise transfer this Agreement or any of your rights and obligations under this Agreement, without our prior written consent. Any assignment or transfer in violation of this Section 13.1 will be void. We may assign this Agreement without your consent (a) in connection with a merger, acquisition or sale of all or substantially all of our assets, or (b) to any Affiliate or as part of a corporate reorganization; and effective upon such assignment, the assignee is deemed substituted for us as a party to this Agreement and we are fully released from all of its obligations and duties to perform under this Agreement. Subject to the foregoing, this Agreement will be binding upon, and inure to the benefit of the parties and their respective permitted successors and assigns.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'13.2 Entire Agreement. This Agreement incorporates the Policies by reference and is the entire agreement between you and us regarding the subject matter of this Agreement. This Agreement supersedes all prior or contemporaneous representations, understandings, agreements, or communications between you and us, whether written or verbal, regarding the subject matter of this Agreement (but does not supersede prior commitments to purchase Services). We will not be bound by, and specifically object to, any term, condition or other provision that is different from or in addition to the provisions of this Agreement (whether or not it would materially alter this Agreement) including for example, any term, condition or other provision (a) submitted by you in any order, receipt, acceptance, confirmation, correspondence or other document, (b) related to any online registration, response to any Request for Bid, Request for Proposal, Request for Information, or other questionnaire, or (c) related to any invoicing process that you submit or require us to complete. If the terms of this document are inconsistent with the terms contained in any Policy, the terms contained in this document will control, except that the Service Terms will control over this document.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'13.3 Force Majeure. We and our affiliates will not be liable for any delay or failure to perform any obligation under this Agreement where the delay or failure results from any cause beyond our reasonable control, including acts of God, labor disputes or other industrial disturbances, electrical or power outages, utilities or other telecommunications failures, earthquake, storms or other elements of nature, blockages, embargoes, riots, acts or orders of government, acts of terrorism, or war.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'13.4 Governing Law. The Governing Laws, without reference to conflict of law rules, govern this Agreement and any dispute of any sort that might arise between you and us. The United Nations Convention for the International Sale of Goods does not apply to this Agreement.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'13.5 Disputes. Any dispute or claim relating in any way to your use of the Service Offerings, or to any products or services sold or distributed by us will be adjudicated in the Governing Courts, and you consent to exclusive jurisdiction and venue in the Governing Courts. Any such dispute will be resolved by binding arbitration as provided in this Section 13.5, rather than in court, except that you may assert claims in small claims court if your claims qualify. Before litigation, you will first attempt to get your concern addressed via arbitration. There is no judge or jury in arbitration, and court review of an arbitration award is limited. However, an arbitrator can award on an individual basis the same damages and relief as a court (including injunctive and declaratory relief or statutory damages), and must follow the terms of this Agreement as a court would. To begin an arbitration proceeding, you must send a letter requesting arbitration and describing your claim to our headquarter address. We will reimburse those fees for claims totaling less than $10,000 unless the arbitrator determines the claims are frivolous. We will not seek attorneys\' fees and costs in arbitration unless the arbitrator determines the claims are frivolous. You may choose to have the arbitration conducted by telephone, based on written submissions, or at a mutually agreed location. We and you agree that any dispute resolution proceedings will be conducted only on an individual basis and not in a class, consolidated or representative action. If for any reason a claim proceeds in court rather than in arbitration we and you waive any right to a jury trial. Notwithstanding the foregoing we and you both agree that you or we may bring suit in court to enjoin infringement or other misuse of intellectual property rights.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'13.6 Trade Compliance. In connection with this Agreement, each party will comply with all applicable import, re-import, sanctions, anti-boycott, export, and re-export control laws and regulations. For clarity, you are solely responsible for compliance related to the manner in which you choose to use the Service Offerings, including your transfer and processing of Your Content, the provision of Your Content to End Users, and the region in which any of the foregoing occur. You represent and warrant that you and your financial institutions, or any party that owns or controls you or your financial institutions, are not subject to sanctions or otherwise designated on any list of prohibited or restricted parties, including but not limited to the lists maintained by the United Nations Security Council, the U.S. Government (e.g., the Specially Designated Nationals List and Foreign Sanctions Evaders List of the U.S. Department of Treasury, and the Entity List of the U.S. Department of Commerce), the European Union or its Member States, or other applicable government authority.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'13.7 Independent Contractors; Non-Exclusive Rights. We and you are independent contractors, and this Agreement will not be construed to create a partnership, joint venture, agency, or employment relationship. Neither party, nor any of their respective affiliates, is an agent of the other for any purpose or has the authority to bind the other. Both parties reserve the right (a) to develop or have developed for it products, services, concepts, systems, or techniques that are similar to or compete with the products, services, concepts, systems, or techniques developed or contemplated by the other party, and (b) to assist third party developers or systems integrators who may offer products or services which compete with the other party\u2019s products or services.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'13.8 Language. All communications and notices made or given pursuant to this Agreement must be in the English language. If we provide a translation of the English language version of this Agreement, the English language version of the Agreement will control if there is any conflict.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'13.9 Confidentiality and Publicity. You may use BrainChain Confidential Information only in connection with your use of the Service Offerings as permitted under this Agreement. You will not disclose BrainChain Confidential Information during the Term or at any time during the 5-year period following the end of the Term. You will take all reasonable measures to avoid disclosure, dissemination or unauthorized use of BrainChain Confidential Information, including, at a minimum, those measures you take to protect your own confidential information of a similar nature. You will not issue any press release or make any other public communication with respect to this Agreement or your use of the Service Offerings.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'13.10 Notice.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(a) To You. We may provide any notice to you under this Agreement by: (i) posting a notice on the BrainChain Site; or (ii) sending a message to the email address then associated with your account. Notices we provide by posting on the BrainChain Site will be effective upon posting and notices we provide by email will be effective when we send the email. It is your responsibility to keep your email address current. You will be deemed to have received any email sent to the email address then associated with your account when we send the email, whether or not you actually receive the email.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'(b) To Us. To give us notice under this Agreement, you must contact us by mail (benevolentears@brainchainmission.org) or personal delivery, overnight courier or registered or certified mail or Email, as applicable, listed for the applicable Contracting Party in Section 14 below. We may update the Email or address for notices to us by posting a notice on the BrainChain Site. Notices provided by personal delivery will be effective immediately. Notices provided by Email transmission or overnight courier will be effective one business day after they are sent. Notices provided registered or certified mail will be effective three business days after they are sent.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'13.11 No Third-Party Beneficiaries. Except as set forth in Section 9, this Agreement does not create any third-party beneficiary rights in any individual or entity that is not a party to this Agreement.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'13.12 No Waivers. The failure by us to enforce any provision of this Agreement will not constitute a present or future waiver of such provision nor limit our right to enforce such provision at a later time. All waivers by us must be in writing to be effective.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'13.13 Severability. If any portion of this Agreement is held to be invalid or unenforceable, the remaining portions of this Agreement will remain in full force and effect. Any invalid or unenforceable portions will be interpreted to effect and intent of the original portion. If such construction is not possible, the invalid or unenforceable portion will be severed from this Agreement but the rest of the Agreement will remain in full force and effect.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'14pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica-Bold',fontWeight:'bold',color:'#1b232f'}},'14. Definitions.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CAcceptable Use Policy\u201D means the policy located at the BrainChain Site (and any successor or related locations designated by us), as it may be updated by us from time to time.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CAccount Country\u201D is the country associated with your account. If you have provided a valid tax registration number for your account, then your Account Country is the country associated with your tax registration. If you have not provided a valid tax registration, then your Account Country is the country where your billing address is located, except if your credit card or bank account is issued in a different country and your contact address is also in that country, then your Account Country is that different country.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CAccount Information\u201D means information about you that you provide to us in connection with the creation or administration of your BrainChain account. For example, Account Information includes names, usernames, phone numbers, email addresses and billing information associated with your BrainChain account.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CAPI\u201D means an application program interface.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CBrainChain Confidential Information\u201D means all nonpublic information disclosed by us, our affiliates, business partners or our or their respective employees, contractors or agents that is designated as confidential or that, given the nature of the information or circumstances surrounding its disclosure, reasonably should be understood to be confidential. BrainChain Confidential Information includes: (a) nonpublic information relating to our or our affiliates or business partners\u2019 technology, customers, business plans, promotional and marketing activities, finances and other business affairs; (b) third-party information that we are obligated to keep confidential; and (c) the nature, content and existence of any discussions or negotiations between you and us or our affiliates. BrainChain Confidential Information does not include any information that: (i) is or becomes publicly available without breach of this Agreement; (ii) can be shown by documentation to have been known to you at the time of your receipt from us; (iii) is received from a third party who did not acquire or disclose the same by a wrongful or tortious act; or (iv) can be shown by documentation to have been independently developed by you without reference to the BrainChain Confidential Information.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201C BrainChain Content\u201D means Content we or any of our affiliates make available in connection with the Services or on the BrainChain Site to allow access to and use of the Services, including APIs; WSDLs; Documentation; sample code; software libraries; command line tools; proofs of concept; templates; and other related technology (including any of the foregoing that are provided by our personnel). BrainChain Content does not include the Services or Third-Party Content.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'"Contracting Party" means the party identified in the table below, based on your Account Country. If you change your Account Country to one identified to a different Contracting Party below, you agree that this Agreement is then assigned to the new Contracting Party under Section 13.1 without any further action required by either party.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201C BrainChain Marks\u201D means any trademarks, service marks, service or trade names, logos, and other designations of us and our affiliates that we may make available to you in connection with this Agreement.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201C BrainChain Site\u201D means http://www.brainchainmission.org\xA0 (and any successor or related site designated by us), as may be updated by us from time to time.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CContent\u201D means software (including machine images), data, text, audio, video or images.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CDocumentation\u201D means the user guides and admin guides (in each case exclusive of content referenced via hyperlink) for the Services located at the BrainChain Site (and any successor or related locations designated by us), as such user guides and admin guides may be updated by us from time to time.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CEnd User\u201D means any individual or entity that directly or indirectly through another user: (a) accesses or uses Your Content; or (b) otherwise accesses or uses the Service Offerings under your account. The term \u201CEnd User\u201D does not include individuals or entities when they are accessing or using the Services or any Content under their own BrainChain account, rather than under your account.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'"Governing Law\u201D and \u201CGoverning Courts\u201D mean, for each Contracting Party, the laws and courts set forth the court of Antwerp, Belgium. ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CIndirect Taxes\u201D means applicable taxes and duties, including, without limitation, VAT, Service Tax, GST, excise taxes, sales and transactions taxes, and gross receipts tax.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CLosses\u201D means any claims, damages, losses, liabilities, costs, and expenses (including reasonable attorneys\u2019 fees).')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CPolicies\u201D means the Acceptable Use Policy, Privacy Policy, the Site Terms, the Service Terms, the Trademark Use Guidelines, all restrictions described in the BrainChain Content and on the BrainChain Site, and any other policy or terms referenced in or incorporated into this Agreement, but does not include whitepapers or other marketing materials referenced on the BrainChain Site.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CPrivacy Policy\u201D means the privacy policy located at the BrainChain Site and it may be updated by us from time to time.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CService\u201D means each of the services made available by us or our affiliates, including those web services described in the Service Terms. Services do not include Third-Party Content.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CService Attributes\u201D means Service usage data related to your account, such as resource identifiers, metadata tags, security and access roles, rules, usage policies, permissions, usage statistics and analytics.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CService Level Agreement\u201D means all service level agreements that we offer with respect to the Services and post on the BrainChain Site, as they may be updated by us from time to time. The service level agreements we offer with respect to the Services are located at the BrainChain Site'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},' (and any successor or related locations designated by us), as may be updated us from time to time.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CService Offerings\u201D means the Services (including associated APIs), the BrainChain Content, the BrainChain Marks, and any other product or service provided by us under this Agreement. Service Offerings do not include Third-Party Content.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CService Terms\u201D means the rights and restrictions for particular Services located at the BrainChain Site'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},' (and any successor or related locations designated by us), as may be updated by us from time to time.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CSite Terms\u201D means the terms of use located at the BrainChain Site '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},' (and any successor or related locations designated by us), as may be updated by us from time to time.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CSuggestions\u201D means all suggested improvements to the Service Offerings that you provide to us.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CTerm\u201D means the term of this Agreement described in Section 7.1.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CTermination Date\u201D means the effective date of termination provided in accordance with Section 7, in a notice from one party to the other.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CThird-Party Content\u201D means Content made available to you by any third party on the BrainChain Site or in conjunction with the Services.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CTrademark Use Guidelines\u201D means the guidelines and trademark license located at the BrainChain Site'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},' (and any successor or related locations designated by us), as they may be updated by us from time to time.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'0pt',marginBottom:'0pt',widows:0,orphans:0,fontSize:'12pt'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontFamily:'Helvetica',color:'#262626'}},'\u201CYour Content\u201D means Content that you or any End User transfers to us for processing, storage or hosting by the Services in connection with your BrainChain account and any computational results that you or any End User derive from the foregoing through their use of the Services.')));}}]);return LicenseComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LicenseComponent);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_account_activation__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActivateApplicantAccount__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_account_userData__ = __webpack_require__(35);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state),email:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_userData__["f" /* getUserEmail */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onActivate:function onActivate(token,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_activation__["b" /* fetchActivateAccount */])(token,data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__ActivateApplicantAccount__["a" /* default */]));

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActivateApplicantAccount_css__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActivateApplicantAccount_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ActivateApplicantAccount_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__confirmPassword_ConfirmPasswordActivation_container__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_utils__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActivateApplicantAccount=function(_Component){_inherits(ActivateApplicantAccount,_Component);function ActivateApplicantAccount(props){_classCallCheck(this,ActivateApplicantAccount);var _this=_possibleConstructorReturn(this,(ActivateApplicantAccount.__proto__||Object.getPrototypeOf(ActivateApplicantAccount)).call(this,props));_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.onActivate=function(e){e.preventDefault();if(_this.state.password!==''&&_this.state.password===_this.state.passwordConfirm&&__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].isValidPassword(_this.state.password)){var data={password:_this.state.password};_this.props.onActivate(_this.props.token,data);}};_this.state={password:'',passwordConfirm:''};return _this;}_createClass(ActivateApplicantAccount,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activation-applicant-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'activation.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'activation.activation_success_alert')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["n" /* Form */],{onSubmit:this.onActivate},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'activation.activate_applicant_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["v" /* Label */],{sm:3},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["r" /* Input */],{type:'text',value:this.props.email,disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__confirmPassword_ConfirmPasswordActivation_container__["a" /* default */],{handleChange:this.handleChange,password:this.state.password,passwordConfirm:this.state.passwordConfirm}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submit-activation-applicant-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'activation.activate_button'))))));}}]);return ActivateApplicantAccount;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ActivateApplicantAccount.propTypes={email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,token:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onActivate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ActivateApplicantAccount);

/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RestoreAccount__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_account_restoreAccount__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{email:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_restoreAccount__["d" /* getResetPasswordEmail */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onRestoreAccount:function onRestoreAccount(email){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_restoreAccount__["g" /* sendResetPasswordEmail */])(email));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__RestoreAccount__["a" /* default */]));

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RestoreAccount_css__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RestoreAccount_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__RestoreAccount_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RestoreAccount=function(_Component){_inherits(RestoreAccount,_Component);function RestoreAccount(props){_classCallCheck(this,RestoreAccount);var _this=_possibleConstructorReturn(this,(RestoreAccount.__proto__||Object.getPrototypeOf(RestoreAccount)).call(this,props));_this.handleEmailChange=function(e){_this.setState({email:e.target.value});};_this.handleSubmit=function(e){e.preventDefault();_this.props.onRestoreAccount(_this.state.email);};_this.state={email:props.email};return _this;}_createClass(RestoreAccount,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'restore-account-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/login',label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'login.back_to_login_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'restore-account-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'restore-account-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'restore_account.success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Form */],{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'restore_account.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:'email',value:this.state.email,onChange:this.handleEmailChange,required:true,placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{type:'submit',block:true,className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'restore_account.submit_button')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'help-message-container'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'restore_account.link_to_help_text'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:'/support'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'restore_account.link_to_help')),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'restore_account.link_to_help_end'))))));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({email:nextProps.email});}}]);return RestoreAccount;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RestoreAccount.propTypes={onRestoreAccount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RestoreAccount);

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResetPassword__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_account_restoreAccount__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_tokenCheck__ = __webpack_require__(177);
var mapStateToProps=function mapStateToProps(state,_ref){var location=_ref.location;var searchParams=__WEBPACK_IMPORTED_MODULE_2__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search);return{token:searchParams.token,isActualToken:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_tokenCheck__["d" /* isActualToken */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_tokenCheck__["f" /* isLoading */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onResetPassword:function onResetPassword(token,password){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_restoreAccount__["f" /* sendResetPassword */])(token,password));},onCheckToken:function onCheckToken(token){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_tokenCheck__["c" /* fetchCheckToken */])(token));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ResetPassword__["a" /* default */]));

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__confirmPassword_ConfirmPasswordActivation_container__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ResetPassword_css__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ResetPassword_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ResetPassword_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResetPassword=function(_Component){_inherits(ResetPassword,_Component);function ResetPassword(props){_classCallCheck(this,ResetPassword);var _this=_possibleConstructorReturn(this,(ResetPassword.__proto__||Object.getPrototypeOf(ResetPassword)).call(this,props));_this.handleChange=function(fieldName){return function(e){_this.setState(_defineProperty({},fieldName,e.target.value));};};_this.handleSubmit=function(e){e.preventDefault();if(_this.state.password!==''&&_this.state.password===_this.state.passwordConfirm&&__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].isValidPassword(_this.state.password)){_this.props.onResetPassword(_this.props.token,{newPassword:_this.state.password});}};_this.state={password:'',passwordConfirm:''};return _this;}_createClass(ResetPassword,[{key:'componentWillMount',value:function componentWillMount(){this.props.onCheckToken(this.props.token);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reset-password-container'},this.renderContent());}},{key:'renderContent',value:function renderContent(){if(this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}if(this.props.success){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["d" /* Redirect */],{to:'/login'});}if(!this.props.token){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(this.props.translation,'reset_password.incorrect_link_alert'));}if(!this.props.isActualToken){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(this.props.translation,'reset_password.expired_link_alert'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reset-password-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(this.props.translation,'reset_password.success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Form */],{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(this.props.translation,'reset_password.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__confirmPassword_ConfirmPasswordActivation_container__["a" /* default */],{password:this.state.password,passwordConfirm:this.state.passwordConfirm,handleChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reset-password-submit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{className:'reset-password-submit-button olive-green-btn',type:'submit'},__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(this.props.translation,'reset_password.submit_button'))))));}}]);return ResetPassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ResetPassword.propTypes={isActualToken:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,loading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,token:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onResetPassword:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onCheckToken:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ResetPassword);

/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangeEmailFinish__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_account_restoreAccount__ = __webpack_require__(81);
var mapStateToProps=function mapStateToProps(state,_ref){var location=_ref.location;var searchParams=__WEBPACK_IMPORTED_MODULE_2__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search);return{token:searchParams.token,success:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),error:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["e" /* getSubmitFormError */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSubmitEmailChange:function onSubmitEmailChange(token){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_restoreAccount__["e" /* onSubmitChangeEmail */])(token));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ChangeEmailFinish__["a" /* default */]));

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChangeEmailFinish_css__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChangeEmailFinish_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ChangeEmailFinish_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//TODO: add missed translations
var ChangeEmailFinish=function(_Component){_inherits(ChangeEmailFinish,_Component);function ChangeEmailFinish(){_classCallCheck(this,ChangeEmailFinish);return _possibleConstructorReturn(this,(ChangeEmailFinish.__proto__||Object.getPrototypeOf(ChangeEmailFinish)).apply(this,arguments));}_createClass(ChangeEmailFinish,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.token){this.props.onSubmitEmailChange(this.props.token);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'change-email-finish'},this.renderContent());}},{key:'renderContent',value:function renderContent(){var content=null;if(!this.props.token){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'reset_password.incorrect_link_alert'));}else if(this.props.success){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'change_password.finish_change_email'));}else if(this.props.error){var errorLabel=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].errors)[this.props.error]||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].defaultError);content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Alert */],{color:'danger'},errorLabel);}if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(content)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/login',label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'login.back_to_login_button')}),content);}}]);return ChangeEmailFinish;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ChangeEmailFinish.propTypes={token:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,success:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,error:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onSubmitEmailChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ChangeEmailFinish);

/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResendActivation__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_account_activation__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{success:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSubmit:function onSubmit(email){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_activation__["c" /* fetchResendActivation */])(email));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ResendActivation__["a" /* default */]));

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ResendActivation_css__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ResendActivation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ResendActivation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResendActivation=function(_Component){_inherits(ResendActivation,_Component);function ResendActivation(props){_classCallCheck(this,ResendActivation);var _this=_possibleConstructorReturn(this,(ResendActivation.__proto__||Object.getPrototypeOf(ResendActivation)).call(this,props));_this.renderContent=function(){if(_this.state.success){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center success-message-header'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'resend_activation.success_message'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resend-activation-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'resend_activation.success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Form */],{onSubmit:_this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'resend_activation.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:'email',value:_this.state.email,onChange:_this.handleEmailChange,required:true,placeholder:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{type:'submit',block:true,className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'resend_activation.submit_button')))));}};_this.handleEmailChange=function(e){_this.setState({email:e.target.value});};_this.handleSubmit=function(e){e.preventDefault();_this.props.onSubmit(_this.state.email);};_this.state={email:"",success:false};return _this;}_createClass(ResendActivation,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.success&&!this.props.success){this.setState({success:true});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resend-activation-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/login',label:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'login.back_to_login_button')}),this.renderContent());}}]);return ResendActivation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ResendActivation.propTypes={success:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onSubmit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ResendActivation);

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_account_createAccount__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RegisterApplicant__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{success:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onRegister:function onRegister(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_createAccount__["a" /* fetchRegisterApplicant */])(data));},onShowLicenseAgreement:function onShowLicenseAgreement(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["F" /* MODAL_LICENSE_AGREEMENT */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__RegisterApplicant__["a" /* default */]));

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RegisterApplicant_css__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RegisterApplicant_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RegisterApplicant_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__personalData_PersonalData_container__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__personalData_PersonalData__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_licenseAgreement_LicenseAgreementModal_container__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var requiredSelectFields=['countryCode'];var RegisterApplicant=function(_Component){_inherits(RegisterApplicant,_Component);function RegisterApplicant(props){_classCallCheck(this,RegisterApplicant);var _this=_possibleConstructorReturn(this,(RegisterApplicant.__proto__||Object.getPrototypeOf(RegisterApplicant)).call(this,props));_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleAgree=function(){_this.setState({isAgreeWithLicense:true});};_this.handleChangeAgreement=function(){_this.setState({isAgreeWithLicense:!_this.state.isAgreeWithLicense});};_this.handleChangeByValue=function(fieldKey){return function(value){_this.setState(_defineProperty({},fieldKey,value));};};_this.handleClickLicenseAgreement=function(e){e.preventDefault();_this.props.onShowLicenseAgreement();};_this.onRegister=function(e){e.preventDefault();if(!_this.checkRequiredSelectFields()){var data={email:_this.state.email,identityAlias:{}};var personalDataFields=['firstName','lastName','phoneNumber','countryCode'];__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(personalDataFields,function(fieldName){if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(_this.state[fieldName])){data.identityAlias[fieldName]=_this.state[fieldName];}});_this.props.onRegister(data);}};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(requiredSelectFields,function(field){if(!_this.state[field]&&!error){error=field;}});_this.setState({requiredFieldError:error});return error;};_this.state={firstName:'',lastName:'',email:'',phoneNumber:'',countryCode:'',isAgreeWithLicense:false,success:false,requiredFieldError:null};return _this;}_createClass(RegisterApplicant,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.success&&!this.props.success){this.setState({success:true});}}},{key:'render',value:function render(){if(this.state.success){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/login',label:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'register_applicant.back_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center succes-message-header'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'register_applicant.success_message')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'register-applicant-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'register_applicant.success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/login',label:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'register_applicant.back_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'register_applicant.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'register-applicant-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["n" /* Form */],{onSubmit:this.onRegister},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'register_applicant.message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__personalData_PersonalData_container__["a" /* default */],{handleChange:this.handleChange,handleChangeByValue:this.handleChangeByValue,firstName:this.state.firstName,lastName:this.state.lastName,email:this.state.email,isEmailEditable:true,phoneNumber:this.state.phoneNumber,countryCode:this.state.countryCode,requiredFields:['firstName','lastName','email','continentCode','countryCode'],requiredFieldError:this.state.requiredFieldError,mode:__WEBPACK_IMPORTED_MODULE_4__personalData_PersonalData__["a" /* PERSONAL_FORM_MODE */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submit-register-applicant-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'register-applicant-license-agreement-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["v" /* Label */],{className:'checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["r" /* Input */],{type:'checkbox',checked:this.state.isAgreeWithLicense,onChange:this.handleChangeAgreement}),__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,"license_agreement.agree_label"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'',className:'register-applicant-license-agreement-link',onClick:this.handleClickLicenseAgreement},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,"license_agreement.agree_link")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn',disabled:!this.state.isAgreeWithLicense},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'register_applicant.submit_button')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_licenseAgreement_LicenseAgreementModal_container__["a" /* default */],{onAgree:this.handleAgree}));}}]);return RegisterApplicant;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RegisterApplicant.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onRegister:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,success:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onShowLicenseAgreement:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RegisterApplicant);

/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_account_activation__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_account_createAccount__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RegisterInvitedApplicant__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_tokenCheck__ = __webpack_require__(177);
var mapStateToProps=function mapStateToProps(state,_ref){var location=_ref.location;return{isEmailAvailable:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_tokenCheck__["e" /* isEmailAvailable */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_tokenCheck__["f" /* isLoading */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_activation__["d" /* getInvitedApplicantDataFromLocation */])(location)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onActivate:function onActivate(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_createAccount__["a" /* fetchRegisterApplicant */])(data));},onShowLicenseAgreement:function onShowLicenseAgreement(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_6__reducers_common_activeModal__["F" /* MODAL_LICENSE_AGREEMENT */]}));},onCheckEmailAvailability:function onCheckEmailAvailability(email){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_tokenCheck__["b" /* fetchCheckEmailAvailability */])(email));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RegisterInvitedApplicant__["a" /* default */]));

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RegisterInvitedApplicant_css__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RegisterInvitedApplicant_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RegisterInvitedApplicant_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__personalData_PersonalData_container__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__personalData_PersonalData__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__confirmPassword_ConfirmPasswordActivation_container__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_licenseAgreement_LicenseAgreementModal_container__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var requiredSelectFields=['countryCode'];var RegisterInvitedApplicant=function(_Component){_inherits(RegisterInvitedApplicant,_Component);function RegisterInvitedApplicant(props){_classCallCheck(this,RegisterInvitedApplicant);var _this=_possibleConstructorReturn(this,(RegisterInvitedApplicant.__proto__||Object.getPrototypeOf(RegisterInvitedApplicant)).call(this,props));_this.handleClickLicenseAgreement=function(e){e.preventDefault();_this.props.onShowLicenseAgreement();};_this.getLinkIrrelevantMessage=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'irrelevant-invited-applicant-activation-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(_this.props.translation,'activation.activation_link_irrelevant_message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(_this.props.translation,'activation.activation_link_irrelevant_forgot_password_message_start')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/login/restore'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(_this.props.translation,'activation.activation_link_irrelevant_forgot_password_message_link'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(_this.props.translation,'activation.activation_link_irrelevant_forgot_password_message_end'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(_this.props.translation,'activation.activation_link_irrelevant_log_in_message_start')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/login'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(_this.props.translation,'activation.activation_link_irrelevant_log_in_message_link'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(_this.props.translation,'activation.activation_link_irrelevant_log_in_message_end'))));};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.setAgreementTrue=function(){_this.setState({isAgreeWithLicense:true});};_this.handleChangeByValue=function(fieldKey){return function(value){_this.setState(_defineProperty({},fieldKey,value));};};_this.handleChangeAgreement=function(){_this.setState({isAgreeWithLicense:!_this.state.isAgreeWithLicense});};_this.onActivate=function(e){e.preventDefault();if(_this.state.password!==''&&_this.state.password===_this.state.passwordConfirm&&__WEBPACK_IMPORTED_MODULE_10__utils_utils__["a" /* Utils */].isValidPassword(_this.state.password)&&!_this.checkRequiredSelectFields()){var data={password:_this.state.password,token:_this.props.data.token,email:_this.state.email,identityAlias:{firstName:_this.state.firstName,lastName:_this.state.lastName,phoneNumber:!__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.isNil(_this.state.phoneNumber)&&_this.state.phoneNumber!==""?_this.state.phoneNumber:null,countryCode:_this.state.countryCode}};_this.props.onActivate(data);}};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(requiredSelectFields,function(field){if(!_this.state[field]&&!error){error=field;}});_this.setState({requiredFieldError:error});return error;};_this.state={firstName:'',lastName:'',email:'',phoneNumber:'',countryCode:'',password:'',passwordConfirm:'',isAgreeWithLicense:false,requiredFieldError:null};if(_this.props.data){_this.state.firstName=_this.props.data.firstName||"";_this.state.lastName=_this.props.data.lastName||"";_this.state.email=_this.props.data.email||"";_this.state.countryCode=_this.props.data.countryCode||"";}return _this;}_createClass(RegisterInvitedApplicant,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.data){this.props.onCheckEmailAvailability(this.props.data.email);}}},{key:'render',value:function render(){if(this.props.success){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["d" /* Redirect */],{to:'/login'});}if(this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_12__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}if(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.isNil(this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'incorrect-activation-invited-applicant-container'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this.props.translation,'activation.incorrect_activation_link_alert'));}if(!this.props.isEmailAvailable){return this.getLinkIrrelevantMessage();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activation-invited-applicant-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this.props.translation,'activation.activation_success_alert')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this.props.translation,'activation.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["n" /* Form */],{onSubmit:this.onActivate,key:'activate-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this.props.translation,'activation.activate_personal_data_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__personalData_PersonalData_container__["a" /* default */],{handleChange:this.handleChange,handleChangeByValue:this.handleChangeByValue,firstName:this.state.firstName,lastName:this.state.lastName,email:this.state.email,phoneNumber:this.state.phoneNumber,countryCode:this.state.countryCode,requiredFields:['firstName','lastName','email','continentCode','countryCode'],requiredFieldError:this.state.requiredFieldError,mode:__WEBPACK_IMPORTED_MODULE_4__personalData_PersonalData__["a" /* PERSONAL_FORM_MODE */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this.props.translation,'activation.activate_password_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__confirmPassword_ConfirmPasswordActivation_container__["a" /* default */],{handleChange:this.handleChange,password:this.state.password,passwordConfirm:this.state.passwordConfirm}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submit-activation-invited-applicant-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'license-agreement-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["v" /* Label */],{className:'checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["r" /* Input */],{type:'checkbox',checked:this.state.isAgreeWithLicense,onChange:this.handleChangeAgreement}),__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this.props.translation,"license_agreement.agree_label"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'',className:'license-agreement-link',onClick:this.handleClickLicenseAgreement},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this.props.translation,"license_agreement.agree_link")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn',disabled:!this.state.isAgreeWithLicense},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this.props.translation,'activation.activate_button'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_licenseAgreement_LicenseAgreementModal_container__["a" /* default */],{onAgree:this.setAgreementTrue}));}}]);return RegisterInvitedApplicant;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RegisterInvitedApplicant.propTypes={location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isEmailAvailable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,success:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCheckEmailAvailability:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onActivate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onShowLicenseAgreement:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RegisterInvitedApplicant);

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccountManagementComponent__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__AccountManagementComponent__["a" /* default */]));

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccountManagementComponent_css__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccountManagementComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AccountManagementComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aliasesManagement_aliasesList_AliasesList_container__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__changePassword_ChangePassword_container__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__aliasesManagement_defaultAliasManagement_DefaultAliasManagement_container__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notificationSettings_NotificationSettings_container__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__securitySettings_SecuritySettings_container__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_utils__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ACCOUNT_PAGES={ALIASES:"aliases",EDIT_DEFAULT_ALIAS:"edit_default_alias",CHANGE_PASSWORD:"change_password",NOTIFICATION_SETTINGS:"notification_settings",SECURITY_SETTINGS:"security_settings"};var AccountManagementComponent=function(_Component){_inherits(AccountManagementComponent,_Component);function AccountManagementComponent(props){_classCallCheck(this,AccountManagementComponent);var _this=_possibleConstructorReturn(this,(AccountManagementComponent.__proto__||Object.getPrototypeOf(AccountManagementComponent)).call(this,props));_this.renderMenuToggler=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:_this.toggleList,className:"toggle-settings-menu-button "+(_this.state.isOpenMenu?"button-open":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'toggle-settings-menu-icon',icon:'arrow_back'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,"account_management."+(_this.state.isOpenMenu?"close_account_management_menu_label":"open_account_management_menu_label")))));};_this.renderPageContent=function(){switch(_this.state.currentPage){case ACCOUNT_PAGES.CHANGE_PASSWORD:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__changePassword_ChangePassword_container__["a" /* default */],null);case ACCOUNT_PAGES.EDIT_DEFAULT_ALIAS:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__aliasesManagement_defaultAliasManagement_DefaultAliasManagement_container__["a" /* default */],null);case ACCOUNT_PAGES.ALIASES:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__aliasesManagement_aliasesList_AliasesList_container__["a" /* default */],null);case ACCOUNT_PAGES.NOTIFICATION_SETTINGS:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__notificationSettings_NotificationSettings_container__["a" /* default */],null);case ACCOUNT_PAGES.SECURITY_SETTINGS:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__securitySettings_SecuritySettings_container__["a" /* default */],null);default:return null;}};_this.handleChangePage=function(newPage){return function(){_this.setState({currentPage:newPage});_this.toggleList();};};_this.toggleList=function(){_this.setState({isOpenMenu:!_this.state.isOpenMenu});};_this.state={currentPage:ACCOUNT_PAGES.EDIT_DEFAULT_ALIAS,isOpenMenu:false};return _this;}_createClass(AccountManagementComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'account-management-container'},this.renderMenuToggler(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"account-management-navbar"+(this.state.isOpenMenu?" page-open":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'account-management-label'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'account_management.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["y" /* Nav */],{className:'account-settings-navbar',vertical:true,pills:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* NavItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["A" /* NavLink */],{href:'#',onClick:this.handleChangePage(ACCOUNT_PAGES.EDIT_DEFAULT_ALIAS),active:this.state.currentPage===ACCOUNT_PAGES.EDIT_DEFAULT_ALIAS},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,"aliases.edit_default_alias"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* NavItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["A" /* NavLink */],{href:'#',onClick:this.handleChangePage(ACCOUNT_PAGES.CHANGE_PASSWORD),active:this.state.currentPage===ACCOUNT_PAGES.CHANGE_PASSWORD},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,ACCOUNT_PAGES.CHANGE_PASSWORD+".label"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* NavItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["A" /* NavLink */],{href:'#',onClick:this.handleChangePage(ACCOUNT_PAGES.NOTIFICATION_SETTINGS),active:this.state.currentPage===ACCOUNT_PAGES.NOTIFICATION_SETTINGS},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,ACCOUNT_PAGES.NOTIFICATION_SETTINGS+".label"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["z" /* NavItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["A" /* NavLink */],{href:'#',onClick:this.handleChangePage(ACCOUNT_PAGES.SECURITY_SETTINGS),active:this.state.currentPage===ACCOUNT_PAGES.SECURITY_SETTINGS},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,ACCOUNT_PAGES.SECURITY_SETTINGS+".label"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'account-page-container'},this.renderPageContent()));}}]);return AccountManagementComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AccountManagementComponent.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AccountManagementComponent);

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AliasesList__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_account_aliases__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_aliases__["n" /* loadingAliases */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_aliases__["k" /* getAliasesData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGetAliases:function onGetAliases(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_aliases__["d" /* fetchGetAliases */])());},onOpenRemoveAliasModal:function onOpenRemoveAliasModal(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["O" /* MODAL_REMOVE_ALIAS */]}));},onOpenAddAliasModal:function onOpenAddAliasModal(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["f" /* MODAL_ADD_ALIAS */]}));},onChangeExpose:function onChangeExpose(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_aliases__["h" /* fetchUpdateAlias */])(id,data));},onSetDefaultAlias:function onSetDefaultAlias(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_aliases__["g" /* fetchSetDefaultAlias */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AliasesList__["a" /* default */]));

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AliasesList_css__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AliasesList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AliasesList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addAliasModal_AddAliasModal__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__removeAliasModal_RemoveAliasModal_container__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__addAliasModal_AddAliasModal_container__ = __webpack_require__(741);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AliasesList=function(_Component){_inherits(AliasesList,_Component);function AliasesList(props){_classCallCheck(this,AliasesList);var _this=_possibleConstructorReturn(this,(AliasesList.__proto__||Object.getPrototypeOf(AliasesList)).call(this,props));_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'aliases-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["N" /* Table */],{className:'aliases-list-table',cellSpacing:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].phone_number_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'expose-header'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'aliases.expose_phone_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'expose-header'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'aliases.expose_email_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderAliasesData()));};_this.changeDefaultAlias=function(id){return function(){_this.props.onSetDefaultAlias(id);};};_this.onExposePhoneClick=function(id,alias){return function(){var data=alias;data.exposePhone=!data.exposePhone;_this.props.onChangeExpose(id,data);};};_this.onExposeEmailClick=function(id,alias){return function(){var data=alias;data.exposeEmail=!data.exposeEmail;_this.props.onChangeExpose(id,data);};};_this.onAddButtonClick=function(){_this.setState({mode:__WEBPACK_IMPORTED_MODULE_7__addAliasModal_AddAliasModal__["a" /* ADD_MODE */],currentAliasId:null});_this.props.onOpenAddAliasModal();};_this.onEditButtonClick=function(id){return function(){_this.setState({mode:__WEBPACK_IMPORTED_MODULE_7__addAliasModal_AddAliasModal__["b" /* EDIT_MODE */],currentAliasId:id});_this.props.onOpenAddAliasModal();};};_this.onRemoveButtonClick=function(id){return function(){_this.setState({currentAliasId:id});_this.props.onOpenRemoveAliasModal();};};_this.state={data:_this.props.data,currentAliasId:null,mode:null};return _this;}_createClass(AliasesList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onGetAliases();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'aliases-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'aliases.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'add-alias-button olive-green-btn',onClick:this.onAddButtonClick},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].add_button))),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__removeAliasModal_RemoveAliasModal_container__["a" /* default */],{id:this.state.currentAliasId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__addAliasModal_AddAliasModal_container__["a" /* default */],{mode:this.state.mode,id:this.state.currentAliasId}));}},{key:'renderAliasesData',value:function renderAliasesData(){var _this2=this;var sortedData=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.props.data,['default'],['desc']);return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(sortedData,function(alias,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index,className:"aliases-list-row "+(alias.default?"default-alias":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'aliases-icon-container'},alias.default?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'aliases-icon',title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'aliases.default_alias_label'),icon:'radio_button_checked',key:"default-alias-"+alias.id}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'aliases-icon',title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'aliases.set_as_default_alias_label'),icon:'radio_button_unchecked',key:"non-default-alias-"+alias.id,onClick:_this2.changeDefaultAlias(alias.id)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,alias.firstName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,alias.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,alias.phoneNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].countries+'.'+alias.countryCode)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'aliases-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'aliases-icon',icon:"check_box"+(!alias.exposePhone?"_outline_blank":""),key:"expose-phone-"+alias.id,onClick:_this2.onExposePhoneClick(alias.id,alias),title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'aliases.expose_phone_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'aliases-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'aliases-icon',icon:"check_box"+(!alias.exposeEmail?"_outline_blank":""),key:"expose-email-"+alias.id,onClick:_this2.onExposeEmailClick(alias.id,alias),title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'aliases.expose_email_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'aliases-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'aliases-icon',icon:'create',key:"edit-alias-"+alias.id,onClick:_this2.onEditButtonClick(alias.id),title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'aliases.edit_alias_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'aliases-icon-container'},alias.default?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'aliases-icon',icon:'clear',key:"delete-alias-"+alias.id,onClick:_this2.onRemoveButtonClick(alias.id),title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'aliases.delete_alias_label')})));});}}]);return AliasesList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AliasesList.propTypes={data:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,loading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onGetAliases:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onChangeExpose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onSetDefaultAlias:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onOpenAddAliasModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onOpenRemoveAliasModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AliasesList);

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_account_aliases__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RemoveAliasModal__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state,_ref){var id=_ref.id;return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["O" /* MODAL_REMOVE_ALIAS */],data:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_aliases__["j" /* getAliasDataById */])(state,id),translation:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onRemove:function onRemove(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_aliases__["f" /* fetchRemoveAlias */])(id));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__RemoveAliasModal__["a" /* default */]));

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RemoveAliasModal_css__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RemoveAliasModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__RemoveAliasModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveAliasModal=function(_Component){_inherits(RemoveAliasModal,_Component);function RemoveAliasModal(props){_classCallCheck(this,RemoveAliasModal);var _this=_possibleConstructorReturn(this,(RemoveAliasModal.__proto__||Object.getPrototypeOf(RemoveAliasModal)).call(this,props));_this.renderAliasData=function(){var paramsList=[{value:"firstName",title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)},{value:"lastName",title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)},{value:"phoneNumber",title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].phone_number_label)},{value:"countryName",title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(paramsList,_this.getLabel)));};_this.getLabel=function(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,params.title+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,_this.state.data[params.value])));};_this.onCancelHandle=function(){_this.clearData();_this.props.onCancel();};_this.onRemoveHandle=function(){_this.props.onRemove(_this.props.id);};_this.clearData=function(){_this.setState({data:null});};_this.state={data:null};return _this;}_createClass(RemoveAliasModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(nextProps.data)){var newData=nextProps.data;newData.countryName=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].countries+'.'+newData.countryCode);this.setState({data:newData});}else{this.clearData();}}},{key:'render',value:function render(){if(this.state.data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen,toggle:this.onCancelHandle,className:'remove-alias-modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'aliases.remove_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'aliases.remove_title')),this.renderAliasData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.onCancelHandle},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.onRemoveHandle},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))))));}else{return null;}}}]);return RemoveAliasModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveAliasModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveAliasModal);

/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_account_aliases__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddAliasModal__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state,_ref){var id=_ref.id;return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["f" /* MODAL_ADD_ALIAS */],data:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_aliases__["j" /* getAliasDataById */])(state,id),translation:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["e" /* getTranslation */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["e" /* getCountriesData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAdd:function onAdd(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_aliases__["c" /* fetchAddAlias */])(data));},onEdit:function onEdit(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_account_aliases__["h" /* fetchUpdateAlias */])(id,data));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},setCurrentContinentByCountry:function setCurrentContinentByCountry(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["i" /* setCurrentContinentByCountry */])(countryCode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__AddAliasModal__["c" /* default */]));

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangePassword__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_account_restoreAccount__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_account_userData__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_account_role__ = __webpack_require__(20);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),userEmail:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_userData__["f" /* getUserEmail */])(state),role:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_account_role__["n" /* getCurrentRole */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChangePassword:function onChangePassword(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_restoreAccount__["b" /* fetchChangePassword */])(data));},onChangeEmail:function onChangeEmail(email){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_restoreAccount__["c" /* fetchUpdateEmail */])(email));},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ChangePassword__["a" /* default */]));

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__confirmPassword_ConfirmPasswordActivation_container__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChangePassword_css__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChangePassword_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ChangePassword_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_account_role__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangePassword=function(_Component){_inherits(ChangePassword,_Component);function ChangePassword(props){_classCallCheck(this,ChangePassword);var _this=_possibleConstructorReturn(this,(ChangePassword.__proto__||Object.getPrototypeOf(ChangePassword)).call(this,props));_this.renderChangeEmailForm=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Form */],{onSubmit:_this.handleEmailChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'change_password.change_email')),_this.props.role===__WEBPACK_IMPORTED_MODULE_9__reducers_account_role__["b" /* ROLES */].EMPLOYEE?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'change-email-hint'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'change_password.change_email_hint')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':'user-email',sm:3},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].email_label),'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:'email',id:'user-email',value:_this.state.userEmail,onChange:_this.handleChange('userEmail'),disabled:_this.props.role===__WEBPACK_IMPORTED_MODULE_9__reducers_account_role__["b" /* ROLES */].SYS_ADMIN,required:true,placeholder:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-email-submit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{className:'user-email-submit-button olive-green-btn',type:'submit',disabled:_this.state.userEmail===_this.props.userEmail},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'change_password.update_email'))));};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleEmailChange=function(e){e.preventDefault();_this.props.onChangeEmail(_this.state.userEmail);};_this.toggleModal=function(e){_this.props.onUnmount();e.preventDefault();_this.setState({isModalOpen:!_this.state.isModalOpen});};_this.handlePasswordChange=function(){if(_this.state.password!==''&&_this.state.password===_this.state.passwordConfirm&&__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].isValidPassword(_this.state.password)){var data={oldPassword:_this.state.oldPassword,newPassword:_this.state.password};_this.props.onChangePassword(data);}};_this.state={oldPassword:'',password:'',passwordConfirm:'',isModalOpen:false,userEmail:props.userEmail};return _this;}_createClass(ChangePassword,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'change-password-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'change_password.change_email_alert')},this.renderChangeEmailForm(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Form */],{onSubmit:this.toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'change_password.change_password')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':'old-password',sm:3},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'change_password.old_password_label')+"*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:'password',id:'old-password',value:this.state.oldPassword,onChange:this.handleChange('oldPassword'),required:true,placeholder:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'change_password.old_password_input_placeholder')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__confirmPassword_ConfirmPasswordActivation_container__["a" /* default */],{password:this.state.password,passwordConfirm:this.state.passwordConfirm,handleChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'change-password-submit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{className:'change-password-submit-button olive-green-btn',type:'submit',disabled:this.state.password===''||this.state.password!==this.state.passwordConfirm||!__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].isValidPassword(this.state.password)},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'change_password.submit_button'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["w" /* Modal */],{isOpen:this.state.isModalOpen,toggle:this.toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'change_password.change_password_alert')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{onClick:this.toggleModal,color:'secondary'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{onClick:this.handlePasswordChange,className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].okey_button))))))));}}]);return ChangePassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ChangePassword.propTypes={role:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onChangePassword:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ChangePassword);

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DefaultAliasManagement__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_account_aliases__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_account_role__ = __webpack_require__(20);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_aliases__["n" /* loadingAliases */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_aliases__["l" /* getDefaultAliasData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["e" /* getCountriesData */])(state),role:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_role__["n" /* getCurrentRole */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGetDefaultAlias:function onGetDefaultAlias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_aliases__["e" /* fetchGetDefaultAlias */])());},onChangeAlias:function onChangeAlias(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_aliases__["i" /* fetchUpdateDefaultAlias */])(id,data));},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},setCurrentContinentByCountry:function setCurrentContinentByCountry(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["i" /* setCurrentContinentByCountry */])(countryCode));},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_aliases__["a" /* clearDefaultAlias */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__DefaultAliasManagement__["a" /* default */]));

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DefaultAliasManagement_css__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DefaultAliasManagement_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DefaultAliasManagement_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_account_role__ = __webpack_require__(20);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var requiredSelectFields=['countryCode'];var DefaultAliasManagement=function(_Component){_inherits(DefaultAliasManagement,_Component);function DefaultAliasManagement(props){_classCallCheck(this,DefaultAliasManagement);var _this=_possibleConstructorReturn(this,(DefaultAliasManagement.__proto__||Object.getPrototypeOf(DefaultAliasManagement)).call(this,props));_this.renderContent=function(){if(_this.props.loading&&__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(_this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.renderAliasFormGroups(),_this.renderLocationFormGroups(),_this.renderCheckBoxes(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',disabled:_this.saveButtonDisabled(),type:'submit'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button))));};_this.saveButtonDisabled=function(){if(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(_this.props.data)){return true;}var oldData=Object.assign({},_this.props.data,{phoneNumber:_this.props.data.phoneNumber||""});return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.every(oldData,function(value,key){return _this.state.hasOwnProperty(key)?_this.state[key]===value:true;});};_this.renderCheckBoxes=function(){if(_this.props.role!==__WEBPACK_IMPORTED_MODULE_9__reducers_account_role__["b" /* ROLES */].APPLICANT){return null;}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alias-checkbox-container',key:'expose-phone-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{key:'expose-phone',className:'alias-checkbox-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'checkbox-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{className:'checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'checkbox',checked:_this.state.exposePhone,onChange:_this.handleChangeExpose("exposePhone")}),__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'aliases.expose_phone_label'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alias-checkbox-container',key:'expose-email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{key:'expose-email',className:'alias-checkbox-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'checkbox-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{className:'checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'checkbox',checked:_this.state.exposeEmail,onChange:_this.handleChangeExpose("exposeEmail")}),__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'aliases.expose_email_label')))))];};_this.renderAliasFormGroups=function(){var paramsList=[{value:"firstName",title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),isRequired:true},{value:"lastName",title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),isRequired:true},{value:"phoneNumber",title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].phone_number_label)}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderLocationFormGroups=function(){var paramsList=[{value:"continentCode",title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label),onChange:_this.handleChangeContinent,type:'select',content:__WEBPACK_IMPORTED_MODULE_5__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),isDisabled:!_this.props.continents,isRequired:true},{value:"countryCode",title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),onChange:_this.handleChangeCountry,type:'select',content:__WEBPACK_IMPORTED_MODULE_5__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isDisabled:!_this.props.countries,isRequired:true}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(paramsList,_this.getSelectFormGroup)));};_this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];}),options:params.content,onSelect:params.onChange,placeholder:params.placeholder,disabled:params.isDisabled,requiredFieldError:_this.state.requiredFieldError===params.value})));};_this.getFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:_this.state[params.value],onChange:params.onChange||_this.handleChange(params.value),placeholder:params.title,required:params.isRequired,disabled:params.isDisabled},params.content)));};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleChangeExpose=function(fieldKey){return function(){_this.setState(_defineProperty({},fieldKey,!_this.state[fieldKey]));};};_this.handleChangeContinent=function(selectedOption){_this.props.onContinentSet(selectedOption.value);_this.setState({countryCode:""});};_this.handleChangeCountry=function(selectedOption){_this.setState({countryCode:selectedOption.value});};_this.onSubmit=function(e){e.preventDefault();if(_this.checkRequiredSelectFields()){return;}var data={firstName:_this.state.firstName,lastName:_this.state.lastName,phoneNumber:!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(_this.state.phoneNumber)&&_this.state.phoneNumber!==""?_this.state.phoneNumber:null,countryCode:_this.state.countryCode,exposePhone:_this.state.exposePhone,exposeEmail:_this.state.exposeEmail};_this.props.onChangeAlias(_this.props.data.id,data);};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(requiredSelectFields,function(field){if(!_this.state[field]&&!error){error=field;}});_this.setState({requiredFieldError:error});return error;};_this.state={firstName:"",lastName:"",phoneNumber:"",countryCode:"",exposePhone:false,exposeEmail:false,requiredFieldError:null};return _this;}_createClass(DefaultAliasManagement,[{key:'componentDidMount',value:function componentDidMount(){this.props.onGetDefaultAlias();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onContinentSet("");this.props.onUnmount();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(nextProps.data)&&nextProps.data!==this.props.data){this.setState({firstName:nextProps.data.firstName,lastName:nextProps.data.lastName,phoneNumber:nextProps.data.phoneNumber||"",countryCode:nextProps.data.countryCode,exposePhone:nextProps.data.exposePhone,exposeEmail:nextProps.data.exposeEmail});this.props.setCurrentContinentByCountry(nextProps.data.countryCode);}if(nextProps.continentCode!==this.state.continentCode){this.setState({continentCode:nextProps.continentCode});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'change-default-alias-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'aliases.edit_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.onSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'aliases.edit_default_alias')),this.renderContent())));}}]);return DefaultAliasManagement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DefaultAliasManagement.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,continentCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onContinentSet:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setCurrentContinentByCountry:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onChangeAlias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUnmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (DefaultAliasManagement);

/***/ }),
/* 747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationSettings__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_account_userSettings__ = __webpack_require__(286);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_userSettings__["f" /* getUserSettingsLoading */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_userSettings__["e" /* getUserSettingsData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_userSettings__["c" /* fetchGetUserSettings */])());},onUnmount:function onUnmount(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_userSettings__["a" /* clearUserSettings */])());},onUserSettingsUpdate:function onUserSettingsUpdate(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_userSettings__["d" /* fetchUpdateUserSettings */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__NotificationSettings__["a" /* default */]));

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotificationSettings_css__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotificationSettings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__NotificationSettings_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__languageSelector_NotificationsLanguageSelector_container__ = __webpack_require__(751);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PREFERRED_LANGUAGE='preferredLanguage';var NotificationSettings=function(_Component){_inherits(NotificationSettings,_Component);function NotificationSettings(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NotificationSettings);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NotificationSettings.__proto__||Object.getPrototypeOf(NotificationSettings)).call.apply(_ref,[this].concat(args))),_this),_this.renderContent=function(){if(_this.props.loading&&__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(_this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'notification_settings.no_settings_label'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification-settings-form-groups-container'},_this.renderData()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',disabled:_this.saveButtonDisabled(),type:'submit'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button))));},_this.saveButtonDisabled=function(){return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.data)||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.every(_this.props.data,function(value,key){return _this.state.hasOwnProperty(key)?_this.state[key]===value:true;});},_this.renderData=function(){if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.data)){return null;}return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.chain(_this.state).mapValues(_this.getFormGroup).values().value()));},_this.getFormGroup=function(value,key){var id=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.kebabCase(key);var label=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.snakeCase(key);if(key===PREFERRED_LANGUAGE){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{key:id,className:'notification-settings-checkbox-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{className:'preferred-language-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'notification_settings.'+label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__languageSelector_NotificationsLanguageSelector_container__["a" /* default */],{className:'notifications-language-selector',key:id,selectedLanguage:_this.state[PREFERRED_LANGUAGE],onLanguageSelect:_this.handleLanguageSelect}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{key:id,className:'notification-settings-checkbox-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'checkbox-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{className:'checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'checkbox',checked:value,onChange:_this.handleChange(key)}),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'notification_settings.'+label))));},_this.handleLanguageSelect=function(language){_this.setState(_defineProperty({},PREFERRED_LANGUAGE,language));},_this.handleChange=function(fieldKey){return function(){_this.setState(_defineProperty({},fieldKey,!_this.state[fieldKey]));};},_this.onSubmit=function(e){e.preventDefault();var data=Object.assign({},_this.state);_this.props.onUserSettingsUpdate(data);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NotificationSettings,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(nextProps.data)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEqual(this.state,nextProps.data)&&!nextProps.loading){this.setState(Object.assign({},nextProps.data));}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification-settings-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'notification_settings.notification_settings_update_success_alert')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.onSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center notification-settings-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'notification_settings.notification_settings_label')),this.renderContent())));}}]);return NotificationSettings;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NotificationSettings.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onUnmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onUserSettingsUpdate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (NotificationSettings);

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LanguageSelector__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{languageList:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["f" /* getTranslationsList */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__LanguageSelector__["a" /* default */]));

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SecuritySettings__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_account_security__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_security__["i" /* getSecurityLoading */])(state),is2FAEnable:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_security__["j" /* is2FAEnable */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_security__["f" /* fetchGetSecurity */])());},onUnmount:function onUnmount(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_security__["a" /* clearSecurity */])());},onSubmit:function onSubmit(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["r" /* MODAL_CHANGE_2FA_ENABLING */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__SecuritySettings__["a" /* default */]));

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SecuritySettings_css__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SecuritySettings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SecuritySettings_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__twoFASettingsModal_TwoFASettingsModal_container__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SecuritySettings=function(_Component){_inherits(SecuritySettings,_Component);function SecuritySettings(props){_classCallCheck(this,SecuritySettings);var _this=_possibleConstructorReturn(this,(SecuritySettings.__proto__||Object.getPrototypeOf(SecuritySettings)).call(this,props));_this.renderContent=function(){if(_this.props.loading&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.is2FAEnable)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'two-fa-status-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'status-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'security_settings.current_status_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'two-fa-status-with-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:"two-fa-status-icon "+(_this.props.is2FAEnable?"enabled":"disabled"),icon:_this.props.is2FAEnable?"check_circle_outline":"highlight_off"}),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'security_settings.'+(_this.props.is2FAEnable?"2fa_enabled_label":"2fa_disabled_label")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit',onClick:_this.props.onSubmit},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'security_settings.'+(_this.props.is2FAEnable?"disable_2fa_submit_button":"enable_2fa_submit_button")))));};_this.state={is2FAEnable:false};return _this;}_createClass(SecuritySettings,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(nextProps.is2FAEnable)&&this.state.is2FAEnable!==nextProps.is2FAEnable&&!nextProps.loading){this.setState({is2FAEnable:nextProps.is2FAEnable});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'security-settings-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center security-settings-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'security_settings.2fa_label')),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__twoFASettingsModal_TwoFASettingsModal_container__["a" /* default */],null));}}]);return SecuritySettings;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SecuritySettings.propTypes={is2FAEnable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onUnmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SecuritySettings);

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TwoFASettingsModal__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_account_security__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_account_userData__ = __webpack_require__(35);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["r" /* MODAL_CHANGE_2FA_ENABLING */],translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state),is2FAEnable:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_security__["j" /* is2FAEnable */])(state),QRCodeData:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_security__["g" /* getQRCodeData */])(state),loadingQRCodeData:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_security__["h" /* getQRCodeDataLoading */])(state),userEmail:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_account_userData__["f" /* getUserEmail */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGenerate2FASecret:function onGenerate2FASecret(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_security__["e" /* fetchGenerate2FASecret */])());},onEnable2FA:function onEnable2FA(checkCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_security__["d" /* fetchEnable2FA */])(checkCode));},onDisable2FA:function onDisable2FA(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_security__["c" /* fetchDisable2FA */])());},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__TwoFASettingsModal__["a" /* default */]));

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TwoFASettingsModal_css__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TwoFASettingsModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TwoFASettingsModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qrcode_react__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qrcode_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_qrcode_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ENABLE_2FA_SUCCESS_MESSAGE="enable_2fa_success_message";var DISABLE_2FA_SUCCESS_MESSAGE="disable_2fa_success_message";var TwoFASettingsModal=function(_Component){_inherits(TwoFASettingsModal,_Component);function TwoFASettingsModal(props){_classCallCheck(this,TwoFASettingsModal);var _this=_possibleConstructorReturn(this,(TwoFASettingsModal.__proto__||Object.getPrototypeOf(TwoFASettingsModal)).call(this,props));_this.checkCodeIsInvalid=function(){return _this.state.checkCode.length<6&&_this.state.checkCode.length>0;};_this.renderLinks=function(){var iconName="keyboard_arrow_"+(_this.state.isLinksCollapseOpen?"down":"right");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'links-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'links-title-container olive-green'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{onClick:_this.toggleLinks},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security_settings.links_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__["a" /* default */],{onClick:_this.toggleLinks,className:'links-title-icon',icon:iconName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'links-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["i" /* Collapse */],{isOpen:_this.state.isLinksCollapseOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'links-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security_settings.google_authenticator_android_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://itunes.apple.com/us/app/google-authenticator/id388497605'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security_settings.google_authenticator_ios_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://play.google.com/store/apps/details?id=org.fedorahosted.freeotp'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security_settings.free_otp_android_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://itunes.apple.com/ru/app/freeotp-authenticator/id872559395'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security_settings.free_otp_ios_label'))))));};_this.renderParameters=function(){var iconName="keyboard_arrow_"+(_this.state.isParametersCollapseOpen?"down":"right");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'parameters-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'parameters-title-container olive-green'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{onClick:_this.toggleParams},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security_settings.enable_2fa_parameters_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__["a" /* default */],{onClick:_this.toggleParams,className:'parameters-title-icon',icon:iconName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'parameters-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["i" /* Collapse */],{isOpen:_this.state.isParametersCollapseOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security_settings.issuer_label')+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},'BrainChain')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},_this.props.userEmail)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security_settings.secret_label')+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},_this.props.QRCodeData.secret)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security_settings.algorithm_label')+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},_this.props.QRCodeData.algorithm)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security_settings.digits_label')+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},_this.props.QRCodeData.digits)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security_settings.period_label')+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},_this.props.QRCodeData.period)))));};_this.toggleParams=function(){_this.setState({isParametersCollapseOpen:!_this.state.isParametersCollapseOpen});};_this.toggleLinks=function(){_this.setState({isLinksCollapseOpen:!_this.state.isLinksCollapseOpen});};_this.handleChangeCheckCode=function(e){var regexp=/^[0-9]{0,6}$/;var value=e.target.value;if(regexp.test(value)){_this.setState({checkCode:value});}};_this.onSubmit=function(){if(_this.props.is2FAEnable){_this.props.onDisable2FA();}else{if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.state.checkCode)&&_this.state.checkCode.length===6){_this.props.onEnable2FA(_this.state.checkCode);}else{_this.props.onEnable2FA();}}};_this.state={checkCode:"",isParametersCollapseOpen:false,isLinksCollapseOpen:false,successMessage:null};return _this;}_createClass(TwoFASettingsModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.isOpen&&!this.props.isOpen&&!nextProps.is2FAEnable){this.props.onGenerate2FASecret();}if(nextProps.success&&this.props.success!==nextProps.success){this.setState({successMessage:this.props.is2FAEnable?DISABLE_2FA_SUCCESS_MESSAGE:ENABLE_2FA_SUCCESS_MESSAGE});}if(nextProps.isOpen&&!this.props.isOpen){this.setState({checkCode:"",isParametersCollapseOpen:false,isLinksCollapseOpen:false,successMessage:null});}}},{key:'render',value:function render(){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.state.successMessage)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen,toggle:this.props.onCancel,className:'two-fa-settings-modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center two-fa-settings-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security_settings.2fa_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security_settings.'+this.state.successMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'two-fa-modal-success-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].okey_button)))));}if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.is2FAEnable)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen,toggle:this.props.onCancel,className:'two-fa-settings-modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security_settings.'+(this.props.is2FAEnable?"enable_2fa_success_message":"disable_2fa_success_message"))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center two-fa-settings-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security_settings.2fa_label')),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'two-fa-modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.onSubmit,disabled:this.props.loadingQRCodeData||this.checkCodeIsInvalid()},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security_settings.'+(this.props.is2FAEnable?"disable_2fa_submit_button":"enable_2fa_submit_button")))))));}else{return null;}}},{key:'renderContent',value:function renderContent(){if(this.props.loadingQRCodeData){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}if(this.props.is2FAEnable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security_settings.disable_2fa_are_you_sure_message')));}else{if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.QRCodeData)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security_settings.enable_2fa_scan_qr_code_message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'warning-message'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security_settings.update_warning')),this.renderLinks(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qr-code-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_qrcode_react___default.a,{renderAs:'svg',size:200,value:'otpauth://totp/BrainChain:'+this.props.userEmail+'?secret='+this.props.QRCodeData.secret+'&issuer=BrainChain'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderParameters()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security_settings.enable_2fa_check_code_message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security_settings.check_code_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{value:this.state.checkCode,onChange:this.handleChangeCheckCode,type:'text',size:'6',placeholder:'_ _ _ _ _ _',invalid:this.checkCodeIsInvalid()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["o" /* FormFeedback */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security_settings.verification_code_details_label')))));}}}}]);return TwoFASettingsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TwoFASettingsModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,is2FAEnable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,loadingQRCodeData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,QRCodeData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,userEmail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,success:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGenerate2FASecret:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onEnable2FA:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onDisable2FA:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TwoFASettingsModal);

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(1);

var PropTypes = __webpack_require__(2); // qr.js doesn't handle error level of zero (M) so we need to do it right,
// thus the deep require.


var QRCodeImpl = __webpack_require__(759);

var ErrorCorrectLevel = __webpack_require__(288); // Convert from UTF-16, forcing the use of byte-mode encoding in our QR Code.
// This allows us to encode Hanji, Kanji, emoji, etc. Ideally we'd do more
// detection and not resort to byte-mode if possible, but we're trading off
// a smaller library for a smaller amount of data we can potentially encode.
// Based on http://jonisalonen.com/2012/from-utf-16-to-utf-8-in-javascript/


function convertStr(str) {
  var out = '';

  for (var i = 0; i < str.length; i++) {
    var charcode = str.charCodeAt(i);

    if (charcode < 0x0080) {
      out += String.fromCharCode(charcode);
    } else if (charcode < 0x0800) {
      out += String.fromCharCode(0xc0 | charcode >> 6);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      out += String.fromCharCode(0xe0 | charcode >> 12);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else {
      // This is a surrogate pair, so we'll reconsitute the pieces and work
      // from that
      i++;
      charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
      out += String.fromCharCode(0xf0 | charcode >> 18);
      out += String.fromCharCode(0x80 | charcode >> 12 & 0x3f);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    }
  }

  return out;
}

var DEFAULT_PROPS = {
  size: 128,
  level: 'L',
  bgColor: '#FFFFFF',
  fgColor: '#000000',
  includeMargin: false
};
var PROP_TYPES = {
  value: PropTypes.string.isRequired,
  size: PropTypes.number,
  level: PropTypes.oneOf(['L', 'M', 'Q', 'H']),
  bgColor: PropTypes.string,
  fgColor: PropTypes.string,
  includeMargin: PropTypes.bool
};
var MARGIN_SIZE = 4;

function generatePath(modules) {
  var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var ops = [];
  modules.forEach(function (row, y) {
    var start = null;
    row.forEach(function (cell, x) {
      if (!cell && start !== null) {
        // M0 0h7v1H0z injects the space with the move and drops the comma,
        // saving a char per operation
        ops.push("M".concat(start + margin, " ").concat(y + margin, "h").concat(x - start, "v1H").concat(start + margin, "z"));
        start = null;
        return;
      } // end of row, clean up or skip


      if (x === row.length - 1) {
        if (!cell) {
          // We would have closed the op above already so this can only mean
          // 2+ light modules in a row.
          return;
        }

        if (start === null) {
          // Just a single dark module.
          ops.push("M".concat(x + margin, ",").concat(y + margin, " h1v1H").concat(x + margin, "z"));
        } else {
          // Otherwise finish the current line.
          ops.push("M".concat(start + margin, ",").concat(y + margin, " h").concat(x + 1 - start, "v1H").concat(start + margin, "z"));
        }

        return;
      }

      if (cell && start === null) {
        start = x;
      }
    });
  });
  return ops.join('');
} // For canvas we're going to switch our drawing mode based on whether or not
// the environment supports Path2D. We only need the constructor to be
// supported, but Edge doesn't actually support the path (string) type
// argument. Luckily it also doesn't support the addPath() method. We can
// treat that as the same thing.


var SUPPORTS_PATH2D = function () {
  try {
    new Path2D().addPath(new Path2D());
  } catch (e) {
    return false;
  }

  return true;
}();

var QRCodeCanvas =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(QRCodeCanvas, _React$PureComponent);

  function QRCodeCanvas() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, QRCodeCanvas);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(QRCodeCanvas)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_canvas", void 0);

    return _this;
  }

  _createClass(QRCodeCanvas, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.update();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      var _this$props = this.props,
          value = _this$props.value,
          size = _this$props.size,
          level = _this$props.level,
          bgColor = _this$props.bgColor,
          fgColor = _this$props.fgColor,
          includeMargin = _this$props.includeMargin; // We'll use type===-1 to force QRCode to automatically pick the best type

      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();

      if (this._canvas != null) {
        var canvas = this._canvas;
        var ctx = canvas.getContext('2d');

        if (!ctx) {
          return;
        }

        var cells = qrcode.modules;

        if (cells === null) {
          return;
        }

        var margin = includeMargin ? MARGIN_SIZE : 0;
        var numCells = cells.length + margin * 2; // We're going to scale this so that the number of drawable units
        // matches the number of cells. This avoids rounding issues, but does
        // result in some potentially unwanted single pixel issues between
        // blocks, only in environments that don't support Path2D.

        var pixelRatio = window.devicePixelRatio || 1;
        canvas.height = canvas.width = size * pixelRatio;
        var scale = size / numCells * pixelRatio;
        ctx.scale(scale, scale); // Draw solid background, only paint dark modules.

        ctx.fillStyle = bgColor;
        ctx.fillRect(0, 0, numCells, numCells);
        ctx.fillStyle = fgColor;

        if (SUPPORTS_PATH2D) {
          // $FlowFixMe: Path2D c'tor doesn't support args yet.
          ctx.fill(new Path2D(generatePath(cells, margin)));
        } else {
          cells.forEach(function (row, rdx) {
            row.forEach(function (cell, cdx) {
              if (cell) {
                ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
              }
            });
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          value = _this$props2.value,
          size = _this$props2.size,
          level = _this$props2.level,
          bgColor = _this$props2.bgColor,
          fgColor = _this$props2.fgColor,
          style = _this$props2.style,
          includeMargin = _this$props2.includeMargin,
          otherProps = _objectWithoutProperties(_this$props2, ["value", "size", "level", "bgColor", "fgColor", "style", "includeMargin"]);

      var canvasStyle = _objectSpread({
        height: size,
        width: size
      }, style);

      return React.createElement("canvas", _extends({
        style: canvasStyle,
        height: size,
        width: size,
        ref: function ref(_ref) {
          return _this2._canvas = _ref;
        }
      }, otherProps));
    }
  }]);

  return QRCodeCanvas;
}(React.PureComponent);

_defineProperty(QRCodeCanvas, "defaultProps", DEFAULT_PROPS);

_defineProperty(QRCodeCanvas, "propTypes", PROP_TYPES);

var QRCodeSVG =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(QRCodeSVG, _React$PureComponent2);

  function QRCodeSVG() {
    _classCallCheck(this, QRCodeSVG);

    return _possibleConstructorReturn(this, _getPrototypeOf(QRCodeSVG).apply(this, arguments));
  }

  _createClass(QRCodeSVG, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          size = _this$props3.size,
          level = _this$props3.level,
          bgColor = _this$props3.bgColor,
          fgColor = _this$props3.fgColor,
          includeMargin = _this$props3.includeMargin,
          otherProps = _objectWithoutProperties(_this$props3, ["value", "size", "level", "bgColor", "fgColor", "includeMargin"]); // We'll use type===-1 to force QRCode to automatically pick the best type


      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();
      var cells = qrcode.modules;

      if (cells === null) {
        return null;
      }

      var margin = includeMargin ? MARGIN_SIZE : 0; // Drawing strategy: instead of a rect per module, we're going to create a
      // single path for the dark modules and layer that on top of a light rect,
      // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
      // way faster than DOM ops.
      // For level 1, 441 nodes -> 2
      // For level 40, 31329 -> 2

      var fgPath = generatePath(cells, margin);
      var numCells = cells.length + margin * 2;
      return React.createElement("svg", _extends({
        shapeRendering: "crispEdges",
        height: size,
        width: size,
        viewBox: "0 0 ".concat(numCells, " ").concat(numCells)
      }, otherProps), React.createElement("path", {
        fill: bgColor,
        d: "M0,0 h".concat(numCells, "v").concat(numCells, "H0z")
      }), React.createElement("path", {
        fill: fgColor,
        d: fgPath
      }));
    }
  }]);

  return QRCodeSVG;
}(React.PureComponent);

_defineProperty(QRCodeSVG, "defaultProps", DEFAULT_PROPS);

_defineProperty(QRCodeSVG, "propTypes", PROP_TYPES);

var QRCode = function QRCode(props) {
  var renderAs = props.renderAs,
      otherProps = _objectWithoutProperties(props, ["renderAs"]);

  var Component = renderAs === 'svg' ? QRCodeSVG : QRCodeCanvas;
  return React.createElement(Component, otherProps);
};

QRCode.defaultProps = _objectSpread({
  renderAs: 'canvas'
}, DEFAULT_PROPS);
module.exports = QRCode;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var BitByte = __webpack_require__(760);
var RSBlock = __webpack_require__(761);
var BitBuffer = __webpack_require__(762);
var util = __webpack_require__(763);
var Polynomial = __webpack_require__(289);

function QRCode(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode.prototype;

proto.addData = function(data) {
	var newData = new BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;

QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD1, 8);
	}

	return QRCode.createBytes(buffer, rsBlocks);
};

QRCode.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

module.exports = QRCode;



/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var mode = __webpack_require__(287);

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

module.exports = QR8bitByte;



/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

// ErrorCorrectLevel
var ECL = __webpack_require__(288);

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
}

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ECL.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ECL.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ECL.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ECL.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
}

module.exports = QRRSBlock;


/***/ }),
/* 762 */
/***/ (function(module, exports) {

function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

module.exports = QRBitBuffer;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(287);
var Polynomial = __webpack_require__(289);
var math = __webpack_require__(290);

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 10;
		    case Mode.MODE_ALPHA_NUM 	: return 9;
		    case Mode.MODE_8BIT_BYTE	: return 8;
		    case Mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 12;
		    case Mode.MODE_ALPHA_NUM 	: return 11;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 14;
		    case Mode.MODE_ALPHA_NUM	: return 13;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

module.exports = QRUtil;


/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrgsList__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_location__ = __webpack_require__(21);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["P" /* loadingOrgs */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["M" /* getValidatedOrgsData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state),subRoles:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_role__["s" /* getSubRoles */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_location__["d" /* getContinentsData */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_location__["f" /* getCurrentContinent */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_location__["e" /* getCountriesData */])(state),countryFilter:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["t" /* getCountryFilter */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["m" /* fetchGetValidatedOrgs */])());},onResendActivation:function onResendActivation(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_4" /* MODAL_RESENT_ACTIVATION_ANCHOR */]}));},onChangeFilter:function onChangeFilter(countryCode,name){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["T" /* setCountryFilter */])(countryCode));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["m" /* fetchGetValidatedOrgs */])(null,countryCode,name));},onSetContinent:function onSetContinent(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onRemoveOrg:function onRemoveOrg(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["Z" /* MODAL_REMOVE_ORG */]}));},onClearFilter:function onClearFilter(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["T" /* setCountryFilter */])(null));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__OrgsList__["a" /* default */]));

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrgsList_css__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrgsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__OrgsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__orgModal_resendActivationAnchor_ResendActivationAnchor_container__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_paginationComponent_PaginationOrgs_container__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__removeOrgModal_RemoveOrgModal_container__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SUCCESS_MESSAGE_PATH_BY_ACTION={RESEND_ACTIVATION:'resend_activation.success_message',REMOVE:'orgs.remove_org_success_message'};var OrgsList=function(_Component){_inherits(OrgsList,_Component);function OrgsList(props){_classCallCheck(this,OrgsList);var _this=_possibleConstructorReturn(this,(OrgsList.__proto__||Object.getPrototypeOf(OrgsList)).call(this,props));_this.renderContent=function(){if(_this.props.loading&&!_this.state.filtering){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if((__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0)&&!_this.state.filtering){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.no_data_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["N" /* Table */],{className:'orgs-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'name-th'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.org_label'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{id:'name-input',value:_this.state.nameFilter,onChange:_this.handleChangeFilterValue,onKeyDown:_this.handleKeyDown,onBlur:_this.handleFilter,className:'name-filter-input',bsSize:'sm',placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'validated_domains.filter_by_name_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.org_type_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.anchor_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.location_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_11__reducers_account_role__["c" /* SUB_ROLES */].ROOT)||_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_11__reducers_account_role__["c" /* SUB_ROLES */].FA)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderOrgsData()));};_this.handleChangeFilterValue=function(e){_this.setState({nameFilter:e.target.value});};_this.handleKeyDown=function(e){if(e.keyCode===13){_this.handleFilter();}};_this.handleFilter=function(){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(_this.state.countryFilter)||!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(_this.state.nameFilter)){_this.setState({filtering:true});}_this.props.onChangeFilter(_this.state.countryFilter,_this.state.nameFilter);};_this.renderOrgsData=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_this.props.data,function(orgData,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'orgs-list-row '+(orgData.active?'':'not-active'),key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'org-name-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.org_label')+':',onClick:_this.handleTableRowClick(orgData.id)},orgData.orgName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'org-type-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.org_type_label')+':',onClick:_this.handleTableRowClick(orgData.id)},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */][__WEBPACK_IMPORTED_MODULE_7__reducers_organization_organizations__["c" /* LABEL_PATH_BY_ORG_TYPE */][orgData.orgType]])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'anchor-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.anchor_label')+':',onClick:_this.handleTableRowClick(orgData.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,orgData.anchorName+'\n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:_this.handleMailtoLinkClick,href:'mailto:'+orgData.anchorEmail},orgData.anchorEmail)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'location-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.location_label')+':',onClick:_this.handleTableRowClick(orgData.id)},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'countries.'+orgData.location)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'resend-activation-link',onClick:_this.handleTableRowClick(orgData.id)},_this.renderResendActivationButton(orgData)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'orgs-list-create-icon-td',onClick:_this.handleTableRowClick(orgData.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:'create'+index,icon:'create',className:'orgs-list-create-icon',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].edit_button)})),_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_11__reducers_account_role__["c" /* SUB_ROLES */].ROOT)||_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_11__reducers_account_role__["c" /* SUB_ROLES */].FA)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'orgs-list-remove-icon-td'},orgData.isBava?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__["a" /* default */],{onClick:_this.handleRemoveButtonClick(orgData),key:'trash'+index,icon:'trash',className:'orgs-list-remove-icon',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button)})):null);});};_this.renderContinentAndCountryFilter=function(){var continentsOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_12__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continents))));var countriesOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_12__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].countries))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filters-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'continent-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continent_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'continent-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(continentsOptions,function(option){return option.value===_this.props.continentCode||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(option.value)&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(_this.props.continentCode);}),options:continentsOptions,onSelect:_this.handleChangeContinentSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'country-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'country-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(countriesOptions,function(option){return option.value===_this.state.countryFilter;}),options:countriesOptions,onSelect:_this.handleChangeCountrySelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{id:'name-filter-input',value:_this.state.nameFilter,onChange:_this.handleChangeFilterValue,onKeyDown:_this.handleKeyDown,onBlur:_this.handleFilter,className:'name-filter-input',bsSize:'sm',placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'validated_domains.filter_by_name_label')})));};_this.handleChangeContinentSelect=function(selectedOption){_this.setState({countryFilter:''});_this.props.onSetContinent(selectedOption.value);};_this.handleChangeCountrySelect=function(selectedOption){_this.setState({countryFilter:selectedOption.value,filtering:!!selectedOption.value||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(_this.state.nameFilter)});_this.props.onChangeFilter(selectedOption.value,_this.state.nameFilter);};_this.handleMailtoLinkClick=function(e){e.stopPropagation();};_this.onResendActivationClick=function(email){return function(e){e.stopPropagation();_this.setState({resendActivationEmail:email,successMessage:SUCCESS_MESSAGE_PATH_BY_ACTION.RESEND_ACTIVATION});_this.props.onResendActivation();};};_this.handleTableRowClick=function(orgId){return function(){_this.setState({selectedOrgId:orgId});};};_this.handleRemoveButtonClick=function(data){return function(e){e.stopPropagation();_this.setState({selectedOrgData:data,successMessage:SUCCESS_MESSAGE_PATH_BY_ACTION.REMOVE});_this.props.onRemoveOrg();};};_this.state={selectedOrgId:null,resendActivationEmail:null,countryFilter:props.countryFilter,selectedOrgData:null,successMessage:null,currentCountryFilter:null,filtering:false,nameFilter:''};return _this;}_createClass(OrgsList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onSetContinent(null);this.props.onClearFilter();}},{key:'render',value:function render(){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.state.selectedOrgId)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Redirect */],{to:'/organization?id='+this.state.selectedOrgId,push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,this.state.successMessage)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.label')),this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_11__reducers_account_role__["c" /* SUB_ROLES */].ROOT)||this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_11__reducers_account_role__["c" /* SUB_ROLES */].FA)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{tag:__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],className:'add-org-button olive-green-btn',to:'/register-org'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.add_org'))):null,this.renderContinentAndCountryFilter(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_paginationComponent_PaginationOrgs_container__["a" /* default */],{validated:true,countryFilter:this.state.countryFilter}),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__removeOrgModal_RemoveOrgModal_container__["a" /* default */],{data:this.state.selectedOrgData,validated:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__orgModal_resendActivationAnchor_ResendActivationAnchor_container__["a" /* default */],{email:this.state.resendActivationEmail})));}},{key:'renderResendActivationButton',value:function renderResendActivationButton(org){if(org.active){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{className:'btn-sm',color:'link',onClick:this.onResendActivationClick(org.anchorEmail)},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'resend_activation.title'));}}]);return OrgsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var OrgShape=__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,anchorName:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,anchorEmail:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,active:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,location:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,orgName:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired});OrgsList.propTypes={translation:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,loading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(OrgShape),subRoles:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,onMount:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,onResendActivation:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,onRemoveOrg:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,onClearFilter:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,onSetContinent:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,onChangeFilter:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (OrgsList);

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResendActivationAnchor__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_account_activation__ = __webpack_require__(62);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_4" /* MODAL_RESENT_ACTIVATION_ANCHOR */],translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onResendActivation:function onResendActivation(email){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_activation__["c" /* fetchResendActivation */])(email));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ResendActivationAnchor__["a" /* default */]));

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResendActivationAnchor_css__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResendActivationAnchor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ResendActivationAnchor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResendActivationAnchor=function(_Component){_inherits(ResendActivationAnchor,_Component);function ResendActivationAnchor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ResendActivationAnchor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ResendActivationAnchor.__proto__||Object.getPrototypeOf(ResendActivationAnchor)).call.apply(_ref,[this].concat(args))),_this),_this.onResendActivationSubmit=function(e){e.preventDefault();_this.props.onResendActivation(_this.props.email);},_this.onResendActivationCancel=function(){_this.props.onCancel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ResendActivationAnchor,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen,toggle:this.onResendActivationCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{className:'resend-anchor-activation-form',onSubmit:this.onResendActivationSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'resend_activation.anchor_label').replace('{email}',this.props.email)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.onResendActivationCancel},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'resend_activation.submit_button'))))));}}]);return ResendActivationAnchor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ResendActivationAnchor.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onResendActivation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ResendActivationAnchor);

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_organizations__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveOrgModal=function(_Component){_inherits(RemoveOrgModal,_Component);function RemoveOrgModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveOrgModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveOrgModal.__proto__||Object.getPrototypeOf(RemoveOrgModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleRemove=function(e){e.preventDefault();_this.props.onRemove(_this.props.data.id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveOrgModal,[{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState,nextContext){if(!this.props.success&&nextProps.success){this.props.onCancel();}}},{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen,toggle:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.remove_org_alert')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.org_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.orgName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.org_type_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */][__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organizations__["c" /* LABEL_PATH_BY_ORG_TYPE */][this.props.data.orgType]]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.anchor_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.data.anchorName+'\n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.handleMailtoLinkClick,href:"mailto:"+this.props.data.anchorEmail},this.props.data.anchorEmail))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.location_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'countries.'+this.props.data.location))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))));}}]);return RemoveOrgModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveOrgModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveOrgModal);

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RegisterOrg__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_finance_finance__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{continentCode:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["e" /* getCountriesData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["e" /* getTranslation */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_8__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onShowFinance:function onShowFinance(orgType,countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_finance_finance__["c" /* fetchGetPriceByOrgTypeAndCountry */])(orgType,countryCode));dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__["w" /* MODAL_CREATE_ORG_PRICE */]}));},onRegister:function onRegister(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["o" /* fetchRegisterOrganization */])(data));},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onResetData:function onResetData(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__RegisterOrg__["a" /* default */]));

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RegisterOrg_css__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RegisterOrg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RegisterOrg_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__orgPriceModal_OrgPriceModal_container__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commonComponents_domainInput_DomainInput__ = __webpack_require__(63);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var REDIRECT_TO_LANDING_PAGE_ACTION_TYPE='redirect_to_landing_page_action_type';var INVITE_NEXT_ACTION_TYPE='invite_next_action_type';var requiredSelectFields=['orgType','orgCountry'];var RegisterOrg=function(_Component){_inherits(RegisterOrg,_Component);function RegisterOrg(props){_classCallCheck(this,RegisterOrg);var _this=_possibleConstructorReturn(this,(RegisterOrg.__proto__||Object.getPrototypeOf(RegisterOrg)).call(this,props));_this.renderOrganizationDataFormGroups=function(){var paramsList=[{value:"orgType",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.org_type_label')+"*",type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_9__constants_constants__["o" /* ORGANIZATION_TYPES */],function(value){return{code:value.code,name:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,value.name)};})),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'register_org.org_type_placeholder'),isRequired:true,onChange:_this.handleChangeOrgTypeSelect},{value:"orgName",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.name_label')+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.name_label')},{value:"orgDomain",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label)},{value:"orgVatNumber",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.vat_number_label'),isRequired:false,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.vat_number_label')},{value:"companyCode",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.company_code_label'),isRequired:false,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.company_code_label')},{value:'orgEmployeeCount',title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].employee_count_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_9__constants_constants__["h" /* EMPLOYEES_COUNT_VALUES */],function(value){return{code:value.code,name:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,value.name)||value.name};})),isRequired:true},{value:'financialData',title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.financial_data_label')+"*",type:'textarea',placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.financial_data_placeholder'),isRequired:true}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderOrganizationAddressFormGroup=function(){var paramsList=[{value:"orgContinent",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label)+"*",type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),onChange:_this.handleChangeContinent,isRequired:true,isDisabled:!_this.props.continents},{value:"orgCountry",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)+"*",type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isRequired:true,isDisabled:!_this.props.countries},{value:"orgCity",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.city_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.city_label')},{value:"orgPostal",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.postal_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.postal_label')},{value:"orgStreet",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.street_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.street_label')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderAnchorFormGroups=function(){var paramsList=[{value:"anchorEmail",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+"*",type:"email",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)},{value:"anchorFirstName",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)},{value:"anchorLastName",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderCheckboxes=function(){return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_9__constants_constants__["n" /* ORGANIZATION_AVAILABLE_FLAGS */],function(flag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{key:flag,className:'checkbox-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'checkbox-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{className:'checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'checkbox',checked:_this.state[flag],onChange:_this.toggleCheckbox(flag)}),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__constants_constants__["j" /* FLAGS */][flag]))));});};_this.getFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}if(params.value==='orgDomain'){return _this.getOrganizationDomainFormGroup(params);}if(params.type==='select'){return _this.getSelectFormGroup(params);}var id=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this.renderPopover(params),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:_this.state[params.value],onChange:params.onChange||_this.handleChange(params.value),placeholder:params.placeholder||params.title,disabled:params.isDisabled,required:params.isRequired},params.content)));};_this.getOrganizationDomainFormGroup=function(params){var id=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this.renderPopover(params),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commonComponents_domainInput_DomainInput__["a" /* default */],{id:id,value:_this.state[params.value],onChange:_this.handleChangeDomainInput,placeholder:params.placeholder||params.title,disabled:params.isDisabled,required:params.isRequired})));};_this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];}),options:params.content,onSelect:params.onChange||_this.handleChangeSelect(params.value),placeholder:params.placeholder,disabled:params.isDisabled,requiredFieldError:_this.state.requiredFieldError===params.value})));};_this.renderPopover=function(params){var hintText='';var id='register-org-by-anchor-';switch(params.value){case'orgDomain':id+='domain-hint-container';hintText=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'register_org.domain_hint');break;case'companyCode':id+='company-code-hint-container';hintText=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'register_org.company_code_hint');break;case'financialData':id+='financial-data-container';hintText=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'part_1'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'register_org.financial_data_hint_part_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'part_2'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'register_org.financial_data_hint_part_2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'part_3'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'register_org.financial_data_hint_part_3'))];break;default:return;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'register-org-by-anchor-domain-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:id,className:'register-org-by-anchor-icon-container',onClick:_this.togglePopover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["H" /* Popover */],{placement:'bottom',isOpen:_this.state.popoverOpen===params.value,target:id,toggle:_this.togglePopover(params.value)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["I" /* PopoverBody */],null,hintText)));};_this.togglePopover=function(type){return function(){if(_this.state.popoverOpen===type){_this.setState({popoverOpen:null});}else{_this.setState({popoverOpen:type});}};};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleChangeDomainInput=function(data){_this.setState({orgDomain:data});};_this.handleChangeSelect=function(fieldKey){return function(selectedOption){_this.setState(_defineProperty({},fieldKey,selectedOption.value));};};_this.handleChangeOrgTypeSelect=function(selectedOption){_this.setState({orgType:selectedOption.value,hasIVs:selectedOption.value===__WEBPACK_IMPORTED_MODULE_14__reducers_organization_organizations__["b" /* EDU_ORG */],providesMoocCertificates:false});};_this.toggleCheckbox=function(fieldKey){return function(){_this.setState(_defineProperty({},fieldKey,!_this.state[fieldKey]));};};_this.handleChangeContinent=function(selectedOption){_this.props.onContinentSet(selectedOption.value);_this.setState({orgCountry:''});};_this.onSubmit=function(e){e.preventDefault();if(_this.checkRequiredSelectFields()){return;}_this.props.onShowFinance(_this.state.orgType,_this.state.orgCountry);};_this.onSubmitModal=function(priceData){var data=Object.assign({type:_this.state.orgType,name:_this.state.orgName,domain:_this.state.orgDomain,address:{countryCode:_this.state.orgCountry,city:_this.state.orgCity,postal:_this.state.orgPostal,street:_this.state.orgStreet},vatNumber:_this.state.orgVatNumber,companyCode:_this.state.companyCode,anchor:{email:_this.state.anchorEmail,identityAlias:{firstName:_this.state.anchorFirstName,lastName:_this.state.anchorLastName,countryCode:_this.state.orgCountry}},hasIVs:_this.state.hasIVs,verifiesIdentities:_this.state.hasIVs,providesMoocCertificates:_this.state.providesMoocCertificates,employeeCount:_this.state.orgEmployeeCount,financialData:_this.state.financialData,validated:true},priceData);_this.props.onRegister(data);switch(_this.state.actionType){case REDIRECT_TO_LANDING_PAGE_ACTION_TYPE:_this.setState({redirect:true});break;default:break;}};_this.setActionType=function(actionType){return function(){_this.setState({actionType:actionType});};};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(requiredSelectFields,function(field){if(!_this.state[field]&&!error){error=field;}});_this.setState({requiredFieldError:error});return error;};_this.state={orgType:'',orgName:'',orgDomain:'',orgVatNumber:'',companyCode:'',orgContinent:_this.props.continentCode,orgEmployeeCount:'UNKNOWN',orgCountry:'',orgCity:'',orgPostal:'',orgStreet:'',orgStreetNumber:'',orgBusNumber:'',anchorFirstName:'',anchorLastName:'',anchorEmail:'',financialData:'',hasIVs:true,providesMoocCertificates:false,popoverOpen:null,actionType:null,redirect:false,requiredFieldError:null};_this.resetData=_this.resetData.bind(_this);return _this;}_createClass(RegisterOrg,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.state.orgContinent!==nextProps.continentCode){this.setState({orgContinent:nextProps.continentCode});}if(!this.props.success&&nextProps.success){this.resetData();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onResetData();this.props.onContinentSet('');}},{key:'render',value:function render(){if(this.state.redirect&&this.props.success){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["d" /* Redirect */],{to:'/organizations'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'register-anchor-org-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'register_org.success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/organizations',label:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'edit_org.back_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'register-anchor-org-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'register_org.register_org_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.onSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'register-anchor-org-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)),this.renderOrganizationDataFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'orgs.address_label')),this.renderOrganizationAddressFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'checkbox-group-label'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'orgs.permissions_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox-group-container'},this.renderCheckboxes()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'register-anchor-org-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'orgs.anchor_label')),this.renderAnchorFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn invite-next-button',onClick:this.setActionType(INVITE_NEXT_ACTION_TYPE)},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'register_org.invite_next_button')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn',onClick:this.setActionType(REDIRECT_TO_LANDING_PAGE_ACTION_TYPE)},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'register_org.send_invitation_button')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__orgPriceModal_OrgPriceModal_container__["a" /* default */],{onSubmit:this.onSubmitModal,submitButtonText:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'finance.accept_price_and_send_invitation')}));}},{key:'resetData',value:function resetData(){this.setState({orgType:'',orgName:'',orgDomain:'',orgVatNumber:'',companyCode:'',orgContinent:this.props.continentCode,orgEmployeeCount:'UNKNOWN',orgCountry:'',orgCity:'',orgPostal:'',orgStreet:'',orgStreetNumber:'',orgBusNumber:'',anchorFirstName:'',anchorLastName:'',anchorEmail:'',financialData:'',hasIVs:true,providesMoocCertificates:false,popoverOpen:null,actionType:null});this.props.onContinentSet('');}}]);return RegisterOrg;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RegisterOrg.propTypes={continentCode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,lastUsedContinent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,onShowFinance:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onRegister:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onContinentSet:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onResetData:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RegisterOrg);

/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrgPriceModal__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_finance_finance__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_finance_currencies__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["w" /* MODAL_CREATE_ORG_PRICE */],currentPresetId:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_finance_finance__["e" /* getCurrentPresetId */])(state),currentPresetData:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_finance_finance__["d" /* getCurrentPresetData */])(state),defaultCurrency:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_finance_finance__["f" /* getDefaultCurrency */])(state),presetsData:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_finance_finance__["g" /* getPresetsData */])(state),currenciesData:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_finance_currencies__["e" /* getCurrenciesData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChangePreset:function onChangePreset(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_finance_finance__["h" /* setCurrentPreset */])(id));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__OrgPriceModal__["a" /* default */]));

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrgPriceModal_css__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrgPriceModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__OrgPriceModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_datepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrgPriceModal=function(_Component){_inherits(OrgPriceModal,_Component);function OrgPriceModal(props){_classCallCheck(this,OrgPriceModal);var _this=_possibleConstructorReturn(this,(OrgPriceModal.__proto__||Object.getPrototypeOf(OrgPriceModal)).call(this,props));_this.submitButtonDisabled=function(){return!_this.isDateValid(_this.state.paidTillInputValue,true)||!_this.isDateValid(_this.state.deviationInputValue,true);};_this.isDateValid=function(value,strict){return value===''||__WEBPACK_IMPORTED_MODULE_11_moment___default()(value,'L',strict).isValid()&&__WEBPACK_IMPORTED_MODULE_11_moment___default()(value,'L').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_11_moment___default()().startOf('day'));};_this.renderPaidTillDateFormGroup=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.paid_till_date_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_datepicker__["a" /* default */],{customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{invalid:!_this.isDateValid(_this.state.paidTillInputValue,true)}),onBlur:_this.handleDateBlur('paidTillDate','paidTillInputValue'),onChange:_this.handleChangeDate('paidTillDate','paidTillInputValue'),onChangeRaw:_this.handleChange('paidTillInputValue'),value:_this.state.paidTillInputValue,selected:_this.state.paidTillDate,showMonthDropdown:true,showYearDropdown:true,dropdownMode:'select',placeholderText:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].datepicker_placeholder),minDate:__WEBPACK_IMPORTED_MODULE_11_moment___default()()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:1,id:'paid-till-icon-container',className:'paid-till-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'info',key:'paid-till-icon',className:'paid-till-info-icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Q" /* UncontrolledPopover */],{placement:'top',trigger:'legacy',target:'paid-till-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["I" /* PopoverBody */],{className:'paid-till-popover-body'},__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.paid_till_alert')))));};_this.renderPresetFormGroup=function(){var defaultAnnualFee=Number(_this.state.annualFee)===_this.props.currentPresetData.annualFee.amount;var defaultConsentRequestFee=Number(_this.state.consentRequestFee)===_this.props.currentPresetData.consentRequestFee.amount;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.preset_price_label')+"*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:'preset-select',selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getPresetsOptions(_this.props.presetsData),function(option){return option.value===_this.props.currentPresetId;}),options:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getPresetsOptions(_this.props.presetsData),onSelect:_this.handleChangePreset,isSearchable:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["i" /* Collapse */],{isOpen:!defaultAnnualFee||!defaultConsentRequestFee},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["q" /* FormText */],{color:'muted',className:'org-finance-edit-form-text'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.default_preset_label').replace('{annual_fee_amount}',_this.props.currentPresetData.annualFee.amount+__WEBPACK_IMPORTED_MODULE_7__constants_constants__["g" /* CURRENCIES */][_this.props.currentPresetData.annualFee.currency]).replace('{consent_request_fee_amount}',_this.props.currentPresetData.consentRequestFee.amount+__WEBPACK_IMPORTED_MODULE_7__constants_constants__["g" /* CURRENCIES */][_this.props.currentPresetData.annualFee.currency])))));};_this.renderBalanceFormGroup=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.balance_currency_label')+"*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8,className:'org-currency-select-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:'balance-select',selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getCurrenciesOptions(_this.props.currenciesData),function(option){return option.value===_this.state.balanceCurrency;}),options:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getCurrenciesOptions(_this.props.currenciesData),onSelect:_this.handleChangeBalanceCurrency,isSearchable:false})));};_this.renderPriceFormGroups=function(){var defaultAnnualFee=Number(_this.state.annualFee)===_this.props.currentPresetData.annualFee.amount;var defaultConsentRequestFee=Number(_this.state.consentRequestFee)===_this.props.currentPresetData.consentRequestFee.amount;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:'annual-fee-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.annual_fee_label')+"*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:7,className:'org-price-input-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* InputGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{className:'org-price-input '+(defaultAnnualFee?'default':''),type:'number',min:0,step:'any',value:_this.state.annualFee,onChange:_this.handleChange('annualFee'),onBlur:_this.handleBlur('annualFee'),invalid:Number(_this.state.annualFee)<0,required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["t" /* InputGroupAddon */],{addonType:'append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["u" /* InputGroupText */],null,__WEBPACK_IMPORTED_MODULE_7__constants_constants__["g" /* CURRENCIES */][_this.props.currentPresetData.annualFee.currency]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["i" /* Collapse */],{isOpen:defaultAnnualFee},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["q" /* FormText */],{color:'muted',className:'org-price-form-text'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.default_annual_fee_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:1,className:'org-price-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'restore',className:'org-price-icon'+(defaultAnnualFee?' default':''),title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.set_default_label'),onClick:_this.resetToDefault('annualFee')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:'request-cost-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.request_cost_label')+"*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:7,className:'org-price-input-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["s" /* InputGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{className:'org-price-input '+(defaultConsentRequestFee?'default':''),type:'number',min:0,step:'any',value:_this.state.consentRequestFee,onChange:_this.handleChange('consentRequestFee'),onBlur:_this.handleBlur('consentRequestFee'),invalid:Number(_this.state.consentRequestFee)<0,required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["t" /* InputGroupAddon */],{addonType:'append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["u" /* InputGroupText */],null,__WEBPACK_IMPORTED_MODULE_7__constants_constants__["g" /* CURRENCIES */][_this.props.currentPresetData.consentRequestFee.currency]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["i" /* Collapse */],{isOpen:defaultConsentRequestFee},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["q" /* FormText */],{color:'muted',className:'org-price-form-text'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.default_consent_request_fee_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:1,className:'org-price-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'restore',className:'org-price-icon'+(defaultConsentRequestFee?' default':''),title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.set_default_label'),onClick:_this.resetToDefault('consentRequestFee')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["i" /* Collapse */],{isOpen:!defaultAnnualFee||!defaultConsentRequestFee,key:'deviation-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,className:'deviation-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.deviation_period_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_datepicker__["a" /* default */],{customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{invalid:!_this.isDateValid(_this.state.deviationInputValue,true)}),onBlur:_this.handleDateBlur('deviationDate','deviationInputValue'),onChange:_this.handleChangeDate('deviationDate','deviationInputValue'),onChangeRaw:_this.handleChange('deviationInputValue'),value:_this.state.deviationInputValue,selected:_this.state.deviationDate,showMonthDropdown:true,showYearDropdown:true,dropdownMode:'select',placeholderText:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].datepicker_placeholder),minDate:__WEBPACK_IMPORTED_MODULE_11_moment___default()(),disabled:_this.state.deviationDateForever,required:(!defaultAnnualFee||!defaultConsentRequestFee)&&!_this.state.deviationDateForever}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{check:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'checkbox',checked:_this.state.deviationDateForever,onChange:_this.toggleCheckBox('deviationDateForever')}),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.forever_label'))))))];};_this.toggleCheckBox=function(fieldKey){return function(){_this.setState(_defineProperty({},fieldKey,!_this.state[fieldKey]));};};_this.handleDateBlur=function(dateFieldKey,inputFieldKey){if((__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.state[dateFieldKey])?'':_this.state[dateFieldKey].format('L'))!==_this.state[inputFieldKey]){if(_this.isDateValid(inputFieldKey,false)){var _this$setState2;_this.setState((_this$setState2={},_defineProperty(_this$setState2,inputFieldKey,__WEBPACK_IMPORTED_MODULE_11_moment___default()(_this.state[inputFieldKey],'L').format('L')),_defineProperty(_this$setState2,dateFieldKey,__WEBPACK_IMPORTED_MODULE_11_moment___default()(_this.state[inputFieldKey],'L')),_this$setState2));}else{_this.setState(_defineProperty({},inputFieldKey,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.state[dateFieldKey])?'':_this.state[dateFieldKey].format('L')));}}};_this.handleChangeDate=function(dateFieldKey,inputFieldKey){return function(date){var _this$setState4;_this.setState((_this$setState4={},_defineProperty(_this$setState4,dateFieldKey,date),_defineProperty(_this$setState4,inputFieldKey,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(date)?'':date.format('L')),_this$setState4));};};_this.handleChangePreset=function(selectedOption){_this.props.onChangePreset(selectedOption.value);};_this.handleChangeBalanceCurrency=function(selectedOption){_this.setState({balanceCurrency:selectedOption.value});};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleBlur=function(fieldKey){return function(){_this.setState(_defineProperty({},fieldKey,Number(_this.state[fieldKey]).toFixed(2)));};};_this.handleKeyDown=function(e){if(e.key==='Enter'){e.preventDefault();}};_this.resetToDefault=function(fieldKey){return function(){_this.setState(_defineProperty({},fieldKey,Number(_this.props.currentPresetData[fieldKey].amount).toFixed(2)));};};_this.onSubmit=function(e){e.preventDefault();var data={pricing:{pricingPreset:{id:_this.props.currentPresetId}},balance:{currency:_this.state.balanceCurrency}};if(_this.props.currentPresetData.annualFee.amount!==Number(_this.state.annualFee)){data.pricing["annualFee"]={amount:Number(_this.state.annualFee),currency:_this.props.currentPresetData.annualFee.currency};}if(_this.props.currentPresetData.consentRequestFee.amount!==Number(_this.state.consentRequestFee)){data.pricing["consentRequestFee"]={amount:Number(_this.state.consentRequestFee),currency:_this.props.currentPresetData.consentRequestFee.currency};}if(data.pricing.annualFee||data.pricing.consentRequestFee){data.pricing["validTill"]=_this.state.deviationDateForever?null:_this.state.deviationDate;}if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.state.paidTillDate)){data["paidTill"]=_this.state.paidTillDate.format('YYYY-MM-DD');}_this.props.onSubmit(data);};_this.state={balanceCurrency:'USD',paidTillDate:null,paidTillInputValue:'',annualFee:'',consentRequestFee:'',deviationDate:null,deviationDateForever:false,deviationInputValue:''};return _this;}_createClass(OrgPriceModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.defaultCurrency)&&nextProps.defaultCurrency!==this.props.defaultCurrency){this.setState({balanceCurrency:nextProps.defaultCurrency,paidTillDate:null});}if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.currentPresetData)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.currentPresetData)){this.setState({annualFee:Number(nextProps.currentPresetData.annualFee.amount).toFixed(2),consentRequestFee:Number(nextProps.currentPresetData.consentRequestFee.amount).toFixed(2)});}if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.currentPresetData)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.currentPresetData)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(nextProps.currentPresetData,this.props.currentPresetData)){var annualFee=Number(this.state.annualFee)===this.props.currentPresetData.annualFee.amount?nextProps.currentPresetData.annualFee.amount:Number(this.state.annualFee);var consentRequestFee=Number(this.state.consentRequestFee)===this.props.currentPresetData.consentRequestFee.amount?nextProps.currentPresetData.consentRequestFee.amount:Number(this.state.consentRequestFee);this.setState({annualFee:annualFee.toFixed(2),consentRequestFee:consentRequestFee.toFixed(2)});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onChangePreset();}},{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.currentPresetData)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.currenciesData)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'org-price-modal',isOpen:this.props.isOpen,toggle:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.onSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'finance.org_finance_label')),this.renderPaidTillDateFormGroup(),this.renderBalanceFormGroup(),this.renderPresetFormGroup(),this.renderPriceFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit',disabled:this.submitButtonDisabled()},this.props.submitButtonText)));}}]);return OrgPriceModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OrgPriceModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,currentPresetId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,defaultCurrency:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,currentPresetData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,presetsData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,submitButtonText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,currenciesData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onChangePreset:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (OrgPriceModal);

/***/ }),
/* 777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IGNORE_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["a"] = (onClickOutsideHOC);


/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Manager__ = __webpack_require__(780);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Target__ = __webpack_require__(781);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Target__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popper__ = __webpack_require__(782);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Popper__["a"]; });
/* unused harmony reexport placements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Arrow__ = __webpack_require__(783);
/* unused harmony reexport Arrow */





/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Manager.childContextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Manager.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Manager.defaultProps = {
  tag: 'div'
};


/* harmony default export */ __webpack_exports__["a"] = (Manager);

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Target.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Target);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_popper_js__ = __webpack_require__(258);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var placements = __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */].placements;

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      if (_this.props.target) {
        return _this.props.target;
      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
      }
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return _extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
          element: this._arrowNode
        });
      }
      this._popper = new __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */](this._getTargetNode(), this._popperNode, {
        placement: placement,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
    }
  }]);

  return Popper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Popper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Popper.childContextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Popper.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(placements),
  eventsEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
  // the following check is needed for SSR
  __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(typeof Element !== 'undefined' ? Element : Object), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    getBoundingClientRect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    clientWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    clientHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  modifiers: {}
};


/* harmony default export */ __webpack_exports__["a"] = (Popper);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Arrow.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* unused harmony default export */ var _unused_webpack_default_export = (Arrow);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StaffList__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_organization_staffMembers__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_staffMembers__["m" /* loadingStaffMembers */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["e" /* getTranslation */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_staffMembers__["k" /* getStaffMembersData */])(state),removingMode:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_staffMembers__["i" /* getStaffMemberToRemove */])(state))};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_staffMembers__["d" /* fetchGetStaffMembers */])());},onStaffMemberAdd:function onStaffMemberAdd(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["G" /* MODAL_NEW_STAFF_MEMBER */]}));},onStaffMemberRemove:function onStaffMemberRemove(staffMemberId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_2" /* MODAL_REMOVE_STAFF_MEMBER */]}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_staffMembers__["o" /* setStaffMemberToRemove */])(staffMemberId));},onChangeAnchor:function onChangeAnchor(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["s" /* MODAL_CHANGE_ANCHOR */]}));},onRemove:function onRemove(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_staffMembers__["n" /* removeStaffMember */])());},onResendActivation:function onResendActivation(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_5" /* MODAL_RESENT_ACTIVATION_STAFF_MEMBER */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__StaffList__["a" /* default */]));

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StaffList_css__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StaffList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StaffList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__staffMemberModal_createStaffMemberModal_CreateStaffMemberModal_container__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__staffMemberModal_removeStaffMemberModal_RemoveStaffMemberModal_container__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__staffMemberModal_resendActivationStaffMember_ResendActivationStaffMember_container__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__changeAnchorModal_ChangeAnchorModal_container__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_paginationComponent_PaginationStaff_container__ = __webpack_require__(799);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StaffList=function(_Component){_inherits(StaffList,_Component);function StaffList(props){_classCallCheck(this,StaffList);var _this=_possibleConstructorReturn(this,(StaffList.__proto__||Object.getPrototypeOf(StaffList)).call(this,props));_this.onAddButtonClick=function(){_this.props.onStaffMemberAdd();};_this.onResendActivationClick=function(email){return function(){_this.setState({resendActivationEmail:email});_this.props.onResendActivation();};};_this.onRemoveButtonClick=function(id){return function(){_this.props.onStaffMemberRemove(id);};};_this.onChangeAnchorButtonClick=function(){_this.props.onChangeAnchor();};_this.onStaffRemove=function(){_this.props.onRemove();};_this.state={resendActivationEmail:null};return _this;}_createClass(StaffList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'staff-list-component-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'staff-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.staff.table_label')),this.renderButtonsBar(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_paginationComponent_PaginationStaff_container__["a" /* default */],null),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__staffMemberModal_createStaffMemberModal_CreateStaffMemberModal_container__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__staffMemberModal_removeStaffMemberModal_RemoveStaffMemberModal_container__["a" /* default */],{onRemove:this.onStaffRemove}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__staffMemberModal_resendActivationStaffMember_ResendActivationStaffMember_container__["a" /* default */],{email:this.state.resendActivationEmail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__changeAnchorModal_ChangeAnchorModal_container__["a" /* default */],null)));}},{key:'renderContent',value:function renderContent(){if(this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'staff-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.data)||this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'staff-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.staff.no_data_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["N" /* Table */],{className:'staff-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.renderStaffData()));}},{key:'renderStaffData',value:function renderStaffData(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.props.data,function(member,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index,className:!member.active?'not-active-staff-member-list-row':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'first-name-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)+':'},member.firstName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'last-name-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)+':'},member.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'email-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+':'},member.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'staff-control-cell resend-activation-cell'},_this2.renderResendActivationButton(member),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'trash',className:'delete-staff-member-icon',onClick:_this2.onRemoveButtonClick(member.id),title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button)})));});}},{key:'renderResendActivationButton',value:function renderResendActivationButton(member){if(member.active){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{className:'btn-sm',color:'link',onClick:this.onResendActivationClick(member.email)},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'resend_activation.title'));}},{key:'renderButtonsBar',value:function renderButtonsBar(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-staff-member-button-container olive-green'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{className:'change-anchor-button',onClick:this.onChangeAnchorButtonClick},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.change_anchor.title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'add',className:'add-staff-member-button',onClick:this.onAddButtonClick,title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].add_button)}));}},{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}}]);return StaffList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var StaffMemberShape=__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,firstName:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,lastName:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,email:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,active:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired});StaffList.propTypes={loading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(StaffMemberShape),removingMode:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,onStaffMemberRemove:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onChangeAnchor:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onResendActivation:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onMount:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onRemove:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (StaffList);

/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateStaffMemberModal__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_organization_staffMembers__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_organization_organization__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["G" /* MODAL_NEW_STAFF_MEMBER */],loadingOrg:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organization__["y" /* loadingOrg */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["e" /* getTranslation */])(state),isOrgValidated:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organization__["x" /* isOrganizationValidated */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onStaffMemberCreate:function onStaffMemberCreate(staffMemberData){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_staffMembers__["e" /* fetchRegisterStaffMember */])(staffMemberData));},onMount:function onMount(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organization__["d" /* fetchGetOrg */])());},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CreateStaffMemberModal__["a" /* default */]));

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreateStaffMemberModal_css__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreateStaffMemberModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CreateStaffMemberModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FIRST_NAME='first-name';var LAST_NAME='last-name';var EMAIL='email';var CreateStaffMemberModal=function(_Component){_inherits(CreateStaffMemberModal,_Component);function CreateStaffMemberModal(props){_classCallCheck(this,CreateStaffMemberModal);var _this=_possibleConstructorReturn(this,(CreateStaffMemberModal.__proto__||Object.getPrototypeOf(CreateStaffMemberModal)).call(this,props));_this.handleChange=function(inputName){return function(e){switch(inputName){case FIRST_NAME:_this.setState({firstName:e.target.value});break;case LAST_NAME:_this.setState({lastName:e.target.value});break;case EMAIL:_this.setState({email:e.target.value});break;default:break;}};};_this.handleSubmit=function(e){e.preventDefault();var staffMemberData={email:_this.state.email,identityAlias:{firstName:_this.state.firstName,lastName:_this.state.lastName}};_this.props.onStaffMemberCreate(staffMemberData);};_this.state={firstName:'',lastName:'',email:''};return _this;}_createClass(CreateStaffMemberModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'staff-member-modal',isOpen:this.props.isOpen&&!this.props.loadingOrg,toggle:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.staff.create_success_message')},this.props.isOrgValidated?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'warning'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'main.non_validated_org_access_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3,className:'modal-label-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)+'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'text',placeholder:''+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),required:true,onChange:this.handleChange(FIRST_NAME)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3,className:'modal-label-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)+'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'text',placeholder:''+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),required:true,onChange:this.handleChange(LAST_NAME)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3,className:'modal-label-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'text',placeholder:''+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label),required:true,onChange:this.handleChange(EMAIL)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit',disabled:!this.props.isOrgValidated},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.staff.register_button')))));}},{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}}]);return CreateStaffMemberModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CreateStaffMemberModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,loadingOrg:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isOrgValidated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,toggle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onStaffMemberCreate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (CreateStaffMemberModal);

/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_organization_staffMembers__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RemoveStaffMemberModal__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_2" /* MODAL_REMOVE_STAFF_MEMBER */],staffMemberName:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_staffMembers__["j" /* getStaffMemberToRemoveName */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_staffMembers__["o" /* setStaffMemberToRemove */])(null));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__RemoveStaffMemberModal__["a" /* default */]));

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveStaffMemberModal_css__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveStaffMemberModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RemoveStaffMemberModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveStaffMemberModal=function(_Component){_inherits(RemoveStaffMemberModal,_Component);function RemoveStaffMemberModal(props){_classCallCheck(this,RemoveStaffMemberModal);var _this=_possibleConstructorReturn(this,(RemoveStaffMemberModal.__proto__||Object.getPrototypeOf(RemoveStaffMemberModal)).call(this,props));_this.onRemoveHandle=function(){_this.props.onRemove();};_this.onCancelHandle=function(){_this.setState({data:null});_this.props.onCancel();};_this.state={data:null};return _this;}_createClass(RemoveStaffMemberModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(nextProps.staffMemberName)){this.setState({data:nextProps.staffMemberName});}}},{key:'render',value:function render(){if(this.state.data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen,toggle:this.onCancelHandle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.staff.remove_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{className:'remove-modal-text'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.staff.remove_modal_alert').replace('{name}',this.state.data)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.onCancelHandle},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.onRemoveHandle},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))))));}else{return null;}}}]);return RemoveStaffMemberModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveStaffMemberModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,staffMemberName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveStaffMemberModal);

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResendActivationStaffMember__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_account_activation__ = __webpack_require__(62);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_5" /* MODAL_RESENT_ACTIVATION_STAFF_MEMBER */],translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onResendActivation:function onResendActivation(email){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_activation__["c" /* fetchResendActivation */])(email));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ResendActivationStaffMember__["a" /* default */]));

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ResendActivationStaffMember_css__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ResendActivationStaffMember_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ResendActivationStaffMember_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResendActivationStaffMember=function(_Component){_inherits(ResendActivationStaffMember,_Component);function ResendActivationStaffMember(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ResendActivationStaffMember);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ResendActivationStaffMember.__proto__||Object.getPrototypeOf(ResendActivationStaffMember)).call.apply(_ref,[this].concat(args))),_this),_this.onResendActivationSubmit=function(e){e.preventDefault();_this.props.onResendActivation(_this.props.email);},_this.onResendActivationCancel=function(){_this.props.onCancel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ResendActivationStaffMember,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen,toggle:this.onResendActivationCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'resend_activation.success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{className:'resend-employee-activation-form',onSubmit:this.onResendActivationSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'resend_activation.employee_label').replace('{email}',this.props.email)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.onResendActivationCancel},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'resend_activation.submit_button')))))));}}]);return ResendActivationStaffMember;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ResendActivationStaffMember.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onResendActivation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ResendActivationStaffMember);

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_organization_staffMembers__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChangeAnchorModal__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["s" /* MODAL_CHANGE_ANCHOR */],availableStaffMembers:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_staffMembers__["g" /* getAvailableStaffMembersForChangeAnchor */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onEmployeesLoad:function onEmployeesLoad(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_staffMembers__["c" /* fetchGetAllStaffMembers */])());},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onChangeAnchor:function onChangeAnchor(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_staffMembers__["b" /* fetchChangeAnchor */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__ChangeAnchorModal__["a" /* default */]));

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeAnchorModal_css__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeAnchorModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ChangeAnchorModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_selectWithSearch_SelectWithSearch__ = __webpack_require__(180);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeAnchorModal=function(_Component){_inherits(ChangeAnchorModal,_Component);function ChangeAnchorModal(props){_classCallCheck(this,ChangeAnchorModal);var _this=_possibleConstructorReturn(this,(ChangeAnchorModal.__proto__||Object.getPrototypeOf(ChangeAnchorModal)).call(this,props));_this.handleChangeEmployeeId=function(value){_this.setState({employeeId:value});};_this.getEmployeesOptions=function(){return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(_this.props.availableStaffMembers,function(employee){return{value:employee.id,label:employee.firstName+' '+employee.lastName+' ('+employee.email+')'};});};_this.onSubmit=function(e){e.preventDefault();_this.props.onChangeAnchor(_this.state.employeeId);};_this.handleCancel=function(){_this.setState({employeeId:null});_this.props.onCancel();};_this.state={employeeId:null};return _this;}_createClass(ChangeAnchorModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!this.props.isOpen&&nextProps.isOpen){this.props.onEmployeesLoad();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'change-anchor-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.change_anchor.success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'change-anchor-modal-alert-message'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.change_anchor.modal_alert_message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'change-anchor-warning'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.change_anchor.modal_alert_warning')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.onSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:3},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.employee_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_selectWithSearch_SelectWithSearch__["a" /* default */],{value:this.state.employeeId,onChange:this.handleChangeEmployeeId,options:this.getEmployeesOptions(),placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.employee_input_placeholder')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit',disabled:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.state.employeeId)},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.change_anchor.submit_button')))))));}}]);return ChangeAnchorModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ChangeAnchorModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,availableStaffMembers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onEmployeesLoad:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onChangeAnchor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ChangeAnchorModal);

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_organization_staffMembers__ = __webpack_require__(64);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_staffMembers__["h" /* getCurrentPageForStaff */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_staffMembers__["l" /* getTotalPagesForStaff */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_staffMembers__["d" /* fetchGetStaffMembers */])(page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_levels__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InsertAccreditation__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_common_titleLangs__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_accreditation_certificate__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_organization_organization__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{continentCode:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["e" /* getCountriesData */])(state),additionalLangs:Object(__WEBPACK_IMPORTED_MODULE_8__reducers_common_titleLangs__["c" /* getOptionalTitleLangsData */])(state),levels:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_levels__["c" /* getLevelsData */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["e" /* getTranslation */])(state),accreditationGroupId:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_account_role__["k" /* getCurrentGroup */])(state),accreditationGroupName:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_account_role__["m" /* getCurrentGroupName */])(state),signingKey:Object(__WEBPACK_IMPORTED_MODULE_9__reducers_accreditation_certificate__["d" /* getKey */])(state),signingKeyLoading:Object(__WEBPACK_IMPORTED_MODULE_9__reducers_accreditation_certificate__["e" /* getKeyLoading */])(state),isSigningRequired:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_organization_organization__["v" /* isAccreditationSigningRequired */])(state),orgLoading:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_organization_organization__["y" /* loadingOrg */])(state),isBava:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_organization_organization__["w" /* isOrgBava */])(state),loadingManagedOrgs:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["L" /* loadingManagedOrgs */])(state),managedOrgs:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["E" /* getManagedOrgsOptions */])(state),locationData:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["g" /* getLocationData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onInsert:function onInsert(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["m" /* fetchInsertAccreditation */])(data));},onSetSubmitFormLoading:function onSetSubmitFormLoading(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["b" /* fetchSubmitForm */])());},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onGetAccreditationGroups:function onGetAccreditationGroups(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_account_role__["i" /* fetchReGetGroups */])());},onGetAdditionalLangs:function onGetAdditionalLangs(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__reducers_common_titleLangs__["b" /* fetchGetTitleLangs */])());},onGetLevels:function onGetLevels(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_levels__["b" /* fetchGetLevels */])());},onGetOrganization:function onGetOrganization(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_organization_organization__["d" /* fetchGetOrg */])());},onGetManagedOrgs:function onGetManagedOrgs(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["l" /* fetchGetManagedOrgs */])(countryCode));},onContinentSetByCountry:function onContinentSetByCountry(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["i" /* setCurrentContinentByCountry */])(countryCode));},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["g" /* clearManagedOrgs */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__InsertAccreditation__["a" /* default */]));

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_datepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__additionalTitle_AdditionalTitle_container__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__InsertAccreditation_css__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__InsertAccreditation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__InsertAccreditation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_cryptoUtils__ = __webpack_require__(101);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var requiredSelectFields=['level','personCountry'];var InsertAccreditation=function(_Component){_inherits(InsertAccreditation,_Component);function InsertAccreditation(props){_classCallCheck(this,InsertAccreditation);var _this=_possibleConstructorReturn(this,(InsertAccreditation.__proto__||Object.getPrototypeOf(InsertAccreditation)).call(this,props));_this.onMount=function(){_this.props.onGetLevels();_this.props.onGetAccreditationGroups();_this.props.onGetAdditionalLangs();_this.props.onGetOrganization();};_this.renderOrganizationFormGroup=function(){if(!_this.props.isBava){return null;}var paramsList=[{value:'orgContinent',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label),type:'select',content:[{value:null,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].continents)))),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),isDisabled:!_this.props.continents,onChange:_this.handleOrgContinentChange,popoverParams:{noPopover:true}},{value:"orgCountry",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),type:'select',content:[{value:null,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.locationData[_this.state.orgContinent],__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].countries)))),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isDisabled:!_this.props.continents,popoverParams:{noPopover:true}},{value:"orgId",type:"select",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)+'*',content:_this.props.managedOrgs,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)),isDisabled:_this.props.loadingManagedOrgs,isRequired:true,popoverParams:{noPopover:true},onChange:_this.handleOrgIdChange}];return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{key:'label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].org_label))].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.handleOrgContinentChange=function(selectedOption){_this.setState({orgContinent:selectedOption.value,orgCountry:null,orgId:null});};_this.handleOrgIdChange=function(selectedOption){_this.setState({orgId:selectedOption.value});_this.props.onContinentSetByCountry(selectedOption.countryCode);_this.setState({personCountry:selectedOption.countryCode});};_this.renderDepartmentFormGroup=function(){if(_this.props.accreditationGroupName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,className:'insert-accreditation-department-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insert-accreditation-department-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].accreditation_group_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.accreditationGroupName)));}};_this.renderTitlesFormGroups=function(){var paramsList=[{value:"titleOrig",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_orig_label')+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_orig_input_placeholder')},{value:"titleEn",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_en_label')+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_en_input_placeholder')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderAdditionalTitlesFormGroups=function(){var title=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'additional-langs-title',key:'additional-langs-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.additional_translations_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'add-additional-lang-icon olive-green',icon:'add',onClick:_this.addAdditionalTitle,title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.add_additional_translations_label')}));var result=[title];_this.state.titlesAdditional.forEach(function(elem){result.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__additionalTitle_AdditionalTitle_container__["a" /* default */],{key:elem.id,id:elem.id,lang:elem.lang,title:elem.title,langs:_this.getAvailableLang(elem.id),onChangeLang:_this.handleChangeAdditionalTitleLang,onChangeTitle:_this.handleChangeAdditionalTitle,onRemove:_this.removeAdditionalTitle,required:true,requiredFieldError:_this.state.requiredFieldError===elem.id}));});return result;};_this.renderAccreditationFormGroups=function(){var params={value:"level",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.level_label')+"*",isDisabled:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.levels),content:__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLevelsOptions(_this.props.levels,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels')),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.level_input_placeholder'),isRequired:true};return[_this.renderDateIssued(),_this.getSelectFormGroup(params)];};_this.renderDateIssued=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:'date-issued'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':'date-issued',sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.date_issued_label'),'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_datepicker__["a" /* default */],{customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{id:'date-issued'}),selected:_this.state.dateIssued,showMonthDropdown:true,showYearDropdown:true,dropdownMode:'select',required:true,onChange:_this.handleChangeDate,maxDate:__WEBPACK_IMPORTED_MODULE_5_moment___default()()})));};_this.renderPersonFormGroups=function(){var paramsList=[{value:"personFirstName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)},{value:"personLastName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)},{value:"email",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+(__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].isDateHistorical(_this.state.dateIssued)?"":"*"),type:"email",isRequired:!__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].isDateHistorical(_this.state.dateIssued),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)},{value:"nationalId",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].national_id_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].national_id_label),popoverHintParams:{hintText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.national_id_hint')},formGroupHintText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.national_id_expose_hint')},{value:"personContinent",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label)+"*",type:'select',content:__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),onChange:_this.handleChangeContinent,isRequired:true,isDisabled:!_this.props.continents},{value:"personCountry",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)+"*",type:'select',content:__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isRequired:true,isDisabled:!_this.props.countries}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.getFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}if(params.type==='select'){return _this.getSelectFormGroup(params);}var id=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.kebabCase(params.value);return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title,_this.renderHintPopover(params.value,params.popoverHintParams)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:_this.state[params.value],onChange:params.onChange||_this.handleChange(params.value),placeholder:params.placeholder,disabled:params.isDisabled,required:params.isRequired},params.content))),params.formGroupHintText?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group-hint',key:params.title+"form-group-hint"},params.formGroupHintText):null];};_this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title,_this.renderHintPopover(params.value,params.popoverHintParams)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];}),options:params.content,onSelect:params.onChange||_this.handleChangeSelect(params.value),placeholder:params.placeholder,disabled:params.isDisabled,requiredFieldError:_this.state.requiredFieldError===params.value})));};_this.renderHintPopover=function(fieldName,params){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(params)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insert-accreditation-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:fieldName+'-hint',className:'insert-accreditation-hint-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Q" /* UncontrolledPopover */],{trigger:'legacy',placement:'top',target:fieldName+'-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["I" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(params.hintText)))));}};_this.onSubmit=function(e){e.preventDefault();if(_this.checkRequiredSelectFields()){return;}var titles={original:_this.state.titleOrig,en:_this.state.titleEn};_this.state.titlesAdditional.forEach(function(elem){if(elem.lang!=="")titles[elem.lang]=elem.title;});var data={accreditationGroupId:_this.props.accreditationGroupId,accreditationData:{titles:titles,issuedAt:_this.state.dateIssued.format("YYYY-MM-DD"),level:_this.state.level},verifiedIdentity:{firstName:_this.state.personFirstName,lastName:_this.state.personLastName,countryCode:_this.state.personCountry,nationalId:_this.state.nationalId}};if(_this.state.email){data["email"]=_this.state.email;}if(_this.state.orgId){data.managedOrgId=_this.state.orgId;}if(_this.props.isSigningRequired){_this.props.onSetSubmitFormLoading();__WEBPACK_IMPORTED_MODULE_14__utils_cryptoUtils__["a" /* CryptoUtils */].signAccreditation(_this.props.signingKey,data).then(function(signingData){_this.props.onInsert(signingData);});}else{_this.props.onInsert(data);}};_this.cleanPersonData=function(){_this.setState({personFirstName:'',personLastName:'',email:'',nationalId:''});};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleChangeDate=function(date){_this.setState({dateIssued:date});};_this.handleChangeSelect=function(fieldKey){return function(selectedOption){_this.setState(_defineProperty({},fieldKey,selectedOption.value));};};_this.handleChangeContinent=function(selectedOption){_this.setState({personCountry:''});_this.props.onContinentSet(selectedOption.value);};_this.handleChangeAdditionalTitle=function(id){return function(e){var newTitles=_this.state.titlesAdditional.map(function(elem){if(elem.id===id)elem.title=e.target.value;return elem;});_this.setState({titlesAdditional:newTitles});};};_this.handleChangeAdditionalTitleLang=function(id,value){var newTitles=_this.state.titlesAdditional.map(function(elem){if(elem.id===id)elem.lang=value;return elem;});_this.setState({titlesAdditional:newTitles});};_this.addAdditionalTitle=function(){var newTitle={id:__WEBPACK_IMPORTED_MODULE_6_uuid___default()(),lang:'',title:''};_this.setState({titlesAdditional:[].concat(_toConsumableArray(_this.state.titlesAdditional),[newTitle])});};_this.removeAdditionalTitle=function(id){return function(){var newTitles=_this.state.titlesAdditional.filter(function(elem){return elem.id!==id;});_this.setState({titlesAdditional:newTitles});};};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(requiredSelectFields,function(field){if(!_this.state[field]&&!error){error=field;}});__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(_this.state.titlesAdditional,function(title){if(title.lang===''&&!error){error=title.id;}});_this.setState({requiredFieldError:error});return error;};_this.state={titleOrig:'',titleEn:'',titlesAdditional:[],dateIssued:__WEBPACK_IMPORTED_MODULE_5_moment___default()(),level:'',personFirstName:'',personLastName:'',email:'',personContinent:_this.props.continentCode,personCountry:'',nationalId:'',requiredFieldError:null,successMessage:'',orgContinent:null,orgCountry:null,orgId:null};return _this;}_createClass(InsertAccreditation,[{key:'componentDidMount',value:function componentDidMount(){this.onMount();if(this.props.isBava){this.props.onGetManagedOrgs();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onContinentSet('');this.props.onUnmount();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.state.personContinent!==nextProps.continentCode){this.setState({personContinent:nextProps.continentCode});}if(nextProps.success&&this.props.success!==nextProps.success){this.cleanPersonData();}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState,nextContext){var _this2=this;if(this.state.orgCountry!==nextState.orgCountry){this.props.onGetManagedOrgs(nextState.orgCountry);}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(this.props.managedOrgs,nextProps.managedOrgs)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(nextProps.managedOrgs)&&this.state.orgId&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.some(nextProps.managedOrgs,function(option){return option.value===_this2.state.orgId;})){this.setState({orgId:null});}}},{key:'render',value:function render(){if(this.props.signingKeyLoading||this.props.orgLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}if(this.props.isSigningRequired&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.signingKey)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'insert_accreditation.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'carrot-red'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,"insert_accreditation.no_certificate_message_start"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/security'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,"insert_accreditation.no_certificate_message_link")),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,"insert_accreditation.no_certificate_message_end")));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insert-accreditation-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'insert_accreditation.success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insert-accreditation-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'insert_accreditation.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Form */],{onSubmit:this.onSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:12},this.renderDepartmentFormGroup())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:7},this.renderOrganizationFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation.accreditation_label')),this.renderTitlesFormGroups(),this.renderAccreditationFormGroups(),this.renderAdditionalTitlesFormGroups()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation.person_label')),this.renderPersonFormGroups())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'insert_accreditation.submit_button')))))));}},{key:'getAvailableLang',// handleAccreditationGroupChange = (e) => {
//     this.setState({accreditationGroupId: e.target.value});
// if (!_.isEmpty(e.target.value)) {
//     this.props.onGetLevels(e.target.value)
// }
// }
value:function getAvailableLang(id){var disabledLangs=this.state.titlesAdditional.filter(function(elem){return elem.id!==id;}).map(function(elem){return elem.lang;});return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(this.props.additionalLangs).filter(function(lang){return!disabledLangs.includes(lang);});}}]);return InsertAccreditation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InsertAccreditation.propTypes={continentCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,accreditationGroupId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,accreditationGroupName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,additionalLangs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,levels:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,success:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,signingKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,signingKeyLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isSigningRequired:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isBava:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,loadingManagedOrgs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,managedOrgs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,locationData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onInsert:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSetSubmitFormLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onContinentSet:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetAccreditationGroups:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetAdditionalLangs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetLevels:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetManagedOrgs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onContinentSetByCountry:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onUnmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (InsertAccreditation);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdditionalTitle_css__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdditionalTitle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AdditionalTitle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AdditionalTitle=function(_Component){_inherits(AdditionalTitle,_Component);function AdditionalTitle(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AdditionalTitle);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AdditionalTitle.__proto__||Object.getPrototypeOf(AdditionalTitle)).call.apply(_ref,[this].concat(args))),_this),_this.getLangOptions=function(){return _this.props.langs.map(function(option){return{value:option,label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'langs.'+option)};});},_this.getSelectedOption=function(){if(_this.props.lang===''){return undefined;}return{value:_this.props.lang,label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'langs.'+_this.props.lang)};},_this.handleChange=function(selectedOption){_this.props.onChangeLang(_this.props.id,selectedOption.value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AdditionalTitle,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{className:'additional-title-form-group',row:true,key:'title-'+this.props.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:'select-'+this.props.id,options:this.getLangOptions(),onSelect:this.handleChange,selectedOption:this.getSelectedOption(),placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'accreditation.language_input_placeholder'),requiredFieldError:this.props.requiredFieldError})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'text',className:this.props.inputClassName,id:this.props.inputId,value:this.props.title,onChange:this.props.onChangeTitle(this.props.id),placeholder:'Title translation',onClick:this.props.inputOnClick,required:this.props.required,autoComplete:this.props.autoComplete})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:1,className:'delete-title-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'delete-title-icon',icon:'clear',onClick:this.props.onRemove(this.props.id),title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button)})));}}]);return AdditionalTitle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AdditionalTitle.propTypes={inputId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,inputOnClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,inputClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,lang:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,langs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,required:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,autoComplete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,requiredFieldError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onChangeLang:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onChangeTitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AdditionalTitle);

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidateAccreditation__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_levels__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_organization_organization__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{id:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["A" /* getCurrentAccreditationId */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["K" /* loadingAccreditationList */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["r" /* getAccreditationDataFormatted */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["e" /* getCountriesData */])(state),levels:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_levels__["c" /* getLevelsData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["e" /* getTranslation */])(state),isBava:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_organization_organization__["w" /* isOrgBava */])(state),loadingManagedOrgs:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["L" /* loadingManagedOrgs */])(state),managedOrgs:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["E" /* getManagedOrgsOptions */])(state),locationData:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["g" /* getLocationData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSubmit:function onSubmit(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["p" /* fetchValidateAccreditation */])(id,data));},onContinentSetByCountry:function onContinentSetByCountry(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["i" /* setCurrentContinentByCountry */])(countryCode));},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onGetLevels:function onGetLevels(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_levels__["b" /* fetchGetLevels */])());},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["d" /* cleanValidatedStatus */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["c" /* cleanStartAccreditation */])());},onNext:function onNext(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["W" /* setNextAsStartAccreditationForValidation */])());},onOpenValidateAccreditationModal:function onOpenValidateAccreditationModal(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_6__reducers_common_activeModal__["_10" /* MODAL_VALIDATE_ACCREDITATION */]}));},onGetManagedOrgs:function onGetManagedOrgs(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["l" /* fetchGetManagedOrgs */])(countryCode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__ValidateAccreditation__["a" /* default */]));

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inputWithPopover_InputWithPopover_container__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_progressBar_ProgressBar_container__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ValidateAccreditation_css__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ValidateAccreditation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ValidateAccreditation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__validateAccreditationModal_ValidateAccreditationModal_container__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__commonComponents_labelWithPages_ProcessAccreditationLabel_container__ = __webpack_require__(294);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ValidateAccreditation=function(_Component){_inherits(ValidateAccreditation,_Component);function ValidateAccreditation(props){_classCallCheck(this,ValidateAccreditation);var _this=_possibleConstructorReturn(this,(ValidateAccreditation.__proto__||Object.getPrototypeOf(ValidateAccreditation)).call(this,props));_this.onMount=function(){_this.props.onGetLevels();if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)){_this.props.onContinentSetByCountry(_this.props.data.personCountry);}if(_this.props.isBava){_this.props.onGetManagedOrgs(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props,'data.orgCountry'));}};_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Form */],{onSubmit:_this.onSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'next-accreditation-for-validate-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'next-accreditation-for-validate-button',color:'link',onClick:_this.props.onNext},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.next_accreditation_button'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,className:'accreditation-data-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:7},_this.renderOrganizationFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_label')),_this.renderTitlesFormGroups(),_this.renderAccreditationFormGroups(),_this.renderAdditionalTitlesFormGroups()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.person_label')),_this.renderPersonFormGroups())),_this.renderSubmitFormGroup());}else{return null;}};_this.renderOrganizationFormGroup=function(){if(!_this.props.isBava){return null;}var selectedOption=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this.props.managedOrgs,function(option){return _this.fieldErrorsHasValue('orgId')?option.value===_this.state.fieldErrors['orgId'].value:option.value===_this.props.data['orgId'];});var params={value:"orgId",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)+"*",type:'select',componentType:__WEBPACK_IMPORTED_MODULE_15__commonComponents_customSelect_CustomSelect_container__["a" /* default */],componentProps:{options:_this.props.managedOrgs,isSearchable:false,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)),onSelect:_this.handleChangeProposedValue("orgId"),selectedOption:selectedOption,requiredFieldError:_this.state.requiredFieldError==='orgId'}};var continents=[{value:null,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].continents))));var countriesByContinent=[{value:null,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.locationData[_this.state.orgContinent],__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].countries))));var proposedValue=_this.fieldErrorsHasValue(params.value)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this.props.managedOrgs,function(option){return option.value===_this.state.fieldErrors[params.value].value;}):null;var oldValue=_this.oldDataHasValue(params.value)?_this.props.data.fieldErrors['orgId'].value.split(/[()]/)[1]:_this.props.data.orgDomain;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{key:'label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:'continent-select',className:'continent-select-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':'continent-select',sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,className:'continent-select-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:11},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{selectedOption:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(continents,function(option){return option.value===_this.state.orgContinent;}),id:'org-continent',options:continents,onSelect:_this.handleOrgContinentChange,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),disabled:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.continents)&&!_this.fieldErrorsHasValue(params.value)}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:'country-select',className:'country-select-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':'country-select',sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,className:'country-select-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:11},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{selectedOption:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(countriesByContinent,function(option){return option.value===_this.state.orgCountry;}),id:'country-select',options:countriesByContinent,onSelect:_this.handleChangeCountrySelect,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder)}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':'org-id-select',sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__inputWithPopover_InputWithPopover_container__["a" /* default */],{id:'org-id-select',type:'select',editMode:_this.fieldErrorsHasValue(params.value),oldValue:oldValue,newValueText:_this.props.data.orgDomain,proposedValue:_this.fieldErrorsHasValue(params.value)?_this.state.fieldErrors[params.value].value:null,proposedValueText:proposedValue?proposedValue.label:null,message:_this.fieldErrorsHasValue(params.value)?_this.state.fieldErrors[params.value].reason:null,onChangeProposedValue:_this.handleChangeProposedValue(params.value),onChangeMessage:_this.handleChangeMessage(params.value),onChangeToggle:_this.handleChangeFieldErrors(params.value),componentType:params.componentType,componentProps:Object.assign({},params.componentProps,{disabled:_this.props.loadingManagedOrgs})},params.content)))];};_this.handleChangeCountrySelect=function(selectedOption){_this.setState({orgCountry:selectedOption.value});_this.props.onGetManagedOrgs(selectedOption.value);};_this.renderTitlesFormGroups=function(){var paramsList=[{value:"titleOrig",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_orig_label')+"*"},{value:"titleEn",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_en_label')+"*"}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderAdditionalTitlesFormGroups=function(){var title=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{key:'additional-langs-title'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.additional_translations_label'));var paramsList=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_this.props.data.titlesAdditional,function(value,key){paramsList.push({value:key,title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'langs.'+key),oldValue:_this.oldDataHasValue(key)?_this.props.data.fieldErrors[key].value:value,proposedValue:_this.fieldErrorsHasValue(key)?_this.state.fieldErrors[key].value:value,newValueText:value});});var result=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));return result.length!==0?[title].concat(_toConsumableArray(result)):null;};_this.renderAccreditationFormGroups=function(){var content=__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLevelsOptions(_this.props.levels,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels'));var selectedOption=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(content,function(option){return _this.fieldErrorsHasValue('level')?option.value===_this.state.fieldErrors['level'].value:option.value===_this.props.data['level'];});var params={value:"level",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.level_label')+"*",type:'select',oldValueText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels.'+(_this.oldDataHasValue('level')?_this.props.data.fieldErrors.level.value:_this.props.data.level)),proposedValueText:_this.fieldErrorsHasValue('level')?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels.'+_this.state.fieldErrors.level.value):'',newValueText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels.'+_this.props.data.level),popoverPlacement:'left',componentType:__WEBPACK_IMPORTED_MODULE_15__commonComponents_customSelect_CustomSelect_container__["a" /* default */],componentProps:{options:content,selectedOption:selectedOption,isSearchable:false,onSelect:_this.handleChangeProposedValue("level"),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.level_input_placeholder')}};return[_this.renderDateIssued(),_this.getFormGroup(params)];};_this.oldDataHasValue=function(fieldKey){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(_this.props.data.fieldErrors,fieldKey);};_this.renderDateIssued=function(){var params={value:"dateIssued",className:'date-issued-input',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.date_issued_label')+"*",oldValueText:_this.oldDataHasValue('dateIssued')?__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.fieldErrors.dateIssued.value).format("L"):__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.dateIssued).format('L'),oldValue:_this.oldDataHasValue('dateIssued')?__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.fieldErrors.dateIssued.value):__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.dateIssued),proposedValueText:_this.fieldErrorsHasValue('dateIssued')?_this.state.fieldErrors.dateIssued.value.format("L"):__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.dateIssued).format('L'),newValueText:__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.dateIssued).format('L'),componentType:__WEBPACK_IMPORTED_MODULE_5_react_datepicker__["a" /* default */],componentProps:{customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{id:'date-issued'}),showMonthDropdown:true,showYearDropdown:true,dropdownMode:"select",maxDate:__WEBPACK_IMPORTED_MODULE_6_moment___default()()},popoverPlacement:'left'};return _this.getFormGroup(params);};_this.renderPersonFormGroups=function(){var selectedDate=_this.fieldErrorsHasValue("dateIssued")?_this.state.fieldErrors.dateIssued.value:_this.props.data.dateIssued;var countries=[{value:null,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].countries))));var selectedCountry=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(countries,function(option){return _this.fieldErrorsHasValue('personCountry')?option.value===_this.state.fieldErrors['personCountry'].value:option.value===_this.props.data['personCountry'];});var paramsList=[{value:"personFirstName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)+"*"},{value:"personLastName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)+"*"},{value:"email",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+(__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].isDateHistorical(selectedDate)?"":"*"),type:"email"},{value:"personNationalId",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].national_id_label)+"*",popoverHintParams:{hintText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.national_id_hint')},formGroupHintText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.national_id_expose_hint')},{value:"personCountry",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)+"*",type:'select',componentType:__WEBPACK_IMPORTED_MODULE_15__commonComponents_customSelect_CustomSelect_container__["a" /* default */],componentProps:{options:countries,isSearchable:false,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),onSelect:_this.handleChangeProposedValue("personCountry"),selectedOption:selectedCountry,requiredFieldError:_this.state.requiredFieldError==='personCountry'}}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.getFormGroup=function(params){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(params)||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.kebabCase(params.value);if(params.value==="personCountry"){return _this.renderContinentAndCountryComponent(params);}var oldValue=_this.props.data[params.value];if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(params.oldValue)){oldValue=params.oldValue;}else if(_this.oldDataHasValue(params.value)){oldValue=_this.props.data.fieldErrors[params.value].value;}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{sm:3},params.title,_this.renderHintPopover(params.value,params.popoverHintParams)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__inputWithPopover_InputWithPopover_container__["a" /* default */],{id:id,className:params.className||'',popoverPlacement:params.popoverPlacement,editMode:_this.fieldErrorsHasValue(params.value),oldValue:oldValue,newValueText:params.newValueText||_this.props.data[params.value],proposedValue:(_this.fieldErrorsHasValue(params.value)?_this.state.fieldErrors[params.value].value:_this.props.data[params.value])||params.proposedValue,message:_this.fieldErrorsHasValue(params.value)?_this.state.fieldErrors[params.value].reason:null,onChangeProposedValue:_this.handleChangeProposedValue(params.value),onChangeMessage:_this.handleChangeMessage(params.value),onChangeToggle:_this.handleChangeFieldErrors(params.value),type:params.type||'text',oldValueText:params.oldValueText,proposedValueText:params.proposedValueText,componentType:params.componentType,componentProps:params.componentProps},params.content))),params.formGroupHintText?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group-hint',key:params.title+"form-group-hint"},params.formGroupHintText):null];};_this.renderHintPopover=function(fieldName,params){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(params)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validate-accreditation-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:fieldName+'-hint',className:'validate-accreditation-hint-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Q" /* UncontrolledPopover */],{trigger:'legacy',placement:'top',target:fieldName+'-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["I" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(params.hintText)))));}};_this.fieldErrorsHasValue=function(value){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(_this.state.fieldErrors,''+value);};_this.renderSubmitFormGroup=function(){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,className:'reject-message',key:'reject-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:7,className:'textarea-col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validate_accreditation.common_message_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{type:'textarea',value:_this.state.message,onChange:_this.handleChange("message"),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validate_accreditation.common_message_placeholder')})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:'submit-validation-btns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:12,className:'submit-validation-btns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{onClick:_this.onSendBackToReview,title:_this.isAccreditationEdited()?"":__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validate_accreditation.submit_button_invalidate_title'),disabled:!_this.isAccreditationEdited()},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validate_accreditation.submit_button_invalidate')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validate_accreditation.submit_button_validate'))))];};_this.isAccreditationEdited=function(){return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.state.fieldErrors)||_this.state.message!=='';};_this.onSendBackToReview=function(){var data={message:_this.state.message,fieldErrors:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(_this.state.fieldErrors),accepted:false};if(_this.fieldErrorsHasValue('dateIssued')){data.fieldErrors.dateIssued.value=data.fieldErrors.dateIssued.value.format("YYYY-MM-DD");}if(_this.fieldErrorsHasValue('orgId')){data.fieldErrors['orgCountry']={value:_this.state.orgCountry};var org=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this.props.managedOrgs,function(_ref){var value=_ref.value;return value===data.fieldErrors['orgId'].value;});data.fieldErrors['orgId']=Object.assign({},data.fieldErrors['orgId'],{label:org?org.label:null});}_this.props.onSubmit(_this.props.id,data);};_this.onSubmit=function(e){e.preventDefault();if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.state.fieldErrors)){_this.onValidateAccreditation();}else{_this.props.onOpenValidateAccreditationModal();}};_this.onValidateAccreditation=function(){var data={accepted:true};_this.props.onSubmit(_this.props.id,data);};_this.handleChangeMessage=function(fieldKey){return function(e){var newFieldErrors=_this.state.fieldErrors;newFieldErrors[fieldKey].reason=e.target.value;_this.setState({fieldErrors:newFieldErrors});};};_this.handleChangeProposedValue=function(fieldKey){return function(e){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(e)){return;}var newValue=void 0;if(fieldKey==="dateIssued"){newValue=e;}else{newValue=e.value||e.target.value;}var newFieldErrors=void 0;if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(newValue,_this.props.data[fieldKey])||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data[fieldKey])&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(newValue,_this.props.data.titlesAdditional[fieldKey])){newFieldErrors=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omit(_this.state.fieldErrors,fieldKey);}else{newFieldErrors=_this.state.fieldErrors;if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(newFieldErrors[fieldKey])){newFieldErrors[fieldKey]={value:null,reason:""};}newFieldErrors[fieldKey].value=newValue;}_this.setState({fieldErrors:newFieldErrors});};};_this.handleChangeFieldErrors=function(fieldKey){return function(){var newFieldErrors=void 0;if(_this.fieldErrorsHasValue(fieldKey)){newFieldErrors=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pickBy(_this.state.fieldErrors,function(value,key){return key!==fieldKey;});if(fieldKey==="personCountry"){_this.props.onContinentSetByCountry(_this.props.data.personCountry);}if(fieldKey==="orgId"){_this.setState({orgCountry:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props,'data.orgCountry')});}}else{newFieldErrors=_this.state.fieldErrors;newFieldErrors[fieldKey]={value:_this.props.data[fieldKey]||_this.props.data.titlesAdditional[fieldKey],reason:""};}_this.setState({fieldErrors:newFieldErrors});};};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleChangeContinent=function(selectedOption){var newFieldErrors=_this.state.fieldErrors;newFieldErrors.personCountry={};newFieldErrors.personCountry.value="";_this.setState({fieldErrors:newFieldErrors});_this.props.onContinentSet(selectedOption.value);};_this.handleOrgContinentChange=function(selectedOption){_this.setState({orgCountry:null,orgContinent:selectedOption.value});};_this.state={personContinent:_this.props.continentCode,message:'',fieldErrors:{},requiredFieldError:null,orgCountry:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(props,'data.orgCountry'),orgContinent:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(props,'data.orgContinent')};return _this;}_createClass(ValidateAccreditation,[{key:'componentDidMount',value:function componentDidMount(){this.onMount();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onContinentSet('');this.props.onUnmount();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(this.props.data,nextProps.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(nextProps.data)){this.props.onContinentSetByCountry(nextProps.data.personCountry);}if(this.state.personContinent!==nextProps.continentCode){this.setState({personContinent:nextProps.continentCode});}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(nextProps,'data.orgCountry')!==__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props,'data.orgCountry')&&this.state.orgCountry!==__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(nextProps,'data.orgCountry')){this.setState({orgCountry:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(nextProps,'data.orgCountry'),orgContinent:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(nextProps,'data.orgContinent')});}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(nextProps.id)&&nextProps.id!==this.props.id){this.setState({fieldErrors:{},message:''});this.props.onContinentSetByCountry(nextProps.data.personCountry);}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState,nextContext){if(this.state.orgCountry!==nextState.orgCountry){this.props.onGetManagedOrgs(nextState.orgCountry);}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(this.props.managedOrgs,nextProps.managedOrgs)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.some(nextProps.managedOrgs,function(org){return org.value===__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(nextProps,'data.orgId');})){var newFieldErrors=this.state.fieldErrors;newFieldErrors.orgId={value:null,reason:""};this.setState({fieldErrors:newFieldErrors});}}},{key:'render',value:function render(){if(!this.props.loading&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.id)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Redirect */],{to:'/validate-accreditations'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validate-accreditation-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'validate_accreditation.success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/validate-accreditations',label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation.back_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validate-accreditation-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__commonComponents_labelWithPages_ProcessAccreditationLabel_container__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'validate_accreditation.label')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_progressBar_ProgressBar_container__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation_requests.validated_accreditations_progress_label')+':'}),this.renderContent())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__validateAccreditationModal_ValidateAccreditationModal_container__["a" /* default */],{onValidateAccreditation:this.onValidateAccreditation}));}},{key:'renderContinentAndCountryComponent',value:function renderContinentAndCountryComponent(params){var _this2=this;var id=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.kebabCase(params.value);var proposedValueText=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.state.fieldErrors[params.value])?null:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].countries+"."+this.state.fieldErrors[params.value].value);var continents=__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLocationOptions(this.props.continents,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].continents));var selectedContinent=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(continents,function(option){return option.value===_this2.state.personContinent;});var oldValue=this.oldDataHasValue(params.value)?this.props.data.fieldErrors[params.value].value:this.props.data[params.value];return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:'continent-select',className:'continent-select-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':'continent-select',sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,className:'continent-select-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:11},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{selectedOption:selectedContinent,id:'person-continent',options:continents,onSelect:this.handleChangeContinent,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),disabled:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.continents)&&!this.fieldErrorsHasValue(params.value)}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__inputWithPopover_InputWithPopover_container__["a" /* default */],{id:id,type:'select',popoverPlacement:'left',editMode:this.fieldErrorsHasValue(params.value),oldValue:oldValue,oldValueText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'countries.'+oldValue),proposedValue:this.fieldErrorsHasValue(params.value)?this.state.fieldErrors[params.value].value:null,newValueText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'countries.'+this.props.data[params.value]),proposedValueText:proposedValueText,message:this.fieldErrorsHasValue(params.value)?this.state.fieldErrors[params.value].reason:null,onChangeProposedValue:this.handleChangeProposedValue(params.value),onChangeMessage:this.handleChangeMessage(params.value),onChangeToggle:this.handleChangeFieldErrors(params.value),componentType:params.componentType,componentProps:Object.assign({},params.componentProps,{disabled:this.fieldErrorsHasValue(params.value)&&(this.state.personContinent===''||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.countries))})},params.content)))];}}]);return ValidateAccreditation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ValidateAccreditation.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,continentCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,levels:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onContinentSet:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onContinentSetByCountry:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetLevels:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onNext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onOpenValidateAccreditationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ValidateAccreditation);

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputWithPopover_css__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputWithPopover_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__InputWithPopover_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_customSelect_CustomSelect__ = __webpack_require__(131);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InputWithPopover=function(_Component){_inherits(InputWithPopover,_Component);function InputWithPopover(props){_classCallCheck(this,InputWithPopover);var _this=_possibleConstructorReturn(this,(InputWithPopover.__proto__||Object.getPrototypeOf(InputWithPopover)).call(this,props));_this.renderPopover=function(){if(_this.props.editMode){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["H" /* Popover */],{placement:_this.props.popoverPlacement||"top",isOpen:_this.state.isOpen,target:_this.props.id,container:_this.popupWithInputContainerRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["I" /* PopoverBody */],{className:'popover-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon-hide-popover-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'clear',className:'icon-hide-popover',onClick:_this.hidePopover,title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'accreditation.popover.old_value_label'),': ',_this.props.oldValueText||_this.props.oldValue),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'accreditation.popover.proposed_value_label'),': ',_this.props.newValueText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'accreditation.popover.message_label'),': '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{type:'textarea',className:'textarea-message',value:_this.props.message,onChange:_this.props.onChangeMessage,placeholder:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'accreditation.popover.message_placeholder'),ref:function ref(elem){return _this.textAreaRef=elem;}})));}};_this.renderTitle=function(){if(_this.props.isOpen||!(_this.props.proposedValueText||_this.props.proposedValue)){return'';}var title='';if(_this.props.oldValueText||_this.props.oldValue){title=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'accreditation.popover.old_value_label')+': '+(_this.props.oldValueText||_this.props.oldValue);if(_this.props.message){title+='\n'+__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'accreditation.popover.message_label')+': '+_this.props.message;}}return title;};_this.renderIcon=function(){var icon=_this.props.editMode?"clear":"create";var title=_this.props.editMode?__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'accreditation.popover.discard_changes_label'):__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'accreditation.popover.edit_field_label');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'input-with-popover-icon',key:_this.props.editMode,icon:icon,onClick:_this.props.onChangeToggle,title:title});};_this.handleKeyDown=function(e){var key=e.charCode||e.keyCode||0;if(key===13){e.preventDefault();}};_this.showPopover=function(){if(!_this.props.editMode){_this.props.onChangeToggle();}_this.setState({isOpen:true});};_this.hidePopover=function(){if(_this.props.editMode&&_this.state.isOpen){_this.setState({isOpen:false});}};_this.handleBlur=function(e){var popupWithInputContainerNode=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this.popupWithInputContainerRef);var inputNode=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this.inputRef.input);var textAreaNode=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this.textAreaRef);var relatedTarget=e.relatedTarget;if(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(relatedTarget)||relatedTarget!==inputNode&&relatedTarget!==textAreaNode&&relatedTarget!==popupWithInputContainerNode){_this.hidePopover();}};_this.state={isOpen:false};return _this;}_createClass(InputWithPopover,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.editMode!==nextProps.editMode){this.setState({isOpen:nextProps.editMode});}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.editMode!==prevProps.editMode&&this.props.editMode){if(this.props.type==='select'){this.inputRef.focus();}else if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(this.inputRef.input)){__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.inputRef.input).focus();}else{__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.inputRef).focus();}}}},{key:'render',value:function render(){var _this2=this;if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(this.props.oldValue)){var _Object$assign;var className='validate-mode '+(this.props.editMode?'check-for-validate ':'')+(this.props.className||'');if(!this.props.editMode&&this.props.newValueText!==(this.props.oldValueText||this.props.oldValue)){className+=' updated ';}var value=_typeof(this.props.oldValue)==='object'?'selected':'value';var componentProps=Object.assign((_Object$assign={type:this.props.type,id:this.props.id},_defineProperty(_Object$assign,value,this.props.proposedValue),_defineProperty(_Object$assign,'className',className),_defineProperty(_Object$assign,'title',this.renderTitle()),_defineProperty(_Object$assign,'onChange',this.props.onChangeProposedValue),_defineProperty(_Object$assign,'placeholder',this.props.editMode?__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'accreditation.popover.proposed_value_input_placeholder'):""),_defineProperty(_Object$assign,'onClick',this.showPopover),_defineProperty(_Object$assign,'onFocus',this.showPopover),_defineProperty(_Object$assign,'onKeyDown',this.handleKeyDown),_defineProperty(_Object$assign,'autoComplete',"off"),_Object$assign),this.props.componentProps);if(this.props.type==='select'){componentProps.innerRef=function(elem){_this2.inputRef=elem;};componentProps.status=this.props.editMode?__WEBPACK_IMPORTED_MODULE_8__commonComponents_customSelect_CustomSelect__["a" /* STATUSES */].ERROR:null;}else{componentProps.ref=function(elem){_this2.inputRef=elem;};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:11},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-with-popover-container',ref:function ref(elem){return _this2.popupWithInputContainerRef=elem;},tabIndex:0,onBlur:this.handleBlur},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.props.componentType||__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],componentProps,this.props.children),this.renderPopover())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:1,className:'icon-container'},this.renderIcon()));}else{return null;}}}]);return InputWithPopover;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InputWithPopover.propTypes={id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,editMode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,oldValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),oldValueText:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,newValueText:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,proposedValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),proposedValueText:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,message:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,popoverPlacement:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,componentProps:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onChangeProposedValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onChangeMessage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onChangeToggle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (InputWithPopover);

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ValidateAccreditationModal__ = __webpack_require__(812);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_10" /* MODAL_VALIDATE_ACCREDITATION */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__ValidateAccreditationModal__["a" /* default */]));

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ValidateAccreditationModal_css__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ValidateAccreditationModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ValidateAccreditationModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ValidateAccreditationModal=function(_Component){_inherits(ValidateAccreditationModal,_Component);function ValidateAccreditationModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ValidateAccreditationModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ValidateAccreditationModal.__proto__||Object.getPrototypeOf(ValidateAccreditationModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleValidate=function(e){e.preventDefault();_this.props.onValidateAccreditation();_this.props.onCancel();},_this.handleCancel=function(){_this.props.onCancel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ValidateAccreditationModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'validate-accreditation-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],{className:'validate-accreditation-modal-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{className:'validate-accreditation-modal-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'validate_accreditation.validate_accreditation_message')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{className:'validate-accreditation-modal-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleValidate},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'validate_accreditation.submit_button_validate'))))));}}]);return ValidateAccreditationModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ValidateAccreditationModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onValidateAccreditation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ValidateAccreditationModal);

/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReviewAccreditation__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_levels__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_titleLangs__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_accreditation_certificate__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_organization_organization__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{id:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["A" /* getCurrentAccreditationId */])(state),groupId:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["z" /* getCurrentAccreditationGroupId */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["K" /* loadingAccreditationList */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["r" /* getAccreditationDataFormatted */])(state),answer:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["q" /* getAccreditationAnswer */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["e" /* getCountriesData */])(state),additionalLangs:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_titleLangs__["c" /* getOptionalTitleLangsData */])(state),levels:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_levels__["c" /* getLevelsData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["e" /* getTranslation */])(state),massageLabelPath:'review_accreditation.feedback_from_validator_label',signingKey:Object(__WEBPACK_IMPORTED_MODULE_9__reducers_accreditation_certificate__["d" /* getKey */])(state),signingKeyLoading:Object(__WEBPACK_IMPORTED_MODULE_9__reducers_accreditation_certificate__["e" /* getKeyLoading */])(state),isSigningRequired:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_organization_organization__["v" /* isAccreditationSigningRequired */])(state),orgLoading:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_organization_organization__["y" /* loadingOrg */])(state),isBava:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_organization_organization__["w" /* isOrgBava */])(state),loadingManagedOrgs:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["L" /* loadingManagedOrgs */])(state),managedOrgs:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["E" /* getManagedOrgsOptions */])(state),locationData:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["g" /* getLocationData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSubmit:function onSubmit(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["o" /* fetchReviewAccreditation */])(id,data));},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},setContinentByCountry:function setContinentByCountry(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["i" /* setCurrentContinentByCountry */])(countryCode));},onGetAdditionalLangs:function onGetAdditionalLangs(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_titleLangs__["b" /* fetchGetTitleLangs */])());},onGetLevels:function onGetLevels(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_levels__["b" /* fetchGetLevels */])());},onRemoveAccreditation:function onRemoveAccreditation(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_6__reducers_common_activeModal__["J" /* MODAL_REMOVE_ACCREDITATION */]}));},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["d" /* cleanValidatedStatus */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["c" /* cleanStartAccreditation */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["g" /* clearManagedOrgs */])());},onNext:function onNext(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["V" /* setNextAsStartAccreditationForReview */])());},onSetSubmitFormLoading:function onSetSubmitFormLoading(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__reducers_common_submitForm__["b" /* fetchSubmitForm */])());},onGetOrganization:function onGetOrganization(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_organization_organization__["d" /* fetchGetOrg */])());},onGetManagedOrgs:function onGetManagedOrgs(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["l" /* fetchGetManagedOrgs */])(countryCode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__ReviewAccreditation__["a" /* default */]));

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveAccreditationModal=function(_Component){_inherits(RemoveAccreditationModal,_Component);function RemoveAccreditationModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveAccreditationModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveAccreditationModal.__proto__||Object.getPrototypeOf(RemoveAccreditationModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleRemove=function(e){e.preventDefault();_this.props.onAccreditationRemove(_this.props.accreditationId||_this.props.data.id);_this.props.onCancel();if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.onCancelRemoving)){_this.props.onCancelRemoving();}},_this.handleCancel=function(){_this.props.onCancel();if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.onCancelRemoving)){_this.props.onCancelRemoving();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveAccreditationModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'accreditation-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation.remove_accreditation_alert')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation.remove_accreditation_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation.remove_accreditation_alert')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_list.title_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_list.date_issued_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_list.level_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'levels.'+this.props.data.level))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_list.applicant_name_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.applicantName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_list.location_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'countries.'+this.props.data.location))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button)))));}}]);return RemoveAccreditationModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveAccreditationModal.propTypes={accreditationId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onAccreditationRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelRemoving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveAccreditationModal);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReviewAccreditation__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_levels__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_titleLangs__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_accreditation_certificate__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_organization_organization__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{id:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["A" /* getCurrentAccreditationId */])(state),groupId:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["z" /* getCurrentAccreditationGroupId */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["K" /* loadingAccreditationList */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["r" /* getAccreditationDataFormatted */])(state),answer:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["q" /* getAccreditationAnswer */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["e" /* getCountriesData */])(state),additionalLangs:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_titleLangs__["c" /* getOptionalTitleLangsData */])(state),levels:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_levels__["c" /* getLevelsData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["e" /* getTranslation */])(state),massageLabelPath:'review_accreditation.feedback_from_applicant_label',signingKey:Object(__WEBPACK_IMPORTED_MODULE_9__reducers_accreditation_certificate__["d" /* getKey */])(state),signingKeyLoading:Object(__WEBPACK_IMPORTED_MODULE_9__reducers_accreditation_certificate__["e" /* getKeyLoading */])(state),isSigningRequired:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_organization_organization__["v" /* isAccreditationSigningRequired */])(state),orgLoading:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_organization_organization__["y" /* loadingOrg */])(state),isBava:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_organization_organization__["w" /* isOrgBava */])(state),loadingManagedOrgs:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["L" /* loadingManagedOrgs */])(state),managedOrgs:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["E" /* getManagedOrgsOptions */])(state),locationData:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["g" /* getLocationData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSubmit:function onSubmit(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["o" /* fetchReviewAccreditation */])(id,data));},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},setContinentByCountry:function setContinentByCountry(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["i" /* setCurrentContinentByCountry */])(countryCode));},onGetAdditionalLangs:function onGetAdditionalLangs(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_titleLangs__["b" /* fetchGetTitleLangs */])());},onGetLevels:function onGetLevels(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_levels__["b" /* fetchGetLevels */])());},onRemoveAccreditation:function onRemoveAccreditation(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_6__reducers_common_activeModal__["J" /* MODAL_REMOVE_ACCREDITATION */]}));},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["d" /* cleanValidatedStatus */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["c" /* cleanStartAccreditation */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["g" /* clearManagedOrgs */])());},onNext:function onNext(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["V" /* setNextAsStartAccreditationForReview */])());},onSetSubmitFormLoading:function onSetSubmitFormLoading(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__reducers_common_submitForm__["b" /* fetchSubmitForm */])());},onGetOrganization:function onGetOrganization(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_organization_organization__["d" /* fetchGetOrg */])());},onGetManagedOrgs:function onGetManagedOrgs(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_accreditation_accreditations__["l" /* fetchGetManagedOrgs */])(countryCode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__ReviewAccreditation__["a" /* default */]));

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccreditationsList__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_location__ = __webpack_require__(21);
var mapStateToProps=function mapStateToProps(state){return{noDataLabelPath:'accreditation_list.no_data_to_validate_message',loading:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["K" /* loadingAccreditationList */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["w" /* getAccreditationsList */])(state),group:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["k" /* getCurrentGroup */])(state),redirectPath:'validate-accreditation',translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state),canRemoveAccreditations:false,isOrgBava:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__["w" /* isOrgBava */])(state),requestsPerCountry:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["x" /* getAccreditationsPerCountryData */])(state),showCountryFilter:true,countryFilter:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["u" /* getAccreditationsCountryFilter */])(state),requestsPerDomain:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["y" /* getAccreditationsPerDomainData */])(state),domainFilter:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["v" /* getAccreditationsDomainFilter */])(state),requestsPerContinent:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["t" /* getAccreditationRequestsPerContinentData */])(state),locationData:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_location__["g" /* getLocationData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onLoadAccreditations:function onLoadAccreditations(groupId,page){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["s" /* getAccreditationForValidation */])(groupId,page));},onStartValidation:function onStartValidation(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["Y" /* setStartAccreditation */])(id));},onLoadARsPerCountry:function onLoadARsPerCountry(groupId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["i" /* fetchGetAccreditationsPerCountryForValidation */])(groupId));},onUpdateCountryFilter:function onUpdateCountryFilter(countryFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["P" /* onUpdateAccreditationsCountryFilterForValidation */])(countryFilter));},onClearCountryFilter:function onClearCountryFilter(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["e" /* clearAccreditationsCountryFilter */])());},onLoadARsPerDomain:function onLoadARsPerDomain(groupId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["M" /* onFetchGetAccreditationsPerDomainForValidation */])(groupId));},onUpdateDomainFilter:function onUpdateDomainFilter(domain){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["S" /* onUpdateAccreditationsDomainFilterForValidation */])(domain));},onClearDomainFilter:function onClearDomainFilter(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["f" /* clearAccreditationsDomainFilter */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AccreditationsList__["a" /* default */]));

/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RejectedAccreditationsManagementComponent__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_accreditations__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_notifications__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_account_role__ = __webpack_require__(20);
var mapStateToProps=function mapStateToProps(state){return{rejectedBy:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_accreditations__["G" /* getRejectedBy */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),notifications:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_notifications__["i" /* getNotificationsData */])(state),groupId:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_role__["k" /* getCurrentGroup */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGetNotifications:function onGetNotifications(groupId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_notifications__["e" /* fetchGetRejectedAccreditationsNotifications */])(groupId));},onChangeRejectedBy:function onChangeRejectedBy(value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_accreditations__["X" /* setRejectedBy */])(value));},onClearCountryFilter:function onClearCountryFilter(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_accreditations__["e" /* clearAccreditationsCountryFilter */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__RejectedAccreditationsManagementComponent__["a" /* default */]));

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RejectedAccreditationsManagementComponent_css__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RejectedAccreditationsManagementComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RejectedAccreditationsManagementComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__accreditationsList_RejectedAccreditationsByValidatorsList_container__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__accreditationsList_RejectedAccreditationsByApplicantsList_container__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_accreditation_accreditations__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_constants__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RejectedAccreditationsManagementComponent=function(_Component){_inherits(RejectedAccreditationsManagementComponent,_Component);function RejectedAccreditationsManagementComponent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RejectedAccreditationsManagementComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RejectedAccreditationsManagementComponent.__proto__||Object.getPrototypeOf(RejectedAccreditationsManagementComponent)).call.apply(_ref,[this].concat(args))),_this),_this.getNotificationLabel=function(type){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.notifications)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.notifications[type])){return null;}return' ('+_this.props.notifications[type]+')';},_this.renderContent=function(){switch(_this.props.rejectedBy){case __WEBPACK_IMPORTED_MODULE_7__reducers_accreditation_accreditations__["b" /* REJECTED_BY_VALIDATORS */]:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__accreditationsList_RejectedAccreditationsByValidatorsList_container__["a" /* default */],null);case __WEBPACK_IMPORTED_MODULE_7__reducers_accreditation_accreditations__["a" /* REJECTED_BY_APPLICANTS */]:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__accreditationsList_RejectedAccreditationsByApplicantsList_container__["a" /* default */],null);default:break;}},_this.handleChangeMode=function(value){return function(){_this.props.onChangeRejectedBy(value);_this.props.onClearCountryFilter();};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RejectedAccreditationsManagementComponent,[{key:'componentDidMount',value:function componentDidMount(){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.groupId)){this.props.onGetNotifications(this.props.groupId);}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(this.props.groupId!==nextProps.groupId){this.props.onGetNotifications(nextProps.groupId);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rejected-accreditations-management-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_list.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rejected-accreditations-management-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rejected-accreditations-mode-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_list.show_accreditations_by_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"rejected-accreditations-mode-icon-container "+(this.props.rejectedBy===__WEBPACK_IMPORTED_MODULE_7__reducers_accreditation_accreditations__["b" /* REJECTED_BY_VALIDATORS */]?" olive-green":""),onClick:this.handleChangeMode(__WEBPACK_IMPORTED_MODULE_7__reducers_accreditation_accreditations__["b" /* REJECTED_BY_VALIDATORS */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'rejected-accreditations-mode-icon',icon:"radio_button_"+(this.props.rejectedBy===__WEBPACK_IMPORTED_MODULE_7__reducers_accreditation_accreditations__["b" /* REJECTED_BY_VALIDATORS */]?"checked":"unchecked"),title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_list.validators_label')}),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_list.validators_label'),this.getNotificationLabel(__WEBPACK_IMPORTED_MODULE_8__constants_constants__["l" /* NOTIFICATION_TYPES */].REJECTED_BY_VALIDATORS_ACCREDITATIONS)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"rejected-accreditations-mode-icon-container"+(this.props.rejectedBy===__WEBPACK_IMPORTED_MODULE_7__reducers_accreditation_accreditations__["a" /* REJECTED_BY_APPLICANTS */]?" olive-green":""),onClick:this.handleChangeMode(__WEBPACK_IMPORTED_MODULE_7__reducers_accreditation_accreditations__["a" /* REJECTED_BY_APPLICANTS */])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'rejected-accreditations-mode-icon',icon:"radio_button_"+(this.props.rejectedBy===__WEBPACK_IMPORTED_MODULE_7__reducers_accreditation_accreditations__["a" /* REJECTED_BY_APPLICANTS */]?"checked":"unchecked"),title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_list.applicants_label')}),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_list.applicants_label'),this.getNotificationLabel(__WEBPACK_IMPORTED_MODULE_8__constants_constants__["l" /* NOTIFICATION_TYPES */].REJECTED_BY_APPLICANTS_ACCREDITATIONS))),this.renderContent());}}]);return RejectedAccreditationsManagementComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RejectedAccreditationsManagementComponent.propTypes={rejectedBy:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,notifications:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,groupId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onChangeRejectedBy:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onGetNotifications:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onClearCountryFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RejectedAccreditationsManagementComponent);

/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccreditationsList__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_organization_organization__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_location__ = __webpack_require__(21);
var mapStateToProps=function mapStateToProps(state){return{noDataLabelPath:'accreditation_list.no_data_to_review_message',showHeader:false,loading:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["K" /* loadingAccreditationList */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["w" /* getAccreditationsList */])(state),group:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["k" /* getCurrentGroup */])(state),redirectPath:'review-accreditation/validator',translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state),canRemoveAccreditations:true,groupsNumber:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["q" /* getGroupsNumberForSubRole */])(state),isOrgBava:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_organization_organization__["w" /* isOrgBava */])(state),requestsPerCountry:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["x" /* getAccreditationsPerCountryData */])(state),showCountryFilter:true,countryFilter:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["u" /* getAccreditationsCountryFilter */])(state),requestsPerDomain:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["y" /* getAccreditationsPerDomainData */])(state),domainFilter:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["v" /* getAccreditationsDomainFilter */])(state),requestsPerContinent:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["t" /* getAccreditationRequestsPerContinentData */])(state),locationData:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_location__["g" /* getLocationData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onLoadAccreditations:function onLoadAccreditations(group,page){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["I" /* getRejectedByValidatorsAccreditations */])(group,page));},onStartValidation:function onStartValidation(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["Y" /* setStartAccreditation */])(id));},onRemoveAccreditation:function onRemoveAccreditation(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["J" /* MODAL_REMOVE_ACCREDITATION */]}));},onLoadARsPerCountry:function onLoadARsPerCountry(groupId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["k" /* fetchGetAccreditationsPerCountryRejectedByValidators */])(groupId));},onUpdateCountryFilter:function onUpdateCountryFilter(countryFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["R" /* onUpdateAccreditationsCountryFilterRejectedByValidators */])(countryFilter));},onClearCountryFilter:function onClearCountryFilter(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["e" /* clearAccreditationsCountryFilter */])());},onLoadARsPerDomain:function onLoadARsPerDomain(groupId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["O" /* onFetchGetAccreditationsPerDomainRejectedByValidators */])(groupId));},onUpdateDomainFilter:function onUpdateDomainFilter(domain){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["U" /* onUpdateAccreditationsDomainFilterRejectedByValidators */])(domain));},onClearDomainFilter:function onClearDomainFilter(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["f" /* clearAccreditationsDomainFilter */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AccreditationsList__["a" /* default */]));

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccreditationsList__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_organization_organization__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_location__ = __webpack_require__(21);
var mapStateToProps=function mapStateToProps(state){return{noDataLabelPath:'accreditation_list.no_data_to_review_message',showHeader:false,loading:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["K" /* loadingAccreditationList */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["w" /* getAccreditationsList */])(state),group:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["k" /* getCurrentGroup */])(state),redirectPath:'review-accreditation/applicant',translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state),canRemoveAccreditations:true,groupsNumber:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["q" /* getGroupsNumberForSubRole */])(state),isOrgBava:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_organization_organization__["w" /* isOrgBava */])(state),requestsPerCountry:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["x" /* getAccreditationsPerCountryData */])(state),showCountryFilter:true,countryFilter:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["u" /* getAccreditationsCountryFilter */])(state),requestsPerDomain:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["y" /* getAccreditationsPerDomainData */])(state),domainFilter:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["v" /* getAccreditationsDomainFilter */])(state),requestsPerContinent:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["t" /* getAccreditationRequestsPerContinentData */])(state),locationData:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_location__["g" /* getLocationData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onLoadAccreditations:function onLoadAccreditations(group,page){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["H" /* getRejectedByApplicantsAccreditations */])(group,page));},onStartValidation:function onStartValidation(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["Y" /* setStartAccreditation */])(id));},onRemoveAccreditation:function onRemoveAccreditation(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["J" /* MODAL_REMOVE_ACCREDITATION */]}));},onLoadARsPerCountry:function onLoadARsPerCountry(groupId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["j" /* fetchGetAccreditationsPerCountryRejectedByApplicants */])(groupId));},onUpdateCountryFilter:function onUpdateCountryFilter(countryFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["Q" /* onUpdateAccreditationsCountryFilterRejectedByApplicants */])(countryFilter));},onClearCountryFilter:function onClearCountryFilter(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["e" /* clearAccreditationsCountryFilter */])());},onLoadARsPerDomain:function onLoadARsPerDomain(groupId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["N" /* onFetchGetAccreditationsPerDomainRejectedByApplicants */])(groupId));},onUpdateDomainFilter:function onUpdateDomainFilter(domain){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["T" /* onUpdateAccreditationsDomainFilterRejectedByApplicants */])(domain));},onClearDomainFilter:function onClearDomainFilter(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_accreditations__["f" /* clearAccreditationsDomainFilter */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AccreditationsList__["a" /* default */]));

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccreditationGroupsList_css__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccreditationGroupsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AccreditationGroupsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccreditationGroupModal_CreateAccreditationGroupModal_CreateAccreditationGroupModal_container__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AccreditationGroupModal_RemoveAccreditationGroupModal_RemoveAccreditationGroupModal_container__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_paginationComponent_PaginationAccreditationGroups_container__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_utils__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SUCCESS_MESSAGE_BY_ACTION={ADD:'org_staff.accreditation_groups.create_accreditation_group_success_message',REMOVE:'org_staff.accreditation_groups.remove_group_success_message'};var AccreditationGroupsList=function(_Component){_inherits(AccreditationGroupsList,_Component);function AccreditationGroupsList(props){_classCallCheck(this,AccreditationGroupsList);var _this=_possibleConstructorReturn(this,(AccreditationGroupsList.__proto__||Object.getPrototypeOf(AccreditationGroupsList)).call(this,props));_this.renderHint=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-groups-list-placeholder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-groups-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'org_staff.accreditation_groups.no_data_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'org_staff.accreditation_groups.accreditation_groups_definition_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].examples_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'org_staff.accreditation_groups.accreditation_group_examples_label').split(';'),function(example,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'example'+index},example);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'org_staff.accreditation_groups.different_from_departments_label')+" "),'-',__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(" "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'org_staff.departments.departments_definition_label_uni'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].examples_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'org_staff.departments.departments_examples_label').split(';'),function(example,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'example'+index},example);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(" "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'org_staff.departments.departments_definition_label_part_2'))));};_this.handleAddButtonClick=function(){_this.props.onAddButtonClick();_this.props.setSuccessMessage(SUCCESS_MESSAGE_BY_ACTION.ADD);};_this.handleTableRowClick=function(id){return function(){_this.props.onAccreditationGroupSelect(id);_this.setState({groupIsSelected:true});};};_this.handleRemoveAccreditationGroup=function(group){return function(){_this.props.onAccreditationGroupRemove();_this.props.setSuccessMessage(SUCCESS_MESSAGE_BY_ACTION.REMOVE);_this.setState({groupToRemove:group});};};_this.handleCancelRemoving=function(){_this.setState({groupToRemove:null});};_this.state={groupToRemove:null,groupIsSelected:false};return _this;}_createClass(AccreditationGroupsList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-groups-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.table_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-groups-list-hint-container',hidden:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.data)||this.props.data.length===0},__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'accreditation_requests.accreditation_group_hint'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-groups-list-hint-container',hidden:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.data)||this.props.data.length===0||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.every(this.props.data,function(el){return el.inserterCount>0&&el.validatorCount>0;})},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.no_staff_assigned_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-accreditation-group-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{className:'add-accreditation-group-button olive-green-btn',onClick:this.handleAddButtonClick},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].add_button))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_paginationComponent_PaginationAccreditationGroups_container__["a" /* default */],null),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__AccreditationGroupModal_CreateAccreditationGroupModal_CreateAccreditationGroupModal_container__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__AccreditationGroupModal_RemoveAccreditationGroupModal_RemoveAccreditationGroupModal_container__["a" /* default */],{data:this.state.groupToRemove,onCancelRemoving:this.handleCancelRemoving}),this.state.groupIsSelected&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.groupId)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Redirect */],{to:'/accreditation-group?id='+this.props.groupId,push:true}):null);}},{key:'renderContent',value:function renderContent(){if(this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-groups-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.data)||this.props.data.length===0){return this.renderHint();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["N" /* Table */],{className:'accreditation-groups-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.accreditation_group_name_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.inserters_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.validators_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.renderAccreditationGroupData()));}},{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'renderAccreditationGroupData',value:function renderAccreditationGroupData(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.props.data,function(accreditationGroup,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index,className:'accreditation-groups-table-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'accreditation-group-name-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'org_staff.accreditation_groups.accreditation_group_name_label')+":",onClick:_this2.handleTableRowClick(accreditationGroup.id)},accreditationGroup.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:"accreditation-group-inserters-td "+(accreditationGroup.inserterCount===0?'empty':''),title:accreditationGroup.inserterCount===0?__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'org_staff.accreditation_groups.no_inserters_label'):'','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'org_staff.accreditation_groups.inserters_label')+":",onClick:_this2.handleTableRowClick(accreditationGroup.id)},accreditationGroup.inserterCount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:"accreditation-group-validators-td "+(accreditationGroup.validatorCount===0?'empty':''),title:accreditationGroup.validatorCount===0?__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'org_staff.accreditation_groups.no_validators_label'):'','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'org_staff.accreditation_groups.validators_label')+":",onClick:_this2.handleTableRowClick(accreditationGroup.id)},accreditationGroup.validatorCount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'control-cell create-group-icon-td',onClick:_this2.handleTableRowClick(accreditationGroup.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:index,icon:'create',className:'create-group-icon',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].edit_button)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'control-cell remove-group-icon-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:index,icon:'trash',className:'remove-group-icon',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button),onClick:_this2.handleRemoveAccreditationGroup(accreditationGroup)})));});}}]);return AccreditationGroupsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AccreditationGroupsList.propTypes={data:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,loading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,onAddButtonClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onMount:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onAccreditationGroupSelect:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onAccreditationGroupRemove:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,setSuccessMessage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AccreditationGroupsList);

/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreateAccreditationGroupModal__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_accreditationGroups__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_organization_organization__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["e" /* MODAL_ADD_ACCREDITATION_GROUP */],translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state),isOrgValidated:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_organization_organization__["x" /* isOrganizationValidated */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAccreditationGroupCreate:function onAccreditationGroupCreate(accreditationGroupData){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_accreditationGroups__["c" /* fetchRegisterAccreditationGroup */])(accreditationGroupData));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__CreateAccreditationGroupModal__["a" /* default */]));

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateAccreditationGroupModal=function(_Component){_inherits(CreateAccreditationGroupModal,_Component);function CreateAccreditationGroupModal(props){_classCallCheck(this,CreateAccreditationGroupModal);var _this=_possibleConstructorReturn(this,(CreateAccreditationGroupModal.__proto__||Object.getPrototypeOf(CreateAccreditationGroupModal)).call(this,props));_this.handleChange=function(inputName){return function(e){_this.setState(_defineProperty({},inputName,e.target.value));};};_this.handleSubmit=function(e){e.preventDefault();var data={name:_this.state.accreditationGroupName};_this.props.onAccreditationGroupCreate(data);};_this.state={accreditationGroupName:''};return _this;}_createClass(CreateAccreditationGroupModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'accreditation-group-modal',isOpen:this.props.isOpen,toggle:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.props.isOrgValidated?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'warning'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'main.non_validated_org_access_label')),this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3,className:'modal-label-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.accreditation_group_name_label')+'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'text',placeholder:''+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.accreditation_group_name_label'),required:true,onChange:this.handleChange('accreditationGroupName')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit',disabled:!this.props.isOrgValidated},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.create_accreditation_group_button'))));}}]);return CreateAccreditationGroupModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CreateAccreditationGroupModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,isOrgValidated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onAccreditationGroupCreate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (CreateAccreditationGroupModal);

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveAccreditationGroupModal__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_organization_accreditationGroups__ = __webpack_require__(82);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["K" /* MODAL_REMOVE_ACCREDITATION_GROUP */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGroupRemove:function onGroupRemove(groupId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_organization_accreditationGroups__["d" /* fetchRemoveAccreditationGroup */])(groupId));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RemoveAccreditationGroupModal__["a" /* default */]));

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveAccreditationGroupModal=function(_Component){_inherits(RemoveAccreditationGroupModal,_Component);function RemoveAccreditationGroupModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveAccreditationGroupModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveAccreditationGroupModal.__proto__||Object.getPrototypeOf(RemoveAccreditationGroupModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleRemove=function(e){e.preventDefault();_this.props.onGroupRemove(_this.props.data.id);},_this.handleCancel=function(){_this.props.onCancel();_this.props.onCancelRemoving();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveAccreditationGroupModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'accreditation-group-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.remove_group_alert')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.accreditation_group_name_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))));}}]);return RemoveAccreditationGroupModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveAccreditationGroupModal.propTypes={groupId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onGroupRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelRemoving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveAccreditationGroupModal);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_organization_accreditationGroups__ = __webpack_require__(82);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_accreditationGroups__["g" /* getCurrentPageForAccreditationGroups */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_accreditationGroups__["h" /* getTotalPagesForAccreditationGroups */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_accreditationGroups__["b" /* fetchGetAccreditationGroups */])(page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccreditationGroupDetails__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_organization_accreditationGroup__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_organization_staffMembers__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils__ = __webpack_require__(12);
var mapStateToProps=function mapStateToProps(state,_ref){var location=_ref.location;var pathId=__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search).id;return{id:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_accreditationGroup__["g" /* getAccreditationGroupId */])(state),pathId:pathId,data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_accreditationGroup__["f" /* getAccreditationGroupData */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_accreditationGroup__["j" /* loadingAccreditationGroup */])(state),fetchingError:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_accreditationGroup__["i" /* getFetchingErrorAccreditationGroup */])(state),employees:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_staffMembers__["f" /* getAllActiveStaffMembers */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_accreditationGroup__["d" /* fetchGetAccreditationGroupData */])(id));},onEmployeesLoad:function onEmployeesLoad(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_staffMembers__["c" /* fetchGetAllStaffMembers */])());},onAccreditationGroupSet:function onAccreditationGroupSet(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_accreditationGroup__["l" /* setAccreditationGroupId */])(id));},onEditAccreditationGroup:function onEditAccreditationGroup(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["z" /* MODAL_EDIT_ACCREDITATION_GROUP */]}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onAddEmployeeToGroup:function onAddEmployeeToGroup(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["i" /* MODAL_ADD_EMPLOYEE_TO_ACCREDITATION_GROUP */]}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onRemoveEmployeeFromGroup:function onRemoveEmployeeFromGroup(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["X" /* MODAL_REMOVE_EMPLOYEE_FROM_ACCREDITATION_GROUP */]}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_accreditationGroup__["l" /* setAccreditationGroupId */])(null));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_accreditationGroup__["k" /* resetAccreditationGroupData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AccreditationGroupDetails__["a" /* default */]));

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccreditationGroupDetails_css__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccreditationGroupDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AccreditationGroupDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccreditationGroupModal_RemoveEmployeeFromGroupModal_RemoveEmployeeFromGroupModal_container__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AccreditationGroupModal_AddEmployeeToGroupModal_AddEmployeeToGroupModal_container__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AccreditationGroupModal_editAccreditationGroupModal_EditAccreditationGroupModal_container__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_pageNotFoundComponent_PageNotFoundComponent_container__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SUCCESS_MESSAGE_BY_ACTION={ADD_STAFF:'org_staff.accreditation_groups.add_employee_to_group_success_message',REMOVE_STAFF:'org_staff.accreditation_groups.remove_employee_from_group_success_message',EDIT:'org_staff.accreditation_groups.edit_accreditation_group_success_message'};var AccreditationGroupDetails=function(_Component){_inherits(AccreditationGroupDetails,_Component);function AccreditationGroupDetails(props){_classCallCheck(this,AccreditationGroupDetails);var _this=_possibleConstructorReturn(this,(AccreditationGroupDetails.__proto__||Object.getPrototypeOf(AccreditationGroupDetails)).call(this,props));_this.renderHeader=function(){if(!_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-group-details-name-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accreditation-group-name-container'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].name_label),': '),_this.props.data.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'create',className:'edit-accreditation-group-icon',onClick:_this.handleEditAccreditationGroup,title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].edit_button)}));}};_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-group-employees-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(_this.props.data)||_this.props.data.inserters.length===0&&_this.props.data.validators.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-group-employees-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'org_staff.accreditation_groups.accreditation_group_no_data_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["N" /* Table */],{className:'accreditation-group-employees-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'org_staff.accreditation_groups.role_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.getEmployeesDataByRole(__WEBPACK_IMPORTED_MODULE_10__reducers_account_role__["c" /* SUB_ROLES */].INSERTER),_this.getEmployeesDataByRole(__WEBPACK_IMPORTED_MODULE_10__reducers_account_role__["c" /* SUB_ROLES */].VALIDATOR)));};_this.renderModals=function(){if(!_this.props.loading){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AccreditationGroupModal_RemoveEmployeeFromGroupModal_RemoveEmployeeFromGroupModal_container__["a" /* default */],{key:'remove-employee-to-group-modal',groupId:_this.props.id,data:_this.state.employeeToRemove,onCancelRemoving:_this.handleCancelRemoving}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__AccreditationGroupModal_AddEmployeeToGroupModal_AddEmployeeToGroupModal_container__["a" /* default */],{key:'add-employee-to-group-modal',groupId:_this.props.id,staffMembersData:_this.getAvailableEmployees()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__AccreditationGroupModal_editAccreditationGroupModal_EditAccreditationGroupModal_container__["a" /* default */],{key:'edit-accreditation-group-modal'})];}};_this.getAvailableEmployees=function(){var employeesInPairsIds=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.concat(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(_this.props.data.inserters,function(inserter){return inserter.id;}),__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(_this.props.data.validators,function(validator){return validator.id;}));return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(_this.props.employees,function(employee){return!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.includes(employeesInPairsIds,employee.id);});};_this.getEmployeesDataByRole=function(role){var employees=role===__WEBPACK_IMPORTED_MODULE_10__reducers_account_role__["c" /* SUB_ROLES */].INSERTER?_this.props.data.inserters:_this.props.data.validators;return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(employees,function(employee){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:employee.id,className:'accreditation-group-employees-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'first-name-td','data-th':__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)+":"},employee.identityAlias.firstName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'last-name-td','data-th':__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)+":"},employee.identityAlias.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'email-td','data-th':__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+":"},employee.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'role-td','data-th':__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'org_staff.accreditation_groups.role_label')+":"},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'roles.'+__WEBPACK_IMPORTED_MODULE_10__reducers_account_role__["d" /* SUB_ROLES_TRANSLATIONS */][role])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'control-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:employee.id,icon:'trash',className:'remove-from-accreditation-group-icon',title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button),onClick:_this.handleRemoveButtonClick(employee,role)})));});};_this.handleAddButtonClick=function(){_this.props.onAddEmployeeToGroup();_this.props.onEmployeesLoad();_this.setState({successMessage:SUCCESS_MESSAGE_BY_ACTION.ADD_STAFF});};_this.handleRemoveButtonClick=function(employee,role){return function(){_this.setState({employeeToRemove:Object.assign({role:role},employee),successMessage:SUCCESS_MESSAGE_BY_ACTION.REMOVE_STAFF});_this.props.onRemoveEmployeeFromGroup();};};_this.handleCancelRemoving=function(){_this.setState({employeeToRemove:null});};_this.handleEditAccreditationGroup=function(){_this.props.onEditAccreditationGroup();_this.setState({successMessage:SUCCESS_MESSAGE_BY_ACTION.EDIT});};_this.state={role:'',employeeToRemove:null,successMessage:null};return _this;}_createClass(AccreditationGroupDetails,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.id!==this.props.pathId){this.props.onAccreditationGroupSet(this.props.pathId);}if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(this.props.id)){this.props.onMount(this.props.id);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(nextProps.id)&&this.props.id!==nextProps.id){this.props.onMount(nextProps.id);}}},{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(this.props.pathId)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["d" /* Redirect */],{to:'/groups-management',push:true});}if(this.props.fetchingError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_pageNotFoundComponent_PageNotFoundComponent_container__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-group-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,this.state.successMessage)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/groups-management',label:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].back_button)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].accreditation_group_label)),this.renderHeader(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-group-employees-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-group-table-label-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'font-weight-bold'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.employees_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'add-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'btn-sm olive-green-btn',onClick:this.handleAddButtonClick},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].add_button)))),this.renderContent()),this.renderModals()));}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}}]);return AccreditationGroupDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AccreditationGroupDetails.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,pathId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,fetchingError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,employees:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onEmployeesLoad:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onEditAccreditationGroup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onAddEmployeeToGroup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onRemoveEmployeeFromGroup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUnmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (AccreditationGroupDetails);

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RemoveEmployeeFromGroupModal__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_accreditationGroup__ = __webpack_require__(83);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["X" /* MODAL_REMOVE_EMPLOYEE_FROM_ACCREDITATION_GROUP */],translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onEmployeeRemoveFromGroup:function onEmployeeRemoveFromGroup(groupId,employeeId,role){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_accreditationGroup__["e" /* fetchRemoveEmployeeFromAccreditationGroup */])(groupId,employeeId,role));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__RemoveEmployeeFromGroupModal__["a" /* default */]));

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_account_role__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveEmployeeFromGroupModal=function(_Component){_inherits(RemoveEmployeeFromGroupModal,_Component);function RemoveEmployeeFromGroupModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveEmployeeFromGroupModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveEmployeeFromGroupModal.__proto__||Object.getPrototypeOf(RemoveEmployeeFromGroupModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleSubmit=function(e){e.preventDefault();_this.props.onEmployeeRemoveFromGroup(_this.props.groupId,_this.props.data.id,_this.props.data.role);},_this.handleCancel=function(){_this.props.onCancel();_this.props.onCancelRemoving();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveEmployeeFromGroupModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'accreditation-group-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.remove_employee_from_group_alert')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.role_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'roles.'+__WEBPACK_IMPORTED_MODULE_5__reducers_account_role__["d" /* SUB_ROLES_TRANSLATIONS */][this.props.data.role]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.identityAlias.firstName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.identityAlias.lastName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].email_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.email)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))));}}]);return RemoveEmployeeFromGroupModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveEmployeeFromGroupModal.propTypes={groupId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onEmployeeRemoveFromGroup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelRemoving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveEmployeeFromGroupModal);

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddEmployeeToGroupModal__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_accreditationGroup__ = __webpack_require__(83);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["i" /* MODAL_ADD_EMPLOYEE_TO_ACCREDITATION_GROUP */],translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onEmployeeAddToGroup:function onEmployeeAddToGroup(groupId,employeeId,role){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_accreditationGroup__["b" /* fetchAddEmployeeToAccreditationGroup */])(groupId,employeeId,role));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__AddEmployeeToGroupModal__["a" /* default */]));

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_selectWithSearch_SelectWithSearch__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AVAILABLE_ROLES=[__WEBPACK_IMPORTED_MODULE_5__reducers_account_role__["c" /* SUB_ROLES */].INSERTER,__WEBPACK_IMPORTED_MODULE_5__reducers_account_role__["c" /* SUB_ROLES */].VALIDATOR];var AddEmployeeToGroupModal=function(_Component){_inherits(AddEmployeeToGroupModal,_Component);function AddEmployeeToGroupModal(props){_classCallCheck(this,AddEmployeeToGroupModal);var _this=_possibleConstructorReturn(this,(AddEmployeeToGroupModal.__proto__||Object.getPrototypeOf(AddEmployeeToGroupModal)).call(this,props));_this.handleChangeEmployeeId=function(value){_this.setState({employeeId:value});};_this.handleChange=function(fieldName){return function(selectedOption){_this.setState(_defineProperty({},fieldName,selectedOption.value));};};_this.getEmployeesOptions=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_this.props.staffMembersData,function(employee){return{value:employee.id,label:employee.firstName+' '+employee.lastName+' ('+employee.email+')'};});};_this.getRolesOptions=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(AVAILABLE_ROLES,function(role){return{value:role,label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'roles.'+__WEBPACK_IMPORTED_MODULE_5__reducers_account_role__["d" /* SUB_ROLES_TRANSLATIONS */][role])};});};_this.handleCancel=function(e){e.preventDefault();_this.cleanState();_this.props.onCancel();};_this.handleSubmit=function(e){e.preventDefault();_this.props.onEmployeeAddToGroup(_this.props.groupId,_this.state.employeeId,_this.state.role);_this.cleanState();};_this.cleanState=function(){_this.setState({employeeId:null,role:''});};_this.state={employeeId:null,role:''};return _this;}_createClass(AddEmployeeToGroupModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'accreditation-group-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'grey',marginBottom:'20px'}},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.digital_key_hint')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:3},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.role_label')+'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:'employee-role-select',selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.getRolesOptions(),function(role){return role.value===_this2.state.role;}),options:this.getRolesOptions(),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.role_input_placeholder'),onSelect:this.handleChange('role'),isSearchable:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:3},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.employee_label')+'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_selectWithSearch_SelectWithSearch__["a" /* default */],{value:this.state.employeeId,onChange:this.handleChangeEmployeeId,options:this.getEmployeesOptions(),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.employee_input_placeholder')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',type:'submit',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit',disabled:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.state.employeeId)||this.state.role===''},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].add_button))));}}]);return AddEmployeeToGroupModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AddEmployeeToGroupModal.propTypes={groupId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,staffMembersData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onEmployeeAddToGroup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (AddEmployeeToGroupModal);

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditAccreditationGroupModal__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_accreditationGroup__ = __webpack_require__(83);
var mapStateToProps=function mapStateToProps(state){return{groupId:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_accreditationGroup__["g" /* getAccreditationGroupId */])(state),groupName:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_accreditationGroup__["h" /* getAccreditationGroupName */])(state),isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["z" /* MODAL_EDIT_ACCREDITATION_GROUP */],translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAccreditationGroupEdit:function onAccreditationGroupEdit(groupId,accreditationGroupData){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_accreditationGroup__["c" /* fetchEditAccreditationGroup */])(groupId,accreditationGroupData));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__EditAccreditationGroupModal__["a" /* default */]));

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditAccreditationGroupModal=function(_Component){_inherits(EditAccreditationGroupModal,_Component);function EditAccreditationGroupModal(props){_classCallCheck(this,EditAccreditationGroupModal);var _this=_possibleConstructorReturn(this,(EditAccreditationGroupModal.__proto__||Object.getPrototypeOf(EditAccreditationGroupModal)).call(this,props));_this.saveButtonDisabled=function(){return _this.props.groupName===_this.state.accreditationGroupName;};_this.handleChange=function(inputName){return function(e){_this.setState(_defineProperty({},inputName,e.target.value));};};_this.handleSubmit=function(e){e.preventDefault();var data={name:_this.state.accreditationGroupName};_this.props.onAccreditationGroupEdit(_this.props.groupId,data);};_this.state={accreditationGroupName:_this.props.groupName};return _this;}_createClass(EditAccreditationGroupModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.groupId)&&this.props.groupId!==nextProps.groupId){this.setState({accreditationGroupName:nextProps.groupName});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'accreditation-group-modal',isOpen:this.props.isOpen,toggle:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3,className:'modal-label-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.accreditation_group_name_label')+'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{value:this.state.accreditationGroupName,type:'text',placeholder:''+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.accreditation_groups.accreditation_group_name_label'),required:true,onChange:this.handleChange('accreditationGroupName')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit',disabled:this.saveButtonDisabled()},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button))));}}]);return EditAccreditationGroupModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EditAccreditationGroupModal.propTypes={groupId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,groupName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onAccreditationGroupEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (EditAccreditationGroupModal);

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BulkJobsList__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_bulk__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_accreditation_certificate__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_organization_organization__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_bulk__["e" /* loadingBulkJobs */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_bulk__["c" /* getBulkJobsFormattedData */])(state),group:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["k" /* getCurrentGroup */])(state),signingKey:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_accreditation_certificate__["d" /* getKey */])(state),signingKeyLoading:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_accreditation_certificate__["e" /* getKeyLoading */])(state),isSigningRequired:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_organization_organization__["v" /* isAccreditationSigningRequired */])(state),orgLoading:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_organization_organization__["y" /* loadingOrg */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onLoadJobs:function onLoadJobs(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_bulk__["d" /* getJobs */])());},onRemoveBulk:function onRemoveBulk(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["Q" /* MODAL_REMOVE_BULK */]}));},onCancelRemoving:function onCancelRemoving(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_16" /* hideModal */])());},onGetOrganization:function onGetOrganization(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_organization_organization__["d" /* fetchGetOrg */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__BulkJobsList__["a" /* default */]));

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_bulkDropZone_BulkDropZone_container__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BulkJobsList_css__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BulkJobsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BulkJobsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bulkModal_removeBulkModal_RemoveBulkModal_container__ = __webpack_require__(872);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BulkJobsList=function(_Component){_inherits(BulkJobsList,_Component);function BulkJobsList(props){_classCallCheck(this,BulkJobsList);var _this=_possibleConstructorReturn(this,(BulkJobsList.__proto__||Object.getPrototypeOf(BulkJobsList)).call(this,props));_this.getStatus=function(jobData){var className=void 0;var labelPath=void 0;if(jobData.finished){if(jobData.globalError){className='error-label';labelPath='bulk_jobs_list.error_label';}else{className='finished-label';labelPath='bulk_jobs_list.finished_label';}}else{className='in-progress-label';labelPath='bulk_jobs_list.in_progress_label';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:className},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,labelPath));};_this.getTitle=function(jobData){return jobData.globalError?__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'bulk_jobs_list.global_error_label'):jobData.errors.join('.\n');};_this.handleRemoveBulk=function(bulkData){return function(){_this.props.onRemoveBulk();_this.setState({bulkToRemove:bulkData});};};_this.state={redirect:false,bulkToRemove:null};return _this;}_createClass(BulkJobsList,[{key:'render',value:function render(){if(this.props.signingKeyLoading||this.props.orgLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-jobs-list-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(this.props.isSigningRequired&&__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(this.props.signingKey)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'bulk_jobs_list.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'carrot-red'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,"insert_accreditation.no_certificate_message_start"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/security'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,"insert_accreditation.no_certificate_message_link")),__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,"insert_accreditation.no_certificate_message_end")));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-jobs-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'bulk_jobs_list.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_bulkDropZone_BulkDropZone_container__["a" /* default */],null),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__bulkModal_removeBulkModal_RemoveBulkModal_container__["a" /* default */],{data:this.state.bulkToRemove,onCancelRemoving:this.props.onCancelRemoving}));}},{key:'renderContent',value:function renderContent(){if(this.props.loading&&(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(this.props.data)||__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(this.props.data))){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-jobs-list-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(this.props.data)||__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-jobs-list-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'bulk_jobs_list.no_data_message')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["N" /* Table */],{className:'jobs-data-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'bulk_jobs_list.file_name_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'bulk_jobs_list.created_at_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'bulk_jobs_list.processed_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'bulk_jobs_list.status_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.renderJobsData()));}},{key:'renderJobsData',value:function renderJobsData(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(this.props.data,function(jobData){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:jobData.id,className:'jobs-data-row '+(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(jobData.errors)||jobData.globalError?'has-errors':''),title:_this2.getTitle(jobData)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'file-name-td','data-th':__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this2.props.translation,'bulk_jobs_list.file_name_label')+":"},jobData.fileName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'created-at-td','data-th':__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this2.props.translation,'bulk_jobs_list.created_at_label')+":"},jobData.createdAt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'processed-td','data-th':__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this2.props.translation,'bulk_jobs_list.processed_label')+":"},jobData.processedPersent,'% (',jobData.processedEntriesCount,'/',jobData.totalEntriesCount,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'status-td','data-th':__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this2.props.translation,'bulk_jobs_list.status_label')+":"},_this2.getStatus(jobData)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'control-cell bulk-controls'},jobData.finished?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'job-remove-icon',icon:'trash',title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this2.props.translation,'bulk_jobs_list.remove_bulk_button'),onClick:_this2.handleRemoveBulk(jobData)}):null));});}},{key:'componentDidMount',value:function componentDidMount(){this.props.onLoadJobs();this.props.onGetOrganization();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.fetchJobsListTimeout(nextProps.data);}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(nextProps.group)&&nextProps.group!==this.props.group){this.props.onLoadJobs();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.timeout){clearTimeout(this.timeout);}}},{key:'fetchJobsListTimeout',value:function fetchJobsListTimeout(jobsData){var _this3=this;if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(jobsData)&&__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.some(jobsData,function(job){return!job.finished;})&&__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(this.timeout)){this.timeout=setTimeout(function(){_this3.props.onLoadJobs();_this3.timeout=null;},5000);}}}]);return BulkJobsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BulkJobsList.propTypes={loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,signingKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,signingKeyLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isSigningRequired:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onLoadJobs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onRemoveBulk:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelRemoving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (BulkJobsList);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BulkDropZone__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_bulk__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_certificate__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),signingKey:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_certificate__["d" /* getKey */])(state),isSigningRequired:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__["v" /* isAccreditationSigningRequired */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onUploadBulkAccreditationsAsFile:function onUploadBulkAccreditationsAsFile(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_bulk__["f" /* uploadBulkAccreditationsAsFile */])(data));},onUploadBulkAccreditationsAsJSON:function onUploadBulkAccreditationsAsJSON(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_bulk__["g" /* uploadBulkAccreditationsAsJSON */])(data));},onSetLoading:function onSetLoading(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["b" /* fetchSubmitForm */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__["_6" /* MODAL_SIGNING_ACCREDITATIONS_PROGRESS */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__BulkDropZone__["a" /* default */]));

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BulkDropZone_css__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BulkDropZone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BulkDropZone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dropzone__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_papaparse__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_cryptoUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_xml_js__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_xml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_xml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__signingProgressModal_SigningProgressModal_container__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_utils__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MAX_FILE_SIZE='20 MB';var CSV_FILE="CSV_FILE";var XML_FILE="XML_FILE";var BulkDropZone=function(_Component){_inherits(BulkDropZone,_Component);function BulkDropZone(props){_classCallCheck(this,BulkDropZone);var _this=_possibleConstructorReturn(this,(BulkDropZone.__proto__||Object.getPrototypeOf(BulkDropZone)).call(this,props));_this.formatIsCorrect=function(file){return file.name.endsWith('.csv')||file.name.endsWith('.xml');};_this.getFileFormat=function(file){if(file.name.endsWith('.xml')){return XML_FILE;}if(file.name.endsWith('.csv')){return CSV_FILE;}};_this.onDragEnter=function(){_this.setState({isEnter:true});_this.cleanState();};_this.onDragLeave=function(){_this.setState({isEnter:false});};_this.onDrop=function(filesArray){_this.setState({isEnter:false});if(filesArray.length!==1){_this.setState({error:true});return;}var file=filesArray[0];if(_this.formatIsCorrect(file)){_this.setState({file:file});if(!_this.props.isSigningRequired){var data=new FormData();data.append('file',file);_this.props.onUploadBulkAccreditationsAsFile(data);}else{_this.onStartParsing();_this.parseFile(file);}}else{_this.setState({error:true});}};_this.onStartParsing=function(){_this.props.onSetLoading();_this.setState({startParsing:true});};_this.onStartSigning=function(amount){_this.setState({startParsing:false,startSigning:true,signed:0,amount:amount});};_this.onFinishSigning=function(){_this.setState({startSigning:false,signed:null,amount:null});_this.count=0;};_this.onSignAccreditation=function(){// TODO: add correct progress showing
if(_this.state.amount<100){_this.setState({signed:_this.state.signed+1});}else{_this.count++;if(_this.count===50||_this.count===_this.state.amount-_this.state.signed){_this.setState({signed:_this.state.signed+_this.count});_this.count=0;}}};_this.parseFile=function(file){var fileFormat=_this.getFileFormat(file);switch(fileFormat){case CSV_FILE:__WEBPACK_IMPORTED_MODULE_8_papaparse___default.a.parse(file,{header:true,skipEmptyLines:true,complete:_this.signCSVAccreditations});break;case XML_FILE:_this.signXMLAccreditations(file);break;default:break;}};_this.signCSVAccreditations=function(result){_this.onStartSigning(result.data?result.data.length:null);var data=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(result.data,function(elem){var titles={};__WEBPACK_IMPORTED_MODULE_10__constants_constants__["v" /* TITLES_LANGS */].forEach(function(lang){if(elem[lang])titles[lang]=elem[lang];});return{email:elem.email,accreditationData:{titles:titles,issuedAt:elem.issuedAt,level:elem.level},verifiedIdentity:{firstName:elem.firstName,lastName:elem.lastName,countryCode:elem.countryCode,nationalId:elem.nationalId}};});var promises=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(data,function(elem){return __WEBPACK_IMPORTED_MODULE_9__utils_cryptoUtils__["a" /* CryptoUtils */].signAccreditation(_this.props.signingKey,elem).then(function(signedElem){_this.onSignAccreditation();return signedElem;});});Promise.all(promises).then(function(results){_this.onFinishSigning();var data={fileName:_this.state.file.name,requests:results};_this.props.onUploadBulkAccreditationsAsJSON(data);});};_this.signXMLAccreditations=function(file){var reader=new FileReader();reader.readAsText(file);reader.onloadend=function(){var result=__WEBPACK_IMPORTED_MODULE_11_xml_js___default.a.xml2js(reader.result,{compact:true,spaces:4,elementNameFn:function elementNameFn(name){return name.slice(name.search(':')+1);}});_this.onStartSigning(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(result,'accreditations.accreditation')?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(result,'accreditations.accreditation').length:null);var data=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(result,'accreditations.accreditation'),function(elem){var titles={};__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(elem,'titles.title'),function(title){titles[__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(title,'_attributes.language')]=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(title,'_text');});return{email:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(elem,'email._text'),accreditationData:{titles:titles,issuedAt:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(elem,'issuedAt._text'),level:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(elem,'level._text')},verifiedIdentity:{firstName:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(elem,'firstName._text'),lastName:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(elem,'lastName._text'),countryCode:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(elem,'countryCode._text'),nationalId:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(elem,'nationalId._text')}};});var promises=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(data,function(elem){return __WEBPACK_IMPORTED_MODULE_9__utils_cryptoUtils__["a" /* CryptoUtils */].signAccreditation(_this.props.signingKey,elem).then(function(signedElem){_this.onSignAccreditation();return signedElem;});});Promise.all(promises).then(function(results){_this.onFinishSigning();var data={fileName:_this.state.file.name,requests:results};_this.props.onUploadBulkAccreditationsAsJSON(data);});};};_this.cleanState=function(){_this.setState({file:null,error:false});};_this.count=0;_this.state={isEnter:false,file:null,error:false,startParsing:false,startSigning:false,amount:null,signed:null};return _this;}_createClass(BulkDropZone,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-drop-zone-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-drop-zone-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.max_file_size_message'),': ',MAX_FILE_SIZE),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["A" /* NavLink */],{tag:__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],to:'/bulk-accreditations-upload/format-details'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.file_format_details_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__formWrapper_FormWrapper_container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_dropzone__["a" /* default */],{className:'bulk-drop-zone',activeClassName:'bulk-drop-zone-active',onDrop:this.onDrop,multiple:false,onDragEnter:this.onDragEnter,onDragLeave:this.onDragLeave,onClick:this.cleanState},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-drop-zone-content-container '+(this.state.isEnter?'bulk-drop-zone-content-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.drag_and_drop_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.or_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_13__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.browse_label'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'bulk-result-label'},this.state.error?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.error_label'):"",!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.state.file)?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.uploaded_file_label')+": "+this.state.file.name:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_reactstrap__["a" /* Alert */],{className:'text-center',color:'warning',hidden:!this.state.startParsing},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_jobs_list.file_reading_process_label'),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_jobs_list.dont_close_tab_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__signingProgressModal_SigningProgressModal_container__["a" /* default */],{startSigning:this.state.startSigning,amount:this.state.amount,signed:this.state.signed}));}}]);return BulkDropZone;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BulkDropZone.propTypes={translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,signingKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,isSigningRequired:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onUploadBulkAccreditationsAsFile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onUploadBulkAccreditationsAsJSON:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onSetLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (BulkDropZone);

/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportMultiple; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDataTransferItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["c"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["e"] = isDragDataWithFiles;
/* unused harmony export isKindFile */
/* harmony export (immutable) */ __webpack_exports__["g"] = onDocumentDragOver;
/* harmony export (immutable) */ __webpack_exports__["f"] = isIeOrEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;

    // NOTE: Only the 'drop' event has access to DataTransfer.files,
    // otherwise it will always be empty
    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }

  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

function isDragDataWithFiles(evt) {
  if (!evt.dataTransfer) {
    return true;
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
  return Array.prototype.every.call(evt.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

function isKindFile(item) {
  return (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null && item.kind === 'file';
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  return isIe(userAgent) || isEdge(userAgent);
}

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=13)}([function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){var r=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=r)},function(t,n,r){t.exports=!r(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(32)("wks"),o=r(9),i=r(0).Symbol,u="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=e},function(t,n,r){var e=r(0),o=r(2),i=r(8),u=r(22),c=r(10),f=function(t,n,r){var a,s,p,l,v=t&f.F,y=t&f.G,h=t&f.S,d=t&f.P,x=t&f.B,g=y?e:h?e[n]||(e[n]={}):(e[n]||{}).prototype,m=y?o:o[n]||(o[n]={}),b=m.prototype||(m.prototype={});y&&(r=n);for(a in r)s=!v&&g&&void 0!==g[a],p=(s?g:r)[a],l=x&&s?c(p,e):d&&"function"==typeof p?c(Function.call,p):p,g&&u(g,a,p,t&f.U),m[a]!=p&&i(m,a,l),d&&b[a]!=p&&(b[a]=p)};e.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,n,r){var e=r(16),o=r(21);t.exports=r(3)?function(t,n,r){return e.f(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(24);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){var e=r(28),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";n.__esModule=!0,n.default=function(t,n){if(t&&n){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):n.endsWith("/*")?i===n.replace(/\/.*$/,""):o===n})}return!0},r(14),r(34)},function(t,n,r){r(15),t.exports=r(2).Array.some},function(t,n,r){"use strict";var e=r(7),o=r(25)(3);e(e.P+e.F*!r(33)([].some,!0),"Array",{some:function(t){return o(this,t,arguments[1])}})},function(t,n,r){var e=r(17),o=r(18),i=r(20),u=Object.defineProperty;n.f=r(3)?Object.defineProperty:function(t,n,r){if(e(t),n=i(n,!0),e(r),o)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t}},function(t,n,r){var e=r(1);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t}},function(t,n,r){t.exports=!r(3)&&!r(4)(function(){return 7!=Object.defineProperty(r(19)("div"),"a",{get:function(){return 7}}).a})},function(t,n,r){var e=r(1),o=r(0).document,i=e(o)&&e(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n,r){var e=r(1);t.exports=function(t,n){if(!e(t))return t;var r,o;if(n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!e(o=r.call(t)))return o;if(!n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(0),o=r(8),i=r(23),u=r(9)("src"),c=Function.toString,f=(""+c).split("toString");r(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,c){var a="function"==typeof r;a&&(i(r,"name")||o(r,"name",n)),t[n]!==r&&(a&&(i(r,u)||o(r,u,t[n]?""+t[n]:f.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:o(t,n,r):(delete t[n],o(t,n,r)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||c.call(this)})},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n)}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n,r){var e=r(10),o=r(26),i=r(27),u=r(12),c=r(29);t.exports=function(t,n){var r=1==t,f=2==t,a=3==t,s=4==t,p=6==t,l=5==t||p,v=n||c;return function(n,c,y){for(var h,d,x=i(n),g=o(x),m=e(c,y,3),b=u(g.length),_=0,w=r?v(n,b):f?v(n,0):void 0;b>_;_++)if((l||_ in g)&&(h=g[_],d=m(h,_,x),t))if(r)w[_]=d;else if(d)switch(t){case 3:return!0;case 5:return h;case 6:return _;case 2:w.push(h)}else if(s)return!1;return p?-1:a||s?s:w}}},function(t,n,r){var e=r(5);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==e(t)?t.split(""):Object(t)}},function(t,n,r){var e=r(11);t.exports=function(t){return Object(e(t))}},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(30);t.exports=function(t,n){return new(e(t))(n)}},function(t,n,r){var e=r(1),o=r(31),i=r(6)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),e(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n}},function(t,n,r){var e=r(5);t.exports=Array.isArray||function(t){return"Array"==e(t)}},function(t,n,r){var e=r(0),o=e["__core-js_shared__"]||(e["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n,r){"use strict";var e=r(4);t.exports=function(t,n){return!!t&&e(function(){n?t.call(null,function(){},1):t.call(null)})}},function(t,n,r){r(35),t.exports=r(2).String.endsWith},function(t,n,r){"use strict";var e=r(7),o=r(12),i=r(36),u="".endsWith;e(e.P+e.F*r(38)("endsWith"),"String",{endsWith:function(t){var n=i(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=o(n.length),c=void 0===r?e:Math.min(o(r),e),f=String(t);return u?u.call(n,f,c):n.slice(c-f.length,c)===f}})},function(t,n,r){var e=r(37),o=r(11);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){var e=r(1),o=r(5),i=r(6)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n,r){var e=r(6)("match");t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return!0}}]);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  active: {
    borderStyle: 'solid',
    backgroundColor: '#eee'
  },
  accepted: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  },
  disabled: {
    opacity: 0.5
  }
});

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* @license
Papa Parse
v4.6.3
https://github.com/mholt/PapaParse
License: MIT
*/
Array.isArray||(Array.isArray=function(e){return"[object Array]"===Object.prototype.toString.call(e)}),function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&"undefined"!=typeof exports?module.exports=t():e.Papa=t()}(this,function(){"use strict";var s,e,f="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==f?f:{},n=!f.document&&!!f.postMessage,o=n&&/(\?|&)papaworker(=|&|$)/.test(f.location.search),a=!1,h={},u=0,k={parse:function(e,t){var r=(t=t||{}).dynamicTyping||!1;z(r)&&(t.dynamicTypingFunction=r,r={});if(t.dynamicTyping=r,t.transform=!!z(t.transform)&&t.transform,t.worker&&k.WORKERS_SUPPORTED){var i=function(){if(!k.WORKERS_SUPPORTED)return!1;if(!a&&null===k.SCRIPT_PATH)throw new Error("Script path cannot be determined automatically when Papa Parse is loaded asynchronously. You need to set Papa.SCRIPT_PATH manually.");var e=k.SCRIPT_PATH||s;e+=(-1!==e.indexOf("?")?"&":"?")+"papaworker";var t=new f.Worker(e);return t.onmessage=m,t.id=u++,h[t.id]=t}();return i.userStep=t.step,i.userChunk=t.chunk,i.userComplete=t.complete,i.userError=t.error,t.step=z(t.step),t.chunk=z(t.chunk),t.complete=z(t.complete),t.error=z(t.error),delete t.worker,void i.postMessage({input:e,config:t,workerId:i.id})}var n=null;k.NODE_STREAM_INPUT,"string"==typeof e?n=t.download?new c(t):new _(t):!0===e.readable&&z(e.read)&&z(e.on)?n=new g(t):(f.File&&e instanceof File||e instanceof Object)&&(n=new p(t));return n.stream(e)},unparse:function(e,t){var i=!1,g=!0,m=",",y="\r\n",n='"',r=!1;!function(){if("object"!=typeof t)return;"string"!=typeof t.delimiter||k.BAD_DELIMITERS.filter(function(e){return-1!==t.delimiter.indexOf(e)}).length||(m=t.delimiter);("boolean"==typeof t.quotes||Array.isArray(t.quotes))&&(i=t.quotes);"boolean"!=typeof t.skipEmptyLines&&"string"!=typeof t.skipEmptyLines||(r=t.skipEmptyLines);"string"==typeof t.newline&&(y=t.newline);"string"==typeof t.quoteChar&&(n=t.quoteChar);"boolean"==typeof t.header&&(g=t.header)}();var s=new RegExp(M(n),"g");"string"==typeof e&&(e=JSON.parse(e));if(Array.isArray(e)){if(!e.length||Array.isArray(e[0]))return o(null,e,r);if("object"==typeof e[0])return o(a(e[0]),e,r)}else if("object"==typeof e)return"string"==typeof e.data&&(e.data=JSON.parse(e.data)),Array.isArray(e.data)&&(e.fields||(e.fields=e.meta&&e.meta.fields),e.fields||(e.fields=Array.isArray(e.data[0])?e.fields:a(e.data[0])),Array.isArray(e.data[0])||"object"==typeof e.data[0]||(e.data=[e.data])),o(e.fields||[],e.data||[],r);throw"exception: Unable to serialize unrecognized input";function a(e){if("object"!=typeof e)return[];var t=[];for(var r in e)t.push(r);return t}function o(e,t,r){var i="";"string"==typeof e&&(e=JSON.parse(e)),"string"==typeof t&&(t=JSON.parse(t));var n=Array.isArray(e)&&0<e.length,s=!Array.isArray(t[0]);if(n&&g){for(var a=0;a<e.length;a++)0<a&&(i+=m),i+=v(e[a],a);0<t.length&&(i+=y)}for(var o=0;o<t.length;o++){var h=n?e.length:t[o].length,u=!1,f=n?0===Object.keys(t[o]).length:0===t[o].length;if(r&&!n&&(u="greedy"===r?""===t[o].join("").trim():1===t[o].length&&0===t[o][0].length),"greedy"===r&&n){for(var d=[],l=0;l<h;l++){var c=s?e[l]:l;d.push(t[o][c])}u=""===d.join("").trim()}if(!u){for(var p=0;p<h;p++){0<p&&!f&&(i+=m);var _=n&&s?e[p]:p;i+=v(t[o][_],p)}o<t.length-1&&(!r||0<h&&!f)&&(i+=y)}}return i}function v(e,t){if(null==e)return"";if(e.constructor===Date)return JSON.stringify(e).slice(1,25);e=e.toString().replace(s,n+n);var r="boolean"==typeof i&&i||Array.isArray(i)&&i[t]||function(e,t){for(var r=0;r<t.length;r++)if(-1<e.indexOf(t[r]))return!0;return!1}(e,k.BAD_DELIMITERS)||-1<e.indexOf(m)||" "===e.charAt(0)||" "===e.charAt(e.length-1);return r?n+e+n:e}}};if(k.RECORD_SEP=String.fromCharCode(30),k.UNIT_SEP=String.fromCharCode(31),k.BYTE_ORDER_MARK="\ufeff",k.BAD_DELIMITERS=["\r","\n",'"',k.BYTE_ORDER_MARK],k.WORKERS_SUPPORTED=!n&&!!f.Worker,k.SCRIPT_PATH=null,k.NODE_STREAM_INPUT=1,k.LocalChunkSize=10485760,k.RemoteChunkSize=5242880,k.DefaultDelimiter=",",k.Parser=v,k.ParserHandle=r,k.NetworkStreamer=c,k.FileStreamer=p,k.StringStreamer=_,k.ReadableStreamStreamer=g,f.jQuery){var d=f.jQuery;d.fn.parse=function(o){var r=o.config||{},h=[];return this.each(function(e){if(!("INPUT"===d(this).prop("tagName").toUpperCase()&&"file"===d(this).attr("type").toLowerCase()&&f.FileReader)||!this.files||0===this.files.length)return!0;for(var t=0;t<this.files.length;t++)h.push({file:this.files[t],inputElem:this,instanceConfig:d.extend({},r)})}),e(),this;function e(){if(0!==h.length){var e,t,r,i,n=h[0];if(z(o.before)){var s=o.before(n.file,n.inputElem);if("object"==typeof s){if("abort"===s.action)return e="AbortError",t=n.file,r=n.inputElem,i=s.reason,void(z(o.error)&&o.error({name:e},t,r,i));if("skip"===s.action)return void u();"object"==typeof s.config&&(n.instanceConfig=d.extend(n.instanceConfig,s.config))}else if("skip"===s)return void u()}var a=n.instanceConfig.complete;n.instanceConfig.complete=function(e){z(a)&&a(e,n.file,n.inputElem),u()},k.parse(n.file,n.instanceConfig)}else z(o.complete)&&o.complete()}function u(){h.splice(0,1),e()}}}function l(e){this._handle=null,this._finished=!1,this._completed=!1,this._input=null,this._baseIndex=0,this._partialLine="",this._rowCount=0,this._start=0,this._nextChunk=null,this.isFirstChunk=!0,this._completeResults={data:[],errors:[],meta:{}},function(e){var t=E(e);t.chunkSize=parseInt(t.chunkSize),e.step||e.chunk||(t.chunkSize=null);this._handle=new r(t),(this._handle.streamer=this)._config=t}.call(this,e),this.parseChunk=function(e,t){if(this.isFirstChunk&&z(this._config.beforeFirstChunk)){var r=this._config.beforeFirstChunk(e);void 0!==r&&(e=r)}this.isFirstChunk=!1;var i=this._partialLine+e;this._partialLine="";var n=this._handle.parse(i,this._baseIndex,!this._finished);if(!this._handle.paused()&&!this._handle.aborted()){var s=n.meta.cursor;this._finished||(this._partialLine=i.substring(s-this._baseIndex),this._baseIndex=s),n&&n.data&&(this._rowCount+=n.data.length);var a=this._finished||this._config.preview&&this._rowCount>=this._config.preview;if(o)f.postMessage({results:n,workerId:k.WORKER_ID,finished:a});else if(z(this._config.chunk)&&!t){if(this._config.chunk(n,this._handle),this._handle.paused()||this._handle.aborted())return;n=void 0,this._completeResults=void 0}return this._config.step||this._config.chunk||(this._completeResults.data=this._completeResults.data.concat(n.data),this._completeResults.errors=this._completeResults.errors.concat(n.errors),this._completeResults.meta=n.meta),this._completed||!a||!z(this._config.complete)||n&&n.meta.aborted||(this._config.complete(this._completeResults,this._input),this._completed=!0),a||n&&n.meta.paused||this._nextChunk(),n}},this._sendError=function(e){z(this._config.error)?this._config.error(e):o&&this._config.error&&f.postMessage({workerId:k.WORKER_ID,error:e,finished:!1})}}function c(e){var i;(e=e||{}).chunkSize||(e.chunkSize=k.RemoteChunkSize),l.call(this,e),this._nextChunk=n?function(){this._readChunk(),this._chunkLoaded()}:function(){this._readChunk()},this.stream=function(e){this._input=e,this._nextChunk()},this._readChunk=function(){if(this._finished)this._chunkLoaded();else{if(i=new XMLHttpRequest,this._config.withCredentials&&(i.withCredentials=this._config.withCredentials),n||(i.onload=w(this._chunkLoaded,this),i.onerror=w(this._chunkError,this)),i.open("GET",this._input,!n),this._config.downloadRequestHeaders){var e=this._config.downloadRequestHeaders;for(var t in e)i.setRequestHeader(t,e[t])}if(this._config.chunkSize){var r=this._start+this._config.chunkSize-1;i.setRequestHeader("Range","bytes="+this._start+"-"+r),i.setRequestHeader("If-None-Match","webkit-no-cache")}try{i.send()}catch(e){this._chunkError(e.message)}n&&0===i.status?this._chunkError():this._start+=this._config.chunkSize}},this._chunkLoaded=function(){4===i.readyState&&(i.status<200||400<=i.status?this._chunkError():(this._finished=!this._config.chunkSize||this._start>function(e){var t=e.getResponseHeader("Content-Range");if(null===t)return-1;return parseInt(t.substr(t.lastIndexOf("/")+1))}(i),this.parseChunk(i.responseText)))},this._chunkError=function(e){var t=i.statusText||e;this._sendError(new Error(t))}}function p(e){var i,n;(e=e||{}).chunkSize||(e.chunkSize=k.LocalChunkSize),l.call(this,e);var s="undefined"!=typeof FileReader;this.stream=function(e){this._input=e,n=e.slice||e.webkitSlice||e.mozSlice,s?((i=new FileReader).onload=w(this._chunkLoaded,this),i.onerror=w(this._chunkError,this)):i=new FileReaderSync,this._nextChunk()},this._nextChunk=function(){this._finished||this._config.preview&&!(this._rowCount<this._config.preview)||this._readChunk()},this._readChunk=function(){var e=this._input;if(this._config.chunkSize){var t=Math.min(this._start+this._config.chunkSize,this._input.size);e=n.call(e,this._start,t)}var r=i.readAsText(e,this._config.encoding);s||this._chunkLoaded({target:{result:r}})},this._chunkLoaded=function(e){this._start+=this._config.chunkSize,this._finished=!this._config.chunkSize||this._start>=this._input.size,this.parseChunk(e.target.result)},this._chunkError=function(){this._sendError(i.error)}}function _(e){var r;l.call(this,e=e||{}),this.stream=function(e){return r=e,this._nextChunk()},this._nextChunk=function(){if(!this._finished){var e=this._config.chunkSize,t=e?r.substr(0,e):r;return r=e?r.substr(e):"",this._finished=!r,this.parseChunk(t)}}}function g(e){l.call(this,e=e||{});var t=[],r=!0,i=!1;this.pause=function(){l.prototype.pause.apply(this,arguments),this._input.pause()},this.resume=function(){l.prototype.resume.apply(this,arguments),this._input.resume()},this.stream=function(e){this._input=e,this._input.on("data",this._streamData),this._input.on("end",this._streamEnd),this._input.on("error",this._streamError)},this._checkIsFinished=function(){i&&1===t.length&&(this._finished=!0)},this._nextChunk=function(){this._checkIsFinished(),t.length?this.parseChunk(t.shift()):r=!0},this._streamData=w(function(e){try{t.push("string"==typeof e?e:e.toString(this._config.encoding)),r&&(r=!1,this._checkIsFinished(),this.parseChunk(t.shift()))}catch(e){this._streamError(e)}},this),this._streamError=w(function(e){this._streamCleanUp(),this._sendError(e)},this),this._streamEnd=w(function(){this._streamCleanUp(),i=!0,this._streamData("")},this),this._streamCleanUp=w(function(){this._input.removeListener("data",this._streamData),this._input.removeListener("end",this._streamEnd),this._input.removeListener("error",this._streamError)},this)}function r(g){var a,o,h,i=/^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i,n=/(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/,t=this,r=0,s=0,u=!1,e=!1,f=[],d={data:[],errors:[],meta:{}};if(z(g.step)){var l=g.step;g.step=function(e){if(d=e,p())c();else{if(c(),0===d.data.length)return;r+=e.data.length,g.preview&&r>g.preview?o.abort():l(d,t)}}}function m(e){return"greedy"===g.skipEmptyLines?""===e.join("").trim():1===e.length&&0===e[0].length}function c(){if(d&&h&&(y("Delimiter","UndetectableDelimiter","Unable to auto-detect delimiting character; defaulted to '"+k.DefaultDelimiter+"'"),h=!1),g.skipEmptyLines)for(var e=0;e<d.data.length;e++)m(d.data[e])&&d.data.splice(e--,1);return p()&&function(){if(!d)return;for(var e=0;p()&&e<d.data.length;e++)for(var t=0;t<d.data[e].length;t++){var r=d.data[e][t];g.trimHeaders&&(r=r.trim()),f.push(r)}d.data.splice(0,1)}(),function(){if(!d||!g.header&&!g.dynamicTyping&&!g.transform)return d;for(var e=0;e<d.data.length;e++){var t,r=g.header?{}:[];for(t=0;t<d.data[e].length;t++){var i=t,n=d.data[e][t];g.header&&(i=t>=f.length?"__parsed_extra":f[t]),g.transform&&(n=g.transform(n,i)),n=_(i,n),"__parsed_extra"===i?(r[i]=r[i]||[],r[i].push(n)):r[i]=n}d.data[e]=r,g.header&&(t>f.length?y("FieldMismatch","TooManyFields","Too many fields: expected "+f.length+" fields but parsed "+t,s+e):t<f.length&&y("FieldMismatch","TooFewFields","Too few fields: expected "+f.length+" fields but parsed "+t,s+e))}g.header&&d.meta&&(d.meta.fields=f);return s+=d.data.length,d}()}function p(){return g.header&&0===f.length}function _(e,t){return r=e,g.dynamicTypingFunction&&void 0===g.dynamicTyping[r]&&(g.dynamicTyping[r]=g.dynamicTypingFunction(r)),!0===(g.dynamicTyping[r]||g.dynamicTyping)?"true"===t||"TRUE"===t||"false"!==t&&"FALSE"!==t&&(i.test(t)?parseFloat(t):n.test(t)?new Date(t):""===t?null:t):t;var r}function y(e,t,r,i){d.errors.push({type:e,code:t,message:r,row:i})}this.parse=function(e,t,r){var i=g.quoteChar||'"';if(g.newline||(g.newline=function(e,t){e=e.substr(0,1048576);var r=new RegExp(M(t)+"([^]*?)"+M(t),"gm"),i=(e=e.replace(r,"")).split("\r"),n=e.split("\n"),s=1<n.length&&n[0].length<i[0].length;if(1===i.length||s)return"\n";for(var a=0,o=0;o<i.length;o++)"\n"===i[o][0]&&a++;return a>=i.length/2?"\r\n":"\r"}(e,i)),h=!1,g.delimiter)z(g.delimiter)&&(g.delimiter=g.delimiter(e),d.meta.delimiter=g.delimiter);else{var n=function(e,t,r,i){for(var n,s,a,o=[",","\t","|",";",k.RECORD_SEP,k.UNIT_SEP],h=0;h<o.length;h++){var u=o[h],f=0,d=0,l=0;a=void 0;for(var c=new v({comments:i,delimiter:u,newline:t,preview:10}).parse(e),p=0;p<c.data.length;p++)if(r&&m(c.data[p]))l++;else{var _=c.data[p].length;d+=_,void 0!==a?1<_&&(f+=Math.abs(_-a),a=_):a=0}0<c.data.length&&(d/=c.data.length-l),(void 0===s||s<f)&&1.99<d&&(s=f,n=u)}return{successful:!!(g.delimiter=n),bestDelimiter:n}}(e,g.newline,g.skipEmptyLines,g.comments);n.successful?g.delimiter=n.bestDelimiter:(h=!0,g.delimiter=k.DefaultDelimiter),d.meta.delimiter=g.delimiter}var s=E(g);return g.preview&&g.header&&s.preview++,a=e,o=new v(s),d=o.parse(a,t,r),c(),u?{meta:{paused:!0}}:d||{meta:{paused:!1}}},this.paused=function(){return u},this.pause=function(){u=!0,o.abort(),a=a.substr(o.getCharIndex())},this.resume=function(){u=!1,t.streamer.parseChunk(a,!0)},this.aborted=function(){return e},this.abort=function(){e=!0,o.abort(),d.meta.aborted=!0,z(g.complete)&&g.complete(d),a=""}}function M(e){return e.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")}function v(e){var S,O=(e=e||{}).delimiter,x=e.newline,T=e.comments,I=e.step,A=e.preview,D=e.fastMode,L=S=void 0===e.quoteChar?'"':e.quoteChar;if(void 0!==e.escapeChar&&(L=e.escapeChar),("string"!=typeof O||-1<k.BAD_DELIMITERS.indexOf(O))&&(O=","),T===O)throw"Comment character same as delimiter";!0===T?T="#":("string"!=typeof T||-1<k.BAD_DELIMITERS.indexOf(T))&&(T=!1),"\n"!==x&&"\r"!==x&&"\r\n"!==x&&(x="\n");var P=0,F=!1;this.parse=function(i,t,r){if("string"!=typeof i)throw"Input must be a string";var n=i.length,e=O.length,s=x.length,a=T.length,o=z(I),h=[],u=[],f=[],d=P=0;if(!i)return C();if(D||!1!==D&&-1===i.indexOf(S)){for(var l=i.split(x),c=0;c<l.length;c++){if(f=l[c],P+=f.length,c!==l.length-1)P+=x.length;else if(r)return C();if(!T||f.substr(0,a)!==T){if(o){if(h=[],k(f.split(O)),R(),F)return C()}else k(f.split(O));if(A&&A<=c)return h=h.slice(0,A),C(!0)}}return C()}for(var p,_=i.indexOf(O,P),g=i.indexOf(x,P),m=new RegExp(M(L)+M(S),"g");;)if(i[P]!==S)if(T&&0===f.length&&i.substr(P,a)===T){if(-1===g)return C();P=g+s,g=i.indexOf(x,P),_=i.indexOf(O,P)}else if(-1!==_&&(_<g||-1===g))f.push(i.substring(P,_)),P=_+e,_=i.indexOf(O,P);else{if(-1===g)break;if(f.push(i.substring(P,g)),w(g+s),o&&(R(),F))return C();if(A&&h.length>=A)return C(!0)}else for(p=P,P++;;){if(-1===(p=i.indexOf(S,p+1)))return r||u.push({type:"Quotes",code:"MissingQuotes",message:"Quoted field unterminated",row:h.length,index:P}),E();if(p===n-1)return E(i.substring(P,p).replace(m,S));if(S!==L||i[p+1]!==L){if(S===L||0===p||i[p-1]!==L){var y=b(-1===g?_:Math.min(_,g));if(i[p+1+y]===O){f.push(i.substring(P,p).replace(m,S)),P=p+1+y+e,_=i.indexOf(O,P),g=i.indexOf(x,P);break}var v=b(g);if(i.substr(p+1+v,s)===x){if(f.push(i.substring(P,p).replace(m,S)),w(p+1+v+s),_=i.indexOf(O,P),o&&(R(),F))return C();if(A&&h.length>=A)return C(!0);break}u.push({type:"Quotes",code:"InvalidQuotes",message:"Trailing quote on quoted field is malformed",row:h.length,index:P}),p++}}else p++}return E();function k(e){h.push(e),d=P}function b(e){var t=0;if(-1!==e){var r=i.substring(p+1,e);r&&""===r.trim()&&(t=r.length)}return t}function E(e){return r||(void 0===e&&(e=i.substr(P)),f.push(e),P=n,k(f),o&&R()),C()}function w(e){P=e,k(f),f=[],g=i.indexOf(x,P)}function C(e){return{data:h,errors:u,meta:{delimiter:O,linebreak:x,aborted:F,truncated:!!e,cursor:d+(t||0)}}}function R(){I(C()),h=[],u=[]}},this.abort=function(){F=!0},this.getCharIndex=function(){return P}}function m(e){var t=e.data,r=h[t.workerId],i=!1;if(t.error)r.userError(t.error,t.file);else if(t.results&&t.results.data){var n={abort:function(){i=!0,y(t.workerId,{data:[],errors:[],meta:{aborted:!0}})},pause:b,resume:b};if(z(r.userStep)){for(var s=0;s<t.results.data.length&&(r.userStep({data:[t.results.data[s]],errors:t.results.errors,meta:t.results.meta},n),!i);s++);delete t.results}else z(r.userChunk)&&(r.userChunk(t.results,n,t.file),delete t.results)}t.finished&&!i&&y(t.workerId,t.results)}function y(e,t){var r=h[e];z(r.userComplete)&&r.userComplete(t),r.terminate(),delete h[e]}function b(){throw"Not implemented."}function E(e){if("object"!=typeof e||null===e)return e;var t=Array.isArray(e)?[]:{};for(var r in e)t[r]=E(e[r]);return t}function w(e,t){return function(){e.apply(t,arguments)}}function z(e){return"function"==typeof e}return o?f.onmessage=function(e){var t=e.data;void 0===k.WORKER_ID&&t&&(k.WORKER_ID=t.workerId);if("string"==typeof t.input)f.postMessage({workerId:k.WORKER_ID,results:k.parse(t.input,t.config),finished:!0});else if(f.File&&t.input instanceof File||t.input instanceof Object){var r=k.parse(t.input,t.config);r&&f.postMessage({workerId:k.WORKER_ID,results:r,finished:!0})}}:k.WORKERS_SUPPORTED&&(e=document.getElementsByTagName("script"),s=e.length?e[e.length-1].src:"",document.body?document.addEventListener("DOMContentLoaded",function(){a=!0},!0):a=!0),(c.prototype=Object.create(l.prototype)).constructor=c,(p.prototype=Object.create(l.prototype)).constructor=p,(_.prototype=Object.create(_.prototype)).constructor=_,(g.prototype=Object.create(l.prototype)).constructor=g,k});

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

/*jslint node:true */

var xml2js = __webpack_require__(299);
var xml2json = __webpack_require__(866);
var js2xml = __webpack_require__(305);
var json2xml = __webpack_require__(867);

module.exports = {
  xml2js: xml2js,
  xml2json: xml2json,
  js2xml: js2xml,
  json2xml: json2xml
};


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {;(function (sax) { // wrapper for non-node envs
  sax.parser = function (strict, opt) { return new SAXParser(strict, opt) }
  sax.SAXParser = SAXParser
  sax.SAXStream = SAXStream
  sax.createStream = createStream

  // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
  // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
  // since that's the earliest that a buffer overrun could occur.  This way, checks are
  // as rare as required, but as often as necessary to ensure never crossing this bound.
  // Furthermore, buffers are only tested at most once per write(), so passing a very
  // large string into write() might have undesirable effects, but this is manageable by
  // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
  // edge case, result in creating at most one complete copy of the string passed in.
  // Set to Infinity to have unlimited buffers.
  sax.MAX_BUFFER_LENGTH = 64 * 1024

  var buffers = [
    'comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype',
    'procInstName', 'procInstBody', 'entity', 'attribName',
    'attribValue', 'cdata', 'script'
  ]

  sax.EVENTS = [
    'text',
    'processinginstruction',
    'sgmldeclaration',
    'doctype',
    'comment',
    'opentagstart',
    'attribute',
    'opentag',
    'closetag',
    'opencdata',
    'cdata',
    'closecdata',
    'error',
    'end',
    'ready',
    'script',
    'opennamespace',
    'closenamespace'
  ]

  function SAXParser (strict, opt) {
    if (!(this instanceof SAXParser)) {
      return new SAXParser(strict, opt)
    }

    var parser = this
    clearBuffers(parser)
    parser.q = parser.c = ''
    parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH
    parser.opt = opt || {}
    parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags
    parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase'
    parser.tags = []
    parser.closed = parser.closedRoot = parser.sawRoot = false
    parser.tag = parser.error = null
    parser.strict = !!strict
    parser.noscript = !!(strict || parser.opt.noscript)
    parser.state = S.BEGIN
    parser.strictEntities = parser.opt.strictEntities
    parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES)
    parser.attribList = []

    // namespaces form a prototype chain.
    // it always points at the current tag,
    // which protos to its parent tag.
    if (parser.opt.xmlns) {
      parser.ns = Object.create(rootNS)
    }

    // mostly just for error reporting
    parser.trackPosition = parser.opt.position !== false
    if (parser.trackPosition) {
      parser.position = parser.line = parser.column = 0
    }
    emit(parser, 'onready')
  }

  if (!Object.create) {
    Object.create = function (o) {
      function F () {}
      F.prototype = o
      var newf = new F()
      return newf
    }
  }

  if (!Object.keys) {
    Object.keys = function (o) {
      var a = []
      for (var i in o) if (o.hasOwnProperty(i)) a.push(i)
      return a
    }
  }

  function checkBufferLength (parser) {
    var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10)
    var maxActual = 0
    for (var i = 0, l = buffers.length; i < l; i++) {
      var len = parser[buffers[i]].length
      if (len > maxAllowed) {
        // Text/cdata nodes can get big, and since they're buffered,
        // we can get here under normal conditions.
        // Avoid issues by emitting the text node now,
        // so at least it won't get any bigger.
        switch (buffers[i]) {
          case 'textNode':
            closeText(parser)
            break

          case 'cdata':
            emitNode(parser, 'oncdata', parser.cdata)
            parser.cdata = ''
            break

          case 'script':
            emitNode(parser, 'onscript', parser.script)
            parser.script = ''
            break

          default:
            error(parser, 'Max buffer length exceeded: ' + buffers[i])
        }
      }
      maxActual = Math.max(maxActual, len)
    }
    // schedule the next check for the earliest possible buffer overrun.
    var m = sax.MAX_BUFFER_LENGTH - maxActual
    parser.bufferCheckPosition = m + parser.position
  }

  function clearBuffers (parser) {
    for (var i = 0, l = buffers.length; i < l; i++) {
      parser[buffers[i]] = ''
    }
  }

  function flushBuffers (parser) {
    closeText(parser)
    if (parser.cdata !== '') {
      emitNode(parser, 'oncdata', parser.cdata)
      parser.cdata = ''
    }
    if (parser.script !== '') {
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }
  }

  SAXParser.prototype = {
    end: function () { end(this) },
    write: write,
    resume: function () { this.error = null; return this },
    close: function () { return this.write(null) },
    flush: function () { flushBuffers(this) }
  }

  var Stream
  try {
    Stream = __webpack_require__(854).Stream
  } catch (ex) {
    Stream = function () {}
  }

  var streamWraps = sax.EVENTS.filter(function (ev) {
    return ev !== 'error' && ev !== 'end'
  })

  function createStream (strict, opt) {
    return new SAXStream(strict, opt)
  }

  function SAXStream (strict, opt) {
    if (!(this instanceof SAXStream)) {
      return new SAXStream(strict, opt)
    }

    Stream.apply(this)

    this._parser = new SAXParser(strict, opt)
    this.writable = true
    this.readable = true

    var me = this

    this._parser.onend = function () {
      me.emit('end')
    }

    this._parser.onerror = function (er) {
      me.emit('error', er)

      // if didn't throw, then means error was handled.
      // go ahead and clear error, so we can write again.
      me._parser.error = null
    }

    this._decoder = null

    streamWraps.forEach(function (ev) {
      Object.defineProperty(me, 'on' + ev, {
        get: function () {
          return me._parser['on' + ev]
        },
        set: function (h) {
          if (!h) {
            me.removeAllListeners(ev)
            me._parser['on' + ev] = h
            return h
          }
          me.on(ev, h)
        },
        enumerable: true,
        configurable: false
      })
    })
  }

  SAXStream.prototype = Object.create(Stream.prototype, {
    constructor: {
      value: SAXStream
    }
  })

  SAXStream.prototype.write = function (data) {
    if (typeof Buffer === 'function' &&
      typeof Buffer.isBuffer === 'function' &&
      Buffer.isBuffer(data)) {
      if (!this._decoder) {
        var SD = __webpack_require__(186).StringDecoder
        this._decoder = new SD('utf8')
      }
      data = this._decoder.write(data)
    }

    this._parser.write(data.toString())
    this.emit('data', data)
    return true
  }

  SAXStream.prototype.end = function (chunk) {
    if (chunk && chunk.length) {
      this.write(chunk)
    }
    this._parser.end()
    return true
  }

  SAXStream.prototype.on = function (ev, handler) {
    var me = this
    if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) {
      me._parser['on' + ev] = function () {
        var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments)
        args.splice(0, 0, ev)
        me.emit.apply(me, args)
      }
    }

    return Stream.prototype.on.call(me, ev, handler)
  }

  // this really needs to be replaced with character classes.
  // XML allows all manner of ridiculous numbers and digits.
  var CDATA = '[CDATA['
  var DOCTYPE = 'DOCTYPE'
  var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace'
  var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/'
  var rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE }

  // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
  // This implementation works on strings, a single character at a time
  // as such, it cannot ever support astral-plane characters (10000-EFFFF)
  // without a significant breaking change to either this  parser, or the
  // JavaScript language.  Implementation of an emoji-capable xml parser
  // is left as an exercise for the reader.
  var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/

  var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/
  var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  function isWhitespace (c) {
    return c === ' ' || c === '\n' || c === '\r' || c === '\t'
  }

  function isQuote (c) {
    return c === '"' || c === '\''
  }

  function isAttribEnd (c) {
    return c === '>' || isWhitespace(c)
  }

  function isMatch (regex, c) {
    return regex.test(c)
  }

  function notMatch (regex, c) {
    return !isMatch(regex, c)
  }

  var S = 0
  sax.STATE = {
    BEGIN: S++, // leading byte order mark or whitespace
    BEGIN_WHITESPACE: S++, // leading whitespace
    TEXT: S++, // general stuff
    TEXT_ENTITY: S++, // &amp and such.
    OPEN_WAKA: S++, // <
    SGML_DECL: S++, // <!BLARG
    SGML_DECL_QUOTED: S++, // <!BLARG foo "bar
    DOCTYPE: S++, // <!DOCTYPE
    DOCTYPE_QUOTED: S++, // <!DOCTYPE "//blah
    DOCTYPE_DTD: S++, // <!DOCTYPE "//blah" [ ...
    DOCTYPE_DTD_QUOTED: S++, // <!DOCTYPE "//blah" [ "foo
    COMMENT_STARTING: S++, // <!-
    COMMENT: S++, // <!--
    COMMENT_ENDING: S++, // <!-- blah -
    COMMENT_ENDED: S++, // <!-- blah --
    CDATA: S++, // <![CDATA[ something
    CDATA_ENDING: S++, // ]
    CDATA_ENDING_2: S++, // ]]
    PROC_INST: S++, // <?hi
    PROC_INST_BODY: S++, // <?hi there
    PROC_INST_ENDING: S++, // <?hi "there" ?
    OPEN_TAG: S++, // <strong
    OPEN_TAG_SLASH: S++, // <strong /
    ATTRIB: S++, // <a
    ATTRIB_NAME: S++, // <a foo
    ATTRIB_NAME_SAW_WHITE: S++, // <a foo _
    ATTRIB_VALUE: S++, // <a foo=
    ATTRIB_VALUE_QUOTED: S++, // <a foo="bar
    ATTRIB_VALUE_CLOSED: S++, // <a foo="bar"
    ATTRIB_VALUE_UNQUOTED: S++, // <a foo=bar
    ATTRIB_VALUE_ENTITY_Q: S++, // <foo bar="&quot;"
    ATTRIB_VALUE_ENTITY_U: S++, // <foo bar=&quot
    CLOSE_TAG: S++, // </a
    CLOSE_TAG_SAW_WHITE: S++, // </a   >
    SCRIPT: S++, // <script> ...
    SCRIPT_ENDING: S++ // <script> ... <
  }

  sax.XML_ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'"
  }

  sax.ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'",
    'AElig': 198,
    'Aacute': 193,
    'Acirc': 194,
    'Agrave': 192,
    'Aring': 197,
    'Atilde': 195,
    'Auml': 196,
    'Ccedil': 199,
    'ETH': 208,
    'Eacute': 201,
    'Ecirc': 202,
    'Egrave': 200,
    'Euml': 203,
    'Iacute': 205,
    'Icirc': 206,
    'Igrave': 204,
    'Iuml': 207,
    'Ntilde': 209,
    'Oacute': 211,
    'Ocirc': 212,
    'Ograve': 210,
    'Oslash': 216,
    'Otilde': 213,
    'Ouml': 214,
    'THORN': 222,
    'Uacute': 218,
    'Ucirc': 219,
    'Ugrave': 217,
    'Uuml': 220,
    'Yacute': 221,
    'aacute': 225,
    'acirc': 226,
    'aelig': 230,
    'agrave': 224,
    'aring': 229,
    'atilde': 227,
    'auml': 228,
    'ccedil': 231,
    'eacute': 233,
    'ecirc': 234,
    'egrave': 232,
    'eth': 240,
    'euml': 235,
    'iacute': 237,
    'icirc': 238,
    'igrave': 236,
    'iuml': 239,
    'ntilde': 241,
    'oacute': 243,
    'ocirc': 244,
    'ograve': 242,
    'oslash': 248,
    'otilde': 245,
    'ouml': 246,
    'szlig': 223,
    'thorn': 254,
    'uacute': 250,
    'ucirc': 251,
    'ugrave': 249,
    'uuml': 252,
    'yacute': 253,
    'yuml': 255,
    'copy': 169,
    'reg': 174,
    'nbsp': 160,
    'iexcl': 161,
    'cent': 162,
    'pound': 163,
    'curren': 164,
    'yen': 165,
    'brvbar': 166,
    'sect': 167,
    'uml': 168,
    'ordf': 170,
    'laquo': 171,
    'not': 172,
    'shy': 173,
    'macr': 175,
    'deg': 176,
    'plusmn': 177,
    'sup1': 185,
    'sup2': 178,
    'sup3': 179,
    'acute': 180,
    'micro': 181,
    'para': 182,
    'middot': 183,
    'cedil': 184,
    'ordm': 186,
    'raquo': 187,
    'frac14': 188,
    'frac12': 189,
    'frac34': 190,
    'iquest': 191,
    'times': 215,
    'divide': 247,
    'OElig': 338,
    'oelig': 339,
    'Scaron': 352,
    'scaron': 353,
    'Yuml': 376,
    'fnof': 402,
    'circ': 710,
    'tilde': 732,
    'Alpha': 913,
    'Beta': 914,
    'Gamma': 915,
    'Delta': 916,
    'Epsilon': 917,
    'Zeta': 918,
    'Eta': 919,
    'Theta': 920,
    'Iota': 921,
    'Kappa': 922,
    'Lambda': 923,
    'Mu': 924,
    'Nu': 925,
    'Xi': 926,
    'Omicron': 927,
    'Pi': 928,
    'Rho': 929,
    'Sigma': 931,
    'Tau': 932,
    'Upsilon': 933,
    'Phi': 934,
    'Chi': 935,
    'Psi': 936,
    'Omega': 937,
    'alpha': 945,
    'beta': 946,
    'gamma': 947,
    'delta': 948,
    'epsilon': 949,
    'zeta': 950,
    'eta': 951,
    'theta': 952,
    'iota': 953,
    'kappa': 954,
    'lambda': 955,
    'mu': 956,
    'nu': 957,
    'xi': 958,
    'omicron': 959,
    'pi': 960,
    'rho': 961,
    'sigmaf': 962,
    'sigma': 963,
    'tau': 964,
    'upsilon': 965,
    'phi': 966,
    'chi': 967,
    'psi': 968,
    'omega': 969,
    'thetasym': 977,
    'upsih': 978,
    'piv': 982,
    'ensp': 8194,
    'emsp': 8195,
    'thinsp': 8201,
    'zwnj': 8204,
    'zwj': 8205,
    'lrm': 8206,
    'rlm': 8207,
    'ndash': 8211,
    'mdash': 8212,
    'lsquo': 8216,
    'rsquo': 8217,
    'sbquo': 8218,
    'ldquo': 8220,
    'rdquo': 8221,
    'bdquo': 8222,
    'dagger': 8224,
    'Dagger': 8225,
    'bull': 8226,
    'hellip': 8230,
    'permil': 8240,
    'prime': 8242,
    'Prime': 8243,
    'lsaquo': 8249,
    'rsaquo': 8250,
    'oline': 8254,
    'frasl': 8260,
    'euro': 8364,
    'image': 8465,
    'weierp': 8472,
    'real': 8476,
    'trade': 8482,
    'alefsym': 8501,
    'larr': 8592,
    'uarr': 8593,
    'rarr': 8594,
    'darr': 8595,
    'harr': 8596,
    'crarr': 8629,
    'lArr': 8656,
    'uArr': 8657,
    'rArr': 8658,
    'dArr': 8659,
    'hArr': 8660,
    'forall': 8704,
    'part': 8706,
    'exist': 8707,
    'empty': 8709,
    'nabla': 8711,
    'isin': 8712,
    'notin': 8713,
    'ni': 8715,
    'prod': 8719,
    'sum': 8721,
    'minus': 8722,
    'lowast': 8727,
    'radic': 8730,
    'prop': 8733,
    'infin': 8734,
    'ang': 8736,
    'and': 8743,
    'or': 8744,
    'cap': 8745,
    'cup': 8746,
    'int': 8747,
    'there4': 8756,
    'sim': 8764,
    'cong': 8773,
    'asymp': 8776,
    'ne': 8800,
    'equiv': 8801,
    'le': 8804,
    'ge': 8805,
    'sub': 8834,
    'sup': 8835,
    'nsub': 8836,
    'sube': 8838,
    'supe': 8839,
    'oplus': 8853,
    'otimes': 8855,
    'perp': 8869,
    'sdot': 8901,
    'lceil': 8968,
    'rceil': 8969,
    'lfloor': 8970,
    'rfloor': 8971,
    'lang': 9001,
    'rang': 9002,
    'loz': 9674,
    'spades': 9824,
    'clubs': 9827,
    'hearts': 9829,
    'diams': 9830
  }

  Object.keys(sax.ENTITIES).forEach(function (key) {
    var e = sax.ENTITIES[key]
    var s = typeof e === 'number' ? String.fromCharCode(e) : e
    sax.ENTITIES[key] = s
  })

  for (var s in sax.STATE) {
    sax.STATE[sax.STATE[s]] = s
  }

  // shorthand
  S = sax.STATE

  function emit (parser, event, data) {
    parser[event] && parser[event](data)
  }

  function emitNode (parser, nodeType, data) {
    if (parser.textNode) closeText(parser)
    emit(parser, nodeType, data)
  }

  function closeText (parser) {
    parser.textNode = textopts(parser.opt, parser.textNode)
    if (parser.textNode) emit(parser, 'ontext', parser.textNode)
    parser.textNode = ''
  }

  function textopts (opt, text) {
    if (opt.trim) text = text.trim()
    if (opt.normalize) text = text.replace(/\s+/g, ' ')
    return text
  }

  function error (parser, er) {
    closeText(parser)
    if (parser.trackPosition) {
      er += '\nLine: ' + parser.line +
        '\nColumn: ' + parser.column +
        '\nChar: ' + parser.c
    }
    er = new Error(er)
    parser.error = er
    emit(parser, 'onerror', er)
    return parser
  }

  function end (parser) {
    if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag')
    if ((parser.state !== S.BEGIN) &&
      (parser.state !== S.BEGIN_WHITESPACE) &&
      (parser.state !== S.TEXT)) {
      error(parser, 'Unexpected end')
    }
    closeText(parser)
    parser.c = ''
    parser.closed = true
    emit(parser, 'onend')
    SAXParser.call(parser, parser.strict, parser.opt)
    return parser
  }

  function strictFail (parser, message) {
    if (typeof parser !== 'object' || !(parser instanceof SAXParser)) {
      throw new Error('bad call to strictFail')
    }
    if (parser.strict) {
      error(parser, message)
    }
  }

  function newTag (parser) {
    if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]()
    var parent = parser.tags[parser.tags.length - 1] || parser
    var tag = parser.tag = { name: parser.tagName, attributes: {} }

    // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
    if (parser.opt.xmlns) {
      tag.ns = parent.ns
    }
    parser.attribList.length = 0
    emitNode(parser, 'onopentagstart', tag)
  }

  function qname (name, attribute) {
    var i = name.indexOf(':')
    var qualName = i < 0 ? [ '', name ] : name.split(':')
    var prefix = qualName[0]
    var local = qualName[1]

    // <x "xmlns"="http://foo">
    if (attribute && name === 'xmlns') {
      prefix = 'xmlns'
      local = ''
    }

    return { prefix: prefix, local: local }
  }

  function attrib (parser) {
    if (!parser.strict) {
      parser.attribName = parser.attribName[parser.looseCase]()
    }

    if (parser.attribList.indexOf(parser.attribName) !== -1 ||
      parser.tag.attributes.hasOwnProperty(parser.attribName)) {
      parser.attribName = parser.attribValue = ''
      return
    }

    if (parser.opt.xmlns) {
      var qn = qname(parser.attribName, true)
      var prefix = qn.prefix
      var local = qn.local

      if (prefix === 'xmlns') {
        // namespace binding attribute. push the binding into scope
        if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
          strictFail(parser,
            'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
          strictFail(parser,
            'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else {
          var tag = parser.tag
          var parent = parser.tags[parser.tags.length - 1] || parser
          if (tag.ns === parent.ns) {
            tag.ns = Object.create(parent.ns)
          }
          tag.ns[local] = parser.attribValue
        }
      }

      // defer onattribute events until all attributes have been seen
      // so any new bindings can take effect. preserve attribute order
      // so deferred events can be emitted in document order
      parser.attribList.push([parser.attribName, parser.attribValue])
    } else {
      // in non-xmlns mode, we can emit the event right away
      parser.tag.attributes[parser.attribName] = parser.attribValue
      emitNode(parser, 'onattribute', {
        name: parser.attribName,
        value: parser.attribValue
      })
    }

    parser.attribName = parser.attribValue = ''
  }

  function openTag (parser, selfClosing) {
    if (parser.opt.xmlns) {
      // emit namespace binding events
      var tag = parser.tag

      // add namespace info to tag
      var qn = qname(parser.tagName)
      tag.prefix = qn.prefix
      tag.local = qn.local
      tag.uri = tag.ns[qn.prefix] || ''

      if (tag.prefix && !tag.uri) {
        strictFail(parser, 'Unbound namespace prefix: ' +
          JSON.stringify(parser.tagName))
        tag.uri = qn.prefix
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (tag.ns && parent.ns !== tag.ns) {
        Object.keys(tag.ns).forEach(function (p) {
          emitNode(parser, 'onopennamespace', {
            prefix: p,
            uri: tag.ns[p]
          })
        })
      }

      // handle deferred onattribute events
      // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting
      for (var i = 0, l = parser.attribList.length; i < l; i++) {
        var nv = parser.attribList[i]
        var name = nv[0]
        var value = nv[1]
        var qualName = qname(name, true)
        var prefix = qualName.prefix
        var local = qualName.local
        var uri = prefix === '' ? '' : (tag.ns[prefix] || '')
        var a = {
          name: name,
          value: value,
          prefix: prefix,
          local: local,
          uri: uri
        }

        // if there's any attributes with an undefined namespace,
        // then fail on them now.
        if (prefix && prefix !== 'xmlns' && !uri) {
          strictFail(parser, 'Unbound namespace prefix: ' +
            JSON.stringify(prefix))
          a.uri = prefix
        }
        parser.tag.attributes[name] = a
        emitNode(parser, 'onattribute', a)
      }
      parser.attribList.length = 0
    }

    parser.tag.isSelfClosing = !!selfClosing

    // process the tag
    parser.sawRoot = true
    parser.tags.push(parser.tag)
    emitNode(parser, 'onopentag', parser.tag)
    if (!selfClosing) {
      // special case for <script> in non-strict mode.
      if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
        parser.state = S.SCRIPT
      } else {
        parser.state = S.TEXT
      }
      parser.tag = null
      parser.tagName = ''
    }
    parser.attribName = parser.attribValue = ''
    parser.attribList.length = 0
  }

  function closeTag (parser) {
    if (!parser.tagName) {
      strictFail(parser, 'Weird empty close tag.')
      parser.textNode += '</>'
      parser.state = S.TEXT
      return
    }

    if (parser.script) {
      if (parser.tagName !== 'script') {
        parser.script += '</' + parser.tagName + '>'
        parser.tagName = ''
        parser.state = S.SCRIPT
        return
      }
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }

    // first make sure that the closing tag actually exists.
    // <a><b></c></b></a> will close everything, otherwise.
    var t = parser.tags.length
    var tagName = parser.tagName
    if (!parser.strict) {
      tagName = tagName[parser.looseCase]()
    }
    var closeTo = tagName
    while (t--) {
      var close = parser.tags[t]
      if (close.name !== closeTo) {
        // fail the first time in strict mode
        strictFail(parser, 'Unexpected close tag')
      } else {
        break
      }
    }

    // didn't find it.  we already failed for strict, so just abort.
    if (t < 0) {
      strictFail(parser, 'Unmatched closing tag: ' + parser.tagName)
      parser.textNode += '</' + parser.tagName + '>'
      parser.state = S.TEXT
      return
    }
    parser.tagName = tagName
    var s = parser.tags.length
    while (s-- > t) {
      var tag = parser.tag = parser.tags.pop()
      parser.tagName = parser.tag.name
      emitNode(parser, 'onclosetag', parser.tagName)

      var x = {}
      for (var i in tag.ns) {
        x[i] = tag.ns[i]
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (parser.opt.xmlns && tag.ns !== parent.ns) {
        // remove namespace bindings introduced by tag
        Object.keys(tag.ns).forEach(function (p) {
          var n = tag.ns[p]
          emitNode(parser, 'onclosenamespace', { prefix: p, uri: n })
        })
      }
    }
    if (t === 0) parser.closedRoot = true
    parser.tagName = parser.attribValue = parser.attribName = ''
    parser.attribList.length = 0
    parser.state = S.TEXT
  }

  function parseEntity (parser) {
    var entity = parser.entity
    var entityLC = entity.toLowerCase()
    var num
    var numStr = ''

    if (parser.ENTITIES[entity]) {
      return parser.ENTITIES[entity]
    }
    if (parser.ENTITIES[entityLC]) {
      return parser.ENTITIES[entityLC]
    }
    entity = entityLC
    if (entity.charAt(0) === '#') {
      if (entity.charAt(1) === 'x') {
        entity = entity.slice(2)
        num = parseInt(entity, 16)
        numStr = num.toString(16)
      } else {
        entity = entity.slice(1)
        num = parseInt(entity, 10)
        numStr = num.toString(10)
      }
    }
    entity = entity.replace(/^0+/, '')
    if (isNaN(num) || numStr.toLowerCase() !== entity) {
      strictFail(parser, 'Invalid character entity')
      return '&' + parser.entity + ';'
    }

    return String.fromCodePoint(num)
  }

  function beginWhiteSpace (parser, c) {
    if (c === '<') {
      parser.state = S.OPEN_WAKA
      parser.startTagPosition = parser.position
    } else if (!isWhitespace(c)) {
      // have to process this as a text node.
      // weird, but happens.
      strictFail(parser, 'Non-whitespace before first tag.')
      parser.textNode = c
      parser.state = S.TEXT
    }
  }

  function charAt (chunk, i) {
    var result = ''
    if (i < chunk.length) {
      result = chunk.charAt(i)
    }
    return result
  }

  function write (chunk) {
    var parser = this
    if (this.error) {
      throw this.error
    }
    if (parser.closed) {
      return error(parser,
        'Cannot write after close. Assign an onready handler.')
    }
    if (chunk === null) {
      return end(parser)
    }
    if (typeof chunk === 'object') {
      chunk = chunk.toString()
    }
    var i = 0
    var c = ''
    while (true) {
      c = charAt(chunk, i++)
      parser.c = c

      if (!c) {
        break
      }

      if (parser.trackPosition) {
        parser.position++
        if (c === '\n') {
          parser.line++
          parser.column = 0
        } else {
          parser.column++
        }
      }

      switch (parser.state) {
        case S.BEGIN:
          parser.state = S.BEGIN_WHITESPACE
          if (c === '\uFEFF') {
            continue
          }
          beginWhiteSpace(parser, c)
          continue

        case S.BEGIN_WHITESPACE:
          beginWhiteSpace(parser, c)
          continue

        case S.TEXT:
          if (parser.sawRoot && !parser.closedRoot) {
            var starti = i - 1
            while (c && c !== '<' && c !== '&') {
              c = charAt(chunk, i++)
              if (c && parser.trackPosition) {
                parser.position++
                if (c === '\n') {
                  parser.line++
                  parser.column = 0
                } else {
                  parser.column++
                }
              }
            }
            parser.textNode += chunk.substring(starti, i - 1)
          }
          if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
            parser.state = S.OPEN_WAKA
            parser.startTagPosition = parser.position
          } else {
            if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) {
              strictFail(parser, 'Text data outside of root node.')
            }
            if (c === '&') {
              parser.state = S.TEXT_ENTITY
            } else {
              parser.textNode += c
            }
          }
          continue

        case S.SCRIPT:
          // only non-strict
          if (c === '<') {
            parser.state = S.SCRIPT_ENDING
          } else {
            parser.script += c
          }
          continue

        case S.SCRIPT_ENDING:
          if (c === '/') {
            parser.state = S.CLOSE_TAG
          } else {
            parser.script += '<' + c
            parser.state = S.SCRIPT
          }
          continue

        case S.OPEN_WAKA:
          // either a /, ?, !, or text is coming next.
          if (c === '!') {
            parser.state = S.SGML_DECL
            parser.sgmlDecl = ''
          } else if (isWhitespace(c)) {
            // wait for it...
          } else if (isMatch(nameStart, c)) {
            parser.state = S.OPEN_TAG
            parser.tagName = c
          } else if (c === '/') {
            parser.state = S.CLOSE_TAG
            parser.tagName = ''
          } else if (c === '?') {
            parser.state = S.PROC_INST
            parser.procInstName = parser.procInstBody = ''
          } else {
            strictFail(parser, 'Unencoded <')
            // if there was some whitespace, then add that in.
            if (parser.startTagPosition + 1 < parser.position) {
              var pad = parser.position - parser.startTagPosition
              c = new Array(pad).join(' ') + c
            }
            parser.textNode += '<' + c
            parser.state = S.TEXT
          }
          continue

        case S.SGML_DECL:
          if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
            emitNode(parser, 'onopencdata')
            parser.state = S.CDATA
            parser.sgmlDecl = ''
            parser.cdata = ''
          } else if (parser.sgmlDecl + c === '--') {
            parser.state = S.COMMENT
            parser.comment = ''
            parser.sgmlDecl = ''
          } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
            parser.state = S.DOCTYPE
            if (parser.doctype || parser.sawRoot) {
              strictFail(parser,
                'Inappropriately located doctype declaration')
            }
            parser.doctype = ''
            parser.sgmlDecl = ''
          } else if (c === '>') {
            emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl)
            parser.sgmlDecl = ''
            parser.state = S.TEXT
          } else if (isQuote(c)) {
            parser.state = S.SGML_DECL_QUOTED
            parser.sgmlDecl += c
          } else {
            parser.sgmlDecl += c
          }
          continue

        case S.SGML_DECL_QUOTED:
          if (c === parser.q) {
            parser.state = S.SGML_DECL
            parser.q = ''
          }
          parser.sgmlDecl += c
          continue

        case S.DOCTYPE:
          if (c === '>') {
            parser.state = S.TEXT
            emitNode(parser, 'ondoctype', parser.doctype)
            parser.doctype = true // just remember that we saw it.
          } else {
            parser.doctype += c
            if (c === '[') {
              parser.state = S.DOCTYPE_DTD
            } else if (isQuote(c)) {
              parser.state = S.DOCTYPE_QUOTED
              parser.q = c
            }
          }
          continue

        case S.DOCTYPE_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.q = ''
            parser.state = S.DOCTYPE
          }
          continue

        case S.DOCTYPE_DTD:
          parser.doctype += c
          if (c === ']') {
            parser.state = S.DOCTYPE
          } else if (isQuote(c)) {
            parser.state = S.DOCTYPE_DTD_QUOTED
            parser.q = c
          }
          continue

        case S.DOCTYPE_DTD_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.state = S.DOCTYPE_DTD
            parser.q = ''
          }
          continue

        case S.COMMENT:
          if (c === '-') {
            parser.state = S.COMMENT_ENDING
          } else {
            parser.comment += c
          }
          continue

        case S.COMMENT_ENDING:
          if (c === '-') {
            parser.state = S.COMMENT_ENDED
            parser.comment = textopts(parser.opt, parser.comment)
            if (parser.comment) {
              emitNode(parser, 'oncomment', parser.comment)
            }
            parser.comment = ''
          } else {
            parser.comment += '-' + c
            parser.state = S.COMMENT
          }
          continue

        case S.COMMENT_ENDED:
          if (c !== '>') {
            strictFail(parser, 'Malformed comment')
            // allow <!-- blah -- bloo --> in non-strict mode,
            // which is a comment of " blah -- bloo "
            parser.comment += '--' + c
            parser.state = S.COMMENT
          } else {
            parser.state = S.TEXT
          }
          continue

        case S.CDATA:
          if (c === ']') {
            parser.state = S.CDATA_ENDING
          } else {
            parser.cdata += c
          }
          continue

        case S.CDATA_ENDING:
          if (c === ']') {
            parser.state = S.CDATA_ENDING_2
          } else {
            parser.cdata += ']' + c
            parser.state = S.CDATA
          }
          continue

        case S.CDATA_ENDING_2:
          if (c === '>') {
            if (parser.cdata) {
              emitNode(parser, 'oncdata', parser.cdata)
            }
            emitNode(parser, 'onclosecdata')
            parser.cdata = ''
            parser.state = S.TEXT
          } else if (c === ']') {
            parser.cdata += ']'
          } else {
            parser.cdata += ']]' + c
            parser.state = S.CDATA
          }
          continue

        case S.PROC_INST:
          if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else if (isWhitespace(c)) {
            parser.state = S.PROC_INST_BODY
          } else {
            parser.procInstName += c
          }
          continue

        case S.PROC_INST_BODY:
          if (!parser.procInstBody && isWhitespace(c)) {
            continue
          } else if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else {
            parser.procInstBody += c
          }
          continue

        case S.PROC_INST_ENDING:
          if (c === '>') {
            emitNode(parser, 'onprocessinginstruction', {
              name: parser.procInstName,
              body: parser.procInstBody
            })
            parser.procInstName = parser.procInstBody = ''
            parser.state = S.TEXT
          } else {
            parser.procInstBody += '?' + c
            parser.state = S.PROC_INST_BODY
          }
          continue

        case S.OPEN_TAG:
          if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else {
            newTag(parser)
            if (c === '>') {
              openTag(parser)
            } else if (c === '/') {
              parser.state = S.OPEN_TAG_SLASH
            } else {
              if (!isWhitespace(c)) {
                strictFail(parser, 'Invalid character in tag name')
              }
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.OPEN_TAG_SLASH:
          if (c === '>') {
            openTag(parser, true)
            closeTag(parser)
          } else {
            strictFail(parser, 'Forward-slash in opening tag not followed by >')
            parser.state = S.ATTRIB
          }
          continue

        case S.ATTRIB:
          // haven't read the attribute name yet.
          if (isWhitespace(c)) {
            continue
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (c === '>') {
            strictFail(parser, 'Attribute without value')
            parser.attribValue = parser.attribName
            attrib(parser)
            openTag(parser)
          } else if (isWhitespace(c)) {
            parser.state = S.ATTRIB_NAME_SAW_WHITE
          } else if (isMatch(nameBody, c)) {
            parser.attribName += c
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME_SAW_WHITE:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (isWhitespace(c)) {
            continue
          } else {
            strictFail(parser, 'Attribute without value')
            parser.tag.attributes[parser.attribName] = ''
            parser.attribValue = ''
            emitNode(parser, 'onattribute', {
              name: parser.attribName,
              value: ''
            })
            parser.attribName = ''
            if (c === '>') {
              openTag(parser)
            } else if (isMatch(nameStart, c)) {
              parser.attribName = c
              parser.state = S.ATTRIB_NAME
            } else {
              strictFail(parser, 'Invalid attribute name')
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.ATTRIB_VALUE:
          if (isWhitespace(c)) {
            continue
          } else if (isQuote(c)) {
            parser.q = c
            parser.state = S.ATTRIB_VALUE_QUOTED
          } else {
            strictFail(parser, 'Unquoted attribute value')
            parser.state = S.ATTRIB_VALUE_UNQUOTED
            parser.attribValue = c
          }
          continue

        case S.ATTRIB_VALUE_QUOTED:
          if (c !== parser.q) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_Q
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          parser.q = ''
          parser.state = S.ATTRIB_VALUE_CLOSED
          continue

        case S.ATTRIB_VALUE_CLOSED:
          if (isWhitespace(c)) {
            parser.state = S.ATTRIB
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            strictFail(parser, 'No whitespace between attributes')
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_VALUE_UNQUOTED:
          if (!isAttribEnd(c)) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_U
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          if (c === '>') {
            openTag(parser)
          } else {
            parser.state = S.ATTRIB
          }
          continue

        case S.CLOSE_TAG:
          if (!parser.tagName) {
            if (isWhitespace(c)) {
              continue
            } else if (notMatch(nameStart, c)) {
              if (parser.script) {
                parser.script += '</' + c
                parser.state = S.SCRIPT
              } else {
                strictFail(parser, 'Invalid tagname in closing tag.')
              }
            } else {
              parser.tagName = c
            }
          } else if (c === '>') {
            closeTag(parser)
          } else if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else if (parser.script) {
            parser.script += '</' + parser.tagName
            parser.tagName = ''
            parser.state = S.SCRIPT
          } else {
            if (!isWhitespace(c)) {
              strictFail(parser, 'Invalid tagname in closing tag')
            }
            parser.state = S.CLOSE_TAG_SAW_WHITE
          }
          continue

        case S.CLOSE_TAG_SAW_WHITE:
          if (isWhitespace(c)) {
            continue
          }
          if (c === '>') {
            closeTag(parser)
          } else {
            strictFail(parser, 'Invalid characters in closing tag')
          }
          continue

        case S.TEXT_ENTITY:
        case S.ATTRIB_VALUE_ENTITY_Q:
        case S.ATTRIB_VALUE_ENTITY_U:
          var returnState
          var buffer
          switch (parser.state) {
            case S.TEXT_ENTITY:
              returnState = S.TEXT
              buffer = 'textNode'
              break

            case S.ATTRIB_VALUE_ENTITY_Q:
              returnState = S.ATTRIB_VALUE_QUOTED
              buffer = 'attribValue'
              break

            case S.ATTRIB_VALUE_ENTITY_U:
              returnState = S.ATTRIB_VALUE_UNQUOTED
              buffer = 'attribValue'
              break
          }

          if (c === ';') {
            parser[buffer] += parseEntity(parser)
            parser.entity = ''
            parser.state = returnState
          } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) {
            parser.entity += c
          } else {
            strictFail(parser, 'Invalid character in entity name')
            parser[buffer] += '&' + parser.entity + c
            parser.entity = ''
            parser.state = returnState
          }

          continue

        default:
          throw new Error(parser, 'Unknown state: ' + parser.state)
      }
    } // while

    if (parser.position >= parser.bufferCheckPosition) {
      checkBufferLength(parser)
    }
    return parser
  }

  /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
  /* istanbul ignore next */
  if (!String.fromCodePoint) {
    (function () {
      var stringFromCharCode = String.fromCharCode
      var floor = Math.floor
      var fromCodePoint = function () {
        var MAX_SIZE = 0x4000
        var codeUnits = []
        var highSurrogate
        var lowSurrogate
        var index = -1
        var length = arguments.length
        if (!length) {
          return ''
        }
        var result = ''
        while (++index < length) {
          var codePoint = Number(arguments[index])
          if (
            !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
            codePoint < 0 || // not a valid Unicode code point
            codePoint > 0x10FFFF || // not a valid Unicode code point
            floor(codePoint) !== codePoint // not an integer
          ) {
            throw RangeError('Invalid code point: ' + codePoint)
          }
          if (codePoint <= 0xFFFF) { // BMP code point
            codeUnits.push(codePoint)
          } else { // Astral code point; split in surrogate halves
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            codePoint -= 0x10000
            highSurrogate = (codePoint >> 10) + 0xD800
            lowSurrogate = (codePoint % 0x400) + 0xDC00
            codeUnits.push(highSurrogate, lowSurrogate)
          }
          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
            result += stringFromCharCode.apply(null, codeUnits)
            codeUnits.length = 0
          }
        }
        return result
      }
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(String, 'fromCodePoint', {
          value: fromCodePoint,
          configurable: true,
          writable: true
        })
      } else {
        String.fromCodePoint = fromCodePoint
      }
    }())
  }
})( false ? this.sax = {} : exports)

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(136).Buffer))

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 853 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(183).EventEmitter;
var inherits = __webpack_require__(84);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(184);
Stream.Writable = __webpack_require__(862);
Stream.Duplex = __webpack_require__(863);
Stream.Transform = __webpack_require__(864);
Stream.PassThrough = __webpack_require__(865);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 855 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(138).Buffer;
var util = __webpack_require__(857);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 857 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(859);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37), __webpack_require__(104)))

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(304);

/*<replacement>*/
var util = __webpack_require__(107);
util.inherits = __webpack_require__(84);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(185);


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(69);


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(184).Transform


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(184).PassThrough


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var helper = __webpack_require__(187);
var xml2js = __webpack_require__(299);

function validateOptions (userOptions) {
  var options = helper.copyOptions(userOptions);
  helper.ensureSpacesExists(options);
  return options;
}

module.exports = function(xml, userOptions) {
  var options, js, json, parentKey;
  options = validateOptions(userOptions);
  js = xml2js(xml, options);
  parentKey = 'compact' in options && options.compact ? '_parent' : 'parent';
  // parentKey = ptions.compact ? '_parent' : 'parent'; // consider this
  if ('addParent' in options && options.addParent) {
    json = JSON.stringify(js, function (k, v) { return k === parentKey? '_' : v; }, options.spaces);
  } else {
    json = JSON.stringify(js, null, options.spaces);
  }
  return json.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
};


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var js2xml = __webpack_require__(305);

module.exports = function (json, options) {
  if (json instanceof Buffer) {
    json = json.toString();
  }
  var js = null;
  if (typeof (json) === 'string') {
    try {
      js = JSON.parse(json);
    } catch (e) {
      throw new Error('The JSON structure is invalid');
    }
  } else {
    js = json;
  }
  return js2xml(js, options);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(136).Buffer))

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SigningProgressModal__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_6" /* MODAL_SIGNING_ACCREDITATIONS_PROGRESS */],translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__SigningProgressModal__["a" /* default */]));

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SigningProgressModal_css__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SigningProgressModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SigningProgressModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SigningProgressModal=function(_Component){_inherits(SigningProgressModal,_Component);function SigningProgressModal(){_classCallCheck(this,SigningProgressModal);return _possibleConstructorReturn(this,(SigningProgressModal.__proto__||Object.getPrototypeOf(SigningProgressModal)).apply(this,arguments));}_createClass(SigningProgressModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen&&this.props.startSigning},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_jobs_list.signing_process_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_jobs_list.dont_close_tab_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},this.props.signed,'/',this.props.amount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["K" /* Progress */],{animated:true,color:'primary',max:this.props.amount,value:this.props.signed}))));}}]);return SigningProgressModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SigningProgressModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,amount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,signed:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,startSigning:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SigningProgressModal);

/***/ }),
/* 870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveBulkModal__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_bulk__ = __webpack_require__(139);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["Q" /* MODAL_REMOVE_BULK */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onBulkRemove:function onBulkRemove(bulkId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_bulk__["b" /* fetchRemoveBulk */])(bulkId));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RemoveBulkModal__["a" /* default */]));

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveBulkModal=function(_Component){_inherits(RemoveBulkModal,_Component);function RemoveBulkModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveBulkModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveBulkModal.__proto__||Object.getPrototypeOf(RemoveBulkModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleRemove=function(e){e.preventDefault();_this.props.onBulkRemove(_this.props.data.id);_this.props.onCancel();if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.onCancelRemoving)){_this.props.onCancelRemoving();}},_this.handleCancel=function(){_this.props.onCancel();if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.onCancelRemoving)){_this.props.onCancelRemoving();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveBulkModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'bulk-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_jobs_list.remove_bulk_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_jobs_list.remove_bulk_alert')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_jobs_list.file_name_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.fileName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_jobs_list.created_at_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.createdAt)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_jobs_list.entries_number_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.totalEntriesCount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button)))));}}]);return RemoveBulkModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveBulkModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onBulkRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelRemoving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveBulkModal);

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrgDetails__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_account_role__ = __webpack_require__(20);
var mapStateToProps=function mapStateToProps(state,_ref){var location=_ref.location;var orgData=Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["D" /* getOrgDataToEdit */])(state);return{id:__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search).id,labelPath:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(orgData)?'':__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["c" /* LABEL_PATH_BY_ORG_TYPE */][orgData.orgType],data:orgData,loading:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["O" /* loadingOrg */])(state),fetchingError:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["y" /* getFetchingErrorOrg */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["e" /* getCountriesData */])(state),subRoles:Object(__WEBPACK_IMPORTED_MODULE_8__reducers_account_role__["s" /* getSubRoles */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["k" /* fetchGetOrgDataById */])(id));},onSetContinent:function onSetContinent(continentCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onOrgEdit:function onOrgEdit(orgId,orgData){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["i" /* fetchEditOrg */])(orgId,orgData));},onAnchorEdit:function onAnchorEdit(orgId,anchorData){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["f" /* fetchChangeAnchorBySysAdmin */])(orgId,anchorData));},onMarkOrgAsBava:function onMarkOrgAsBava(orgId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["n" /* fetchMarkOrgAsBava */])(orgId));},onRemoveOrgBavaFlag:function onRemoveOrgBavaFlag(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["p" /* fetchRemoveOrgBavaFlag */])());},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["d" /* clearOrgData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["h" /* setCurrentContinent */])(''));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__OrgDetails__["a" /* default */]));

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrgDetails_css__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrgDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__OrgDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_pageNotFoundComponent_PageNotFoundComponent_container__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__certificatesManagement_orgCertificates_OrgCertificates_container__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_domainInput_DomainInput__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_account_role__ = __webpack_require__(20);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PATH_BY_FIELD_NAME={'hasIVs':'orgs.has_accreditation_groups_label','verifiesIdentities':'orgs.verifies_identities_label','providesMoocCertificates':'orgs.provides_mooc_certificates_label'};var ORG_EDIT_SUCCESS_MESSAGE='edit_org.org_edit_success_message';var ANCHOR_EDIT_SUCCESS_MESSAGE='edit_org.anchor_edit_success_message';var BAVA_ADD_SUCCESS_MESSAGE='edit_org.bava_set_success_message';var BAVA_REMOVE_SUCCESS_MESSAGE='edit_org.bava_removed_success_message';var requiredSelectFields=['orgCountry'];var OrgDetails=function(_Component){_inherits(OrgDetails,_Component);function OrgDetails(props){_classCallCheck(this,OrgDetails);var _this=_possibleConstructorReturn(this,(OrgDetails.__proto__||Object.getPrototypeOf(OrgDetails)).call(this,props));_this.renderBavaForm=function(){if(_this.props.subRoles&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_15__reducers_account_role__["c" /* SUB_ROLES */].ROOT)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:_this.onBavaEdit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'org-details-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'edit_org.bava_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox-group-container'},_this.renderBavaFormGroup()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{type:'submit',disabled:_this.saveButtonDisabled('orgBava'),className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button))));};_this.renderOrgCertificatesForm=function(){if(_this.props.subRoles&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_15__reducers_account_role__["c" /* SUB_ROLES */].ROOT)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_15__reducers_account_role__["c" /* SUB_ROLES */].PA)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'org-details-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'certificate.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__certificatesManagement_orgCertificates_OrgCertificates_container__["a" /* default */],{orgId:_this.props.id}));};_this.saveButtonDisabled=function(type){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNull(_this.props.data)){return true;}var keysList=[];switch(type){case'orgDetails':keysList=['orgType','orgName','orgDomain','orgVatNumber','companyCode','orgEmployeeCount','orgCountry','orgCity','orgPostal','orgStreet'].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["n" /* ORGANIZATION_AVAILABLE_FLAGS */]));break;case'orgBava':keysList=['isBava'];break;case'anchorDetails':keysList=['anchorEmail','anchorFirstName','anchorLastName'];break;default:break;}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.every(keysList,function(fieldKey){return _this.state[fieldKey]===_this.props.data[fieldKey];});};_this.renderOrganizationDataFormGroups=function(){var paramsList=[{value:"orgType",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.org_type_label'),type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["o" /* ORGANIZATION_TYPES */],function(value){return{code:value.code,name:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,value.name)};})),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'register_org.org_type_placeholder'),onChange:_this.handleChangeSelect('orgType')},{value:"orgName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.name_label')+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.name_label')},{value:"orgDomain",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label)},{value:"orgVatNumber",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.vat_number_label'),isRequired:false,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.vat_number_label')},{value:"companyCode",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.company_code_label'),isRequired:false,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.company_code_label')},{value:'orgEmployeeCount',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].employee_count_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["h" /* EMPLOYEES_COUNT_VALUES */],function(value){return{code:value.code,name:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,value.name)||value.name};})),isRequired:true,onChange:_this.handleChangeSelect('orgEmployeeCount')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderOrganizationAddressFormGroup=function(){var paramsList=[{value:"orgContinent",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label),onChange:_this.handleChangeContinent,type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),isDisabled:!_this.props.continents,isRequired:true},{value:"orgCountry",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),onChange:_this.handleChangeSelect('orgCountry'),type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isRequired:true,isDisabled:!_this.props.countries},{value:"orgCity",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.city_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.city_label')},{value:"orgPostal",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.postal_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.postal_label')},{value:"orgStreet",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.street_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.street_label')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderAnchorFormGroups=function(){var paramsList=[{value:"anchorEmail",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+"*",type:"email",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)},{value:"anchorFirstName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)},{value:"anchorLastName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderCheckboxes=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["n" /* ORGANIZATION_AVAILABLE_FLAGS */],function(flag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{key:flag,className:'checkbox-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'checkbox-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{className:'checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'checkbox',checked:_this.state[flag],onChange:_this.toggleCheckbox(flag)}),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,PATH_BY_FIELD_NAME[flag]))));});};_this.renderPermissionsFormGroup=function(){var paramsList=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["n" /* ORGANIZATION_AVAILABLE_FLAGS */],function(flag){return{value:flag,title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,PATH_BY_FIELD_NAME[flag])};});return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getCheckboxFormGroup)));};_this.renderBavaFormGroup=function(){var params={value:'isBava',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'edit_org.bava_organization_label')};return _this.getCheckboxFormGroup(params);};_this.getCheckboxFormGroup=function(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{key:params.value,className:'checkbox-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'checkbox-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{className:'checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'checkbox',checked:_this.state[params.value],disabled:params.isDisabled,onChange:_this.toggleCheckbox(params.value)}),params.title)));};_this.getFormGroup=function(params){if(params.type==='select'){return _this.getSelectFormGroup(params);}if(params.value==='orgDomain'){return _this.getOrganizationDomainFormGroup(params);}if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this.renderPopover(params),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:_this.state[params.value],onChange:params.onChange||_this.handleChange(params.value),placeholder:params.placeholder,disabled:params.isDisabled,required:params.isRequired},params.content)));};_this.getOrganizationDomainFormGroup=function(params){var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this.renderPopover(params),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_domainInput_DomainInput__["a" /* default */],{id:id,value:_this.state[params.value],onChange:_this.handleChangeDomainInput,placeholder:params.placeholder||params.title,disabled:params.isDisabled,required:params.isRequired})));};_this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];}),options:params.content,onSelect:params.onChange,placeholder:params.placeholder,disabled:params.isDisabled,requiredFieldError:_this.state.requiredFieldError===params.value})));};_this.renderPopover=function(params){var hintText='';var id='validate-org-';switch(params.value){case'orgDomain':id+='domain-hint-container';hintText=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'register_org.domain_hint');break;case'companyCode':id+='company-code-hint-container';hintText=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'register_org.company_code_hint');break;default:return;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validate-org-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:id,className:'validate-org-icon-container',onClick:_this.togglePopover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["H" /* Popover */],{placement:'bottom',isOpen:_this.state.popoverOpen===params.value,target:id,toggle:_this.togglePopover(params.value)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["I" /* PopoverBody */],null,hintText)));};_this.togglePopover=function(type){return function(){if(_this.state.popoverOpen===type){_this.setState({popoverOpen:null});}else{_this.setState({popoverOpen:type});}};};_this.handleChangeSelect=function(fieldKey){return function(selectedOption){_this.setState(_defineProperty({},fieldKey,selectedOption.value));};};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleChangeDomainInput=function(data){_this.setState({orgDomain:data});};_this.toggleCheckbox=function(fieldKey){return function(){_this.setState(_defineProperty({},fieldKey,!_this.state[fieldKey]));};};_this.handleChangeContinent=function(selectedOption){_this.props.onSetContinent(selectedOption.value);_this.setState({orgCountry:''});};_this.onAnchorEdit=function(e){e.preventDefault();var data={email:_this.state.anchorEmail,identityAlias:{firstName:_this.state.anchorFirstName,lastName:_this.state.anchorLastName,countryCode:_this.state.orgCountry}};_this.setState({successMessage:ANCHOR_EDIT_SUCCESS_MESSAGE});_this.props.onAnchorEdit(_this.props.id,data);};_this.onOrgEdit=function(e){e.preventDefault();if(_this.checkRequiredSelectFields()){return;}var data={type:_this.state.orgType,name:_this.state.orgName,domain:_this.state.orgDomain,address:{countryCode:_this.state.orgCountry,city:_this.state.orgCity,postal:_this.state.orgPostal,street:_this.state.orgStreet},vatNumber:_this.state.orgVatNumber,companyCode:_this.state.companyCode,anchor:{email:_this.state.anchorEmail,identityAlias:{firstName:_this.state.anchorFirstName,lastName:_this.state.anchorLastName}},hasIVs:_this.state.hasIVs,verifiesIdentities:_this.state.hasIVs,providesMoocCertificates:_this.state.providesMoocCertificates,employeeCount:_this.state.orgEmployeeCount,validated:true};_this.setState({successMessage:ORG_EDIT_SUCCESS_MESSAGE});_this.props.onOrgEdit(_this.props.id,data);};_this.onBavaEdit=function(e){e.preventDefault();if(_this.state.isBava){_this.setState({successMessage:BAVA_ADD_SUCCESS_MESSAGE});_this.props.onMarkOrgAsBava(_this.props.id);}else{_this.setState({successMessage:BAVA_REMOVE_SUCCESS_MESSAGE});_this.props.onRemoveOrgBavaFlag();}};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(requiredSelectFields,function(field){if(!_this.state[field]&&!error){error=field;}});_this.setState({requiredFieldError:error});return error;};_this.state={orgType:'',orgName:'',orgDomain:'',orgVatNumber:'',companyCode:'',orgContinent:_this.props.continentCode,orgEmployeeCount:'UNKNOWN',orgCountry:'',orgCity:'',orgPostal:'',orgStreet:'',orgStreetNumber:'',orgBusNumber:'',anchorFirstName:'',anchorLastName:'',anchorEmail:'',hasIVs:true,providesMoocCertificates:false,isBava:false,successMessage:'',requiredFieldError:null,popoverOpen:null};return _this;}_createClass(OrgDetails,[{key:'componentWillMount',value:function componentWillMount(){this.props.onMount(this.props.id);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.state.orgContinent!==nextProps.continentCode){this.setState({orgContinent:nextProps.continentCode});}if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.data)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(nextProps.data,this.props.data)){this.setState(Object.assign({},nextProps.data));this.props.onSetContinent(nextProps.data.orgContinent);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}},{key:'render',value:function render(){if(this.props.fetchingError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_pageNotFoundComponent_PageNotFoundComponent_container__["a" /* default */],null);}if(this.props.loading&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-details-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,this.state.successMessage)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-details-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/organizations',label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'edit_org.back_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */][this.props.labelPath]),': ',__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)?'':this.props.data.orgName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.onOrgEdit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'org-details-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.org_label')),this.renderOrganizationDataFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.address_label')),this.renderOrganizationAddressFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'checkbox-group-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.permissions_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox-group-container'},this.renderPermissionsFormGroup()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{type:'submit',disabled:this.saveButtonDisabled('orgDetails'),className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button)))),this.renderBavaForm(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.onAnchorEdit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'org-details-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.anchor_label')),this.renderAnchorFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{type:'submit',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'edit_org.edit_anchor_alert'),disabled:this.saveButtonDisabled('anchorDetails'),className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'edit_org.edit_anchor_button')))),this.renderOrgCertificatesForm())));}}]);return OrgDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OrgDetails.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,labelPath:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,fetchingError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,continentCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,subRoles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onSetContinent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onOrgEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onAnchorEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onMarkOrgAsBava:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onRemoveOrgBavaFlag:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUnmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (OrgDetails);

/***/ }),
/* 876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrgCertificates__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_organization_orgCertificate__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_organizations__ = __webpack_require__(30);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),fetching:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_orgCertificate__["l" /* loadingCertificate */])(state),certificates:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_orgCertificate__["k" /* getOrgCertificates */])(state),permissions:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organizations__["H" /* getOrgPermissionsData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGetOrgCertificates:function onGetOrgCertificates(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_orgCertificate__["e" /* fetchGetOrgCertificates */])(data));},onAddCertificate:function onAddCertificate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["g" /* MODAL_ADD_CERTIFICATE */]}));},onRemoveCertificate:function onRemoveCertificate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["T" /* MODAL_REMOVE_CERTIFICATE */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__OrgCertificates__["a" /* default */]));

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrgCertificates_css__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrgCertificates_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__OrgCertificates_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addCertificateModal_AddOrgCertificateModal_container__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__removeCertificateModal_RemoveOrgCertificateModal_container__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrgCertificates=function(_Component){_inherits(OrgCertificates,_Component);function OrgCertificates(props){_classCallCheck(this,OrgCertificates);var _this=_possibleConstructorReturn(this,(OrgCertificates.__proto__||Object.getPrototypeOf(OrgCertificates)).call(this,props));_this.renderCertificates=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["N" /* Table */],{className:'org-certificates-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'certificate.created_at_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'certificate.valid_from_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'certificate.valid_till_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderCertificatesData()));};_this.renderCertificatesData=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_this.props.certificates,function(certificateData,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'org-certificate-created-at-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'certificate.valid_till_label')+":"},__WEBPACK_IMPORTED_MODULE_9_moment___default()(certificateData.createdAt).format("MMMM Do YYYY, HH:mm")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'org-certificate-valid-from-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'certificate.valid_from_label')+":"},__WEBPACK_IMPORTED_MODULE_9_moment___default()(certificateData.validFrom).format("MMMM Do YYYY, HH:mm")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'org-certificate-valid-till-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'certificate.valid_till_label')+":"},__WEBPACK_IMPORTED_MODULE_9_moment___default()(certificateData.validTill).format("MMMM Do YYYY, HH:mm")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'org-certificate-remove-icon-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:index,icon:'trash',className:'org-certificate-remove-icon',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button),onClick:_this.onRemoveCertificate(certificateData.id)})));});};_this.onRemoveCertificate=function(certId){return function(){_this.setState({certId:certId});_this.props.onRemoveCertificate();};};_this.state={certId:null};return _this;}_createClass(OrgCertificates,[{key:'componentWillMount',value:function componentWillMount(){this.props.onGetOrgCertificates(this.props.orgId);}},{key:'render',value:function render(){if(this.props.fetching){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}if(this.props.permissions&&!this.props.permissions.hasIVs&&!this.props.permissions.providesMoocCertificates){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'certificate.no_certificates_needed_label'));}if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.certificates)){if(this.props.certificates.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"certificate.no_org_certificate_label_start"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/security'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"certificate.no_org_certificate_label_link")),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"certificate.no_org_certificate_label_end"));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-certificates-container'},this.renderCertificates(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-org-certificate-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.props.onAddCertificate},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].add_button))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__addCertificateModal_AddOrgCertificateModal_container__["a" /* default */],{orgId:this.props.orgId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__removeCertificateModal_RemoveOrgCertificateModal_container__["a" /* default */],{certId:this.state.certId,orgId:this.props.orgId}));}}else{return null;}}}]);return OrgCertificates;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OrgCertificates.propTypes={orgId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,certificates:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onGetOrgCertificates:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onAddCertificate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onRemoveCertificate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (OrgCertificates);

/***/ }),
/* 879 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddCertificateModal__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_orgCertificate__ = __webpack_require__(58);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["g" /* MODAL_ADD_CERTIFICATE */],translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAddCertificate:function onAddCertificate(data,orgId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_orgCertificate__["c" /* fetchAddOrgCertificate */])(orgId,data));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onSetLoading:function onSetLoading(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["b" /* fetchSubmitForm */])());},onStopLoading:function onStopLoading(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AddCertificateModal__["a" /* default */]));

/***/ }),
/* 881 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RemoveCertificateModal__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_orgCertificate__ = __webpack_require__(58);
var mapStateToProps=function mapStateToProps(state,_ref){var certId=_ref.certId;return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["T" /* MODAL_REMOVE_CERTIFICATE */],translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state),certificate:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_orgCertificate__["j" /* getOrgCertificateDataById */])(state,certId)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onRemoveCertificate:function onRemoveCertificate(certId,orgId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_orgCertificate__["g" /* fetchRemoveOrgCertificate */])(orgId,certId));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__RemoveCertificateModal__["a" /* default */]));

/***/ }),
/* 883 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_levels__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_titleLangs__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BulkFileFormatDetails__ = __webpack_require__(885);
var mapStateToProps=function mapStateToProps(state){return{levels:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_levels__["c" /* getLevelsData */])(state),langs:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_titleLangs__["c" /* getOptionalTitleLangsData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_levels__["b" /* fetchGetLevels */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_titleLangs__["b" /* fetchGetTitleLangs */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__BulkFileFormatDetails__["a" /* default */]));

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BulkFileFormatDetails_css__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BulkFileFormatDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BulkFileFormatDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CSVFileFormatDetails_CSVFileFormatDetails_container__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__XMLFileFormatDetails_XMLFileFormatDetails_container__ = __webpack_require__(890);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AVAILABLE_FILE_FORMAT_PAGES={CSV_FILE_FORMAT_PAGE:"csv_file_format_page",XML_FILE_FORMAT_PAGE:"xml_file_format_page"};var BulkFileFormatDetails=function(_Component){_inherits(BulkFileFormatDetails,_Component);function BulkFileFormatDetails(props){_classCallCheck(this,BulkFileFormatDetails);var _this=_possibleConstructorReturn(this,(BulkFileFormatDetails.__proto__||Object.getPrototypeOf(BulkFileFormatDetails)).call(this,props));_this.renderCurrentPage=function(){switch(_this.state.currentPage){case AVAILABLE_FILE_FORMAT_PAGES.CSV_FILE_FORMAT_PAGE:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CSVFileFormatDetails_CSVFileFormatDetails_container__["a" /* default */],null);case AVAILABLE_FILE_FORMAT_PAGES.XML_FILE_FORMAT_PAGE:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__XMLFileFormatDetails_XMLFileFormatDetails_container__["a" /* default */],null);default:return null;}};_this.renderLevelsCodesTable=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["N" /* Table */],{bordered:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.code_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.mean_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderLevelsData()));};_this.renderAdditionalTitlesTable=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["N" /* Table */],{bordered:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.code_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'accreditation.language_input_placeholder')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderLangsData()));};_this.renderLangsData=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_this.props.langs,function(lang,id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,lang),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'langs.'+lang)));});};_this.renderLevelsData=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_this.props.levels,function(level,id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,level),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'levels.'+level)));});};_this.handleChangePage=function(page){return function(){_this.setState({currentPage:page});};};_this.state={currentPage:AVAILABLE_FILE_FORMAT_PAGES.XML_FILE_FORMAT_PAGE};return _this;}_createClass(BulkFileFormatDetails,[{key:'componentWillMount',value:function componentWillMount(){this.props.onMount();}},{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.langs)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.levels)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-file-format-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/bulk-accreditations-upload',label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.back_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_upload.file_format_info_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["y" /* Nav */],{pills:true,className:'bulk-file-format-details-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["z" /* NavItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["A" /* NavLink */],{href:'#',onClick:this.handleChangePage(AVAILABLE_FILE_FORMAT_PAGES.CSV_FILE_FORMAT_PAGE),active:this.state.currentPage===AVAILABLE_FILE_FORMAT_PAGES.CSV_FILE_FORMAT_PAGE},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.csv_file_format_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["z" /* NavItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["A" /* NavLink */],{href:'#',onClick:this.handleChangePage(AVAILABLE_FILE_FORMAT_PAGES.XML_FILE_FORMAT_PAGE),active:this.state.currentPage===AVAILABLE_FILE_FORMAT_PAGES.XML_FILE_FORMAT_PAGE},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.xml_file_format_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["a" /* Alert */],{color:'warning'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.liaise_it_staff')),this.renderCurrentPage(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["L" /* Row */],{className:'bulk-csv-file-format-levels-titles-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.levels_label')),this.renderLevelsCodesTable()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.titles_label')),this.renderAdditionalTitlesTable())));}}]);return BulkFileFormatDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BulkFileFormatDetails.propTypes={levels:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,langs:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,onMount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (BulkFileFormatDetails);

/***/ }),
/* 886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CSVFileFormatDetails__ = __webpack_require__(888);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__CSVFileFormatDetails__["a" /* default */]));

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CSVFileFormatDetails_css__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CSVFileFormatDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CSVFileFormatDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BULK_FILE_EXAMPLE=["email,firstName,lastName,countryCode,nationalId,issuedAt,level,original,en,fr,nl\n","june.rogers@email.com,June,Rogers,CA,836154446309,2017-05-01,MASTER,Original title,English title,Titre français,Nederlandse titel\n","dean.arnold@email.com,Dean,Arnold,US,289298416441,2017-09-15,POST_GRADUATE,Original title,English title,,Nederlandse titel\n","terry.mullins@email.com,Terry,Mullins,GB,273822698758,2012-12-12,TECHNICAL,Original title,English title,Titre français,Nederlandse titel\n","velma.walsh@email.com,Velma,Walsh,FR,627573870715,2007-06-25,PHD,Original title,English title,Titre français,Nederlandse titel\n","kelly.larson@email.com,Kelly,Larson,DE,622358932838,2004-03-07,BACHELOR,Original title,English title,Titre français,Nederlandse titel"];var VALUES_DETAILS=[{name:"email",isRequired:"no_label",mean:"email_mean_label",format:"email_format"},{name:"firstName",isRequired:"yes_label",mean:"first_name_mean_label",format:"string_format"},{name:"lastName",isRequired:"yes_label",mean:"last_name_mean_label",format:"string_format"},{name:"countryCode",isRequired:"yes_label",mean:"country_code_mean_label",format:"country_code_format"},{name:"nationalId",isRequired:"yes_label",mean:"national_id_mean_label",format:"string_format"},{name:"issuedAt",isRequired:"yes_label",mean:"date_issued_mean_label",format:"date_format"},{name:"level",isRequired:"yes_label",mean:"level_mean_label",format:"level_format"},{name:"original",isRequired:"yes_label",mean:"original_mean_label",format:"string_format"},{name:"en",isRequired:"yes_label",mean:"en_mean_label",format:"string_format"},{name:"lang_code",isRequired:"no_label",mean:"lang_code_mean_label",format:"string_format"}];var CSVFileFormatDetails=function(_Component){_inherits(CSVFileFormatDetails,_Component);function CSVFileFormatDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CSVFileFormatDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CSVFileFormatDetails.__proto__||Object.getPrototypeOf(CSVFileFormatDetails)).call.apply(_ref,[this].concat(args))),_this),_this.renderValueDetailsTable=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["N" /* Table */],{className:'bulk-csv-values-details-table',bordered:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.header_name_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.required_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.mean_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.format_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderValuesDetailsData()));},_this.renderValuesDetailsData=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(VALUES_DETAILS,function(elem,id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'header-codes-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.header_name_label')+":"},elem.name==="lang_code"?"["+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.language_code_label')+"]":elem.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'required-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.required_label')+":"},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */][elem.isRequired])+(elem.name==="email"?" (*)":"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'mean-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.mean_label')+":"},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,"bulk_file_format_details."+elem.mean)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'format-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.format_label')+":"},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,"bulk_file_format_details."+elem.format)));});},_this.getFileExampleText=function(){var result=[];BULK_FILE_EXAMPLE.forEach(function(row,id){result.push(row);result.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:id}));});return result;},_this.downloadCSVFile=function(){var element=document.createElement("a");var file=new Blob(BULK_FILE_EXAMPLE,{type:'text/csv'});element.href=URL.createObjectURL(file);element.download="bulk_csv_file_example.csv";element.click();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CSVFileFormatDetails,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-csv-file-format-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-csv-file-format-info'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.use_csv_message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.csv_file_example_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-csv-file-example'},this.getFileExampleText()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-csv-example-download-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["c" /* Button */],{onClick:this.downloadCSVFile},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.download_example_button'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-csv-file-format-info'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.file_header_message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-csv-file-format-info bulk-header-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'optional-field'},"email"),",firstName,lastName,countryCode,nationalId,issuedAt,level,original,en",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'optional-field'},',',__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.additional_titles_label')),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-csv-file-format-info'},'(',__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.optional-fields-highlighted-label')+' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'optional-field'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.gray_label')),'.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-csv-file-format-info'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.provide_data_message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'bulk-csv-file-format-requirements-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'bulk-csv-file-format-info'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.applicant_data_message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'bulk-csv-file-format-info'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.accreditation_data_message'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-csv-file-format-info'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.file_entries_message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center bulk-csv-file-format-values-detail-header'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.values_details_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-csv-file-format-info'},"*"+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.email_details')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-csv-file-format-info'},"**"+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.date_issued_details')),this.renderValueDetailsTable());}}]);return CSVFileFormatDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CSVFileFormatDetails.propTypes={translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CSVFileFormatDetails);

/***/ }),
/* 889 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__XMLFileFormatDetails__ = __webpack_require__(891);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__XMLFileFormatDetails__["a" /* default */]));

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__XMLFileFormatDetails_css__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__XMLFileFormatDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__XMLFileFormatDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BULK_FILE_EXAMPLE=["<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n","<accreditations xmlns=\"http://www.wickedware.eu/xmlschemas\">\n","\t<accreditation>\n","\t\t<email>test@test.com</email>\n","\t\t<firstName>Test</firstName>\n","\t\t<lastName>Testovich</lastName>\n","\t\t<countryCode>BY</countryCode>\n","\t\t<nationalId>MP1112233</nationalId>\n","\t\t<issuedAt>2018-01-30</issuedAt>\n","\t\t<level>BACHELOR</level>\n","\t\t<titles>\n","\t\t\t<title language=\"original\">Test Accreditation</title>\n","\t\t\t<title language=\"en\">Test Accreditation</title>\n","\t\t\t<title language=\"fr\">Test d'accréditation</title>\n","\t\t</titles>\n","\t</accreditation>\n","\t<accreditation>\n","\t\t<email>test@test.by</email>\n","\t\t<firstName>Test</firstName>\n","\t\t<lastName>Testovich</lastName>\n","\t\t<countryCode>BY</countryCode>\n","\t\t<nationalId>MP1112233</nationalId>\n","\t\t<issuedAt>2018-01-30</issuedAt>\n","\t\t<level>BACHELOR</level>\n","\t\t<titles>\n","\t\t\t<title language=\"original\">Test Accreditation</title>\n","\t\t\t<title language=\"en\">Test Accreditation</title>\n","\t\t</titles>\n","\t</accreditation>\n","</accreditations>"];var VALUES_DETAILS=[{name:"accreditations",isRequired:"yes_label",mean:"accreditations_meaning_label",format:"<accreditation>\n\t...\n</accreditation>\n...\n<accreditation>\n\t...\n</accreditation>"},{name:"accreditation",isRequired:"no_label",mean:"accreditation_meaning_label",format:"<email>...</email>\n"+"<firstName>...</firstName>\n"+"<lastName>...</lastName>\n"+"<countryCode>...</countryCode>\n"+"<nationalId>...</nationalId>\n"+"<issuedAt>...</issuedAt>\n"+"<level>...</level>\n"+"<titles>...</titles>"},{name:"email",isRequired:"no_label",mean:"email_mean_label",format:"email_format"},{name:"firstName",isRequired:"yes_label",mean:"first_name_mean_label",format:"string_format"},{name:"lastName",isRequired:"yes_label",mean:"last_name_mean_label",format:"string_format"},{name:"countryCode",isRequired:"yes_label",mean:"country_code_mean_label",format:"country_code_format"},{name:"nationalId",isRequired:"yes_label",mean:"national_id_mean_label",format:"string_format"},{name:"issuedAt",isRequired:"yes_label",mean:"date_issued_mean_label",format:"date_format"},{name:"level",isRequired:"yes_label",mean:"level_mean_label",format:"level_format"},{name:"titles",isRequired:"yes_label",mean:"titles_meaning_label",format:"<title language=\"...\">...</title>\n\t...\n<title language=\"...\">...</title>"},{name:"title",isRequired:"yes_label",attributes:["language"],mean:"title_meaning_label",format:"string_format"}];var XMLFileFormatDetails=function(_Component){_inherits(XMLFileFormatDetails,_Component);function XMLFileFormatDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,XMLFileFormatDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=XMLFileFormatDetails.__proto__||Object.getPrototypeOf(XMLFileFormatDetails)).call.apply(_ref,[this].concat(args))),_this),_this.renderValueDetailsTable=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["N" /* Table */],{className:'bulk-xml-values-details-table',bordered:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.tag_name_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.required_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.attributes_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.mean_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.format_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderValuesDetailsData()));},_this.renderValuesDetailsData=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(VALUES_DETAILS,function(elem,id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'tags-codes-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.tag_name_label')+":"},elem.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'required-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.required_label')+":"},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */][elem.isRequired])+(elem.name==="email"?" (*)":"")+(elem.name==="title"?" (***)":"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'attributes-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.attributes_label')+":"},elem.attributes?elem.attributes.join(','):'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'mean-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.mean_label')+":"},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,"bulk_file_format_details."+elem.mean)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'format-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.format_label')+":"},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,"bulk_file_format_details."+elem.format)||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre',null,elem.format)));});},_this.getFileExampleText=function(){var result=[];BULK_FILE_EXAMPLE.forEach(function(row){result.push(row);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre',null,result);},_this.downloadXMLFile=function(){var element=document.createElement("a");var file=new Blob(BULK_FILE_EXAMPLE,{type:'application/xml'});element.href=URL.createObjectURL(file);element.download="bulk_xml_file_example.xml";element.click();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(XMLFileFormatDetails,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-xml-file-format-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-xml-file-format-info'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.use_xml_message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.xml_file_example_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-xml-file-example'},this.getFileExampleText()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-xml-example-download-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["c" /* Button */],{onClick:this.downloadXMLFile},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.download_example_button'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-xml-file-format-info'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.file_header_message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-xml-file-format-info bulk-header-list'},'<?xml version="1.0" encoding="UTF-8"?>'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-xml-file-format-info'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.then_provide_message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'bulk-xml-file-format-requirements-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'bulk-xml-file-format-info'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.applicant_data_message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'bulk-xml-file-format-info'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.accreditation_data_message'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center bulk-xml-file-format-values-detail-header'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.values_details_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-xml-file-format-info'},"*"+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.email_details')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-xml-file-format-info'},"**"+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.date_issued_details')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-xml-file-format-info'},"***"+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_file_format_details.title_details')),this.renderValueDetailsTable());}}]);return XMLFileFormatDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);XMLFileFormatDetails.propTypes={translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (XMLFileFormatDetails);

/***/ }),
/* 892 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrgsToValidateList__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_account_role__ = __webpack_require__(20);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["P" /* loadingOrgs */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["A" /* getNotValidatedOrgsData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),subRoles:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_account_role__["s" /* getSubRoles */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["S" /* resetTotalElementsForNotValidated */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["j" /* fetchGetNotValidatedOrgs */])());},onStartValidation:function onStartValidation(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["U" /* startOrgValidation */])(id));},onRemoveOrg:function onRemoveOrg(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["Z" /* MODAL_REMOVE_ORG */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__OrgsToValidateList__["a" /* default */]));

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrgsToValidateList_css__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrgsToValidateList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OrgsToValidateList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_paginationComponent_PaginationOrgs_container__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__removeOrgModal_RemoveOrgModal_container__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducers_account_role__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrgsToValidateList=function(_Component){_inherits(OrgsToValidateList,_Component);function OrgsToValidateList(props){_classCallCheck(this,OrgsToValidateList);var _this=_possibleConstructorReturn(this,(OrgsToValidateList.__proto__||Object.getPrototypeOf(OrgsToValidateList)).call(this,props));_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-to-validate-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-to-validate-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.no_data_to_validate_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["N" /* Table */],{className:'orgs-to-validate-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.org_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.org_type_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.anchor_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.location_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.validate_org_progress_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_12__reducers_account_role__["c" /* SUB_ROLES */].ROOT)||_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_12__reducers_account_role__["c" /* SUB_ROLES */].FA)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderOrgsData()));};_this.renderOrgsData=function(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(_this.props.data,function(orgData,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'orgs-to-validate-list-row '+(orgData.active?'':'not-active'),key:index,onClick:_this.handleTableRowClick(orgData.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'org-to-validate-name-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.org_label')+':'},orgData.orgName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'org-to-validate-type-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.org_type_label')+':'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */][__WEBPACK_IMPORTED_MODULE_6__reducers_organization_organizations__["c" /* LABEL_PATH_BY_ORG_TYPE */][orgData.orgType]])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'org-to-validate-anchor-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.anchor_label')+':'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,orgData.anchorName+'\n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:_this.handleMailtoLinkClick,href:'mailto:'+orgData.anchorEmail},orgData.anchorEmail)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'org-to-validate-location-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.location_label')+':'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'countries.'+orgData.location)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'org-to-validate-status-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.validate_org_progress_label')+':'},_this.getStatusLabel(orgData)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'validate-organization-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{className:'btn-sm',color:'link'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.inspect_organization_button'))),_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_12__reducers_account_role__["c" /* SUB_ROLES */].ROOT)||_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_12__reducers_account_role__["c" /* SUB_ROLES */].FA)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'orgs-list-to-validate-remove-icon-td',onClick:_this.handleRemoveButtonClick(orgData)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:'trash'+index,icon:'trash',className:'orgs-list-to-validate-remove-icon',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button)})):null);});};_this.getStatusLabel=function(orgData){var labels=[];if(orgData.generalDataValidated){labels.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Badge */],{key:'general_data_validated'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.general_data_validated')));}if(orgData.financialDataValidated){labels.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Badge */],{key:'financial_data_validated'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.financial_data_validated')));}return labels;};_this.handleTableRowClick=function(id){return function(){_this.props.onStartValidation(id);_this.setState({validate:true});};};_this.handleMailtoLinkClick=function(e){e.stopPropagation();};_this.handleRemoveButtonClick=function(data){return function(e){e.stopPropagation();_this.setState({selectedOrgData:data});_this.props.onRemoveOrg();};};_this.state={validate:false,selectedRowData:null};return _this;}_createClass(OrgsToValidateList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'render',value:function render(){if(this.state.validate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["d" /* Redirect */],{to:'/validate-organization',push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-to-validate-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'orgs.remove_org_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'orgs.validate_organizations_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_paginationComponent_PaginationOrgs_container__["a" /* default */],null),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__removeOrgModal_RemoveOrgModal_container__["a" /* default */],{data:this.state.selectedOrgData})));}}]);return OrgsToValidateList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var OrgShape=__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,anchorName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,anchorEmail:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,active:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,location:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,orgName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired});OrgsToValidateList.propTypes={translation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,loading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(OrgShape),subRoles:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,onMount:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onStartValidation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onRemoveOrg:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (OrgsToValidateList);

/***/ }),
/* 895 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidateOrg__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_finance_finance__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_account_role__ = __webpack_require__(20);
var mapStateToProps=function mapStateToProps(state){return{id:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__["u" /* getCurrentOrgId */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__["D" /* getOrgDataToEdit */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["e" /* getCountriesData */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__["P" /* loadingOrgs */])(state),subRoles:Object(__WEBPACK_IMPORTED_MODULE_8__reducers_account_role__["s" /* getSubRoles */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onShowValidateOrgModal:function onShowValidateOrgModal(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_6__reducers_common_activeModal__["_13" /* MODAL_VALIDATE_PENDING_ORGANIZATION */]}));},onSetDefaultCurrencyAndPricingPreset:function onSetDefaultCurrencyAndPricingPreset(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_finance_finance__["i" /* setDefaultCurrencyAndPricingPreset */])());},onLoadOrg:function onLoadOrg(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__["l" /* fetchGetOrgDataForValidateById */])(id));},onSetContinent:function onSetContinent(continentCode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onValidate:function onValidate(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__["s" /* fetchValidateOrg */])(id));},onNext:function onNext(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__["R" /* onSetNextOrg */])());},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__["d" /* clearOrgData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["h" /* setCurrentContinent */])(''));},onResetSubmitFormData:function onResetSubmitFormData(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onUpdateGeneralData:function onUpdateGeneralData(id,data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__["q" /* fetchUpdateNotValidatedOrgGeneralData */])(id,data));},onAnchorEdit:function onAnchorEdit(id,data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__["g" /* fetchChangeAnchorBySysAdminForNotValidatedOrg */])(id,data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__ValidateOrg__["a" /* default */]));

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ValidateOrg_css__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ValidateOrg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ValidateOrg_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_progressBar_ValidateOrgsProgressBar_container__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_domainInput_DomainInput__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_labelWithPages_ValidateOrgLabel_container__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__validatePendingOrgModal_ValidatePendingOrgModal_container__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__orgFinanceManagement_OrgFinanceManagement_container__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__orgFinanceManagement_OrgFinanceManagement__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__reducers_account_role__ = __webpack_require__(20);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fields=['orgType','orgName','orgDomain','orgVatNumber','companyCode','orgContinent','orgEmployeeCount','orgCountry','orgCity','orgPostal','orgStreet','anchorFirstName','anchorLastName','anchorEmail','hasIVs','verifiesIdentities','providesMoocCertificates'];var requiredSelectFields=['orgCountry'];var ORG_EDIT_SUCCESS_MESSAGE='edit_org.org_edit_success_message';var ANCHOR_EDIT_SUCCESS_MESSAGE='edit_org.anchor_edit_success_message';var ORG_VALIDATED_SUCCESS_MESSAGE='orgs.validate_org_success_message';var ValidateOrg=function(_Component){_inherits(ValidateOrg,_Component);function ValidateOrg(props){_classCallCheck(this,ValidateOrg);var _this=_possibleConstructorReturn(this,(ValidateOrg.__proto__||Object.getPrototypeOf(ValidateOrg)).call(this,props));_this.loadOrg=function(id){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(id)){_this.props.onLoadOrg(id);}};_this.renderContent=function(){if(_this.props.loading||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'next-org-for-validate-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'next-org-for-validate-button',color:'link',onClick:_this.handleNextButtonClick},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.next_org_button'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:_this.onUpdateOrgData},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'validate-org-details-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.org_label')),_this.renderOrganizationDataFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.address_label')),_this.renderOrganizationAddressFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'checkbox-group-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.permissions_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox-group-container'},_this.renderCheckboxes()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'update-buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn',disabled:_this.isUpdateButtonDisabled('orgDetails')},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'shared.save_changes_button')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:_this.onAnchorEdit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'validate-org-details-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.anchor_label')),_this.renderAnchorFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'update-buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{type:'submit',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'edit_org.edit_anchor_alert'),disabled:_this.isUpdateButtonDisabled('anchorDetails'),className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'edit_org.edit_anchor_button')))),_this.renderFinanceManagementComponent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validate-buttons-group'},_this.renderValidateButton()));};_this.renderValidateButton=function(){var data=_this.props.data;var subRoles=_this.props.subRoles;if(subRoles.includes(__WEBPACK_IMPORTED_MODULE_19__reducers_account_role__["c" /* SUB_ROLES */].PA)&&!data.generalDataValidated||subRoles.includes(__WEBPACK_IMPORTED_MODULE_19__reducers_account_role__["c" /* SUB_ROLES */].FA)&&!data.financialDataValidated){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{onClick:_this.onValidate,className:'olive-green-btn',disabled:_this.isValidateButtonDisabled()},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.validate_organization_button'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'already-validated-message olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.already_validated'));};_this.renderFinanceManagementComponent=function(){if(_this.props.subRoles&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_19__reducers_account_role__["c" /* SUB_ROLES */].FA)&&!_this.props.subRoles.includes(__WEBPACK_IMPORTED_MODULE_19__reducers_account_role__["c" /* SUB_ROLES */].ROOT)){return null;}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'validate-org-details-subtitle olive-green',key:'header'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'finance.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__orgFinanceManagement_OrgFinanceManagement_container__["a" /* default */],{key:'org-finance-management',id:_this.props.id,mode:__WEBPACK_IMPORTED_MODULE_18__orgFinanceManagement_OrgFinanceManagement__["a" /* VALIDATE_ORG_MODE */],onUpdateOrgFinanceDataSubmit:_this.onUpdateOrgFinanceDataSubmit,onChangeSubmitStatus:_this.onFinanceSubmitStatusChange})];};_this.renderOrganizationDataFormGroups=function(){var paramsList=[{value:"orgType",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.org_type_label'),type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["o" /* ORGANIZATION_TYPES */],function(value){return{code:value.code,name:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,value.name)};})),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'register_org.org_type_placeholder'),onChange:_this.handleChangeSelect('orgType')},{value:"orgName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.name_label')+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.name_label')},{value:"orgDomain",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label)},{value:"orgVatNumber",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.vat_number_label'),isRequired:false,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.vat_number_label')},{value:"companyCode",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.company_code_label'),isRequired:false,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.company_code_label')},{value:'orgEmployeeCount',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].employee_count_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["h" /* EMPLOYEES_COUNT_VALUES */],function(value){return{code:value.code,name:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,value.name)||value.name};})),isRequired:true,onChange:_this.handleChangeSelect('orgEmployeeCount')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderOrganizationAddressFormGroup=function(){var paramsList=[{value:"orgContinent",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label),onChange:_this.handleChangeContinent,type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),isDisabled:!_this.props.continents},{value:"orgCountry",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),onChange:_this.handleChangeSelect('orgCountry'),type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isDisabled:!_this.props.countries},{value:"orgCity",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.city_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.city_label')},{value:"orgPostal",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.postal_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.postal_label')},{value:"orgStreet",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.street_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.street_label')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderAnchorFormGroups=function(){var paramsList=[{value:"anchorEmail",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+"*",type:"email",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)},{value:"anchorFirstName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)},{value:"anchorLastName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderPopover=function(params){var hintText='';var id='validate-org-';switch(params.value){case'orgDomain':id+='domain-hint-container';hintText=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'register_org.domain_hint');break;case'companyCode':id+='company-code-hint-container';hintText=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'register_org.company_code_hint');break;default:return;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validate-org-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:id,className:'validate-org-icon-container',onClick:_this.togglePopover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["H" /* Popover */],{placement:'bottom',isOpen:_this.state.popoverOpen===params.value,target:id,toggle:_this.togglePopover(params.value)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["I" /* PopoverBody */],null,hintText)));};_this.togglePopover=function(type){return function(){if(_this.state.popoverOpen===type){_this.setState({popoverOpen:null});}else{_this.setState({popoverOpen:type});}};};_this.renderCheckboxes=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["n" /* ORGANIZATION_AVAILABLE_FLAGS */],function(flag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{key:flag,className:'checkbox-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{className:'checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'checkbox',checked:_this.state[flag],onChange:_this.toggleCheckbox(flag)}),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__constants_constants__["j" /* FLAGS */][flag]))));});};_this.getFormGroup=function(params){if(params.type==='select'){return _this.getSelectFormGroup(params);}if(params.value==='orgDomain'){return _this.getOrganizationDomainFormGroup(params);}if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this.renderPopover(params),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:_this.state[params.value],onChange:params.onChange||_this.handleChange(params.value),placeholder:params.placeholder,disabled:params.isDisabled,required:params.isRequired},params.content)));};_this.getOrganizationDomainFormGroup=function(params){var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this.renderPopover(params),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_domainInput_DomainInput__["a" /* default */],{id:id,value:_this.state[params.value],onChange:_this.handleChangeDomainInput,placeholder:params.placeholder||params.title,disabled:params.isDisabled,required:params.isRequired})));};_this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];}),options:params.content,onSelect:params.onChange,placeholder:params.placeholder,disabled:params.isDisabled,requiredFieldError:_this.state.requiredFieldError===params.value})));};_this.handleChangeSelect=function(fieldKey){return function(selectedOption){_this.setState(_defineProperty({},fieldKey,selectedOption.value));};};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleChangeDomainInput=function(data){_this.setState({orgDomain:data});};_this.toggleCheckbox=function(fieldKey){return function(){_this.setState(_defineProperty({},fieldKey,!_this.state[fieldKey]));};};_this.handleChangeContinent=function(selectedOption){_this.props.onSetContinent(selectedOption.value);_this.setState({orgCountry:''});};_this.onUpdateOrgData=function(e){e.preventDefault();_this.setState({successMessage:ORG_EDIT_SUCCESS_MESSAGE});var data={type:_this.state.orgType,name:_this.state.orgName,domain:_this.state.orgDomain,address:{countryCode:_this.state.orgCountry,city:_this.state.orgCity,postal:_this.state.orgPostal,street:_this.state.orgStreet},vatNumber:_this.state.orgVatNumber,companyCode:_this.state.companyCode,anchor:{email:_this.state.anchorEmail,identityAlias:{firstName:_this.state.anchorFirstName,lastName:_this.state.anchorLastName}},hasIVs:_this.state.hasIVs,verifiesIdentities:_this.state.verifiesIdentities,providesMoocCertificates:_this.state.providesMoocCertificates,employeeCount:_this.state.orgEmployeeCount};_this.props.onUpdateGeneralData(_this.props.id,data);};_this.onAnchorEdit=function(e){e.preventDefault();var data={email:_this.state.anchorEmail,identityAlias:{firstName:_this.state.anchorFirstName,lastName:_this.state.anchorLastName,countryCode:_this.state.orgCountry}};_this.setState({successMessage:ANCHOR_EDIT_SUCCESS_MESSAGE});_this.props.onAnchorEdit(_this.props.id,data);};_this.onUpdateOrgFinanceDataSubmit=function(){_this.setState({successMessage:ORG_EDIT_SUCCESS_MESSAGE});};_this.onValidate=function(){_this.props.onResetSubmitFormData();if(_this.checkRequiredSelectFields()){return;}_this.setState({successMessage:ORG_VALIDATED_SUCCESS_MESSAGE});_this.props.onShowValidateOrgModal();};_this.onSubmitModal=function(){_this.props.onValidate(_this.props.id);};_this.handleNextButtonClick=function(){_this.props.onNext();};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(requiredSelectFields,function(field){if(!_this.state[field]&&!error){error=field;}});_this.setState({requiredFieldError:error});return error;};_this.onFinanceSubmitStatusChange=function(isDisabled){if(_this.state.isFinanceSubmitDisabled!==isDisabled){_this.setState({isFinanceSubmitDisabled:isDisabled});}};_this.isValidateButtonDisabled=function(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNull(_this.props.data)){return true;}return!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.every(fields,function(field){return _this.props.data.hasOwnProperty(field)?_this.props.data[field]===_this.state[field]:_this.state[field]==='';})||!_this.state.isFinanceSubmitDisabled;};_this.isUpdateButtonDisabled=function(type){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNull(_this.props.data)){return true;}var keysList=[];switch(type){case'orgDetails':keysList=['orgType','orgName','orgDomain','orgVatNumber','companyCode','orgEmployeeCount','orgCountry','orgCity','orgPostal','orgStreet'].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["n" /* ORGANIZATION_AVAILABLE_FLAGS */]));break;case'anchorDetails':keysList=['anchorEmail','anchorFirstName','anchorLastName'];break;default:break;}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.every(keysList,function(fieldKey){return _this.state[fieldKey]===_this.props.data[fieldKey];});};_this.state={orgType:'',orgName:'',orgDomain:'',orgVatNumber:'',companyCode:'',orgContinent:_this.props.continentCode,orgEmployeeCount:'UNKNOWN',orgCountry:'',orgCity:'',orgPostal:'',orgStreet:'',orgStreetNumber:'',orgBusNumber:'',anchorFirstName:'',anchorLastName:'',anchorEmail:'',hasIVs:true,verifiesIdentities:true,providesMoocCertificates:false,successMessage:'',requiredFieldError:null,popoverOpen:null,isFinanceSubmitDisabled:true};return _this;}_createClass(ValidateOrg,[{key:'componentWillMount',value:function componentWillMount(){this.loadOrg(this.props.id);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.state.orgContinent!==nextProps.continentCode){this.setState({orgContinent:nextProps.continentCode});}if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.data)&&(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)||this.props.data.orgId!==nextProps.data.orgId)){this.setState(Object.assign({},nextProps.data));this.props.onSetContinent(nextProps.data.orgContinent);this.props.onSetDefaultCurrencyAndPricingPreset();}if(this.props.id!==nextProps.id){this.loadOrg(nextProps.id);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}},{key:'render',value:function render(){if(!this.props.loading&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.id)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["d" /* Redirect */],{to:'/validate-organizations'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-validate-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,this.state.successMessage)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-validate-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/validate-organizations',label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.back_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_labelWithPages_ValidateOrgLabel_container__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.validate_organization_label')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_progressBar_ValidateOrgsProgressBar_container__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.validate_org_progress_label')+':'}),this.renderContent())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__validatePendingOrgModal_ValidatePendingOrgModal_container__["a" /* default */],{onValidateOrganization:this.onSubmitModal}));}}]);return ValidateOrg;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ValidateOrg.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,labelPath:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,continentCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,subRoles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onSetContinent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUnmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onValidate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onShowValidateOrgModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSetDefaultCurrencyAndPricingPreset:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onLoadOrg:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onNext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onResetSubmitFormData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUpdateGeneralData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onAnchorEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ValidateOrg);

/***/ }),
/* 898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProgressBar__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__ = __webpack_require__(30);
var mapStateToProps=function mapStateToProps(state){return{left:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["z" /* getLeftOrgsNumber */])(state),skipped:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["B" /* getNumberOfSkippedOrgs */])(state),validated:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["C" /* getNumberOfValidatedOrgs */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["J" /* getTotalNumberOfNotValidatedOrgs */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__ProgressBar__["a" /* default */]));

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LabelWithPages__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__ = __webpack_require__(30);
var mapStateToProps=function mapStateToProps(state){return{total:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__["J" /* getTotalNumberOfNotValidatedOrgs */])(state),processed:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__["C" /* getNumberOfValidatedOrgs */])(state),currentIndex:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__["v" /* getCurrentOrgIndex */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__LabelWithPages__["a" /* default */]));

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ValidatePendingOrgModal__ = __webpack_require__(902);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_13" /* MODAL_VALIDATE_PENDING_ORGANIZATION */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__ValidatePendingOrgModal__["a" /* default */]));

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ValidatePendingOrgModal_css__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ValidatePendingOrgModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ValidatePendingOrgModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ValidatePendingOrgModal=function(_Component){_inherits(ValidatePendingOrgModal,_Component);function ValidatePendingOrgModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ValidatePendingOrgModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ValidatePendingOrgModal.__proto__||Object.getPrototypeOf(ValidatePendingOrgModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleSubmit=function(e){e.preventDefault();_this.props.onValidateOrganization();_this.props.onCancel();},_this.handleCancel=function(){_this.props.onCancel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ValidatePendingOrgModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'validate-pending-org-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],{className:'validate-pending-org-modal-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{className:'validate-pending-org-modal-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"orgs.validate_organization_alert")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{className:'validate-pending-org-modal-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"orgs.validate_organization_button"))))));}}]);return ValidatePendingOrgModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ValidatePendingOrgModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onValidateOrganization:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ValidatePendingOrgModal);

/***/ }),
/* 903 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 904 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DepartmentsList_css__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DepartmentsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DepartmentsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__departmentModal_createDepartmentModal_CreateDepartmentModal_container__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__departmentModal_removeDepartmentModal_RemoveDepartmentModal_container__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_paginationComponent_PaginationDepartments_container__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_utils__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SUCCESS_MESSAGE_BY_ACTION={ADD:'org_staff.departments.create_department_success_message',REMOVE:'org_staff.departments.remove_department_success_message'};var DepartmentsList=function(_Component){_inherits(DepartmentsList,_Component);function DepartmentsList(props){_classCallCheck(this,DepartmentsList);var _this=_possibleConstructorReturn(this,(DepartmentsList.__proto__||Object.getPrototypeOf(DepartmentsList)).call(this,props));_this.renderHint=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'departments-list-placeholder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'departments-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'org_staff.departments.no_data_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(" "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'org_staff.departments.departments_definition_label_'+(_this.props.orgPermissions.hasIVs?'uni':'company')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].examples_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'org_staff.departments.departments_examples_label').split(';'),function(example,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'example'+index},example);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(" "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'org_staff.departments.departments_definition_label_part_2'))),_this.props.orgPermissions.hasIVs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'org_staff.departments.different_from_accreditation_groups_label')+" "),'-',__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(" "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'org_staff.accreditation_groups.accreditation_groups_definition_label'))):null,_this.props.orgPermissions.hasIVs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].examples_label),':'):null,_this.props.orgPermissions.hasIVs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'org_staff.accreditation_groups.accreditation_group_examples_label').split(';'),function(example,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'example'+index},example);})):null);};_this.handleAddButtonClick=function(){_this.props.onAddButtonClick();_this.props.setSuccessMessage(SUCCESS_MESSAGE_BY_ACTION.ADD);};_this.handleTableRowClick=function(id){return function(){_this.props.onDepartmentSelect(id);_this.setState({departmentIsSelected:true});};};_this.handleRemoveDepartment=function(department){return function(){_this.props.onDepartmentRemove();_this.setState({departmentToRemove:department});_this.props.setSuccessMessage(SUCCESS_MESSAGE_BY_ACTION.REMOVE);};};_this.handleCancelRemoving=function(){_this.setState({departmentToRemove:null});};_this.state={departmentToRemove:null,departmentIsSelected:false};return _this;}_createClass(DepartmentsList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'departments-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.departments.table_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-department-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{className:'add-department-button olive-green-btn',onClick:this.handleAddButtonClick},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].add_button))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_paginationComponent_PaginationDepartments_container__["a" /* default */],null),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__departmentModal_createDepartmentModal_CreateDepartmentModal_container__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__departmentModal_removeDepartmentModal_RemoveDepartmentModal_container__["a" /* default */],{data:this.state.departmentToRemove,onCancelRemoving:this.handleCancelRemoving}),this.state.departmentIsSelected&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.departmentId)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Redirect */],{to:'/department?id='+this.props.departmentId,push:true}):null);}},{key:'renderContent',value:function renderContent(){if(this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'departments-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.data)||this.props.data.length===0){return this.renderHint();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["N" /* Table */],{className:'departments-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.departments.department_name_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.departments.hms_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'org_staff.departments.bos_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.renderDepartmentData()));}},{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'renderDepartmentData',value:function renderDepartmentData(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.props.data,function(department,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index,className:'departments-table-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'department-name-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'org_staff.departments.department_name_label')+":",onClick:_this2.handleTableRowClick(department.id)},department.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'department-hms-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'org_staff.departments.hms_label')+":",onClick:_this2.handleTableRowClick(department.id)},department.hrManagerCount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'department-bos-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'org_staff.departments.bos_label')+":",onClick:_this2.handleTableRowClick(department.id)},department.businessOwnerCount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'control-cell create-department-icon-td',onClick:_this2.handleTableRowClick(department.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:index,icon:'create',className:'create-department-icon',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].edit_button)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'control-cell remove-department-icon-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:index,icon:'trash',className:'remove-department-icon',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button),onClick:_this2.handleRemoveDepartment(department)})));});}}]);return DepartmentsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DepartmentsList.propTypes={departmentId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,loading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,onAddButtonClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onMount:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onDepartmentSelect:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onDepartmentRemove:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,setSuccessMessage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (DepartmentsList);

/***/ }),
/* 906 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_organization_departments__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreateDepartmentModal__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_organization_organization__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["h" /* MODAL_ADD_DEPARTMENT */],translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state),isOrgValidated:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_organization_organization__["x" /* isOrganizationValidated */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onDepartmentCreate:function onDepartmentCreate(departmentData){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_organization_departments__["c" /* fetchRegisterDepartment */])(departmentData));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__CreateDepartmentModal__["a" /* default */]));

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreateDepartmentModal_css__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreateDepartmentModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CreateDepartmentModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateDepartmentModal=function(_Component){_inherits(CreateDepartmentModal,_Component);function CreateDepartmentModal(props){_classCallCheck(this,CreateDepartmentModal);var _this=_possibleConstructorReturn(this,(CreateDepartmentModal.__proto__||Object.getPrototypeOf(CreateDepartmentModal)).call(this,props));_this.handleChange=function(inputName){return function(e){_this.setState(_defineProperty({},inputName,e.target.value));};};_this.handleSubmit=function(e){e.preventDefault();var data={name:_this.state.departmentName};if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.state.departmentEmail)&&_this.state.departmentEmail!==''){data["email"]=_this.state.departmentEmail;}_this.props.onDepartmentCreate(data);};_this.state={departmentName:'',departmentEmail:''};return _this;}_createClass(CreateDepartmentModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'department-modal',isOpen:this.props.isOpen,toggle:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.props.isOrgValidated?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["a" /* Alert */],{color:'warning'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'main.non_validated_org_access_label')),this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3,className:'modal-label-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.department_name_label')+'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'text',placeholder:''+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.department_name_label'),required:true,onChange:this.handleChange('departmentName')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3,className:'modal-label-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.department_email_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'text',placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.department_email_label'),onChange:this.handleChange('departmentEmail')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit',disabled:!this.props.isOrgValidated},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.create_department_button'))));}}]);return CreateDepartmentModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CreateDepartmentModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,isOrgValidated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onDepartmentCreate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (CreateDepartmentModal);

/***/ }),
/* 909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveDepartmentModal__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_organization_departments__ = __webpack_require__(108);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["W" /* MODAL_REMOVE_DEPARTMENT */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onDepartmentRemove:function onDepartmentRemove(departmentId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_organization_departments__["d" /* fetchRemoveDepartment */])(departmentId));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RemoveDepartmentModal__["a" /* default */]));

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveDepartmentModal=function(_Component){_inherits(RemoveDepartmentModal,_Component);function RemoveDepartmentModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveDepartmentModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveDepartmentModal.__proto__||Object.getPrototypeOf(RemoveDepartmentModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleRemove=function(e){e.preventDefault();_this.props.onDepartmentRemove(_this.props.data.id);},_this.handleCancel=function(){_this.props.onCancel();_this.props.onCancelRemoving();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveDepartmentModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'department-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.remove_department_alert')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.department_name_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.department_email_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.email||"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))));}}]);return RemoveDepartmentModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveDepartmentModal.propTypes={departmentId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onDepartmentRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelRemoving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveDepartmentModal);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_organization_departments__ = __webpack_require__(108);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_departments__["e" /* getCurrentPageForDepartments */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_departments__["g" /* getTotalPagesForDepartments */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_departments__["b" /* fetchGetDepartments */])(page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DepartmentDetails__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_organization_department__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_organization_staffMembers__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils__ = __webpack_require__(12);
var mapStateToProps=function mapStateToProps(state,_ref){var location=_ref.location;var pathId=__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search).id;return{id:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_department__["h" /* getDepartmentId */])(state),pathId:pathId,data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_department__["f" /* getDepartmentAndStaffData */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_department__["k" /* loadingDepartment */])(state),fetchingError:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_department__["j" /* getFetchingErrorDepartment */])(state),employees:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_staffMembers__["f" /* getAllActiveStaffMembers */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_department__["d" /* fetchGetDepartmentData */])(id));},onEmployeesLoad:function onEmployeesLoad(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_staffMembers__["c" /* fetchGetAllStaffMembers */])());},onDepartmentSet:function onDepartmentSet(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_department__["m" /* setDepartmentId */])(id));},onEditDepartment:function onEditDepartment(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["C" /* MODAL_EDIT_DEPARTMENT */]}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onAddEmployeeToDepartment:function onAddEmployeeToDepartment(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["j" /* MODAL_ADD_EMPLOYEE_TO_DEPARTMENT */]}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onRemoveEmployeeFromDepartment:function onRemoveEmployeeFromDepartment(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["Y" /* MODAL_REMOVE_EMPLOYEE_FROM_DEPARTMENT */]}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_department__["m" /* setDepartmentId */])(null));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_department__["l" /* resetDepartmentData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__DepartmentDetails__["a" /* default */]));

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DepartmentDetails_css__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DepartmentDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DepartmentDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__departmentModal_removeEmployeeFromDepartmentModal_RemoveEmployeeFromDepartmentModal_container__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__departmentModal_addEmployeeToDepartmentModal_AddEmployeeToDepartmentModal_container__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__departmentModal_editDepartmentModal_EditDepartmentModal_container__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_pageNotFoundComponent_PageNotFoundComponent_container__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SUCCESS_MESSAGE_BY_ACTION={ADD_STAFF:'org_staff.departments.add_employee_to_department_success_message',REMOVE_STAFF:'org_staff.departments.remove_employee_from_department_success_message',EDIT:'org_staff.departments.edit_department_success_message'};var DepartmentDetails=function(_Component){_inherits(DepartmentDetails,_Component);function DepartmentDetails(props){_classCallCheck(this,DepartmentDetails);var _this=_possibleConstructorReturn(this,(DepartmentDetails.__proto__||Object.getPrototypeOf(DepartmentDetails)).call(this,props));_this.renderHeader=function(){if(!_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'department-details-name-email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'department-details-name-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'department-name-container'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].name_label),': '),_this.props.data.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'create',className:'edit-department-icon',onClick:_this.handleEditDepartment,title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].edit_button)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'department-details-email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'department-email-container'},' ',__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].email_label),': '),_this.props.data.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'create',className:'edit-department-icon',onClick:_this.handleEditDepartment,title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].edit_button)})));}};_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'department-employees-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(_this.props.data)||_this.props.data.hms.length===0&&_this.props.data.bos.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'department-employees-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'org_staff.departments.department_no_data_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["N" /* Table */],{className:'department-employees-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'org_staff.departments.role_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.getEmployeesDataByRole(__WEBPACK_IMPORTED_MODULE_10__reducers_account_role__["c" /* SUB_ROLES */].HM),_this.getEmployeesDataByRole(__WEBPACK_IMPORTED_MODULE_10__reducers_account_role__["c" /* SUB_ROLES */].BO)));};_this.renderModals=function(){if(!_this.props.loading){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__departmentModal_removeEmployeeFromDepartmentModal_RemoveEmployeeFromDepartmentModal_container__["a" /* default */],{key:'remove-employee-to-department-modal',departmentId:_this.props.id,data:_this.state.employeeToRemove,onCancelRemoving:_this.handleCancelRemoving}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__departmentModal_addEmployeeToDepartmentModal_AddEmployeeToDepartmentModal_container__["a" /* default */],{key:'add-employee-to-department-modal',departmentId:_this.props.id,staffMembersData:_this.props.employees,hmList:_this.props.data.hms.map(function(hm){return hm.id;}),boList:_this.props.data.bos.map(function(bo){return bo.id;})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__departmentModal_editDepartmentModal_EditDepartmentModal_container__["a" /* default */],{key:'edit-department-modal'})];}};_this.getEmployeesDataByRole=function(role){var employees=role===__WEBPACK_IMPORTED_MODULE_10__reducers_account_role__["c" /* SUB_ROLES */].HM?_this.props.data.hms:_this.props.data.bos;return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(employees,function(employee){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:employee.id,className:'department-employees-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'first-name-td','data-th':__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)+":"},employee.identityAlias.firstName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'last-name-td','data-th':__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)+":"},employee.identityAlias.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'email-td','data-th':__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+":"},employee.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'role-td','data-th':__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'org_staff.departments.role_label')+":"},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'roles.'+__WEBPACK_IMPORTED_MODULE_10__reducers_account_role__["d" /* SUB_ROLES_TRANSLATIONS */][role])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'control-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:employee.id,icon:'trash',className:'remove-from-department-icon',title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button),onClick:_this.handleRemoveButtonClick(employee,role)})));});};_this.handleAddButtonClick=function(){_this.props.onAddEmployeeToDepartment();_this.props.onEmployeesLoad();_this.setState({successMessage:SUCCESS_MESSAGE_BY_ACTION.ADD_STAFF});};_this.handleRemoveButtonClick=function(employee,role){return function(){_this.setState({employeeToRemove:Object.assign({role:role},employee),successMessage:SUCCESS_MESSAGE_BY_ACTION.REMOVE_STAFF});_this.props.onRemoveEmployeeFromDepartment();};};_this.handleCancelRemoving=function(){_this.setState({employeeToRemove:null});};_this.handleEditDepartment=function(){_this.props.onEditDepartment();_this.setState({successMessage:SUCCESS_MESSAGE_BY_ACTION.EDIT});};_this.state={role:'',employeeToRemove:null,successMessage:null};return _this;}_createClass(DepartmentDetails,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.id!==this.props.pathId){this.props.onDepartmentSet(this.props.pathId);}if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(this.props.id)){this.props.onMount(this.props.id);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(nextProps.id)&&this.props.id!==nextProps.id){this.props.onMount(nextProps.id);}}},{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(this.props.pathId)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["d" /* Redirect */],{to:'/groups-management',push:true});}if(this.props.fetchingError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_pageNotFoundComponent_PageNotFoundComponent_container__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'department-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,this.state.successMessage)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/groups-management',label:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].back_button)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].department_label)),this.renderHeader(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'department-employees-table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'department-table-label-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'font-weight-bold'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'org_staff.departments.employees_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'add-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'btn-sm olive-green-btn',onClick:this.handleAddButtonClick},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].add_button)))),this.renderContent()),this.renderModals()));}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}}]);return DepartmentDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DepartmentDetails.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,pathId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,fetchingError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,employees:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onEmployeesLoad:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onEditDepartment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onAddEmployeeToDepartment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onRemoveEmployeeFromDepartment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUnmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (DepartmentDetails);

/***/ }),
/* 915 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RemoveEmployeeFromDepartmentModal__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_department__ = __webpack_require__(85);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["Y" /* MODAL_REMOVE_EMPLOYEE_FROM_DEPARTMENT */],translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onEmployeeRemoveFromDepartment:function onEmployeeRemoveFromDepartment(departmentId,employeeId,role){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_department__["e" /* fetchRemoveEmployeeFromDepartment */])(departmentId,employeeId,role));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__RemoveEmployeeFromDepartmentModal__["a" /* default */]));

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_account_role__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveEmployeeFromDepartmentModal=function(_Component){_inherits(RemoveEmployeeFromDepartmentModal,_Component);function RemoveEmployeeFromDepartmentModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveEmployeeFromDepartmentModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveEmployeeFromDepartmentModal.__proto__||Object.getPrototypeOf(RemoveEmployeeFromDepartmentModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleSubmit=function(e){e.preventDefault();_this.props.onEmployeeRemoveFromDepartment(_this.props.departmentId,_this.props.data.id,_this.props.data.role);},_this.handleCancel=function(){_this.props.onCancel();_this.props.onCancelRemoving();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveEmployeeFromDepartmentModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'department-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.remove_employee_from_department_alert')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.role_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'roles.'+__WEBPACK_IMPORTED_MODULE_5__reducers_account_role__["d" /* SUB_ROLES_TRANSLATIONS */][this.props.data.role]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.identityAlias.firstName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.identityAlias.lastName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].email_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.email)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))));}}]);return RemoveEmployeeFromDepartmentModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveEmployeeFromDepartmentModal.propTypes={departmentId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onEmployeeRemoveFromDepartment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelRemoving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveEmployeeFromDepartmentModal);

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddEmployeeToDepartmentModal__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_department__ = __webpack_require__(85);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["j" /* MODAL_ADD_EMPLOYEE_TO_DEPARTMENT */],translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onEmployeeAddToDepartment:function onEmployeeAddToDepartment(departmentId,employeeId,role){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_department__["b" /* fetchAddEmployeeToDepartment */])(departmentId,employeeId,role));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__AddEmployeeToDepartmentModal__["a" /* default */]));

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_selectWithSearch_SelectWithSearch__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AVAILABLE_ROLES=[__WEBPACK_IMPORTED_MODULE_5__reducers_account_role__["c" /* SUB_ROLES */].HM,__WEBPACK_IMPORTED_MODULE_5__reducers_account_role__["c" /* SUB_ROLES */].BO];var AddEmployeeToDepartmentModal=function(_Component){_inherits(AddEmployeeToDepartmentModal,_Component);function AddEmployeeToDepartmentModal(props){_classCallCheck(this,AddEmployeeToDepartmentModal);var _this=_possibleConstructorReturn(this,(AddEmployeeToDepartmentModal.__proto__||Object.getPrototypeOf(AddEmployeeToDepartmentModal)).call(this,props));_this.handleChangeEmployeeId=function(value){_this.setState({employeeId:value});};_this.handleChange=function(fieldName){return function(selectedOption){_this.setState(_defineProperty({},fieldName,selectedOption.value));};};_this.getEmployeesOptions=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.chain(_this.props.staffMembersData).filter(function(employee){switch(_this.state.role){case __WEBPACK_IMPORTED_MODULE_5__reducers_account_role__["c" /* SUB_ROLES */].HM:return!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(_this.props.hmList,employee.id);case __WEBPACK_IMPORTED_MODULE_5__reducers_account_role__["c" /* SUB_ROLES */].BO:return!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(_this.props.boList,employee.id);default:return false;}}).map(function(employee){return{value:employee.id,label:employee.firstName+' '+employee.lastName+' ('+employee.email+')'};}).value();};_this.getRolesOptions=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(AVAILABLE_ROLES,function(role){return{value:role,label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'roles.'+__WEBPACK_IMPORTED_MODULE_5__reducers_account_role__["d" /* SUB_ROLES_TRANSLATIONS */][role])};});};_this.handleCancel=function(e){e.preventDefault();_this.cleanState();_this.props.onCancel();};_this.handleSubmit=function(e){e.preventDefault();_this.props.onEmployeeAddToDepartment(_this.props.departmentId,_this.state.employeeId,_this.state.role);};_this.cleanState=function(){_this.setState({employeeId:null,role:''});};_this.state={employeeId:null,role:''};return _this;}_createClass(AddEmployeeToDepartmentModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.isOpen&&!this.props.isOpen){this.cleanState();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'department-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:3},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.role_label')+'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:'employee-role-select',selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.getRolesOptions(),function(option){return option.value===_this2.state.role;}),options:this.getRolesOptions(),onSelect:this.handleChange('role'),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.role_input_placeholder'),isSearchable:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:3},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.employee_label')+'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_selectWithSearch_SelectWithSearch__["a" /* default */],{value:this.state.employeeId,onChange:this.handleChangeEmployeeId,isDisabled:this.state.role==='',options:this.getEmployeesOptions(),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.employee_input_placeholder')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',type:'submit',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit',disabled:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.state.employeeId)||this.state.role===''},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].add_button))));}}]);return AddEmployeeToDepartmentModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AddEmployeeToDepartmentModal.propTypes={departmentId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,staffMembersData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,hmList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,boList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onEmployeeAddToDepartment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (AddEmployeeToDepartmentModal);

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditDepartmentModal__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_department__ = __webpack_require__(85);
var mapStateToProps=function mapStateToProps(state){return{departmentId:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_department__["h" /* getDepartmentId */])(state),departmentName:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_department__["i" /* getDepartmentName */])(state),departmentEmail:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_department__["g" /* getDepartmentEmail */])(state),isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["C" /* MODAL_EDIT_DEPARTMENT */],translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onDepartmentEdit:function onDepartmentEdit(departmentId,departmentData){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_department__["c" /* fetchEditDepartment */])(departmentId,departmentData));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__EditDepartmentModal__["a" /* default */]));

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditDepartmentModal_css__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditDepartmentModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__EditDepartmentModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditDepartmentModal=function(_Component){_inherits(EditDepartmentModal,_Component);function EditDepartmentModal(props){_classCallCheck(this,EditDepartmentModal);var _this=_possibleConstructorReturn(this,(EditDepartmentModal.__proto__||Object.getPrototypeOf(EditDepartmentModal)).call(this,props));_this.saveButtonDisabled=function(){return _this.state.departmentName===_this.props.departmentName&&_this.state.departmentEmail===_this.props.departmentEmail;};_this.handleChange=function(inputName){return function(e){_this.setState(_defineProperty({},inputName,e.target.value));};};_this.handleSubmit=function(e){e.preventDefault();var data={name:_this.state.departmentName};if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.state.departmentEmail)&&_this.state.departmentEmail!==""){data["email"]=_this.state.departmentEmail;}else{data["email"]=null;}_this.props.onDepartmentEdit(_this.props.departmentId,data);};_this.state={departmentName:_this.props.departmentName,departmentEmail:_this.props.departmentEmail||""};return _this;}_createClass(EditDepartmentModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.isOpen&&!this.props.isOpen){this.setState({departmentName:nextProps.departmentName,departmentEmail:nextProps.departmentEmail||''});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'department-modal',isOpen:this.props.isOpen,toggle:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3,className:'modal-label-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.department_name_label')+'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'text',value:this.state.departmentName,placeholder:''+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.department_name_label'),required:true,onChange:this.handleChange('departmentName')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,className:'email-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3,className:'modal-label-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.department_email_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'text',value:this.state.departmentEmail,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_staff.departments.department_email_label'),onChange:this.handleChange('departmentEmail')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit',disabled:this.saveButtonDisabled()},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button))));}}]);return EditDepartmentModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EditDepartmentModal.propTypes={departmentId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,departmentName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,departmentEmail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onDepartmentEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (EditDepartmentModal);

/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CertifiedAccreditationsList__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_applicantAccreditations_certifiedAccreditations__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_applicantAccreditations_certifiedAccreditations__["e" /* getCertifiedAccreditationsData */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_applicantAccreditations_certifiedAccreditations__["f" /* loadingCertifiedAccreditations */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGetAccreditations:function onGetAccreditations(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_applicantAccreditations_certifiedAccreditations__["b" /* fetchGetCertifiedAccreditations */])());},onOpenAccreditationDetailsModal:function onOpenAccreditationDetailsModal(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["q" /* MODAL_CERTIFIED_ACCREDITATION */]}));},onChangeExpose:function onChangeExpose(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_applicantAccreditations_certifiedAccreditations__["c" /* fetchUpdateCertifiedAccreditation */])(id,data));},onRemoveAccreditation:function onRemoveAccreditation(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["U" /* MODAL_REMOVE_CERTIFIED_ACCREDITATION */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CertifiedAccreditationsList__["a" /* default */]));

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CertifiedAccreditationsList_css__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CertifiedAccreditationsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CertifiedAccreditationsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__certifiedAccreditationModal_CertifiedAccreditationModal_container__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__certifiedAccreditationModal_RemoveCertifiedAccreditationModal_container__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CertifiedAccreditationsList=function(_Component){_inherits(CertifiedAccreditationsList,_Component);function CertifiedAccreditationsList(props){_classCallCheck(this,CertifiedAccreditationsList);var _this=_possibleConstructorReturn(this,(CertifiedAccreditationsList.__proto__||Object.getPrototypeOf(CertifiedAccreditationsList)).call(this,props));_this.renderContent=function(){if(_this.props.loading&&(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'certified-accreditations-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'certified-accreditations-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_10__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.no_data_label_part_1')),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.no_data_label_part_2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'olive-green',href:'http://www.brainchainmission.org',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.no_data_label_part_3')),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.no_data_label_part_4')));}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'responsive-header',key:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accreditation-expose-responsive-header'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.expose_certified_accreditations'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["N" /* Table */],{className:'certified-accreditations-list-table',cellSpacing:'0',key:'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_orig_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_en_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'accreditation.date_issued_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.issued_by_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'accreditation.level_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'accreditation-expose-header'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.expose_certified_accreditations')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderAccreditationsData()))];};_this.handleRemoveIconClick=function(id){return function(){_this.setState({currentAccreditationId:id});_this.props.onRemoveAccreditation();};};_this.onShowAccreditationDetails=function(id){return function(){_this.setState({currentAccreditationId:id});_this.props.onOpenAccreditationDetailsModal();};};_this.onExposeClick=function(id,accreditation){return function(){var data={expose:!accreditation.expose};_this.props.onChangeExpose(id,data);};};_this.state={currentAccreditationId:null};return _this;}_createClass(CertifiedAccreditationsList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onGetAccreditations();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'certified-accreditations-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'applicant_accreditations_management.remove_accreditation_success_massage'),hideOverlay:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'applicant_accreditations_management.certified_accreditations_label')),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__certifiedAccreditationModal_CertifiedAccreditationModal_container__["a" /* default */],{id:this.state.currentAccreditationId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__certifiedAccreditationModal_RemoveCertifiedAccreditationModal_container__["a" /* default */],{id:this.state.currentAccreditationId})));}},{key:'renderAccreditationsData',value:function renderAccreditationsData(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(this.props.data,function(accreditation,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:accreditation.id,className:'certified-accreditations-list-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'certified-accreditation-title-original-td',onClick:_this2.onShowAccreditationDetails(accreditation.id),'data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'accreditation.accreditation_title_orig_label')+":"},accreditation.titleOriginal),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'certified-accreditation-title-en-td',onClick:_this2.onShowAccreditationDetails(accreditation.id),'data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'accreditation.accreditation_title_en_label')+":"},accreditation.titleEn),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'certified-accreditation-date-issued-td',onClick:_this2.onShowAccreditationDetails(accreditation.id),'data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'accreditation.date_issued_label')+":"},__WEBPACK_IMPORTED_MODULE_9_moment___default()(accreditation.dateIssued).format("L")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'certified-accreditation-issued-by-td',onClick:_this2.onShowAccreditationDetails(accreditation.id),'data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'applicant_accreditations_management.issued_by_label')+":"},accreditation.issuedByName+', '+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'countries.'+accreditation.issuedByCountry)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'certified-accreditation-level-td',onClick:_this2.onShowAccreditationDetails(accreditation.id),'data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'accreditation.level_label')+":"},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'levels.'+accreditation.level)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'accreditation-expose-icon-container','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'applicant_accreditations_management.expose_certified_accreditations')+":"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'accreditation-expose-icon',icon:"check_box"+(!accreditation.expose?"_outline_blank":""),key:"accreditation-expose-"+accreditation.id,onClick:_this2.onExposeClick(accreditation.id,accreditation),title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'applicant_accreditations_management.expose_certified_accreditations')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'certified-accreditation-visibility-icon-td',onClick:_this2.onShowAccreditationDetails(accreditation.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'visibility',key:index,className:'certified-accreditation-visibility-icon',title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'applicant_accreditations_management.show_details_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'remove-accreditation-icon-td',onClick:_this2.handleRemoveIconClick(accreditation.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'trash',key:accreditation.id+'-trash',className:'trash-accreditation-icon',title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'accreditation_requests.remove_accreditation_request_label')})));});}}]);return CertifiedAccreditationsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CertifiedAccreditationsList.propTypes={data:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,loading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onGetAccreditations:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onChangeExpose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onOpenAccreditationDetailsModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onRemoveAccreditation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CertifiedAccreditationsList);

/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CertifiedAccreditationModal__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_applicantAccreditations_certifiedAccreditations__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state,_ref){var id=_ref.id;return{action:__WEBPACK_IMPORTED_MODULE_1__CertifiedAccreditationModal__["a" /* AVAILABLE_ACTIONS */].SHOW_DETAILS,isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["q" /* MODAL_CERTIFIED_ACCREDITATION */],data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_applicantAccreditations_certifiedAccreditations__["d" /* getCertifiedAccreditationDataById */])(state,id),translation:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CertifiedAccreditationModal__["b" /* default */]));

/***/ }),
/* 927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CertifiedAccreditationModal__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_applicantAccreditations_certifiedAccreditations__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state,_ref){var id=_ref.id;return{action:__WEBPACK_IMPORTED_MODULE_1__CertifiedAccreditationModal__["a" /* AVAILABLE_ACTIONS */].REMOVE,isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["U" /* MODAL_REMOVE_CERTIFIED_ACCREDITATION */],data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_applicantAccreditations_certifiedAccreditations__["d" /* getCertifiedAccreditationDataById */])(state,id),translation:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var id=_ref2.id;return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onRemove:function onRemove(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_applicantAccreditations_certifiedAccreditations__["g" /* removeCertificateAccreditation */])(id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CertifiedAccreditationModal__["b" /* default */]));

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PendingAccreditationsList__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_applicantAccreditations_pendingAccreditations__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_applicantAccreditations_pendingAccreditations__["g" /* getPendingAccreditationsListData */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_applicantAccreditations_pendingAccreditations__["h" /* loadingPendingAccreditations */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGetAccreditations:function onGetAccreditations(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_applicantAccreditations_pendingAccreditations__["c" /* fetchGetPendingAccreditations */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PendingAccreditationsList__["a" /* default */]));

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PendingAccreditationsList_css__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PendingAccreditationsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PendingAccreditationsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_utils__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PendingAccreditationsList=function(_Component){_inherits(PendingAccreditationsList,_Component);function PendingAccreditationsList(props){_classCallCheck(this,PendingAccreditationsList);var _this=_possibleConstructorReturn(this,(PendingAccreditationsList.__proto__||Object.getPrototypeOf(PendingAccreditationsList)).call(this,props));_this.renderContent=function(){if(_this.props.loading&&(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pending-accreditations-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pending-accreditations-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_9__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.no_pending_accreditations_label'))));}if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.state.currentAccreditationId)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Redirect */],{to:"/validate-pending-accreditation?id="+_this.state.currentAccreditationId,push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["N" /* Table */],{className:'pending-accreditations-list-table',cellSpacing:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_orig_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_en_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'accreditation.date_issued_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.issued_by_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'accreditation.level_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderAccreditationsData()));};_this.onShowAccreditationDetails=function(id){return function(){_this.setState({currentAccreditationId:id});};};_this.state={currentAccreditationId:null};return _this;}_createClass(PendingAccreditationsList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onGetAccreditations();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pending-accreditations-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,"applicant_accreditations_management.pending_accreditations_label")),this.renderContent());}},{key:'renderAccreditationsData',value:function renderAccreditationsData(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.props.data,function(accreditation,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:accreditation.id,className:'pending-accreditations-list-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'pending-accreditation-title-original-td',onClick:_this2.onShowAccreditationDetails(accreditation.id),'data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'accreditation.accreditation_title_orig_label')+":"},accreditation.titleOriginal),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'pending-accreditation-title-en-td',onClick:_this2.onShowAccreditationDetails(accreditation.id),'data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'accreditation.accreditation_title_en_label')+":"},accreditation.titleEn),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'pending-accreditation-date-issued-td',onClick:_this2.onShowAccreditationDetails(accreditation.id),'data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'accreditation.date_issued_label')+":"},__WEBPACK_IMPORTED_MODULE_7_moment___default()(accreditation.dateIssued).format("L")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'pending-accreditation-issued-by-td',onClick:_this2.onShowAccreditationDetails(accreditation.id),'data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'applicant_accreditations_management.issued_by_label')+":"},accreditation.issuedByName+', '+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'countries.'+accreditation.issuedByCountry)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'pending-accreditation-level-td',onClick:_this2.onShowAccreditationDetails(accreditation.id),'data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'accreditation.level_label')+":"},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'levels.'+accreditation.level)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'pending-accreditation-create-icon-td',onClick:_this2.onShowAccreditationDetails(accreditation.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'create',key:index,className:'pending-accreditation-create-icon',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'accreditation_list.edit_label')})));});}}]);return PendingAccreditationsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PendingAccreditationsList.propTypes={data:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,loading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onGetAccreditations:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PendingAccreditationsList);

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_applicantAccreditations_pendingAccreditations__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidatePendingAccreditation__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_levels__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_VIDs__ = __webpack_require__(109);
var mapStateToProps=function mapStateToProps(state,_ref){var location=_ref.location;var searchParams=__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search);return{id:searchParams.id,success:Object(__WEBPACK_IMPORTED_MODULE_9__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_applicantAccreditations_pendingAccreditations__["f" /* getPendingAccreditationDataFormatted */])(state,searchParams.id),isVIDEditable:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_VIDs__["h" /* isVIDEditable */])(state,searchParams.id),continentCode:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["e" /* getCountriesData */])(state),levels:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_levels__["c" /* getLevelsData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSubmit:function onSubmit(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_applicantAccreditations_pendingAccreditations__["d" /* fetchValidatePendingAccreditation */])(id,data));},onDiscard:function onDiscard(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_applicantAccreditations_pendingAccreditations__["b" /* fetchDiscardPendingAccreditation */])(id));},onContinentSetByCountry:function onContinentSetByCountry(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_location__["i" /* setCurrentContinentByCountry */])(countryCode));},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onGetLevels:function onGetLevels(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_levels__["b" /* fetchGetLevels */])());},onGetVIDs:function onGetVIDs(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_VIDs__["c" /* fetchGetVIDs */])());},onOpenValidatePendingAccreditationModal:function onOpenValidatePendingAccreditationModal(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__["_12" /* MODAL_VALIDATE_PENDING_ACCREDITATION */]}));},onOpenDiscardPendingAccreditationModal:function onOpenDiscardPendingAccreditationModal(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__["x" /* MODAL_DISCARD_PENDING_ACCREDITATION */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__ValidatePendingAccreditation__["a" /* default */]));

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__accreditationManagement_validateAccreditation_inputWithPopover_InputWithPopover_container__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ValidatePendingAccreditation_css__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ValidatePendingAccreditation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ValidatePendingAccreditation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__validatePendingAccreditationModal_ValidatePendingAccreditationModal_container__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__discardPendingAccreditationModal_DiscardPendingAccreditationModal_container__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_pageNotFoundComponent_PageNotFoundComponent_container__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ValidatePendingAccreditation=function(_Component){_inherits(ValidatePendingAccreditation,_Component);function ValidatePendingAccreditation(props){_classCallCheck(this,ValidatePendingAccreditation);var _this=_possibleConstructorReturn(this,(ValidatePendingAccreditation.__proto__||Object.getPrototypeOf(ValidatePendingAccreditation)).call(this,props));_this.renderOrganizationData=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validate-pending-accreditation-org-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.issued_by_label')+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this.props.data.issuedByName+', '+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'countries.'+_this.props.data.issuedByCountry)));};_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.isVIDEditable)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Form */],{onSubmit:_this.onSubmit},_this.renderOrganizationData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,className:'accreditation-data-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_label')),_this.renderTitlesFormGroups(),_this.renderAdditionalTitlesFormGroups(),_this.renderAccreditationFormGroups()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.person_label')),_this.renderPersonFormGroups())),_this.renderSubmitFormGroup());}else{return null;}};_this.renderTitlesFormGroups=function(){var paramsList=[{value:"titleOrig",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_orig_label')+"*"},{value:"titleEn",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_en_label')+"*"}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderAdditionalTitlesFormGroups=function(){var title=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{key:'additional-langs-title'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.additional_translations_label'));var paramsList=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_this.props.data.titlesAdditional,function(value,key){var oldValue=_this.props.data.original.titlesAdditional&&_this.props.data.original.titlesAdditional[key]?_this.props.data.original.titlesAdditional[key]:value;paramsList.push({value:key,title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'langs.'+key),oldValue:oldValue,proposedValue:_this.fieldErrorsHasValue(key)?_this.state.fieldErrors[key].value:value,newValueText:value});});var result=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));return result.length!==0?[title].concat(_toConsumableArray(result)):null;};_this.renderAccreditationFormGroups=function(){var content=__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLevelsOptions(_this.props.levels,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels'));var selectedOption=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(content,function(option){return _this.fieldErrorsHasValue('level')?option.value===_this.state.fieldErrors['level'].value:option.value===_this.props.data['level'];});var oldValue=_this.originalDataHasValue('level')?_this.props.data.original.level:_this.props.data.level;var params={value:"level",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.level_label')+"*",type:'select',oldValue:oldValue,oldValueText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels.'+oldValue),proposedValueText:_this.fieldErrorsHasValue('level')?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels.'+_this.state.fieldErrors.level.value):'',newValueText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels.'+_this.props.data.level),popoverPlacement:'left',componentType:__WEBPACK_IMPORTED_MODULE_16__commonComponents_customSelect_CustomSelect_container__["a" /* default */],componentProps:{options:content,selectedOption:selectedOption,isSearchable:false,onSelect:_this.handleChangeProposedValue("level"),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.level_input_placeholder')}};return[_this.renderDateIssued(),_this.getFormGroup(params)];};_this.renderDateIssued=function(){var params={value:"dateIssued",className:'date-issued-input',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.date_issued_label')+"*",oldValueText:(_this.originalDataHasValue('dateIssued')?_this.props.data.original:_this.props.data).dateIssued.format("L"),proposedValueText:_this.fieldErrorsHasValue('dateIssued')?_this.state.fieldErrors.dateIssued.value.format("L"):'',newValueText:__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.dateIssued).format('L'),componentType:__WEBPACK_IMPORTED_MODULE_5_react_datepicker__["a" /* default */],componentProps:{customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{id:'date-issued'}),showMonthDropdown:true,showYearDropdown:true,dropdownMode:"select",maxDate:__WEBPACK_IMPORTED_MODULE_6_moment___default()()},popoverPlacement:'left'};return _this.getFormGroup(params);};_this.renderPersonFormGroups=function(){var countries=__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].countries));var selectedCountry=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(countries,function(option){return _this.fieldErrorsHasValue('personCountry')?option.value===_this.state.fieldErrors['personCountry'].value:option.value===_this.props.data['personCountry'];});var paramsList=[{value:"personFirstName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)+"*"},{value:"personLastName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)+"*"},{value:"personNationalId",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].national_id_label)+"*",popoverHintParams:{hintText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.national_id_hint')}},{value:"personCountry",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)+"*",type:'select',componentType:__WEBPACK_IMPORTED_MODULE_16__commonComponents_customSelect_CustomSelect_container__["a" /* default */],componentProps:{options:countries,isSearchable:false,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),onSelect:_this.handleChangeProposedValue("personCountry"),selectedOption:selectedCountry}}];if(_this.props.isVIDEditable){return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));}else{return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getNotEditableFormGroup)));}};_this.getNotEditableFormGroup=function(params){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(params)||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var value=void 0;if(params.value==="personCountry"){value=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].countries+"."+_this.props.data[params.value]);}else{value=_this.props.data[params.value];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{sm:4},params.title,_this.renderHintPopover(params.value,params.popoverHintParams)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{sm:8},value));};_this.getFormGroup=function(params){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(params)||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.kebabCase(params.value);if(params.value==="personCountry"){return _this.renderContinentAndCountryComponent(params);}var oldValue=_this.props.data[params.value];if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(params.oldValue)){oldValue=params.oldValue;}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(_this.props.data.original,params.value)){oldValue=_this.props.data.original[params.value];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{sm:3},params.title,_this.renderHintPopover(params.value,params.popoverHintParams)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__accreditationManagement_validateAccreditation_inputWithPopover_InputWithPopover_container__["a" /* default */],{id:id,className:params.className||'',popoverPlacement:params.popoverPlacement,editMode:_this.fieldErrorsHasValue(params.value),oldValue:oldValue,proposedValue:params.proposedValue||(_this.fieldErrorsHasValue(params.value)?_this.state.fieldErrors[params.value].value:_this.props.data[params.value]),newValueText:params.newValueText||_this.props.data[params.value],message:_this.fieldErrorsHasValue(params.value)?_this.state.fieldErrors[params.value].reason:null,onChangeProposedValue:_this.handleChangeProposedValue(params.value),onChangeMessage:_this.handleChangeMessage(params.value),onChangeToggle:_this.handleChangeFieldErrors(params.value),type:params.type||'text',oldValueText:params.oldValueText,proposedValueText:params.proposedValueText,componentType:params.componentType,componentProps:params.componentProps},params.content)));};_this.renderHintPopover=function(fieldName,params){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(params)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validate-pending-accreditation-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:fieldName+'-hint',className:'validate-pending-accreditation-hint-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Q" /* UncontrolledPopover */],{trigger:'legacy',placement:'top',target:fieldName+'-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["I" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(params.hintText)))));}};_this.fieldErrorsHasValue=function(value){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(_this.state.fieldErrors,''+value);};_this.originalDataHasValue=function(value){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(_this.props.data.original,value);};_this.renderSubmitFormGroup=function(){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,className:'reject-message',key:'reject-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:7,className:'textarea-col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validate_accreditation.common_message_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{type:'textarea',value:_this.state.message,onChange:_this.handleChange("message"),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validate_accreditation.common_message_placeholder')})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:'submit-validation-pending-accreditation-btns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:12,className:'submit-validation-pending-accreditation-btns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{onClick:_this.onSendBackToReview,title:_this.isAccreditationEdited()?"":__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validate_accreditation.submit_button_invalidate_title'),disabled:!_this.isAccreditationEdited()},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"applicant_accreditations_management.send_back_accreditation_button_label")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'discard-pending-accreditation-button carrot-red-btn',onClick:_this.onDiscardButtonClick},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"applicant_accreditations_management.discard_accreditation_button_label")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"applicant_accreditations_management.accept_accreditation_button_label")))))];};_this.isAccreditationEdited=function(){return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.state.fieldErrors)||_this.state.message!=='';};_this.getNewValue=function(fieldKey){if(_this.fieldErrorsHasValue(fieldKey)){return _this.state.fieldErrors[fieldKey].value;}return _this.props.data[fieldKey];};_this.onSendBackToReview=function(){var titles={original:_this.getNewValue('titleOrig'),en:_this.getNewValue('titleEn')};__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(_this.props.data.titlesAdditional,function(title,lang){if(lang!==""&&title!==""){titles[lang]=_this.fieldErrorsHasValue(lang)?_this.state.fieldErrors[lang].value:_this.props.data.titlesAdditional[lang];}});var data={accreditationData:{issuedAt:_this.getNewValue('dateIssued').format("YYYY-MM-DD"),level:_this.getNewValue('level'),titles:titles},verifiedIdentity:{firstName:_this.getNewValue('personFirstName'),lastName:_this.getNewValue('personLastName'),countryCode:_this.getNewValue('personCountry'),nationalId:_this.getNewValue('personNationalId')},answer:{message:_this.state.message,fieldErrors:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(_this.state.fieldErrors),accepted:false}};if(_this.fieldErrorsHasValue('dateIssued')){data.answer.fieldErrors.dateIssued.value=data.answer.fieldErrors.dateIssued.value.format("YYYY-MM-DD");}_this.props.onSubmit(_this.props.id,data);};_this.onDiscardButtonClick=function(){_this.props.onOpenDiscardPendingAccreditationModal();};_this.onDiscardAccreditation=function(){_this.props.onDiscard(_this.props.id);};_this.onSubmit=function(e){e.preventDefault();if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.state.fieldErrors)){_this.onValidateAccreditation();}else{_this.props.onOpenValidatePendingAccreditationModal();}};_this.onValidateAccreditation=function(){var data={answer:{accepted:true}};_this.props.onSubmit(_this.props.id,data);};_this.handleChangeMessage=function(fieldKey){return function(e){var newFieldErrors=_this.state.fieldErrors;newFieldErrors[fieldKey].reason=e.target.value;_this.setState({fieldErrors:newFieldErrors});};};_this.handleChangeProposedValue=function(fieldKey){return function(e){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(e)){return;}var newValue=void 0;if(fieldKey==="dateIssued"){newValue=e;}else{newValue=e.value||e.target.value;}var newFieldErrors=void 0;if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(newValue,_this.props.data[fieldKey])||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data[fieldKey])&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(newValue,_this.props.data.titlesAdditional[fieldKey])){newFieldErrors=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omit(_this.state.fieldErrors,fieldKey);}else{newFieldErrors=_this.state.fieldErrors;if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(newFieldErrors[fieldKey])){newFieldErrors[fieldKey]={value:null,reason:""};}newFieldErrors[fieldKey].value=newValue;}_this.setState({fieldErrors:newFieldErrors});};};_this.handleChangeFieldErrors=function(fieldKey){return function(){var newFieldErrors=void 0;if(_this.fieldErrorsHasValue(fieldKey)){newFieldErrors=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pickBy(_this.state.fieldErrors,function(value,key){return key!==fieldKey;});if(fieldKey==="personCountry"){_this.props.onContinentSetByCountry(_this.props.data.personCountry);}}else{newFieldErrors=_this.state.fieldErrors;newFieldErrors[fieldKey]={value:_this.props.data[fieldKey]||_this.props.data.titlesAdditional[fieldKey],reason:""};}_this.setState({fieldErrors:newFieldErrors});};};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleChangeContinent=function(e){var newFieldErrors=_this.state.fieldErrors;newFieldErrors.personCountry={};newFieldErrors.personCountry.value="";_this.setState({fieldErrors:newFieldErrors});_this.props.onContinentSet(e.target.value);};_this.state={personContinent:_this.props.continentCode,message:'',fieldErrors:{}};return _this;}_createClass(ValidatePendingAccreditation,[{key:'componentWillMount',value:function componentWillMount(){this.props.onGetVIDs(this.props.id);if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.data)){this.props.onGetLevels(this.props.data.accreditationGroupId);this.props.onContinentSetByCountry(this.props.data.personCountry);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.state.personContinent!==nextProps.continentCode){this.setState({personContinent:nextProps.continentCode});}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(nextProps.data)){this.props.onContinentSetByCountry(nextProps.data.personCountry);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onContinentSet('');}},{key:'render',value:function render(){if(this.props.success){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Redirect */],{to:'/pending-accreditations',push:true});}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.id)||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_pageNotFoundComponent_PageNotFoundComponent_container__["a" /* default */],null);}if(this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validate-pending-accreditation-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validate-pending-accreditation-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'validate_accreditation.success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/pending-accreditations',label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].back_button)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validate-pending-accreditation-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'validate_accreditation.label')),this.renderContent())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__validatePendingAccreditationModal_ValidatePendingAccreditationModal_container__["a" /* default */],{onAcceptAccreditation:this.onValidateAccreditation}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__discardPendingAccreditationModal_DiscardPendingAccreditationModal_container__["a" /* default */],{onDiscardAccreditation:this.onDiscardAccreditation}));}},{key:'renderContinentAndCountryComponent',value:function renderContinentAndCountryComponent(params){var _this2=this;var id=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.kebabCase(params.value);var proposedValueText=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.state.fieldErrors[params.value])?null:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].countries+"."+this.state.fieldErrors[params.value].value);var continents=__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLocationOptions(this.props.continents,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].continents));var selectedContinent=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(continents,function(option){return option.value===_this2.state.personContinent;});var oldValue=(this.originalDataHasValue(params.value)?this.props.data.original:this.props.data)[params.value];return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:'continent-select',className:'continent-select-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':'continent-select',sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,className:'continent-select-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:11},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{selectedOption:selectedContinent,options:continents,onSelect:this.handleChangeContinent,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_8__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),disabled:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.continents)&&!this.fieldErrorsHasValue(params.value)}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__accreditationManagement_validateAccreditation_inputWithPopover_InputWithPopover_container__["a" /* default */],{id:id,type:'select',popoverPlacement:'left',editMode:this.fieldErrorsHasValue(params.value),oldValue:oldValue,oldValueText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'countries.'+oldValue),proposedValue:this.fieldErrorsHasValue(params.value)?this.state.fieldErrors[params.value].value:null,proposedValueText:proposedValueText,newValueText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'countries.'+this.props.data[params.value]),message:this.fieldErrorsHasValue(params.value)?this.state.fieldErrors[params.value].reason:null,onChangeProposedValue:this.handleChangeProposedValue(params.value),onChangeMessage:this.handleChangeMessage(params.value),onChangeToggle:this.handleChangeFieldErrors(params.value),componentType:params.componentType,componentProps:Object.assign({},params.componentProps,{disabled:this.fieldErrorsHasValue(params.value)&&(this.state.personContinent===''||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.countries))})},params.content)))];}}]);return ValidatePendingAccreditation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ValidatePendingAccreditation.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,continentCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,levels:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,isVIDEditable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onDiscard:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onContinentSet:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onContinentSetByCountry:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetLevels:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetVIDs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onOpenValidatePendingAccreditationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onOpenDiscardPendingAccreditationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ValidatePendingAccreditation);

/***/ }),
/* 934 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ValidatePendingAccreditationModal__ = __webpack_require__(936);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_12" /* MODAL_VALIDATE_PENDING_ACCREDITATION */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__ValidatePendingAccreditationModal__["a" /* default */]));

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ValidatePendingAccreditationModal_css__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ValidatePendingAccreditationModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ValidatePendingAccreditationModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ValidatePendingAccreditationModal=function(_Component){_inherits(ValidatePendingAccreditationModal,_Component);function ValidatePendingAccreditationModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ValidatePendingAccreditationModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ValidatePendingAccreditationModal.__proto__||Object.getPrototypeOf(ValidatePendingAccreditationModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleValidate=function(e){e.preventDefault();_this.props.onAcceptAccreditation();_this.props.onCancel();},_this.handleCancel=function(){_this.props.onCancel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ValidatePendingAccreditationModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'validate-pending-accreditation-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],{className:'validate-pending-accreditation-modal-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{className:'validate-pending-accreditation-modal-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'validate_accreditation.validate_accreditation_message')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{className:'validate-pending-accreditation-modal-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleValidate},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"applicant_accreditations_management.accept_accreditation_button_label"))))));}}]);return ValidatePendingAccreditationModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ValidatePendingAccreditationModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onAcceptAccreditation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ValidatePendingAccreditationModal);

/***/ }),
/* 937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DiscardPendingAccreditationModal__ = __webpack_require__(939);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["x" /* MODAL_DISCARD_PENDING_ACCREDITATION */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__DiscardPendingAccreditationModal__["a" /* default */]));

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DiscardPendingAccreditationModal_css__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DiscardPendingAccreditationModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DiscardPendingAccreditationModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DiscardPendingAccreditationModal=function(_Component){_inherits(DiscardPendingAccreditationModal,_Component);function DiscardPendingAccreditationModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DiscardPendingAccreditationModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DiscardPendingAccreditationModal.__proto__||Object.getPrototypeOf(DiscardPendingAccreditationModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleDiscard=function(e){e.preventDefault();_this.props.onDiscardAccreditation();_this.props.onCancel();},_this.handleCancel=function(){_this.props.onCancel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DiscardPendingAccreditationModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'discard-pending-accreditation-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],{className:'discard-pending-accreditation-modal-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{className:'discard-pending-accreditation-modal-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"applicant_accreditations_management.discard_accreditation_message")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"applicant_accreditations_management.discard_accreditation_warning_message")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{className:'discard-pending-accreditation-modal-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'carrot-red-btn',onClick:this.handleDiscard},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"applicant_accreditations_management.discard_accreditation_button_label"))))));}}]);return DiscardPendingAccreditationModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DiscardPendingAccreditationModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onDiscardAccreditation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (DiscardPendingAccreditationModal);

/***/ }),
/* 940 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VIDsList__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_applicantAccreditations_VIDs__ = __webpack_require__(109);
var mapStateToProps=function mapStateToProps(state){return{data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_applicantAccreditations_VIDs__["f" /* getVIDsData */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_applicantAccreditations_VIDs__["g" /* getVIDsLoading */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGetVIDs:function onGetVIDs(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_applicantAccreditations_VIDs__["d" /* fetchGetVIDsForList */])());},onUpdateVID:function onUpdateVID(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_applicantAccreditations_VIDs__["e" /* fetchUpdateVID */])(id,data));},onActivateVID:function onActivateVID(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_applicantAccreditations_VIDs__["b" /* fetchActivateVID */])(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__VIDsList__["a" /* default */]));

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VIDsList_css__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VIDsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__VIDsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_select__ = __webpack_require__(79);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customStyles={container:function container(provided){return Object.assign({},provided,{maxWidth:300});},option:function option(provided,state){return Object.assign({},provided,{":hover":{backgroundColor:state.isSelected?'#89aa11':'rgba(137, 170, 17, 0.44)'},backgroundColor:state.isSelected?'#89aa11':'white',cursor:'pointer',fontSize:'.9rem',paddingTop:'0',paddingBottom:'0',textOverflow:'ellipsis',overflow:'hidden'});},control:function control(provided,state){return Object.assign({},provided,{fontSize:'.875rem',cursor:'pointer',minHeight:'calc(1.5em + .5rem + 2px)',height:'calc(1.5em + .5rem + 2px)',border:'1px solid #ced4da',":hover":{border:'1px solid #ced4da'},borderColor:state.isFocused?'#80bdff':'#ced4da',boxShadow:state.isFocused?'0 0 0 0.2rem rgba(0,123,255,.25)':'none'});},dropdownIndicator:function dropdownIndicator(provided){return Object.assign({},provided,{padding:'0 5px 0 0'});},indicatorSeparator:function indicatorSeparator(){return{display:'none'};},menu:function menu(styles){return Object.assign({},styles,{marginTop:'0',marginBottom:'0',borderRadius:'0'});},menuList:function menuList(styles){return Object.assign({},styles,{paddingTop:'0',paddingBottom:'0'});}};var VIDsList=function(_Component){_inherits(VIDsList,_Component);function VIDsList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VIDsList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VIDsList.__proto__||Object.getPrototypeOf(VIDsList)).call.apply(_ref,[this].concat(args))),_this),_this.renderContent=function(){if(_this.props.loading&&(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vids-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vids-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.no_vids_label'))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["N" /* Table */],{className:'vids-list-table',cellSpacing:'0',key:'vids-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.active_vid_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].national_id_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'vid-expose-name-country-header'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.expose_fn_ln_country')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'vid-expose-national-id-header'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.expose_national_id')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderVIDsData()));},_this.getExposeNIDOptions=function(){return[{value:__WEBPACK_IMPORTED_MODULE_8__constants_constants__["i" /* EXPOSE_NID_OPTIONS */].NOT_EXPOSE,label:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.expose_nid_option_not_expose')},{value:__WEBPACK_IMPORTED_MODULE_8__constants_constants__["i" /* EXPOSE_NID_OPTIONS */].EXPOSE_SHORT,label:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.expose_nid_option_short')},{value:__WEBPACK_IMPORTED_MODULE_8__constants_constants__["i" /* EXPOSE_NID_OPTIONS */].EXPOSE_FULL,label:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'applicant_accreditations_management.expose_nid_option_full')}];},_this.getExposeNIDSelectedOption=function(vid){var selectedElem=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(_this.getExposeNIDOptions(),function(elem){return elem.value===vid.exposeNationalIdLevel;});if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(selectedElem)){return null;}return selectedElem;},_this.onExposeClick=function(key,id,vid){return function(){var data=vid;data[key]=!vid[key];_this.props.onUpdateVID(id,data);};},_this.handleChangeExposeNID=function(id,vid){return function(selectedOption){var data=vid;data.exposeNationalIdLevel=selectedOption.value;_this.props.onUpdateVID(id,data);};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VIDsList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onGetVIDs();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vids-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'applicant_accreditations_management.vids_label')),this.renderContent());}},{key:'renderVIDsData',value:function renderVIDsData(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(this.props.data,function(vid){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:vid.id,className:"vids-list-row"+(vid.active?' active-vid':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'active-vid-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'applicant_accreditations_management.active_vid_label')+":"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'vid-active-vid-icon',icon:"radio_button"+(!vid.active?"_unchecked":"_checked"),key:"vid-active-vid-"+vid.id,onClick:function onClick(){_this2.props.onActivateVID(vid.id);},title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'applicant_accreditations_management.active_vid_title_'+(vid.active?"checked":"unchecked"))})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'vid-first-name-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)+":"},vid.firstName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'vid-last-name-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)+":"},vid.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'vid-national-id-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].national_id_label)+":"},vid.nationalId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'vid-country-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)+":"},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'countries.'+vid.countryCode)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'vid-expose-name-country-icon-container','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'applicant_accreditations_management.expose_fn_ln_country')+":"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'vid-expose-name-country-icon',icon:"check_box"+(!vid.exposeNameCountry?"_outline_blank":""),key:"vid-expose-name-country-"+vid.id,onClick:_this2.onExposeClick("exposeNameCountry",vid.id,vid),title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'applicant_accreditations_management.expose_fn_ln_country')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'vid-expose-national-id-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'applicant_accreditations_management.expose_national_id')+":"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["b" /* default */],{styles:customStyles,options:_this2.getExposeNIDOptions(),value:_this2.getExposeNIDSelectedOption(vid),onChange:_this2.handleChangeExposeNID(vid.id,vid),isSearchable:false})));});}}]);return VIDsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);VIDsList.propTypes={data:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,loading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onGetVIDs:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onUpdateVID:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (VIDsList);

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RegisterOrgByAnchor__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{continentCode:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_location__["e" /* getCountriesData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onOpenModal:function onOpenModal(countryCode,organizationType){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__["g" /* fetchGetOrgPriceByAnchor */])(countryCode,organizationType));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["I" /* MODAL_REGISTER_ORG_BY_ANCHOR */]}));},onRegister:function onRegister(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__["h" /* fetchRegisterOrgByAnchor */])(data));},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onShowLicenseAgreement:function onShowLicenseAgreement(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["F" /* MODAL_LICENSE_AGREEMENT */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RegisterOrgByAnchor__["a" /* default */]));

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RegisterOrgByAnchor_css__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RegisterOrgByAnchor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RegisterOrgByAnchor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__registerOrgByAnchorModal_RegisterOrgByAnchorModal_container__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_domainInput_DomainInput__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commonComponents_licenseAgreement_LicenseAgreementModal_container__ = __webpack_require__(133);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var requiredSelectFields=['orgCountry'];var RegisterOrgByAnchor=function(_Component){_inherits(RegisterOrgByAnchor,_Component);function RegisterOrgByAnchor(props){_classCallCheck(this,RegisterOrgByAnchor);var _this=_possibleConstructorReturn(this,(RegisterOrgByAnchor.__proto__||Object.getPrototypeOf(RegisterOrgByAnchor)).call(this,props));_this.renderOrganizationDataFormGroups=function(){var paramsList=[{value:"orgName",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.name_label')+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.name_label')},{value:"orgDomain",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label)},{value:"orgVatNumber",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.vat_number_label'),isRequired:false,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.vat_number_label')},{value:"companyCode",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.company_code_label'),isRequired:false,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.company_code_label')},{value:'orgEmployeeCount',title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].employee_count_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_8__constants_constants__["h" /* EMPLOYEES_COUNT_VALUES */],function(value){return{code:value.code,name:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,value.name)||value.name};})),onChange:_this.handleChangeSelect('orgEmployeeCount')},{value:'financialData',title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.financial_data_label')+'*',type:'textarea',placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.financial_data_placeholder'),isRequired:true}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderOrganizationAddressFormGroup=function(){var paramsList=[{value:"orgContinent",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label)+'*',onChange:_this.handleChangeContinent,type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),isDisabled:!_this.props.continents},{value:"orgCountry",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)+'*',onChange:_this.handleChangeSelect('orgCountry'),type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isDisabled:!_this.props.countries},{value:"orgCity",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.city_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.city_label')},{value:"orgPostal",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.postal_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.postal_label')},{value:"orgStreet",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.street_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'orgs.street_label')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderAnchorFormGroups=function(){var paramsList=[{value:"anchorEmail",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+"*",type:"email",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)},{value:"anchorFirstName",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)},{value:"anchorLastName",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.getFormGroup=function(params){if(params.type==='select'){return _this.getSelectFormGroup(params);}if(params.value==='orgDomain'){return _this.getOrganizationDomainFormGroup(params);}if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this.renderPopover(params),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:_this.state[params.value],onChange:params.onChange||_this.handleChange(params.value),placeholder:params.placeholder,disabled:params.isDisabled,required:params.isRequired},params.content)));};_this.getOrganizationDomainFormGroup=function(params){var id=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this.renderPopover(params),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_domainInput_DomainInput__["a" /* default */],{id:id,value:_this.state[params.value],onChange:_this.handleChangeDomainInput,placeholder:params.placeholder||params.title,disabled:params.isDisabled,required:params.isRequired})));};_this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];}),options:params.content,onSelect:params.onChange,placeholder:params.placeholder,disabled:params.isDisabled,requiredFieldError:_this.state.requiredFieldError===params.value})));};_this.renderPopover=function(params){var hintText='';var id='register-org-by-anchor-';switch(params.value){case'orgDomain':id+='domain-hint-container';hintText=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'register_org.domain_hint');break;case'companyCode':id+='company-code-hint-container';hintText=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'register_org.company_code_hint');break;case'financialData':id+='financial-data-container';hintText=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'part_1'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'register_org.financial_data_hint_part_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'part_2'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'register_org.financial_data_hint_part_2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'part_3'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'register_org.financial_data_hint_part_3'))];break;default:return;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'register-org-by-anchor-domain-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:id,className:'register-org-by-anchor-icon-container',onClick:_this.togglePopover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["H" /* Popover */],{placement:'bottom',isOpen:_this.state.popoverOpen===params.value,target:id,toggle:_this.togglePopover(params.value)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["I" /* PopoverBody */],null,hintText)));};_this.handleAgree=function(){_this.setState({agreeWithLicense:true});};_this.handleChangeAgreement=function(){_this.setState({agreeWithLicense:!_this.state.agreeWithLicense});};_this.handleClickLicenseAgreement=function(e){e.preventDefault();console.log('click');_this.props.onShowLicenseAgreement();};_this.togglePopover=function(type){return function(){if(_this.state.popoverOpen===type){_this.setState({popoverOpen:null});}else{_this.setState({popoverOpen:type});}};};_this.handleChangeSelect=function(fieldKey){return function(selectedOption){_this.setState(_defineProperty({},fieldKey,selectedOption.value));};};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleChangeDomainInput=function(data){_this.setState({orgDomain:data});};_this.toggleCheckbox=function(fieldKey){return function(){_this.setState(_defineProperty({},fieldKey,!_this.state[fieldKey]));};};_this.handleChangeContinent=function(selectedOption){_this.props.onContinentSet(selectedOption.value);_this.setState({orgCountry:''});};_this.onSubmit=function(e){e.preventDefault();if(_this.checkRequiredSelectFields()){return;}_this.props.onOpenModal(_this.state.orgCountry,__WEBPACK_IMPORTED_MODULE_9__reducers_organization_organizations__["a" /* COMPANY */]);};_this.handleProceed=function(){var data={type:__WEBPACK_IMPORTED_MODULE_9__reducers_organization_organizations__["a" /* COMPANY */],name:_this.state.orgName,domain:_this.state.orgDomain,address:{countryCode:_this.state.orgCountry,city:_this.state.orgCity,postal:_this.state.orgPostal,street:_this.state.orgStreet},vatNumber:_this.state.orgVatNumber,companyCode:_this.state.companyCode,anchor:{email:_this.state.anchorEmail,identityAlias:{firstName:_this.state.anchorFirstName,lastName:_this.state.anchorLastName,countryCode:_this.state.orgCountry}},hasIVs:false,verifiesIdentities:false,providesMoocCertificates:false,employeeCount:_this.state.orgEmployeeCount,financialData:_this.state.financialData,validated:false};_this.props.onRegister(data);};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(requiredSelectFields,function(field){if(!_this.state[field]&&!error){error=field;}});_this.setState({requiredFieldError:error});return error;};_this.state={orgName:'',orgDomain:'',orgVatNumber:'',companyCode:'',orgContinent:_this.props.continentCode,orgEmployeeCount:'UNKNOWN',orgCountry:'',orgCity:'',orgPostal:'',orgStreet:'',orgStreetNumber:'',orgBusNumber:'',anchorFirstName:'',anchorLastName:'',anchorEmail:'',financialData:'',popoverOpen:null,success:false,requiredFieldError:null,agreeWithLicense:false};_this.resetData=_this.resetData.bind(_this);return _this;}_createClass(RegisterOrgByAnchor,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.state.orgContinent!==nextProps.continentCode){this.setState({orgContinent:nextProps.continentCode});}if(nextProps.success&&!this.props.success){this.setState({success:true});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onContinentSet('');}},{key:'render',value:function render(){if(this.state.success){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/login',label:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'register_org.back_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center success-message-header'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'register_org.success_message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center success-message-header'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'register_applicant.success_message')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'register-anchor-org-by-anchor-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'register_org.success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/login',label:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'register_org.back_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'register-anchor-org-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'register_org.company_registration_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.onSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'register-anchor-org-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)),this.renderOrganizationDataFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'orgs.address_label')),this.renderOrganizationAddressFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'register-anchor-org-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'orgs.anchor_label')),this.renderAnchorFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'register-anchor-org-license-agreement-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{className:'checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'checkbox',checked:this.state.agreeWithLicense,onChange:this.handleChangeAgreement}),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,"license_agreement.agree_label"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'',className:'register-anchor-org-license-agreement-link',onClick:this.handleClickLicenseAgreement},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,"license_agreement.agree_link")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn',disabled:!this.state.agreeWithLicense},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'register_org.register_button'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__registerOrgByAnchorModal_RegisterOrgByAnchorModal_container__["a" /* default */],{orgName:this.state.orgName,orgCountryCode:this.state.orgCountry,onProceed:this.handleProceed})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commonComponents_licenseAgreement_LicenseAgreementModal_container__["a" /* default */],{onAgree:this.handleAgree}));}},{key:'resetData',value:function resetData(){this.setState({orgName:'',orgDomain:'',orgVatNumber:'',companyCode:'',orgContinent:this.props.continentCode,orgEmployeeCount:'UNKNOWN',orgCountry:'',orgCity:'',orgPostal:'',orgStreet:'',orgStreetNumber:'',orgBusNumber:'',anchorFirstName:'',anchorLastName:'',anchorEmail:'',popoverOpen:null});this.props.onContinentSet('');}}]);return RegisterOrgByAnchor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RegisterOrgByAnchor.propTypes={continentCode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,lastUsedContinent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,success:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,onRegister:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onContinentSet:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onOpenModal:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onShowLicenseAgreement:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RegisterOrgByAnchor);

/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RegisterOrgByAnchorModal__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["I" /* MODAL_REGISTER_ORG_BY_ANCHOR */],pricingData:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__["r" /* getOrgPricingData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__RegisterOrgByAnchorModal__["a" /* default */]));

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RegisterOrgByAnchorModal_css__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RegisterOrgByAnchorModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__RegisterOrgByAnchorModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_utils__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegisterOrgByAnchorModal=function(_Component){_inherits(RegisterOrgByAnchorModal,_Component);function RegisterOrgByAnchorModal(props){_classCallCheck(this,RegisterOrgByAnchorModal);var _this=_possibleConstructorReturn(this,(RegisterOrgByAnchorModal.__proto__||Object.getPrototypeOf(RegisterOrgByAnchorModal)).call(this,props));_this.toggle=function(){_this.setState({isOpenBankInfo:!_this.state.isOpenBankInfo});};_this.state={isOpenBankInfo:false};return _this;}_createClass(RegisterOrgByAnchorModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.pricingData)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["w" /* Modal */],{className:'register-org-modal',isOpen:this.props.isOpen,toggle:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{className:'register-org-modal-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'register_org.register_org_by_anchor_alert')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{className:'register-org-modal-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.annual_license_cost_label')+': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.pricingData.annualFee.amount,__WEBPACK_IMPORTED_MODULE_7__constants_constants__["g" /* CURRENCIES */][this.props.pricingData.annualFee.currency])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{className:'register-org-modal-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.wire_label')+' ',__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.account_id_label').replace("{iban}",__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getBankDataByCountry(this.props.orgCountryCode,this.props.translation),'iban_number'))+' ',__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.create_account_label')+' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.create_account_message_label').replace("{orgName}",this.props.orgName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'payment-info-icon',icon:'info',onClick:this.toggle,title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.bank_details_label')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["i" /* Collapse */],{className:'payment-info-collapse',isOpen:this.state.isOpenBankInfo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["d" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* CardBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.about_us_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'payment.bank_data_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bank-data-container'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getBankDataByCountry(this.props.orgCountryCode,this.props.translation),'bank_data')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{className:'register-org-modal-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'register_org.register_org_by_anchor_hint')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.props.onProceed},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'register_org.proceed_button')))));}}]);return RegisterOrgByAnchorModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RegisterOrgByAnchorModal.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,orgName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,orgCountryCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,pricingData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onProceed:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RegisterOrgByAnchorModal);

/***/ }),
/* 949 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateAccount__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__CreateAccount__["a" /* default */]));

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreateAccount_css__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreateAccount_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CreateAccount_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateAccount=function(_Component){_inherits(CreateAccount,_Component);function CreateAccount(){_classCallCheck(this,CreateAccount);return _possibleConstructorReturn(this,(CreateAccount.__proto__||Object.getPrototypeOf(CreateAccount)).apply(this,arguments));}_createClass(CreateAccount,[{key:'render',value:function render(){// TODO: change link http to https
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'create-account-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/login',label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].back_button)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'create-account-box-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'login.create_account_alert')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["f" /* CardDeck */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["d" /* Card */],{body:true,className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["g" /* CardText */],null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'login.create_an_label')+' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'login.applicant_button')+' '),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'login.applicant_account_hint')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{tag:__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],to:'/applicant-registration',className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'login.applicant_button'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["d" /* Card */],{body:true,className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["g" /* CardText */],null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'login.create_a_label')+' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'login.company_button')+' '),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'login.company_account_hint')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{tag:__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],to:'/company-registration',className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'login.company_button')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hint-message'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'login.more_info_label')+' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.brainchainmission.org',target:'_blank',rel:'noopener noreferrer'},'www.brainchainmission.org')));}}]);return CreateAccount;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CreateAccount.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (CreateAccount);

/***/ }),
/* 952 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrgSettings__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{data:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__["s" /* getOrgSettings */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__["y" /* loadingOrg */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["e" /* getCountriesData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__["d" /* fetchGetOrg */])());},onSetContinent:function onSetContinent(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_location__["h" /* setCurrentContinent */])(''));},onSaveChanges:function onSaveChanges(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__["b" /* fetchEditOrgByAnchor */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__OrgSettings__["a" /* default */]));

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrgSettings_css__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrgSettings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__OrgSettings_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var requiredSelectFields=['orgCountry'];var OrgSettings=function(_Component){_inherits(OrgSettings,_Component);function OrgSettings(props){_classCallCheck(this,OrgSettings);var _this=_possibleConstructorReturn(this,(OrgSettings.__proto__||Object.getPrototypeOf(OrgSettings)).call(this,props));_initialiseProps.call(_this);_this.state={orgEmployeeCount:'UNKNOWN',orgContinent:_this.props.continentCode,orgCountry:'',orgCity:'',orgPostal:'',orgStreet:'',financialData:'',requiredFieldError:null,popoverOpen:null};return _this;}_createClass(OrgSettings,[{key:'componentWillMount',value:function componentWillMount(){this.props.onMount();if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){this.onDataLoaded(this.props);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.data)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(nextProps.data,this.props.data)){this.onDataLoaded(nextProps);}if(this.state.orgContinent!==nextProps.continentCode){this.setState({orgContinent:nextProps.continentCode});}if(nextProps.continentCode===''&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.data)){this.props.onSetContinent(nextProps.data.orgContinent);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}},{key:'render',value:function render(){if(this.state.backToList){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["d" /* Redirect */],{to:'/organizations',push:true});}if(this.props.loading&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-details-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'edit_org.org_edit_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'org_management.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-details-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.onOrgEdit},this.renderOrgDataRows(),this.renderOrganizationDataFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.address_label')),this.renderOrganizationAddressFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit',disabled:this.saveButtonDisabled()},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button)))))));}else{return null;}}}]);return OrgSettings;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.onDataLoaded=function(props){_this2.setState({orgEmployeeCount:props.data.orgEmployeeCount,orgCountry:props.data.orgCountry,orgCity:props.data.orgCity,orgPostal:props.data.orgPostal,orgStreet:props.data.orgStreet,financialData:props.data.financialData});_this2.props.onSetContinent(props.data.orgContinent);};this.saveButtonDisabled=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this2.props.data)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.every(_this2.props.data,function(value,key){return _this2.state.hasOwnProperty(key)?_this2.state[key]===value:true;});};this.renderOrgDataRows=function(){var paramsList=[{value:'orgType',data:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["o" /* ORGANIZATION_TYPES */],function(type){return type.code===_this2.props.data.orgType;}).name),title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'orgs.org_type_label')},{value:'orgName',data:_this2.props.data.orgName,title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'orgs.name_label')},{value:'orgDomain',data:_this2.props.data.orgDomain,title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label)},{value:'orgVatNumber',data:_this2.props.data.orgVatNumber,title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'orgs.vat_number_label')},{value:'companyCode',data:_this2.props.data.companyCode,title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'orgs.company_code_label')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this2.getDataRow)));};this.renderOrganizationDataFormGroups=function(){var paramsList=[{value:'orgEmployeeCount',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].employee_count_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["h" /* EMPLOYEES_COUNT_VALUES */],function(value){return{code:value.code,name:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,value.name)||value.name};})),isRequired:true,onChange:_this2.handleChangeSelect('orgEmployeeCount')},{value:'financialData',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'orgs.financial_data_label')+'*',type:'textarea',placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'orgs.financial_data_placeholder'),isRequired:true}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this2.getFormGroup)));};this.renderOrganizationAddressFormGroup=function(){var paramsList=[{value:"orgContinent",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label),onChange:_this2.handleChangeContinent,type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getLocationOptions(_this2.props.continents,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),isDisabled:!_this2.props.continents,isRequired:true},{value:"orgCountry",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),onChange:_this2.handleChangeSelect('orgCountry'),type:'select',content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getLocationOptions(_this2.props.countries,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isDisabled:!_this2.props.countries,isRequired:true},{value:"orgCity",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'orgs.city_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'orgs.city_label')},{value:"orgPostal",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'orgs.postal_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'orgs.postal_label')},{value:"orgStreet",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'orgs.street_label')+'*',isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'orgs.street_label')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this2.getFormGroup)));};this.renderAnchorFormGroups=function(){var paramsList=[{value:"anchorEmail",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+"*",type:"email",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)},{value:"anchorFirstName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)},{value:"anchorLastName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this2.getFormGroup)));};this.getDataRow=function(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'org-settings-row',key:params.value},_this2.renderPopover(params),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},params.title,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,params.data));};this.getFormGroup=function(params){if(params.type==='select'){return _this2.getSelectFormGroup(params);}if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this2.renderPopover(params),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:_this2.state[params.value],onChange:params.onChange||_this2.handleChange(params.value),placeholder:params.placeholder,disabled:params.isDisabled,required:params.isRequired},params.content)));};this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(params.content,function(option){return option.value===_this2.state[params.value];}),options:params.content,onSelect:params.onChange,placeholder:params.placeholder,disabled:params.isDisabled,requiredFieldError:_this2.state.requiredFieldError===params.value})));};this.renderPopover=function(params){var hintText='';var id='org-settings-';switch(params.value){case'companyCode':id+='company-code-hint-container';hintText=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'register_org.company_code_hint');break;case'financialData':id+='financial-data-container';hintText=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'part_1'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'register_org.financial_data_hint_part_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'part_2'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'register_org.financial_data_hint_part_2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'part_3'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'register_org.financial_data_hint_part_3'))];break;default:return;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-settings-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:id,className:'org-settings-icon-container',onClick:_this2.togglePopover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["H" /* Popover */],{placement:'bottom',isOpen:_this2.state.popoverOpen===params.value,target:id,toggle:_this2.togglePopover(params.value)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["I" /* PopoverBody */],null,hintText)));};this.togglePopover=function(type){return function(){if(_this2.state.popoverOpen===type){_this2.setState({popoverOpen:null});}else{_this2.setState({popoverOpen:type});}};};this.handleChangeSelect=function(fieldKey){return function(selectedOption){_this2.setState(_defineProperty({},fieldKey,selectedOption.value));};};this.handleBackButtonClick=function(){_this2.setState({backToList:true});};this.handleChange=function(fieldKey){return function(e){_this2.setState(_defineProperty({},fieldKey,e.target.value));};};this.toggleCheckbox=function(fieldKey){return function(){_this2.setState(_defineProperty({},fieldKey,!_this2.state[fieldKey]));};};this.handleChangeContinent=function(selectedOption){_this2.props.onSetContinent(selectedOption.value);_this2.setState({orgCountry:''});};this.onOrgEdit=function(e){e.preventDefault();if(_this2.checkRequiredSelectFields()){return;}var data={address:{countryCode:_this2.state.orgCountry,city:_this2.state.orgCity,postal:_this2.state.orgPostal,street:_this2.state.orgStreet},employeeCount:_this2.state.orgEmployeeCount,financialData:_this2.state.financialData};_this2.props.onSaveChanges(data);};this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(requiredSelectFields,function(field){if(!_this2.state[field]&&!error){error=field;}});_this2.setState({requiredFieldError:error});return error;};};OrgSettings.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,continentCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onSetContinent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUnmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSaveChanges:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (OrgSettings);

/***/ }),
/* 955 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_consent_consents__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CredentialsVerificationRequest__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_account_aliases__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_organization_organization__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_account_userData__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_consent_consents__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_organization_organization__["y" /* loadingOrg */])(state)||Object(__WEBPACK_IMPORTED_MODULE_6__reducers_account_aliases__["n" /* loadingAliases */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state),yourName:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_account_aliases__["m" /* getDefaultAliasName */])(state),companyName:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_organization_organization__["o" /* getOrgName */])(state),companyDomain:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_organization_organization__["j" /* getEmailDomain */])(state),companyCountry:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_organization_organization__["m" /* getOrgCountryCode */])(state),companyContinent:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["c" /* getContinentByCountry */])(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_organization_organization__["m" /* getOrgCountryCode */])(state),state),departmentId:Object(__WEBPACK_IMPORTED_MODULE_8__reducers_account_role__["k" /* getCurrentGroup */])(state),departmentName:Object(__WEBPACK_IMPORTED_MODULE_8__reducers_account_role__["m" /* getCurrentGroupName */])(state),yourEmail:Object(__WEBPACK_IMPORTED_MODULE_9__reducers_account_userData__["f" /* getUserEmail */])(state),departmentEmail:Object(__WEBPACK_IMPORTED_MODULE_8__reducers_account_role__["l" /* getCurrentGroupEmail */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_11__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),operationAvailability:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_organization_organization__["k" /* getOperationAvailability */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_account_aliases__["e" /* fetchGetDefaultAlias */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_account_aliases__["d" /* fetchGetAliases */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_organization_organization__["d" /* fetchGetOrg */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_organization_organization__["c" /* fetchGetOperationAvailability */])());},onProcessRequest:function onProcessRequest(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_consent_consents__["g" /* fetchRequestCredentialsVerification */])(data));},onProcessBulkRequest:function onProcessBulkRequest(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_consent_consents__["f" /* fetchRequestBulkCredentialsVerification */])(data));},onContinentsSet:function onContinentsSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onResetData:function onResetData(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__CredentialsVerificationRequest__["a" /* default */]));

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CredentialsVerificationRequest_css__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CredentialsVerificationRequest_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CredentialsVerificationRequest_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__consentRequestBulkDropZone_ConsentRequestBulkDropZone_container__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CredentialsVerificationRequest=function(_Component){_inherits(CredentialsVerificationRequest,_Component);function CredentialsVerificationRequest(props){_classCallCheck(this,CredentialsVerificationRequest);var _this=_possibleConstructorReturn(this,(CredentialsVerificationRequest.__proto__||Object.getPrototypeOf(CredentialsVerificationRequest)).call(this,props));_this.renderContent=function(){if(_this.props.operationAvailability&&!_this.props.operationAvailability.canCreateConsentRequest){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'credentials-verification-request-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.request_unavailable_alert')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:_this.onSubmit},_this.renderDepartmentFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'request-credentials-verification-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.your_data_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'request_credentials_verification-message'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.visible_data_message')),_this.renderYourEmailFormGroup(),_this.renderCompanyDataRow(),_this.renderYourNameRow(),_this.renderCheckBoxes()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'request-credentials-verification-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.applicant_data_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'request_credentials_verification-message'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.reference_to_bulk_list_start'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */],{to:'/bulk-consent-requests',target:'_blank'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.reference_to_bulk_list_link')),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.reference_to_bulk_list_end')),_this.renderApplicantIdentityFormGroups()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'request-credentials-verification-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.reason_for_request_label')),_this.renderJobFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{className:'request-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'consents.note_to_applicants_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'textarea',value:_this.state.message,onChange:_this.handleChange("message"),placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.reason_for_request_placeholder')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.submit_button'))));};_this.renderSuccessModal=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'request-credentials-verification-modal',isOpen:_this.state.isOpenModal,toggle:_this.handleStay},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.success_modal_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:_this.handleStay},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.stay_on_this_page_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',tag:__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Link */],to:'/home'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.go_to_home_page_label'))))));};_this.handleStay=function(){_this.setState({isOpenModal:false});};_this.renderDepartmentFormGroup=function(){if(_this.props.departmentName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,className:'consent-request-department-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-request-department-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].department_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.departmentName)));}};_this.renderApplicantIdentityFormGroups=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.renderInputModeMenu(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["i" /* Collapse */],{isOpen:!_this.state.bulkUploadEnabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,className:'emails-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':'emails',sm:3},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.emails_label'),'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8,className:'emails-textarea-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'textarea',id:'emails',value:_this.state.emails,placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.emails_label'),required:!_this.state.bulkUploadEnabled,onChange:_this.handleChange('emails')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:1,id:'applicant-emails-icons-container',className:'applicant-emails-icons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',key:'applicant-emails-hint-icon',onClick:_this.toggleEmailsInfoPopover,className:'applicant-emails-hint-icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["H" /* Popover */],{placement:'top',isOpen:_this.state.emailsInfoPopoverOpen,key:'applicant-emails-hint-popover',target:'applicant-emails-icons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["I" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.manual_input_hint'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["i" /* Collapse */],{isOpen:_this.state.bulkUploadEnabled&&_this.state.emails.length===0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__consentRequestBulkDropZone_ConsentRequestBulkDropZone_container__["a" /* default */],{onSubmit:_this.handleFileUpload,clean:_this.state.cleanDropZoneState,error:_this.state.bulkDropZoneError})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["i" /* Collapse */],{isOpen:_this.state.bulkUploadEnabled&&_this.state.emails.length!==0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{className:'emails-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':'uploaded-emails-textarea',sm:3},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'bulk_jobs_list.file_name_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8,id:'uploaded-file-name'},_this.state.fileName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:1,id:'applicant-emails-icons-container',className:'applicant-emails-icons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'clear',key:'applicant-emails-remove-icon',id:'applicant-emails-icon',className:'applicant-emails-remove-icon',onClick:_this.handleEmailsRemove}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':'uploaded-emails-textarea',sm:3},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.emails_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:8,className:'emails-textarea-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'textarea',id:'uploaded-emails-textarea',className:'uploaded-emails-textarea',disabled:true,rows:_this.state.emails.length>0?_this.state.emails.length>3?4:_this.state.emails.length:1,value:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.slice(_this.state.emails,0,3).join('\n')+(_this.state.emails.length>3?'\n...':''),placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.emails_label')}))))));};_this.renderInputModeMenu=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emails-input-mode-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"input-mode-icon-container"+(!_this.state.bulkUploadEnabled?" olive-green":""),onClick:_this.handleToggleBulkUpload(false)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'input-mode-icon',icon:"radio_button_"+(!_this.state.bulkUploadEnabled?"checked":"unchecked"),title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.manual_input_label')}),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.manual_input_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"input-mode-icon-container"+(_this.state.bulkUploadEnabled?" olive-green":""),onClick:_this.handleToggleBulkUpload(true)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'input-mode-icon',icon:"radio_button_"+(_this.state.bulkUploadEnabled?"checked":"unchecked"),title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.upload_file_label')}),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.upload_file_label')));};_this.toggleEmailsInfoPopover=function(){_this.setState({emailsInfoPopoverOpen:!_this.state.emailsInfoPopoverOpen});};_this.renderJobFormGroups=function(){var jobInternalReferenceParams={value:"jobInternalReference",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'consents.internal_job_reference'),placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'consents.internal_job_reference'),className:"job-internal-reference-form-group"};var jobTitleParams={value:"jobTitle",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'consents.job_title_label')+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'consents.job_title_label')};var exposeJobReferenceParams={checked:_this.state.exposeJobReference,key:"exposeJobReference",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'consents.expose_job_reference')};return[_this.getFormGroup(jobInternalReferenceParams),_this.getCheckboxFormGroup(exposeJobReferenceParams),_this.getFormGroup(jobTitleParams)];};_this.renderYourEmailFormGroup=function(){var emailsList=[{value:__WEBPACK_IMPORTED_MODULE_7__constants_constants__["u" /* REQUEST_EMAIL_SOURCE_REQUESTER */],label:_this.props.yourEmail}];if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this.props.departmentEmail)){emailsList.push({value:__WEBPACK_IMPORTED_MODULE_7__constants_constants__["s" /* REQUEST_EMAIL_SOURCE_DEPARTMENT */],label:_this.props.departmentEmail});}emailsList.push({value:__WEBPACK_IMPORTED_MODULE_7__constants_constants__["t" /* REQUEST_EMAIL_SOURCE_NONE */],label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'consents.none_label')});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:'email-source'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':'email-source',sm:3},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:'email-source',selectedOption:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(emailsList,function(option){return option.value===_this.state.emailSource;}),options:emailsList,onSelect:_this.handleEmailSourceChange,placeholder:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)})));};_this.renderYourNameRow=function(){var paramsList=[{value:_this.props.yourName?_this.props.yourName.firstName+' '+_this.props.yourName.lastName:'',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].name_label)}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(paramsList,_this.getDataRow)));};_this.renderCheckBoxes=function(){var paramsList=[{checked:_this.state.hideName,key:"hideName",title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'request_credentials_verification.hide_your_name_label')/* Note: disabled in current version,
            {
                checked: this.state.isGetEmail && this.state.yourEmail !== "none",
                key: "isGetEmail",
                disabled: this.state.yourEmail === "none",
                title: _.get(this.props.translation, 'request_credentials_verification.get_email_label')
            }*/}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(paramsList,_this.getCheckboxFormGroup)));};_this.renderCompanyDataRow=function(){var title=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].company_label);var value=(_this.props.companyName||'')+', '+(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'countries.'+_this.props.companyCountry)||'');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{key:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:3},title,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},value));};_this.getFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title,className:params.className||""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:_this.state[params.value],onChange:params.onChange||_this.handleChange(params.value),placeholder:params.placeholder,disabled:params.isDisabled,required:params.isRequired},params.content)));};_this.getDataRow=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:3},params.title,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},params.value));};_this.getCheckboxFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{check:true,key:params.key,className:'checkbox-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{check:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'checkbox',checked:params.checked,onChange:_this.handleChangeCheckbox(params.key),disabled:params.disabled}),params.title))));};_this.handleChange=function(fieldName){return function(e){_this.setState(_defineProperty({},fieldName,e.target.value));};};_this.handleEmailSourceChange=function(selectedOption){_this.setState({emailSource:selectedOption.value});};_this.handleChangeContinent=function(e){_this.setState({companyContinent:e.target.value,companyCountry:''});_this.props.onContinentsSet(e.target.value);};_this.handleChangeCheckbox=function(fieldName){return function(){_this.setState(_defineProperty({},fieldName,!_this.state[fieldName]));};};_this.handleFileUpload=function(file){_this.setState({bulkDropZoneError:null});var fileReader=new FileReader();fileReader.onloadend=function(){var content=fileReader.result.trim().split(/[\s,;]+/).filter(function(email){return!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(email);});if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(content)){_this.setState({bulkDropZoneError:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'bulk_upload.consent_request_bulk_empty_file_label')});}else{_this.setState({emails:content,fileName:file.name});}};fileReader.readAsText(file);};_this.handleToggleBulkUpload=function(enabled){return function(){if(_this.state.bulkUploadEnabled!==enabled){_this.setState({bulkUploadEnabled:enabled,emails:enabled?[]:'',bulkDropZoneError:false,cleanDropZoneState:true,emailsInfoPopoverOpen:false});}};};_this.handleEmailsRemove=function(){_this.setState({emails:[],cleanDropZoneState:true});};_this.onSubmit=function(e){e.preventDefault();if(_this.state.bulkUploadEnabled&&_this.state.emails.length===0){_this.setState({bulkDropZoneError:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'bulk_upload.consent_request_bulk_error_label')});return;}var emails=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isArray(_this.state.emails)?_this.state.emails:_this.state.emails.trim().split(/[\s,;]+/).filter(function(email){return!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(email);});var data={emailSource:_this.state.emailSource,showRequesterFNLN:!_this.state.hideName,requestComment:_this.state.message,departmentId:_this.props.departmentId,jobDescription:{internalReference:_this.state.jobInternalReference!==""?_this.state.jobInternalReference:null,title:_this.state.jobTitle,exposeReference:_this.state.exposeJobReference},emails:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.uniq(emails.map(function(email){return email.toLowerCase();}))};if(_this.state.bulkUploadEnabled||data.emails.length>1){_this.props.onProcessBulkRequest(data);}else{_this.props.onProcessRequest(data);}};_this.resetData=function(){_this.setState({emails:"",emailSource:__WEBPACK_IMPORTED_MODULE_7__constants_constants__["u" /* REQUEST_EMAIL_SOURCE_REQUESTER */],hideName:false,jobInternalReference:"",jobTitle:"",exposeJobReference:false,message:"",bulkUploadEnabled:false,bulkDropZoneError:null,cleanDropZoneState:false,emailsInfoPopoverOpen:false});};_this.state={emails:"",emailSource:__WEBPACK_IMPORTED_MODULE_7__constants_constants__["u" /* REQUEST_EMAIL_SOURCE_REQUESTER */],hideName:false,jobInternalReference:"",jobTitle:"",exposeJobReference:false,message:"",isOpenModal:false,bulkUploadEnabled:false,bulkDropZoneError:null,cleanDropZoneState:false,emailsInfoPopoverOpen:false};return _this;}_createClass(CredentialsVerificationRequest,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){if(nextState.bulkUploadEnabled&&nextState.emails.length!==0&&nextState.bulkDropZoneError){this.setState({bulkDropZoneError:null});}if(this.state.cleanDropZoneState){this.setState({cleanDropZoneState:false});}if(!this.props.success&&nextProps.success){this.setState({isOpenModal:true});this.resetData();}}},{key:'render',value:function render(){if(this.props.loading||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.operationAvailability)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'credentials-verification-request-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'request-credentials-verification-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{showSuccessAlert:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'request-credentials-verification-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'request_credentials_verification.label')),this.renderContent())),this.renderSuccessModal());}}]);return CredentialsVerificationRequest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CredentialsVerificationRequest.propTypes={continents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,departmentId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,departmentName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,yourEmail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,departmentEmail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,success:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,operationAvailability:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onProcessRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onProcessBulkRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onContinentsSet:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onResetData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CredentialsVerificationRequest);

/***/ }),
/* 958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConsentRequestBulkDropZone__ = __webpack_require__(960);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__ConsentRequestBulkDropZone__["a" /* default */]));

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropzone__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConsentRequestBulkDropZone_css__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConsentRequestBulkDropZone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ConsentRequestBulkDropZone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MAX_FILE_SIZE='20 MB';var ConsentRequestBulkDropZone=function(_Component){_inherits(ConsentRequestBulkDropZone,_Component);function ConsentRequestBulkDropZone(props){_classCallCheck(this,ConsentRequestBulkDropZone);var _this=_possibleConstructorReturn(this,(ConsentRequestBulkDropZone.__proto__||Object.getPrototypeOf(ConsentRequestBulkDropZone)).call(this,props));_this.renderFileFormatModal=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["w" /* Modal */],{isOpen:_this.state.isFileFormatModalOpen,toggle:_this.toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_upload.file_format_info_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_file_format_details.consent_bulk_file_info_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'file-format-button-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:_this.toggleModal},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].okey_button)))));};_this.toggleModal=function(){_this.setState({isFileFormatModalOpen:!_this.state.isFileFormatModalOpen});};_this.formatIsCorrect=function(file){return file.name.endsWith('.txt')||file.name.endsWith('.csv');};_this.onDragEnter=function(){_this.setState({isEnter:true});_this.cleanState();};_this.onDragLeave=function(){_this.setState({isEnter:false});};_this.onDrop=function(filesArray){_this.setState({isEnter:false});if(filesArray.length!==1){_this.setState({error:true});return;}var file=filesArray[0];if(_this.formatIsCorrect(file)){_this.setState({file:file});_this.props.onSubmit(file);}else{_this.setState({error:true});}};_this.cleanState=function(){_this.setState({file:null,error:false});};_this.state={isEnter:false,file:null,error:false,isFileFormatModalOpen:false};return _this;}_createClass(ConsentRequestBulkDropZone,[{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(!this.props.clean&&nextProps.clean){this.cleanState();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-drop-zone-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-drop-zone-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_upload.max_file_size_message'),': ',MAX_FILE_SIZE),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["c" /* Button */],{color:'link',onClick:this.toggleModal},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_upload.file_format_details_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */],{className:'bulk-drop-zone',activeClassName:'bulk-drop-zone-active',onDrop:this.onDrop,multiple:false,onDragEnter:this.onDragEnter,onDragLeave:this.onDragLeave,onClick:this.cleanState},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-drop-zone-content-container '+(this.state.isEnter?'bulk-drop-zone-content-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_upload.drag_and_drop_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_upload.or_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_upload.browse_label'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-result-label'},this.state.error?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'bulk_upload.error_label')):"",this.props.error?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["a" /* Alert */],{className:'bulk-upload-error-alert',color:'danger'},this.props.error):""),this.renderFileFormatModal());}}]);return ConsentRequestBulkDropZone;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsentRequestBulkDropZone.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ConsentRequestBulkDropZone);

/***/ }),
/* 961 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PendingConsentsList__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_consent_consents__ = __webpack_require__(44);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_consents__["i" /* getConsentsList */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_consents__["s" /* loadingConsents */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_consents__["p" /* getRequestsByStatus */])(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_consents__["b" /* PENDING */]));},onStateConsentsProcessing:function onStateConsentsProcessing(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_consents__["u" /* startConsentsProcessing */])(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PendingConsentsList__["a" /* default */]));

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PendingConsentsList_css__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PendingConsentsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PendingConsentsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_paginationComponent_PaginationPendingConsents_container__ = __webpack_require__(311);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PendingConsentsList=function(_Component){_inherits(PendingConsentsList,_Component);function PendingConsentsList(props){_classCallCheck(this,PendingConsentsList);var _this=_possibleConstructorReturn(this,(PendingConsentsList.__proto__||Object.getPrototypeOf(PendingConsentsList)).call(this,props));_this.renderTable=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pending-consents-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pending-consents-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.no_pending_consents_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["N" /* Table */],{className:'pending-consents-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.person_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.job_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].company_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderPendingConsentsData()));};_this.renderPendingConsentsData=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_this.props.data,function(consentData,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'pending-consents-list-row',key:index,onClick:_this.handleClick(consentData.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'person-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.person_label')+':'},_this.renderPersonName(consentData)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'job-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.job_label')+':'},consentData.jobTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'company-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].company_label)+':'},consentData.companyName?consentData.companyName+", "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'countries.'+consentData.countryCode):'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'email-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+':'},consentData.email?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:_this.handleEmailLinkClick,href:"mailto:"+consentData.email},consentData.email):'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'control-cell edit-pending-consent-icon-td',onClick:_this.handleClick(consentData.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:index,icon:'create',className:'edit-pending-consent-icon',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.edit_label')})));});};_this.renderPersonName=function(consentData){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(consentData.firstName)&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(consentData.lastName)){return'-';}else if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(consentData.firstName)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(consentData.lastName)){return consentData.lastName;}else if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(consentData.firstName)&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(consentData.lastName)){return consentData.firstName;}else{return consentData.firstName+' '+consentData.lastName;}};_this.handleEmailLinkClick=function(e){e.stopPropagation();};_this.handleClick=function(id){return function(){_this.setState({redirect:true});_this.props.onStateConsentsProcessing(id);};};_this.state={redirect:false};return _this;}_createClass(PendingConsentsList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'render',value:function render(){if(this.state.redirect){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["d" /* Redirect */],{to:'/approve-consent',push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pending-consents-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'consents.pending_consents_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_paginationComponent_PaginationPendingConsents_container__["a" /* default */],null),this.renderTable());}}]);return PendingConsentsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PendingConsentsList.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onStateConsentsProcessing:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (PendingConsentsList);

/***/ }),
/* 964 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApproveConsentAfterRequest__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_consent_consent__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_consent_consents__ = __webpack_require__(44);
var mapStateToProps=function mapStateToProps(state){return{id:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_consent_consents__["j" /* getCurrentConsentId */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_consent__["d" /* getFormattedConsent */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_consent__["e" /* loadingConsent */])(state)||Object(__WEBPACK_IMPORTED_MODULE_4__reducers_consent_consents__["s" /* loadingConsents */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onLoadConsent:function onLoadConsent(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_consent__["b" /* fetchGetConsentById */])(id));},onGrantRequest:function onGrantRequest(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_consent__["c" /* fetchUpdateConsent */])(id,data));},onRefuseRequest:function onRefuseRequest(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_consent__["c" /* fetchUpdateConsent */])(id,data));},onNext:function onNext(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_consent_consents__["t" /* onSetNextConsent */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ApproveConsentAfterRequest__["a" /* default */]));

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_switch__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ApproveConsentAfterRequest_css__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ApproveConsentAfterRequest_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ApproveConsentAfterRequest_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__periodSelect_PeriodSelect_container__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reducers_consent_consents__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_progressBar_ApproveConsentProgressBar_container__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MAX_PERIOD=__WEBPACK_IMPORTED_MODULE_12_moment_moment___default.a.duration(3,__WEBPACK_IMPORTED_MODULE_7__constants_constants__["d" /* AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST */].MONTH).add(1,'day');var MIN_PERIOD=__WEBPACK_IMPORTED_MODULE_12_moment_moment___default.a.duration(1,__WEBPACK_IMPORTED_MODULE_7__constants_constants__["d" /* AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST */].WEEK).subtract(1,'day');var DEFAULT_PERIOD_TYPE=__WEBPACK_IMPORTED_MODULE_7__constants_constants__["d" /* AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST */].MONTH;var DEFAULT_PERIOD_NUM='1';var ApproveConsentAfterRequest=function(_Component){_inherits(ApproveConsentAfterRequest,_Component);function ApproveConsentAfterRequest(props){_classCallCheck(this,ApproveConsentAfterRequest);var _this=_possibleConstructorReturn(this,(ApproveConsentAfterRequest.__proto__||Object.getPrototypeOf(ApproveConsentAfterRequest)).call(this,props));_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pending-consents-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(_this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:_this.onSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'next-consent-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'next-consent-button',color:'link',onClick:_this.props.onNext},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'consents.next_consent_button'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'consent-requestor-label'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'approve_consent_after_request.consent_requestor_label')),_this.getConsentRequestorFormGroups()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{className:'decision-switch-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:_this.state.isGrant?"olive-green":null},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'approve_consent_after_request.grant_title_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_switch___default.a,{checked:!_this.state.isGrant,onChange:_this.toggleDecision,onColor:'#888888',uncheckedIcon:false,checkedIcon:false,className:'decision-switcher'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:!_this.state.isGrant?"carrot-red":null},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'approve_consent_after_request.refuse_title_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["m" /* Fade */],{key:'grant','in':_this.state.isGrant},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-pane-container',hidden:!_this.state.isGrant},_this.renderGrantFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'approve_consent_after_request.grant_button'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["m" /* Fade */],{key:'refuse','in':!_this.state.isGrant},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-pane-container',hidden:_this.state.isGrant},_this.renderRefuseFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{type:'submit',className:'carrot-red-btn'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'approve_consent_after_request.refuse_button')))))))));};_this.toggleDecision=function(){_this.setState({isGrant:!_this.state.isGrant});};_this.getConsentRequestorFormGroups=function(){var paramsList=[{value:!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(_this.props.data.email)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+_this.props.data.email},_this.props.data.email):null,title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)},// {
//     value: "firstName",
//     title: _.get(this.props.translation, sharedLabelsPath.first_name_label)
// },
// {
//     value: "lastName",
//     title: _.get(this.props.translation, sharedLabelsPath.last_name_label)
// },
{value:_this.props.data.companyName+", "+__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'countries.'+_this.props.data.companyCountry),title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].company_label)},{value:_this.props.data.job,title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'consents.job_label')},// {
//     value: "companyCountry",
//     title: _.get(this.props.translation, 'approve_consent_after_request.company_country_label')
// },
// {
//     value: "companyDomain",
//     title: _.get(this.props.translation, sharedLabelsPath.company_domain_label)
// },
{value:_this.props.data.message,title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'consents.note_to_applicants_label')}];if(!(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(_this.props.data.firstName)&&__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(_this.props.data.lastName))){paramsList.push({value:_this.props.data.firstName+' '+_this.props.data.lastName,title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'request_credentials_verification.manager_label')});}paramsList.push({value:__WEBPACK_IMPORTED_MODULE_12_moment_moment___default()(_this.props.data.requestDate).format('L'),title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'approve_consent_after_request.request_date')});return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(paramsList,_this.getReadOnlyFormGroup)));};_this.getReadOnlyFormGroup=function(params){if(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(params.value)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,params.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,params.value)));};_this.renderGrantFormGroup=function(){if(!_this.state.isGrant){return null;}return[_this.renderPeriodFormGroup(),_this.getCommentFormGroup()];};_this.renderPeriodFormGroup=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:'period_label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{sm:2},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'approve_consent_after_request.period_label')+"*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__periodSelect_PeriodSelect_container__["a" /* default */],{id:'approve-consent-after-request-period-select',showPopover:true,placement:'top',periodEndDateMessage:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'consents.consent_end_date_alert')+' '+__WEBPACK_IMPORTED_MODULE_12_moment_moment___default()().add(_this.state.periodNum,_this.state.periodType).format('LL'),onPeriodNumChange:_this.handlePeriodNumChange,onPeriodTypeChange:_this.handlePeriodTypeChange,periodType:_this.state.periodType,periodNum:_this.state.periodNum})));};_this.handlePeriodNumChange=function(nextPeriodNum){if(__WEBPACK_IMPORTED_MODULE_12_moment_moment___default()().add(nextPeriodNum,_this.state.periodType).subtract(MAX_PERIOD).isBefore(__WEBPACK_IMPORTED_MODULE_12_moment_moment___default()())&&__WEBPACK_IMPORTED_MODULE_12_moment_moment___default()().add(nextPeriodNum,_this.state.periodType).subtract(MIN_PERIOD).isAfter(__WEBPACK_IMPORTED_MODULE_12_moment_moment___default()())){_this.setState({periodNum:nextPeriodNum});}};_this.handlePeriodTypeChange=function(nextPeriodType){var nextPeriodNum=_this.state.periodNum;if(!(__WEBPACK_IMPORTED_MODULE_12_moment_moment___default()().add(_this.state.periodNum,nextPeriodType).subtract(MAX_PERIOD).isBefore(__WEBPACK_IMPORTED_MODULE_12_moment_moment___default()())&&__WEBPACK_IMPORTED_MODULE_12_moment_moment___default()().add(_this.state.periodNum,nextPeriodType).subtract(MIN_PERIOD).isAfter(__WEBPACK_IMPORTED_MODULE_12_moment_moment___default()()))){nextPeriodNum=DEFAULT_PERIOD_NUM;}_this.setState({periodType:nextPeriodType,periodNum:nextPeriodNum});};_this.renderRefuseFormGroup=function(){if(_this.state.isGrant){return null;}var paramsList=[{value:"reason",title:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'approve_consent_after_request.reason_label'),type:'select',onChange:_this.handleChangeSelect("reason"),content:__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["r" /* REFUSE_REASONS */],function(value){return{code:value,name:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'approve_consent_after_request.reasons.'+value)};})),placeholder:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'approve_consent_after_request.reason_input_placeholder')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(paramsList,_this.getFormGroup)),[_this.getCommentFormGroup()]);};_this.getCommentFormGroup=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{key:'comment_for_requestor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'approve_consent_after_request.comment_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'textarea',value:_this.state.message,onChange:_this.handleChange("message"),placeholder:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'approve_consent_after_request.comment_placeholder')}));};_this.getFormGroup=function(params){if(params.type==='select'){return _this.getSelectFormGroup(params);}if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}if(params.hidden){return null;}var id=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:2},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:_this.state[params.value],onChange:_this.handleChange(params.value),placeholder:params.placeholder,required:params.isRequired,className:params.className},params.content)));};_this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];}),options:params.content,onSelect:params.onChange,placeholder:params.placeholder,disabled:params.isDisabled})));};_this.handleChange=function(fieldName){return function(e){_this.setState(_defineProperty({},fieldName,e.target.value));};};_this.handleChangeSelect=function(fieldKey){return function(selectedOption){_this.setState(_defineProperty({},fieldKey,selectedOption.value));};};_this.onSubmit=function(e){e.preventDefault();if(_this.state.isGrant){var data={status:__WEBPACK_IMPORTED_MODULE_11__reducers_consent_consents__["a" /* GRANTED */],grantedTill:__WEBPACK_IMPORTED_MODULE_12_moment_moment___default()().endOf('day').add(_this.state.periodNum,_this.state.periodType)};if(_this.state.message!==""){data.responseComment=_this.state.message;}_this.props.onGrantRequest(_this.props.id,data);}else{var _data={status:__WEBPACK_IMPORTED_MODULE_11__reducers_consent_consents__["c" /* REJECTED */]};if(_this.state.reason!==""){_data.responseComment=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this.props.translation,'approve_consent_after_request.reasons.'+_this.state.reason)+'. ';}if(_this.state.message!==""){_data.responseComment=_data.responseComment?_data.responseComment+_this.state.message:_this.state.message;}_this.props.onRefuseRequest(_this.props.id,_data);}};_this.state={reason:"",message:"",isGrant:true,periodType:DEFAULT_PERIOD_TYPE,periodNum:DEFAULT_PERIOD_NUM};return _this;}_createClass(ApproveConsentAfterRequest,[{key:'componentWillMount',value:function componentWillMount(){if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(this.props.id)){this.props.onLoadConsent(this.props.id);}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(this.props.id!==nextProps.id&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(nextProps.id)){this.props.onLoadConsent(nextProps.id);}}},{key:'render',value:function render(){if(!this.props.loading&&__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isNil(this.props.id)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_router_dom__["d" /* Redirect */],{to:'/pending-consents'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'approve-consent-after-request-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'approve_consent_after_request.success_alert')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/pending-consents',label:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].back_button)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'approve-consent-after-request-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'approve_consent_after_request.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_progressBar_ApproveConsentProgressBar_container__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this.props.translation,'approve_consent_after_request.approve_consent_progress_label')+":"}),this.renderContent())));}}]);return ApproveConsentAfterRequest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ApproveConsentAfterRequest.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onLoadConsent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGrantRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onRefuseRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onNext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ApproveConsentAfterRequest);

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

if (true) {
  module.exports = __webpack_require__(968);
} else {
  module.exports = require("./dist/react-switch.dev.js");
}


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var React=__webpack_require__(1),uncheckedIcon=React.createElement("svg",{viewBox:"-2 -5 14 20",height:"100%",width:"100%",style:{position:"absolute",top:0}},React.createElement("path",{d:"M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",fill:"#fff",fillRule:"evenodd"})),checkedIcon=React.createElement("svg",{height:"100%",width:"100%",viewBox:"-2 -5 17 21",style:{position:"absolute",top:0}},React.createElement("path",{d:"M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",fill:"#fff",fillRule:"evenodd"}));function createBackgroundColor(t,i,s,o,n){var h=(t-s)/(i-s);if(0===h)return o;if(1===h)return n;for(var e="#",a=1;a<6;a+=2){var r=parseInt(o.substr(a,2),16),c=parseInt(n.substr(a,2),16),l=Math.round((1-h)*r+h*c).toString(16);1===l.length&&(l="0"+l),e+=l}return e}function convertShorthandColor(t){if(7===t.length)return t;for(var i="#",s=1;s<4;s+=1)i+=t[s]+t[s];return i}function getBackgroundColor(t,i,s,o,n){return createBackgroundColor(t,i,s,convertShorthandColor(o),convertShorthandColor(n))}var ReactSwitch=function(n){function t(t){n.call(this,t);var i=t.height,s=t.width,o=t.checked;this.t=t.handleDiameter||i-2,this.i=Math.max(s-i,s-(i+this.t)/2),this.s=Math.max(0,(i-this.t)/2),this.state={o:o?this.i:this.s},this.n=0,this.h=0,this.e=this.e.bind(this),this.a=this.a.bind(this),this.r=this.r.bind(this),this.c=this.c.bind(this),this.l=this.l.bind(this),this.u=this.u.bind(this),this.f=this.f.bind(this),this.p=this.p.bind(this),this.b=this.b.bind(this),this.g=this.g.bind(this),this.v=this.v.bind(this),this.w=this.w.bind(this)}return n&&(t.__proto__=n),((t.prototype=Object.create(n&&n.prototype)).constructor=t).prototype.componentWillReceiveProps=function(t){this.setState({o:t.checked?this.i:this.s})},t.prototype.k=function(t){this.y.focus(),this.setState({M:t,R:!0,m:Date.now()})},t.prototype.C=function(t){var i=this.state,s=i.M,o=i.o,n=(this.props.checked?this.i:this.s)+t-s;i.T||t===s||this.setState({T:!0});var h=Math.min(this.i,Math.max(this.s,n));h!==o&&this.setState({o:h})},t.prototype.S=function(t){var i=this.state,s=i.o,o=i.T,n=i.m,h=this.props.checked,e=(this.i+this.s)/2,a=Date.now()-n;!o||a<250?this.$(t):h?e<s?this.setState({o:this.i}):this.$(t):s<e?this.setState({o:this.s}):this.$(t),this.setState({T:!1,R:!1}),this.n=Date.now()},t.prototype.e=function(t){t.preventDefault(),"number"==typeof t.button&&0!==t.button||(this.k(t.clientX),window.addEventListener("mousemove",this.a),window.addEventListener("mouseup",this.r))},t.prototype.a=function(t){t.preventDefault(),this.C(t.clientX)},t.prototype.r=function(t){this.S(t),window.removeEventListener("mousemove",this.a),window.removeEventListener("mouseup",this.r)},t.prototype.c=function(t){this.x=null,this.k(t.touches[0].clientX)},t.prototype.l=function(t){this.C(t.touches[0].clientX)},t.prototype.u=function(t){t.preventDefault(),this.S(t)},t.prototype.p=function(t){50<Date.now()-this.n&&(this.$(t),50<Date.now()-this.h&&this.setState({R:!1}))},t.prototype.b=function(){this.h=Date.now()},t.prototype.g=function(){this.setState({R:!0})},t.prototype.v=function(){this.setState({R:!1})},t.prototype.w=function(t){this.y=t},t.prototype.f=function(t){t.preventDefault(),this.y.focus(),this.$(t),this.setState({R:!1})},t.prototype.$=function(t){var i=this.props;(0,i.onChange)(!i.checked,t,i.id)},t.prototype.render=function(){var t=this.props,i=t.checked,s=t.disabled,o=t.className,n=t.offColor,h=t.onColor,e=t.offHandleColor,a=t.onHandleColor,r=t.checkedIcon,c=t.uncheckedIcon,l=t.boxShadow,u=t.activeBoxShadow,d=t.height,f=t.width,p=t.id,b=t["aria-labelledby"],g=t["aria-label"],v=t.tabIndex,w=this.state,k=w.o,y=w.T,M=w.R,R={position:"relative",display:"inline-block",textAlign:"left",opacity:s?.5:1,borderRadius:d/2,WebkitTransition:"opacity 0.25s",MozTransition:"opacity 0.25s",transition:"opacity 0.25s",touchAction:"none",WebkitTapHighlightColor:"rgba(0, 0, 0, 0)",WebkitUserSelect:"none",MozUserSelect:"none",msUserSelect:"none",userSelect:"none"},m={height:d,width:f,margin:Math.max(0,(this.t-d)/2),position:"relative",background:getBackgroundColor(k,this.i,this.s,n,h),borderRadius:d/2,cursor:s?"default":"pointer",WebkitTransition:y?null:"background 0.25s",MozTransition:y?null:"background 0.25s",transition:y?null:"background 0.25s"},C={height:d,width:Math.min(1.5*d,f-(this.t+d)/2+1),position:"relative",opacity:(k-this.s)/(this.i-this.s),pointerEvents:"none",WebkitTransition:y?null:"opacity 0.25s",MozTransition:y?null:"opacity 0.25s",transition:y?null:"opacity 0.25s"},T={height:d,width:Math.min(1.5*d,f-(this.t+d)/2+1),position:"absolute",opacity:1-(k-this.s)/(this.i-this.s),right:0,top:0,pointerEvents:"none",WebkitTransition:y?null:"opacity 0.25s",MozTransition:y?null:"opacity 0.25s",transition:y?null:"opacity 0.25s"},S={height:this.t,width:this.t,background:getBackgroundColor(k,this.i,this.s,e,a),display:"inline-block",cursor:s?"default":"pointer",borderRadius:"50%",position:"absolute",transform:"translateX("+k+"px)",top:Math.max(0,(d-this.t)/2),outline:0,boxShadow:M?u:l,border:0,WebkitTransition:y?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",MozTransition:y?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",transition:y?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s"};return React.createElement("div",{className:o,style:R},React.createElement("div",{className:"react-switch-bg",style:m,onClick:s?null:this.f,onMouseDown:function(t){return t.preventDefault()}},r&&React.createElement("div",{style:C},r),c&&React.createElement("div",{style:T},c)),React.createElement("div",{className:"react-switch-handle",style:S,onClick:function(t){return t.preventDefault()},onMouseDown:s?null:this.e,onTouchStart:s?null:this.c,onTouchMove:s?null:this.l,onTouchEnd:s?null:this.u,onTouchCancel:s?null:this.v}),React.createElement("input",{type:"checkbox",role:"switch",id:p,checked:i,disabled:s,tabIndex:v,onFocus:this.g,onBlur:this.v,onKeyUp:this.b,onChange:this.p,"aria-labelledby":b,"aria-label":g,style:{border:0,clip:"rect(0 0 0 0)",height:1,margin:-1,overflow:"hidden",padding:0,position:"absolute",width:1},ref:this.w}))},t}(React.Component);ReactSwitch.defaultProps={disabled:!1,offColor:"#888",onColor:"#080",offHandleColor:"#fff",onHandleColor:"#fff",uncheckedIcon:uncheckedIcon,checkedIcon:checkedIcon,boxShadow:null,activeBoxShadow:"0 0 2px 3px #3bf",height:28,width:56},module.exports=ReactSwitch;


/***/ }),
/* 969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PeriodSelect_css__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PeriodSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PeriodSelect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PeriodSelect=function(_Component){_inherits(PeriodSelect,_Component);function PeriodSelect(props){_classCallCheck(this,PeriodSelect);var _this=_possibleConstructorReturn(this,(PeriodSelect.__proto__||Object.getPrototypeOf(PeriodSelect)).call(this,props));_this.setInput=function(inputName){return function(input){_this[inputName]=input;};};_this.renderPopover=function(target){if(!_this.props.showPopover){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["H" /* Popover */],{placement:_this.props.placement||'right',target:target,isOpen:_this.state.isPopoverOpen,container:'period-input-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["I" /* PopoverBody */],null,_this.props.periodEndDateMessage));};_this.showPopover=function(){if(!_this.state.isPopoverOpen){_this.setState({isPopoverOpen:true});}};_this.hidePopover=function(){if(_this.state.isPopoverOpen){_this.setState({isPopoverOpen:false});}};_this.handlePopoverBlur=function(e){var relatedTarget=e.relatedTarget;if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(relatedTarget)||relatedTarget.id!==_this.numInput.props.id&&relatedTarget.id!==_this.typeInput.props.id){_this.hidePopover();}};_this.getSelectedPeriodOption=function(){return{value:_this.props.periodType,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'consents.periods.'+_this.props.periodType+'_label')};};_this.getPeriodOptions=function(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_5__constants_constants__["d" /* AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST */],function(period){return{value:period,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'consents.periods.'+period+'_label')};});};_this.handlePeriodTypeChange=function(selectedOption){_this.props.onPeriodTypeChange(selectedOption.value);};_this.handlePeriodNumChange=function(e){if(e.target.value>0){_this.props.onPeriodNumChange(Math.floor(e.target.value).toString());}};_this.state={isPopoverOpen:false};return _this;}_createClass(PeriodSelect,[{key:'render',value:function render(){var periodTypeSelectId='period-type-input'+(this.props.id?this.props.id:'');var periodNumSelectId='period-number-input'+(this.props.id?this.props.id:'');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"period-select-container "+this.props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["L" /* Row */],{hidden:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.label)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{className:'period-label'},this.props.label))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:3,className:'period-number-input-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{id:periodNumSelectId,ref:this.setInput('numInput'),type:'number',value:this.props.periodNum,required:true,hidden:this.props.periodType===__WEBPACK_IMPORTED_MODULE_5__constants_constants__["c" /* AVAILABLE_CONSENT_PERIODS */].FOREVER,onBlur:this.handlePopoverBlur,onFocus:this.showPopover,onChange:this.handlePeriodNumChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{className:'period-input-container',id:'period-input-container',sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:periodTypeSelectId,ref:this.setInput('typeInput'),onBlur:this.handlePopoverBlur,onFocus:this.showPopover,onSelect:this.handlePeriodTypeChange,selectedOption:this.getSelectedPeriodOption(),options:this.getPeriodOptions()}),this.renderPopover(periodTypeSelectId))));}}]);return PeriodSelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PeriodSelect.propTypes={id:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,className:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,showPopover:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,placement:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,periodEndDateMessage:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,periodType:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,periodNum:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,onPeriodNumChange:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onPeriodTypeChange:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (PeriodSelect);

/***/ }),
/* 971 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProgressBar__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__ = __webpack_require__(44);
var mapStateToProps=function mapStateToProps(state){return{left:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__["m" /* getLeftConsentsNumber */])(state),skipped:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__["o" /* getNumberOfSkippedConsents */])(state),validated:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__["n" /* getNumberOfProcessedConsents */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__ProgressBar__["a" /* default */]));

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConsentRequestsList__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_consent_organizationConsents__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_account_role__ = __webpack_require__(20);
var mapStateToProps=function mapStateToProps(state){return{data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_organizationConsents__["k" /* getOrganizationConsentsData */])(state),departmentId:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["k" /* getCurrentGroup */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_organizationConsents__["n" /* loadingOrganizationConsents */])(state),isLoadNextPageAvailable:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_organizationConsents__["l" /* isLoadNextPageAvailable */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_organizationConsents__["e" /* fetchGetOrganizationConsents */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["v" /* onChangeConsentRequestsFilterVisibility */])(true));},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_account_role__["v" /* onChangeConsentRequestsFilterVisibility */])(false));},onGetConsentRequests:function onGetConsentRequests(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_organizationConsents__["e" /* fetchGetOrganizationConsents */])());},onGetConsentRequestsNextPage:function onGetConsentRequestsNextPage(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_organizationConsents__["f" /* fetchGetOrganizationConsentsNextPage */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ConsentRequestsList__["a" /* default */]));

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConsentRequestsList_css__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConsentRequestsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ConsentRequestsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__consentRequestCard_ConsentRequestsCard_container__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__consentRequestDetails_ConsentRequestDetails_container__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConsentRequestsList=function(_Component){_inherits(ConsentRequestsList,_Component);function ConsentRequestsList(props){_classCallCheck(this,ConsentRequestsList);var _this=_possibleConstructorReturn(this,(ConsentRequestsList.__proto__||Object.getPrototypeOf(ConsentRequestsList)).call(this,props));_this.onScroll=function(e){var elem=e.target;if(_this.props.isLoadNextPageAvailable&&!_this.props.loading&&elem.scrollTop+10>elem.scrollHeight-elem.clientHeight){_this.props.onGetConsentRequestsNextPage();}};_this.renderContent=function(){if(_this.props.loading&&(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-requests-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(_this.props.data)&&_this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-requests-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,"consents.no_data_label")));}if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(_this.props.data)){return[_this.renderCards(),_this.props.loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{key:'fetching-message',className:'text-center'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)):_this.props.isLoadNextPageAvailable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'empty-div',className:'consent-requests-cards-list-empty-div'}):null];}};_this.renderCards=function(){return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(_this.props.data,function(elem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__consentRequestCard_ConsentRequestsCard_container__["a" /* default */],{key:elem.id,data:elem,id:elem.id,onClick:_this.toggleList});});};_this.renderListToggler=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:_this.toggleList,className:"toggle-consents-list-button "+(_this.state.isOpenList?"button-open":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'toggle-consents-list-icon',icon:'arrow_back'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,"consents."+(_this.state.isOpenList?"hide_consents_list_label":"show_consents_list_label"))));};_this.onFilterStatusChange=function(e){_this.props.onSetFilter(e.target.value);};_this.toggleList=function(){_this.setState({isOpenList:!_this.state.isOpenList});};_this.state={isOpenList:true};return _this;}_createClass(ConsentRequestsList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();if(this.listContainer){this.listContainer.addEventListener('scroll',this.onScroll);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();if(this.listContainer){this.listContainer.removeEventListener('scroll',this.onScroll);}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.departmentId!==prevProps.departmentId){this.props.onGetConsentRequests();}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-requests-list-container '},this.renderListToggler(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-requests-list-content-container '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"consent-requests-cards-list-container "+(this.state.isOpenList?"list-open":""),ref:function ref(elem){_this2.listContainer=elem;}},this.renderContent()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-requests-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__consentRequestDetails_ConsentRequestDetails_container__["a" /* default */],null))));}}]);return ConsentRequestsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsentRequestsList.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,departmentId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isLoadNextPageAvailable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onUnmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetConsentRequests:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetConsentRequestsNextPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ConsentRequestsList);

/***/ }),
/* 975 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConsentRequestsCard__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_consent_organizationConsents__ = __webpack_require__(49);
var mapStateToProps=function mapStateToProps(state,_ref){var id=_ref.id;return{isActive:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_organizationConsents__["h" /* getCurrentConsentRequestId */])(state)===id,translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSelectConsentRequest:function onSelectConsentRequest(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_organizationConsents__["o" /* setCurrentConsentRequest */])(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ConsentRequestsCard__["a" /* default */]));

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConsentRequestsCard_css__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConsentRequestsCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ConsentRequestsCard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _CARD_STATUS_COLOR;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var CARD_STATUS_COLOR=(_CARD_STATUS_COLOR={},_defineProperty(_CARD_STATUS_COLOR,__WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].PENDING,"secondary"),_defineProperty(_CARD_STATUS_COLOR,__WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].REJECTED,"danger"),_defineProperty(_CARD_STATUS_COLOR,__WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].GRANTED,"success"),_defineProperty(_CARD_STATUS_COLOR,__WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].EXPIRED,"warning"),_defineProperty(_CARD_STATUS_COLOR,__WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].REVOKED,"warning"),_defineProperty(_CARD_STATUS_COLOR,__WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["a" /* CONSENT_REQUESTS_CANCELED */],"light"),_CARD_STATUS_COLOR);var CARD_STATUS_HAS_EXPIRE_TIME=[__WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].GRANTED,__WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].EXPIRED];var ConsentRequestsCard=function(_Component){_inherits(ConsentRequestsCard,_Component);function ConsentRequestsCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ConsentRequestsCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ConsentRequestsCard.__proto__||Object.getPrototypeOf(ConsentRequestsCard)).call.apply(_ref,[this].concat(args))),_this),_this.renderContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-request-card-last-update'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.last_update_label")+": "+__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.updatedAt).format("L")),_this.renderJobInfo(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'consent-request-card-email'},_this.props.data.applicant.email),_this.renderRequestCardStatus());},_this.renderJobInfo=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this.props.data.jobDescription.internalReference?_this.props.data.jobDescription.internalReference+" - "+_this.props.data.jobDescription.title:_this.props.data.jobDescription.title);},_this.renderRequestCardStatus=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"consent-request-card-status "+(CARD_STATUS_HAS_EXPIRE_TIME.includes(_this.props.data.status)?"with-expire":"")},_this.renderRequestsCardDate(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["b" /* Badge */],{className:"request-status-badge "+_this.props.data.status.toLowerCase(),color:CARD_STATUS_COLOR[_this.props.data.status]},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'consents.status.'+_this.props.data.status))));},_this.renderRequestsCardDate=function(){switch(_this.props.data.status){case __WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].GRANTED:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.expires_label")+" "+__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.grantedTill).format("L"));case __WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].EXPIRED:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'consent-request-card-expired-status-expire-date'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.expired_label")+" "+__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.grantedTill).format("L"));default:return null;}},_this.handleClick=function(){_this.props.onSelectConsentRequest(_this.props.id);_this.props.onClick();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ConsentRequestsCard,[{key:'render',value:function render(){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"consent-request-card-container "+(this.props.isActive?"active":""),onClick:this.handleClick},this.renderContent());}else{return null;}}}]);return ConsentRequestsCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsentRequestsCard.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isActive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onSelectConsentRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ConsentRequestsCard);

/***/ }),
/* 978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConsentRequestDetails__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_consent_organizationConsents__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_account_userData__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{id:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_organizationConsents__["h" /* getCurrentConsentRequestId */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_organizationConsents__["g" /* getCurrentConsentRequestData */])(state),organizationData:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__["n" /* getOrgData */])(state),userId:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_account_userData__["g" /* getUserId */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_organizationConsents__["m" /* loadingCurrentConsentRequest */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancelPendingRequest:function onCancelPendingRequest(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__["p" /* MODAL_CANCEL_CONSENT_REQUEST */]}));},onDismissRequest:function onDismissRequest(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_7__reducers_common_activeModal__["y" /* MODAL_DISMISS_CONSENT_REQUEST */]}));},onResetSubmitFormData:function onResetSubmitFormData(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ConsentRequestDetails__["a" /* default */]));

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConsentRequestDetails_css__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConsentRequestDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ConsentRequestDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_consent_organizationConsents__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__certificateCard_CertificateCard_container__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cancelConsentRequestModal_CancelConsentRequestModal_container__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cancelConsentRequestModal_DismissConsentRequestModal_container__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selfStudyBookCard_SelfStudyBookCard_container__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__accreditationRequestCard_AccreditationRequestCard_container__ = __webpack_require__(990);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TABS={REQUEST_DETAILS:"RequestDetails",CREDENTIALS:"Credentials",ACCREDITATIONS:"Accreditations",BOOKS:"Books",ACCREDITATION_REQUESTS:"AccreditationRequests"};var ConsentRequestDetails=function(_Component){_inherits(ConsentRequestDetails,_Component);function ConsentRequestDetails(props){_classCallCheck(this,ConsentRequestDetails);var _this=_possibleConstructorReturn(this,(ConsentRequestDetails.__proto__||Object.getPrototypeOf(ConsentRequestDetails)).call(this,props));_this.renderContent=function(){if(_this.props.loading&&(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-request-details-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.renderDismissRequestButton(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'consents.status_title.'+_this.props.data.status)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-request-details-expire-label'},_this.renderRequestsCardDate()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"consent-request-details-tab-header-container olive-green "+(_this.props.data.status===__WEBPACK_IMPORTED_MODULE_6__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].GRANTED?"switchable":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{onClick:_this.toggle(TABS.REQUEST_DETAILS)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.request_details_label"))),_this.renderCollapseArrow(TABS.REQUEST_DETAILS)),_this.props.data.status===__WEBPACK_IMPORTED_MODULE_6__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].GRANTED?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["i" /* Collapse */],{isOpen:_this.state.isOpenRequestDetails},_this.renderRequestDetails()):_this.renderRequestDetails(),_this.renderCredentials(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__cancelConsentRequestModal_CancelConsentRequestModal_container__["a" /* default */],{id:_this.props.id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__cancelConsentRequestModal_DismissConsentRequestModal_container__["a" /* default */],{id:_this.props.id}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.no_selected_consent_request_label"));}};_this.renderRequestsCardDate=function(){switch(_this.props.data.status){case __WEBPACK_IMPORTED_MODULE_6__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].GRANTED:return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.expires_label")+" "+__WEBPACK_IMPORTED_MODULE_9_moment___default()(_this.props.data.grantedTill).format("MMMM Do YYYY, HH:mm");case __WEBPACK_IMPORTED_MODULE_6__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].EXPIRED:return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.expired_label")+" "+__WEBPACK_IMPORTED_MODULE_9_moment___default()(_this.props.data.grantedTill).format("MMMM Do YYYY, HH:mm");case __WEBPACK_IMPORTED_MODULE_6__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].REVOKED:return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.revoked_label")+" "+__WEBPACK_IMPORTED_MODULE_9_moment___default()(_this.props.data.updatedAt).format("MMMM Do YYYY, HH:mm");default:return null;}};_this.renderRequestDetails=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["n" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.target_label")+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+_this.props.data.applicant.email},_this.props.data.applicant.email))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.created_by_label")+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.data.requester.identityAlias.firstName+" "+_this.props.data.requester.identityAlias.lastName,_this.props.data.showRequesterFNLN?null:" ("+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.hidden_for_applicant_label")+")"),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data.contactEmail)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+_this.props.data.contactEmail},_this.props.data.contactEmail)):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].company_label)+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:10},_this.props.organizationData.name+", "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'countries.'+_this.props.organizationData.address.countryCode)+", "+_this.props.organizationData.address.city)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'consents.internal_job_reference')+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:10},_this.props.data.jobDescription.internalReference,!_this.props.data.jobDescription.exposeReference&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data.jobDescription.internalReference)?" ("+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.hidden_for_applicant_label")+")":null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.job_title_label")+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:10},_this.props.data.jobDescription.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.note_to_applicants_label")+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,_this.props.data.requestComment))),_this.renderCancelRequestButton(),_this.renderApplicantResponse());};_this.renderCredentials=function(){if(_this.props.data.status===__WEBPACK_IMPORTED_MODULE_6__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].GRANTED){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-request-details-tab-header-container switchable olive-green'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{onClick:_this.toggle(TABS.CREDENTIALS)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.credentials_label"))),_this.renderCollapseArrow(TABS.CREDENTIALS)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["i" /* Collapse */],{isOpen:_this.state.isOpenCredentials},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center applicant-name'},_this.renderApplicantName(),_this.renderVIDData()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+_this.props.data.applicant.email},_this.props.data.applicant.email))),_this.props.data.applicant.identityAlias.phoneNumber?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].phone_number_label)+":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:10},_this.props.data.applicant.identityAlias.phoneNumber)):null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.props.data.accreditations)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'certificate-tab olive-green'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{onClick:_this.toggle(TABS.ACCREDITATIONS)},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'consents.accreditations_label')),_this.renderCollapseArrow(TABS.ACCREDITATIONS)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["i" /* Collapse */],{isOpen:_this.state.isOpenAccreditations},_this.renderCertificates()),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.props.data.selfStudyBooks)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'certificate-tab olive-green'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{onClick:_this.toggle(TABS.BOOKS)},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'consents.self_study_books_label')),_this.renderCollapseArrow(TABS.BOOKS)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["i" /* Collapse */],{isOpen:_this.state.isOpenBooks},_this.renderSelfStudyBooks()),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.props.data.accreditationRequests)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'certificate-tab olive-green'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{onClick:_this.toggle(TABS.ACCREDITATION_REQUESTS)},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.accreditations_pending_approval_label')),_this.renderCollapseArrow(TABS.ACCREDITATION_REQUESTS)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["i" /* Collapse */],{isOpen:_this.state.isOpenAccreditationRequests},_this.renderAccreditationRequests())));}};_this.renderApplicantName=function(){var vid=_this.props.data.verifiedIdentity;if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(vid,'firstName')&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(vid,'lastName')){return vid.firstName+" "+vid.lastName;}return _this.props.data.applicant.identityAlias.firstName+" "+_this.props.data.applicant.identityAlias.lastName;};_this.renderVIDData=function(){var vid=_this.props.data.verifiedIdentity;var vidData='';if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(vid,'countryCode')){vidData+=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"countries."+vid.countryCode);}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(vid,'nationalId')){vidData+=(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(vidData)?'':', ')+(vid.nationalId.length===4?"*":"")+vid.nationalId;}return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(vidData)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'vid-data'},'(',vidData,')');};_this.renderCertificates=function(){//TODO: add certificates types - Accreditation & Booc (and also MOOC later)
return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(_this.props.data.accreditations,function(elem,id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__certificateCard_CertificateCard_container__["a" /* default */],{data:elem,key:id});});};_this.renderSelfStudyBooks=function(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(_this.props.data.selfStudyBooks,function(elem,id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__selfStudyBookCard_SelfStudyBookCard_container__["a" /* default */],{data:elem,key:id});});};_this.renderAccreditationRequests=function(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(_this.props.data.accreditationRequests,function(elem,id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__accreditationRequestCard_AccreditationRequestCard_container__["a" /* default */],{data:elem,key:id});});};_this.renderCollapseArrow=function(tab){if(_this.props.data.status===__WEBPACK_IMPORTED_MODULE_6__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].GRANTED){var iconName="keyboard_arrow_"+(_this.state['isOpen'+tab]?"down":"right");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__["a" /* default */],{onClick:_this.toggle(tab),className:'consent-request-details-tab-header-icon',icon:iconName});}};_this.renderCancelRequestButton=function(){if(_this.props.data.status===__WEBPACK_IMPORTED_MODULE_6__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].PENDING&&_this.props.userId===_this.props.data.requester.id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-request-details-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["c" /* Button */],{className:'carrot-red-btn',onClick:_this.props.onCancelPendingRequest},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.cancel_request_button_label")));}};_this.renderDismissRequestButton=function(){if(_this.props.data.status!==__WEBPACK_IMPORTED_MODULE_6__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].PENDING){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-request-details-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'clear',className:'consent-request-details-button-icon',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.dismiss_request_button_label"),onClick:_this.props.onDismissRequest}));}};_this.renderApplicantResponse=function(){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data.responseComment)&&_this.props.data.responseComment!==""){var color=_this.props.data.status===__WEBPACK_IMPORTED_MODULE_6__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].GRANTED||_this.props.data.status===__WEBPACK_IMPORTED_MODULE_6__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].EXPIRED?"success":"warning";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.applicant_response_label")+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["a" /* Alert */],{color:color},_this.props.data.responseComment));}};_this.toggle=function(tab){return function(){if(_this.props.data.status===__WEBPACK_IMPORTED_MODULE_6__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].GRANTED){_this.setState(_defineProperty({},'isOpen'+tab,!_this.state['isOpen'+tab]));}};};_this.state={isOpenRequestDetails:false,isOpenCredentials:true,isOpenAccreditations:false,isOpenBooks:false,isOpenAccreditationRequests:false};return _this;}_createClass(ConsentRequestDetails,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.id!==this.props.id){this.setState({isOpenRequestDetails:false,isOpenCredentials:true,isOpenAccreditations:false,isOpenBooks:false,isOpenAccreditationRequests:false});this.props.onResetSubmitFormData();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consent-request-details-container'},this.renderContent());}}]);return ConsentRequestDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsentRequestDetails.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,organizationData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,userId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancelPendingRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onDismissRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onResetSubmitFormData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ConsentRequestDetails);

/***/ }),
/* 981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CertificateCard__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__CertificateCard__["a" /* default */]));

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CertificateCard_css__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CertificateCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CertificateCard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CertificateCard=function(_Component){_inherits(CertificateCard,_Component);function CertificateCard(props){_classCallCheck(this,CertificateCard);var _this=_possibleConstructorReturn(this,(CertificateCard.__proto__||Object.getPrototypeOf(CertificateCard)).call(this,props));_this.renderContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'certificate-card-information-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'certificate-card-original-title-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{onClick:_this.toggle},_this.props.data.accreditationData.titles.original),_this.renderCollapseArrow()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'certificate-card-additional-titles-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["i" /* Collapse */],{isOpen:_this.state.isOpenAdditionalTitles},_this.renderAdditionalTitles())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"orgs.org_label")+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:9},_this.props.data.organization.name+", "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'countries.'+_this.props.data.organization.address.countryCode)+", "+_this.props.data.organization.address.city)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.issued_at_label")+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.accreditationData.issuedAt).format("L"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"accreditation.level_label")+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels.'+_this.props.data.accreditationData.level))));};_this.renderCollapseArrow=function(){var iconName="keyboard_arrow_"+(_this.state.isOpenAdditionalTitles?"down":"right");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{onClick:_this.toggle,className:'certificate-card-additional-titles-icon',icon:iconName});};_this.renderAdditionalTitles=function(){var result=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_this.props.data.accreditationData.titles,function(value,key){if(key!=="original"){result.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:2},"("+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'langs.'+key)+")"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:10},value)));}});return result;};_this.toggle=function(){_this.setState({isOpenAdditionalTitles:!_this.state.isOpenAdditionalTitles});};_this.state={isOpenAdditionalTitles:false};return _this;}_createClass(CertificateCard,[{key:'render',value:function render(){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'certificate-card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'certificate-card-icon',icon:'certify'}),this.renderContent());}else{return null;}}}]);return CertificateCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CertificateCard.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CertificateCard);

/***/ }),
/* 984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConsentRequestModal__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__ = __webpack_require__(49);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["p" /* MODAL_CANCEL_CONSENT_REQUEST */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),actionType:__WEBPACK_IMPORTED_MODULE_3__ConsentRequestModal__["a" /* actionType */].CANCEL};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAbandonConsentRequest:function onAbandonConsentRequest(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["d" /* fetchAbandonConsentRequest */])(id));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__ConsentRequestModal__["b" /* default */]));

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConsentRequestModal__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__ = __webpack_require__(49);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["y" /* MODAL_DISMISS_CONSENT_REQUEST */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),actionType:__WEBPACK_IMPORTED_MODULE_3__ConsentRequestModal__["a" /* actionType */].DISMISS};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAbandonConsentRequest:function onAbandonConsentRequest(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_consent_organizationConsents__["d" /* fetchAbandonConsentRequest */])(id));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__ConsentRequestModal__["b" /* default */]));

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelfStudyBookCard__ = __webpack_require__(988);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__SelfStudyBookCard__["a" /* default */]));

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelfStudyBookCard_css__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelfStudyBookCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SelfStudyBookCard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelfStudyBookCard=function(_Component){_inherits(SelfStudyBookCard,_Component);function SelfStudyBookCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SelfStudyBookCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SelfStudyBookCard.__proto__||Object.getPrototypeOf(SelfStudyBookCard)).call.apply(_ref,[this].concat(args))),_this),_this.renderContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'self-study-book-card-information-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'self-study-book-card-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,_this.props.data.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"self_study.domain_label")+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"self_study.domains."+_this.props.data.domain))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"self_study.publisher_label")+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:9},_this.props.data.publisher)),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data.isbn)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"self_study.isbn_label")+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:9},_this.props.data.isbn)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"self_study.study_date_label")+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.studyDate).format('LL'))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SelfStudyBookCard,[{key:'render',value:function render(){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'self-study-book-card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'self-study-book-card-icon',icon:'book'}),this.renderContent());}else{return null;}}}]);return SelfStudyBookCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelfStudyBookCard.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SelfStudyBookCard);

/***/ }),
/* 989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccreditationRequestCard__ = __webpack_require__(991);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__AccreditationRequestCard__["a" /* default */]));

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccreditationRequestCard_css__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccreditationRequestCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AccreditationRequestCard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccreditationRequestCard=function(_Component){_inherits(AccreditationRequestCard,_Component);function AccreditationRequestCard(props){_classCallCheck(this,AccreditationRequestCard);var _this=_possibleConstructorReturn(this,(AccreditationRequestCard.__proto__||Object.getPrototypeOf(AccreditationRequestCard)).call(this,props));_this.renderContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-request-card-information-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["b" /* Badge */],{color:'warning'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'consents.verified_by_applicant_only_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-request-card-original-title-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{onClick:_this.toggle},_this.props.data.accreditationData.titles.original),_this.renderCollapseArrow()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-request-card-additional-titles-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["i" /* Collapse */],{isOpen:_this.state.isOpenAdditionalTitles},_this.renderAdditionalTitles())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"orgs.org_label")+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:9},_this.props.data.orgName+", "+_this.props.data.orgDomain)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"consents.issued_at_label")+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.accreditationData.issuedAt).format("L"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"accreditation.level_label")+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels.'+_this.props.data.accreditationData.level))));};_this.renderCollapseArrow=function(){var iconName="keyboard_arrow_"+(_this.state.isOpenAdditionalTitles?"down":"right");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{onClick:_this.toggle,className:'accreditation-request-card-additional-titles-icon',icon:iconName});};_this.renderAdditionalTitles=function(){var result=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_this.props.data.accreditationData.titles,function(value,key){if(key!=="original"){result.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["L" /* Row */],{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:2},"("+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'langs.'+key)+")"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["h" /* Col */],{sm:10},value)));}});return result;};_this.toggle=function(){_this.setState({isOpenAdditionalTitles:!_this.state.isOpenAdditionalTitles});};_this.state={isOpenAdditionalTitles:false};return _this;}_createClass(AccreditationRequestCard,[{key:'render',value:function render(){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-request-card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'accreditation-request-card-icon',icon:'certify'}),this.renderContent());}else{return null;}}}]);return AccreditationRequestCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AccreditationRequestCard.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AccreditationRequestCard);

/***/ }),
/* 992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PriorConsentsList__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_consent_priorConsents__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_priorConsents__["c" /* loadingPriorConsents */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_priorConsents__["b" /* getPriorConsentsList */])(state),addingDisabled:false,editingDisabled:false};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_priorConsents__["g" /* setFilterDate */])(null));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_priorConsents__["e" /* onGetPriorConsents */])());},onRemoveIconClick:function onRemoveIconClick(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_0" /* MODAL_REMOVE_PRIOR_CONSENT */]}));},onUnmount:function onUnmount(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_priorConsents__["f" /* resetPriorConsentsData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__PriorConsentsList__["b" /* default */]));

/***/ }),
/* 994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemovePriorConsentModal__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_consent_priorConsent__ = __webpack_require__(193);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_0" /* MODAL_REMOVE_PRIOR_CONSENT */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onPriorConsentRemove:function onPriorConsentRemove(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_consent_priorConsent__["e" /* onRemovePriorConsent */])(id));},onClose:function onClose(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RemovePriorConsentModal__["a" /* default */]));

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__consentsList_priorConsentsList_PriorConsentsList__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemovePriorConsentModal=function(_Component){_inherits(RemovePriorConsentModal,_Component);function RemovePriorConsentModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemovePriorConsentModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemovePriorConsentModal.__proto__||Object.getPrototypeOf(RemovePriorConsentModal)).call.apply(_ref,[this].concat(args))),_this),_this.renderData=function(){var paramsList=[{key:"target_type",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.target_type_label'),value:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__consentsList_priorConsentsList_PriorConsentsList__["a" /* TARGET_TYPE_LABEL_PATH */][_this.props.data.targetType])},{key:"target_data",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.target_data_label'),value:_this.getTargetDataValue()},{key:"auto_grant_till",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.auto_grant_till_label'),value:__WEBPACK_IMPORTED_MODULE_7_moment_moment___default()(_this.props.data.enabledTill).format('LL')},{key:"duration",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.duration_label'),value:_this.getGrantedPeriodDays(_this.props.data.grantedPeriodDays)}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getDataRow)));},_this.getTargetDataValue=function(){switch(_this.props.data.targetType){case __WEBPACK_IMPORTED_MODULE_6__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].PERSON:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'target-data'},!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(_this.props.data.metadata.firstName)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(_this.props.data.metadata.lastName)?_this.props.data.metadata.firstName+' '+_this.props.data.metadata.lastName+'\n':'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+_this.props.data.targetId},_this.props.data.targetId));case __WEBPACK_IMPORTED_MODULE_6__constants_constants__["e" /* AVAILABLE_PRIOR_CONSENT_TYPES */].ORGANIZATION:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'target-data'},_this.props.data.targetId);default:return;}},_this.getGrantedPeriodDays=function(periodDays){var label=periodDays===1?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.day_label'):__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'prior_consents.days_label');return periodDays+' '+label;},_this.getDataRow=function(params){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(params.value)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container',key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,params.value));},_this.handleRemove=function(e){e.preventDefault();_this.props.onPriorConsentRemove(_this.props.data.id);_this.props.onClose();},_this.handleCancel=function(){_this.props.onClose();_this.props.onCancelRemoving();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemovePriorConsentModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'prior-consent-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'prior_consents.remove_prior_consent_alert')),this.renderData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))));}}]);return RemovePriorConsentModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemovePriorConsentModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onPriorConsentRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelRemoving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemovePriorConsentModal);

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PriorConsentDetails__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_consent_priorConsents__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),actionType:__WEBPACK_IMPORTED_MODULE_1__PriorConsentDetails__["a" /* ACTION_TYPES */].ADD,success:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onProcess:function onProcess(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_priorConsents__["d" /* onCreatePriorConsent */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PriorConsentDetails__["b" /* default */]));

/***/ }),
/* 998 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PriorConsentDetails__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_consent_priorConsent__ = __webpack_require__(193);
var mapStateToProps=function mapStateToProps(state,_ref){var location=_ref.location;return{id:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search).id,data:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_consent_priorConsent__["c" /* getFormattedPriorConsent */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_consent_priorConsent__["d" /* loadingPriorConsent */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),actionType:__WEBPACK_IMPORTED_MODULE_1__PriorConsentDetails__["a" /* ACTION_TYPES */].EDIT,success:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_consent_priorConsent__["b" /* fetchGetPriorConsentById */])(id));},onProcess:function onProcess(id,data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_consent_priorConsent__["f" /* onUpdatePriorConsent */])(id,data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PriorConsentDetails__["b" /* default */]));

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HistoryConsentsList__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_consent_consents__ = __webpack_require__(44);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_consents__["s" /* loadingConsents */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_consents__["h" /* getConsentsData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onLoadData:function onLoadData(statuses){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_consents__["p" /* getRequestsByStatus */])(statuses));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__HistoryConsentsList__["a" /* default */]));

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HistoryConsentsList_css__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HistoryConsentsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__HistoryConsentsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_paginationComponent_PaginationHistoryConsentsList_container__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_consent_organizationConsents__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _CARD_STATUS_COLOR;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var CARD_STATUS_COLOR=(_CARD_STATUS_COLOR={},_defineProperty(_CARD_STATUS_COLOR,__WEBPACK_IMPORTED_MODULE_10__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].REJECTED,"danger"),_defineProperty(_CARD_STATUS_COLOR,__WEBPACK_IMPORTED_MODULE_10__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].EXPIRED,"warning"),_defineProperty(_CARD_STATUS_COLOR,__WEBPACK_IMPORTED_MODULE_10__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].REVOKED,"secondary"),_defineProperty(_CARD_STATUS_COLOR,__WEBPACK_IMPORTED_MODULE_10__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].GRANTED,"success"),_CARD_STATUS_COLOR);var DEFAULT_STATUS_LIST=[__WEBPACK_IMPORTED_MODULE_10__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].REJECTED,__WEBPACK_IMPORTED_MODULE_10__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].EXPIRED,__WEBPACK_IMPORTED_MODULE_10__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].REVOKED,__WEBPACK_IMPORTED_MODULE_10__reducers_consent_organizationConsents__["b" /* CONSENT_REQUESTS_FILTER */].GRANTED];var HistoryConsentsList=function(_Component){_inherits(HistoryConsentsList,_Component);function HistoryConsentsList(props){_classCallCheck(this,HistoryConsentsList);var _this=_possibleConstructorReturn(this,(HistoryConsentsList.__proto__||Object.getPrototypeOf(HistoryConsentsList)).call(this,props));_this.renderStatusCheckboxes=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(DEFAULT_STATUS_LIST,function(status,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:"consents-history-status-icon-container"+(_this.state.selectedStatuses.includes(status)?" olive-green":""),onClick:_this.toggleSelectedStatuses(status)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'consents-history-status-icon',icon:"check_box"+(_this.state.selectedStatuses.includes(status)?"":"_outline_blank"),title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.status.'+status)}),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.status.'+status));});};_this.renderTable=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consents-history-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consents-history-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.consents_history_no_data_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["N" /* Table */],{className:'consents-history-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.status_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.person_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.job_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].company_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.expired_on_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderConsentsData()));};_this.renderConsentsData=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_this.props.data,function(consentData,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'consents-history-list-row',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'status-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.status_label')+':'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["b" /* Badge */],{color:CARD_STATUS_COLOR[consentData.status]},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.status.'+consentData.status)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'person-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.person_label')+':'},!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(consentData.requester)?consentData.requester.identityAlias.firstName+" "+consentData.requester.identityAlias.lastName:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'job-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.job_label')+':'},!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(consentData.jobDescription)?consentData.jobDescription.title:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'company-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].company_label)+':'},consentData.organization.name,', ',__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'countries.'+consentData.organization.address.countryCode)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'email-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+':'},!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(consentData.contactEmail)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+consentData.contactEmail},consentData.contactEmail):'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'expired-on-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.expired_on_label')+':'},!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(consentData.grantedTill)?__WEBPACK_IMPORTED_MODULE_8_moment_moment___default()(consentData.grantedTill).format('LL'):'-'));});};_this.toggleSelectedStatuses=function(currentStatus){return function(){var newSelectedStatuses=void 0;if(_this.state.selectedStatuses.includes(currentStatus)&&_this.state.selectedStatuses.length!==1){newSelectedStatuses=_this.state.selectedStatuses.filter(function(status){return status!==currentStatus;});}else{newSelectedStatuses=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.union(_this.state.selectedStatuses,[currentStatus]);}if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(newSelectedStatuses,_this.state.selectedStatuses)){_this.setState({selectedStatuses:newSelectedStatuses});_this.props.onLoadData(newSelectedStatuses);}};};_this.state={selectedStatuses:DEFAULT_STATUS_LIST};return _this;}_createClass(HistoryConsentsList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onLoadData(this.state.selectedStatuses);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consents-history-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'consents.consents_history_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consents-history-management-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'consents-history-status-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'consents.show_consents_with_status_label')),this.renderStatusCheckboxes()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_paginationComponent_PaginationHistoryConsentsList_container__["a" /* default */],{statuses:this.state.selectedStatuses}),this.renderTable()));}}]);return HistoryConsentsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);HistoryConsentsList.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onLoadData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (HistoryConsentsList);

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__ = __webpack_require__(44);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__["k" /* getCurrentPageForConsents */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__["q" /* getTotalPagesForConsents */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref){var statuses=_ref.statuses;return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__["p" /* getRequestsByStatus */])(statuses,page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_applicantSelfStudy_applicantSelfStudyBooks__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelfStudyList__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_applicantSelfStudy_applicantSelfStudyBook__ = __webpack_require__(143);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_applicantSelfStudy_applicantSelfStudyBooks__["d" /* loadingApplicantSelfStudyBooks */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_applicantSelfStudy_applicantSelfStudyBooks__["c" /* getApplicantSelfStudyBooksData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_applicantSelfStudy_applicantSelfStudyBooks__["b" /* fetchGetSelfStudyBooks */])());},onBookRemove:function onBookRemove(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_1" /* MODAL_REMOVE_SELF_STUDY_BOOK */]}));},onBookUpdate:function onBookUpdate(id,data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_applicantSelfStudy_applicantSelfStudyBook__["g" /* onUpdateSelfStudyBookFromList */])(id,data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__SelfStudyList__["a" /* default */]));

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelfStudyList_css__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelfStudyList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SelfStudyList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__removeSelfStudyBookModal_RemoveSelfStudyModal_container__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_utils__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelfStudyList=function(_Component){_inherits(SelfStudyList,_Component);function SelfStudyList(props){_classCallCheck(this,SelfStudyList);var _this=_possibleConstructorReturn(this,(SelfStudyList.__proto__||Object.getPrototypeOf(SelfStudyList)).call(this,props));_this.handleRowClick=function(id){return function(){_this.setState({selectedSelfStudyBookId:id});};};_this.handleRemoveIconClick=function(book){return function(e){e.stopPropagation();_this.setState({selfStudyBookToRemove:book});_this.props.onBookRemove();};};_this.handleCloseModal=function(){_this.setState({selfStudyBookToRemove:null});};_this.handleExposeIconClick=function(book){return function(e){e.stopPropagation();var data=book;data.expose=!book.expose;_this.props.onBookUpdate(data.id,data);};};_this.state={selectedSelfStudyBookId:null,selfStudyBookToRemove:null};return _this;}_createClass(SelfStudyList,[{key:'render',value:function render(){if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.state.selectedSelfStudyBookId)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["d" /* Redirect */],{to:"/edit-self-study-book?id="+this.state.selectedSelfStudyBookId,push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'self-study-list-component-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'self_study.remove_self_study_book_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'self-study-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'self_study.table_label')),this.renderButtonsBar(),this.renderContent()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__removeSelfStudyBookModal_RemoveSelfStudyModal_container__["a" /* default */],{data:this.state.selfStudyBookToRemove,onCancelRemoving:this.handleCloseModal})));}},{key:'renderContent',value:function renderContent(){if(this.props.loading&&(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.data)||this.props.data.length===0)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'self-study-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.data)||this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'self-study-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'self_study.no_data_label'))));}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'self-study-list-relative-header',key:'self-study-list-relative-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'self_study.expose_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["N" /* Table */],{className:'self-study-list-table',key:'self-study-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'self_study.domain_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].title_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'self_study.publisher_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'self_study.isbn_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'self_study.study_date_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'self-study-expose-icon-th'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'self_study.expose_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.renderStaffData()))];}},{key:'renderStaffData',value:function renderStaffData(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.props.data,function(book,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index,className:'self-study-list-row',onClick:_this2.handleRowClick(book.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'domain-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'self_study.domain_label')+':'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'self_study.domains.'+book.domain)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'title-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].title_label)+':'},book.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'publisher-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'self_study.publisher_label')+':'},book.publisher),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'isbn-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'self_study.isbn_label')+':'},book.isbn||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'study-date-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'self_study.study_date_label')+':'},__WEBPACK_IMPORTED_MODULE_8_moment___default()(book.studyDate).format('LL')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'self-study-expose-icon-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:book.expose?"check_box":"check_box_outline_blank",onClick:_this2.handleExposeIconClick(book),key:"expose-self-study-member-icon-"+book.id,className:'expose-self-study-member-icon',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'self_study.expose_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'self-study-edit-icon-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'create',className:'edit-self-study-member-icon',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].edit_button)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'self-study-remove-icon-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_iconContainer_IconContainer__["a" /* default */],{onClick:_this2.handleRemoveIconClick(book),icon:'trash',className:'delete-self-study-member-icon',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button)})));});}},{key:'renderButtonsBar',value:function renderButtonsBar(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-self-study-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{tag:__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],to:'/add-self-study-book',className:'add-self-study-button olive-green-btn',onClick:this.onChangeAnchorButtonClick},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].add_button)));}},{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}}]);return SelfStudyList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelfStudyList.propTypes={loading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,onBookRemove:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onMount:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onRemove:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onBookUpdate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (SelfStudyList);

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_applicantSelfStudy_applicantSelfStudyBook__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RemoveSelfStudyModal__ = __webpack_require__(1008);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_1" /* MODAL_REMOVE_SELF_STUDY_BOOK */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSelfStudyBookRemove:function onSelfStudyBookRemove(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_applicantSelfStudy_applicantSelfStudyBook__["e" /* onRemoveSelfStudyBook */])(id));},onClose:function onClose(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__RemoveSelfStudyModal__["a" /* default */]));

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveSelfStudyModal=function(_Component){_inherits(RemoveSelfStudyModal,_Component);function RemoveSelfStudyModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveSelfStudyModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveSelfStudyModal.__proto__||Object.getPrototypeOf(RemoveSelfStudyModal)).call.apply(_ref,[this].concat(args))),_this),_this.renderData=function(){var paramsList=[{key:"domain",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'self_study.domain_label'),value:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,"self_study.domains."+_this.props.data.domain)},{key:"title",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].title_label),value:_this.props.data.title},{key:"publisher",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,"self_study.publisher_label"),value:_this.props.data.publisher},{key:"studyDate",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,"self_study.study_date_label"),value:__WEBPACK_IMPORTED_MODULE_5_moment_moment___default()(_this.props.data.studyDate).format('LL')}];if(_this.props.data.isbn!==''){paramsList.push({key:"isbn",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,"self_study.isbn_label"),value:_this.props.data.isbn});}return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getDataRow)));},_this.getDataRow=function(params){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(params.value)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container',key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,params.value));},_this.handleRemove=function(e){e.preventDefault();_this.props.onSelfStudyBookRemove(_this.props.data.id);_this.props.onClose();},_this.handleCancel=function(){_this.props.onClose();_this.props.onCancelRemoving();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveSelfStudyModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'self-study-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'self_study.remove_self_study_book_alert')),this.renderData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))));}}]);return RemoveSelfStudyModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveSelfStudyModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onSelfStudyBookRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelRemoving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveSelfStudyModal);

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelfStudyDetails__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_applicantSelfStudy_applicantSelfStudyBooks__ = __webpack_require__(142);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),actionType:__WEBPACK_IMPORTED_MODULE_3__SelfStudyDetails__["a" /* ACTION_TYPES */].ADD,success:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),errors:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["g" /* getSubmitFormFieldsErrors */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onProcess:function onProcess(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_applicantSelfStudy_applicantSelfStudyBooks__["e" /* onCreateSelfStudyBook */])(data));},onChangeFieldWithError:function onChangeFieldWithError(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["i" /* resetFieldErrors */])(field));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__SelfStudyDetails__["b" /* default */]));

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_applicantSelfStudy_applicantSelfStudyBook__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SelfStudyDetails__ = __webpack_require__(194);
var mapStateToProps=function mapStateToProps(state,_ref){var location=_ref.location;return{id:__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search).id,data:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_applicantSelfStudy_applicantSelfStudyBook__["c" /* getSelfStudyBookData */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_applicantSelfStudy_applicantSelfStudyBook__["d" /* loadingSelfStudyBook */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),actionType:__WEBPACK_IMPORTED_MODULE_5__SelfStudyDetails__["a" /* ACTION_TYPES */].EDIT,success:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),errors:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["g" /* getSubmitFormFieldsErrors */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_applicantSelfStudy_applicantSelfStudyBook__["b" /* fetchGetSelfStudyBookById */])(id));},onProcess:function onProcess(id,data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_applicantSelfStudy_applicantSelfStudyBook__["f" /* onUpdateSelfStudyBook */])(id,data));},onChangeFieldWithError:function onChangeFieldWithError(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["i" /* resetFieldErrors */])(field));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__SelfStudyDetails__["b" /* default */]));

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_consent_bulkConsentRequests__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BulkConsentRequestsList__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__ = __webpack_require__(6);
// import {fetchGetOrgBalance, getConsentRequestFee, getOrgBalance, getPaidTillDate} from "../../../reducers/organization/organization";
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_bulkConsentRequests__["d" /* loadingBulkConsentRequests */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_bulkConsentRequests__["b" /* getBulkConsentRequestsFormattedData */])(state),groupId:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_role__["k" /* getCurrentGroup */])(state),groupName:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_account_role__["m" /* getCurrentGroupName */])(state)// balance: getOrgBalance(state),
// consentRequestFee: getConsentRequestFee(state),
// paidTillDate: getPaidTillDate(state)
};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{// onMount: () => dispatch(fetchGetOrgBalance()),
onLoadJobs:function onLoadJobs(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_bulkConsentRequests__["c" /* getBulkRequestsJobs */])());},onRemoveBulk:function onRemoveBulk(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["R" /* MODAL_REMOVE_BULK_CONSENT_REQUEST */]}));},onCancelRemoving:function onCancelRemoving(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_16" /* hideModal */])());},onResumeBulk:function onResumeBulk(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_bulkConsentRequests__["f" /* onResumeBulkConsentRequest */])(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__BulkConsentRequestsList__["a" /* default */]));

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BulkConsentRequestsList_css__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BulkConsentRequestsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BulkConsentRequestsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__removeBulkConsetRequestModal_RemoveBulkConsentRequestModal_container__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import {CURRENCIES} from "../../../constants/constants";
// import moment from "moment";
var UNSUFFICIENT_BALANCE='UNSUFFICIENT_BALANCE';var BulkConsentRequestsList=function(_Component){_inherits(BulkConsentRequestsList,_Component);function BulkConsentRequestsList(props){_classCallCheck(this,BulkConsentRequestsList);var _this=_possibleConstructorReturn(this,(BulkConsentRequestsList.__proto__||Object.getPrototypeOf(BulkConsentRequestsList)).call(this,props));_this.renderDepartment=function(){if(_this.props.groupName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'department-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].department_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.groupName));}};_this.renderWarning=function(){//TODO: add money conversion if balance and pricing ara in different currencies (conversion is now available only for SysAdmin)
// if (this.props.balance.amount < this.props.consentRequestFee.amount || moment(this.props.paidTillDate).isBefore(moment())) {
//     return (
//         <div className="consent-requests-jobs-status-message-container"  key="consent-requests-jobs-status-message">
//             <h6>{_.get(this.props.translation, 'request_credentials_verification.request_unavailable_alert')}</h6>
//         </div>
//     )
// }
};_this.getStatus=function(jobData){if(!jobData.finished){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'in-progress-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'bulk_jobs_list.in_progress_label'));}else{if(jobData.error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'error-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'bulk_jobs_list.error_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'error-info-icon-container'+jobData.id,className:'error-info-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'error-info-icon',icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Q" /* UncontrolledPopover */],{placement:'bottom',trigger:'legacy',target:'error-info-icon-container'+jobData.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["I" /* PopoverBody */],null,jobData.error===UNSUFFICIENT_BALANCE?_this.getUnsufficientBalanceErrorAlert(jobData):__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].errors)[jobData.error])));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'finished-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'bulk_jobs_list.finished_label'));}}};_this.getUnsufficientBalanceErrorAlert=function(jobData){// if (_.isNil(this.props.balance) || _.isNil(this.props.consentRequestFee)) {
//     return;
// }
//TODO: add money conversion if balance and pricing ara in different currencies (conversion is now available only for SysAdmin)
// let amount = this.props.consentRequestFee.amount * (jobData.totalEntriesCount - jobData.processedEntriesCount) - this.props.balance.amount;
return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'bulk_jobs_list.insufficient_balance_error_alert_part_1').replace('{processed}',jobData.processedEntriesCount).replace('{total}',jobData.totalEntriesCount);// + _.get(this.props.translation, 'bulk_jobs_list.insufficient_balance_error_alert_part_2')
// .replace('{amount}', amount + CURRENCIES[this.props.balance.currency]);
};_this.handleRemoveBulk=function(jobData){return function(){_this.props.onRemoveBulk();_this.setState({bulkToRemove:jobData});};};_this.handleFlushRemainingButtonClick=function(id){return function(){_this.props.onResumeBulk(id);};};_this.state={redirect:false,bulkToRemove:null};return _this;}// componentWillMount() {
// this.props.onMount();
// }
_createClass(BulkConsentRequestsList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-consents-requests-jobs-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{showSuccessAlert:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'bulk_jobs_list.bulk_consent_requests_label')),this.renderDepartment(),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__removeBulkConsetRequestModal_RemoveBulkConsentRequestModal_container__["a" /* default */],{data:this.state.bulkToRemove,onCancelRemoving:this.props.onCancelRemoving})));}},{key:'renderContent',value:function renderContent(){if(this.props.loading&&(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.data)||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(this.props.data)))/*|| _.isNil(this.props.balance) || _.isNil(this.props.consentRequestFee) || _.isNil(this.props.paidTillDate)*/{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-jobs-list-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.data)||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-jobs-list-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'bulk_jobs_list.no_bulk_consents_data_label')));}return[this.renderWarning(),this.renderTable()];}},{key:'renderTable',value:function renderTable(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["N" /* Table */],{className:'consent-requests-jobs-data-table',key:'consent-requests-jobs-data-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'consents.job_title_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'bulk_jobs_list.requestor_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'bulk_jobs_list.created_at_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'bulk_jobs_list.created_requests_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'bulk_jobs_list.processed_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'bulk_jobs_list.status_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.renderJobsData()));}},{key:'renderJobsData',value:function renderJobsData(){var _this2=this;//TODO: add money conversion if balance and pricing ara in different currencies (conversion is now available only for SysAdmin)
// let isDisabledRequestFlush = this.props.balance.amount < this.props.consentRequestFee.amount || moment(this.props.paidTillDate).isBefore(moment());
return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.props.data,function(jobData){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:jobData.id,className:'consent-requests-jobs-data-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'job-title-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'consents.job_title_label')+":"},jobData.jobTitle,jobData.jobReference?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'job-reference'},'(',jobData.jobReference,')'):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'requester-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'bulk_jobs_list.requestor_label')+":"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+jobData.requesterEmail},jobData.requesterEmail)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'created-at-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'bulk_jobs_list.created_at_label')+":"},jobData.createdAt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'created-requests-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'bulk_jobs_list.created_requests_label')+":"},jobData.createdConsentRequestsCount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'processed-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'bulk_jobs_list.processed_label')+":"},jobData.processedPersent,'% (',jobData.processedEntriesCount,'/',jobData.totalEntriesCount,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'status-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'bulk_jobs_list.status_label')+":"},_this2.getStatus(jobData)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'control-cell flush-icon-container'},jobData.error&&jobData.error===UNSUFFICIENT_BALANCE/*&& !isDisabledRequestFlush*/?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'flush-icon',icon:'play_circle_outline',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'bulk_jobs_list.flush_remaining_label'),onClick:_this2.handleFlushRemainingButtonClick(jobData.id)}):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'control-cell bulk-controls'},jobData.finished?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'job-remove-icon',icon:'trash',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button),onClick:_this2.handleRemoveBulk(jobData)}):null));});}},{key:'componentDidMount',value:function componentDidMount(){this.props.onLoadJobs();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.fetchJobsListTimeout(nextProps.data);}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(nextProps.groupId)&&nextProps.groupId!==this.props.groupId){this.props.onLoadJobs();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.timeout){clearTimeout(this.timeout);}}},{key:'fetchJobsListTimeout',value:function fetchJobsListTimeout(jobsData){var _this3=this;if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(jobsData)&&__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.some(jobsData,function(job){return!job.finished;})&&__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.timeout)){this.timeout=setTimeout(function(){_this3.props.onLoadJobs();_this3.timeout=null;},5000);}}}]);return BulkConsentRequestsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BulkConsentRequestsList.propTypes={loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,// balance: PropTypes.object,
// consentRequestFee: PropTypes.object,
// paidTillDate: PropTypes.string,
// onMount: PropTypes.func,
onLoadJobs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onRemoveBulk:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelRemoving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onResumeBulk:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (BulkConsentRequestsList);

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveBulkConsentRequestModal__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_consent_bulkConsentRequests__ = __webpack_require__(195);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["R" /* MODAL_REMOVE_BULK_CONSENT_REQUEST */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onBulkRemove:function onBulkRemove(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_consent_bulkConsentRequests__["e" /* onRemoveBulkConsentRequest */])(id));},onClose:function onClose(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RemoveBulkConsentRequestModal__["a" /* default */]));

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RemoveBulkConsentRequestModal_css__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RemoveBulkConsentRequestModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RemoveBulkConsentRequestModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveBulkConsentRequestModal=function(_Component){_inherits(RemoveBulkConsentRequestModal,_Component);function RemoveBulkConsentRequestModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveBulkConsentRequestModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveBulkConsentRequestModal.__proto__||Object.getPrototypeOf(RemoveBulkConsentRequestModal)).call.apply(_ref,[this].concat(args))),_this),_this.renderData=function(){var paramsList=[{key:"job-title",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'consents.job_title_label'),value:_this.props.data.jobTitle},{key:"requester",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_jobs_list.requestor_label'),value:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+_this.props.data.requesterEmail},_this.props.data.requesterEmail)},{key:"department",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].department_label),value:_this.getDepartmentData()},{key:"creates-at",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_jobs_list.created_at_label'),value:_this.props.data.createdAt},{key:"entries-number",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'bulk_jobs_list.entries_number_label'),value:_this.props.data.totalEntriesCount}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getDataRow)));},_this.getDepartmentData=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.data.departmentName+'\n',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+_this.props.data.departmentEmail},_this.props.data.departmentEmail));},_this.getDataRow=function(params){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(params.value)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container',key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},params.title,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{className:'modal-form-field-value-container'},params.value));},_this.handleRemove=function(e){e.preventDefault();_this.props.onBulkRemove(_this.props.data.id);_this.props.onClose();},_this.handleCancel=function(){_this.props.onClose();_this.props.onCancelRemoving();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveBulkConsentRequestModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'prior-consent-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'consents.remove_bulk_consent_requests')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bulk-consent-data-container'},this.renderData()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))));}}]);return RemoveBulkConsentRequestModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveBulkConsentRequestModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onBulkRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelRemoving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveBulkConsentRequestModal);

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CollapseWithArrow_css__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CollapseWithArrow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CollapseWithArrow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CollapseWithArrow=function(_Component){_inherits(CollapseWithArrow,_Component);function CollapseWithArrow(props){_classCallCheck(this,CollapseWithArrow);var _this=_possibleConstructorReturn(this,(CollapseWithArrow.__proto__||Object.getPrototypeOf(CollapseWithArrow)).call(this,props));_this.renderCollapseArrow=function(){var iconName="keyboard_arrow_"+(_this.state.isOpen?"down":"right");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__iconContainer_IconContainer__["a" /* default */],{onClick:_this.toggle,className:'collapse-with-arrow-icon',icon:iconName});};_this.toggle=function(){_this.setState({isOpen:!_this.state.isOpen});};_this.state={isOpen:false};return _this;}_createClass(CollapseWithArrow,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"collapse-with-arrow-container "+(this.props.className||"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapse-with-arrow-title-container',onClick:this.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'collapse-with-arrow-title'},this.props.title),this.renderCollapseArrow()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["i" /* Collapse */],{isOpen:this.state.isOpen},this.props.children));}}]);return CollapseWithArrow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CollapseWithArrow.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CollapseWithArrow);

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateAccreditationRequest__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_titleLangs__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_levels__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_applicantAccreditations_VIDs__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_account_userData__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_account_aliases__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_applicantAccreditations_accreditationRequests__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_accreditationRequestOrgData__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),additionalLangs:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_titleLangs__["c" /* getOptionalTitleLangsData */])(state),levels:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_levels__["c" /* getLevelsData */])(state),VIDs:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_applicantAccreditations_VIDs__["f" /* getVIDsData */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_location__["e" /* getCountriesData */])(state),email:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_account_userData__["f" /* getUserEmail */])(state),defaultAlias:Object(__WEBPACK_IMPORTED_MODULE_8__reducers_account_aliases__["l" /* getDefaultAliasData */])(state),organizations:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_accreditationRequestOrgData__["j" /* getOrgsSelectOptionsForRequests */])(state),accreditationGroups:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_accreditationRequestOrgData__["f" /* getAGsSelectOptionsForRequests */])(state),orgByDomain:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_accreditationRequestOrgData__["i" /* getOrgByDomainOption */])(state),countryByDomain:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_accreditationRequestOrgData__["g" /* getOrgByDomainCountryOption */])(state),orgNameByDomain:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_accreditationRequestOrgData__["h" /* getOrgByDomainNameOption */])(state),loadingOrgByDomain:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_accreditationRequestOrgData__["k" /* loadingOrgByDomain */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_12__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),AGError:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_accreditationRequestOrgData__["e" /* getAGsForRequestError */])(state),locationData:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_location__["g" /* getLocationData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGetAdditionalLangs:function onGetAdditionalLangs(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_titleLangs__["b" /* fetchGetTitleLangs */])());},onGetLevels:function onGetLevels(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_levels__["b" /* fetchGetLevels */])());},onGetVIDs:function onGetVIDs(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_applicantAccreditations_VIDs__["c" /* fetchGetVIDs */])());},onGetOrganizations:function onGetOrganizations(country,orgName){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_accreditationRequestOrgData__["d" /* fetchGetOrgsForRequest */])(country,orgName));},onGetAccreditationGroups:function onGetAccreditationGroups(orgId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_accreditationRequestOrgData__["b" /* fetchGetAGsForRequest */])(orgId));},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onCreate:function onCreate(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__reducers_applicantAccreditations_accreditationRequests__["h" /* onCreateAccreditationRequest */])(data));},onGetDefaultAlias:function onGetDefaultAlias(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__reducers_account_aliases__["e" /* fetchGetDefaultAlias */])());},onContinentSetByCountry:function onContinentSetByCountry(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_location__["i" /* setCurrentContinentByCountry */])(countryCode));},onGetOrgByDomain:function onGetOrgByDomain(domain){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_accreditationRequestOrgData__["c" /* fetchGetOrgByDomain */])(domain));},resetAccreditationGroups:function resetAccreditationGroups(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_accreditationRequestOrgData__["l" /* resetAccreditationGroups */])());},resetOrganization:function resetOrganization(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_accreditationRequestOrgData__["m" /* resetOrganization */])());},onOpenErrorModal:function onOpenErrorModal(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_11__reducers_common_activeModal__["a" /* MODAL_ACCREDITATION_REQUESTS_GET_ORG_ERROR */]}));},resetOrganizations:function resetOrganizations(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_applicantAccreditations_accreditationRequestOrgData__["n" /* resetOrganizations */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CreateAccreditationRequest__["a" /* default */]));

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateAccreditationRequest_css__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateAccreditationRequest_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CreateAccreditationRequest_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_datepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__accreditationManagement_additionalTitle_AdditionalTitle_container__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_uuid__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__accreditationRequestGetOrgErrorModal_AccreditationRequestGetOrgErrorModal_container__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonComponents_domainInput_DomainInput__ = __webpack_require__(63);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var requiredSelectFields=['orgContinent','orgCountry','orgId','accreditationGroupId','level','VID','personContinent','personCountry'];var INPUT_MODE={MANUAL_INPUT:'manual_input',SELECT_INPUT:'select_input'};var CreateAccreditationRequest=function(_Component){_inherits(CreateAccreditationRequest,_Component);function CreateAccreditationRequest(props){_classCallCheck(this,CreateAccreditationRequest);var _this=_possibleConstructorReturn(this,(CreateAccreditationRequest.__proto__||Object.getPrototypeOf(CreateAccreditationRequest)).call(this,props));_this.renderContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["n" /* Form */],{className:'create-accreditation-request-form',onSubmit:_this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'create-accreditation-request-subtitle before-hint olive-green'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'organization-hint'},__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.create_accreditation_request_hint'))),_this.renderMenu('orgInputMode'),_this.renderCountrySelect(),_this.renderOrgFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["i" /* Collapse */],{isOpen:_this.state.orgInputMode===INPUT_MODE.SELECT_INPUT&&_this.state.hasAccreditationGroups},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'create-accreditation-request-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].accreditation_group_label)),_this.renderAccreditationGroupFormGroup()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'create-accreditation-request-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_label')),_this.renderTitlesFormGroups(),_this.renderAccreditationFormGroups(),_this.renderAdditionalTitlesFormGroups(),_this.renderAccreditationCheckboxFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'create-accreditation-request-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.vid_label')),_this.renderVIDFormGroup(),_this.renderExposeCheckbox(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].add_button))));};_this.renderCountrySelect=function(){if(_this.state.orgInputMode===INPUT_MODE.SELECT_INPUT){var paramsList=[{value:"orgContinent",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),isDisabled:!_this.props.continents,onChange:_this.handleChangeOrgContinent},{value:"orgCountry",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.locationData[_this.state.orgContinent],__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isDisabled:!_this.props.continents,onChange:_this.handleChangeOrgCountry}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(paramsList,_this.getSelectFormGroup)));}};_this.renderOrgFormGroup=function(){var selectInputParams={value:"orgId",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].org_label),content:_this.props.organizations||[],placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)),isDisabled:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(_this.state.orgCountry)||__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(_this.props.organizations)||_this.props.loadingOrgByDomain,isRequired:_this.state.orgInputMode===INPUT_MODE.SELECT_INPUT,onInputChange:_this.handleSelectInputChange,onChange:_this.handleChangeOrgId};var manualInputParamsList=[{value:"orgContinent",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),isDisabled:!_this.props.continents,isRequired:_this.state.orgInputMode===INPUT_MODE.MANUAL_INPUT},{value:"orgCountry",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.locationData[_this.state.orgContinent],__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isDisabled:!_this.props.continents,isRequired:_this.state.orgInputMode===INPUT_MODE.MANUAL_INPUT},{value:"orgDomain",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label)+'*',isRequired:_this.state.orgInputMode===INPUT_MODE.MANUAL_INPUT,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label),isDisabled:_this.props.loadingOrgByDomain,onBlur:_this.getOrgByDomain,popoverHintParams:{hintText:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.domain_hint')}},{value:"orgName",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,"orgs.name_label"),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,"orgs.name_label")}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["p" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["i" /* Collapse */],{isOpen:_this.state.orgInputMode===INPUT_MODE.SELECT_INPUT},_this.state.orgInputMode===INPUT_MODE.SELECT_INPUT?_this.getSelectFormGroup(selectInputParams):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["i" /* Collapse */],{isOpen:_this.state.orgInputMode===INPUT_MODE.MANUAL_INPUT},_this.state.orgInputMode===INPUT_MODE.MANUAL_INPUT?[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(manualInputParamsList,_this.getFormGroup))):null));};_this.renderAccreditationGroupFormGroup=function(){var selectInputParams={value:"accreditationGroupId",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].accreditation_group_label),content:_this.props.accreditationGroups||[],placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].accreditation_group_label),isDisabled:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(_this.state.orgId)&&__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(_this.state.orgDomain),isRequired:_this.state.orgInputMode===INPUT_MODE.SELECT_INPUT&&_this.state.hasAccreditationGroups&&_this.state.accreditationGroupInputMode===INPUT_MODE.SELECT_INPUT,popoverHintParams:{hintText:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.accreditation_group_hint')}};var manualInputParams={value:"accreditationGroupName",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'org_staff.accreditation_groups.accreditation_group_name_label'),isRequired:_this.state.orgInputMode===INPUT_MODE.SELECT_INPUT&&_this.state.hasAccreditationGroups&&_this.state.accreditationGroupInputMode===INPUT_MODE.MANUAL_INPUT,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'org_staff.accreditation_groups.accreditation_group_name_label'),isDisabled:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(_this.state.orgId)&&__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(_this.state.orgDomain),popoverHintParams:{hintText:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.accreditation_group_hint')}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["p" /* FormGroup */],null,_this.renderMenu('accreditationGroupInputMode'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["i" /* Collapse */],{isOpen:_this.state.accreditationGroupInputMode===INPUT_MODE.SELECT_INPUT},_this.state.accreditationGroupInputMode===INPUT_MODE.SELECT_INPUT?_this.getSelectFormGroup(selectInputParams):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["i" /* Collapse */],{isOpen:_this.state.accreditationGroupInputMode===INPUT_MODE.MANUAL_INPUT},_this.state.accreditationGroupInputMode===INPUT_MODE.MANUAL_INPUT?_this.getFormGroup(manualInputParams):null));};_this.renderTitlesFormGroups=function(){var paramsList=[{value:"titleOrig",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_orig_label'),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_orig_input_placeholder')},{value:"titleEn",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_en_label'),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_en_input_placeholder')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderAccreditationFormGroups=function(){var params={value:"level",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.level_label'),isDisabled:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(_this.props.levels),content:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getLevelsOptions(_this.props.levels,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'levels')),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.level_input_placeholder'),isRequired:true};return[_this.renderDateIssued(),_this.getSelectFormGroup(params)];};_this.renderAccreditationCheckboxFormGroup=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["p" /* FormGroup */],{className:'checkbox-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["L" /* Row */],{className:'checkbox-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["v" /* Label */],{className:'checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["r" /* Input */],{type:'checkbox',checked:_this.state.accreditationConsent,required:true,onChange:_this.toggleConsentCheckbox}),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.applicant_accreditation_consent_label'))));};_this.toggleConsentCheckbox=function(){_this.setState({accreditationConsent:!_this.state.accreditationConsent});};_this.renderAdditionalTitlesFormGroups=function(){var title=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'additional-langs-title',key:'additional-langs-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.additional_translations_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'add-additional-lang-icon olive-green',icon:'add',onClick:_this.addAdditionalTitle,title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.add_additional_translations_label')}));var result=[title];_this.state.titlesAdditional.forEach(function(elem){result.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__accreditationManagement_additionalTitle_AdditionalTitle_container__["a" /* default */],{key:elem.id,id:elem.id,lang:elem.lang,title:elem.title,langs:_this.getAvailableLang(elem.id),onChangeLang:_this.handleChangeAdditionalTitleLang,onChangeTitle:_this.handleChangeAdditionalTitle,onRemove:_this.removeAdditionalTitle,required:true,requiredFieldError:_this.state.requiredFieldError===elem.id}));});return result;};_this.renderDateIssued=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["p" /* FormGroup */],{row:true,key:'date-issued'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["v" /* Label */],{'for':'date-issued',sm:3},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.date_issued_label'),'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_datepicker__["a" /* default */],{customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["r" /* Input */],{id:'date-issued'}),selected:_this.state.dateIssued,showMonthDropdown:true,showYearDropdown:true,dropdownMode:'select',required:true,onChange:_this.handleChangeDate,maxDate:__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()()})));};_this.renderVIDFormGroup=function(){var selectInputParams={value:"VID",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.vid_label'),content:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(_this.props.VIDs,function(VID){return{code:VID.id,name:VID.firstName+' '+VID.lastName+', '+VID.nationalId};})),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.vid_label'),isDisabled:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(_this.props.VIDs),isRequired:_this.state.VIDInputMode===INPUT_MODE.SELECT_INPUT,menuPlacement:'top'};var manualInputParamsList=[{value:"personFirstName",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)},{value:"personLastName",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)},{value:"nationalId",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].national_id_label),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].national_id_label),popoverHintParams:{hintText:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.national_id_hint')}},{value:"personContinent",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),onChange:_this.handleChangeContinent,isRequired:true,isDisabled:!_this.props.continents,menuPlacement:'top'},{value:"personCountry",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isRequired:true,isDisabled:!_this.props.countries,menuPlacement:'top'}];var emailParams={value:_this.props.email,title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["p" /* FormGroup */],null,_this.renderMenu('VIDInputMode'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["i" /* Collapse */],{isOpen:_this.state.VIDInputMode===INPUT_MODE.SELECT_INPUT},_this.state.VIDInputMode===INPUT_MODE.SELECT_INPUT?_this.getSelectFormGroup(selectInputParams):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["i" /* Collapse */],{isOpen:_this.state.VIDInputMode===INPUT_MODE.MANUAL_INPUT},_this.state.VIDInputMode===INPUT_MODE.MANUAL_INPUT?[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(manualInputParamsList,_this.getFormGroup))):null),_this.getDataRow(emailParams));};_this.renderMenu=function(fieldKey){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-mode-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"input-mode-icon-container"+(_this.state[fieldKey]===INPUT_MODE.SELECT_INPUT?" olive-green":""),onClick:_this.handleToggleMenu(fieldKey,INPUT_MODE.SELECT_INPUT)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'input-mode-icon',icon:"radio_button_"+(_this.state[fieldKey]===INPUT_MODE.SELECT_INPUT?"checked":"unchecked"),title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'request_credentials_verification.manual_input_label')}),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.select_'+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.snakeCase(fieldKey)+'_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"input-mode-icon-container"+(_this.state[fieldKey]===INPUT_MODE.MANUAL_INPUT?" olive-green":""),onClick:_this.handleToggleMenu(fieldKey,INPUT_MODE.MANUAL_INPUT)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'input-mode-icon',icon:"radio_button_"+(_this.state[fieldKey]===INPUT_MODE.MANUAL_INPUT?"checked":"unchecked"),title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'request_credentials_verification.upload_file_label')}),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.manual_'+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.snakeCase(fieldKey)+'_label')));};_this.getDataRow=function(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["L" /* Row */],{className:'org-settings-row',key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["h" /* Col */],{sm:3},params.title,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["h" /* Col */],null,params.value));};_this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this.renderHintPopover(params.value,params.popoverHintParams),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];}),options:params.content,onSelect:params.onChange||_this.handleChangeSelect(params.value),placeholder:params.placeholder,disabled:params.isDisabled,isSearchable:true,menuPlacement:params.menuPlacement,requiredFieldError:params.isRequired&&_this.state.requiredFieldError===params.value,onInputChange:params.onInputChange})));};_this.getFormGroup=function(params){if(params.type==='dataRow'){return _this.getDataRow(params);}if(params.value==='orgDomain'){return _this.getOrganizationDomainFormGroup(params);}if(params.type==='select'){return _this.getSelectFormGroup(params);}if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this.renderHintPopover(params.value,params.popoverHintParams),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.state,params.value),onChange:params.onChange||_this.handleChange(params.value),placeholder:params.placeholder,disabled:params.isDisabled,required:params.isRequired,onBlur:params.onBlur},params.content)));};_this.getOrganizationDomainFormGroup=function(params){var id=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__commonComponents_domainInput_DomainInput__["a" /* default */],{id:id,value:_this.state[params.value],onChange:_this.handleChangeDomainInput,onBlur:params.onBlur,placeholder:params.placeholder||params.title,disabled:params.isDisabled,required:params.isRequired})));};_this.renderHintPopover=function(fieldName,params){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(params)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:fieldName+'-hint',className:'hint-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["Q" /* UncontrolledPopover */],{trigger:'legacy',placement:'bottom',target:fieldName+'-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["I" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(params.hintText)))));}};_this.handleToggleMenu=function(fieldKey,value){return function(){var _this$setState,_this$setState2,_this$setState3;switch(fieldKey){case'orgInputMode':_this.props.resetOrganization();_this.setState((_this$setState={},_defineProperty(_this$setState,fieldKey,value),_defineProperty(_this$setState,'orgId',''),_defineProperty(_this$setState,'orgContinent',''),_defineProperty(_this$setState,'orgCountry',''),_defineProperty(_this$setState,'orgDomain',''),_defineProperty(_this$setState,'orgName',''),_defineProperty(_this$setState,'requiredFieldError',null),_this$setState));break;case'accreditationGroupInputMode':_this.setState((_this$setState2={},_defineProperty(_this$setState2,fieldKey,value),_defineProperty(_this$setState2,'accreditationGroupName',''),_defineProperty(_this$setState2,'accreditationGroupId',''),_defineProperty(_this$setState2,'requiredFieldError',null),_this$setState2));break;case'VIDInputMode':_this.setState((_this$setState3={},_defineProperty(_this$setState3,fieldKey,value),_defineProperty(_this$setState3,'VID',null),_defineProperty(_this$setState3,'requiredFieldError',null),_defineProperty(_this$setState3,'firstName',''),_defineProperty(_this$setState3,'lastName',''),_defineProperty(_this$setState3,'personContinent',_this.props.continentCode),_defineProperty(_this$setState3,'personCountry',''),_defineProperty(_this$setState3,'nationalId',''),_this$setState3));break;default:break;}};};_this.renderExposeCheckbox=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["p" /* FormGroup */],{className:'checkbox-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["L" /* Row */],{className:'checkbox-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["v" /* Label */],{className:'checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["r" /* Input */],{type:'checkbox',checked:_this.state.expose,onChange:_this.toggleExposeCheckbox}),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.expose_accreditation_request_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'create-accreditation-request-expose-icon-container',className:'create-accreditation-request-expose-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["Q" /* UncontrolledPopover */],{placement:'bottom',trigger:'legacy',target:'create-accreditation-request-expose-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["I" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.expose_hint')))));};_this.handleChangeDate=function(date){_this.setState({dateIssued:date});};_this.toggleExposeCheckbox=function(){_this.setState({expose:!_this.state.expose});};_this.handleChangeOrgId=function(selectedOption){_this.setState({orgId:selectedOption.value,hasAccreditationGroups:!selectedOption.bavaManaged});};_this.handleChangeOrgContinent=function(selectedOption){_this.setState({orgContinent:selectedOption.value,orgCountry:'',orgId:'',hasAccreditationGroups:true});_this.props.resetOrganizations();};_this.handleChangeOrgCountry=function(selectedOption){_this.setState({orgCountry:selectedOption.value,orgId:'',hasAccreditationGroups:true});if(_this.state.orgName!==''){_this.props.onGetOrganizations(selectedOption.value,_this.state.orgName);}else{_this.props.onGetOrganizations(selectedOption.value);}};_this.handleChangeSelect=function(fieldKey){return function(selectedOption){_this.setState(_defineProperty({},fieldKey,selectedOption.value));};};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleChangeDomainInput=function(data){_this.setState({orgDomain:data});};_this.handleChangeAdditionalTitle=function(id){return function(e){var newTitles=_this.state.titlesAdditional.map(function(elem){if(elem.id===id)elem.title=e.target.value;return elem;});_this.setState({titlesAdditional:newTitles});};};_this.handleChangeAdditionalTitleLang=function(id,value){var newTitles=_this.state.titlesAdditional.map(function(elem){if(elem.id===id)elem.lang=value;return elem;});_this.setState({titlesAdditional:newTitles});};_this.handleChangeContinent=function(selectedOption){_this.setState({personCountry:''});_this.props.onContinentSet(selectedOption.value);};_this.addAdditionalTitle=function(){var newTitle={id:__WEBPACK_IMPORTED_MODULE_13_uuid___default()(),lang:'',title:''};_this.setState({titlesAdditional:[].concat(_toConsumableArray(_this.state.titlesAdditional),[newTitle])});};_this.removeAdditionalTitle=function(id){return function(){var newTitles=_this.state.titlesAdditional.filter(function(elem){return elem.id!==id;});_this.setState({titlesAdditional:newTitles});};};_this.getOrgByDomain=function(data){_this.setState({orgDomain:data},function(){_this.props.onGetOrgByDomain(_this.state.orgDomain);_this.setState({orgId:''});});};_this.handleSelectInputChange=function(value){_this.setState({orgIdInput:value});};_this.handleSubmit=function(e){e.preventDefault();if(_this.checkRequiredSelectFields()){return;}var titles={original:_this.state.titleOrig,en:_this.state.titleEn};_this.state.titlesAdditional.forEach(function(elem){if(elem.lang!=="")titles[elem.lang]=elem.title;});var data={accreditationData:{titles:titles,issuedAt:_this.state.dateIssued.format("YYYY-MM-DD"),level:_this.state.level},expose:_this.state.expose};switch(_this.state.orgInputMode){case INPUT_MODE.MANUAL_INPUT:data.orgDomain=_this.state.orgDomain;data.orgName=_this.state.orgName;data.countryCode=_this.state.orgCountry;break;case INPUT_MODE.SELECT_INPUT:data.orgId=_this.state.orgId;break;default:break;}switch(_this.state.accreditationGroupInputMode){case INPUT_MODE.MANUAL_INPUT:data.accreditationGroupName=_this.state.accreditationGroupName;break;case INPUT_MODE.SELECT_INPUT:data.accreditationGroupId=_this.state.accreditationGroupId;break;default:break;}switch(_this.state.VIDInputMode){case INPUT_MODE.SELECT_INPUT:data.verifiedIdentity=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(_this.props.VIDs,function(vid){return vid.id===_this.state.VID;});break;case INPUT_MODE.MANUAL_INPUT:data.verifiedIdentity={firstName:_this.state.personFirstName,lastName:_this.state.personLastName,countryCode:_this.state.personCountry,nationalId:_this.state.nationalId};break;default:break;}_this.props.onCreate(data);};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(requiredSelectFields,function(field){if(!_this.state[field]&&!error){switch(field){case'orgContinent':if(_this.state.orgInputMode===INPUT_MODE.MANUAL_INPUT){error=field;}break;case'orgCountry':if(_this.state.orgInputMode===INPUT_MODE.MANUAL_INPUT){error=field;}break;case'orgId':if(_this.state.orgInputMode===INPUT_MODE.SELECT_INPUT){error=field;}break;case'accreditationGroupId':if(_this.state.orgInputMode===INPUT_MODE.SELECT_INPUT&&_this.state.hasAccreditationGroups&&_this.state.accreditationGroupInputMode===INPUT_MODE.SELECT_INPUT){error=field;}break;case'VID':if(_this.state.VIDInputMode===INPUT_MODE.SELECT_INPUT){error=field;}break;case'personCountry':if(_this.state.VIDInputMode===INPUT_MODE.MANUAL_INPUT){error=field;}break;case'personContinent':if(_this.state.VIDInputMode===INPUT_MODE.MANUAL_INPUT){error=field;}break;default:error=field;break;}}});__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(_this.state.titlesAdditional,function(title){if(title.lang===''&&!error){error=title.id;}});_this.setState({requiredFieldError:error});return error;};_this.resetData=function(){_this.setState({orgCountry:'',orgId:'',orgDomain:'',orgName:'',orgInputMode:INPUT_MODE.SELECT_INPUT,accreditationGroupName:'',accreditationGroupId:'',accreditationGroupInputMode:INPUT_MODE.MANUAL_INPUT,titleOrig:'',titleEn:'',titlesAdditional:[],dateIssued:__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(),level:'',VIDInputMode:INPUT_MODE.SELECT_INPUT,VID:null,personFirstName:'',personLastName:'',personContinent:_this.props.continentCode,personCountry:'',nationalId:'',expose:false,requiredFieldError:null,hasAccreditationGroups:true});};_this.state={orgContinent:'',orgCountry:'',orgId:'',orgDomain:'',orgName:'',orgInputMode:INPUT_MODE.SELECT_INPUT,accreditationGroupName:'',accreditationGroupId:'',accreditationGroupInputMode:INPUT_MODE.MANUAL_INPUT,titleOrig:'',titleEn:'',titlesAdditional:[],dateIssued:__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(),level:'',VIDInputMode:INPUT_MODE.SELECT_INPUT,VID:null,personFirstName:'',personLastName:'',personContinent:_this.props.continentCode,personCountry:'',nationalId:'',expose:false,requiredFieldError:null,accreditationConsent:false,hasAccreditationGroups:true,orgIdInput:''};return _this;}_createClass(CreateAccreditationRequest,[{key:'componentWillMount',value:function componentWillMount(){this.props.onGetLevels();this.props.onGetAdditionalLangs();this.props.onGetVIDs();this.props.onGetDefaultAlias();}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){if(!this.props.AGError&&nextProps.AGError==="ORGANIZATION_ACCREDITATION_FLOW_FORBIDDEN"){this.props.onOpenErrorModal();}if(this.state.VIDInputMode===INPUT_MODE.SELECT_INPUT&&nextState.VIDInputMode===INPUT_MODE.MANUAL_INPUT&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(nextProps.defaultAlias)){this.setState({personFirstName:nextProps.defaultAlias.firstName,personLastName:nextProps.defaultAlias.lastName,personCountry:nextProps.defaultAlias.countryCode});this.props.onContinentSetByCountry(nextProps.defaultAlias.countryCode);}if(nextProps.continentCode!==this.props.continentCode){this.setState({personContinent:nextProps.continentCode});}if(this.state.orgIdInput!==nextState.orgIdInput){this.props.onGetOrganizations(this.state.orgCountry,nextState.orgIdInput);}if(this.state.orgId!==nextState.orgId&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(nextState.orgId)){this.props.onGetAccreditationGroups(nextState.orgId);}if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(this.props.orgByDomain)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(nextProps.orgByDomain)){this.setState({orgContinent:nextProps.countryByDomain.continent,orgCountry:nextProps.countryByDomain.countryCode,orgId:nextProps.orgByDomain,orgName:nextProps.orgNameByDomain});this.props.onGetOrganizations(nextProps.countryByDomain.countryCode);}if(this.state.orgInputMode===INPUT_MODE.SELECT_INPUT&&nextState.orgInputMode===INPUT_MODE.MANUAL_INPUT){this.props.resetAccreditationGroups();}if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(this.props.accreditationGroups)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(nextProps.accreditationGroups)&&nextProps.accreditationGroups.length!==0){this.setState({accreditationGroupInputMode:INPUT_MODE.SELECT_INPUT});}if(!this.props.success&&nextProps.success){this.resetData();}if((!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual(this.props.organizations,nextProps.organizations)||!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual(nextProps.orgByDomain,this.props.orgByDomain))&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(nextProps.organizations)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(nextProps.orgByDomain)&&__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(nextProps.organizations,function(option){return option.value===nextProps.orgByDomain;})){var org=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(nextProps.organizations,function(option){return option.value===nextProps.orgByDomain;});this.setState({orgInputMode:INPUT_MODE.SELECT_INPUT,hasAccreditationGroups:org?!org.bavaManaged:true});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'create-accreditation-request-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'accreditation_requests.create_accreditation_request_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/accreditation-requests-list',label:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].back_button)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'accreditation_requests.create_accreditation_request_label')),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__accreditationRequestGetOrgErrorModal_AccreditationRequestGetOrgErrorModal_container__["a" /* default */],null)));}},{key:'getAvailableLang',value:function getAvailableLang(id){var disabledLangs=this.state.titlesAdditional.filter(function(elem){return elem.id!==id;}).map(function(elem){return elem.lang;});return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(this.props.additionalLangs).filter(function(lang){return!disabledLangs.includes(lang);});}}]);return CreateAccreditationRequest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CreateAccreditationRequest.propTypes={translation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,additionalLangs:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,levels:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,VIDs:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,continentCode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,email:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,defaultAlias:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,organizations:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,accreditationGroups:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,orgByDomain:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,countryByDomain:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,orgNameByDomain:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,loadingOrgByDomain:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,AGError:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,onGetAdditionalLangs:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onGetLevels:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onGetVIDs:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onContinentSet:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onCreate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onGetDefaultAlias:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onContinentSetByCountry:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onGetOrganizations:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onGetAccreditationGroups:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onGetOrgByDomain:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,resetAccreditationGroups:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,resetOrganization:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onOpenErrorModal:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,resetOrganizations:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CreateAccreditationRequest);

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccreditationRequestGetOrgErrorModal__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_applicantAccreditations_accreditationRequestOrgData__ = __webpack_require__(196);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["a" /* MODAL_ACCREDITATION_REQUESTS_GET_ORG_ERROR */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onClose:function onClose(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_applicantAccreditations_accreditationRequestOrgData__["l" /* resetAccreditationGroups */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__AccreditationRequestGetOrgErrorModal__["a" /* default */]));

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccreditationRequestGetOrgErrorModal_css__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccreditationRequestGetOrgErrorModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AccreditationRequestGetOrgErrorModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccreditationRequestGetOrgErrorModal=function(_Component){_inherits(AccreditationRequestGetOrgErrorModal,_Component);function AccreditationRequestGetOrgErrorModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AccreditationRequestGetOrgErrorModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AccreditationRequestGetOrgErrorModal.__proto__||Object.getPrototypeOf(AccreditationRequestGetOrgErrorModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.onClose();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AccreditationRequestGetOrgErrorModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'accreditation-request-get-org-error-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],{className:'accreditation-request-get-org-error-modal-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{className:'accreditation-request-get-org-error-modal-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"accreditation_requests.org_by_domain_error_alert")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{className:'accreditation-request-get-org-error-modal-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'carrot-red-btn',onClick:this.handleClose},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].okey_button))))));}}]);return AccreditationRequestGetOrgErrorModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AccreditationRequestGetOrgErrorModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (AccreditationRequestGetOrgErrorModal);

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccreditationRequestsList__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_applicantAccreditations_accreditationRequests__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_applicantAccreditations_accreditationRequest__ = __webpack_require__(144);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_applicantAccreditations_accreditationRequests__["g" /* loadingAccreditationRequests */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_applicantAccreditations_accreditationRequests__["f" /* getAccreditationRequestsData */])(state),accreditationRequest:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_applicantAccreditations_accreditationRequest__["c" /* getAccreditationRequestDataFormatted */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_applicantAccreditations_accreditationRequests__["e" /* fetchGetAccreditationRequests */])());},onAccreditationRequestRemove:function onAccreditationRequestRemove(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["L" /* MODAL_REMOVE_ACCREDITATION_REQUEST */]}));},onUpdate:function onUpdate(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_applicantAccreditations_accreditationRequest__["f" /* onUpdateAccreditationRequest */])(id,data,false));},onGetAccreditationRequestData:function onGetAccreditationRequestData(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_applicantAccreditations_accreditationRequest__["b" /* fetchAccreditationRequestById */])(id));},onShowAccreditationRequestModal:function onShowAccreditationRequestModal(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["d" /* MODAL_ACCREDITATION_REQUEST_DATA */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__AccreditationRequestsList__["a" /* default */]));

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccreditationRequestsList_css__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccreditationRequestsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AccreditationRequestsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__removeAccreditationRequetsModal_RemoveAccreditationRequestModal_container__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reducers_applicantAccreditations_accreditationRequests__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__accreditationRequestDataModal_AccreditationRequestDataModal_container__ = __webpack_require__(1031);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _STATUS_COLOR;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var STATUS_COLOR=(_STATUS_COLOR={},_defineProperty(_STATUS_COLOR,__WEBPACK_IMPORTED_MODULE_11__reducers_applicantAccreditations_accreditationRequests__["c" /* REQUEST_SUBMITTED */],"secondary"),_defineProperty(_STATUS_COLOR,__WEBPACK_IMPORTED_MODULE_11__reducers_applicantAccreditations_accreditationRequests__["b" /* REQUEST_REJECTED */],"danger"),_defineProperty(_STATUS_COLOR,__WEBPACK_IMPORTED_MODULE_11__reducers_applicantAccreditations_accreditationRequests__["a" /* REQUEST_IN_PROCESS */],"warning"),_STATUS_COLOR);var SUCCESS_MESSAGE_BY_ACTION={EDIT:'accreditation_requests.edit_accreditation_request_success_message',REMOVE:'accreditation_requests.remove_accreditation_request_success_message'};var AccreditationRequestsList=function(_Component){_inherits(AccreditationRequestsList,_Component);function AccreditationRequestsList(props){_classCallCheck(this,AccreditationRequestsList);var _this=_possibleConstructorReturn(this,(AccreditationRequestsList.__proto__||Object.getPrototypeOf(AccreditationRequestsList)).call(this,props));_this.renderTable=function(){if(_this.props.loading&&(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-requests-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-requests-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.accreditation_requests_no_data_label')));}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-requests-list-relative-header',key:'accreditation-requests-list-relative-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.expose_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["N" /* Table */],{className:'accreditation-requests-list-table',key:'accreditation-requests-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.status_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.organization_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].accreditation_group_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_list.level_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.created_at_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'expose-th'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.expose_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderAccreditationRequestsData()))];};_this.renderAccreditationRequestsData=function(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(_this.props.data,function(request,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'accreditation-requests-list-row',key:index,onClick:_this.handleRowClick(request)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'status-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.status_label')+':'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Badge */],{color:STATUS_COLOR[request.status]},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.status.'+request.status))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'org-name-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.organization_label')+':'},request.orgName,' (',request.orgDomain,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'accreditation-group-name-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].accreditation_group_label)+':'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(request.managingOrganizationId)?request.accreditationGroupName:null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'level-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_list.level_label')+':'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels.'+request.accreditationData.level)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'created-at-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.created_at_label')+':'},__WEBPACK_IMPORTED_MODULE_12_moment___default()(request.createdAt).format('LL')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'expose-icon-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:request.expose?'check_box':'check_box_outline_blank',key:request.id+'-expose',onClick:_this.handleChangeExpose(request),className:'expose-accreditation-request-icon'+(request.expose?' exposed':' not-exposed')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'edit-icon-td'},request.status===__WEBPACK_IMPORTED_MODULE_10__constants_constants__["a" /* ACCREDITATION_REQUEST_STATUSES */].REQUEST_SUBMITTED&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(request.orgId)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(request.accreditationGroupId)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'create',key:request.id+'-create',className:'edit-accreditation-request-icon',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.edit_accreditation_request_label')}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'visibility',key:request.id+'-visibility',className:'edit-accreditation-request-icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'remove-icon-td',onClick:_this.handleRemoveIconClick(request)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'trash',key:request.id+'-trash',className:'trash-accreditation-request-icon',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.remove_accreditation_request_label')})));});};_this.handleAddButtonClick=function(){_this.setState({redirect:true});};_this.handleRowClick=function(request){return function(){if(request.status===__WEBPACK_IMPORTED_MODULE_10__constants_constants__["a" /* ACCREDITATION_REQUEST_STATUSES */].REQUEST_SUBMITTED&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(request.orgId)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(request.accreditationGroupId)){_this.setState({selectedAccreditationRequestId:request.id});}else{_this.props.onGetAccreditationRequestData(request.id);}};};_this.handleRemoveIconClick=function(data){return function(e){e.stopPropagation();_this.setState({accreditationRequestToRemove:data,successMessage:SUCCESS_MESSAGE_BY_ACTION.REMOVE});_this.props.onAccreditationRequestRemove();};};_this.handleCloseModal=function(){_this.setState({accreditationRequestToRemove:null});};_this.handleChangeExpose=function(data){return function(e){e.stopPropagation();_this.setState({successMessage:SUCCESS_MESSAGE_BY_ACTION.EDIT});_this.props.onUpdate(data.id,{expose:!data.expose});};};_this.state={redirect:false,selectedAccreditationRequestId:null,accreditationRequestToRemove:null,successMessage:null};return _this;}_createClass(AccreditationRequestsList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.accreditationRequest)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(nextProps.accreditationRequest)){this.props.onShowAccreditationRequestModal();}}},{key:'render',value:function render(){if(this.state.redirect){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["d" /* Redirect */],{to:'/create-accreditation-request',push:true});}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.state.selectedAccreditationRequestId)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["d" /* Redirect */],{to:'/edit-accreditation-request?id='+this.state.selectedAccreditationRequestId,push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-request-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,this.state.successMessage)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation_requests.accreditation_requests_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-accreditation-request-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleAddButtonClick},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].add_button))),this.renderTable(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__removeAccreditationRequetsModal_RemoveAccreditationRequestModal_container__["a" /* default */],{data:this.state.accreditationRequestToRemove,onCancelRemoving:this.handleCloseModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__accreditationRequestDataModal_AccreditationRequestDataModal_container__["a" /* default */],{data:this.props.accreditationRequest})));}}]);return AccreditationRequestsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AccreditationRequestsList.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,accreditationRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onAccreditationRequestRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onUpdate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetAccreditationRequestData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onShowAccreditationRequestModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AccreditationRequestsList);

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveAccreditationRequestModal__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_applicantAccreditations_accreditationRequest__ = __webpack_require__(144);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["L" /* MODAL_REMOVE_ACCREDITATION_REQUEST */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAccreditationRequestRemove:function onAccreditationRequestRemove(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_applicantAccreditations_accreditationRequest__["e" /* onRemoveAccreditationRequest */])(id));},onClose:function onClose(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RemoveAccreditationRequestModal__["a" /* default */]));

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveAccreditationRequestModal=function(_Component){_inherits(RemoveAccreditationRequestModal,_Component);function RemoveAccreditationRequestModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveAccreditationRequestModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveAccreditationRequestModal.__proto__||Object.getPrototypeOf(RemoveAccreditationRequestModal)).call.apply(_ref,[this].concat(args))),_this),_this.renderData=function(){var paramsList=[{key:"status",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'accreditation_requests.status_label'),value:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'accreditation_requests.status.'+_this.props.data.status)},{key:"orgName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,"accreditation_requests.organization_label"),value:_this.props.data.orgName+' ('+_this.props.data.orgDomain+')'},{key:"accreditationGroupName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'org_staff.accreditation_groups.accreditation_group_name_label'),value:_this.props.data.accreditationGroupName},{key:"level",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'accreditation.level_label'),value:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'levels.'+_this.props.data.accreditationData.level)},{key:"createdAt",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'accreditation_requests.created_at_label'),value:__WEBPACK_IMPORTED_MODULE_5_moment___default()(_this.props.data.createdAt).format('LL')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getDataRow)));},_this.getDataRow=function(params){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(params.value)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container',key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,params.value));},_this.handleRemove=function(e){e.preventDefault();_this.props.onAccreditationRequestRemove(_this.props.data.id);_this.props.onClose();},_this.handleCancel=function(){_this.props.onClose();_this.props.onCancelRemoving();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveAccreditationRequestModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'accreditation-request-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_requests.accreditation_request_remove_alert')),this.renderData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))));}}]);return RemoveAccreditationRequestModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveAccreditationRequestModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onAccreditationRequestRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelRemoving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveAccreditationRequestModal);

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccreditationRequestDataModal__ = __webpack_require__(1032);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["d" /* MODAL_ACCREDITATION_REQUEST_DATA */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onClose:function onClose(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__AccreditationRequestDataModal__["a" /* default */]));

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccreditationRequestDataModal_css__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccreditationRequestDataModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AccreditationRequestDataModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccreditationRequestDataModal=function(_Component){_inherits(AccreditationRequestDataModal,_Component);function AccreditationRequestDataModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AccreditationRequestDataModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AccreditationRequestDataModal.__proto__||Object.getPrototypeOf(AccreditationRequestDataModal)).call.apply(_ref,[this].concat(args))),_this),_this.renderOrgData=function(){var paramsList=[{key:'orgName',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,"orgs.name_label"),value:_this.props.data.orgName},{key:'orgDomain',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label),value:_this.props.data.orgDomain}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getDataRow)));},_this.renderAccreditationGroupData=function(){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.data.managingOrganizationId)){return null;}var params={key:'accreditationGroupName',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'org_staff.accreditation_groups.accreditation_group_name_label'),value:_this.props.data.accreditationGroupName};return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].accreditation_group_label)),_this.getDataRow(params)];},_this.renderAccreditationOriginalTitle=function(){var paramsList=[{key:'titleOrig',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_orig_label'),value:_this.props.data.titleOrig},{key:'titleEn',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_en_label'),value:_this.props.data.titleEn}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getDataRow)));},_this.renderAccreditationAdditionalTitles=function(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(_this.props.data.titlesAdditional).length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'accreditation.additional_translations_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.chain(_this.props.data.titlesAdditional).mapValues(function(title,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{key:key},'(',__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'langs.'+key),') ',title);}).values().value()));},_this.renderAccreditationData=function(){var paramsList=[{key:'level',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'accreditation.level_label'),value:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'levels.'+_this.props.data.level)},{key:'dateIssued',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'accreditation.date_issued_label'),value:__WEBPACK_IMPORTED_MODULE_5_moment_moment___default()(_this.props.data.dateIssued).format('LL')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getDataRow)));},_this.renderVIDData=function(){var paramsList=[{key:'firstName',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),value:_this.props.data.verifiedIdentity.firstName},{key:'lastName',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),value:_this.props.data.verifiedIdentity.lastName},{key:'nationalId',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].national_id_label),value:_this.props.data.verifiedIdentity.nationalId},{key:'countryCode',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),value:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'countries.'+_this.props.data.verifiedIdentity.countryCode)}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getDataRow)));},_this.getDataRow=function(params){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(params.value)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container',key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,params.value));},_this.handleClose=function(){_this.props.onClose();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AccreditationRequestDataModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'accreditation-request-data-modal',isOpen:this.props.isOpen,toggle:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_requests.accreditation_requests_details_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)),this.renderOrgData(),this.renderAccreditationGroupData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation.accreditation_label')),this.renderAccreditationOriginalTitle(),this.renderAccreditationAdditionalTitles(),this.renderAccreditationData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_requests.vid_label')),this.renderVIDData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-request-data-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleClose},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].okey_button))));}}]);return AccreditationRequestDataModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AccreditationRequestDataModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (AccreditationRequestDataModal);

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditAccreditationRequest__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_applicantAccreditations_VIDs__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_titleLangs__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_account_userData__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_common_levels__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_applicantAccreditations_accreditationRequest__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state,_ref){var location=_ref.location;return{id:__WEBPACK_IMPORTED_MODULE_2__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search).id,data:Object(__WEBPACK_IMPORTED_MODULE_9__reducers_applicantAccreditations_accreditationRequest__["c" /* getAccreditationRequestDataFormatted */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_9__reducers_applicantAccreditations_accreditationRequest__["d" /* loadingAccreditationRequest */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),additionalLangs:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_titleLangs__["c" /* getOptionalTitleLangsData */])(state),loadingAdditionalLangs:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_titleLangs__["d" /* loadingTitleLangs */])(state),levels:Object(__WEBPACK_IMPORTED_MODULE_8__reducers_common_levels__["c" /* getLevelsData */])(state),loadingLevels:Object(__WEBPACK_IMPORTED_MODULE_8__reducers_common_levels__["d" /* loadingLevels */])(state),VIDs:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_applicantAccreditations_VIDs__["f" /* getVIDsData */])(state),loadingVIDs:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_applicantAccreditations_VIDs__["i" /* loadingVIDs */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["e" /* getCountriesData */])(state),email:Object(__WEBPACK_IMPORTED_MODULE_7__reducers_account_userData__["f" /* getUserEmail */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGetAccreditationRequestData:function onGetAccreditationRequestData(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__reducers_applicantAccreditations_accreditationRequest__["b" /* fetchAccreditationRequestById */])(id));},onProcess:function onProcess(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__reducers_applicantAccreditations_accreditationRequest__["f" /* onUpdateAccreditationRequest */])(id,data,true));},onGetAdditionalLangs:function onGetAdditionalLangs(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_titleLangs__["b" /* fetchGetTitleLangs */])());},onGetLevels:function onGetLevels(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__reducers_common_levels__["b" /* fetchGetLevels */])());},onGetVIDs:function onGetVIDs(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_applicantAccreditations_VIDs__["c" /* fetchGetVIDs */])());},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onContinentSetByCountry:function onContinentSetByCountry(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["i" /* setCurrentContinentByCountry */])(countryCode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__EditAccreditationRequest__["a" /* default */]));

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditAccreditationRequest_css__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditAccreditationRequest_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EditAccreditationRequest_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_datepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__accreditationManagement_additionalTitle_AdditionalTitle_container__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_uuid__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(22);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var requiredSelectFields=['level','VID','personContinent','personCountry'];var INPUT_MODE={MANUAL_INPUT:'manual_input',SELECT_INPUT:'select_input'};var EditAccreditationRequest=function(_Component){_inherits(EditAccreditationRequest,_Component);function EditAccreditationRequest(props){_classCallCheck(this,EditAccreditationRequest);var _this=_possibleConstructorReturn(this,(EditAccreditationRequest.__proto__||Object.getPrototypeOf(EditAccreditationRequest)).call(this,props));_this.getTitlesAdditional=function(titles){var titlesAdditional=[];__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapValues(titles,function(value,key){titlesAdditional.push({id:__WEBPACK_IMPORTED_MODULE_13_uuid___default()(),lang:key,title:value});});return titlesAdditional;};_this.renderContent=function(){if(_this.props.loading||_this.props.loadingLevels||_this.props.loadingAdditionalLangs||_this.props.loadingVIDs){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'staff-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["n" /* Form */],{className:'edit-accreditation-request-form',onSubmit:_this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'edit-accreditation-request-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)),_this.renderOrgFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'edit-accreditation-request-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_label')),_this.renderTitlesFormGroups(),_this.renderAccreditationFormGroups(),_this.renderAdditionalTitlesFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'edit-accreditation-request-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.vid_label')),_this.renderVIDFormGroup(),_this.renderExposeCheckbox(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn',disabled:_this.saveButtonDisabled()},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button))));};_this.saveButtonDisabled=function(){return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(_this.props.data)||__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.every(_this.props.data,function(value,key){switch(key){case'titlesAdditional':return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.xorWith(_this.state.titlesAdditional,_this.getTitlesAdditional(_this.props.data.titlesAdditional),function(a,b){return a.lang===b.lang&&a.title===b.title;}).length===0;case'dateIssued':return _this.state.dateIssued.format('L')===__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(_this.props.data.dateIssued).format('L');case'verifiedIdentity':return _this.props.data.verifiedIdentity.firstName===_this.state.personFirstName&&_this.props.data.verifiedIdentity.lastName===_this.state.personLastName&&_this.props.data.verifiedIdentity.countryCode===_this.state.personCountry&&_this.props.data.verifiedIdentity.nationalId===_this.state.nationalId;default:return _this.state.hasOwnProperty(key)?_this.state[key]===value:true;}});};_this.renderOrgFormGroup=function(){var manualInputParamsList=[{value:"orgName",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,"orgs.name_label"),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,"orgs.name_label")}];var rowDataParams={value:"orgDomain",valueText:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(_this.props.data)?null:_this.props.data.orgDomain,title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label),popoverHintParams:{hintText:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.domain_hint')}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["p" /* FormGroup */],null,[_this.getDataRow(rowDataParams)].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(manualInputParamsList,_this.getFormGroup))));};_this.renderTitlesFormGroups=function(){var paramsList=[{value:"titleOrig",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_orig_label'),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_orig_input_placeholder')},{value:"titleEn",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_en_label'),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_en_input_placeholder')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderAccreditationFormGroups=function(){var params={value:"level",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.level_label'),isDisabled:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(_this.props.levels),content:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getLevelsOptions(_this.props.levels,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'levels')),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.level_input_placeholder'),isRequired:true};return[_this.renderDateIssued(),_this.getSelectFormGroup(params)];};_this.renderAdditionalTitlesFormGroups=function(){var title=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'additional-langs-title',key:'additional-langs-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.additional_translations_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'add-additional-lang-icon olive-green',icon:'add',onClick:_this.addAdditionalTitle,title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.add_additional_translations_label')}));var result=[title];_this.state.titlesAdditional.forEach(function(elem){result.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__accreditationManagement_additionalTitle_AdditionalTitle_container__["a" /* default */],{key:elem.id,id:elem.id,lang:elem.lang,title:elem.title,langs:_this.getAvailableLang(elem.id),onChangeLang:_this.handleChangeAdditionalTitleLang,onChangeTitle:_this.handleChangeAdditionalTitle,onRemove:_this.removeAdditionalTitle,required:true,requiredFieldError:_this.state.requiredFieldError===elem.id}));});return result;};_this.renderDateIssued=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["p" /* FormGroup */],{row:true,key:'date-issued'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["v" /* Label */],{'for':'date-issued',sm:3},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation.date_issued_label'),'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_datepicker__["a" /* default */],{customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["r" /* Input */],{id:'date-issued'}),selected:_this.state.dateIssued,showMonthDropdown:true,showYearDropdown:true,dropdownMode:'select',required:true,onChange:_this.handleChangeDate,maxDate:__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()()})));};_this.renderVIDFormGroup=function(){var selectInputParams={value:"VID",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.vid_label'),content:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(_this.props.VIDs,function(VID){return{code:VID.id,name:VID.firstName+' '+VID.lastName+', '+VID.nationalId};})),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.vid_label'),isDisabled:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(_this.props.VIDs),isRequired:_this.state.VIDInputMode===INPUT_MODE.SELECT_INPUT};var manualInputParamsList=[{value:"personFirstName",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)},{value:"personLastName",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)},{value:"nationalId",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].national_id_label),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].national_id_label),popoverHintParams:{hintText:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.national_id_hint')}},{value:"personContinent",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),onChange:_this.handleChangeContinent,isRequired:true,isDisabled:!_this.props.continents,menuPlacement:'top'},{value:"personCountry",title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isRequired:true,isDisabled:!_this.props.countries,menuPlacement:'top'}];var emailParams={valueText:_this.props.email,title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["p" /* FormGroup */],null,_this.renderMenu('VIDInputMode'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["i" /* Collapse */],{isOpen:_this.state.VIDInputMode===INPUT_MODE.SELECT_INPUT},_this.getSelectFormGroup(selectInputParams)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["i" /* Collapse */],{isOpen:_this.state.VIDInputMode===INPUT_MODE.MANUAL_INPUT},[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(manualInputParamsList,_this.getFormGroup)))),_this.getDataRow(emailParams));};_this.renderMenu=function(fieldKey){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-mode-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"input-mode-icon-container"+(_this.state[fieldKey]===INPUT_MODE.SELECT_INPUT?" olive-green":""),onClick:_this.handleToggleMenu(fieldKey,INPUT_MODE.SELECT_INPUT)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'input-mode-icon',icon:"radio_button_"+(_this.state[fieldKey]===INPUT_MODE.SELECT_INPUT?"checked":"unchecked"),title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'request_credentials_verification.manual_input_label')}),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.select_'+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.snakeCase(fieldKey)+'_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"input-mode-icon-container"+(_this.state[fieldKey]===INPUT_MODE.MANUAL_INPUT?" olive-green":""),onClick:_this.handleToggleMenu(fieldKey,INPUT_MODE.MANUAL_INPUT)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'input-mode-icon',icon:"radio_button_"+(_this.state[fieldKey]===INPUT_MODE.MANUAL_INPUT?"checked":"unchecked"),title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'request_credentials_verification.upload_file_label')}),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.manual_'+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.snakeCase(fieldKey)+'_label')));};_this.getDataRow=function(params){if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(params.valueText)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["L" /* Row */],{className:'org-settings-row',key:params.title},_this.renderHintPopover(params.value,params.popoverHintParams),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["h" /* Col */],{sm:3},params.title,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["h" /* Col */],null,params.valueText));};_this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this.renderHintPopover(params.value,params.popoverHintParams),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];}),options:params.content,onSelect:params.onChange||_this.handleChangeSelect(params.value),placeholder:params.placeholder,disabled:params.isDisabled,isSearchable:true,menuPlacement:params.menuPlacement,requiredFieldError:_this.state.requiredFieldError===params.value,onInputChange:params.onInputChange})));};_this.getFormGroup=function(params){if(params.type==='dataRow'){return _this.getDataRow(params);}if(params.type==='select'){return _this.getSelectFormGroup(params);}if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},_this.renderHintPopover(params.value,params.popoverHintParams),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.state,params.value),onChange:params.onChange||_this.handleChange(params.value),placeholder:params.placeholder,disabled:params.isDisabled,required:params.isRequired},params.content)));};_this.renderHintPopover=function(fieldName,params){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(params)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-accreditation-request-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:fieldName+'-hint',className:'edit-accreditation-request-hint-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["Q" /* UncontrolledPopover */],{trigger:'legacy',placement:'bottom',target:fieldName+'-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["I" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(params.hintText)))));}};_this.handleChangeDate=function(dateIssued){_this.setState({dateIssued:dateIssued});};_this.handleToggleMenu=function(fieldKey,value){return function(){var _this$setState;switch(fieldKey){case'VIDInputMode':_this.setState((_this$setState={},_defineProperty(_this$setState,fieldKey,value),_defineProperty(_this$setState,'VID',null),_defineProperty(_this$setState,'requiredFieldError',null),_defineProperty(_this$setState,'firstName',_this.props.data.verifiedIdentity.firstName),_defineProperty(_this$setState,'lastName',_this.props.data.verifiedIdentity.lastName),_defineProperty(_this$setState,'personCountry',_this.props.data.verifiedIdentity.countryCode),_defineProperty(_this$setState,'nationalId',_this.props.data.verifiedIdentity.nationalId),_this$setState));_this.props.onContinentSetByCountry(_this.props.data.verifiedIdentity.countryCode);break;default:break;}};};_this.renderExposeCheckbox=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["p" /* FormGroup */],{row:true,className:'checkbox-form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["h" /* Col */],{className:'checkbox-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["v" /* Label */],{className:'checkbox-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["r" /* Input */],{type:'checkbox',checked:_this.state.expose,onChange:_this.toggleExposeCheckbox}),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.expose_accreditation_request_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'edit-accreditation-request-expose-icon-container',className:'edit-accreditation-request-expose-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["Q" /* UncontrolledPopover */],{placement:'bottom',trigger:'legacy',target:'edit-accreditation-request-expose-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["I" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.props.translation,'accreditation_requests.expose_hint')))));};_this.toggleExposeCheckbox=function(){_this.setState({expose:!_this.state.expose});};_this.handleChangeSelect=function(fieldKey){return function(selectedOption){_this.setState(_defineProperty({},fieldKey,selectedOption.value));};};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleChangeAdditionalTitle=function(id){return function(e){var newTitles=_this.state.titlesAdditional.map(function(elem){if(elem.id===id)elem.title=e.target.value;return elem;});_this.setState({titlesAdditional:newTitles});};};_this.handleChangeAdditionalTitleLang=function(id,value){var newTitles=_this.state.titlesAdditional.map(function(elem){if(elem.id===id)elem.lang=value;return elem;});_this.setState({titlesAdditional:newTitles});};_this.handleChangeContinent=function(selectedOption){_this.setState({personCountry:''});_this.props.onContinentSet(selectedOption.value);};_this.addAdditionalTitle=function(){var newTitle={id:__WEBPACK_IMPORTED_MODULE_13_uuid___default()(),lang:'',title:''};_this.setState({titlesAdditional:[].concat(_toConsumableArray(_this.state.titlesAdditional),[newTitle])});};_this.removeAdditionalTitle=function(id){return function(){var newTitles=_this.state.titlesAdditional.filter(function(elem){return elem.id!==id;});_this.setState({titlesAdditional:newTitles});};};_this.handleSubmit=function(e){e.preventDefault();if(_this.checkRequiredSelectFields()){return;}var titles={original:_this.state.titleOrig,en:_this.state.titleEn};_this.state.titlesAdditional.forEach(function(elem){if(elem.lang!=="")titles[elem.lang]=elem.title;});var data={accreditationData:{titles:titles,issuedAt:_this.state.dateIssued.format("YYYY-MM-DD"),level:_this.state.level},orgDomain:_this.props.data.orgDomain,orgName:_this.state.orgName,expose:_this.state.expose};if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(_this.props.data,'accreditationGroupName')){data.accreditationGroupName=_this.props.data.accreditationGroupName;}switch(_this.state.VIDInputMode){case INPUT_MODE.MANUAL_INPUT:data.verifiedIdentity={firstName:_this.state.personFirstName,lastName:_this.state.personLastName,countryCode:_this.state.personCountry,nationalId:_this.state.nationalId};break;case INPUT_MODE.SELECT_INPUT:data.verifiedIdentity=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(_this.props.VIDs,function(vid){return vid.id===_this.state.VID;});break;default:break;}_this.props.onProcess(_this.props.id,data);};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(requiredSelectFields,function(field){if(!_this.state[field]&&!error){switch(field){case'VID':if(_this.state.VIDInputMode===INPUT_MODE.SELECT_INPUT){error=field;}break;case'personCountry':if(_this.state.VIDInputMode===INPUT_MODE.MANUAL_INPUT){error=field;}break;case'personContinent':if(_this.state.VIDInputMode===INPUT_MODE.MANUAL_INPUT){error=field;}break;default:error=field;break;}}});__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(_this.state.titlesAdditional,function(title){if(title.lang===''&&!error){error=title.id;}});_this.setState({requiredFieldError:error});return error;};_this.state={orgName:'',titleOrig:'',titleEn:'',titlesAdditional:[],dateIssued:__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(),level:'',VIDInputMode:INPUT_MODE.SELECT_INPUT,VID:null,personFirstName:'',personLastName:'',personContinent:_this.props.continentCode,personCountry:'',nationalId:'',expose:false,requiredFieldError:null};return _this;}_createClass(EditAccreditationRequest,[{key:'componentWillMount',value:function componentWillMount(){this.props.onGetAccreditationRequestData(this.props.id);this.props.onGetLevels();this.props.onGetAdditionalLangs();this.props.onGetVIDs();}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(this.props.data)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(nextProps.data)){this.setState({orgName:nextProps.data.orgName,titleOrig:nextProps.data.titleOrig,titleEn:nextProps.data.titleEn,titlesAdditional:this.getTitlesAdditional(nextProps.data.titlesAdditional),dateIssued:__WEBPACK_IMPORTED_MODULE_10_moment_moment___default()(nextProps.data.dateIssued),level:nextProps.data.level,VIDInputMode:INPUT_MODE.MANUAL_INPUT,personFirstName:nextProps.data.verifiedIdentity.firstName,personLastName:nextProps.data.verifiedIdentity.lastName,personCountry:nextProps.data.verifiedIdentity.countryCode,nationalId:nextProps.data.verifiedIdentity.nationalId,expose:nextProps.data.expose});this.props.onContinentSetByCountry(nextProps.data.verifiedIdentity.countryCode);}if(nextProps.continentCode!==this.props.continentCode){this.setState({personContinent:nextProps.continentCode});}}},{key:'render',value:function render(){if(this.props.success){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_router_dom__["d" /* Redirect */],{to:'/accreditation-requests-list',push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edit-accreditation-request-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'accreditation_requests.edit_accreditation_request_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/accreditation-requests-list',label:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].back_button)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.props.translation,'accreditation_requests.edit_accreditation_request_label')),this.renderContent()));}},{key:'getAvailableLang',value:function getAvailableLang(id){var disabledLangs=this.state.titlesAdditional.filter(function(elem){return elem.id!==id;}).map(function(elem){return elem.lang;});return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(this.props.additionalLangs).filter(function(lang){return!disabledLangs.includes(lang);});}}]);return EditAccreditationRequest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EditAccreditationRequest.propTypes={id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,loading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,loadingLevels:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,loadingAdditionalLangs:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,loadingVIDs:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,additionalLangs:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,levels:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,VIDs:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,continentCode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,email:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,defaultAlias:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,success:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,onGetAdditionalLangs:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onGetLevels:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onGetVIDs:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onContinentSet:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onContinentSetByCountry:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onGetAccreditationRequestData:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onProcess:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (EditAccreditationRequest);

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccreditationRequestsByDomainsList__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["j" /* loadingUnreferencedAccreditationRequests */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["h" /* getUnreferencedAccreditationRequestsData */])(state),listType:__WEBPACK_IMPORTED_MODULE_2__AccreditationRequestsByDomainsList__["a" /* AVAILABLE_LIST_TYPES */].PENDING};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["v" /* setFilterDomain */])(null));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["w" /* setValidated */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["m" /* onGetAccreditationRequestsByDomains */])());},onAccreditationRequestsByDomainRemove:function onAccreditationRequestsByDomainRemove(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["M" /* MODAL_REMOVE_ACCREDITATION_REQUESTS_BY_DOMAIN */]}));},onAccreditationRequestsByDomainEdit:function onAccreditationRequestsByDomainEdit(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["A" /* MODAL_EDIT_ACCREDITATION_REQUESTS_BY_DOMAIN */]}));},onAccreditationRequestsByDomainValidate:function onAccreditationRequestsByDomainValidate(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_11" /* MODAL_VALIDATE_DOMAIN */]}));},onFilterByDomain:function onFilterByDomain(domain){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["p" /* onGetAccreditationRequestsFilteredByDomains */])(domain));},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["t" /* resetAccreditationRequestsData */])());},onShowLastRequestors:function onShowLastRequestors(domain){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["d" /* fetchGetLastRequestorsOfAccreditationRequest */])(domain));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["E" /* MODAL_LAST_REQUESTORS_ACCREDITATION_REQUEST_BY_DOMAIN */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__AccreditationRequestsByDomainsList__["b" /* default */]));

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AVAILABLE_LIST_TYPES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccreditationRequestsByDomainsList_css__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccreditationRequestsByDomainsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AccreditationRequestsByDomainsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__accreditationModal_removeAccreditationRequestsByDomainModal_RemoveAccreditationRequestsByDomainModal_container__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__accreditationModal_editAccreditationRequestsByDomainModal_EditAccreditationRequestsByDomainModal_container__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_paginationComponent_PaginationUnreferencedAccreditationRequestsByDomains_container__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__accreditationModal_lastRequestorsAccreditationRequestsByDomainModal_LastRequestorsAccreditationRequestsByDomainModal_container__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__accreditationModal_validateDomainModal_ValidateDomainModal_container__ = __webpack_require__(1048);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SUCCESS_MESSAGE_PATH_BY_ACTION={REMOVE:'accreditation_requests.remove_accreditation_requests_success_message',EDIT:'accreditation_requests.update_accreditation_requests_success_message',VALIDATE:'accreditation_requests.validate_accreditation_requests_success_message'};var AVAILABLE_LIST_TYPES={PENDING:'pending',VALIDATED:'validated'};var AccreditationRequestsByDomainsList=function(_Component){_inherits(AccreditationRequestsByDomainsList,_Component);function AccreditationRequestsByDomainsList(props){_classCallCheck(this,AccreditationRequestsByDomainsList);var _this=_possibleConstructorReturn(this,(AccreditationRequestsByDomainsList.__proto__||Object.getPrototypeOf(AccreditationRequestsByDomainsList)).call(this,props));_this.renderTable=function(){if(_this.props.loading&&(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-requests-by-domains-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(!_this.state.filtering&&(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-requests-by-domains-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.'+_this.props.listType+'_accreditation_requests_list_no_data_label')));}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["L" /* Row */],{className:'accreditation-requests-by-domains-list-relative-header',key:'relative-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':'input',className:'relative-header-label',sm:4},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.filter_by_domain_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{id:_this.props.listType+'-accreditation-requests-by-domains-input',value:_this.state.filterValue,onChange:_this.handleChangeFilterValue,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.filter_by_domain_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:_this.handleFilter},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.filter_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["N" /* Table */],{className:'accreditation-requests-by-domains-list-table',key:'accreditation-requests-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'domain-th'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.organization_domain_label'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{id:'input',value:_this.state.filterValue,onChange:_this.handleChangeFilterValue,onKeyDown:_this.handleKeyDown,onBlur:_this.handleFilter,className:'domain-filter-input',bsSize:'sm',placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.filter_by_domain_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'number-th'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.accreditation_requests_number_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),_this.props.listType===AVAILABLE_LIST_TYPES.PENDING?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderAccreditationRequestsByDomainsData()))];};_this.renderAccreditationRequestsByDomainsData=function(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(_this.props.data,function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'accreditation-requests-list-row',key:index,onClick:_this.handleRowClick(data)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'domain-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.organization_domain_label')+':'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'td-with-icon'},data.value,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'create',key:data.id+'-create',className:'create-accreditation-request-icon',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.edit_accreditation_request_label')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'number-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.accreditation_requests_number_label')+':'},data.amount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'last-requestors-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'btn-sm',color:'link',onClick:_this.handleLastRequestorsButtonClick(data.value)},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.last_requestors_button'))),_this.props.listType===AVAILABLE_LIST_TYPES.PENDING?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'validate-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'btn-sm',color:'link',onClick:_this.handleValidateButtonClick(data)},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.validate_button'))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'remove-icon-td',onClick:_this.handleRemoveIconClick(data)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'trash',key:data.id+'-trash',className:'trash-accreditation-request-icon',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.remove_accreditation_request_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'relative-edit-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'create',key:data.id+'-create',className:'relative-create-accreditation-request-icon',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.edit_accreditation_request_label')})));});};_this.handleChangeFilterValue=function(e){_this.setState({filterValue:e.target.value,filtering:true});};_this.handleRowClick=function(data){return function(){_this.setState({selectedRowData:data,successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,SUCCESS_MESSAGE_PATH_BY_ACTION.EDIT)});_this.props.onAccreditationRequestsByDomainEdit();};};_this.handleRemoveIconClick=function(data){return function(e){e.stopPropagation();_this.setState({selectedRowData:data,successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,SUCCESS_MESSAGE_PATH_BY_ACTION.REMOVE)});_this.props.onAccreditationRequestsByDomainRemove();};};_this.handleKeyDown=function(e){if(e.keyCode===13){_this.handleFilter();}};_this.handleFilter=function(){if(!_this.state.filterValue||_this.state.filterValue===''){_this.setState({filtering:false});}_this.props.onFilterByDomain(_this.state.filterValue);};_this.handleValidateButtonClick=function(data){return function(e){e.stopPropagation();_this.setState({selectedRowData:{orgDomain:data.value,orgName:data.orgName,orgCountry:data.countryCode},successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,SUCCESS_MESSAGE_PATH_BY_ACTION.VALIDATE)});_this.props.onAccreditationRequestsByDomainValidate();};};_this.handleLastRequestorsButtonClick=function(domain){return function(e){e.stopPropagation();_this.props.onShowLastRequestors(domain);};};_this.handleCloseModal=function(){_this.setState({selectedRowData:null});};_this.state={selectedRowData:null,filterValue:'',successMessage:'',filtering:false};return _this;}_createClass(AccreditationRequestsByDomainsList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-requests-by-domains-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:this.state.successMessage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation_requests.'+this.props.listType+'_accreditation_requests_by_domain_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_paginationComponent_PaginationUnreferencedAccreditationRequestsByDomains_container__["a" /* default */],null),this.renderTable(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__accreditationModal_removeAccreditationRequestsByDomainModal_RemoveAccreditationRequestsByDomainModal_container__["a" /* default */],{data:this.state.selectedRowData}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__accreditationModal_editAccreditationRequestsByDomainModal_EditAccreditationRequestsByDomainModal_container__["a" /* default */],{data:this.state.selectedRowData}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__accreditationModal_validateDomainModal_ValidateDomainModal_container__["a" /* default */],{data:this.state.selectedRowData,onClose:this.handleCloseModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__accreditationModal_lastRequestorsAccreditationRequestsByDomainModal_LastRequestorsAccreditationRequestsByDomainModal_container__["a" /* default */],null)));}}]);return AccreditationRequestsByDomainsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AccreditationRequestsByDomainsList.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,listType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onAccreditationRequestsByDomainRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onAccreditationRequestsByDomainEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onAccreditationRequestsByDomainValidate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onFilterByDomain:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onUnmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["b"] = (AccreditationRequestsByDomainsList);

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveAccreditationRequestsByDomainModal__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["M" /* MODAL_REMOVE_ACCREDITATION_REQUESTS_BY_DOMAIN */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAccreditationRequestsRemove:function onAccreditationRequestsRemove(domain){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["r" /* onRemoveUnreferencedAccreditationRequestDomain */])(domain));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["b" /* fetchSubmitForm */])());},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RemoveAccreditationRequestsByDomainModal__["a" /* default */]));

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveAccreditationRequestsByDomainModal=function(_Component){_inherits(RemoveAccreditationRequestsByDomainModal,_Component);function RemoveAccreditationRequestsByDomainModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveAccreditationRequestsByDomainModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveAccreditationRequestsByDomainModal.__proto__||Object.getPrototypeOf(RemoveAccreditationRequestsByDomainModal)).call.apply(_ref,[this].concat(args))),_this),_this.renderData=function(){var paramsList=[{key:"domain",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,"accreditation_requests.organization_domain_label")+":",value:_this.props.data.value},{key:"requestsNumber",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,"accreditation_requests.accreditation_requests_number_label")+":",value:_this.props.data.amount}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getDataRow)));},_this.getDataRow=function(params){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(params.value)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container',key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:7},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,params.value));},_this.handleRemove=function(e){e.preventDefault();_this.props.onAccreditationRequestsRemove(_this.props.data.value);_this.props.onCancel();},_this.handleCancel=function(){_this.props.onCancel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveAccreditationRequestsByDomainModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'accreditation-requests-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_requests.accreditation_requests_remove_alert')),this.renderData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))));}}]);return RemoveAccreditationRequestsByDomainModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveAccreditationRequestsByDomainModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onAccreditationRequestsRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveAccreditationRequestsByDomainModal);

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditAccreditationRequestsByDomainModal__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["A" /* MODAL_EDIT_ACCREDITATION_REQUESTS_BY_DOMAIN */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAccreditationRequestsEdit:function onAccreditationRequestsEdit(domain,newDomain){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["a" /* changeUnreferencedAccreditationRequestDomain */])(domain,newDomain));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["b" /* fetchSubmitForm */])());},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__EditAccreditationRequestsByDomainModal__["a" /* default */]));

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_domainInput_DomainInput__ = __webpack_require__(63);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditAccreditationRequestsByDomainModal=function(_Component){_inherits(EditAccreditationRequestsByDomainModal,_Component);function EditAccreditationRequestsByDomainModal(props){_classCallCheck(this,EditAccreditationRequestsByDomainModal);var _this=_possibleConstructorReturn(this,(EditAccreditationRequestsByDomainModal.__proto__||Object.getPrototypeOf(EditAccreditationRequestsByDomainModal)).call(this,props));_this.saveButtonDisabled=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.data)||_this.props.data.value===_this.state.domain;};_this.renderData=function(){var rowDataParams={key:"requestsNumber",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,"accreditation_requests.accreditation_requests_number_label")+":",value:_this.props.data.amount};var inputParams={value:"domain",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,"accreditation_requests.organization_domain_label"),isRequired:true};return[_this.getDataRow(rowDataParams),_this.getOrganizationDomainFormGroup(inputParams)];};_this.getOrganizationDomainFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:6},params.title,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_domainInput_DomainInput__["a" /* default */],{value:_this.state[params.value],onChange:_this.handleChangeDomain,placeholder:params.title,required:params.isRequired})));};_this.getDataRow=function(params){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(params.value)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container',key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,params.value));};_this.handleChangeDomain=function(data){_this.setState({domain:data});};_this.handleEdit=function(e){e.preventDefault();_this.props.onAccreditationRequestsEdit(_this.props.data.value,_this.state.domain);_this.props.onCancel();_this.setState({domain:''});};_this.handleCancel=function(){_this.props.onCancel();_this.setState({domain:''});};_this.state={domain:''};return _this;}_createClass(EditAccreditationRequestsByDomainModal,[{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(this.props.data,nextProps.data)||this.props.isOpen!==nextProps.isOpen){this.setState({domain:nextProps.data?nextProps.data.value:''});}}},{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'accreditation-requests-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],null,this.renderData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit',disabled:this.saveButtonDisabled(),onClick:this.handleEdit},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button))));}}]);return EditAccreditationRequestsByDomainModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EditAccreditationRequestsByDomainModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onAccreditationRequestsEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (EditAccreditationRequestsByDomainModal);

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_unreferencedAccreditationRequests__ = __webpack_require__(54);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_unreferencedAccreditationRequests__["e" /* getCurrentPageForAccreditationRequests */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_unreferencedAccreditationRequests__["g" /* getTotalPagesForAccreditationRequests */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_unreferencedAccreditationRequests__["n" /* onGetAccreditationRequestsByDomainsByPage */])(page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LastRequestorsAccreditationRequestsByDomainModal__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__ = __webpack_require__(54);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["E" /* MODAL_LAST_REQUESTORS_ACCREDITATION_REQUEST_BY_DOMAIN */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["f" /* getLastRequestorsOfAccreditationRequestData */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["i" /* loadingLastRequestorsOfAccreditationRequest */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__LastRequestorsAccreditationRequestsByDomainModal__["a" /* default */]));

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LastRequestorsAccreditationRequestsByDomainModal_css__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LastRequestorsAccreditationRequestsByDomainModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LastRequestorsAccreditationRequestsByDomainModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LastRequestorsAccreditationRequestsByDomainModal=function(_Component){_inherits(LastRequestorsAccreditationRequestsByDomainModal,_Component);function LastRequestorsAccreditationRequestsByDomainModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LastRequestorsAccreditationRequestsByDomainModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LastRequestorsAccreditationRequestsByDomainModal.__proto__||Object.getPrototypeOf(LastRequestorsAccreditationRequestsByDomainModal)).call.apply(_ref,[this].concat(args))),_this),_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_this.props.data,function(elem,id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'last-requestors-list',key:id},elem.identityAlias?elem.identityAlias.firstName+" "+elem.identityAlias.lastName:"",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+elem.email},elem.email));});},_this.handleCancel=function(){_this.props.onCancel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LastRequestorsAccreditationRequestsByDomainModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'last-requestors-accreditation-requests-by-domain-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].okey_button))));}}]);return LastRequestorsAccreditationRequestsByDomainModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);LastRequestorsAccreditationRequestsByDomainModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (LastRequestorsAccreditationRequestsByDomainModal);

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValidateDomainModal__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_accreditation_unreferencedAccreditationRequests__ = __webpack_require__(54);
var mapStateToProps=function mapStateToProps(state){return{action:__WEBPACK_IMPORTED_MODULE_1__ValidateDomainModal__["a" /* AVAILABLE_ACTIONS */].VALIDATE,isOpen:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_11" /* MODAL_VALIDATE_DOMAIN */],continentCode:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["e" /* getCountriesData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch,props){return{onSubmit:function onSubmit(data,bavaManaged){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_accreditation_unreferencedAccreditationRequests__["s" /* onValidateDomain */])(props.data.orgDomain,data,bavaManaged));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["h" /* setCurrentContinent */])(''));},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onContinentSetByCountry:function onContinentSetByCountry(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["i" /* setCurrentContinentByCountry */])(countryCode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ValidateDomainModal__["b" /* default */]));

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccreditationRequestsByGroupList__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__ = __webpack_require__(54);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["j" /* loadingUnreferencedAccreditationRequests */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["h" /* getUnreferencedAccreditationRequestsData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["u" /* setFilterAG */])(null));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["c" /* fetchGetAccreditationRequestsByAGs */])());},onAccreditationRequestsReject:function onAccreditationRequestsReject(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["b" /* MODAL_ACCREDITATION_REQUESTS_REJECT */]}));},onAccreditationRequestsSetAG:function onAccreditationRequestsSetAG(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["c" /* MODAL_ACCREDITATION_REQUESTS_SET_AG */]}));},onFilterByGroup:function onFilterByGroup(group){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["o" /* onGetAccreditationRequestsFilteredByAGs */])(group));},onReject:function onReject(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["q" /* onRemoveUnreferencedAccreditationRequestAG */])(data));},onSetAccreditationGroup:function onSetAccreditationGroup(group,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["k" /* onChangeUnreferencedAccreditationRequestAG */])(group,data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__AccreditationRequestsByGroupList__["a" /* default */]));

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccreditationRequestsByGroupList_css__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccreditationRequestsByGroupList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AccreditationRequestsByGroupList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__accreditationModal_rejectAccreditationRequestsByGroupModal_RejectAccreditationRequestsByGroupModal_container__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__accreditationModal_setAccreditationGroupForRequestsModal_SetAccreditationGroupForRequestsModal_container__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_paginationComponent_PaginationUnreferencedAccreditationRequestsByAGs_container__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_utils__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SUCCESS_MESSAGE_PATH_BY_ACTION={REMOVE:'accreditation_requests.remove_accreditation_requests_success_message',EDIT:'accreditation_requests.set_accreditation_group_for_selected_requests_success_message'};var AccreditationRequestsByGroupList=function(_Component){_inherits(AccreditationRequestsByGroupList,_Component);function AccreditationRequestsByGroupList(props){_classCallCheck(this,AccreditationRequestsByGroupList);var _this=_possibleConstructorReturn(this,(AccreditationRequestsByGroupList.__proto__||Object.getPrototypeOf(AccreditationRequestsByGroupList)).call(this,props));_this.renderTable=function(){if(_this.props.loading&&(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-requests-by-group-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(!_this.state.filtering&&(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-requests-by-group-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.accreditation_requests_list_no_data_label')));}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group',key:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'carrot-red-btn',disabled:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.state.selected),onClick:_this.handleRejectButtonClick},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.reject_selected_button')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'olive-green-btn',disabled:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.state.selected),onClick:_this.handleSetAGButtonClick},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.set_accreditation_group_for_selected_button'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["N" /* Table */],{className:'accreditation-requests-by-group-list-table',key:'accreditation-requests-by-group-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,_this.renderSelectAllCheckbox()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'group-th'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].accreditation_group_label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{id:'input',value:_this.state.filterValue,onChange:_this.handleChangeFilterValue,onKeyDown:_this.handleKeyDown,onBlur:_this.handleFilter,className:'group-filter-input',bsSize:'sm',placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].accreditation_group_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'number-th'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.accreditation_requests_number_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderAccreditationRequestsByDomainsData()))];};_this.renderSelectAllCheckbox=function(){var allSelected=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.props.data)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.chain(_this.props.data).map(function(data){return data.value;}).xor(_this.state.selected).value().length===0;if(allSelected){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'accreditation-request-checkbox',icon:'check_box',onClick:_this.onToggleSelectAllCheckBox});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'accreditation-request-checkbox',icon:'check_box_outline_blank',onClick:_this.onToggleSelectAllCheckBox});}};_this.renderAccreditationRequestsByDomainsData=function(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(_this.props.data,function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'accreditation-requests-list-row',key:data.value,onClick:_this.onToggleSelectCheckbox(data.value)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'selected-check-box'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(_this.state.selected,data.value)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'accreditation-request-checkbox',icon:'check_box',key:data.value+'_checkbox'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'accreditation-request-checkbox',icon:'check_box_outline_blank',key:data.value+'_checkbox'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'group-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].accreditation_group_label)+':'},data.value),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'relative-edit-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'create',key:data.id+'-create',className:'relative-create-accreditation-request-icon',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.edit_accreditation_request_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'number-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.accreditation_requests_number_label')+':'},data.amount));});};_this.onToggleSelectAllCheckBox=function(){if(_this.state.selected.length!==_this.props.data.length){_this.setState({selected:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(_this.props.data,function(data){return data.value;})});}else{_this.setState({selected:[]});}};_this.onToggleSelectCheckbox=function(value){return function(e){e.stopPropagation();if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(_this.state.selected,value)){_this.setState({selected:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pull([].concat(_toConsumableArray(_this.state.selected)),value)});}else{_this.setState({selected:[].concat(_toConsumableArray(_this.state.selected),[value])});}};};_this.handleChangeFilterValue=function(e){_this.setState({filterValue:e.target.value,filtering:true});};_this.handleSetAGButtonClick=function(){_this.setState({successMessage:SUCCESS_MESSAGE_PATH_BY_ACTION.EDIT});_this.props.onAccreditationRequestsSetAG();};_this.handleRejectButtonClick=function(){_this.setState({successMessage:SUCCESS_MESSAGE_PATH_BY_ACTION.REMOVE});_this.props.onAccreditationRequestsReject();};_this.handleKeyDown=function(e){if(e.keyCode===13){_this.handleFilter();}};_this.handleFilter=function(){if(!_this.state.filterValue||_this.state.filterValue===''){_this.setState({filtering:false});}_this.props.onFilterByGroup(_this.state.filterValue);};_this.handleReject=function(){_this.props.onReject(_this.state.selected);_this.setState({selected:[]});};_this.handleSetAccreditationGroup=function(group){_this.props.onSetAccreditationGroup(group,_this.state.selected);_this.setState({selected:[]});};_this.state={selectedRowData:null,filterValue:'',successMessage:'',selected:[],filtering:false};return _this;}_createClass(AccreditationRequestsByGroupList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-requests-by-group-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,this.state.successMessage)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation_requests.accreditation_requests_by_group_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accreditation-requests-by-group-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation_requests.accreditation_requests_by_group_hint_part_1'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation_requests.accreditation_requests_by_group_hint_part_2'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_11__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation_requests.accreditation_requests_by_group_hint_part_3')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_paginationComponent_PaginationUnreferencedAccreditationRequestsByAGs_container__["a" /* default */],null),this.renderTable(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__accreditationModal_rejectAccreditationRequestsByGroupModal_RejectAccreditationRequestsByGroupModal_container__["a" /* default */],{onReject:this.handleReject}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__accreditationModal_setAccreditationGroupForRequestsModal_SetAccreditationGroupForRequestsModal_container__["a" /* default */],{onSetAccreditationGroup:this.handleSetAccreditationGroup})));}}]);return AccreditationRequestsByGroupList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AccreditationRequestsByGroupList.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onAccreditationRequestsReject:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onAccreditationRequestsSetAG:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onFilterByGroup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onReject:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSetAccreditationGroup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AccreditationRequestsByGroupList);

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RejectAccreditationRequestsByGroupModal__ = __webpack_require__(1054);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["b" /* MODAL_ACCREDITATION_REQUESTS_REJECT */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RejectAccreditationRequestsByGroupModal__["a" /* default */]));

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RejectAccreditationRequestsByGroupModal=function(_Component){_inherits(RejectAccreditationRequestsByGroupModal,_Component);function RejectAccreditationRequestsByGroupModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RejectAccreditationRequestsByGroupModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RejectAccreditationRequestsByGroupModal.__proto__||Object.getPrototypeOf(RejectAccreditationRequestsByGroupModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleReject=function(e){e.preventDefault();_this.props.onReject();_this.props.onCancel();},_this.handleCancel=function(){_this.props.onCancel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RejectAccreditationRequestsByGroupModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'accreditation-requests-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_requests.reject_accreditation_requests_alert')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'carrot-red-btn',onClick:this.handleReject},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"accreditation_requests.reject_button"))));}}]);return RejectAccreditationRequestsByGroupModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RejectAccreditationRequestsByGroupModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onReject:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RejectAccreditationRequestsByGroupModal);

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SetAccreditationGroupForRequestsModal__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_organization_accreditationGroups__ = __webpack_require__(82);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["c" /* MODAL_ACCREDITATION_REQUESTS_SET_AG */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),accreditationGroups:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_organization_accreditationGroups__["f" /* getAccreditationGroupsDataForSelect */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());},onGetAccreditationGroups:function onGetAccreditationGroups(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_organization_accreditationGroups__["b" /* fetchGetAccreditationGroups */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__SetAccreditationGroupForRequestsModal__["a" /* default */]));

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SetAccreditationGroupForRequestsModal_css__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SetAccreditationGroupForRequestsModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SetAccreditationGroupForRequestsModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SetAccreditationGroupForRequestsModal=function(_Component){_inherits(SetAccreditationGroupForRequestsModal,_Component);function SetAccreditationGroupForRequestsModal(props){_classCallCheck(this,SetAccreditationGroupForRequestsModal);var _this=_possibleConstructorReturn(this,(SetAccreditationGroupForRequestsModal.__proto__||Object.getPrototypeOf(SetAccreditationGroupForRequestsModal)).call(this,props));_this.handleChangeSelect=function(selectedOption){_this.setState({selectedAccreditationGroupId:selectedOption.value});};_this.handleReject=function(e){e.preventDefault();_this.props.onSetAccreditationGroup(_this.state.selectedAccreditationGroupId);_this.props.onCancel();};_this.handleCancel=function(){_this.props.onCancel();};_this.state={selectedAccreditationGroupId:''};return _this;}_createClass(SetAccreditationGroupForRequestsModal,[{key:'componentWillMount',value:function componentWillMount(){this.props.onGetAccreditationGroups();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'accreditation-requests-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_requests.set_accreditation_group_for_selected_requests_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'accreditation-group-select-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':'accreditation-group-select',sm:5},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].accreditation_group_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:'accreditation-group-select',selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.props.accreditationGroups,function(option){return option.value===_this2.state.selectedAccreditationGroupId;}),options:this.props.accreditationGroups,onSelect:this.handleChangeSelect,placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].accreditation_group_label),disabled:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.accreditationGroups)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',disabled:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(this.state.selectedAccreditationGroupId),onClick:this.handleReject},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button))));}}]);return SetAccreditationGroupForRequestsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SetAccreditationGroupForRequestsModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,accreditationGroups:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onSetAccreditationGroup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onGetAccreditationGroups:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (SetAccreditationGroupForRequestsModal);

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_unreferencedAccreditationRequests__ = __webpack_require__(54);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_unreferencedAccreditationRequests__["e" /* getCurrentPageForAccreditationRequests */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_unreferencedAccreditationRequests__["g" /* getTotalPagesForAccreditationRequests */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_unreferencedAccreditationRequests__["l" /* onGetAccreditationRequestsByAGsByPage */])(page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PendingAccreditationRequestsList__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_location__ = __webpack_require__(21);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__["t" /* loadingPendingAccreditationRequestsList */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__["o" /* getPendingAccreditationRequestsData */])(state),group:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_account_role__["k" /* getCurrentGroup */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),isOrgBava:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__["w" /* isOrgBava */])(state),requestsPerCountry:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__["r" /* getPendingAccreditationRequestsPerCountryData */])(state),requestsPerDomain:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__["s" /* getPendingAccreditationRequestsPerDomainData */])(state),requestsPerContinent:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__["q" /* getPendingAccreditationRequestsPerContinentData */])(state),countryFilter:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__["n" /* getPendingAccreditationRequestsCountryFilter */])(state),domainFilter:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__["p" /* getPendingAccreditationRequestsDomainFilter */])(state),locationData:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_location__["g" /* getLocationData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onLoadAccreditationRequests:function onLoadAccreditationRequests(groupId,page){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__["i" /* getAccreditationRequestsForProcessing */])(groupId,page));},onStartValidation:function onStartValidation(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__["y" /* setStartAccreditationRequest */])(id));},onLoadARsPerCountry:function onLoadARsPerCountry(groupId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__["g" /* fetchGetAccreditationRequestsPerCountryForValidation */])(groupId));},onLoadARsPerDomain:function onLoadARsPerDomain(groupId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__["u" /* onFetchGetAccreditationRequestsPerDomainForValidation */])(groupId));},onUpdateCountryFilter:function onUpdateCountryFilter(countryFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__["v" /* onUpdateAccreditationRequestsForValidationCountryFilter */])(countryFilter));},onUpdateDomainFilter:function onUpdateDomainFilter(domain){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__["w" /* onUpdateAccreditationRequestsForValidationDomainFilter */])(domain));},onClearCountryFilter:function onClearCountryFilter(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__["c" /* clearAccreditationRequestsForValidationCountryFilter */])());},onClearDomainFilter:function onClearDomainFilter(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_pendingAccreditationRequests__["d" /* clearAccreditationRequestsForValidationDomainFilter */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PendingAccreditationRequestsList__["a" /* default */]));

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PendingAccreditationRequestsList_css__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PendingAccreditationRequestsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PendingAccreditationRequestsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_paginationComponent_PaginationAccreditations_container__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PendingAccreditationRequestsList=function(_Component){_inherits(PendingAccreditationRequestsList,_Component);function PendingAccreditationRequestsList(props){_classCallCheck(this,PendingAccreditationRequestsList);var _this=_possibleConstructorReturn(this,(PendingAccreditationRequestsList.__proto__||Object.getPrototypeOf(PendingAccreditationRequestsList)).call(this,props));_this.getAccreditationRequestsByPage=function(page){_this.props.onLoadAccreditationRequests(_this.props.group,page);};_this.handleClick=function(id){return function(){_this.setState({redirect:true});_this.props.onStartValidation(id);};};_this.handleChangeContinentFilter=function(selectedOption){_this.setState({continentFilter:selectedOption.value});};_this.handleChangeCountryFilter=function(selectedOption){_this.props.onUpdateCountryFilter(selectedOption.value);};_this.handleChangeDomainFilter=function(selectedOption){_this.props.onUpdateDomainFilter(selectedOption.value);};_this.state={redirect:false,continentFilter:null};return _this;}_createClass(PendingAccreditationRequestsList,[{key:'render',value:function render(){if(this.state.redirect){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Redirect */],{to:'/process-accreditation-requests',push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pending-accreditation-requests-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'accreditation_requests.pending_accreditation_requests_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_paginationComponent_PaginationAccreditations_container__["a" /* default */],{getDataForPage:this.getAccreditationRequestsByPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pending-accreditation-requests-filters-container'},this.renderFilters()),this.renderContent());}},{key:'renderFilters',value:function renderFilters(){var _this2=this;if(this.props.isOrgBava){var requestsPerContinentOptions=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.props.requestsPerContinent,function(elem){return{value:elem.value,label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continents+"."+elem.value)+' ('+elem.count+')'};});var continentsOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(requestsPerContinentOptions));var requestsPerCountryOptions=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.chain(this.props.requestsPerCountry).filter(function(elem){return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(_this2.state.continentFilter)||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.includes(_this2.props.locationData[_this2.state.continentFilter],elem.value);}).map(function(elem){return{value:elem.value,label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].countries+'.'+elem.value)+' ('+elem.count+')'};}).value();requestsPerCountryOptions=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.orderBy(requestsPerCountryOptions,"label","asc");var countriesOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(requestsPerCountryOptions));var requestsPerDomainOptions=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.props.requestsPerDomain,function(elem){return{value:elem.value,label:elem.value+' ('+elem.count+')'};});requestsPerDomainOptions=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.orderBy(requestsPerDomainOptions,"label","asc");var domainOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(requestsPerDomainOptions));return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-container',key:'continent-filter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(continentsOptions,function(option){return option.value===_this2.state.continentFilter;}),options:continentsOptions,onSelect:this.handleChangeContinentFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-container',key:'country-filter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(countriesOptions,function(option){return option.value===_this2.props.countryFilter;}),options:countriesOptions,onSelect:this.handleChangeCountryFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-container',key:'domain-filter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(domainOptions,function(option){return option.value===_this2.props.domainFilter;}),options:domainOptions,onSelect:this.handleChangeDomainFilter}))];}}},{key:'renderContent',value:function renderContent(){if(this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pending-accreditation-requests-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.data)||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pending-accreditation-requests-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'accreditation_requests.pending_accreditation_requests_no_data_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["N" /* Table */],{className:'pending-accreditation-requests-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'accreditation_list.applicant_name_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'accreditation_requests.applicant_email_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'accreditation_requests.created_at_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.renderAccreditationRequestsData()));}},{key:'renderAccreditationRequestsData',value:function renderAccreditationRequestsData(){var _this3=this;if(!this.props.loading){return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.props.data,function(request,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index,className:'pending-accreditation-requests-list-row',onClick:_this3.handleClick(request.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'accreditation-applicant-name-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this3.props.translation,'accreditation_list.applicant_name_label')+":"},request.verifiedIdentity.firstName+' '+request.verifiedIdentity.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'accreditation-applicant-email-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this3.props.translation,'accreditation_requests.applicant_email_label')+":"},request.applicantEmail),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'accreditation-applicant-created-at-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this3.props.translation,'accreditation_requests.created_at_label')+":"},__WEBPACK_IMPORTED_MODULE_9_moment___default()(request.createdAt).format('LL')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'create-icon-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'create',key:'create'+index,title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this3.props.translation,'accreditation_list.edit_label'),className:'create-accreditation-icon'})));});}}},{key:'componentDidMount',value:function componentDidMount(){this.props.onLoadAccreditationRequests(this.props.group);if(this.props.isOrgBava){this.props.onLoadARsPerCountry(this.props.group);this.props.onLoadARsPerDomain(this.props.group);}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.group!==prevProps.group){this.props.onLoadAccreditationRequests(this.props.group);if(this.props.isOrgBava){this.props.onClearCountryFilter();this.props.onClearDomainFilter();this.props.onLoadARsPerCountry(this.props.group);this.props.onLoadARsPerDomain(this.props.group);}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onClearCountryFilter();this.props.onClearDomainFilter();}}]);return PendingAccreditationRequestsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PendingAccreditationRequestsList.propTypes={data:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,loading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,group:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,isOrgBava:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,requestsPerCountry:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,requestsPerContinent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,countryFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,locationData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,onStartValidation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onLoadAccreditationRequests:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onLoadARsPerCountry:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onUpdateCountryFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onClearCountryFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onLoadARsPerDomain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onUpdateDomainFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onClearDomainFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (PendingAccreditationRequestsList);

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProcessAccreditationRequest__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_levels__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_titleLangs__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_accreditation_certificate__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_organization_organization__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_accreditation_pendingAccreditationRequests__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reducers_accreditation_pendingAccreditationRequest__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducers_account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__reducers_accreditation_accreditations__ = __webpack_require__(38);
var mapStateToProps=function mapStateToProps(state){return{id:Object(__WEBPACK_IMPORTED_MODULE_10__reducers_accreditation_pendingAccreditationRequests__["j" /* getCurrentAccreditationRequestId */])(state),groupId:Object(__WEBPACK_IMPORTED_MODULE_12__reducers_account_role__["k" /* getCurrentGroup */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_11__reducers_accreditation_pendingAccreditationRequest__["d" /* loadingPendingAccreditationRequest */])(state)||Object(__WEBPACK_IMPORTED_MODULE_10__reducers_accreditation_pendingAccreditationRequests__["t" /* loadingPendingAccreditationRequestsList */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_11__reducers_accreditation_pendingAccreditationRequest__["c" /* getPendingAccreditationRequestDataFormatted */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["e" /* getCountriesData */])(state),additionalLangs:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_titleLangs__["c" /* getOptionalTitleLangsData */])(state),levels:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_levels__["c" /* getLevelsData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state),signingKey:Object(__WEBPACK_IMPORTED_MODULE_8__reducers_accreditation_certificate__["d" /* getKey */])(state),signingKeyLoading:Object(__WEBPACK_IMPORTED_MODULE_8__reducers_accreditation_certificate__["e" /* getKeyLoading */])(state),isSigningRequired:Object(__WEBPACK_IMPORTED_MODULE_9__reducers_organization_organization__["v" /* isAccreditationSigningRequired */])(state),orgLoading:Object(__WEBPACK_IMPORTED_MODULE_9__reducers_organization_organization__["y" /* loadingOrg */])(state),isBava:Object(__WEBPACK_IMPORTED_MODULE_9__reducers_organization_organization__["w" /* isOrgBava */])(state),loadingManagedOrgs:Object(__WEBPACK_IMPORTED_MODULE_13__reducers_accreditation_accreditations__["L" /* loadingManagedOrgs */])(state),managedOrgs:Object(__WEBPACK_IMPORTED_MODULE_13__reducers_accreditation_accreditations__["E" /* getManagedOrgsOptions */])(state),locationData:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["g" /* getLocationData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGetPendingAccreditationRequest:function onGetPendingAccreditationRequest(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__reducers_accreditation_pendingAccreditationRequest__["b" /* fetchGetPendingAccreditationRequestById */])(id));},onSubmit:function onSubmit(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_accreditation_pendingAccreditationRequests__["f" /* fetchConfirmAccreditationRequest */])(id,data));},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},setContinentByCountry:function setContinentByCountry(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["i" /* setCurrentContinentByCountry */])(countryCode));},onGetAdditionalLangs:function onGetAdditionalLangs(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_titleLangs__["b" /* fetchGetTitleLangs */])());},onGetLevels:function onGetLevels(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_levels__["b" /* fetchGetLevels */])());},onRejectAccreditationRequestShowModal:function onRejectAccreditationRequestShowModal(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["b" /* MODAL_ACCREDITATION_REQUESTS_REJECT */]}));},onRejectAccreditationRequest:function onRejectAccreditationRequest(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_accreditation_pendingAccreditationRequests__["h" /* fetchRejectAccreditationRequest */])(id));},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_accreditation_pendingAccreditationRequests__["a" /* cleanProcessedStatus */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_accreditation_pendingAccreditationRequests__["b" /* cleanStartAccreditationRequest */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__reducers_accreditation_accreditations__["g" /* clearManagedOrgs */])());},onNext:function onNext(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_accreditation_pendingAccreditationRequests__["x" /* setNextAsStartAccreditationRequestForProcessing */])());},onSetSubmitFormLoading:function onSetSubmitFormLoading(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_submitForm__["b" /* fetchSubmitForm */])());},onGetOrganization:function onGetOrganization(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__reducers_organization_organization__["d" /* fetchGetOrg */])());},onGetManagedOrgs:function onGetManagedOrgs(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__reducers_accreditation_accreditations__["l" /* fetchGetManagedOrgs */])(countryCode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ProcessAccreditationRequest__["a" /* default */]));

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProcessAccreditationRequest_css__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProcessAccreditationRequest_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ProcessAccreditationRequest_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__additionalTitle_AdditionalTitle_container__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_progressBar_AccreditationRequestsProgressBar_container__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__commonComponents_customSelect_CustomSelect__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_cryptoUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__accreditationModal_rejectAccreditationRequestModal_RejectAccreditationRequestModal_container__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__commonComponents_labelWithPages_ProcessAccreditationRequestLabel_container_js__ = __webpack_require__(1068);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var requiredSelectFields=['personCountry','orgId'];var SUCCESS_MESSAGE_PATH={REJECT:'accreditation_requests.reject_accreditation_request_success_message',CONFIRM:'accreditation_requests.confirm_accreditation_request_success_message'};var ProcessAccreditationRequest=function(_Component){_inherits(ProcessAccreditationRequest,_Component);function ProcessAccreditationRequest(props){_classCallCheck(this,ProcessAccreditationRequest);var _this=_possibleConstructorReturn(this,(ProcessAccreditationRequest.__proto__||Object.getPrototypeOf(ProcessAccreditationRequest)).call(this,props));_this.setDataFromProps=function(data){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(data)){var keysArray=["titleOrig","titleEn","level","personFirstName","personLastName","email","personNationalId","orgContinent","orgCountry","orgId"];var state=Object.assign({},_this.getStateValueForArray(keysArray,data),{titlesAdditional:_this.getTitlesAdditional(data.titlesAdditional),dateIssued:__WEBPACK_IMPORTED_MODULE_6_moment___default()(data["dateIssued"]),personCountry:data.personCountry});_this.setState(Object.assign({},state,{originalData:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state)}));_this.props.setContinentByCountry(data.personCountry);}};_this.getStateValueForArray=function(keysArray,originalData){var newValues={};keysArray.forEach(function(key){newValues[key]=originalData[key];});return newValues;};_this.getTitlesAdditional=function(titles){var titlesAdditional=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(titles,function(value,key){titlesAdditional.push({id:__WEBPACK_IMPORTED_MODULE_7_uuid___default()(),lang:key,title:value});});return titlesAdditional;};_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["n" /* Form */],{onSubmit:_this.onSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'next-accreditation-request-for-processing-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'next-accreditation-request-for-processing-button',color:'link',onClick:_this.props.onNext},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.next_accreditation_request_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:7},_this.renderOrganizationFormGroup(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_label')),_this.renderTitlesFormGroups(),_this.renderAccreditationFormGroups(),_this.renderAdditionalTitlesFormGroups()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.person_label')),_this.renderPersonFormGroups())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{onClick:_this.props.onRejectAccreditationRequestShowModal,className:'process-reject-button carrot-red-btn'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.reject_button')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{type:'submit',className:'confirm-accreditation-request olive-green-btn'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.state.newFieldErrors)?'accreditation_requests.confirm_accreditation_request_button':'insert_accreditation.submit_button'))));}else{return null;}};_this.renderOrganizationFormGroup=function(){if(!_this.props.isBava){return null;}var paramsList=[{value:"orgContinent",type:"select",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label),content:[{value:null,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].continents)))),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),onChange:_this.handleOrgContinentChange,popoverParams:{noPopover:true},newField:true},{value:"orgCountry",type:"select",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),content:[{value:null,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.locationData[_this.state.orgContinent],__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].countries)))),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),popoverParams:{noPopover:true},newField:true},{value:"orgId",type:"select",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)+'*',content:_this.props.managedOrgs,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].org_label)),isDisabled:_this.props.loadingManagedOrgs,isRequired:true,popoverParams:{oldValueText:_this.props.data.orgDomain}}];return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{key:'label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].org_label))].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.handleOrgContinentChange=function(selectedOption){_this.setState({orgContinent:selectedOption.value,orgCountry:null,orgId:null});};_this.renderTitlesFormGroups=function(){var paramsList=[{value:"titleOrig",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_orig_label')+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_orig_input_placeholder')},{value:"titleEn",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_en_label')+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.accreditation_title_en_input_placeholder')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.renderAdditionalTitlesFormGroups=function(){var result=[];var title=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'additional-langs-title',key:'additional-langs-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.additional_translations_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'add',className:'add-additional-title-icon olive-green',onClick:_this.addAdditionalTitle,title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.add_additional_translations_label')})));_this.state.titlesAdditional.forEach(function(elem,id){var popoverParams={id:'additional_title_'+id,key:elem.lang,oldValueText:_this.props.data.titlesAdditional[elem.lang],noPopover:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data.titlesAdditional[elem.lang])};var className=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(_this.state.changedFields,'additionalTitle.'+elem.lang)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data.titlesAdditional[elem.lang])?'changed-value':'';result.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__additionalTitle_AdditionalTitle_container__["a" /* default */],{key:elem.id,id:elem.id,lang:elem.lang,title:elem.title,langs:_this.getAvailableLang(elem.id),onChangeLang:_this.handleChangeAdditionalTitleLang,onChangeTitle:_this.handleChangeAdditionalTitle,onRemove:_this.removeAdditionalTitle,inputId:popoverParams.id,inputOnClick:_this.openPopover(elem.lang),inputClassName:className,required:true,autoComplete:'off'}));result.push(_this.renderPopover(popoverParams,'additionalTitle.'+elem.lang));});return result.length!==0?[title].concat(result):[title];};_this.renderAccreditationFormGroups=function(){var params={value:"level",type:'select',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.level_label')+"*",isDisabled:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.levels),content:__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getLevelsOptions(_this.props.levels,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels')),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.level_input_placeholder'),popoverParams:{placement:"left",oldValueText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'levels.'+_this.props.data.level)}};return[_this.renderDateIssued(),_this.getFormGroup(params)];};_this.renderDateIssued=function(){var className=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(_this.state.changedFields,'dateIssued')?'changed-value':'';var params={placement:"top",oldValueText:__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.dateIssued).format("L"),id:'date_issued_id',key:'dateIssued'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:'date-issued'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':'date-issued',sm:3},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.date_issued_label'),'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:_this.openPopover('dateIssued')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_datepicker__["a" /* default */],{id:params.id,className:className,customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],null),selected:_this.state.dateIssued,showMonthDropdown:true,showYearDropdown:true,dropdownMode:'select',required:true,onChange:_this.handleChangeDate,shouldCloseOnSelect:false,maxDate:__WEBPACK_IMPORTED_MODULE_6_moment___default()()})),_this.renderPopover(params,'dateIssued')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:1,className:'question-mark-icon-container',hidden:_this.state.dateIssued.format('L')===__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.dateIssued).format('L')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_iconContainer_IconContainer__["a" /* default */],{className:'question-mark-icon',icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.show_details_label'),onClick:_this.togglePopover(params.key)})));};_this.renderPersonFormGroups=function(){var paramsList=[{value:"personFirstName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)},{value:"personLastName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)},{value:"email",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].isDateHistorical(_this.state.dateIssued)?"":"*"),type:"email",isRequired:!__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].isDateHistorical(_this.state.dateIssued),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)},{value:"personNationalId",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].national_id_label)+"*",isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].national_id_label),popoverHintParams:{hintText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.national_id_hint')},formGroupHintText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.national_id_expose_hint')},{value:"personContinent",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label)+"*",type:'select',content:__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),onChange:_this.handleChangeContinent,isDisabled:!_this.props.continents,popoverParams:{noPopover:true}},{value:"personCountry",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)+"*",type:'select',content:__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isDisabled:!_this.props.countries,popoverParams:{placement:"left",oldValueText:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].countries+"."+_this.props.data.personCountry)}}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.getFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id='review_'+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.kebabCase(params.value);var popoverParams=Object.assign({},params.popoverParams,{id:id,key:params.value});var className=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(_this.state.changedFields,params.value)?'changed-value':'';var status=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(_this.state.changedFields,params.value)&&params.type==='select'&&!params.newField?__WEBPACK_IMPORTED_MODULE_17__commonComponents_customSelect_CustomSelect__["a" /* STATUSES */].ERROR:null;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title,_this.renderHintPopover(params.value,params.popoverHintParams)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:8},params.type==='select'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,selectedOption:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];}),options:params.content,onSelect:params.onChange||_this.handleChangeSelect(params.value),placeholder:params.placeholder,disabled:params.isDisabled,status:status,requiredFieldError:_this.state.requiredFieldError===params.value}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,className:className,value:_this.state[params.value],onChange:params.onChange||_this.handleChange(params.value),placeholder:params.placeholder,disabled:params.isDisabled,required:params.isRequired,autoComplete:'off'}),_this.renderPopover(popoverParams,params.value)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:1,className:'question-mark-icon-container',hidden:_this.state[params.value]===_this.props.data[params.value]||_this.state[params.value]===_this.props.continentCode||params.newField},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_iconContainer_IconContainer__["a" /* default */],{onClick:_this.togglePopover(popoverParams.key),className:'question-mark-icon',icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.show_details_label')}))),params.formGroupHintText?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group-hint',key:params.title+"form-group-hint"},params.formGroupHintText):null];};_this.renderHintPopover=function(fieldName,params){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(params)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'process-accreditation-request-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:fieldName+'-hint',className:'process-accreditation-request-hint-icon-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'question_mark',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].about_label)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Q" /* UncontrolledPopover */],{trigger:'legacy',placement:'top',target:fieldName+'-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["I" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(params.hintText)))));}};_this.renderPopover=function(params,fieldKey){if(!params.noPopover){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["H" /* Popover */],{trigger:'focus',placement:params.placement||"top",target:params.id,isOpen:_this.state.openPopover===params.key&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(_this.state.changedFields,fieldKey),toggle:_this.togglePopover(params.key),key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["I" /* PopoverBody */],{className:'popover-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation.popover.old_value_label'),': ',params.oldValueText||_this.props.data[params.key])));}};_this.openPopover=function(key){return function(){if(_this.state.openPopover!==key){_this.setState({openPopover:key});}};};_this.togglePopover=function(key){return function(){if(_this.state.openPopover===key){_this.setState({openPopover:null});}else{_this.setState({openPopover:key});}};};_this.onSubmit=function(e){e.preventDefault();if(_this.checkRequiredSelectFields()){return;}var fieldErrors=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(_this.state.newFieldErrors);if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(fieldErrors,'dateIssued')){fieldErrors.dateIssued.value=fieldErrors.dateIssued.value.format("YYYY-MM-DD");}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(fieldErrors,'orgId')){fieldErrors['orgCountry']={value:_this.state.orgCountry};var org=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this.props.managedOrgs,function(_ref){var value=_ref.value;return value===fieldErrors['orgId'].value;});fieldErrors['orgId']={value:org?org.label:null};}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(fieldErrors,'titlesAdditional')){fieldErrors.titlesAdditional.value.forEach(function(elem){fieldErrors[elem.lang]={value:elem.title};});fieldErrors=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omit(fieldErrors,'titlesAdditional');}var titles={original:_this.state.titleOrig,en:_this.state.titleEn};_this.state.titlesAdditional.forEach(function(elem){if(elem.lang!==""&&elem.title!=="")titles[elem.lang]=elem.title;});var data={accreditationGroupId:_this.props.groupId,accreditationData:{titles:titles,issuedAt:_this.state.dateIssued.format("YYYY-MM-DD"),level:_this.state.level},verifiedIdentity:{firstName:_this.state.personFirstName,lastName:_this.state.personLastName,countryCode:_this.state.personCountry,nationalId:_this.state.personNationalId},answer:{fieldErrors:fieldErrors}};if(_this.state.email){data["email"]=_this.state.email;}if(_this.state.orgId){data.managedOrgId=_this.state.orgId;}if(_this.props.isSigningRequired){_this.props.onSetSubmitFormLoading();__WEBPACK_IMPORTED_MODULE_18__utils_cryptoUtils__["a" /* CryptoUtils */].signAccreditation(_this.props.signingKey,data).then(function(signingData){_this.props.onSubmit(_this.props.id,signingData);});}else{_this.props.onSubmit(_this.props.id,data);}_this.setState({changedFields:[],successMessage:SUCCESS_MESSAGE_PATH.CONFIRM});};_this.handleFieldErrors=function(fieldKey,newValue){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(_this.state.originalData,fieldKey)){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(_this.state.originalData[fieldKey],newValue)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(_this.state.newFieldErrors,fieldKey)){_this.setState({newFieldErrors:Object.assign({},_this.state.newFieldErrors,_defineProperty({},fieldKey,{value:_this.state.originalData[fieldKey]}))});}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(_this.state.originalData[fieldKey],newValue)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(_this.state.newFieldErrors,fieldKey)){_this.setState({newFieldErrors:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omit(_this.state.newFieldErrors,fieldKey)});}}};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));_this.handleFieldErrors(fieldKey,e.target.value);_this.handleChangeFields(_this.props.data[fieldKey],e.target.value,fieldKey);};};_this.handleChangeDate=function(date){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(date)){return;}_this.setState({dateIssued:date});_this.handleFieldErrors('dateIssued',date);_this.handleChangeFields(__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.dateIssued).format('L'),__WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format('L'),'dateIssued');};_this.handleChangeContinent=function(selectedOption){_this.setState({personCountry:''});_this.props.onContinentSet(selectedOption.value);};_this.handleChangeSelect=function(fieldKey){return function(selectedOption){_this.setState(_defineProperty({},fieldKey,selectedOption.value));_this.handleFieldErrors(fieldKey,selectedOption.value);_this.handleChangeFields(_this.props.data[fieldKey],selectedOption.value,fieldKey);};};_this.handleChangeAdditionalTitle=function(id){return function(e){var newElemLang=null;var newElemTitle=null;var newTitles=_this.state.titlesAdditional.map(function(elem){if(elem.id===id){elem.title=e.target.value;newElemLang=elem.lang;newElemTitle=elem.title;}return elem;});_this.handleFieldErrors('titlesAdditional',newTitles);_this.setState({titlesAdditional:newTitles});_this.handleChangeFields(newElemLang+' '+_this.props.additionalLangs[newElemLang],newElemLang+' '+newElemTitle,'additionalTitle.'+newElemLang);};};_this.handleChangeAdditionalTitleLang=function(id,value){var newTitles=_this.state.titlesAdditional.map(function(elem){if(elem.id===id){elem.lang=value;}return elem;});_this.setState({titlesAdditional:newTitles});};_this.handleChangeFields=function(oldValue,newValue,fieldKey){var changedFields=[].concat(_toConsumableArray(_this.state.changedFields));if(oldValue!==newValue){changedFields=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.union(changedFields,[fieldKey]);}else{changedFields=changedFields.filter(function(field){return field!==fieldKey;});}_this.setState({changedFields:changedFields});};_this.addAdditionalTitle=function(){var newTitle={id:__WEBPACK_IMPORTED_MODULE_7_uuid___default()(),lang:'',title:''};_this.handleFieldErrors('titlesAdditional',[].concat(_toConsumableArray(_this.state.titlesAdditional),[newTitle]));_this.setState({titlesAdditional:[].concat(_toConsumableArray(_this.state.titlesAdditional),[newTitle])});};_this.removeAdditionalTitle=function(id){return function(){var newTitles=_this.state.titlesAdditional.filter(function(elem){return elem.id!==id;});_this.handleFieldErrors('titlesAdditional',newTitles);_this.setState({titlesAdditional:newTitles});};};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(requiredSelectFields,function(field){if(!_this.state[field]&&!error){error=field;}});_this.setState({requiredFieldError:error});return error;};_this.handleRejectAccreditationRequest=function(){_this.props.onRejectAccreditationRequest(_this.props.id);_this.setState({changedFields:[],successMessage:SUCCESS_MESSAGE_PATH.REJECT});};_this.state={titleOrig:'',titleEn:'',titlesAdditional:[],dateIssued:__WEBPACK_IMPORTED_MODULE_6_moment___default()(),level:'',personFirstName:'',personLastName:'',email:'',personContinent:_this.props.continentCode,personCountry:'',personNationalId:'',openPopover:null,requiredFieldError:null,changedFields:[],successMessage:'',orgContinent:null,orgCountry:null,orgId:null,originalData:{},newFieldErrors:{},orgIdOldValue:null};return _this;}_createClass(ProcessAccreditationRequest,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.id){this.props.onGetPendingAccreditationRequest(this.props.id);}this.setDataFromProps(this.props.data);this.props.onGetLevels();this.props.onGetAdditionalLangs();if(this.props.isBava){this.props.onGetManagedOrgs();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onContinentSet('');this.props.onUnmount();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.state.personContinent!==nextProps.continentCode){this.setState({personContinent:nextProps.continentCode});}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.id)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(nextProps.id)&&nextProps.id!==this.props.id){this.setState({openPopover:null});this.props.onGetPendingAccreditationRequest(nextProps.id);}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.id)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(nextProps.id)){this.props.onGetPendingAccreditationRequest(nextProps.id);}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(nextProps.data)){this.setDataFromProps(nextProps.data);}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState,nextContext){var _this2=this;if(this.state.orgCountry!==nextState.orgCountry){this.props.onGetManagedOrgs(nextState.orgCountry);}if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(this.props.managedOrgs,nextProps.managedOrgs)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(nextProps.managedOrgs)&&this.state.orgId&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.some(nextProps.managedOrgs,function(option){return option.value===_this2.state.orgId;})){this.setState({orgId:null});}}},{key:'render',value:function render(){if(!this.props.loading&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.id)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Redirect */],{to:'/pending-accreditation-requests'});}if(this.props.signingKeyLoading||this.props.orgLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}if(this.props.isSigningRequired&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.signingKey)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation_requests.process_accreditation_request')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'carrot-red'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,"insert_accreditation.no_certificate_message_start"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/security'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,"insert_accreditation.no_certificate_message_link")),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,"insert_accreditation.no_certificate_message_end")));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'process-accreditation-request-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,this.state.successMessage)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/pending-accreditation-requests',label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation_requests.back_button')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'process-accreditation-request-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__commonComponents_labelWithPages_ProcessAccreditationRequestLabel_container_js__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation_requests.process_accreditation_request')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'process-accreditation-request-page-hint-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation_requests.pending_accreditation_requests_hint_part_1'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation_requests.pending_accreditation_requests_hint_part_2')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_progressBar_AccreditationRequestsProgressBar_container__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'accreditation_requests.pending_accreditations_progress_label')+':'}),this.renderContent())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__accreditationModal_rejectAccreditationRequestModal_RejectAccreditationRequestModal_container__["a" /* default */],{onReject:this.handleRejectAccreditationRequest}));}},{key:'getAvailableLang',value:function getAvailableLang(id){var disabledLangs=this.state.titlesAdditional.filter(function(elem){return elem.id!==id;}).map(function(elem){return elem.lang;});return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(this.props.additionalLangs).filter(function(lang){return!disabledLangs.includes(lang);});}}]);return ProcessAccreditationRequest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProcessAccreditationRequest.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,groupId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,answer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,additionalLangs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,levels:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,continentCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,massageLabelPath:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,signingKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,signingKeyLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isSigningRequired:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,orgLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isBava:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,loadingManagedOrgs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,managedOrgs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,locationData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onContinentSet:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setContinentByCountry:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetAdditionalLangs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetLevels:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onRejectAccreditationRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onRejectAccreditationRequestShowModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onNext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSetSubmitFormLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetOrganization:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetPendingAccreditationRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onGetManagedOrgs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ProcessAccreditationRequest);

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProgressBar__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_pendingAccreditationRequests__ = __webpack_require__(86);
var mapStateToProps=function mapStateToProps(state){return{left:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_pendingAccreditationRequests__["l" /* getLeftAccreditationRequestsNumber */])(state),validated:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_pendingAccreditationRequests__["m" /* getNumberOfProcessedAccreditationRequests */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__ProgressBar__["a" /* default */]));

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RejectAccreditationRequestModal__ = __webpack_require__(1067);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["b" /* MODAL_ACCREDITATION_REQUESTS_REJECT */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RejectAccreditationRequestModal__["a" /* default */]));

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RejectAccreditationRequestModal=function(_Component){_inherits(RejectAccreditationRequestModal,_Component);function RejectAccreditationRequestModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RejectAccreditationRequestModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RejectAccreditationRequestModal.__proto__||Object.getPrototypeOf(RejectAccreditationRequestModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleReject=function(e){e.preventDefault();_this.props.onReject();_this.props.onCancel();},_this.handleCancel=function(){_this.props.onCancel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RejectAccreditationRequestModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'accreditation-requests-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_requests.reject_accreditation_request_alert')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'carrot-red-btn',onClick:this.handleReject},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,"accreditation_requests.reject_button"))));}}]);return RejectAccreditationRequestModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RejectAccreditationRequestModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onReject:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RejectAccreditationRequestModal);

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LabelWithPages__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_pendingAccreditationRequests__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{left:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_pendingAccreditationRequests__["l" /* getLeftAccreditationRequestsNumber */])(state),processed:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_pendingAccreditationRequests__["m" /* getNumberOfProcessedAccreditationRequests */])(state),currentIndex:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_pendingAccreditationRequests__["k" /* getCurrentAccreditationRequestIndex */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__LabelWithPages__["a" /* default */]));

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GroupsManagementComponent__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onUnmount:function onUnmount(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__GroupsManagementComponent__["a" /* default */]));

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccreditationGroupsList_AccreditationGroupsList_container__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__departmentsList_DepartmentsList_container__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GroupsManagementComponent=function(_Component){_inherits(GroupsManagementComponent,_Component);function GroupsManagementComponent(props){_classCallCheck(this,GroupsManagementComponent);var _this=_possibleConstructorReturn(this,(GroupsManagementComponent.__proto__||Object.getPrototypeOf(GroupsManagementComponent)).call(this,props));_this.setSuccessMessage=function(successMessage){_this.setState({successMessage:successMessage});};_this.state={successMessage:null};return _this;}_createClass(GroupsManagementComponent,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,this.state.successMessage)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'groups-management-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AccreditationGroupsList_AccreditationGroupsList_container__["a" /* default */],{setSuccessMessage:this.setSuccessMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brain-chain-divider'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__departmentsList_DepartmentsList_container__["a" /* default */],{setSuccessMessage:this.setSuccessMessage})));}}]);return GroupsManagementComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);GroupsManagementComponent.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onUnmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (GroupsManagementComponent);

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consentsList_activeConsentsList_ActiveConsentsList_container__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consentsList_priorConsentsList_ActivePriorConsentsList_container__ = __webpack_require__(1082);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CurrentConsents=function(_Component){_inherits(CurrentConsents,_Component);function CurrentConsents(){_classCallCheck(this,CurrentConsents);return _possibleConstructorReturn(this,(CurrentConsents.__proto__||Object.getPrototypeOf(CurrentConsents)).apply(this,arguments));}_createClass(CurrentConsents,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"groups-management-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__consentsList_activeConsentsList_ActiveConsentsList_container__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"brain-chain-divider"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__consentsList_priorConsentsList_ActivePriorConsentsList_container__["a" /* default */],null));}}]);return CurrentConsents;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CurrentConsents);

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActiveConsentsList__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_consent_consents__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_consent_consent__ = __webpack_require__(191);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_consent_consents__["i" /* getConsentsList */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_consent_consents__["s" /* loadingConsents */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_consent_consents__["p" /* getRequestsByStatus */])(__WEBPACK_IMPORTED_MODULE_4__reducers_consent_consents__["a" /* GRANTED */]));},onRemove:function onRemove(id,data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_consent_consent__["c" /* fetchUpdateConsent */])(id,data));},onRemoveButtonClick:function onRemoveButtonClick(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["N" /* MODAL_REMOVE_ACTIVE_CONSENT */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ActiveConsentsList__["a" /* default */]));

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActiveConsentsList_css__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActiveConsentsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ActiveConsentsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__removeActiveConsentModal_RemoveActiveConsentModal_container__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addPeriodPopover_AddPeriodPopover_container__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_consent_consents__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_paginationComponent_PaginationActiveConsents_container__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActiveConsentList=function(_Component){_inherits(ActiveConsentList,_Component);function ActiveConsentList(props){_classCallCheck(this,ActiveConsentList);var _this=_possibleConstructorReturn(this,(ActiveConsentList.__proto__||Object.getPrototypeOf(ActiveConsentList)).call(this,props));_this.renderTable=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'active-consents-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'active-consents-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'consents.no_active_consents_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["N" /* Table */],{className:'active-consents-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'consents.person_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'consents.job_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].company_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'consents.requested_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'consents.valid_till_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderActiveConsentsData()));};_this.renderActiveConsentsData=function(){return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(_this.props.data,function(consentData,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'person-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'consents.person_label')+':'},_this.renderPersonName(consentData)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'job-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'consents.job_label')+':'},consentData.jobTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'company-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].company_label)+':'},consentData.companyName?consentData.companyName+", "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'countries.'+consentData.countryCode):'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'email-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+':'},consentData.email?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+consentData.email},consentData.email):'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'requested-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'consents.requested_label')+':'},__WEBPACK_IMPORTED_MODULE_12_moment___default()(consentData.requestDate).format('LL')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'valid-till-td','data-th':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'consents.valid_till_label')+':'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(consentData.expireDate)?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'consents.periods.forever_label'):__WEBPACK_IMPORTED_MODULE_12_moment___default()(consentData.expireDate).format('LL')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'consent-controls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'revoke-consent-icon-container',onClick:_this.handleRemoveButtonClick(consentData)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'trash',title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'consents.remove_consent_label')}))));});};_this.renderPersonName=function(consentData){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(consentData.firstName)&&__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(consentData.lastName)){return'-';}else if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(consentData.firstName)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(consentData.lastName)){return consentData.lastName;}else if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(consentData.firstName)&&__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(consentData.lastName)){return consentData.firstName;}else{return consentData.firstName+' '+consentData.lastName;}};_this.handleAddButtonClick=function(consent){return function(){_this.setState({consentToExtendId:"edit-consent-icon-container"+consent.id,consentToExtendExpireDate:consent.expireDate});};};_this.closeAddPeriodPopover=function(){_this.setState({consentToExtendId:null,consentToExtendExpireDate:null});};_this.handleExpandConsentButtonClick=function(){_this.setState({consentToExtendId:null,consentToExtendExpireDate:null});//TODO: save new consent period
};_this.handleRemoveButtonClick=function(consentData){return function(){_this.setState({consentToRemoveData:consentData});_this.props.onRemoveButtonClick();};};_this.handleRemoveConsent=function(){var data={status:__WEBPACK_IMPORTED_MODULE_9__reducers_consent_consents__["d" /* REVOKED */]};_this.props.onRemove(_this.state.consentToRemoveData.id,data);};_this.state={isModalOpen:false,consentToRemoveData:null,consentToExtendId:null,consentToExtendExpireDate:null};return _this;}_createClass(ActiveConsentList,[{key:'componentWillMount',value:function componentWillMount(){this.props.onMount();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'active-consents-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'consents.remove_consent_success_label')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'consents.active_consents_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_paginationComponent_PaginationActiveConsents_container__["a" /* default */],null),this.renderTable(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__removeActiveConsentModal_RemoveActiveConsentModal_container__["a" /* default */],{data:this.state.consentToRemoveData,onRemove:this.handleRemoveConsent}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__addPeriodPopover_AddPeriodPopover_container__["a" /* default */],{target:this.state.consentToExtendId,onExpandConsent:this.handleExpandConsentButtonClick,currentExpireDate:this.state.consentToExtendExpireDate,toggle:this.closeAddPeriodPopover,isOpen:!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.state.consentToExtendId)})));}/*Note: no ability to extend consent period in current version
    renderPeriodContainer = (consentData) => {
        if (_.isNil(consentData.expireDate)) {
            return (<div className='period-container'>{_.get(this.props.translation, 'consents.periods.forever_label')}</div>)
        } else {
            return (
                <div className='period-container'>
                    {consentData.expireDate.format('LL')}
                    <span className="edit-consent-icon-container"
                          id={"edit-consent-icon-container" + consentData.id}
                          onClick={this.handleAddButtonClick(consentData)}>
                        <IconContainer icon='add'/>
                    </span>
                </div>
            )
        }
    };*/}]);return ActiveConsentList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ActiveConsentList.propTypes={data:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object),translation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,onMount:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onRemoveButtonClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ActiveConsentList);

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RemoveActiveConsentModal__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["N" /* MODAL_REMOVE_ACTIVE_CONSENT */],translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__RemoveActiveConsentModal__["a" /* default */]));

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveActiveConsentModal_css__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveActiveConsentModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RemoveActiveConsentModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveActiveConsentModal=function(_Component){_inherits(RemoveActiveConsentModal,_Component);function RemoveActiveConsentModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveActiveConsentModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveActiveConsentModal.__proto__||Object.getPrototypeOf(RemoveActiveConsentModal)).call.apply(_ref,[this].concat(args))),_this),_this.renderConsentData=function(){var paramsList=[{title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'consents.person_label'),value:!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(_this.props.data.firstName)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(_this.props.data.lastName)?_this.props.data.firstName+' '+_this.props.data.lastName:null},{title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].company_label),value:_this.props.data.companyName},{title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),value:_this.props.data.country},{title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].email_label),value:_this.props.data.email},{title:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'consents.valid_till_label'),value:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(_this.props.data.expireDate)?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this.props.translation,'consents.periods.forever_label'):__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.props.data.expireDate).format('LL')}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(paramsList,_this.renderConsentDataRow)));},_this.renderConsentDataRow=function(params){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(params.value)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'remove-active-consent-data-row',key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},params.value));},_this.onRemoveHandle=function(){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(_this.props.data)){_this.props.onRemove();}},_this.onCancelHandle=function(){_this.props.onCancel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveActiveConsentModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen,toggle:this.onCancelHandle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'remove-active-consent-alert-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'consents.remove_modal_alert'))),this.renderConsentData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.onCancelHandle},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.onRemoveHandle},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,"consents.remove_consent_button")))));}}]);return RemoveActiveConsentModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveActiveConsentModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveActiveConsentModal);

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddPeriodPopover__ = __webpack_require__(1079);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__AddPeriodPopover__["a" /* default */]));

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__periodSelect_PeriodSelect_container__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddPeriodPopover_css__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddPeriodPopover_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AddPeriodPopover_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_constants__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultPeriodType=__WEBPACK_IMPORTED_MODULE_7__constants_constants__["c" /* AVAILABLE_CONSENT_PERIODS */].MONTH;var defaultPeriodNum='1';var AddPeriodPopover=function(_Component){_inherits(AddPeriodPopover,_Component);function AddPeriodPopover(props){_classCallCheck(this,AddPeriodPopover);var _this=_possibleConstructorReturn(this,(AddPeriodPopover.__proto__||Object.getPrototypeOf(AddPeriodPopover)).call(this,props));_this.handleChange=function(fieldName){return function(e){_this.setState(_defineProperty({},fieldName,e.target.value));};};_this.toggle=function(){_this.setState({periodType:defaultPeriodType,periodNum:defaultPeriodNum});_this.props.toggle();};_this.state={periodType:defaultPeriodType,periodNum:defaultPeriodNum};return _this;}_createClass(AddPeriodPopover,[{key:'render',value:function render(){if(!this.props.isOpen){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["H" /* Popover */],{className:'add-period-popover',key:this.props.target,isOpen:this.props.isOpen,placement:'bottom',toggle:this.toggle,target:this.props.target},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["J" /* PopoverHeader */],{className:'add-period-popover-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'consents.current_expire_date_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.currentExpireDate.format('LL'))),this.renderNextExpireDate()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["I" /* PopoverBody */],{className:'add-period-popover-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__periodSelect_PeriodSelect_container__["a" /* default */],{onPeriodNumChange:this.handleChange('periodNum'),showPopover:false,onPeriodTypeChange:this.handleChange('periodType'),periodType:this.state.periodType,periodNum:this.state.periodNum}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{className:'extend-consent-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',block:true,onClick:this.props.onExpandConsent},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'consents.extend_consent_button'))))));}},{key:'renderNextExpireDate',value:function renderNextExpireDate(){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.props.currentExpireDate)||this.state.periodType===__WEBPACK_IMPORTED_MODULE_7__constants_constants__["c" /* AVAILABLE_CONSENT_PERIODS */].FOREVER){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'consents.next_expire_date_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.props.currentExpireDate).add(this.state.periodNum,this.state.periodType).format('LL')));}}]);return AddPeriodPopover;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AddPeriodPopover.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,target:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,currentExpireDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onExpandConsent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,toggle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (AddPeriodPopover);

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__ = __webpack_require__(44);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__["k" /* getCurrentPageForConsents */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__["q" /* getTotalPagesForConsents */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__["p" /* getRequestsByStatus */])(__WEBPACK_IMPORTED_MODULE_2__reducers_consent_consents__["a" /* GRANTED */],page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PriorConsentsList__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_consent_priorConsents__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_priorConsents__["c" /* loadingPriorConsents */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_priorConsents__["b" /* getPriorConsentsList */])(state),addingDisabled:true,editingDisabled:true};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_priorConsents__["g" /* setFilterDate */])(__WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(1,'day').endOf('day').toISOString()));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_priorConsents__["e" /* onGetPriorConsents */])());},onRemoveIconClick:function onRemoveIconClick(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_0" /* MODAL_REMOVE_PRIOR_CONSENT */]}));},onUnmount:function onUnmount(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_consent_priorConsents__["f" /* resetPriorConsentsData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__PriorConsentsList__["b" /* default */]));

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnchorSecurityComponent__ = __webpack_require__(1084);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__AnchorSecurityComponent__["a" /* default */]));

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnchorSecurityComponent_css__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnchorSecurityComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AnchorSecurityComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_storageApi__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AnchorSecurityComponent=function(_Component){_inherits(AnchorSecurityComponent,_Component);function AnchorSecurityComponent(props){_classCallCheck(this,AnchorSecurityComponent);var _this=_possibleConstructorReturn(this,(AnchorSecurityComponent.__proto__||Object.getPrototypeOf(AnchorSecurityComponent)).call(this,props));_this.onGotItClick=function(){__WEBPACK_IMPORTED_MODULE_4__utils_storageApi__["a" /* StorageApi */].setAnchorSecurityGotIt();_this.setState({isAnchorSecurityGotIt:true});};_this.state={isAnchorSecurityGotIt:__WEBPACK_IMPORTED_MODULE_4__utils_storageApi__["a" /* StorageApi */].getAnchorSecurityGotIt()};return _this;}_createClass(AnchorSecurityComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'anchor-security-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security.anchor_info_part_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security.anchor_info_part_2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security.anchor_info_part_3'))),!this.state.isAnchorSecurityGotIt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["c" /* Button */],{className:'got-it-button olive-green-btn',onClick:this.onGotItClick},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security.got_it_button'))):null);}}]);return AnchorSecurityComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AnchorSecurityComponent.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (AnchorSecurityComponent);

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InsertorSecurityComponent__ = __webpack_require__(1087);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__InsertorSecurityComponent__["a" /* default */]));

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InsertorSecurityComponent_css__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InsertorSecurityComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InsertorSecurityComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__insertCertificate_InsertCertificate_container__ = __webpack_require__(1089);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InsertorSecurityComponent=function(_Component){_inherits(InsertorSecurityComponent,_Component);function InsertorSecurityComponent(){_classCallCheck(this,InsertorSecurityComponent);return _possibleConstructorReturn(this,(InsertorSecurityComponent.__proto__||Object.getPrototypeOf(InsertorSecurityComponent)).apply(this,arguments));}_createClass(InsertorSecurityComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insertor-security-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security.inserter_info_part_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security.inserter_info_part_2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security.inserter_info_part_3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security.inserter_info_part_4'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__insertCertificate_InsertCertificate_container__["a" /* default */],null));}}]);return InsertorSecurityComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InsertorSecurityComponent.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (InsertorSecurityComponent);

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InsertCertificate__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_certificate__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__ = __webpack_require__(29);
var mapStateToProps=function mapStateToProps(state){return{signingKey:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_certificate__["d" /* getKey */])(state),isSigningRequired:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organization__["v" /* isAccreditationSigningRequired */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onInsertKey:function onInsertKey(jwk){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_certificate__["c" /* fetchPutKey */])(jwk));},onSetLoading:function onSetLoading(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["b" /* fetchSubmitForm */])());},onStopLoading:function onStopLoading(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__InsertCertificate__["a" /* default */]));

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InsertCertificate_css__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InsertCertificate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__InsertCertificate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dropzone__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_formWrapper_FormWrapper_container_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_utils__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InsertCertificate=function(_Component){_inherits(InsertCertificate,_Component);function InsertCertificate(props){_classCallCheck(this,InsertCertificate);var _this=_possibleConstructorReturn(this,(InsertCertificate.__proto__||Object.getPrototypeOf(InsertCertificate)).call(this,props));_this.formatIsCorrect=function(file){return file.name.endsWith('.jwk');};_this.onDragEnter=function(){_this.setState({isEnter:true});_this.cleanState();};_this.onDragLeave=function(){_this.setState({isEnter:false});};_this.onDrop=function(filesArray){_this.setState({isEnter:false});if(filesArray.length!==1){_this.setState({error:true});return;}var file=filesArray[0];if(_this.formatIsCorrect(file)){_this.props.onSetLoading();var reader=new FileReader();reader.readAsText(file);reader.onloadend=function(){var data=JSON.parse(reader.result);_this.setState({file:file,fileContent:data});_this.props.onStopLoading();};}else{_this.setState({error:true});}};_this.onAddCertificate=function(){_this.props.onInsertKey(_this.state.fileContent);};_this.cleanState=function(){_this.setState({file:null,fileContent:null,error:false});};_this.handleChangeCertificateMode=function(value){return function(){_this.setState({isChangeCertificateMode:value});};};_this.state={isEnter:false,file:null,fileContent:null,error:false,fetching:false,isChangeCertificateMode:false};return _this;}_createClass(InsertCertificate,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.props.signingKey)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(nextProps.signingKey)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(this.props.signingKey,nextProps.signingKey)){this.setState({isChangeCertificateMode:false});}}},{key:'render',value:function render(){if(this.props.fetching){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.props.signingKey)&&!this.state.isChangeCertificateMode){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insert-certificate-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center olive-green'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'certificate.key_already_installed_button')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reinsert-certificate-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleChangeCertificateMode(true)},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'certificate.change_certificate_button'))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insert-certificate-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_formWrapper_FormWrapper_container_js__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'certificate.insert_certificate_about_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_dropzone__["a" /* default */],{className:'certificate-drop-zone',activeClassName:'certificate-drop-zone-active',onDrop:this.onDrop,multiple:false,onDragEnter:this.onDragEnter,onDragLeave:this.onDragLeave,onClick:this.cleanState},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'certificate-drop-zone-content-container '+(this.state.isEnter?'certificate-drop-zone-content-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.drag_and_drop_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.or_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getTagsFromStringWithStyles(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.browse_label'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'certificate-result-label'},this.state.error?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.error_label'):"",!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.state.file)?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'bulk_upload.uploaded_file_label')+": "+this.state.file.name:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"insert-certificate-button-container "+(this.state.isChangeCertificateMode?"two-buttons":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleChangeCertificateMode(false),hidden:!this.state.isChangeCertificateMode},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].back_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["c" /* Button */],{className:'olive-green-btn',type:'submit',onClick:this.onAddCertificate,disabled:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.state.fileContent)},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'certificate.insert_key_button')))));}}]);return InsertCertificate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InsertCertificate.propTypes={translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onInsertKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onSetLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onStopLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (InsertCertificate);

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdminSecurityComponent__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_organization_orgsWithoutCertificates__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_orgsWithoutCertificates__["h" /* loadingOrgsWithoutCertificates */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_orgsWithoutCertificates__["f" /* getOrgsWithoutCertificatesFormattedData */])(state),certificatesData:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_orgsWithoutCertificates__["e" /* getFirstCertificatesData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_orgsWithoutCertificates__["c" /* fetchGetOrgsWithoutCertificates */])());},onAddCertificate:function onAddCertificate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["k" /* MODAL_ADD_ORG_FIRST_CERTIFICATE */]}));},onConfirmSent:function onConfirmSent(orgId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_orgsWithoutCertificates__["i" /* removeOrgWithoutCertificatesFromPage */])(orgId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__AdminSecurityComponent__["a" /* default */]));

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdminSecurityComponent_css__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdminSecurityComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AdminSecurityComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__organizationManagement_certificatesManagement_globalCertificates_GlobalCertificates_container__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_paginationComponent_PaginationOrgsWithoutCertificates_container__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__organizationManagement_certificatesManagement_addCertificateModal_AddOrgFirstCertificateModal_container__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NEW_LINE_ELEM="\r\n";var AdminSecurityComponent=function(_Component){_inherits(AdminSecurityComponent,_Component);function AdminSecurityComponent(props){_classCallCheck(this,AdminSecurityComponent);var _this=_possibleConstructorReturn(this,(AdminSecurityComponent.__proto__||Object.getPrototypeOf(AdminSecurityComponent)).call(this,props));_this.renderOrgsTable=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_7__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.no_data_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["N" /* Table */],{className:'orgs-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.org_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.anchor_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security.add_valid_till_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security.is_uni_key_sent_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderOrgsData()));};_this.renderOrgsData=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_this.props.data,function(orgData,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'orgs-table-row',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'org-name-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.org_label')+":"},orgData.orgName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'anchor-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'orgs.anchor_label')+":"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,orgData.anchorName+'\n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:_this.handleMailtoLinkClick,href:"mailto:"+orgData.anchorEmail},orgData.anchorEmail)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'add-valid-till-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security.add_valid_till_label')+":"},_this.props.certificatesData&&_this.props.certificatesData[orgData.id]?__WEBPACK_IMPORTED_MODULE_9_moment___default()(_this.props.certificatesData[orgData.id].validTill).format("MMMM Do YYYY, HH:mm"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:_this.onAddCertificateButtonClick(orgData.id),size:'sm'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security.add_certificate_button'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'mail-to-anchor-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn olive-green-btn btn-sm '+(_this.props.certificatesData&&_this.props.certificatesData[orgData.id]?"":"disabled"),href:_this.getMailToHref(orgData.anchorEmail,orgData.anchorName),onClick:_this.onMailAnchorButtonClick(orgData.id)},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security.mail_anchor_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'confirm-mail-to-anchor-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:_this.onConfirmSentButtonClick(orgData.id),disabled:!_this.state.isConfirmButtonEnabledData[orgData.id],size:'sm'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security.confirm_sent_button'))));});};_this.getMailToHref=function(anchorEmail,anchorName){var str="mailto:"+anchorEmail+"?subject="+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security.mail_subject_label')+"&body="+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security.mail_body_part_1').replace('{anchor}',anchorName)+NEW_LINE_ELEM+NEW_LINE_ELEM+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security.mail_body_part_2')+NEW_LINE_ELEM+NEW_LINE_ELEM+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security.mail_body_part_3')+NEW_LINE_ELEM+NEW_LINE_ELEM+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security.mail_body_part_4')+NEW_LINE_ELEM+NEW_LINE_ELEM+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security.mail_body_part_5')+NEW_LINE_ELEM+NEW_LINE_ELEM+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'security.mail_body_part_6');return encodeURI(str);};_this.onAddCertificateButtonClick=function(orgId){return function(){_this.setState({orgId:orgId});_this.props.onAddCertificate();};};_this.onMailAnchorButtonClick=function(orgId){return function(){var data=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(_this.state.isConfirmButtonEnabledData);data[orgId]=true;_this.setState({isConfirmButtonEnabledData:data});};};_this.onConfirmSentButtonClick=function(orgId){return function(){_this.props.onConfirmSent(orgId);};};_this.state={orgId:null,isConfirmButtonEnabledData:{}};return _this;}_createClass(AdminSecurityComponent,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'admin-security-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security.label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'admin-security-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security.admin_root_certificates_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__organizationManagement_certificatesManagement_globalCertificates_GlobalCertificates_container__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'admin-security-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security.admin_universities_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'admin-security-info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security.admin_universities_info_part_1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'security.admin_universities_info_part_2'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_paginationComponent_PaginationOrgsWithoutCertificates_container__["a" /* default */],null),this.renderOrgsTable(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__organizationManagement_certificatesManagement_addCertificateModal_AddOrgFirstCertificateModal_container__["a" /* default */],{orgId:this.state.orgId}));}}]);return AdminSecurityComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AdminSecurityComponent.propTypes={loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,certificatesData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onAddCertificate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onConfirmSent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AdminSecurityComponent);

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GlobalCertificates__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_organization_orgCertificate__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),fetching:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_orgCertificate__["l" /* loadingCertificate */])(state),certificates:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_orgCertificate__["i" /* getGlobalCertificates */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGetGlobalCertificates:function onGetGlobalCertificates(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_orgCertificate__["d" /* fetchGetGlobalCertificates */])(data));},onAddCertificate:function onAddCertificate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["g" /* MODAL_ADD_CERTIFICATE */]}));},onRemoveCertificate:function onRemoveCertificate(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["T" /* MODAL_REMOVE_CERTIFICATE */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__GlobalCertificates__["a" /* default */]));

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GlobalCertificates_css__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GlobalCertificates_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__GlobalCertificates_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addCertificateModal_AddGlobalCertificateModal_container__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__removeCertificateModal_RemoveGlobalCertificateModal_container__ = __webpack_require__(1099);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GlobalCertificates=function(_Component){_inherits(GlobalCertificates,_Component);function GlobalCertificates(props){_classCallCheck(this,GlobalCertificates);var _this=_possibleConstructorReturn(this,(GlobalCertificates.__proto__||Object.getPrototypeOf(GlobalCertificates)).call(this,props));_this.renderContent=function(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(_this.props.certificates)||_this.props.certificates.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'certificate.no_data_label'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["N" /* Table */],{className:'global-certificates-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'certificate.created_at_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'certificate.valid_from_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'certificate.valid_till_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderCertificatesData())));};_this.renderCertificatesData=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_this.props.certificates,function(certificateData,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'certificate-created-at-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'certificate.created_at_label')+":"},__WEBPACK_IMPORTED_MODULE_9_moment___default()(certificateData.createdAt).format("MMMM Do YYYY, HH:mm")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'certificate-valid-from-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'certificate.valid_from_label')+":"},__WEBPACK_IMPORTED_MODULE_9_moment___default()(certificateData.validFrom).format("MMMM Do YYYY, HH:mm")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'certificate-valid-till-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'certificate.valid_till_label')+":"},__WEBPACK_IMPORTED_MODULE_9_moment___default()(certificateData.validTill).format("MMMM Do YYYY, HH:mm")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'certificate-remove-icon-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:index,icon:'trash',className:'certificate-remove-icon',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button),onClick:_this.onRemoveCertificate(certificateData.id)})));});};_this.onRemoveCertificate=function(certId){return function(){_this.setState({certId:certId});_this.props.onRemoveCertificate();};};_this.state={certId:null};return _this;}_createClass(GlobalCertificates,[{key:'componentWillMount',value:function componentWillMount(){this.props.onGetGlobalCertificates();}},{key:'render',value:function render(){if(this.props.fetching){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-certificates-container'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.certificates)||this.props.certificates.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center carrot-red'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'certificate.no_root_certificate_label')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'certificate.root_certificate_hint')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-global-certificate-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.props.onAddCertificate},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].add_button))),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__addCertificateModal_AddGlobalCertificateModal_container__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__removeCertificateModal_RemoveGlobalCertificateModal_container__["a" /* default */],{certId:this.state.certId}));}}]);return GlobalCertificates;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);GlobalCertificates.propTypes={certificates:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,onGetGlobalCertificates:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onAddCertificate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onRemoveCertificate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (GlobalCertificates);

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddCertificateModal__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_orgCertificate__ = __webpack_require__(58);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["g" /* MODAL_ADD_CERTIFICATE */],translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAddCertificate:function onAddCertificate(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_orgCertificate__["b" /* fetchAddGlobalCertificate */])(data));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onSetLoading:function onSetLoading(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["b" /* fetchSubmitForm */])());},onStopLoading:function onStopLoading(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AddCertificateModal__["a" /* default */]));

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RemoveCertificateModal__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_orgCertificate__ = __webpack_require__(58);
var mapStateToProps=function mapStateToProps(state,_ref){var certId=_ref.certId;return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["T" /* MODAL_REMOVE_CERTIFICATE */],translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state),certificate:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_orgCertificate__["h" /* getGlobalCertificateDataById */])(state,certId)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onRemoveCertificate:function onRemoveCertificate(certId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_orgCertificate__["f" /* fetchRemoveGlobalCertificate */])(certId));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__RemoveCertificateModal__["a" /* default */]));

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_organization_orgsWithoutCertificates__ = __webpack_require__(145);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_orgsWithoutCertificates__["d" /* getCurrentPageForOrgsWithoutCertificates */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_orgsWithoutCertificates__["g" /* getTotalPagesForOrgsWithoutCertificates */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_orgsWithoutCertificates__["c" /* fetchGetOrgsWithoutCertificates */])(page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddCertificateModal__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_orgsWithoutCertificates__ = __webpack_require__(145);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["k" /* MODAL_ADD_ORG_FIRST_CERTIFICATE */],translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAddCertificate:function onAddCertificate(data,orgId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_organization_orgsWithoutCertificates__["b" /* fetchAddFirstOrgCertificate */])(orgId,data));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onSetLoading:function onSetLoading(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["b" /* fetchSubmitForm */])());},onStopLoading:function onStopLoading(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AddCertificateModal__["a" /* default */]));

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrgsPaymentsList__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_location__ = __webpack_require__(21);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["P" /* loadingOrgs */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["N" /* getValidatedOrgsPaymentsData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["d" /* getContinentsData */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["f" /* getCurrentContinent */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["e" /* getCountriesData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["m" /* fetchGetValidatedOrgs */])());},onChangeBalance:function onChangeBalance(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["t" /* MODAL_CHANGE_ORG_BALANCE */]}));},onChangeCountryFilter:function onChangeCountryFilter(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_organization_organizations__["m" /* fetchGetValidatedOrgs */])(null,countryCode));},onSetContinent:function onSetContinent(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__OrgsPaymentsList__["a" /* default */]));

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrgsPaymentsList_css__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrgsPaymentsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OrgsPaymentsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_paginationComponent_PaginationOrgs_container__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__changeBalanceModal_ChangeBalanceModal_container__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrgsPaymentList=function(_Component){_inherits(OrgsPaymentList,_Component);function OrgsPaymentList(props){_classCallCheck(this,OrgsPaymentList);var _this=_possibleConstructorReturn(this,(OrgsPaymentList.__proto__||Object.getPrototypeOf(OrgsPaymentList)).call(this,props));_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.no_data_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["N" /* Table */],{className:'orgs-payments-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.org_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.org_type_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.anchor_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.location_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'finance.paid_till_date_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'finance.balance_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderOrgsData()));};_this.renderContinentAndCountryFilter=function(){var continentsOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_13__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continents))));var countriesOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_13__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].countries))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filters-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'continent-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continent_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'continent-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(continentsOptions,function(option){return option.value===_this.props.continentCode||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(option.value)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.props.continentCode);}),options:continentsOptions,onSelect:_this.handleChangeContinentSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'country-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'country-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(countriesOptions,function(option){return option.value===_this.state.countryFilter;}),options:countriesOptions,onSelect:_this.handleChangeCountrySelect})));};_this.handleChangeContinentSelect=function(selectedOption){_this.props.onSetContinent(selectedOption.value);if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.state.countryFilter)){_this.setState({countryFilter:null});_this.props.onChangeCountryFilter(null);}};_this.handleChangeCountrySelect=function(selectedOption){_this.setState({countryFilter:selectedOption.value});_this.props.onChangeCountryFilter(selectedOption.value);};_this.renderOrgsData=function(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(_this.props.data,function(orgData,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:"orgs-payments-list-row "+(orgData.active?"":"not-active"),key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'org-name-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.org_label')+":",onClick:_this.handleTableRowClick(orgData.id)},orgData.orgName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'org-type-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.org_type_label')+":",onClick:_this.handleTableRowClick(orgData.id)},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */][__WEBPACK_IMPORTED_MODULE_12__reducers_organization_organizations__["c" /* LABEL_PATH_BY_ORG_TYPE */][orgData.orgType]])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'anchor-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.anchor_label')+":",onClick:_this.handleTableRowClick(orgData.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,orgData.anchorName+'\n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:_this.handleMailtoLinkClick,href:"mailto:"+orgData.anchorEmail},orgData.anchorEmail)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'location-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.location_label')+":",onClick:_this.handleTableRowClick(orgData.id)},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'countries.'+orgData.location)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'paid-till-date-td'+(!__WEBPACK_IMPORTED_MODULE_7_moment___default()(orgData.paidTillDate).isSameOrAfter(__WEBPACK_IMPORTED_MODULE_7_moment___default()().startOf('day'))?' invalid':''),'data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'finance.paid_till_date_label')+":",onClick:_this.handleTableRowClick(orgData.id)},!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(orgData.paidTillDate)?__WEBPACK_IMPORTED_MODULE_7_moment___default()(orgData.paidTillDate).format("L"):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'balance-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'finance.balance_label')+":"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,orgData.balance.amount+__WEBPACK_IMPORTED_MODULE_9__constants_constants__["g" /* CURRENCIES */][orgData.balance.currency]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{className:'btn-sm',color:'link',onClick:_this.onChangeBalanceClick(orgData)},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'finance.change_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'orgs-payments-list-create-icon-td',onClick:_this.handleTableRowClick(orgData.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:index,icon:'create',className:'orgs-payments-list-create-icon',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].edit_button)})));});};_this.onChangeBalanceClick=function(data){return function(){_this.setState({editBalanceData:{id:data.id,balance:data.balance.amount,balanceCurrency:data.balance.currency}});_this.props.onChangeBalance();};};_this.handleTableRowClick=function(orgId){return function(){_this.setState({selectedOrgId:orgId});};};_this.state={editBalanceData:null,selectedOrgId:null,countryFilter:null};return _this;}_createClass(OrgsPaymentList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onSetContinent(null);}},{key:'render',value:function render(){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.state.selectedOrgId)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["d" /* Redirect */],{to:'/organization-payments?id='+this.state.selectedOrgId,push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-payments-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'orgs.orgs_payments_list_label')),this.renderContinentAndCountryFilter(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_paginationComponent_PaginationOrgs_container__["a" /* default */],{validated:true,countryFilter:this.state.countryFilter}),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__changeBalanceModal_ChangeBalanceModal_container__["a" /* default */],{data:this.state.editBalanceData}));}}]);return OrgsPaymentList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OrgsPaymentList.propTypes={translation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,data:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,loading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,onMount:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onChangeBalance:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onSetContinent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onChangeCountryFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (OrgsPaymentList);

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangeBalanceModal__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_finance_currencies__ = __webpack_require__(67);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["t" /* MODAL_CHANGE_ORG_BALANCE */],currenciesData:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_finance_currencies__["e" /* getCurrenciesData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onChangeBalance:function onChangeBalance(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_organization_organizations__["h" /* fetchChangeOrgBalance */])(id,data));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ChangeBalanceModal__["a" /* default */]));

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChangeBalanceModal_css__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChangeBalanceModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ChangeBalanceModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var INCREASE='INCREASE';var DECREASE='DECREASE';var ChangeBalanceModal=function(_Component){_inherits(ChangeBalanceModal,_Component);function ChangeBalanceModal(props){_classCallCheck(this,ChangeBalanceModal);var _this=_possibleConstructorReturn(this,(ChangeBalanceModal.__proto__||Object.getPrototypeOf(ChangeBalanceModal)).call(this,props));_this.submitButtonDisabled=function(){return _this.state.amount<=0;};_this.handleChange=function(fieldKey){return function(e){_this.setState(_defineProperty({},fieldKey,e.target.value));};};_this.handleChangeSelect=function(fieldKey){return function(selectedOption){_this.setState(_defineProperty({},fieldKey,selectedOption.value));};};_this.handleChangeAmount=function(e){_this.setState({amount:e.target.value});};_this.handleBlur=function(){var newValue=Number(_this.state.amount);var newMode=_this.state.mode;if(Number(newValue)<0){newValue=-newValue;newMode=newMode===INCREASE?DECREASE:INCREASE;}_this.setState({amount:newValue.toFixed(2),mode:newMode});};_this.handleKeyDown=function(e){if(e.key==='Enter'){e.preventDefault();}};_this.getCurrencySelectedOption=function(){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getCurrenciesOptions(_this.props.currenciesData),function(currency){return currency.value===_this.state.currency;});};_this.onSubmit=function(e){e.preventDefault();if(Number(_this.state.amount)>0){var data={delta:{amount:(_this.state.mode===DECREASE?"-":"")+_this.state.amount,currency:_this.state.currency}};if(_this.state.comment!==''){data['comment']=_this.state.comment;}_this.props.onChangeBalance(_this.props.data.id,data);}};_this.cleanData=function(){_this.setState({mode:INCREASE,amount:Number(1).toFixed(2),comment:''});};_this.state={mode:INCREASE,amount:Number(1).toFixed(2),currency:'USD',comment:''};return _this;}_createClass(ChangeBalanceModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.data)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(nextProps.data,this.props.data)){this.setState({currency:nextProps.data.balanceCurrency});this.cleanData();}if(this.props.isOpen&&!nextProps.isOpen){this.cleanData();}}},{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.currenciesData)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen,toggle:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],{onSubmit:this.onSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'finance.change_balance_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'current-balance-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'finance.balance_label')+": "),this.props.data.balance+__WEBPACK_IMPORTED_MODULE_7__constants_constants__["g" /* CURRENCIES */][this.props.data.balanceCurrency]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{className:'change-balance-modal-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'finance.change_balance_modal_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{selectedOption:{value:this.state.mode,label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'finance.'+this.state.mode.toLowerCase()+'_label')},options:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getOptions([{code:INCREASE,name:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'finance.increase_label')},{code:DECREASE,name:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'finance.decrease_label')}]),onSelect:this.handleChangeSelect("mode"),isSearchable:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4,className:"change-balance-amount-container change-balance-amount-container-"+(this.state.mode===INCREASE?"increase":"decrease")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{className:"change-balance-amount-input "+(this.state.mode===INCREASE?"change-balance-amount-input-increase":"change-balance-amount-input-decrease"),type:'number',min:0,step:'any',value:this.state.amount,onChange:this.handleChangeAmount,onBlur:this.handleBlur,onKeyDown:this.handleKeyDown,required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:3,className:'change-balance-currency-select-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{selectedOption:this.getCurrencySelectedOption(),options:__WEBPACK_IMPORTED_MODULE_4__utils_utils__["a" /* Utils */].getCurrenciesOptions(this.props.currenciesData),onSelect:this.handleChangeSelect("currency"),isSearchable:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["r" /* Input */],{type:'textarea',value:this.state.comment,onChange:this.handleChange("comment"),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'finance.balance_change_comment_placeholder'),required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',disabled:this.submitButtonDisabled(),type:'submit'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'finance.change_balance_submit_button')))));}}]);return ChangeBalanceModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ChangeBalanceModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,currenciesData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onChangeBalance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ChangeBalanceModal);

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrgPaymentsDetails__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_utils__ = __webpack_require__(12);
var mapStateToProps=function mapStateToProps(state,_ref){var location=_ref.location;return{id:__WEBPACK_IMPORTED_MODULE_5__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search).id,data:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["E" /* getOrgDataToEditPayments */])(state),orgName:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["G" /* getOrgName */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["O" /* loadingOrg */])(state),fetchingError:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["y" /* getFetchingErrorOrg */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["k" /* fetchGetOrgDataById */])(id));},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_organization_organizations__["d" /* clearOrgData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__OrgPaymentsDetails__["a" /* default */]));

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orgFinanceManagement_OrgFinanceManagement_container__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_pageNotFoundComponent_PageNotFoundComponent_container__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OrgPaymentsDetails_css__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OrgPaymentsDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__OrgPaymentsDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_organization_organizations__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrgPaymentsDetails=function(_Component){_inherits(OrgPaymentsDetails,_Component);function OrgPaymentsDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OrgPaymentsDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OrgPaymentsDetails.__proto__||Object.getPrototypeOf(OrgPaymentsDetails)).call.apply(_ref,[this].concat(args))),_this),_this.renderOrgData=function(){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)){return;}var paramsList=[{key:"orgType",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.org_type_label'),value:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */][__WEBPACK_IMPORTED_MODULE_10__reducers_organization_organizations__["c" /* LABEL_PATH_BY_ORG_TYPE */][_this.props.data.orgType]])},{key:"orgName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'orgs.name_label'),value:_this.props.data.orgName},{key:"anchor",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,"orgs.anchor_label"),value:{name:_this.props.data.anchorName,email:_this.props.data.anchorEmail}},{key:"continent",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].continent_label),value:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'continents.'+_this.props.data.orgContinent)},{key:"country",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),value:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'countries.'+_this.props.data.orgCountry)}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getDataRow)));},_this.getAnchorDataRow=function(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["L" /* Row */],{className:'org-details-form-field-container',key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["h" /* Col */],{sm:4},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["h" /* Col */],null,params.value.name+', ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+params.value.email},params.value.email)));},_this.getDataRow=function(params){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(params.value)){return null;}if(params.key==="anchor"){return _this.getAnchorDataRow(params);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["L" /* Row */],{className:'org-details-form-field-container',key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["h" /* Col */],{sm:4},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["h" /* Col */],null,params.value));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OrgPaymentsDetails,[{key:'componentWillMount',value:function componentWillMount(){this.props.onMount(this.props.id);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}},{key:'render',value:function render(){if(this.props.fetchingError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_pageNotFoundComponent_PageNotFoundComponent_container__["a" /* default */],null);}if(this.props.loading&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-details-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-details-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'finance.change_finance_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'org-details-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/organizations-payments',label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["h" /* sharedLabelsPath */].back_button)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},this.props.orgName,' ',__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'finance.label')),this.renderOrgData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__orgFinanceManagement_OrgFinanceManagement_container__["a" /* default */],{id:this.props.id}))));}}]);return OrgPaymentsDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OrgPaymentsDetails.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,orgName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,fetchingError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUnmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (OrgPaymentsDetails);

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AssistantsList__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_assistant_assistants__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_assistant_assistants__["d" /* loadingAssistants */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_assistant_assistants__["c" /* geAssistantsFormattedData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_assistant_assistants__["b" /* fetchGetAssistants */])());},onRemoveButtonClick:function onRemoveButtonClick(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["P" /* MODAL_REMOVE_ASSISTANT */]}));},onEditButtonClick:function onEditButtonClick(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["B" /* MODAL_EDIT_ASSISTANT */]}));},onResetSubmitFormData:function onResetSubmitFormData(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["k" /* resetSubmitFormData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AssistantsList__["a" /* default */]));

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AssistantsList_css__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AssistantsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AssistantsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__removeAssistantModal_RemoveAssistantModal_container__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__editAssistantModal_EditAssistantModal_container__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AssistantsList=function(_Component){_inherits(AssistantsList,_Component);function AssistantsList(props){_classCallCheck(this,AssistantsList);var _this=_possibleConstructorReturn(this,(AssistantsList.__proto__||Object.getPrototypeOf(AssistantsList)).call(this,props));_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'assistants-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'assistants-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'assistants.no_data_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["N" /* Table */],{className:'assistants-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].name_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'assistants.roles_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'assistants.location_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderOrgsData()));};_this.getRolesLabel=function(roles){return roles.map(function(role){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'assistants.'+role+'_label');}).join(', ');};_this.renderOrgsData=function(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(_this.props.data,function(assistantData,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:"assistants-list-row",key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'name-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].name_label)+":"},assistantData.firstName+' '+assistantData.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'role-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'assistants.roles_label')+":"},_this.getRolesLabel(assistantData.roles)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'assistants-create-icon-td'},assistantData.hasRootPermission?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:index,icon:'create',className:'assistants-create-icon',onClick:_this.onEditButtonClick(assistantData),title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].edit_button)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'email-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+":"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+assistantData.email},assistantData.email)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'location-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'assistants.location_label')+":"},assistantData.countryCode?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'countries.'+assistantData.countryCode):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'assistants-remove-icon-td'},assistantData.hasRootPermission?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__["a" /* default */],{onClick:_this.onRemoveButtonClick(assistantData),key:index,icon:'trash',className:'assistants-remove-icon',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button)})));});};_this.onRemoveButtonClick=function(assistant){return function(){_this.setState({selectedAssistant:assistant});_this.props.onRemoveButtonClick();};};_this.onEditButtonClick=function(assistant){return function(){_this.setState({selectedAssistant:assistant});_this.props.onEditButtonClick();};};_this.handleCloseModal=function(){_this.setState({selectedAssistant:null});};_this.state={selectedAssistant:null};return _this;}_createClass(AssistantsList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'assistants-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'assistants.assistants_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{tag:__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],to:'/add-assistant',onClick:this.props.onResetSubmitFormData,className:'add-assistant-button olive-green-btn'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].add_button))),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__removeAssistantModal_RemoveAssistantModal_container__["a" /* default */],{data:this.state.selectedAssistant,onCancelRemoving:this.handleCloseModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__editAssistantModal_EditAssistantModal_container__["a" /* default */],{data:this.state.selectedAssistant,onCancelEditing:this.handleCloseModal})));}}]);return AssistantsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var AssistantShape=__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,roles:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,firstName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,lastName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,email:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,countryCode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string});AssistantsList.propTypes={translation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,loading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(AssistantShape),onMount:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onRemoveButtonClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onEditButtonClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onResetSubmitFormData:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AssistantsList);

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveAssistantModal__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_assistant_assistants__ = __webpack_require__(112);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["P" /* MODAL_REMOVE_ASSISTANT */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAssistantRemove:function onAssistantRemove(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_assistant_assistants__["g" /* onRemoveAssistant */])(id));},onClose:function onClose(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RemoveAssistantModal__["a" /* default */]));

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_constants__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveAssistantModal=function(_Component){_inherits(RemoveAssistantModal,_Component);function RemoveAssistantModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveAssistantModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveAssistantModal.__proto__||Object.getPrototypeOf(RemoveAssistantModal)).call.apply(_ref,[this].concat(args))),_this),_this.renderData=function(){var paramsList=[{key:"role",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'assistants.role_label'),value:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'assistants.'+__WEBPACK_IMPORTED_MODULE_5__constants_constants__["b" /* ASSISTANT_TYPES */][_this.props.data.role]+'_label')},{key:"firstName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),value:_this.props.data.firstName},{key:"lastName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),value:_this.props.data.lastName},{key:"email",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].email_label),value:_this.props.data.email},{key:"country",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),value:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'countries.'+_this.props.data.countryCode)}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getDataRow)));},_this.getDataRow=function(params){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(params.value)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container',key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,params.value));},_this.handleRemove=function(e){e.preventDefault();_this.props.onAssistantRemove(_this.props.data.id);_this.props.onClose();},_this.handleCancel=function(){_this.props.onClose();_this.props.onCancelRemoving();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveAssistantModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'assistant-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'assistants.remove_assistant_alert')),this.renderData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))));}}]);return RemoveAssistantModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveAssistantModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onAssistantRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelRemoving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveAssistantModal);

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditAssistantModal__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_assistant_assistants__ = __webpack_require__(112);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["B" /* MODAL_EDIT_ASSISTANT */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAssistantEdit:function onAssistantEdit(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_assistant_assistants__["f" /* onEditAssistant */])(id,data));},onClose:function onClose(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__EditAssistantModal__["a" /* default */]));

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_constants__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditAssistantModal=function(_Component){_inherits(EditAssistantModal,_Component);function EditAssistantModal(props){_classCallCheck(this,EditAssistantModal);var _this=_possibleConstructorReturn(this,(EditAssistantModal.__proto__||Object.getPrototypeOf(EditAssistantModal)).call(this,props));_this.getRolesSelectFormGroup=function(params){params={value:'roles',title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'assistants.roles_label'),type:'select',isRequired:true,isMulti:true,content:__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["b" /* ASSISTANT_TYPES */],function(value){return{code:value,name:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'assistants.'+value+'_label')};})),placeholder:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'assistants.roles_select_placeholder'),onChange:_this.handleChangeRoleSelect};var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,isMulti:params.isMulti,selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(params.content,function(option){return _this.state[params.value].includes(option.value);}),options:params.content,onSelect:params.onChange||_this.handleChangeSelect(params.value),placeholder:params.placeholder,disabled:params.isDisabled,requiredFieldError:_this.state.requiredFieldError===params.value})));};_this.handleChangeRoleSelect=function(selectedOptions){_this.setState({roles:selectedOptions.map(function(option){return option.value;})});};_this.renderData=function(){var paramsList=[{key:"firstName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),value:_this.props.data.firstName},{key:"lastName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),value:_this.props.data.lastName},{key:"email",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].email_label),value:_this.props.data.email},{key:"country",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),value:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'countries.'+_this.props.data.countryCode)}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getDataRow)));};_this.getDataRow=function(params){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(params.value)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container',key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,params.value));};_this.handleRemove=function(e){e.preventDefault();var data={hasRootPermission:false,hasFinancialManagerPermission:_this.state.roles.includes(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["b" /* ASSISTANT_TYPES */].FINANCIAL_ASSISTANT),hasProcessingManagerPermission:_this.state.roles.includes(__WEBPACK_IMPORTED_MODULE_7__constants_constants__["b" /* ASSISTANT_TYPES */].PROCESS_ASSISTANT)};_this.props.onAssistantEdit(_this.props.data.id,data);_this.props.onClose();};_this.handleCancel=function(){_this.props.onClose();_this.props.onCancelEditing();};_this.state={roles:[]};return _this;}_createClass(EditAssistantModal,[{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(this.props.data,nextProps.data)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(nextProps.data)){this.setState({roles:nextProps.data.roles});}}},{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'assistant-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'assistants.edit_assistant_alert')),this.getRolesSelectFormGroup(),this.renderData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].save_changes_button))));}}]);return EditAssistantModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EditAssistantModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onAssistantEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelEditing:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (EditAssistantModal);

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddAssistantComponent__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_assistant_assistants__ = __webpack_require__(112);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["e" /* getCountriesData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onProcess:function onProcess(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_assistant_assistants__["e" /* onCreateAssistant */])(data));},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__AddAssistantComponent__["a" /* default */]));

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddAssistantComponent_css__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddAssistantComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AddAssistantComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_backButtonComponent_BackButtonComponent__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(22);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var requiredSelectFields=['roles','country'];var AddAssistantComponent=function(_Component){_inherits(AddAssistantComponent,_Component);function AddAssistantComponent(props){_classCallCheck(this,AddAssistantComponent);var _this=_possibleConstructorReturn(this,(AddAssistantComponent.__proto__||Object.getPrototypeOf(AddAssistantComponent)).call(this,props));_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* Form */],{className:'add-assistant-form',onSubmit:_this.handleSubmit},_this.renderFormGroups(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{type:'submit',className:'olive-green-btn'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].add_button))));};_this.renderFormGroups=function(){var paramsList=[{value:'roles',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'assistants.roles_label'),type:'select',isRequired:true,isMulti:true,content:__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getOptions(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_6__constants_constants__["b" /* ASSISTANT_TYPES */],function(value){return{code:value,name:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'assistants.'+value+'_label')};})),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'assistants.roles_select_placeholder'),onChange:_this.handleChangeRoleSelect},{value:"firstName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label)},{value:"lastName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label)},{value:"email",type:"email",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].email_label),isRequired:true,placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)},{value:"continent",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continent_filter_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continents)),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continent_input_placeholder),onChange:_this.handleChangeContinent,isRequired:true,isDisabled:!_this.props.continents},{value:"country",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),type:'select',content:__WEBPACK_IMPORTED_MODULE_7__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].countries)),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].country_input_placeholder),isRequired:true,isDisabled:!_this.props.countries}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getFormGroup)));};_this.handleChangeContinent=function(selectedOption){_this.props.onContinentSet(selectedOption.value);_this.setState({country:''});};_this.getFormGroup=function(params){if(params.type==='select'){return _this.getSelectFormGroup(params);}if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.kebabCase(params.value);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* Input */],{type:params.type||'text',id:id,value:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.state,params.value),onChange:params.onChange||_this.handleChange(params.value),placeholder:params.placeholder,disabled:params.isDisabled,required:params.isRequired,invalid:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.errors)?false:_this.props.errors.includes(params.value)},params.content),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* FormFeedback */],null,params.errorMessage||'')));};_this.getSelectFormGroup=function(params){if(!params||(typeof params==='undefined'?'undefined':_typeof(params))!=='object'){return;}var id=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.kebabCase(params.value);var selectedOption=params.isMulti?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(params.content,function(option){return _this.state[params.value].includes(option.value);}):__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(params.content,function(option){return option.value===_this.state[params.value];});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* FormGroup */],{row:true,key:params.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* Label */],{'for':id,sm:3},params.title+(params.isRequired?'*':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["h" /* Col */],{sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{id:id,isMulti:params.isMulti,selectedOption:selectedOption,options:params.content,onSelect:params.onChange||_this.handleChangeSelect(params.value),placeholder:params.placeholder,disabled:params.isDisabled,requiredFieldError:_this.state.requiredFieldError===params.value})));};_this.handleChangeRoleSelect=function(selectedOptions){_this.setState({roles:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(selectedOptions,function(option){return option.value;})});};_this.handleChangeSelect=function(fieldName){return function(selectedOption){_this.setState(_defineProperty({},fieldName,selectedOption.value));};};_this.handleChange=function(fieldName){return function(e){_this.setState(_defineProperty({},fieldName,e.target.value));};};_this.handleSubmit=function(e){e.preventDefault();if(_this.checkRequiredSelectFields()){return;}var permissions={hasRootPermission:false,hasFinancialManagerPermission:_this.state.roles.includes(__WEBPACK_IMPORTED_MODULE_6__constants_constants__["b" /* ASSISTANT_TYPES */].FINANCIAL_ASSISTANT),hasProcessingManagerPermission:_this.state.roles.includes(__WEBPACK_IMPORTED_MODULE_6__constants_constants__["b" /* ASSISTANT_TYPES */].PROCESS_ASSISTANT)};var data={permissions:permissions,email:_this.state.email,identityAlias:{firstName:_this.state.firstName,lastName:_this.state.lastName,countryCode:_this.state.country}};_this.props.onProcess(data);};_this.checkRequiredSelectFields=function(){var error=null;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(requiredSelectFields,function(field){if((!_this.state[field]||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.state[field]))&&!error){error=field;}});_this.setState({requiredFieldError:error});return error;};_this.state={roles:[],firstName:'',lastName:'',email:'',continent:_this.props.continentCode,country:'',requiredFieldError:null};return _this;}_createClass(AddAssistantComponent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.state.orgContinent!==nextProps.continentCode){this.setState({continent:nextProps.continentCode});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onContinentSet('');}},{key:'render',value:function render(){if(this.props.success){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["d" /* Redirect */],{to:'/assistants-management',push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-assistant-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_backButtonComponent_BackButtonComponent__["a" /* default */],{path:'/assistants-management',label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].back_button)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-assistant-form-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'assistants.add_assistant_page_label')),this.renderContent())));}}]);return AddAssistantComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AddAssistantComponent.propTypes={translation:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,success:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,continentCode:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,onProcess:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,onContinentSet:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AddAssistantComponent);

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BusinessAmbassadorsList__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_businessAmbassador_businessAmbassadors__ = __webpack_require__(146);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_businessAmbassador_businessAmbassadors__["d" /* loadingBusinessAmbassadors */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_businessAmbassador_businessAmbassadors__["c" /* getBusinessAmbassadorsData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_businessAmbassador_businessAmbassadors__["b" /* fetchGetBusinessAmbassadors */])());},onRemoveButtonClick:function onRemoveButtonClick(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["S" /* MODAL_REMOVE_BUSINESS_AMBASSADOR */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__BusinessAmbassadorsList__["a" /* default */]));

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BusinessAmbassadorsList_css__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BusinessAmbassadorsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BusinessAmbassadorsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__removeBusinessAmbassadorModal_RemoveBusinessAmbassadorModal_container__ = __webpack_require__(1124);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BusinessAmbassadorsList=function(_Component){_inherits(BusinessAmbassadorsList,_Component);function BusinessAmbassadorsList(props){_classCallCheck(this,BusinessAmbassadorsList);var _this=_possibleConstructorReturn(this,(BusinessAmbassadorsList.__proto__||Object.getPrototypeOf(BusinessAmbassadorsList)).call(this,props));_this.renderContent=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'business-ambassadors-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'business-ambassadors-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'business_ambassadors.no_data_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["N" /* Table */],{className:'business-ambassadors-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].name_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].phone_number_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'business_ambassadors.financial_data_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderData()));};_this.renderData=function(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(_this.props.data,function(businessAmbassador,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{onClick:_this.handleTableRowClick,className:"business-ambassadors-list-row",key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'name-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].name_label)+":"},businessAmbassador.firstName+' '+businessAmbassador.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'email-td '+(!businessAmbassador.email?'empty':''),'data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].email_label)+":",onClick:_this.handleTableRowClick(businessAmbassador.id)},businessAmbassador.email?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+businessAmbassador.email,onClick:_this.handleMailToLinkClick},businessAmbassador.email):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'phone-number-td '+(!businessAmbassador.phoneNumber?'empty':''),'data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].phone_number_label)+":",onClick:_this.handleTableRowClick(businessAmbassador.id)},businessAmbassador.phoneNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'financial-data-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'business_ambassadors.financial_data_label')+":",onClick:_this.handleTableRowClick(businessAmbassador.id)},businessAmbassador.financialData),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'ba-create-icon-td',onClick:_this.handleTableRowClick(businessAmbassador.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:index,icon:'create',className:'ba-create-icon',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].edit_button)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'ba-remove-icon-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:index,icon:'trash',className:'ba-remove-icon',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button),onClick:_this.onRemoveButtonClick(businessAmbassador)})));});};_this.handleTableRowClick=function(id){return function(){_this.setState({selectedAmbassador:id});};};_this.handleMailToLinkClick=function(e){e.stopPropagation();};_this.onRemoveButtonClick=function(businessAmbassador){return function(e){e.stopPropagation();_this.setState({ambassadorToRemove:businessAmbassador});_this.props.onRemoveButtonClick();};};_this.handleCloseModal=function(){_this.setState({ambassadorToRemove:null});};_this.state={selectedAmbassador:null,ambassadorToRemove:null};return _this;}_createClass(BusinessAmbassadorsList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'render',value:function render(){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(this.state.selectedAmbassador)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["d" /* Redirect */],{to:'/edit-business-ambassador?id='+this.state.selectedAmbassador,push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'business-ambassadors-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'business_ambassadors.business_ambassadors_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{tag:__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],to:'/add-business-ambassador',className:'add-business-ambassador-button olive-green-btn'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].add_button))),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__removeBusinessAmbassadorModal_RemoveBusinessAmbassadorModal_container__["a" /* default */],{data:this.state.ambassadorToRemove,onCancelRemoving:this.handleCloseModal}));}}]);return BusinessAmbassadorsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var BusinessAmbassadorShape=__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,firstName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,lastName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,email:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,phoneNumber:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,financialData:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired});BusinessAmbassadorsList.propTypes={translation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,loading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(BusinessAmbassadorShape),onMount:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,onRemoveButtonClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (BusinessAmbassadorsList);

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveBusinessAmbassadorModal__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_businessAmbassador_businessAmbassadors__ = __webpack_require__(146);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["S" /* MODAL_REMOVE_BUSINESS_AMBASSADOR */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onBusinessAmbassadorRemove:function onBusinessAmbassadorRemove(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_businessAmbassador_businessAmbassadors__["f" /* onRemoveBusinessAmbassador */])(id));},onClose:function onClose(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RemoveBusinessAmbassadorModal__["a" /* default */]));

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveBusinessAmbassadorModal=function(_Component){_inherits(RemoveBusinessAmbassadorModal,_Component);function RemoveBusinessAmbassadorModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveBusinessAmbassadorModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveBusinessAmbassadorModal.__proto__||Object.getPrototypeOf(RemoveBusinessAmbassadorModal)).call.apply(_ref,[this].concat(args))),_this),_this.renderData=function(){var paramsList=[{key:"firstName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),value:_this.props.data.firstName},{key:"lastName",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),value:_this.props.data.lastName},{key:"email",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].email_label),value:_this.props.data.email},{key:"phoneNumber",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].phone_number_label),value:_this.props.data.phoneNumber},{key:"countryCode",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),value:_this.props.data.countryCode},{key:"financialData",title:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'business_ambassadors.financial_data_label'),value:_this.props.data.financialData}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(paramsList,_this.getDataRow)));},_this.getDataRow=function(params){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(params.value)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container',key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:4},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,params.value));},_this.handleRemove=function(e){e.preventDefault();_this.props.onBusinessAmbassadorRemove(_this.props.data.id);_this.props.onClose();},_this.handleCancel=function(){_this.props.onClose();_this.props.onCancelRemoving();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveBusinessAmbassadorModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'ba-remove-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'business_ambassadors.remove_ambassador_alert')),this.renderData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))));}}]);return RemoveBusinessAmbassadorModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveBusinessAmbassadorModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onBusinessAmbassadorRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancelRemoving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveBusinessAmbassadorModal);

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BusinessAmbassadorDetails__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_businessAmbassador_businessAmbassadors__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_finance_currencies__ = __webpack_require__(67);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),actionType:__WEBPACK_IMPORTED_MODULE_3__BusinessAmbassadorDetails__["a" /* ACTION_TYPES */].ADD,success:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),currenciesData:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_finance_currencies__["e" /* getCurrenciesData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onProcess:function onProcess(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_businessAmbassador_businessAmbassadors__["e" /* onCreateBusinessAmbassador */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__BusinessAmbassadorDetails__["b" /* default */]));

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BusinessAmbassadorDetails__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_businessAmbassador_businessAmbassador__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_finance_currencies__ = __webpack_require__(67);
var mapStateToProps=function mapStateToProps(state,_ref){var location=_ref.location;return{id:__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search).id,data:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_businessAmbassador_businessAmbassador__["c" /* getBusinessAmbassadorData */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_businessAmbassador_businessAmbassador__["d" /* loadingBusinessAmbassador */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),actionType:__WEBPACK_IMPORTED_MODULE_4__BusinessAmbassadorDetails__["a" /* ACTION_TYPES */].EDIT,success:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state),currenciesData:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_finance_currencies__["e" /* getCurrenciesData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_businessAmbassador_businessAmbassador__["b" /* fetchGetBusinessAmbassadorById */])(id));},onProcess:function onProcess(id,data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_businessAmbassador_businessAmbassador__["e" /* onUpdateBusinessAmbassador */])(id,data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__BusinessAmbassadorDetails__["b" /* default */]));

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommissionsList__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_location__ = __webpack_require__(21);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["p" /* loadingCommissions */])(state)||Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["o" /* loadingBAsList */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_localization__["e" /* getTranslation */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["k" /* getCommissionsData */])(state),BAsList:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["g" /* getBAsList */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["d" /* getContinentsData */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["f" /* getCurrentContinent */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["e" /* getCountriesData */])(state),countryFilter:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["j" /* getCommissionsCountryFilter */])(state),BAFilter:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["i" /* getCommissionsBAFilter */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["e" /* fetchGetCommissions */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["c" /* fetchGetBAsList */])());},onCommissionRemove:function onCommissionRemove(commissionId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["s" /* setCommissionToRemove */])(commissionId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["V" /* MODAL_REMOVE_COMMISSION */]}));},onSetContinent:function onSetContinent(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onCountryFilterChange:function onCountryFilterChange(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["u" /* updateCommissionsCountryFilter */])(countryCode));},onBAFilterChange:function onBAFilterChange(baId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["t" /* updateCommissionsBAFilter */])(baId));},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["h" /* setCurrentContinent */])(""));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["u" /* updateCommissionsCountryFilter */])(null));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["t" /* updateCommissionsBAFilter */])(null));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CommissionsList__["a" /* default */]));

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CommissionsList_css__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CommissionsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CommissionsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_paginationComponent_PaginationCommissions_container__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commissionsModal_removeCommissionModal_RemoveCommissionModal_container__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CommissionsList=function(_Component){_inherits(CommissionsList,_Component);function CommissionsList(props){_classCallCheck(this,CommissionsList);var _this=_possibleConstructorReturn(this,(CommissionsList.__proto__||Object.getPrototypeOf(CommissionsList)).call(this,props));_this.handleRowClick=function(baId,id){return function(){_this.setState({selectedCommissionBAId:baId,selectedCommissionId:id});};};_this.onAddButtonClick=function(){_this.setState({redirect:true});};_this.onRemoveButtonClick=function(id){return function(e){e.stopPropagation();_this.props.onCommissionRemove(id);};};_this.renderFilters=function(){var BAsOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_10__utils_utils__["a" /* Utils */].getBAsOptions(_this.props.BAsList)));var continentsOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_10__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continents))));var countriesOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_10__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].countries))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filters-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'filters-title'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].filter_options_label)+":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ba-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,'commissions.ba_short_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'ba-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(BAsOptions,function(option){return option.value===_this.props.BAFilter;}),options:BAsOptions,onSelect:_this.handleChangeBASelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'continent-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continent_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'continent-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(continentsOptions,function(option){return option.value===_this.props.continentCode||__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(option.value)&&__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(_this.props.continentCode);}),options:continentsOptions,onSelect:_this.handleChangeContinentSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'country-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'country-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(countriesOptions,function(option){return option.value===_this.props.countryFilter;}),options:countriesOptions,onSelect:_this.handleChangeCountrySelect})));};_this.handleChangeContinentSelect=function(selectedOption){_this.props.onSetContinent(selectedOption.value);_this.props.onCountryFilterChange(null);};_this.handleChangeCountrySelect=function(selectedOption){_this.props.onCountryFilterChange(selectedOption.value);};_this.handleChangeBASelect=function(selectedOption){_this.props.onBAFilterChange(selectedOption.value);};_this.state={selectedCommissionBAId:null,selectedCommissionId:null};return _this;}_createClass(CommissionsList,[{key:'render',value:function render(){if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.state.selectedCommissionId)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.state.selectedCommissionBAId)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["d" /* Redirect */],{to:"/edit-commission?baId="+this.state.selectedCommissionBAId+"&id="+this.state.selectedCommissionId,push:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'commissions-list-component-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'commissions-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'commissions.commissions_list_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_paginationComponent_PaginationCommissions_container__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-pane-container'},this.renderFilters(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'add-commission-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* Button */],{tag:__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],to:'/add-commission',className:'add-commission-button olive-green-btn'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].add_button)))),this.renderContent()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commissionsModal_removeCommissionModal_RemoveCommissionModal_container__["a" /* default */],null));}},{key:'renderContent',value:function renderContent(){if(this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'commissions-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isNil(this.props.data)||this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'commissions-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'commissions.no_data_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["N" /* Table */],{className:'commissions-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].name_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continent_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'commissions.countries_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'commissions.commission_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'commissions.date_from_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.translation,'commissions.date_to_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.renderCommissionsData()));}},{key:'renderCommissionsData',value:function renderCommissionsData(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.props.data,function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index,className:'commission-row',onClick:_this2.handleRowClick(data.baId,data.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'name-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].name_label)+':'},data.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'continent-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].continent_label)+':'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'continents.'+data.continent)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'countries-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'commissions.countries_label')+':'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'countries-container'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(data.countries,function(country,id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'country-item',key:id},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'countries.'+country));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'commission-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'commissions.commission_label')+':'},data.commission+'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date-from-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'commissions.date_from_label')+':'},data.dateFrom),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date-to-td','data-th':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,'commissions.date_to_label')+':'},data.dateTo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'edit-commission-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:index,icon:'create',className:'commissions-list-create-icon',title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].edit_button)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'delete-commission-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_iconContainer_IconContainer__["a" /* default */],{key:index,icon:'trash',className:'commissions-list-delete-icon',onClick:_this2.onRemoveButtonClick(data.id),title:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this2.props.translation,__WEBPACK_IMPORTED_MODULE_6__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button)})));});}},{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onUnmount();}}]);return CommissionsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var CommissionShape=__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,continent:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,countries:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string).isRequired,commission:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,dateFrom:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,dateTo:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired});CommissionsList.propTypes={loading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,data:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(CommissionShape),continentCode:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,continents:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,countries:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,BAsList:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,BAFilter:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,onMount:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onCommissionRemove:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onSetContinent:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onCountryFilterChange:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onBAFilterChange:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onUnmount:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (CommissionsList);

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_commission_commissions__ = __webpack_require__(87);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_commission_commissions__["m" /* getCurrentPageForCommissions */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_commission_commissions__["n" /* getTotalPagesForCommissions */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_commission_commissions__["e" /* fetchGetCommissions */])(page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RemoveCommissionModal__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_commission_commissions__ = __webpack_require__(87);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["V" /* MODAL_REMOVE_COMMISSION */],data:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_commission_commissions__["h" /* getCommissionToRemove */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_commission_commissions__["s" /* setCommissionToRemove */])(null));},onCommissionRemove:function onCommissionRemove(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_commission_commissions__["r" /* removeCommission */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__RemoveCommissionModal__["a" /* default */]));

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveCommissionModal=function(_Component){_inherits(RemoveCommissionModal,_Component);function RemoveCommissionModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveCommissionModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveCommissionModal.__proto__||Object.getPrototypeOf(RemoveCommissionModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleRemove=function(e){e.preventDefault();_this.props.onCommissionRemove(_this.props.data.id);},_this.handleCancel=function(){_this.props.onCancel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveCommissionModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'commission-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'commissions.remove_commission_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'commissions.remove_commission_alert')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].name_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].continent_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'continents.'+this.props.data.continent))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'commissions.countries_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'countries-container'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(this.props.data.countries,function(country,id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'country-item',key:id},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this2.props.translation,'countries.'+country));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'commissions.commission_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.commission+'%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'commissions.date_from_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.dateFrom)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,'commissions.date_to_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.dateTo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_5__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button)))));}}]);return RemoveCommissionModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveCommissionModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCommissionRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveCommissionModal);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommissionDetails__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),actionType:__WEBPACK_IMPORTED_MODULE_1__CommissionDetails__["a" /* ACTION_TYPES */].ADD,currentContinent:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["e" /* getCountriesData */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["o" /* loadingBAsList */])(state),BAsList:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["g" /* getBAsList */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGetBAsList:function onGetBAsList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["c" /* fetchGetBAsList */])());},onSetContinent:function onSetContinent(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onProcess:function onProcess(baId,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["b" /* fetchAddCommission */])(baId,data));},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["h" /* setCurrentContinent */])(""));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CommissionDetails__["b" /* default */]));

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommissionDetails__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils__ = __webpack_require__(12);
var mapStateToProps=function mapStateToProps(state,_ref){var location=_ref.location;var pathParams=__WEBPACK_IMPORTED_MODULE_6__utils_utils__["a" /* Utils */].getParamsFromLocationSearch(location.search);return{id:pathParams.id,baId:pathParams.baId,translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),actionType:__WEBPACK_IMPORTED_MODULE_1__CommissionDetails__["a" /* ACTION_TYPES */].EDIT,data:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["l" /* getCurrentCommissionDataFormatted */])(state),currentContinent:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["e" /* getCountriesData */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["o" /* loadingBAsList */])(state)||Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["q" /* loadingCurrentCommission */])(state),BAsList:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["g" /* getBAsList */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onGetCommissionData:function onGetCommissionData(baId,commissionId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["d" /* fetchGetCommissionData */])(baId,commissionId));},onGetBAsList:function onGetBAsList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["c" /* fetchGetBAsList */])());},onSetContinent:function onSetContinent(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onProcess:function onProcess(baId,commissionId,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_commission_commissions__["f" /* fetchUpdateCommission */])(baId,commissionId,data));},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["h" /* setCurrentContinent */])(""));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CommissionDetails__["b" /* default */]));

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DuePaymentsComponent__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__DuePaymentsComponent__["a" /* default */]));

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DuePaymentsComponent_css__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DuePaymentsComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DuePaymentsComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__duePaymentsList_UniversitiesDuePaymentsList_container__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__duePaymentsList_BAsDuePaymentsList_container__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__duePaymentsList_SystemDuePaymentsList_container__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DuePaymentsComponent=function(_Component){_inherits(DuePaymentsComponent,_Component);function DuePaymentsComponent(){_classCallCheck(this,DuePaymentsComponent);return _possibleConstructorReturn(this,(DuePaymentsComponent.__proto__||Object.getPrototypeOf(DuePaymentsComponent)).apply(this,arguments));}_createClass(DuePaymentsComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'due-payments-component-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.due_payments_paid_success_message')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.due_payments_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'system-payment-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.system_due_payments_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__duePaymentsList_SystemDuePaymentsList_container__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'system-payment-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.ba_s_due_payments_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__duePaymentsList_BAsDuePaymentsList_container__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'system-payment-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.uni_s_due_payments_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__duePaymentsList_UniversitiesDuePaymentsList_container__["a" /* default */],null)));}}]);return DuePaymentsComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DuePaymentsComponent.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (DuePaymentsComponent);

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DuePaymentsList__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),mode:__WEBPACK_IMPORTED_MODULE_1__DuePaymentsList__["a" /* DUE_PAYMENTS_MODE */].UNI,loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["r" /* loadingUniversitiesDuePayments */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["o" /* getUniversitiesDuePaymentsData */])(state),countryFilter:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["i" /* getCountryFilterForUniversitiesDuePayments */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["d" /* getContinentsData */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["f" /* getCurrentContinent */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["e" /* getCountriesData */])(state),nameFilter:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["l" /* getNameFilterForUniversitiesDuePayments */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["c" /* fetchGetDuePaymentsForUniversities */])());},onShowWireDataModal:function onShowWireDataModal(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_9" /* MODAL_UNI_WIRE_DATA */]}));},onShowDuePaymentsConfirmModal:function onShowDuePaymentsConfirmModal(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_8" /* MODAL_UNI_DUE_PAYMENT_CONFIRM */]}));},onChangeCountryFilter:function onChangeCountryFilter(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["w" /* updateCountryFilterForUniversitiesDuePayments */])(countryCode));},onSetContinent:function onSetContinent(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["h" /* setCurrentContinent */])(null));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["u" /* onUpdateCountryFilterForUniversitiesDuePayments */])(null));},onUpdateNameFilter:function onUpdateNameFilter(name){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["y" /* updateNameFilterForUniversitiesDuePayments */])(name));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__DuePaymentsList__["b" /* default */]));

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WireDataModal__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["o" /* MODAL_BA_WIRE_DATA */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__WireDataModal__["a" /* default */]));

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WireDataModal__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_9" /* MODAL_UNI_WIRE_DATA */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__WireDataModal__["a" /* default */]));

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DuePaymentsConfirmModal__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_duePayments__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["n" /* MODAL_BA_DUE_PAYMENT_CONFIRM */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onPayDuePayments:function onPayDuePayments(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_duePayments__["d" /* fetchPayDuePaymentsForBA */])(id,data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__DuePaymentsConfirmModal__["a" /* default */]));

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DuePaymentsConfirmModal__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_duePayments__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_8" /* MODAL_UNI_DUE_PAYMENT_CONFIRM */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onPayDuePayments:function onPayDuePayments(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_duePayments__["f" /* fetchPayDuePaymentsForUniversity */])(id,data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__DuePaymentsConfirmModal__["a" /* default */]));

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DuePaymentsConfirmModal__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_systemPayments_duePayments__ = __webpack_require__(66);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_7" /* MODAL_SYSTEM_DUE_PAYMENT_CONFIRM */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),label:'system_payment.system_due_payments_label'};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["k" /* resetSubmitFormData */])());},onPayDuePayments:function onPayDuePayments(id,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_systemPayments_duePayments__["e" /* fetchPayDuePaymentsForSystem */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__DuePaymentsConfirmModal__["a" /* default */]));

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_duePayments__ = __webpack_require__(66);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_duePayments__["j" /* getCurrentPageForUniversitiesDuePayments */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_duePayments__["n" /* getTotalPagesForUniversitiesDuePayments */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_duePayments__["c" /* fetchGetDuePaymentsForUniversities */])(page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DuePaymentsList__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),mode:__WEBPACK_IMPORTED_MODULE_1__DuePaymentsList__["a" /* DUE_PAYMENTS_MODE */].BA,loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["p" /* loadingBAsDuePayments */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["g" /* getBAsDuePaymentsData */])(state),continentFilter:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["h" /* getContinentFilterForBAsDuePayments */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["d" /* getContinentsData */])(state),nameFilter:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["k" /* getNameFilterForBAsDuePayments */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["b" /* fetchGetDuePaymentsForBAs */])());},onShowWireDataModal:function onShowWireDataModal(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["o" /* MODAL_BA_WIRE_DATA */]}));},onShowDuePaymentsConfirmModal:function onShowDuePaymentsConfirmModal(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["n" /* MODAL_BA_DUE_PAYMENT_CONFIRM */]}));},onChangeContinentFilter:function onChangeContinentFilter(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["v" /* updateContinentFilterForBAsDuePayments */])(continentCode));},onUnmount:function onUnmount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["t" /* onUpdateContinentFilterForBAsDuePayments */])(null));},onUpdateNameFilter:function onUpdateNameFilter(name){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_duePayments__["x" /* updateNameFilterForBAsDuePayments */])(name));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__DuePaymentsList__["b" /* default */]));

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DuePaymentsList__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_systemPayments_duePayments__ = __webpack_require__(66);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),mode:__WEBPACK_IMPORTED_MODULE_1__DuePaymentsList__["a" /* DUE_PAYMENTS_MODE */].SYSTEM,loading:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_systemPayments_duePayments__["q" /* loadingSystemDuePayments */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_systemPayments_duePayments__["m" /* getSystemDuePayments */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_systemPayments_duePayments__["s" /* onFetchGetDuePaymentsForSystem */])());},onShowDuePaymentsConfirmModal:function onShowDuePaymentsConfirmModal(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_7" /* MODAL_SYSTEM_DUE_PAYMENT_CONFIRM */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__DuePaymentsList__["b" /* default */]));

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaymentsHistoryComponent__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__PaymentsHistoryComponent__["a" /* default */]));

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentsHistoryComponent_css__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentsHistoryComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PaymentsHistoryComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paymentsHistoryList_BAsPaymentsHistoryList_container__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__paymentsHistoryList_UniversitiesPaymentsHistoryList_container__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__companiesCreditsList_CompaniesCreditsList_container__ = __webpack_require__(1164);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentsHistoryComponent=function(_Component){_inherits(PaymentsHistoryComponent,_Component);function PaymentsHistoryComponent(){_classCallCheck(this,PaymentsHistoryComponent);return _possibleConstructorReturn(this,(PaymentsHistoryComponent.__proto__||Object.getPrototypeOf(PaymentsHistoryComponent)).apply(this,arguments));}_createClass(PaymentsHistoryComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payments-history-component-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.payments_history_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'system-payment-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.ba_s_payments_history_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__paymentsHistoryList_BAsPaymentsHistoryList_container__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'system-payment-subtitle olive-green'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.uni_s_payments_history_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__paymentsHistoryList_UniversitiesPaymentsHistoryList_container__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brain-chain-divider'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.company_credit_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__companiesCreditsList_CompaniesCreditsList_container__["a" /* default */],null));}}]);return PaymentsHistoryComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PaymentsHistoryComponent.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PaymentsHistoryComponent);

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaymentsHistoryList__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_location__ = __webpack_require__(21);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),mode:__WEBPACK_IMPORTED_MODULE_1__PaymentsHistoryList__["a" /* PAYMENTS_HISTORY_MODE */].BA,loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["p" /* loadingBAsPaymentsHistory */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["d" /* getBAsPaymentsHistoryData */])(state),dateFromFilter:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["g" /* getDateFromFilterForBAsPaymentsHistory */])(state),dateToFilter:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["i" /* getDateToFilterForBAsPaymentsHistory */])(state),nameFilter:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["k" /* getNameFilterForBAsPaymentsHistory */])(state),locationData:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["g" /* getLocationData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["b" /* fetchGetPaymentsHistoryForBAs */])());},onChangeDateFromFilter:function onChangeDateFromFilter(dateFrom){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["v" /* updateDateFromFilterForBAsPaymentsHistory */])(dateFrom));},onChangeDateToFilter:function onChangeDateToFilter(dateTo){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["x" /* updateDateToFilterForBAsPaymentsHistory */])(dateTo));},onChangeNameFilter:function onChangeNameFilter(name){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["z" /* updateNameFilterForBAsPaymentsHistory */])(name));},onShowComment:function onShowComment(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["H" /* MODAL_PAYMENT_HISTORY_COMMENT */]}));},onChangeContinentFilter:function onChangeContinentFilter(continent){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["r" /* onUpdateCountryFilterByContinentForBAsPaymentsHistory */])(continent));},onChangeCountryFilter:function onChangeCountryFilter(country){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["t" /* onUpdateCountryFilterForBAsPaymentsHistory */])(country));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaymentsHistoryList__["b" /* default */]));

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_paymentsHistory__ = __webpack_require__(113);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_paymentsHistory__["f" /* getCurrentPageForUniversitiesPaymentsHistory */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_paymentsHistory__["n" /* getTotalPagesForUniversitiesPaymentsHistory */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_paymentsHistory__["c" /* fetchGetPaymentsHistoryForUniversities */])(page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_paymentsHistory__ = __webpack_require__(113);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_paymentsHistory__["e" /* getCurrentPageForBAsPaymentsHistory */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_paymentsHistory__["m" /* getTotalPagesForBAsPaymentsHistory */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_paymentsHistory__["b" /* fetchGetPaymentsHistoryForBAs */])(page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommentModal__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["H" /* MODAL_PAYMENT_HISTORY_COMMENT */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CommentModal__["a" /* default */]));

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CommentModal_css__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CommentModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CommentModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CommentModal=function(_Component){_inherits(CommentModal,_Component);function CommentModal(){_classCallCheck(this,CommentModal);return _possibleConstructorReturn(this,(CommentModal.__proto__||Object.getPrototypeOf(CommentModal)).apply(this,arguments));}_createClass(CommentModal,[{key:'render',value:function render(){if(!this.props.data){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["x" /* ModalBody */],{className:'comment-modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'modal-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'system_payment.comment_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'data-container'},this.props.data),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-modal-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].okey_button)))));}}]);return CommentModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CommentModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,contactData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CommentModal);

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaymentsHistoryList__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_location__ = __webpack_require__(21);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),mode:__WEBPACK_IMPORTED_MODULE_1__PaymentsHistoryList__["a" /* PAYMENTS_HISTORY_MODE */].UNI,loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["q" /* loadingUniversitiesPaymentsHistory */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["o" /* getUniversitiesPaymentsHistoryData */])(state),dateFromFilter:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["h" /* getDateFromFilterForUniversitiesPaymentsHistory */])(state),dateToFilter:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["j" /* getDateToFilterForUniversitiesPaymentsHistory */])(state),nameFilter:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["l" /* getNameFilterForUniversitiesPaymentsHistory */])(state),locationData:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["g" /* getLocationData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["c" /* fetchGetPaymentsHistoryForUniversities */])());},onChangeDateFromFilter:function onChangeDateFromFilter(dateFrom){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["w" /* updateDateFromFilterForUniversitiesPaymentsHistory */])(dateFrom));},onChangeDateToFilter:function onChangeDateToFilter(dateTo){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["y" /* updateDateToFilterForUniversitiesPaymentsHistory */])(dateTo));},onChangeNameFilter:function onChangeNameFilter(name){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["A" /* updateNameFilterForUniversitiesPaymentsHistory */])(name));},onShowComment:function onShowComment(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_4__reducers_common_activeModal__["H" /* MODAL_PAYMENT_HISTORY_COMMENT */]}));},onChangeContinentFilter:function onChangeContinentFilter(continent){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["s" /* onUpdateCountryFilterByContinentForUniversitiesPaymentsHistory */])(continent));},onChangeCountryFilter:function onChangeCountryFilter(country){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_systemPayments_paymentsHistory__["u" /* onUpdateCountryFilterForUniversitiesPaymentsHistory */])(country));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaymentsHistoryList__["b" /* default */]));

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompaniesCreditsList__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_location__ = __webpack_require__(21);
var mapStateToProps=function mapStateToProps(state){return{translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__["n" /* loadingCompaniesCredits */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__["d" /* getCompaniesCreditsData */])(state),sorting:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__["f" /* getCompaniesCreditsSorting */])(state),nameFilter:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__["e" /* getCompaniesCreditsNameFilter */])(state),locationData:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_location__["g" /* getLocationData */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__["c" /* fetchGetCompaniesCredits */])());},onShowContactDataModal:function onShowContactDataModal(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["u" /* MODAL_COMPANIES_CREDITS_CONTACT_DATA */]}));},onChangeSorting:function onChangeSorting(sorting){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__["v" /* updateCompaniesCreditsSorting */])(sorting));},onChangeNameFilter:function onChangeNameFilter(name){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__["u" /* updateCompaniesCreditsNameFilter */])(name));},onChangeContinentFilter:function onChangeContinentFilter(continent){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__["r" /* onUpdateCompanyCreditsCountryFilterByContinent */])(continent));},onChangeCountryFilter:function onChangeCountryFilter(country){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__["q" /* onUpdateCompanyCreditsCountryFilter */])(country));},onShowHistoryModal:function onShowHistoryModal(id,name){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["v" /* MODAL_COMPANY_CREDITS_HISTORY_MODAL */]}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__["s" /* setSelectedCompanyId */])(id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__["t" /* setSelectedCompanyName */])(name));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__["p" /* onFetchGetCompanyHistory */])(0,id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CompaniesCreditsList__["a" /* default */]));

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CompaniesCreditsList_css__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CompaniesCreditsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CompaniesCreditsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__contactDataModal_ContactDataModal_container__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_paginationComponent_PaginationCompaniesCredits_container__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reducers_systemPayments_companiesCredits__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__creditsHistoryModal_CreditsHistoryModal_container__ = __webpack_require__(1171);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CompaniesCreditsList=function(_Component){_inherits(CompaniesCreditsList,_Component);function CompaniesCreditsList(props){_classCallCheck(this,CompaniesCreditsList);var _this=_possibleConstructorReturn(this,(CompaniesCreditsList.__proto__||Object.getPrototypeOf(CompaniesCreditsList)).call(this,props));_this.getTotalCreditLabel=function(totalCredit){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(totalCredit)){return"-";}return totalCredit.map(function(pay){return Math.abs(pay.amount)+" "+__WEBPACK_IMPORTED_MODULE_10__constants_constants__["g" /* CURRENCIES */][pay.currency];}).join(', ');};_this.renderSorting=function(){var options=[{value:__WEBPACK_IMPORTED_MODULE_11__reducers_systemPayments_companiesCredits__["a" /* COMPANIES_CREDITS_SORTING */].NAME,label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'system_payment.name_label')},{value:__WEBPACK_IMPORTED_MODULE_11__reducers_systemPayments_companiesCredits__["a" /* COMPANIES_CREDITS_SORTING */].CREATED_AT,label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'system_payment.date_joined_label')}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sorting-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'system_payment.order_by_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'sorting-select',selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(options,function(option){return option.value===_this.props.sorting;}),options:options,onSelect:_this.handleChangeSortingSelect}));};_this.handleChangeSortingSelect=function(selectedOption){_this.props.onChangeSorting(selectedOption.value);};_this.renderNameFilter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'name-label'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,'system_payment.name_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["r" /* Input */],{className:'name-input',type:'text',value:_this.state.nameFilter,onKeyDown:_this.handleKeyDownNameFilter,onChange:_this.handleChangeNameFilter,onBlur:_this.handleBlurNameFilter}));};_this.renderContinentAndCountryFilter=function(){var continentsOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_12__utils_utils__["a" /* Utils */].getLocationOptions(Object.keys(_this.props.locationData),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].continents))));var countriesOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_12__utils_utils__["a" /* Utils */].getLocationOptions(_this.state.continentFilter?_this.props.locationData[_this.state.continentFilter]:null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].countries))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'continent-country-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'continent-filter-container',key:'continent-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].continent_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'continent-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(continentsOptions,function(option){return option.value===_this.state.continentFilter;}),options:continentsOptions,onSelect:_this.handleChangeContinentSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'country-filter-container',key:'country-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'country-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(countriesOptions,function(option){return option.value===_this.state.countryFilter;}),options:countriesOptions,onSelect:_this.handleChangeCountrySelect})));};_this.handleChangeContinentSelect=function(selectedOption){if(_this.state.continentFilter!==selectedOption.value){_this.props.onChangeContinentFilter(selectedOption.value);_this.setState({countryFilter:null});}_this.setState({continentFilter:selectedOption.value});};_this.handleChangeCountrySelect=function(selectedOption){if(!selectedOption.value){_this.props.onChangeContinentFilter(_this.state.continentFilter);}else{_this.props.onChangeCountryFilter(selectedOption.value);}_this.setState({countryFilter:selectedOption.value});};_this.handleChangeNameFilter=function(e){_this.setState({nameFilter:e.target.value});};_this.handleKeyDownNameFilter=function(e){if(e.keyCode===13){_this.props.onChangeNameFilter(_this.state.nameFilter||null);}};_this.handleBlurNameFilter=function(){_this.props.onChangeNameFilter(_this.state.nameFilter||null);};_this.onShowContactDataClick=function(contactData){return function(){_this.setState({currentContactData:contactData});_this.props.onShowContactDataModal();};};_this.onShowHistoryClick=function(id,name){return function(){_this.props.onShowHistoryModal(id,name);};};_this.state={currentContactData:null,nameFilter:'',countryFilter:null,continentFilter:null};return _this;}_createClass(CompaniesCreditsList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'companies-credits-component-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'controls-container'},this.renderSorting(),this.renderNameFilter(),this.renderContinentAndCountryFilter()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_paginationComponent_PaginationCompaniesCredits_container__["a" /* default */],null),this.renderContent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__contactDataModal_ContactDataModal_container__["a" /* default */],{contactData:this.state.currentContactData}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__creditsHistoryModal_CreditsHistoryModal_container__["a" /* default */],null));}},{key:'renderContent',value:function renderContent(){if(this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'companies-credits-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_9__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)||this.props.data.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'companies-credits-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.no_companies_credits_label')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["N" /* Table */],{className:'companies-credits-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.name_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.date_joined_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.open_credit_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'centered'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.total_credit_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'system_payment.contact_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'main.payments_history_shirt_page_button')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.renderCreditsData()));}},{key:'renderCreditsData',value:function renderCreditsData(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(this.props.data,function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'name-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'system_payment.name_label')+':'},data.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date-joined-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'system_payment.date_joined_label')+':'},__WEBPACK_IMPORTED_MODULE_4_moment___default()(data.joinDate).format('L')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'open-credit-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'system_payment.open_credit_label')+':'},data.openCredit.amount+" "+__WEBPACK_IMPORTED_MODULE_10__constants_constants__["g" /* CURRENCIES */][data.openCredit.currency]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'total-credit-td centered','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'system_payment.total_credit_label')+':'},_this2.getTotalCreditLabel(data.totalCredit)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'contact-data-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'system_payment.contact_label')+':'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["c" /* Button */],{color:'link',size:'sm',onClick:_this2.onShowContactDataClick(data.contactData)},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'system_payment.show_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'history-data-td','data-th':__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'main.payments_history_shirt_page_button')+':'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactstrap__["c" /* Button */],{color:'link',size:'sm',onClick:_this2.onShowHistoryClick(data.id,data.name)},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.props.translation,'system_payment.show_label'))));});}}]);return CompaniesCreditsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CompaniesCreditsList.propTypes={translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,nameFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,locationData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onShowContactDataModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onChangeSorting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onChangeNameFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onChangeContinentFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onChangeCountryFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onShowHistoryModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CompaniesCreditsList);

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContactDataModal__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["u" /* MODAL_COMPANIES_CREDITS_CONTACT_DATA */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ContactDataModal__["a" /* default */]));

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContactDataModal_css__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContactDataModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ContactDataModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContactDataModal=function(_Component){_inherits(ContactDataModal,_Component);function ContactDataModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContactDataModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContactDataModal.__proto__||Object.getPrototypeOf(ContactDataModal)).call.apply(_ref,[this].concat(args))),_this),_this.renderData=function(){var paramsList=[{key:"firstName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].first_name_label),value:_this.props.contactData.firstName},{key:"lastName",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].last_name_label),value:_this.props.contactData.lastName},{key:"email",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].email_label),value:_this.props.contactData.email},{key:"phoneNumber",title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].phone_number_label),value:_this.props.contactData.phoneNumber}];return[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(paramsList,_this.getDataRow)));},_this.getDataRow=function(params){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(params.value)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["L" /* Row */],{className:'modal-form-field-container',key:params.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:4},params.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],null,params.value));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContactDataModal,[{key:'render',value:function render(){if(!this.props.contactData){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["x" /* ModalBody */],null,this.renderData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contact-data-modal-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].okey_button)))));}}]);return ContactDataModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ContactDataModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,contactData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ContactDataModal);

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_companiesCredits__ = __webpack_require__(88);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_companiesCredits__["k" /* getCurrentPageForCompaniesCredits */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_companiesCredits__["m" /* getTotalPagesForCompaniesCredits */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_companiesCredits__["c" /* fetchGetCompaniesCredits */])(page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreditsHistoryModal__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__ = __webpack_require__(88);
var mapStateToProps=function mapStateToProps(state){return{companyName:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__["l" /* getSelectedCompanyName */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__["i" /* getCompanyHistoryData */])(state),isOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["v" /* MODAL_COMPANY_CREDITS_HISTORY_MODAL */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_systemPayments_companiesCredits__["o" /* loadingCompanyHistory */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CreditsHistoryModal__["a" /* default */]));

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreditsHistoryModal_css__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreditsHistoryModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CreditsHistoryModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_constants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_paginationComponent_PaginationCreditsHistory_container__ = __webpack_require__(1174);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreditsHistoryModal=function(_Component){_inherits(CreditsHistoryModal,_Component);function CreditsHistoryModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CreditsHistoryModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CreditsHistoryModal.__proto__||Object.getPrototypeOf(CreditsHistoryModal)).call.apply(_ref,[this].concat(args))),_this),_this.renderData=function(){if(_this.props.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'companies-credits-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(!_this.props.loading&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.props.data)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'credit-history-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'system_payment.no_company_credits')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["N" /* Table */],{className:'companies-credits-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'system_payment.date_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'system_payment.value_of_change_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'system_payment.comment_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderTableContent()));},_this.renderTableContent=function(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(_this.props.data,function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'name-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'system_payment.date_label')+':'},__WEBPACK_IMPORTED_MODULE_6_moment___default()(data.date).format('L')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date-joined-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'system_payment.value_of_change_label')+':'},data.delta.amount+" "+__WEBPACK_IMPORTED_MODULE_7__constants_constants__["g" /* CURRENCIES */][data.delta.currency]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'open-credit-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'system_payment.comment_label')+':'},data.comment));});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CreditsHistoryModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["w" /* Modal */],{isOpen:this.props.isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["x" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'credit-history-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'system_payment.credit_history_label').replace('{name}',this.props.companyName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_paginationComponent_PaginationCreditsHistory_container__["a" /* default */],null),this.renderData(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contact-data-modal-button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].okey_button)))));}}]);return CreditsHistoryModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CreditsHistoryModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,companyName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CreditsHistoryModal);

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_companiesCredits__ = __webpack_require__(88);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_companiesCredits__["h" /* getCompanyHistoryCurrentPage */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_companiesCredits__["j" /* getCompanyHistoryTotalPages */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_systemPayments_companiesCredits__["g" /* getCompanyHistory */])(page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidatedDomainsList__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_validatedDomains__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_accreditation_unreferencedAccreditationRequests__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{loading:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_validatedDomains__["i" /* loadingValidatedDomains */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_localization__["e" /* getTranslation */])(state),data:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_validatedDomains__["g" /* getValidatedDomainsFormattedData */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["d" /* getContinentsData */])(state),continentCode:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["f" /* getCurrentContinent */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["e" /* getCountriesData */])(state),modalOpen:[__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["l" /* MODAL_ADD_VALIDATED_DOMAIN */],__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["D" /* MODAL_EDIT_VALIDATED_DOMAIN */]].includes(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onMount:function onMount(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_validatedDomains__["o" /* setValidatedDomainsNameFilter */])(null));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_validatedDomains__["n" /* setValidatedDomainsDomainFilter */])(null));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_validatedDomains__["m" /* setValidatedDomainsCountryFilter */])(null));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["h" /* setCurrentContinent */])(''));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_validatedDomains__["c" /* fetchGetValidatedDomains */])());},onChangeCountryFilter:function onChangeCountryFilter(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_validatedDomains__["d" /* fetchGetValidatedDomainsByCountry */])(countryCode));},onSetContinent:function onSetContinent(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onFilter:function onFilter(name,domain){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_accreditation_validatedDomains__["e" /* fetchGetValidatedDomainsByNameAndDomain */])(name,domain));},onRemove:function onRemove(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_3" /* MODAL_REMOVE_VALIDATED_DOMAIN */]}));},onAddDomain:function onAddDomain(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["l" /* MODAL_ADD_VALIDATED_DOMAIN */]}));},onEditDomain:function onEditDomain(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_common_submitForm__["k" /* resetSubmitFormData */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["D" /* MODAL_EDIT_VALIDATED_DOMAIN */]}));},onShowApplicantRequests:function onShowApplicantRequests(domain){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_accreditation_unreferencedAccreditationRequests__["d" /* fetchGetLastRequestorsOfAccreditationRequest */])(domain));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["_17" /* showModal */])({modalKey:__WEBPACK_IMPORTED_MODULE_5__reducers_common_activeModal__["m" /* MODAL_APPLICANT_REQUESTS */]}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__ValidatedDomainsList__["a" /* default */]));

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_formWrapper_FormWrapper_container__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_paginationComponent_PaginationValidatedDomains_container__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_customSelect_CustomSelect_container__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ValidatedDomainsList_css__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ValidatedDomainsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ValidatedDomainsList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__accreditationModal_validateDomainModal_AddValidatedDomainModal_container__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__accreditationModal_validateDomainModal_EditValidatedDomainModal_container__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__accreditationModal_removeValidatedDomainModal_RemoveValidatedDomainModal_container__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__accreditationModal_applicantRequestsModal_ApplicantRequestsModal_container__ = __webpack_require__(1183);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SUCCESS_MESSAGE_BY_ACTION={ADD:'validated_domains.add_success_message',EDIT:'validated_domains.edit_success_message',REMOVE:'validated_domains.remove_success_message'};var ValidatedDomainsList=function(_Component){_inherits(ValidatedDomainsList,_Component);function ValidatedDomainsList(props){_classCallCheck(this,ValidatedDomainsList);var _this=_possibleConstructorReturn(this,(ValidatedDomainsList.__proto__||Object.getPrototypeOf(ValidatedDomainsList)).call(this,props));_this.renderContinentAndCountryFilter=function(){var continentsOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.continents,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continents))));var countriesOptions=[{value:null,label:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].all_label)}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["a" /* Utils */].getLocationOptions(_this.props.countries,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].countries))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filters-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'continent-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].continent_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'continent-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(continentsOptions,function(option){return option.value===_this.state.continentCode||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(option.value)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.state.continentCode);}),options:continentsOptions,onSelect:_this.handleChangeContinentSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'country-filter-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_customSelect_CustomSelect_container__["a" /* default */],{className:'country-filter-select',selectedOption:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(countriesOptions,function(option){return option.value===_this.state.countryFilter;}),options:countriesOptions,onSelect:_this.handleChangeCountrySelect})));};_this.renderTable=function(){if(!_this.state.filtering&&_this.props.loading&&(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validated-domains-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].fetching_message)));}if(!_this.state.filtering&&(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(_this.props.data)||_this.props.data.length===0)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validated-domains-list-status-message-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validated_domains.no_data_label')));}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["L" /* Row */],{className:'validated-domains-list-relative-header',key:'relative-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':'domain-input',className:'relative-header-label',sm:2},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.filter_by_domain_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{value:_this.state.filterDomain,onChange:_this.handleChangeFilterValue('filterDomain'),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.filter_by_domain_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["v" /* Label */],{'for':'name-input',className:'relative-header-label',sm:2},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validated_domains.filter_by_name_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{value:_this.state.filterName,onChange:_this.handleChangeFilterValue('filterName'),placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validated_domains.filter_by_name_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["h" /* Col */],{sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:_this.handleFilter},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.filter_label')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["N" /* Table */],{className:'validated-domains-list-table',key:'accreditation-requests-list-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'domain-th'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.organization_domain_label'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{id:'domain-input',value:_this.state.filterValue,onChange:_this.handleChangeFilterValue('filterDomain'),onKeyDown:_this.handleKeyDown,onBlur:_this.handleFilter,className:'domain-filter-input',bsSize:'sm',placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.filter_by_domain_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'name-th'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validated_domains.organization_name_label'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["r" /* Input */],{id:'name-input',value:_this.state.filterValue,onChange:_this.handleChangeFilterValue('filterName'),onKeyDown:_this.handleKeyDown,onBlur:_this.handleFilter,className:'name-filter-input',bsSize:'sm',placeholder:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validated_domains.filter_by_name_label')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'managed-by-th'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validated_domains.managed_by_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'applicant-requests-th'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'remove-icon-th'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this.renderValidatedDomainsData()))];};_this.renderValidatedDomainsData=function(){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(_this.props.data,function(data,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'validated-domains-list-row',key:index,onClick:_this.handleRowClick(data)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'domain-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.organization_domain_label')+':'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'td-with-icon'},data.orgDomain,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'create',key:index+'-create',className:'create-domain-icon'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'name-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validated_domains.organization_name_label')+':'},data.orgName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'managed-by-td','data-th':__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validated_domains.organization_name_label')+':'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validated_domains.'+data.managedBy+'_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'applicant-requests-td'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{className:'btn-sm',color:'link',onClick:_this.handleApplicantRequestsButtonClick(data)},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'validated_domains.applicant_requests_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'remove-icon-td',onClick:_this.handleRemoveIconClick(data)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_iconContainer_IconContainer__["a" /* default */],{icon:'trash',key:data.id+'-trash',className:'trash-accreditation-request-icon',title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,'accreditation_requests.remove_accreditation_request_label')})));});};_this.handleChangeContinentSelect=function(selectedOption){_this.setState({countryFilter:selectedOption.value});_this.props.onSetContinent(selectedOption.value);};_this.handleChangeCountrySelect=function(selectedOption){_this.setState({countryFilter:selectedOption.value});_this.setState({filtering:!!selectedOption.value||!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.state.filterName)||!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.state.filterDomain)});_this.props.onChangeCountryFilter(selectedOption.value);};_this.handleChangeFilterValue=function(fieldKey){return function(e){var _this$setState;_this.setState((_this$setState={},_defineProperty(_this$setState,fieldKey,e.target.value),_defineProperty(_this$setState,'filtering',true),_this$setState));};};_this.handleRemoveIconClick=function(data){return function(e){e.stopPropagation();_this.setState({selectedRowData:data,successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,SUCCESS_MESSAGE_BY_ACTION.REMOVE)});_this.props.onRemove();};};_this.handleKeyDown=function(e){if(e.keyCode===13){_this.handleFilter();}};_this.handleFilter=function(){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.state.filterName)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(_this.state.filterDomain)){_this.setState({filtering:false});}_this.props.onFilter(_this.state.filterName,_this.state.filterDomain);};_this.handleApplicantRequestsButtonClick=function(data){return function(e){e.stopPropagation();_this.setState({selectedRowData:{requestsNumber:data.requestsNumber}});_this.props.onShowApplicantRequests(data.orgDomain);};};_this.handleAddButtonClick=function(){_this.setState({successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,SUCCESS_MESSAGE_BY_ACTION.ADD)});_this.props.onAddDomain();};_this.handleRowClick=function(data){return function(){_this.setState({selectedRowData:data,successMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.translation,SUCCESS_MESSAGE_BY_ACTION.EDIT)});_this.props.onEditDomain();};};_this.handleCloseModal=function(){_this.setState({selectedRowData:null});};_this.state={filterName:'',filterDomain:'',filtering:false,selectedRowData:null,continentCode:_this.props.continentCode,countryFilter:null};return _this;}_createClass(ValidatedDomainsList,[{key:'componentDidMount',value:function componentDidMount(){this.props.onMount();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextContext){if(this.state.continentCode!==nextProps.continentCode&&!nextProps.modalOpen){this.setState({continentCode:nextProps.continentCode});}if(this.props.modalOpen&&!nextProps.modalOpen){this.props.onSetContinent(this.state.continentCode);}if(!this.props.modalOpen&&nextProps.modalOpen){this.props.onSetContinent(null);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'validated-domains-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_formWrapper_FormWrapper_container__["a" /* default */],{successMessage:this.state.successMessage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-label'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'validated_domains.validated_domains_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["c" /* Button */],{onClick:this.handleAddButtonClick,className:'add-domain-button olive-green-btn'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.props.translation,'validated_domains.add_domain_button'))),this.renderContinentAndCountryFilter(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_paginationComponent_PaginationValidatedDomains_container__["a" /* default */],null),this.renderTable(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__accreditationModal_validateDomainModal_AddValidatedDomainModal_container__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__accreditationModal_validateDomainModal_EditValidatedDomainModal_container__["a" /* default */],{data:this.state.selectedRowData,onClose:this.handleCloseModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__accreditationModal_applicantRequestsModal_ApplicantRequestsModal_container__["a" /* default */],{data:this.state.selectedRowData}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__accreditationModal_removeValidatedDomainModal_RemoveValidatedDomainModal_container__["a" /* default */],{data:this.state.selectedRowData,onClose:this.handleCloseModal})));}}]);return ValidatedDomainsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ValidatedDomainsList.propTypes={loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,continents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,continentCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,countries:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,modalOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onChangeCountryFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSetContinent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onAddDomain:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onEditDomain:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onShowApplicantRequests:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ValidatedDomainsList);

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaginationComponent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_validatedDomains__ = __webpack_require__(70);
var mapStateToProps=function mapStateToProps(state){return{current:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_validatedDomains__["f" /* getValidatedDomainsCurrentPage */])(state),total:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_validatedDomains__["h" /* getValidatedDomainsTotalPages */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getDataForPage:function getDataForPage(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_accreditation_validatedDomains__["c" /* fetchGetValidatedDomains */])(page));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PaginationComponent__["a" /* default */]));

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValidateDomainModal__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_accreditation_validatedDomains__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{action:__WEBPACK_IMPORTED_MODULE_1__ValidateDomainModal__["a" /* AVAILABLE_ACTIONS */].ADD,isOpen:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["l" /* MODAL_ADD_VALIDATED_DOMAIN */],continentCode:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["e" /* getCountriesData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSubmit:function onSubmit(data,bavaManaged){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_accreditation_validatedDomains__["j" /* onFetchAddValidatedDomain */])(data,bavaManaged));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["h" /* setCurrentContinent */])(''));},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ValidateDomainModal__["b" /* default */]));

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValidateDomainModal__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_accreditation_validatedDomains__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{action:__WEBPACK_IMPORTED_MODULE_1__ValidateDomainModal__["a" /* AVAILABLE_ACTIONS */].EDIT,isOpen:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["D" /* MODAL_EDIT_VALIDATED_DOMAIN */],continentCode:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["f" /* getCurrentContinent */])(state),continents:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["d" /* getContinentsData */])(state),countries:Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["e" /* getCountriesData */])(state),translation:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["e" /* getTranslation */])(state),success:Object(__WEBPACK_IMPORTED_MODULE_6__reducers_common_submitForm__["h" /* getSubmitFormSuccessStatus */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch,props){return{onSubmit:function onSubmit(data,bavaManaged){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_accreditation_validatedDomains__["k" /* onFetchEditValidatedDomain */])(props.data.orgDomain,data,bavaManaged));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_activeModal__["_16" /* hideModal */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["h" /* setCurrentContinent */])(''));},onContinentSet:function onContinentSet(continentCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["h" /* setCurrentContinent */])(continentCode));},onContinentSetByCountry:function onContinentSetByCountry(countryCode){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__reducers_common_location__["i" /* setCurrentContinentByCountry */])(countryCode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ValidateDomainModal__["b" /* default */]));

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveValidatedDomainModal__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_validatedDomains__ = __webpack_require__(70);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_3" /* MODAL_REMOVE_VALIDATED_DOMAIN */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onRemove:function onRemove(domain){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_validatedDomains__["l" /* onFetchRemoveValidatedDomain */])(domain));},onCancel:function onCancel(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RemoveValidatedDomainModal__["a" /* default */]));

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_organization_organizations__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveValidatedDomainModal=function(_Component){_inherits(RemoveValidatedDomainModal,_Component);function RemoveValidatedDomainModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveValidatedDomainModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveValidatedDomainModal.__proto__||Object.getPrototypeOf(RemoveValidatedDomainModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleRemove=function(e){e.preventDefault();_this.props.onRemove(_this.props.data.orgDomain);_this.props.onCancel();_this.props.onClose();},_this.handleCancel=function(){_this.props.onCancel();_this.props.onClose();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveValidatedDomainModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'validated-domain-modal',isOpen:this.props.isOpen,toggle:this.handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["n" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["v" /* Label */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'validated_domains.remove_domain_alert'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.org_type_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */][__WEBPACK_IMPORTED_MODULE_5__reducers_organization_organizations__["c" /* LABEL_PATH_BY_ORG_TYPE */][this.props.data.orgType]]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.name_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.orgName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].domain_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.orgDomain)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].country_label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'countries.'+this.props.data.orgCountry))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.city_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.orgCity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.postal_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.orgPostal)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'orgs.street_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.orgStreet)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'validated_domains.contact_name_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.contactName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'validated_domains.contact_email_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.contactEmail)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'validated_domains.contact_phone_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.contactPhone)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'validated_domains.managed_by_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'validated_domains.'+this.props.data.managedBy+'_label'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].cancel_button)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{className:'olive-green-btn',onClick:this.handleRemove},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].remove_button))));}}]);return RemoveValidatedDomainModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RemoveValidatedDomainModal.propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RemoveValidatedDomainModal);

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ApplicantRequestsModal__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__ = __webpack_require__(54);
var mapStateToProps=function mapStateToProps(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_15" /* getActiveModal */])(state).modalKey===__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["m" /* MODAL_APPLICANT_REQUESTS */],translation:Object(__WEBPACK_IMPORTED_MODULE_2__reducers_common_localization__["e" /* getTranslation */])(state),requestors:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["f" /* getLastRequestorsOfAccreditationRequestData */])(state),loading:Object(__WEBPACK_IMPORTED_MODULE_4__reducers_accreditation_unreferencedAccreditationRequests__["i" /* loadingLastRequestorsOfAccreditationRequest */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onClose:function onClose(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__reducers_common_activeModal__["_16" /* hideModal */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__ApplicantRequestsModal__["a" /* default */]));

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ApplicantRequestsModal_css__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ApplicantRequestsModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ApplicantRequestsModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ApplicantRequestsModal=function(_Component){_inherits(ApplicantRequestsModal,_Component);function ApplicantRequestsModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ApplicantRequestsModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ApplicantRequestsModal.__proto__||Object.getPrototypeOf(ApplicantRequestsModal)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){_this.props.onClose();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ApplicantRequestsModal,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.requestors)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.props.data)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["w" /* Modal */],{className:'applicant-requests-modal',isOpen:this.props.isOpen,toggle:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["x" /* ModalBody */],null,this.renderModalBody()));}},{key:'renderModalBody',value:function renderModalBody(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_requests.accreditation_requests_number_label'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,this.props.data.requestsNumber)),this.props.data.requestsNumber?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["L" /* Row */],{className:'modal-form-field-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],{sm:6},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,'accreditation_requests.last_requestors_button'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* Col */],null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(this.props.requestors,function(elem,id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'last-requestors-list',key:id},elem.identityAlias?elem.identityAlias.firstName+" "+elem.identityAlias.lastName:"",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"mailto:"+elem.email},elem.email));}))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-buttons-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["c" /* Button */],{color:'secondary',onClick:this.handleClose},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.props.translation,__WEBPACK_IMPORTED_MODULE_4__reducers_common_localization__["h" /* sharedLabelsPath */].okey_button))));}}]);return ApplicantRequestsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ApplicantRequestsModal.propTypes={requestors:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,translation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ApplicantRequestsModal);

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rootReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rootEpic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__oauth_oauth__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_login__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_tokenCheck__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__account_activation__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__account_restoreAccount__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__account_role__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__account_aliases__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__accreditation_accreditations__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_activeModal__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__organization_department__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__organization_departments__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_handleApiCall__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_titleLangs__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_levels__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_location__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_localization__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_submitForm__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__organization_organization__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__organization_organizations__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__organization_staffMembers__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__organization_accreditationGroups__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__organization_accreditationGroup__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__accreditation_bulk__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__applicantAccreditations_certifiedAccreditations__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__applicantAccreditations_pendingAccreditations__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__applicantAccreditations_VIDs__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__finance_currencies__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__finance_finance__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__consent_consents__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__consent_consent__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__consent_organizationConsents__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__consent_priorConsents__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__consent_priorConsent__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__account_userData__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__account_userSettings__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__account_security__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__applicantSelfStudy_applicantSelfStudyBooks__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__applicantSelfStudy_applicantSelfStudyBook__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__consent_bulkConsentRequests__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__accreditation_certificate__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__organization_orgCertificate__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__common_notifications__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__applicantAccreditations_accreditationRequests__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__applicantAccreditations_accreditationRequest__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__applicantAccreditations_accreditationRequestOrgData__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__accreditation_unreferencedAccreditationRequests__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__accreditation_pendingAccreditationRequests__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__accreditation_pendingAccreditationRequest__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__accreditation_validatedDomains__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__organization_orgsWithoutCertificates__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__assistant_assistants__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__businessAmbassador_businessAmbassadors__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__businessAmbassador_businessAmbassador__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__commission_commissions__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__systemPayments_duePayments__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__systemPayments_paymentsHistory__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__systemPayments_companiesCredits__ = __webpack_require__(88);
var appReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({oauth:__WEBPACK_IMPORTED_MODULE_2__oauth_oauth__["a" /* default */],login:__WEBPACK_IMPORTED_MODULE_3__account_login__["c" /* default */],tokenCheck:__WEBPACK_IMPORTED_MODULE_4__common_tokenCheck__["a" /* default */],activation:__WEBPACK_IMPORTED_MODULE_5__account_activation__["a" /* default */],restoreAccount:__WEBPACK_IMPORTED_MODULE_6__account_restoreAccount__["a" /* default */],role:__WEBPACK_IMPORTED_MODULE_7__account_role__["g" /* default */],aliases:__WEBPACK_IMPORTED_MODULE_8__account_aliases__["b" /* default */],accreditations:__WEBPACK_IMPORTED_MODULE_9__accreditation_accreditations__["h" /* default */],activeModal:__WEBPACK_IMPORTED_MODULE_10__common_activeModal__["_14" /* default */],department:__WEBPACK_IMPORTED_MODULE_11__organization_department__["a" /* default */],departments:__WEBPACK_IMPORTED_MODULE_12__organization_departments__["a" /* default */],titleLangs:__WEBPACK_IMPORTED_MODULE_14__common_titleLangs__["a" /* default */],levels:__WEBPACK_IMPORTED_MODULE_15__common_levels__["a" /* default */],location:__WEBPACK_IMPORTED_MODULE_16__common_location__["a" /* default */],localization:__WEBPACK_IMPORTED_MODULE_17__common_localization__["b" /* default */],submitForm:__WEBPACK_IMPORTED_MODULE_18__common_submitForm__["a" /* default */],organization:__WEBPACK_IMPORTED_MODULE_19__organization_organization__["a" /* default */],organizations:__WEBPACK_IMPORTED_MODULE_20__organization_organizations__["e" /* default */],staffMembers:__WEBPACK_IMPORTED_MODULE_21__organization_staffMembers__["a" /* default */],accreditationGroups:__WEBPACK_IMPORTED_MODULE_22__organization_accreditationGroups__["a" /* default */],accreditationGroup:__WEBPACK_IMPORTED_MODULE_23__organization_accreditationGroup__["a" /* default */],bulk:__WEBPACK_IMPORTED_MODULE_24__accreditation_bulk__["a" /* default */],certifiedAccreditations:__WEBPACK_IMPORTED_MODULE_25__applicantAccreditations_certifiedAccreditations__["a" /* default */],pendingAccreditations:__WEBPACK_IMPORTED_MODULE_26__applicantAccreditations_pendingAccreditations__["a" /* default */],VIDs:__WEBPACK_IMPORTED_MODULE_27__applicantAccreditations_VIDs__["a" /* default */],currencies:__WEBPACK_IMPORTED_MODULE_28__finance_currencies__["a" /* default */],finance:__WEBPACK_IMPORTED_MODULE_29__finance_finance__["a" /* default */],consents:__WEBPACK_IMPORTED_MODULE_30__consent_consents__["e" /* default */],consent:__WEBPACK_IMPORTED_MODULE_31__consent_consent__["a" /* default */],organizationConsents:__WEBPACK_IMPORTED_MODULE_32__consent_organizationConsents__["c" /* default */],priorConsents:__WEBPACK_IMPORTED_MODULE_33__consent_priorConsents__["a" /* default */],priorConsent:__WEBPACK_IMPORTED_MODULE_34__consent_priorConsent__["a" /* default */],userData:__WEBPACK_IMPORTED_MODULE_35__account_userData__["a" /* default */],userSettings:__WEBPACK_IMPORTED_MODULE_36__account_userSettings__["b" /* default */],security:__WEBPACK_IMPORTED_MODULE_37__account_security__["b" /* default */],applicantSelfStudyBooks:__WEBPACK_IMPORTED_MODULE_38__applicantSelfStudy_applicantSelfStudyBooks__["a" /* default */],applicantSelfStudyBook:__WEBPACK_IMPORTED_MODULE_39__applicantSelfStudy_applicantSelfStudyBook__["a" /* default */],bulkConsentRequests:__WEBPACK_IMPORTED_MODULE_40__consent_bulkConsentRequests__["a" /* default */],certificate:__WEBPACK_IMPORTED_MODULE_41__accreditation_certificate__["a" /* default */],orgCertificate:__WEBPACK_IMPORTED_MODULE_42__organization_orgCertificate__["a" /* default */],notifications:__WEBPACK_IMPORTED_MODULE_43__common_notifications__["c" /* default */],accreditationRequests:__WEBPACK_IMPORTED_MODULE_44__applicantAccreditations_accreditationRequests__["d" /* default */],accreditationRequest:__WEBPACK_IMPORTED_MODULE_45__applicantAccreditations_accreditationRequest__["a" /* default */],accreditationRequestOrgData:__WEBPACK_IMPORTED_MODULE_46__applicantAccreditations_accreditationRequestOrgData__["a" /* default */],unreferencedAccreditationRequests:__WEBPACK_IMPORTED_MODULE_47__accreditation_unreferencedAccreditationRequests__["b" /* default */],pendingAccreditationRequests:__WEBPACK_IMPORTED_MODULE_48__accreditation_pendingAccreditationRequests__["e" /* default */],pendingAccreditationRequest:__WEBPACK_IMPORTED_MODULE_49__accreditation_pendingAccreditationRequest__["a" /* default */],orgsWithoutCertificates:__WEBPACK_IMPORTED_MODULE_51__organization_orgsWithoutCertificates__["a" /* default */],assistants:__WEBPACK_IMPORTED_MODULE_52__assistant_assistants__["a" /* default */],businessAmbassadors:__WEBPACK_IMPORTED_MODULE_53__businessAmbassador_businessAmbassadors__["a" /* default */],businessAmbassador:__WEBPACK_IMPORTED_MODULE_54__businessAmbassador_businessAmbassador__["a" /* default */],commissions:__WEBPACK_IMPORTED_MODULE_55__commission_commissions__["a" /* default */],duePayments:__WEBPACK_IMPORTED_MODULE_56__systemPayments_duePayments__["a" /* default */],paymentsHistory:__WEBPACK_IMPORTED_MODULE_57__systemPayments_paymentsHistory__["a" /* default */],companiesCredits:__WEBPACK_IMPORTED_MODULE_58__systemPayments_companiesCredits__["b" /* default */],validatedDomains:__WEBPACK_IMPORTED_MODULE_50__accreditation_validatedDomains__["b" /* default */]});var rootReducer=function rootReducer(state,action){if(action.type==='LOGOUT'){state={location:state.location,localization:state.localization,oauth:state.oauth};}return appReducer(state,action);};var rootEpic=Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["a" /* combineEpics */])(__WEBPACK_IMPORTED_MODULE_13__common_handleApiCall__["d" /* handleApiCallEpic */],__WEBPACK_IMPORTED_MODULE_41__accreditation_certificate__["f" /* handleCryptoEpic */]);

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.c6d5feb6.js